var Bc = Object.defineProperty;
var Wc = (t, e, n) => e in t ? Bc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Xt = (t, e, n) => (Wc(t, typeof e != "symbol" ? e + "" : e, n), n), zr = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var se = (t, e, n) => (zr(t, e, "read from private field"), n ? n.call(t) : e.get(t)), Ge = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, at = (t, e, n, a) => (zr(t, e, "write to private field"), a ? a.call(t, n) : e.set(t, n), n);
var zn = (t, e, n, a) => ({
  set _(s) {
    at(t, e, s, n);
  },
  get _() {
    return se(t, e, a);
  }
}), Ke = (t, e, n) => (zr(t, e, "access private method"), n);
import React, { forwardRef, createContext, useState, useCallback, useRef, useMemo, useImperativeHandle, useContext, useEffect, useLayoutEffect as useLayoutEffect$1, memo, useId, useReducer } from "react";
import { flushSync } from "react-dom";
function _mergeNamespaces(t, e) {
  for (var n = 0; n < e.length; n++) {
    const a = e[n];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const s in a)
        if (s !== "default" && !(s in t)) {
          const o = Object.getOwnPropertyDescriptor(a, s);
          o && Object.defineProperty(t, s, o.get ? o : {
            enumerable: !0,
            get: () => a[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getAugmentedNamespace(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(t, a);
    Object.defineProperty(n, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return t[a];
      }
    });
  }), n;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var t = React, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), E = Symbol.iterator, m = "@@iterator";
    function v(ee) {
      if (ee === null || typeof ee != "object")
        return null;
      var ce = E && ee[E] || ee[m];
      return typeof ce == "function" ? ce : null;
    }
    var y = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(ee) {
      {
        for (var ce = arguments.length, pe = new Array(ce > 1 ? ce - 1 : 0), be = 1; be < ce; be++)
          pe[be - 1] = arguments[be];
        b("error", ee, pe);
      }
    }
    function b(ee, ce, pe) {
      {
        var be = y.ReactDebugCurrentFrame, Ee = be.getStackAddendum();
        Ee !== "" && (ce += "%s", pe = pe.concat([Ee]));
        var He = pe.map(function(de) {
          return String(de);
        });
        He.unshift("Warning: " + ce), Function.prototype.apply.call(console[ee], console, He);
      }
    }
    var C = !1, T = !1, w = !1, R = !1, O = !1, D;
    D = Symbol.for("react.module.reference");
    function k(ee) {
      return !!(typeof ee == "string" || typeof ee == "function" || ee === a || ee === o || O || ee === s || ee === d || ee === f || R || ee === x || C || T || w || typeof ee == "object" && ee !== null && (ee.$$typeof === g || ee.$$typeof === h || ee.$$typeof === l || ee.$$typeof === c || ee.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ee.$$typeof === D || ee.getModuleId !== void 0));
    }
    function W(ee, ce, pe) {
      var be = ee.displayName;
      if (be)
        return be;
      var Ee = ce.displayName || ce.name || "";
      return Ee !== "" ? pe + "(" + Ee + ")" : pe;
    }
    function L(ee) {
      return ee.displayName || "Context";
    }
    function z(ee) {
      if (ee == null)
        return null;
      if (typeof ee.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ee == "function")
        return ee.displayName || ee.name || null;
      if (typeof ee == "string")
        return ee;
      switch (ee) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof ee == "object")
        switch (ee.$$typeof) {
          case c:
            var ce = ee;
            return L(ce) + ".Consumer";
          case l:
            var pe = ee;
            return L(pe._context) + ".Provider";
          case u:
            return W(ee, ee.render, "ForwardRef");
          case h:
            var be = ee.displayName || null;
            return be !== null ? be : z(ee.type) || "Memo";
          case g: {
            var Ee = ee, He = Ee._payload, de = Ee._init;
            try {
              return z(de(He));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, Q = 0, Y, ie, te, Z, ae, G, U;
    function F() {
    }
    F.__reactDisabledLog = !0;
    function M() {
      {
        if (Q === 0) {
          Y = console.log, ie = console.info, te = console.warn, Z = console.error, ae = console.group, G = console.groupCollapsed, U = console.groupEnd;
          var ee = {
            configurable: !0,
            enumerable: !0,
            value: F,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ee,
            log: ee,
            warn: ee,
            error: ee,
            group: ee,
            groupCollapsed: ee,
            groupEnd: ee
          });
        }
        Q++;
      }
    }
    function I() {
      {
        if (Q--, Q === 0) {
          var ee = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, ee, {
              value: Y
            }),
            info: P({}, ee, {
              value: ie
            }),
            warn: P({}, ee, {
              value: te
            }),
            error: P({}, ee, {
              value: Z
            }),
            group: P({}, ee, {
              value: ae
            }),
            groupCollapsed: P({}, ee, {
              value: G
            }),
            groupEnd: P({}, ee, {
              value: U
            })
          });
        }
        Q < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var N = y.ReactCurrentDispatcher, V;
    function q(ee, ce, pe) {
      {
        if (V === void 0)
          try {
            throw Error();
          } catch (Ee) {
            var be = Ee.stack.trim().match(/\n( *(at )?)/);
            V = be && be[1] || "";
          }
        return `
` + V + ee;
      }
    }
    var H = !1, ne;
    {
      var he = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new he();
    }
    function j(ee, ce) {
      if (!ee || H)
        return "";
      {
        var pe = ne.get(ee);
        if (pe !== void 0)
          return pe;
      }
      var be;
      H = !0;
      var Ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var He;
      He = N.current, N.current = null, M();
      try {
        if (ce) {
          var de = function() {
            throw Error();
          };
          if (Object.defineProperty(de.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(de, []);
            } catch (_t) {
              be = _t;
            }
            Reflect.construct(ee, [], de);
          } else {
            try {
              de.call();
            } catch (_t) {
              be = _t;
            }
            ee.call(de.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (_t) {
            be = _t;
          }
          ee();
        }
      } catch (_t) {
        if (_t && be && typeof _t.stack == "string") {
          for (var ve = _t.stack.split(`
`), Se = be.stack.split(`
`), we = ve.length - 1, Ue = Se.length - 1; we >= 1 && Ue >= 0 && ve[we] !== Se[Ue]; )
            Ue--;
          for (; we >= 1 && Ue >= 0; we--, Ue--)
            if (ve[we] !== Se[Ue]) {
              if (we !== 1 || Ue !== 1)
                do
                  if (we--, Ue--, Ue < 0 || ve[we] !== Se[Ue]) {
                    var Qe = `
` + ve[we].replace(" at new ", " at ");
                    return ee.displayName && Qe.includes("<anonymous>") && (Qe = Qe.replace("<anonymous>", ee.displayName)), typeof ee == "function" && ne.set(ee, Qe), Qe;
                  }
                while (we >= 1 && Ue >= 0);
              break;
            }
        }
      } finally {
        H = !1, N.current = He, I(), Error.prepareStackTrace = Ee;
      }
      var ft = ee ? ee.displayName || ee.name : "", ut = ft ? q(ft) : "";
      return typeof ee == "function" && ne.set(ee, ut), ut;
    }
    function Fe(ee, ce, pe) {
      return j(ee, !1);
    }
    function X(ee) {
      var ce = ee.prototype;
      return !!(ce && ce.isReactComponent);
    }
    function ye(ee, ce, pe) {
      if (ee == null)
        return "";
      if (typeof ee == "function")
        return j(ee, X(ee));
      if (typeof ee == "string")
        return q(ee);
      switch (ee) {
        case d:
          return q("Suspense");
        case f:
          return q("SuspenseList");
      }
      if (typeof ee == "object")
        switch (ee.$$typeof) {
          case u:
            return Fe(ee.render);
          case h:
            return ye(ee.type, ce, pe);
          case g: {
            var be = ee, Ee = be._payload, He = be._init;
            try {
              return ye(He(Ee), ce, pe);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, fe = {}, _e = y.ReactDebugCurrentFrame;
    function Ie(ee) {
      if (ee) {
        var ce = ee._owner, pe = ye(ee.type, ee._source, ce ? ce.type : null);
        _e.setExtraStackFrame(pe);
      } else
        _e.setExtraStackFrame(null);
    }
    function Be(ee, ce, pe, be, Ee) {
      {
        var He = Function.call.bind(Ae);
        for (var de in ee)
          if (He(ee, de)) {
            var ve = void 0;
            try {
              if (typeof ee[de] != "function") {
                var Se = Error((be || "React class") + ": " + pe + " type `" + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ee[de] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Se.name = "Invariant Violation", Se;
              }
              ve = ee[de](ce, de, be, pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ve = we;
            }
            ve && !(ve instanceof Error) && (Ie(Ee), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", pe, de, typeof ve), Ie(null)), ve instanceof Error && !(ve.message in fe) && (fe[ve.message] = !0, Ie(Ee), A("Failed %s type: %s", pe, ve.message), Ie(null));
          }
      }
    }
    var $e = Array.isArray;
    function Me(ee) {
      return $e(ee);
    }
    function J(ee) {
      {
        var ce = typeof Symbol == "function" && Symbol.toStringTag, pe = ce && ee[Symbol.toStringTag] || ee.constructor.name || "Object";
        return pe;
      }
    }
    function K(ee) {
      try {
        return ge(ee), !1;
      } catch {
        return !0;
      }
    }
    function ge(ee) {
      return "" + ee;
    }
    function Ce(ee) {
      if (K(ee))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", J(ee)), ge(ee);
    }
    var Oe = y.ReactCurrentOwner, qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ct, ze, et;
    et = {};
    function gt(ee) {
      if (Ae.call(ee, "ref")) {
        var ce = Object.getOwnPropertyDescriptor(ee, "ref").get;
        if (ce && ce.isReactWarning)
          return !1;
      }
      return ee.ref !== void 0;
    }
    function pt(ee) {
      if (Ae.call(ee, "key")) {
        var ce = Object.getOwnPropertyDescriptor(ee, "key").get;
        if (ce && ce.isReactWarning)
          return !1;
      }
      return ee.key !== void 0;
    }
    function nt(ee, ce) {
      if (typeof ee.ref == "string" && Oe.current && ce && Oe.current.stateNode !== ce) {
        var pe = z(Oe.current.type);
        et[pe] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(Oe.current.type), ee.ref), et[pe] = !0);
      }
    }
    function tt(ee, ce) {
      {
        var pe = function() {
          ct || (ct = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ce));
        };
        pe.isReactWarning = !0, Object.defineProperty(ee, "key", {
          get: pe,
          configurable: !0
        });
      }
    }
    function Ve(ee, ce) {
      {
        var pe = function() {
          ze || (ze = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ce));
        };
        pe.isReactWarning = !0, Object.defineProperty(ee, "ref", {
          get: pe,
          configurable: !0
        });
      }
    }
    var We = function(ee, ce, pe, be, Ee, He, de) {
      var ve = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: ee,
        key: ce,
        ref: pe,
        props: de,
        // Record the component responsible for creating this element.
        _owner: He
      };
      return ve._store = {}, Object.defineProperty(ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: be
      }), Object.defineProperty(ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
    };
    function it(ee, ce, pe, be, Ee) {
      {
        var He, de = {}, ve = null, Se = null;
        pe !== void 0 && (Ce(pe), ve = "" + pe), pt(ce) && (Ce(ce.key), ve = "" + ce.key), gt(ce) && (Se = ce.ref, nt(ce, Ee));
        for (He in ce)
          Ae.call(ce, He) && !qe.hasOwnProperty(He) && (de[He] = ce[He]);
        if (ee && ee.defaultProps) {
          var we = ee.defaultProps;
          for (He in we)
            de[He] === void 0 && (de[He] = we[He]);
        }
        if (ve || Se) {
          var Ue = typeof ee == "function" ? ee.displayName || ee.name || "Unknown" : ee;
          ve && tt(de, Ue), Se && Ve(de, Ue);
        }
        return We(ee, ve, Se, Ee, be, Oe.current, de);
      }
    }
    var Je = y.ReactCurrentOwner, Rt = y.ReactDebugCurrentFrame;
    function je(ee) {
      if (ee) {
        var ce = ee._owner, pe = ye(ee.type, ee._source, ce ? ce.type : null);
        Rt.setExtraStackFrame(pe);
      } else
        Rt.setExtraStackFrame(null);
    }
    var ke;
    ke = !1;
    function Ye(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === e;
    }
    function Ze() {
      {
        if (Je.current) {
          var ee = z(Je.current.type);
          if (ee)
            return `

Check the render method of \`` + ee + "`.";
        }
        return "";
      }
    }
    function rt(ee) {
      {
        if (ee !== void 0) {
          var ce = ee.fileName.replace(/^.*[\\\/]/, ""), pe = ee.lineNumber;
          return `

Check your code at ` + ce + ":" + pe + ".";
        }
        return "";
      }
    }
    var xt = {};
    function bt(ee) {
      {
        var ce = Ze();
        if (!ce) {
          var pe = typeof ee == "string" ? ee : ee.displayName || ee.name;
          pe && (ce = `

Check the top-level render call using <` + pe + ">.");
        }
        return ce;
      }
    }
    function wt(ee, ce) {
      {
        if (!ee._store || ee._store.validated || ee.key != null)
          return;
        ee._store.validated = !0;
        var pe = bt(ce);
        if (xt[pe])
          return;
        xt[pe] = !0;
        var be = "";
        ee && ee._owner && ee._owner !== Je.current && (be = " It was passed a child from " + z(ee._owner.type) + "."), je(ee), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', pe, be), je(null);
      }
    }
    function mt(ee, ce) {
      {
        if (typeof ee != "object")
          return;
        if (Me(ee))
          for (var pe = 0; pe < ee.length; pe++) {
            var be = ee[pe];
            Ye(be) && wt(be, ce);
          }
        else if (Ye(ee))
          ee._store && (ee._store.validated = !0);
        else if (ee) {
          var Ee = v(ee);
          if (typeof Ee == "function" && Ee !== ee.entries)
            for (var He = Ee.call(ee), de; !(de = He.next()).done; )
              Ye(de.value) && wt(de.value, ce);
        }
      }
    }
    function St(ee) {
      {
        var ce = ee.type;
        if (ce == null || typeof ce == "string")
          return;
        var pe;
        if (typeof ce == "function")
          pe = ce.propTypes;
        else if (typeof ce == "object" && (ce.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ce.$$typeof === h))
          pe = ce.propTypes;
        else
          return;
        if (pe) {
          var be = z(ce);
          Be(pe, ee.props, "prop", be, ee);
        } else if (ce.PropTypes !== void 0 && !ke) {
          ke = !0;
          var Ee = z(ce);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ee || "Unknown");
        }
        typeof ce.getDefaultProps == "function" && !ce.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dt(ee) {
      {
        for (var ce = Object.keys(ee.props), pe = 0; pe < ce.length; pe++) {
          var be = ce[pe];
          if (be !== "children" && be !== "key") {
            je(ee), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), je(null);
            break;
          }
        }
        ee.ref !== null && (je(ee), A("Invalid attribute `ref` supplied to `React.Fragment`."), je(null));
      }
    }
    function Le(ee, ce, pe, be, Ee, He) {
      {
        var de = k(ee);
        if (!de) {
          var ve = "";
          (ee === void 0 || typeof ee == "object" && ee !== null && Object.keys(ee).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Se = rt(Ee);
          Se ? ve += Se : ve += Ze();
          var we;
          ee === null ? we = "null" : Me(ee) ? we = "array" : ee !== void 0 && ee.$$typeof === e ? (we = "<" + (z(ee.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : we = typeof ee, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ve);
        }
        var Ue = it(ee, ce, pe, Ee, He);
        if (Ue == null)
          return Ue;
        if (de) {
          var Qe = ce.children;
          if (Qe !== void 0)
            if (be)
              if (Me(Qe)) {
                for (var ft = 0; ft < Qe.length; ft++)
                  mt(Qe[ft], ee);
                Object.freeze && Object.freeze(Qe);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              mt(Qe, ee);
        }
        return ee === a ? dt(Ue) : St(Ue), Ue;
      }
    }
    function ue(ee, ce, pe) {
      return Le(ee, ce, pe, !0);
    }
    function De(ee, ce, pe) {
      return Le(ee, ce, pe, !1);
    }
    var Ne = De, oe = ue;
    reactJsxRuntime_development.Fragment = a, reactJsxRuntime_development.jsx = Ne, reactJsxRuntime_development.jsxs = oe;
  }()), reactJsxRuntime_development;
}
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var t = React, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, d) {
    var f, h = {}, g = null, x = null;
    d !== void 0 && (g = "" + d), u.key !== void 0 && (g = "" + u.key), u.ref !== void 0 && (x = u.ref);
    for (f in u)
      a.call(u, f) && !o.hasOwnProperty(f) && (h[f] = u[f]);
    if (c && c.defaultProps)
      for (f in u = c.defaultProps, u)
        h[f] === void 0 && (h[f] = u[f]);
    return { $$typeof: e, type: c, key: g, ref: x, props: h, _owner: s.current };
  }
  return reactJsxRuntime_production_min.Fragment = n, reactJsxRuntime_production_min.jsx = l, reactJsxRuntime_production_min.jsxs = l, reactJsxRuntime_production_min;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const Error$2 = (t) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-message", children: t.children ? t.children : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "alert", children: t.error }) }), Loading = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loading-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "loading" }) });
function r(t) {
  var e, n, a = "";
  if (typeof t == "string" || typeof t == "number")
    a += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = r(t[e])) && (a && (a += " "), a += n);
    else
      for (e in t)
        t[e] && (a && (a += " "), a += e);
  return a;
}
function clsx() {
  for (var t, e, n = 0, a = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = r(t)) && (a && (a += " "), a += e);
  return a;
}
function getColSpan(t, e, n) {
  const a = typeof t.colSpan == "function" ? t.colSpan(n) : 1;
  if (Number.isInteger(a) && a > 1 && (!t.frozen || t.idx + a - 1 <= e))
    return a;
}
function stopPropagation(t) {
  t.stopPropagation();
}
function scrollIntoView(t) {
  t == null || t.scrollIntoView({
    inline: "nearest",
    block: "nearest"
  });
}
function createCellEvent(t) {
  let e = !1;
  const n = {
    ...t,
    preventGridDefault() {
      e = !0;
    },
    isGridDefaultPrevented() {
      return e;
    }
  };
  return Object.setPrototypeOf(n, Object.getPrototypeOf(t)), n;
}
const nonInputKeys = /* @__PURE__ */ new Set(["Unidentified", "Alt", "AltGraph", "CapsLock", "Control", "Fn", "FnLock", "Meta", "NumLock", "ScrollLock", "Shift", "Tab", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Home", "PageDown", "PageUp", "Insert", "ContextMenu", "Escape", "Pause", "Play", "PrintScreen", "F1", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"]);
function isCtrlKeyHeldDown(t) {
  return (t.ctrlKey || t.metaKey) && t.key !== "Control";
}
function isDefaultCellInput(t) {
  return !nonInputKeys.has(t.key);
}
function onEditorNavigation({
  key: t,
  target: e
}) {
  var n;
  return t === "Tab" && (e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement) ? ((n = e.closest(".rdg-editor-container")) == null ? void 0 : n.querySelectorAll("input, textarea, select").length) === 1 : !1;
}
const measuringCellClassname = "mlln6zg7-0-0-beta-41";
function renderMeasuringCells(t) {
  return t.map(({
    key: e,
    idx: n,
    minWidth: a,
    maxWidth: s
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: measuringCellClassname,
    style: {
      gridColumnStart: n + 1,
      minWidth: a,
      maxWidth: s
    },
    "data-measuring-cell-key": e
  }, e));
}
function isSelectedCellEditable({
  selectedPosition: t,
  columns: e,
  rows: n
}) {
  const a = e[t.idx], s = n[t.rowIdx];
  return isCellEditableUtil(a, s);
}
function isCellEditableUtil(t, e) {
  return t.renderEditCell != null && (typeof t.editable == "function" ? t.editable(e) : t.editable) !== !1;
}
function getSelectedCellColSpan({
  rows: t,
  topSummaryRows: e,
  bottomSummaryRows: n,
  rowIdx: a,
  mainHeaderRowIdx: s,
  lastFrozenColumnIndex: o,
  column: l
}) {
  const c = (e == null ? void 0 : e.length) ?? 0;
  if (a === s)
    return getColSpan(l, o, {
      type: "HEADER"
    });
  if (e && a > s && a <= c + s)
    return getColSpan(l, o, {
      type: "SUMMARY",
      row: e[a + c]
    });
  if (a >= 0 && a < t.length) {
    const u = t[a];
    return getColSpan(l, o, {
      type: "ROW",
      row: u
    });
  }
  if (n)
    return getColSpan(l, o, {
      type: "SUMMARY",
      row: n[a - t.length]
    });
}
function getNextSelectedCellPosition({
  moveUp: t,
  moveNext: e,
  cellNavigationMode: n,
  columns: a,
  colSpanColumns: s,
  rows: o,
  topSummaryRows: l,
  bottomSummaryRows: c,
  minRowIdx: u,
  mainHeaderRowIdx: d,
  maxRowIdx: f,
  currentPosition: {
    idx: h,
    rowIdx: g
  },
  nextPosition: x,
  lastFrozenColumnIndex: E,
  isCellWithinBounds: m
}) {
  let {
    idx: v,
    rowIdx: y
  } = x;
  const A = a.length, b = (w) => {
    for (const R of s) {
      const O = R.idx;
      if (O > v)
        break;
      const D = getSelectedCellColSpan({
        rows: o,
        topSummaryRows: l,
        bottomSummaryRows: c,
        rowIdx: y,
        mainHeaderRowIdx: d,
        lastFrozenColumnIndex: E,
        column: R
      });
      if (D && v > O && v < D + O) {
        v = O + (w ? D : 0);
        break;
      }
    }
  }, C = (w) => w.level + d, T = () => {
    if (e) {
      let R = a[v].parent;
      for (; R !== void 0; ) {
        const O = C(R);
        if (y === O) {
          v = R.idx + R.colSpan;
          break;
        }
        R = R.parent;
      }
    } else if (t) {
      let R = a[v].parent, O = !1;
      for (; R !== void 0; ) {
        const D = C(R);
        if (y >= D) {
          v = R.idx, y = D, O = !0;
          break;
        }
        R = R.parent;
      }
      O || (v = h, y = g);
    }
  };
  if (m(x) && (b(e), y < d && T()), n === "CHANGE_ROW" && (v === A ? y === f || (v = 0, y += 1) : v === -1 && (y === u || (y -= 1, v = A - 1), b(!1))), y < d) {
    let R = a[v].parent;
    const O = y;
    for (y = d; R !== void 0; ) {
      const D = C(R);
      D >= O && (y = D, v = R.idx), R = R.parent;
    }
  }
  return {
    idx: v,
    rowIdx: y
  };
}
function canExitGrid({
  maxColIdx: t,
  minRowIdx: e,
  maxRowIdx: n,
  selectedPosition: {
    rowIdx: a,
    idx: s
  },
  shiftKey: o
}) {
  return o ? s === 0 && a === e : s === t && a === n;
}
const cell = "cj343x07-0-0-beta-41", cellClassname = `rdg-cell ${cell}`, cellFrozen = "csofj7r7-0-0-beta-41", cellFrozenClassname = `rdg-cell-frozen ${cellFrozen}`, cellFrozenLast = "ch2wcw87-0-0-beta-41", cellFrozenLastClassname = `rdg-cell-frozen-last ${cellFrozenLast}`;
function getRowStyle(t, e) {
  return e !== void 0 ? {
    "--rdg-grid-row-start": t,
    "--rdg-row-height": `${e}px`
  } : {
    "--rdg-grid-row-start": t
  };
}
function getHeaderCellStyle(t, e, n) {
  const a = e + 1, s = `calc(${n - 1} * var(--rdg-header-row-height))`;
  return t.parent === void 0 ? {
    insetBlockStart: 0,
    gridRowStart: 1,
    gridRowEnd: a,
    paddingBlockStart: s
  } : {
    insetBlockStart: `calc(${e - n} * var(--rdg-header-row-height))`,
    gridRowStart: a - n,
    gridRowEnd: a,
    paddingBlockStart: s
  };
}
function getCellStyle(t, e = 1) {
  const n = t.idx + 1;
  return {
    gridColumnStart: n,
    gridColumnEnd: n + e,
    insetInlineStart: t.frozen ? `var(--rdg-frozen-left-${t.idx})` : void 0
  };
}
function getCellClassname(t, ...e) {
  return clsx(cellClassname, ...e, t.frozen && cellFrozenClassname, t.isLastFrozenColumn && cellFrozenLastClassname);
}
const {
  min: min$1,
  max: max$1,
  floor,
  sign,
  abs
} = Math;
function assertIsValidKeyGetter(t) {
  if (typeof t != "function")
    throw new Error("Please specify the rowKeyGetter prop to use selection");
}
function clampColumnWidth(t, {
  minWidth: e,
  maxWidth: n
}) {
  return t = max$1(t, e), typeof n == "number" && n >= e ? min$1(t, n) : t;
}
function getHeaderCellRowSpan(t, e) {
  return t.parent === void 0 ? e : t.level - t.parent.level;
}
const checkboxLabel = "c1bn88vv7-0-0-beta-41", checkboxLabelClassname = `rdg-checkbox-label ${checkboxLabel}`, checkboxInput = "c1qt073l7-0-0-beta-41", checkboxInputClassname = `rdg-checkbox-input ${checkboxInput}`, checkbox = "cf71kmq7-0-0-beta-41", checkboxClassname = `rdg-checkbox ${checkbox}`, checkboxLabelDisabled = "c1lwve4p7-0-0-beta-41", checkboxLabelDisabledClassname = `rdg-checkbox-label-disabled ${checkboxLabelDisabled}`;
function renderCheckbox({
  onChange: t,
  ...e
}) {
  function n(a) {
    t(a.target.checked, a.nativeEvent.shiftKey);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("label", {
    className: clsx(checkboxLabelClassname, e.disabled && checkboxLabelDisabledClassname),
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("input", {
      type: "checkbox",
      ...e,
      className: checkboxInputClassname,
      onChange: n
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: checkboxClassname
    })]
  });
}
function renderValue(t) {
  try {
    return t.row[t.column.key];
  } catch {
    return null;
  }
}
const DataGridDefaultRenderersContext = /* @__PURE__ */ createContext(void 0), DataGridDefaultRenderersProvider = DataGridDefaultRenderersContext.Provider;
function useDefaultRenderers() {
  return useContext(DataGridDefaultRenderersContext);
}
const RowSelectionContext = /* @__PURE__ */ createContext(void 0), RowSelectionProvider = RowSelectionContext.Provider, RowSelectionChangeContext = /* @__PURE__ */ createContext(void 0), RowSelectionChangeProvider = RowSelectionChangeContext.Provider, SELECT_COLUMN_KEY = "select-row", DEFAULT_COLUMN_WIDTH = "auto", DEFAULT_COLUMN_MIN_WIDTH = 50;
function useCalculatedColumns({
  rawColumns: t,
  defaultColumnOptions: e,
  getColumnWidth: n,
  viewportWidth: a,
  scrollLeft: s,
  enableVirtualization: o
}) {
  const l = (e == null ? void 0 : e.width) ?? DEFAULT_COLUMN_WIDTH, c = (e == null ? void 0 : e.minWidth) ?? DEFAULT_COLUMN_MIN_WIDTH, u = (e == null ? void 0 : e.maxWidth) ?? void 0, d = (e == null ? void 0 : e.renderCell) ?? renderValue, f = (e == null ? void 0 : e.sortable) ?? !1, h = (e == null ? void 0 : e.resizable) ?? !1, g = (e == null ? void 0 : e.draggable) ?? !1, {
    columns: x,
    colSpanColumns: E,
    lastFrozenColumnIndex: m,
    headerRowsCount: v
  } = useMemo(() => {
    let R = -1, O = 1;
    const D = [];
    k(t, 1);
    function k(L, z, P) {
      for (const Q of L) {
        if ("children" in Q) {
          const te = {
            name: Q.name,
            parent: P,
            idx: -1,
            colSpan: 0,
            level: 0,
            headerCellClass: Q.headerCellClass
          };
          k(Q.children, z + 1, te);
          continue;
        }
        const Y = Q.frozen ?? !1, ie = {
          ...Q,
          parent: P,
          idx: 0,
          level: 0,
          frozen: Y,
          isLastFrozenColumn: !1,
          width: Q.width ?? l,
          minWidth: Q.minWidth ?? c,
          maxWidth: Q.maxWidth ?? u,
          sortable: Q.sortable ?? f,
          resizable: Q.resizable ?? h,
          draggable: Q.draggable ?? g,
          renderCell: Q.renderCell ?? d
        };
        D.push(ie), Y && R++, z > O && (O = z);
      }
    }
    D.sort(({
      key: L,
      frozen: z
    }, {
      key: P,
      frozen: Q
    }) => L === SELECT_COLUMN_KEY ? -1 : P === SELECT_COLUMN_KEY ? 1 : z ? Q ? 0 : -1 : Q ? 1 : 0);
    const W = [];
    return D.forEach((L, z) => {
      L.idx = z, updateColumnParent(L, z, 0), L.colSpan != null && W.push(L);
    }), R !== -1 && (D[R].isLastFrozenColumn = !0), {
      columns: D,
      colSpanColumns: W,
      lastFrozenColumnIndex: R,
      headerRowsCount: O
    };
  }, [t, l, c, u, d, h, f, g]), {
    templateColumns: y,
    layoutCssVars: A,
    totalFrozenColumnWidth: b,
    columnMetrics: C
  } = useMemo(() => {
    const R = /* @__PURE__ */ new Map();
    let O = 0, D = 0;
    const k = [];
    for (const L of x) {
      let z = n(L);
      typeof z == "number" ? z = clampColumnWidth(z, L) : z = L.minWidth, k.push(`${z}px`), R.set(L, {
        width: z,
        left: O
      }), O += z;
    }
    if (m !== -1) {
      const L = R.get(x[m]);
      D = L.left + L.width;
    }
    const W = {};
    for (let L = 0; L <= m; L++) {
      const z = x[L];
      W[`--rdg-frozen-left-${z.idx}`] = `${R.get(z).left}px`;
    }
    return {
      templateColumns: k,
      layoutCssVars: W,
      totalFrozenColumnWidth: D,
      columnMetrics: R
    };
  }, [n, x, m]), [T, w] = useMemo(() => {
    if (!o)
      return [0, x.length - 1];
    const R = s + b, O = s + a, D = x.length - 1, k = min$1(m + 1, D);
    if (R >= O)
      return [k, k];
    let W = k;
    for (; W < D; ) {
      const {
        left: Q,
        width: Y
      } = C.get(x[W]);
      if (Q + Y > R)
        break;
      W++;
    }
    let L = W;
    for (; L < D; ) {
      const {
        left: Q,
        width: Y
      } = C.get(x[L]);
      if (Q + Y >= O)
        break;
      L++;
    }
    const z = max$1(k, W - 1), P = min$1(D, L + 1);
    return [z, P];
  }, [C, x, m, s, b, a, o]);
  return {
    columns: x,
    colSpanColumns: E,
    colOverscanStartIdx: T,
    colOverscanEndIdx: w,
    templateColumns: y,
    layoutCssVars: A,
    headerRowsCount: v,
    lastFrozenColumnIndex: m,
    totalFrozenColumnWidth: b
  };
}
function updateColumnParent(t, e, n) {
  if (n < t.level && (t.level = n), t.parent !== void 0) {
    const {
      parent: a
    } = t;
    a.idx === -1 && (a.idx = e), a.colSpan += 1, updateColumnParent(a, e, n - 1);
  }
}
const useLayoutEffect = typeof window > "u" ? useEffect : useLayoutEffect$1;
function useColumnWidths(t, e, n, a, s, o, l, c, u, d) {
  const f = useRef(s), h = t.length === e.length, g = h && s !== f.current, x = [...n], E = [];
  for (const {
    key: A,
    idx: b,
    width: C
  } of e)
    typeof C == "string" && (g || !l.has(A)) && !o.has(A) && (x[b] = C, E.push(A));
  const m = x.join(" ");
  useLayoutEffect(() => {
    f.current = s, v(E);
  });
  function v(A) {
    A.length !== 0 && u((b) => {
      const C = new Map(b);
      let T = !1;
      for (const w of A) {
        const R = measureColumnWidth(a, w);
        T || (T = R !== b.get(w)), R === void 0 ? C.delete(w) : C.set(w, R);
      }
      return T ? C : b;
    });
  }
  function y(A, b) {
    const {
      key: C
    } = A, T = [...n], w = [];
    for (const {
      key: O,
      idx: D,
      width: k
    } of e)
      if (C === O) {
        const W = typeof b == "number" ? `${b}px` : b;
        T[D] = W;
      } else
        h && typeof k == "string" && !o.has(O) && (T[D] = k, w.push(O));
    a.current.style.gridTemplateColumns = T.join(" ");
    const R = typeof b == "number" ? b : measureColumnWidth(a, C);
    flushSync(() => {
      c((O) => {
        const D = new Map(O);
        return D.set(C, R), D;
      }), v(w);
    }), d == null || d(A.idx, R);
  }
  return {
    gridTemplateColumns: m,
    handleColumnResize: y
  };
}
function measureColumnWidth(t, e) {
  const n = `[data-measuring-cell-key="${CSS.escape(e)}"]`, a = t.current.querySelector(n);
  return a == null ? void 0 : a.getBoundingClientRect().width;
}
function useGridDimensions() {
  const t = useRef(null), [e, n] = useState(1), [a, s] = useState(1);
  return useLayoutEffect(() => {
    const {
      ResizeObserver: o
    } = window;
    if (o == null)
      return;
    const {
      clientWidth: l,
      clientHeight: c,
      offsetWidth: u,
      offsetHeight: d
    } = t.current, {
      width: f,
      height: h
    } = t.current.getBoundingClientRect(), g = f - u + l, x = h - d + c;
    n(g), s(x);
    const E = new o((m) => {
      const v = m[0].contentBoxSize[0];
      flushSync(() => {
        n(v.inlineSize), s(v.blockSize);
      });
    });
    return E.observe(t.current), () => {
      E.disconnect();
    };
  }, []), [t, e, a];
}
function useLatestFunc(t) {
  const e = useRef(t);
  useEffect(() => {
    e.current = t;
  });
  const n = useCallback((...a) => {
    e.current(...a);
  }, []);
  return t && n;
}
function useRovingTabIndex(t) {
  const [e, n] = useState(!1);
  e && !t && n(!1);
  function a(o) {
    o.target !== o.currentTarget && n(!0);
  }
  return {
    tabIndex: t && !e ? 0 : -1,
    childTabIndex: t ? 0 : -1,
    onFocus: t ? a : void 0
  };
}
function useViewportColumns({
  columns: t,
  colSpanColumns: e,
  rows: n,
  topSummaryRows: a,
  bottomSummaryRows: s,
  colOverscanStartIdx: o,
  colOverscanEndIdx: l,
  lastFrozenColumnIndex: c,
  rowOverscanStartIdx: u,
  rowOverscanEndIdx: d
}) {
  const f = useMemo(() => {
    if (o === 0)
      return 0;
    let h = o;
    const g = (x, E) => E !== void 0 && x + E > o ? (h = x, !0) : !1;
    for (const x of e) {
      const E = x.idx;
      if (E >= h || g(E, getColSpan(x, c, {
        type: "HEADER"
      })))
        break;
      for (let m = u; m <= d; m++) {
        const v = n[m];
        if (g(E, getColSpan(x, c, {
          type: "ROW",
          row: v
        })))
          break;
      }
      if (a != null) {
        for (const m of a)
          if (g(E, getColSpan(x, c, {
            type: "SUMMARY",
            row: m
          })))
            break;
      }
      if (s != null) {
        for (const m of s)
          if (g(E, getColSpan(x, c, {
            type: "SUMMARY",
            row: m
          })))
            break;
      }
    }
    return h;
  }, [u, d, n, a, s, o, c, e]);
  return useMemo(() => {
    const h = [];
    for (let g = 0; g <= l; g++) {
      const x = t[g];
      g < f && !x.frozen || h.push(x);
    }
    return h;
  }, [f, l, t]);
}
function useViewportRows({
  rows: t,
  rowHeight: e,
  clientHeight: n,
  scrollTop: a,
  enableVirtualization: s
}) {
  const {
    totalRowHeight: o,
    gridTemplateRows: l,
    getRowTop: c,
    getRowHeight: u,
    findRowIdx: d
  } = useMemo(() => {
    if (typeof e == "number")
      return {
        totalRowHeight: e * t.length,
        gridTemplateRows: ` repeat(${t.length}, ${e}px)`,
        getRowTop: (v) => v * e,
        getRowHeight: () => e,
        findRowIdx: (v) => floor(v / e)
      };
    let g = 0, x = " ";
    const E = t.map((v) => {
      const y = e(v), A = {
        top: g,
        height: y
      };
      return x += `${y}px `, g += y, A;
    }), m = (v) => max$1(0, min$1(t.length - 1, v));
    return {
      totalRowHeight: g,
      gridTemplateRows: x,
      getRowTop: (v) => E[m(v)].top,
      getRowHeight: (v) => E[m(v)].height,
      findRowIdx(v) {
        let y = 0, A = E.length - 1;
        for (; y <= A; ) {
          const b = y + floor((A - y) / 2), C = E[b].top;
          if (C === v)
            return b;
          if (C < v ? y = b + 1 : C > v && (A = b - 1), y > A)
            return A;
        }
        return 0;
      }
    };
  }, [e, t]);
  let f = 0, h = t.length - 1;
  if (s) {
    const x = d(a), E = d(a + n);
    f = max$1(0, x - 4), h = min$1(t.length - 1, E + 4);
  }
  return {
    rowOverscanStartIdx: f,
    rowOverscanEndIdx: h,
    totalRowHeight: o,
    gridTemplateRows: l,
    getRowTop: c,
    getRowHeight: u,
    findRowIdx: d
  };
}
const cellDragHandle = "c1w9bbhr7-0-0-beta-41", cellDragHandleFrozenClassname = "c1creorc7-0-0-beta-41", cellDragHandleClassname = `rdg-cell-drag-handle ${cellDragHandle}`;
function DragHandle({
  gridRowStart: t,
  rows: e,
  column: n,
  columnWidth: a,
  maxColIdx: s,
  isLastRow: o,
  selectedPosition: l,
  latestDraggedOverRowIdx: c,
  isCellEditable: u,
  onRowsChange: d,
  onFill: f,
  onClick: h,
  setDragging: g,
  setDraggedOverRowIdx: x
}) {
  const {
    idx: E,
    rowIdx: m
  } = l;
  function v(T) {
    if (T.preventDefault(), T.buttons !== 1)
      return;
    g(!0), window.addEventListener("mouseover", w), window.addEventListener("mouseup", R);
    function w(O) {
      O.buttons !== 1 && R();
    }
    function R() {
      window.removeEventListener("mouseover", w), window.removeEventListener("mouseup", R), g(!1), y();
    }
  }
  function y() {
    const T = c.current;
    if (T === void 0)
      return;
    const w = m < T ? m + 1 : T, R = m < T ? T + 1 : m;
    b(w, R), x(void 0);
  }
  function A(T) {
    T.stopPropagation(), b(m + 1, e.length);
  }
  function b(T, w) {
    const R = e[m], O = [...e], D = [];
    for (let k = T; k < w; k++)
      if (u({
        rowIdx: k,
        idx: E
      })) {
        const W = f({
          columnKey: n.key,
          sourceRow: R,
          targetRow: e[k]
        });
        W !== e[k] && (O[k] = W, D.push(k));
      }
    D.length > 0 && (d == null || d(O, {
      indexes: D,
      column: n
    }));
  }
  function C() {
    var k;
    const T = ((k = n.colSpan) == null ? void 0 : k.call(n, {
      type: "ROW",
      row: e[m]
    })) ?? 1, {
      insetInlineStart: w,
      ...R
    } = getCellStyle(n, T), O = "calc(var(--rdg-drag-handle-size) * -0.5 + 1px)", D = n.idx + T - 1 === s;
    return {
      ...R,
      gridRowStart: t,
      marginInlineEnd: D ? void 0 : O,
      marginBlockEnd: o ? void 0 : O,
      insetInlineStart: w ? `calc(${w} + ${a}px + var(--rdg-drag-handle-size) * -0.5 - 1px)` : void 0
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    style: C(),
    className: clsx(cellDragHandleClassname, n.frozen && cellDragHandleFrozenClassname),
    onClick: h,
    onMouseDown: v,
    onDoubleClick: A
  });
}
const cellEditing = "cis5rrm7-0-0-beta-41";
function EditCell({
  column: t,
  colSpan: e,
  row: n,
  rowIdx: a,
  onRowChange: s,
  closeEditor: o,
  onKeyDown: l,
  navigate: c
}) {
  var y, A, b;
  const u = useRef(), d = ((y = t.editorOptions) == null ? void 0 : y.commitOnOutsideClick) !== !1, f = useLatestFunc(() => {
    x(!0, !1);
  });
  useEffect(() => {
    if (!d)
      return;
    function C() {
      u.current = requestAnimationFrame(f);
    }
    return addEventListener("mousedown", C, {
      capture: !0
    }), () => {
      removeEventListener("mousedown", C, {
        capture: !0
      }), h();
    };
  }, [d, f]);
  function h() {
    cancelAnimationFrame(u.current);
  }
  function g(C) {
    if (l) {
      const T = createCellEvent(C);
      if (l({
        mode: "EDIT",
        row: n,
        column: t,
        rowIdx: a,
        navigate() {
          c(C);
        },
        onClose: x
      }, T), T.isGridDefaultPrevented())
        return;
    }
    C.key === "Escape" ? x() : C.key === "Enter" ? x(!0) : onEditorNavigation(C) && c(C);
  }
  function x(C = !1, T = !0) {
    C ? s(n, !0, T) : o(T);
  }
  function E(C, T = !1) {
    s(C, T, T);
  }
  const {
    cellClass: m
  } = t, v = getCellClassname(t, "rdg-editor-container", typeof m == "function" ? m(n) : m, !((A = t.editorOptions) != null && A.displayCellContent) && cellEditing);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "gridcell",
    "aria-colindex": t.idx + 1,
    "aria-colspan": e,
    "aria-selected": !0,
    className: v,
    style: getCellStyle(t, e),
    onKeyDown: g,
    onMouseDownCapture: h,
    children: t.renderEditCell != null && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [t.renderEditCell({
        column: t,
        row: n,
        onRowChange: E,
        onClose: x
      }), ((b = t.editorOptions) == null ? void 0 : b.displayCellContent) && t.renderCell({
        column: t,
        row: n,
        rowIdx: a,
        isCellEditable: !0,
        tabIndex: -1,
        onRowChange: E
      })]
    })
  });
}
function GroupedColumnHeaderCell({
  column: t,
  rowIdx: e,
  isCellSelected: n,
  selectCell: a
}) {
  const {
    tabIndex: s,
    onFocus: o
  } = useRovingTabIndex(n), {
    colSpan: l
  } = t, c = getHeaderCellRowSpan(t, e), u = t.idx + 1;
  function d() {
    a({
      idx: t.idx,
      rowIdx: e
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "columnheader",
    "aria-colindex": u,
    "aria-colspan": l,
    "aria-rowspan": c,
    "aria-selected": n,
    tabIndex: s,
    className: clsx(cellClassname, t.headerCellClass),
    style: {
      ...getHeaderCellStyle(t, e, c),
      gridColumnStart: u,
      gridColumnEnd: u + l
    },
    onFocus: o,
    onClick: d,
    children: t.name
  });
}
const headerSortCellClassname = "h44jtk67-0-0-beta-41", headerSortName = "hcgkhxz7-0-0-beta-41", headerSortNameClassname = `rdg-header-sort-name ${headerSortName}`;
function renderHeaderCell({
  column: t,
  sortDirection: e,
  priority: n
}) {
  return t.sortable ? /* @__PURE__ */ jsxRuntimeExports.jsx(SortableHeaderCell, {
    sortDirection: e,
    priority: n,
    children: t.name
  }) : t.name;
}
function SortableHeaderCell({
  sortDirection: t,
  priority: e,
  children: n
}) {
  const a = useDefaultRenderers().renderSortStatus;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
    className: headerSortCellClassname,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: headerSortNameClassname,
      children: n
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: a({
        sortDirection: t,
        priority: e
      })
    })]
  });
}
const cellSortableClassname = "c6l2wv17-0-0-beta-41", cellResizable = "c1kqdw7y7-0-0-beta-41", cellResizableClassname = `rdg-cell-resizable ${cellResizable}`, resizeHandleClassname = "r1y6ywlx7-0-0-beta-41", cellDraggableClassname = "rdg-cell-draggable", cellDragging = "c1bezg5o7-0-0-beta-41", cellDraggingClassname = `rdg-cell-dragging ${cellDragging}`, cellOver = "c1vc96037-0-0-beta-41", cellOverClassname = `rdg-cell-drag-over ${cellOver}`;
function HeaderCell({
  column: t,
  colSpan: e,
  rowIdx: n,
  isCellSelected: a,
  onColumnResize: s,
  onColumnsReorder: o,
  sortColumns: l,
  onSortColumnsChange: c,
  selectCell: u,
  shouldFocusGrid: d,
  direction: f,
  dragDropKey: h
}) {
  const [g, x] = useState(!1), [E, m] = useState(!1), v = f === "rtl", y = getHeaderCellRowSpan(t, n), {
    tabIndex: A,
    childTabIndex: b,
    onFocus: C
  } = useRovingTabIndex(a), T = l == null ? void 0 : l.findIndex((q) => q.columnKey === t.key), w = T !== void 0 && T > -1 ? l[T] : void 0, R = w == null ? void 0 : w.direction, O = w !== void 0 && l.length > 1 ? T + 1 : void 0, D = R && !O ? R === "ASC" ? "ascending" : "descending" : void 0, {
    sortable: k,
    resizable: W,
    draggable: L
  } = t, z = getCellClassname(t, t.headerCellClass, k && cellSortableClassname, W && cellResizableClassname, L && cellDraggableClassname, g && cellDraggingClassname, E && cellOverClassname), P = t.renderHeaderCell ?? renderHeaderCell;
  function Q(q) {
    if (q.pointerType === "mouse" && q.buttons !== 1)
      return;
    q.preventDefault();
    const {
      currentTarget: H,
      pointerId: ne
    } = q, he = H.parentElement, {
      right: j,
      left: Fe
    } = he.getBoundingClientRect(), X = v ? q.clientX - Fe : j - q.clientX;
    function ye(fe) {
      const {
        right: _e,
        left: Ie
      } = he.getBoundingClientRect(), Be = v ? _e + X - fe.clientX : fe.clientX + X - Ie;
      Be > 0 && s(t, clampColumnWidth(Be, t));
    }
    function Ae() {
      H.removeEventListener("pointermove", ye), H.removeEventListener("lostpointercapture", Ae);
    }
    H.setPointerCapture(ne), H.addEventListener("pointermove", ye), H.addEventListener("lostpointercapture", Ae);
  }
  function Y(q) {
    if (c == null)
      return;
    const {
      sortDescendingFirst: H
    } = t;
    if (w === void 0) {
      const ne = {
        columnKey: t.key,
        direction: H ? "DESC" : "ASC"
      };
      c(l && q ? [...l, ne] : [ne]);
    } else {
      let ne;
      if ((H === !0 && R === "DESC" || H !== !0 && R === "ASC") && (ne = {
        columnKey: t.key,
        direction: R === "ASC" ? "DESC" : "ASC"
      }), q) {
        const he = [...l];
        ne ? he[T] = ne : he.splice(T, 1), c(he);
      } else
        c(ne ? [ne] : []);
    }
  }
  function ie(q) {
    u({
      idx: t.idx,
      rowIdx: n
    }), k && Y(q.ctrlKey || q.metaKey);
  }
  function te() {
    s(t, "max-content");
  }
  function Z(q) {
    C == null || C(q), d && u({
      idx: 0,
      rowIdx: n
    });
  }
  function ae(q) {
    (q.key === " " || q.key === "Enter") && (q.preventDefault(), Y(q.ctrlKey || q.metaKey));
  }
  function G(q) {
    q.dataTransfer.setData(h, t.key), q.dataTransfer.dropEffect = "move", x(!0);
  }
  function U() {
    x(!1);
  }
  function F(q) {
    q.preventDefault(), q.dataTransfer.dropEffect = "move";
  }
  function M(q) {
    if (m(!1), q.dataTransfer.types.includes(h)) {
      const H = q.dataTransfer.getData(h);
      H !== t.key && (q.preventDefault(), o == null || o(H, t.key));
    }
  }
  function I(q) {
    isEventPertinent(q) && m(!0);
  }
  function N(q) {
    isEventPertinent(q) && m(!1);
  }
  let V;
  return L && (V = {
    draggable: !0,
    onDragStart: G,
    onDragEnd: U,
    onDragOver: F,
    onDragEnter: I,
    onDragLeave: N,
    onDrop: M
  }), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    role: "columnheader",
    "aria-colindex": t.idx + 1,
    "aria-colspan": e,
    "aria-rowspan": y,
    "aria-selected": a,
    "aria-sort": D,
    tabIndex: d ? 0 : A,
    className: z,
    style: {
      ...getHeaderCellStyle(t, n, y),
      ...getCellStyle(t, e)
    },
    onFocus: Z,
    onClick: ie,
    onKeyDown: k ? ae : void 0,
    ...V,
    children: [P({
      column: t,
      sortDirection: R,
      priority: O,
      tabIndex: b
    }), W && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: resizeHandleClassname,
      onClick: stopPropagation,
      onDoubleClick: te,
      onPointerDown: Q
    })]
  });
}
function isEventPertinent(t) {
  const e = t.relatedTarget;
  return !t.currentTarget.contains(e);
}
const row = "r1upfr807-0-0-beta-41", rowClassname = `rdg-row ${row}`, rowSelected = "r190mhd37-0-0-beta-41", rowSelectedClassname = "rdg-row-selected", rowSelectedWithFrozenCell = "r139qu9m7-0-0-beta-41", headerRow = "h10tskcx7-0-0-beta-41", headerRowClassname = `rdg-header-row ${headerRow}`;
function HeaderRow({
  rowIdx: t,
  columns: e,
  onColumnResize: n,
  onColumnsReorder: a,
  sortColumns: s,
  onSortColumnsChange: o,
  lastFrozenColumnIndex: l,
  selectedCellIdx: c,
  selectCell: u,
  shouldFocusGrid: d,
  direction: f
}) {
  const h = useId(), g = [];
  for (let x = 0; x < e.length; x++) {
    const E = e[x], m = getColSpan(E, l, {
      type: "HEADER"
    });
    m !== void 0 && (x += m - 1), g.push(/* @__PURE__ */ jsxRuntimeExports.jsx(HeaderCell, {
      column: E,
      colSpan: m,
      rowIdx: t,
      isCellSelected: c === E.idx,
      onColumnResize: n,
      onColumnsReorder: a,
      onSortColumnsChange: o,
      sortColumns: s,
      selectCell: u,
      shouldFocusGrid: d && x === 0,
      direction: f,
      dragDropKey: h
    }, E.key));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "row",
    "aria-rowindex": t,
    className: clsx(headerRowClassname, c === -1 && rowSelectedClassname),
    children: g
  });
}
const HeaderRow$1 = /* @__PURE__ */ memo(HeaderRow);
function GroupedColumnHeaderRow({
  rowIdx: t,
  level: e,
  columns: n,
  selectedCellIdx: a,
  selectCell: s
}) {
  const o = [], l = /* @__PURE__ */ new Set();
  for (const c of n) {
    let {
      parent: u
    } = c;
    if (u !== void 0) {
      for (; u.level > e && u.parent !== void 0; )
        u = u.parent;
      if (u.level === e && !l.has(u)) {
        l.add(u);
        const {
          idx: d
        } = u;
        o.push(/* @__PURE__ */ jsxRuntimeExports.jsx(GroupedColumnHeaderCell, {
          column: u,
          rowIdx: t,
          isCellSelected: a === d,
          selectCell: s
        }, d));
      }
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "row",
    "aria-rowindex": t,
    className: headerRowClassname,
    children: o
  });
}
const GroupedColumnHeaderRow$1 = /* @__PURE__ */ memo(GroupedColumnHeaderRow), cellCopied = "c6ra8a37-0-0-beta-41", cellCopiedClassname = `rdg-cell-copied ${cellCopied}`, cellDraggedOver = "cq910m07-0-0-beta-41", cellDraggedOverClassname = `rdg-cell-dragged-over ${cellDraggedOver}`;
function Cell({
  column: t,
  colSpan: e,
  isCellSelected: n,
  isCopied: a,
  isDraggedOver: s,
  row: o,
  rowIdx: l,
  onClick: c,
  onDoubleClick: u,
  onContextMenu: d,
  onRowChange: f,
  selectCell: h,
  ...g
}) {
  const {
    tabIndex: x,
    childTabIndex: E,
    onFocus: m
  } = useRovingTabIndex(n), {
    cellClass: v
  } = t, y = getCellClassname(t, typeof v == "function" ? v(o) : v, a && cellCopiedClassname, s && cellDraggedOverClassname), A = isCellEditableUtil(t, o);
  function b(O) {
    h({
      rowIdx: l,
      idx: t.idx
    }, O);
  }
  function C(O) {
    if (c) {
      const D = createCellEvent(O);
      if (c({
        row: o,
        column: t,
        selectCell: b
      }, D), D.isGridDefaultPrevented())
        return;
    }
    b();
  }
  function T(O) {
    if (d) {
      const D = createCellEvent(O);
      if (d({
        row: o,
        column: t,
        selectCell: b
      }, D), D.isGridDefaultPrevented())
        return;
    }
    b();
  }
  function w(O) {
    if (u) {
      const D = createCellEvent(O);
      if (u({
        row: o,
        column: t,
        selectCell: b
      }, D), D.isGridDefaultPrevented())
        return;
    }
    b(!0);
  }
  function R(O) {
    f(t, O);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "gridcell",
    "aria-colindex": t.idx + 1,
    "aria-colspan": e,
    "aria-selected": n,
    "aria-readonly": !A || void 0,
    tabIndex: x,
    className: y,
    style: getCellStyle(t, e),
    onClick: C,
    onDoubleClick: w,
    onContextMenu: T,
    onFocus: m,
    ...g,
    children: t.renderCell({
      column: t,
      row: o,
      rowIdx: l,
      isCellEditable: A,
      tabIndex: E,
      onRowChange: R
    })
  });
}
const Cell$1 = /* @__PURE__ */ memo(Cell);
function Row({
  className: t,
  rowIdx: e,
  gridRowStart: n,
  height: a,
  selectedCellIdx: s,
  isRowSelected: o,
  copiedCellIdx: l,
  draggedOverCellIdx: c,
  lastFrozenColumnIndex: u,
  row: d,
  viewportColumns: f,
  selectedCellEditor: h,
  onCellClick: g,
  onCellDoubleClick: x,
  onCellContextMenu: E,
  rowClass: m,
  setDraggedOverRowIdx: v,
  onMouseEnter: y,
  onRowChange: A,
  selectCell: b,
  ...C
}, T) {
  const w = useLatestFunc((D, k) => {
    A(D, e, k);
  });
  function R(D) {
    v == null || v(e), y == null || y(D);
  }
  t = clsx(rowClassname, `rdg-row-${e % 2 === 0 ? "even" : "odd"}`, m == null ? void 0 : m(d, e), t, s === -1 && rowSelectedClassname);
  const O = [];
  for (let D = 0; D < f.length; D++) {
    const k = f[D], {
      idx: W
    } = k, L = getColSpan(k, u, {
      type: "ROW",
      row: d
    });
    L !== void 0 && (D += L - 1);
    const z = s === W;
    z && h ? O.push(h) : O.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Cell$1, {
      column: k,
      colSpan: L,
      row: d,
      rowIdx: e,
      isCopied: l === W,
      isDraggedOver: c === W,
      isCellSelected: z,
      onClick: g,
      onDoubleClick: x,
      onContextMenu: E,
      onRowChange: w,
      selectCell: b
    }, k.key));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RowSelectionProvider, {
    value: o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      role: "row",
      ref: T,
      className: t,
      onMouseEnter: R,
      style: getRowStyle(n, a),
      ...C,
      children: O
    })
  });
}
const RowComponent = /* @__PURE__ */ memo(/* @__PURE__ */ forwardRef(Row));
function defaultRenderRow(t, e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RowComponent, {
    ...e
  }, t);
}
function ScrollToCell({
  scrollToPosition: {
    idx: t,
    rowIdx: e
  },
  gridElement: n,
  setScrollToCellPosition: a
}) {
  const s = useRef(null);
  return useLayoutEffect(() => {
    scrollIntoView(s.current);
  }), useLayoutEffect(() => {
    function o() {
      a(null);
    }
    const l = new IntersectionObserver(o, {
      root: n,
      threshold: 1
    });
    return l.observe(s.current), () => {
      l.disconnect();
    };
  }, [n, a]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref: s,
    style: {
      gridColumn: t === void 0 ? "1/-1" : t + 1,
      gridRow: e === void 0 ? "1/-1" : e + 2
    }
  });
}
const arrow = "a3ejtar7-0-0-beta-41", arrowClassname = `rdg-sort-arrow ${arrow}`;
function renderSortStatus({
  sortDirection: t,
  priority: e
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [renderSortIcon({
      sortDirection: t
    }), renderSortPriority({
      priority: e
    })]
  });
}
function renderSortIcon({
  sortDirection: t
}) {
  return t === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("svg", {
    viewBox: "0 0 12 8",
    width: "12",
    height: "8",
    className: arrowClassname,
    "aria-hidden": !0,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
      d: t === "ASC" ? "M0 8 6 0 12 8" : "M0 0 6 8 12 0"
    })
  });
}
function renderSortPriority({
  priority: t
}) {
  return t;
}
const root$1 = "rnvodz57-0-0-beta-41", rootClassname = `rdg ${root$1}`, viewportDragging = "vlqv91k7-0-0-beta-41", viewportDraggingClassname = `rdg-viewport-dragging ${viewportDragging}`, focusSinkClassname = "f1lsfrzw7-0-0-beta-41", focusSinkHeaderAndSummaryClassname = "f1cte0lg7-0-0-beta-41", summaryCellClassname = "s8wc6fl7-0-0-beta-41";
function SummaryCell({
  column: t,
  colSpan: e,
  row: n,
  rowIdx: a,
  isCellSelected: s,
  selectCell: o
}) {
  var g;
  const {
    tabIndex: l,
    childTabIndex: c,
    onFocus: u
  } = useRovingTabIndex(s), {
    summaryCellClass: d
  } = t, f = getCellClassname(t, summaryCellClassname, typeof d == "function" ? d(n) : d);
  function h() {
    o({
      rowIdx: a,
      idx: t.idx
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "gridcell",
    "aria-colindex": t.idx + 1,
    "aria-colspan": e,
    "aria-selected": s,
    tabIndex: l,
    className: f,
    style: getCellStyle(t, e),
    onClick: h,
    onFocus: u,
    children: (g = t.renderSummaryCell) == null ? void 0 : g.call(t, {
      column: t,
      row: n,
      tabIndex: c
    })
  });
}
const SummaryCell$1 = /* @__PURE__ */ memo(SummaryCell), summaryRow = "skuhp557-0-0-beta-41", topSummaryRow = "tf8l5ub7-0-0-beta-41", topSummaryRowBorderClassname = "tb9ughf7-0-0-beta-41", bottomSummaryRowBorderClassname = "b1yssfnt7-0-0-beta-41", summaryRowClassname = `rdg-summary-row ${summaryRow}`, topSummaryRowClassname = `rdg-top-summary-row ${topSummaryRow}`;
function SummaryRow({
  rowIdx: t,
  gridRowStart: e,
  row: n,
  viewportColumns: a,
  top: s,
  bottom: o,
  lastFrozenColumnIndex: l,
  selectedCellIdx: c,
  isTop: u,
  showBorder: d,
  selectCell: f,
  "aria-rowindex": h
}) {
  const g = [];
  for (let x = 0; x < a.length; x++) {
    const E = a[x], m = getColSpan(E, l, {
      type: "SUMMARY",
      row: n
    });
    m !== void 0 && (x += m - 1);
    const v = c === E.idx;
    g.push(/* @__PURE__ */ jsxRuntimeExports.jsx(SummaryCell$1, {
      column: E,
      colSpan: m,
      row: n,
      rowIdx: t,
      isCellSelected: v,
      selectCell: f
    }, E.key));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "row",
    "aria-rowindex": h,
    className: clsx(rowClassname, `rdg-row-${t % 2 === 0 ? "even" : "odd"}`, summaryRowClassname, u ? [topSummaryRowClassname, d && topSummaryRowBorderClassname] : ["rdg-bottom-summary-row", d && bottomSummaryRowBorderClassname], c === -1 && rowSelectedClassname),
    style: {
      ...getRowStyle(e),
      "--rdg-summary-row-top": s !== void 0 ? `${s}px` : void 0,
      "--rdg-summary-row-bottom": o !== void 0 ? `${o}px` : void 0
    },
    children: g
  });
}
const SummaryRow$1 = /* @__PURE__ */ memo(SummaryRow);
function DataGrid(t, e) {
  const {
    columns: n,
    rows: a,
    topSummaryRows: s,
    bottomSummaryRows: o,
    rowKeyGetter: l,
    onRowsChange: c,
    rowHeight: u,
    headerRowHeight: d,
    summaryRowHeight: f,
    selectedRows: h,
    onSelectedRowsChange: g,
    sortColumns: x,
    onSortColumnsChange: E,
    defaultColumnOptions: m,
    onCellClick: v,
    onCellDoubleClick: y,
    onCellContextMenu: A,
    onCellKeyDown: b,
    onSelectedCellChange: C,
    onScroll: T,
    onColumnResize: w,
    onColumnsReorder: R,
    onFill: O,
    onCopy: D,
    onPaste: k,
    enableVirtualization: W,
    renderers: L,
    className: z,
    style: P,
    rowClass: Q,
    direction: Y,
    role: ie,
    "aria-label": te,
    "aria-labelledby": Z,
    "aria-describedby": ae,
    "aria-rowcount": G,
    "data-testid": U
  } = t, F = useDefaultRenderers(), M = ie ?? "grid", I = u ?? 35, N = d ?? (typeof I == "number" ? I : 35), V = f ?? (typeof I == "number" ? I : 35), q = (L == null ? void 0 : L.renderRow) ?? (F == null ? void 0 : F.renderRow) ?? defaultRenderRow, H = (L == null ? void 0 : L.renderSortStatus) ?? (F == null ? void 0 : F.renderSortStatus) ?? renderSortStatus, ne = (L == null ? void 0 : L.renderCheckbox) ?? (F == null ? void 0 : F.renderCheckbox) ?? renderCheckbox, he = (L == null ? void 0 : L.noRowsFallback) ?? (F == null ? void 0 : F.noRowsFallback), j = W ?? !0, Fe = Y ?? "ltr", [X, ye] = useState(0), [Ae, fe] = useState(0), [_e, Ie] = useState(() => /* @__PURE__ */ new Map()), [Be, $e] = useState(() => /* @__PURE__ */ new Map()), [Me, J] = useState(null), [K, ge] = useState(!1), [Ce, Oe] = useState(void 0), [qe, ct] = useState(null), ze = useCallback((Et) => _e.get(Et.key) ?? Be.get(Et.key) ?? Et.width, [Be, _e]), [et, gt, pt] = useGridDimensions(), {
    columns: nt,
    colSpanColumns: tt,
    lastFrozenColumnIndex: Ve,
    headerRowsCount: We,
    colOverscanStartIdx: it,
    colOverscanEndIdx: Je,
    templateColumns: Rt,
    layoutCssVars: je,
    totalFrozenColumnWidth: ke
  } = useCalculatedColumns({
    rawColumns: n,
    defaultColumnOptions: m,
    getColumnWidth: ze,
    scrollLeft: Ae,
    viewportWidth: gt,
    enableVirtualization: j
  }), Ye = (s == null ? void 0 : s.length) ?? 0, Ze = (o == null ? void 0 : o.length) ?? 0, rt = Ye + Ze, xt = We + Ye, bt = We - 1, wt = -xt, mt = wt + bt, St = a.length + Ze - 1, [dt, Le] = useState(() => ({
    idx: -1,
    rowIdx: wt - 1,
    mode: "SELECT"
  })), ue = useRef(dt), De = useRef(Ce), Ne = useRef(-1), oe = useRef(null), ee = useRef(!1), ce = M === "treegrid", pe = We * N, be = pt - pe - rt * V, Ee = h != null && g != null, He = Fe === "rtl", de = He ? "ArrowRight" : "ArrowLeft", ve = He ? "ArrowLeft" : "ArrowRight", Se = G ?? We + a.length + rt, we = useMemo(() => ({
    renderCheckbox: ne,
    renderSortStatus: H
  }), [ne, H]), Ue = useMemo(() => {
    const {
      length: Et
    } = a;
    return Et !== 0 && h != null && l != null && h.size >= Et && a.every((Ct) => h.has(l(Ct)));
  }, [a, h, l]), {
    rowOverscanStartIdx: Qe,
    rowOverscanEndIdx: ft,
    totalRowHeight: ut,
    gridTemplateRows: _t,
    getRowTop: At,
    getRowHeight: Dt,
    findRowIdx: Mt
  } = useViewportRows({
    rows: a,
    rowHeight: I,
    clientHeight: be,
    scrollTop: X,
    enableVirtualization: j
  }), Ut = useViewportColumns({
    columns: nt,
    colSpanColumns: tt,
    colOverscanStartIdx: it,
    colOverscanEndIdx: Je,
    lastFrozenColumnIndex: Ve,
    rowOverscanStartIdx: Qe,
    rowOverscanEndIdx: ft,
    rows: a,
    topSummaryRows: s,
    bottomSummaryRows: o
  }), {
    gridTemplateColumns: Qt,
    handleColumnResize: zt
  } = useColumnWidths(nt, Ut, Rt, et, gt, _e, Be, Ie, $e, w), sn = ce ? -1 : 0, Vt = nt.length - 1, Wt = Vn(dt), an = rr(dt), Kt = useLatestFunc(zt), dn = useLatestFunc(R), Mn = useLatestFunc(E), mn = useLatestFunc(v), En = useLatestFunc(y), on = useLatestFunc(A), fn = useLatestFunc(Sn), An = useLatestFunc(Fn), cn = useLatestFunc(Cn), yn = useLatestFunc(({
    idx: Et,
    rowIdx: Ct
  }) => {
    Cn({
      rowIdx: wt + Ct - 1,
      idx: Et
    });
  });
  useLayoutEffect(() => {
    if (!Wt || isSamePosition(dt, ue.current)) {
      ue.current = dt;
      return;
    }
    ue.current = dt, dt.idx === -1 && (oe.current.focus({
      preventScroll: !0
    }), scrollIntoView(oe.current));
  }), useLayoutEffect(() => {
    ee.current && (ee.current = !1, sr());
  }), useImperativeHandle(e, () => ({
    element: et.current,
    scrollToCell({
      idx: Et,
      rowIdx: Ct
    }) {
      const It = Et !== void 0 && Et > Ve && Et < nt.length ? Et : void 0, Pt = Ct !== void 0 && bn(Ct) ? Ct : void 0;
      (It !== void 0 || Pt !== void 0) && ct({
        idx: It,
        rowIdx: Pt
      });
    },
    selectCell: Cn
  }));
  const Tn = useCallback((Et) => {
    Oe(Et), De.current = Et;
  }, []);
  function Sn(Et) {
    if (!g)
      return;
    if (assertIsValidKeyGetter(l), Et.type === "HEADER") {
      const qt = new Set(h);
      for (const jt of a) {
        const nn = l(jt);
        Et.checked ? qt.add(nn) : qt.delete(nn);
      }
      g(qt);
      return;
    }
    const {
      row: Ct,
      checked: It,
      isShiftClick: Pt
    } = Et, Gt = new Set(h), Ht = l(Ct);
    if (It) {
      Gt.add(Ht);
      const qt = Ne.current, jt = a.indexOf(Ct);
      if (Ne.current = jt, Pt && qt !== -1 && qt !== jt) {
        const nn = sign(jt - qt);
        for (let ln = qt + nn; ln !== jt; ln += nn) {
          const _n = a[ln];
          Gt.add(l(_n));
        }
      }
    } else
      Gt.delete(Ht), Ne.current = -1;
    g(Gt);
  }
  function wr(Et) {
    const {
      idx: Ct,
      rowIdx: It,
      mode: Pt
    } = dt;
    if (Pt === "EDIT")
      return;
    if (b && bn(It)) {
      const jt = a[It], nn = createCellEvent(Et);
      if (b({
        mode: "SELECT",
        row: jt,
        column: nt[Ct],
        rowIdx: It,
        selectCell: Cn
      }, nn), nn.isGridDefaultPrevented())
        return;
    }
    if (!(Et.target instanceof Element))
      return;
    const Gt = Et.target.closest(".rdg-cell") !== null, Ht = ce && Et.target === oe.current;
    if (!Gt && !Ht)
      return;
    const {
      keyCode: qt
    } = Et;
    if (an && (k != null || D != null) && isCtrlKeyHeldDown(Et)) {
      if (qt === 67) {
        Jn();
        return;
      }
      if (qt === 86) {
        er();
        return;
      }
    }
    switch (Et.key) {
      case "Escape":
        J(null);
        return;
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowLeft":
      case "ArrowRight":
      case "Tab":
      case "Home":
      case "End":
      case "PageUp":
      case "PageDown":
        ar(Et);
        break;
      default:
        Dr(Et);
        break;
    }
  }
  function Qn(Et) {
    const {
      scrollTop: Ct,
      scrollLeft: It
    } = Et.currentTarget;
    flushSync(() => {
      ye(Ct), fe(abs(It));
    }), T == null || T(Et);
  }
  function Fn(Et, Ct, It) {
    if (typeof c != "function" || It === a[Ct])
      return;
    const Pt = [...a];
    Pt[Ct] = It, c(Pt, {
      indexes: [Ct],
      column: Et
    });
  }
  function Wn() {
    dt.mode === "EDIT" && Fn(nt[dt.idx], dt.rowIdx, dt.row);
  }
  function Jn() {
    const {
      idx: Et,
      rowIdx: Ct
    } = dt, It = a[Ct], Pt = nt[Et].key;
    J({
      row: It,
      columnKey: Pt
    }), D == null || D({
      sourceRow: It,
      sourceColumnKey: Pt
    });
  }
  function er() {
    if (!k || !c || Me === null || !In(dt))
      return;
    const {
      idx: Et,
      rowIdx: Ct
    } = dt, It = nt[Et], Pt = a[Ct], Gt = k({
      sourceRow: Me.row,
      sourceColumnKey: Me.columnKey,
      targetRow: Pt,
      targetColumnKey: It.key
    });
    Fn(It, Ct, Gt);
  }
  function Dr(Et) {
    if (!an)
      return;
    const Ct = a[dt.rowIdx], {
      key: It,
      shiftKey: Pt
    } = Et;
    if (Ee && Pt && It === " ") {
      assertIsValidKeyGetter(l);
      const Gt = l(Ct);
      Sn({
        type: "ROW",
        row: Ct,
        checked: !h.has(Gt),
        isShiftClick: !1
      }), Et.preventDefault();
      return;
    }
    In(dt) && isDefaultCellInput(Et) && Le(({
      idx: Gt,
      rowIdx: Ht
    }) => ({
      idx: Gt,
      rowIdx: Ht,
      mode: "EDIT",
      row: Ct,
      originalRow: Ct
    }));
  }
  function tr(Et) {
    return Et >= sn && Et <= Vt;
  }
  function bn(Et) {
    return Et >= 0 && Et < a.length;
  }
  function Vn({
    idx: Et,
    rowIdx: Ct
  }) {
    return Ct >= wt && Ct <= St && tr(Et);
  }
  function nr({
    idx: Et,
    rowIdx: Ct
  }) {
    return bn(Ct) && Et >= 0 && Et <= Vt;
  }
  function rr({
    idx: Et,
    rowIdx: Ct
  }) {
    return bn(Ct) && tr(Et);
  }
  function In(Et) {
    return nr(Et) && isSelectedCellEditable({
      columns: nt,
      rows: a,
      selectedPosition: Et
    });
  }
  function Cn(Et, Ct) {
    if (!Vn(Et))
      return;
    Wn();
    const It = a[Et.rowIdx], Pt = isSamePosition(dt, Et);
    Ct && In(Et) ? Le({
      ...Et,
      mode: "EDIT",
      row: It,
      originalRow: It
    }) : Pt ? scrollIntoView(getCellToScroll(et.current)) : (ee.current = !0, Le({
      ...Et,
      mode: "SELECT"
    })), C && !Pt && C({
      rowIdx: Et.rowIdx,
      row: It,
      column: nt[Et.idx]
    });
  }
  function ir(Et, Ct, It) {
    const {
      idx: Pt,
      rowIdx: Gt
    } = dt, Ht = Wt && Pt === -1;
    switch (Et) {
      case "ArrowUp":
        return {
          idx: Pt,
          rowIdx: Gt - 1
        };
      case "ArrowDown":
        return {
          idx: Pt,
          rowIdx: Gt + 1
        };
      case de:
        return {
          idx: Pt - 1,
          rowIdx: Gt
        };
      case ve:
        return {
          idx: Pt + 1,
          rowIdx: Gt
        };
      case "Tab":
        return {
          idx: Pt + (It ? -1 : 1),
          rowIdx: Gt
        };
      case "Home":
        return Ht ? {
          idx: Pt,
          rowIdx: wt
        } : {
          idx: 0,
          rowIdx: Ct ? wt : Gt
        };
      case "End":
        return Ht ? {
          idx: Pt,
          rowIdx: St
        } : {
          idx: Vt,
          rowIdx: Ct ? St : Gt
        };
      case "PageUp": {
        if (dt.rowIdx === wt)
          return dt;
        const qt = At(Gt) + Dt(Gt) - be;
        return {
          idx: Pt,
          rowIdx: qt > 0 ? Mt(qt) : 0
        };
      }
      case "PageDown": {
        if (dt.rowIdx >= a.length)
          return dt;
        const qt = At(Gt) + be;
        return {
          idx: Pt,
          rowIdx: qt < ut ? Mt(qt) : a.length - 1
        };
      }
      default:
        return dt;
    }
  }
  function ar(Et) {
    const {
      key: Ct,
      shiftKey: It
    } = Et;
    let Pt = "NONE";
    if (Ct === "Tab") {
      if (canExitGrid({
        shiftKey: It,
        maxColIdx: Vt,
        minRowIdx: wt,
        maxRowIdx: St,
        selectedPosition: dt
      })) {
        Wn();
        return;
      }
      Pt = "CHANGE_ROW";
    }
    Et.preventDefault();
    const Gt = isCtrlKeyHeldDown(Et), Ht = ir(Ct, Gt, It);
    if (isSamePosition(dt, Ht))
      return;
    const qt = getNextSelectedCellPosition({
      moveUp: Ct === "ArrowUp",
      moveNext: Ct === ve || Ct === "Tab" && !It,
      columns: nt,
      colSpanColumns: tt,
      rows: a,
      topSummaryRows: s,
      bottomSummaryRows: o,
      minRowIdx: wt,
      mainHeaderRowIdx: mt,
      maxRowIdx: St,
      lastFrozenColumnIndex: Ve,
      cellNavigationMode: Pt,
      currentPosition: dt,
      nextPosition: Ht,
      isCellWithinBounds: Vn
    });
    Cn(qt);
  }
  function Rr(Et) {
    if (Ce === void 0)
      return;
    const {
      rowIdx: Ct
    } = dt;
    return (Ct < Ce ? Ct < Et && Et <= Ce : Ct > Et && Et >= Ce) ? dt.idx : void 0;
  }
  function sr() {
    const Et = getCellToScroll(et.current);
    if (Et === null)
      return;
    scrollIntoView(Et), (Et.querySelector('[tabindex="0"]') ?? Et).focus({
      preventScroll: !0
    });
  }
  function Mr() {
    if (O == null || dt.mode === "EDIT" || !rr(dt))
      return;
    const {
      idx: Et,
      rowIdx: Ct
    } = dt, It = nt[Et];
    if (It.renderEditCell == null || It.editable === !1)
      return;
    const Pt = ze(It);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandle, {
      gridRowStart: xt + Ct + 1,
      rows: a,
      column: It,
      columnWidth: Pt,
      maxColIdx: Vt,
      isLastRow: Ct === St,
      selectedPosition: dt,
      isCellEditable: In,
      latestDraggedOverRowIdx: De,
      onRowsChange: c,
      onClick: sr,
      onFill: O,
      setDragging: ge,
      setDraggedOverRowIdx: Tn
    });
  }
  function Fr(Et) {
    if (dt.rowIdx !== Et || dt.mode === "SELECT")
      return;
    const {
      idx: Ct,
      row: It
    } = dt, Pt = nt[Ct], Gt = getColSpan(Pt, Ve, {
      type: "ROW",
      row: It
    }), Ht = (jt) => {
      ee.current = jt, Le(({
        idx: nn,
        rowIdx: ln
      }) => ({
        idx: nn,
        rowIdx: ln,
        mode: "SELECT"
      }));
    }, qt = (jt, nn, ln) => {
      nn ? flushSync(() => {
        Fn(Pt, dt.rowIdx, jt), Ht(ln);
      }) : Le((_n) => ({
        ..._n,
        row: jt
      }));
    };
    return a[dt.rowIdx] !== dt.originalRow && Ht(!1), /* @__PURE__ */ jsxRuntimeExports.jsx(EditCell, {
      column: Pt,
      colSpan: Gt,
      row: It,
      rowIdx: Et,
      onRowChange: qt,
      closeEditor: Ht,
      onKeyDown: b,
      navigate: ar
    }, Pt.key);
  }
  function wn(Et) {
    const Ct = dt.idx === -1 ? void 0 : nt[dt.idx];
    return Ct !== void 0 && dt.rowIdx === Et && !Ut.includes(Ct) ? dt.idx > Je ? [...Ut, Ct] : [...Ut.slice(0, Ve + 1), Ct, ...Ut.slice(Ve + 1)] : Ut;
  }
  function Ir() {
    const Et = [], {
      idx: Ct,
      rowIdx: It
    } = dt, Pt = an && It < Qe ? Qe - 1 : Qe, Gt = an && It > ft ? ft + 1 : ft;
    for (let Ht = Pt; Ht <= Gt; Ht++) {
      const qt = Ht === Qe - 1 || Ht === ft + 1, jt = qt ? It : Ht;
      let nn = Ut;
      const ln = Ct === -1 ? void 0 : nt[Ct];
      ln !== void 0 && (qt ? nn = [ln] : nn = wn(jt));
      const _n = a[jt], Pr = xt + jt + 1;
      let Pn = jt, Ln = !1;
      typeof l == "function" && (Pn = l(_n), Ln = (h == null ? void 0 : h.has(Pn)) ?? !1), Et.push(q(Pn, {
        "aria-rowindex": xt + jt + 1,
        "aria-selected": Ee ? Ln : void 0,
        rowIdx: jt,
        row: _n,
        viewportColumns: nn,
        isRowSelected: Ln,
        onCellClick: mn,
        onCellDoubleClick: En,
        onCellContextMenu: on,
        rowClass: Q,
        gridRowStart: Pr,
        height: Dt(jt),
        copiedCellIdx: Me !== null && Me.row === _n ? nt.findIndex((cr) => cr.key === Me.columnKey) : void 0,
        selectedCellIdx: It === jt ? Ct : void 0,
        draggedOverCellIdx: Rr(jt),
        setDraggedOverRowIdx: K ? Tn : void 0,
        lastFrozenColumnIndex: Ve,
        onRowChange: An,
        selectCell: cn,
        selectedCellEditor: Fr(jt)
      }));
    }
    return Et;
  }
  (dt.idx > Vt || dt.rowIdx > St) && (Le({
    idx: -1,
    rowIdx: wt - 1,
    mode: "SELECT"
  }), Tn(void 0));
  let Dn = `repeat(${We}, ${N}px)`;
  Ye > 0 && (Dn += ` repeat(${Ye}, ${V}px)`), a.length > 0 && (Dn += _t), Ze > 0 && (Dn += ` repeat(${Ze}, ${V}px)`);
  const or = dt.idx === -1 && dt.rowIdx !== wt - 1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    role: M,
    "aria-label": te,
    "aria-labelledby": Z,
    "aria-describedby": ae,
    "aria-multiselectable": Ee ? !0 : void 0,
    "aria-colcount": nt.length,
    "aria-rowcount": Se,
    className: clsx(rootClassname, z, K && viewportDraggingClassname),
    style: {
      ...P,
      scrollPaddingInlineStart: dt.idx > Ve || (qe == null ? void 0 : qe.idx) !== void 0 ? `${ke}px` : void 0,
      scrollPaddingBlock: bn(dt.rowIdx) || (qe == null ? void 0 : qe.rowIdx) !== void 0 ? `${pe + Ye * V}px ${Ze * V}px` : void 0,
      gridTemplateColumns: Qt,
      gridTemplateRows: Dn,
      "--rdg-header-row-height": `${N}px`,
      "--rdg-summary-row-height": `${V}px`,
      "--rdg-sign": He ? -1 : 1,
      ...je
    },
    dir: Fe,
    ref: et,
    onScroll: Qn,
    onKeyDown: wr,
    "data-testid": U,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(DataGridDefaultRenderersProvider, {
      value: we,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(RowSelectionChangeProvider, {
        value: fn,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(RowSelectionProvider, {
          value: Ue,
          children: [Array.from({
            length: bt
          }, (Et, Ct) => /* @__PURE__ */ jsxRuntimeExports.jsx(GroupedColumnHeaderRow$1, {
            rowIdx: Ct + 1,
            level: -bt + Ct,
            columns: wn(wt + Ct),
            selectedCellIdx: dt.rowIdx === wt + Ct ? dt.idx : void 0,
            selectCell: yn
          }, Ct)), /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderRow$1, {
            rowIdx: We,
            columns: wn(mt),
            onColumnResize: Kt,
            onColumnsReorder: dn,
            sortColumns: x,
            onSortColumnsChange: Mn,
            lastFrozenColumnIndex: Ve,
            selectedCellIdx: dt.rowIdx === mt ? dt.idx : void 0,
            selectCell: yn,
            shouldFocusGrid: !Wt,
            direction: Fe
          })]
        }), a.length === 0 && he ? he : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
          children: [s == null ? void 0 : s.map((Et, Ct) => {
            const It = We + 1 + Ct, Pt = mt + 1 + Ct, Gt = dt.rowIdx === Pt, Ht = pe + V * Ct;
            return /* @__PURE__ */ jsxRuntimeExports.jsx(SummaryRow$1, {
              "aria-rowindex": It,
              rowIdx: Pt,
              gridRowStart: It,
              row: Et,
              top: Ht,
              bottom: void 0,
              viewportColumns: wn(Pt),
              lastFrozenColumnIndex: Ve,
              selectedCellIdx: Gt ? dt.idx : void 0,
              isTop: !0,
              showBorder: Ct === Ye - 1,
              selectCell: cn
            }, Ct);
          }), Ir(), o == null ? void 0 : o.map((Et, Ct) => {
            const It = xt + a.length + Ct + 1, Pt = a.length + Ct, Gt = dt.rowIdx === Pt, Ht = be > ut ? pt - V * (o.length - Ct) : void 0, qt = Ht === void 0 ? V * (o.length - 1 - Ct) : void 0;
            return /* @__PURE__ */ jsxRuntimeExports.jsx(SummaryRow$1, {
              "aria-rowindex": Se - Ze + Ct + 1,
              rowIdx: Pt,
              gridRowStart: It,
              row: Et,
              top: Ht,
              bottom: qt,
              viewportColumns: wn(Pt),
              lastFrozenColumnIndex: Ve,
              selectedCellIdx: Gt ? dt.idx : void 0,
              isTop: !1,
              showBorder: Ct === 0,
              selectCell: cn
            }, Ct);
          })]
        })]
      })
    }), Mr(), renderMeasuringCells(Ut), ce && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: oe,
      tabIndex: or ? 0 : -1,
      className: clsx(focusSinkClassname, or && [rowSelected, Ve !== -1 && rowSelectedWithFrozenCell], !bn(dt.rowIdx) && focusSinkHeaderAndSummaryClassname),
      style: {
        gridRowStart: dt.rowIdx + xt + 1
      }
    }), qe !== null && /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollToCell, {
      scrollToPosition: qe,
      setScrollToCellPosition: ct,
      gridElement: et.current
    })]
  });
}
function getCellToScroll(t) {
  return t.querySelector(':scope > [role="row"] > [tabindex="0"]');
}
function isSamePosition(t, e) {
  return t.idx === e.idx && t.rowIdx === e.rowIdx;
}
const DataGrid$1 = /* @__PURE__ */ forwardRef(DataGrid);
var csv = { exports: {} };
(function(t) {
  (function(e, n) {
    t.exports ? t.exports = n() : e.CSV = n();
  })(commonjsGlobal, function() {
    var e = ["|", "^"], n = [",", ";", "	", "|", "^"], a = [`\r
`, "\r", `
`];
    function s(b) {
      var C = typeof b;
      return C === "function" || C === "object" && !!b;
    }
    var o = Array.isArray || function(b) {
      return toString.call(b) === "[object Array]";
    };
    function l(b) {
      return typeof b == "string";
    }
    function c(b) {
      return !isNaN(Number(b));
    }
    function u(b) {
      return b == !1 || b == !0;
    }
    function d(b) {
      return b == null;
    }
    function f(b) {
      return b != null;
    }
    function h(b, C) {
      return f(b) ? b : C;
    }
    function g(b, C) {
      for (var T = 0, w = b.length; T < w && C(b[T], T) !== !1; T += 1)
        ;
    }
    function x(b) {
      return b.replace(/"/g, '\\"');
    }
    function E(b) {
      return "attrs[" + b + "]";
    }
    function m(b, C) {
      return c(b) ? "Number(" + E(C) + ")" : u(b) ? "Boolean(" + E(C) + " == true)" : "String(" + E(C) + ")";
    }
    function v(b, C, T, w) {
      var R = [];
      return arguments.length == 3 ? (C ? o(C) ? g(T, function(O, D) {
        l(C[D]) ? C[D] = C[D].toLowerCase() : b[C[D]] = C[D], R.push("deserialize[cast[" + D + "]](" + E(D) + ")");
      }) : g(T, function(O, D) {
        R.push(m(O, D));
      }) : g(T, function(O, D) {
        R.push(E(D));
      }), R = "return [" + R.join(",") + "]") : (C ? o(C) ? g(T, function(O, D) {
        l(C[D]) ? C[D] = C[D].toLowerCase() : b[C[D]] = C[D], R.push('"' + x(w[D]) + '": deserialize[cast[' + D + "]](" + E(D) + ")");
      }) : g(T, function(O, D) {
        R.push('"' + x(w[D]) + '": ' + m(O, D));
      }) : g(T, function(O, D) {
        R.push('"' + x(w[D]) + '": ' + E(D));
      }), R = "return {" + R.join(",") + "}"), new Function("attrs", "deserialize", "cast", R);
    }
    function y(b, C) {
      var T = 0, w;
      return g(C, function(R) {
        var O = R, D;
        e.indexOf(R) != -1 && (O = "\\" + O), D = b.match(new RegExp(O, "g")), D && D.length > T && (T = D.length, w = R);
      }), w || C[0];
    }
    var A = function() {
      function b(R, O) {
        if (O || (O = {}), o(R))
          this.mode = "encode";
        else if (l(R))
          this.mode = "parse";
        else
          throw new Error("Incompatible format!");
        this.data = R, this.options = {
          header: h(O.header, !1),
          cast: h(O.cast, !0)
        };
        var D = O.lineDelimiter || O.line, k = O.cellDelimiter || O.delimiter;
        this.isParser() ? (this.options.lineDelimiter = D || y(this.data, a), this.options.cellDelimiter = k || y(this.data, n), this.data = T(this.data, this.options.lineDelimiter)) : this.isEncoder() && (this.options.lineDelimiter = D || `\r
`, this.options.cellDelimiter = k || ",");
      }
      function C(R, O, D, k, W) {
        R(new O(D, k, W));
      }
      function T(R, O) {
        return R.slice(-O.length) != O && (R += O), R;
      }
      b.prototype.set = function(R, O) {
        return this.options[R] = O;
      }, b.prototype.isParser = function() {
        return this.mode == "parse";
      }, b.prototype.isEncoder = function() {
        return this.mode == "encode";
      }, b.prototype.parse = function(R) {
        if (this.mode != "parse")
          return;
        if (this.data.trim().length === 0)
          return [];
        var O = this.data, D = this.options, k = D.header, W = { cell: "", line: [] }, L = this.deserialize, z, P, Q;
        R || (Q = [], R = function(q) {
          Q.push(q);
        });
        function Y() {
          z = { escaped: !1, quote: !1, cell: !0 };
        }
        function ie() {
          W.cell = "";
        }
        function te() {
          W.line = [];
        }
        function Z(q) {
          W.line.push(z.escaped ? q.slice(1, -1).replace(/""/g, '"') : q), ie(), Y();
        }
        function ae(q) {
          Z(q.slice(0, 1 - D.lineDelimiter.length));
        }
        function G() {
          k ? o(k) ? (P = v(L, D.cast, W.line, k), G = function() {
            C(R, P, W.line, L, D.cast);
          }, G()) : k = W.line : (P || (P = v(L, D.cast, W.line)), G = function() {
            C(R, P, W.line, L, D.cast);
          }, G());
        }
        D.lineDelimiter.length == 1 && (ae = Z);
        var U = O.length, F = D.cellDelimiter.charCodeAt(0), M = D.lineDelimiter.charCodeAt(D.lineDelimiter.length - 1), I, N, V;
        for (Y(), I = 0, N = 0; I < U; I++) {
          if (V = O.charCodeAt(I), z.cell && (z.cell = !1, V == 34)) {
            z.escaped = !0;
            continue;
          }
          if (z.escaped && V == 34) {
            z.quote = !z.quote;
            continue;
          }
          (z.escaped && z.quote || !z.escaped) && (V == F ? (Z(W.cell + O.slice(N, I)), N = I + 1) : V == M && (ae(W.cell + O.slice(N, I)), N = I + 1, (W.line.length > 1 || W.line[0] !== "") && G(), te()));
        }
        return Q || this;
      };
      function w(R) {
        return o(R) ? "array" : s(R) ? "object" : l(R) ? "string" : d(R) ? "null" : "primitive";
      }
      return b.prototype.deserialize = {
        string: function(R) {
          return String(R);
        },
        number: function(R) {
          return Number(R);
        },
        boolean: function(R) {
          return !!R;
        }
      }, b.prototype.serialize = {
        object: function(R) {
          var O = this, D = Object.keys(R), k = Array(D.length);
          return g(D, function(W, L) {
            k[L] = O[w(R[W])](R[W]);
          }), k;
        },
        array: function(R) {
          var O = this, D = Array(R.length);
          return g(R, function(k, W) {
            D[W] = O[w(k)](k);
          }), D;
        },
        string: function(R) {
          return '"' + String(R).replace(/"/g, '""') + '"';
        },
        null: function(R) {
          return "";
        },
        primitive: function(R) {
          return R;
        }
      }, b.prototype.encode = function(R) {
        if (this.mode != "encode")
          return;
        if (this.data.length == 0)
          return "";
        var O = this.data, D = this.options, k = D.header, W = O[0], L = this.serialize, z = 0, P, Q;
        R || (Q = Array(O.length), R = function(Z, ae) {
          Q[ae + z] = Z;
        });
        function Y(Z) {
          return Z.join(D.cellDelimiter);
        }
        k && (o(k) || (P = Object.keys(W), k = P), R(Y(L.array(k)), 0), z = 1);
        var ie = w(W), te;
        return ie == "array" ? (o(D.cast) ? (te = Array(D.cast.length), g(D.cast, function(Z, ae) {
          l(Z) ? te[ae] = Z.toLowerCase() : (te[ae] = Z, L[Z] = Z);
        })) : (te = Array(W.length), g(W, function(Z, ae) {
          te[ae] = w(Z);
        })), g(O, function(Z, ae) {
          var G = Array(te.length);
          g(Z, function(U, F) {
            G[F] = L[te[F]](U);
          }), R(Y(G), ae);
        })) : ie == "object" && (P = Object.keys(W), o(D.cast) ? (te = Array(D.cast.length), g(D.cast, function(Z, ae) {
          l(Z) ? te[ae] = Z.toLowerCase() : (te[ae] = Z, L[Z] = Z);
        })) : (te = Array(P.length), g(P, function(Z, ae) {
          te[ae] = w(W[Z]);
        })), g(O, function(Z, ae) {
          var G = Array(P.length);
          g(P, function(U, F) {
            G[F] = L[te[F]](Z[U]);
          }), R(Y(G), ae);
        })), Q ? Q.join(D.lineDelimiter) : this;
      }, b.prototype.forEach = function(R) {
        return this[this.mode](R);
      }, b;
    }();
    return A.parse = function(b, C) {
      return new A(b, C).parse();
    }, A.encode = function(b, C) {
      return new A(b, C).encode();
    }, A.forEach = function(b, C, T) {
      return arguments.length == 2 && (T = C), new A(b, C).forEach(T);
    }, A;
  });
})(csv);
var csvExports = csv.exports;
const CSV = /* @__PURE__ */ getDefaultExportFromCjs(csvExports), CsvViewer = (t) => {
  const e = (s) => {
    const o = [], l = [];
    return new CSV(s).forEach((c) => {
      if (l.length < 1)
        c.forEach((u, d) => {
          l.push({
            key: `key-${d}`,
            name: u,
            resizable: !0,
            sortable: !0,
            filterable: !0
          });
        });
      else {
        const u = {};
        c.forEach((d, f) => {
          u[`key-${f}`] = d.toString();
        }), o.push(u);
      }
    }), { rows: o, columns: l };
  }, { rows: n, columns: a } = e(t.data);
  return n.length > 0 && a.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-csv-viewer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DataGrid$1,
    {
      columns: a,
      rows: n,
      minHeight: 1e3
    }
  ) }) : null;
};
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "158", CullFaceNone = 0, CullFaceBack = 1, CullFaceFront = 2, PCFShadowMap = 1, PCFSoftShadowMap = 2, VSMShadowMap = 3, FrontSide = 0, BackSide = 1, DoubleSide = 2, NoBlending = 0, NormalBlending = 1, AdditiveBlending = 2, SubtractiveBlending = 3, MultiplyBlending = 4, CustomBlending = 5, AddEquation = 100, SubtractEquation = 101, ReverseSubtractEquation = 102, MinEquation = 103, MaxEquation = 104, ZeroFactor = 200, OneFactor = 201, SrcColorFactor = 202, OneMinusSrcColorFactor = 203, SrcAlphaFactor = 204, OneMinusSrcAlphaFactor = 205, DstAlphaFactor = 206, OneMinusDstAlphaFactor = 207, DstColorFactor = 208, OneMinusDstColorFactor = 209, SrcAlphaSaturateFactor = 210, ConstantColorFactor = 211, OneMinusConstantColorFactor = 212, ConstantAlphaFactor = 213, OneMinusConstantAlphaFactor = 214, NeverDepth = 0, AlwaysDepth = 1, LessDepth = 2, LessEqualDepth = 3, EqualDepth = 4, GreaterEqualDepth = 5, GreaterDepth = 6, NotEqualDepth = 7, MultiplyOperation = 0, MixOperation = 1, AddOperation = 2, NoToneMapping = 0, LinearToneMapping = 1, ReinhardToneMapping = 2, CineonToneMapping = 3, ACESFilmicToneMapping = 4, CustomToneMapping = 5, UVMapping = 300, CubeReflectionMapping = 301, CubeRefractionMapping = 302, EquirectangularReflectionMapping = 303, EquirectangularRefractionMapping = 304, CubeUVReflectionMapping = 306, RepeatWrapping = 1e3, ClampToEdgeWrapping = 1001, MirroredRepeatWrapping = 1002, NearestFilter = 1003, NearestMipmapNearestFilter = 1004, NearestMipmapLinearFilter = 1005, LinearFilter = 1006, LinearMipmapNearestFilter = 1007, LinearMipmapLinearFilter = 1008, UnsignedByteType = 1009, ByteType = 1010, ShortType = 1011, UnsignedShortType = 1012, IntType = 1013, UnsignedIntType = 1014, FloatType = 1015, HalfFloatType = 1016, UnsignedShort4444Type = 1017, UnsignedShort5551Type = 1018, UnsignedInt248Type = 1020, AlphaFormat = 1021, RGBAFormat = 1023, LuminanceFormat = 1024, LuminanceAlphaFormat = 1025, DepthFormat = 1026, DepthStencilFormat = 1027, RedFormat = 1028, RedIntegerFormat = 1029, RGFormat = 1030, RGIntegerFormat = 1031, RGBAIntegerFormat = 1033, RGB_S3TC_DXT1_Format = 33776, RGBA_S3TC_DXT1_Format = 33777, RGBA_S3TC_DXT3_Format = 33778, RGBA_S3TC_DXT5_Format = 33779, RGB_PVRTC_4BPPV1_Format = 35840, RGB_PVRTC_2BPPV1_Format = 35841, RGBA_PVRTC_4BPPV1_Format = 35842, RGBA_PVRTC_2BPPV1_Format = 35843, RGB_ETC1_Format = 36196, RGB_ETC2_Format = 37492, RGBA_ETC2_EAC_Format = 37496, RGBA_ASTC_4x4_Format = 37808, RGBA_ASTC_5x4_Format = 37809, RGBA_ASTC_5x5_Format = 37810, RGBA_ASTC_6x5_Format = 37811, RGBA_ASTC_6x6_Format = 37812, RGBA_ASTC_8x5_Format = 37813, RGBA_ASTC_8x6_Format = 37814, RGBA_ASTC_8x8_Format = 37815, RGBA_ASTC_10x5_Format = 37816, RGBA_ASTC_10x6_Format = 37817, RGBA_ASTC_10x8_Format = 37818, RGBA_ASTC_10x10_Format = 37819, RGBA_ASTC_12x10_Format = 37820, RGBA_ASTC_12x12_Format = 37821, RGBA_BPTC_Format = 36492, RGB_BPTC_SIGNED_Format = 36494, RGB_BPTC_UNSIGNED_Format = 36495, RED_RGTC1_Format = 36283, SIGNED_RED_RGTC1_Format = 36284, RED_GREEN_RGTC2_Format = 36285, SIGNED_RED_GREEN_RGTC2_Format = 36286, LinearEncoding = 3e3, sRGBEncoding = 3001, BasicDepthPacking = 3200, RGBADepthPacking = 3201, TangentSpaceNormalMap = 0, ObjectSpaceNormalMap = 1, NoColorSpace = "", SRGBColorSpace = "srgb", LinearSRGBColorSpace = "srgb-linear", DisplayP3ColorSpace = "display-p3", LinearDisplayP3ColorSpace = "display-p3-linear", LinearTransfer = "linear", SRGBTransfer = "srgb", Rec709Primaries = "rec709", P3Primaries = "p3", KeepStencilOp = 7680, AlwaysStencilFunc = 519, NeverCompare = 512, LessCompare = 513, EqualCompare = 514, LessEqualCompare = 515, GreaterCompare = 516, NotEqualCompare = 517, GreaterEqualCompare = 518, AlwaysCompare = 519, StaticDrawUsage = 35044, GLSL3 = "300 es", _SRGBAFormat = 1035, WebGLCoordinateSystem = 2e3, WebGPUCoordinateSystem = 2001;
class EventDispatcher {
  addEventListener(e, n) {
    this._listeners === void 0 && (this._listeners = {});
    const a = this._listeners;
    a[e] === void 0 && (a[e] = []), a[e].indexOf(n) === -1 && a[e].push(n);
  }
  hasEventListener(e, n) {
    if (this._listeners === void 0)
      return !1;
    const a = this._listeners;
    return a[e] !== void 0 && a[e].indexOf(n) !== -1;
  }
  removeEventListener(e, n) {
    if (this._listeners === void 0)
      return;
    const s = this._listeners[e];
    if (s !== void 0) {
      const o = s.indexOf(n);
      o !== -1 && s.splice(o, 1);
    }
  }
  dispatchEvent(e) {
    if (this._listeners === void 0)
      return;
    const a = this._listeners[e.type];
    if (a !== void 0) {
      e.target = this;
      const s = a.slice(0);
      for (let o = 0, l = s.length; o < l; o++)
        s[o].call(this, e);
      e.target = null;
    }
  }
}
const _lut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let _seed = 1234567;
const DEG2RAD = Math.PI / 180, RAD2DEG = 180 / Math.PI;
function generateUUID() {
  const t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, a = Math.random() * 4294967295 | 0;
  return (_lut[t & 255] + _lut[t >> 8 & 255] + _lut[t >> 16 & 255] + _lut[t >> 24 & 255] + "-" + _lut[e & 255] + _lut[e >> 8 & 255] + "-" + _lut[e >> 16 & 15 | 64] + _lut[e >> 24 & 255] + "-" + _lut[n & 63 | 128] + _lut[n >> 8 & 255] + "-" + _lut[n >> 16 & 255] + _lut[n >> 24 & 255] + _lut[a & 255] + _lut[a >> 8 & 255] + _lut[a >> 16 & 255] + _lut[a >> 24 & 255]).toLowerCase();
}
function clamp(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function euclideanModulo(t, e) {
  return (t % e + e) % e;
}
function mapLinear(t, e, n, a, s) {
  return a + (t - e) * (s - a) / (n - e);
}
function inverseLerp(t, e, n) {
  return t !== e ? (n - t) / (e - t) : 0;
}
function lerp(t, e, n) {
  return (1 - n) * t + n * e;
}
function damp(t, e, n, a) {
  return lerp(t, e, 1 - Math.exp(-n * a));
}
function pingpong(t, e = 1) {
  return e - Math.abs(euclideanModulo(t, e * 2) - e);
}
function smoothstep(t, e, n) {
  return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e), t * t * (3 - 2 * t));
}
function smootherstep(t, e, n) {
  return t <= e ? 0 : t >= n ? 1 : (t = (t - e) / (n - e), t * t * t * (t * (t * 6 - 15) + 10));
}
function randInt(t, e) {
  return t + Math.floor(Math.random() * (e - t + 1));
}
function randFloat(t, e) {
  return t + Math.random() * (e - t);
}
function randFloatSpread(t) {
  return t * (0.5 - Math.random());
}
function seededRandom(t) {
  t !== void 0 && (_seed = t);
  let e = _seed += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function degToRad(t) {
  return t * DEG2RAD;
}
function radToDeg(t) {
  return t * RAD2DEG;
}
function isPowerOfTwo(t) {
  return (t & t - 1) === 0 && t !== 0;
}
function ceilPowerOfTwo(t) {
  return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
}
function floorPowerOfTwo(t) {
  return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}
function setQuaternionFromProperEuler(t, e, n, a, s) {
  const o = Math.cos, l = Math.sin, c = o(n / 2), u = l(n / 2), d = o((e + a) / 2), f = l((e + a) / 2), h = o((e - a) / 2), g = l((e - a) / 2), x = o((a - e) / 2), E = l((a - e) / 2);
  switch (s) {
    case "XYX":
      t.set(c * f, u * h, u * g, c * d);
      break;
    case "YZY":
      t.set(u * g, c * f, u * h, c * d);
      break;
    case "ZXZ":
      t.set(u * h, u * g, c * f, c * d);
      break;
    case "XZX":
      t.set(c * f, u * E, u * x, c * d);
      break;
    case "YXY":
      t.set(u * x, c * f, u * E, c * d);
      break;
    case "ZYZ":
      t.set(u * E, u * x, c * f, c * d);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + s);
  }
}
function denormalize(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return t / 4294967295;
    case Uint16Array:
      return t / 65535;
    case Uint8Array:
      return t / 255;
    case Int32Array:
      return Math.max(t / 2147483647, -1);
    case Int16Array:
      return Math.max(t / 32767, -1);
    case Int8Array:
      return Math.max(t / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return Math.round(t * 4294967295);
    case Uint16Array:
      return Math.round(t * 65535);
    case Uint8Array:
      return Math.round(t * 255);
    case Int32Array:
      return Math.round(t * 2147483647);
    case Int16Array:
      return Math.round(t * 32767);
    case Int8Array:
      return Math.round(t * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const MathUtils = {
  DEG2RAD,
  RAD2DEG,
  generateUUID,
  clamp,
  euclideanModulo,
  mapLinear,
  inverseLerp,
  lerp,
  damp,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad,
  radToDeg,
  isPowerOfTwo,
  ceilPowerOfTwo,
  floorPowerOfTwo,
  setQuaternionFromProperEuler,
  normalize,
  denormalize
};
class Vector2 {
  constructor(e = 0, n = 0) {
    Vector2.prototype.isVector2 = !0, this.x = e, this.y = n;
  }
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  set(e, n) {
    return this.x = e, this.y = n, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this;
  }
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  applyMatrix3(e) {
    const n = this.x, a = this.y, s = e.elements;
    return this.x = s[0] * n + s[3] * a + s[6], this.y = s[1] * n + s[4] * a + s[7], this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  clamp(e, n) {
    return this.x = Math.max(e.x, Math.min(n.x, this.x)), this.y = Math.max(e.y, Math.min(n.y, this.y)), this;
  }
  clampScalar(e, n) {
    return this.x = Math.max(e, Math.min(n, this.x)), this.y = Math.max(e, Math.min(n, this.y)), this;
  }
  clampLength(e, n) {
    const a = this.length();
    return this.divideScalar(a || 1).multiplyScalar(Math.max(e, Math.min(n, a)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(e) {
    const n = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (n === 0)
      return Math.PI / 2;
    const a = this.dot(e) / n;
    return Math.acos(clamp(a, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const n = this.x - e.x, a = this.y - e.y;
    return n * n + a * a;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this;
  }
  lerpVectors(e, n, a) {
    return this.x = e.x + (n.x - e.x) * a, this.y = e.y + (n.y - e.y) * a, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e;
  }
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this;
  }
  rotateAround(e, n) {
    const a = Math.cos(n), s = Math.sin(n), o = this.x - e.x, l = this.y - e.y;
    return this.x = o * a - l * s + e.x, this.y = o * s + l * a + e.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class Matrix3 {
  constructor(e, n, a, s, o, l, c, u, d) {
    Matrix3.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, n, a, s, o, l, c, u, d);
  }
  set(e, n, a, s, o, l, c, u, d) {
    const f = this.elements;
    return f[0] = e, f[1] = s, f[2] = c, f[3] = n, f[4] = o, f[5] = u, f[6] = a, f[7] = l, f[8] = d, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(e) {
    const n = this.elements, a = e.elements;
    return n[0] = a[0], n[1] = a[1], n[2] = a[2], n[3] = a[3], n[4] = a[4], n[5] = a[5], n[6] = a[6], n[7] = a[7], n[8] = a[8], this;
  }
  extractBasis(e, n, a) {
    return e.setFromMatrix3Column(this, 0), n.setFromMatrix3Column(this, 1), a.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(e) {
    const n = e.elements;
    return this.set(
      n[0],
      n[4],
      n[8],
      n[1],
      n[5],
      n[9],
      n[2],
      n[6],
      n[10]
    ), this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, n) {
    const a = e.elements, s = n.elements, o = this.elements, l = a[0], c = a[3], u = a[6], d = a[1], f = a[4], h = a[7], g = a[2], x = a[5], E = a[8], m = s[0], v = s[3], y = s[6], A = s[1], b = s[4], C = s[7], T = s[2], w = s[5], R = s[8];
    return o[0] = l * m + c * A + u * T, o[3] = l * v + c * b + u * w, o[6] = l * y + c * C + u * R, o[1] = d * m + f * A + h * T, o[4] = d * v + f * b + h * w, o[7] = d * y + f * C + h * R, o[2] = g * m + x * A + E * T, o[5] = g * v + x * b + E * w, o[8] = g * y + x * C + E * R, this;
  }
  multiplyScalar(e) {
    const n = this.elements;
    return n[0] *= e, n[3] *= e, n[6] *= e, n[1] *= e, n[4] *= e, n[7] *= e, n[2] *= e, n[5] *= e, n[8] *= e, this;
  }
  determinant() {
    const e = this.elements, n = e[0], a = e[1], s = e[2], o = e[3], l = e[4], c = e[5], u = e[6], d = e[7], f = e[8];
    return n * l * f - n * c * d - a * o * f + a * c * u + s * o * d - s * l * u;
  }
  invert() {
    const e = this.elements, n = e[0], a = e[1], s = e[2], o = e[3], l = e[4], c = e[5], u = e[6], d = e[7], f = e[8], h = f * l - c * d, g = c * u - f * o, x = d * o - l * u, E = n * h + a * g + s * x;
    if (E === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const m = 1 / E;
    return e[0] = h * m, e[1] = (s * d - f * a) * m, e[2] = (c * a - s * l) * m, e[3] = g * m, e[4] = (f * n - s * u) * m, e[5] = (s * o - c * n) * m, e[6] = x * m, e[7] = (a * u - d * n) * m, e[8] = (l * n - a * o) * m, this;
  }
  transpose() {
    let e;
    const n = this.elements;
    return e = n[1], n[1] = n[3], n[3] = e, e = n[2], n[2] = n[6], n[6] = e, e = n[5], n[5] = n[7], n[7] = e, this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    const n = this.elements;
    return e[0] = n[0], e[1] = n[3], e[2] = n[6], e[3] = n[1], e[4] = n[4], e[5] = n[7], e[6] = n[2], e[7] = n[5], e[8] = n[8], this;
  }
  setUvTransform(e, n, a, s, o, l, c) {
    const u = Math.cos(o), d = Math.sin(o);
    return this.set(
      a * u,
      a * d,
      -a * (u * l + d * c) + l + e,
      -s * d,
      s * u,
      -s * (-d * l + u * c) + c + n,
      0,
      0,
      1
    ), this;
  }
  //
  scale(e, n) {
    return this.premultiply(_m3.makeScale(e, n)), this;
  }
  rotate(e) {
    return this.premultiply(_m3.makeRotation(-e)), this;
  }
  translate(e, n) {
    return this.premultiply(_m3.makeTranslation(e, n)), this;
  }
  // for 2D Transforms
  makeTranslation(e, n) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      n,
      0,
      0,
      1
    ), this;
  }
  makeRotation(e) {
    const n = Math.cos(e), a = Math.sin(e);
    return this.set(
      n,
      -a,
      0,
      a,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, n) {
    return this.set(
      e,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  //
  equals(e) {
    const n = this.elements, a = e.elements;
    for (let s = 0; s < 9; s++)
      if (n[s] !== a[s])
        return !1;
    return !0;
  }
  fromArray(e, n = 0) {
    for (let a = 0; a < 9; a++)
      this.elements[a] = e[a + n];
    return this;
  }
  toArray(e = [], n = 0) {
    const a = this.elements;
    return e[n] = a[0], e[n + 1] = a[1], e[n + 2] = a[2], e[n + 3] = a[3], e[n + 4] = a[4], e[n + 5] = a[5], e[n + 6] = a[6], e[n + 7] = a[7], e[n + 8] = a[8], e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const _m3 = /* @__PURE__ */ new Matrix3();
function arrayNeedsUint32(t) {
  for (let e = t.length - 1; e >= 0; --e)
    if (t[e] >= 65535)
      return !0;
  return !1;
}
function createElementNS(t) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", t);
}
function createCanvasElement() {
  const t = createElementNS("canvas");
  return t.style.display = "block", t;
}
const _cache = {};
function warnOnce(t) {
  t in _cache || (_cache[t] = !0, console.warn(t));
}
const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /* @__PURE__ */ new Matrix3().set(
  0.8224621,
  0.177538,
  0,
  0.0331941,
  0.9668058,
  0,
  0.0170827,
  0.0723974,
  0.9105199
), LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /* @__PURE__ */ new Matrix3().set(
  1.2249401,
  -0.2249404,
  0,
  -0.0420569,
  1.0420571,
  0,
  -0.0196376,
  -0.0786361,
  1.0982735
), COLOR_SPACES = {
  [LinearSRGBColorSpace]: {
    transfer: LinearTransfer,
    primaries: Rec709Primaries,
    toReference: (t) => t,
    fromReference: (t) => t
  },
  [SRGBColorSpace]: {
    transfer: SRGBTransfer,
    primaries: Rec709Primaries,
    toReference: (t) => t.convertSRGBToLinear(),
    fromReference: (t) => t.convertLinearToSRGB()
  },
  [LinearDisplayP3ColorSpace]: {
    transfer: LinearTransfer,
    primaries: P3Primaries,
    toReference: (t) => t.applyMatrix3(LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
    fromReference: (t) => t.applyMatrix3(LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
  },
  [DisplayP3ColorSpace]: {
    transfer: SRGBTransfer,
    primaries: P3Primaries,
    toReference: (t) => t.convertSRGBToLinear().applyMatrix3(LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
    fromReference: (t) => t.applyMatrix3(LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
  }
}, SUPPORTED_WORKING_COLOR_SPACES = /* @__PURE__ */ new Set([LinearSRGBColorSpace, LinearDisplayP3ColorSpace]), ColorManagement = {
  enabled: !0,
  _workingColorSpace: LinearSRGBColorSpace,
  get legacyMode() {
    return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
  },
  set legacyMode(t) {
    console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !t;
  },
  get workingColorSpace() {
    return this._workingColorSpace;
  },
  set workingColorSpace(t) {
    if (!SUPPORTED_WORKING_COLOR_SPACES.has(t))
      throw new Error(`Unsupported working color space, "${t}".`);
    this._workingColorSpace = t;
  },
  convert: function(t, e, n) {
    if (this.enabled === !1 || e === n || !e || !n)
      return t;
    const a = COLOR_SPACES[e].toReference, s = COLOR_SPACES[n].fromReference;
    return s(a(t));
  },
  fromWorkingColorSpace: function(t, e) {
    return this.convert(t, this._workingColorSpace, e);
  },
  toWorkingColorSpace: function(t, e) {
    return this.convert(t, e, this._workingColorSpace);
  },
  getPrimaries: function(t) {
    return COLOR_SPACES[t].primaries;
  },
  getTransfer: function(t) {
    return t === NoColorSpace ? LinearTransfer : COLOR_SPACES[t].transfer;
  }
};
function SRGBToLinear(t) {
  return t < 0.04045 ? t * 0.0773993808 : Math.pow(t * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(t) {
  return t < 31308e-7 ? t * 12.92 : 1.055 * Math.pow(t, 0.41666) - 0.055;
}
let _canvas;
class ImageUtils {
  static getDataURL(e) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let n;
    if (e instanceof HTMLCanvasElement)
      n = e;
    else {
      _canvas === void 0 && (_canvas = createElementNS("canvas")), _canvas.width = e.width, _canvas.height = e.height;
      const a = _canvas.getContext("2d");
      e instanceof ImageData ? a.putImageData(e, 0, 0) : a.drawImage(e, 0, 0, e.width, e.height), n = _canvas;
    }
    return n.width > 2048 || n.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e), n.toDataURL("image/jpeg", 0.6)) : n.toDataURL("image/png");
  }
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const n = createElementNS("canvas");
      n.width = e.width, n.height = e.height;
      const a = n.getContext("2d");
      a.drawImage(e, 0, 0, e.width, e.height);
      const s = a.getImageData(0, 0, e.width, e.height), o = s.data;
      for (let l = 0; l < o.length; l++)
        o[l] = SRGBToLinear(o[l] / 255) * 255;
      return a.putImageData(s, 0, 0), n;
    } else if (e.data) {
      const n = e.data.slice(0);
      for (let a = 0; a < n.length; a++)
        n instanceof Uint8Array || n instanceof Uint8ClampedArray ? n[a] = Math.floor(SRGBToLinear(n[a] / 255) * 255) : n[a] = SRGBToLinear(n[a]);
      return {
        data: n,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let _sourceId = 0;
class Source {
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: _sourceId++ }), this.uuid = generateUUID(), this.data = e, this.version = 0;
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    if (!n && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const a = {
      uuid: this.uuid,
      url: ""
    }, s = this.data;
    if (s !== null) {
      let o;
      if (Array.isArray(s)) {
        o = [];
        for (let l = 0, c = s.length; l < c; l++)
          s[l].isDataTexture ? o.push(serializeImage(s[l].image)) : o.push(serializeImage(s[l]));
      } else
        o = serializeImage(s);
      a.url = o;
    }
    return n || (e.images[this.uuid] = a), a;
  }
}
function serializeImage(t) {
  return typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap ? ImageUtils.getDataURL(t) : t.data ? {
    data: Array.from(t.data),
    width: t.width,
    height: t.height,
    type: t.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let _textureId = 0;
class Texture extends EventDispatcher {
  constructor(e = Texture.DEFAULT_IMAGE, n = Texture.DEFAULT_MAPPING, a = ClampToEdgeWrapping, s = ClampToEdgeWrapping, o = LinearFilter, l = LinearMipmapLinearFilter, c = RGBAFormat, u = UnsignedByteType, d = Texture.DEFAULT_ANISOTROPY, f = NoColorSpace) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: _textureId++ }), this.uuid = generateUUID(), this.name = "", this.source = new Source(e), this.mipmaps = [], this.mapping = n, this.channel = 0, this.wrapS = a, this.wrapT = s, this.magFilter = o, this.minFilter = l, this.anisotropy = d, this.format = c, this.internalFormat = null, this.type = u, this.offset = new Vector2(0, 0), this.repeat = new Vector2(1, 1), this.center = new Vector2(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Matrix3(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, typeof f == "string" ? this.colorSpace = f : (warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = f === sRGBEncoding ? SRGBColorSpace : NoColorSpace), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
  }
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    if (!n && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const a = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (a.userData = this.userData), n || (e.textures[this.uuid] = a), a;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(e) {
    if (this.mapping !== UVMapping)
      return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case RepeatWrapping:
          e.x = e.x - Math.floor(e.x);
          break;
        case ClampToEdgeWrapping:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case RepeatWrapping:
          e.y = e.y - Math.floor(e.y);
          break;
        case ClampToEdgeWrapping:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  get encoding() {
    return warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === SRGBColorSpace ? sRGBEncoding : LinearEncoding;
  }
  set encoding(e) {
    warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e === sRGBEncoding ? SRGBColorSpace : NoColorSpace;
  }
}
Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;
class Vector4 {
  constructor(e = 0, n = 0, a = 0, s = 1) {
    Vector4.prototype.isVector4 = !0, this.x = e, this.y = n, this.z = a, this.w = s;
  }
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  set(e, n, a, s) {
    return this.x = e, this.y = n, this.z = a, this.w = s, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setW(e) {
    return this.w = e, this;
  }
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      case 2:
        this.z = n;
        break;
      case 3:
        this.w = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this.z = e.z + n.z, this.w = e.w + n.w, this;
  }
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this.z += e.z * n, this.w += e.w * n, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this.z = e.z - n.z, this.w = e.w - n.w, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  applyMatrix4(e) {
    const n = this.x, a = this.y, s = this.z, o = this.w, l = e.elements;
    return this.x = l[0] * n + l[4] * a + l[8] * s + l[12] * o, this.y = l[1] * n + l[5] * a + l[9] * s + l[13] * o, this.z = l[2] * n + l[6] * a + l[10] * s + l[14] * o, this.w = l[3] * n + l[7] * a + l[11] * s + l[15] * o, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const n = Math.sqrt(1 - e.w * e.w);
    return n < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / n, this.y = e.y / n, this.z = e.z / n), this;
  }
  setAxisAngleFromRotationMatrix(e) {
    let n, a, s, o;
    const u = e.elements, d = u[0], f = u[4], h = u[8], g = u[1], x = u[5], E = u[9], m = u[2], v = u[6], y = u[10];
    if (Math.abs(f - g) < 0.01 && Math.abs(h - m) < 0.01 && Math.abs(E - v) < 0.01) {
      if (Math.abs(f + g) < 0.1 && Math.abs(h + m) < 0.1 && Math.abs(E + v) < 0.1 && Math.abs(d + x + y - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      n = Math.PI;
      const b = (d + 1) / 2, C = (x + 1) / 2, T = (y + 1) / 2, w = (f + g) / 4, R = (h + m) / 4, O = (E + v) / 4;
      return b > C && b > T ? b < 0.01 ? (a = 0, s = 0.707106781, o = 0.707106781) : (a = Math.sqrt(b), s = w / a, o = R / a) : C > T ? C < 0.01 ? (a = 0.707106781, s = 0, o = 0.707106781) : (s = Math.sqrt(C), a = w / s, o = O / s) : T < 0.01 ? (a = 0.707106781, s = 0.707106781, o = 0) : (o = Math.sqrt(T), a = R / o, s = O / o), this.set(a, s, o, n), this;
    }
    let A = Math.sqrt((v - E) * (v - E) + (h - m) * (h - m) + (g - f) * (g - f));
    return Math.abs(A) < 1e-3 && (A = 1), this.x = (v - E) / A, this.y = (h - m) / A, this.z = (g - f) / A, this.w = Math.acos((d + x + y - 1) / 2), this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  clamp(e, n) {
    return this.x = Math.max(e.x, Math.min(n.x, this.x)), this.y = Math.max(e.y, Math.min(n.y, this.y)), this.z = Math.max(e.z, Math.min(n.z, this.z)), this.w = Math.max(e.w, Math.min(n.w, this.w)), this;
  }
  clampScalar(e, n) {
    return this.x = Math.max(e, Math.min(n, this.x)), this.y = Math.max(e, Math.min(n, this.y)), this.z = Math.max(e, Math.min(n, this.z)), this.w = Math.max(e, Math.min(n, this.w)), this;
  }
  clampLength(e, n) {
    const a = this.length();
    return this.divideScalar(a || 1).multiplyScalar(Math.max(e, Math.min(n, a)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this.z += (e.z - this.z) * n, this.w += (e.w - this.w) * n, this;
  }
  lerpVectors(e, n, a) {
    return this.x = e.x + (n.x - e.x) * a, this.y = e.y + (n.y - e.y) * a, this.z = e.z + (n.z - e.z) * a, this.w = e.w + (n.w - e.w) * a, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this.z = e[n + 2], this.w = e[n + 3], this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, e[n + 3] = this.w, e;
  }
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this.z = e.getZ(n), this.w = e.getW(n), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class RenderTarget extends EventDispatcher {
  constructor(e = 1, n = 1, a = {}) {
    super(), this.isRenderTarget = !0, this.width = e, this.height = n, this.depth = 1, this.scissor = new Vector4(0, 0, e, n), this.scissorTest = !1, this.viewport = new Vector4(0, 0, e, n);
    const s = { width: e, height: n, depth: 1 };
    a.encoding !== void 0 && (warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), a.colorSpace = a.encoding === sRGBEncoding ? SRGBColorSpace : NoColorSpace), a = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: LinearFilter,
      depthBuffer: !0,
      stencilBuffer: !1,
      depthTexture: null,
      samples: 0
    }, a), this.texture = new Texture(s, a.mapping, a.wrapS, a.wrapT, a.magFilter, a.minFilter, a.format, a.type, a.anisotropy, a.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = a.generateMipmaps, this.texture.internalFormat = a.internalFormat, this.depthBuffer = a.depthBuffer, this.stencilBuffer = a.stencilBuffer, this.depthTexture = a.depthTexture, this.samples = a.samples;
  }
  setSize(e, n, a = 1) {
    (this.width !== e || this.height !== n || this.depth !== a) && (this.width = e, this.height = n, this.depth = a, this.texture.image.width = e, this.texture.image.height = n, this.texture.image.depth = a, this.dispose()), this.viewport.set(0, 0, e, n), this.scissor.set(0, 0, e, n);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.texture.isRenderTargetTexture = !0;
    const n = Object.assign({}, e.texture.image);
    return this.texture.source = new Source(n), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class WebGLRenderTarget extends RenderTarget {
  constructor(e = 1, n = 1, a = {}) {
    super(e, n, a), this.isWebGLRenderTarget = !0;
  }
}
class DataArrayTexture extends Texture {
  constructor(e = null, n = 1, a = 1, s = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: n, height: a, depth: s }, this.magFilter = NearestFilter, this.minFilter = NearestFilter, this.wrapR = ClampToEdgeWrapping, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Data3DTexture extends Texture {
  constructor(e = null, n = 1, a = 1, s = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: n, height: a, depth: s }, this.magFilter = NearestFilter, this.minFilter = NearestFilter, this.wrapR = ClampToEdgeWrapping, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Quaternion {
  constructor(e = 0, n = 0, a = 0, s = 1) {
    this.isQuaternion = !0, this._x = e, this._y = n, this._z = a, this._w = s;
  }
  static slerpFlat(e, n, a, s, o, l, c) {
    let u = a[s + 0], d = a[s + 1], f = a[s + 2], h = a[s + 3];
    const g = o[l + 0], x = o[l + 1], E = o[l + 2], m = o[l + 3];
    if (c === 0) {
      e[n + 0] = u, e[n + 1] = d, e[n + 2] = f, e[n + 3] = h;
      return;
    }
    if (c === 1) {
      e[n + 0] = g, e[n + 1] = x, e[n + 2] = E, e[n + 3] = m;
      return;
    }
    if (h !== m || u !== g || d !== x || f !== E) {
      let v = 1 - c;
      const y = u * g + d * x + f * E + h * m, A = y >= 0 ? 1 : -1, b = 1 - y * y;
      if (b > Number.EPSILON) {
        const T = Math.sqrt(b), w = Math.atan2(T, y * A);
        v = Math.sin(v * w) / T, c = Math.sin(c * w) / T;
      }
      const C = c * A;
      if (u = u * v + g * C, d = d * v + x * C, f = f * v + E * C, h = h * v + m * C, v === 1 - c) {
        const T = 1 / Math.sqrt(u * u + d * d + f * f + h * h);
        u *= T, d *= T, f *= T, h *= T;
      }
    }
    e[n] = u, e[n + 1] = d, e[n + 2] = f, e[n + 3] = h;
  }
  static multiplyQuaternionsFlat(e, n, a, s, o, l) {
    const c = a[s], u = a[s + 1], d = a[s + 2], f = a[s + 3], h = o[l], g = o[l + 1], x = o[l + 2], E = o[l + 3];
    return e[n] = c * E + f * h + u * x - d * g, e[n + 1] = u * E + f * g + d * h - c * x, e[n + 2] = d * E + f * x + c * g - u * h, e[n + 3] = f * E - c * h - u * g - d * x, e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  set(e, n, a, s) {
    return this._x = e, this._y = n, this._z = a, this._w = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  setFromEuler(e, n) {
    const a = e._x, s = e._y, o = e._z, l = e._order, c = Math.cos, u = Math.sin, d = c(a / 2), f = c(s / 2), h = c(o / 2), g = u(a / 2), x = u(s / 2), E = u(o / 2);
    switch (l) {
      case "XYZ":
        this._x = g * f * h + d * x * E, this._y = d * x * h - g * f * E, this._z = d * f * E + g * x * h, this._w = d * f * h - g * x * E;
        break;
      case "YXZ":
        this._x = g * f * h + d * x * E, this._y = d * x * h - g * f * E, this._z = d * f * E - g * x * h, this._w = d * f * h + g * x * E;
        break;
      case "ZXY":
        this._x = g * f * h - d * x * E, this._y = d * x * h + g * f * E, this._z = d * f * E + g * x * h, this._w = d * f * h - g * x * E;
        break;
      case "ZYX":
        this._x = g * f * h - d * x * E, this._y = d * x * h + g * f * E, this._z = d * f * E - g * x * h, this._w = d * f * h + g * x * E;
        break;
      case "YZX":
        this._x = g * f * h + d * x * E, this._y = d * x * h + g * f * E, this._z = d * f * E - g * x * h, this._w = d * f * h - g * x * E;
        break;
      case "XZY":
        this._x = g * f * h - d * x * E, this._y = d * x * h - g * f * E, this._z = d * f * E + g * x * h, this._w = d * f * h + g * x * E;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + l);
    }
    return n !== !1 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(e, n) {
    const a = n / 2, s = Math.sin(a);
    return this._x = e.x * s, this._y = e.y * s, this._z = e.z * s, this._w = Math.cos(a), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e) {
    const n = e.elements, a = n[0], s = n[4], o = n[8], l = n[1], c = n[5], u = n[9], d = n[2], f = n[6], h = n[10], g = a + c + h;
    if (g > 0) {
      const x = 0.5 / Math.sqrt(g + 1);
      this._w = 0.25 / x, this._x = (f - u) * x, this._y = (o - d) * x, this._z = (l - s) * x;
    } else if (a > c && a > h) {
      const x = 2 * Math.sqrt(1 + a - c - h);
      this._w = (f - u) / x, this._x = 0.25 * x, this._y = (s + l) / x, this._z = (o + d) / x;
    } else if (c > h) {
      const x = 2 * Math.sqrt(1 + c - a - h);
      this._w = (o - d) / x, this._x = (s + l) / x, this._y = 0.25 * x, this._z = (u + f) / x;
    } else {
      const x = 2 * Math.sqrt(1 + h - a - c);
      this._w = (l - s) / x, this._x = (o + d) / x, this._y = (u + f) / x, this._z = 0.25 * x;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(e, n) {
    let a = e.dot(n) + 1;
    return a < Number.EPSILON ? (a = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = a) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = a)) : (this._x = e.y * n.z - e.z * n.y, this._y = e.z * n.x - e.x * n.z, this._z = e.x * n.y - e.y * n.x, this._w = a), this.normalize();
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(clamp(this.dot(e), -1, 1)));
  }
  rotateTowards(e, n) {
    const a = this.angleTo(e);
    if (a === 0)
      return this;
    const s = Math.min(1, n / a);
    return this.slerp(e, s), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, n) {
    const a = e._x, s = e._y, o = e._z, l = e._w, c = n._x, u = n._y, d = n._z, f = n._w;
    return this._x = a * f + l * c + s * d - o * u, this._y = s * f + l * u + o * c - a * d, this._z = o * f + l * d + a * u - s * c, this._w = l * f - a * c - s * u - o * d, this._onChangeCallback(), this;
  }
  slerp(e, n) {
    if (n === 0)
      return this;
    if (n === 1)
      return this.copy(e);
    const a = this._x, s = this._y, o = this._z, l = this._w;
    let c = l * e._w + a * e._x + s * e._y + o * e._z;
    if (c < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, c = -c) : this.copy(e), c >= 1)
      return this._w = l, this._x = a, this._y = s, this._z = o, this;
    const u = 1 - c * c;
    if (u <= Number.EPSILON) {
      const x = 1 - n;
      return this._w = x * l + n * this._w, this._x = x * a + n * this._x, this._y = x * s + n * this._y, this._z = x * o + n * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    const d = Math.sqrt(u), f = Math.atan2(d, c), h = Math.sin((1 - n) * f) / d, g = Math.sin(n * f) / d;
    return this._w = l * h + this._w * g, this._x = a * h + this._x * g, this._y = s * h + this._y * g, this._z = o * h + this._z * g, this._onChangeCallback(), this;
  }
  slerpQuaternions(e, n, a) {
    return this.copy(e).slerp(n, a);
  }
  random() {
    const e = Math.random(), n = Math.sqrt(1 - e), a = Math.sqrt(e), s = 2 * Math.PI * Math.random(), o = 2 * Math.PI * Math.random();
    return this.set(
      n * Math.cos(s),
      a * Math.sin(o),
      a * Math.cos(o),
      n * Math.sin(s)
    );
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, n = 0) {
    return this._x = e[n], this._y = e[n + 1], this._z = e[n + 2], this._w = e[n + 3], this._onChangeCallback(), this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this._x, e[n + 1] = this._y, e[n + 2] = this._z, e[n + 3] = this._w, e;
  }
  fromBufferAttribute(e, n) {
    return this._x = e.getX(n), this._y = e.getY(n), this._z = e.getZ(n), this._w = e.getW(n), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class Vector3 {
  constructor(e = 0, n = 0, a = 0) {
    Vector3.prototype.isVector3 = !0, this.x = e, this.y = n, this.z = a;
  }
  set(e, n, a) {
    return a === void 0 && (a = this.z), this.x = e, this.y = n, this.z = a, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setComponent(e, n) {
    switch (e) {
      case 0:
        this.x = n;
        break;
      case 1:
        this.y = n;
        break;
      case 2:
        this.z = n;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  addVectors(e, n) {
    return this.x = e.x + n.x, this.y = e.y + n.y, this.z = e.z + n.z, this;
  }
  addScaledVector(e, n) {
    return this.x += e.x * n, this.y += e.y * n, this.z += e.z * n, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  subVectors(e, n) {
    return this.x = e.x - n.x, this.y = e.y - n.y, this.z = e.z - n.z, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  multiplyVectors(e, n) {
    return this.x = e.x * n.x, this.y = e.y * n.y, this.z = e.z * n.z, this;
  }
  applyEuler(e) {
    return this.applyQuaternion(_quaternion$4.setFromEuler(e));
  }
  applyAxisAngle(e, n) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(e, n));
  }
  applyMatrix3(e) {
    const n = this.x, a = this.y, s = this.z, o = e.elements;
    return this.x = o[0] * n + o[3] * a + o[6] * s, this.y = o[1] * n + o[4] * a + o[7] * s, this.z = o[2] * n + o[5] * a + o[8] * s, this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    const n = this.x, a = this.y, s = this.z, o = e.elements, l = 1 / (o[3] * n + o[7] * a + o[11] * s + o[15]);
    return this.x = (o[0] * n + o[4] * a + o[8] * s + o[12]) * l, this.y = (o[1] * n + o[5] * a + o[9] * s + o[13]) * l, this.z = (o[2] * n + o[6] * a + o[10] * s + o[14]) * l, this;
  }
  applyQuaternion(e) {
    const n = this.x, a = this.y, s = this.z, o = e.x, l = e.y, c = e.z, u = e.w, d = 2 * (l * s - c * a), f = 2 * (c * n - o * s), h = 2 * (o * a - l * n);
    return this.x = n + u * d + l * h - c * f, this.y = a + u * f + c * d - o * h, this.z = s + u * h + o * f - l * d, this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    const n = this.x, a = this.y, s = this.z, o = e.elements;
    return this.x = o[0] * n + o[4] * a + o[8] * s, this.y = o[1] * n + o[5] * a + o[9] * s, this.z = o[2] * n + o[6] * a + o[10] * s, this.normalize();
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  clamp(e, n) {
    return this.x = Math.max(e.x, Math.min(n.x, this.x)), this.y = Math.max(e.y, Math.min(n.y, this.y)), this.z = Math.max(e.z, Math.min(n.z, this.z)), this;
  }
  clampScalar(e, n) {
    return this.x = Math.max(e, Math.min(n, this.x)), this.y = Math.max(e, Math.min(n, this.y)), this.z = Math.max(e, Math.min(n, this.z)), this;
  }
  clampLength(e, n) {
    const a = this.length();
    return this.divideScalar(a || 1).multiplyScalar(Math.max(e, Math.min(n, a)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, n) {
    return this.x += (e.x - this.x) * n, this.y += (e.y - this.y) * n, this.z += (e.z - this.z) * n, this;
  }
  lerpVectors(e, n, a) {
    return this.x = e.x + (n.x - e.x) * a, this.y = e.y + (n.y - e.y) * a, this.z = e.z + (n.z - e.z) * a, this;
  }
  cross(e) {
    return this.crossVectors(this, e);
  }
  crossVectors(e, n) {
    const a = e.x, s = e.y, o = e.z, l = n.x, c = n.y, u = n.z;
    return this.x = s * u - o * c, this.y = o * l - a * u, this.z = a * c - s * l, this;
  }
  projectOnVector(e) {
    const n = e.lengthSq();
    if (n === 0)
      return this.set(0, 0, 0);
    const a = e.dot(this) / n;
    return this.copy(e).multiplyScalar(a);
  }
  projectOnPlane(e) {
    return _vector$b.copy(this).projectOnVector(e), this.sub(_vector$b);
  }
  reflect(e) {
    return this.sub(_vector$b.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  angleTo(e) {
    const n = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (n === 0)
      return Math.PI / 2;
    const a = this.dot(e) / n;
    return Math.acos(clamp(a, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const n = this.x - e.x, a = this.y - e.y, s = this.z - e.z;
    return n * n + a * a + s * s;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, n, a) {
    const s = Math.sin(n) * e;
    return this.x = s * Math.sin(a), this.y = Math.cos(n) * e, this.z = s * Math.cos(a), this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, n, a) {
    return this.x = e * Math.sin(n), this.y = a, this.z = e * Math.cos(n), this;
  }
  setFromMatrixPosition(e) {
    const n = e.elements;
    return this.x = n[12], this.y = n[13], this.z = n[14], this;
  }
  setFromMatrixScale(e) {
    const n = this.setFromMatrixColumn(e, 0).length(), a = this.setFromMatrixColumn(e, 1).length(), s = this.setFromMatrixColumn(e, 2).length();
    return this.x = n, this.y = a, this.z = s, this;
  }
  setFromMatrixColumn(e, n) {
    return this.fromArray(e.elements, n * 4);
  }
  setFromMatrix3Column(e, n) {
    return this.fromArray(e.elements, n * 3);
  }
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, n = 0) {
    return this.x = e[n], this.y = e[n + 1], this.z = e[n + 2], this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, e;
  }
  fromBufferAttribute(e, n) {
    return this.x = e.getX(n), this.y = e.getY(n), this.z = e.getZ(n), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const e = (Math.random() - 0.5) * 2, n = Math.random() * Math.PI * 2, a = Math.sqrt(1 - e ** 2);
    return this.x = a * Math.cos(n), this.y = a * Math.sin(n), this.z = e, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const _vector$b = /* @__PURE__ */ new Vector3(), _quaternion$4 = /* @__PURE__ */ new Quaternion();
class Box3 {
  constructor(e = new Vector3(1 / 0, 1 / 0, 1 / 0), n = new Vector3(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = n;
  }
  set(e, n) {
    return this.min.copy(e), this.max.copy(n), this;
  }
  setFromArray(e) {
    this.makeEmpty();
    for (let n = 0, a = e.length; n < a; n += 3)
      this.expandByPoint(_vector$a.fromArray(e, n));
    return this;
  }
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let n = 0, a = e.count; n < a; n++)
      this.expandByPoint(_vector$a.fromBufferAttribute(e, n));
    return this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let n = 0, a = e.length; n < a; n++)
      this.expandByPoint(e[n]);
    return this;
  }
  setFromCenterAndSize(e, n) {
    const a = _vector$a.copy(n).multiplyScalar(0.5);
    return this.min.copy(e).sub(a), this.max.copy(e).add(a), this;
  }
  setFromObject(e, n = !1) {
    return this.makeEmpty(), this.expandByObject(e, n);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  expandByObject(e, n = !1) {
    e.updateWorldMatrix(!1, !1);
    const a = e.geometry;
    if (a !== void 0) {
      const o = a.getAttribute("position");
      if (n === !0 && o !== void 0 && e.isInstancedMesh !== !0)
        for (let l = 0, c = o.count; l < c; l++)
          e.isMesh === !0 ? e.getVertexPosition(l, _vector$a) : _vector$a.fromBufferAttribute(o, l), _vector$a.applyMatrix4(e.matrixWorld), this.expandByPoint(_vector$a);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), _box$3.copy(e.boundingBox)) : (a.boundingBox === null && a.computeBoundingBox(), _box$3.copy(a.boundingBox)), _box$3.applyMatrix4(e.matrixWorld), this.union(_box$3);
    }
    const s = e.children;
    for (let o = 0, l = s.length; o < l; o++)
      this.expandByObject(s[o], n);
    return this;
  }
  containsPoint(e) {
    return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, n) {
    return n.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(e) {
    return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
  }
  intersectsSphere(e) {
    return this.clampPoint(e.center, _vector$a), _vector$a.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let n, a;
    return e.normal.x > 0 ? (n = e.normal.x * this.min.x, a = e.normal.x * this.max.x) : (n = e.normal.x * this.max.x, a = e.normal.x * this.min.x), e.normal.y > 0 ? (n += e.normal.y * this.min.y, a += e.normal.y * this.max.y) : (n += e.normal.y * this.max.y, a += e.normal.y * this.min.y), e.normal.z > 0 ? (n += e.normal.z * this.min.z, a += e.normal.z * this.max.z) : (n += e.normal.z * this.max.z, a += e.normal.z * this.min.z), n <= -e.constant && a >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(_center), _extents.subVectors(this.max, _center), _v0$2.subVectors(e.a, _center), _v1$7.subVectors(e.b, _center), _v2$4.subVectors(e.c, _center), _f0.subVectors(_v1$7, _v0$2), _f1.subVectors(_v2$4, _v1$7), _f2.subVectors(_v0$2, _v2$4);
    let n = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    return !satForAxes(n, _v0$2, _v1$7, _v2$4, _extents) || (n = [1, 0, 0, 0, 1, 0, 0, 0, 1], !satForAxes(n, _v0$2, _v1$7, _v2$4, _extents)) ? !1 : (_triangleNormal.crossVectors(_f0, _f1), n = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z], satForAxes(n, _v0$2, _v1$7, _v2$4, _extents));
  }
  clampPoint(e, n) {
    return n.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return this.clampPoint(e, _vector$a).distanceTo(e);
  }
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(_vector$a).length() * 0.5), e;
  }
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  applyMatrix4(e) {
    return this.isEmpty() ? this : (_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(_points), this);
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const _points = [
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3()
], _vector$a = /* @__PURE__ */ new Vector3(), _box$3 = /* @__PURE__ */ new Box3(), _v0$2 = /* @__PURE__ */ new Vector3(), _v1$7 = /* @__PURE__ */ new Vector3(), _v2$4 = /* @__PURE__ */ new Vector3(), _f0 = /* @__PURE__ */ new Vector3(), _f1 = /* @__PURE__ */ new Vector3(), _f2 = /* @__PURE__ */ new Vector3(), _center = /* @__PURE__ */ new Vector3(), _extents = /* @__PURE__ */ new Vector3(), _triangleNormal = /* @__PURE__ */ new Vector3(), _testAxis = /* @__PURE__ */ new Vector3();
function satForAxes(t, e, n, a, s) {
  for (let o = 0, l = t.length - 3; o <= l; o += 3) {
    _testAxis.fromArray(t, o);
    const c = s.x * Math.abs(_testAxis.x) + s.y * Math.abs(_testAxis.y) + s.z * Math.abs(_testAxis.z), u = e.dot(_testAxis), d = n.dot(_testAxis), f = a.dot(_testAxis);
    if (Math.max(-Math.max(u, d, f), Math.min(u, d, f)) > c)
      return !1;
  }
  return !0;
}
const _box$2 = /* @__PURE__ */ new Box3(), _v1$6 = /* @__PURE__ */ new Vector3(), _v2$3 = /* @__PURE__ */ new Vector3();
class Sphere {
  constructor(e = new Vector3(), n = -1) {
    this.center = e, this.radius = n;
  }
  set(e, n) {
    return this.center.copy(e), this.radius = n, this;
  }
  setFromPoints(e, n) {
    const a = this.center;
    n !== void 0 ? a.copy(n) : _box$2.setFromPoints(e).getCenter(a);
    let s = 0;
    for (let o = 0, l = e.length; o < l; o++)
      s = Math.max(s, a.distanceToSquared(e[o]));
    return this.radius = Math.sqrt(s), this;
  }
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    const n = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= n * n;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, n) {
    const a = this.center.distanceToSquared(e);
    return n.copy(e), a > this.radius * this.radius && (n.sub(this.center).normalize(), n.multiplyScalar(this.radius).add(this.center)), n;
  }
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  translate(e) {
    return this.center.add(e), this;
  }
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    _v1$6.subVectors(e, this.center);
    const n = _v1$6.lengthSq();
    if (n > this.radius * this.radius) {
      const a = Math.sqrt(n), s = (a - this.radius) * 0.5;
      this.center.addScaledVector(_v1$6, s / a), this.radius += s;
    }
    return this;
  }
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (_v2$3.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(_v1$6.copy(e.center).add(_v2$3)), this.expandByPoint(_v1$6.copy(e.center).sub(_v2$3))), this);
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$9 = /* @__PURE__ */ new Vector3(), _segCenter = /* @__PURE__ */ new Vector3(), _segDir = /* @__PURE__ */ new Vector3(), _diff = /* @__PURE__ */ new Vector3(), _edge1 = /* @__PURE__ */ new Vector3(), _edge2 = /* @__PURE__ */ new Vector3(), _normal$1 = /* @__PURE__ */ new Vector3();
class Ray {
  constructor(e = new Vector3(), n = new Vector3(0, 0, -1)) {
    this.origin = e, this.direction = n;
  }
  set(e, n) {
    return this.origin.copy(e), this.direction.copy(n), this;
  }
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  at(e, n) {
    return n.copy(this.origin).addScaledVector(this.direction, e);
  }
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  recast(e) {
    return this.origin.copy(this.at(e, _vector$9)), this;
  }
  closestPointToPoint(e, n) {
    n.subVectors(e, this.origin);
    const a = n.dot(this.direction);
    return a < 0 ? n.copy(this.origin) : n.copy(this.origin).addScaledVector(this.direction, a);
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  distanceSqToPoint(e) {
    const n = _vector$9.subVectors(e, this.origin).dot(this.direction);
    return n < 0 ? this.origin.distanceToSquared(e) : (_vector$9.copy(this.origin).addScaledVector(this.direction, n), _vector$9.distanceToSquared(e));
  }
  distanceSqToSegment(e, n, a, s) {
    _segCenter.copy(e).add(n).multiplyScalar(0.5), _segDir.copy(n).sub(e).normalize(), _diff.copy(this.origin).sub(_segCenter);
    const o = e.distanceTo(n) * 0.5, l = -this.direction.dot(_segDir), c = _diff.dot(this.direction), u = -_diff.dot(_segDir), d = _diff.lengthSq(), f = Math.abs(1 - l * l);
    let h, g, x, E;
    if (f > 0)
      if (h = l * u - c, g = l * c - u, E = o * f, h >= 0)
        if (g >= -E)
          if (g <= E) {
            const m = 1 / f;
            h *= m, g *= m, x = h * (h + l * g + 2 * c) + g * (l * h + g + 2 * u) + d;
          } else
            g = o, h = Math.max(0, -(l * g + c)), x = -h * h + g * (g + 2 * u) + d;
        else
          g = -o, h = Math.max(0, -(l * g + c)), x = -h * h + g * (g + 2 * u) + d;
      else
        g <= -E ? (h = Math.max(0, -(-l * o + c)), g = h > 0 ? -o : Math.min(Math.max(-o, -u), o), x = -h * h + g * (g + 2 * u) + d) : g <= E ? (h = 0, g = Math.min(Math.max(-o, -u), o), x = g * (g + 2 * u) + d) : (h = Math.max(0, -(l * o + c)), g = h > 0 ? o : Math.min(Math.max(-o, -u), o), x = -h * h + g * (g + 2 * u) + d);
    else
      g = l > 0 ? -o : o, h = Math.max(0, -(l * g + c)), x = -h * h + g * (g + 2 * u) + d;
    return a && a.copy(this.origin).addScaledVector(this.direction, h), s && s.copy(_segCenter).addScaledVector(_segDir, g), x;
  }
  intersectSphere(e, n) {
    _vector$9.subVectors(e.center, this.origin);
    const a = _vector$9.dot(this.direction), s = _vector$9.dot(_vector$9) - a * a, o = e.radius * e.radius;
    if (s > o)
      return null;
    const l = Math.sqrt(o - s), c = a - l, u = a + l;
    return u < 0 ? null : c < 0 ? this.at(u, n) : this.at(c, n);
  }
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  distanceToPlane(e) {
    const n = e.normal.dot(this.direction);
    if (n === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const a = -(this.origin.dot(e.normal) + e.constant) / n;
    return a >= 0 ? a : null;
  }
  intersectPlane(e, n) {
    const a = this.distanceToPlane(e);
    return a === null ? null : this.at(a, n);
  }
  intersectsPlane(e) {
    const n = e.distanceToPoint(this.origin);
    return n === 0 || e.normal.dot(this.direction) * n < 0;
  }
  intersectBox(e, n) {
    let a, s, o, l, c, u;
    const d = 1 / this.direction.x, f = 1 / this.direction.y, h = 1 / this.direction.z, g = this.origin;
    return d >= 0 ? (a = (e.min.x - g.x) * d, s = (e.max.x - g.x) * d) : (a = (e.max.x - g.x) * d, s = (e.min.x - g.x) * d), f >= 0 ? (o = (e.min.y - g.y) * f, l = (e.max.y - g.y) * f) : (o = (e.max.y - g.y) * f, l = (e.min.y - g.y) * f), a > l || o > s || ((o > a || isNaN(a)) && (a = o), (l < s || isNaN(s)) && (s = l), h >= 0 ? (c = (e.min.z - g.z) * h, u = (e.max.z - g.z) * h) : (c = (e.max.z - g.z) * h, u = (e.min.z - g.z) * h), a > u || c > s) || ((c > a || a !== a) && (a = c), (u < s || s !== s) && (s = u), s < 0) ? null : this.at(a >= 0 ? a : s, n);
  }
  intersectsBox(e) {
    return this.intersectBox(e, _vector$9) !== null;
  }
  intersectTriangle(e, n, a, s, o) {
    _edge1.subVectors(n, e), _edge2.subVectors(a, e), _normal$1.crossVectors(_edge1, _edge2);
    let l = this.direction.dot(_normal$1), c;
    if (l > 0) {
      if (s)
        return null;
      c = 1;
    } else if (l < 0)
      c = -1, l = -l;
    else
      return null;
    _diff.subVectors(this.origin, e);
    const u = c * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (u < 0)
      return null;
    const d = c * this.direction.dot(_edge1.cross(_diff));
    if (d < 0 || u + d > l)
      return null;
    const f = -c * _diff.dot(_normal$1);
    return f < 0 ? null : this.at(f / l, o);
  }
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix4 {
  constructor(e, n, a, s, o, l, c, u, d, f, h, g, x, E, m, v) {
    Matrix4.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, n, a, s, o, l, c, u, d, f, h, g, x, E, m, v);
  }
  set(e, n, a, s, o, l, c, u, d, f, h, g, x, E, m, v) {
    const y = this.elements;
    return y[0] = e, y[4] = n, y[8] = a, y[12] = s, y[1] = o, y[5] = l, y[9] = c, y[13] = u, y[2] = d, y[6] = f, y[10] = h, y[14] = g, y[3] = x, y[7] = E, y[11] = m, y[15] = v, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  copy(e) {
    const n = this.elements, a = e.elements;
    return n[0] = a[0], n[1] = a[1], n[2] = a[2], n[3] = a[3], n[4] = a[4], n[5] = a[5], n[6] = a[6], n[7] = a[7], n[8] = a[8], n[9] = a[9], n[10] = a[10], n[11] = a[11], n[12] = a[12], n[13] = a[13], n[14] = a[14], n[15] = a[15], this;
  }
  copyPosition(e) {
    const n = this.elements, a = e.elements;
    return n[12] = a[12], n[13] = a[13], n[14] = a[14], this;
  }
  setFromMatrix3(e) {
    const n = e.elements;
    return this.set(
      n[0],
      n[3],
      n[6],
      0,
      n[1],
      n[4],
      n[7],
      0,
      n[2],
      n[5],
      n[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(e, n, a) {
    return e.setFromMatrixColumn(this, 0), n.setFromMatrixColumn(this, 1), a.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(e, n, a) {
    return this.set(
      e.x,
      n.x,
      a.x,
      0,
      e.y,
      n.y,
      a.y,
      0,
      e.z,
      n.z,
      a.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(e) {
    const n = this.elements, a = e.elements, s = 1 / _v1$5.setFromMatrixColumn(e, 0).length(), o = 1 / _v1$5.setFromMatrixColumn(e, 1).length(), l = 1 / _v1$5.setFromMatrixColumn(e, 2).length();
    return n[0] = a[0] * s, n[1] = a[1] * s, n[2] = a[2] * s, n[3] = 0, n[4] = a[4] * o, n[5] = a[5] * o, n[6] = a[6] * o, n[7] = 0, n[8] = a[8] * l, n[9] = a[9] * l, n[10] = a[10] * l, n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, this;
  }
  makeRotationFromEuler(e) {
    const n = this.elements, a = e.x, s = e.y, o = e.z, l = Math.cos(a), c = Math.sin(a), u = Math.cos(s), d = Math.sin(s), f = Math.cos(o), h = Math.sin(o);
    if (e.order === "XYZ") {
      const g = l * f, x = l * h, E = c * f, m = c * h;
      n[0] = u * f, n[4] = -u * h, n[8] = d, n[1] = x + E * d, n[5] = g - m * d, n[9] = -c * u, n[2] = m - g * d, n[6] = E + x * d, n[10] = l * u;
    } else if (e.order === "YXZ") {
      const g = u * f, x = u * h, E = d * f, m = d * h;
      n[0] = g + m * c, n[4] = E * c - x, n[8] = l * d, n[1] = l * h, n[5] = l * f, n[9] = -c, n[2] = x * c - E, n[6] = m + g * c, n[10] = l * u;
    } else if (e.order === "ZXY") {
      const g = u * f, x = u * h, E = d * f, m = d * h;
      n[0] = g - m * c, n[4] = -l * h, n[8] = E + x * c, n[1] = x + E * c, n[5] = l * f, n[9] = m - g * c, n[2] = -l * d, n[6] = c, n[10] = l * u;
    } else if (e.order === "ZYX") {
      const g = l * f, x = l * h, E = c * f, m = c * h;
      n[0] = u * f, n[4] = E * d - x, n[8] = g * d + m, n[1] = u * h, n[5] = m * d + g, n[9] = x * d - E, n[2] = -d, n[6] = c * u, n[10] = l * u;
    } else if (e.order === "YZX") {
      const g = l * u, x = l * d, E = c * u, m = c * d;
      n[0] = u * f, n[4] = m - g * h, n[8] = E * h + x, n[1] = h, n[5] = l * f, n[9] = -c * f, n[2] = -d * f, n[6] = x * h + E, n[10] = g - m * h;
    } else if (e.order === "XZY") {
      const g = l * u, x = l * d, E = c * u, m = c * d;
      n[0] = u * f, n[4] = -h, n[8] = d * f, n[1] = g * h + m, n[5] = l * f, n[9] = x * h - E, n[2] = E * h - x, n[6] = c * f, n[10] = m * h + g;
    }
    return n[3] = 0, n[7] = 0, n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, this;
  }
  makeRotationFromQuaternion(e) {
    return this.compose(_zero, e, _one);
  }
  lookAt(e, n, a) {
    const s = this.elements;
    return _z.subVectors(e, n), _z.lengthSq() === 0 && (_z.z = 1), _z.normalize(), _x.crossVectors(a, _z), _x.lengthSq() === 0 && (Math.abs(a.z) === 1 ? _z.x += 1e-4 : _z.z += 1e-4, _z.normalize(), _x.crossVectors(a, _z)), _x.normalize(), _y.crossVectors(_z, _x), s[0] = _x.x, s[4] = _y.x, s[8] = _z.x, s[1] = _x.y, s[5] = _y.y, s[9] = _z.y, s[2] = _x.z, s[6] = _y.z, s[10] = _z.z, this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, n) {
    const a = e.elements, s = n.elements, o = this.elements, l = a[0], c = a[4], u = a[8], d = a[12], f = a[1], h = a[5], g = a[9], x = a[13], E = a[2], m = a[6], v = a[10], y = a[14], A = a[3], b = a[7], C = a[11], T = a[15], w = s[0], R = s[4], O = s[8], D = s[12], k = s[1], W = s[5], L = s[9], z = s[13], P = s[2], Q = s[6], Y = s[10], ie = s[14], te = s[3], Z = s[7], ae = s[11], G = s[15];
    return o[0] = l * w + c * k + u * P + d * te, o[4] = l * R + c * W + u * Q + d * Z, o[8] = l * O + c * L + u * Y + d * ae, o[12] = l * D + c * z + u * ie + d * G, o[1] = f * w + h * k + g * P + x * te, o[5] = f * R + h * W + g * Q + x * Z, o[9] = f * O + h * L + g * Y + x * ae, o[13] = f * D + h * z + g * ie + x * G, o[2] = E * w + m * k + v * P + y * te, o[6] = E * R + m * W + v * Q + y * Z, o[10] = E * O + m * L + v * Y + y * ae, o[14] = E * D + m * z + v * ie + y * G, o[3] = A * w + b * k + C * P + T * te, o[7] = A * R + b * W + C * Q + T * Z, o[11] = A * O + b * L + C * Y + T * ae, o[15] = A * D + b * z + C * ie + T * G, this;
  }
  multiplyScalar(e) {
    const n = this.elements;
    return n[0] *= e, n[4] *= e, n[8] *= e, n[12] *= e, n[1] *= e, n[5] *= e, n[9] *= e, n[13] *= e, n[2] *= e, n[6] *= e, n[10] *= e, n[14] *= e, n[3] *= e, n[7] *= e, n[11] *= e, n[15] *= e, this;
  }
  determinant() {
    const e = this.elements, n = e[0], a = e[4], s = e[8], o = e[12], l = e[1], c = e[5], u = e[9], d = e[13], f = e[2], h = e[6], g = e[10], x = e[14], E = e[3], m = e[7], v = e[11], y = e[15];
    return E * (+o * u * h - s * d * h - o * c * g + a * d * g + s * c * x - a * u * x) + m * (+n * u * x - n * d * g + o * l * g - s * l * x + s * d * f - o * u * f) + v * (+n * d * h - n * c * x - o * l * h + a * l * x + o * c * f - a * d * f) + y * (-s * c * f - n * u * h + n * c * g + s * l * h - a * l * g + a * u * f);
  }
  transpose() {
    const e = this.elements;
    let n;
    return n = e[1], e[1] = e[4], e[4] = n, n = e[2], e[2] = e[8], e[8] = n, n = e[6], e[6] = e[9], e[9] = n, n = e[3], e[3] = e[12], e[12] = n, n = e[7], e[7] = e[13], e[13] = n, n = e[11], e[11] = e[14], e[14] = n, this;
  }
  setPosition(e, n, a) {
    const s = this.elements;
    return e.isVector3 ? (s[12] = e.x, s[13] = e.y, s[14] = e.z) : (s[12] = e, s[13] = n, s[14] = a), this;
  }
  invert() {
    const e = this.elements, n = e[0], a = e[1], s = e[2], o = e[3], l = e[4], c = e[5], u = e[6], d = e[7], f = e[8], h = e[9], g = e[10], x = e[11], E = e[12], m = e[13], v = e[14], y = e[15], A = h * v * d - m * g * d + m * u * x - c * v * x - h * u * y + c * g * y, b = E * g * d - f * v * d - E * u * x + l * v * x + f * u * y - l * g * y, C = f * m * d - E * h * d + E * c * x - l * m * x - f * c * y + l * h * y, T = E * h * u - f * m * u - E * c * g + l * m * g + f * c * v - l * h * v, w = n * A + a * b + s * C + o * T;
    if (w === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const R = 1 / w;
    return e[0] = A * R, e[1] = (m * g * o - h * v * o - m * s * x + a * v * x + h * s * y - a * g * y) * R, e[2] = (c * v * o - m * u * o + m * s * d - a * v * d - c * s * y + a * u * y) * R, e[3] = (h * u * o - c * g * o - h * s * d + a * g * d + c * s * x - a * u * x) * R, e[4] = b * R, e[5] = (f * v * o - E * g * o + E * s * x - n * v * x - f * s * y + n * g * y) * R, e[6] = (E * u * o - l * v * o - E * s * d + n * v * d + l * s * y - n * u * y) * R, e[7] = (l * g * o - f * u * o + f * s * d - n * g * d - l * s * x + n * u * x) * R, e[8] = C * R, e[9] = (E * h * o - f * m * o - E * a * x + n * m * x + f * a * y - n * h * y) * R, e[10] = (l * m * o - E * c * o + E * a * d - n * m * d - l * a * y + n * c * y) * R, e[11] = (f * c * o - l * h * o - f * a * d + n * h * d + l * a * x - n * c * x) * R, e[12] = T * R, e[13] = (f * m * s - E * h * s + E * a * g - n * m * g - f * a * v + n * h * v) * R, e[14] = (E * c * s - l * m * s - E * a * u + n * m * u + l * a * v - n * c * v) * R, e[15] = (l * h * s - f * c * s + f * a * u - n * h * u - l * a * g + n * c * g) * R, this;
  }
  scale(e) {
    const n = this.elements, a = e.x, s = e.y, o = e.z;
    return n[0] *= a, n[4] *= s, n[8] *= o, n[1] *= a, n[5] *= s, n[9] *= o, n[2] *= a, n[6] *= s, n[10] *= o, n[3] *= a, n[7] *= s, n[11] *= o, this;
  }
  getMaxScaleOnAxis() {
    const e = this.elements, n = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], a = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], s = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(n, a, s));
  }
  makeTranslation(e, n, a) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      n,
      0,
      0,
      1,
      a,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(e) {
    const n = Math.cos(e), a = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      n,
      -a,
      0,
      0,
      a,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(e) {
    const n = Math.cos(e), a = Math.sin(e);
    return this.set(
      n,
      0,
      a,
      0,
      0,
      1,
      0,
      0,
      -a,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(e) {
    const n = Math.cos(e), a = Math.sin(e);
    return this.set(
      n,
      -a,
      0,
      0,
      a,
      n,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(e, n) {
    const a = Math.cos(n), s = Math.sin(n), o = 1 - a, l = e.x, c = e.y, u = e.z, d = o * l, f = o * c;
    return this.set(
      d * l + a,
      d * c - s * u,
      d * u + s * c,
      0,
      d * c + s * u,
      f * c + a,
      f * u - s * l,
      0,
      d * u - s * c,
      f * u + s * l,
      o * u * u + a,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, n, a) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      a,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(e, n, a, s, o, l) {
    return this.set(
      1,
      a,
      o,
      0,
      e,
      1,
      l,
      0,
      n,
      s,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(e, n, a) {
    const s = this.elements, o = n._x, l = n._y, c = n._z, u = n._w, d = o + o, f = l + l, h = c + c, g = o * d, x = o * f, E = o * h, m = l * f, v = l * h, y = c * h, A = u * d, b = u * f, C = u * h, T = a.x, w = a.y, R = a.z;
    return s[0] = (1 - (m + y)) * T, s[1] = (x + C) * T, s[2] = (E - b) * T, s[3] = 0, s[4] = (x - C) * w, s[5] = (1 - (g + y)) * w, s[6] = (v + A) * w, s[7] = 0, s[8] = (E + b) * R, s[9] = (v - A) * R, s[10] = (1 - (g + m)) * R, s[11] = 0, s[12] = e.x, s[13] = e.y, s[14] = e.z, s[15] = 1, this;
  }
  decompose(e, n, a) {
    const s = this.elements;
    let o = _v1$5.set(s[0], s[1], s[2]).length();
    const l = _v1$5.set(s[4], s[5], s[6]).length(), c = _v1$5.set(s[8], s[9], s[10]).length();
    this.determinant() < 0 && (o = -o), e.x = s[12], e.y = s[13], e.z = s[14], _m1$2.copy(this);
    const d = 1 / o, f = 1 / l, h = 1 / c;
    return _m1$2.elements[0] *= d, _m1$2.elements[1] *= d, _m1$2.elements[2] *= d, _m1$2.elements[4] *= f, _m1$2.elements[5] *= f, _m1$2.elements[6] *= f, _m1$2.elements[8] *= h, _m1$2.elements[9] *= h, _m1$2.elements[10] *= h, n.setFromRotationMatrix(_m1$2), a.x = o, a.y = l, a.z = c, this;
  }
  makePerspective(e, n, a, s, o, l, c = WebGLCoordinateSystem) {
    const u = this.elements, d = 2 * o / (n - e), f = 2 * o / (a - s), h = (n + e) / (n - e), g = (a + s) / (a - s);
    let x, E;
    if (c === WebGLCoordinateSystem)
      x = -(l + o) / (l - o), E = -2 * l * o / (l - o);
    else if (c === WebGPUCoordinateSystem)
      x = -l / (l - o), E = -l * o / (l - o);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + c);
    return u[0] = d, u[4] = 0, u[8] = h, u[12] = 0, u[1] = 0, u[5] = f, u[9] = g, u[13] = 0, u[2] = 0, u[6] = 0, u[10] = x, u[14] = E, u[3] = 0, u[7] = 0, u[11] = -1, u[15] = 0, this;
  }
  makeOrthographic(e, n, a, s, o, l, c = WebGLCoordinateSystem) {
    const u = this.elements, d = 1 / (n - e), f = 1 / (a - s), h = 1 / (l - o), g = (n + e) * d, x = (a + s) * f;
    let E, m;
    if (c === WebGLCoordinateSystem)
      E = (l + o) * h, m = -2 * h;
    else if (c === WebGPUCoordinateSystem)
      E = o * h, m = -1 * h;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + c);
    return u[0] = 2 * d, u[4] = 0, u[8] = 0, u[12] = -g, u[1] = 0, u[5] = 2 * f, u[9] = 0, u[13] = -x, u[2] = 0, u[6] = 0, u[10] = m, u[14] = -E, u[3] = 0, u[7] = 0, u[11] = 0, u[15] = 1, this;
  }
  equals(e) {
    const n = this.elements, a = e.elements;
    for (let s = 0; s < 16; s++)
      if (n[s] !== a[s])
        return !1;
    return !0;
  }
  fromArray(e, n = 0) {
    for (let a = 0; a < 16; a++)
      this.elements[a] = e[a + n];
    return this;
  }
  toArray(e = [], n = 0) {
    const a = this.elements;
    return e[n] = a[0], e[n + 1] = a[1], e[n + 2] = a[2], e[n + 3] = a[3], e[n + 4] = a[4], e[n + 5] = a[5], e[n + 6] = a[6], e[n + 7] = a[7], e[n + 8] = a[8], e[n + 9] = a[9], e[n + 10] = a[10], e[n + 11] = a[11], e[n + 12] = a[12], e[n + 13] = a[13], e[n + 14] = a[14], e[n + 15] = a[15], e;
  }
}
const _v1$5 = /* @__PURE__ */ new Vector3(), _m1$2 = /* @__PURE__ */ new Matrix4(), _zero = /* @__PURE__ */ new Vector3(0, 0, 0), _one = /* @__PURE__ */ new Vector3(1, 1, 1), _x = /* @__PURE__ */ new Vector3(), _y = /* @__PURE__ */ new Vector3(), _z = /* @__PURE__ */ new Vector3(), _matrix = /* @__PURE__ */ new Matrix4(), _quaternion$3 = /* @__PURE__ */ new Quaternion();
class Euler {
  constructor(e = 0, n = 0, a = 0, s = Euler.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = n, this._z = a, this._order = s;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  set(e, n, a, s = this._order) {
    return this._x = e, this._y = n, this._z = a, this._order = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e, n = this._order, a = !0) {
    const s = e.elements, o = s[0], l = s[4], c = s[8], u = s[1], d = s[5], f = s[9], h = s[2], g = s[6], x = s[10];
    switch (n) {
      case "XYZ":
        this._y = Math.asin(clamp(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(-f, x), this._z = Math.atan2(-l, o)) : (this._x = Math.atan2(g, d), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-clamp(f, -1, 1)), Math.abs(f) < 0.9999999 ? (this._y = Math.atan2(c, x), this._z = Math.atan2(u, d)) : (this._y = Math.atan2(-h, o), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(clamp(g, -1, 1)), Math.abs(g) < 0.9999999 ? (this._y = Math.atan2(-h, x), this._z = Math.atan2(-l, d)) : (this._y = 0, this._z = Math.atan2(u, o));
        break;
      case "ZYX":
        this._y = Math.asin(-clamp(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(g, x), this._z = Math.atan2(u, o)) : (this._x = 0, this._z = Math.atan2(-l, d));
        break;
      case "YZX":
        this._z = Math.asin(clamp(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._x = Math.atan2(-f, d), this._y = Math.atan2(-h, o)) : (this._x = 0, this._y = Math.atan2(c, x));
        break;
      case "XZY":
        this._z = Math.asin(-clamp(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(g, d), this._y = Math.atan2(c, o)) : (this._x = Math.atan2(-f, x), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + n);
    }
    return this._order = n, a === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(e, n, a) {
    return _matrix.makeRotationFromQuaternion(e), this.setFromRotationMatrix(_matrix, n, a);
  }
  setFromVector3(e, n = this._order) {
    return this.set(e.x, e.y, e.z, n);
  }
  reorder(e) {
    return _quaternion$3.setFromEuler(this), this.setFromQuaternion(_quaternion$3, e);
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this._x, e[n + 1] = this._y, e[n + 2] = this._z, e[n + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
Euler.DEFAULT_ORDER = "XYZ";
class Layers {
  constructor() {
    this.mask = 1;
  }
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3(), _q1 = /* @__PURE__ */ new Quaternion(), _m1$1 = /* @__PURE__ */ new Matrix4(), _target = /* @__PURE__ */ new Vector3(), _position$3 = /* @__PURE__ */ new Vector3(), _scale$2 = /* @__PURE__ */ new Vector3(), _quaternion$2 = /* @__PURE__ */ new Quaternion(), _xAxis = /* @__PURE__ */ new Vector3(1, 0, 0), _yAxis = /* @__PURE__ */ new Vector3(0, 1, 0), _zAxis = /* @__PURE__ */ new Vector3(0, 0, 1), _addedEvent = { type: "added" }, _removedEvent = { type: "removed" };
class Object3D extends EventDispatcher {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: _object3DId++ }), this.uuid = generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Object3D.DEFAULT_UP.clone();
    const e = new Vector3(), n = new Euler(), a = new Quaternion(), s = new Vector3(1, 1, 1);
    function o() {
      a.setFromEuler(n, !1);
    }
    function l() {
      n.setFromQuaternion(a, void 0, !1);
    }
    n._onChange(o), a._onChange(l), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: a
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      modelViewMatrix: {
        value: new Matrix4()
      },
      normalMatrix: {
        value: new Matrix3()
      }
    }), this.matrix = new Matrix4(), this.matrixWorld = new Matrix4(), this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new Layers(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  setRotationFromAxisAngle(e, n) {
    this.quaternion.setFromAxisAngle(e, n);
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  rotateOnAxis(e, n) {
    return _q1.setFromAxisAngle(e, n), this.quaternion.multiply(_q1), this;
  }
  rotateOnWorldAxis(e, n) {
    return _q1.setFromAxisAngle(e, n), this.quaternion.premultiply(_q1), this;
  }
  rotateX(e) {
    return this.rotateOnAxis(_xAxis, e);
  }
  rotateY(e) {
    return this.rotateOnAxis(_yAxis, e);
  }
  rotateZ(e) {
    return this.rotateOnAxis(_zAxis, e);
  }
  translateOnAxis(e, n) {
    return _v1$4.copy(e).applyQuaternion(this.quaternion), this.position.add(_v1$4.multiplyScalar(n)), this;
  }
  translateX(e) {
    return this.translateOnAxis(_xAxis, e);
  }
  translateY(e) {
    return this.translateOnAxis(_yAxis, e);
  }
  translateZ(e) {
    return this.translateOnAxis(_zAxis, e);
  }
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  lookAt(e, n, a) {
    e.isVector3 ? _target.copy(e) : _target.set(e, n, a);
    const s = this.parent;
    this.updateWorldMatrix(!0, !1), _position$3.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? _m1$1.lookAt(_position$3, _target, this.up) : _m1$1.lookAt(_target, _position$3, this.up), this.quaternion.setFromRotationMatrix(_m1$1), s && (_m1$1.extractRotation(s.matrixWorld), _q1.setFromRotationMatrix(_m1$1), this.quaternion.premultiply(_q1.invert()));
  }
  add(e) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.add(arguments[n]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.parent !== null && e.parent.remove(e), e.parent = this, this.children.push(e), e.dispatchEvent(_addedEvent)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let a = 0; a < arguments.length; a++)
        this.remove(arguments[a]);
      return this;
    }
    const n = this.children.indexOf(e);
    return n !== -1 && (e.parent = null, this.children.splice(n, 1), e.dispatchEvent(_removedEvent)), this;
  }
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(e) {
    return this.updateWorldMatrix(!0, !1), _m1$1.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), _m1$1.multiply(e.parent.matrixWorld)), e.applyMatrix4(_m1$1), this.add(e), e.updateWorldMatrix(!1, !0), this;
  }
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  getObjectByProperty(e, n) {
    if (this[e] === n)
      return this;
    for (let a = 0, s = this.children.length; a < s; a++) {
      const l = this.children[a].getObjectByProperty(e, n);
      if (l !== void 0)
        return l;
    }
  }
  getObjectsByProperty(e, n) {
    let a = [];
    this[e] === n && a.push(this);
    for (let s = 0, o = this.children.length; s < o; s++) {
      const l = this.children[s].getObjectsByProperty(e, n);
      l.length > 0 && (a = a.concat(l));
    }
    return a;
  }
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(_position$3, e, _scale$2), e;
  }
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(_position$3, _quaternion$2, e), e;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const n = this.matrixWorld.elements;
    return e.set(n[8], n[9], n[10]).normalize();
  }
  raycast() {
  }
  traverse(e) {
    e(this);
    const n = this.children;
    for (let a = 0, s = n.length; a < s; a++)
      n[a].traverse(e);
  }
  traverseVisible(e) {
    if (this.visible === !1)
      return;
    e(this);
    const n = this.children;
    for (let a = 0, s = n.length; a < s; a++)
      n[a].traverseVisible(e);
  }
  traverseAncestors(e) {
    const n = this.parent;
    n !== null && (e(n), n.traverseAncestors(e));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e = !0);
    const n = this.children;
    for (let a = 0, s = n.length; a < s; a++) {
      const o = n[a];
      (o.matrixWorldAutoUpdate === !0 || e === !0) && o.updateMatrixWorld(e);
    }
  }
  updateWorldMatrix(e, n) {
    const a = this.parent;
    if (e === !0 && a !== null && a.matrixWorldAutoUpdate === !0 && a.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), n === !0) {
      const s = this.children;
      for (let o = 0, l = s.length; o < l; o++) {
        const c = s[o];
        c.matrixWorldAutoUpdate === !0 && c.updateWorldMatrix(!1, !0);
      }
    }
  }
  toJSON(e) {
    const n = e === void 0 || typeof e == "string", a = {};
    n && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, a.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const s = {};
    s.uuid = this.uuid, s.type = this.type, this.name !== "" && (s.name = this.name), this.castShadow === !0 && (s.castShadow = !0), this.receiveShadow === !0 && (s.receiveShadow = !0), this.visible === !1 && (s.visible = !1), this.frustumCulled === !1 && (s.frustumCulled = !1), this.renderOrder !== 0 && (s.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (s.userData = this.userData), s.layers = this.layers.mask, s.matrix = this.matrix.toArray(), s.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (s.matrixAutoUpdate = !1), this.isInstancedMesh && (s.type = "InstancedMesh", s.count = this.count, s.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (s.instanceColor = this.instanceColor.toJSON()));
    function o(c, u) {
      return c[u.uuid] === void 0 && (c[u.uuid] = u.toJSON(e)), u.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? s.background = this.background.toJSON() : this.background.isTexture && (s.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (s.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      s.geometry = o(e.geometries, this.geometry);
      const c = this.geometry.parameters;
      if (c !== void 0 && c.shapes !== void 0) {
        const u = c.shapes;
        if (Array.isArray(u))
          for (let d = 0, f = u.length; d < f; d++) {
            const h = u[d];
            o(e.shapes, h);
          }
        else
          o(e.shapes, u);
      }
    }
    if (this.isSkinnedMesh && (s.bindMode = this.bindMode, s.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (o(e.skeletons, this.skeleton), s.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const c = [];
        for (let u = 0, d = this.material.length; u < d; u++)
          c.push(o(e.materials, this.material[u]));
        s.material = c;
      } else
        s.material = o(e.materials, this.material);
    if (this.children.length > 0) {
      s.children = [];
      for (let c = 0; c < this.children.length; c++)
        s.children.push(this.children[c].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      s.animations = [];
      for (let c = 0; c < this.animations.length; c++) {
        const u = this.animations[c];
        s.animations.push(o(e.animations, u));
      }
    }
    if (n) {
      const c = l(e.geometries), u = l(e.materials), d = l(e.textures), f = l(e.images), h = l(e.shapes), g = l(e.skeletons), x = l(e.animations), E = l(e.nodes);
      c.length > 0 && (a.geometries = c), u.length > 0 && (a.materials = u), d.length > 0 && (a.textures = d), f.length > 0 && (a.images = f), h.length > 0 && (a.shapes = h), g.length > 0 && (a.skeletons = g), x.length > 0 && (a.animations = x), E.length > 0 && (a.nodes = E);
    }
    return a.object = s, a;
    function l(c) {
      const u = [];
      for (const d in c) {
        const f = c[d];
        delete f.metadata, u.push(f);
      }
      return u;
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  copy(e, n = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), n === !0)
      for (let a = 0; a < e.children.length; a++) {
        const s = e.children[a];
        this.add(s.clone());
      }
    return this;
  }
}
Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3(0, 1, 0);
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const _v0$1 = /* @__PURE__ */ new Vector3(), _v1$3 = /* @__PURE__ */ new Vector3(), _v2$2 = /* @__PURE__ */ new Vector3(), _v3$1 = /* @__PURE__ */ new Vector3(), _vab = /* @__PURE__ */ new Vector3(), _vac = /* @__PURE__ */ new Vector3(), _vbc = /* @__PURE__ */ new Vector3(), _vap = /* @__PURE__ */ new Vector3(), _vbp = /* @__PURE__ */ new Vector3(), _vcp = /* @__PURE__ */ new Vector3();
let warnedGetUV = !1;
class Triangle {
  constructor(e = new Vector3(), n = new Vector3(), a = new Vector3()) {
    this.a = e, this.b = n, this.c = a;
  }
  static getNormal(e, n, a, s) {
    s.subVectors(a, n), _v0$1.subVectors(e, n), s.cross(_v0$1);
    const o = s.lengthSq();
    return o > 0 ? s.multiplyScalar(1 / Math.sqrt(o)) : s.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(e, n, a, s, o) {
    _v0$1.subVectors(s, n), _v1$3.subVectors(a, n), _v2$2.subVectors(e, n);
    const l = _v0$1.dot(_v0$1), c = _v0$1.dot(_v1$3), u = _v0$1.dot(_v2$2), d = _v1$3.dot(_v1$3), f = _v1$3.dot(_v2$2), h = l * d - c * c;
    if (h === 0)
      return o.set(-2, -1, -1);
    const g = 1 / h, x = (d * u - c * f) * g, E = (l * f - c * u) * g;
    return o.set(1 - x - E, E, x);
  }
  static containsPoint(e, n, a, s) {
    return this.getBarycoord(e, n, a, s, _v3$1), _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
  }
  static getUV(e, n, a, s, o, l, c, u) {
    return warnedGetUV === !1 && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), warnedGetUV = !0), this.getInterpolation(e, n, a, s, o, l, c, u);
  }
  static getInterpolation(e, n, a, s, o, l, c, u) {
    return this.getBarycoord(e, n, a, s, _v3$1), u.setScalar(0), u.addScaledVector(o, _v3$1.x), u.addScaledVector(l, _v3$1.y), u.addScaledVector(c, _v3$1.z), u;
  }
  static isFrontFacing(e, n, a, s) {
    return _v0$1.subVectors(a, n), _v1$3.subVectors(e, n), _v0$1.cross(_v1$3).dot(s) < 0;
  }
  set(e, n, a) {
    return this.a.copy(e), this.b.copy(n), this.c.copy(a), this;
  }
  setFromPointsAndIndices(e, n, a, s) {
    return this.a.copy(e[n]), this.b.copy(e[a]), this.c.copy(e[s]), this;
  }
  setFromAttributeAndIndices(e, n, a, s) {
    return this.a.fromBufferAttribute(e, n), this.b.fromBufferAttribute(e, a), this.c.fromBufferAttribute(e, s), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  getArea() {
    return _v0$1.subVectors(this.c, this.b), _v1$3.subVectors(this.a, this.b), _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(e) {
    return Triangle.getNormal(this.a, this.b, this.c, e);
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(e, n) {
    return Triangle.getBarycoord(e, this.a, this.b, this.c, n);
  }
  getUV(e, n, a, s, o) {
    return warnedGetUV === !1 && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), warnedGetUV = !0), Triangle.getInterpolation(e, this.a, this.b, this.c, n, a, s, o);
  }
  getInterpolation(e, n, a, s, o) {
    return Triangle.getInterpolation(e, this.a, this.b, this.c, n, a, s, o);
  }
  containsPoint(e) {
    return Triangle.containsPoint(e, this.a, this.b, this.c);
  }
  isFrontFacing(e) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, e);
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  closestPointToPoint(e, n) {
    const a = this.a, s = this.b, o = this.c;
    let l, c;
    _vab.subVectors(s, a), _vac.subVectors(o, a), _vap.subVectors(e, a);
    const u = _vab.dot(_vap), d = _vac.dot(_vap);
    if (u <= 0 && d <= 0)
      return n.copy(a);
    _vbp.subVectors(e, s);
    const f = _vab.dot(_vbp), h = _vac.dot(_vbp);
    if (f >= 0 && h <= f)
      return n.copy(s);
    const g = u * h - f * d;
    if (g <= 0 && u >= 0 && f <= 0)
      return l = u / (u - f), n.copy(a).addScaledVector(_vab, l);
    _vcp.subVectors(e, o);
    const x = _vab.dot(_vcp), E = _vac.dot(_vcp);
    if (E >= 0 && x <= E)
      return n.copy(o);
    const m = x * d - u * E;
    if (m <= 0 && d >= 0 && E <= 0)
      return c = d / (d - E), n.copy(a).addScaledVector(_vac, c);
    const v = f * E - x * h;
    if (v <= 0 && h - f >= 0 && x - E >= 0)
      return _vbc.subVectors(o, s), c = (h - f) / (h - f + (x - E)), n.copy(s).addScaledVector(_vbc, c);
    const y = 1 / (v + m + g);
    return l = m * y, c = g * y, n.copy(a).addScaledVector(_vab, l).addScaledVector(_vac, c);
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
const _colorKeywords = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, _hslA = { h: 0, s: 0, l: 0 }, _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * 6 * (2 / 3 - n) : t;
}
class Color {
  constructor(e, n, a) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, n, a);
  }
  set(e, n, a) {
    if (n === void 0 && a === void 0) {
      const s = e;
      s && s.isColor ? this.copy(s) : typeof s == "number" ? this.setHex(s) : typeof s == "string" && this.setStyle(s);
    } else
      this.setRGB(e, n, a);
    return this;
  }
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  setHex(e, n = SRGBColorSpace) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, ColorManagement.toWorkingColorSpace(this, n), this;
  }
  setRGB(e, n, a, s = ColorManagement.workingColorSpace) {
    return this.r = e, this.g = n, this.b = a, ColorManagement.toWorkingColorSpace(this, s), this;
  }
  setHSL(e, n, a, s = ColorManagement.workingColorSpace) {
    if (e = euclideanModulo(e, 1), n = clamp(n, 0, 1), a = clamp(a, 0, 1), n === 0)
      this.r = this.g = this.b = a;
    else {
      const o = a <= 0.5 ? a * (1 + n) : a + n - a * n, l = 2 * a - o;
      this.r = hue2rgb(l, o, e + 1 / 3), this.g = hue2rgb(l, o, e), this.b = hue2rgb(l, o, e - 1 / 3);
    }
    return ColorManagement.toWorkingColorSpace(this, s), this;
  }
  setStyle(e, n = SRGBColorSpace) {
    function a(o) {
      o !== void 0 && parseFloat(o) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let s;
    if (s = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let o;
      const l = s[1], c = s[2];
      switch (l) {
        case "rgb":
        case "rgba":
          if (o = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return a(o[4]), this.setRGB(
              Math.min(255, parseInt(o[1], 10)) / 255,
              Math.min(255, parseInt(o[2], 10)) / 255,
              Math.min(255, parseInt(o[3], 10)) / 255,
              n
            );
          if (o = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return a(o[4]), this.setRGB(
              Math.min(100, parseInt(o[1], 10)) / 100,
              Math.min(100, parseInt(o[2], 10)) / 100,
              Math.min(100, parseInt(o[3], 10)) / 100,
              n
            );
          break;
        case "hsl":
        case "hsla":
          if (o = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return a(o[4]), this.setHSL(
              parseFloat(o[1]) / 360,
              parseFloat(o[2]) / 100,
              parseFloat(o[3]) / 100,
              n
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + e);
      }
    } else if (s = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const o = s[1], l = o.length;
      if (l === 3)
        return this.setRGB(
          parseInt(o.charAt(0), 16) / 15,
          parseInt(o.charAt(1), 16) / 15,
          parseInt(o.charAt(2), 16) / 15,
          n
        );
      if (l === 6)
        return this.setHex(parseInt(o, 16), n);
      console.warn("THREE.Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, n);
    return this;
  }
  setColorName(e, n = SRGBColorSpace) {
    const a = _colorKeywords[e.toLowerCase()];
    return a !== void 0 ? this.setHex(a, n) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  copySRGBToLinear(e) {
    return this.r = SRGBToLinear(e.r), this.g = SRGBToLinear(e.g), this.b = SRGBToLinear(e.b), this;
  }
  copyLinearToSRGB(e) {
    return this.r = LinearToSRGB(e.r), this.g = LinearToSRGB(e.g), this.b = LinearToSRGB(e.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(e = SRGBColorSpace) {
    return ColorManagement.fromWorkingColorSpace(_color.copy(this), e), Math.round(clamp(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp(_color.g * 255, 0, 255)) * 256 + Math.round(clamp(_color.b * 255, 0, 255));
  }
  getHexString(e = SRGBColorSpace) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  getHSL(e, n = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), n);
    const a = _color.r, s = _color.g, o = _color.b, l = Math.max(a, s, o), c = Math.min(a, s, o);
    let u, d;
    const f = (c + l) / 2;
    if (c === l)
      u = 0, d = 0;
    else {
      const h = l - c;
      switch (d = f <= 0.5 ? h / (l + c) : h / (2 - l - c), l) {
        case a:
          u = (s - o) / h + (s < o ? 6 : 0);
          break;
        case s:
          u = (o - a) / h + 2;
          break;
        case o:
          u = (a - s) / h + 4;
          break;
      }
      u /= 6;
    }
    return e.h = u, e.s = d, e.l = f, e;
  }
  getRGB(e, n = ColorManagement.workingColorSpace) {
    return ColorManagement.fromWorkingColorSpace(_color.copy(this), n), e.r = _color.r, e.g = _color.g, e.b = _color.b, e;
  }
  getStyle(e = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), e);
    const n = _color.r, a = _color.g, s = _color.b;
    return e !== SRGBColorSpace ? `color(${e} ${n.toFixed(3)} ${a.toFixed(3)} ${s.toFixed(3)})` : `rgb(${Math.round(n * 255)},${Math.round(a * 255)},${Math.round(s * 255)})`;
  }
  offsetHSL(e, n, a) {
    return this.getHSL(_hslA), this.setHSL(_hslA.h + e, _hslA.s + n, _hslA.l + a);
  }
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  addColors(e, n) {
    return this.r = e.r + n.r, this.g = e.g + n.g, this.b = e.b + n.b, this;
  }
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  lerp(e, n) {
    return this.r += (e.r - this.r) * n, this.g += (e.g - this.g) * n, this.b += (e.b - this.b) * n, this;
  }
  lerpColors(e, n, a) {
    return this.r = e.r + (n.r - e.r) * a, this.g = e.g + (n.g - e.g) * a, this.b = e.b + (n.b - e.b) * a, this;
  }
  lerpHSL(e, n) {
    this.getHSL(_hslA), e.getHSL(_hslB);
    const a = lerp(_hslA.h, _hslB.h, n), s = lerp(_hslA.s, _hslB.s, n), o = lerp(_hslA.l, _hslB.l, n);
    return this.setHSL(a, s, o), this;
  }
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  applyMatrix3(e) {
    const n = this.r, a = this.g, s = this.b, o = e.elements;
    return this.r = o[0] * n + o[3] * a + o[6] * s, this.g = o[1] * n + o[4] * a + o[7] * s, this.b = o[2] * n + o[5] * a + o[8] * s, this;
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  fromArray(e, n = 0) {
    return this.r = e[n], this.g = e[n + 1], this.b = e[n + 2], this;
  }
  toArray(e = [], n = 0) {
    return e[n] = this.r, e[n + 1] = this.g, e[n + 2] = this.b, e;
  }
  fromBufferAttribute(e, n) {
    return this.r = e.getX(n), this.g = e.getY(n), this.b = e.getZ(n), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const _color = /* @__PURE__ */ new Color();
Color.NAMES = _colorKeywords;
let _materialId = 0;
class Material extends EventDispatcher {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: _materialId++ }), this.uuid = generateUUID(), this.name = "", this.type = "Material", this.blending = NormalBlending, this.side = FrontSide, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = SrcAlphaFactor, this.blendDst = OneMinusSrcAlphaFactor, this.blendEquation = AddEquation, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Color(0, 0, 0), this.blendAlpha = 0, this.depthFunc = LessEqualDepth, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = AlwaysStencilFunc, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = KeepStencilOp, this.stencilZFail = KeepStencilOp, this.stencilZPass = KeepStencilOp, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  onBuild() {
  }
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(e) {
    if (e !== void 0)
      for (const n in e) {
        const a = e[n];
        if (a === void 0) {
          console.warn(`THREE.Material: parameter '${n}' has value of undefined.`);
          continue;
        }
        const s = this[n];
        if (s === void 0) {
          console.warn(`THREE.Material: '${n}' is not a property of THREE.${this.type}.`);
          continue;
        }
        s && s.isColor ? s.set(a) : s && s.isVector3 && a && a.isVector3 ? s.copy(a) : this[n] = a;
      }
  }
  toJSON(e) {
    const n = e === void 0 || typeof e == "string";
    n && (e = {
      textures: {},
      images: {}
    });
    const a = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    a.uuid = this.uuid, a.type = this.type, this.name !== "" && (a.name = this.name), this.color && this.color.isColor && (a.color = this.color.getHex()), this.roughness !== void 0 && (a.roughness = this.roughness), this.metalness !== void 0 && (a.metalness = this.metalness), this.sheen !== void 0 && (a.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (a.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (a.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (a.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (a.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (a.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (a.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (a.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (a.shininess = this.shininess), this.clearcoat !== void 0 && (a.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (a.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (a.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (a.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (a.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, a.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (a.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (a.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (a.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (a.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (a.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (a.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (a.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (a.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (a.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (a.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (a.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (a.lightMap = this.lightMap.toJSON(e).uuid, a.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (a.aoMap = this.aoMap.toJSON(e).uuid, a.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (a.bumpMap = this.bumpMap.toJSON(e).uuid, a.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (a.normalMap = this.normalMap.toJSON(e).uuid, a.normalMapType = this.normalMapType, a.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (a.displacementMap = this.displacementMap.toJSON(e).uuid, a.displacementScale = this.displacementScale, a.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (a.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (a.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (a.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (a.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (a.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (a.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (a.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (a.combine = this.combine)), this.envMapIntensity !== void 0 && (a.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (a.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (a.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (a.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (a.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (a.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (a.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (a.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (a.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (a.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (a.size = this.size), this.shadowSide !== null && (a.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (a.sizeAttenuation = this.sizeAttenuation), this.blending !== NormalBlending && (a.blending = this.blending), this.side !== FrontSide && (a.side = this.side), this.vertexColors === !0 && (a.vertexColors = !0), this.opacity < 1 && (a.opacity = this.opacity), this.transparent === !0 && (a.transparent = !0), this.blendSrc !== SrcAlphaFactor && (a.blendSrc = this.blendSrc), this.blendDst !== OneMinusSrcAlphaFactor && (a.blendDst = this.blendDst), this.blendEquation !== AddEquation && (a.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (a.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (a.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (a.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (a.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (a.blendAlpha = this.blendAlpha), this.depthFunc !== LessEqualDepth && (a.depthFunc = this.depthFunc), this.depthTest === !1 && (a.depthTest = this.depthTest), this.depthWrite === !1 && (a.depthWrite = this.depthWrite), this.colorWrite === !1 && (a.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (a.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== AlwaysStencilFunc && (a.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (a.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (a.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== KeepStencilOp && (a.stencilFail = this.stencilFail), this.stencilZFail !== KeepStencilOp && (a.stencilZFail = this.stencilZFail), this.stencilZPass !== KeepStencilOp && (a.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (a.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (a.rotation = this.rotation), this.polygonOffset === !0 && (a.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (a.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (a.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (a.linewidth = this.linewidth), this.dashSize !== void 0 && (a.dashSize = this.dashSize), this.gapSize !== void 0 && (a.gapSize = this.gapSize), this.scale !== void 0 && (a.scale = this.scale), this.dithering === !0 && (a.dithering = !0), this.alphaTest > 0 && (a.alphaTest = this.alphaTest), this.alphaHash === !0 && (a.alphaHash = !0), this.alphaToCoverage === !0 && (a.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (a.premultipliedAlpha = !0), this.forceSinglePass === !0 && (a.forceSinglePass = !0), this.wireframe === !0 && (a.wireframe = !0), this.wireframeLinewidth > 1 && (a.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (a.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (a.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (a.flatShading = !0), this.visible === !1 && (a.visible = !1), this.toneMapped === !1 && (a.toneMapped = !1), this.fog === !1 && (a.fog = !1), Object.keys(this.userData).length > 0 && (a.userData = this.userData);
    function s(o) {
      const l = [];
      for (const c in o) {
        const u = o[c];
        delete u.metadata, l.push(u);
      }
      return l;
    }
    if (n) {
      const o = s(e.textures), l = s(e.images);
      o.length > 0 && (a.textures = o), l.length > 0 && (a.images = l);
    }
    return a;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const n = e.clippingPlanes;
    let a = null;
    if (n !== null) {
      const s = n.length;
      a = new Array(s);
      for (let o = 0; o !== s; ++o)
        a[o] = n[o].clone();
    }
    return this.clippingPlanes = a, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
class MeshBasicMaterial extends Material {
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Color(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = MultiplyOperation, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const _vector$8 = /* @__PURE__ */ new Vector3(), _vector2$1 = /* @__PURE__ */ new Vector2();
class BufferAttribute {
  constructor(e, n, a = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = e, this.itemSize = n, this.count = e !== void 0 ? e.length / n : 0, this.normalized = a, this.usage = StaticDrawUsage, this.updateRange = { offset: 0, count: -1 }, this.gpuType = FloatType, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  copyAt(e, n, a) {
    e *= this.itemSize, a *= n.itemSize;
    for (let s = 0, o = this.itemSize; s < o; s++)
      this.array[e + s] = n.array[a + s];
    return this;
  }
  copyArray(e) {
    return this.array.set(e), this;
  }
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let n = 0, a = this.count; n < a; n++)
        _vector2$1.fromBufferAttribute(this, n), _vector2$1.applyMatrix3(e), this.setXY(n, _vector2$1.x, _vector2$1.y);
    else if (this.itemSize === 3)
      for (let n = 0, a = this.count; n < a; n++)
        _vector$8.fromBufferAttribute(this, n), _vector$8.applyMatrix3(e), this.setXYZ(n, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  applyMatrix4(e) {
    for (let n = 0, a = this.count; n < a; n++)
      _vector$8.fromBufferAttribute(this, n), _vector$8.applyMatrix4(e), this.setXYZ(n, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let n = 0, a = this.count; n < a; n++)
      _vector$8.fromBufferAttribute(this, n), _vector$8.applyNormalMatrix(e), this.setXYZ(n, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  transformDirection(e) {
    for (let n = 0, a = this.count; n < a; n++)
      _vector$8.fromBufferAttribute(this, n), _vector$8.transformDirection(e), this.setXYZ(n, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  set(e, n = 0) {
    return this.array.set(e, n), this;
  }
  getComponent(e, n) {
    let a = this.array[e * this.itemSize + n];
    return this.normalized && (a = denormalize(a, this.array)), a;
  }
  setComponent(e, n, a) {
    return this.normalized && (a = normalize(a, this.array)), this.array[e * this.itemSize + n] = a, this;
  }
  getX(e) {
    let n = this.array[e * this.itemSize];
    return this.normalized && (n = denormalize(n, this.array)), n;
  }
  setX(e, n) {
    return this.normalized && (n = normalize(n, this.array)), this.array[e * this.itemSize] = n, this;
  }
  getY(e) {
    let n = this.array[e * this.itemSize + 1];
    return this.normalized && (n = denormalize(n, this.array)), n;
  }
  setY(e, n) {
    return this.normalized && (n = normalize(n, this.array)), this.array[e * this.itemSize + 1] = n, this;
  }
  getZ(e) {
    let n = this.array[e * this.itemSize + 2];
    return this.normalized && (n = denormalize(n, this.array)), n;
  }
  setZ(e, n) {
    return this.normalized && (n = normalize(n, this.array)), this.array[e * this.itemSize + 2] = n, this;
  }
  getW(e) {
    let n = this.array[e * this.itemSize + 3];
    return this.normalized && (n = denormalize(n, this.array)), n;
  }
  setW(e, n) {
    return this.normalized && (n = normalize(n, this.array)), this.array[e * this.itemSize + 3] = n, this;
  }
  setXY(e, n, a) {
    return e *= this.itemSize, this.normalized && (n = normalize(n, this.array), a = normalize(a, this.array)), this.array[e + 0] = n, this.array[e + 1] = a, this;
  }
  setXYZ(e, n, a, s) {
    return e *= this.itemSize, this.normalized && (n = normalize(n, this.array), a = normalize(a, this.array), s = normalize(s, this.array)), this.array[e + 0] = n, this.array[e + 1] = a, this.array[e + 2] = s, this;
  }
  setXYZW(e, n, a, s, o) {
    return e *= this.itemSize, this.normalized && (n = normalize(n, this.array), a = normalize(a, this.array), s = normalize(s, this.array), o = normalize(o, this.array)), this.array[e + 0] = n, this.array[e + 1] = a, this.array[e + 2] = s, this.array[e + 3] = o, this;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== StaticDrawUsage && (e.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (e.updateRange = this.updateRange), e;
  }
}
class Uint16BufferAttribute extends BufferAttribute {
  constructor(e, n, a) {
    super(new Uint16Array(e), n, a);
  }
}
class Uint32BufferAttribute extends BufferAttribute {
  constructor(e, n, a) {
    super(new Uint32Array(e), n, a);
  }
}
class Float32BufferAttribute extends BufferAttribute {
  constructor(e, n, a) {
    super(new Float32Array(e), n, a);
  }
}
let _id$2 = 0;
const _m1 = /* @__PURE__ */ new Matrix4(), _obj = /* @__PURE__ */ new Object3D(), _offset = /* @__PURE__ */ new Vector3(), _box$1 = /* @__PURE__ */ new Box3(), _boxMorphTargets = /* @__PURE__ */ new Box3(), _vector$7 = /* @__PURE__ */ new Vector3();
class BufferGeometry extends EventDispatcher {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: _id$2++ }), this.uuid = generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (arrayNeedsUint32(e) ? Uint32BufferAttribute : Uint16BufferAttribute)(e, 1) : this.index = e, this;
  }
  getAttribute(e) {
    return this.attributes[e];
  }
  setAttribute(e, n) {
    return this.attributes[e] = n, this;
  }
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  addGroup(e, n, a = 0) {
    this.groups.push({
      start: e,
      count: n,
      materialIndex: a
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(e, n) {
    this.drawRange.start = e, this.drawRange.count = n;
  }
  applyMatrix4(e) {
    const n = this.attributes.position;
    n !== void 0 && (n.applyMatrix4(e), n.needsUpdate = !0);
    const a = this.attributes.normal;
    if (a !== void 0) {
      const o = new Matrix3().getNormalMatrix(e);
      a.applyNormalMatrix(o), a.needsUpdate = !0;
    }
    const s = this.attributes.tangent;
    return s !== void 0 && (s.transformDirection(e), s.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(e) {
    return _m1.makeRotationFromQuaternion(e), this.applyMatrix4(_m1), this;
  }
  rotateX(e) {
    return _m1.makeRotationX(e), this.applyMatrix4(_m1), this;
  }
  rotateY(e) {
    return _m1.makeRotationY(e), this.applyMatrix4(_m1), this;
  }
  rotateZ(e) {
    return _m1.makeRotationZ(e), this.applyMatrix4(_m1), this;
  }
  translate(e, n, a) {
    return _m1.makeTranslation(e, n, a), this.applyMatrix4(_m1), this;
  }
  scale(e, n, a) {
    return _m1.makeScale(e, n, a), this.applyMatrix4(_m1), this;
  }
  lookAt(e) {
    return _obj.lookAt(e), _obj.updateMatrix(), this.applyMatrix4(_obj.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(_offset).negate(), this.translate(_offset.x, _offset.y, _offset.z), this;
  }
  setFromPoints(e) {
    const n = [];
    for (let a = 0, s = e.length; a < s; a++) {
      const o = e[a];
      n.push(o.x, o.y, o.z || 0);
    }
    return this.setAttribute("position", new Float32BufferAttribute(n, 3)), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Box3());
    const e = this.attributes.position, n = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(
        new Vector3(-1 / 0, -1 / 0, -1 / 0),
        new Vector3(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), n)
        for (let a = 0, s = n.length; a < s; a++) {
          const o = n[a];
          _box$1.setFromBufferAttribute(o), this.morphTargetsRelative ? (_vector$7.addVectors(this.boundingBox.min, _box$1.min), this.boundingBox.expandByPoint(_vector$7), _vector$7.addVectors(this.boundingBox.max, _box$1.max), this.boundingBox.expandByPoint(_vector$7)) : (this.boundingBox.expandByPoint(_box$1.min), this.boundingBox.expandByPoint(_box$1.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Sphere());
    const e = this.attributes.position, n = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new Vector3(), 1 / 0);
      return;
    }
    if (e) {
      const a = this.boundingSphere.center;
      if (_box$1.setFromBufferAttribute(e), n)
        for (let o = 0, l = n.length; o < l; o++) {
          const c = n[o];
          _boxMorphTargets.setFromBufferAttribute(c), this.morphTargetsRelative ? (_vector$7.addVectors(_box$1.min, _boxMorphTargets.min), _box$1.expandByPoint(_vector$7), _vector$7.addVectors(_box$1.max, _boxMorphTargets.max), _box$1.expandByPoint(_vector$7)) : (_box$1.expandByPoint(_boxMorphTargets.min), _box$1.expandByPoint(_boxMorphTargets.max));
        }
      _box$1.getCenter(a);
      let s = 0;
      for (let o = 0, l = e.count; o < l; o++)
        _vector$7.fromBufferAttribute(e, o), s = Math.max(s, a.distanceToSquared(_vector$7));
      if (n)
        for (let o = 0, l = n.length; o < l; o++) {
          const c = n[o], u = this.morphTargetsRelative;
          for (let d = 0, f = c.count; d < f; d++)
            _vector$7.fromBufferAttribute(c, d), u && (_offset.fromBufferAttribute(e, d), _vector$7.add(_offset)), s = Math.max(s, a.distanceToSquared(_vector$7));
        }
      this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const e = this.index, n = this.attributes;
    if (e === null || n.position === void 0 || n.normal === void 0 || n.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const a = e.array, s = n.position.array, o = n.normal.array, l = n.uv.array, c = s.length / 3;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * c), 4));
    const u = this.getAttribute("tangent").array, d = [], f = [];
    for (let k = 0; k < c; k++)
      d[k] = new Vector3(), f[k] = new Vector3();
    const h = new Vector3(), g = new Vector3(), x = new Vector3(), E = new Vector2(), m = new Vector2(), v = new Vector2(), y = new Vector3(), A = new Vector3();
    function b(k, W, L) {
      h.fromArray(s, k * 3), g.fromArray(s, W * 3), x.fromArray(s, L * 3), E.fromArray(l, k * 2), m.fromArray(l, W * 2), v.fromArray(l, L * 2), g.sub(h), x.sub(h), m.sub(E), v.sub(E);
      const z = 1 / (m.x * v.y - v.x * m.y);
      isFinite(z) && (y.copy(g).multiplyScalar(v.y).addScaledVector(x, -m.y).multiplyScalar(z), A.copy(x).multiplyScalar(m.x).addScaledVector(g, -v.x).multiplyScalar(z), d[k].add(y), d[W].add(y), d[L].add(y), f[k].add(A), f[W].add(A), f[L].add(A));
    }
    let C = this.groups;
    C.length === 0 && (C = [{
      start: 0,
      count: a.length
    }]);
    for (let k = 0, W = C.length; k < W; ++k) {
      const L = C[k], z = L.start, P = L.count;
      for (let Q = z, Y = z + P; Q < Y; Q += 3)
        b(
          a[Q + 0],
          a[Q + 1],
          a[Q + 2]
        );
    }
    const T = new Vector3(), w = new Vector3(), R = new Vector3(), O = new Vector3();
    function D(k) {
      R.fromArray(o, k * 3), O.copy(R);
      const W = d[k];
      T.copy(W), T.sub(R.multiplyScalar(R.dot(W))).normalize(), w.crossVectors(O, W);
      const z = w.dot(f[k]) < 0 ? -1 : 1;
      u[k * 4] = T.x, u[k * 4 + 1] = T.y, u[k * 4 + 2] = T.z, u[k * 4 + 3] = z;
    }
    for (let k = 0, W = C.length; k < W; ++k) {
      const L = C[k], z = L.start, P = L.count;
      for (let Q = z, Y = z + P; Q < Y; Q += 3)
        D(a[Q + 0]), D(a[Q + 1]), D(a[Q + 2]);
    }
  }
  computeVertexNormals() {
    const e = this.index, n = this.getAttribute("position");
    if (n !== void 0) {
      let a = this.getAttribute("normal");
      if (a === void 0)
        a = new BufferAttribute(new Float32Array(n.count * 3), 3), this.setAttribute("normal", a);
      else
        for (let g = 0, x = a.count; g < x; g++)
          a.setXYZ(g, 0, 0, 0);
      const s = new Vector3(), o = new Vector3(), l = new Vector3(), c = new Vector3(), u = new Vector3(), d = new Vector3(), f = new Vector3(), h = new Vector3();
      if (e)
        for (let g = 0, x = e.count; g < x; g += 3) {
          const E = e.getX(g + 0), m = e.getX(g + 1), v = e.getX(g + 2);
          s.fromBufferAttribute(n, E), o.fromBufferAttribute(n, m), l.fromBufferAttribute(n, v), f.subVectors(l, o), h.subVectors(s, o), f.cross(h), c.fromBufferAttribute(a, E), u.fromBufferAttribute(a, m), d.fromBufferAttribute(a, v), c.add(f), u.add(f), d.add(f), a.setXYZ(E, c.x, c.y, c.z), a.setXYZ(m, u.x, u.y, u.z), a.setXYZ(v, d.x, d.y, d.z);
        }
      else
        for (let g = 0, x = n.count; g < x; g += 3)
          s.fromBufferAttribute(n, g + 0), o.fromBufferAttribute(n, g + 1), l.fromBufferAttribute(n, g + 2), f.subVectors(l, o), h.subVectors(s, o), f.cross(h), a.setXYZ(g + 0, f.x, f.y, f.z), a.setXYZ(g + 1, f.x, f.y, f.z), a.setXYZ(g + 2, f.x, f.y, f.z);
      this.normalizeNormals(), a.needsUpdate = !0;
    }
  }
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let n = 0, a = e.count; n < a; n++)
      _vector$7.fromBufferAttribute(e, n), _vector$7.normalize(), e.setXYZ(n, _vector$7.x, _vector$7.y, _vector$7.z);
  }
  toNonIndexed() {
    function e(c, u) {
      const d = c.array, f = c.itemSize, h = c.normalized, g = new d.constructor(u.length * f);
      let x = 0, E = 0;
      for (let m = 0, v = u.length; m < v; m++) {
        c.isInterleavedBufferAttribute ? x = u[m] * c.data.stride + c.offset : x = u[m] * f;
        for (let y = 0; y < f; y++)
          g[E++] = d[x++];
      }
      return new BufferAttribute(g, f, h);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const n = new BufferGeometry(), a = this.index.array, s = this.attributes;
    for (const c in s) {
      const u = s[c], d = e(u, a);
      n.setAttribute(c, d);
    }
    const o = this.morphAttributes;
    for (const c in o) {
      const u = [], d = o[c];
      for (let f = 0, h = d.length; f < h; f++) {
        const g = d[f], x = e(g, a);
        u.push(x);
      }
      n.morphAttributes[c] = u;
    }
    n.morphTargetsRelative = this.morphTargetsRelative;
    const l = this.groups;
    for (let c = 0, u = l.length; c < u; c++) {
      const d = l[c];
      n.addGroup(d.start, d.count, d.materialIndex);
    }
    return n;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const u = this.parameters;
      for (const d in u)
        u[d] !== void 0 && (e[d] = u[d]);
      return e;
    }
    e.data = { attributes: {} };
    const n = this.index;
    n !== null && (e.data.index = {
      type: n.array.constructor.name,
      array: Array.prototype.slice.call(n.array)
    });
    const a = this.attributes;
    for (const u in a) {
      const d = a[u];
      e.data.attributes[u] = d.toJSON(e.data);
    }
    const s = {};
    let o = !1;
    for (const u in this.morphAttributes) {
      const d = this.morphAttributes[u], f = [];
      for (let h = 0, g = d.length; h < g; h++) {
        const x = d[h];
        f.push(x.toJSON(e.data));
      }
      f.length > 0 && (s[u] = f, o = !0);
    }
    o && (e.data.morphAttributes = s, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const l = this.groups;
    l.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(l)));
    const c = this.boundingSphere;
    return c !== null && (e.data.boundingSphere = {
      center: c.center.toArray(),
      radius: c.radius
    }), e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const n = {};
    this.name = e.name;
    const a = e.index;
    a !== null && this.setIndex(a.clone(n));
    const s = e.attributes;
    for (const d in s) {
      const f = s[d];
      this.setAttribute(d, f.clone(n));
    }
    const o = e.morphAttributes;
    for (const d in o) {
      const f = [], h = o[d];
      for (let g = 0, x = h.length; g < x; g++)
        f.push(h[g].clone(n));
      this.morphAttributes[d] = f;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const l = e.groups;
    for (let d = 0, f = l.length; d < f; d++) {
      const h = l[d];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const c = e.boundingBox;
    c !== null && (this.boundingBox = c.clone());
    const u = e.boundingSphere;
    return u !== null && (this.boundingSphere = u.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const _inverseMatrix$3 = /* @__PURE__ */ new Matrix4(), _ray$3 = /* @__PURE__ */ new Ray(), _sphere$5 = /* @__PURE__ */ new Sphere(), _sphereHitAt = /* @__PURE__ */ new Vector3(), _vA$1 = /* @__PURE__ */ new Vector3(), _vB$1 = /* @__PURE__ */ new Vector3(), _vC$1 = /* @__PURE__ */ new Vector3(), _tempA = /* @__PURE__ */ new Vector3(), _morphA = /* @__PURE__ */ new Vector3(), _uvA$1 = /* @__PURE__ */ new Vector2(), _uvB$1 = /* @__PURE__ */ new Vector2(), _uvC$1 = /* @__PURE__ */ new Vector2(), _normalA = /* @__PURE__ */ new Vector3(), _normalB = /* @__PURE__ */ new Vector3(), _normalC = /* @__PURE__ */ new Vector3(), _intersectionPoint = /* @__PURE__ */ new Vector3(), _intersectionPointWorld = /* @__PURE__ */ new Vector3();
class Mesh extends Object3D {
  constructor(e = new BufferGeometry(), n = new MeshBasicMaterial()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = n, this.updateMorphTargets();
  }
  copy(e, n) {
    return super.copy(e, n), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  updateMorphTargets() {
    const n = this.geometry.morphAttributes, a = Object.keys(n);
    if (a.length > 0) {
      const s = n[a[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let o = 0, l = s.length; o < l; o++) {
          const c = s[o].name || String(o);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = o;
        }
      }
    }
  }
  getVertexPosition(e, n) {
    const a = this.geometry, s = a.attributes.position, o = a.morphAttributes.position, l = a.morphTargetsRelative;
    n.fromBufferAttribute(s, e);
    const c = this.morphTargetInfluences;
    if (o && c) {
      _morphA.set(0, 0, 0);
      for (let u = 0, d = o.length; u < d; u++) {
        const f = c[u], h = o[u];
        f !== 0 && (_tempA.fromBufferAttribute(h, e), l ? _morphA.addScaledVector(_tempA, f) : _morphA.addScaledVector(_tempA.sub(n), f));
      }
      n.add(_morphA);
    }
    return n;
  }
  raycast(e, n) {
    const a = this.geometry, s = this.material, o = this.matrixWorld;
    s !== void 0 && (a.boundingSphere === null && a.computeBoundingSphere(), _sphere$5.copy(a.boundingSphere), _sphere$5.applyMatrix4(o), _ray$3.copy(e.ray).recast(e.near), !(_sphere$5.containsPoint(_ray$3.origin) === !1 && (_ray$3.intersectSphere(_sphere$5, _sphereHitAt) === null || _ray$3.origin.distanceToSquared(_sphereHitAt) > (e.far - e.near) ** 2)) && (_inverseMatrix$3.copy(o).invert(), _ray$3.copy(e.ray).applyMatrix4(_inverseMatrix$3), !(a.boundingBox !== null && _ray$3.intersectsBox(a.boundingBox) === !1) && this._computeIntersections(e, n, _ray$3)));
  }
  _computeIntersections(e, n, a) {
    let s;
    const o = this.geometry, l = this.material, c = o.index, u = o.attributes.position, d = o.attributes.uv, f = o.attributes.uv1, h = o.attributes.normal, g = o.groups, x = o.drawRange;
    if (c !== null)
      if (Array.isArray(l))
        for (let E = 0, m = g.length; E < m; E++) {
          const v = g[E], y = l[v.materialIndex], A = Math.max(v.start, x.start), b = Math.min(c.count, Math.min(v.start + v.count, x.start + x.count));
          for (let C = A, T = b; C < T; C += 3) {
            const w = c.getX(C), R = c.getX(C + 1), O = c.getX(C + 2);
            s = checkGeometryIntersection(this, y, e, a, d, f, h, w, R, O), s && (s.faceIndex = Math.floor(C / 3), s.face.materialIndex = v.materialIndex, n.push(s));
          }
        }
      else {
        const E = Math.max(0, x.start), m = Math.min(c.count, x.start + x.count);
        for (let v = E, y = m; v < y; v += 3) {
          const A = c.getX(v), b = c.getX(v + 1), C = c.getX(v + 2);
          s = checkGeometryIntersection(this, l, e, a, d, f, h, A, b, C), s && (s.faceIndex = Math.floor(v / 3), n.push(s));
        }
      }
    else if (u !== void 0)
      if (Array.isArray(l))
        for (let E = 0, m = g.length; E < m; E++) {
          const v = g[E], y = l[v.materialIndex], A = Math.max(v.start, x.start), b = Math.min(u.count, Math.min(v.start + v.count, x.start + x.count));
          for (let C = A, T = b; C < T; C += 3) {
            const w = C, R = C + 1, O = C + 2;
            s = checkGeometryIntersection(this, y, e, a, d, f, h, w, R, O), s && (s.faceIndex = Math.floor(C / 3), s.face.materialIndex = v.materialIndex, n.push(s));
          }
        }
      else {
        const E = Math.max(0, x.start), m = Math.min(u.count, x.start + x.count);
        for (let v = E, y = m; v < y; v += 3) {
          const A = v, b = v + 1, C = v + 2;
          s = checkGeometryIntersection(this, l, e, a, d, f, h, A, b, C), s && (s.faceIndex = Math.floor(v / 3), n.push(s));
        }
      }
  }
}
function checkIntersection(t, e, n, a, s, o, l, c) {
  let u;
  if (e.side === BackSide ? u = a.intersectTriangle(l, o, s, !0, c) : u = a.intersectTriangle(s, o, l, e.side === FrontSide, c), u === null)
    return null;
  _intersectionPointWorld.copy(c), _intersectionPointWorld.applyMatrix4(t.matrixWorld);
  const d = n.ray.origin.distanceTo(_intersectionPointWorld);
  return d < n.near || d > n.far ? null : {
    distance: d,
    point: _intersectionPointWorld.clone(),
    object: t
  };
}
function checkGeometryIntersection(t, e, n, a, s, o, l, c, u, d) {
  t.getVertexPosition(c, _vA$1), t.getVertexPosition(u, _vB$1), t.getVertexPosition(d, _vC$1);
  const f = checkIntersection(t, e, n, a, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (f) {
    s && (_uvA$1.fromBufferAttribute(s, c), _uvB$1.fromBufferAttribute(s, u), _uvC$1.fromBufferAttribute(s, d), f.uv = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2())), o && (_uvA$1.fromBufferAttribute(o, c), _uvB$1.fromBufferAttribute(o, u), _uvC$1.fromBufferAttribute(o, d), f.uv1 = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2()), f.uv2 = f.uv1), l && (_normalA.fromBufferAttribute(l, c), _normalB.fromBufferAttribute(l, u), _normalC.fromBufferAttribute(l, d), f.normal = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3()), f.normal.dot(a.direction) > 0 && f.normal.multiplyScalar(-1));
    const h = {
      a: c,
      b: u,
      c: d,
      normal: new Vector3(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, h.normal), f.face = h;
  }
  return f;
}
class BoxGeometry extends BufferGeometry {
  constructor(e = 1, n = 1, a = 1, s = 1, o = 1, l = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: n,
      depth: a,
      widthSegments: s,
      heightSegments: o,
      depthSegments: l
    };
    const c = this;
    s = Math.floor(s), o = Math.floor(o), l = Math.floor(l);
    const u = [], d = [], f = [], h = [];
    let g = 0, x = 0;
    E("z", "y", "x", -1, -1, a, n, e, l, o, 0), E("z", "y", "x", 1, -1, a, n, -e, l, o, 1), E("x", "z", "y", 1, 1, e, a, n, s, l, 2), E("x", "z", "y", 1, -1, e, a, -n, s, l, 3), E("x", "y", "z", 1, -1, e, n, a, s, o, 4), E("x", "y", "z", -1, -1, e, n, -a, s, o, 5), this.setIndex(u), this.setAttribute("position", new Float32BufferAttribute(d, 3)), this.setAttribute("normal", new Float32BufferAttribute(f, 3)), this.setAttribute("uv", new Float32BufferAttribute(h, 2));
    function E(m, v, y, A, b, C, T, w, R, O, D) {
      const k = C / R, W = T / O, L = C / 2, z = T / 2, P = w / 2, Q = R + 1, Y = O + 1;
      let ie = 0, te = 0;
      const Z = new Vector3();
      for (let ae = 0; ae < Y; ae++) {
        const G = ae * W - z;
        for (let U = 0; U < Q; U++) {
          const F = U * k - L;
          Z[m] = F * A, Z[v] = G * b, Z[y] = P, d.push(Z.x, Z.y, Z.z), Z[m] = 0, Z[v] = 0, Z[y] = w > 0 ? 1 : -1, f.push(Z.x, Z.y, Z.z), h.push(U / R), h.push(1 - ae / O), ie += 1;
        }
      }
      for (let ae = 0; ae < O; ae++)
        for (let G = 0; G < R; G++) {
          const U = g + G + Q * ae, F = g + G + Q * (ae + 1), M = g + (G + 1) + Q * (ae + 1), I = g + (G + 1) + Q * ae;
          u.push(U, F, I), u.push(F, M, I), te += 6;
        }
      c.addGroup(x, te, D), x += te, g += ie;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new BoxGeometry(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function cloneUniforms(t) {
  const e = {};
  for (const n in t) {
    e[n] = {};
    for (const a in t[n]) {
      const s = t[n][a];
      s && (s.isColor || s.isMatrix3 || s.isMatrix4 || s.isVector2 || s.isVector3 || s.isVector4 || s.isTexture || s.isQuaternion) ? s.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[n][a] = null) : e[n][a] = s.clone() : Array.isArray(s) ? e[n][a] = s.slice() : e[n][a] = s;
    }
  }
  return e;
}
function mergeUniforms(t) {
  const e = {};
  for (let n = 0; n < t.length; n++) {
    const a = cloneUniforms(t[n]);
    for (const s in a)
      e[s] = a[s];
  }
  return e;
}
function cloneUniformsGroups(t) {
  const e = [];
  for (let n = 0; n < t.length; n++)
    e.push(t[n].clone());
  return e;
}
function getUnlitUniformColorSpace(t) {
  return t.getRenderTarget() === null ? t.outputColorSpace : ColorManagement.workingColorSpace;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, default_fragment = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class ShaderMaterial extends Material {
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = default_vertex, this.fragmentShader = default_fragment, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      derivatives: !1,
      // set to use derivatives
      fragDepth: !1,
      // set to use fragment depth values
      drawBuffers: !1,
      // set to use draw buffers
      shaderTextureLOD: !1
      // set to use shader texture LOD
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = cloneUniforms(e.uniforms), this.uniformsGroups = cloneUniformsGroups(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    n.glslVersion = this.glslVersion, n.uniforms = {};
    for (const s in this.uniforms) {
      const l = this.uniforms[s].value;
      l && l.isTexture ? n.uniforms[s] = {
        type: "t",
        value: l.toJSON(e).uuid
      } : l && l.isColor ? n.uniforms[s] = {
        type: "c",
        value: l.getHex()
      } : l && l.isVector2 ? n.uniforms[s] = {
        type: "v2",
        value: l.toArray()
      } : l && l.isVector3 ? n.uniforms[s] = {
        type: "v3",
        value: l.toArray()
      } : l && l.isVector4 ? n.uniforms[s] = {
        type: "v4",
        value: l.toArray()
      } : l && l.isMatrix3 ? n.uniforms[s] = {
        type: "m3",
        value: l.toArray()
      } : l && l.isMatrix4 ? n.uniforms[s] = {
        type: "m4",
        value: l.toArray()
      } : n.uniforms[s] = {
        value: l
      };
    }
    Object.keys(this.defines).length > 0 && (n.defines = this.defines), n.vertexShader = this.vertexShader, n.fragmentShader = this.fragmentShader, n.lights = this.lights, n.clipping = this.clipping;
    const a = {};
    for (const s in this.extensions)
      this.extensions[s] === !0 && (a[s] = !0);
    return Object.keys(a).length > 0 && (n.extensions = a), n;
  }
}
class Camera extends Object3D {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Matrix4(), this.projectionMatrix = new Matrix4(), this.projectionMatrixInverse = new Matrix4(), this.coordinateSystem = WebGLCoordinateSystem;
  }
  copy(e, n) {
    return super.copy(e, n), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, n) {
    super.updateWorldMatrix(e, n), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class PerspectiveCamera extends Camera {
  constructor(e = 50, n = 1, a = 0.1, s = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = a, this.far = s, this.focus = 10, this.aspect = n, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, n) {
    return super.copy(e, n), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const n = 0.5 * this.getFilmHeight() / e;
    this.fov = RAD2DEG * 2 * Math.atan(n), this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const e = Math.tan(DEG2RAD * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(e, n, a, s, o, l) {
    this.aspect = e / n, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = n, this.view.offsetX = a, this.view.offsetY = s, this.view.width = o, this.view.height = l, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = this.near;
    let n = e * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom, a = 2 * n, s = this.aspect * a, o = -0.5 * s;
    const l = this.view;
    if (this.view !== null && this.view.enabled) {
      const u = l.fullWidth, d = l.fullHeight;
      o += l.offsetX * s / u, n -= l.offsetY * a / d, s *= l.width / u, a *= l.height / d;
    }
    const c = this.filmOffset;
    c !== 0 && (o += e * c / this.getFilmWidth()), this.projectionMatrix.makePerspective(o, o + s, n, n - a, e, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return n.object.fov = this.fov, n.object.zoom = this.zoom, n.object.near = this.near, n.object.far = this.far, n.object.focus = this.focus, n.object.aspect = this.aspect, this.view !== null && (n.object.view = Object.assign({}, this.view)), n.object.filmGauge = this.filmGauge, n.object.filmOffset = this.filmOffset, n;
  }
}
const fov = -90, aspect = 1;
class CubeCamera extends Object3D {
  constructor(e, n, a) {
    super(), this.type = "CubeCamera", this.renderTarget = a, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const s = new PerspectiveCamera(fov, aspect, e, n);
    s.layers = this.layers, this.add(s);
    const o = new PerspectiveCamera(fov, aspect, e, n);
    o.layers = this.layers, this.add(o);
    const l = new PerspectiveCamera(fov, aspect, e, n);
    l.layers = this.layers, this.add(l);
    const c = new PerspectiveCamera(fov, aspect, e, n);
    c.layers = this.layers, this.add(c);
    const u = new PerspectiveCamera(fov, aspect, e, n);
    u.layers = this.layers, this.add(u);
    const d = new PerspectiveCamera(fov, aspect, e, n);
    d.layers = this.layers, this.add(d);
  }
  updateCoordinateSystem() {
    const e = this.coordinateSystem, n = this.children.concat(), [a, s, o, l, c, u] = n;
    for (const d of n)
      this.remove(d);
    if (e === WebGLCoordinateSystem)
      a.up.set(0, 1, 0), a.lookAt(1, 0, 0), s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), o.up.set(0, 0, -1), o.lookAt(0, 1, 0), l.up.set(0, 0, 1), l.lookAt(0, -1, 0), c.up.set(0, 1, 0), c.lookAt(0, 0, 1), u.up.set(0, 1, 0), u.lookAt(0, 0, -1);
    else if (e === WebGPUCoordinateSystem)
      a.up.set(0, -1, 0), a.lookAt(-1, 0, 0), s.up.set(0, -1, 0), s.lookAt(1, 0, 0), o.up.set(0, 0, 1), o.lookAt(0, 1, 0), l.up.set(0, 0, -1), l.lookAt(0, -1, 0), c.up.set(0, -1, 0), c.lookAt(0, 0, 1), u.up.set(0, -1, 0), u.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const d of n)
      this.add(d), d.updateMatrixWorld();
  }
  update(e, n) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: a, activeMipmapLevel: s } = this;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [o, l, c, u, d, f] = this.children, h = e.getRenderTarget(), g = e.getActiveCubeFace(), x = e.getActiveMipmapLevel(), E = e.xr.enabled;
    e.xr.enabled = !1;
    const m = a.texture.generateMipmaps;
    a.texture.generateMipmaps = !1, e.setRenderTarget(a, 0, s), e.render(n, o), e.setRenderTarget(a, 1, s), e.render(n, l), e.setRenderTarget(a, 2, s), e.render(n, c), e.setRenderTarget(a, 3, s), e.render(n, u), e.setRenderTarget(a, 4, s), e.render(n, d), a.texture.generateMipmaps = m, e.setRenderTarget(a, 5, s), e.render(n, f), e.setRenderTarget(h, g, x), e.xr.enabled = E, a.texture.needsPMREMUpdate = !0;
  }
}
class CubeTexture extends Texture {
  constructor(e, n, a, s, o, l, c, u, d, f) {
    e = e !== void 0 ? e : [], n = n !== void 0 ? n : CubeReflectionMapping, super(e, n, a, s, o, l, c, u, d, f), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class WebGLCubeRenderTarget extends WebGLRenderTarget {
  constructor(e = 1, n = {}) {
    super(e, e, n), this.isWebGLCubeRenderTarget = !0;
    const a = { width: e, height: e, depth: 1 }, s = [a, a, a, a, a, a];
    n.encoding !== void 0 && (warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), n.colorSpace = n.encoding === sRGBEncoding ? SRGBColorSpace : NoColorSpace), this.texture = new CubeTexture(s, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = n.generateMipmaps !== void 0 ? n.generateMipmaps : !1, this.texture.minFilter = n.minFilter !== void 0 ? n.minFilter : LinearFilter;
  }
  fromEquirectangularTexture(e, n) {
    this.texture.type = n.type, this.texture.colorSpace = n.colorSpace, this.texture.generateMipmaps = n.generateMipmaps, this.texture.minFilter = n.minFilter, this.texture.magFilter = n.magFilter;
    const a = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, s = new BoxGeometry(5, 5, 5), o = new ShaderMaterial({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(a.uniforms),
      vertexShader: a.vertexShader,
      fragmentShader: a.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    o.uniforms.tEquirect.value = n;
    const l = new Mesh(s, o), c = n.minFilter;
    return n.minFilter === LinearMipmapLinearFilter && (n.minFilter = LinearFilter), new CubeCamera(1, 10, this).update(e, l), n.minFilter = c, l.geometry.dispose(), l.material.dispose(), this;
  }
  clear(e, n, a, s) {
    const o = e.getRenderTarget();
    for (let l = 0; l < 6; l++)
      e.setRenderTarget(this, l), e.clear(n, a, s);
    e.setRenderTarget(o);
  }
}
const _vector1 = /* @__PURE__ */ new Vector3(), _vector2 = /* @__PURE__ */ new Vector3(), _normalMatrix = /* @__PURE__ */ new Matrix3();
class Plane {
  constructor(e = new Vector3(1, 0, 0), n = 0) {
    this.isPlane = !0, this.normal = e, this.constant = n;
  }
  set(e, n) {
    return this.normal.copy(e), this.constant = n, this;
  }
  setComponents(e, n, a, s) {
    return this.normal.set(e, n, a), this.constant = s, this;
  }
  setFromNormalAndCoplanarPoint(e, n) {
    return this.normal.copy(e), this.constant = -n.dot(this.normal), this;
  }
  setFromCoplanarPoints(e, n, a) {
    const s = _vector1.subVectors(a, n).cross(_vector2.subVectors(e, n)).normalize();
    return this.setFromNormalAndCoplanarPoint(s, e), this;
  }
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  projectPoint(e, n) {
    return n.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  intersectLine(e, n) {
    const a = e.delta(_vector1), s = this.normal.dot(a);
    if (s === 0)
      return this.distanceToPoint(e.start) === 0 ? n.copy(e.start) : null;
    const o = -(e.start.dot(this.normal) + this.constant) / s;
    return o < 0 || o > 1 ? null : n.copy(e.start).addScaledVector(a, o);
  }
  intersectsLine(e) {
    const n = this.distanceToPoint(e.start), a = this.distanceToPoint(e.end);
    return n < 0 && a > 0 || a < 0 && n > 0;
  }
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(e, n) {
    const a = n || _normalMatrix.getNormalMatrix(e), s = this.coplanarPoint(_vector1).applyMatrix4(e), o = this.normal.applyMatrix3(a).normalize();
    return this.constant = -s.dot(o), this;
  }
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _sphere$4 = /* @__PURE__ */ new Sphere(), _vector$6 = /* @__PURE__ */ new Vector3();
class Frustum {
  constructor(e = new Plane(), n = new Plane(), a = new Plane(), s = new Plane(), o = new Plane(), l = new Plane()) {
    this.planes = [e, n, a, s, o, l];
  }
  set(e, n, a, s, o, l) {
    const c = this.planes;
    return c[0].copy(e), c[1].copy(n), c[2].copy(a), c[3].copy(s), c[4].copy(o), c[5].copy(l), this;
  }
  copy(e) {
    const n = this.planes;
    for (let a = 0; a < 6; a++)
      n[a].copy(e.planes[a]);
    return this;
  }
  setFromProjectionMatrix(e, n = WebGLCoordinateSystem) {
    const a = this.planes, s = e.elements, o = s[0], l = s[1], c = s[2], u = s[3], d = s[4], f = s[5], h = s[6], g = s[7], x = s[8], E = s[9], m = s[10], v = s[11], y = s[12], A = s[13], b = s[14], C = s[15];
    if (a[0].setComponents(u - o, g - d, v - x, C - y).normalize(), a[1].setComponents(u + o, g + d, v + x, C + y).normalize(), a[2].setComponents(u + l, g + f, v + E, C + A).normalize(), a[3].setComponents(u - l, g - f, v - E, C - A).normalize(), a[4].setComponents(u - c, g - h, v - m, C - b).normalize(), n === WebGLCoordinateSystem)
      a[5].setComponents(u + c, g + h, v + m, C + b).normalize();
    else if (n === WebGPUCoordinateSystem)
      a[5].setComponents(c, h, m, b).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + n);
    return this;
  }
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), _sphere$4.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const n = e.geometry;
      n.boundingSphere === null && n.computeBoundingSphere(), _sphere$4.copy(n.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(_sphere$4);
  }
  intersectsSprite(e) {
    return _sphere$4.center.set(0, 0, 0), _sphere$4.radius = 0.7071067811865476, _sphere$4.applyMatrix4(e.matrixWorld), this.intersectsSphere(_sphere$4);
  }
  intersectsSphere(e) {
    const n = this.planes, a = e.center, s = -e.radius;
    for (let o = 0; o < 6; o++)
      if (n[o].distanceToPoint(a) < s)
        return !1;
    return !0;
  }
  intersectsBox(e) {
    const n = this.planes;
    for (let a = 0; a < 6; a++) {
      const s = n[a];
      if (_vector$6.x = s.normal.x > 0 ? e.max.x : e.min.x, _vector$6.y = s.normal.y > 0 ? e.max.y : e.min.y, _vector$6.z = s.normal.z > 0 ? e.max.z : e.min.z, s.distanceToPoint(_vector$6) < 0)
        return !1;
    }
    return !0;
  }
  containsPoint(e) {
    const n = this.planes;
    for (let a = 0; a < 6; a++)
      if (n[a].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function WebGLAnimation() {
  let t = null, e = !1, n = null, a = null;
  function s(o, l) {
    n(o, l), a = t.requestAnimationFrame(s);
  }
  return {
    start: function() {
      e !== !0 && n !== null && (a = t.requestAnimationFrame(s), e = !0);
    },
    stop: function() {
      t.cancelAnimationFrame(a), e = !1;
    },
    setAnimationLoop: function(o) {
      n = o;
    },
    setContext: function(o) {
      t = o;
    }
  };
}
function WebGLAttributes(t, e) {
  const n = e.isWebGL2, a = /* @__PURE__ */ new WeakMap();
  function s(d, f) {
    const h = d.array, g = d.usage, x = t.createBuffer();
    t.bindBuffer(f, x), t.bufferData(f, h, g), d.onUploadCallback();
    let E;
    if (h instanceof Float32Array)
      E = t.FLOAT;
    else if (h instanceof Uint16Array)
      if (d.isFloat16BufferAttribute)
        if (n)
          E = t.HALF_FLOAT;
        else
          throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
      else
        E = t.UNSIGNED_SHORT;
    else if (h instanceof Int16Array)
      E = t.SHORT;
    else if (h instanceof Uint32Array)
      E = t.UNSIGNED_INT;
    else if (h instanceof Int32Array)
      E = t.INT;
    else if (h instanceof Int8Array)
      E = t.BYTE;
    else if (h instanceof Uint8Array)
      E = t.UNSIGNED_BYTE;
    else if (h instanceof Uint8ClampedArray)
      E = t.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
    return {
      buffer: x,
      type: E,
      bytesPerElement: h.BYTES_PER_ELEMENT,
      version: d.version
    };
  }
  function o(d, f, h) {
    const g = f.array, x = f.updateRange;
    t.bindBuffer(h, d), x.count === -1 ? t.bufferSubData(h, 0, g) : (n ? t.bufferSubData(
      h,
      x.offset * g.BYTES_PER_ELEMENT,
      g,
      x.offset,
      x.count
    ) : t.bufferSubData(
      h,
      x.offset * g.BYTES_PER_ELEMENT,
      g.subarray(x.offset, x.offset + x.count)
    ), x.count = -1), f.onUploadCallback();
  }
  function l(d) {
    return d.isInterleavedBufferAttribute && (d = d.data), a.get(d);
  }
  function c(d) {
    d.isInterleavedBufferAttribute && (d = d.data);
    const f = a.get(d);
    f && (t.deleteBuffer(f.buffer), a.delete(d));
  }
  function u(d, f) {
    if (d.isGLBufferAttribute) {
      const g = a.get(d);
      (!g || g.version < d.version) && a.set(d, {
        buffer: d.buffer,
        type: d.type,
        bytesPerElement: d.elementSize,
        version: d.version
      });
      return;
    }
    d.isInterleavedBufferAttribute && (d = d.data);
    const h = a.get(d);
    h === void 0 ? a.set(d, s(d, f)) : h.version < d.version && (o(h.buffer, d, f), h.version = d.version);
  }
  return {
    get: l,
    remove: c,
    update: u
  };
}
class PlaneGeometry extends BufferGeometry {
  constructor(e = 1, n = 1, a = 1, s = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: n,
      widthSegments: a,
      heightSegments: s
    };
    const o = e / 2, l = n / 2, c = Math.floor(a), u = Math.floor(s), d = c + 1, f = u + 1, h = e / c, g = n / u, x = [], E = [], m = [], v = [];
    for (let y = 0; y < f; y++) {
      const A = y * g - l;
      for (let b = 0; b < d; b++) {
        const C = b * h - o;
        E.push(C, -A, 0), m.push(0, 0, 1), v.push(b / c), v.push(1 - y / u);
      }
    }
    for (let y = 0; y < u; y++)
      for (let A = 0; A < c; A++) {
        const b = A + d * y, C = A + d * (y + 1), T = A + 1 + d * (y + 1), w = A + 1 + d * y;
        x.push(b, C, w), x.push(C, T, w);
      }
    this.setIndex(x), this.setAttribute("position", new Float32BufferAttribute(E, 3)), this.setAttribute("normal", new Float32BufferAttribute(m, 3)), this.setAttribute("uv", new Float32BufferAttribute(v, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new PlaneGeometry(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
var alphahash_fragment = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, alphahash_pars_fragment = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, alphamap_fragment = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, alphamap_pars_fragment = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, alphatest_fragment = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, alphatest_pars_fragment = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, aomap_fragment = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, aomap_pars_fragment = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, begin_vertex = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, beginnormal_vertex = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, bsdfs = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, iridescence_fragment = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, bumpmap_pars_fragment = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, clipping_planes_fragment = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, clipping_planes_pars_fragment = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, clipping_planes_pars_vertex = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, clipping_planes_vertex = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, color_fragment = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, color_pars_fragment = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, color_pars_vertex = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, color_vertex = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, common = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, cube_uv_reflection_fragment = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, defaultnormal_vertex = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, displacementmap_pars_vertex = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, displacementmap_vertex = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, emissivemap_fragment = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, emissivemap_pars_fragment = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );", colorspace_pars_fragment = `
const mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(
	vec3( 0.8224621, 0.177538, 0.0 ),
	vec3( 0.0331941, 0.9668058, 0.0 ),
	vec3( 0.0170827, 0.0723974, 0.9105199 )
);
const mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(
	vec3( 1.2249401, - 0.2249404, 0.0 ),
	vec3( - 0.0420569, 1.0420571, 0.0 ),
	vec3( - 0.0196376, - 0.0786361, 1.0982735 )
);
vec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {
	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );
}
vec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {
	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );
}
vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}
vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return sRGBTransferOETF( value );
}`, envmap_fragment = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, envmap_common_pars_fragment = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, envmap_pars_fragment = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, envmap_pars_vertex = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, envmap_vertex = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, fog_vertex = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, fog_pars_vertex = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, fog_fragment = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, fog_pars_fragment = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, gradientmap_pars_fragment = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, lightmap_fragment = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, lightmap_pars_fragment = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, lights_lambert_fragment = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, lights_lambert_pars_fragment = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, lights_pars_begin = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( LEGACY_LIGHTS )
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#else
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, envmap_physical_pars_fragment = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, lights_toon_fragment = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, lights_toon_pars_fragment = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, lights_phong_fragment = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, lights_phong_pars_fragment = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, lights_physical_fragment = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	anisotropyV /= material.anisotropy;
	material.anisotropy = saturate( material.anisotropy );
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;
#endif`, lights_physical_pars_fragment = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, lights_fragment_begin = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, lights_fragment_maps = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, lights_fragment_end = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, logdepthbuf_fragment = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, logdepthbuf_pars_fragment = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, logdepthbuf_pars_vertex = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, logdepthbuf_vertex = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, map_fragment = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, map_pars_fragment = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, map_particle_fragment = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, map_particle_pars_fragment = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, metalnessmap_fragment = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, metalnessmap_pars_fragment = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, morphcolor_vertex = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, morphnormal_vertex = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, morphtarget_pars_vertex = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, morphtarget_vertex = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, normal_fragment_begin = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, normal_fragment_maps = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, normal_pars_fragment = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, normal_pars_vertex = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, normal_vertex = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, normalmap_pars_fragment = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, clearcoat_normal_fragment_begin = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, clearcoat_normal_fragment_maps = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, clearcoat_pars_fragment = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, iridescence_pars_fragment = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, opaque_fragment = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, packing = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, premultiplied_alpha_fragment = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, project_vertex = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, dithering_fragment = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, dithering_pars_fragment = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, roughnessmap_fragment = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, roughnessmap_pars_fragment = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, shadowmap_pars_fragment = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, shadowmap_pars_vertex = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, shadowmap_vertex = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, shadowmask_pars_fragment = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, skinbase_vertex = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, skinning_pars_vertex = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, skinning_vertex = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, skinnormal_vertex = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, specularmap_fragment = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, specularmap_pars_fragment = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, tonemapping_fragment = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, tonemapping_pars_fragment = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, transmission_fragment = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, transmission_pars_fragment = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, uv_pars_fragment = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, uv_pars_vertex = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, uv_vertex = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, worldpos_vertex = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const vertex$h = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, fragment$h = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$g = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, fragment$g = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$f = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, fragment$f = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$e = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, fragment$e = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, vertex$d = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, fragment$d = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, vertex$c = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, fragment$c = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$b = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, fragment$b = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, vertex$a = `#include <common>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, fragment$a = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$9 = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$9 = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$8 = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, fragment$8 = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$7 = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, fragment$7 = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, vertex$6 = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$6 = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$5 = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, fragment$5 = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$4 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$4 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$3 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, fragment$3 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, vertex$2 = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$2 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, vertex$1 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, fragment$1 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, ShaderChunk = {
  alphahash_fragment,
  alphahash_pars_fragment,
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  alphatest_pars_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  iridescence_fragment,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  colorspace_fragment,
  colorspace_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_fragment,
  lightmap_pars_fragment,
  lights_lambert_fragment,
  lights_lambert_pars_fragment,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphcolor_vertex,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normal_pars_fragment,
  normal_pars_vertex,
  normal_vertex,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  iridescence_pars_fragment,
  opaque_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  worldpos_vertex,
  background_vert: vertex$h,
  background_frag: fragment$h,
  backgroundCube_vert: vertex$g,
  backgroundCube_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
}, UniformsLib = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    normalScale: { value: /* @__PURE__ */ new Vector2(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Color(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Vector2(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 }
  }
}, ShaderLib = {
  basic: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        specular: { value: /* @__PURE__ */ new Color(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
        // temporary
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Matrix3() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk.backgroundCube_vert,
    fragmentShader: ShaderChunk.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new Vector3() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: /* @__PURE__ */ new Color(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: /* @__PURE__ */ mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Color(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Color(0) },
      specularColor: { value: /* @__PURE__ */ new Color(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      anisotropyVector: { value: /* @__PURE__ */ new Vector2() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
const _rgb = { r: 0, b: 0, g: 0 };
function WebGLBackground(t, e, n, a, s, o, l) {
  const c = new Color(0);
  let u = o === !0 ? 0 : 1, d, f, h = null, g = 0, x = null;
  function E(v, y) {
    let A = !1, b = y.isScene === !0 ? y.background : null;
    b && b.isTexture && (b = (y.backgroundBlurriness > 0 ? n : e).get(b)), b === null ? m(c, u) : b && b.isColor && (m(b, 1), A = !0);
    const C = t.xr.getEnvironmentBlendMode();
    C === "additive" ? a.buffers.color.setClear(0, 0, 0, 1, l) : C === "alpha-blend" && a.buffers.color.setClear(0, 0, 0, 0, l), (t.autoClear || A) && t.clear(t.autoClearColor, t.autoClearDepth, t.autoClearStencil), b && (b.isCubeTexture || b.mapping === CubeUVReflectionMapping) ? (f === void 0 && (f = new Mesh(
      new BoxGeometry(1, 1, 1),
      new ShaderMaterial({
        name: "BackgroundCubeMaterial",
        uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
        vertexShader: ShaderLib.backgroundCube.vertexShader,
        fragmentShader: ShaderLib.backgroundCube.fragmentShader,
        side: BackSide,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), f.geometry.deleteAttribute("normal"), f.geometry.deleteAttribute("uv"), f.onBeforeRender = function(T, w, R) {
      this.matrixWorld.copyPosition(R.matrixWorld);
    }, Object.defineProperty(f.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), s.update(f)), f.material.uniforms.envMap.value = b, f.material.uniforms.flipEnvMap.value = b.isCubeTexture && b.isRenderTargetTexture === !1 ? -1 : 1, f.material.uniforms.backgroundBlurriness.value = y.backgroundBlurriness, f.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, f.material.toneMapped = ColorManagement.getTransfer(b.colorSpace) !== SRGBTransfer, (h !== b || g !== b.version || x !== t.toneMapping) && (f.material.needsUpdate = !0, h = b, g = b.version, x = t.toneMapping), f.layers.enableAll(), v.unshift(f, f.geometry, f.material, 0, 0, null)) : b && b.isTexture && (d === void 0 && (d = new Mesh(
      new PlaneGeometry(2, 2),
      new ShaderMaterial({
        name: "BackgroundMaterial",
        uniforms: cloneUniforms(ShaderLib.background.uniforms),
        vertexShader: ShaderLib.background.vertexShader,
        fragmentShader: ShaderLib.background.fragmentShader,
        side: FrontSide,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), d.geometry.deleteAttribute("normal"), Object.defineProperty(d.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), s.update(d)), d.material.uniforms.t2D.value = b, d.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, d.material.toneMapped = ColorManagement.getTransfer(b.colorSpace) !== SRGBTransfer, b.matrixAutoUpdate === !0 && b.updateMatrix(), d.material.uniforms.uvTransform.value.copy(b.matrix), (h !== b || g !== b.version || x !== t.toneMapping) && (d.material.needsUpdate = !0, h = b, g = b.version, x = t.toneMapping), d.layers.enableAll(), v.unshift(d, d.geometry, d.material, 0, 0, null));
  }
  function m(v, y) {
    v.getRGB(_rgb, getUnlitUniformColorSpace(t)), a.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, y, l);
  }
  return {
    getClearColor: function() {
      return c;
    },
    setClearColor: function(v, y = 1) {
      c.set(v), u = y, m(c, u);
    },
    getClearAlpha: function() {
      return u;
    },
    setClearAlpha: function(v) {
      u = v, m(c, u);
    },
    render: E
  };
}
function WebGLBindingStates(t, e, n, a) {
  const s = t.getParameter(t.MAX_VERTEX_ATTRIBS), o = a.isWebGL2 ? null : e.get("OES_vertex_array_object"), l = a.isWebGL2 || o !== null, c = {}, u = v(null);
  let d = u, f = !1;
  function h(P, Q, Y, ie, te) {
    let Z = !1;
    if (l) {
      const ae = m(ie, Y, Q);
      d !== ae && (d = ae, x(d.object)), Z = y(P, ie, Y, te), Z && A(P, ie, Y, te);
    } else {
      const ae = Q.wireframe === !0;
      (d.geometry !== ie.id || d.program !== Y.id || d.wireframe !== ae) && (d.geometry = ie.id, d.program = Y.id, d.wireframe = ae, Z = !0);
    }
    te !== null && n.update(te, t.ELEMENT_ARRAY_BUFFER), (Z || f) && (f = !1, O(P, Q, Y, ie), te !== null && t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, n.get(te).buffer));
  }
  function g() {
    return a.isWebGL2 ? t.createVertexArray() : o.createVertexArrayOES();
  }
  function x(P) {
    return a.isWebGL2 ? t.bindVertexArray(P) : o.bindVertexArrayOES(P);
  }
  function E(P) {
    return a.isWebGL2 ? t.deleteVertexArray(P) : o.deleteVertexArrayOES(P);
  }
  function m(P, Q, Y) {
    const ie = Y.wireframe === !0;
    let te = c[P.id];
    te === void 0 && (te = {}, c[P.id] = te);
    let Z = te[Q.id];
    Z === void 0 && (Z = {}, te[Q.id] = Z);
    let ae = Z[ie];
    return ae === void 0 && (ae = v(g()), Z[ie] = ae), ae;
  }
  function v(P) {
    const Q = [], Y = [], ie = [];
    for (let te = 0; te < s; te++)
      Q[te] = 0, Y[te] = 0, ie[te] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: Q,
      enabledAttributes: Y,
      attributeDivisors: ie,
      object: P,
      attributes: {},
      index: null
    };
  }
  function y(P, Q, Y, ie) {
    const te = d.attributes, Z = Q.attributes;
    let ae = 0;
    const G = Y.getAttributes();
    for (const U in G)
      if (G[U].location >= 0) {
        const M = te[U];
        let I = Z[U];
        if (I === void 0 && (U === "instanceMatrix" && P.instanceMatrix && (I = P.instanceMatrix), U === "instanceColor" && P.instanceColor && (I = P.instanceColor)), M === void 0 || M.attribute !== I || I && M.data !== I.data)
          return !0;
        ae++;
      }
    return d.attributesNum !== ae || d.index !== ie;
  }
  function A(P, Q, Y, ie) {
    const te = {}, Z = Q.attributes;
    let ae = 0;
    const G = Y.getAttributes();
    for (const U in G)
      if (G[U].location >= 0) {
        let M = Z[U];
        M === void 0 && (U === "instanceMatrix" && P.instanceMatrix && (M = P.instanceMatrix), U === "instanceColor" && P.instanceColor && (M = P.instanceColor));
        const I = {};
        I.attribute = M, M && M.data && (I.data = M.data), te[U] = I, ae++;
      }
    d.attributes = te, d.attributesNum = ae, d.index = ie;
  }
  function b() {
    const P = d.newAttributes;
    for (let Q = 0, Y = P.length; Q < Y; Q++)
      P[Q] = 0;
  }
  function C(P) {
    T(P, 0);
  }
  function T(P, Q) {
    const Y = d.newAttributes, ie = d.enabledAttributes, te = d.attributeDivisors;
    Y[P] = 1, ie[P] === 0 && (t.enableVertexAttribArray(P), ie[P] = 1), te[P] !== Q && ((a.isWebGL2 ? t : e.get("ANGLE_instanced_arrays"))[a.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](P, Q), te[P] = Q);
  }
  function w() {
    const P = d.newAttributes, Q = d.enabledAttributes;
    for (let Y = 0, ie = Q.length; Y < ie; Y++)
      Q[Y] !== P[Y] && (t.disableVertexAttribArray(Y), Q[Y] = 0);
  }
  function R(P, Q, Y, ie, te, Z, ae) {
    ae === !0 ? t.vertexAttribIPointer(P, Q, Y, te, Z) : t.vertexAttribPointer(P, Q, Y, ie, te, Z);
  }
  function O(P, Q, Y, ie) {
    if (a.isWebGL2 === !1 && (P.isInstancedMesh || ie.isInstancedBufferGeometry) && e.get("ANGLE_instanced_arrays") === null)
      return;
    b();
    const te = ie.attributes, Z = Y.getAttributes(), ae = Q.defaultAttributeValues;
    for (const G in Z) {
      const U = Z[G];
      if (U.location >= 0) {
        let F = te[G];
        if (F === void 0 && (G === "instanceMatrix" && P.instanceMatrix && (F = P.instanceMatrix), G === "instanceColor" && P.instanceColor && (F = P.instanceColor)), F !== void 0) {
          const M = F.normalized, I = F.itemSize, N = n.get(F);
          if (N === void 0)
            continue;
          const V = N.buffer, q = N.type, H = N.bytesPerElement, ne = a.isWebGL2 === !0 && (q === t.INT || q === t.UNSIGNED_INT || F.gpuType === IntType);
          if (F.isInterleavedBufferAttribute) {
            const he = F.data, j = he.stride, Fe = F.offset;
            if (he.isInstancedInterleavedBuffer) {
              for (let X = 0; X < U.locationSize; X++)
                T(U.location + X, he.meshPerAttribute);
              P.isInstancedMesh !== !0 && ie._maxInstanceCount === void 0 && (ie._maxInstanceCount = he.meshPerAttribute * he.count);
            } else
              for (let X = 0; X < U.locationSize; X++)
                C(U.location + X);
            t.bindBuffer(t.ARRAY_BUFFER, V);
            for (let X = 0; X < U.locationSize; X++)
              R(
                U.location + X,
                I / U.locationSize,
                q,
                M,
                j * H,
                (Fe + I / U.locationSize * X) * H,
                ne
              );
          } else {
            if (F.isInstancedBufferAttribute) {
              for (let he = 0; he < U.locationSize; he++)
                T(U.location + he, F.meshPerAttribute);
              P.isInstancedMesh !== !0 && ie._maxInstanceCount === void 0 && (ie._maxInstanceCount = F.meshPerAttribute * F.count);
            } else
              for (let he = 0; he < U.locationSize; he++)
                C(U.location + he);
            t.bindBuffer(t.ARRAY_BUFFER, V);
            for (let he = 0; he < U.locationSize; he++)
              R(
                U.location + he,
                I / U.locationSize,
                q,
                M,
                I * H,
                I / U.locationSize * he * H,
                ne
              );
          }
        } else if (ae !== void 0) {
          const M = ae[G];
          if (M !== void 0)
            switch (M.length) {
              case 2:
                t.vertexAttrib2fv(U.location, M);
                break;
              case 3:
                t.vertexAttrib3fv(U.location, M);
                break;
              case 4:
                t.vertexAttrib4fv(U.location, M);
                break;
              default:
                t.vertexAttrib1fv(U.location, M);
            }
        }
      }
    }
    w();
  }
  function D() {
    L();
    for (const P in c) {
      const Q = c[P];
      for (const Y in Q) {
        const ie = Q[Y];
        for (const te in ie)
          E(ie[te].object), delete ie[te];
        delete Q[Y];
      }
      delete c[P];
    }
  }
  function k(P) {
    if (c[P.id] === void 0)
      return;
    const Q = c[P.id];
    for (const Y in Q) {
      const ie = Q[Y];
      for (const te in ie)
        E(ie[te].object), delete ie[te];
      delete Q[Y];
    }
    delete c[P.id];
  }
  function W(P) {
    for (const Q in c) {
      const Y = c[Q];
      if (Y[P.id] === void 0)
        continue;
      const ie = Y[P.id];
      for (const te in ie)
        E(ie[te].object), delete ie[te];
      delete Y[P.id];
    }
  }
  function L() {
    z(), f = !0, d !== u && (d = u, x(d.object));
  }
  function z() {
    u.geometry = null, u.program = null, u.wireframe = !1;
  }
  return {
    setup: h,
    reset: L,
    resetDefaultState: z,
    dispose: D,
    releaseStatesOfGeometry: k,
    releaseStatesOfProgram: W,
    initAttributes: b,
    enableAttribute: C,
    disableUnusedAttributes: w
  };
}
function WebGLBufferRenderer(t, e, n, a) {
  const s = a.isWebGL2;
  let o;
  function l(d) {
    o = d;
  }
  function c(d, f) {
    t.drawArrays(o, d, f), n.update(f, o, 1);
  }
  function u(d, f, h) {
    if (h === 0)
      return;
    let g, x;
    if (s)
      g = t, x = "drawArraysInstanced";
    else if (g = e.get("ANGLE_instanced_arrays"), x = "drawArraysInstancedANGLE", g === null) {
      console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    g[x](o, d, f, h), n.update(f, o, h);
  }
  this.setMode = l, this.render = c, this.renderInstances = u;
}
function WebGLCapabilities(t, e, n) {
  let a;
  function s() {
    if (a !== void 0)
      return a;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const R = e.get("EXT_texture_filter_anisotropic");
      a = t.getParameter(R.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      a = 0;
    return a;
  }
  function o(R) {
    if (R === "highp") {
      if (t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.HIGH_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.HIGH_FLOAT).precision > 0)
        return "highp";
      R = "mediump";
    }
    return R === "mediump" && t.getShaderPrecisionFormat(t.VERTEX_SHADER, t.MEDIUM_FLOAT).precision > 0 && t.getShaderPrecisionFormat(t.FRAGMENT_SHADER, t.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  const l = typeof WebGL2RenderingContext < "u" && t.constructor.name === "WebGL2RenderingContext";
  let c = n.precision !== void 0 ? n.precision : "highp";
  const u = o(c);
  u !== c && (console.warn("THREE.WebGLRenderer:", c, "not supported, using", u, "instead."), c = u);
  const d = l || e.has("WEBGL_draw_buffers"), f = n.logarithmicDepthBuffer === !0, h = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS), g = t.getParameter(t.MAX_VERTEX_TEXTURE_IMAGE_UNITS), x = t.getParameter(t.MAX_TEXTURE_SIZE), E = t.getParameter(t.MAX_CUBE_MAP_TEXTURE_SIZE), m = t.getParameter(t.MAX_VERTEX_ATTRIBS), v = t.getParameter(t.MAX_VERTEX_UNIFORM_VECTORS), y = t.getParameter(t.MAX_VARYING_VECTORS), A = t.getParameter(t.MAX_FRAGMENT_UNIFORM_VECTORS), b = g > 0, C = l || e.has("OES_texture_float"), T = b && C, w = l ? t.getParameter(t.MAX_SAMPLES) : 0;
  return {
    isWebGL2: l,
    drawBuffers: d,
    getMaxAnisotropy: s,
    getMaxPrecision: o,
    precision: c,
    logarithmicDepthBuffer: f,
    maxTextures: h,
    maxVertexTextures: g,
    maxTextureSize: x,
    maxCubemapSize: E,
    maxAttributes: m,
    maxVertexUniforms: v,
    maxVaryings: y,
    maxFragmentUniforms: A,
    vertexTextures: b,
    floatFragmentTextures: C,
    floatVertexTextures: T,
    maxSamples: w
  };
}
function WebGLClipping(t) {
  const e = this;
  let n = null, a = 0, s = !1, o = !1;
  const l = new Plane(), c = new Matrix3(), u = { value: null, needsUpdate: !1 };
  this.uniform = u, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, g) {
    const x = h.length !== 0 || g || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    a !== 0 || s;
    return s = g, a = h.length, x;
  }, this.beginShadows = function() {
    o = !0, f(null);
  }, this.endShadows = function() {
    o = !1;
  }, this.setGlobalState = function(h, g) {
    n = f(h, g, 0);
  }, this.setState = function(h, g, x) {
    const E = h.clippingPlanes, m = h.clipIntersection, v = h.clipShadows, y = t.get(h);
    if (!s || E === null || E.length === 0 || o && !v)
      o ? f(null) : d();
    else {
      const A = o ? 0 : a, b = A * 4;
      let C = y.clippingState || null;
      u.value = C, C = f(E, g, b, x);
      for (let T = 0; T !== b; ++T)
        C[T] = n[T];
      y.clippingState = C, this.numIntersection = m ? this.numPlanes : 0, this.numPlanes += A;
    }
  };
  function d() {
    u.value !== n && (u.value = n, u.needsUpdate = a > 0), e.numPlanes = a, e.numIntersection = 0;
  }
  function f(h, g, x, E) {
    const m = h !== null ? h.length : 0;
    let v = null;
    if (m !== 0) {
      if (v = u.value, E !== !0 || v === null) {
        const y = x + m * 4, A = g.matrixWorldInverse;
        c.getNormalMatrix(A), (v === null || v.length < y) && (v = new Float32Array(y));
        for (let b = 0, C = x; b !== m; ++b, C += 4)
          l.copy(h[b]).applyMatrix4(A, c), l.normal.toArray(v, C), v[C + 3] = l.constant;
      }
      u.value = v, u.needsUpdate = !0;
    }
    return e.numPlanes = m, e.numIntersection = 0, v;
  }
}
function WebGLCubeMaps(t) {
  let e = /* @__PURE__ */ new WeakMap();
  function n(l, c) {
    return c === EquirectangularReflectionMapping ? l.mapping = CubeReflectionMapping : c === EquirectangularRefractionMapping && (l.mapping = CubeRefractionMapping), l;
  }
  function a(l) {
    if (l && l.isTexture && l.isRenderTargetTexture === !1) {
      const c = l.mapping;
      if (c === EquirectangularReflectionMapping || c === EquirectangularRefractionMapping)
        if (e.has(l)) {
          const u = e.get(l).texture;
          return n(u, l.mapping);
        } else {
          const u = l.image;
          if (u && u.height > 0) {
            const d = new WebGLCubeRenderTarget(u.height / 2);
            return d.fromEquirectangularTexture(t, l), e.set(l, d), l.addEventListener("dispose", s), n(d.texture, l.mapping);
          } else
            return null;
        }
    }
    return l;
  }
  function s(l) {
    const c = l.target;
    c.removeEventListener("dispose", s);
    const u = e.get(c);
    u !== void 0 && (e.delete(c), u.dispose());
  }
  function o() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: a,
    dispose: o
  };
}
class OrthographicCamera extends Camera {
  constructor(e = -1, n = 1, a = 1, s = -1, o = 0.1, l = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = n, this.top = a, this.bottom = s, this.near = o, this.far = l, this.updateProjectionMatrix();
  }
  copy(e, n) {
    return super.copy(e, n), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  setViewOffset(e, n, a, s, o, l) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = n, this.view.offsetX = a, this.view.offsetY = s, this.view.width = o, this.view.height = l, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), n = (this.top - this.bottom) / (2 * this.zoom), a = (this.right + this.left) / 2, s = (this.top + this.bottom) / 2;
    let o = a - e, l = a + e, c = s + n, u = s - n;
    if (this.view !== null && this.view.enabled) {
      const d = (this.right - this.left) / this.view.fullWidth / this.zoom, f = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      o += d * this.view.offsetX, l = o + d * this.view.width, c -= f * this.view.offsetY, u = c - f * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(o, l, c, u, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return n.object.zoom = this.zoom, n.object.left = this.left, n.object.right = this.right, n.object.top = this.top, n.object.bottom = this.bottom, n.object.near = this.near, n.object.far = this.far, this.view !== null && (n.object.view = Object.assign({}, this.view)), n;
  }
}
const LOD_MIN = 4, EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], MAX_SAMPLES = 20, _flatCamera = /* @__PURE__ */ new OrthographicCamera(), _clearColor = /* @__PURE__ */ new Color();
let _oldTarget = null, _oldActiveCubeFace = 0, _oldActiveMipmapLevel = 0;
const PHI = (1 + Math.sqrt(5)) / 2, INV_PHI = 1 / PHI, _axisDirections = [
  /* @__PURE__ */ new Vector3(1, 1, 1),
  /* @__PURE__ */ new Vector3(-1, 1, 1),
  /* @__PURE__ */ new Vector3(1, 1, -1),
  /* @__PURE__ */ new Vector3(-1, 1, -1),
  /* @__PURE__ */ new Vector3(0, PHI, INV_PHI),
  /* @__PURE__ */ new Vector3(0, PHI, -INV_PHI),
  /* @__PURE__ */ new Vector3(INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3(-INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3(PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector3(-PHI, INV_PHI, 0)
];
class PMREMGenerator {
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(e, n = 0, a = 0.1, s = 100) {
    _oldTarget = this._renderer.getRenderTarget(), _oldActiveCubeFace = this._renderer.getActiveCubeFace(), _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel(), this._setSize(256);
    const o = this._allocateTargets();
    return o.depthBuffer = !0, this._sceneToCubeUV(e, a, s, o), n > 0 && this._blur(o, 0, 0, n), this._applyPMREM(o), this._cleanup(o), o;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromEquirectangular(e, n = null) {
    return this._fromTexture(e, n);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromCubemap(e, n = null) {
    return this._fromTexture(e, n);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = _getCubemapMaterial(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = _getEquirectMaterial(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(_oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel), e.scissorTest = !1, _setViewport(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, n) {
    e.mapping === CubeReflectionMapping || e.mapping === CubeRefractionMapping ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), _oldTarget = this._renderer.getRenderTarget(), _oldActiveCubeFace = this._renderer.getActiveCubeFace(), _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
    const a = n || this._allocateTargets();
    return this._textureToCubeUV(e, a), this._applyPMREM(a), this._cleanup(a), a;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), n = 4 * this._cubeSize, a = {
      magFilter: LinearFilter,
      minFilter: LinearFilter,
      generateMipmaps: !1,
      type: HalfFloatType,
      format: RGBAFormat,
      colorSpace: LinearSRGBColorSpace,
      depthBuffer: !1
    }, s = _createRenderTarget(e, n, a);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== n) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = _createRenderTarget(e, n, a);
      const { _lodMax: o } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(o)), this._blurMaterial = _getBlurShader(o, e, n);
    }
    return s;
  }
  _compileMaterial(e) {
    const n = new Mesh(this._lodPlanes[0], e);
    this._renderer.compile(n, _flatCamera);
  }
  _sceneToCubeUV(e, n, a, s) {
    const c = new PerspectiveCamera(90, 1, n, a), u = [1, -1, 1, 1, 1, 1], d = [1, 1, 1, -1, -1, -1], f = this._renderer, h = f.autoClear, g = f.toneMapping;
    f.getClearColor(_clearColor), f.toneMapping = NoToneMapping, f.autoClear = !1;
    const x = new MeshBasicMaterial({
      name: "PMREM.Background",
      side: BackSide,
      depthWrite: !1,
      depthTest: !1
    }), E = new Mesh(new BoxGeometry(), x);
    let m = !1;
    const v = e.background;
    v ? v.isColor && (x.color.copy(v), e.background = null, m = !0) : (x.color.copy(_clearColor), m = !0);
    for (let y = 0; y < 6; y++) {
      const A = y % 3;
      A === 0 ? (c.up.set(0, u[y], 0), c.lookAt(d[y], 0, 0)) : A === 1 ? (c.up.set(0, 0, u[y]), c.lookAt(0, d[y], 0)) : (c.up.set(0, u[y], 0), c.lookAt(0, 0, d[y]));
      const b = this._cubeSize;
      _setViewport(s, A * b, y > 2 ? b : 0, b, b), f.setRenderTarget(s), m && f.render(E, c), f.render(e, c);
    }
    E.geometry.dispose(), E.material.dispose(), f.toneMapping = g, f.autoClear = h, e.background = v;
  }
  _textureToCubeUV(e, n) {
    const a = this._renderer, s = e.mapping === CubeReflectionMapping || e.mapping === CubeRefractionMapping;
    s ? (this._cubemapMaterial === null && (this._cubemapMaterial = _getCubemapMaterial()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = _getEquirectMaterial());
    const o = s ? this._cubemapMaterial : this._equirectMaterial, l = new Mesh(this._lodPlanes[0], o), c = o.uniforms;
    c.envMap.value = e;
    const u = this._cubeSize;
    _setViewport(n, 0, 0, 3 * u, 2 * u), a.setRenderTarget(n), a.render(l, _flatCamera);
  }
  _applyPMREM(e) {
    const n = this._renderer, a = n.autoClear;
    n.autoClear = !1;
    for (let s = 1; s < this._lodPlanes.length; s++) {
      const o = Math.sqrt(this._sigmas[s] * this._sigmas[s] - this._sigmas[s - 1] * this._sigmas[s - 1]), l = _axisDirections[(s - 1) % _axisDirections.length];
      this._blur(e, s - 1, s, o, l);
    }
    n.autoClear = a;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(e, n, a, s, o) {
    const l = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      l,
      n,
      a,
      s,
      "latitudinal",
      o
    ), this._halfBlur(
      l,
      e,
      a,
      a,
      s,
      "longitudinal",
      o
    );
  }
  _halfBlur(e, n, a, s, o, l, c) {
    const u = this._renderer, d = this._blurMaterial;
    l !== "latitudinal" && l !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const f = 3, h = new Mesh(this._lodPlanes[s], d), g = d.uniforms, x = this._sizeLods[a] - 1, E = isFinite(o) ? Math.PI / (2 * x) : 2 * Math.PI / (2 * MAX_SAMPLES - 1), m = o / E, v = isFinite(o) ? 1 + Math.floor(f * m) : MAX_SAMPLES;
    v > MAX_SAMPLES && console.warn(`sigmaRadians, ${o}, is too large and will clip, as it requested ${v} samples when the maximum is set to ${MAX_SAMPLES}`);
    const y = [];
    let A = 0;
    for (let R = 0; R < MAX_SAMPLES; ++R) {
      const O = R / m, D = Math.exp(-O * O / 2);
      y.push(D), R === 0 ? A += D : R < v && (A += 2 * D);
    }
    for (let R = 0; R < y.length; R++)
      y[R] = y[R] / A;
    g.envMap.value = e.texture, g.samples.value = v, g.weights.value = y, g.latitudinal.value = l === "latitudinal", c && (g.poleAxis.value = c);
    const { _lodMax: b } = this;
    g.dTheta.value = E, g.mipInt.value = b - a;
    const C = this._sizeLods[s], T = 3 * C * (s > b - LOD_MIN ? s - b + LOD_MIN : 0), w = 4 * (this._cubeSize - C);
    _setViewport(n, T, w, 3 * C, 2 * C), u.setRenderTarget(n), u.render(h, _flatCamera);
  }
}
function _createPlanes(t) {
  const e = [], n = [], a = [];
  let s = t;
  const o = t - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
  for (let l = 0; l < o; l++) {
    const c = Math.pow(2, s);
    n.push(c);
    let u = 1 / c;
    l > t - LOD_MIN ? u = EXTRA_LOD_SIGMA[l - t + LOD_MIN - 1] : l === 0 && (u = 0), a.push(u);
    const d = 1 / (c - 2), f = -d, h = 1 + d, g = [f, f, h, f, h, h, f, f, h, h, f, h], x = 6, E = 6, m = 3, v = 2, y = 1, A = new Float32Array(m * E * x), b = new Float32Array(v * E * x), C = new Float32Array(y * E * x);
    for (let w = 0; w < x; w++) {
      const R = w % 3 * 2 / 3 - 1, O = w > 2 ? 0 : -1, D = [
        R,
        O,
        0,
        R + 2 / 3,
        O,
        0,
        R + 2 / 3,
        O + 1,
        0,
        R,
        O,
        0,
        R + 2 / 3,
        O + 1,
        0,
        R,
        O + 1,
        0
      ];
      A.set(D, m * E * w), b.set(g, v * E * w);
      const k = [w, w, w, w, w, w];
      C.set(k, y * E * w);
    }
    const T = new BufferGeometry();
    T.setAttribute("position", new BufferAttribute(A, m)), T.setAttribute("uv", new BufferAttribute(b, v)), T.setAttribute("faceIndex", new BufferAttribute(C, y)), e.push(T), s > LOD_MIN && s--;
  }
  return { lodPlanes: e, sizeLods: n, sigmas: a };
}
function _createRenderTarget(t, e, n) {
  const a = new WebGLRenderTarget(t, e, n);
  return a.texture.mapping = CubeUVReflectionMapping, a.texture.name = "PMREM.cubeUv", a.scissorTest = !0, a;
}
function _setViewport(t, e, n, a, s) {
  t.viewport.set(e, n, a, s), t.scissor.set(e, n, a, s);
}
function _getBlurShader(t, e, n) {
  const a = new Float32Array(MAX_SAMPLES), s = new Vector3(0, 1, 0);
  return new ShaderMaterial({
    name: "SphericalGaussianBlur",
    defines: {
      n: MAX_SAMPLES,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / n,
      CUBEUV_MAX_MIP: `${t}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: a },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: s }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps(t) {
  let e = /* @__PURE__ */ new WeakMap(), n = null;
  function a(c) {
    if (c && c.isTexture) {
      const u = c.mapping, d = u === EquirectangularReflectionMapping || u === EquirectangularRefractionMapping, f = u === CubeReflectionMapping || u === CubeRefractionMapping;
      if (d || f)
        if (c.isRenderTargetTexture && c.needsPMREMUpdate === !0) {
          c.needsPMREMUpdate = !1;
          let h = e.get(c);
          return n === null && (n = new PMREMGenerator(t)), h = d ? n.fromEquirectangular(c, h) : n.fromCubemap(c, h), e.set(c, h), h.texture;
        } else {
          if (e.has(c))
            return e.get(c).texture;
          {
            const h = c.image;
            if (d && h && h.height > 0 || f && h && s(h)) {
              n === null && (n = new PMREMGenerator(t));
              const g = d ? n.fromEquirectangular(c) : n.fromCubemap(c);
              return e.set(c, g), c.addEventListener("dispose", o), g.texture;
            } else
              return null;
          }
        }
    }
    return c;
  }
  function s(c) {
    let u = 0;
    const d = 6;
    for (let f = 0; f < d; f++)
      c[f] !== void 0 && u++;
    return u === d;
  }
  function o(c) {
    const u = c.target;
    u.removeEventListener("dispose", o);
    const d = e.get(u);
    d !== void 0 && (e.delete(u), d.dispose());
  }
  function l() {
    e = /* @__PURE__ */ new WeakMap(), n !== null && (n.dispose(), n = null);
  }
  return {
    get: a,
    dispose: l
  };
}
function WebGLExtensions(t) {
  const e = {};
  function n(a) {
    if (e[a] !== void 0)
      return e[a];
    let s;
    switch (a) {
      case "WEBGL_depth_texture":
        s = t.getExtension("WEBGL_depth_texture") || t.getExtension("MOZ_WEBGL_depth_texture") || t.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        s = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        s = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        s = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        s = t.getExtension(a);
    }
    return e[a] = s, s;
  }
  return {
    has: function(a) {
      return n(a) !== null;
    },
    init: function(a) {
      a.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
    },
    get: function(a) {
      const s = n(a);
      return s === null && console.warn("THREE.WebGLRenderer: " + a + " extension not supported."), s;
    }
  };
}
function WebGLGeometries(t, e, n, a) {
  const s = {}, o = /* @__PURE__ */ new WeakMap();
  function l(h) {
    const g = h.target;
    g.index !== null && e.remove(g.index);
    for (const E in g.attributes)
      e.remove(g.attributes[E]);
    for (const E in g.morphAttributes) {
      const m = g.morphAttributes[E];
      for (let v = 0, y = m.length; v < y; v++)
        e.remove(m[v]);
    }
    g.removeEventListener("dispose", l), delete s[g.id];
    const x = o.get(g);
    x && (e.remove(x), o.delete(g)), a.releaseStatesOfGeometry(g), g.isInstancedBufferGeometry === !0 && delete g._maxInstanceCount, n.memory.geometries--;
  }
  function c(h, g) {
    return s[g.id] === !0 || (g.addEventListener("dispose", l), s[g.id] = !0, n.memory.geometries++), g;
  }
  function u(h) {
    const g = h.attributes;
    for (const E in g)
      e.update(g[E], t.ARRAY_BUFFER);
    const x = h.morphAttributes;
    for (const E in x) {
      const m = x[E];
      for (let v = 0, y = m.length; v < y; v++)
        e.update(m[v], t.ARRAY_BUFFER);
    }
  }
  function d(h) {
    const g = [], x = h.index, E = h.attributes.position;
    let m = 0;
    if (x !== null) {
      const A = x.array;
      m = x.version;
      for (let b = 0, C = A.length; b < C; b += 3) {
        const T = A[b + 0], w = A[b + 1], R = A[b + 2];
        g.push(T, w, w, R, R, T);
      }
    } else if (E !== void 0) {
      const A = E.array;
      m = E.version;
      for (let b = 0, C = A.length / 3 - 1; b < C; b += 3) {
        const T = b + 0, w = b + 1, R = b + 2;
        g.push(T, w, w, R, R, T);
      }
    } else
      return;
    const v = new (arrayNeedsUint32(g) ? Uint32BufferAttribute : Uint16BufferAttribute)(g, 1);
    v.version = m;
    const y = o.get(h);
    y && e.remove(y), o.set(h, v);
  }
  function f(h) {
    const g = o.get(h);
    if (g) {
      const x = h.index;
      x !== null && g.version < x.version && d(h);
    } else
      d(h);
    return o.get(h);
  }
  return {
    get: c,
    update: u,
    getWireframeAttribute: f
  };
}
function WebGLIndexedBufferRenderer(t, e, n, a) {
  const s = a.isWebGL2;
  let o;
  function l(g) {
    o = g;
  }
  let c, u;
  function d(g) {
    c = g.type, u = g.bytesPerElement;
  }
  function f(g, x) {
    t.drawElements(o, x, c, g * u), n.update(x, o, 1);
  }
  function h(g, x, E) {
    if (E === 0)
      return;
    let m, v;
    if (s)
      m = t, v = "drawElementsInstanced";
    else if (m = e.get("ANGLE_instanced_arrays"), v = "drawElementsInstancedANGLE", m === null) {
      console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    m[v](o, x, c, g * u, E), n.update(x, o, E);
  }
  this.setMode = l, this.setIndex = d, this.render = f, this.renderInstances = h;
}
function WebGLInfo(t) {
  const e = {
    geometries: 0,
    textures: 0
  }, n = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function a(o, l, c) {
    switch (n.calls++, l) {
      case t.TRIANGLES:
        n.triangles += c * (o / 3);
        break;
      case t.LINES:
        n.lines += c * (o / 2);
        break;
      case t.LINE_STRIP:
        n.lines += c * (o - 1);
        break;
      case t.LINE_LOOP:
        n.lines += c * o;
        break;
      case t.POINTS:
        n.points += c * o;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", l);
        break;
    }
  }
  function s() {
    n.calls = 0, n.triangles = 0, n.points = 0, n.lines = 0;
  }
  return {
    memory: e,
    render: n,
    programs: null,
    autoReset: !0,
    reset: s,
    update: a
  };
}
function numericalSort(t, e) {
  return t[0] - e[0];
}
function absNumericalSort(t, e) {
  return Math.abs(e[1]) - Math.abs(t[1]);
}
function WebGLMorphtargets(t, e, n) {
  const a = {}, s = new Float32Array(8), o = /* @__PURE__ */ new WeakMap(), l = new Vector4(), c = [];
  for (let d = 0; d < 8; d++)
    c[d] = [d, 0];
  function u(d, f, h) {
    const g = d.morphTargetInfluences;
    if (e.isWebGL2 === !0) {
      const x = f.morphAttributes.position || f.morphAttributes.normal || f.morphAttributes.color, E = x !== void 0 ? x.length : 0;
      let m = o.get(f);
      if (m === void 0 || m.count !== E) {
        let P = function() {
          L.dispose(), o.delete(f), f.removeEventListener("dispose", P);
        };
        m !== void 0 && m.texture.dispose();
        const A = f.morphAttributes.position !== void 0, b = f.morphAttributes.normal !== void 0, C = f.morphAttributes.color !== void 0, T = f.morphAttributes.position || [], w = f.morphAttributes.normal || [], R = f.morphAttributes.color || [];
        let O = 0;
        A === !0 && (O = 1), b === !0 && (O = 2), C === !0 && (O = 3);
        let D = f.attributes.position.count * O, k = 1;
        D > e.maxTextureSize && (k = Math.ceil(D / e.maxTextureSize), D = e.maxTextureSize);
        const W = new Float32Array(D * k * 4 * E), L = new DataArrayTexture(W, D, k, E);
        L.type = FloatType, L.needsUpdate = !0;
        const z = O * 4;
        for (let Q = 0; Q < E; Q++) {
          const Y = T[Q], ie = w[Q], te = R[Q], Z = D * k * 4 * Q;
          for (let ae = 0; ae < Y.count; ae++) {
            const G = ae * z;
            A === !0 && (l.fromBufferAttribute(Y, ae), W[Z + G + 0] = l.x, W[Z + G + 1] = l.y, W[Z + G + 2] = l.z, W[Z + G + 3] = 0), b === !0 && (l.fromBufferAttribute(ie, ae), W[Z + G + 4] = l.x, W[Z + G + 5] = l.y, W[Z + G + 6] = l.z, W[Z + G + 7] = 0), C === !0 && (l.fromBufferAttribute(te, ae), W[Z + G + 8] = l.x, W[Z + G + 9] = l.y, W[Z + G + 10] = l.z, W[Z + G + 11] = te.itemSize === 4 ? l.w : 1);
          }
        }
        m = {
          count: E,
          texture: L,
          size: new Vector2(D, k)
        }, o.set(f, m), f.addEventListener("dispose", P);
      }
      let v = 0;
      for (let A = 0; A < g.length; A++)
        v += g[A];
      const y = f.morphTargetsRelative ? 1 : 1 - v;
      h.getUniforms().setValue(t, "morphTargetBaseInfluence", y), h.getUniforms().setValue(t, "morphTargetInfluences", g), h.getUniforms().setValue(t, "morphTargetsTexture", m.texture, n), h.getUniforms().setValue(t, "morphTargetsTextureSize", m.size);
    } else {
      const x = g === void 0 ? 0 : g.length;
      let E = a[f.id];
      if (E === void 0 || E.length !== x) {
        E = [];
        for (let b = 0; b < x; b++)
          E[b] = [b, 0];
        a[f.id] = E;
      }
      for (let b = 0; b < x; b++) {
        const C = E[b];
        C[0] = b, C[1] = g[b];
      }
      E.sort(absNumericalSort);
      for (let b = 0; b < 8; b++)
        b < x && E[b][1] ? (c[b][0] = E[b][0], c[b][1] = E[b][1]) : (c[b][0] = Number.MAX_SAFE_INTEGER, c[b][1] = 0);
      c.sort(numericalSort);
      const m = f.morphAttributes.position, v = f.morphAttributes.normal;
      let y = 0;
      for (let b = 0; b < 8; b++) {
        const C = c[b], T = C[0], w = C[1];
        T !== Number.MAX_SAFE_INTEGER && w ? (m && f.getAttribute("morphTarget" + b) !== m[T] && f.setAttribute("morphTarget" + b, m[T]), v && f.getAttribute("morphNormal" + b) !== v[T] && f.setAttribute("morphNormal" + b, v[T]), s[b] = w, y += w) : (m && f.hasAttribute("morphTarget" + b) === !0 && f.deleteAttribute("morphTarget" + b), v && f.hasAttribute("morphNormal" + b) === !0 && f.deleteAttribute("morphNormal" + b), s[b] = 0);
      }
      const A = f.morphTargetsRelative ? 1 : 1 - y;
      h.getUniforms().setValue(t, "morphTargetBaseInfluence", A), h.getUniforms().setValue(t, "morphTargetInfluences", s);
    }
  }
  return {
    update: u
  };
}
function WebGLObjects(t, e, n, a) {
  let s = /* @__PURE__ */ new WeakMap();
  function o(u) {
    const d = a.render.frame, f = u.geometry, h = e.get(u, f);
    if (s.get(h) !== d && (e.update(h), s.set(h, d)), u.isInstancedMesh && (u.hasEventListener("dispose", c) === !1 && u.addEventListener("dispose", c), s.get(u) !== d && (n.update(u.instanceMatrix, t.ARRAY_BUFFER), u.instanceColor !== null && n.update(u.instanceColor, t.ARRAY_BUFFER), s.set(u, d))), u.isSkinnedMesh) {
      const g = u.skeleton;
      s.get(g) !== d && (g.update(), s.set(g, d));
    }
    return h;
  }
  function l() {
    s = /* @__PURE__ */ new WeakMap();
  }
  function c(u) {
    const d = u.target;
    d.removeEventListener("dispose", c), n.remove(d.instanceMatrix), d.instanceColor !== null && n.remove(d.instanceColor);
  }
  return {
    update: o,
    dispose: l
  };
}
const emptyTexture = /* @__PURE__ */ new Texture(), emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture(), empty3dTexture = /* @__PURE__ */ new Data3DTexture(), emptyCubeTexture = /* @__PURE__ */ new CubeTexture(), arrayCacheF32 = [], arrayCacheI32 = [], mat4array = new Float32Array(16), mat3array = new Float32Array(9), mat2array = new Float32Array(4);
function flatten$2(t, e, n) {
  const a = t[0];
  if (a <= 0 || a > 0)
    return t;
  const s = e * n;
  let o = arrayCacheF32[s];
  if (o === void 0 && (o = new Float32Array(s), arrayCacheF32[s] = o), e !== 0) {
    a.toArray(o, 0);
    for (let l = 1, c = 0; l !== e; ++l)
      c += n, t[l].toArray(o, c);
  }
  return o;
}
function arraysEqual(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0, a = t.length; n < a; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function copyArray(t, e) {
  for (let n = 0, a = e.length; n < a; n++)
    t[n] = e[n];
}
function allocTexUnits(t, e) {
  let n = arrayCacheI32[e];
  n === void 0 && (n = new Int32Array(e), arrayCacheI32[e] = n);
  for (let a = 0; a !== e; ++a)
    n[a] = t.allocateTextureUnit();
  return n;
}
function setValueV1f(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1f(this.addr, e), n[0] = e);
}
function setValueV2f(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2f(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform2fv(this.addr, e), copyArray(n, e);
  }
}
function setValueV3f(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3f(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else if (e.r !== void 0)
    (n[0] !== e.r || n[1] !== e.g || n[2] !== e.b) && (t.uniform3f(this.addr, e.r, e.g, e.b), n[0] = e.r, n[1] = e.g, n[2] = e.b);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform3fv(this.addr, e), copyArray(n, e);
  }
}
function setValueV4f(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4f(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform4fv(this.addr, e), copyArray(n, e);
  }
}
function setValueM2(t, e) {
  const n = this.cache, a = e.elements;
  if (a === void 0) {
    if (arraysEqual(n, e))
      return;
    t.uniformMatrix2fv(this.addr, !1, e), copyArray(n, e);
  } else {
    if (arraysEqual(n, a))
      return;
    mat2array.set(a), t.uniformMatrix2fv(this.addr, !1, mat2array), copyArray(n, a);
  }
}
function setValueM3(t, e) {
  const n = this.cache, a = e.elements;
  if (a === void 0) {
    if (arraysEqual(n, e))
      return;
    t.uniformMatrix3fv(this.addr, !1, e), copyArray(n, e);
  } else {
    if (arraysEqual(n, a))
      return;
    mat3array.set(a), t.uniformMatrix3fv(this.addr, !1, mat3array), copyArray(n, a);
  }
}
function setValueM4(t, e) {
  const n = this.cache, a = e.elements;
  if (a === void 0) {
    if (arraysEqual(n, e))
      return;
    t.uniformMatrix4fv(this.addr, !1, e), copyArray(n, e);
  } else {
    if (arraysEqual(n, a))
      return;
    mat4array.set(a), t.uniformMatrix4fv(this.addr, !1, mat4array), copyArray(n, a);
  }
}
function setValueV1i(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1i(this.addr, e), n[0] = e);
}
function setValueV2i(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2i(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform2iv(this.addr, e), copyArray(n, e);
  }
}
function setValueV3i(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3i(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform3iv(this.addr, e), copyArray(n, e);
  }
}
function setValueV4i(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4i(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform4iv(this.addr, e), copyArray(n, e);
  }
}
function setValueV1ui(t, e) {
  const n = this.cache;
  n[0] !== e && (t.uniform1ui(this.addr, e), n[0] = e);
}
function setValueV2ui(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y) && (t.uniform2ui(this.addr, e.x, e.y), n[0] = e.x, n[1] = e.y);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform2uiv(this.addr, e), copyArray(n, e);
  }
}
function setValueV3ui(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z) && (t.uniform3ui(this.addr, e.x, e.y, e.z), n[0] = e.x, n[1] = e.y, n[2] = e.z);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform3uiv(this.addr, e), copyArray(n, e);
  }
}
function setValueV4ui(t, e) {
  const n = this.cache;
  if (e.x !== void 0)
    (n[0] !== e.x || n[1] !== e.y || n[2] !== e.z || n[3] !== e.w) && (t.uniform4ui(this.addr, e.x, e.y, e.z, e.w), n[0] = e.x, n[1] = e.y, n[2] = e.z, n[3] = e.w);
  else {
    if (arraysEqual(n, e))
      return;
    t.uniform4uiv(this.addr, e), copyArray(n, e);
  }
}
function setValueT1(t, e, n) {
  const a = this.cache, s = n.allocateTextureUnit();
  a[0] !== s && (t.uniform1i(this.addr, s), a[0] = s), n.setTexture2D(e || emptyTexture, s);
}
function setValueT3D1(t, e, n) {
  const a = this.cache, s = n.allocateTextureUnit();
  a[0] !== s && (t.uniform1i(this.addr, s), a[0] = s), n.setTexture3D(e || empty3dTexture, s);
}
function setValueT6(t, e, n) {
  const a = this.cache, s = n.allocateTextureUnit();
  a[0] !== s && (t.uniform1i(this.addr, s), a[0] = s), n.setTextureCube(e || emptyCubeTexture, s);
}
function setValueT2DArray1(t, e, n) {
  const a = this.cache, s = n.allocateTextureUnit();
  a[0] !== s && (t.uniform1i(this.addr, s), a[0] = s), n.setTexture2DArray(e || emptyArrayTexture, s);
}
function getSingularSetter(t) {
  switch (t) {
    case 5126:
      return setValueV1f;
    case 35664:
      return setValueV2f;
    case 35665:
      return setValueV3f;
    case 35666:
      return setValueV4f;
    case 35674:
      return setValueM2;
    case 35675:
      return setValueM3;
    case 35676:
      return setValueM4;
    case 5124:
    case 35670:
      return setValueV1i;
    case 35667:
    case 35671:
      return setValueV2i;
    case 35668:
    case 35672:
      return setValueV3i;
    case 35669:
    case 35673:
      return setValueV4i;
    case 5125:
      return setValueV1ui;
    case 36294:
      return setValueV2ui;
    case 36295:
      return setValueV3ui;
    case 36296:
      return setValueV4ui;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(t, e) {
  t.uniform1fv(this.addr, e);
}
function setValueV2fArray(t, e) {
  const n = flatten$2(e, this.size, 2);
  t.uniform2fv(this.addr, n);
}
function setValueV3fArray(t, e) {
  const n = flatten$2(e, this.size, 3);
  t.uniform3fv(this.addr, n);
}
function setValueV4fArray(t, e) {
  const n = flatten$2(e, this.size, 4);
  t.uniform4fv(this.addr, n);
}
function setValueM2Array(t, e) {
  const n = flatten$2(e, this.size, 4);
  t.uniformMatrix2fv(this.addr, !1, n);
}
function setValueM3Array(t, e) {
  const n = flatten$2(e, this.size, 9);
  t.uniformMatrix3fv(this.addr, !1, n);
}
function setValueM4Array(t, e) {
  const n = flatten$2(e, this.size, 16);
  t.uniformMatrix4fv(this.addr, !1, n);
}
function setValueV1iArray(t, e) {
  t.uniform1iv(this.addr, e);
}
function setValueV2iArray(t, e) {
  t.uniform2iv(this.addr, e);
}
function setValueV3iArray(t, e) {
  t.uniform3iv(this.addr, e);
}
function setValueV4iArray(t, e) {
  t.uniform4iv(this.addr, e);
}
function setValueV1uiArray(t, e) {
  t.uniform1uiv(this.addr, e);
}
function setValueV2uiArray(t, e) {
  t.uniform2uiv(this.addr, e);
}
function setValueV3uiArray(t, e) {
  t.uniform3uiv(this.addr, e);
}
function setValueV4uiArray(t, e) {
  t.uniform4uiv(this.addr, e);
}
function setValueT1Array(t, e, n) {
  const a = this.cache, s = e.length, o = allocTexUnits(n, s);
  arraysEqual(a, o) || (t.uniform1iv(this.addr, o), copyArray(a, o));
  for (let l = 0; l !== s; ++l)
    n.setTexture2D(e[l] || emptyTexture, o[l]);
}
function setValueT3DArray(t, e, n) {
  const a = this.cache, s = e.length, o = allocTexUnits(n, s);
  arraysEqual(a, o) || (t.uniform1iv(this.addr, o), copyArray(a, o));
  for (let l = 0; l !== s; ++l)
    n.setTexture3D(e[l] || empty3dTexture, o[l]);
}
function setValueT6Array(t, e, n) {
  const a = this.cache, s = e.length, o = allocTexUnits(n, s);
  arraysEqual(a, o) || (t.uniform1iv(this.addr, o), copyArray(a, o));
  for (let l = 0; l !== s; ++l)
    n.setTextureCube(e[l] || emptyCubeTexture, o[l]);
}
function setValueT2DArrayArray(t, e, n) {
  const a = this.cache, s = e.length, o = allocTexUnits(n, s);
  arraysEqual(a, o) || (t.uniform1iv(this.addr, o), copyArray(a, o));
  for (let l = 0; l !== s; ++l)
    n.setTexture2DArray(e[l] || emptyArrayTexture, o[l]);
}
function getPureArraySetter(t) {
  switch (t) {
    case 5126:
      return setValueV1fArray;
    case 35664:
      return setValueV2fArray;
    case 35665:
      return setValueV3fArray;
    case 35666:
      return setValueV4fArray;
    case 35674:
      return setValueM2Array;
    case 35675:
      return setValueM3Array;
    case 35676:
      return setValueM4Array;
    case 5124:
    case 35670:
      return setValueV1iArray;
    case 35667:
    case 35671:
      return setValueV2iArray;
    case 35668:
    case 35672:
      return setValueV3iArray;
    case 35669:
    case 35673:
      return setValueV4iArray;
    case 5125:
      return setValueV1uiArray;
    case 36294:
      return setValueV2uiArray;
    case 36295:
      return setValueV3uiArray;
    case 36296:
      return setValueV4uiArray;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3DArray;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArrayArray;
  }
}
class SingleUniform {
  constructor(e, n, a) {
    this.id = e, this.addr = a, this.cache = [], this.setValue = getSingularSetter(n.type);
  }
}
class PureArrayUniform {
  constructor(e, n, a) {
    this.id = e, this.addr = a, this.cache = [], this.size = n.size, this.setValue = getPureArraySetter(n.type);
  }
}
class StructuredUniform {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, n, a) {
    const s = this.seq;
    for (let o = 0, l = s.length; o !== l; ++o) {
      const c = s[o];
      c.setValue(e, n[c.id], a);
    }
  }
}
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(t, e) {
  t.seq.push(e), t.map[e.id] = e;
}
function parseUniform(t, e, n) {
  const a = t.name, s = a.length;
  for (RePathPart.lastIndex = 0; ; ) {
    const o = RePathPart.exec(a), l = RePathPart.lastIndex;
    let c = o[1];
    const u = o[2] === "]", d = o[3];
    if (u && (c = c | 0), d === void 0 || d === "[" && l + 2 === s) {
      addUniform(n, d === void 0 ? new SingleUniform(c, t, e) : new PureArrayUniform(c, t, e));
      break;
    } else {
      let h = n.map[c];
      h === void 0 && (h = new StructuredUniform(c), addUniform(n, h)), n = h;
    }
  }
}
class WebGLUniforms {
  constructor(e, n) {
    this.seq = [], this.map = {};
    const a = e.getProgramParameter(n, e.ACTIVE_UNIFORMS);
    for (let s = 0; s < a; ++s) {
      const o = e.getActiveUniform(n, s), l = e.getUniformLocation(n, o.name);
      parseUniform(o, l, this);
    }
  }
  setValue(e, n, a, s) {
    const o = this.map[n];
    o !== void 0 && o.setValue(e, a, s);
  }
  setOptional(e, n, a) {
    const s = n[a];
    s !== void 0 && this.setValue(e, a, s);
  }
  static upload(e, n, a, s) {
    for (let o = 0, l = n.length; o !== l; ++o) {
      const c = n[o], u = a[c.id];
      u.needsUpdate !== !1 && c.setValue(e, u.value, s);
    }
  }
  static seqWithValue(e, n) {
    const a = [];
    for (let s = 0, o = e.length; s !== o; ++s) {
      const l = e[s];
      l.id in n && a.push(l);
    }
    return a;
  }
}
function WebGLShader(t, e, n) {
  const a = t.createShader(e);
  return t.shaderSource(a, n), t.compileShader(a), a;
}
const COMPLETION_STATUS_KHR = 37297;
let programIdCount = 0;
function handleSource(t, e) {
  const n = t.split(`
`), a = [], s = Math.max(e - 6, 0), o = Math.min(e + 6, n.length);
  for (let l = s; l < o; l++) {
    const c = l + 1;
    a.push(`${c === e ? ">" : " "} ${c}: ${n[l]}`);
  }
  return a.join(`
`);
}
function getEncodingComponents(t) {
  const e = ColorManagement.getPrimaries(ColorManagement.workingColorSpace), n = ColorManagement.getPrimaries(t);
  let a;
  switch (e === n ? a = "" : e === P3Primaries && n === Rec709Primaries ? a = "LinearDisplayP3ToLinearSRGB" : e === Rec709Primaries && n === P3Primaries && (a = "LinearSRGBToLinearDisplayP3"), t) {
    case LinearSRGBColorSpace:
    case LinearDisplayP3ColorSpace:
      return [a, "LinearTransferOETF"];
    case SRGBColorSpace:
    case DisplayP3ColorSpace:
      return [a, "sRGBTransferOETF"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space:", t), [a, "LinearTransferOETF"];
  }
}
function getShaderErrors(t, e, n) {
  const a = t.getShaderParameter(e, t.COMPILE_STATUS), s = t.getShaderInfoLog(e).trim();
  if (a && s === "")
    return "";
  const o = /ERROR: 0:(\d+)/.exec(s);
  if (o) {
    const l = parseInt(o[1]);
    return n.toUpperCase() + `

` + s + `

` + handleSource(t.getShaderSource(e), l);
  } else
    return s;
}
function getTexelEncodingFunction(t, e) {
  const n = getEncodingComponents(e);
  return `vec4 ${t}( vec4 value ) { return ${n[0]}( ${n[1]}( value ) ); }`;
}
function getToneMappingFunction(t, e) {
  let n;
  switch (e) {
    case LinearToneMapping:
      n = "Linear";
      break;
    case ReinhardToneMapping:
      n = "Reinhard";
      break;
    case CineonToneMapping:
      n = "OptimizedCineon";
      break;
    case ACESFilmicToneMapping:
      n = "ACESFilmic";
      break;
    case CustomToneMapping:
      n = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), n = "Linear";
  }
  return "vec3 " + t + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
}
function generateExtensions(t) {
  return [
    t.extensionDerivatives || t.envMapCubeUVHeight || t.bumpMap || t.normalMapTangentSpace || t.clearcoatNormalMap || t.flatShading || t.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (t.extensionFragDepth || t.logarithmicDepthBuffer) && t.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    t.extensionDrawBuffers && t.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (t.extensionShaderTextureLOD || t.envMap || t.transmission) && t.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ].filter(filterEmptyLine).join(`
`);
}
function generateDefines(t) {
  const e = [];
  for (const n in t) {
    const a = t[n];
    a !== !1 && e.push("#define " + n + " " + a);
  }
  return e.join(`
`);
}
function fetchAttributeLocations(t, e) {
  const n = {}, a = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES);
  for (let s = 0; s < a; s++) {
    const o = t.getActiveAttrib(e, s), l = o.name;
    let c = 1;
    o.type === t.FLOAT_MAT2 && (c = 2), o.type === t.FLOAT_MAT3 && (c = 3), o.type === t.FLOAT_MAT4 && (c = 4), n[l] = {
      type: o.type,
      location: t.getAttribLocation(e, l),
      locationSize: c
    };
  }
  return n;
}
function filterEmptyLine(t) {
  return t !== "";
}
function replaceLightNums(t, e) {
  const n = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function replaceClippingPlaneNums(t, e) {
  return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(t) {
  return t.replace(includePattern, includeReplacer);
}
const shaderChunkMap = /* @__PURE__ */ new Map([
  ["encodings_fragment", "colorspace_fragment"],
  // @deprecated, r154
  ["encodings_pars_fragment", "colorspace_pars_fragment"],
  // @deprecated, r154
  ["output_fragment", "opaque_fragment"]
  // @deprecated, r154
]);
function includeReplacer(t, e) {
  let n = ShaderChunk[e];
  if (n === void 0) {
    const a = shaderChunkMap.get(e);
    if (a !== void 0)
      n = ShaderChunk[a], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, a);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return resolveIncludes(n);
}
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(t) {
  return t.replace(unrollLoopPattern, loopReplacer);
}
function loopReplacer(t, e, n, a) {
  let s = "";
  for (let o = parseInt(e); o < parseInt(n); o++)
    s += a.replace(/\[\s*i\s*\]/g, "[ " + o + " ]").replace(/UNROLLED_LOOP_INDEX/g, o);
  return s;
}
function generatePrecision(t) {
  let e = "precision " + t.precision + ` float;
precision ` + t.precision + " int;";
  return t.precision === "highp" ? e += `
#define HIGH_PRECISION` : t.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : t.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function generateShadowMapTypeDefine(t) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return t.shadowMapType === PCFShadowMap ? e = "SHADOWMAP_TYPE_PCF" : t.shadowMapType === PCFSoftShadowMap ? e = "SHADOWMAP_TYPE_PCF_SOFT" : t.shadowMapType === VSMShadowMap && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function generateEnvMapTypeDefine(t) {
  let e = "ENVMAP_TYPE_CUBE";
  if (t.envMap)
    switch (t.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function generateEnvMapModeDefine(t) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (t.envMap)
    switch (t.envMapMode) {
      case CubeRefractionMapping:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function generateEnvMapBlendingDefine(t) {
  let e = "ENVMAP_BLENDING_NONE";
  if (t.envMap)
    switch (t.combine) {
      case MultiplyOperation:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function generateCubeUVSize(t) {
  const e = t.envMapCubeUVHeight;
  if (e === null)
    return null;
  const n = Math.log2(e) - 2, a = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 7 * 16)), texelHeight: a, maxMip: n };
}
function WebGLProgram(t, e, n, a) {
  const s = t.getContext(), o = n.defines;
  let l = n.vertexShader, c = n.fragmentShader;
  const u = generateShadowMapTypeDefine(n), d = generateEnvMapTypeDefine(n), f = generateEnvMapModeDefine(n), h = generateEnvMapBlendingDefine(n), g = generateCubeUVSize(n), x = n.isWebGL2 ? "" : generateExtensions(n), E = generateDefines(o), m = s.createProgram();
  let v, y, A = n.glslVersion ? "#version " + n.glslVersion + `
` : "";
  n.isRawShaderMaterial ? (v = [
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    E
  ].filter(filterEmptyLine).join(`
`), v.length > 0 && (v += `
`), y = [
    x,
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    E
  ].filter(filterEmptyLine).join(`
`), y.length > 0 && (y += `
`)) : (v = [
    generatePrecision(n),
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    E,
    n.instancing ? "#define USE_INSTANCING" : "",
    n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    n.useFog && n.fog ? "#define USE_FOG" : "",
    n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
    n.map ? "#define USE_MAP" : "",
    n.envMap ? "#define USE_ENVMAP" : "",
    n.envMap ? "#define " + f : "",
    n.lightMap ? "#define USE_LIGHTMAP" : "",
    n.aoMap ? "#define USE_AOMAP" : "",
    n.bumpMap ? "#define USE_BUMPMAP" : "",
    n.normalMap ? "#define USE_NORMALMAP" : "",
    n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    n.anisotropy ? "#define USE_ANISOTROPY" : "",
    n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    n.specularMap ? "#define USE_SPECULARMAP" : "",
    n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    n.metalnessMap ? "#define USE_METALNESSMAP" : "",
    n.alphaMap ? "#define USE_ALPHAMAP" : "",
    n.alphaHash ? "#define USE_ALPHAHASH" : "",
    n.transmission ? "#define USE_TRANSMISSION" : "",
    n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    n.mapUv ? "#define MAP_UV " + n.mapUv : "",
    n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
    n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
    n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
    n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
    n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
    n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
    n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
    n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
    n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
    n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
    n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
    n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
    n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
    n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
    n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
    n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
    n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
    n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
    n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
    n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
    n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
    n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
    //
    n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
    n.vertexColors ? "#define USE_COLOR" : "",
    n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    n.vertexUv1s ? "#define USE_UV1" : "",
    n.vertexUv2s ? "#define USE_UV2" : "",
    n.vertexUv3s ? "#define USE_UV3" : "",
    n.pointsUvs ? "#define USE_POINTS_UV" : "",
    n.flatShading ? "#define FLAT_SHADED" : "",
    n.skinning ? "#define USE_SKINNING" : "",
    n.morphTargets ? "#define USE_MORPHTARGETS" : "",
    n.morphNormals && n.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
    n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
    n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
    n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
    n.doubleSided ? "#define DOUBLE_SIDED" : "",
    n.flipSided ? "#define FLIP_SIDED" : "",
    n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    n.shadowMapEnabled ? "#define " + u : "",
    n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
    n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
    "	attribute vec3 morphTarget0;",
    "	attribute vec3 morphTarget1;",
    "	attribute vec3 morphTarget2;",
    "	attribute vec3 morphTarget3;",
    "	#ifdef USE_MORPHNORMALS",
    "		attribute vec3 morphNormal0;",
    "		attribute vec3 morphNormal1;",
    "		attribute vec3 morphNormal2;",
    "		attribute vec3 morphNormal3;",
    "	#else",
    "		attribute vec3 morphTarget4;",
    "		attribute vec3 morphTarget5;",
    "		attribute vec3 morphTarget6;",
    "		attribute vec3 morphTarget7;",
    "	#endif",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(filterEmptyLine).join(`
`), y = [
    x,
    generatePrecision(n),
    "#define SHADER_TYPE " + n.shaderType,
    "#define SHADER_NAME " + n.shaderName,
    E,
    n.useFog && n.fog ? "#define USE_FOG" : "",
    n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
    n.map ? "#define USE_MAP" : "",
    n.matcap ? "#define USE_MATCAP" : "",
    n.envMap ? "#define USE_ENVMAP" : "",
    n.envMap ? "#define " + d : "",
    n.envMap ? "#define " + f : "",
    n.envMap ? "#define " + h : "",
    g ? "#define CUBEUV_TEXEL_WIDTH " + g.texelWidth : "",
    g ? "#define CUBEUV_TEXEL_HEIGHT " + g.texelHeight : "",
    g ? "#define CUBEUV_MAX_MIP " + g.maxMip + ".0" : "",
    n.lightMap ? "#define USE_LIGHTMAP" : "",
    n.aoMap ? "#define USE_AOMAP" : "",
    n.bumpMap ? "#define USE_BUMPMAP" : "",
    n.normalMap ? "#define USE_NORMALMAP" : "",
    n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    n.anisotropy ? "#define USE_ANISOTROPY" : "",
    n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    n.clearcoat ? "#define USE_CLEARCOAT" : "",
    n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    n.iridescence ? "#define USE_IRIDESCENCE" : "",
    n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    n.specularMap ? "#define USE_SPECULARMAP" : "",
    n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    n.metalnessMap ? "#define USE_METALNESSMAP" : "",
    n.alphaMap ? "#define USE_ALPHAMAP" : "",
    n.alphaTest ? "#define USE_ALPHATEST" : "",
    n.alphaHash ? "#define USE_ALPHAHASH" : "",
    n.sheen ? "#define USE_SHEEN" : "",
    n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    n.transmission ? "#define USE_TRANSMISSION" : "",
    n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    n.vertexTangents && n.flatShading === !1 ? "#define USE_TANGENT" : "",
    n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
    n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    n.vertexUv1s ? "#define USE_UV1" : "",
    n.vertexUv2s ? "#define USE_UV2" : "",
    n.vertexUv3s ? "#define USE_UV3" : "",
    n.pointsUvs ? "#define USE_POINTS_UV" : "",
    n.gradientMap ? "#define USE_GRADIENTMAP" : "",
    n.flatShading ? "#define FLAT_SHADED" : "",
    n.doubleSided ? "#define DOUBLE_SIDED" : "",
    n.flipSided ? "#define FLIP_SIDED" : "",
    n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    n.shadowMapEnabled ? "#define " + u : "",
    n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
    n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    n.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
    n.toneMapping !== NoToneMapping ? ShaderChunk.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    n.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", n.toneMapping) : "",
    n.dithering ? "#define DITHERING" : "",
    n.opaque ? "#define OPAQUE" : "",
    ShaderChunk.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    getTexelEncodingFunction("linearToOutputTexel", n.outputColorSpace),
    n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
    `
`
  ].filter(filterEmptyLine).join(`
`)), l = resolveIncludes(l), l = replaceLightNums(l, n), l = replaceClippingPlaneNums(l, n), c = resolveIncludes(c), c = replaceLightNums(c, n), c = replaceClippingPlaneNums(c, n), l = unrollLoops(l), c = unrollLoops(c), n.isWebGL2 && n.isRawShaderMaterial !== !0 && (A = `#version 300 es
`, v = [
    "precision mediump sampler2DArray;",
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + v, y = [
    "precision mediump sampler2DArray;",
    "#define varying in",
    n.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    n.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + y);
  const b = A + v + l, C = A + y + c, T = WebGLShader(s, s.VERTEX_SHADER, b), w = WebGLShader(s, s.FRAGMENT_SHADER, C);
  s.attachShader(m, T), s.attachShader(m, w), n.index0AttributeName !== void 0 ? s.bindAttribLocation(m, 0, n.index0AttributeName) : n.morphTargets === !0 && s.bindAttribLocation(m, 0, "position"), s.linkProgram(m);
  function R(W) {
    if (t.debug.checkShaderErrors) {
      const L = s.getProgramInfoLog(m).trim(), z = s.getShaderInfoLog(T).trim(), P = s.getShaderInfoLog(w).trim();
      let Q = !0, Y = !0;
      if (s.getProgramParameter(m, s.LINK_STATUS) === !1)
        if (Q = !1, typeof t.debug.onShaderError == "function")
          t.debug.onShaderError(s, m, T, w);
        else {
          const ie = getShaderErrors(s, T, "vertex"), te = getShaderErrors(s, w, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + s.getError() + " - VALIDATE_STATUS " + s.getProgramParameter(m, s.VALIDATE_STATUS) + `

Program Info Log: ` + L + `
` + ie + `
` + te
          );
        }
      else
        L !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", L) : (z === "" || P === "") && (Y = !1);
      Y && (W.diagnostics = {
        runnable: Q,
        programLog: L,
        vertexShader: {
          log: z,
          prefix: v
        },
        fragmentShader: {
          log: P,
          prefix: y
        }
      });
    }
    s.deleteShader(T), s.deleteShader(w), O = new WebGLUniforms(s, m), D = fetchAttributeLocations(s, m);
  }
  let O;
  this.getUniforms = function() {
    return O === void 0 && R(this), O;
  };
  let D;
  this.getAttributes = function() {
    return D === void 0 && R(this), D;
  };
  let k = n.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return k === !1 && (k = s.getProgramParameter(m, COMPLETION_STATUS_KHR)), k;
  }, this.destroy = function() {
    a.releaseStatesOfProgram(this), s.deleteProgram(m), this.program = void 0;
  }, this.type = n.shaderType, this.name = n.shaderName, this.id = programIdCount++, this.cacheKey = e, this.usedTimes = 1, this.program = m, this.vertexShader = T, this.fragmentShader = w, this;
}
let _id$1 = 0;
class WebGLShaderCache {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const n = e.vertexShader, a = e.fragmentShader, s = this._getShaderStage(n), o = this._getShaderStage(a), l = this._getShaderCacheForMaterial(e);
    return l.has(s) === !1 && (l.add(s), s.usedTimes++), l.has(o) === !1 && (l.add(o), o.usedTimes++), this;
  }
  remove(e) {
    const n = this.materialCache.get(e);
    for (const a of n)
      a.usedTimes--, a.usedTimes === 0 && this.shaderCache.delete(a.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const n = this.materialCache;
    let a = n.get(e);
    return a === void 0 && (a = /* @__PURE__ */ new Set(), n.set(e, a)), a;
  }
  _getShaderStage(e) {
    const n = this.shaderCache;
    let a = n.get(e);
    return a === void 0 && (a = new WebGLShaderStage(e), n.set(e, a)), a;
  }
}
class WebGLShaderStage {
  constructor(e) {
    this.id = _id$1++, this.code = e, this.usedTimes = 0;
  }
}
function WebGLPrograms(t, e, n, a, s, o, l) {
  const c = new Layers(), u = new WebGLShaderCache(), d = [], f = s.isWebGL2, h = s.logarithmicDepthBuffer, g = s.vertexTextures;
  let x = s.precision;
  const E = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function m(D) {
    return D === 0 ? "uv" : `uv${D}`;
  }
  function v(D, k, W, L, z) {
    const P = L.fog, Q = z.geometry, Y = D.isMeshStandardMaterial ? L.environment : null, ie = (D.isMeshStandardMaterial ? n : e).get(D.envMap || Y), te = ie && ie.mapping === CubeUVReflectionMapping ? ie.image.height : null, Z = E[D.type];
    D.precision !== null && (x = s.getMaxPrecision(D.precision), x !== D.precision && console.warn("THREE.WebGLProgram.getParameters:", D.precision, "not supported, using", x, "instead."));
    const ae = Q.morphAttributes.position || Q.morphAttributes.normal || Q.morphAttributes.color, G = ae !== void 0 ? ae.length : 0;
    let U = 0;
    Q.morphAttributes.position !== void 0 && (U = 1), Q.morphAttributes.normal !== void 0 && (U = 2), Q.morphAttributes.color !== void 0 && (U = 3);
    let F, M, I, N;
    if (Z) {
      const wt = ShaderLib[Z];
      F = wt.vertexShader, M = wt.fragmentShader;
    } else
      F = D.vertexShader, M = D.fragmentShader, u.update(D), I = u.getVertexShaderID(D), N = u.getFragmentShaderID(D);
    const V = t.getRenderTarget(), q = z.isInstancedMesh === !0, H = !!D.map, ne = !!D.matcap, he = !!ie, j = !!D.aoMap, Fe = !!D.lightMap, X = !!D.bumpMap, ye = !!D.normalMap, Ae = !!D.displacementMap, fe = !!D.emissiveMap, _e = !!D.metalnessMap, Ie = !!D.roughnessMap, Be = D.anisotropy > 0, $e = D.clearcoat > 0, Me = D.iridescence > 0, J = D.sheen > 0, K = D.transmission > 0, ge = Be && !!D.anisotropyMap, Ce = $e && !!D.clearcoatMap, Oe = $e && !!D.clearcoatNormalMap, qe = $e && !!D.clearcoatRoughnessMap, ct = Me && !!D.iridescenceMap, ze = Me && !!D.iridescenceThicknessMap, et = J && !!D.sheenColorMap, gt = J && !!D.sheenRoughnessMap, pt = !!D.specularMap, nt = !!D.specularColorMap, tt = !!D.specularIntensityMap, Ve = K && !!D.transmissionMap, We = K && !!D.thicknessMap, it = !!D.gradientMap, Je = !!D.alphaMap, Rt = D.alphaTest > 0, je = !!D.alphaHash, ke = !!D.extensions, Ye = !!Q.attributes.uv1, Ze = !!Q.attributes.uv2, rt = !!Q.attributes.uv3;
    let xt = NoToneMapping;
    return D.toneMapped && (V === null || V.isXRRenderTarget === !0) && (xt = t.toneMapping), {
      isWebGL2: f,
      shaderID: Z,
      shaderType: D.type,
      shaderName: D.name,
      vertexShader: F,
      fragmentShader: M,
      defines: D.defines,
      customVertexShaderID: I,
      customFragmentShaderID: N,
      isRawShaderMaterial: D.isRawShaderMaterial === !0,
      glslVersion: D.glslVersion,
      precision: x,
      instancing: q,
      instancingColor: q && z.instanceColor !== null,
      supportsVertexTextures: g,
      outputColorSpace: V === null ? t.outputColorSpace : V.isXRRenderTarget === !0 ? V.texture.colorSpace : LinearSRGBColorSpace,
      map: H,
      matcap: ne,
      envMap: he,
      envMapMode: he && ie.mapping,
      envMapCubeUVHeight: te,
      aoMap: j,
      lightMap: Fe,
      bumpMap: X,
      normalMap: ye,
      displacementMap: g && Ae,
      emissiveMap: fe,
      normalMapObjectSpace: ye && D.normalMapType === ObjectSpaceNormalMap,
      normalMapTangentSpace: ye && D.normalMapType === TangentSpaceNormalMap,
      metalnessMap: _e,
      roughnessMap: Ie,
      anisotropy: Be,
      anisotropyMap: ge,
      clearcoat: $e,
      clearcoatMap: Ce,
      clearcoatNormalMap: Oe,
      clearcoatRoughnessMap: qe,
      iridescence: Me,
      iridescenceMap: ct,
      iridescenceThicknessMap: ze,
      sheen: J,
      sheenColorMap: et,
      sheenRoughnessMap: gt,
      specularMap: pt,
      specularColorMap: nt,
      specularIntensityMap: tt,
      transmission: K,
      transmissionMap: Ve,
      thicknessMap: We,
      gradientMap: it,
      opaque: D.transparent === !1 && D.blending === NormalBlending,
      alphaMap: Je,
      alphaTest: Rt,
      alphaHash: je,
      combine: D.combine,
      //
      mapUv: H && m(D.map.channel),
      aoMapUv: j && m(D.aoMap.channel),
      lightMapUv: Fe && m(D.lightMap.channel),
      bumpMapUv: X && m(D.bumpMap.channel),
      normalMapUv: ye && m(D.normalMap.channel),
      displacementMapUv: Ae && m(D.displacementMap.channel),
      emissiveMapUv: fe && m(D.emissiveMap.channel),
      metalnessMapUv: _e && m(D.metalnessMap.channel),
      roughnessMapUv: Ie && m(D.roughnessMap.channel),
      anisotropyMapUv: ge && m(D.anisotropyMap.channel),
      clearcoatMapUv: Ce && m(D.clearcoatMap.channel),
      clearcoatNormalMapUv: Oe && m(D.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: qe && m(D.clearcoatRoughnessMap.channel),
      iridescenceMapUv: ct && m(D.iridescenceMap.channel),
      iridescenceThicknessMapUv: ze && m(D.iridescenceThicknessMap.channel),
      sheenColorMapUv: et && m(D.sheenColorMap.channel),
      sheenRoughnessMapUv: gt && m(D.sheenRoughnessMap.channel),
      specularMapUv: pt && m(D.specularMap.channel),
      specularColorMapUv: nt && m(D.specularColorMap.channel),
      specularIntensityMapUv: tt && m(D.specularIntensityMap.channel),
      transmissionMapUv: Ve && m(D.transmissionMap.channel),
      thicknessMapUv: We && m(D.thicknessMap.channel),
      alphaMapUv: Je && m(D.alphaMap.channel),
      //
      vertexTangents: !!Q.attributes.tangent && (ye || Be),
      vertexColors: D.vertexColors,
      vertexAlphas: D.vertexColors === !0 && !!Q.attributes.color && Q.attributes.color.itemSize === 4,
      vertexUv1s: Ye,
      vertexUv2s: Ze,
      vertexUv3s: rt,
      pointsUvs: z.isPoints === !0 && !!Q.attributes.uv && (H || Je),
      fog: !!P,
      useFog: D.fog === !0,
      fogExp2: P && P.isFogExp2,
      flatShading: D.flatShading === !0,
      sizeAttenuation: D.sizeAttenuation === !0,
      logarithmicDepthBuffer: h,
      skinning: z.isSkinnedMesh === !0,
      morphTargets: Q.morphAttributes.position !== void 0,
      morphNormals: Q.morphAttributes.normal !== void 0,
      morphColors: Q.morphAttributes.color !== void 0,
      morphTargetsCount: G,
      morphTextureStride: U,
      numDirLights: k.directional.length,
      numPointLights: k.point.length,
      numSpotLights: k.spot.length,
      numSpotLightMaps: k.spotLightMap.length,
      numRectAreaLights: k.rectArea.length,
      numHemiLights: k.hemi.length,
      numDirLightShadows: k.directionalShadowMap.length,
      numPointLightShadows: k.pointShadowMap.length,
      numSpotLightShadows: k.spotShadowMap.length,
      numSpotLightShadowsWithMaps: k.numSpotLightShadowsWithMaps,
      numLightProbes: k.numLightProbes,
      numClippingPlanes: l.numPlanes,
      numClipIntersection: l.numIntersection,
      dithering: D.dithering,
      shadowMapEnabled: t.shadowMap.enabled && W.length > 0,
      shadowMapType: t.shadowMap.type,
      toneMapping: xt,
      useLegacyLights: t._useLegacyLights,
      decodeVideoTexture: H && D.map.isVideoTexture === !0 && ColorManagement.getTransfer(D.map.colorSpace) === SRGBTransfer,
      premultipliedAlpha: D.premultipliedAlpha,
      doubleSided: D.side === DoubleSide,
      flipSided: D.side === BackSide,
      useDepthPacking: D.depthPacking >= 0,
      depthPacking: D.depthPacking || 0,
      index0AttributeName: D.index0AttributeName,
      extensionDerivatives: ke && D.extensions.derivatives === !0,
      extensionFragDepth: ke && D.extensions.fragDepth === !0,
      extensionDrawBuffers: ke && D.extensions.drawBuffers === !0,
      extensionShaderTextureLOD: ke && D.extensions.shaderTextureLOD === !0,
      rendererExtensionFragDepth: f || a.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: f || a.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: f || a.has("EXT_shader_texture_lod"),
      rendererExtensionParallelShaderCompile: a.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: D.customProgramCacheKey()
    };
  }
  function y(D) {
    const k = [];
    if (D.shaderID ? k.push(D.shaderID) : (k.push(D.customVertexShaderID), k.push(D.customFragmentShaderID)), D.defines !== void 0)
      for (const W in D.defines)
        k.push(W), k.push(D.defines[W]);
    return D.isRawShaderMaterial === !1 && (A(k, D), b(k, D), k.push(t.outputColorSpace)), k.push(D.customProgramCacheKey), k.join();
  }
  function A(D, k) {
    D.push(k.precision), D.push(k.outputColorSpace), D.push(k.envMapMode), D.push(k.envMapCubeUVHeight), D.push(k.mapUv), D.push(k.alphaMapUv), D.push(k.lightMapUv), D.push(k.aoMapUv), D.push(k.bumpMapUv), D.push(k.normalMapUv), D.push(k.displacementMapUv), D.push(k.emissiveMapUv), D.push(k.metalnessMapUv), D.push(k.roughnessMapUv), D.push(k.anisotropyMapUv), D.push(k.clearcoatMapUv), D.push(k.clearcoatNormalMapUv), D.push(k.clearcoatRoughnessMapUv), D.push(k.iridescenceMapUv), D.push(k.iridescenceThicknessMapUv), D.push(k.sheenColorMapUv), D.push(k.sheenRoughnessMapUv), D.push(k.specularMapUv), D.push(k.specularColorMapUv), D.push(k.specularIntensityMapUv), D.push(k.transmissionMapUv), D.push(k.thicknessMapUv), D.push(k.combine), D.push(k.fogExp2), D.push(k.sizeAttenuation), D.push(k.morphTargetsCount), D.push(k.morphAttributeCount), D.push(k.numDirLights), D.push(k.numPointLights), D.push(k.numSpotLights), D.push(k.numSpotLightMaps), D.push(k.numHemiLights), D.push(k.numRectAreaLights), D.push(k.numDirLightShadows), D.push(k.numPointLightShadows), D.push(k.numSpotLightShadows), D.push(k.numSpotLightShadowsWithMaps), D.push(k.numLightProbes), D.push(k.shadowMapType), D.push(k.toneMapping), D.push(k.numClippingPlanes), D.push(k.numClipIntersection), D.push(k.depthPacking);
  }
  function b(D, k) {
    c.disableAll(), k.isWebGL2 && c.enable(0), k.supportsVertexTextures && c.enable(1), k.instancing && c.enable(2), k.instancingColor && c.enable(3), k.matcap && c.enable(4), k.envMap && c.enable(5), k.normalMapObjectSpace && c.enable(6), k.normalMapTangentSpace && c.enable(7), k.clearcoat && c.enable(8), k.iridescence && c.enable(9), k.alphaTest && c.enable(10), k.vertexColors && c.enable(11), k.vertexAlphas && c.enable(12), k.vertexUv1s && c.enable(13), k.vertexUv2s && c.enable(14), k.vertexUv3s && c.enable(15), k.vertexTangents && c.enable(16), k.anisotropy && c.enable(17), k.alphaHash && c.enable(18), D.push(c.mask), c.disableAll(), k.fog && c.enable(0), k.useFog && c.enable(1), k.flatShading && c.enable(2), k.logarithmicDepthBuffer && c.enable(3), k.skinning && c.enable(4), k.morphTargets && c.enable(5), k.morphNormals && c.enable(6), k.morphColors && c.enable(7), k.premultipliedAlpha && c.enable(8), k.shadowMapEnabled && c.enable(9), k.useLegacyLights && c.enable(10), k.doubleSided && c.enable(11), k.flipSided && c.enable(12), k.useDepthPacking && c.enable(13), k.dithering && c.enable(14), k.transmission && c.enable(15), k.sheen && c.enable(16), k.opaque && c.enable(17), k.pointsUvs && c.enable(18), k.decodeVideoTexture && c.enable(19), D.push(c.mask);
  }
  function C(D) {
    const k = E[D.type];
    let W;
    if (k) {
      const L = ShaderLib[k];
      W = UniformsUtils.clone(L.uniforms);
    } else
      W = D.uniforms;
    return W;
  }
  function T(D, k) {
    let W;
    for (let L = 0, z = d.length; L < z; L++) {
      const P = d[L];
      if (P.cacheKey === k) {
        W = P, ++W.usedTimes;
        break;
      }
    }
    return W === void 0 && (W = new WebGLProgram(t, k, D, o), d.push(W)), W;
  }
  function w(D) {
    if (--D.usedTimes === 0) {
      const k = d.indexOf(D);
      d[k] = d[d.length - 1], d.pop(), D.destroy();
    }
  }
  function R(D) {
    u.remove(D);
  }
  function O() {
    u.dispose();
  }
  return {
    getParameters: v,
    getProgramCacheKey: y,
    getUniforms: C,
    acquireProgram: T,
    releaseProgram: w,
    releaseShaderCache: R,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: d,
    dispose: O
  };
}
function WebGLProperties() {
  let t = /* @__PURE__ */ new WeakMap();
  function e(o) {
    let l = t.get(o);
    return l === void 0 && (l = {}, t.set(o, l)), l;
  }
  function n(o) {
    t.delete(o);
  }
  function a(o, l, c) {
    t.get(o)[l] = c;
  }
  function s() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    remove: n,
    update: a,
    dispose: s
  };
}
function painterSortStable(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id;
}
function reversePainterSortStable(t, e) {
  return t.groupOrder !== e.groupOrder ? t.groupOrder - e.groupOrder : t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id;
}
function WebGLRenderList() {
  const t = [];
  let e = 0;
  const n = [], a = [], s = [];
  function o() {
    e = 0, n.length = 0, a.length = 0, s.length = 0;
  }
  function l(h, g, x, E, m, v) {
    let y = t[e];
    return y === void 0 ? (y = {
      id: h.id,
      object: h,
      geometry: g,
      material: x,
      groupOrder: E,
      renderOrder: h.renderOrder,
      z: m,
      group: v
    }, t[e] = y) : (y.id = h.id, y.object = h, y.geometry = g, y.material = x, y.groupOrder = E, y.renderOrder = h.renderOrder, y.z = m, y.group = v), e++, y;
  }
  function c(h, g, x, E, m, v) {
    const y = l(h, g, x, E, m, v);
    x.transmission > 0 ? a.push(y) : x.transparent === !0 ? s.push(y) : n.push(y);
  }
  function u(h, g, x, E, m, v) {
    const y = l(h, g, x, E, m, v);
    x.transmission > 0 ? a.unshift(y) : x.transparent === !0 ? s.unshift(y) : n.unshift(y);
  }
  function d(h, g) {
    n.length > 1 && n.sort(h || painterSortStable), a.length > 1 && a.sort(g || reversePainterSortStable), s.length > 1 && s.sort(g || reversePainterSortStable);
  }
  function f() {
    for (let h = e, g = t.length; h < g; h++) {
      const x = t[h];
      if (x.id === null)
        break;
      x.id = null, x.object = null, x.geometry = null, x.material = null, x.group = null;
    }
  }
  return {
    opaque: n,
    transmissive: a,
    transparent: s,
    init: o,
    push: c,
    unshift: u,
    finish: f,
    sort: d
  };
}
function WebGLRenderLists() {
  let t = /* @__PURE__ */ new WeakMap();
  function e(a, s) {
    const o = t.get(a);
    let l;
    return o === void 0 ? (l = new WebGLRenderList(), t.set(a, [l])) : s >= o.length ? (l = new WebGLRenderList(), o.push(l)) : l = o[s], l;
  }
  function n() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: n
  };
}
function UniformsCache() {
  const t = {};
  return {
    get: function(e) {
      if (t[e.id] !== void 0)
        return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
          n = {
            direction: new Vector3(),
            color: new Color()
          };
          break;
        case "SpotLight":
          n = {
            position: new Vector3(),
            direction: new Vector3(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          n = {
            position: new Vector3(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          n = {
            direction: new Vector3(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          n = {
            color: new Color(),
            position: new Vector3(),
            halfWidth: new Vector3(),
            halfHeight: new Vector3()
          };
          break;
      }
      return t[e.id] = n, n;
    }
  };
}
function ShadowUniformsCache() {
  const t = {};
  return {
    get: function(e) {
      if (t[e.id] !== void 0)
        return t[e.id];
      let n;
      switch (e.type) {
        case "DirectionalLight":
          n = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "SpotLight":
          n = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "PointLight":
          n = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return t[e.id] = n, n;
    }
  };
}
let nextVersion = 0;
function shadowCastingAndTexturingLightsFirst(t, e) {
  return (e.castShadow ? 2 : 0) - (t.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (t.map ? 1 : 0);
}
function WebGLLights(t, e) {
  const n = new UniformsCache(), a = ShadowUniformsCache(), s = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let f = 0; f < 9; f++)
    s.probe.push(new Vector3());
  const o = new Vector3(), l = new Matrix4(), c = new Matrix4();
  function u(f, h) {
    let g = 0, x = 0, E = 0;
    for (let L = 0; L < 9; L++)
      s.probe[L].set(0, 0, 0);
    let m = 0, v = 0, y = 0, A = 0, b = 0, C = 0, T = 0, w = 0, R = 0, O = 0, D = 0;
    f.sort(shadowCastingAndTexturingLightsFirst);
    const k = h === !0 ? Math.PI : 1;
    for (let L = 0, z = f.length; L < z; L++) {
      const P = f[L], Q = P.color, Y = P.intensity, ie = P.distance, te = P.shadow && P.shadow.map ? P.shadow.map.texture : null;
      if (P.isAmbientLight)
        g += Q.r * Y * k, x += Q.g * Y * k, E += Q.b * Y * k;
      else if (P.isLightProbe) {
        for (let Z = 0; Z < 9; Z++)
          s.probe[Z].addScaledVector(P.sh.coefficients[Z], Y);
        D++;
      } else if (P.isDirectionalLight) {
        const Z = n.get(P);
        if (Z.color.copy(P.color).multiplyScalar(P.intensity * k), P.castShadow) {
          const ae = P.shadow, G = a.get(P);
          G.shadowBias = ae.bias, G.shadowNormalBias = ae.normalBias, G.shadowRadius = ae.radius, G.shadowMapSize = ae.mapSize, s.directionalShadow[m] = G, s.directionalShadowMap[m] = te, s.directionalShadowMatrix[m] = P.shadow.matrix, C++;
        }
        s.directional[m] = Z, m++;
      } else if (P.isSpotLight) {
        const Z = n.get(P);
        Z.position.setFromMatrixPosition(P.matrixWorld), Z.color.copy(Q).multiplyScalar(Y * k), Z.distance = ie, Z.coneCos = Math.cos(P.angle), Z.penumbraCos = Math.cos(P.angle * (1 - P.penumbra)), Z.decay = P.decay, s.spot[y] = Z;
        const ae = P.shadow;
        if (P.map && (s.spotLightMap[R] = P.map, R++, ae.updateMatrices(P), P.castShadow && O++), s.spotLightMatrix[y] = ae.matrix, P.castShadow) {
          const G = a.get(P);
          G.shadowBias = ae.bias, G.shadowNormalBias = ae.normalBias, G.shadowRadius = ae.radius, G.shadowMapSize = ae.mapSize, s.spotShadow[y] = G, s.spotShadowMap[y] = te, w++;
        }
        y++;
      } else if (P.isRectAreaLight) {
        const Z = n.get(P);
        Z.color.copy(Q).multiplyScalar(Y), Z.halfWidth.set(P.width * 0.5, 0, 0), Z.halfHeight.set(0, P.height * 0.5, 0), s.rectArea[A] = Z, A++;
      } else if (P.isPointLight) {
        const Z = n.get(P);
        if (Z.color.copy(P.color).multiplyScalar(P.intensity * k), Z.distance = P.distance, Z.decay = P.decay, P.castShadow) {
          const ae = P.shadow, G = a.get(P);
          G.shadowBias = ae.bias, G.shadowNormalBias = ae.normalBias, G.shadowRadius = ae.radius, G.shadowMapSize = ae.mapSize, G.shadowCameraNear = ae.camera.near, G.shadowCameraFar = ae.camera.far, s.pointShadow[v] = G, s.pointShadowMap[v] = te, s.pointShadowMatrix[v] = P.shadow.matrix, T++;
        }
        s.point[v] = Z, v++;
      } else if (P.isHemisphereLight) {
        const Z = n.get(P);
        Z.skyColor.copy(P.color).multiplyScalar(Y * k), Z.groundColor.copy(P.groundColor).multiplyScalar(Y * k), s.hemi[b] = Z, b++;
      }
    }
    A > 0 && (e.isWebGL2 || t.has("OES_texture_float_linear") === !0 ? (s.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1, s.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2) : t.has("OES_texture_half_float_linear") === !0 ? (s.rectAreaLTC1 = UniformsLib.LTC_HALF_1, s.rectAreaLTC2 = UniformsLib.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), s.ambient[0] = g, s.ambient[1] = x, s.ambient[2] = E;
    const W = s.hash;
    (W.directionalLength !== m || W.pointLength !== v || W.spotLength !== y || W.rectAreaLength !== A || W.hemiLength !== b || W.numDirectionalShadows !== C || W.numPointShadows !== T || W.numSpotShadows !== w || W.numSpotMaps !== R || W.numLightProbes !== D) && (s.directional.length = m, s.spot.length = y, s.rectArea.length = A, s.point.length = v, s.hemi.length = b, s.directionalShadow.length = C, s.directionalShadowMap.length = C, s.pointShadow.length = T, s.pointShadowMap.length = T, s.spotShadow.length = w, s.spotShadowMap.length = w, s.directionalShadowMatrix.length = C, s.pointShadowMatrix.length = T, s.spotLightMatrix.length = w + R - O, s.spotLightMap.length = R, s.numSpotLightShadowsWithMaps = O, s.numLightProbes = D, W.directionalLength = m, W.pointLength = v, W.spotLength = y, W.rectAreaLength = A, W.hemiLength = b, W.numDirectionalShadows = C, W.numPointShadows = T, W.numSpotShadows = w, W.numSpotMaps = R, W.numLightProbes = D, s.version = nextVersion++);
  }
  function d(f, h) {
    let g = 0, x = 0, E = 0, m = 0, v = 0;
    const y = h.matrixWorldInverse;
    for (let A = 0, b = f.length; A < b; A++) {
      const C = f[A];
      if (C.isDirectionalLight) {
        const T = s.directional[g];
        T.direction.setFromMatrixPosition(C.matrixWorld), o.setFromMatrixPosition(C.target.matrixWorld), T.direction.sub(o), T.direction.transformDirection(y), g++;
      } else if (C.isSpotLight) {
        const T = s.spot[E];
        T.position.setFromMatrixPosition(C.matrixWorld), T.position.applyMatrix4(y), T.direction.setFromMatrixPosition(C.matrixWorld), o.setFromMatrixPosition(C.target.matrixWorld), T.direction.sub(o), T.direction.transformDirection(y), E++;
      } else if (C.isRectAreaLight) {
        const T = s.rectArea[m];
        T.position.setFromMatrixPosition(C.matrixWorld), T.position.applyMatrix4(y), c.identity(), l.copy(C.matrixWorld), l.premultiply(y), c.extractRotation(l), T.halfWidth.set(C.width * 0.5, 0, 0), T.halfHeight.set(0, C.height * 0.5, 0), T.halfWidth.applyMatrix4(c), T.halfHeight.applyMatrix4(c), m++;
      } else if (C.isPointLight) {
        const T = s.point[x];
        T.position.setFromMatrixPosition(C.matrixWorld), T.position.applyMatrix4(y), x++;
      } else if (C.isHemisphereLight) {
        const T = s.hemi[v];
        T.direction.setFromMatrixPosition(C.matrixWorld), T.direction.transformDirection(y), v++;
      }
    }
  }
  return {
    setup: u,
    setupView: d,
    state: s
  };
}
function WebGLRenderState(t, e) {
  const n = new WebGLLights(t, e), a = [], s = [];
  function o() {
    a.length = 0, s.length = 0;
  }
  function l(h) {
    a.push(h);
  }
  function c(h) {
    s.push(h);
  }
  function u(h) {
    n.setup(a, h);
  }
  function d(h) {
    n.setupView(a, h);
  }
  return {
    init: o,
    state: {
      lightsArray: a,
      shadowsArray: s,
      lights: n
    },
    setupLights: u,
    setupLightsView: d,
    pushLight: l,
    pushShadow: c
  };
}
function WebGLRenderStates(t, e) {
  let n = /* @__PURE__ */ new WeakMap();
  function a(o, l = 0) {
    const c = n.get(o);
    let u;
    return c === void 0 ? (u = new WebGLRenderState(t, e), n.set(o, [u])) : l >= c.length ? (u = new WebGLRenderState(t, e), c.push(u)) : u = c[l], u;
  }
  function s() {
    n = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: a,
    dispose: s
  };
}
class MeshDepthMaterial extends Material {
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = BasicDepthPacking, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class MeshDistanceMaterial extends Material {
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const vertex = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, fragment = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function WebGLShadowMap(t, e, n) {
  let a = new Frustum();
  const s = new Vector2(), o = new Vector2(), l = new Vector4(), c = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), u = new MeshDistanceMaterial(), d = {}, f = n.maxTextureSize, h = { [FrontSide]: BackSide, [BackSide]: FrontSide, [DoubleSide]: DoubleSide }, g = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  }), x = g.clone();
  x.defines.HORIZONTAL_PASS = 1;
  const E = new BufferGeometry();
  E.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const m = new Mesh(E, g), v = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = PCFShadowMap;
  let y = this.type;
  this.render = function(T, w, R) {
    if (v.enabled === !1 || v.autoUpdate === !1 && v.needsUpdate === !1 || T.length === 0)
      return;
    const O = t.getRenderTarget(), D = t.getActiveCubeFace(), k = t.getActiveMipmapLevel(), W = t.state;
    W.setBlending(NoBlending), W.buffers.color.setClear(1, 1, 1, 1), W.buffers.depth.setTest(!0), W.setScissorTest(!1);
    const L = y !== VSMShadowMap && this.type === VSMShadowMap, z = y === VSMShadowMap && this.type !== VSMShadowMap;
    for (let P = 0, Q = T.length; P < Q; P++) {
      const Y = T[P], ie = Y.shadow;
      if (ie === void 0) {
        console.warn("THREE.WebGLShadowMap:", Y, "has no shadow.");
        continue;
      }
      if (ie.autoUpdate === !1 && ie.needsUpdate === !1)
        continue;
      s.copy(ie.mapSize);
      const te = ie.getFrameExtents();
      if (s.multiply(te), o.copy(ie.mapSize), (s.x > f || s.y > f) && (s.x > f && (o.x = Math.floor(f / te.x), s.x = o.x * te.x, ie.mapSize.x = o.x), s.y > f && (o.y = Math.floor(f / te.y), s.y = o.y * te.y, ie.mapSize.y = o.y)), ie.map === null || L === !0 || z === !0) {
        const ae = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};
        ie.map !== null && ie.map.dispose(), ie.map = new WebGLRenderTarget(s.x, s.y, ae), ie.map.texture.name = Y.name + ".shadowMap", ie.camera.updateProjectionMatrix();
      }
      t.setRenderTarget(ie.map), t.clear();
      const Z = ie.getViewportCount();
      for (let ae = 0; ae < Z; ae++) {
        const G = ie.getViewport(ae);
        l.set(
          o.x * G.x,
          o.y * G.y,
          o.x * G.z,
          o.y * G.w
        ), W.viewport(l), ie.updateMatrices(Y, ae), a = ie.getFrustum(), C(w, R, ie.camera, Y, this.type);
      }
      ie.isPointLightShadow !== !0 && this.type === VSMShadowMap && A(ie, R), ie.needsUpdate = !1;
    }
    y = this.type, v.needsUpdate = !1, t.setRenderTarget(O, D, k);
  };
  function A(T, w) {
    const R = e.update(m);
    g.defines.VSM_SAMPLES !== T.blurSamples && (g.defines.VSM_SAMPLES = T.blurSamples, x.defines.VSM_SAMPLES = T.blurSamples, g.needsUpdate = !0, x.needsUpdate = !0), T.mapPass === null && (T.mapPass = new WebGLRenderTarget(s.x, s.y)), g.uniforms.shadow_pass.value = T.map.texture, g.uniforms.resolution.value = T.mapSize, g.uniforms.radius.value = T.radius, t.setRenderTarget(T.mapPass), t.clear(), t.renderBufferDirect(w, null, R, g, m, null), x.uniforms.shadow_pass.value = T.mapPass.texture, x.uniforms.resolution.value = T.mapSize, x.uniforms.radius.value = T.radius, t.setRenderTarget(T.map), t.clear(), t.renderBufferDirect(w, null, R, x, m, null);
  }
  function b(T, w, R, O) {
    let D = null;
    const k = R.isPointLight === !0 ? T.customDistanceMaterial : T.customDepthMaterial;
    if (k !== void 0)
      D = k;
    else if (D = R.isPointLight === !0 ? u : c, t.localClippingEnabled && w.clipShadows === !0 && Array.isArray(w.clippingPlanes) && w.clippingPlanes.length !== 0 || w.displacementMap && w.displacementScale !== 0 || w.alphaMap && w.alphaTest > 0 || w.map && w.alphaTest > 0) {
      const W = D.uuid, L = w.uuid;
      let z = d[W];
      z === void 0 && (z = {}, d[W] = z);
      let P = z[L];
      P === void 0 && (P = D.clone(), z[L] = P), D = P;
    }
    if (D.visible = w.visible, D.wireframe = w.wireframe, O === VSMShadowMap ? D.side = w.shadowSide !== null ? w.shadowSide : w.side : D.side = w.shadowSide !== null ? w.shadowSide : h[w.side], D.alphaMap = w.alphaMap, D.alphaTest = w.alphaTest, D.map = w.map, D.clipShadows = w.clipShadows, D.clippingPlanes = w.clippingPlanes, D.clipIntersection = w.clipIntersection, D.displacementMap = w.displacementMap, D.displacementScale = w.displacementScale, D.displacementBias = w.displacementBias, D.wireframeLinewidth = w.wireframeLinewidth, D.linewidth = w.linewidth, R.isPointLight === !0 && D.isMeshDistanceMaterial === !0) {
      const W = t.properties.get(D);
      W.light = R;
    }
    return D;
  }
  function C(T, w, R, O, D) {
    if (T.visible === !1)
      return;
    if (T.layers.test(w.layers) && (T.isMesh || T.isLine || T.isPoints) && (T.castShadow || T.receiveShadow && D === VSMShadowMap) && (!T.frustumCulled || a.intersectsObject(T))) {
      T.modelViewMatrix.multiplyMatrices(R.matrixWorldInverse, T.matrixWorld);
      const L = e.update(T), z = T.material;
      if (Array.isArray(z)) {
        const P = L.groups;
        for (let Q = 0, Y = P.length; Q < Y; Q++) {
          const ie = P[Q], te = z[ie.materialIndex];
          if (te && te.visible) {
            const Z = b(T, te, O, D);
            t.renderBufferDirect(R, null, L, Z, T, ie);
          }
        }
      } else if (z.visible) {
        const P = b(T, z, O, D);
        t.renderBufferDirect(R, null, L, P, T, null);
      }
    }
    const W = T.children;
    for (let L = 0, z = W.length; L < z; L++)
      C(W[L], w, R, O, D);
  }
}
function WebGLState(t, e, n) {
  const a = n.isWebGL2;
  function s() {
    let je = !1;
    const ke = new Vector4();
    let Ye = null;
    const Ze = new Vector4(0, 0, 0, 0);
    return {
      setMask: function(rt) {
        Ye !== rt && !je && (t.colorMask(rt, rt, rt, rt), Ye = rt);
      },
      setLocked: function(rt) {
        je = rt;
      },
      setClear: function(rt, xt, bt, wt, mt) {
        mt === !0 && (rt *= wt, xt *= wt, bt *= wt), ke.set(rt, xt, bt, wt), Ze.equals(ke) === !1 && (t.clearColor(rt, xt, bt, wt), Ze.copy(ke));
      },
      reset: function() {
        je = !1, Ye = null, Ze.set(-1, 0, 0, 0);
      }
    };
  }
  function o() {
    let je = !1, ke = null, Ye = null, Ze = null;
    return {
      setTest: function(rt) {
        rt ? H(t.DEPTH_TEST) : ne(t.DEPTH_TEST);
      },
      setMask: function(rt) {
        ke !== rt && !je && (t.depthMask(rt), ke = rt);
      },
      setFunc: function(rt) {
        if (Ye !== rt) {
          switch (rt) {
            case NeverDepth:
              t.depthFunc(t.NEVER);
              break;
            case AlwaysDepth:
              t.depthFunc(t.ALWAYS);
              break;
            case LessDepth:
              t.depthFunc(t.LESS);
              break;
            case LessEqualDepth:
              t.depthFunc(t.LEQUAL);
              break;
            case EqualDepth:
              t.depthFunc(t.EQUAL);
              break;
            case GreaterEqualDepth:
              t.depthFunc(t.GEQUAL);
              break;
            case GreaterDepth:
              t.depthFunc(t.GREATER);
              break;
            case NotEqualDepth:
              t.depthFunc(t.NOTEQUAL);
              break;
            default:
              t.depthFunc(t.LEQUAL);
          }
          Ye = rt;
        }
      },
      setLocked: function(rt) {
        je = rt;
      },
      setClear: function(rt) {
        Ze !== rt && (t.clearDepth(rt), Ze = rt);
      },
      reset: function() {
        je = !1, ke = null, Ye = null, Ze = null;
      }
    };
  }
  function l() {
    let je = !1, ke = null, Ye = null, Ze = null, rt = null, xt = null, bt = null, wt = null, mt = null;
    return {
      setTest: function(St) {
        je || (St ? H(t.STENCIL_TEST) : ne(t.STENCIL_TEST));
      },
      setMask: function(St) {
        ke !== St && !je && (t.stencilMask(St), ke = St);
      },
      setFunc: function(St, dt, Le) {
        (Ye !== St || Ze !== dt || rt !== Le) && (t.stencilFunc(St, dt, Le), Ye = St, Ze = dt, rt = Le);
      },
      setOp: function(St, dt, Le) {
        (xt !== St || bt !== dt || wt !== Le) && (t.stencilOp(St, dt, Le), xt = St, bt = dt, wt = Le);
      },
      setLocked: function(St) {
        je = St;
      },
      setClear: function(St) {
        mt !== St && (t.clearStencil(St), mt = St);
      },
      reset: function() {
        je = !1, ke = null, Ye = null, Ze = null, rt = null, xt = null, bt = null, wt = null, mt = null;
      }
    };
  }
  const c = new s(), u = new o(), d = new l(), f = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
  let g = {}, x = {}, E = /* @__PURE__ */ new WeakMap(), m = [], v = null, y = !1, A = null, b = null, C = null, T = null, w = null, R = null, O = null, D = new Color(0, 0, 0), k = 0, W = !1, L = null, z = null, P = null, Q = null, Y = null;
  const ie = t.getParameter(t.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let te = !1, Z = 0;
  const ae = t.getParameter(t.VERSION);
  ae.indexOf("WebGL") !== -1 ? (Z = parseFloat(/^WebGL (\d)/.exec(ae)[1]), te = Z >= 1) : ae.indexOf("OpenGL ES") !== -1 && (Z = parseFloat(/^OpenGL ES (\d)/.exec(ae)[1]), te = Z >= 2);
  let G = null, U = {};
  const F = t.getParameter(t.SCISSOR_BOX), M = t.getParameter(t.VIEWPORT), I = new Vector4().fromArray(F), N = new Vector4().fromArray(M);
  function V(je, ke, Ye, Ze) {
    const rt = new Uint8Array(4), xt = t.createTexture();
    t.bindTexture(je, xt), t.texParameteri(je, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(je, t.TEXTURE_MAG_FILTER, t.NEAREST);
    for (let bt = 0; bt < Ye; bt++)
      a && (je === t.TEXTURE_3D || je === t.TEXTURE_2D_ARRAY) ? t.texImage3D(ke, 0, t.RGBA, 1, 1, Ze, 0, t.RGBA, t.UNSIGNED_BYTE, rt) : t.texImage2D(ke + bt, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, rt);
    return xt;
  }
  const q = {};
  q[t.TEXTURE_2D] = V(t.TEXTURE_2D, t.TEXTURE_2D, 1), q[t.TEXTURE_CUBE_MAP] = V(t.TEXTURE_CUBE_MAP, t.TEXTURE_CUBE_MAP_POSITIVE_X, 6), a && (q[t.TEXTURE_2D_ARRAY] = V(t.TEXTURE_2D_ARRAY, t.TEXTURE_2D_ARRAY, 1, 1), q[t.TEXTURE_3D] = V(t.TEXTURE_3D, t.TEXTURE_3D, 1, 1)), c.setClear(0, 0, 0, 1), u.setClear(1), d.setClear(0), H(t.DEPTH_TEST), u.setFunc(LessEqualDepth), _e(!1), Ie(CullFaceBack), H(t.CULL_FACE), Ae(NoBlending);
  function H(je) {
    g[je] !== !0 && (t.enable(je), g[je] = !0);
  }
  function ne(je) {
    g[je] !== !1 && (t.disable(je), g[je] = !1);
  }
  function he(je, ke) {
    return x[je] !== ke ? (t.bindFramebuffer(je, ke), x[je] = ke, a && (je === t.DRAW_FRAMEBUFFER && (x[t.FRAMEBUFFER] = ke), je === t.FRAMEBUFFER && (x[t.DRAW_FRAMEBUFFER] = ke)), !0) : !1;
  }
  function j(je, ke) {
    let Ye = m, Ze = !1;
    if (je)
      if (Ye = E.get(ke), Ye === void 0 && (Ye = [], E.set(ke, Ye)), je.isWebGLMultipleRenderTargets) {
        const rt = je.texture;
        if (Ye.length !== rt.length || Ye[0] !== t.COLOR_ATTACHMENT0) {
          for (let xt = 0, bt = rt.length; xt < bt; xt++)
            Ye[xt] = t.COLOR_ATTACHMENT0 + xt;
          Ye.length = rt.length, Ze = !0;
        }
      } else
        Ye[0] !== t.COLOR_ATTACHMENT0 && (Ye[0] = t.COLOR_ATTACHMENT0, Ze = !0);
    else
      Ye[0] !== t.BACK && (Ye[0] = t.BACK, Ze = !0);
    Ze && (n.isWebGL2 ? t.drawBuffers(Ye) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(Ye));
  }
  function Fe(je) {
    return v !== je ? (t.useProgram(je), v = je, !0) : !1;
  }
  const X = {
    [AddEquation]: t.FUNC_ADD,
    [SubtractEquation]: t.FUNC_SUBTRACT,
    [ReverseSubtractEquation]: t.FUNC_REVERSE_SUBTRACT
  };
  if (a)
    X[MinEquation] = t.MIN, X[MaxEquation] = t.MAX;
  else {
    const je = e.get("EXT_blend_minmax");
    je !== null && (X[MinEquation] = je.MIN_EXT, X[MaxEquation] = je.MAX_EXT);
  }
  const ye = {
    [ZeroFactor]: t.ZERO,
    [OneFactor]: t.ONE,
    [SrcColorFactor]: t.SRC_COLOR,
    [SrcAlphaFactor]: t.SRC_ALPHA,
    [SrcAlphaSaturateFactor]: t.SRC_ALPHA_SATURATE,
    [DstColorFactor]: t.DST_COLOR,
    [DstAlphaFactor]: t.DST_ALPHA,
    [OneMinusSrcColorFactor]: t.ONE_MINUS_SRC_COLOR,
    [OneMinusSrcAlphaFactor]: t.ONE_MINUS_SRC_ALPHA,
    [OneMinusDstColorFactor]: t.ONE_MINUS_DST_COLOR,
    [OneMinusDstAlphaFactor]: t.ONE_MINUS_DST_ALPHA,
    [ConstantColorFactor]: t.CONSTANT_COLOR,
    [OneMinusConstantColorFactor]: t.ONE_MINUS_CONSTANT_COLOR,
    [ConstantAlphaFactor]: t.CONSTANT_ALPHA,
    [OneMinusConstantAlphaFactor]: t.ONE_MINUS_CONSTANT_ALPHA
  };
  function Ae(je, ke, Ye, Ze, rt, xt, bt, wt, mt, St) {
    if (je === NoBlending) {
      y === !0 && (ne(t.BLEND), y = !1);
      return;
    }
    if (y === !1 && (H(t.BLEND), y = !0), je !== CustomBlending) {
      if (je !== A || St !== W) {
        if ((b !== AddEquation || w !== AddEquation) && (t.blendEquation(t.FUNC_ADD), b = AddEquation, w = AddEquation), St)
          switch (je) {
            case NormalBlending:
              t.blendFuncSeparate(t.ONE, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              t.blendFunc(t.ONE, t.ONE);
              break;
            case SubtractiveBlending:
              t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
              break;
            case MultiplyBlending:
              t.blendFuncSeparate(t.ZERO, t.SRC_COLOR, t.ZERO, t.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", je);
              break;
          }
        else
          switch (je) {
            case NormalBlending:
              t.blendFuncSeparate(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              t.blendFunc(t.SRC_ALPHA, t.ONE);
              break;
            case SubtractiveBlending:
              t.blendFuncSeparate(t.ZERO, t.ONE_MINUS_SRC_COLOR, t.ZERO, t.ONE);
              break;
            case MultiplyBlending:
              t.blendFunc(t.ZERO, t.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", je);
              break;
          }
        C = null, T = null, R = null, O = null, D.set(0, 0, 0), k = 0, A = je, W = St;
      }
      return;
    }
    rt = rt || ke, xt = xt || Ye, bt = bt || Ze, (ke !== b || rt !== w) && (t.blendEquationSeparate(X[ke], X[rt]), b = ke, w = rt), (Ye !== C || Ze !== T || xt !== R || bt !== O) && (t.blendFuncSeparate(ye[Ye], ye[Ze], ye[xt], ye[bt]), C = Ye, T = Ze, R = xt, O = bt), (wt.equals(D) === !1 || mt !== k) && (t.blendColor(wt.r, wt.g, wt.b, mt), D.copy(wt), k = mt), A = je, W = !1;
  }
  function fe(je, ke) {
    je.side === DoubleSide ? ne(t.CULL_FACE) : H(t.CULL_FACE);
    let Ye = je.side === BackSide;
    ke && (Ye = !Ye), _e(Ye), je.blending === NormalBlending && je.transparent === !1 ? Ae(NoBlending) : Ae(je.blending, je.blendEquation, je.blendSrc, je.blendDst, je.blendEquationAlpha, je.blendSrcAlpha, je.blendDstAlpha, je.blendColor, je.blendAlpha, je.premultipliedAlpha), u.setFunc(je.depthFunc), u.setTest(je.depthTest), u.setMask(je.depthWrite), c.setMask(je.colorWrite);
    const Ze = je.stencilWrite;
    d.setTest(Ze), Ze && (d.setMask(je.stencilWriteMask), d.setFunc(je.stencilFunc, je.stencilRef, je.stencilFuncMask), d.setOp(je.stencilFail, je.stencilZFail, je.stencilZPass)), $e(je.polygonOffset, je.polygonOffsetFactor, je.polygonOffsetUnits), je.alphaToCoverage === !0 ? H(t.SAMPLE_ALPHA_TO_COVERAGE) : ne(t.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function _e(je) {
    L !== je && (je ? t.frontFace(t.CW) : t.frontFace(t.CCW), L = je);
  }
  function Ie(je) {
    je !== CullFaceNone ? (H(t.CULL_FACE), je !== z && (je === CullFaceBack ? t.cullFace(t.BACK) : je === CullFaceFront ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : ne(t.CULL_FACE), z = je;
  }
  function Be(je) {
    je !== P && (te && t.lineWidth(je), P = je);
  }
  function $e(je, ke, Ye) {
    je ? (H(t.POLYGON_OFFSET_FILL), (Q !== ke || Y !== Ye) && (t.polygonOffset(ke, Ye), Q = ke, Y = Ye)) : ne(t.POLYGON_OFFSET_FILL);
  }
  function Me(je) {
    je ? H(t.SCISSOR_TEST) : ne(t.SCISSOR_TEST);
  }
  function J(je) {
    je === void 0 && (je = t.TEXTURE0 + ie - 1), G !== je && (t.activeTexture(je), G = je);
  }
  function K(je, ke, Ye) {
    Ye === void 0 && (G === null ? Ye = t.TEXTURE0 + ie - 1 : Ye = G);
    let Ze = U[Ye];
    Ze === void 0 && (Ze = { type: void 0, texture: void 0 }, U[Ye] = Ze), (Ze.type !== je || Ze.texture !== ke) && (G !== Ye && (t.activeTexture(Ye), G = Ye), t.bindTexture(je, ke || q[je]), Ze.type = je, Ze.texture = ke);
  }
  function ge() {
    const je = U[G];
    je !== void 0 && je.type !== void 0 && (t.bindTexture(je.type, null), je.type = void 0, je.texture = void 0);
  }
  function Ce() {
    try {
      t.compressedTexImage2D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function Oe() {
    try {
      t.compressedTexImage3D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function qe() {
    try {
      t.texSubImage2D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function ct() {
    try {
      t.texSubImage3D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function ze() {
    try {
      t.compressedTexSubImage2D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function et() {
    try {
      t.compressedTexSubImage3D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function gt() {
    try {
      t.texStorage2D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function pt() {
    try {
      t.texStorage3D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function nt() {
    try {
      t.texImage2D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function tt() {
    try {
      t.texImage3D.apply(t, arguments);
    } catch (je) {
      console.error("THREE.WebGLState:", je);
    }
  }
  function Ve(je) {
    I.equals(je) === !1 && (t.scissor(je.x, je.y, je.z, je.w), I.copy(je));
  }
  function We(je) {
    N.equals(je) === !1 && (t.viewport(je.x, je.y, je.z, je.w), N.copy(je));
  }
  function it(je, ke) {
    let Ye = h.get(ke);
    Ye === void 0 && (Ye = /* @__PURE__ */ new WeakMap(), h.set(ke, Ye));
    let Ze = Ye.get(je);
    Ze === void 0 && (Ze = t.getUniformBlockIndex(ke, je.name), Ye.set(je, Ze));
  }
  function Je(je, ke) {
    const Ze = h.get(ke).get(je);
    f.get(ke) !== Ze && (t.uniformBlockBinding(ke, Ze, je.__bindingPointIndex), f.set(ke, Ze));
  }
  function Rt() {
    t.disable(t.BLEND), t.disable(t.CULL_FACE), t.disable(t.DEPTH_TEST), t.disable(t.POLYGON_OFFSET_FILL), t.disable(t.SCISSOR_TEST), t.disable(t.STENCIL_TEST), t.disable(t.SAMPLE_ALPHA_TO_COVERAGE), t.blendEquation(t.FUNC_ADD), t.blendFunc(t.ONE, t.ZERO), t.blendFuncSeparate(t.ONE, t.ZERO, t.ONE, t.ZERO), t.blendColor(0, 0, 0, 0), t.colorMask(!0, !0, !0, !0), t.clearColor(0, 0, 0, 0), t.depthMask(!0), t.depthFunc(t.LESS), t.clearDepth(1), t.stencilMask(4294967295), t.stencilFunc(t.ALWAYS, 0, 4294967295), t.stencilOp(t.KEEP, t.KEEP, t.KEEP), t.clearStencil(0), t.cullFace(t.BACK), t.frontFace(t.CCW), t.polygonOffset(0, 0), t.activeTexture(t.TEXTURE0), t.bindFramebuffer(t.FRAMEBUFFER, null), a === !0 && (t.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), t.bindFramebuffer(t.READ_FRAMEBUFFER, null)), t.useProgram(null), t.lineWidth(1), t.scissor(0, 0, t.canvas.width, t.canvas.height), t.viewport(0, 0, t.canvas.width, t.canvas.height), g = {}, G = null, U = {}, x = {}, E = /* @__PURE__ */ new WeakMap(), m = [], v = null, y = !1, A = null, b = null, C = null, T = null, w = null, R = null, O = null, D = new Color(0, 0, 0), k = 0, W = !1, L = null, z = null, P = null, Q = null, Y = null, I.set(0, 0, t.canvas.width, t.canvas.height), N.set(0, 0, t.canvas.width, t.canvas.height), c.reset(), u.reset(), d.reset();
  }
  return {
    buffers: {
      color: c,
      depth: u,
      stencil: d
    },
    enable: H,
    disable: ne,
    bindFramebuffer: he,
    drawBuffers: j,
    useProgram: Fe,
    setBlending: Ae,
    setMaterial: fe,
    setFlipSided: _e,
    setCullFace: Ie,
    setLineWidth: Be,
    setPolygonOffset: $e,
    setScissorTest: Me,
    activeTexture: J,
    bindTexture: K,
    unbindTexture: ge,
    compressedTexImage2D: Ce,
    compressedTexImage3D: Oe,
    texImage2D: nt,
    texImage3D: tt,
    updateUBOMapping: it,
    uniformBlockBinding: Je,
    texStorage2D: gt,
    texStorage3D: pt,
    texSubImage2D: qe,
    texSubImage3D: ct,
    compressedTexSubImage2D: ze,
    compressedTexSubImage3D: et,
    scissor: Ve,
    viewport: We,
    reset: Rt
  };
}
function WebGLTextures(t, e, n, a, s, o, l) {
  const c = s.isWebGL2, u = s.maxTextures, d = s.maxCubemapSize, f = s.maxTextureSize, h = s.maxSamples, g = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, x = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), E = /* @__PURE__ */ new WeakMap();
  let m;
  const v = /* @__PURE__ */ new WeakMap();
  let y = !1;
  try {
    y = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function A(J, K) {
    return y ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(J, K)
    ) : createElementNS("canvas");
  }
  function b(J, K, ge, Ce) {
    let Oe = 1;
    if ((J.width > Ce || J.height > Ce) && (Oe = Ce / Math.max(J.width, J.height)), Oe < 1 || K === !0)
      if (typeof HTMLImageElement < "u" && J instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && J instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && J instanceof ImageBitmap) {
        const qe = K ? floorPowerOfTwo : Math.floor, ct = qe(Oe * J.width), ze = qe(Oe * J.height);
        m === void 0 && (m = A(ct, ze));
        const et = ge ? A(ct, ze) : m;
        return et.width = ct, et.height = ze, et.getContext("2d").drawImage(J, 0, 0, ct, ze), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + J.width + "x" + J.height + ") to (" + ct + "x" + ze + ")."), et;
      } else
        return "data" in J && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + J.width + "x" + J.height + ")."), J;
    return J;
  }
  function C(J) {
    return isPowerOfTwo(J.width) && isPowerOfTwo(J.height);
  }
  function T(J) {
    return c ? !1 : J.wrapS !== ClampToEdgeWrapping || J.wrapT !== ClampToEdgeWrapping || J.minFilter !== NearestFilter && J.minFilter !== LinearFilter;
  }
  function w(J, K) {
    return J.generateMipmaps && K && J.minFilter !== NearestFilter && J.minFilter !== LinearFilter;
  }
  function R(J) {
    t.generateMipmap(J);
  }
  function O(J, K, ge, Ce, Oe = !1) {
    if (c === !1)
      return K;
    if (J !== null) {
      if (t[J] !== void 0)
        return t[J];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + J + "'");
    }
    let qe = K;
    if (K === t.RED && (ge === t.FLOAT && (qe = t.R32F), ge === t.HALF_FLOAT && (qe = t.R16F), ge === t.UNSIGNED_BYTE && (qe = t.R8)), K === t.RED_INTEGER && (ge === t.UNSIGNED_BYTE && (qe = t.R8UI), ge === t.UNSIGNED_SHORT && (qe = t.R16UI), ge === t.UNSIGNED_INT && (qe = t.R32UI), ge === t.BYTE && (qe = t.R8I), ge === t.SHORT && (qe = t.R16I), ge === t.INT && (qe = t.R32I)), K === t.RG && (ge === t.FLOAT && (qe = t.RG32F), ge === t.HALF_FLOAT && (qe = t.RG16F), ge === t.UNSIGNED_BYTE && (qe = t.RG8)), K === t.RGBA) {
      const ct = Oe ? LinearTransfer : ColorManagement.getTransfer(Ce);
      ge === t.FLOAT && (qe = t.RGBA32F), ge === t.HALF_FLOAT && (qe = t.RGBA16F), ge === t.UNSIGNED_BYTE && (qe = ct === SRGBTransfer ? t.SRGB8_ALPHA8 : t.RGBA8), ge === t.UNSIGNED_SHORT_4_4_4_4 && (qe = t.RGBA4), ge === t.UNSIGNED_SHORT_5_5_5_1 && (qe = t.RGB5_A1);
    }
    return (qe === t.R16F || qe === t.R32F || qe === t.RG16F || qe === t.RG32F || qe === t.RGBA16F || qe === t.RGBA32F) && e.get("EXT_color_buffer_float"), qe;
  }
  function D(J, K, ge) {
    return w(J, ge) === !0 || J.isFramebufferTexture && J.minFilter !== NearestFilter && J.minFilter !== LinearFilter ? Math.log2(Math.max(K.width, K.height)) + 1 : J.mipmaps !== void 0 && J.mipmaps.length > 0 ? J.mipmaps.length : J.isCompressedTexture && Array.isArray(J.image) ? K.mipmaps.length : 1;
  }
  function k(J) {
    return J === NearestFilter || J === NearestMipmapNearestFilter || J === NearestMipmapLinearFilter ? t.NEAREST : t.LINEAR;
  }
  function W(J) {
    const K = J.target;
    K.removeEventListener("dispose", W), z(K), K.isVideoTexture && E.delete(K);
  }
  function L(J) {
    const K = J.target;
    K.removeEventListener("dispose", L), Q(K);
  }
  function z(J) {
    const K = a.get(J);
    if (K.__webglInit === void 0)
      return;
    const ge = J.source, Ce = v.get(ge);
    if (Ce) {
      const Oe = Ce[K.__cacheKey];
      Oe.usedTimes--, Oe.usedTimes === 0 && P(J), Object.keys(Ce).length === 0 && v.delete(ge);
    }
    a.remove(J);
  }
  function P(J) {
    const K = a.get(J);
    t.deleteTexture(K.__webglTexture);
    const ge = J.source, Ce = v.get(ge);
    delete Ce[K.__cacheKey], l.memory.textures--;
  }
  function Q(J) {
    const K = J.texture, ge = a.get(J), Ce = a.get(K);
    if (Ce.__webglTexture !== void 0 && (t.deleteTexture(Ce.__webglTexture), l.memory.textures--), J.depthTexture && J.depthTexture.dispose(), J.isWebGLCubeRenderTarget)
      for (let Oe = 0; Oe < 6; Oe++) {
        if (Array.isArray(ge.__webglFramebuffer[Oe]))
          for (let qe = 0; qe < ge.__webglFramebuffer[Oe].length; qe++)
            t.deleteFramebuffer(ge.__webglFramebuffer[Oe][qe]);
        else
          t.deleteFramebuffer(ge.__webglFramebuffer[Oe]);
        ge.__webglDepthbuffer && t.deleteRenderbuffer(ge.__webglDepthbuffer[Oe]);
      }
    else {
      if (Array.isArray(ge.__webglFramebuffer))
        for (let Oe = 0; Oe < ge.__webglFramebuffer.length; Oe++)
          t.deleteFramebuffer(ge.__webglFramebuffer[Oe]);
      else
        t.deleteFramebuffer(ge.__webglFramebuffer);
      if (ge.__webglDepthbuffer && t.deleteRenderbuffer(ge.__webglDepthbuffer), ge.__webglMultisampledFramebuffer && t.deleteFramebuffer(ge.__webglMultisampledFramebuffer), ge.__webglColorRenderbuffer)
        for (let Oe = 0; Oe < ge.__webglColorRenderbuffer.length; Oe++)
          ge.__webglColorRenderbuffer[Oe] && t.deleteRenderbuffer(ge.__webglColorRenderbuffer[Oe]);
      ge.__webglDepthRenderbuffer && t.deleteRenderbuffer(ge.__webglDepthRenderbuffer);
    }
    if (J.isWebGLMultipleRenderTargets)
      for (let Oe = 0, qe = K.length; Oe < qe; Oe++) {
        const ct = a.get(K[Oe]);
        ct.__webglTexture && (t.deleteTexture(ct.__webglTexture), l.memory.textures--), a.remove(K[Oe]);
      }
    a.remove(K), a.remove(J);
  }
  let Y = 0;
  function ie() {
    Y = 0;
  }
  function te() {
    const J = Y;
    return J >= u && console.warn("THREE.WebGLTextures: Trying to use " + J + " texture units while this GPU supports only " + u), Y += 1, J;
  }
  function Z(J) {
    const K = [];
    return K.push(J.wrapS), K.push(J.wrapT), K.push(J.wrapR || 0), K.push(J.magFilter), K.push(J.minFilter), K.push(J.anisotropy), K.push(J.internalFormat), K.push(J.format), K.push(J.type), K.push(J.generateMipmaps), K.push(J.premultiplyAlpha), K.push(J.flipY), K.push(J.unpackAlignment), K.push(J.colorSpace), K.join();
  }
  function ae(J, K) {
    const ge = a.get(J);
    if (J.isVideoTexture && $e(J), J.isRenderTargetTexture === !1 && J.version > 0 && ge.__version !== J.version) {
      const Ce = J.image;
      if (Ce === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (Ce.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        H(ge, J, K);
        return;
      }
    }
    n.bindTexture(t.TEXTURE_2D, ge.__webglTexture, t.TEXTURE0 + K);
  }
  function G(J, K) {
    const ge = a.get(J);
    if (J.version > 0 && ge.__version !== J.version) {
      H(ge, J, K);
      return;
    }
    n.bindTexture(t.TEXTURE_2D_ARRAY, ge.__webglTexture, t.TEXTURE0 + K);
  }
  function U(J, K) {
    const ge = a.get(J);
    if (J.version > 0 && ge.__version !== J.version) {
      H(ge, J, K);
      return;
    }
    n.bindTexture(t.TEXTURE_3D, ge.__webglTexture, t.TEXTURE0 + K);
  }
  function F(J, K) {
    const ge = a.get(J);
    if (J.version > 0 && ge.__version !== J.version) {
      ne(ge, J, K);
      return;
    }
    n.bindTexture(t.TEXTURE_CUBE_MAP, ge.__webglTexture, t.TEXTURE0 + K);
  }
  const M = {
    [RepeatWrapping]: t.REPEAT,
    [ClampToEdgeWrapping]: t.CLAMP_TO_EDGE,
    [MirroredRepeatWrapping]: t.MIRRORED_REPEAT
  }, I = {
    [NearestFilter]: t.NEAREST,
    [NearestMipmapNearestFilter]: t.NEAREST_MIPMAP_NEAREST,
    [NearestMipmapLinearFilter]: t.NEAREST_MIPMAP_LINEAR,
    [LinearFilter]: t.LINEAR,
    [LinearMipmapNearestFilter]: t.LINEAR_MIPMAP_NEAREST,
    [LinearMipmapLinearFilter]: t.LINEAR_MIPMAP_LINEAR
  }, N = {
    [NeverCompare]: t.NEVER,
    [AlwaysCompare]: t.ALWAYS,
    [LessCompare]: t.LESS,
    [LessEqualCompare]: t.LEQUAL,
    [EqualCompare]: t.EQUAL,
    [GreaterEqualCompare]: t.GEQUAL,
    [GreaterCompare]: t.GREATER,
    [NotEqualCompare]: t.NOTEQUAL
  };
  function V(J, K, ge) {
    if (ge ? (t.texParameteri(J, t.TEXTURE_WRAP_S, M[K.wrapS]), t.texParameteri(J, t.TEXTURE_WRAP_T, M[K.wrapT]), (J === t.TEXTURE_3D || J === t.TEXTURE_2D_ARRAY) && t.texParameteri(J, t.TEXTURE_WRAP_R, M[K.wrapR]), t.texParameteri(J, t.TEXTURE_MAG_FILTER, I[K.magFilter]), t.texParameteri(J, t.TEXTURE_MIN_FILTER, I[K.minFilter])) : (t.texParameteri(J, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(J, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), (J === t.TEXTURE_3D || J === t.TEXTURE_2D_ARRAY) && t.texParameteri(J, t.TEXTURE_WRAP_R, t.CLAMP_TO_EDGE), (K.wrapS !== ClampToEdgeWrapping || K.wrapT !== ClampToEdgeWrapping) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), t.texParameteri(J, t.TEXTURE_MAG_FILTER, k(K.magFilter)), t.texParameteri(J, t.TEXTURE_MIN_FILTER, k(K.minFilter)), K.minFilter !== NearestFilter && K.minFilter !== LinearFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), K.compareFunction && (t.texParameteri(J, t.TEXTURE_COMPARE_MODE, t.COMPARE_REF_TO_TEXTURE), t.texParameteri(J, t.TEXTURE_COMPARE_FUNC, N[K.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      const Ce = e.get("EXT_texture_filter_anisotropic");
      if (K.magFilter === NearestFilter || K.minFilter !== NearestMipmapLinearFilter && K.minFilter !== LinearMipmapLinearFilter || K.type === FloatType && e.has("OES_texture_float_linear") === !1 || c === !1 && K.type === HalfFloatType && e.has("OES_texture_half_float_linear") === !1)
        return;
      (K.anisotropy > 1 || a.get(K).__currentAnisotropy) && (t.texParameterf(J, Ce.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(K.anisotropy, s.getMaxAnisotropy())), a.get(K).__currentAnisotropy = K.anisotropy);
    }
  }
  function q(J, K) {
    let ge = !1;
    J.__webglInit === void 0 && (J.__webglInit = !0, K.addEventListener("dispose", W));
    const Ce = K.source;
    let Oe = v.get(Ce);
    Oe === void 0 && (Oe = {}, v.set(Ce, Oe));
    const qe = Z(K);
    if (qe !== J.__cacheKey) {
      Oe[qe] === void 0 && (Oe[qe] = {
        texture: t.createTexture(),
        usedTimes: 0
      }, l.memory.textures++, ge = !0), Oe[qe].usedTimes++;
      const ct = Oe[J.__cacheKey];
      ct !== void 0 && (Oe[J.__cacheKey].usedTimes--, ct.usedTimes === 0 && P(K)), J.__cacheKey = qe, J.__webglTexture = Oe[qe].texture;
    }
    return ge;
  }
  function H(J, K, ge) {
    let Ce = t.TEXTURE_2D;
    (K.isDataArrayTexture || K.isCompressedArrayTexture) && (Ce = t.TEXTURE_2D_ARRAY), K.isData3DTexture && (Ce = t.TEXTURE_3D);
    const Oe = q(J, K), qe = K.source;
    n.bindTexture(Ce, J.__webglTexture, t.TEXTURE0 + ge);
    const ct = a.get(qe);
    if (qe.version !== ct.__version || Oe === !0) {
      n.activeTexture(t.TEXTURE0 + ge);
      const ze = ColorManagement.getPrimaries(ColorManagement.workingColorSpace), et = K.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(K.colorSpace), gt = K.colorSpace === NoColorSpace || ze === et ? t.NONE : t.BROWSER_DEFAULT_WEBGL;
      t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, K.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, K.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, K.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, gt);
      const pt = T(K) && C(K.image) === !1;
      let nt = b(K.image, pt, !1, f);
      nt = Me(K, nt);
      const tt = C(nt) || c, Ve = o.convert(K.format, K.colorSpace);
      let We = o.convert(K.type), it = O(K.internalFormat, Ve, We, K.colorSpace, K.isVideoTexture);
      V(Ce, K, tt);
      let Je;
      const Rt = K.mipmaps, je = c && K.isVideoTexture !== !0, ke = ct.__version === void 0 || Oe === !0, Ye = D(K, nt, tt);
      if (K.isDepthTexture)
        it = t.DEPTH_COMPONENT, c ? K.type === FloatType ? it = t.DEPTH_COMPONENT32F : K.type === UnsignedIntType ? it = t.DEPTH_COMPONENT24 : K.type === UnsignedInt248Type ? it = t.DEPTH24_STENCIL8 : it = t.DEPTH_COMPONENT16 : K.type === FloatType && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), K.format === DepthFormat && it === t.DEPTH_COMPONENT && K.type !== UnsignedShortType && K.type !== UnsignedIntType && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), K.type = UnsignedIntType, We = o.convert(K.type)), K.format === DepthStencilFormat && it === t.DEPTH_COMPONENT && (it = t.DEPTH_STENCIL, K.type !== UnsignedInt248Type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), K.type = UnsignedInt248Type, We = o.convert(K.type))), ke && (je ? n.texStorage2D(t.TEXTURE_2D, 1, it, nt.width, nt.height) : n.texImage2D(t.TEXTURE_2D, 0, it, nt.width, nt.height, 0, Ve, We, null));
      else if (K.isDataTexture)
        if (Rt.length > 0 && tt) {
          je && ke && n.texStorage2D(t.TEXTURE_2D, Ye, it, Rt[0].width, Rt[0].height);
          for (let Ze = 0, rt = Rt.length; Ze < rt; Ze++)
            Je = Rt[Ze], je ? n.texSubImage2D(t.TEXTURE_2D, Ze, 0, 0, Je.width, Je.height, Ve, We, Je.data) : n.texImage2D(t.TEXTURE_2D, Ze, it, Je.width, Je.height, 0, Ve, We, Je.data);
          K.generateMipmaps = !1;
        } else
          je ? (ke && n.texStorage2D(t.TEXTURE_2D, Ye, it, nt.width, nt.height), n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, nt.width, nt.height, Ve, We, nt.data)) : n.texImage2D(t.TEXTURE_2D, 0, it, nt.width, nt.height, 0, Ve, We, nt.data);
      else if (K.isCompressedTexture)
        if (K.isCompressedArrayTexture) {
          je && ke && n.texStorage3D(t.TEXTURE_2D_ARRAY, Ye, it, Rt[0].width, Rt[0].height, nt.depth);
          for (let Ze = 0, rt = Rt.length; Ze < rt; Ze++)
            Je = Rt[Ze], K.format !== RGBAFormat ? Ve !== null ? je ? n.compressedTexSubImage3D(t.TEXTURE_2D_ARRAY, Ze, 0, 0, 0, Je.width, Je.height, nt.depth, Ve, Je.data, 0, 0) : n.compressedTexImage3D(t.TEXTURE_2D_ARRAY, Ze, it, Je.width, Je.height, nt.depth, 0, Je.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : je ? n.texSubImage3D(t.TEXTURE_2D_ARRAY, Ze, 0, 0, 0, Je.width, Je.height, nt.depth, Ve, We, Je.data) : n.texImage3D(t.TEXTURE_2D_ARRAY, Ze, it, Je.width, Je.height, nt.depth, 0, Ve, We, Je.data);
        } else {
          je && ke && n.texStorage2D(t.TEXTURE_2D, Ye, it, Rt[0].width, Rt[0].height);
          for (let Ze = 0, rt = Rt.length; Ze < rt; Ze++)
            Je = Rt[Ze], K.format !== RGBAFormat ? Ve !== null ? je ? n.compressedTexSubImage2D(t.TEXTURE_2D, Ze, 0, 0, Je.width, Je.height, Ve, Je.data) : n.compressedTexImage2D(t.TEXTURE_2D, Ze, it, Je.width, Je.height, 0, Je.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : je ? n.texSubImage2D(t.TEXTURE_2D, Ze, 0, 0, Je.width, Je.height, Ve, We, Je.data) : n.texImage2D(t.TEXTURE_2D, Ze, it, Je.width, Je.height, 0, Ve, We, Je.data);
        }
      else if (K.isDataArrayTexture)
        je ? (ke && n.texStorage3D(t.TEXTURE_2D_ARRAY, Ye, it, nt.width, nt.height, nt.depth), n.texSubImage3D(t.TEXTURE_2D_ARRAY, 0, 0, 0, 0, nt.width, nt.height, nt.depth, Ve, We, nt.data)) : n.texImage3D(t.TEXTURE_2D_ARRAY, 0, it, nt.width, nt.height, nt.depth, 0, Ve, We, nt.data);
      else if (K.isData3DTexture)
        je ? (ke && n.texStorage3D(t.TEXTURE_3D, Ye, it, nt.width, nt.height, nt.depth), n.texSubImage3D(t.TEXTURE_3D, 0, 0, 0, 0, nt.width, nt.height, nt.depth, Ve, We, nt.data)) : n.texImage3D(t.TEXTURE_3D, 0, it, nt.width, nt.height, nt.depth, 0, Ve, We, nt.data);
      else if (K.isFramebufferTexture) {
        if (ke)
          if (je)
            n.texStorage2D(t.TEXTURE_2D, Ye, it, nt.width, nt.height);
          else {
            let Ze = nt.width, rt = nt.height;
            for (let xt = 0; xt < Ye; xt++)
              n.texImage2D(t.TEXTURE_2D, xt, it, Ze, rt, 0, Ve, We, null), Ze >>= 1, rt >>= 1;
          }
      } else if (Rt.length > 0 && tt) {
        je && ke && n.texStorage2D(t.TEXTURE_2D, Ye, it, Rt[0].width, Rt[0].height);
        for (let Ze = 0, rt = Rt.length; Ze < rt; Ze++)
          Je = Rt[Ze], je ? n.texSubImage2D(t.TEXTURE_2D, Ze, 0, 0, Ve, We, Je) : n.texImage2D(t.TEXTURE_2D, Ze, it, Ve, We, Je);
        K.generateMipmaps = !1;
      } else
        je ? (ke && n.texStorage2D(t.TEXTURE_2D, Ye, it, nt.width, nt.height), n.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, Ve, We, nt)) : n.texImage2D(t.TEXTURE_2D, 0, it, Ve, We, nt);
      w(K, tt) && R(Ce), ct.__version = qe.version, K.onUpdate && K.onUpdate(K);
    }
    J.__version = K.version;
  }
  function ne(J, K, ge) {
    if (K.image.length !== 6)
      return;
    const Ce = q(J, K), Oe = K.source;
    n.bindTexture(t.TEXTURE_CUBE_MAP, J.__webglTexture, t.TEXTURE0 + ge);
    const qe = a.get(Oe);
    if (Oe.version !== qe.__version || Ce === !0) {
      n.activeTexture(t.TEXTURE0 + ge);
      const ct = ColorManagement.getPrimaries(ColorManagement.workingColorSpace), ze = K.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(K.colorSpace), et = K.colorSpace === NoColorSpace || ct === ze ? t.NONE : t.BROWSER_DEFAULT_WEBGL;
      t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, K.flipY), t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, K.premultiplyAlpha), t.pixelStorei(t.UNPACK_ALIGNMENT, K.unpackAlignment), t.pixelStorei(t.UNPACK_COLORSPACE_CONVERSION_WEBGL, et);
      const gt = K.isCompressedTexture || K.image[0].isCompressedTexture, pt = K.image[0] && K.image[0].isDataTexture, nt = [];
      for (let Ze = 0; Ze < 6; Ze++)
        !gt && !pt ? nt[Ze] = b(K.image[Ze], !1, !0, d) : nt[Ze] = pt ? K.image[Ze].image : K.image[Ze], nt[Ze] = Me(K, nt[Ze]);
      const tt = nt[0], Ve = C(tt) || c, We = o.convert(K.format, K.colorSpace), it = o.convert(K.type), Je = O(K.internalFormat, We, it, K.colorSpace), Rt = c && K.isVideoTexture !== !0, je = qe.__version === void 0 || Ce === !0;
      let ke = D(K, tt, Ve);
      V(t.TEXTURE_CUBE_MAP, K, Ve);
      let Ye;
      if (gt) {
        Rt && je && n.texStorage2D(t.TEXTURE_CUBE_MAP, ke, Je, tt.width, tt.height);
        for (let Ze = 0; Ze < 6; Ze++) {
          Ye = nt[Ze].mipmaps;
          for (let rt = 0; rt < Ye.length; rt++) {
            const xt = Ye[rt];
            K.format !== RGBAFormat ? We !== null ? Rt ? n.compressedTexSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt, 0, 0, xt.width, xt.height, We, xt.data) : n.compressedTexImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt, Je, xt.width, xt.height, 0, xt.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Rt ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt, 0, 0, xt.width, xt.height, We, it, xt.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt, Je, xt.width, xt.height, 0, We, it, xt.data);
          }
        }
      } else {
        Ye = K.mipmaps, Rt && je && (Ye.length > 0 && ke++, n.texStorage2D(t.TEXTURE_CUBE_MAP, ke, Je, nt[0].width, nt[0].height));
        for (let Ze = 0; Ze < 6; Ze++)
          if (pt) {
            Rt ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, 0, 0, 0, nt[Ze].width, nt[Ze].height, We, it, nt[Ze].data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, 0, Je, nt[Ze].width, nt[Ze].height, 0, We, it, nt[Ze].data);
            for (let rt = 0; rt < Ye.length; rt++) {
              const bt = Ye[rt].image[Ze].image;
              Rt ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt + 1, 0, 0, bt.width, bt.height, We, it, bt.data) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt + 1, Je, bt.width, bt.height, 0, We, it, bt.data);
            }
          } else {
            Rt ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, 0, 0, 0, We, it, nt[Ze]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, 0, Je, We, it, nt[Ze]);
            for (let rt = 0; rt < Ye.length; rt++) {
              const xt = Ye[rt];
              Rt ? n.texSubImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt + 1, 0, 0, We, it, xt.image[Ze]) : n.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + Ze, rt + 1, Je, We, it, xt.image[Ze]);
            }
          }
      }
      w(K, Ve) && R(t.TEXTURE_CUBE_MAP), qe.__version = Oe.version, K.onUpdate && K.onUpdate(K);
    }
    J.__version = K.version;
  }
  function he(J, K, ge, Ce, Oe, qe) {
    const ct = o.convert(ge.format, ge.colorSpace), ze = o.convert(ge.type), et = O(ge.internalFormat, ct, ze, ge.colorSpace);
    if (!a.get(K).__hasExternalTextures) {
      const pt = Math.max(1, K.width >> qe), nt = Math.max(1, K.height >> qe);
      Oe === t.TEXTURE_3D || Oe === t.TEXTURE_2D_ARRAY ? n.texImage3D(Oe, qe, et, pt, nt, K.depth, 0, ct, ze, null) : n.texImage2D(Oe, qe, et, pt, nt, 0, ct, ze, null);
    }
    n.bindFramebuffer(t.FRAMEBUFFER, J), Be(K) ? g.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, Ce, Oe, a.get(ge).__webglTexture, 0, Ie(K)) : (Oe === t.TEXTURE_2D || Oe >= t.TEXTURE_CUBE_MAP_POSITIVE_X && Oe <= t.TEXTURE_CUBE_MAP_NEGATIVE_Z) && t.framebufferTexture2D(t.FRAMEBUFFER, Ce, Oe, a.get(ge).__webglTexture, qe), n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function j(J, K, ge) {
    if (t.bindRenderbuffer(t.RENDERBUFFER, J), K.depthBuffer && !K.stencilBuffer) {
      let Ce = c === !0 ? t.DEPTH_COMPONENT24 : t.DEPTH_COMPONENT16;
      if (ge || Be(K)) {
        const Oe = K.depthTexture;
        Oe && Oe.isDepthTexture && (Oe.type === FloatType ? Ce = t.DEPTH_COMPONENT32F : Oe.type === UnsignedIntType && (Ce = t.DEPTH_COMPONENT24));
        const qe = Ie(K);
        Be(K) ? g.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, qe, Ce, K.width, K.height) : t.renderbufferStorageMultisample(t.RENDERBUFFER, qe, Ce, K.width, K.height);
      } else
        t.renderbufferStorage(t.RENDERBUFFER, Ce, K.width, K.height);
      t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, J);
    } else if (K.depthBuffer && K.stencilBuffer) {
      const Ce = Ie(K);
      ge && Be(K) === !1 ? t.renderbufferStorageMultisample(t.RENDERBUFFER, Ce, t.DEPTH24_STENCIL8, K.width, K.height) : Be(K) ? g.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, Ce, t.DEPTH24_STENCIL8, K.width, K.height) : t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, K.width, K.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, J);
    } else {
      const Ce = K.isWebGLMultipleRenderTargets === !0 ? K.texture : [K.texture];
      for (let Oe = 0; Oe < Ce.length; Oe++) {
        const qe = Ce[Oe], ct = o.convert(qe.format, qe.colorSpace), ze = o.convert(qe.type), et = O(qe.internalFormat, ct, ze, qe.colorSpace), gt = Ie(K);
        ge && Be(K) === !1 ? t.renderbufferStorageMultisample(t.RENDERBUFFER, gt, et, K.width, K.height) : Be(K) ? g.renderbufferStorageMultisampleEXT(t.RENDERBUFFER, gt, et, K.width, K.height) : t.renderbufferStorage(t.RENDERBUFFER, et, K.width, K.height);
      }
    }
    t.bindRenderbuffer(t.RENDERBUFFER, null);
  }
  function Fe(J, K) {
    if (K && K.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported");
    if (n.bindFramebuffer(t.FRAMEBUFFER, J), !(K.depthTexture && K.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    (!a.get(K.depthTexture).__webglTexture || K.depthTexture.image.width !== K.width || K.depthTexture.image.height !== K.height) && (K.depthTexture.image.width = K.width, K.depthTexture.image.height = K.height, K.depthTexture.needsUpdate = !0), ae(K.depthTexture, 0);
    const Ce = a.get(K.depthTexture).__webglTexture, Oe = Ie(K);
    if (K.depthTexture.format === DepthFormat)
      Be(K) ? g.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, Ce, 0, Oe) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.TEXTURE_2D, Ce, 0);
    else if (K.depthTexture.format === DepthStencilFormat)
      Be(K) ? g.framebufferTexture2DMultisampleEXT(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, Ce, 0, Oe) : t.framebufferTexture2D(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.TEXTURE_2D, Ce, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function X(J) {
    const K = a.get(J), ge = J.isWebGLCubeRenderTarget === !0;
    if (J.depthTexture && !K.__autoAllocateDepthBuffer) {
      if (ge)
        throw new Error("target.depthTexture not supported in Cube render targets");
      Fe(K.__webglFramebuffer, J);
    } else if (ge) {
      K.__webglDepthbuffer = [];
      for (let Ce = 0; Ce < 6; Ce++)
        n.bindFramebuffer(t.FRAMEBUFFER, K.__webglFramebuffer[Ce]), K.__webglDepthbuffer[Ce] = t.createRenderbuffer(), j(K.__webglDepthbuffer[Ce], J, !1);
    } else
      n.bindFramebuffer(t.FRAMEBUFFER, K.__webglFramebuffer), K.__webglDepthbuffer = t.createRenderbuffer(), j(K.__webglDepthbuffer, J, !1);
    n.bindFramebuffer(t.FRAMEBUFFER, null);
  }
  function ye(J, K, ge) {
    const Ce = a.get(J);
    K !== void 0 && he(Ce.__webglFramebuffer, J, J.texture, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, 0), ge !== void 0 && X(J);
  }
  function Ae(J) {
    const K = J.texture, ge = a.get(J), Ce = a.get(K);
    J.addEventListener("dispose", L), J.isWebGLMultipleRenderTargets !== !0 && (Ce.__webglTexture === void 0 && (Ce.__webglTexture = t.createTexture()), Ce.__version = K.version, l.memory.textures++);
    const Oe = J.isWebGLCubeRenderTarget === !0, qe = J.isWebGLMultipleRenderTargets === !0, ct = C(J) || c;
    if (Oe) {
      ge.__webglFramebuffer = [];
      for (let ze = 0; ze < 6; ze++)
        if (c && K.mipmaps && K.mipmaps.length > 0) {
          ge.__webglFramebuffer[ze] = [];
          for (let et = 0; et < K.mipmaps.length; et++)
            ge.__webglFramebuffer[ze][et] = t.createFramebuffer();
        } else
          ge.__webglFramebuffer[ze] = t.createFramebuffer();
    } else {
      if (c && K.mipmaps && K.mipmaps.length > 0) {
        ge.__webglFramebuffer = [];
        for (let ze = 0; ze < K.mipmaps.length; ze++)
          ge.__webglFramebuffer[ze] = t.createFramebuffer();
      } else
        ge.__webglFramebuffer = t.createFramebuffer();
      if (qe)
        if (s.drawBuffers) {
          const ze = J.texture;
          for (let et = 0, gt = ze.length; et < gt; et++) {
            const pt = a.get(ze[et]);
            pt.__webglTexture === void 0 && (pt.__webglTexture = t.createTexture(), l.memory.textures++);
          }
        } else
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      if (c && J.samples > 0 && Be(J) === !1) {
        const ze = qe ? K : [K];
        ge.__webglMultisampledFramebuffer = t.createFramebuffer(), ge.__webglColorRenderbuffer = [], n.bindFramebuffer(t.FRAMEBUFFER, ge.__webglMultisampledFramebuffer);
        for (let et = 0; et < ze.length; et++) {
          const gt = ze[et];
          ge.__webglColorRenderbuffer[et] = t.createRenderbuffer(), t.bindRenderbuffer(t.RENDERBUFFER, ge.__webglColorRenderbuffer[et]);
          const pt = o.convert(gt.format, gt.colorSpace), nt = o.convert(gt.type), tt = O(gt.internalFormat, pt, nt, gt.colorSpace, J.isXRRenderTarget === !0), Ve = Ie(J);
          t.renderbufferStorageMultisample(t.RENDERBUFFER, Ve, tt, J.width, J.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + et, t.RENDERBUFFER, ge.__webglColorRenderbuffer[et]);
        }
        t.bindRenderbuffer(t.RENDERBUFFER, null), J.depthBuffer && (ge.__webglDepthRenderbuffer = t.createRenderbuffer(), j(ge.__webglDepthRenderbuffer, J, !0)), n.bindFramebuffer(t.FRAMEBUFFER, null);
      }
    }
    if (Oe) {
      n.bindTexture(t.TEXTURE_CUBE_MAP, Ce.__webglTexture), V(t.TEXTURE_CUBE_MAP, K, ct);
      for (let ze = 0; ze < 6; ze++)
        if (c && K.mipmaps && K.mipmaps.length > 0)
          for (let et = 0; et < K.mipmaps.length; et++)
            he(ge.__webglFramebuffer[ze][et], J, K, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + ze, et);
        else
          he(ge.__webglFramebuffer[ze], J, K, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + ze, 0);
      w(K, ct) && R(t.TEXTURE_CUBE_MAP), n.unbindTexture();
    } else if (qe) {
      const ze = J.texture;
      for (let et = 0, gt = ze.length; et < gt; et++) {
        const pt = ze[et], nt = a.get(pt);
        n.bindTexture(t.TEXTURE_2D, nt.__webglTexture), V(t.TEXTURE_2D, pt, ct), he(ge.__webglFramebuffer, J, pt, t.COLOR_ATTACHMENT0 + et, t.TEXTURE_2D, 0), w(pt, ct) && R(t.TEXTURE_2D);
      }
      n.unbindTexture();
    } else {
      let ze = t.TEXTURE_2D;
      if ((J.isWebGL3DRenderTarget || J.isWebGLArrayRenderTarget) && (c ? ze = J.isWebGL3DRenderTarget ? t.TEXTURE_3D : t.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(ze, Ce.__webglTexture), V(ze, K, ct), c && K.mipmaps && K.mipmaps.length > 0)
        for (let et = 0; et < K.mipmaps.length; et++)
          he(ge.__webglFramebuffer[et], J, K, t.COLOR_ATTACHMENT0, ze, et);
      else
        he(ge.__webglFramebuffer, J, K, t.COLOR_ATTACHMENT0, ze, 0);
      w(K, ct) && R(ze), n.unbindTexture();
    }
    J.depthBuffer && X(J);
  }
  function fe(J) {
    const K = C(J) || c, ge = J.isWebGLMultipleRenderTargets === !0 ? J.texture : [J.texture];
    for (let Ce = 0, Oe = ge.length; Ce < Oe; Ce++) {
      const qe = ge[Ce];
      if (w(qe, K)) {
        const ct = J.isWebGLCubeRenderTarget ? t.TEXTURE_CUBE_MAP : t.TEXTURE_2D, ze = a.get(qe).__webglTexture;
        n.bindTexture(ct, ze), R(ct), n.unbindTexture();
      }
    }
  }
  function _e(J) {
    if (c && J.samples > 0 && Be(J) === !1) {
      const K = J.isWebGLMultipleRenderTargets ? J.texture : [J.texture], ge = J.width, Ce = J.height;
      let Oe = t.COLOR_BUFFER_BIT;
      const qe = [], ct = J.stencilBuffer ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT, ze = a.get(J), et = J.isWebGLMultipleRenderTargets === !0;
      if (et)
        for (let gt = 0; gt < K.length; gt++)
          n.bindFramebuffer(t.FRAMEBUFFER, ze.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + gt, t.RENDERBUFFER, null), n.bindFramebuffer(t.FRAMEBUFFER, ze.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + gt, t.TEXTURE_2D, null, 0);
      n.bindFramebuffer(t.READ_FRAMEBUFFER, ze.__webglMultisampledFramebuffer), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, ze.__webglFramebuffer);
      for (let gt = 0; gt < K.length; gt++) {
        qe.push(t.COLOR_ATTACHMENT0 + gt), J.depthBuffer && qe.push(ct);
        const pt = ze.__ignoreDepthValues !== void 0 ? ze.__ignoreDepthValues : !1;
        if (pt === !1 && (J.depthBuffer && (Oe |= t.DEPTH_BUFFER_BIT), J.stencilBuffer && (Oe |= t.STENCIL_BUFFER_BIT)), et && t.framebufferRenderbuffer(t.READ_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.RENDERBUFFER, ze.__webglColorRenderbuffer[gt]), pt === !0 && (t.invalidateFramebuffer(t.READ_FRAMEBUFFER, [ct]), t.invalidateFramebuffer(t.DRAW_FRAMEBUFFER, [ct])), et) {
          const nt = a.get(K[gt]).__webglTexture;
          t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, nt, 0);
        }
        t.blitFramebuffer(0, 0, ge, Ce, 0, 0, ge, Ce, Oe, t.NEAREST), x && t.invalidateFramebuffer(t.READ_FRAMEBUFFER, qe);
      }
      if (n.bindFramebuffer(t.READ_FRAMEBUFFER, null), n.bindFramebuffer(t.DRAW_FRAMEBUFFER, null), et)
        for (let gt = 0; gt < K.length; gt++) {
          n.bindFramebuffer(t.FRAMEBUFFER, ze.__webglMultisampledFramebuffer), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + gt, t.RENDERBUFFER, ze.__webglColorRenderbuffer[gt]);
          const pt = a.get(K[gt]).__webglTexture;
          n.bindFramebuffer(t.FRAMEBUFFER, ze.__webglFramebuffer), t.framebufferTexture2D(t.DRAW_FRAMEBUFFER, t.COLOR_ATTACHMENT0 + gt, t.TEXTURE_2D, pt, 0);
        }
      n.bindFramebuffer(t.DRAW_FRAMEBUFFER, ze.__webglMultisampledFramebuffer);
    }
  }
  function Ie(J) {
    return Math.min(h, J.samples);
  }
  function Be(J) {
    const K = a.get(J);
    return c && J.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && K.__useRenderToTexture !== !1;
  }
  function $e(J) {
    const K = l.render.frame;
    E.get(J) !== K && (E.set(J, K), J.update());
  }
  function Me(J, K) {
    const ge = J.colorSpace, Ce = J.format, Oe = J.type;
    return J.isCompressedTexture === !0 || J.isVideoTexture === !0 || J.format === _SRGBAFormat || ge !== LinearSRGBColorSpace && ge !== NoColorSpace && (ColorManagement.getTransfer(ge) === SRGBTransfer ? c === !1 ? e.has("EXT_sRGB") === !0 && Ce === RGBAFormat ? (J.format = _SRGBAFormat, J.minFilter = LinearFilter, J.generateMipmaps = !1) : K = ImageUtils.sRGBToLinear(K) : (Ce !== RGBAFormat || Oe !== UnsignedByteType) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", ge)), K;
  }
  this.allocateTextureUnit = te, this.resetTextureUnits = ie, this.setTexture2D = ae, this.setTexture2DArray = G, this.setTexture3D = U, this.setTextureCube = F, this.rebindTextures = ye, this.setupRenderTarget = Ae, this.updateRenderTargetMipmap = fe, this.updateMultisampleRenderTarget = _e, this.setupDepthRenderbuffer = X, this.setupFrameBufferTexture = he, this.useMultisampledRTT = Be;
}
function WebGLUtils(t, e, n) {
  const a = n.isWebGL2;
  function s(o, l = NoColorSpace) {
    let c;
    const u = ColorManagement.getTransfer(l);
    if (o === UnsignedByteType)
      return t.UNSIGNED_BYTE;
    if (o === UnsignedShort4444Type)
      return t.UNSIGNED_SHORT_4_4_4_4;
    if (o === UnsignedShort5551Type)
      return t.UNSIGNED_SHORT_5_5_5_1;
    if (o === ByteType)
      return t.BYTE;
    if (o === ShortType)
      return t.SHORT;
    if (o === UnsignedShortType)
      return t.UNSIGNED_SHORT;
    if (o === IntType)
      return t.INT;
    if (o === UnsignedIntType)
      return t.UNSIGNED_INT;
    if (o === FloatType)
      return t.FLOAT;
    if (o === HalfFloatType)
      return a ? t.HALF_FLOAT : (c = e.get("OES_texture_half_float"), c !== null ? c.HALF_FLOAT_OES : null);
    if (o === AlphaFormat)
      return t.ALPHA;
    if (o === RGBAFormat)
      return t.RGBA;
    if (o === LuminanceFormat)
      return t.LUMINANCE;
    if (o === LuminanceAlphaFormat)
      return t.LUMINANCE_ALPHA;
    if (o === DepthFormat)
      return t.DEPTH_COMPONENT;
    if (o === DepthStencilFormat)
      return t.DEPTH_STENCIL;
    if (o === _SRGBAFormat)
      return c = e.get("EXT_sRGB"), c !== null ? c.SRGB_ALPHA_EXT : null;
    if (o === RedFormat)
      return t.RED;
    if (o === RedIntegerFormat)
      return t.RED_INTEGER;
    if (o === RGFormat)
      return t.RG;
    if (o === RGIntegerFormat)
      return t.RG_INTEGER;
    if (o === RGBAIntegerFormat)
      return t.RGBA_INTEGER;
    if (o === RGB_S3TC_DXT1_Format || o === RGBA_S3TC_DXT1_Format || o === RGBA_S3TC_DXT3_Format || o === RGBA_S3TC_DXT5_Format)
      if (u === SRGBTransfer)
        if (c = e.get("WEBGL_compressed_texture_s3tc_srgb"), c !== null) {
          if (o === RGB_S3TC_DXT1_Format)
            return c.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (o === RGBA_S3TC_DXT1_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (o === RGBA_S3TC_DXT3_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (o === RGBA_S3TC_DXT5_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (c = e.get("WEBGL_compressed_texture_s3tc"), c !== null) {
        if (o === RGB_S3TC_DXT1_Format)
          return c.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (o === RGBA_S3TC_DXT1_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (o === RGBA_S3TC_DXT3_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (o === RGBA_S3TC_DXT5_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (o === RGB_PVRTC_4BPPV1_Format || o === RGB_PVRTC_2BPPV1_Format || o === RGBA_PVRTC_4BPPV1_Format || o === RGBA_PVRTC_2BPPV1_Format)
      if (c = e.get("WEBGL_compressed_texture_pvrtc"), c !== null) {
        if (o === RGB_PVRTC_4BPPV1_Format)
          return c.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (o === RGB_PVRTC_2BPPV1_Format)
          return c.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (o === RGBA_PVRTC_4BPPV1_Format)
          return c.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (o === RGBA_PVRTC_2BPPV1_Format)
          return c.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (o === RGB_ETC1_Format)
      return c = e.get("WEBGL_compressed_texture_etc1"), c !== null ? c.COMPRESSED_RGB_ETC1_WEBGL : null;
    if (o === RGB_ETC2_Format || o === RGBA_ETC2_EAC_Format)
      if (c = e.get("WEBGL_compressed_texture_etc"), c !== null) {
        if (o === RGB_ETC2_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ETC2 : c.COMPRESSED_RGB8_ETC2;
        if (o === RGBA_ETC2_EAC_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : c.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (o === RGBA_ASTC_4x4_Format || o === RGBA_ASTC_5x4_Format || o === RGBA_ASTC_5x5_Format || o === RGBA_ASTC_6x5_Format || o === RGBA_ASTC_6x6_Format || o === RGBA_ASTC_8x5_Format || o === RGBA_ASTC_8x6_Format || o === RGBA_ASTC_8x8_Format || o === RGBA_ASTC_10x5_Format || o === RGBA_ASTC_10x6_Format || o === RGBA_ASTC_10x8_Format || o === RGBA_ASTC_10x10_Format || o === RGBA_ASTC_12x10_Format || o === RGBA_ASTC_12x12_Format)
      if (c = e.get("WEBGL_compressed_texture_astc"), c !== null) {
        if (o === RGBA_ASTC_4x4_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : c.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (o === RGBA_ASTC_5x4_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : c.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (o === RGBA_ASTC_5x5_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : c.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (o === RGBA_ASTC_6x5_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : c.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (o === RGBA_ASTC_6x6_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : c.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (o === RGBA_ASTC_8x5_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : c.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (o === RGBA_ASTC_8x6_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : c.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (o === RGBA_ASTC_8x8_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : c.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (o === RGBA_ASTC_10x5_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : c.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (o === RGBA_ASTC_10x6_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : c.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (o === RGBA_ASTC_10x8_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : c.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (o === RGBA_ASTC_10x10_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : c.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (o === RGBA_ASTC_12x10_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : c.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (o === RGBA_ASTC_12x12_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : c.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (o === RGBA_BPTC_Format || o === RGB_BPTC_SIGNED_Format || o === RGB_BPTC_UNSIGNED_Format)
      if (c = e.get("EXT_texture_compression_bptc"), c !== null) {
        if (o === RGBA_BPTC_Format)
          return u === SRGBTransfer ? c.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : c.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (o === RGB_BPTC_SIGNED_Format)
          return c.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (o === RGB_BPTC_UNSIGNED_Format)
          return c.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (o === RED_RGTC1_Format || o === SIGNED_RED_RGTC1_Format || o === RED_GREEN_RGTC2_Format || o === SIGNED_RED_GREEN_RGTC2_Format)
      if (c = e.get("EXT_texture_compression_rgtc"), c !== null) {
        if (o === RGBA_BPTC_Format)
          return c.COMPRESSED_RED_RGTC1_EXT;
        if (o === SIGNED_RED_RGTC1_Format)
          return c.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (o === RED_GREEN_RGTC2_Format)
          return c.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (o === SIGNED_RED_GREEN_RGTC2_Format)
          return c.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return o === UnsignedInt248Type ? a ? t.UNSIGNED_INT_24_8 : (c = e.get("WEBGL_depth_texture"), c !== null ? c.UNSIGNED_INT_24_8_WEBGL : null) : t[o] !== void 0 ? t[o] : null;
  }
  return { convert: s };
}
class ArrayCamera extends PerspectiveCamera {
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e;
  }
}
class Group extends Object3D {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const _moveEvent = { type: "move" };
class WebXRController {
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  getHandSpace() {
    return this._hand === null && (this._hand = new Group(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new Group(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Vector3(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Vector3()), this._targetRay;
  }
  getGripSpace() {
    return this._grip === null && (this._grip = new Group(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Vector3(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Vector3()), this._grip;
  }
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  connect(e) {
    if (e && e.hand) {
      const n = this._hand;
      if (n)
        for (const a of e.hand.values())
          this._getHandJoint(n, a);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  update(e, n, a) {
    let s = null, o = null, l = null;
    const c = this._targetRay, u = this._grip, d = this._hand;
    if (e && n.session.visibilityState !== "visible-blurred") {
      if (d && e.hand) {
        l = !0;
        for (const m of e.hand.values()) {
          const v = n.getJointPose(m, a), y = this._getHandJoint(d, m);
          v !== null && (y.matrix.fromArray(v.transform.matrix), y.matrix.decompose(y.position, y.rotation, y.scale), y.matrixWorldNeedsUpdate = !0, y.jointRadius = v.radius), y.visible = v !== null;
        }
        const f = d.joints["index-finger-tip"], h = d.joints["thumb-tip"], g = f.position.distanceTo(h.position), x = 0.02, E = 5e-3;
        d.inputState.pinching && g > x + E ? (d.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !d.inputState.pinching && g <= x - E && (d.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        u !== null && e.gripSpace && (o = n.getPose(e.gripSpace, a), o !== null && (u.matrix.fromArray(o.transform.matrix), u.matrix.decompose(u.position, u.rotation, u.scale), u.matrixWorldNeedsUpdate = !0, o.linearVelocity ? (u.hasLinearVelocity = !0, u.linearVelocity.copy(o.linearVelocity)) : u.hasLinearVelocity = !1, o.angularVelocity ? (u.hasAngularVelocity = !0, u.angularVelocity.copy(o.angularVelocity)) : u.hasAngularVelocity = !1));
      c !== null && (s = n.getPose(e.targetRaySpace, a), s === null && o !== null && (s = o), s !== null && (c.matrix.fromArray(s.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), c.matrixWorldNeedsUpdate = !0, s.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(s.linearVelocity)) : c.hasLinearVelocity = !1, s.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(s.angularVelocity)) : c.hasAngularVelocity = !1, this.dispatchEvent(_moveEvent)));
    }
    return c !== null && (c.visible = s !== null), u !== null && (u.visible = o !== null), d !== null && (d.visible = l !== null), this;
  }
  // private method
  _getHandJoint(e, n) {
    if (e.joints[n.jointName] === void 0) {
      const a = new Group();
      a.matrixAutoUpdate = !1, a.visible = !1, e.joints[n.jointName] = a, e.add(a);
    }
    return e.joints[n.jointName];
  }
}
class DepthTexture extends Texture {
  constructor(e, n, a, s, o, l, c, u, d, f) {
    if (f = f !== void 0 ? f : DepthFormat, f !== DepthFormat && f !== DepthStencilFormat)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    a === void 0 && f === DepthFormat && (a = UnsignedIntType), a === void 0 && f === DepthStencilFormat && (a = UnsignedInt248Type), super(null, s, o, l, c, u, f, a, d), this.isDepthTexture = !0, this.image = { width: e, height: n }, this.magFilter = c !== void 0 ? c : NearestFilter, this.minFilter = u !== void 0 ? u : NearestFilter, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return this.compareFunction !== null && (n.compareFunction = this.compareFunction), n;
  }
}
class WebXRManager extends EventDispatcher {
  constructor(e, n) {
    super();
    const a = this;
    let s = null, o = 1, l = null, c = "local-floor", u = 1, d = null, f = null, h = null, g = null, x = null, E = null;
    const m = n.getContextAttributes();
    let v = null, y = null;
    const A = [], b = [], C = new PerspectiveCamera();
    C.layers.enable(1), C.viewport = new Vector4();
    const T = new PerspectiveCamera();
    T.layers.enable(2), T.viewport = new Vector4();
    const w = [C, T], R = new ArrayCamera();
    R.layers.enable(1), R.layers.enable(2);
    let O = null, D = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(G) {
      let U = A[G];
      return U === void 0 && (U = new WebXRController(), A[G] = U), U.getTargetRaySpace();
    }, this.getControllerGrip = function(G) {
      let U = A[G];
      return U === void 0 && (U = new WebXRController(), A[G] = U), U.getGripSpace();
    }, this.getHand = function(G) {
      let U = A[G];
      return U === void 0 && (U = new WebXRController(), A[G] = U), U.getHandSpace();
    };
    function k(G) {
      const U = b.indexOf(G.inputSource);
      if (U === -1)
        return;
      const F = A[U];
      F !== void 0 && (F.update(G.inputSource, G.frame, d || l), F.dispatchEvent({ type: G.type, data: G.inputSource }));
    }
    function W() {
      s.removeEventListener("select", k), s.removeEventListener("selectstart", k), s.removeEventListener("selectend", k), s.removeEventListener("squeeze", k), s.removeEventListener("squeezestart", k), s.removeEventListener("squeezeend", k), s.removeEventListener("end", W), s.removeEventListener("inputsourceschange", L);
      for (let G = 0; G < A.length; G++) {
        const U = b[G];
        U !== null && (b[G] = null, A[G].disconnect(U));
      }
      O = null, D = null, e.setRenderTarget(v), x = null, g = null, h = null, s = null, y = null, ae.stop(), a.isPresenting = !1, a.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(G) {
      o = G, a.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(G) {
      c = G, a.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return d || l;
    }, this.setReferenceSpace = function(G) {
      d = G;
    }, this.getBaseLayer = function() {
      return g !== null ? g : x;
    }, this.getBinding = function() {
      return h;
    }, this.getFrame = function() {
      return E;
    }, this.getSession = function() {
      return s;
    }, this.setSession = async function(G) {
      if (s = G, s !== null) {
        if (v = e.getRenderTarget(), s.addEventListener("select", k), s.addEventListener("selectstart", k), s.addEventListener("selectend", k), s.addEventListener("squeeze", k), s.addEventListener("squeezestart", k), s.addEventListener("squeezeend", k), s.addEventListener("end", W), s.addEventListener("inputsourceschange", L), m.xrCompatible !== !0 && await n.makeXRCompatible(), s.renderState.layers === void 0 || e.capabilities.isWebGL2 === !1) {
          const U = {
            antialias: s.renderState.layers === void 0 ? m.antialias : !0,
            alpha: !0,
            depth: m.depth,
            stencil: m.stencil,
            framebufferScaleFactor: o
          };
          x = new XRWebGLLayer(s, n, U), s.updateRenderState({ baseLayer: x }), y = new WebGLRenderTarget(
            x.framebufferWidth,
            x.framebufferHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              colorSpace: e.outputColorSpace,
              stencilBuffer: m.stencil
            }
          );
        } else {
          let U = null, F = null, M = null;
          m.depth && (M = m.stencil ? n.DEPTH24_STENCIL8 : n.DEPTH_COMPONENT24, U = m.stencil ? DepthStencilFormat : DepthFormat, F = m.stencil ? UnsignedInt248Type : UnsignedIntType);
          const I = {
            colorFormat: n.RGBA8,
            depthFormat: M,
            scaleFactor: o
          };
          h = new XRWebGLBinding(s, n), g = h.createProjectionLayer(I), s.updateRenderState({ layers: [g] }), y = new WebGLRenderTarget(
            g.textureWidth,
            g.textureHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              depthTexture: new DepthTexture(g.textureWidth, g.textureHeight, F, void 0, void 0, void 0, void 0, void 0, void 0, U),
              stencilBuffer: m.stencil,
              colorSpace: e.outputColorSpace,
              samples: m.antialias ? 4 : 0
            }
          );
          const N = e.properties.get(y);
          N.__ignoreDepthValues = g.ignoreDepthValues;
        }
        y.isXRRenderTarget = !0, this.setFoveation(u), d = null, l = await s.requestReferenceSpace(c), ae.setContext(s), ae.start(), a.isPresenting = !0, a.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (s !== null)
        return s.environmentBlendMode;
    };
    function L(G) {
      for (let U = 0; U < G.removed.length; U++) {
        const F = G.removed[U], M = b.indexOf(F);
        M >= 0 && (b[M] = null, A[M].disconnect(F));
      }
      for (let U = 0; U < G.added.length; U++) {
        const F = G.added[U];
        let M = b.indexOf(F);
        if (M === -1) {
          for (let N = 0; N < A.length; N++)
            if (N >= b.length) {
              b.push(F), M = N;
              break;
            } else if (b[N] === null) {
              b[N] = F, M = N;
              break;
            }
          if (M === -1)
            break;
        }
        const I = A[M];
        I && I.connect(F);
      }
    }
    const z = new Vector3(), P = new Vector3();
    function Q(G, U, F) {
      z.setFromMatrixPosition(U.matrixWorld), P.setFromMatrixPosition(F.matrixWorld);
      const M = z.distanceTo(P), I = U.projectionMatrix.elements, N = F.projectionMatrix.elements, V = I[14] / (I[10] - 1), q = I[14] / (I[10] + 1), H = (I[9] + 1) / I[5], ne = (I[9] - 1) / I[5], he = (I[8] - 1) / I[0], j = (N[8] + 1) / N[0], Fe = V * he, X = V * j, ye = M / (-he + j), Ae = ye * -he;
      U.matrixWorld.decompose(G.position, G.quaternion, G.scale), G.translateX(Ae), G.translateZ(ye), G.matrixWorld.compose(G.position, G.quaternion, G.scale), G.matrixWorldInverse.copy(G.matrixWorld).invert();
      const fe = V + ye, _e = q + ye, Ie = Fe - Ae, Be = X + (M - Ae), $e = H * q / _e * fe, Me = ne * q / _e * fe;
      G.projectionMatrix.makePerspective(Ie, Be, $e, Me, fe, _e), G.projectionMatrixInverse.copy(G.projectionMatrix).invert();
    }
    function Y(G, U) {
      U === null ? G.matrixWorld.copy(G.matrix) : G.matrixWorld.multiplyMatrices(U.matrixWorld, G.matrix), G.matrixWorldInverse.copy(G.matrixWorld).invert();
    }
    this.updateCamera = function(G) {
      if (s === null)
        return;
      R.near = T.near = C.near = G.near, R.far = T.far = C.far = G.far, (O !== R.near || D !== R.far) && (s.updateRenderState({
        depthNear: R.near,
        depthFar: R.far
      }), O = R.near, D = R.far);
      const U = G.parent, F = R.cameras;
      Y(R, U);
      for (let M = 0; M < F.length; M++)
        Y(F[M], U);
      F.length === 2 ? Q(R, C, T) : R.projectionMatrix.copy(C.projectionMatrix), ie(G, R, U);
    };
    function ie(G, U, F) {
      F === null ? G.matrix.copy(U.matrixWorld) : (G.matrix.copy(F.matrixWorld), G.matrix.invert(), G.matrix.multiply(U.matrixWorld)), G.matrix.decompose(G.position, G.quaternion, G.scale), G.updateMatrixWorld(!0), G.projectionMatrix.copy(U.projectionMatrix), G.projectionMatrixInverse.copy(U.projectionMatrixInverse), G.isPerspectiveCamera && (G.fov = RAD2DEG * 2 * Math.atan(1 / G.projectionMatrix.elements[5]), G.zoom = 1);
    }
    this.getCamera = function() {
      return R;
    }, this.getFoveation = function() {
      if (!(g === null && x === null))
        return u;
    }, this.setFoveation = function(G) {
      u = G, g !== null && (g.fixedFoveation = G), x !== null && x.fixedFoveation !== void 0 && (x.fixedFoveation = G);
    };
    let te = null;
    function Z(G, U) {
      if (f = U.getViewerPose(d || l), E = U, f !== null) {
        const F = f.views;
        x !== null && (e.setRenderTargetFramebuffer(y, x.framebuffer), e.setRenderTarget(y));
        let M = !1;
        F.length !== R.cameras.length && (R.cameras.length = 0, M = !0);
        for (let I = 0; I < F.length; I++) {
          const N = F[I];
          let V = null;
          if (x !== null)
            V = x.getViewport(N);
          else {
            const H = h.getViewSubImage(g, N);
            V = H.viewport, I === 0 && (e.setRenderTargetTextures(
              y,
              H.colorTexture,
              g.ignoreDepthValues ? void 0 : H.depthStencilTexture
            ), e.setRenderTarget(y));
          }
          let q = w[I];
          q === void 0 && (q = new PerspectiveCamera(), q.layers.enable(I), q.viewport = new Vector4(), w[I] = q), q.matrix.fromArray(N.transform.matrix), q.matrix.decompose(q.position, q.quaternion, q.scale), q.projectionMatrix.fromArray(N.projectionMatrix), q.projectionMatrixInverse.copy(q.projectionMatrix).invert(), q.viewport.set(V.x, V.y, V.width, V.height), I === 0 && (R.matrix.copy(q.matrix), R.matrix.decompose(R.position, R.quaternion, R.scale)), M === !0 && R.cameras.push(q);
        }
      }
      for (let F = 0; F < A.length; F++) {
        const M = b[F], I = A[F];
        M !== null && I !== void 0 && I.update(M, U, d || l);
      }
      te && te(G, U), U.detectedPlanes && a.dispatchEvent({ type: "planesdetected", data: U }), E = null;
    }
    const ae = new WebGLAnimation();
    ae.setAnimationLoop(Z), this.setAnimationLoop = function(G) {
      te = G;
    }, this.dispose = function() {
    };
  }
}
function WebGLMaterials(t, e) {
  function n(v, y) {
    v.matrixAutoUpdate === !0 && v.updateMatrix(), y.value.copy(v.matrix);
  }
  function a(v, y) {
    y.color.getRGB(v.fogColor.value, getUnlitUniformColorSpace(t)), y.isFog ? (v.fogNear.value = y.near, v.fogFar.value = y.far) : y.isFogExp2 && (v.fogDensity.value = y.density);
  }
  function s(v, y, A, b, C) {
    y.isMeshBasicMaterial || y.isMeshLambertMaterial ? o(v, y) : y.isMeshToonMaterial ? (o(v, y), h(v, y)) : y.isMeshPhongMaterial ? (o(v, y), f(v, y)) : y.isMeshStandardMaterial ? (o(v, y), g(v, y), y.isMeshPhysicalMaterial && x(v, y, C)) : y.isMeshMatcapMaterial ? (o(v, y), E(v, y)) : y.isMeshDepthMaterial ? o(v, y) : y.isMeshDistanceMaterial ? (o(v, y), m(v, y)) : y.isMeshNormalMaterial ? o(v, y) : y.isLineBasicMaterial ? (l(v, y), y.isLineDashedMaterial && c(v, y)) : y.isPointsMaterial ? u(v, y, A, b) : y.isSpriteMaterial ? d(v, y) : y.isShadowMaterial ? (v.color.value.copy(y.color), v.opacity.value = y.opacity) : y.isShaderMaterial && (y.uniformsNeedUpdate = !1);
  }
  function o(v, y) {
    v.opacity.value = y.opacity, y.color && v.diffuse.value.copy(y.color), y.emissive && v.emissive.value.copy(y.emissive).multiplyScalar(y.emissiveIntensity), y.map && (v.map.value = y.map, n(y.map, v.mapTransform)), y.alphaMap && (v.alphaMap.value = y.alphaMap, n(y.alphaMap, v.alphaMapTransform)), y.bumpMap && (v.bumpMap.value = y.bumpMap, n(y.bumpMap, v.bumpMapTransform), v.bumpScale.value = y.bumpScale, y.side === BackSide && (v.bumpScale.value *= -1)), y.normalMap && (v.normalMap.value = y.normalMap, n(y.normalMap, v.normalMapTransform), v.normalScale.value.copy(y.normalScale), y.side === BackSide && v.normalScale.value.negate()), y.displacementMap && (v.displacementMap.value = y.displacementMap, n(y.displacementMap, v.displacementMapTransform), v.displacementScale.value = y.displacementScale, v.displacementBias.value = y.displacementBias), y.emissiveMap && (v.emissiveMap.value = y.emissiveMap, n(y.emissiveMap, v.emissiveMapTransform)), y.specularMap && (v.specularMap.value = y.specularMap, n(y.specularMap, v.specularMapTransform)), y.alphaTest > 0 && (v.alphaTest.value = y.alphaTest);
    const A = e.get(y).envMap;
    if (A && (v.envMap.value = A, v.flipEnvMap.value = A.isCubeTexture && A.isRenderTargetTexture === !1 ? -1 : 1, v.reflectivity.value = y.reflectivity, v.ior.value = y.ior, v.refractionRatio.value = y.refractionRatio), y.lightMap) {
      v.lightMap.value = y.lightMap;
      const b = t._useLegacyLights === !0 ? Math.PI : 1;
      v.lightMapIntensity.value = y.lightMapIntensity * b, n(y.lightMap, v.lightMapTransform);
    }
    y.aoMap && (v.aoMap.value = y.aoMap, v.aoMapIntensity.value = y.aoMapIntensity, n(y.aoMap, v.aoMapTransform));
  }
  function l(v, y) {
    v.diffuse.value.copy(y.color), v.opacity.value = y.opacity, y.map && (v.map.value = y.map, n(y.map, v.mapTransform));
  }
  function c(v, y) {
    v.dashSize.value = y.dashSize, v.totalSize.value = y.dashSize + y.gapSize, v.scale.value = y.scale;
  }
  function u(v, y, A, b) {
    v.diffuse.value.copy(y.color), v.opacity.value = y.opacity, v.size.value = y.size * A, v.scale.value = b * 0.5, y.map && (v.map.value = y.map, n(y.map, v.uvTransform)), y.alphaMap && (v.alphaMap.value = y.alphaMap, n(y.alphaMap, v.alphaMapTransform)), y.alphaTest > 0 && (v.alphaTest.value = y.alphaTest);
  }
  function d(v, y) {
    v.diffuse.value.copy(y.color), v.opacity.value = y.opacity, v.rotation.value = y.rotation, y.map && (v.map.value = y.map, n(y.map, v.mapTransform)), y.alphaMap && (v.alphaMap.value = y.alphaMap, n(y.alphaMap, v.alphaMapTransform)), y.alphaTest > 0 && (v.alphaTest.value = y.alphaTest);
  }
  function f(v, y) {
    v.specular.value.copy(y.specular), v.shininess.value = Math.max(y.shininess, 1e-4);
  }
  function h(v, y) {
    y.gradientMap && (v.gradientMap.value = y.gradientMap);
  }
  function g(v, y) {
    v.metalness.value = y.metalness, y.metalnessMap && (v.metalnessMap.value = y.metalnessMap, n(y.metalnessMap, v.metalnessMapTransform)), v.roughness.value = y.roughness, y.roughnessMap && (v.roughnessMap.value = y.roughnessMap, n(y.roughnessMap, v.roughnessMapTransform)), e.get(y).envMap && (v.envMapIntensity.value = y.envMapIntensity);
  }
  function x(v, y, A) {
    v.ior.value = y.ior, y.sheen > 0 && (v.sheenColor.value.copy(y.sheenColor).multiplyScalar(y.sheen), v.sheenRoughness.value = y.sheenRoughness, y.sheenColorMap && (v.sheenColorMap.value = y.sheenColorMap, n(y.sheenColorMap, v.sheenColorMapTransform)), y.sheenRoughnessMap && (v.sheenRoughnessMap.value = y.sheenRoughnessMap, n(y.sheenRoughnessMap, v.sheenRoughnessMapTransform))), y.clearcoat > 0 && (v.clearcoat.value = y.clearcoat, v.clearcoatRoughness.value = y.clearcoatRoughness, y.clearcoatMap && (v.clearcoatMap.value = y.clearcoatMap, n(y.clearcoatMap, v.clearcoatMapTransform)), y.clearcoatRoughnessMap && (v.clearcoatRoughnessMap.value = y.clearcoatRoughnessMap, n(y.clearcoatRoughnessMap, v.clearcoatRoughnessMapTransform)), y.clearcoatNormalMap && (v.clearcoatNormalMap.value = y.clearcoatNormalMap, n(y.clearcoatNormalMap, v.clearcoatNormalMapTransform), v.clearcoatNormalScale.value.copy(y.clearcoatNormalScale), y.side === BackSide && v.clearcoatNormalScale.value.negate())), y.iridescence > 0 && (v.iridescence.value = y.iridescence, v.iridescenceIOR.value = y.iridescenceIOR, v.iridescenceThicknessMinimum.value = y.iridescenceThicknessRange[0], v.iridescenceThicknessMaximum.value = y.iridescenceThicknessRange[1], y.iridescenceMap && (v.iridescenceMap.value = y.iridescenceMap, n(y.iridescenceMap, v.iridescenceMapTransform)), y.iridescenceThicknessMap && (v.iridescenceThicknessMap.value = y.iridescenceThicknessMap, n(y.iridescenceThicknessMap, v.iridescenceThicknessMapTransform))), y.transmission > 0 && (v.transmission.value = y.transmission, v.transmissionSamplerMap.value = A.texture, v.transmissionSamplerSize.value.set(A.width, A.height), y.transmissionMap && (v.transmissionMap.value = y.transmissionMap, n(y.transmissionMap, v.transmissionMapTransform)), v.thickness.value = y.thickness, y.thicknessMap && (v.thicknessMap.value = y.thicknessMap, n(y.thicknessMap, v.thicknessMapTransform)), v.attenuationDistance.value = y.attenuationDistance, v.attenuationColor.value.copy(y.attenuationColor)), y.anisotropy > 0 && (v.anisotropyVector.value.set(y.anisotropy * Math.cos(y.anisotropyRotation), y.anisotropy * Math.sin(y.anisotropyRotation)), y.anisotropyMap && (v.anisotropyMap.value = y.anisotropyMap, n(y.anisotropyMap, v.anisotropyMapTransform))), v.specularIntensity.value = y.specularIntensity, v.specularColor.value.copy(y.specularColor), y.specularColorMap && (v.specularColorMap.value = y.specularColorMap, n(y.specularColorMap, v.specularColorMapTransform)), y.specularIntensityMap && (v.specularIntensityMap.value = y.specularIntensityMap, n(y.specularIntensityMap, v.specularIntensityMapTransform));
  }
  function E(v, y) {
    y.matcap && (v.matcap.value = y.matcap);
  }
  function m(v, y) {
    const A = e.get(y).light;
    v.referencePosition.value.setFromMatrixPosition(A.matrixWorld), v.nearDistance.value = A.shadow.camera.near, v.farDistance.value = A.shadow.camera.far;
  }
  return {
    refreshFogUniforms: a,
    refreshMaterialUniforms: s
  };
}
function WebGLUniformsGroups(t, e, n, a) {
  let s = {}, o = {}, l = [];
  const c = n.isWebGL2 ? t.getParameter(t.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  function u(A, b) {
    const C = b.program;
    a.uniformBlockBinding(A, C);
  }
  function d(A, b) {
    let C = s[A.id];
    C === void 0 && (E(A), C = f(A), s[A.id] = C, A.addEventListener("dispose", v));
    const T = b.program;
    a.updateUBOMapping(A, T);
    const w = e.render.frame;
    o[A.id] !== w && (g(A), o[A.id] = w);
  }
  function f(A) {
    const b = h();
    A.__bindingPointIndex = b;
    const C = t.createBuffer(), T = A.__size, w = A.usage;
    return t.bindBuffer(t.UNIFORM_BUFFER, C), t.bufferData(t.UNIFORM_BUFFER, T, w), t.bindBuffer(t.UNIFORM_BUFFER, null), t.bindBufferBase(t.UNIFORM_BUFFER, b, C), C;
  }
  function h() {
    for (let A = 0; A < c; A++)
      if (l.indexOf(A) === -1)
        return l.push(A), A;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function g(A) {
    const b = s[A.id], C = A.uniforms, T = A.__cache;
    t.bindBuffer(t.UNIFORM_BUFFER, b);
    for (let w = 0, R = C.length; w < R; w++) {
      const O = C[w];
      if (x(O, w, T) === !0) {
        const D = O.__offset, k = Array.isArray(O.value) ? O.value : [O.value];
        let W = 0;
        for (let L = 0; L < k.length; L++) {
          const z = k[L], P = m(z);
          typeof z == "number" ? (O.__data[0] = z, t.bufferSubData(t.UNIFORM_BUFFER, D + W, O.__data)) : z.isMatrix3 ? (O.__data[0] = z.elements[0], O.__data[1] = z.elements[1], O.__data[2] = z.elements[2], O.__data[3] = z.elements[0], O.__data[4] = z.elements[3], O.__data[5] = z.elements[4], O.__data[6] = z.elements[5], O.__data[7] = z.elements[0], O.__data[8] = z.elements[6], O.__data[9] = z.elements[7], O.__data[10] = z.elements[8], O.__data[11] = z.elements[0]) : (z.toArray(O.__data, W), W += P.storage / Float32Array.BYTES_PER_ELEMENT);
        }
        t.bufferSubData(t.UNIFORM_BUFFER, D, O.__data);
      }
    }
    t.bindBuffer(t.UNIFORM_BUFFER, null);
  }
  function x(A, b, C) {
    const T = A.value;
    if (C[b] === void 0) {
      if (typeof T == "number")
        C[b] = T;
      else {
        const w = Array.isArray(T) ? T : [T], R = [];
        for (let O = 0; O < w.length; O++)
          R.push(w[O].clone());
        C[b] = R;
      }
      return !0;
    } else if (typeof T == "number") {
      if (C[b] !== T)
        return C[b] = T, !0;
    } else {
      const w = Array.isArray(C[b]) ? C[b] : [C[b]], R = Array.isArray(T) ? T : [T];
      for (let O = 0; O < w.length; O++) {
        const D = w[O];
        if (D.equals(R[O]) === !1)
          return D.copy(R[O]), !0;
      }
    }
    return !1;
  }
  function E(A) {
    const b = A.uniforms;
    let C = 0;
    const T = 16;
    let w = 0;
    for (let R = 0, O = b.length; R < O; R++) {
      const D = b[R], k = {
        boundary: 0,
        // bytes
        storage: 0
        // bytes
      }, W = Array.isArray(D.value) ? D.value : [D.value];
      for (let L = 0, z = W.length; L < z; L++) {
        const P = W[L], Q = m(P);
        k.boundary += Q.boundary, k.storage += Q.storage;
      }
      if (D.__data = new Float32Array(k.storage / Float32Array.BYTES_PER_ELEMENT), D.__offset = C, R > 0) {
        w = C % T;
        const L = T - w;
        w !== 0 && L - k.boundary < 0 && (C += T - w, D.__offset = C);
      }
      C += k.storage;
    }
    return w = C % T, w > 0 && (C += T - w), A.__size = C, A.__cache = {}, this;
  }
  function m(A) {
    const b = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof A == "number" ? (b.boundary = 4, b.storage = 4) : A.isVector2 ? (b.boundary = 8, b.storage = 8) : A.isVector3 || A.isColor ? (b.boundary = 16, b.storage = 12) : A.isVector4 ? (b.boundary = 16, b.storage = 16) : A.isMatrix3 ? (b.boundary = 48, b.storage = 48) : A.isMatrix4 ? (b.boundary = 64, b.storage = 64) : A.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", A), b;
  }
  function v(A) {
    const b = A.target;
    b.removeEventListener("dispose", v);
    const C = l.indexOf(b.__bindingPointIndex);
    l.splice(C, 1), t.deleteBuffer(s[b.id]), delete s[b.id], delete o[b.id];
  }
  function y() {
    for (const A in s)
      t.deleteBuffer(s[A]);
    l = [], s = {}, o = {};
  }
  return {
    bind: u,
    update: d,
    dispose: y
  };
}
class WebGLRenderer {
  constructor(e = {}) {
    const {
      canvas: n = createCanvasElement(),
      context: a = null,
      depth: s = !0,
      stencil: o = !0,
      alpha: l = !1,
      antialias: c = !1,
      premultipliedAlpha: u = !0,
      preserveDrawingBuffer: d = !1,
      powerPreference: f = "default",
      failIfMajorPerformanceCaveat: h = !1
    } = e;
    this.isWebGLRenderer = !0;
    let g;
    a !== null ? g = a.getContextAttributes().alpha : g = l;
    const x = new Uint32Array(4), E = new Int32Array(4);
    let m = null, v = null;
    const y = [], A = [];
    this.domElement = n, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = SRGBColorSpace, this._useLegacyLights = !1, this.toneMapping = NoToneMapping, this.toneMappingExposure = 1;
    const b = this;
    let C = !1, T = 0, w = 0, R = null, O = -1, D = null;
    const k = new Vector4(), W = new Vector4();
    let L = null;
    const z = new Color(0);
    let P = 0, Q = n.width, Y = n.height, ie = 1, te = null, Z = null;
    const ae = new Vector4(0, 0, Q, Y), G = new Vector4(0, 0, Q, Y);
    let U = !1;
    const F = new Frustum();
    let M = !1, I = !1, N = null;
    const V = new Matrix4(), q = new Vector2(), H = new Vector3(), ne = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    function he() {
      return R === null ? ie : 1;
    }
    let j = a;
    function Fe(de, ve) {
      for (let Se = 0; Se < de.length; Se++) {
        const we = de[Se], Ue = n.getContext(we, ve);
        if (Ue !== null)
          return Ue;
      }
      return null;
    }
    try {
      const de = {
        alpha: !0,
        depth: s,
        stencil: o,
        antialias: c,
        premultipliedAlpha: u,
        preserveDrawingBuffer: d,
        powerPreference: f,
        failIfMajorPerformanceCaveat: h
      };
      if ("setAttribute" in n && n.setAttribute("data-engine", `three.js r${REVISION}`), n.addEventListener("webglcontextlost", Rt, !1), n.addEventListener("webglcontextrestored", je, !1), n.addEventListener("webglcontextcreationerror", ke, !1), j === null) {
        const ve = ["webgl2", "webgl", "experimental-webgl"];
        if (b.isWebGL1Renderer === !0 && ve.shift(), j = Fe(ve, de), j === null)
          throw Fe(ve) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
      typeof WebGLRenderingContext < "u" && j instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), j.getShaderPrecisionFormat === void 0 && (j.getShaderPrecisionFormat = function() {
        return { rangeMin: 1, rangeMax: 1, precision: 1 };
      });
    } catch (de) {
      throw console.error("THREE.WebGLRenderer: " + de.message), de;
    }
    let X, ye, Ae, fe, _e, Ie, Be, $e, Me, J, K, ge, Ce, Oe, qe, ct, ze, et, gt, pt, nt, tt, Ve, We;
    function it() {
      X = new WebGLExtensions(j), ye = new WebGLCapabilities(j, X, e), X.init(ye), tt = new WebGLUtils(j, X, ye), Ae = new WebGLState(j, X, ye), fe = new WebGLInfo(j), _e = new WebGLProperties(), Ie = new WebGLTextures(j, X, Ae, _e, ye, tt, fe), Be = new WebGLCubeMaps(b), $e = new WebGLCubeUVMaps(b), Me = new WebGLAttributes(j, ye), Ve = new WebGLBindingStates(j, X, Me, ye), J = new WebGLGeometries(j, Me, fe, Ve), K = new WebGLObjects(j, J, Me, fe), gt = new WebGLMorphtargets(j, ye, Ie), ct = new WebGLClipping(_e), ge = new WebGLPrograms(b, Be, $e, X, ye, Ve, ct), Ce = new WebGLMaterials(b, _e), Oe = new WebGLRenderLists(), qe = new WebGLRenderStates(X, ye), et = new WebGLBackground(b, Be, $e, Ae, K, g, u), ze = new WebGLShadowMap(b, K, ye), We = new WebGLUniformsGroups(j, fe, ye, Ae), pt = new WebGLBufferRenderer(j, X, fe, ye), nt = new WebGLIndexedBufferRenderer(j, X, fe, ye), fe.programs = ge.programs, b.capabilities = ye, b.extensions = X, b.properties = _e, b.renderLists = Oe, b.shadowMap = ze, b.state = Ae, b.info = fe;
    }
    it();
    const Je = new WebXRManager(b, j);
    this.xr = Je, this.getContext = function() {
      return j;
    }, this.getContextAttributes = function() {
      return j.getContextAttributes();
    }, this.forceContextLoss = function() {
      const de = X.get("WEBGL_lose_context");
      de && de.loseContext();
    }, this.forceContextRestore = function() {
      const de = X.get("WEBGL_lose_context");
      de && de.restoreContext();
    }, this.getPixelRatio = function() {
      return ie;
    }, this.setPixelRatio = function(de) {
      de !== void 0 && (ie = de, this.setSize(Q, Y, !1));
    }, this.getSize = function(de) {
      return de.set(Q, Y);
    }, this.setSize = function(de, ve, Se = !0) {
      if (Je.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      Q = de, Y = ve, n.width = Math.floor(de * ie), n.height = Math.floor(ve * ie), Se === !0 && (n.style.width = de + "px", n.style.height = ve + "px"), this.setViewport(0, 0, de, ve);
    }, this.getDrawingBufferSize = function(de) {
      return de.set(Q * ie, Y * ie).floor();
    }, this.setDrawingBufferSize = function(de, ve, Se) {
      Q = de, Y = ve, ie = Se, n.width = Math.floor(de * Se), n.height = Math.floor(ve * Se), this.setViewport(0, 0, de, ve);
    }, this.getCurrentViewport = function(de) {
      return de.copy(k);
    }, this.getViewport = function(de) {
      return de.copy(ae);
    }, this.setViewport = function(de, ve, Se, we) {
      de.isVector4 ? ae.set(de.x, de.y, de.z, de.w) : ae.set(de, ve, Se, we), Ae.viewport(k.copy(ae).multiplyScalar(ie).floor());
    }, this.getScissor = function(de) {
      return de.copy(G);
    }, this.setScissor = function(de, ve, Se, we) {
      de.isVector4 ? G.set(de.x, de.y, de.z, de.w) : G.set(de, ve, Se, we), Ae.scissor(W.copy(G).multiplyScalar(ie).floor());
    }, this.getScissorTest = function() {
      return U;
    }, this.setScissorTest = function(de) {
      Ae.setScissorTest(U = de);
    }, this.setOpaqueSort = function(de) {
      te = de;
    }, this.setTransparentSort = function(de) {
      Z = de;
    }, this.getClearColor = function(de) {
      return de.copy(et.getClearColor());
    }, this.setClearColor = function() {
      et.setClearColor.apply(et, arguments);
    }, this.getClearAlpha = function() {
      return et.getClearAlpha();
    }, this.setClearAlpha = function() {
      et.setClearAlpha.apply(et, arguments);
    }, this.clear = function(de = !0, ve = !0, Se = !0) {
      let we = 0;
      if (de) {
        let Ue = !1;
        if (R !== null) {
          const Qe = R.texture.format;
          Ue = Qe === RGBAIntegerFormat || Qe === RGIntegerFormat || Qe === RedIntegerFormat;
        }
        if (Ue) {
          const Qe = R.texture.type, ft = Qe === UnsignedByteType || Qe === UnsignedIntType || Qe === UnsignedShortType || Qe === UnsignedInt248Type || Qe === UnsignedShort4444Type || Qe === UnsignedShort5551Type, ut = et.getClearColor(), _t = et.getClearAlpha(), At = ut.r, Dt = ut.g, Mt = ut.b;
          ft ? (x[0] = At, x[1] = Dt, x[2] = Mt, x[3] = _t, j.clearBufferuiv(j.COLOR, 0, x)) : (E[0] = At, E[1] = Dt, E[2] = Mt, E[3] = _t, j.clearBufferiv(j.COLOR, 0, E));
        } else
          we |= j.COLOR_BUFFER_BIT;
      }
      ve && (we |= j.DEPTH_BUFFER_BIT), Se && (we |= j.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), j.clear(we);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      n.removeEventListener("webglcontextlost", Rt, !1), n.removeEventListener("webglcontextrestored", je, !1), n.removeEventListener("webglcontextcreationerror", ke, !1), Oe.dispose(), qe.dispose(), _e.dispose(), Be.dispose(), $e.dispose(), K.dispose(), Ve.dispose(), We.dispose(), ge.dispose(), Je.dispose(), Je.removeEventListener("sessionstart", mt), Je.removeEventListener("sessionend", St), N && (N.dispose(), N = null), dt.stop();
    };
    function Rt(de) {
      de.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), C = !0;
    }
    function je() {
      console.log("THREE.WebGLRenderer: Context Restored."), C = !1;
      const de = fe.autoReset, ve = ze.enabled, Se = ze.autoUpdate, we = ze.needsUpdate, Ue = ze.type;
      it(), fe.autoReset = de, ze.enabled = ve, ze.autoUpdate = Se, ze.needsUpdate = we, ze.type = Ue;
    }
    function ke(de) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", de.statusMessage);
    }
    function Ye(de) {
      const ve = de.target;
      ve.removeEventListener("dispose", Ye), Ze(ve);
    }
    function Ze(de) {
      rt(de), _e.remove(de);
    }
    function rt(de) {
      const ve = _e.get(de).programs;
      ve !== void 0 && (ve.forEach(function(Se) {
        ge.releaseProgram(Se);
      }), de.isShaderMaterial && ge.releaseShaderCache(de));
    }
    this.renderBufferDirect = function(de, ve, Se, we, Ue, Qe) {
      ve === null && (ve = ne);
      const ft = Ue.isMesh && Ue.matrixWorld.determinant() < 0, ut = be(de, ve, Se, we, Ue);
      Ae.setMaterial(we, ft);
      let _t = Se.index, At = 1;
      if (we.wireframe === !0) {
        if (_t = J.getWireframeAttribute(Se), _t === void 0)
          return;
        At = 2;
      }
      const Dt = Se.drawRange, Mt = Se.attributes.position;
      let Ut = Dt.start * At, Qt = (Dt.start + Dt.count) * At;
      Qe !== null && (Ut = Math.max(Ut, Qe.start * At), Qt = Math.min(Qt, (Qe.start + Qe.count) * At)), _t !== null ? (Ut = Math.max(Ut, 0), Qt = Math.min(Qt, _t.count)) : Mt != null && (Ut = Math.max(Ut, 0), Qt = Math.min(Qt, Mt.count));
      const zt = Qt - Ut;
      if (zt < 0 || zt === 1 / 0)
        return;
      Ve.setup(Ue, we, ut, Se, _t);
      let sn, Vt = pt;
      if (_t !== null && (sn = Me.get(_t), Vt = nt, Vt.setIndex(sn)), Ue.isMesh)
        we.wireframe === !0 ? (Ae.setLineWidth(we.wireframeLinewidth * he()), Vt.setMode(j.LINES)) : Vt.setMode(j.TRIANGLES);
      else if (Ue.isLine) {
        let Wt = we.linewidth;
        Wt === void 0 && (Wt = 1), Ae.setLineWidth(Wt * he()), Ue.isLineSegments ? Vt.setMode(j.LINES) : Ue.isLineLoop ? Vt.setMode(j.LINE_LOOP) : Vt.setMode(j.LINE_STRIP);
      } else
        Ue.isPoints ? Vt.setMode(j.POINTS) : Ue.isSprite && Vt.setMode(j.TRIANGLES);
      if (Ue.isInstancedMesh)
        Vt.renderInstances(Ut, zt, Ue.count);
      else if (Se.isInstancedBufferGeometry) {
        const Wt = Se._maxInstanceCount !== void 0 ? Se._maxInstanceCount : 1 / 0, an = Math.min(Se.instanceCount, Wt);
        Vt.renderInstances(Ut, zt, an);
      } else
        Vt.render(Ut, zt);
    };
    function xt(de, ve, Se) {
      de.transparent === !0 && de.side === DoubleSide && de.forceSinglePass === !1 ? (de.side = BackSide, de.needsUpdate = !0, ee(de, ve, Se), de.side = FrontSide, de.needsUpdate = !0, ee(de, ve, Se), de.side = DoubleSide) : ee(de, ve, Se);
    }
    this.compile = function(de, ve, Se = null) {
      Se === null && (Se = de), v = qe.get(Se), v.init(), A.push(v), Se.traverseVisible(function(Ue) {
        Ue.isLight && Ue.layers.test(ve.layers) && (v.pushLight(Ue), Ue.castShadow && v.pushShadow(Ue));
      }), de !== Se && de.traverseVisible(function(Ue) {
        Ue.isLight && Ue.layers.test(ve.layers) && (v.pushLight(Ue), Ue.castShadow && v.pushShadow(Ue));
      }), v.setupLights(b._useLegacyLights);
      const we = /* @__PURE__ */ new Set();
      return de.traverse(function(Ue) {
        const Qe = Ue.material;
        if (Qe)
          if (Array.isArray(Qe))
            for (let ft = 0; ft < Qe.length; ft++) {
              const ut = Qe[ft];
              xt(ut, Se, Ue), we.add(ut);
            }
          else
            xt(Qe, Se, Ue), we.add(Qe);
      }), A.pop(), v = null, we;
    }, this.compileAsync = function(de, ve, Se = null) {
      const we = this.compile(de, ve, Se);
      return new Promise((Ue) => {
        function Qe() {
          if (we.forEach(function(ft) {
            _e.get(ft).currentProgram.isReady() && we.delete(ft);
          }), we.size === 0) {
            Ue(de);
            return;
          }
          setTimeout(Qe, 10);
        }
        X.get("KHR_parallel_shader_compile") !== null ? Qe() : setTimeout(Qe, 10);
      });
    };
    let bt = null;
    function wt(de) {
      bt && bt(de);
    }
    function mt() {
      dt.stop();
    }
    function St() {
      dt.start();
    }
    const dt = new WebGLAnimation();
    dt.setAnimationLoop(wt), typeof self < "u" && dt.setContext(self), this.setAnimationLoop = function(de) {
      bt = de, Je.setAnimationLoop(de), de === null ? dt.stop() : dt.start();
    }, Je.addEventListener("sessionstart", mt), Je.addEventListener("sessionend", St), this.render = function(de, ve) {
      if (ve !== void 0 && ve.isCamera !== !0) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (C === !0)
        return;
      de.matrixWorldAutoUpdate === !0 && de.updateMatrixWorld(), ve.parent === null && ve.matrixWorldAutoUpdate === !0 && ve.updateMatrixWorld(), Je.enabled === !0 && Je.isPresenting === !0 && (Je.cameraAutoUpdate === !0 && Je.updateCamera(ve), ve = Je.getCamera()), de.isScene === !0 && de.onBeforeRender(b, de, ve, R), v = qe.get(de, A.length), v.init(), A.push(v), V.multiplyMatrices(ve.projectionMatrix, ve.matrixWorldInverse), F.setFromProjectionMatrix(V), I = this.localClippingEnabled, M = ct.init(this.clippingPlanes, I), m = Oe.get(de, y.length), m.init(), y.push(m), Le(de, ve, 0, b.sortObjects), m.finish(), b.sortObjects === !0 && m.sort(te, Z), this.info.render.frame++, M === !0 && ct.beginShadows();
      const Se = v.state.shadowsArray;
      if (ze.render(Se, de, ve), M === !0 && ct.endShadows(), this.info.autoReset === !0 && this.info.reset(), et.render(m, de), v.setupLights(b._useLegacyLights), ve.isArrayCamera) {
        const we = ve.cameras;
        for (let Ue = 0, Qe = we.length; Ue < Qe; Ue++) {
          const ft = we[Ue];
          ue(m, de, ft, ft.viewport);
        }
      } else
        ue(m, de, ve);
      R !== null && (Ie.updateMultisampleRenderTarget(R), Ie.updateRenderTargetMipmap(R)), de.isScene === !0 && de.onAfterRender(b, de, ve), Ve.resetDefaultState(), O = -1, D = null, A.pop(), A.length > 0 ? v = A[A.length - 1] : v = null, y.pop(), y.length > 0 ? m = y[y.length - 1] : m = null;
    };
    function Le(de, ve, Se, we) {
      if (de.visible === !1)
        return;
      if (de.layers.test(ve.layers)) {
        if (de.isGroup)
          Se = de.renderOrder;
        else if (de.isLOD)
          de.autoUpdate === !0 && de.update(ve);
        else if (de.isLight)
          v.pushLight(de), de.castShadow && v.pushShadow(de);
        else if (de.isSprite) {
          if (!de.frustumCulled || F.intersectsSprite(de)) {
            we && H.setFromMatrixPosition(de.matrixWorld).applyMatrix4(V);
            const ft = K.update(de), ut = de.material;
            ut.visible && m.push(de, ft, ut, Se, H.z, null);
          }
        } else if ((de.isMesh || de.isLine || de.isPoints) && (!de.frustumCulled || F.intersectsObject(de))) {
          const ft = K.update(de), ut = de.material;
          if (we && (de.boundingSphere !== void 0 ? (de.boundingSphere === null && de.computeBoundingSphere(), H.copy(de.boundingSphere.center)) : (ft.boundingSphere === null && ft.computeBoundingSphere(), H.copy(ft.boundingSphere.center)), H.applyMatrix4(de.matrixWorld).applyMatrix4(V)), Array.isArray(ut)) {
            const _t = ft.groups;
            for (let At = 0, Dt = _t.length; At < Dt; At++) {
              const Mt = _t[At], Ut = ut[Mt.materialIndex];
              Ut && Ut.visible && m.push(de, ft, Ut, Se, H.z, Mt);
            }
          } else
            ut.visible && m.push(de, ft, ut, Se, H.z, null);
        }
      }
      const Qe = de.children;
      for (let ft = 0, ut = Qe.length; ft < ut; ft++)
        Le(Qe[ft], ve, Se, we);
    }
    function ue(de, ve, Se, we) {
      const Ue = de.opaque, Qe = de.transmissive, ft = de.transparent;
      v.setupLightsView(Se), M === !0 && ct.setGlobalState(b.clippingPlanes, Se), Qe.length > 0 && De(Ue, Qe, ve, Se), we && Ae.viewport(k.copy(we)), Ue.length > 0 && Ne(Ue, ve, Se), Qe.length > 0 && Ne(Qe, ve, Se), ft.length > 0 && Ne(ft, ve, Se), Ae.buffers.depth.setTest(!0), Ae.buffers.depth.setMask(!0), Ae.buffers.color.setMask(!0), Ae.setPolygonOffset(!1);
    }
    function De(de, ve, Se, we) {
      if ((Se.isScene === !0 ? Se.overrideMaterial : null) !== null)
        return;
      const Qe = ye.isWebGL2;
      N === null && (N = new WebGLRenderTarget(1, 1, {
        generateMipmaps: !0,
        type: X.has("EXT_color_buffer_half_float") ? HalfFloatType : UnsignedByteType,
        minFilter: LinearMipmapLinearFilter,
        samples: Qe ? 4 : 0
      })), b.getDrawingBufferSize(q), Qe ? N.setSize(q.x, q.y) : N.setSize(floorPowerOfTwo(q.x), floorPowerOfTwo(q.y));
      const ft = b.getRenderTarget();
      b.setRenderTarget(N), b.getClearColor(z), P = b.getClearAlpha(), P < 1 && b.setClearColor(16777215, 0.5), b.clear();
      const ut = b.toneMapping;
      b.toneMapping = NoToneMapping, Ne(de, Se, we), Ie.updateMultisampleRenderTarget(N), Ie.updateRenderTargetMipmap(N);
      let _t = !1;
      for (let At = 0, Dt = ve.length; At < Dt; At++) {
        const Mt = ve[At], Ut = Mt.object, Qt = Mt.geometry, zt = Mt.material, sn = Mt.group;
        if (zt.side === DoubleSide && Ut.layers.test(we.layers)) {
          const Vt = zt.side;
          zt.side = BackSide, zt.needsUpdate = !0, oe(Ut, Se, we, Qt, zt, sn), zt.side = Vt, zt.needsUpdate = !0, _t = !0;
        }
      }
      _t === !0 && (Ie.updateMultisampleRenderTarget(N), Ie.updateRenderTargetMipmap(N)), b.setRenderTarget(ft), b.setClearColor(z, P), b.toneMapping = ut;
    }
    function Ne(de, ve, Se) {
      const we = ve.isScene === !0 ? ve.overrideMaterial : null;
      for (let Ue = 0, Qe = de.length; Ue < Qe; Ue++) {
        const ft = de[Ue], ut = ft.object, _t = ft.geometry, At = we === null ? ft.material : we, Dt = ft.group;
        ut.layers.test(Se.layers) && oe(ut, ve, Se, _t, At, Dt);
      }
    }
    function oe(de, ve, Se, we, Ue, Qe) {
      de.onBeforeRender(b, ve, Se, we, Ue, Qe), de.modelViewMatrix.multiplyMatrices(Se.matrixWorldInverse, de.matrixWorld), de.normalMatrix.getNormalMatrix(de.modelViewMatrix), Ue.onBeforeRender(b, ve, Se, we, de, Qe), Ue.transparent === !0 && Ue.side === DoubleSide && Ue.forceSinglePass === !1 ? (Ue.side = BackSide, Ue.needsUpdate = !0, b.renderBufferDirect(Se, ve, we, Ue, de, Qe), Ue.side = FrontSide, Ue.needsUpdate = !0, b.renderBufferDirect(Se, ve, we, Ue, de, Qe), Ue.side = DoubleSide) : b.renderBufferDirect(Se, ve, we, Ue, de, Qe), de.onAfterRender(b, ve, Se, we, Ue, Qe);
    }
    function ee(de, ve, Se) {
      ve.isScene !== !0 && (ve = ne);
      const we = _e.get(de), Ue = v.state.lights, Qe = v.state.shadowsArray, ft = Ue.state.version, ut = ge.getParameters(de, Ue.state, Qe, ve, Se), _t = ge.getProgramCacheKey(ut);
      let At = we.programs;
      we.environment = de.isMeshStandardMaterial ? ve.environment : null, we.fog = ve.fog, we.envMap = (de.isMeshStandardMaterial ? $e : Be).get(de.envMap || we.environment), At === void 0 && (de.addEventListener("dispose", Ye), At = /* @__PURE__ */ new Map(), we.programs = At);
      let Dt = At.get(_t);
      if (Dt !== void 0) {
        if (we.currentProgram === Dt && we.lightsStateVersion === ft)
          return pe(de, ut), Dt;
      } else
        ut.uniforms = ge.getUniforms(de), de.onBuild(Se, ut, b), de.onBeforeCompile(ut, b), Dt = ge.acquireProgram(ut, _t), At.set(_t, Dt), we.uniforms = ut.uniforms;
      const Mt = we.uniforms;
      return (!de.isShaderMaterial && !de.isRawShaderMaterial || de.clipping === !0) && (Mt.clippingPlanes = ct.uniform), pe(de, ut), we.needsLights = He(de), we.lightsStateVersion = ft, we.needsLights && (Mt.ambientLightColor.value = Ue.state.ambient, Mt.lightProbe.value = Ue.state.probe, Mt.directionalLights.value = Ue.state.directional, Mt.directionalLightShadows.value = Ue.state.directionalShadow, Mt.spotLights.value = Ue.state.spot, Mt.spotLightShadows.value = Ue.state.spotShadow, Mt.rectAreaLights.value = Ue.state.rectArea, Mt.ltc_1.value = Ue.state.rectAreaLTC1, Mt.ltc_2.value = Ue.state.rectAreaLTC2, Mt.pointLights.value = Ue.state.point, Mt.pointLightShadows.value = Ue.state.pointShadow, Mt.hemisphereLights.value = Ue.state.hemi, Mt.directionalShadowMap.value = Ue.state.directionalShadowMap, Mt.directionalShadowMatrix.value = Ue.state.directionalShadowMatrix, Mt.spotShadowMap.value = Ue.state.spotShadowMap, Mt.spotLightMatrix.value = Ue.state.spotLightMatrix, Mt.spotLightMap.value = Ue.state.spotLightMap, Mt.pointShadowMap.value = Ue.state.pointShadowMap, Mt.pointShadowMatrix.value = Ue.state.pointShadowMatrix), we.currentProgram = Dt, we.uniformsList = null, Dt;
    }
    function ce(de) {
      if (de.uniformsList === null) {
        const ve = de.currentProgram.getUniforms();
        de.uniformsList = WebGLUniforms.seqWithValue(ve.seq, de.uniforms);
      }
      return de.uniformsList;
    }
    function pe(de, ve) {
      const Se = _e.get(de);
      Se.outputColorSpace = ve.outputColorSpace, Se.instancing = ve.instancing, Se.instancingColor = ve.instancingColor, Se.skinning = ve.skinning, Se.morphTargets = ve.morphTargets, Se.morphNormals = ve.morphNormals, Se.morphColors = ve.morphColors, Se.morphTargetsCount = ve.morphTargetsCount, Se.numClippingPlanes = ve.numClippingPlanes, Se.numIntersection = ve.numClipIntersection, Se.vertexAlphas = ve.vertexAlphas, Se.vertexTangents = ve.vertexTangents, Se.toneMapping = ve.toneMapping;
    }
    function be(de, ve, Se, we, Ue) {
      ve.isScene !== !0 && (ve = ne), Ie.resetTextureUnits();
      const Qe = ve.fog, ft = we.isMeshStandardMaterial ? ve.environment : null, ut = R === null ? b.outputColorSpace : R.isXRRenderTarget === !0 ? R.texture.colorSpace : LinearSRGBColorSpace, _t = (we.isMeshStandardMaterial ? $e : Be).get(we.envMap || ft), At = we.vertexColors === !0 && !!Se.attributes.color && Se.attributes.color.itemSize === 4, Dt = !!Se.attributes.tangent && (!!we.normalMap || we.anisotropy > 0), Mt = !!Se.morphAttributes.position, Ut = !!Se.morphAttributes.normal, Qt = !!Se.morphAttributes.color;
      let zt = NoToneMapping;
      we.toneMapped && (R === null || R.isXRRenderTarget === !0) && (zt = b.toneMapping);
      const sn = Se.morphAttributes.position || Se.morphAttributes.normal || Se.morphAttributes.color, Vt = sn !== void 0 ? sn.length : 0, Wt = _e.get(we), an = v.state.lights;
      if (M === !0 && (I === !0 || de !== D)) {
        const cn = de === D && we.id === O;
        ct.setState(we, de, cn);
      }
      let Kt = !1;
      we.version === Wt.__version ? (Wt.needsLights && Wt.lightsStateVersion !== an.state.version || Wt.outputColorSpace !== ut || Ue.isInstancedMesh && Wt.instancing === !1 || !Ue.isInstancedMesh && Wt.instancing === !0 || Ue.isSkinnedMesh && Wt.skinning === !1 || !Ue.isSkinnedMesh && Wt.skinning === !0 || Ue.isInstancedMesh && Wt.instancingColor === !0 && Ue.instanceColor === null || Ue.isInstancedMesh && Wt.instancingColor === !1 && Ue.instanceColor !== null || Wt.envMap !== _t || we.fog === !0 && Wt.fog !== Qe || Wt.numClippingPlanes !== void 0 && (Wt.numClippingPlanes !== ct.numPlanes || Wt.numIntersection !== ct.numIntersection) || Wt.vertexAlphas !== At || Wt.vertexTangents !== Dt || Wt.morphTargets !== Mt || Wt.morphNormals !== Ut || Wt.morphColors !== Qt || Wt.toneMapping !== zt || ye.isWebGL2 === !0 && Wt.morphTargetsCount !== Vt) && (Kt = !0) : (Kt = !0, Wt.__version = we.version);
      let dn = Wt.currentProgram;
      Kt === !0 && (dn = ee(we, ve, Ue));
      let Mn = !1, mn = !1, En = !1;
      const on = dn.getUniforms(), fn = Wt.uniforms;
      if (Ae.useProgram(dn.program) && (Mn = !0, mn = !0, En = !0), we.id !== O && (O = we.id, mn = !0), Mn || D !== de) {
        on.setValue(j, "projectionMatrix", de.projectionMatrix), on.setValue(j, "viewMatrix", de.matrixWorldInverse);
        const cn = on.map.cameraPosition;
        cn !== void 0 && cn.setValue(j, H.setFromMatrixPosition(de.matrixWorld)), ye.logarithmicDepthBuffer && on.setValue(
          j,
          "logDepthBufFC",
          2 / (Math.log(de.far + 1) / Math.LN2)
        ), (we.isMeshPhongMaterial || we.isMeshToonMaterial || we.isMeshLambertMaterial || we.isMeshBasicMaterial || we.isMeshStandardMaterial || we.isShaderMaterial) && on.setValue(j, "isOrthographic", de.isOrthographicCamera === !0), D !== de && (D = de, mn = !0, En = !0);
      }
      if (Ue.isSkinnedMesh) {
        on.setOptional(j, Ue, "bindMatrix"), on.setOptional(j, Ue, "bindMatrixInverse");
        const cn = Ue.skeleton;
        cn && (ye.floatVertexTextures ? (cn.boneTexture === null && cn.computeBoneTexture(), on.setValue(j, "boneTexture", cn.boneTexture, Ie), on.setValue(j, "boneTextureSize", cn.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
      }
      const An = Se.morphAttributes;
      if ((An.position !== void 0 || An.normal !== void 0 || An.color !== void 0 && ye.isWebGL2 === !0) && gt.update(Ue, Se, dn), (mn || Wt.receiveShadow !== Ue.receiveShadow) && (Wt.receiveShadow = Ue.receiveShadow, on.setValue(j, "receiveShadow", Ue.receiveShadow)), we.isMeshGouraudMaterial && we.envMap !== null && (fn.envMap.value = _t, fn.flipEnvMap.value = _t.isCubeTexture && _t.isRenderTargetTexture === !1 ? -1 : 1), mn && (on.setValue(j, "toneMappingExposure", b.toneMappingExposure), Wt.needsLights && Ee(fn, En), Qe && we.fog === !0 && Ce.refreshFogUniforms(fn, Qe), Ce.refreshMaterialUniforms(fn, we, ie, Y, N), WebGLUniforms.upload(j, ce(Wt), fn, Ie)), we.isShaderMaterial && we.uniformsNeedUpdate === !0 && (WebGLUniforms.upload(j, ce(Wt), fn, Ie), we.uniformsNeedUpdate = !1), we.isSpriteMaterial && on.setValue(j, "center", Ue.center), on.setValue(j, "modelViewMatrix", Ue.modelViewMatrix), on.setValue(j, "normalMatrix", Ue.normalMatrix), on.setValue(j, "modelMatrix", Ue.matrixWorld), we.isShaderMaterial || we.isRawShaderMaterial) {
        const cn = we.uniformsGroups;
        for (let yn = 0, Tn = cn.length; yn < Tn; yn++)
          if (ye.isWebGL2) {
            const Sn = cn[yn];
            We.update(Sn, dn), We.bind(Sn, dn);
          } else
            console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
      }
      return dn;
    }
    function Ee(de, ve) {
      de.ambientLightColor.needsUpdate = ve, de.lightProbe.needsUpdate = ve, de.directionalLights.needsUpdate = ve, de.directionalLightShadows.needsUpdate = ve, de.pointLights.needsUpdate = ve, de.pointLightShadows.needsUpdate = ve, de.spotLights.needsUpdate = ve, de.spotLightShadows.needsUpdate = ve, de.rectAreaLights.needsUpdate = ve, de.hemisphereLights.needsUpdate = ve;
    }
    function He(de) {
      return de.isMeshLambertMaterial || de.isMeshToonMaterial || de.isMeshPhongMaterial || de.isMeshStandardMaterial || de.isShadowMaterial || de.isShaderMaterial && de.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return T;
    }, this.getActiveMipmapLevel = function() {
      return w;
    }, this.getRenderTarget = function() {
      return R;
    }, this.setRenderTargetTextures = function(de, ve, Se) {
      _e.get(de.texture).__webglTexture = ve, _e.get(de.depthTexture).__webglTexture = Se;
      const we = _e.get(de);
      we.__hasExternalTextures = !0, we.__hasExternalTextures && (we.__autoAllocateDepthBuffer = Se === void 0, we.__autoAllocateDepthBuffer || X.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), we.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(de, ve) {
      const Se = _e.get(de);
      Se.__webglFramebuffer = ve, Se.__useDefaultFramebuffer = ve === void 0;
    }, this.setRenderTarget = function(de, ve = 0, Se = 0) {
      R = de, T = ve, w = Se;
      let we = !0, Ue = null, Qe = !1, ft = !1;
      if (de) {
        const _t = _e.get(de);
        _t.__useDefaultFramebuffer !== void 0 ? (Ae.bindFramebuffer(j.FRAMEBUFFER, null), we = !1) : _t.__webglFramebuffer === void 0 ? Ie.setupRenderTarget(de) : _t.__hasExternalTextures && Ie.rebindTextures(de, _e.get(de.texture).__webglTexture, _e.get(de.depthTexture).__webglTexture);
        const At = de.texture;
        (At.isData3DTexture || At.isDataArrayTexture || At.isCompressedArrayTexture) && (ft = !0);
        const Dt = _e.get(de).__webglFramebuffer;
        de.isWebGLCubeRenderTarget ? (Array.isArray(Dt[ve]) ? Ue = Dt[ve][Se] : Ue = Dt[ve], Qe = !0) : ye.isWebGL2 && de.samples > 0 && Ie.useMultisampledRTT(de) === !1 ? Ue = _e.get(de).__webglMultisampledFramebuffer : Array.isArray(Dt) ? Ue = Dt[Se] : Ue = Dt, k.copy(de.viewport), W.copy(de.scissor), L = de.scissorTest;
      } else
        k.copy(ae).multiplyScalar(ie).floor(), W.copy(G).multiplyScalar(ie).floor(), L = U;
      if (Ae.bindFramebuffer(j.FRAMEBUFFER, Ue) && ye.drawBuffers && we && Ae.drawBuffers(de, Ue), Ae.viewport(k), Ae.scissor(W), Ae.setScissorTest(L), Qe) {
        const _t = _e.get(de.texture);
        j.framebufferTexture2D(j.FRAMEBUFFER, j.COLOR_ATTACHMENT0, j.TEXTURE_CUBE_MAP_POSITIVE_X + ve, _t.__webglTexture, Se);
      } else if (ft) {
        const _t = _e.get(de.texture), At = ve || 0;
        j.framebufferTextureLayer(j.FRAMEBUFFER, j.COLOR_ATTACHMENT0, _t.__webglTexture, Se || 0, At);
      }
      O = -1;
    }, this.readRenderTargetPixels = function(de, ve, Se, we, Ue, Qe, ft) {
      if (!(de && de.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let ut = _e.get(de).__webglFramebuffer;
      if (de.isWebGLCubeRenderTarget && ft !== void 0 && (ut = ut[ft]), ut) {
        Ae.bindFramebuffer(j.FRAMEBUFFER, ut);
        try {
          const _t = de.texture, At = _t.format, Dt = _t.type;
          if (At !== RGBAFormat && tt.convert(At) !== j.getParameter(j.IMPLEMENTATION_COLOR_READ_FORMAT)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          const Mt = Dt === HalfFloatType && (X.has("EXT_color_buffer_half_float") || ye.isWebGL2 && X.has("EXT_color_buffer_float"));
          if (Dt !== UnsignedByteType && tt.convert(Dt) !== j.getParameter(j.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
          !(Dt === FloatType && (ye.isWebGL2 || X.has("OES_texture_float") || X.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
          !Mt) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          ve >= 0 && ve <= de.width - we && Se >= 0 && Se <= de.height - Ue && j.readPixels(ve, Se, we, Ue, tt.convert(At), tt.convert(Dt), Qe);
        } finally {
          const _t = R !== null ? _e.get(R).__webglFramebuffer : null;
          Ae.bindFramebuffer(j.FRAMEBUFFER, _t);
        }
      }
    }, this.copyFramebufferToTexture = function(de, ve, Se = 0) {
      const we = Math.pow(2, -Se), Ue = Math.floor(ve.image.width * we), Qe = Math.floor(ve.image.height * we);
      Ie.setTexture2D(ve, 0), j.copyTexSubImage2D(j.TEXTURE_2D, Se, 0, 0, de.x, de.y, Ue, Qe), Ae.unbindTexture();
    }, this.copyTextureToTexture = function(de, ve, Se, we = 0) {
      const Ue = ve.image.width, Qe = ve.image.height, ft = tt.convert(Se.format), ut = tt.convert(Se.type);
      Ie.setTexture2D(Se, 0), j.pixelStorei(j.UNPACK_FLIP_Y_WEBGL, Se.flipY), j.pixelStorei(j.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Se.premultiplyAlpha), j.pixelStorei(j.UNPACK_ALIGNMENT, Se.unpackAlignment), ve.isDataTexture ? j.texSubImage2D(j.TEXTURE_2D, we, de.x, de.y, Ue, Qe, ft, ut, ve.image.data) : ve.isCompressedTexture ? j.compressedTexSubImage2D(j.TEXTURE_2D, we, de.x, de.y, ve.mipmaps[0].width, ve.mipmaps[0].height, ft, ve.mipmaps[0].data) : j.texSubImage2D(j.TEXTURE_2D, we, de.x, de.y, ft, ut, ve.image), we === 0 && Se.generateMipmaps && j.generateMipmap(j.TEXTURE_2D), Ae.unbindTexture();
    }, this.copyTextureToTexture3D = function(de, ve, Se, we, Ue = 0) {
      if (b.isWebGL1Renderer) {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
        return;
      }
      const Qe = de.max.x - de.min.x + 1, ft = de.max.y - de.min.y + 1, ut = de.max.z - de.min.z + 1, _t = tt.convert(we.format), At = tt.convert(we.type);
      let Dt;
      if (we.isData3DTexture)
        Ie.setTexture3D(we, 0), Dt = j.TEXTURE_3D;
      else if (we.isDataArrayTexture)
        Ie.setTexture2DArray(we, 0), Dt = j.TEXTURE_2D_ARRAY;
      else {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
        return;
      }
      j.pixelStorei(j.UNPACK_FLIP_Y_WEBGL, we.flipY), j.pixelStorei(j.UNPACK_PREMULTIPLY_ALPHA_WEBGL, we.premultiplyAlpha), j.pixelStorei(j.UNPACK_ALIGNMENT, we.unpackAlignment);
      const Mt = j.getParameter(j.UNPACK_ROW_LENGTH), Ut = j.getParameter(j.UNPACK_IMAGE_HEIGHT), Qt = j.getParameter(j.UNPACK_SKIP_PIXELS), zt = j.getParameter(j.UNPACK_SKIP_ROWS), sn = j.getParameter(j.UNPACK_SKIP_IMAGES), Vt = Se.isCompressedTexture ? Se.mipmaps[0] : Se.image;
      j.pixelStorei(j.UNPACK_ROW_LENGTH, Vt.width), j.pixelStorei(j.UNPACK_IMAGE_HEIGHT, Vt.height), j.pixelStorei(j.UNPACK_SKIP_PIXELS, de.min.x), j.pixelStorei(j.UNPACK_SKIP_ROWS, de.min.y), j.pixelStorei(j.UNPACK_SKIP_IMAGES, de.min.z), Se.isDataTexture || Se.isData3DTexture ? j.texSubImage3D(Dt, Ue, ve.x, ve.y, ve.z, Qe, ft, ut, _t, At, Vt.data) : Se.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), j.compressedTexSubImage3D(Dt, Ue, ve.x, ve.y, ve.z, Qe, ft, ut, _t, Vt.data)) : j.texSubImage3D(Dt, Ue, ve.x, ve.y, ve.z, Qe, ft, ut, _t, At, Vt), j.pixelStorei(j.UNPACK_ROW_LENGTH, Mt), j.pixelStorei(j.UNPACK_IMAGE_HEIGHT, Ut), j.pixelStorei(j.UNPACK_SKIP_PIXELS, Qt), j.pixelStorei(j.UNPACK_SKIP_ROWS, zt), j.pixelStorei(j.UNPACK_SKIP_IMAGES, sn), Ue === 0 && we.generateMipmaps && j.generateMipmap(Dt), Ae.unbindTexture();
    }, this.initTexture = function(de) {
      de.isCubeTexture ? Ie.setTextureCube(de, 0) : de.isData3DTexture ? Ie.setTexture3D(de, 0) : de.isDataArrayTexture || de.isCompressedArrayTexture ? Ie.setTexture2DArray(de, 0) : Ie.setTexture2D(de, 0), Ae.unbindTexture();
    }, this.resetState = function() {
      T = 0, w = 0, R = null, Ae.reset(), Ve.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  get coordinateSystem() {
    return WebGLCoordinateSystem;
  }
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    const n = this.getContext();
    n.drawingBufferColorSpace = e === DisplayP3ColorSpace ? "display-p3" : "srgb", n.unpackColorSpace = ColorManagement.workingColorSpace === LinearDisplayP3ColorSpace ? "display-p3" : "srgb";
  }
  get physicallyCorrectLights() {
    return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
  }
  set physicallyCorrectLights(e) {
    console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !e;
  }
  get outputEncoding() {
    return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === SRGBColorSpace ? sRGBEncoding : LinearEncoding;
  }
  set outputEncoding(e) {
    console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = e === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
  }
  get useLegacyLights() {
    return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
  }
  set useLegacyLights(e) {
    console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = e;
  }
}
class WebGL1Renderer extends WebGLRenderer {
}
WebGL1Renderer.prototype.isWebGL1Renderer = !0;
class Scene extends Object3D {
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, n) {
    return super.copy(e, n), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const n = super.toJSON(e);
    return this.fog !== null && (n.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (n.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (n.object.backgroundIntensity = this.backgroundIntensity), n;
  }
}
class SphereGeometry extends BufferGeometry {
  constructor(e = 1, n = 32, a = 16, s = 0, o = Math.PI * 2, l = 0, c = Math.PI) {
    super(), this.type = "SphereGeometry", this.parameters = {
      radius: e,
      widthSegments: n,
      heightSegments: a,
      phiStart: s,
      phiLength: o,
      thetaStart: l,
      thetaLength: c
    }, n = Math.max(3, Math.floor(n)), a = Math.max(2, Math.floor(a));
    const u = Math.min(l + c, Math.PI);
    let d = 0;
    const f = [], h = new Vector3(), g = new Vector3(), x = [], E = [], m = [], v = [];
    for (let y = 0; y <= a; y++) {
      const A = [], b = y / a;
      let C = 0;
      y === 0 && l === 0 ? C = 0.5 / n : y === a && u === Math.PI && (C = -0.5 / n);
      for (let T = 0; T <= n; T++) {
        const w = T / n;
        h.x = -e * Math.cos(s + w * o) * Math.sin(l + b * c), h.y = e * Math.cos(l + b * c), h.z = e * Math.sin(s + w * o) * Math.sin(l + b * c), E.push(h.x, h.y, h.z), g.copy(h).normalize(), m.push(g.x, g.y, g.z), v.push(w + C, 1 - b), A.push(d++);
      }
      f.push(A);
    }
    for (let y = 0; y < a; y++)
      for (let A = 0; A < n; A++) {
        const b = f[y][A + 1], C = f[y][A], T = f[y + 1][A], w = f[y + 1][A + 1];
        (y !== 0 || l > 0) && x.push(b, C, w), (y !== a - 1 || u < Math.PI) && x.push(C, T, w);
      }
    this.setIndex(x), this.setAttribute("position", new Float32BufferAttribute(E, 3)), this.setAttribute("normal", new Float32BufferAttribute(m, 3)), this.setAttribute("uv", new Float32BufferAttribute(v, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new SphereGeometry(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
  }
}
const Cache = {
  enabled: !1,
  files: {},
  add: function(t, e) {
    this.enabled !== !1 && (this.files[t] = e);
  },
  get: function(t) {
    if (this.enabled !== !1)
      return this.files[t];
  },
  remove: function(t) {
    delete this.files[t];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager {
  constructor(e, n, a) {
    const s = this;
    let o = !1, l = 0, c = 0, u;
    const d = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = n, this.onError = a, this.itemStart = function(f) {
      c++, o === !1 && s.onStart !== void 0 && s.onStart(f, l, c), o = !0;
    }, this.itemEnd = function(f) {
      l++, s.onProgress !== void 0 && s.onProgress(f, l, c), l === c && (o = !1, s.onLoad !== void 0 && s.onLoad());
    }, this.itemError = function(f) {
      s.onError !== void 0 && s.onError(f);
    }, this.resolveURL = function(f) {
      return u ? u(f) : f;
    }, this.setURLModifier = function(f) {
      return u = f, this;
    }, this.addHandler = function(f, h) {
      return d.push(f, h), this;
    }, this.removeHandler = function(f) {
      const h = d.indexOf(f);
      return h !== -1 && d.splice(h, 2), this;
    }, this.getHandler = function(f) {
      for (let h = 0, g = d.length; h < g; h += 2) {
        const x = d[h], E = d[h + 1];
        if (x.global && (x.lastIndex = 0), x.test(f))
          return E;
      }
      return null;
    };
  }
}
const DefaultLoadingManager = /* @__PURE__ */ new LoadingManager();
class Loader {
  constructor(e) {
    this.manager = e !== void 0 ? e : DefaultLoadingManager, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  load() {
  }
  loadAsync(e, n) {
    const a = this;
    return new Promise(function(s, o) {
      a.load(e, s, n, o);
    });
  }
  parse() {
  }
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  setPath(e) {
    return this.path = e, this;
  }
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
}
Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
class ImageLoader extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, n, a, s) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const o = this, l = Cache.get(e);
    if (l !== void 0)
      return o.manager.itemStart(e), setTimeout(function() {
        n && n(l), o.manager.itemEnd(e);
      }, 0), l;
    const c = createElementNS("img");
    function u() {
      f(), Cache.add(e, this), n && n(this), o.manager.itemEnd(e);
    }
    function d(h) {
      f(), s && s(h), o.manager.itemError(e), o.manager.itemEnd(e);
    }
    function f() {
      c.removeEventListener("load", u, !1), c.removeEventListener("error", d, !1);
    }
    return c.addEventListener("load", u, !1), c.addEventListener("error", d, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (c.crossOrigin = this.crossOrigin), o.manager.itemStart(e), c.src = e, c;
  }
}
class TextureLoader extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, n, a, s) {
    const o = new Texture(), l = new ImageLoader(this.manager);
    return l.setCrossOrigin(this.crossOrigin), l.setPath(this.path), l.load(e, function(c) {
      o.image = c, o.needsUpdate = !0, n !== void 0 && n(o);
    }, a, s), o;
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: REVISION
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = REVISION);
const Photo360Viewer = (t) => {
  const e = useRef(!1), n = useRef(null), [a, s] = useState(0), [o, l] = useState(0), [c, u] = useState(!1), [d, f] = useState({
    savedX: 0,
    savedY: 0,
    savedLongitude: 0,
    savedLatitude: 0
  }), [h, g] = useState(), [x, E] = useState(), [m, v] = useState();
  useEffect(() => {
    const w = () => {
      const R = n.current;
      if (R) {
        R.childNodes.length > 0 && R.removeChild(R.childNodes[0]);
        const { width: z, height: P } = R.getBoundingClientRect(), Q = new WebGLRenderer();
        Q.setSize(z, P), g(Q), R.appendChild(Q.domElement);
      }
      const O = new Scene();
      E(O);
      const D = new PerspectiveCamera(
        75,
        t.originalWidth / t.originalHeight,
        1,
        1e3
      );
      D.lookAt(new Vector3(0, 0, 0)), v(D);
      const k = new SphereGeometry(100, 100, 40);
      k.applyMatrix4(new Matrix4().makeScale(-1, 1, 1));
      const W = new MeshBasicMaterial();
      W.map = t.texture;
      const L = new Mesh(k, W);
      O.add(L);
    };
    e.current || (e.current = !0, w());
  }, [t.texture]), useEffect(() => {
    T();
  }, [x, m, h]);
  const y = (w) => {
    c && (s(
      (d.savedX - w.clientX) * 0.1 + d.savedLongitude
    ), l(
      (w.clientY - d.savedY) * 0.1 + d.savedLatitude
    ), T());
  }, A = () => {
    u(!1);
  }, b = () => {
    u(!1);
  }, C = (w) => {
    w.preventDefault(), f({
      savedLongitude: a,
      savedLatitude: o,
      savedX: w.clientX,
      savedY: w.clientY
    }), u(!0);
  }, T = () => {
    const w = Math.max(-85, Math.min(85, o)), R = new Vector3();
    R.x = 500 * Math.sin(MathUtils.degToRad(90 - w)) * Math.cos(MathUtils.degToRad(a)), R.y = 500 * Math.cos(MathUtils.degToRad(90 - w)), R.z = 500 * Math.sin(MathUtils.degToRad(90 - w)) * Math.sin(MathUtils.degToRad(a)), m && m.lookAt(R), x && h && m && h.render(x, m);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: n,
      className: "photo360",
      onMouseDown: C,
      onMouseMove: y,
      onMouseLeave: b,
      onMouseUp: A
    }
  );
};
function commonjsRequire(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf$1 = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(module, exports) {
  (function(e, n) {
    module.exports = e.pdfjsLib = n();
  })(globalThis, () => (
    /******/
    (() => {
      var __webpack_modules__ = [
        ,
        /* 1 */
        /***/
        (t, e) => {
          var nt;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.VerbosityLevel = e.Util = e.UnknownErrorException = e.UnexpectedResponseException = e.TextRenderingMode = e.RenderingIntentFlag = e.PromiseCapability = e.PermissionFlag = e.PasswordResponses = e.PasswordException = e.PageActionEventType = e.OPS = e.MissingPDFException = e.MAX_IMAGE_SIZE_TO_CACHE = e.LINE_FACTOR = e.LINE_DESCENT_FACTOR = e.InvalidPDFException = e.ImageKind = e.IDENTITY_MATRIX = e.FormatError = e.FeatureTest = e.FONT_IDENTITY_MATRIX = e.DocumentActionEventType = e.CMapCompressionType = e.BaseException = e.BASELINE_FACTOR = e.AnnotationType = e.AnnotationReplyType = e.AnnotationPrefix = e.AnnotationMode = e.AnnotationFlag = e.AnnotationFieldFlag = e.AnnotationEditorType = e.AnnotationEditorPrefix = e.AnnotationEditorParamsType = e.AnnotationBorderStyleType = e.AnnotationActionEventType = e.AbortException = void 0, e.assert = Z, e.bytesToString = he, e.createValidAbsoluteUrl = G, e.getModificationDate = Oe, e.getUuid = gt, e.getVerbosityLevel = Q, e.info = Y, e.isArrayBuffer = ge, e.isArrayEqual = Ce, e.isNodeJS = void 0, e.normalizeUnicode = et, e.objectFromMap = ye, e.objectSize = X, e.setVerbosityLevel = P, e.shadow = U, e.string32 = Fe, e.stringToBytes = j, e.stringToPDFString = Me, e.stringToUTF8String = J, e.unreachable = te, e.utf8StringToString = K, e.warn = ie;
          const n = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          e.isNodeJS = n;
          const a = [1, 0, 0, 1, 0, 0];
          e.IDENTITY_MATRIX = a;
          const s = [1e-3, 0, 0, 1e-3, 0, 0];
          e.FONT_IDENTITY_MATRIX = s;
          const o = 1e7;
          e.MAX_IMAGE_SIZE_TO_CACHE = o;
          const l = 1.35;
          e.LINE_FACTOR = l;
          const c = 0.35;
          e.LINE_DESCENT_FACTOR = c;
          const u = c / l;
          e.BASELINE_FACTOR = u;
          const d = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          e.RenderingIntentFlag = d;
          const f = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          e.AnnotationMode = f;
          const h = "pdfjs_internal_editor_";
          e.AnnotationEditorPrefix = h;
          const g = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            STAMP: 13,
            INK: 15
          };
          e.AnnotationEditorType = g;
          const x = {
            RESIZE: 1,
            CREATE: 2,
            FREETEXT_SIZE: 11,
            FREETEXT_COLOR: 12,
            FREETEXT_OPACITY: 13,
            INK_COLOR: 21,
            INK_THICKNESS: 22,
            INK_OPACITY: 23
          };
          e.AnnotationEditorParamsType = x;
          const E = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          e.PermissionFlag = E;
          const m = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          e.TextRenderingMode = m;
          const v = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          e.ImageKind = v;
          const y = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          e.AnnotationType = y;
          const A = {
            GROUP: "Group",
            REPLY: "R"
          };
          e.AnnotationReplyType = A;
          const b = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          e.AnnotationFlag = b;
          const C = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          e.AnnotationFieldFlag = C;
          const T = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          e.AnnotationBorderStyleType = T;
          const w = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          e.AnnotationActionEventType = w;
          const R = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          e.DocumentActionEventType = R;
          const O = {
            O: "PageOpen",
            C: "PageClose"
          };
          e.PageActionEventType = O;
          const D = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          e.VerbosityLevel = D;
          const k = {
            NONE: 0,
            BINARY: 1
          };
          e.CMapCompressionType = k;
          const W = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          e.OPS = W;
          const L = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          e.PasswordResponses = L;
          let z = D.WARNINGS;
          function P(tt) {
            Number.isInteger(tt) && (z = tt);
          }
          function Q() {
            return z;
          }
          function Y(tt) {
            z >= D.INFOS && console.log(`Info: ${tt}`);
          }
          function ie(tt) {
            z >= D.WARNINGS && console.log(`Warning: ${tt}`);
          }
          function te(tt) {
            throw new Error(tt);
          }
          function Z(tt, Ve) {
            tt || te(Ve);
          }
          function ae(tt) {
            switch (tt == null ? void 0 : tt.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function G(tt, Ve = null, We = null) {
            if (!tt)
              return null;
            try {
              if (We && typeof tt == "string") {
                if (We.addDefaultProtocol && tt.startsWith("www.")) {
                  const Je = tt.match(/\./g);
                  (Je == null ? void 0 : Je.length) >= 2 && (tt = `http://${tt}`);
                }
                if (We.tryConvertEncoding)
                  try {
                    tt = J(tt);
                  } catch {
                  }
              }
              const it = Ve ? new URL(tt, Ve) : new URL(tt);
              if (ae(it))
                return it;
            } catch {
            }
            return null;
          }
          function U(tt, Ve, We, it = !1) {
            return Object.defineProperty(tt, Ve, {
              value: We,
              enumerable: !it,
              configurable: !0,
              writable: !1
            }), We;
          }
          const F = function() {
            function Ve(We, it) {
              this.constructor === Ve && te("Cannot initialize BaseException."), this.message = We, this.name = it;
            }
            return Ve.prototype = new Error(), Ve.constructor = Ve, Ve;
          }();
          e.BaseException = F;
          class M extends F {
            constructor(Ve, We) {
              super(Ve, "PasswordException"), this.code = We;
            }
          }
          e.PasswordException = M;
          class I extends F {
            constructor(Ve, We) {
              super(Ve, "UnknownErrorException"), this.details = We;
            }
          }
          e.UnknownErrorException = I;
          class N extends F {
            constructor(Ve) {
              super(Ve, "InvalidPDFException");
            }
          }
          e.InvalidPDFException = N;
          class V extends F {
            constructor(Ve) {
              super(Ve, "MissingPDFException");
            }
          }
          e.MissingPDFException = V;
          class q extends F {
            constructor(Ve, We) {
              super(Ve, "UnexpectedResponseException"), this.status = We;
            }
          }
          e.UnexpectedResponseException = q;
          class H extends F {
            constructor(Ve) {
              super(Ve, "FormatError");
            }
          }
          e.FormatError = H;
          class ne extends F {
            constructor(Ve) {
              super(Ve, "AbortException");
            }
          }
          e.AbortException = ne;
          function he(tt) {
            (typeof tt != "object" || (tt == null ? void 0 : tt.length) === void 0) && te("Invalid argument for bytesToString");
            const Ve = tt.length, We = 8192;
            if (Ve < We)
              return String.fromCharCode.apply(null, tt);
            const it = [];
            for (let Je = 0; Je < Ve; Je += We) {
              const Rt = Math.min(Je + We, Ve), je = tt.subarray(Je, Rt);
              it.push(String.fromCharCode.apply(null, je));
            }
            return it.join("");
          }
          function j(tt) {
            typeof tt != "string" && te("Invalid argument for stringToBytes");
            const Ve = tt.length, We = new Uint8Array(Ve);
            for (let it = 0; it < Ve; ++it)
              We[it] = tt.charCodeAt(it) & 255;
            return We;
          }
          function Fe(tt) {
            return String.fromCharCode(tt >> 24 & 255, tt >> 16 & 255, tt >> 8 & 255, tt & 255);
          }
          function X(tt) {
            return Object.keys(tt).length;
          }
          function ye(tt) {
            const Ve = /* @__PURE__ */ Object.create(null);
            for (const [We, it] of tt)
              Ve[We] = it;
            return Ve;
          }
          function Ae() {
            const tt = new Uint8Array(4);
            return tt[0] = 1, new Uint32Array(tt.buffer, 0, 1)[0] === 1;
          }
          function fe() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class _e {
            static get isLittleEndian() {
              return U(this, "isLittleEndian", Ae());
            }
            static get isEvalSupported() {
              return U(this, "isEvalSupported", fe());
            }
            static get isOffscreenCanvasSupported() {
              return U(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? U(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : U(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
            static get isCSSRoundSupported() {
              var Ve, We;
              return U(this, "isCSSRoundSupported", (We = (Ve = globalThis.CSS) == null ? void 0 : Ve.supports) == null ? void 0 : We.call(Ve, "width: round(1.5px, 1px)"));
            }
          }
          e.FeatureTest = _e;
          const Ie = [...Array(256).keys()].map((tt) => tt.toString(16).padStart(2, "0"));
          class Be {
            static makeHexColor(Ve, We, it) {
              return `#${Ie[Ve]}${Ie[We]}${Ie[it]}`;
            }
            static scaleMinMax(Ve, We) {
              let it;
              Ve[0] ? (Ve[0] < 0 && (it = We[0], We[0] = We[1], We[1] = it), We[0] *= Ve[0], We[1] *= Ve[0], Ve[3] < 0 && (it = We[2], We[2] = We[3], We[3] = it), We[2] *= Ve[3], We[3] *= Ve[3]) : (it = We[0], We[0] = We[2], We[2] = it, it = We[1], We[1] = We[3], We[3] = it, Ve[1] < 0 && (it = We[2], We[2] = We[3], We[3] = it), We[2] *= Ve[1], We[3] *= Ve[1], Ve[2] < 0 && (it = We[0], We[0] = We[1], We[1] = it), We[0] *= Ve[2], We[1] *= Ve[2]), We[0] += Ve[4], We[1] += Ve[4], We[2] += Ve[5], We[3] += Ve[5];
            }
            static transform(Ve, We) {
              return [Ve[0] * We[0] + Ve[2] * We[1], Ve[1] * We[0] + Ve[3] * We[1], Ve[0] * We[2] + Ve[2] * We[3], Ve[1] * We[2] + Ve[3] * We[3], Ve[0] * We[4] + Ve[2] * We[5] + Ve[4], Ve[1] * We[4] + Ve[3] * We[5] + Ve[5]];
            }
            static applyTransform(Ve, We) {
              const it = Ve[0] * We[0] + Ve[1] * We[2] + We[4], Je = Ve[0] * We[1] + Ve[1] * We[3] + We[5];
              return [it, Je];
            }
            static applyInverseTransform(Ve, We) {
              const it = We[0] * We[3] - We[1] * We[2], Je = (Ve[0] * We[3] - Ve[1] * We[2] + We[2] * We[5] - We[4] * We[3]) / it, Rt = (-Ve[0] * We[1] + Ve[1] * We[0] + We[4] * We[1] - We[5] * We[0]) / it;
              return [Je, Rt];
            }
            static getAxialAlignedBoundingBox(Ve, We) {
              const it = this.applyTransform(Ve, We), Je = this.applyTransform(Ve.slice(2, 4), We), Rt = this.applyTransform([Ve[0], Ve[3]], We), je = this.applyTransform([Ve[2], Ve[1]], We);
              return [Math.min(it[0], Je[0], Rt[0], je[0]), Math.min(it[1], Je[1], Rt[1], je[1]), Math.max(it[0], Je[0], Rt[0], je[0]), Math.max(it[1], Je[1], Rt[1], je[1])];
            }
            static inverseTransform(Ve) {
              const We = Ve[0] * Ve[3] - Ve[1] * Ve[2];
              return [Ve[3] / We, -Ve[1] / We, -Ve[2] / We, Ve[0] / We, (Ve[2] * Ve[5] - Ve[4] * Ve[3]) / We, (Ve[4] * Ve[1] - Ve[5] * Ve[0]) / We];
            }
            static singularValueDecompose2dScale(Ve) {
              const We = [Ve[0], Ve[2], Ve[1], Ve[3]], it = Ve[0] * We[0] + Ve[1] * We[2], Je = Ve[0] * We[1] + Ve[1] * We[3], Rt = Ve[2] * We[0] + Ve[3] * We[2], je = Ve[2] * We[1] + Ve[3] * We[3], ke = (it + je) / 2, Ye = Math.sqrt((it + je) ** 2 - 4 * (it * je - Rt * Je)) / 2, Ze = ke + Ye || 1, rt = ke - Ye || 1;
              return [Math.sqrt(Ze), Math.sqrt(rt)];
            }
            static normalizeRect(Ve) {
              const We = Ve.slice(0);
              return Ve[0] > Ve[2] && (We[0] = Ve[2], We[2] = Ve[0]), Ve[1] > Ve[3] && (We[1] = Ve[3], We[3] = Ve[1]), We;
            }
            static intersect(Ve, We) {
              const it = Math.max(Math.min(Ve[0], Ve[2]), Math.min(We[0], We[2])), Je = Math.min(Math.max(Ve[0], Ve[2]), Math.max(We[0], We[2]));
              if (it > Je)
                return null;
              const Rt = Math.max(Math.min(Ve[1], Ve[3]), Math.min(We[1], We[3])), je = Math.min(Math.max(Ve[1], Ve[3]), Math.max(We[1], We[3]));
              return Rt > je ? null : [it, Rt, Je, je];
            }
            static bezierBoundingBox(Ve, We, it, Je, Rt, je, ke, Ye) {
              const Ze = [], rt = [[], []];
              let xt, bt, wt, mt, St, dt, Le, ue;
              for (let ee = 0; ee < 2; ++ee) {
                if (ee === 0 ? (bt = 6 * Ve - 12 * it + 6 * Rt, xt = -3 * Ve + 9 * it - 9 * Rt + 3 * ke, wt = 3 * it - 3 * Ve) : (bt = 6 * We - 12 * Je + 6 * je, xt = -3 * We + 9 * Je - 9 * je + 3 * Ye, wt = 3 * Je - 3 * We), Math.abs(xt) < 1e-12) {
                  if (Math.abs(bt) < 1e-12)
                    continue;
                  mt = -wt / bt, 0 < mt && mt < 1 && Ze.push(mt);
                  continue;
                }
                Le = bt * bt - 4 * wt * xt, ue = Math.sqrt(Le), !(Le < 0) && (St = (-bt + ue) / (2 * xt), 0 < St && St < 1 && Ze.push(St), dt = (-bt - ue) / (2 * xt), 0 < dt && dt < 1 && Ze.push(dt));
              }
              let De = Ze.length, Ne;
              const oe = De;
              for (; De--; )
                mt = Ze[De], Ne = 1 - mt, rt[0][De] = Ne * Ne * Ne * Ve + 3 * Ne * Ne * mt * it + 3 * Ne * mt * mt * Rt + mt * mt * mt * ke, rt[1][De] = Ne * Ne * Ne * We + 3 * Ne * Ne * mt * Je + 3 * Ne * mt * mt * je + mt * mt * mt * Ye;
              return rt[0][oe] = Ve, rt[1][oe] = We, rt[0][oe + 1] = ke, rt[1][oe + 1] = Ye, rt[0].length = rt[1].length = oe + 2, [Math.min(...rt[0]), Math.min(...rt[1]), Math.max(...rt[0]), Math.max(...rt[1])];
            }
          }
          e.Util = Be;
          const $e = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function Me(tt) {
            if (tt[0] >= "ï") {
              let We;
              if (tt[0] === "þ" && tt[1] === "ÿ" ? We = "utf-16be" : tt[0] === "ÿ" && tt[1] === "þ" ? We = "utf-16le" : tt[0] === "ï" && tt[1] === "»" && tt[2] === "¿" && (We = "utf-8"), We)
                try {
                  const it = new TextDecoder(We, {
                    fatal: !0
                  }), Je = j(tt);
                  return it.decode(Je);
                } catch (it) {
                  ie(`stringToPDFString: "${it}".`);
                }
            }
            const Ve = [];
            for (let We = 0, it = tt.length; We < it; We++) {
              const Je = $e[tt.charCodeAt(We)];
              Ve.push(Je ? String.fromCharCode(Je) : tt.charAt(We));
            }
            return Ve.join("");
          }
          function J(tt) {
            return decodeURIComponent(escape(tt));
          }
          function K(tt) {
            return unescape(encodeURIComponent(tt));
          }
          function ge(tt) {
            return typeof tt == "object" && (tt == null ? void 0 : tt.byteLength) !== void 0;
          }
          function Ce(tt, Ve) {
            if (tt.length !== Ve.length)
              return !1;
            for (let We = 0, it = tt.length; We < it; We++)
              if (tt[We] !== Ve[We])
                return !1;
            return !0;
          }
          function Oe(tt = /* @__PURE__ */ new Date()) {
            return [tt.getUTCFullYear().toString(), (tt.getUTCMonth() + 1).toString().padStart(2, "0"), tt.getUTCDate().toString().padStart(2, "0"), tt.getUTCHours().toString().padStart(2, "0"), tt.getUTCMinutes().toString().padStart(2, "0"), tt.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class qe {
            constructor() {
              Ge(this, nt, !1);
              this.promise = new Promise((Ve, We) => {
                this.resolve = (it) => {
                  at(this, nt, !0), Ve(it);
                }, this.reject = (it) => {
                  at(this, nt, !0), We(it);
                };
              });
            }
            get settled() {
              return se(this, nt);
            }
          }
          nt = new WeakMap(), e.PromiseCapability = qe;
          let ct = null, ze = null;
          function et(tt) {
            return ct || (ct = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, ze = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), tt.replaceAll(ct, (Ve, We, it) => We ? We.normalize("NFKC") : ze.get(it));
          }
          function gt() {
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function")
              return crypto.randomUUID();
            const tt = new Uint8Array(32);
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function")
              crypto.getRandomValues(tt);
            else
              for (let Ve = 0; Ve < 32; Ve++)
                tt[Ve] = Math.floor(Math.random() * 255);
            return he(tt);
          }
          const pt = "pdfjs_internal_id_";
          e.AnnotationPrefix = pt;
        },
        /* 2 */
        /***/
        (__unused_webpack_module, exports, __w_pdfjs_require__) => {
          var t, n, a, s, Un, l, hr, u, d, f, h, g, x, E, m, v, pr, A, b, Xr, T, w;
          Object.defineProperty(exports, "__esModule", {
            value: !0
          }), exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, Object.defineProperty(exports, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return _displaySvg.SVGGraphics;
            }
          }), exports.build = void 0, exports.getDocument = getDocument, exports.version = void 0;
          var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(3), _display_utils = __w_pdfjs_require__(6), _font_loader = __w_pdfjs_require__(9), _displayNode_utils = __w_pdfjs_require__(10), _canvas = __w_pdfjs_require__(11), _worker_options = __w_pdfjs_require__(14), _message_handler = __w_pdfjs_require__(15), _metadata = __w_pdfjs_require__(16), _optional_content_config = __w_pdfjs_require__(17), _transport_stream = __w_pdfjs_require__(18), _displayFetch_stream = __w_pdfjs_require__(19), _displayNetwork = __w_pdfjs_require__(22), _displayNode_stream = __w_pdfjs_require__(23), _displaySvg = __w_pdfjs_require__(24), _xfa_text = __w_pdfjs_require__(25);
          const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3, DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
          exports.DefaultCanvasFactory = DefaultCanvasFactory;
          const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
          exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
          const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
          exports.DefaultFilterFactory = DefaultFilterFactory;
          const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
          exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
          function getDocument(O) {
            if (typeof O == "string" || O instanceof URL ? O = {
              url: O
            } : (0, _util.isArrayBuffer)(O) && (O = {
              data: O
            }), typeof O != "object")
              throw new Error("Invalid parameter in getDocument, need parameter object.");
            if (!O.url && !O.data && !O.range)
              throw new Error("Invalid parameter object: need either .data, .range or .url");
            const D = new PDFDocumentLoadingTask(), {
              docId: k
            } = D, W = O.url ? getUrlProp(O.url) : null, L = O.data ? getDataProp(O.data) : null, z = O.httpHeaders || null, P = O.withCredentials === !0, Q = O.password ?? null, Y = O.range instanceof PDFDataRangeTransport ? O.range : null, ie = Number.isInteger(O.rangeChunkSize) && O.rangeChunkSize > 0 ? O.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
            let te = O.worker instanceof PDFWorker ? O.worker : null;
            const Z = O.verbosity, ae = typeof O.docBaseUrl == "string" && !(0, _display_utils.isDataScheme)(O.docBaseUrl) ? O.docBaseUrl : null, G = typeof O.cMapUrl == "string" ? O.cMapUrl : null, U = O.cMapPacked !== !1, F = O.CMapReaderFactory || DefaultCMapReaderFactory, M = typeof O.standardFontDataUrl == "string" ? O.standardFontDataUrl : null, I = O.StandardFontDataFactory || DefaultStandardFontDataFactory, N = O.stopAtErrors !== !0, V = Number.isInteger(O.maxImageSize) && O.maxImageSize > -1 ? O.maxImageSize : -1, q = O.isEvalSupported !== !1, H = typeof O.isOffscreenCanvasSupported == "boolean" ? O.isOffscreenCanvasSupported : !_util.isNodeJS, ne = Number.isInteger(O.canvasMaxAreaInBytes) ? O.canvasMaxAreaInBytes : -1, he = typeof O.disableFontFace == "boolean" ? O.disableFontFace : _util.isNodeJS, j = O.fontExtraProperties === !0, Fe = O.enableXfa === !0, X = O.ownerDocument || globalThis.document, ye = O.disableRange === !0, Ae = O.disableStream === !0, fe = O.disableAutoFetch === !0, _e = O.pdfBug === !0, Ie = Y ? Y.length : O.length ?? NaN, Be = typeof O.useSystemFonts == "boolean" ? O.useSystemFonts : !_util.isNodeJS && !he, $e = typeof O.useWorkerFetch == "boolean" ? O.useWorkerFetch : F === _display_utils.DOMCMapReaderFactory && I === _display_utils.DOMStandardFontDataFactory && G && M && (0, _display_utils.isValidFetchUrl)(G, document.baseURI) && (0, _display_utils.isValidFetchUrl)(M, document.baseURI), Me = O.canvasFactory || new DefaultCanvasFactory({
              ownerDocument: X
            }), J = O.filterFactory || new DefaultFilterFactory({
              docId: k,
              ownerDocument: X
            }), K = null;
            (0, _util.setVerbosityLevel)(Z);
            const ge = {
              canvasFactory: Me,
              filterFactory: J
            };
            if ($e || (ge.cMapReaderFactory = new F({
              baseUrl: G,
              isCompressed: U
            }), ge.standardFontDataFactory = new I({
              baseUrl: M
            })), !te) {
              const qe = {
                verbosity: Z,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              te = qe.port ? PDFWorker.fromPort(qe) : new PDFWorker(qe), D._worker = te;
            }
            const Ce = {
              docId: k,
              apiVersion: "3.11.174",
              data: L,
              password: Q,
              disableAutoFetch: fe,
              rangeChunkSize: ie,
              length: Ie,
              docBaseUrl: ae,
              enableXfa: Fe,
              evaluatorOptions: {
                maxImageSize: V,
                disableFontFace: he,
                ignoreErrors: N,
                isEvalSupported: q,
                isOffscreenCanvasSupported: H,
                canvasMaxAreaInBytes: ne,
                fontExtraProperties: j,
                useSystemFonts: Be,
                cMapUrl: $e ? G : null,
                standardFontDataUrl: $e ? M : null
              }
            }, Oe = {
              ignoreErrors: N,
              isEvalSupported: q,
              disableFontFace: he,
              fontExtraProperties: j,
              enableXfa: Fe,
              ownerDocument: X,
              disableAutoFetch: fe,
              pdfBug: _e,
              styleElement: K
            };
            return te.promise.then(function() {
              if (D.destroyed)
                throw new Error("Loading aborted");
              const qe = _fetchDocument(te, Ce), ct = new Promise(function(ze) {
                let et;
                Y ? et = new _transport_stream.PDFDataTransportStream({
                  length: Ie,
                  initialData: Y.initialData,
                  progressiveDone: Y.progressiveDone,
                  contentDispositionFilename: Y.contentDispositionFilename,
                  disableRange: ye,
                  disableStream: Ae
                }, Y) : L || (et = ((pt) => _util.isNodeJS ? new _displayNode_stream.PDFNodeStream(pt) : (0, _display_utils.isValidFetchUrl)(pt.url) ? new _displayFetch_stream.PDFFetchStream(pt) : new _displayNetwork.PDFNetworkStream(pt))({
                  url: W,
                  length: Ie,
                  httpHeaders: z,
                  withCredentials: P,
                  rangeChunkSize: ie,
                  disableRange: ye,
                  disableStream: Ae
                })), ze(et);
              });
              return Promise.all([qe, ct]).then(function([ze, et]) {
                if (D.destroyed)
                  throw new Error("Loading aborted");
                const gt = new _message_handler.MessageHandler(k, ze, te.port), pt = new WorkerTransport(gt, D, et, Oe, ge);
                D._transport = pt, gt.send("Ready", null);
              });
            }).catch(D._capability.reject), D;
          }
          async function _fetchDocument(O, D) {
            if (O.destroyed)
              throw new Error("Worker was destroyed");
            const k = await O.messageHandler.sendWithPromise("GetDocRequest", D, D.data ? [D.data.buffer] : null);
            if (O.destroyed)
              throw new Error("Worker was destroyed");
            return k;
          }
          function getUrlProp(O) {
            if (O instanceof URL)
              return O.href;
            try {
              return new URL(O, window.location).href;
            } catch {
              if (_util.isNodeJS && typeof O == "string")
                return O;
            }
            throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
          }
          function getDataProp(O) {
            if (_util.isNodeJS && typeof Buffer < "u" && O instanceof Buffer)
              throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
            if (O instanceof Uint8Array && O.byteLength === O.buffer.byteLength)
              return O;
            if (typeof O == "string")
              return (0, _util.stringToBytes)(O);
            if (typeof O == "object" && !isNaN(O == null ? void 0 : O.length) || (0, _util.isArrayBuffer)(O))
              return new Uint8Array(O);
            throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
          }
          const e = class e {
            constructor() {
              this._capability = new _util.PromiseCapability(), this._transport = null, this._worker = null, this.docId = `d${zn(e, t)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
            }
            get promise() {
              return this._capability.promise;
            }
            async destroy() {
              var D, k, W;
              this.destroyed = !0;
              try {
                (D = this._worker) != null && D.port && (this._worker._pendingDestroy = !0), await ((k = this._transport) == null ? void 0 : k.destroy());
              } catch (L) {
                throw (W = this._worker) != null && W.port && delete this._worker._pendingDestroy, L;
              }
              this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
            }
          };
          t = new WeakMap(), Ge(e, t, 0);
          let PDFDocumentLoadingTask = e;
          exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
          class PDFDataRangeTransport {
            constructor(D, k, W = !1, L = null) {
              this.length = D, this.initialData = k, this.progressiveDone = W, this.contentDispositionFilename = L, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = new _util.PromiseCapability();
            }
            addRangeListener(D) {
              this._rangeListeners.push(D);
            }
            addProgressListener(D) {
              this._progressListeners.push(D);
            }
            addProgressiveReadListener(D) {
              this._progressiveReadListeners.push(D);
            }
            addProgressiveDoneListener(D) {
              this._progressiveDoneListeners.push(D);
            }
            onDataRange(D, k) {
              for (const W of this._rangeListeners)
                W(D, k);
            }
            onDataProgress(D, k) {
              this._readyCapability.promise.then(() => {
                for (const W of this._progressListeners)
                  W(D, k);
              });
            }
            onDataProgressiveRead(D) {
              this._readyCapability.promise.then(() => {
                for (const k of this._progressiveReadListeners)
                  k(D);
              });
            }
            onDataProgressiveDone() {
              this._readyCapability.promise.then(() => {
                for (const D of this._progressiveDoneListeners)
                  D();
              });
            }
            transportReady() {
              this._readyCapability.resolve();
            }
            requestDataRange(D, k) {
              (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
            }
            abort() {
            }
          }
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          class PDFDocumentProxy {
            constructor(D, k) {
              this._pdfInfo = D, this._transport = k, Object.defineProperty(this, "getJavaScript", {
                value: () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead."), this.getJSActions().then((W) => {
                  if (!W)
                    return W;
                  const L = [];
                  for (const z in W)
                    L.push(...W[z]);
                  return L;
                }))
              });
            }
            get annotationStorage() {
              return this._transport.annotationStorage;
            }
            get filterFactory() {
              return this._transport.filterFactory;
            }
            get numPages() {
              return this._pdfInfo.numPages;
            }
            get fingerprints() {
              return this._pdfInfo.fingerprints;
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            get allXfaHtml() {
              return this._transport._htmlForXfa;
            }
            getPage(D) {
              return this._transport.getPage(D);
            }
            getPageIndex(D) {
              return this._transport.getPageIndex(D);
            }
            getDestinations() {
              return this._transport.getDestinations();
            }
            getDestination(D) {
              return this._transport.getDestination(D);
            }
            getPageLabels() {
              return this._transport.getPageLabels();
            }
            getPageLayout() {
              return this._transport.getPageLayout();
            }
            getPageMode() {
              return this._transport.getPageMode();
            }
            getViewerPreferences() {
              return this._transport.getViewerPreferences();
            }
            getOpenAction() {
              return this._transport.getOpenAction();
            }
            getAttachments() {
              return this._transport.getAttachments();
            }
            getJSActions() {
              return this._transport.getDocJSActions();
            }
            getOutline() {
              return this._transport.getOutline();
            }
            getOptionalContentConfig() {
              return this._transport.getOptionalContentConfig();
            }
            getPermissions() {
              return this._transport.getPermissions();
            }
            getMetadata() {
              return this._transport.getMetadata();
            }
            getMarkInfo() {
              return this._transport.getMarkInfo();
            }
            getData() {
              return this._transport.getData();
            }
            saveDocument() {
              return this._transport.saveDocument();
            }
            getDownloadInfo() {
              return this._transport.downloadInfoCapability.promise;
            }
            cleanup(D = !1) {
              return this._transport.startCleanup(D || this.isPureXfa);
            }
            destroy() {
              return this.loadingTask.destroy();
            }
            get loadingParams() {
              return this._transport.loadingParams;
            }
            get loadingTask() {
              return this._transport.loadingTask;
            }
            getFieldObjects() {
              return this._transport.getFieldObjects();
            }
            hasJSActions() {
              return this._transport.hasJSActions();
            }
            getCalculationOrderIds() {
              return this._transport.getCalculationOrderIds();
            }
          }
          exports.PDFDocumentProxy = PDFDocumentProxy;
          class PDFPageProxy {
            constructor(D, k, W, L = !1) {
              Ge(this, s);
              Ge(this, l);
              Ge(this, n, null);
              Ge(this, a, !1);
              this._pageIndex = D, this._pageInfo = k, this._transport = W, this._stats = L ? new _display_utils.StatTimer() : null, this._pdfBug = L, this.commonObjs = W.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
            }
            get pageNumber() {
              return this._pageIndex + 1;
            }
            get rotate() {
              return this._pageInfo.rotate;
            }
            get ref() {
              return this._pageInfo.ref;
            }
            get userUnit() {
              return this._pageInfo.userUnit;
            }
            get view() {
              return this._pageInfo.view;
            }
            getViewport({
              scale: D,
              rotation: k = this.rotate,
              offsetX: W = 0,
              offsetY: L = 0,
              dontFlip: z = !1
            } = {}) {
              return new _display_utils.PageViewport({
                viewBox: this.view,
                scale: D,
                rotation: k,
                offsetX: W,
                offsetY: L,
                dontFlip: z
              });
            }
            getAnnotations({
              intent: D = "display"
            } = {}) {
              const k = this._transport.getRenderingIntent(D);
              return this._transport.getAnnotations(this._pageIndex, k.renderingIntent);
            }
            getJSActions() {
              return this._transport.getPageJSActions(this._pageIndex);
            }
            get filterFactory() {
              return this._transport.filterFactory;
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            async getXfa() {
              var D;
              return ((D = this._transport._htmlForXfa) == null ? void 0 : D.children[this._pageIndex]) || null;
            }
            render({
              canvasContext: D,
              viewport: k,
              intent: W = "display",
              annotationMode: L = _util.AnnotationMode.ENABLE,
              transform: z = null,
              background: P = null,
              optionalContentConfigPromise: Q = null,
              annotationCanvasMap: Y = null,
              pageColors: ie = null,
              printAnnotationStorage: te = null
            }) {
              var I, N;
              (I = this._stats) == null || I.time("Overall");
              const Z = this._transport.getRenderingIntent(W, L, te);
              at(this, a, !1), Ke(this, l, hr).call(this), Q || (Q = this._transport.getOptionalContentConfig());
              let ae = this._intentStates.get(Z.cacheKey);
              ae || (ae = /* @__PURE__ */ Object.create(null), this._intentStates.set(Z.cacheKey, ae)), ae.streamReaderCancelTimeout && (clearTimeout(ae.streamReaderCancelTimeout), ae.streamReaderCancelTimeout = null);
              const G = !!(Z.renderingIntent & _util.RenderingIntentFlag.PRINT);
              ae.displayReadyCapability || (ae.displayReadyCapability = new _util.PromiseCapability(), ae.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (N = this._stats) == null || N.time("Page Request"), this._pumpOperatorList(Z));
              const U = (V) => {
                var q, H;
                ae.renderTasks.delete(F), (this._maybeCleanupAfterRender || G) && at(this, a, !0), Ke(this, s, Un).call(this, !G), V ? (F.capability.reject(V), this._abortOperatorList({
                  intentState: ae,
                  reason: V instanceof Error ? V : new Error(V)
                })) : F.capability.resolve(), (q = this._stats) == null || q.timeEnd("Rendering"), (H = this._stats) == null || H.timeEnd("Overall");
              }, F = new InternalRenderTask({
                callback: U,
                params: {
                  canvasContext: D,
                  viewport: k,
                  transform: z,
                  background: P
                },
                objs: this.objs,
                commonObjs: this.commonObjs,
                annotationCanvasMap: Y,
                operatorList: ae.operatorList,
                pageIndex: this._pageIndex,
                canvasFactory: this._transport.canvasFactory,
                filterFactory: this._transport.filterFactory,
                useRequestAnimationFrame: !G,
                pdfBug: this._pdfBug,
                pageColors: ie
              });
              (ae.renderTasks || (ae.renderTasks = /* @__PURE__ */ new Set())).add(F);
              const M = F.task;
              return Promise.all([ae.displayReadyCapability.promise, Q]).then(([V, q]) => {
                var H;
                if (this.destroyed) {
                  U();
                  return;
                }
                (H = this._stats) == null || H.time("Rendering"), F.initializeGraphics({
                  transparency: V,
                  optionalContentConfig: q
                }), F.operatorListChanged();
              }).catch(U), M;
            }
            getOperatorList({
              intent: D = "display",
              annotationMode: k = _util.AnnotationMode.ENABLE,
              printAnnotationStorage: W = null
            } = {}) {
              var Y;
              function L() {
                P.operatorList.lastChunk && (P.opListReadCapability.resolve(P.operatorList), P.renderTasks.delete(Q));
              }
              const z = this._transport.getRenderingIntent(D, k, W, !0);
              let P = this._intentStates.get(z.cacheKey);
              P || (P = /* @__PURE__ */ Object.create(null), this._intentStates.set(z.cacheKey, P));
              let Q;
              return P.opListReadCapability || (Q = /* @__PURE__ */ Object.create(null), Q.operatorListChanged = L, P.opListReadCapability = new _util.PromiseCapability(), (P.renderTasks || (P.renderTasks = /* @__PURE__ */ new Set())).add(Q), P.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (Y = this._stats) == null || Y.time("Page Request"), this._pumpOperatorList(z)), P.opListReadCapability.promise;
            }
            streamTextContent({
              includeMarkedContent: D = !1,
              disableNormalization: k = !1
            } = {}) {
              return this._transport.messageHandler.sendWithStream("GetTextContent", {
                pageIndex: this._pageIndex,
                includeMarkedContent: D === !0,
                disableNormalization: k === !0
              }, {
                highWaterMark: 100,
                size(L) {
                  return L.items.length;
                }
              });
            }
            getTextContent(D = {}) {
              if (this._transport._htmlForXfa)
                return this.getXfa().then((W) => _xfa_text.XfaText.textContent(W));
              const k = this.streamTextContent(D);
              return new Promise(function(W, L) {
                function z() {
                  P.read().then(function({
                    value: Y,
                    done: ie
                  }) {
                    if (ie) {
                      W(Q);
                      return;
                    }
                    Object.assign(Q.styles, Y.styles), Q.items.push(...Y.items), z();
                  }, L);
                }
                const P = k.getReader(), Q = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                };
                z();
              });
            }
            getStructTree() {
              return this._transport.getStructTree(this._pageIndex);
            }
            _destroy() {
              this.destroyed = !0;
              const D = [];
              for (const k of this._intentStates.values())
                if (this._abortOperatorList({
                  intentState: k,
                  reason: new Error("Page was destroyed."),
                  force: !0
                }), !k.opListReadCapability)
                  for (const W of k.renderTasks)
                    D.push(W.completed), W.cancel();
              return this.objs.clear(), at(this, a, !1), Ke(this, l, hr).call(this), Promise.all(D);
            }
            cleanup(D = !1) {
              at(this, a, !0);
              const k = Ke(this, s, Un).call(this, !1);
              return D && k && this._stats && (this._stats = new _display_utils.StatTimer()), k;
            }
            _startRenderPage(D, k) {
              var L, z;
              const W = this._intentStates.get(k);
              W && ((L = this._stats) == null || L.timeEnd("Page Request"), (z = W.displayReadyCapability) == null || z.resolve(D));
            }
            _renderPageChunk(D, k) {
              for (let W = 0, L = D.length; W < L; W++)
                k.operatorList.fnArray.push(D.fnArray[W]), k.operatorList.argsArray.push(D.argsArray[W]);
              k.operatorList.lastChunk = D.lastChunk, k.operatorList.separateAnnots = D.separateAnnots;
              for (const W of k.renderTasks)
                W.operatorListChanged();
              D.lastChunk && Ke(this, s, Un).call(this, !0);
            }
            _pumpOperatorList({
              renderingIntent: D,
              cacheKey: k,
              annotationStorageSerializable: W
            }) {
              const {
                map: L,
                transfers: z
              } = W, Q = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                pageIndex: this._pageIndex,
                intent: D,
                cacheKey: k,
                annotationStorage: L
              }, z).getReader(), Y = this._intentStates.get(k);
              Y.streamReader = Q;
              const ie = () => {
                Q.read().then(({
                  value: te,
                  done: Z
                }) => {
                  if (Z) {
                    Y.streamReader = null;
                    return;
                  }
                  this._transport.destroyed || (this._renderPageChunk(te, Y), ie());
                }, (te) => {
                  if (Y.streamReader = null, !this._transport.destroyed) {
                    if (Y.operatorList) {
                      Y.operatorList.lastChunk = !0;
                      for (const Z of Y.renderTasks)
                        Z.operatorListChanged();
                      Ke(this, s, Un).call(this, !0);
                    }
                    if (Y.displayReadyCapability)
                      Y.displayReadyCapability.reject(te);
                    else if (Y.opListReadCapability)
                      Y.opListReadCapability.reject(te);
                    else
                      throw te;
                  }
                });
              };
              ie();
            }
            _abortOperatorList({
              intentState: D,
              reason: k,
              force: W = !1
            }) {
              if (D.streamReader) {
                if (D.streamReaderCancelTimeout && (clearTimeout(D.streamReaderCancelTimeout), D.streamReaderCancelTimeout = null), !W) {
                  if (D.renderTasks.size > 0)
                    return;
                  if (k instanceof _display_utils.RenderingCancelledException) {
                    let L = RENDERING_CANCELLED_TIMEOUT;
                    k.extraDelay > 0 && k.extraDelay < 1e3 && (L += k.extraDelay), D.streamReaderCancelTimeout = setTimeout(() => {
                      D.streamReaderCancelTimeout = null, this._abortOperatorList({
                        intentState: D,
                        reason: k,
                        force: !0
                      });
                    }, L);
                    return;
                  }
                }
                if (D.streamReader.cancel(new _util.AbortException(k.message)).catch(() => {
                }), D.streamReader = null, !this._transport.destroyed) {
                  for (const [L, z] of this._intentStates)
                    if (z === D) {
                      this._intentStates.delete(L);
                      break;
                    }
                  this.cleanup();
                }
              }
            }
            get stats() {
              return this._stats;
            }
          }
          n = new WeakMap(), a = new WeakMap(), s = new WeakSet(), Un = function(D = !1) {
            if (Ke(this, l, hr).call(this), !se(this, a) || this.destroyed)
              return !1;
            if (D)
              return at(this, n, setTimeout(() => {
                at(this, n, null), Ke(this, s, Un).call(this, !1);
              }, DELAYED_CLEANUP_TIMEOUT)), !1;
            for (const {
              renderTasks: k,
              operatorList: W
            } of this._intentStates.values())
              if (k.size > 0 || !W.lastChunk)
                return !1;
            return this._intentStates.clear(), this.objs.clear(), at(this, a, !1), !0;
          }, l = new WeakSet(), hr = function() {
            se(this, n) && (clearTimeout(se(this, n)), at(this, n, null));
          }, exports.PDFPageProxy = PDFPageProxy;
          class LoopbackPort {
            constructor() {
              Ge(this, u, /* @__PURE__ */ new Set());
              Ge(this, d, Promise.resolve());
            }
            postMessage(D, k) {
              const W = {
                data: structuredClone(D, k ? {
                  transfer: k
                } : null)
              };
              se(this, d).then(() => {
                for (const L of se(this, u))
                  L.call(this, W);
              });
            }
            addEventListener(D, k) {
              se(this, u).add(k);
            }
            removeEventListener(D, k) {
              se(this, u).delete(k);
            }
            terminate() {
              se(this, u).clear();
            }
          }
          u = new WeakMap(), d = new WeakMap(), exports.LoopbackPort = LoopbackPort;
          const PDFWorkerUtil = {
            isWorkerDisabled: !1,
            fallbackWorkerSrc: null,
            fakeWorkerId: 0
          };
          exports.PDFWorkerUtil = PDFWorkerUtil;
          {
            if (_util.isNodeJS && typeof commonjsRequire == "function")
              PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
            else if (typeof document == "object") {
              const O = (f = document == null ? void 0 : document.currentScript) == null ? void 0 : f.src;
              O && (PDFWorkerUtil.fallbackWorkerSrc = O.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
            }
            PDFWorkerUtil.isSameOrigin = function(O, D) {
              let k;
              try {
                if (k = new URL(O), !k.origin || k.origin === "null")
                  return !1;
              } catch {
                return !1;
              }
              const W = new URL(D, k);
              return k.origin === W.origin;
            }, PDFWorkerUtil.createCDNWrapper = function(O) {
              const D = `importScripts("${O}");`;
              return URL.createObjectURL(new Blob([D]));
            };
          }
          const _PDFWorker = class _PDFWorker {
            constructor({
              name: O = null,
              port: D = null,
              verbosity: k = (0, _util.getVerbosityLevel)()
            } = {}) {
              var W;
              if (this.name = O, this.destroyed = !1, this.verbosity = k, this._readyCapability = new _util.PromiseCapability(), this._port = null, this._webWorker = null, this._messageHandler = null, D) {
                if ((W = se(_PDFWorker, h)) != null && W.has(D))
                  throw new Error("Cannot use more than one PDFWorker per port.");
                (se(_PDFWorker, h) || at(_PDFWorker, h, /* @__PURE__ */ new WeakMap())).set(D, this), this._initializeFromPort(D);
                return;
              }
              this._initialize();
            }
            get promise() {
              return this._readyCapability.promise;
            }
            get port() {
              return this._port;
            }
            get messageHandler() {
              return this._messageHandler;
            }
            _initializeFromPort(O) {
              this._port = O, this._messageHandler = new _message_handler.MessageHandler("main", "worker", O), this._messageHandler.on("ready", function() {
              }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
                verbosity: this.verbosity
              });
            }
            _initialize() {
              if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                let {
                  workerSrc: O
                } = _PDFWorker;
                try {
                  PDFWorkerUtil.isSameOrigin(window.location.href, O) || (O = PDFWorkerUtil.createCDNWrapper(new URL(O, window.location).href));
                  const D = new Worker(O), k = new _message_handler.MessageHandler("main", "worker", D), W = () => {
                    D.removeEventListener("error", L), k.destroy(), D.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                  }, L = () => {
                    this._webWorker || W();
                  };
                  D.addEventListener("error", L), k.on("test", (P) => {
                    if (D.removeEventListener("error", L), this.destroyed) {
                      W();
                      return;
                    }
                    P ? (this._messageHandler = k, this._port = D, this._webWorker = D, this._readyCapability.resolve(), k.send("configure", {
                      verbosity: this.verbosity
                    })) : (this._setupFakeWorker(), k.destroy(), D.terminate());
                  }), k.on("ready", (P) => {
                    if (D.removeEventListener("error", L), this.destroyed) {
                      W();
                      return;
                    }
                    try {
                      z();
                    } catch {
                      this._setupFakeWorker();
                    }
                  });
                  const z = () => {
                    const P = new Uint8Array();
                    k.send("test", P, [P.buffer]);
                  };
                  z();
                  return;
                } catch {
                  (0, _util.info)("The worker has been disabled.");
                }
              }
              this._setupFakeWorker();
            }
            _setupFakeWorker() {
              PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((O) => {
                if (this.destroyed) {
                  this._readyCapability.reject(new Error("Worker was destroyed"));
                  return;
                }
                const D = new LoopbackPort();
                this._port = D;
                const k = `fake${PDFWorkerUtil.fakeWorkerId++}`, W = new _message_handler.MessageHandler(k + "_worker", k, D);
                O.setup(W, D);
                const L = new _message_handler.MessageHandler(k, k + "_worker", D);
                this._messageHandler = L, this._readyCapability.resolve(), L.send("configure", {
                  verbosity: this.verbosity
                });
              }).catch((O) => {
                this._readyCapability.reject(new Error(`Setting up fake worker failed: "${O.message}".`));
              });
            }
            destroy() {
              var O;
              this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), (O = se(_PDFWorker, h)) == null || O.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
            }
            static fromPort(O) {
              var k;
              if (!(O != null && O.port))
                throw new Error("PDFWorker.fromPort - invalid method signature.");
              const D = (k = se(this, h)) == null ? void 0 : k.get(O.port);
              if (D) {
                if (D._pendingDestroy)
                  throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                return D;
              }
              return new _PDFWorker(O);
            }
            static get workerSrc() {
              if (_worker_options.GlobalWorkerOptions.workerSrc)
                return _worker_options.GlobalWorkerOptions.workerSrc;
              if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                return _util.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
              throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
            }
            static get _mainThreadWorkerMessageHandler() {
              var O;
              try {
                return ((O = globalThis.pdfjsWorker) == null ? void 0 : O.WorkerMessageHandler) || null;
              } catch {
                return null;
              }
            }
            static get _setupFakeWorkerGlobal() {
              const loader = async () => {
                const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                if (mainWorkerMessageHandler)
                  return mainWorkerMessageHandler;
                if (_util.isNodeJS && typeof commonjsRequire == "function") {
                  const worker = eval("require")(this.workerSrc);
                  return worker.WorkerMessageHandler;
                }
                return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
              };
              return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
            }
          };
          h = new WeakMap(), Ge(_PDFWorker, h, void 0);
          let PDFWorker = _PDFWorker;
          exports.PDFWorker = PDFWorker;
          class WorkerTransport {
            constructor(D, k, W, L, z) {
              Ge(this, v);
              Ge(this, g, /* @__PURE__ */ new Map());
              Ge(this, x, /* @__PURE__ */ new Map());
              Ge(this, E, /* @__PURE__ */ new Map());
              Ge(this, m, null);
              this.messageHandler = D, this.loadingTask = k, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                ownerDocument: L.ownerDocument,
                styleElement: L.styleElement
              }), this._params = L, this.canvasFactory = z.canvasFactory, this.filterFactory = z.filterFactory, this.cMapReaderFactory = z.cMapReaderFactory, this.standardFontDataFactory = z.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = W, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = new _util.PromiseCapability(), this.setupMessageHandler();
            }
            get annotationStorage() {
              return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
            }
            getRenderingIntent(D, k = _util.AnnotationMode.ENABLE, W = null, L = !1) {
              let z = _util.RenderingIntentFlag.DISPLAY, P = _annotation_storage.SerializableEmpty;
              switch (D) {
                case "any":
                  z = _util.RenderingIntentFlag.ANY;
                  break;
                case "display":
                  break;
                case "print":
                  z = _util.RenderingIntentFlag.PRINT;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid intent: ${D}`);
              }
              switch (k) {
                case _util.AnnotationMode.DISABLE:
                  z += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                  break;
                case _util.AnnotationMode.ENABLE:
                  break;
                case _util.AnnotationMode.ENABLE_FORMS:
                  z += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                  break;
                case _util.AnnotationMode.ENABLE_STORAGE:
                  z += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, P = (z & _util.RenderingIntentFlag.PRINT && W instanceof _annotation_storage.PrintAnnotationStorage ? W : this.annotationStorage).serializable;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${k}`);
              }
              return L && (z += _util.RenderingIntentFlag.OPLIST), {
                renderingIntent: z,
                cacheKey: `${z}_${P.hash}`,
                annotationStorageSerializable: P
              };
            }
            destroy() {
              var W;
              if (this.destroyCapability)
                return this.destroyCapability.promise;
              this.destroyed = !0, this.destroyCapability = new _util.PromiseCapability(), (W = se(this, m)) == null || W.reject(new Error("Worker was destroyed during onPassword callback"));
              const D = [];
              for (const L of se(this, x).values())
                D.push(L._destroy());
              se(this, x).clear(), se(this, E).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
              const k = this.messageHandler.sendWithPromise("Terminate", null);
              return D.push(k), Promise.all(D).then(() => {
                var L;
                this.commonObjs.clear(), this.fontLoader.clear(), se(this, g).clear(), this.filterFactory.destroy(), (L = this._networkStream) == null || L.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
              }, this.destroyCapability.reject), this.destroyCapability.promise;
            }
            setupMessageHandler() {
              const {
                messageHandler: D,
                loadingTask: k
              } = this;
              D.on("GetReader", (W, L) => {
                (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (z) => {
                  this._lastProgress = {
                    loaded: z.loaded,
                    total: z.total
                  };
                }, L.onPull = () => {
                  this._fullReader.read().then(function({
                    value: z,
                    done: P
                  }) {
                    if (P) {
                      L.close();
                      return;
                    }
                    (0, _util.assert)(z instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), L.enqueue(new Uint8Array(z), 1, [z]);
                  }).catch((z) => {
                    L.error(z);
                  });
                }, L.onCancel = (z) => {
                  this._fullReader.cancel(z), L.ready.catch((P) => {
                    if (!this.destroyed)
                      throw P;
                  });
                };
              }), D.on("ReaderHeadersReady", (W) => {
                const L = new _util.PromiseCapability(), z = this._fullReader;
                return z.headersReady.then(() => {
                  var P;
                  (!z.isStreamingSupported || !z.isRangeSupported) && (this._lastProgress && ((P = k.onProgress) == null || P.call(k, this._lastProgress)), z.onProgress = (Q) => {
                    var Y;
                    (Y = k.onProgress) == null || Y.call(k, {
                      loaded: Q.loaded,
                      total: Q.total
                    });
                  }), L.resolve({
                    isStreamingSupported: z.isStreamingSupported,
                    isRangeSupported: z.isRangeSupported,
                    contentLength: z.contentLength
                  });
                }, L.reject), L.promise;
              }), D.on("GetRangeReader", (W, L) => {
                (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                const z = this._networkStream.getRangeReader(W.begin, W.end);
                if (!z) {
                  L.close();
                  return;
                }
                L.onPull = () => {
                  z.read().then(function({
                    value: P,
                    done: Q
                  }) {
                    if (Q) {
                      L.close();
                      return;
                    }
                    (0, _util.assert)(P instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), L.enqueue(new Uint8Array(P), 1, [P]);
                  }).catch((P) => {
                    L.error(P);
                  });
                }, L.onCancel = (P) => {
                  z.cancel(P), L.ready.catch((Q) => {
                    if (!this.destroyed)
                      throw Q;
                  });
                };
              }), D.on("GetDoc", ({
                pdfInfo: W
              }) => {
                this._numPages = W.numPages, this._htmlForXfa = W.htmlForXfa, delete W.htmlForXfa, k._capability.resolve(new PDFDocumentProxy(W, this));
              }), D.on("DocException", function(W) {
                let L;
                switch (W.name) {
                  case "PasswordException":
                    L = new _util.PasswordException(W.message, W.code);
                    break;
                  case "InvalidPDFException":
                    L = new _util.InvalidPDFException(W.message);
                    break;
                  case "MissingPDFException":
                    L = new _util.MissingPDFException(W.message);
                    break;
                  case "UnexpectedResponseException":
                    L = new _util.UnexpectedResponseException(W.message, W.status);
                    break;
                  case "UnknownErrorException":
                    L = new _util.UnknownErrorException(W.message, W.details);
                    break;
                  default:
                    (0, _util.unreachable)("DocException - expected a valid Error.");
                }
                k._capability.reject(L);
              }), D.on("PasswordRequest", (W) => {
                if (at(this, m, new _util.PromiseCapability()), k.onPassword) {
                  const L = (z) => {
                    z instanceof Error ? se(this, m).reject(z) : se(this, m).resolve({
                      password: z
                    });
                  };
                  try {
                    k.onPassword(L, W.code);
                  } catch (z) {
                    se(this, m).reject(z);
                  }
                } else
                  se(this, m).reject(new _util.PasswordException(W.message, W.code));
                return se(this, m).promise;
              }), D.on("DataLoaded", (W) => {
                var L;
                (L = k.onProgress) == null || L.call(k, {
                  loaded: W.length,
                  total: W.length
                }), this.downloadInfoCapability.resolve(W);
              }), D.on("StartRenderPage", (W) => {
                if (this.destroyed)
                  return;
                se(this, x).get(W.pageIndex)._startRenderPage(W.transparency, W.cacheKey);
              }), D.on("commonobj", ([W, L, z]) => {
                var P;
                if (!this.destroyed && !this.commonObjs.has(W))
                  switch (L) {
                    case "Font":
                      const Q = this._params;
                      if ("error" in z) {
                        const te = z.error;
                        (0, _util.warn)(`Error during font loading: ${te}`), this.commonObjs.resolve(W, te);
                        break;
                      }
                      const Y = Q.pdfBug && ((P = globalThis.FontInspector) != null && P.enabled) ? (te, Z) => globalThis.FontInspector.fontAdded(te, Z) : null, ie = new _font_loader.FontFaceObject(z, {
                        isEvalSupported: Q.isEvalSupported,
                        disableFontFace: Q.disableFontFace,
                        ignoreErrors: Q.ignoreErrors,
                        inspectFont: Y
                      });
                      this.fontLoader.bind(ie).catch((te) => D.sendWithPromise("FontFallback", {
                        id: W
                      })).finally(() => {
                        !Q.fontExtraProperties && ie.data && (ie.data = null), this.commonObjs.resolve(W, ie);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                    case "Pattern":
                      this.commonObjs.resolve(W, z);
                      break;
                    default:
                      throw new Error(`Got unknown common object type ${L}`);
                  }
              }), D.on("obj", ([W, L, z, P]) => {
                var Y;
                if (this.destroyed)
                  return;
                const Q = se(this, x).get(L);
                if (!Q.objs.has(W))
                  switch (z) {
                    case "Image":
                      if (Q.objs.resolve(W, P), P) {
                        let ie;
                        if (P.bitmap) {
                          const {
                            width: te,
                            height: Z
                          } = P;
                          ie = te * Z * 4;
                        } else
                          ie = ((Y = P.data) == null ? void 0 : Y.length) || 0;
                        ie > _util.MAX_IMAGE_SIZE_TO_CACHE && (Q._maybeCleanupAfterRender = !0);
                      }
                      break;
                    case "Pattern":
                      Q.objs.resolve(W, P);
                      break;
                    default:
                      throw new Error(`Got unknown object type ${z}`);
                  }
              }), D.on("DocProgress", (W) => {
                var L;
                this.destroyed || (L = k.onProgress) == null || L.call(k, {
                  loaded: W.loaded,
                  total: W.total
                });
              }), D.on("FetchBuiltInCMap", (W) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(W) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), D.on("FetchStandardFontData", (W) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(W) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
            }
            getData() {
              return this.messageHandler.sendWithPromise("GetData", null);
            }
            saveDocument() {
              var W;
              this.annotationStorage.size <= 0 && (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
              const {
                map: D,
                transfers: k
              } = this.annotationStorage.serializable;
              return this.messageHandler.sendWithPromise("SaveDocument", {
                isPureXfa: !!this._htmlForXfa,
                numPages: this._numPages,
                annotationStorage: D,
                filename: ((W = this._fullReader) == null ? void 0 : W.filename) ?? null
              }, k).finally(() => {
                this.annotationStorage.resetModified();
              });
            }
            getPage(D) {
              if (!Number.isInteger(D) || D <= 0 || D > this._numPages)
                return Promise.reject(new Error("Invalid page request."));
              const k = D - 1, W = se(this, E).get(k);
              if (W)
                return W;
              const L = this.messageHandler.sendWithPromise("GetPage", {
                pageIndex: k
              }).then((z) => {
                if (this.destroyed)
                  throw new Error("Transport destroyed");
                const P = new PDFPageProxy(k, z, this, this._params.pdfBug);
                return se(this, x).set(k, P), P;
              });
              return se(this, E).set(k, L), L;
            }
            getPageIndex(D) {
              return typeof D != "object" || D === null || !Number.isInteger(D.num) || D.num < 0 || !Number.isInteger(D.gen) || D.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                num: D.num,
                gen: D.gen
              });
            }
            getAnnotations(D, k) {
              return this.messageHandler.sendWithPromise("GetAnnotations", {
                pageIndex: D,
                intent: k
              });
            }
            getFieldObjects() {
              return Ke(this, v, pr).call(this, "GetFieldObjects");
            }
            hasJSActions() {
              return Ke(this, v, pr).call(this, "HasJSActions");
            }
            getCalculationOrderIds() {
              return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
            }
            getDestinations() {
              return this.messageHandler.sendWithPromise("GetDestinations", null);
            }
            getDestination(D) {
              return typeof D != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                id: D
              });
            }
            getPageLabels() {
              return this.messageHandler.sendWithPromise("GetPageLabels", null);
            }
            getPageLayout() {
              return this.messageHandler.sendWithPromise("GetPageLayout", null);
            }
            getPageMode() {
              return this.messageHandler.sendWithPromise("GetPageMode", null);
            }
            getViewerPreferences() {
              return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
            }
            getOpenAction() {
              return this.messageHandler.sendWithPromise("GetOpenAction", null);
            }
            getAttachments() {
              return this.messageHandler.sendWithPromise("GetAttachments", null);
            }
            getDocJSActions() {
              return Ke(this, v, pr).call(this, "GetDocJSActions");
            }
            getPageJSActions(D) {
              return this.messageHandler.sendWithPromise("GetPageJSActions", {
                pageIndex: D
              });
            }
            getStructTree(D) {
              return this.messageHandler.sendWithPromise("GetStructTree", {
                pageIndex: D
              });
            }
            getOutline() {
              return this.messageHandler.sendWithPromise("GetOutline", null);
            }
            getOptionalContentConfig() {
              return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((D) => new _optional_content_config.OptionalContentConfig(D));
            }
            getPermissions() {
              return this.messageHandler.sendWithPromise("GetPermissions", null);
            }
            getMetadata() {
              const D = "GetMetadata", k = se(this, g).get(D);
              if (k)
                return k;
              const W = this.messageHandler.sendWithPromise(D, null).then((L) => {
                var z, P;
                return {
                  info: L[0],
                  metadata: L[1] ? new _metadata.Metadata(L[1]) : null,
                  contentDispositionFilename: ((z = this._fullReader) == null ? void 0 : z.filename) ?? null,
                  contentLength: ((P = this._fullReader) == null ? void 0 : P.contentLength) ?? null
                };
              });
              return se(this, g).set(D, W), W;
            }
            getMarkInfo() {
              return this.messageHandler.sendWithPromise("GetMarkInfo", null);
            }
            async startCleanup(D = !1) {
              if (!this.destroyed) {
                await this.messageHandler.sendWithPromise("Cleanup", null);
                for (const k of se(this, x).values())
                  if (!k.cleanup())
                    throw new Error(`startCleanup: Page ${k.pageNumber} is currently rendering.`);
                this.commonObjs.clear(), D || this.fontLoader.clear(), se(this, g).clear(), this.filterFactory.destroy(!0);
              }
            }
            get loadingParams() {
              const {
                disableAutoFetch: D,
                enableXfa: k
              } = this._params;
              return (0, _util.shadow)(this, "loadingParams", {
                disableAutoFetch: D,
                enableXfa: k
              });
            }
          }
          g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakSet(), pr = function(D, k = null) {
            const W = se(this, g).get(D);
            if (W)
              return W;
            const L = this.messageHandler.sendWithPromise(D, k);
            return se(this, g).set(D, L), L;
          };
          class PDFObjects {
            constructor() {
              Ge(this, b);
              Ge(this, A, /* @__PURE__ */ Object.create(null));
            }
            get(D, k = null) {
              if (k) {
                const L = Ke(this, b, Xr).call(this, D);
                return L.capability.promise.then(() => k(L.data)), null;
              }
              const W = se(this, A)[D];
              if (!(W != null && W.capability.settled))
                throw new Error(`Requesting object that isn't resolved yet ${D}.`);
              return W.data;
            }
            has(D) {
              const k = se(this, A)[D];
              return (k == null ? void 0 : k.capability.settled) || !1;
            }
            resolve(D, k = null) {
              const W = Ke(this, b, Xr).call(this, D);
              W.data = k, W.capability.resolve();
            }
            clear() {
              var D;
              for (const k in se(this, A)) {
                const {
                  data: W
                } = se(this, A)[k];
                (D = W == null ? void 0 : W.bitmap) == null || D.close();
              }
              at(this, A, /* @__PURE__ */ Object.create(null));
            }
          }
          A = new WeakMap(), b = new WeakSet(), Xr = function(D) {
            var k;
            return (k = se(this, A))[D] || (k[D] = {
              capability: new _util.PromiseCapability(),
              data: null
            });
          };
          class RenderTask {
            constructor(D) {
              Ge(this, T, null);
              at(this, T, D), this.onContinue = null;
            }
            get promise() {
              return se(this, T).capability.promise;
            }
            cancel(D = 0) {
              se(this, T).cancel(null, D);
            }
            get separateAnnots() {
              const {
                separateAnnots: D
              } = se(this, T).operatorList;
              if (!D)
                return !1;
              const {
                annotationCanvasMap: k
              } = se(this, T);
              return D.form || D.canvas && (k == null ? void 0 : k.size) > 0;
            }
          }
          T = new WeakMap(), exports.RenderTask = RenderTask;
          const R = class R {
            constructor({
              callback: D,
              params: k,
              objs: W,
              commonObjs: L,
              annotationCanvasMap: z,
              operatorList: P,
              pageIndex: Q,
              canvasFactory: Y,
              filterFactory: ie,
              useRequestAnimationFrame: te = !1,
              pdfBug: Z = !1,
              pageColors: ae = null
            }) {
              this.callback = D, this.params = k, this.objs = W, this.commonObjs = L, this.annotationCanvasMap = z, this.operatorListIdx = null, this.operatorList = P, this._pageIndex = Q, this.canvasFactory = Y, this.filterFactory = ie, this._pdfBug = Z, this.pageColors = ae, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = te === !0 && typeof window < "u", this.cancelled = !1, this.capability = new _util.PromiseCapability(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = k.canvasContext.canvas;
            }
            get completed() {
              return this.capability.promise.catch(function() {
              });
            }
            initializeGraphics({
              transparency: D = !1,
              optionalContentConfig: k
            }) {
              var Q, Y;
              if (this.cancelled)
                return;
              if (this._canvas) {
                if (se(R, w).has(this._canvas))
                  throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                se(R, w).add(this._canvas);
              }
              this._pdfBug && ((Q = globalThis.StepperManager) != null && Q.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
              const {
                canvasContext: W,
                viewport: L,
                transform: z,
                background: P
              } = this.params;
              this.gfx = new _canvas.CanvasGraphics(W, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                optionalContentConfig: k
              }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                transform: z,
                viewport: L,
                transparency: D,
                background: P
              }), this.operatorListIdx = 0, this.graphicsReady = !0, (Y = this.graphicsReadyCallback) == null || Y.call(this);
            }
            cancel(D = null, k = 0) {
              var W;
              this.running = !1, this.cancelled = !0, (W = this.gfx) == null || W.endDrawing(), se(R, w).delete(this._canvas), this.callback(D || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, k));
            }
            operatorListChanged() {
              var D;
              if (!this.graphicsReady) {
                this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                return;
              }
              (D = this.stepper) == null || D.updateOperatorList(this.operatorList), !this.running && this._continue();
            }
            _continue() {
              this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
            }
            _scheduleNext() {
              this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                this._nextBound().catch(this._cancelBound);
              }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
            }
            async _next() {
              this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), se(R, w).delete(this._canvas), this.callback())));
            }
          };
          w = new WeakMap(), Ge(R, w, /* @__PURE__ */ new WeakSet());
          let InternalRenderTask = R;
          const version = "3.11.174";
          exports.version = version;
          const build = "ce8716743";
          exports.build = build;
        },
        /* 3 */
        /***/
        (t, e, n) => {
          var d, f, h, ya, x;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.SerializableEmpty = e.PrintAnnotationStorage = e.AnnotationStorage = void 0;
          var a = n(1), s = n(4), o = n(8);
          const l = Object.freeze({
            map: null,
            hash: "",
            transfers: void 0
          });
          e.SerializableEmpty = l;
          class c {
            constructor() {
              Ge(this, h);
              Ge(this, d, !1);
              Ge(this, f, /* @__PURE__ */ new Map());
              this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
            }
            getValue(m, v) {
              const y = se(this, f).get(m);
              return y === void 0 ? v : Object.assign(v, y);
            }
            getRawValue(m) {
              return se(this, f).get(m);
            }
            remove(m) {
              if (se(this, f).delete(m), se(this, f).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                for (const v of se(this, f).values())
                  if (v instanceof s.AnnotationEditor)
                    return;
                this.onAnnotationEditor(null);
              }
            }
            setValue(m, v) {
              const y = se(this, f).get(m);
              let A = !1;
              if (y !== void 0)
                for (const [b, C] of Object.entries(v))
                  y[b] !== C && (A = !0, y[b] = C);
              else
                A = !0, se(this, f).set(m, v);
              A && Ke(this, h, ya).call(this), v instanceof s.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(v.constructor._type);
            }
            has(m) {
              return se(this, f).has(m);
            }
            getAll() {
              return se(this, f).size > 0 ? (0, a.objectFromMap)(se(this, f)) : null;
            }
            setAll(m) {
              for (const [v, y] of Object.entries(m))
                this.setValue(v, y);
            }
            get size() {
              return se(this, f).size;
            }
            resetModified() {
              se(this, d) && (at(this, d, !1), typeof this.onResetModified == "function" && this.onResetModified());
            }
            get print() {
              return new u(this);
            }
            get serializable() {
              if (se(this, f).size === 0)
                return l;
              const m = /* @__PURE__ */ new Map(), v = new o.MurmurHash3_64(), y = [], A = /* @__PURE__ */ Object.create(null);
              let b = !1;
              for (const [C, T] of se(this, f)) {
                const w = T instanceof s.AnnotationEditor ? T.serialize(!1, A) : T;
                w && (m.set(C, w), v.update(`${C}:${JSON.stringify(w)}`), b || (b = !!w.bitmap));
              }
              if (b)
                for (const C of m.values())
                  C.bitmap && y.push(C.bitmap);
              return m.size > 0 ? {
                map: m,
                hash: v.hexdigest(),
                transfers: y
              } : l;
            }
          }
          d = new WeakMap(), f = new WeakMap(), h = new WeakSet(), ya = function() {
            se(this, d) || (at(this, d, !0), typeof this.onSetModified == "function" && this.onSetModified());
          }, e.AnnotationStorage = c;
          class u extends c {
            constructor(v) {
              super();
              Ge(this, x, void 0);
              const {
                map: y,
                hash: A,
                transfers: b
              } = v.serializable, C = structuredClone(y, b ? {
                transfer: b
              } : null);
              at(this, x, {
                map: C,
                hash: A,
                transfers: b
              });
            }
            get print() {
              (0, a.unreachable)("Should not call PrintAnnotationStorage.print");
            }
            get serializable() {
              return se(this, x);
            }
          }
          x = new WeakMap(), e.PrintAnnotationStorage = u;
        },
        /* 4 */
        /***/
        (t, e, n) => {
          var u, d, f, h, g, x, E, m, v, y, A, b, C, T, w, qr, O, jr, k, $r, L, Yr, P, ba, Y, Ea, te, Aa, ae, Kr, U, Ta;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.AnnotationEditor = void 0;
          var a = n(5), s = n(1), o = n(6);
          const M = class M {
            constructor(N) {
              Ge(this, w);
              Ge(this, O);
              Ge(this, L);
              Ge(this, P);
              Ge(this, Y);
              Ge(this, te);
              Ge(this, ae);
              Ge(this, U);
              Ge(this, u, "");
              Ge(this, d, !1);
              Ge(this, f, null);
              Ge(this, h, null);
              Ge(this, g, null);
              Ge(this, x, !1);
              Ge(this, E, null);
              Ge(this, m, this.focusin.bind(this));
              Ge(this, v, this.focusout.bind(this));
              Ge(this, y, !1);
              Ge(this, A, !1);
              Ge(this, b, !1);
              Xt(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
              Xt(this, "_uiManager", null);
              Xt(this, "_focusEventsAllowed", !0);
              Xt(this, "_l10nPromise", null);
              Ge(this, C, !1);
              Ge(this, T, M._zIndex++);
              this.constructor === M && (0, s.unreachable)("Cannot initialize AnnotationEditor."), this.parent = N.parent, this.id = N.id, this.width = this.height = null, this.pageIndex = N.parent.pageIndex, this.name = N.name, this.div = null, this._uiManager = N.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = N.isCentered, this._structTreeParentId = null;
              const {
                rotation: V,
                rawDims: {
                  pageWidth: q,
                  pageHeight: H,
                  pageX: ne,
                  pageY: he
                }
              } = this.parent.viewport;
              this.rotation = V, this.pageRotation = (360 + V - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [q, H], this.pageTranslation = [ne, he];
              const [j, Fe] = this.parentDimensions;
              this.x = N.x / j, this.y = N.y / Fe, this.isAttachedToDOM = !1, this.deleted = !1;
            }
            get editorType() {
              return Object.getPrototypeOf(this).constructor._type;
            }
            static get _defaultLineColor() {
              return (0, s.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
            }
            static deleteAnnotationElement(N) {
              const V = new c({
                id: N.parent.getNextId(),
                parent: N.parent,
                uiManager: N._uiManager
              });
              V.annotationElementId = N.annotationElementId, V.deleted = !0, V._uiManager.addToAnnotationStorage(V);
            }
            static initialize(N, V = null) {
              if (M._l10nPromise || (M._l10nPromise = new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((H) => [H, N.get(H)]))), V != null && V.strings)
                for (const H of V.strings)
                  M._l10nPromise.set(H, N.get(H));
              if (M._borderLineWidth !== -1)
                return;
              const q = getComputedStyle(document.documentElement);
              M._borderLineWidth = parseFloat(q.getPropertyValue("--outline-width")) || 0;
            }
            static updateDefaultParams(N, V) {
            }
            static get defaultPropertiesToUpdate() {
              return [];
            }
            static isHandlingMimeForPasting(N) {
              return !1;
            }
            static paste(N, V) {
              (0, s.unreachable)("Not implemented");
            }
            get propertiesToUpdate() {
              return [];
            }
            get _isDraggable() {
              return se(this, C);
            }
            set _isDraggable(N) {
              var V;
              at(this, C, N), (V = this.div) == null || V.classList.toggle("draggable", N);
            }
            center() {
              const [N, V] = this.pageDimensions;
              switch (this.parentRotation) {
                case 90:
                  this.x -= this.height * V / (N * 2), this.y += this.width * N / (V * 2);
                  break;
                case 180:
                  this.x += this.width / 2, this.y += this.height / 2;
                  break;
                case 270:
                  this.x += this.height * V / (N * 2), this.y -= this.width * N / (V * 2);
                  break;
                default:
                  this.x -= this.width / 2, this.y -= this.height / 2;
                  break;
              }
              this.fixAndSetPosition();
            }
            addCommands(N) {
              this._uiManager.addCommands(N);
            }
            get currentLayer() {
              return this._uiManager.currentLayer;
            }
            setInBackground() {
              this.div.style.zIndex = 0;
            }
            setInForeground() {
              this.div.style.zIndex = se(this, T);
            }
            setParent(N) {
              N !== null && (this.pageIndex = N.pageIndex, this.pageDimensions = N.pageDimensions), this.parent = N;
            }
            focusin(N) {
              this._focusEventsAllowed && (se(this, y) ? at(this, y, !1) : this.parent.setSelected(this));
            }
            focusout(N) {
              var q;
              if (!this._focusEventsAllowed || !this.isAttachedToDOM)
                return;
              const V = N.relatedTarget;
              V != null && V.closest(`#${this.id}`) || (N.preventDefault(), (q = this.parent) != null && q.isMultipleSelection || this.commitOrRemove());
            }
            commitOrRemove() {
              this.isEmpty() ? this.remove() : this.commit();
            }
            commit() {
              this.addToAnnotationStorage();
            }
            addToAnnotationStorage() {
              this._uiManager.addToAnnotationStorage(this);
            }
            setAt(N, V, q, H) {
              const [ne, he] = this.parentDimensions;
              [q, H] = this.screenToPageTranslation(q, H), this.x = (N + q) / ne, this.y = (V + H) / he, this.fixAndSetPosition();
            }
            translate(N, V) {
              Ke(this, w, qr).call(this, this.parentDimensions, N, V);
            }
            translateInPage(N, V) {
              Ke(this, w, qr).call(this, this.pageDimensions, N, V), this.div.scrollIntoView({
                block: "nearest"
              });
            }
            drag(N, V) {
              const [q, H] = this.parentDimensions;
              if (this.x += N / q, this.y += V / H, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                const {
                  x: X,
                  y: ye
                } = this.div.getBoundingClientRect();
                this.parent.findNewParent(this, X, ye) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
              }
              let {
                x: ne,
                y: he
              } = this;
              const [j, Fe] = Ke(this, O, jr).call(this);
              ne += j, he += Fe, this.div.style.left = `${(100 * ne).toFixed(2)}%`, this.div.style.top = `${(100 * he).toFixed(2)}%`, this.div.scrollIntoView({
                block: "nearest"
              });
            }
            fixAndSetPosition() {
              const [N, V] = this.pageDimensions;
              let {
                x: q,
                y: H,
                width: ne,
                height: he
              } = this;
              switch (ne *= N, he *= V, q *= N, H *= V, this.rotation) {
                case 0:
                  q = Math.max(0, Math.min(N - ne, q)), H = Math.max(0, Math.min(V - he, H));
                  break;
                case 90:
                  q = Math.max(0, Math.min(N - he, q)), H = Math.min(V, Math.max(ne, H));
                  break;
                case 180:
                  q = Math.min(N, Math.max(ne, q)), H = Math.min(V, Math.max(he, H));
                  break;
                case 270:
                  q = Math.min(N, Math.max(he, q)), H = Math.max(0, Math.min(V - ne, H));
                  break;
              }
              this.x = q /= N, this.y = H /= V;
              const [j, Fe] = Ke(this, O, jr).call(this);
              q += j, H += Fe;
              const {
                style: X
              } = this.div;
              X.left = `${(100 * q).toFixed(2)}%`, X.top = `${(100 * H).toFixed(2)}%`, this.moveInDOM();
            }
            screenToPageTranslation(N, V) {
              var q;
              return Ke(q = M, k, $r).call(q, N, V, this.parentRotation);
            }
            pageTranslationToScreen(N, V) {
              var q;
              return Ke(q = M, k, $r).call(q, N, V, 360 - this.parentRotation);
            }
            get parentScale() {
              return this._uiManager.viewParameters.realScale;
            }
            get parentRotation() {
              return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
            }
            get parentDimensions() {
              const {
                parentScale: N,
                pageDimensions: [V, q]
              } = this, H = V * N, ne = q * N;
              return s.FeatureTest.isCSSRoundSupported ? [Math.round(H), Math.round(ne)] : [H, ne];
            }
            setDims(N, V) {
              var ne;
              const [q, H] = this.parentDimensions;
              this.div.style.width = `${(100 * N / q).toFixed(2)}%`, se(this, x) || (this.div.style.height = `${(100 * V / H).toFixed(2)}%`), (ne = se(this, f)) == null || ne.classList.toggle("small", N < M.SMALL_EDITOR_SIZE || V < M.SMALL_EDITOR_SIZE);
            }
            fixDims() {
              const {
                style: N
              } = this.div, {
                height: V,
                width: q
              } = N, H = q.endsWith("%"), ne = !se(this, x) && V.endsWith("%");
              if (H && ne)
                return;
              const [he, j] = this.parentDimensions;
              H || (N.width = `${(100 * parseFloat(q) / he).toFixed(2)}%`), !se(this, x) && !ne && (N.height = `${(100 * parseFloat(V) / j).toFixed(2)}%`);
            }
            getInitialTranslation() {
              return [0, 0];
            }
            async addAltTextButton() {
              if (se(this, f))
                return;
              const N = at(this, f, document.createElement("button"));
              N.className = "altText";
              const V = await M._l10nPromise.get("editor_alt_text_button_label");
              N.textContent = V, N.setAttribute("aria-label", V), N.tabIndex = "0", N.addEventListener("contextmenu", o.noContextMenu), N.addEventListener("pointerdown", (q) => q.stopPropagation()), N.addEventListener("click", (q) => {
                q.preventDefault(), this._uiManager.editAltText(this);
              }, {
                capture: !0
              }), N.addEventListener("keydown", (q) => {
                q.target === N && q.key === "Enter" && (q.preventDefault(), this._uiManager.editAltText(this));
              }), Ke(this, ae, Kr).call(this), this.div.append(N), M.SMALL_EDITOR_SIZE || (M.SMALL_EDITOR_SIZE = Math.min(128, Math.round(N.getBoundingClientRect().width * 1.4)));
            }
            getClientDimensions() {
              return this.div.getBoundingClientRect();
            }
            get altTextData() {
              return {
                altText: se(this, u),
                decorative: se(this, d)
              };
            }
            set altTextData({
              altText: N,
              decorative: V
            }) {
              se(this, u) === N && se(this, d) === V || (at(this, u, N), at(this, d, V), Ke(this, ae, Kr).call(this));
            }
            render() {
              this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", se(this, m)), this.div.addEventListener("focusout", se(this, v));
              const [N, V] = this.parentDimensions;
              this.parentRotation % 180 !== 0 && (this.div.style.maxWidth = `${(100 * V / N).toFixed(2)}%`, this.div.style.maxHeight = `${(100 * N / V).toFixed(2)}%`);
              const [q, H] = this.getInitialTranslation();
              return this.translate(q, H), (0, a.bindEvents)(this, this.div, ["pointerdown"]), this.div;
            }
            pointerdown(N) {
              const {
                isMac: V
              } = s.FeatureTest.platform;
              if (N.button !== 0 || N.ctrlKey && V) {
                N.preventDefault();
                return;
              }
              at(this, y, !0), Ke(this, U, Ta).call(this, N);
            }
            moveInDOM() {
              var N;
              (N = this.parent) == null || N.moveEditorInDOM(this);
            }
            _setParentAndPosition(N, V, q) {
              N.changeParent(this), this.x = V, this.y = q, this.fixAndSetPosition();
            }
            getRect(N, V) {
              const q = this.parentScale, [H, ne] = this.pageDimensions, [he, j] = this.pageTranslation, Fe = N / q, X = V / q, ye = this.x * H, Ae = this.y * ne, fe = this.width * H, _e = this.height * ne;
              switch (this.rotation) {
                case 0:
                  return [ye + Fe + he, ne - Ae - X - _e + j, ye + Fe + fe + he, ne - Ae - X + j];
                case 90:
                  return [ye + X + he, ne - Ae + Fe + j, ye + X + _e + he, ne - Ae + Fe + fe + j];
                case 180:
                  return [ye - Fe - fe + he, ne - Ae + X + j, ye - Fe + he, ne - Ae + X + _e + j];
                case 270:
                  return [ye - X - _e + he, ne - Ae - Fe - fe + j, ye - X + he, ne - Ae - Fe + j];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            getRectInCurrentCoords(N, V) {
              const [q, H, ne, he] = N, j = ne - q, Fe = he - H;
              switch (this.rotation) {
                case 0:
                  return [q, V - he, j, Fe];
                case 90:
                  return [q, V - H, Fe, j];
                case 180:
                  return [ne, V - H, j, Fe];
                case 270:
                  return [ne, V - he, Fe, j];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            onceAdded() {
            }
            isEmpty() {
              return !1;
            }
            enableEditMode() {
              at(this, b, !0);
            }
            disableEditMode() {
              at(this, b, !1);
            }
            isInEditMode() {
              return se(this, b);
            }
            shouldGetKeyboardEvents() {
              return !1;
            }
            needsToBeRebuilt() {
              return this.div && !this.isAttachedToDOM;
            }
            rebuild() {
              var N, V;
              (N = this.div) == null || N.addEventListener("focusin", se(this, m)), (V = this.div) == null || V.addEventListener("focusout", se(this, v));
            }
            serialize(N = !1, V = null) {
              (0, s.unreachable)("An editor must be serializable");
            }
            static deserialize(N, V, q) {
              const H = new this.prototype.constructor({
                parent: V,
                id: V.getNextId(),
                uiManager: q
              });
              H.rotation = N.rotation;
              const [ne, he] = H.pageDimensions, [j, Fe, X, ye] = H.getRectInCurrentCoords(N.rect, he);
              return H.x = j / ne, H.y = Fe / he, H.width = X / ne, H.height = ye / he, H;
            }
            remove() {
              var N;
              this.div.removeEventListener("focusin", se(this, m)), this.div.removeEventListener("focusout", se(this, v)), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), (N = se(this, f)) == null || N.remove(), at(this, f, null), at(this, h, null);
            }
            get isResizable() {
              return !1;
            }
            makeResizable() {
              this.isResizable && (Ke(this, P, ba).call(this), se(this, E).classList.remove("hidden"));
            }
            select() {
              var N;
              this.makeResizable(), (N = this.div) == null || N.classList.add("selectedEditor");
            }
            unselect() {
              var N, V, q;
              (N = se(this, E)) == null || N.classList.add("hidden"), (V = this.div) == null || V.classList.remove("selectedEditor"), (q = this.div) != null && q.contains(document.activeElement) && this._uiManager.currentLayer.div.focus();
            }
            updateParams(N, V) {
            }
            disableEditing() {
              se(this, f) && (se(this, f).hidden = !0);
            }
            enableEditing() {
              se(this, f) && (se(this, f).hidden = !1);
            }
            enterInEditMode() {
            }
            get contentDiv() {
              return this.div;
            }
            get isEditing() {
              return se(this, A);
            }
            set isEditing(N) {
              at(this, A, N), this.parent && (N ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
            }
            setAspectRatio(N, V) {
              at(this, x, !0);
              const q = N / V, {
                style: H
              } = this.div;
              H.aspectRatio = q, H.height = "auto";
            }
            static get MIN_SIZE() {
              return 16;
            }
          };
          u = new WeakMap(), d = new WeakMap(), f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakMap(), A = new WeakMap(), b = new WeakMap(), C = new WeakMap(), T = new WeakMap(), w = new WeakSet(), qr = function([N, V], q, H) {
            [q, H] = this.screenToPageTranslation(q, H), this.x += q / N, this.y += H / V, this.fixAndSetPosition();
          }, O = new WeakSet(), jr = function() {
            const [N, V] = this.parentDimensions, {
              _borderLineWidth: q
            } = M, H = q / N, ne = q / V;
            switch (this.rotation) {
              case 90:
                return [-H, ne];
              case 180:
                return [H, ne];
              case 270:
                return [H, -ne];
              default:
                return [-H, -ne];
            }
          }, k = new WeakSet(), $r = function(N, V, q) {
            switch (q) {
              case 90:
                return [V, -N];
              case 180:
                return [-N, -V];
              case 270:
                return [-V, N];
              default:
                return [N, V];
            }
          }, L = new WeakSet(), Yr = function(N) {
            switch (N) {
              case 90: {
                const [V, q] = this.pageDimensions;
                return [0, -V / q, q / V, 0];
              }
              case 180:
                return [-1, 0, 0, -1];
              case 270: {
                const [V, q] = this.pageDimensions;
                return [0, V / q, -q / V, 0];
              }
              default:
                return [1, 0, 0, 1];
            }
          }, P = new WeakSet(), ba = function() {
            if (se(this, E))
              return;
            at(this, E, document.createElement("div")), se(this, E).classList.add("resizers");
            const N = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
            this._willKeepAspectRatio || N.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
            for (const V of N) {
              const q = document.createElement("div");
              se(this, E).append(q), q.classList.add("resizer", V), q.addEventListener("pointerdown", Ke(this, Y, Ea).bind(this, V)), q.addEventListener("contextmenu", o.noContextMenu);
            }
            this.div.prepend(se(this, E));
          }, Y = new WeakSet(), Ea = function(N, V) {
            V.preventDefault();
            const {
              isMac: q
            } = s.FeatureTest.platform;
            if (V.button !== 0 || V.ctrlKey && q)
              return;
            const H = Ke(this, te, Aa).bind(this, N), ne = this._isDraggable;
            this._isDraggable = !1;
            const he = {
              passive: !0,
              capture: !0
            };
            window.addEventListener("pointermove", H, he);
            const j = this.x, Fe = this.y, X = this.width, ye = this.height, Ae = this.parent.div.style.cursor, fe = this.div.style.cursor;
            this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(V.target).cursor;
            const _e = () => {
              this._isDraggable = ne, window.removeEventListener("pointerup", _e), window.removeEventListener("blur", _e), window.removeEventListener("pointermove", H, he), this.parent.div.style.cursor = Ae, this.div.style.cursor = fe;
              const Ie = this.x, Be = this.y, $e = this.width, Me = this.height;
              Ie === j && Be === Fe && $e === X && Me === ye || this.addCommands({
                cmd: () => {
                  this.width = $e, this.height = Me, this.x = Ie, this.y = Be;
                  const [J, K] = this.parentDimensions;
                  this.setDims(J * $e, K * Me), this.fixAndSetPosition();
                },
                undo: () => {
                  this.width = X, this.height = ye, this.x = j, this.y = Fe;
                  const [J, K] = this.parentDimensions;
                  this.setDims(J * X, K * ye), this.fixAndSetPosition();
                },
                mustExec: !0
              });
            };
            window.addEventListener("pointerup", _e), window.addEventListener("blur", _e);
          }, te = new WeakSet(), Aa = function(N, V) {
            const [q, H] = this.parentDimensions, ne = this.x, he = this.y, j = this.width, Fe = this.height, X = M.MIN_SIZE / q, ye = M.MIN_SIZE / H, Ae = (it) => Math.round(it * 1e4) / 1e4, fe = Ke(this, L, Yr).call(this, this.rotation), _e = (it, Je) => [fe[0] * it + fe[2] * Je, fe[1] * it + fe[3] * Je], Ie = Ke(this, L, Yr).call(this, 360 - this.rotation), Be = (it, Je) => [Ie[0] * it + Ie[2] * Je, Ie[1] * it + Ie[3] * Je];
            let $e, Me, J = !1, K = !1;
            switch (N) {
              case "topLeft":
                J = !0, $e = (it, Je) => [0, 0], Me = (it, Je) => [it, Je];
                break;
              case "topMiddle":
                $e = (it, Je) => [it / 2, 0], Me = (it, Je) => [it / 2, Je];
                break;
              case "topRight":
                J = !0, $e = (it, Je) => [it, 0], Me = (it, Je) => [0, Je];
                break;
              case "middleRight":
                K = !0, $e = (it, Je) => [it, Je / 2], Me = (it, Je) => [0, Je / 2];
                break;
              case "bottomRight":
                J = !0, $e = (it, Je) => [it, Je], Me = (it, Je) => [0, 0];
                break;
              case "bottomMiddle":
                $e = (it, Je) => [it / 2, Je], Me = (it, Je) => [it / 2, 0];
                break;
              case "bottomLeft":
                J = !0, $e = (it, Je) => [0, Je], Me = (it, Je) => [it, 0];
                break;
              case "middleLeft":
                K = !0, $e = (it, Je) => [0, Je / 2], Me = (it, Je) => [it, Je / 2];
                break;
            }
            const ge = $e(j, Fe), Ce = Me(j, Fe);
            let Oe = _e(...Ce);
            const qe = Ae(ne + Oe[0]), ct = Ae(he + Oe[1]);
            let ze = 1, et = 1, [gt, pt] = this.screenToPageTranslation(V.movementX, V.movementY);
            if ([gt, pt] = Be(gt / q, pt / H), J) {
              const it = Math.hypot(j, Fe);
              ze = et = Math.max(Math.min(Math.hypot(Ce[0] - ge[0] - gt, Ce[1] - ge[1] - pt) / it, 1 / j, 1 / Fe), X / j, ye / Fe);
            } else
              K ? ze = Math.max(X, Math.min(1, Math.abs(Ce[0] - ge[0] - gt))) / j : et = Math.max(ye, Math.min(1, Math.abs(Ce[1] - ge[1] - pt))) / Fe;
            const nt = Ae(j * ze), tt = Ae(Fe * et);
            Oe = _e(...Me(nt, tt));
            const Ve = qe - Oe[0], We = ct - Oe[1];
            this.width = nt, this.height = tt, this.x = Ve, this.y = We, this.setDims(q * nt, H * tt), this.fixAndSetPosition();
          }, ae = new WeakSet(), Kr = async function() {
            var q;
            const N = se(this, f);
            if (!N)
              return;
            if (!se(this, u) && !se(this, d)) {
              N.classList.remove("done"), (q = se(this, h)) == null || q.remove();
              return;
            }
            M._l10nPromise.get("editor_alt_text_edit_button_label").then((H) => {
              N.setAttribute("aria-label", H);
            });
            let V = se(this, h);
            if (!V) {
              at(this, h, V = document.createElement("span")), V.className = "tooltip", V.setAttribute("role", "tooltip");
              const H = V.id = `alt-text-tooltip-${this.id}`;
              N.setAttribute("aria-describedby", H);
              const ne = 100;
              N.addEventListener("mouseenter", () => {
                at(this, g, setTimeout(() => {
                  at(this, g, null), se(this, h).classList.add("show"), this._uiManager._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                      type: "editing",
                      subtype: this.editorType,
                      data: {
                        action: "alt_text_tooltip"
                      }
                    }
                  });
                }, ne));
              }), N.addEventListener("mouseleave", () => {
                var he;
                clearTimeout(se(this, g)), at(this, g, null), (he = se(this, h)) == null || he.classList.remove("show");
              });
            }
            N.classList.add("done"), V.innerText = se(this, d) ? await M._l10nPromise.get("editor_alt_text_decorative_tooltip") : se(this, u), V.parentNode || N.append(V);
          }, U = new WeakSet(), Ta = function(N) {
            if (!this._isDraggable)
              return;
            const V = this._uiManager.isSelected(this);
            this._uiManager.setUpDragSession();
            let q, H;
            V && (q = {
              passive: !0,
              capture: !0
            }, H = (he) => {
              const [j, Fe] = this.screenToPageTranslation(he.movementX, he.movementY);
              this._uiManager.dragSelectedEditors(j, Fe);
            }, window.addEventListener("pointermove", H, q));
            const ne = () => {
              if (window.removeEventListener("pointerup", ne), window.removeEventListener("blur", ne), V && window.removeEventListener("pointermove", H, q), at(this, y, !1), !this._uiManager.endDragSession()) {
                const {
                  isMac: he
                } = s.FeatureTest.platform;
                N.ctrlKey && !he || N.shiftKey || N.metaKey && he ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
              }
            };
            window.addEventListener("pointerup", ne), window.addEventListener("blur", ne);
          }, Ge(M, k), Xt(M, "_borderLineWidth", -1), Xt(M, "_colorManager", new a.ColorManager()), Xt(M, "_zIndex", 1), Xt(M, "SMALL_EDITOR_SIZE", 0);
          let l = M;
          e.AnnotationEditor = l;
          class c extends l {
            constructor(N) {
              super(N), this.annotationElementId = N.annotationElementId, this.deleted = !0;
            }
            serialize() {
              return {
                id: this.annotationElementId,
                deleted: !0,
                pageIndex: this.pageIndex
              };
            }
          }
        },
        /* 5 */
        /***/
        (t, e, n) => {
          var x, E, m, v, y, Zr, C, T, w, R, O, Sa, W, L, z, P, Q, Y, ie, te, Z, ae, G, U, F, M, I, N, V, q, H, ne, he, j, Fe, X, ye, Ae, fe, _e, Ie, Be, $e, Me, J, K, ge, Ca, Oe, Qr, ct, Jr, et, gr, pt, ei, tt, ti, We, un, Je, Xn, je, wa, Ye, Da, rt, ni, bt, qn, mt, ri;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.KeyboardManager = e.CommandManager = e.ColorManager = e.AnnotationEditorUIManager = void 0, e.bindEvents = o, e.opacityToHex = l;
          var a = n(1), s = n(6);
          function o(Le, ue, De) {
            for (const Ne of De)
              ue.addEventListener(Ne, Le[Ne].bind(Le));
          }
          function l(Le) {
            return Math.round(Math.min(255, Math.max(1, 255 * Le))).toString(16).padStart(2, "0");
          }
          class c {
            constructor() {
              Ge(this, x, 0);
            }
            getId() {
              return `${a.AnnotationEditorPrefix}${zn(this, x)._++}`;
            }
          }
          x = new WeakMap();
          const b = class b {
            constructor() {
              Ge(this, y);
              Ge(this, E, (0, a.getUuid)());
              Ge(this, m, 0);
              Ge(this, v, null);
            }
            static get _isSVGFittingCanvas() {
              const ue = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', Ne = new OffscreenCanvas(1, 3).getContext("2d"), oe = new Image();
              oe.src = ue;
              const ee = oe.decode().then(() => (Ne.drawImage(oe, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(Ne.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
              return (0, a.shadow)(this, "_isSVGFittingCanvas", ee);
            }
            async getFromFile(ue) {
              const {
                lastModified: De,
                name: Ne,
                size: oe,
                type: ee
              } = ue;
              return Ke(this, y, Zr).call(this, `${De}_${Ne}_${oe}_${ee}`, ue);
            }
            async getFromUrl(ue) {
              return Ke(this, y, Zr).call(this, ue, ue);
            }
            async getFromId(ue) {
              se(this, v) || at(this, v, /* @__PURE__ */ new Map());
              const De = se(this, v).get(ue);
              return De ? De.bitmap ? (De.refCounter += 1, De) : De.file ? this.getFromFile(De.file) : this.getFromUrl(De.url) : null;
            }
            getSvgUrl(ue) {
              const De = se(this, v).get(ue);
              return De != null && De.isSvg ? De.svgUrl : null;
            }
            deleteId(ue) {
              se(this, v) || at(this, v, /* @__PURE__ */ new Map());
              const De = se(this, v).get(ue);
              De && (De.refCounter -= 1, De.refCounter === 0 && (De.bitmap = null));
            }
            isValidId(ue) {
              return ue.startsWith(`image_${se(this, E)}_`);
            }
          };
          E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakSet(), Zr = async function(ue, De) {
            se(this, v) || at(this, v, /* @__PURE__ */ new Map());
            let Ne = se(this, v).get(ue);
            if (Ne === null)
              return null;
            if (Ne != null && Ne.bitmap)
              return Ne.refCounter += 1, Ne;
            try {
              Ne || (Ne = {
                bitmap: null,
                id: `image_${se(this, E)}_${zn(this, m)._++}`,
                refCounter: 0,
                isSvg: !1
              });
              let oe;
              if (typeof De == "string") {
                Ne.url = De;
                const ee = await fetch(De);
                if (!ee.ok)
                  throw new Error(ee.statusText);
                oe = await ee.blob();
              } else
                oe = Ne.file = De;
              if (oe.type === "image/svg+xml") {
                const ee = b._isSVGFittingCanvas, ce = new FileReader(), pe = new Image(), be = new Promise((Ee, He) => {
                  pe.onload = () => {
                    Ne.bitmap = pe, Ne.isSvg = !0, Ee();
                  }, ce.onload = async () => {
                    const de = Ne.svgUrl = ce.result;
                    pe.src = await ee ? `${de}#svgView(preserveAspectRatio(none))` : de;
                  }, pe.onerror = ce.onerror = He;
                });
                ce.readAsDataURL(oe), await be;
              } else
                Ne.bitmap = await createImageBitmap(oe);
              Ne.refCounter = 1;
            } catch (oe) {
              console.error(oe), Ne = null;
            }
            return se(this, v).set(ue, Ne), Ne && se(this, v).set(Ne.id, Ne), Ne;
          };
          let u = b;
          class d {
            constructor(ue = 128) {
              Ge(this, C, []);
              Ge(this, T, !1);
              Ge(this, w, void 0);
              Ge(this, R, -1);
              at(this, w, ue);
            }
            add({
              cmd: ue,
              undo: De,
              mustExec: Ne,
              type: oe = NaN,
              overwriteIfSameType: ee = !1,
              keepUndo: ce = !1
            }) {
              if (Ne && ue(), se(this, T))
                return;
              const pe = {
                cmd: ue,
                undo: De,
                type: oe
              };
              if (se(this, R) === -1) {
                se(this, C).length > 0 && (se(this, C).length = 0), at(this, R, 0), se(this, C).push(pe);
                return;
              }
              if (ee && se(this, C)[se(this, R)].type === oe) {
                ce && (pe.undo = se(this, C)[se(this, R)].undo), se(this, C)[se(this, R)] = pe;
                return;
              }
              const be = se(this, R) + 1;
              be === se(this, w) ? se(this, C).splice(0, 1) : (at(this, R, be), be < se(this, C).length && se(this, C).splice(be)), se(this, C).push(pe);
            }
            undo() {
              se(this, R) !== -1 && (at(this, T, !0), se(this, C)[se(this, R)].undo(), at(this, T, !1), at(this, R, se(this, R) - 1));
            }
            redo() {
              se(this, R) < se(this, C).length - 1 && (at(this, R, se(this, R) + 1), at(this, T, !0), se(this, C)[se(this, R)].cmd(), at(this, T, !1));
            }
            hasSomethingToUndo() {
              return se(this, R) !== -1;
            }
            hasSomethingToRedo() {
              return se(this, R) < se(this, C).length - 1;
            }
            destroy() {
              at(this, C, null);
            }
          }
          C = new WeakMap(), T = new WeakMap(), w = new WeakMap(), R = new WeakMap(), e.CommandManager = d;
          class f {
            constructor(ue) {
              Ge(this, O);
              this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
              const {
                isMac: De
              } = a.FeatureTest.platform;
              for (const [Ne, oe, ee = {}] of ue)
                for (const ce of Ne) {
                  const pe = ce.startsWith("mac+");
                  De && pe ? (this.callbacks.set(ce.slice(4), {
                    callback: oe,
                    options: ee
                  }), this.allKeys.add(ce.split("+").at(-1))) : !De && !pe && (this.callbacks.set(ce, {
                    callback: oe,
                    options: ee
                  }), this.allKeys.add(ce.split("+").at(-1)));
                }
            }
            exec(ue, De) {
              if (!this.allKeys.has(De.key))
                return;
              const Ne = this.callbacks.get(Ke(this, O, Sa).call(this, De));
              if (!Ne)
                return;
              const {
                callback: oe,
                options: {
                  bubbles: ee = !1,
                  args: ce = [],
                  checker: pe = null
                }
              } = Ne;
              pe && !pe(ue, De) || (oe.bind(ue, ...ce)(), ee || (De.stopPropagation(), De.preventDefault()));
            }
          }
          O = new WeakSet(), Sa = function(ue) {
            ue.altKey && this.buffer.push("alt"), ue.ctrlKey && this.buffer.push("ctrl"), ue.metaKey && this.buffer.push("meta"), ue.shiftKey && this.buffer.push("shift"), this.buffer.push(ue.key);
            const De = this.buffer.join("+");
            return this.buffer.length = 0, De;
          }, e.KeyboardManager = f;
          const k = class k {
            get _colors() {
              const ue = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
              return (0, s.getColorValues)(ue), (0, a.shadow)(this, "_colors", ue);
            }
            convert(ue) {
              const De = (0, s.getRGB)(ue);
              if (!window.matchMedia("(forced-colors: active)").matches)
                return De;
              for (const [Ne, oe] of this._colors)
                if (oe.every((ee, ce) => ee === De[ce]))
                  return k._colorsMapping.get(Ne);
              return De;
            }
            getHexCode(ue) {
              const De = this._colors.get(ue);
              return De ? a.Util.makeHexColor(...De) : ue;
            }
          };
          Xt(k, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
          let h = k;
          e.ColorManager = h;
          const dt = class dt {
            constructor(ue, De, Ne, oe, ee, ce) {
              Ge(this, ge);
              Ge(this, Oe);
              Ge(this, ct);
              Ge(this, et);
              Ge(this, pt);
              Ge(this, tt);
              Ge(this, We);
              Ge(this, Je);
              Ge(this, je);
              Ge(this, Ye);
              Ge(this, rt);
              Ge(this, bt);
              Ge(this, mt);
              Ge(this, W, null);
              Ge(this, L, /* @__PURE__ */ new Map());
              Ge(this, z, /* @__PURE__ */ new Map());
              Ge(this, P, null);
              Ge(this, Q, null);
              Ge(this, Y, new d());
              Ge(this, ie, 0);
              Ge(this, te, /* @__PURE__ */ new Set());
              Ge(this, Z, null);
              Ge(this, ae, null);
              Ge(this, G, /* @__PURE__ */ new Set());
              Ge(this, U, null);
              Ge(this, F, new c());
              Ge(this, M, !1);
              Ge(this, I, !1);
              Ge(this, N, null);
              Ge(this, V, a.AnnotationEditorType.NONE);
              Ge(this, q, /* @__PURE__ */ new Set());
              Ge(this, H, null);
              Ge(this, ne, this.blur.bind(this));
              Ge(this, he, this.focus.bind(this));
              Ge(this, j, this.copy.bind(this));
              Ge(this, Fe, this.cut.bind(this));
              Ge(this, X, this.paste.bind(this));
              Ge(this, ye, this.keydown.bind(this));
              Ge(this, Ae, this.onEditingAction.bind(this));
              Ge(this, fe, this.onPageChanging.bind(this));
              Ge(this, _e, this.onScaleChanging.bind(this));
              Ge(this, Ie, this.onRotationChanging.bind(this));
              Ge(this, Be, {
                isEditing: !1,
                isEmpty: !0,
                hasSomethingToUndo: !1,
                hasSomethingToRedo: !1,
                hasSelectedEditor: !1
              });
              Ge(this, $e, [0, 0]);
              Ge(this, Me, null);
              Ge(this, J, null);
              Ge(this, K, null);
              at(this, J, ue), at(this, K, De), at(this, P, Ne), this._eventBus = oe, this._eventBus._on("editingaction", se(this, Ae)), this._eventBus._on("pagechanging", se(this, fe)), this._eventBus._on("scalechanging", se(this, _e)), this._eventBus._on("rotationchanging", se(this, Ie)), at(this, Q, ee.annotationStorage), at(this, U, ee.filterFactory), at(this, H, ce), this.viewParameters = {
                realScale: s.PixelsPerInch.PDF_TO_CSS_UNITS,
                rotation: 0
              };
            }
            static get _keyboardManager() {
              const ue = dt.prototype, De = (ee) => {
                const {
                  activeElement: ce
                } = document;
                return ce && se(ee, J).contains(ce) && ee.hasSomethingToControl();
              }, Ne = this.TRANSLATE_SMALL, oe = this.TRANSLATE_BIG;
              return (0, a.shadow)(this, "_keyboardManager", new f([[["ctrl+a", "mac+meta+a"], ue.selectAll], [["ctrl+z", "mac+meta+z"], ue.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], ue.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], ue.delete], [["Escape", "mac+Escape"], ue.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], ue.translateSelectedEditors, {
                args: [-Ne, 0],
                checker: De
              }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], ue.translateSelectedEditors, {
                args: [-oe, 0],
                checker: De
              }], [["ArrowRight", "mac+ArrowRight"], ue.translateSelectedEditors, {
                args: [Ne, 0],
                checker: De
              }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], ue.translateSelectedEditors, {
                args: [oe, 0],
                checker: De
              }], [["ArrowUp", "mac+ArrowUp"], ue.translateSelectedEditors, {
                args: [0, -Ne],
                checker: De
              }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], ue.translateSelectedEditors, {
                args: [0, -oe],
                checker: De
              }], [["ArrowDown", "mac+ArrowDown"], ue.translateSelectedEditors, {
                args: [0, Ne],
                checker: De
              }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], ue.translateSelectedEditors, {
                args: [0, oe],
                checker: De
              }]]));
            }
            destroy() {
              Ke(this, et, gr).call(this), Ke(this, Oe, Qr).call(this), this._eventBus._off("editingaction", se(this, Ae)), this._eventBus._off("pagechanging", se(this, fe)), this._eventBus._off("scalechanging", se(this, _e)), this._eventBus._off("rotationchanging", se(this, Ie));
              for (const ue of se(this, z).values())
                ue.destroy();
              se(this, z).clear(), se(this, L).clear(), se(this, G).clear(), at(this, W, null), se(this, q).clear(), se(this, Y).destroy(), se(this, P).destroy();
            }
            get hcmFilter() {
              return (0, a.shadow)(this, "hcmFilter", se(this, H) ? se(this, U).addHCMFilter(se(this, H).foreground, se(this, H).background) : "none");
            }
            get direction() {
              return (0, a.shadow)(this, "direction", getComputedStyle(se(this, J)).direction);
            }
            editAltText(ue) {
              var De;
              (De = se(this, P)) == null || De.editAltText(this, ue);
            }
            onPageChanging({
              pageNumber: ue
            }) {
              at(this, ie, ue - 1);
            }
            focusMainContainer() {
              se(this, J).focus();
            }
            findParent(ue, De) {
              for (const Ne of se(this, z).values()) {
                const {
                  x: oe,
                  y: ee,
                  width: ce,
                  height: pe
                } = Ne.div.getBoundingClientRect();
                if (ue >= oe && ue <= oe + ce && De >= ee && De <= ee + pe)
                  return Ne;
              }
              return null;
            }
            disableUserSelect(ue = !1) {
              se(this, K).classList.toggle("noUserSelect", ue);
            }
            addShouldRescale(ue) {
              se(this, G).add(ue);
            }
            removeShouldRescale(ue) {
              se(this, G).delete(ue);
            }
            onScaleChanging({
              scale: ue
            }) {
              this.commitOrRemove(), this.viewParameters.realScale = ue * s.PixelsPerInch.PDF_TO_CSS_UNITS;
              for (const De of se(this, G))
                De.onScaleChanging();
            }
            onRotationChanging({
              pagesRotation: ue
            }) {
              this.commitOrRemove(), this.viewParameters.rotation = ue;
            }
            addToAnnotationStorage(ue) {
              !ue.isEmpty() && se(this, Q) && !se(this, Q).has(ue.id) && se(this, Q).setValue(ue.id, ue);
            }
            blur() {
              if (!this.hasSelection)
                return;
              const {
                activeElement: ue
              } = document;
              for (const De of se(this, q))
                if (De.div.contains(ue)) {
                  at(this, N, [De, ue]), De._focusEventsAllowed = !1;
                  break;
                }
            }
            focus() {
              if (!se(this, N))
                return;
              const [ue, De] = se(this, N);
              at(this, N, null), De.addEventListener("focusin", () => {
                ue._focusEventsAllowed = !0;
              }, {
                once: !0
              }), De.focus();
            }
            addEditListeners() {
              Ke(this, ct, Jr).call(this), Ke(this, pt, ei).call(this);
            }
            removeEditListeners() {
              Ke(this, et, gr).call(this), Ke(this, tt, ti).call(this);
            }
            copy(ue) {
              var Ne;
              if (ue.preventDefault(), (Ne = se(this, W)) == null || Ne.commitOrRemove(), !this.hasSelection)
                return;
              const De = [];
              for (const oe of se(this, q)) {
                const ee = oe.serialize(!0);
                ee && De.push(ee);
              }
              De.length !== 0 && ue.clipboardData.setData("application/pdfjs", JSON.stringify(De));
            }
            cut(ue) {
              this.copy(ue), this.delete();
            }
            paste(ue) {
              ue.preventDefault();
              const {
                clipboardData: De
              } = ue;
              for (const ee of De.items)
                for (const ce of se(this, ae))
                  if (ce.isHandlingMimeForPasting(ee.type)) {
                    ce.paste(ee, this.currentLayer);
                    return;
                  }
              let Ne = De.getData("application/pdfjs");
              if (!Ne)
                return;
              try {
                Ne = JSON.parse(Ne);
              } catch (ee) {
                (0, a.warn)(`paste: "${ee.message}".`);
                return;
              }
              if (!Array.isArray(Ne))
                return;
              this.unselectAll();
              const oe = this.currentLayer;
              try {
                const ee = [];
                for (const be of Ne) {
                  const Ee = oe.deserialize(be);
                  if (!Ee)
                    return;
                  ee.push(Ee);
                }
                const ce = () => {
                  for (const be of ee)
                    Ke(this, rt, ni).call(this, be);
                  Ke(this, mt, ri).call(this, ee);
                }, pe = () => {
                  for (const be of ee)
                    be.remove();
                };
                this.addCommands({
                  cmd: ce,
                  undo: pe,
                  mustExec: !0
                });
              } catch (ee) {
                (0, a.warn)(`paste: "${ee.message}".`);
              }
            }
            keydown(ue) {
              var De;
              (De = this.getActive()) != null && De.shouldGetKeyboardEvents() || dt._keyboardManager.exec(this, ue);
            }
            onEditingAction(ue) {
              ["undo", "redo", "delete", "selectAll"].includes(ue.name) && this[ue.name]();
            }
            setEditingState(ue) {
              ue ? (Ke(this, ge, Ca).call(this), Ke(this, ct, Jr).call(this), Ke(this, pt, ei).call(this), Ke(this, We, un).call(this, {
                isEditing: se(this, V) !== a.AnnotationEditorType.NONE,
                isEmpty: Ke(this, bt, qn).call(this),
                hasSomethingToUndo: se(this, Y).hasSomethingToUndo(),
                hasSomethingToRedo: se(this, Y).hasSomethingToRedo(),
                hasSelectedEditor: !1
              })) : (Ke(this, Oe, Qr).call(this), Ke(this, et, gr).call(this), Ke(this, tt, ti).call(this), Ke(this, We, un).call(this, {
                isEditing: !1
              }), this.disableUserSelect(!1));
            }
            registerEditorTypes(ue) {
              if (!se(this, ae)) {
                at(this, ae, ue);
                for (const De of se(this, ae))
                  Ke(this, Je, Xn).call(this, De.defaultPropertiesToUpdate);
              }
            }
            getId() {
              return se(this, F).getId();
            }
            get currentLayer() {
              return se(this, z).get(se(this, ie));
            }
            getLayer(ue) {
              return se(this, z).get(ue);
            }
            get currentPageIndex() {
              return se(this, ie);
            }
            addLayer(ue) {
              se(this, z).set(ue.pageIndex, ue), se(this, M) ? ue.enable() : ue.disable();
            }
            removeLayer(ue) {
              se(this, z).delete(ue.pageIndex);
            }
            updateMode(ue, De = null) {
              if (se(this, V) !== ue) {
                if (at(this, V, ue), ue === a.AnnotationEditorType.NONE) {
                  this.setEditingState(!1), Ke(this, Ye, Da).call(this);
                  return;
                }
                this.setEditingState(!0), Ke(this, je, wa).call(this), this.unselectAll();
                for (const Ne of se(this, z).values())
                  Ne.updateMode(ue);
                if (De) {
                  for (const Ne of se(this, L).values())
                    if (Ne.annotationElementId === De) {
                      this.setSelected(Ne), Ne.enterInEditMode();
                      break;
                    }
                }
              }
            }
            updateToolbar(ue) {
              ue !== se(this, V) && this._eventBus.dispatch("switchannotationeditormode", {
                source: this,
                mode: ue
              });
            }
            updateParams(ue, De) {
              if (se(this, ae)) {
                if (ue === a.AnnotationEditorParamsType.CREATE) {
                  this.currentLayer.addNewEditor(ue);
                  return;
                }
                for (const Ne of se(this, q))
                  Ne.updateParams(ue, De);
                for (const Ne of se(this, ae))
                  Ne.updateDefaultParams(ue, De);
              }
            }
            enableWaiting(ue = !1) {
              if (se(this, I) !== ue) {
                at(this, I, ue);
                for (const De of se(this, z).values())
                  ue ? De.disableClick() : De.enableClick(), De.div.classList.toggle("waiting", ue);
              }
            }
            getEditors(ue) {
              const De = [];
              for (const Ne of se(this, L).values())
                Ne.pageIndex === ue && De.push(Ne);
              return De;
            }
            getEditor(ue) {
              return se(this, L).get(ue);
            }
            addEditor(ue) {
              se(this, L).set(ue.id, ue);
            }
            removeEditor(ue) {
              var De;
              se(this, L).delete(ue.id), this.unselect(ue), (!ue.annotationElementId || !se(this, te).has(ue.annotationElementId)) && ((De = se(this, Q)) == null || De.remove(ue.id));
            }
            addDeletedAnnotationElement(ue) {
              se(this, te).add(ue.annotationElementId), ue.deleted = !0;
            }
            isDeletedAnnotationElement(ue) {
              return se(this, te).has(ue);
            }
            removeDeletedAnnotationElement(ue) {
              se(this, te).delete(ue.annotationElementId), ue.deleted = !1;
            }
            setActiveEditor(ue) {
              se(this, W) !== ue && (at(this, W, ue), ue && Ke(this, Je, Xn).call(this, ue.propertiesToUpdate));
            }
            toggleSelected(ue) {
              if (se(this, q).has(ue)) {
                se(this, q).delete(ue), ue.unselect(), Ke(this, We, un).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
                return;
              }
              se(this, q).add(ue), ue.select(), Ke(this, Je, Xn).call(this, ue.propertiesToUpdate), Ke(this, We, un).call(this, {
                hasSelectedEditor: !0
              });
            }
            setSelected(ue) {
              for (const De of se(this, q))
                De !== ue && De.unselect();
              se(this, q).clear(), se(this, q).add(ue), ue.select(), Ke(this, Je, Xn).call(this, ue.propertiesToUpdate), Ke(this, We, un).call(this, {
                hasSelectedEditor: !0
              });
            }
            isSelected(ue) {
              return se(this, q).has(ue);
            }
            unselect(ue) {
              ue.unselect(), se(this, q).delete(ue), Ke(this, We, un).call(this, {
                hasSelectedEditor: this.hasSelection
              });
            }
            get hasSelection() {
              return se(this, q).size !== 0;
            }
            undo() {
              se(this, Y).undo(), Ke(this, We, un).call(this, {
                hasSomethingToUndo: se(this, Y).hasSomethingToUndo(),
                hasSomethingToRedo: !0,
                isEmpty: Ke(this, bt, qn).call(this)
              });
            }
            redo() {
              se(this, Y).redo(), Ke(this, We, un).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: se(this, Y).hasSomethingToRedo(),
                isEmpty: Ke(this, bt, qn).call(this)
              });
            }
            addCommands(ue) {
              se(this, Y).add(ue), Ke(this, We, un).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: !1,
                isEmpty: Ke(this, bt, qn).call(this)
              });
            }
            delete() {
              if (this.commitOrRemove(), !this.hasSelection)
                return;
              const ue = [...se(this, q)], De = () => {
                for (const oe of ue)
                  oe.remove();
              }, Ne = () => {
                for (const oe of ue)
                  Ke(this, rt, ni).call(this, oe);
              };
              this.addCommands({
                cmd: De,
                undo: Ne,
                mustExec: !0
              });
            }
            commitOrRemove() {
              var ue;
              (ue = se(this, W)) == null || ue.commitOrRemove();
            }
            hasSomethingToControl() {
              return se(this, W) || this.hasSelection;
            }
            selectAll() {
              for (const ue of se(this, q))
                ue.commit();
              Ke(this, mt, ri).call(this, se(this, L).values());
            }
            unselectAll() {
              if (se(this, W)) {
                se(this, W).commitOrRemove();
                return;
              }
              if (this.hasSelection) {
                for (const ue of se(this, q))
                  ue.unselect();
                se(this, q).clear(), Ke(this, We, un).call(this, {
                  hasSelectedEditor: !1
                });
              }
            }
            translateSelectedEditors(ue, De, Ne = !1) {
              if (Ne || this.commitOrRemove(), !this.hasSelection)
                return;
              se(this, $e)[0] += ue, se(this, $e)[1] += De;
              const [oe, ee] = se(this, $e), ce = [...se(this, q)], pe = 1e3;
              se(this, Me) && clearTimeout(se(this, Me)), at(this, Me, setTimeout(() => {
                at(this, Me, null), se(this, $e)[0] = se(this, $e)[1] = 0, this.addCommands({
                  cmd: () => {
                    for (const be of ce)
                      se(this, L).has(be.id) && be.translateInPage(oe, ee);
                  },
                  undo: () => {
                    for (const be of ce)
                      se(this, L).has(be.id) && be.translateInPage(-oe, -ee);
                  },
                  mustExec: !1
                });
              }, pe));
              for (const be of ce)
                be.translateInPage(ue, De);
            }
            setUpDragSession() {
              if (this.hasSelection) {
                this.disableUserSelect(!0), at(this, Z, /* @__PURE__ */ new Map());
                for (const ue of se(this, q))
                  se(this, Z).set(ue, {
                    savedX: ue.x,
                    savedY: ue.y,
                    savedPageIndex: ue.pageIndex,
                    newX: 0,
                    newY: 0,
                    newPageIndex: -1
                  });
              }
            }
            endDragSession() {
              if (!se(this, Z))
                return !1;
              this.disableUserSelect(!1);
              const ue = se(this, Z);
              at(this, Z, null);
              let De = !1;
              for (const [{
                x: oe,
                y: ee,
                pageIndex: ce
              }, pe] of ue)
                pe.newX = oe, pe.newY = ee, pe.newPageIndex = ce, De || (De = oe !== pe.savedX || ee !== pe.savedY || ce !== pe.savedPageIndex);
              if (!De)
                return !1;
              const Ne = (oe, ee, ce, pe) => {
                if (se(this, L).has(oe.id)) {
                  const be = se(this, z).get(pe);
                  be ? oe._setParentAndPosition(be, ee, ce) : (oe.pageIndex = pe, oe.x = ee, oe.y = ce);
                }
              };
              return this.addCommands({
                cmd: () => {
                  for (const [oe, {
                    newX: ee,
                    newY: ce,
                    newPageIndex: pe
                  }] of ue)
                    Ne(oe, ee, ce, pe);
                },
                undo: () => {
                  for (const [oe, {
                    savedX: ee,
                    savedY: ce,
                    savedPageIndex: pe
                  }] of ue)
                    Ne(oe, ee, ce, pe);
                },
                mustExec: !0
              }), !0;
            }
            dragSelectedEditors(ue, De) {
              if (se(this, Z))
                for (const Ne of se(this, Z).keys())
                  Ne.drag(ue, De);
            }
            rebuild(ue) {
              if (ue.parent === null) {
                const De = this.getLayer(ue.pageIndex);
                De ? (De.changeParent(ue), De.addOrRebuild(ue)) : (this.addEditor(ue), this.addToAnnotationStorage(ue), ue.rebuild());
              } else
                ue.parent.addOrRebuild(ue);
            }
            isActive(ue) {
              return se(this, W) === ue;
            }
            getActive() {
              return se(this, W);
            }
            getMode() {
              return se(this, V);
            }
            get imageManager() {
              return (0, a.shadow)(this, "imageManager", new u());
            }
          };
          W = new WeakMap(), L = new WeakMap(), z = new WeakMap(), P = new WeakMap(), Q = new WeakMap(), Y = new WeakMap(), ie = new WeakMap(), te = new WeakMap(), Z = new WeakMap(), ae = new WeakMap(), G = new WeakMap(), U = new WeakMap(), F = new WeakMap(), M = new WeakMap(), I = new WeakMap(), N = new WeakMap(), V = new WeakMap(), q = new WeakMap(), H = new WeakMap(), ne = new WeakMap(), he = new WeakMap(), j = new WeakMap(), Fe = new WeakMap(), X = new WeakMap(), ye = new WeakMap(), Ae = new WeakMap(), fe = new WeakMap(), _e = new WeakMap(), Ie = new WeakMap(), Be = new WeakMap(), $e = new WeakMap(), Me = new WeakMap(), J = new WeakMap(), K = new WeakMap(), ge = new WeakSet(), Ca = function() {
            window.addEventListener("focus", se(this, he)), window.addEventListener("blur", se(this, ne));
          }, Oe = new WeakSet(), Qr = function() {
            window.removeEventListener("focus", se(this, he)), window.removeEventListener("blur", se(this, ne));
          }, ct = new WeakSet(), Jr = function() {
            window.addEventListener("keydown", se(this, ye), {
              capture: !0
            });
          }, et = new WeakSet(), gr = function() {
            window.removeEventListener("keydown", se(this, ye), {
              capture: !0
            });
          }, pt = new WeakSet(), ei = function() {
            document.addEventListener("copy", se(this, j)), document.addEventListener("cut", se(this, Fe)), document.addEventListener("paste", se(this, X));
          }, tt = new WeakSet(), ti = function() {
            document.removeEventListener("copy", se(this, j)), document.removeEventListener("cut", se(this, Fe)), document.removeEventListener("paste", se(this, X));
          }, We = new WeakSet(), un = function(ue) {
            Object.entries(ue).some(([Ne, oe]) => se(this, Be)[Ne] !== oe) && this._eventBus.dispatch("annotationeditorstateschanged", {
              source: this,
              details: Object.assign(se(this, Be), ue)
            });
          }, Je = new WeakSet(), Xn = function(ue) {
            this._eventBus.dispatch("annotationeditorparamschanged", {
              source: this,
              details: ue
            });
          }, je = new WeakSet(), wa = function() {
            if (!se(this, M)) {
              at(this, M, !0);
              for (const ue of se(this, z).values())
                ue.enable();
            }
          }, Ye = new WeakSet(), Da = function() {
            if (this.unselectAll(), se(this, M)) {
              at(this, M, !1);
              for (const ue of se(this, z).values())
                ue.disable();
            }
          }, rt = new WeakSet(), ni = function(ue) {
            const De = se(this, z).get(ue.pageIndex);
            De ? De.addOrRebuild(ue) : this.addEditor(ue);
          }, bt = new WeakSet(), qn = function() {
            if (se(this, L).size === 0)
              return !0;
            if (se(this, L).size === 1)
              for (const ue of se(this, L).values())
                return ue.isEmpty();
            return !1;
          }, mt = new WeakSet(), ri = function(ue) {
            se(this, q).clear();
            for (const De of ue)
              De.isEmpty() || (se(this, q).add(De), De.select());
            Ke(this, We, un).call(this, {
              hasSelectedEditor: !0
            });
          }, Xt(dt, "TRANSLATE_SMALL", 1), Xt(dt, "TRANSLATE_BIG", 10);
          let g = dt;
          e.AnnotationEditorUIManager = g;
        },
        /* 6 */
        /***/
        (t, e, n) => {
          var ie, te, Z, ae, G, U, F, M, I, N, V, q, On, ne, Nn, j, ii, X, mr, Ae, _r, _e, jn, Be, $n;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.StatTimer = e.RenderingCancelledException = e.PixelsPerInch = e.PageViewport = e.PDFDateString = e.DOMStandardFontDataFactory = e.DOMSVGFactory = e.DOMFilterFactory = e.DOMCanvasFactory = e.DOMCMapReaderFactory = void 0, e.deprecated = R, e.getColorValues = L, e.getCurrentTransform = z, e.getCurrentTransformInverse = P, e.getFilenameFromUrl = y, e.getPdfFilenameFromUrl = A, e.getRGB = W, e.getXfaPageViewport = k, e.isDataScheme = m, e.isPdfFile = v, e.isValidFetchUrl = C, e.loadScript = w, e.noContextMenu = T, e.setLayerDimensions = Q;
          var a = n(7), s = n(1);
          const o = "http://www.w3.org/2000/svg", Y = class Y {
          };
          Xt(Y, "CSS", 96), Xt(Y, "PDF", 72), Xt(Y, "PDF_TO_CSS_UNITS", Y.CSS / Y.PDF);
          let l = Y;
          e.PixelsPerInch = l;
          class c extends a.BaseFilterFactory {
            constructor({
              docId: K,
              ownerDocument: ge = globalThis.document
            } = {}) {
              super();
              Ge(this, q);
              Ge(this, ne);
              Ge(this, j);
              Ge(this, X);
              Ge(this, Ae);
              Ge(this, _e);
              Ge(this, Be);
              Ge(this, ie, void 0);
              Ge(this, te, void 0);
              Ge(this, Z, void 0);
              Ge(this, ae, void 0);
              Ge(this, G, void 0);
              Ge(this, U, void 0);
              Ge(this, F, void 0);
              Ge(this, M, void 0);
              Ge(this, I, void 0);
              Ge(this, N, void 0);
              Ge(this, V, 0);
              at(this, Z, K), at(this, ae, ge);
            }
            addFilter(K) {
              if (!K)
                return "none";
              let ge = se(this, q, On).get(K);
              if (ge)
                return ge;
              let Ce, Oe, qe, ct;
              if (K.length === 1) {
                const pt = K[0], nt = new Array(256);
                for (let tt = 0; tt < 256; tt++)
                  nt[tt] = pt[tt] / 255;
                ct = Ce = Oe = qe = nt.join(",");
              } else {
                const [pt, nt, tt] = K, Ve = new Array(256), We = new Array(256), it = new Array(256);
                for (let Je = 0; Je < 256; Je++)
                  Ve[Je] = pt[Je] / 255, We[Je] = nt[Je] / 255, it[Je] = tt[Je] / 255;
                Ce = Ve.join(","), Oe = We.join(","), qe = it.join(","), ct = `${Ce}${Oe}${qe}`;
              }
              if (ge = se(this, q, On).get(ct), ge)
                return se(this, q, On).set(K, ge), ge;
              const ze = `g_${se(this, Z)}_transfer_map_${zn(this, V)._++}`, et = `url(#${ze})`;
              se(this, q, On).set(K, et), se(this, q, On).set(ct, et);
              const gt = Ke(this, X, mr).call(this, ze);
              return Ke(this, _e, jn).call(this, Ce, Oe, qe, gt), et;
            }
            addHCMFilter(K, ge) {
              var nt;
              const Ce = `${K}-${ge}`;
              if (se(this, U) === Ce)
                return se(this, F);
              if (at(this, U, Ce), at(this, F, "none"), (nt = se(this, G)) == null || nt.remove(), !K || !ge)
                return se(this, F);
              const Oe = Ke(this, Be, $n).call(this, K);
              K = s.Util.makeHexColor(...Oe);
              const qe = Ke(this, Be, $n).call(this, ge);
              if (ge = s.Util.makeHexColor(...qe), se(this, ne, Nn).style.color = "", K === "#000000" && ge === "#ffffff" || K === ge)
                return se(this, F);
              const ct = new Array(256);
              for (let tt = 0; tt <= 255; tt++) {
                const Ve = tt / 255;
                ct[tt] = Ve <= 0.03928 ? Ve / 12.92 : ((Ve + 0.055) / 1.055) ** 2.4;
              }
              const ze = ct.join(","), et = `g_${se(this, Z)}_hcm_filter`, gt = at(this, M, Ke(this, X, mr).call(this, et));
              Ke(this, _e, jn).call(this, ze, ze, ze, gt), Ke(this, j, ii).call(this, gt);
              const pt = (tt, Ve) => {
                const We = Oe[tt] / 255, it = qe[tt] / 255, Je = new Array(Ve + 1);
                for (let Rt = 0; Rt <= Ve; Rt++)
                  Je[Rt] = We + Rt / Ve * (it - We);
                return Je.join(",");
              };
              return Ke(this, _e, jn).call(this, pt(0, 5), pt(1, 5), pt(2, 5), gt), at(this, F, `url(#${et})`), se(this, F);
            }
            addHighlightHCMFilter(K, ge, Ce, Oe) {
              var it;
              const qe = `${K}-${ge}-${Ce}-${Oe}`;
              if (se(this, I) === qe)
                return se(this, N);
              if (at(this, I, qe), at(this, N, "none"), (it = se(this, M)) == null || it.remove(), !K || !ge)
                return se(this, N);
              const [ct, ze] = [K, ge].map(Ke(this, Be, $n).bind(this));
              let et = Math.round(0.2126 * ct[0] + 0.7152 * ct[1] + 0.0722 * ct[2]), gt = Math.round(0.2126 * ze[0] + 0.7152 * ze[1] + 0.0722 * ze[2]), [pt, nt] = [Ce, Oe].map(Ke(this, Be, $n).bind(this));
              gt < et && ([et, gt, pt, nt] = [gt, et, nt, pt]), se(this, ne, Nn).style.color = "";
              const tt = (Je, Rt, je) => {
                const ke = new Array(256), Ye = (gt - et) / je, Ze = Je / 255, rt = (Rt - Je) / (255 * je);
                let xt = 0;
                for (let bt = 0; bt <= je; bt++) {
                  const wt = Math.round(et + bt * Ye), mt = Ze + bt * rt;
                  for (let St = xt; St <= wt; St++)
                    ke[St] = mt;
                  xt = wt + 1;
                }
                for (let bt = xt; bt < 256; bt++)
                  ke[bt] = ke[xt - 1];
                return ke.join(",");
              }, Ve = `g_${se(this, Z)}_hcm_highlight_filter`, We = at(this, M, Ke(this, X, mr).call(this, Ve));
              return Ke(this, j, ii).call(this, We), Ke(this, _e, jn).call(this, tt(pt[0], nt[0], 5), tt(pt[1], nt[1], 5), tt(pt[2], nt[2], 5), We), at(this, N, `url(#${Ve})`), se(this, N);
            }
            destroy(K = !1) {
              K && (se(this, F) || se(this, N)) || (se(this, te) && (se(this, te).parentNode.parentNode.remove(), at(this, te, null)), se(this, ie) && (se(this, ie).clear(), at(this, ie, null)), at(this, V, 0));
            }
          }
          ie = new WeakMap(), te = new WeakMap(), Z = new WeakMap(), ae = new WeakMap(), G = new WeakMap(), U = new WeakMap(), F = new WeakMap(), M = new WeakMap(), I = new WeakMap(), N = new WeakMap(), V = new WeakMap(), q = new WeakSet(), On = function() {
            return se(this, ie) || at(this, ie, /* @__PURE__ */ new Map());
          }, ne = new WeakSet(), Nn = function() {
            if (!se(this, te)) {
              const K = se(this, ae).createElement("div"), {
                style: ge
              } = K;
              ge.visibility = "hidden", ge.contain = "strict", ge.width = ge.height = 0, ge.position = "absolute", ge.top = ge.left = 0, ge.zIndex = -1;
              const Ce = se(this, ae).createElementNS(o, "svg");
              Ce.setAttribute("width", 0), Ce.setAttribute("height", 0), at(this, te, se(this, ae).createElementNS(o, "defs")), K.append(Ce), Ce.append(se(this, te)), se(this, ae).body.append(K);
            }
            return se(this, te);
          }, j = new WeakSet(), ii = function(K) {
            const ge = se(this, ae).createElementNS(o, "feColorMatrix");
            ge.setAttribute("type", "matrix"), ge.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), K.append(ge);
          }, X = new WeakSet(), mr = function(K) {
            const ge = se(this, ae).createElementNS(o, "filter");
            return ge.setAttribute("color-interpolation-filters", "sRGB"), ge.setAttribute("id", K), se(this, ne, Nn).append(ge), ge;
          }, Ae = new WeakSet(), _r = function(K, ge, Ce) {
            const Oe = se(this, ae).createElementNS(o, ge);
            Oe.setAttribute("type", "discrete"), Oe.setAttribute("tableValues", Ce), K.append(Oe);
          }, _e = new WeakSet(), jn = function(K, ge, Ce, Oe) {
            const qe = se(this, ae).createElementNS(o, "feComponentTransfer");
            Oe.append(qe), Ke(this, Ae, _r).call(this, qe, "feFuncR", K), Ke(this, Ae, _r).call(this, qe, "feFuncG", ge), Ke(this, Ae, _r).call(this, qe, "feFuncB", Ce);
          }, Be = new WeakSet(), $n = function(K) {
            return se(this, ne, Nn).style.color = K, W(getComputedStyle(se(this, ne, Nn)).getPropertyValue("color"));
          }, e.DOMFilterFactory = c;
          class u extends a.BaseCanvasFactory {
            constructor({
              ownerDocument: J = globalThis.document
            } = {}) {
              super(), this._document = J;
            }
            _createCanvas(J, K) {
              const ge = this._document.createElement("canvas");
              return ge.width = J, ge.height = K, ge;
            }
          }
          e.DOMCanvasFactory = u;
          async function d(Me, J = !1) {
            if (C(Me, document.baseURI)) {
              const K = await fetch(Me);
              if (!K.ok)
                throw new Error(K.statusText);
              return J ? new Uint8Array(await K.arrayBuffer()) : (0, s.stringToBytes)(await K.text());
            }
            return new Promise((K, ge) => {
              const Ce = new XMLHttpRequest();
              Ce.open("GET", Me, !0), J && (Ce.responseType = "arraybuffer"), Ce.onreadystatechange = () => {
                if (Ce.readyState === XMLHttpRequest.DONE) {
                  if (Ce.status === 200 || Ce.status === 0) {
                    let Oe;
                    if (J && Ce.response ? Oe = new Uint8Array(Ce.response) : !J && Ce.responseText && (Oe = (0, s.stringToBytes)(Ce.responseText)), Oe) {
                      K(Oe);
                      return;
                    }
                  }
                  ge(new Error(Ce.statusText));
                }
              }, Ce.send(null);
            });
          }
          class f extends a.BaseCMapReaderFactory {
            _fetchData(J, K) {
              return d(J, this.isCompressed).then((ge) => ({
                cMapData: ge,
                compressionType: K
              }));
            }
          }
          e.DOMCMapReaderFactory = f;
          class h extends a.BaseStandardFontDataFactory {
            _fetchData(J) {
              return d(J, !0);
            }
          }
          e.DOMStandardFontDataFactory = h;
          class g extends a.BaseSVGFactory {
            _createSVG(J) {
              return document.createElementNS(o, J);
            }
          }
          e.DOMSVGFactory = g;
          class x {
            constructor({
              viewBox: J,
              scale: K,
              rotation: ge,
              offsetX: Ce = 0,
              offsetY: Oe = 0,
              dontFlip: qe = !1
            }) {
              this.viewBox = J, this.scale = K, this.rotation = ge, this.offsetX = Ce, this.offsetY = Oe;
              const ct = (J[2] + J[0]) / 2, ze = (J[3] + J[1]) / 2;
              let et, gt, pt, nt;
              switch (ge %= 360, ge < 0 && (ge += 360), ge) {
                case 180:
                  et = -1, gt = 0, pt = 0, nt = 1;
                  break;
                case 90:
                  et = 0, gt = 1, pt = 1, nt = 0;
                  break;
                case 270:
                  et = 0, gt = -1, pt = -1, nt = 0;
                  break;
                case 0:
                  et = 1, gt = 0, pt = 0, nt = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              qe && (pt = -pt, nt = -nt);
              let tt, Ve, We, it;
              et === 0 ? (tt = Math.abs(ze - J[1]) * K + Ce, Ve = Math.abs(ct - J[0]) * K + Oe, We = (J[3] - J[1]) * K, it = (J[2] - J[0]) * K) : (tt = Math.abs(ct - J[0]) * K + Ce, Ve = Math.abs(ze - J[1]) * K + Oe, We = (J[2] - J[0]) * K, it = (J[3] - J[1]) * K), this.transform = [et * K, gt * K, pt * K, nt * K, tt - et * K * ct - pt * K * ze, Ve - gt * K * ct - nt * K * ze], this.width = We, this.height = it;
            }
            get rawDims() {
              const {
                viewBox: J
              } = this;
              return (0, s.shadow)(this, "rawDims", {
                pageWidth: J[2] - J[0],
                pageHeight: J[3] - J[1],
                pageX: J[0],
                pageY: J[1]
              });
            }
            clone({
              scale: J = this.scale,
              rotation: K = this.rotation,
              offsetX: ge = this.offsetX,
              offsetY: Ce = this.offsetY,
              dontFlip: Oe = !1
            } = {}) {
              return new x({
                viewBox: this.viewBox.slice(),
                scale: J,
                rotation: K,
                offsetX: ge,
                offsetY: Ce,
                dontFlip: Oe
              });
            }
            convertToViewportPoint(J, K) {
              return s.Util.applyTransform([J, K], this.transform);
            }
            convertToViewportRectangle(J) {
              const K = s.Util.applyTransform([J[0], J[1]], this.transform), ge = s.Util.applyTransform([J[2], J[3]], this.transform);
              return [K[0], K[1], ge[0], ge[1]];
            }
            convertToPdfPoint(J, K) {
              return s.Util.applyInverseTransform([J, K], this.transform);
            }
          }
          e.PageViewport = x;
          class E extends s.BaseException {
            constructor(J, K = 0) {
              super(J, "RenderingCancelledException"), this.extraDelay = K;
            }
          }
          e.RenderingCancelledException = E;
          function m(Me) {
            const J = Me.length;
            let K = 0;
            for (; K < J && Me[K].trim() === ""; )
              K++;
            return Me.substring(K, K + 5).toLowerCase() === "data:";
          }
          function v(Me) {
            return typeof Me == "string" && /\.pdf$/i.test(Me);
          }
          function y(Me, J = !1) {
            return J || ([Me] = Me.split(/[#?]/, 1)), Me.substring(Me.lastIndexOf("/") + 1);
          }
          function A(Me, J = "document.pdf") {
            if (typeof Me != "string")
              return J;
            if (m(Me))
              return (0, s.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), J;
            const K = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, ge = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, Ce = K.exec(Me);
            let Oe = ge.exec(Ce[1]) || ge.exec(Ce[2]) || ge.exec(Ce[3]);
            if (Oe && (Oe = Oe[0], Oe.includes("%")))
              try {
                Oe = ge.exec(decodeURIComponent(Oe))[0];
              } catch {
              }
            return Oe || J;
          }
          class b {
            constructor() {
              Xt(this, "started", /* @__PURE__ */ Object.create(null));
              Xt(this, "times", []);
            }
            time(J) {
              J in this.started && (0, s.warn)(`Timer is already running for ${J}`), this.started[J] = Date.now();
            }
            timeEnd(J) {
              J in this.started || (0, s.warn)(`Timer has not been started for ${J}`), this.times.push({
                name: J,
                start: this.started[J],
                end: Date.now()
              }), delete this.started[J];
            }
            toString() {
              const J = [];
              let K = 0;
              for (const {
                name: ge
              } of this.times)
                K = Math.max(ge.length, K);
              for (const {
                name: ge,
                start: Ce,
                end: Oe
              } of this.times)
                J.push(`${ge.padEnd(K)} ${Oe - Ce}ms
`);
              return J.join("");
            }
          }
          e.StatTimer = b;
          function C(Me, J) {
            try {
              const {
                protocol: K
              } = J ? new URL(Me, J) : new URL(Me);
              return K === "http:" || K === "https:";
            } catch {
              return !1;
            }
          }
          function T(Me) {
            Me.preventDefault();
          }
          function w(Me, J = !1) {
            return new Promise((K, ge) => {
              const Ce = document.createElement("script");
              Ce.src = Me, Ce.onload = function(Oe) {
                J && Ce.remove(), K(Oe);
              }, Ce.onerror = function() {
                ge(new Error(`Cannot load script at: ${Ce.src}`));
              }, (document.head || document.documentElement).append(Ce);
            });
          }
          function R(Me) {
            console.log("Deprecated API usage: " + Me);
          }
          let O;
          class D {
            static toDateObject(J) {
              if (!J || typeof J != "string")
                return null;
              O || (O = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
              const K = O.exec(J);
              if (!K)
                return null;
              const ge = parseInt(K[1], 10);
              let Ce = parseInt(K[2], 10);
              Ce = Ce >= 1 && Ce <= 12 ? Ce - 1 : 0;
              let Oe = parseInt(K[3], 10);
              Oe = Oe >= 1 && Oe <= 31 ? Oe : 1;
              let qe = parseInt(K[4], 10);
              qe = qe >= 0 && qe <= 23 ? qe : 0;
              let ct = parseInt(K[5], 10);
              ct = ct >= 0 && ct <= 59 ? ct : 0;
              let ze = parseInt(K[6], 10);
              ze = ze >= 0 && ze <= 59 ? ze : 0;
              const et = K[7] || "Z";
              let gt = parseInt(K[8], 10);
              gt = gt >= 0 && gt <= 23 ? gt : 0;
              let pt = parseInt(K[9], 10) || 0;
              return pt = pt >= 0 && pt <= 59 ? pt : 0, et === "-" ? (qe += gt, ct += pt) : et === "+" && (qe -= gt, ct -= pt), new Date(Date.UTC(ge, Ce, Oe, qe, ct, ze));
            }
          }
          e.PDFDateString = D;
          function k(Me, {
            scale: J = 1,
            rotation: K = 0
          }) {
            const {
              width: ge,
              height: Ce
            } = Me.attributes.style, Oe = [0, 0, parseInt(ge), parseInt(Ce)];
            return new x({
              viewBox: Oe,
              scale: J,
              rotation: K
            });
          }
          function W(Me) {
            if (Me.startsWith("#")) {
              const J = parseInt(Me.slice(1), 16);
              return [(J & 16711680) >> 16, (J & 65280) >> 8, J & 255];
            }
            return Me.startsWith("rgb(") ? Me.slice(4, -1).split(",").map((J) => parseInt(J)) : Me.startsWith("rgba(") ? Me.slice(5, -1).split(",").map((J) => parseInt(J)).slice(0, 3) : ((0, s.warn)(`Not a valid color format: "${Me}"`), [0, 0, 0]);
          }
          function L(Me) {
            const J = document.createElement("span");
            J.style.visibility = "hidden", document.body.append(J);
            for (const K of Me.keys()) {
              J.style.color = K;
              const ge = window.getComputedStyle(J).color;
              Me.set(K, W(ge));
            }
            J.remove();
          }
          function z(Me) {
            const {
              a: J,
              b: K,
              c: ge,
              d: Ce,
              e: Oe,
              f: qe
            } = Me.getTransform();
            return [J, K, ge, Ce, Oe, qe];
          }
          function P(Me) {
            const {
              a: J,
              b: K,
              c: ge,
              d: Ce,
              e: Oe,
              f: qe
            } = Me.getTransform().invertSelf();
            return [J, K, ge, Ce, Oe, qe];
          }
          function Q(Me, J, K = !1, ge = !0) {
            if (J instanceof x) {
              const {
                pageWidth: Ce,
                pageHeight: Oe
              } = J.rawDims, {
                style: qe
              } = Me, ct = s.FeatureTest.isCSSRoundSupported, ze = `var(--scale-factor) * ${Ce}px`, et = `var(--scale-factor) * ${Oe}px`, gt = ct ? `round(${ze}, 1px)` : `calc(${ze})`, pt = ct ? `round(${et}, 1px)` : `calc(${et})`;
              !K || J.rotation % 180 === 0 ? (qe.width = gt, qe.height = pt) : (qe.width = pt, qe.height = gt);
            }
            ge && Me.setAttribute("data-main-rotation", J.rotation);
          }
        },
        /* 7 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.BaseStandardFontDataFactory = e.BaseSVGFactory = e.BaseFilterFactory = e.BaseCanvasFactory = e.BaseCMapReaderFactory = void 0;
          var a = n(1);
          class s {
            constructor() {
              this.constructor === s && (0, a.unreachable)("Cannot initialize BaseFilterFactory.");
            }
            addFilter(f) {
              return "none";
            }
            addHCMFilter(f, h) {
              return "none";
            }
            addHighlightHCMFilter(f, h, g, x) {
              return "none";
            }
            destroy(f = !1) {
            }
          }
          e.BaseFilterFactory = s;
          class o {
            constructor() {
              this.constructor === o && (0, a.unreachable)("Cannot initialize BaseCanvasFactory.");
            }
            create(f, h) {
              if (f <= 0 || h <= 0)
                throw new Error("Invalid canvas size");
              const g = this._createCanvas(f, h);
              return {
                canvas: g,
                context: g.getContext("2d")
              };
            }
            reset(f, h, g) {
              if (!f.canvas)
                throw new Error("Canvas is not specified");
              if (h <= 0 || g <= 0)
                throw new Error("Invalid canvas size");
              f.canvas.width = h, f.canvas.height = g;
            }
            destroy(f) {
              if (!f.canvas)
                throw new Error("Canvas is not specified");
              f.canvas.width = 0, f.canvas.height = 0, f.canvas = null, f.context = null;
            }
            _createCanvas(f, h) {
              (0, a.unreachable)("Abstract method `_createCanvas` called.");
            }
          }
          e.BaseCanvasFactory = o;
          class l {
            constructor({
              baseUrl: f = null,
              isCompressed: h = !0
            }) {
              this.constructor === l && (0, a.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = f, this.isCompressed = h;
            }
            async fetch({
              name: f
            }) {
              if (!this.baseUrl)
                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
              if (!f)
                throw new Error("CMap name must be specified.");
              const h = this.baseUrl + f + (this.isCompressed ? ".bcmap" : ""), g = this.isCompressed ? a.CMapCompressionType.BINARY : a.CMapCompressionType.NONE;
              return this._fetchData(h, g).catch((x) => {
                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${h}`);
              });
            }
            _fetchData(f, h) {
              (0, a.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          e.BaseCMapReaderFactory = l;
          class c {
            constructor({
              baseUrl: f = null
            }) {
              this.constructor === c && (0, a.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = f;
            }
            async fetch({
              filename: f
            }) {
              if (!this.baseUrl)
                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
              if (!f)
                throw new Error("Font filename must be specified.");
              const h = `${this.baseUrl}${f}`;
              return this._fetchData(h).catch((g) => {
                throw new Error(`Unable to load font data at: ${h}`);
              });
            }
            _fetchData(f) {
              (0, a.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          e.BaseStandardFontDataFactory = c;
          class u {
            constructor() {
              this.constructor === u && (0, a.unreachable)("Cannot initialize BaseSVGFactory.");
            }
            create(f, h, g = !1) {
              if (f <= 0 || h <= 0)
                throw new Error("Invalid SVG dimensions");
              const x = this._createSVG("svg:svg");
              return x.setAttribute("version", "1.1"), g || (x.setAttribute("width", `${f}px`), x.setAttribute("height", `${h}px`)), x.setAttribute("preserveAspectRatio", "none"), x.setAttribute("viewBox", `0 0 ${f} ${h}`), x;
            }
            createElement(f) {
              if (typeof f != "string")
                throw new Error("Invalid SVG element type");
              return this._createSVG(f);
            }
            _createSVG(f) {
              (0, a.unreachable)("Abstract method `_createSVG` called.");
            }
          }
          e.BaseSVGFactory = u;
        },
        /* 8 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.MurmurHash3_64 = void 0;
          var a = n(1);
          const s = 3285377520, o = 4294901760, l = 65535;
          class c {
            constructor(d) {
              this.h1 = d ? d & 4294967295 : s, this.h2 = d ? d & 4294967295 : s;
            }
            update(d) {
              let f, h;
              if (typeof d == "string") {
                f = new Uint8Array(d.length * 2), h = 0;
                for (let R = 0, O = d.length; R < O; R++) {
                  const D = d.charCodeAt(R);
                  D <= 255 ? f[h++] = D : (f[h++] = D >>> 8, f[h++] = D & 255);
                }
              } else if ((0, a.isArrayBuffer)(d))
                f = d.slice(), h = f.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const g = h >> 2, x = h - g * 4, E = new Uint32Array(f.buffer, 0, g);
              let m = 0, v = 0, y = this.h1, A = this.h2;
              const b = 3432918353, C = 461845907, T = b & l, w = C & l;
              for (let R = 0; R < g; R++)
                R & 1 ? (m = E[R], m = m * b & o | m * T & l, m = m << 15 | m >>> 17, m = m * C & o | m * w & l, y ^= m, y = y << 13 | y >>> 19, y = y * 5 + 3864292196) : (v = E[R], v = v * b & o | v * T & l, v = v << 15 | v >>> 17, v = v * C & o | v * w & l, A ^= v, A = A << 13 | A >>> 19, A = A * 5 + 3864292196);
              switch (m = 0, x) {
                case 3:
                  m ^= f[g * 4 + 2] << 16;
                case 2:
                  m ^= f[g * 4 + 1] << 8;
                case 1:
                  m ^= f[g * 4], m = m * b & o | m * T & l, m = m << 15 | m >>> 17, m = m * C & o | m * w & l, g & 1 ? y ^= m : A ^= m;
              }
              this.h1 = y, this.h2 = A;
            }
            hexdigest() {
              let d = this.h1, f = this.h2;
              return d ^= f >>> 1, d = d * 3981806797 & o | d * 36045 & l, f = f * 4283543511 & o | ((f << 16 | d >>> 16) * 2950163797 & o) >>> 16, d ^= f >>> 1, d = d * 444984403 & o | d * 60499 & l, f = f * 3301882366 & o | ((f << 16 | d >>> 16) * 3120437893 & o) >>> 16, d ^= f >>> 1, (d >>> 0).toString(16).padStart(8, "0") + (f >>> 0).toString(16).padStart(8, "0");
            }
          }
          e.MurmurHash3_64 = c;
        },
        /* 9 */
        /***/
        (t, e, n) => {
          var l;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.FontLoader = e.FontFaceObject = void 0;
          var a = n(1);
          class s {
            constructor({
              ownerDocument: u = globalThis.document,
              styleElement: d = null
            }) {
              Ge(this, l, /* @__PURE__ */ new Set());
              this._document = u, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
            }
            addNativeFontFace(u) {
              this.nativeFontFaces.add(u), this._document.fonts.add(u);
            }
            removeNativeFontFace(u) {
              this.nativeFontFaces.delete(u), this._document.fonts.delete(u);
            }
            insertRule(u) {
              this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
              const d = this.styleElement.sheet;
              d.insertRule(u, d.cssRules.length);
            }
            clear() {
              for (const u of this.nativeFontFaces)
                this._document.fonts.delete(u);
              this.nativeFontFaces.clear(), se(this, l).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
            }
            async loadSystemFont(u) {
              if (!(!u || se(this, l).has(u.loadedName))) {
                if ((0, a.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
                  const {
                    loadedName: d,
                    src: f,
                    style: h
                  } = u, g = new FontFace(d, f, h);
                  this.addNativeFontFace(g);
                  try {
                    await g.load(), se(this, l).add(d);
                  } catch {
                    (0, a.warn)(`Cannot load system font: ${u.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(g);
                  }
                  return;
                }
                (0, a.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
              }
            }
            async bind(u) {
              if (u.attached || u.missingFile && !u.systemFontInfo)
                return;
              if (u.attached = !0, u.systemFontInfo) {
                await this.loadSystemFont(u.systemFontInfo);
                return;
              }
              if (this.isFontLoadingAPISupported) {
                const f = u.createNativeFontFace();
                if (f) {
                  this.addNativeFontFace(f);
                  try {
                    await f.loaded;
                  } catch (h) {
                    throw (0, a.warn)(`Failed to load font '${f.family}': '${h}'.`), u.disableFontFace = !0, h;
                  }
                }
                return;
              }
              const d = u.createFontFaceRule();
              if (d) {
                if (this.insertRule(d), this.isSyncFontLoadingSupported)
                  return;
                await new Promise((f) => {
                  const h = this._queueLoadingCallback(f);
                  this._prepareFontLoadEvent(u, h);
                });
              }
            }
            get isFontLoadingAPISupported() {
              var d;
              const u = !!((d = this._document) != null && d.fonts);
              return (0, a.shadow)(this, "isFontLoadingAPISupported", u);
            }
            get isSyncFontLoadingSupported() {
              let u = !1;
              return (a.isNodeJS || typeof navigator < "u" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (u = !0), (0, a.shadow)(this, "isSyncFontLoadingSupported", u);
            }
            _queueLoadingCallback(u) {
              function d() {
                for ((0, a.assert)(!h.done, "completeRequest() cannot be called twice."), h.done = !0; f.length > 0 && f[0].done; ) {
                  const g = f.shift();
                  setTimeout(g.callback, 0);
                }
              }
              const {
                loadingRequests: f
              } = this, h = {
                done: !1,
                complete: d,
                callback: u
              };
              return f.push(h), h;
            }
            get _loadTestFont() {
              const u = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
              return (0, a.shadow)(this, "_loadTestFont", u);
            }
            _prepareFontLoadEvent(u, d) {
              function f(W, L) {
                return W.charCodeAt(L) << 24 | W.charCodeAt(L + 1) << 16 | W.charCodeAt(L + 2) << 8 | W.charCodeAt(L + 3) & 255;
              }
              function h(W, L, z, P) {
                const Q = W.substring(0, L), Y = W.substring(L + z);
                return Q + P + Y;
              }
              let g, x;
              const E = this._document.createElement("canvas");
              E.width = 1, E.height = 1;
              const m = E.getContext("2d");
              let v = 0;
              function y(W, L) {
                if (++v > 30) {
                  (0, a.warn)("Load test font never loaded."), L();
                  return;
                }
                if (m.font = "30px " + W, m.fillText(".", 0, 20), m.getImageData(0, 0, 1, 1).data[3] > 0) {
                  L();
                  return;
                }
                setTimeout(y.bind(null, W, L));
              }
              const A = `lt${Date.now()}${this.loadTestFontId++}`;
              let b = this._loadTestFont;
              b = h(b, 976, A.length, A);
              const T = 16, w = 1482184792;
              let R = f(b, T);
              for (g = 0, x = A.length - 3; g < x; g += 4)
                R = R - w + f(A, g) | 0;
              g < A.length && (R = R - w + f(A + "XXX", g) | 0), b = h(b, T, 4, (0, a.string32)(R));
              const O = `url(data:font/opentype;base64,${btoa(b)});`, D = `@font-face {font-family:"${A}";src:${O}}`;
              this.insertRule(D);
              const k = this._document.createElement("div");
              k.style.visibility = "hidden", k.style.width = k.style.height = "10px", k.style.position = "absolute", k.style.top = k.style.left = "0px";
              for (const W of [u.loadedName, A]) {
                const L = this._document.createElement("span");
                L.textContent = "Hi", L.style.fontFamily = W, k.append(L);
              }
              this._document.body.append(k), y(A, () => {
                k.remove(), d.complete();
              });
            }
          }
          l = new WeakMap(), e.FontLoader = s;
          class o {
            constructor(u, {
              isEvalSupported: d = !0,
              disableFontFace: f = !1,
              ignoreErrors: h = !1,
              inspectFont: g = null
            }) {
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (const x in u)
                this[x] = u[x];
              this.isEvalSupported = d !== !1, this.disableFontFace = f === !0, this.ignoreErrors = h === !0, this._inspectFont = g;
            }
            createNativeFontFace() {
              var d;
              if (!this.data || this.disableFontFace)
                return null;
              let u;
              if (!this.cssFontInfo)
                u = new FontFace(this.loadedName, this.data, {});
              else {
                const f = {
                  weight: this.cssFontInfo.fontWeight
                };
                this.cssFontInfo.italicAngle && (f.style = `oblique ${this.cssFontInfo.italicAngle}deg`), u = new FontFace(this.cssFontInfo.fontFamily, this.data, f);
              }
              return (d = this._inspectFont) == null || d.call(this, this), u;
            }
            createFontFaceRule() {
              var h;
              if (!this.data || this.disableFontFace)
                return null;
              const u = (0, a.bytesToString)(this.data), d = `url(data:${this.mimetype};base64,${btoa(u)});`;
              let f;
              if (!this.cssFontInfo)
                f = `@font-face {font-family:"${this.loadedName}";src:${d}}`;
              else {
                let g = `font-weight: ${this.cssFontInfo.fontWeight};`;
                this.cssFontInfo.italicAngle && (g += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), f = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${g}src:${d}}`;
              }
              return (h = this._inspectFont) == null || h.call(this, this, d), f;
            }
            getPathGenerator(u, d) {
              if (this.compiledGlyphs[d] !== void 0)
                return this.compiledGlyphs[d];
              let f;
              try {
                f = u.get(this.loadedName + "_path_" + d);
              } catch (h) {
                if (!this.ignoreErrors)
                  throw h;
                return (0, a.warn)(`getPathGenerator - ignoring character: "${h}".`), this.compiledGlyphs[d] = function(g, x) {
                };
              }
              if (this.isEvalSupported && a.FeatureTest.isEvalSupported) {
                const h = [];
                for (const g of f) {
                  const x = g.args !== void 0 ? g.args.join(",") : "";
                  h.push("c.", g.cmd, "(", x, `);
`);
                }
                return this.compiledGlyphs[d] = new Function("c", "size", h.join(""));
              }
              return this.compiledGlyphs[d] = function(h, g) {
                for (const x of f)
                  x.cmd === "scale" && (x.args = [g, -g]), h[x.cmd].apply(h, x.args);
              };
            }
          }
          e.FontFaceObject = o;
        },
        /* 10 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.NodeStandardFontDataFactory = e.NodeFilterFactory = e.NodeCanvasFactory = e.NodeCMapReaderFactory = void 0;
          var a = n(7);
          n(1);
          const s = function(d) {
            return new Promise((f, h) => {
              require$$0$1.readFile(d, (x, E) => {
                if (x || !E) {
                  h(new Error(x));
                  return;
                }
                f(new Uint8Array(E));
              });
            });
          };
          class o extends a.BaseFilterFactory {
          }
          e.NodeFilterFactory = o;
          class l extends a.BaseCanvasFactory {
            _createCanvas(f, h) {
              return require$$0$1.createCanvas(f, h);
            }
          }
          e.NodeCanvasFactory = l;
          class c extends a.BaseCMapReaderFactory {
            _fetchData(f, h) {
              return s(f).then((g) => ({
                cMapData: g,
                compressionType: h
              }));
            }
          }
          e.NodeCMapReaderFactory = c;
          class u extends a.BaseStandardFontDataFactory {
            _fetchData(f) {
              return s(f);
            }
          }
          e.NodeStandardFontDataFactory = u;
        },
        /* 11 */
        /***/
        (t, e, n) => {
          var te, ai, ae, si;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.CanvasGraphics = void 0;
          var a = n(1), s = n(6), o = n(12), l = n(13);
          const c = 16, u = 100, d = 4096, f = 15, h = 10, g = 1e3, x = 16;
          function E(F, M) {
            if (F._removeMirroring)
              throw new Error("Context is already forwarding operations.");
            F.__originalSave = F.save, F.__originalRestore = F.restore, F.__originalRotate = F.rotate, F.__originalScale = F.scale, F.__originalTranslate = F.translate, F.__originalTransform = F.transform, F.__originalSetTransform = F.setTransform, F.__originalResetTransform = F.resetTransform, F.__originalClip = F.clip, F.__originalMoveTo = F.moveTo, F.__originalLineTo = F.lineTo, F.__originalBezierCurveTo = F.bezierCurveTo, F.__originalRect = F.rect, F.__originalClosePath = F.closePath, F.__originalBeginPath = F.beginPath, F._removeMirroring = () => {
              F.save = F.__originalSave, F.restore = F.__originalRestore, F.rotate = F.__originalRotate, F.scale = F.__originalScale, F.translate = F.__originalTranslate, F.transform = F.__originalTransform, F.setTransform = F.__originalSetTransform, F.resetTransform = F.__originalResetTransform, F.clip = F.__originalClip, F.moveTo = F.__originalMoveTo, F.lineTo = F.__originalLineTo, F.bezierCurveTo = F.__originalBezierCurveTo, F.rect = F.__originalRect, F.closePath = F.__originalClosePath, F.beginPath = F.__originalBeginPath, delete F._removeMirroring;
            }, F.save = function() {
              M.save(), this.__originalSave();
            }, F.restore = function() {
              M.restore(), this.__originalRestore();
            }, F.translate = function(N, V) {
              M.translate(N, V), this.__originalTranslate(N, V);
            }, F.scale = function(N, V) {
              M.scale(N, V), this.__originalScale(N, V);
            }, F.transform = function(N, V, q, H, ne, he) {
              M.transform(N, V, q, H, ne, he), this.__originalTransform(N, V, q, H, ne, he);
            }, F.setTransform = function(N, V, q, H, ne, he) {
              M.setTransform(N, V, q, H, ne, he), this.__originalSetTransform(N, V, q, H, ne, he);
            }, F.resetTransform = function() {
              M.resetTransform(), this.__originalResetTransform();
            }, F.rotate = function(N) {
              M.rotate(N), this.__originalRotate(N);
            }, F.clip = function(N) {
              M.clip(N), this.__originalClip(N);
            }, F.moveTo = function(I, N) {
              M.moveTo(I, N), this.__originalMoveTo(I, N);
            }, F.lineTo = function(I, N) {
              M.lineTo(I, N), this.__originalLineTo(I, N);
            }, F.bezierCurveTo = function(I, N, V, q, H, ne) {
              M.bezierCurveTo(I, N, V, q, H, ne), this.__originalBezierCurveTo(I, N, V, q, H, ne);
            }, F.rect = function(I, N, V, q) {
              M.rect(I, N, V, q), this.__originalRect(I, N, V, q);
            }, F.closePath = function() {
              M.closePath(), this.__originalClosePath();
            }, F.beginPath = function() {
              M.beginPath(), this.__originalBeginPath();
            };
          }
          class m {
            constructor(M) {
              this.canvasFactory = M, this.cache = /* @__PURE__ */ Object.create(null);
            }
            getCanvas(M, I, N) {
              let V;
              return this.cache[M] !== void 0 ? (V = this.cache[M], this.canvasFactory.reset(V, I, N)) : (V = this.canvasFactory.create(I, N), this.cache[M] = V), V;
            }
            delete(M) {
              delete this.cache[M];
            }
            clear() {
              for (const M in this.cache) {
                const I = this.cache[M];
                this.canvasFactory.destroy(I), delete this.cache[M];
              }
            }
          }
          function v(F, M, I, N, V, q, H, ne, he, j) {
            const [Fe, X, ye, Ae, fe, _e] = (0, s.getCurrentTransform)(F);
            if (X === 0 && ye === 0) {
              const $e = H * Fe + fe, Me = Math.round($e), J = ne * Ae + _e, K = Math.round(J), ge = (H + he) * Fe + fe, Ce = Math.abs(Math.round(ge) - Me) || 1, Oe = (ne + j) * Ae + _e, qe = Math.abs(Math.round(Oe) - K) || 1;
              return F.setTransform(Math.sign(Fe), 0, 0, Math.sign(Ae), Me, K), F.drawImage(M, I, N, V, q, 0, 0, Ce, qe), F.setTransform(Fe, X, ye, Ae, fe, _e), [Ce, qe];
            }
            if (Fe === 0 && Ae === 0) {
              const $e = ne * ye + fe, Me = Math.round($e), J = H * X + _e, K = Math.round(J), ge = (ne + j) * ye + fe, Ce = Math.abs(Math.round(ge) - Me) || 1, Oe = (H + he) * X + _e, qe = Math.abs(Math.round(Oe) - K) || 1;
              return F.setTransform(0, Math.sign(X), Math.sign(ye), 0, Me, K), F.drawImage(M, I, N, V, q, 0, 0, qe, Ce), F.setTransform(Fe, X, ye, Ae, fe, _e), [qe, Ce];
            }
            F.drawImage(M, I, N, V, q, H, ne, he, j);
            const Ie = Math.hypot(Fe, X), Be = Math.hypot(ye, Ae);
            return [Ie * he, Be * j];
          }
          function y(F) {
            const {
              width: M,
              height: I
            } = F;
            if (M > g || I > g)
              return null;
            const N = 1e3, V = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), q = M + 1;
            let H = new Uint8Array(q * (I + 1)), ne, he, j;
            const Fe = M + 7 & -8;
            let X = new Uint8Array(Fe * I), ye = 0;
            for (const Be of F.data) {
              let $e = 128;
              for (; $e > 0; )
                X[ye++] = Be & $e ? 0 : 255, $e >>= 1;
            }
            let Ae = 0;
            for (ye = 0, X[ye] !== 0 && (H[0] = 1, ++Ae), he = 1; he < M; he++)
              X[ye] !== X[ye + 1] && (H[he] = X[ye] ? 2 : 1, ++Ae), ye++;
            for (X[ye] !== 0 && (H[he] = 2, ++Ae), ne = 1; ne < I; ne++) {
              ye = ne * Fe, j = ne * q, X[ye - Fe] !== X[ye] && (H[j] = X[ye] ? 1 : 8, ++Ae);
              let Be = (X[ye] ? 4 : 0) + (X[ye - Fe] ? 8 : 0);
              for (he = 1; he < M; he++)
                Be = (Be >> 2) + (X[ye + 1] ? 4 : 0) + (X[ye - Fe + 1] ? 8 : 0), V[Be] && (H[j + he] = V[Be], ++Ae), ye++;
              if (X[ye - Fe] !== X[ye] && (H[j + he] = X[ye] ? 2 : 4, ++Ae), Ae > N)
                return null;
            }
            for (ye = Fe * (I - 1), j = ne * q, X[ye] !== 0 && (H[j] = 8, ++Ae), he = 1; he < M; he++)
              X[ye] !== X[ye + 1] && (H[j + he] = X[ye] ? 4 : 8, ++Ae), ye++;
            if (X[ye] !== 0 && (H[j + he] = 4, ++Ae), Ae > N)
              return null;
            const fe = new Int32Array([0, q, -1, 0, -q, 0, 0, 0, 1]), _e = new Path2D();
            for (ne = 0; Ae && ne <= I; ne++) {
              let Be = ne * q;
              const $e = Be + M;
              for (; Be < $e && !H[Be]; )
                Be++;
              if (Be === $e)
                continue;
              _e.moveTo(Be % q, ne);
              const Me = Be;
              let J = H[Be];
              do {
                const K = fe[J];
                do
                  Be += K;
                while (!H[Be]);
                const ge = H[Be];
                ge !== 5 && ge !== 10 ? (J = ge, H[Be] = 0) : (J = ge & 51 * J >> 4, H[Be] &= J >> 2 | J << 2), _e.lineTo(Be % q, Be / q | 0), H[Be] || --Ae;
              } while (Me !== Be);
              --ne;
            }
            return X = null, H = null, function(Be) {
              Be.save(), Be.scale(1 / M, -1 / I), Be.translate(0, -I), Be.fill(_e), Be.beginPath(), Be.restore();
            };
          }
          class A {
            constructor(M, I) {
              this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = a.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = a.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = a.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, M, I]);
            }
            clone() {
              const M = Object.create(this);
              return M.clipBox = this.clipBox.slice(), M;
            }
            setCurrentPoint(M, I) {
              this.x = M, this.y = I;
            }
            updatePathMinMax(M, I, N) {
              [I, N] = a.Util.applyTransform([I, N], M), this.minX = Math.min(this.minX, I), this.minY = Math.min(this.minY, N), this.maxX = Math.max(this.maxX, I), this.maxY = Math.max(this.maxY, N);
            }
            updateRectMinMax(M, I) {
              const N = a.Util.applyTransform(I, M), V = a.Util.applyTransform(I.slice(2), M);
              this.minX = Math.min(this.minX, N[0], V[0]), this.minY = Math.min(this.minY, N[1], V[1]), this.maxX = Math.max(this.maxX, N[0], V[0]), this.maxY = Math.max(this.maxY, N[1], V[1]);
            }
            updateScalingPathMinMax(M, I) {
              a.Util.scaleMinMax(M, I), this.minX = Math.min(this.minX, I[0]), this.maxX = Math.max(this.maxX, I[1]), this.minY = Math.min(this.minY, I[2]), this.maxY = Math.max(this.maxY, I[3]);
            }
            updateCurvePathMinMax(M, I, N, V, q, H, ne, he, j, Fe) {
              const X = a.Util.bezierBoundingBox(I, N, V, q, H, ne, he, j);
              if (Fe) {
                Fe[0] = Math.min(Fe[0], X[0], X[2]), Fe[1] = Math.max(Fe[1], X[0], X[2]), Fe[2] = Math.min(Fe[2], X[1], X[3]), Fe[3] = Math.max(Fe[3], X[1], X[3]);
                return;
              }
              this.updateRectMinMax(M, X);
            }
            getPathBoundingBox(M = o.PathType.FILL, I = null) {
              const N = [this.minX, this.minY, this.maxX, this.maxY];
              if (M === o.PathType.STROKE) {
                I || (0, a.unreachable)("Stroke bounding box must include transform.");
                const V = a.Util.singularValueDecompose2dScale(I), q = V[0] * this.lineWidth / 2, H = V[1] * this.lineWidth / 2;
                N[0] -= q, N[1] -= H, N[2] += q, N[3] += H;
              }
              return N;
            }
            updateClipFromPath() {
              const M = a.Util.intersect(this.clipBox, this.getPathBoundingBox());
              this.startNewPathAndClipBox(M || [0, 0, 0, 0]);
            }
            isEmptyClip() {
              return this.minX === 1 / 0;
            }
            startNewPathAndClipBox(M) {
              this.clipBox = M, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
            }
            getClippedPathBoundingBox(M = o.PathType.FILL, I = null) {
              return a.Util.intersect(this.clipBox, this.getPathBoundingBox(M, I));
            }
          }
          function b(F, M) {
            if (typeof ImageData < "u" && M instanceof ImageData) {
              F.putImageData(M, 0, 0);
              return;
            }
            const I = M.height, N = M.width, V = I % x, q = (I - V) / x, H = V === 0 ? q : q + 1, ne = F.createImageData(N, x);
            let he = 0, j;
            const Fe = M.data, X = ne.data;
            let ye, Ae, fe, _e;
            if (M.kind === a.ImageKind.GRAYSCALE_1BPP) {
              const Ie = Fe.byteLength, Be = new Uint32Array(X.buffer, 0, X.byteLength >> 2), $e = Be.length, Me = N + 7 >> 3, J = 4294967295, K = a.FeatureTest.isLittleEndian ? 4278190080 : 255;
              for (ye = 0; ye < H; ye++) {
                for (fe = ye < q ? x : V, j = 0, Ae = 0; Ae < fe; Ae++) {
                  const ge = Ie - he;
                  let Ce = 0;
                  const Oe = ge > Me ? N : ge * 8 - 7, qe = Oe & -8;
                  let ct = 0, ze = 0;
                  for (; Ce < qe; Ce += 8)
                    ze = Fe[he++], Be[j++] = ze & 128 ? J : K, Be[j++] = ze & 64 ? J : K, Be[j++] = ze & 32 ? J : K, Be[j++] = ze & 16 ? J : K, Be[j++] = ze & 8 ? J : K, Be[j++] = ze & 4 ? J : K, Be[j++] = ze & 2 ? J : K, Be[j++] = ze & 1 ? J : K;
                  for (; Ce < Oe; Ce++)
                    ct === 0 && (ze = Fe[he++], ct = 128), Be[j++] = ze & ct ? J : K, ct >>= 1;
                }
                for (; j < $e; )
                  Be[j++] = 0;
                F.putImageData(ne, 0, ye * x);
              }
            } else if (M.kind === a.ImageKind.RGBA_32BPP) {
              for (Ae = 0, _e = N * x * 4, ye = 0; ye < q; ye++)
                X.set(Fe.subarray(he, he + _e)), he += _e, F.putImageData(ne, 0, Ae), Ae += x;
              ye < H && (_e = N * V * 4, X.set(Fe.subarray(he, he + _e)), F.putImageData(ne, 0, Ae));
            } else if (M.kind === a.ImageKind.RGB_24BPP)
              for (fe = x, _e = N * fe, ye = 0; ye < H; ye++) {
                for (ye >= q && (fe = V, _e = N * fe), j = 0, Ae = _e; Ae--; )
                  X[j++] = Fe[he++], X[j++] = Fe[he++], X[j++] = Fe[he++], X[j++] = 255;
                F.putImageData(ne, 0, ye * x);
              }
            else
              throw new Error(`bad image kind: ${M.kind}`);
          }
          function C(F, M) {
            if (M.bitmap) {
              F.drawImage(M.bitmap, 0, 0);
              return;
            }
            const I = M.height, N = M.width, V = I % x, q = (I - V) / x, H = V === 0 ? q : q + 1, ne = F.createImageData(N, x);
            let he = 0;
            const j = M.data, Fe = ne.data;
            for (let X = 0; X < H; X++) {
              const ye = X < q ? x : V;
              ({
                srcPos: he
              } = (0, l.convertBlackAndWhiteToRGBA)({
                src: j,
                srcPos: he,
                dest: Fe,
                width: N,
                height: ye,
                nonBlackColor: 0
              })), F.putImageData(ne, 0, X * x);
            }
          }
          function T(F, M) {
            const I = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
            for (const N of I)
              F[N] !== void 0 && (M[N] = F[N]);
            F.setLineDash !== void 0 && (M.setLineDash(F.getLineDash()), M.lineDashOffset = F.lineDashOffset);
          }
          function w(F) {
            if (F.strokeStyle = F.fillStyle = "#000000", F.fillRule = "nonzero", F.globalAlpha = 1, F.lineWidth = 1, F.lineCap = "butt", F.lineJoin = "miter", F.miterLimit = 10, F.globalCompositeOperation = "source-over", F.font = "10px sans-serif", F.setLineDash !== void 0 && (F.setLineDash([]), F.lineDashOffset = 0), !a.isNodeJS) {
              const {
                filter: M
              } = F;
              M !== "none" && M !== "" && (F.filter = "none");
            }
          }
          function R(F, M, I, N) {
            const V = F.length;
            for (let q = 3; q < V; q += 4) {
              const H = F[q];
              if (H === 0)
                F[q - 3] = M, F[q - 2] = I, F[q - 1] = N;
              else if (H < 255) {
                const ne = 255 - H;
                F[q - 3] = F[q - 3] * H + M * ne >> 8, F[q - 2] = F[q - 2] * H + I * ne >> 8, F[q - 1] = F[q - 1] * H + N * ne >> 8;
              }
            }
          }
          function O(F, M, I) {
            const N = F.length, V = 1 / 255;
            for (let q = 3; q < N; q += 4) {
              const H = I ? I[F[q]] : F[q];
              M[q] = M[q] * H * V | 0;
            }
          }
          function D(F, M, I) {
            const N = F.length;
            for (let V = 3; V < N; V += 4) {
              const q = F[V - 3] * 77 + F[V - 2] * 152 + F[V - 1] * 28;
              M[V] = I ? M[V] * I[q >> 8] >> 8 : M[V] * q >> 16;
            }
          }
          function k(F, M, I, N, V, q, H, ne, he, j, Fe) {
            const X = !!q, ye = X ? q[0] : 0, Ae = X ? q[1] : 0, fe = X ? q[2] : 0, _e = V === "Luminosity" ? D : O, Be = Math.min(N, Math.ceil(1048576 / I));
            for (let $e = 0; $e < N; $e += Be) {
              const Me = Math.min(Be, N - $e), J = F.getImageData(ne - j, $e + (he - Fe), I, Me), K = M.getImageData(ne, $e + he, I, Me);
              X && R(J.data, ye, Ae, fe), _e(J.data, K.data, H), M.putImageData(K, ne, $e + he);
            }
          }
          function W(F, M, I, N) {
            const V = N[0], q = N[1], H = N[2] - V, ne = N[3] - q;
            H === 0 || ne === 0 || (k(M.context, I, H, ne, M.subtype, M.backdrop, M.transferMap, V, q, M.offsetX, M.offsetY), F.save(), F.globalAlpha = 1, F.globalCompositeOperation = "source-over", F.setTransform(1, 0, 0, 1, 0, 0), F.drawImage(I.canvas, 0, 0), F.restore());
          }
          function L(F, M) {
            const I = a.Util.singularValueDecompose2dScale(F);
            I[0] = Math.fround(I[0]), I[1] = Math.fround(I[1]);
            const N = Math.fround((globalThis.devicePixelRatio || 1) * s.PixelsPerInch.PDF_TO_CSS_UNITS);
            return M !== void 0 ? M : I[0] <= N || I[1] <= N;
          }
          const z = ["butt", "round", "square"], P = ["miter", "round", "bevel"], Q = {}, Y = {}, U = class U {
            constructor(M, I, N, V, q, {
              optionalContentConfig: H,
              markedContentStack: ne = null
            }, he, j) {
              Ge(this, te);
              Ge(this, ae);
              this.ctx = M, this.current = new A(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = I, this.objs = N, this.canvasFactory = V, this.filterFactory = q, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = ne || [], this.optionalContentConfig = H, this.cachedCanvases = new m(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = he, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = j, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
            }
            getObject(M, I = null) {
              return typeof M == "string" ? M.startsWith("g_") ? this.commonObjs.get(M) : this.objs.get(M) : I;
            }
            beginDrawing({
              transform: M,
              viewport: I,
              transparency: N = !1,
              background: V = null
            }) {
              const q = this.ctx.canvas.width, H = this.ctx.canvas.height, ne = this.ctx.fillStyle;
              if (this.ctx.fillStyle = V || "#ffffff", this.ctx.fillRect(0, 0, q, H), this.ctx.fillStyle = ne, N) {
                const he = this.cachedCanvases.getCanvas("transparent", q, H);
                this.compositeCtx = this.ctx, this.transparentCanvas = he.canvas, this.ctx = he.context, this.ctx.save(), this.ctx.transform(...(0, s.getCurrentTransform)(this.compositeCtx));
              }
              this.ctx.save(), w(this.ctx), M && (this.ctx.transform(...M), this.outputScaleX = M[0], this.outputScaleY = M[0]), this.ctx.transform(...I.transform), this.viewportScale = I.scale, this.baseTransform = (0, s.getCurrentTransform)(this.ctx);
            }
            executeOperatorList(M, I, N, V) {
              const q = M.argsArray, H = M.fnArray;
              let ne = I || 0;
              const he = q.length;
              if (he === ne)
                return ne;
              const j = he - ne > h && typeof N == "function", Fe = j ? Date.now() + f : 0;
              let X = 0;
              const ye = this.commonObjs, Ae = this.objs;
              let fe;
              for (; ; ) {
                if (V !== void 0 && ne === V.nextBreakPoint)
                  return V.breakIt(ne, N), ne;
                if (fe = H[ne], fe !== a.OPS.dependency)
                  this[fe].apply(this, q[ne]);
                else
                  for (const _e of q[ne]) {
                    const Ie = _e.startsWith("g_") ? ye : Ae;
                    if (!Ie.has(_e))
                      return Ie.get(_e, N), ne;
                  }
                if (ne++, ne === he)
                  return ne;
                if (j && ++X > h) {
                  if (Date.now() > Fe)
                    return N(), ne;
                  X = 0;
                }
              }
            }
            endDrawing() {
              Ke(this, te, ai).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
              for (const M of this._cachedBitmapsMap.values()) {
                for (const I of M.values())
                  typeof HTMLCanvasElement < "u" && I instanceof HTMLCanvasElement && (I.width = I.height = 0);
                M.clear();
              }
              this._cachedBitmapsMap.clear(), Ke(this, ae, si).call(this);
            }
            _scaleImage(M, I) {
              const N = M.width, V = M.height;
              let q = Math.max(Math.hypot(I[0], I[1]), 1), H = Math.max(Math.hypot(I[2], I[3]), 1), ne = N, he = V, j = "prescale1", Fe, X;
              for (; q > 2 && ne > 1 || H > 2 && he > 1; ) {
                let ye = ne, Ae = he;
                q > 2 && ne > 1 && (ye = ne >= 16384 ? Math.floor(ne / 2) - 1 || 1 : Math.ceil(ne / 2), q /= ne / ye), H > 2 && he > 1 && (Ae = he >= 16384 ? Math.floor(he / 2) - 1 || 1 : Math.ceil(he) / 2, H /= he / Ae), Fe = this.cachedCanvases.getCanvas(j, ye, Ae), X = Fe.context, X.clearRect(0, 0, ye, Ae), X.drawImage(M, 0, 0, ne, he, 0, 0, ye, Ae), M = Fe.canvas, ne = ye, he = Ae, j = j === "prescale1" ? "prescale2" : "prescale1";
              }
              return {
                img: M,
                paintWidth: ne,
                paintHeight: he
              };
            }
            _createMaskCanvas(M) {
              const I = this.ctx, {
                width: N,
                height: V
              } = M, q = this.current.fillColor, H = this.current.patternFill, ne = (0, s.getCurrentTransform)(I);
              let he, j, Fe, X;
              if ((M.bitmap || M.data) && M.count > 1) {
                const Ce = M.bitmap || M.data.buffer;
                j = JSON.stringify(H ? ne : [ne.slice(0, 4), q]), he = this._cachedBitmapsMap.get(Ce), he || (he = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(Ce, he));
                const Oe = he.get(j);
                if (Oe && !H) {
                  const qe = Math.round(Math.min(ne[0], ne[2]) + ne[4]), ct = Math.round(Math.min(ne[1], ne[3]) + ne[5]);
                  return {
                    canvas: Oe,
                    offsetX: qe,
                    offsetY: ct
                  };
                }
                Fe = Oe;
              }
              Fe || (X = this.cachedCanvases.getCanvas("maskCanvas", N, V), C(X.context, M));
              let ye = a.Util.transform(ne, [1 / N, 0, 0, -1 / V, 0, 0]);
              ye = a.Util.transform(ye, [1, 0, 0, 1, 0, -V]);
              const Ae = a.Util.applyTransform([0, 0], ye), fe = a.Util.applyTransform([N, V], ye), _e = a.Util.normalizeRect([Ae[0], Ae[1], fe[0], fe[1]]), Ie = Math.round(_e[2] - _e[0]) || 1, Be = Math.round(_e[3] - _e[1]) || 1, $e = this.cachedCanvases.getCanvas("fillCanvas", Ie, Be), Me = $e.context, J = Math.min(Ae[0], fe[0]), K = Math.min(Ae[1], fe[1]);
              Me.translate(-J, -K), Me.transform(...ye), Fe || (Fe = this._scaleImage(X.canvas, (0, s.getCurrentTransformInverse)(Me)), Fe = Fe.img, he && H && he.set(j, Fe)), Me.imageSmoothingEnabled = L((0, s.getCurrentTransform)(Me), M.interpolate), v(Me, Fe, 0, 0, Fe.width, Fe.height, 0, 0, N, V), Me.globalCompositeOperation = "source-in";
              const ge = a.Util.transform((0, s.getCurrentTransformInverse)(Me), [1, 0, 0, 1, -J, -K]);
              return Me.fillStyle = H ? q.getPattern(I, this, ge, o.PathType.FILL) : q, Me.fillRect(0, 0, N, V), he && !H && (this.cachedCanvases.delete("fillCanvas"), he.set(j, $e.canvas)), {
                canvas: $e.canvas,
                offsetX: Math.round(J),
                offsetY: Math.round(K)
              };
            }
            setLineWidth(M) {
              M !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = M, this.ctx.lineWidth = M;
            }
            setLineCap(M) {
              this.ctx.lineCap = z[M];
            }
            setLineJoin(M) {
              this.ctx.lineJoin = P[M];
            }
            setMiterLimit(M) {
              this.ctx.miterLimit = M;
            }
            setDash(M, I) {
              const N = this.ctx;
              N.setLineDash !== void 0 && (N.setLineDash(M), N.lineDashOffset = I);
            }
            setRenderingIntent(M) {
            }
            setFlatness(M) {
            }
            setGState(M) {
              for (const [I, N] of M)
                switch (I) {
                  case "LW":
                    this.setLineWidth(N);
                    break;
                  case "LC":
                    this.setLineCap(N);
                    break;
                  case "LJ":
                    this.setLineJoin(N);
                    break;
                  case "ML":
                    this.setMiterLimit(N);
                    break;
                  case "D":
                    this.setDash(N[0], N[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(N);
                    break;
                  case "FL":
                    this.setFlatness(N);
                    break;
                  case "Font":
                    this.setFont(N[0], N[1]);
                    break;
                  case "CA":
                    this.current.strokeAlpha = N;
                    break;
                  case "ca":
                    this.current.fillAlpha = N, this.ctx.globalAlpha = N;
                    break;
                  case "BM":
                    this.ctx.globalCompositeOperation = N;
                    break;
                  case "SMask":
                    this.current.activeSMask = N ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                    break;
                  case "TR":
                    this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(N);
                    break;
                }
            }
            get inSMaskMode() {
              return !!this.suspendedCtx;
            }
            checkSMaskState() {
              const M = this.inSMaskMode;
              this.current.activeSMask && !M ? this.beginSMaskMode() : !this.current.activeSMask && M && this.endSMaskMode();
            }
            beginSMaskMode() {
              if (this.inSMaskMode)
                throw new Error("beginSMaskMode called while already in smask mode");
              const M = this.ctx.canvas.width, I = this.ctx.canvas.height, N = "smaskGroupAt" + this.groupLevel, V = this.cachedCanvases.getCanvas(N, M, I);
              this.suspendedCtx = this.ctx, this.ctx = V.context;
              const q = this.ctx;
              q.setTransform(...(0, s.getCurrentTransform)(this.suspendedCtx)), T(this.suspendedCtx, q), E(q, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            }
            endSMaskMode() {
              if (!this.inSMaskMode)
                throw new Error("endSMaskMode called while not in smask mode");
              this.ctx._removeMirroring(), T(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
            }
            compose(M) {
              if (!this.current.activeSMask)
                return;
              M ? (M[0] = Math.floor(M[0]), M[1] = Math.floor(M[1]), M[2] = Math.ceil(M[2]), M[3] = Math.ceil(M[3])) : M = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
              const I = this.current.activeSMask, N = this.suspendedCtx;
              W(N, I, this.ctx, M), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
            }
            save() {
              this.inSMaskMode ? (T(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
              const M = this.current;
              this.stateStack.push(M), this.current = M.clone();
            }
            restore() {
              this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), T(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
            }
            transform(M, I, N, V, q, H) {
              this.ctx.transform(M, I, N, V, q, H), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
            }
            constructPath(M, I, N) {
              const V = this.ctx, q = this.current;
              let H = q.x, ne = q.y, he, j;
              const Fe = (0, s.getCurrentTransform)(V), X = Fe[0] === 0 && Fe[3] === 0 || Fe[1] === 0 && Fe[2] === 0, ye = X ? N.slice(0) : null;
              for (let Ae = 0, fe = 0, _e = M.length; Ae < _e; Ae++)
                switch (M[Ae] | 0) {
                  case a.OPS.rectangle:
                    H = I[fe++], ne = I[fe++];
                    const Ie = I[fe++], Be = I[fe++], $e = H + Ie, Me = ne + Be;
                    V.moveTo(H, ne), Ie === 0 || Be === 0 ? V.lineTo($e, Me) : (V.lineTo($e, ne), V.lineTo($e, Me), V.lineTo(H, Me)), X || q.updateRectMinMax(Fe, [H, ne, $e, Me]), V.closePath();
                    break;
                  case a.OPS.moveTo:
                    H = I[fe++], ne = I[fe++], V.moveTo(H, ne), X || q.updatePathMinMax(Fe, H, ne);
                    break;
                  case a.OPS.lineTo:
                    H = I[fe++], ne = I[fe++], V.lineTo(H, ne), X || q.updatePathMinMax(Fe, H, ne);
                    break;
                  case a.OPS.curveTo:
                    he = H, j = ne, H = I[fe + 4], ne = I[fe + 5], V.bezierCurveTo(I[fe], I[fe + 1], I[fe + 2], I[fe + 3], H, ne), q.updateCurvePathMinMax(Fe, he, j, I[fe], I[fe + 1], I[fe + 2], I[fe + 3], H, ne, ye), fe += 6;
                    break;
                  case a.OPS.curveTo2:
                    he = H, j = ne, V.bezierCurveTo(H, ne, I[fe], I[fe + 1], I[fe + 2], I[fe + 3]), q.updateCurvePathMinMax(Fe, he, j, H, ne, I[fe], I[fe + 1], I[fe + 2], I[fe + 3], ye), H = I[fe + 2], ne = I[fe + 3], fe += 4;
                    break;
                  case a.OPS.curveTo3:
                    he = H, j = ne, H = I[fe + 2], ne = I[fe + 3], V.bezierCurveTo(I[fe], I[fe + 1], H, ne, H, ne), q.updateCurvePathMinMax(Fe, he, j, I[fe], I[fe + 1], H, ne, H, ne, ye), fe += 4;
                    break;
                  case a.OPS.closePath:
                    V.closePath();
                    break;
                }
              X && q.updateScalingPathMinMax(Fe, ye), q.setCurrentPoint(H, ne);
            }
            closePath() {
              this.ctx.closePath();
            }
            stroke(M = !0) {
              const I = this.ctx, N = this.current.strokeColor;
              I.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof N == "object" && (N != null && N.getPattern) ? (I.save(), I.strokeStyle = N.getPattern(I, this, (0, s.getCurrentTransformInverse)(I), o.PathType.STROKE), this.rescaleAndStroke(!1), I.restore()) : this.rescaleAndStroke(!0)), M && this.consumePath(this.current.getClippedPathBoundingBox()), I.globalAlpha = this.current.fillAlpha;
            }
            closeStroke() {
              this.closePath(), this.stroke();
            }
            fill(M = !0) {
              const I = this.ctx, N = this.current.fillColor, V = this.current.patternFill;
              let q = !1;
              V && (I.save(), I.fillStyle = N.getPattern(I, this, (0, s.getCurrentTransformInverse)(I), o.PathType.FILL), q = !0);
              const H = this.current.getClippedPathBoundingBox();
              this.contentVisible && H !== null && (this.pendingEOFill ? (I.fill("evenodd"), this.pendingEOFill = !1) : I.fill()), q && I.restore(), M && this.consumePath(H);
            }
            eoFill() {
              this.pendingEOFill = !0, this.fill();
            }
            fillStroke() {
              this.fill(!1), this.stroke(!1), this.consumePath();
            }
            eoFillStroke() {
              this.pendingEOFill = !0, this.fillStroke();
            }
            closeFillStroke() {
              this.closePath(), this.fillStroke();
            }
            closeEOFillStroke() {
              this.pendingEOFill = !0, this.closePath(), this.fillStroke();
            }
            endPath() {
              this.consumePath();
            }
            clip() {
              this.pendingClip = Q;
            }
            eoClip() {
              this.pendingClip = Y;
            }
            beginText() {
              this.current.textMatrix = a.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            endText() {
              const M = this.pendingTextPaths, I = this.ctx;
              if (M === void 0) {
                I.beginPath();
                return;
              }
              I.save(), I.beginPath();
              for (const N of M)
                I.setTransform(...N.transform), I.translate(N.x, N.y), N.addToPath(I, N.fontSize);
              I.restore(), I.clip(), I.beginPath(), delete this.pendingTextPaths;
            }
            setCharSpacing(M) {
              this.current.charSpacing = M;
            }
            setWordSpacing(M) {
              this.current.wordSpacing = M;
            }
            setHScale(M) {
              this.current.textHScale = M / 100;
            }
            setLeading(M) {
              this.current.leading = -M;
            }
            setFont(M, I) {
              var Fe;
              const N = this.commonObjs.get(M), V = this.current;
              if (!N)
                throw new Error(`Can't find font for ${M}`);
              if (V.fontMatrix = N.fontMatrix || a.FONT_IDENTITY_MATRIX, (V.fontMatrix[0] === 0 || V.fontMatrix[3] === 0) && (0, a.warn)("Invalid font matrix for font " + M), I < 0 ? (I = -I, V.fontDirection = -1) : V.fontDirection = 1, this.current.font = N, this.current.fontSize = I, N.isType3Font)
                return;
              const q = N.loadedName || "sans-serif", H = ((Fe = N.systemFontInfo) == null ? void 0 : Fe.css) || `"${q}", ${N.fallbackName}`;
              let ne = "normal";
              N.black ? ne = "900" : N.bold && (ne = "bold");
              const he = N.italic ? "italic" : "normal";
              let j = I;
              I < c ? j = c : I > u && (j = u), this.current.fontSizeScale = I / j, this.ctx.font = `${he} ${ne} ${j}px ${H}`;
            }
            setTextRenderingMode(M) {
              this.current.textRenderingMode = M;
            }
            setTextRise(M) {
              this.current.textRise = M;
            }
            moveText(M, I) {
              this.current.x = this.current.lineX += M, this.current.y = this.current.lineY += I;
            }
            setLeadingMoveText(M, I) {
              this.setLeading(-I), this.moveText(M, I);
            }
            setTextMatrix(M, I, N, V, q, H) {
              this.current.textMatrix = [M, I, N, V, q, H], this.current.textMatrixScale = Math.hypot(M, I), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            nextLine() {
              this.moveText(0, this.current.leading);
            }
            paintChar(M, I, N, V) {
              const q = this.ctx, H = this.current, ne = H.font, he = H.textRenderingMode, j = H.fontSize / H.fontSizeScale, Fe = he & a.TextRenderingMode.FILL_STROKE_MASK, X = !!(he & a.TextRenderingMode.ADD_TO_PATH_FLAG), ye = H.patternFill && !ne.missingFile;
              let Ae;
              (ne.disableFontFace || X || ye) && (Ae = ne.getPathGenerator(this.commonObjs, M)), ne.disableFontFace || ye ? (q.save(), q.translate(I, N), q.beginPath(), Ae(q, j), V && q.setTransform(...V), (Fe === a.TextRenderingMode.FILL || Fe === a.TextRenderingMode.FILL_STROKE) && q.fill(), (Fe === a.TextRenderingMode.STROKE || Fe === a.TextRenderingMode.FILL_STROKE) && q.stroke(), q.restore()) : ((Fe === a.TextRenderingMode.FILL || Fe === a.TextRenderingMode.FILL_STROKE) && q.fillText(M, I, N), (Fe === a.TextRenderingMode.STROKE || Fe === a.TextRenderingMode.FILL_STROKE) && q.strokeText(M, I, N)), X && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                transform: (0, s.getCurrentTransform)(q),
                x: I,
                y: N,
                fontSize: j,
                addToPath: Ae
              });
            }
            get isFontSubpixelAAEnabled() {
              const {
                context: M
              } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
              M.scale(1.5, 1), M.fillText("I", 0, 10);
              const I = M.getImageData(0, 0, 10, 10).data;
              let N = !1;
              for (let V = 3; V < I.length; V += 4)
                if (I[V] > 0 && I[V] < 255) {
                  N = !0;
                  break;
                }
              return (0, a.shadow)(this, "isFontSubpixelAAEnabled", N);
            }
            showText(M) {
              const I = this.current, N = I.font;
              if (N.isType3Font)
                return this.showType3Text(M);
              const V = I.fontSize;
              if (V === 0)
                return;
              const q = this.ctx, H = I.fontSizeScale, ne = I.charSpacing, he = I.wordSpacing, j = I.fontDirection, Fe = I.textHScale * j, X = M.length, ye = N.vertical, Ae = ye ? 1 : -1, fe = N.defaultVMetrics, _e = V * I.fontMatrix[0], Ie = I.textRenderingMode === a.TextRenderingMode.FILL && !N.disableFontFace && !I.patternFill;
              q.save(), q.transform(...I.textMatrix), q.translate(I.x, I.y + I.textRise), j > 0 ? q.scale(Fe, -1) : q.scale(Fe, 1);
              let Be;
              if (I.patternFill) {
                q.save();
                const ge = I.fillColor.getPattern(q, this, (0, s.getCurrentTransformInverse)(q), o.PathType.FILL);
                Be = (0, s.getCurrentTransform)(q), q.restore(), q.fillStyle = ge;
              }
              let $e = I.lineWidth;
              const Me = I.textMatrixScale;
              if (Me === 0 || $e === 0) {
                const ge = I.textRenderingMode & a.TextRenderingMode.FILL_STROKE_MASK;
                (ge === a.TextRenderingMode.STROKE || ge === a.TextRenderingMode.FILL_STROKE) && ($e = this.getSinglePixelWidth());
              } else
                $e /= Me;
              if (H !== 1 && (q.scale(H, H), $e /= H), q.lineWidth = $e, N.isInvalidPDFjsFont) {
                const ge = [];
                let Ce = 0;
                for (const Oe of M)
                  ge.push(Oe.unicode), Ce += Oe.width;
                q.fillText(ge.join(""), 0, 0), I.x += Ce * _e * Fe, q.restore(), this.compose();
                return;
              }
              let J = 0, K;
              for (K = 0; K < X; ++K) {
                const ge = M[K];
                if (typeof ge == "number") {
                  J += Ae * ge * V / 1e3;
                  continue;
                }
                let Ce = !1;
                const Oe = (ge.isSpace ? he : 0) + ne, qe = ge.fontChar, ct = ge.accent;
                let ze, et, gt = ge.width;
                if (ye) {
                  const nt = ge.vmetric || fe, tt = -(ge.vmetric ? nt[1] : gt * 0.5) * _e, Ve = nt[2] * _e;
                  gt = nt ? -nt[0] : gt, ze = tt / H, et = (J + Ve) / H;
                } else
                  ze = J / H, et = 0;
                if (N.remeasure && gt > 0) {
                  const nt = q.measureText(qe).width * 1e3 / V * H;
                  if (gt < nt && this.isFontSubpixelAAEnabled) {
                    const tt = gt / nt;
                    Ce = !0, q.save(), q.scale(tt, 1), ze /= tt;
                  } else
                    gt !== nt && (ze += (gt - nt) / 2e3 * V / H);
                }
                if (this.contentVisible && (ge.isInFont || N.missingFile)) {
                  if (Ie && !ct)
                    q.fillText(qe, ze, et);
                  else if (this.paintChar(qe, ze, et, Be), ct) {
                    const nt = ze + V * ct.offset.x / H, tt = et - V * ct.offset.y / H;
                    this.paintChar(ct.fontChar, nt, tt, Be);
                  }
                }
                const pt = ye ? gt * _e - Oe * j : gt * _e + Oe * j;
                J += pt, Ce && q.restore();
              }
              ye ? I.y -= J : I.x += J * Fe, q.restore(), this.compose();
            }
            showType3Text(M) {
              const I = this.ctx, N = this.current, V = N.font, q = N.fontSize, H = N.fontDirection, ne = V.vertical ? 1 : -1, he = N.charSpacing, j = N.wordSpacing, Fe = N.textHScale * H, X = N.fontMatrix || a.FONT_IDENTITY_MATRIX, ye = M.length, Ae = N.textRenderingMode === a.TextRenderingMode.INVISIBLE;
              let fe, _e, Ie, Be;
              if (!(Ae || q === 0)) {
                for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, I.save(), I.transform(...N.textMatrix), I.translate(N.x, N.y), I.scale(Fe, H), fe = 0; fe < ye; ++fe) {
                  if (_e = M[fe], typeof _e == "number") {
                    Be = ne * _e * q / 1e3, this.ctx.translate(Be, 0), N.x += Be * Fe;
                    continue;
                  }
                  const $e = (_e.isSpace ? j : 0) + he, Me = V.charProcOperatorList[_e.operatorListId];
                  if (!Me) {
                    (0, a.warn)(`Type3 character "${_e.operatorListId}" is not available.`);
                    continue;
                  }
                  this.contentVisible && (this.processingType3 = _e, this.save(), I.scale(q, q), I.transform(...X), this.executeOperatorList(Me), this.restore()), Ie = a.Util.applyTransform([_e.width, 0], X)[0] * q + $e, I.translate(Ie, 0), N.x += Ie * Fe;
                }
                I.restore(), this.processingType3 = null;
              }
            }
            setCharWidth(M, I) {
            }
            setCharWidthAndBounds(M, I, N, V, q, H) {
              this.ctx.rect(N, V, q - N, H - V), this.ctx.clip(), this.endPath();
            }
            getColorN_Pattern(M) {
              let I;
              if (M[0] === "TilingPattern") {
                const N = M[1], V = this.baseTransform || (0, s.getCurrentTransform)(this.ctx), q = {
                  createCanvasGraphics: (H) => new U(H, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                    optionalContentConfig: this.optionalContentConfig,
                    markedContentStack: this.markedContentStack
                  })
                };
                I = new o.TilingPattern(M, N, this.ctx, q, V);
              } else
                I = this._getPattern(M[1], M[2]);
              return I;
            }
            setStrokeColorN() {
              this.current.strokeColor = this.getColorN_Pattern(arguments);
            }
            setFillColorN() {
              this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
            }
            setStrokeRGBColor(M, I, N) {
              const V = a.Util.makeHexColor(M, I, N);
              this.ctx.strokeStyle = V, this.current.strokeColor = V;
            }
            setFillRGBColor(M, I, N) {
              const V = a.Util.makeHexColor(M, I, N);
              this.ctx.fillStyle = V, this.current.fillColor = V, this.current.patternFill = !1;
            }
            _getPattern(M, I = null) {
              let N;
              return this.cachedPatterns.has(M) ? N = this.cachedPatterns.get(M) : (N = (0, o.getShadingPattern)(this.getObject(M)), this.cachedPatterns.set(M, N)), I && (N.matrix = I), N;
            }
            shadingFill(M) {
              if (!this.contentVisible)
                return;
              const I = this.ctx;
              this.save();
              const N = this._getPattern(M);
              I.fillStyle = N.getPattern(I, this, (0, s.getCurrentTransformInverse)(I), o.PathType.SHADING);
              const V = (0, s.getCurrentTransformInverse)(I);
              if (V) {
                const {
                  width: q,
                  height: H
                } = I.canvas, [ne, he, j, Fe] = a.Util.getAxialAlignedBoundingBox([0, 0, q, H], V);
                this.ctx.fillRect(ne, he, j - ne, Fe - he);
              } else
                this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
              this.compose(this.current.getClippedPathBoundingBox()), this.restore();
            }
            beginInlineImage() {
              (0, a.unreachable)("Should not call beginInlineImage");
            }
            beginImageData() {
              (0, a.unreachable)("Should not call beginImageData");
            }
            paintFormXObjectBegin(M, I) {
              if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(M) && M.length === 6 && this.transform(...M), this.baseTransform = (0, s.getCurrentTransform)(this.ctx), I)) {
                const N = I[2] - I[0], V = I[3] - I[1];
                this.ctx.rect(I[0], I[1], N, V), this.current.updateRectMinMax((0, s.getCurrentTransform)(this.ctx), I), this.clip(), this.endPath();
              }
            }
            paintFormXObjectEnd() {
              this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
            }
            beginGroup(M) {
              if (!this.contentVisible)
                return;
              this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
              const I = this.ctx;
              M.isolated || (0, a.info)("TODO: Support non-isolated groups."), M.knockout && (0, a.warn)("Knockout groups not supported.");
              const N = (0, s.getCurrentTransform)(I);
              if (M.matrix && I.transform(...M.matrix), !M.bbox)
                throw new Error("Bounding box is required.");
              let V = a.Util.getAxialAlignedBoundingBox(M.bbox, (0, s.getCurrentTransform)(I));
              const q = [0, 0, I.canvas.width, I.canvas.height];
              V = a.Util.intersect(V, q) || [0, 0, 0, 0];
              const H = Math.floor(V[0]), ne = Math.floor(V[1]);
              let he = Math.max(Math.ceil(V[2]) - H, 1), j = Math.max(Math.ceil(V[3]) - ne, 1), Fe = 1, X = 1;
              he > d && (Fe = he / d, he = d), j > d && (X = j / d, j = d), this.current.startNewPathAndClipBox([0, 0, he, j]);
              let ye = "groupAt" + this.groupLevel;
              M.smask && (ye += "_smask_" + this.smaskCounter++ % 2);
              const Ae = this.cachedCanvases.getCanvas(ye, he, j), fe = Ae.context;
              fe.scale(1 / Fe, 1 / X), fe.translate(-H, -ne), fe.transform(...N), M.smask ? this.smaskStack.push({
                canvas: Ae.canvas,
                context: fe,
                offsetX: H,
                offsetY: ne,
                scaleX: Fe,
                scaleY: X,
                subtype: M.smask.subtype,
                backdrop: M.smask.backdrop,
                transferMap: M.smask.transferMap || null,
                startTransformInverse: null
              }) : (I.setTransform(1, 0, 0, 1, 0, 0), I.translate(H, ne), I.scale(Fe, X), I.save()), T(I, fe), this.ctx = fe, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(I), this.groupLevel++;
            }
            endGroup(M) {
              if (!this.contentVisible)
                return;
              this.groupLevel--;
              const I = this.ctx, N = this.groupStack.pop();
              if (this.ctx = N, this.ctx.imageSmoothingEnabled = !1, M.smask)
                this.tempSMask = this.smaskStack.pop(), this.restore();
              else {
                this.ctx.restore();
                const V = (0, s.getCurrentTransform)(this.ctx);
                this.restore(), this.ctx.save(), this.ctx.setTransform(...V);
                const q = a.Util.getAxialAlignedBoundingBox([0, 0, I.canvas.width, I.canvas.height], V);
                this.ctx.drawImage(I.canvas, 0, 0), this.ctx.restore(), this.compose(q);
              }
            }
            beginAnnotation(M, I, N, V, q) {
              if (Ke(this, te, ai).call(this), w(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(I) && I.length === 4) {
                const H = I[2] - I[0], ne = I[3] - I[1];
                if (q && this.annotationCanvasMap) {
                  N = N.slice(), N[4] -= I[0], N[5] -= I[1], I = I.slice(), I[0] = I[1] = 0, I[2] = H, I[3] = ne;
                  const [he, j] = a.Util.singularValueDecompose2dScale((0, s.getCurrentTransform)(this.ctx)), {
                    viewportScale: Fe
                  } = this, X = Math.ceil(H * this.outputScaleX * Fe), ye = Math.ceil(ne * this.outputScaleY * Fe);
                  this.annotationCanvas = this.canvasFactory.create(X, ye);
                  const {
                    canvas: Ae,
                    context: fe
                  } = this.annotationCanvas;
                  this.annotationCanvasMap.set(M, Ae), this.annotationCanvas.savedCtx = this.ctx, this.ctx = fe, this.ctx.save(), this.ctx.setTransform(he, 0, 0, -j, 0, ne * j), w(this.ctx);
                } else
                  w(this.ctx), this.ctx.rect(I[0], I[1], H, ne), this.ctx.clip(), this.endPath();
              }
              this.current = new A(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...N), this.transform(...V);
            }
            endAnnotation() {
              this.annotationCanvas && (this.ctx.restore(), Ke(this, ae, si).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
            }
            paintImageMaskXObject(M) {
              if (!this.contentVisible)
                return;
              const I = M.count;
              M = this.getObject(M.data, M), M.count = I;
              const N = this.ctx, V = this.processingType3;
              if (V && (V.compiled === void 0 && (V.compiled = y(M)), V.compiled)) {
                V.compiled(N);
                return;
              }
              const q = this._createMaskCanvas(M), H = q.canvas;
              N.save(), N.setTransform(1, 0, 0, 1, 0, 0), N.drawImage(H, q.offsetX, q.offsetY), N.restore(), this.compose();
            }
            paintImageMaskXObjectRepeat(M, I, N = 0, V = 0, q, H) {
              if (!this.contentVisible)
                return;
              M = this.getObject(M.data, M);
              const ne = this.ctx;
              ne.save();
              const he = (0, s.getCurrentTransform)(ne);
              ne.transform(I, N, V, q, 0, 0);
              const j = this._createMaskCanvas(M);
              ne.setTransform(1, 0, 0, 1, j.offsetX - he[4], j.offsetY - he[5]);
              for (let Fe = 0, X = H.length; Fe < X; Fe += 2) {
                const ye = a.Util.transform(he, [I, N, V, q, H[Fe], H[Fe + 1]]), [Ae, fe] = a.Util.applyTransform([0, 0], ye);
                ne.drawImage(j.canvas, Ae, fe);
              }
              ne.restore(), this.compose();
            }
            paintImageMaskXObjectGroup(M) {
              if (!this.contentVisible)
                return;
              const I = this.ctx, N = this.current.fillColor, V = this.current.patternFill;
              for (const q of M) {
                const {
                  data: H,
                  width: ne,
                  height: he,
                  transform: j
                } = q, Fe = this.cachedCanvases.getCanvas("maskCanvas", ne, he), X = Fe.context;
                X.save();
                const ye = this.getObject(H, q);
                C(X, ye), X.globalCompositeOperation = "source-in", X.fillStyle = V ? N.getPattern(X, this, (0, s.getCurrentTransformInverse)(I), o.PathType.FILL) : N, X.fillRect(0, 0, ne, he), X.restore(), I.save(), I.transform(...j), I.scale(1, -1), v(I, Fe.canvas, 0, 0, ne, he, 0, -1, 1, 1), I.restore();
              }
              this.compose();
            }
            paintImageXObject(M) {
              if (!this.contentVisible)
                return;
              const I = this.getObject(M);
              if (!I) {
                (0, a.warn)("Dependent image isn't ready yet");
                return;
              }
              this.paintInlineImageXObject(I);
            }
            paintImageXObjectRepeat(M, I, N, V) {
              if (!this.contentVisible)
                return;
              const q = this.getObject(M);
              if (!q) {
                (0, a.warn)("Dependent image isn't ready yet");
                return;
              }
              const H = q.width, ne = q.height, he = [];
              for (let j = 0, Fe = V.length; j < Fe; j += 2)
                he.push({
                  transform: [I, 0, 0, N, V[j], V[j + 1]],
                  x: 0,
                  y: 0,
                  w: H,
                  h: ne
                });
              this.paintInlineImageXObjectGroup(q, he);
            }
            applyTransferMapsToCanvas(M) {
              return this.current.transferMaps !== "none" && (M.filter = this.current.transferMaps, M.drawImage(M.canvas, 0, 0), M.filter = "none"), M.canvas;
            }
            applyTransferMapsToBitmap(M) {
              if (this.current.transferMaps === "none")
                return M.bitmap;
              const {
                bitmap: I,
                width: N,
                height: V
              } = M, q = this.cachedCanvases.getCanvas("inlineImage", N, V), H = q.context;
              return H.filter = this.current.transferMaps, H.drawImage(I, 0, 0), H.filter = "none", q.canvas;
            }
            paintInlineImageXObject(M) {
              if (!this.contentVisible)
                return;
              const I = M.width, N = M.height, V = this.ctx;
              if (this.save(), !a.isNodeJS) {
                const {
                  filter: ne
                } = V;
                ne !== "none" && ne !== "" && (V.filter = "none");
              }
              V.scale(1 / I, -1 / N);
              let q;
              if (M.bitmap)
                q = this.applyTransferMapsToBitmap(M);
              else if (typeof HTMLElement == "function" && M instanceof HTMLElement || !M.data)
                q = M;
              else {
                const he = this.cachedCanvases.getCanvas("inlineImage", I, N).context;
                b(he, M), q = this.applyTransferMapsToCanvas(he);
              }
              const H = this._scaleImage(q, (0, s.getCurrentTransformInverse)(V));
              V.imageSmoothingEnabled = L((0, s.getCurrentTransform)(V), M.interpolate), v(V, H.img, 0, 0, H.paintWidth, H.paintHeight, 0, -N, I, N), this.compose(), this.restore();
            }
            paintInlineImageXObjectGroup(M, I) {
              if (!this.contentVisible)
                return;
              const N = this.ctx;
              let V;
              if (M.bitmap)
                V = M.bitmap;
              else {
                const q = M.width, H = M.height, he = this.cachedCanvases.getCanvas("inlineImage", q, H).context;
                b(he, M), V = this.applyTransferMapsToCanvas(he);
              }
              for (const q of I)
                N.save(), N.transform(...q.transform), N.scale(1, -1), v(N, V, q.x, q.y, q.w, q.h, 0, -1, 1, 1), N.restore();
              this.compose();
            }
            paintSolidColorImageMask() {
              this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
            }
            markPoint(M) {
            }
            markPointProps(M, I) {
            }
            beginMarkedContent(M) {
              this.markedContentStack.push({
                visible: !0
              });
            }
            beginMarkedContentProps(M, I) {
              M === "OC" ? this.markedContentStack.push({
                visible: this.optionalContentConfig.isVisible(I)
              }) : this.markedContentStack.push({
                visible: !0
              }), this.contentVisible = this.isContentVisible();
            }
            endMarkedContent() {
              this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
            }
            beginCompat() {
            }
            endCompat() {
            }
            consumePath(M) {
              const I = this.current.isEmptyClip();
              this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(M);
              const N = this.ctx;
              this.pendingClip && (I || (this.pendingClip === Y ? N.clip("evenodd") : N.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), N.beginPath();
            }
            getSinglePixelWidth() {
              if (!this._cachedGetSinglePixelWidth) {
                const M = (0, s.getCurrentTransform)(this.ctx);
                if (M[1] === 0 && M[2] === 0)
                  this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(M[0]), Math.abs(M[3]));
                else {
                  const I = Math.abs(M[0] * M[3] - M[2] * M[1]), N = Math.hypot(M[0], M[2]), V = Math.hypot(M[1], M[3]);
                  this._cachedGetSinglePixelWidth = Math.max(N, V) / I;
                }
              }
              return this._cachedGetSinglePixelWidth;
            }
            getScaleForStroking() {
              if (this._cachedScaleForStroking[0] === -1) {
                const {
                  lineWidth: M
                } = this.current, {
                  a: I,
                  b: N,
                  c: V,
                  d: q
                } = this.ctx.getTransform();
                let H, ne;
                if (N === 0 && V === 0) {
                  const he = Math.abs(I), j = Math.abs(q);
                  if (he === j)
                    if (M === 0)
                      H = ne = 1 / he;
                    else {
                      const Fe = he * M;
                      H = ne = Fe < 1 ? 1 / Fe : 1;
                    }
                  else if (M === 0)
                    H = 1 / he, ne = 1 / j;
                  else {
                    const Fe = he * M, X = j * M;
                    H = Fe < 1 ? 1 / Fe : 1, ne = X < 1 ? 1 / X : 1;
                  }
                } else {
                  const he = Math.abs(I * q - N * V), j = Math.hypot(I, N), Fe = Math.hypot(V, q);
                  if (M === 0)
                    H = Fe / he, ne = j / he;
                  else {
                    const X = M * he;
                    H = Fe > X ? Fe / X : 1, ne = j > X ? j / X : 1;
                  }
                }
                this._cachedScaleForStroking[0] = H, this._cachedScaleForStroking[1] = ne;
              }
              return this._cachedScaleForStroking;
            }
            rescaleAndStroke(M) {
              const {
                ctx: I
              } = this, {
                lineWidth: N
              } = this.current, [V, q] = this.getScaleForStroking();
              if (I.lineWidth = N || 1, V === 1 && q === 1) {
                I.stroke();
                return;
              }
              const H = I.getLineDash();
              if (M && I.save(), I.scale(V, q), H.length > 0) {
                const ne = Math.max(V, q);
                I.setLineDash(H.map((he) => he / ne)), I.lineDashOffset /= ne;
              }
              I.stroke(), M && I.restore();
            }
            isContentVisible() {
              for (let M = this.markedContentStack.length - 1; M >= 0; M--)
                if (!this.markedContentStack[M].visible)
                  return !1;
              return !0;
            }
          };
          te = new WeakSet(), ai = function() {
            for (; this.stateStack.length || this.inSMaskMode; )
              this.restore();
            this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
          }, ae = new WeakSet(), si = function() {
            if (this.pageColors) {
              const M = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
              if (M !== "none") {
                const I = this.ctx.filter;
                this.ctx.filter = M, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = I;
              }
            }
          };
          let ie = U;
          e.CanvasGraphics = ie;
          for (const F in a.OPS)
            ie.prototype[F] !== void 0 && (ie.prototype[a.OPS[F]] = ie.prototype[F]);
        },
        /* 12 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.TilingPattern = e.PathType = void 0, e.getShadingPattern = x;
          var a = n(1), s = n(6);
          const o = {
            FILL: "Fill",
            STROKE: "Stroke",
            SHADING: "Shading"
          };
          e.PathType = o;
          function l(y, A) {
            if (!A)
              return;
            const b = A[2] - A[0], C = A[3] - A[1], T = new Path2D();
            T.rect(A[0], A[1], b, C), y.clip(T);
          }
          class c {
            constructor() {
              this.constructor === c && (0, a.unreachable)("Cannot initialize BaseShadingPattern.");
            }
            getPattern() {
              (0, a.unreachable)("Abstract method `getPattern` called.");
            }
          }
          class u extends c {
            constructor(A) {
              super(), this._type = A[1], this._bbox = A[2], this._colorStops = A[3], this._p0 = A[4], this._p1 = A[5], this._r0 = A[6], this._r1 = A[7], this.matrix = null;
            }
            _createGradient(A) {
              let b;
              this._type === "axial" ? b = A.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (b = A.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
              for (const C of this._colorStops)
                b.addColorStop(C[0], C[1]);
              return b;
            }
            getPattern(A, b, C, T) {
              let w;
              if (T === o.STROKE || T === o.FILL) {
                const R = b.current.getClippedPathBoundingBox(T, (0, s.getCurrentTransform)(A)) || [0, 0, 0, 0], O = Math.ceil(R[2] - R[0]) || 1, D = Math.ceil(R[3] - R[1]) || 1, k = b.cachedCanvases.getCanvas("pattern", O, D, !0), W = k.context;
                W.clearRect(0, 0, W.canvas.width, W.canvas.height), W.beginPath(), W.rect(0, 0, W.canvas.width, W.canvas.height), W.translate(-R[0], -R[1]), C = a.Util.transform(C, [1, 0, 0, 1, R[0], R[1]]), W.transform(...b.baseTransform), this.matrix && W.transform(...this.matrix), l(W, this._bbox), W.fillStyle = this._createGradient(W), W.fill(), w = A.createPattern(k.canvas, "no-repeat");
                const L = new DOMMatrix(C);
                w.setTransform(L);
              } else
                l(A, this._bbox), w = this._createGradient(A);
              return w;
            }
          }
          function d(y, A, b, C, T, w, R, O) {
            const D = A.coords, k = A.colors, W = y.data, L = y.width * 4;
            let z;
            D[b + 1] > D[C + 1] && (z = b, b = C, C = z, z = w, w = R, R = z), D[C + 1] > D[T + 1] && (z = C, C = T, T = z, z = R, R = O, O = z), D[b + 1] > D[C + 1] && (z = b, b = C, C = z, z = w, w = R, R = z);
            const P = (D[b] + A.offsetX) * A.scaleX, Q = (D[b + 1] + A.offsetY) * A.scaleY, Y = (D[C] + A.offsetX) * A.scaleX, ie = (D[C + 1] + A.offsetY) * A.scaleY, te = (D[T] + A.offsetX) * A.scaleX, Z = (D[T + 1] + A.offsetY) * A.scaleY;
            if (Q >= Z)
              return;
            const ae = k[w], G = k[w + 1], U = k[w + 2], F = k[R], M = k[R + 1], I = k[R + 2], N = k[O], V = k[O + 1], q = k[O + 2], H = Math.round(Q), ne = Math.round(Z);
            let he, j, Fe, X, ye, Ae, fe, _e;
            for (let Ie = H; Ie <= ne; Ie++) {
              if (Ie < ie) {
                const K = Ie < Q ? 0 : (Q - Ie) / (Q - ie);
                he = P - (P - Y) * K, j = ae - (ae - F) * K, Fe = G - (G - M) * K, X = U - (U - I) * K;
              } else {
                let K;
                Ie > Z ? K = 1 : ie === Z ? K = 0 : K = (ie - Ie) / (ie - Z), he = Y - (Y - te) * K, j = F - (F - N) * K, Fe = M - (M - V) * K, X = I - (I - q) * K;
              }
              let Be;
              Ie < Q ? Be = 0 : Ie > Z ? Be = 1 : Be = (Q - Ie) / (Q - Z), ye = P - (P - te) * Be, Ae = ae - (ae - N) * Be, fe = G - (G - V) * Be, _e = U - (U - q) * Be;
              const $e = Math.round(Math.min(he, ye)), Me = Math.round(Math.max(he, ye));
              let J = L * Ie + $e * 4;
              for (let K = $e; K <= Me; K++)
                Be = (he - K) / (he - ye), Be < 0 ? Be = 0 : Be > 1 && (Be = 1), W[J++] = j - (j - Ae) * Be | 0, W[J++] = Fe - (Fe - fe) * Be | 0, W[J++] = X - (X - _e) * Be | 0, W[J++] = 255;
            }
          }
          function f(y, A, b) {
            const C = A.coords, T = A.colors;
            let w, R;
            switch (A.type) {
              case "lattice":
                const O = A.verticesPerRow, D = Math.floor(C.length / O) - 1, k = O - 1;
                for (w = 0; w < D; w++) {
                  let W = w * O;
                  for (let L = 0; L < k; L++, W++)
                    d(y, b, C[W], C[W + 1], C[W + O], T[W], T[W + 1], T[W + O]), d(y, b, C[W + O + 1], C[W + 1], C[W + O], T[W + O + 1], T[W + 1], T[W + O]);
                }
                break;
              case "triangles":
                for (w = 0, R = C.length; w < R; w += 3)
                  d(y, b, C[w], C[w + 1], C[w + 2], T[w], T[w + 1], T[w + 2]);
                break;
              default:
                throw new Error("illegal figure");
            }
          }
          class h extends c {
            constructor(A) {
              super(), this._coords = A[2], this._colors = A[3], this._figures = A[4], this._bounds = A[5], this._bbox = A[7], this._background = A[8], this.matrix = null;
            }
            _createMeshCanvas(A, b, C) {
              const O = Math.floor(this._bounds[0]), D = Math.floor(this._bounds[1]), k = Math.ceil(this._bounds[2]) - O, W = Math.ceil(this._bounds[3]) - D, L = Math.min(Math.ceil(Math.abs(k * A[0] * 1.1)), 3e3), z = Math.min(Math.ceil(Math.abs(W * A[1] * 1.1)), 3e3), P = k / L, Q = W / z, Y = {
                coords: this._coords,
                colors: this._colors,
                offsetX: -O,
                offsetY: -D,
                scaleX: 1 / P,
                scaleY: 1 / Q
              }, ie = L + 2 * 2, te = z + 2 * 2, Z = C.getCanvas("mesh", ie, te, !1), ae = Z.context, G = ae.createImageData(L, z);
              if (b) {
                const F = G.data;
                for (let M = 0, I = F.length; M < I; M += 4)
                  F[M] = b[0], F[M + 1] = b[1], F[M + 2] = b[2], F[M + 3] = 255;
              }
              for (const F of this._figures)
                f(G, F, Y);
              return ae.putImageData(G, 2, 2), {
                canvas: Z.canvas,
                offsetX: O - 2 * P,
                offsetY: D - 2 * Q,
                scaleX: P,
                scaleY: Q
              };
            }
            getPattern(A, b, C, T) {
              l(A, this._bbox);
              let w;
              if (T === o.SHADING)
                w = a.Util.singularValueDecompose2dScale((0, s.getCurrentTransform)(A));
              else if (w = a.Util.singularValueDecompose2dScale(b.baseTransform), this.matrix) {
                const O = a.Util.singularValueDecompose2dScale(this.matrix);
                w = [w[0] * O[0], w[1] * O[1]];
              }
              const R = this._createMeshCanvas(w, T === o.SHADING ? null : this._background, b.cachedCanvases);
              return T !== o.SHADING && (A.setTransform(...b.baseTransform), this.matrix && A.transform(...this.matrix)), A.translate(R.offsetX, R.offsetY), A.scale(R.scaleX, R.scaleY), A.createPattern(R.canvas, "no-repeat");
            }
          }
          class g extends c {
            getPattern() {
              return "hotpink";
            }
          }
          function x(y) {
            switch (y[0]) {
              case "RadialAxial":
                return new u(y);
              case "Mesh":
                return new h(y);
              case "Dummy":
                return new g();
            }
            throw new Error(`Unknown IR type: ${y[0]}`);
          }
          const E = {
            COLORED: 1,
            UNCOLORED: 2
          }, v = class v {
            constructor(A, b, C, T, w) {
              this.operatorList = A[2], this.matrix = A[3] || [1, 0, 0, 1, 0, 0], this.bbox = A[4], this.xstep = A[5], this.ystep = A[6], this.paintType = A[7], this.tilingType = A[8], this.color = b, this.ctx = C, this.canvasGraphicsFactory = T, this.baseTransform = w;
            }
            createPatternCanvas(A) {
              const b = this.operatorList, C = this.bbox, T = this.xstep, w = this.ystep, R = this.paintType, O = this.tilingType, D = this.color, k = this.canvasGraphicsFactory;
              (0, a.info)("TilingType: " + O);
              const W = C[0], L = C[1], z = C[2], P = C[3], Q = a.Util.singularValueDecompose2dScale(this.matrix), Y = a.Util.singularValueDecompose2dScale(this.baseTransform), ie = [Q[0] * Y[0], Q[1] * Y[1]], te = this.getSizeAndScale(T, this.ctx.canvas.width, ie[0]), Z = this.getSizeAndScale(w, this.ctx.canvas.height, ie[1]), ae = A.cachedCanvases.getCanvas("pattern", te.size, Z.size, !0), G = ae.context, U = k.createCanvasGraphics(G);
              U.groupLevel = A.groupLevel, this.setFillAndStrokeStyleToContext(U, R, D);
              let F = W, M = L, I = z, N = P;
              return W < 0 && (F = 0, I += Math.abs(W)), L < 0 && (M = 0, N += Math.abs(L)), G.translate(-(te.scale * F), -(Z.scale * M)), U.transform(te.scale, 0, 0, Z.scale, 0, 0), G.save(), this.clipBbox(U, F, M, I, N), U.baseTransform = (0, s.getCurrentTransform)(U.ctx), U.executeOperatorList(b), U.endDrawing(), {
                canvas: ae.canvas,
                scaleX: te.scale,
                scaleY: Z.scale,
                offsetX: F,
                offsetY: M
              };
            }
            getSizeAndScale(A, b, C) {
              A = Math.abs(A);
              const T = Math.max(v.MAX_PATTERN_SIZE, b);
              let w = Math.ceil(A * C);
              return w >= T ? w = T : C = w / A, {
                scale: C,
                size: w
              };
            }
            clipBbox(A, b, C, T, w) {
              const R = T - b, O = w - C;
              A.ctx.rect(b, C, R, O), A.current.updateRectMinMax((0, s.getCurrentTransform)(A.ctx), [b, C, T, w]), A.clip(), A.endPath();
            }
            setFillAndStrokeStyleToContext(A, b, C) {
              const T = A.ctx, w = A.current;
              switch (b) {
                case E.COLORED:
                  const R = this.ctx;
                  T.fillStyle = R.fillStyle, T.strokeStyle = R.strokeStyle, w.fillColor = R.fillStyle, w.strokeColor = R.strokeStyle;
                  break;
                case E.UNCOLORED:
                  const O = a.Util.makeHexColor(C[0], C[1], C[2]);
                  T.fillStyle = O, T.strokeStyle = O, w.fillColor = O, w.strokeColor = O;
                  break;
                default:
                  throw new a.FormatError(`Unsupported paint type: ${b}`);
              }
            }
            getPattern(A, b, C, T) {
              let w = C;
              T !== o.SHADING && (w = a.Util.transform(w, b.baseTransform), this.matrix && (w = a.Util.transform(w, this.matrix)));
              const R = this.createPatternCanvas(b);
              let O = new DOMMatrix(w);
              O = O.translate(R.offsetX, R.offsetY), O = O.scale(1 / R.scaleX, 1 / R.scaleY);
              const D = A.createPattern(R.canvas, "repeat");
              return D.setTransform(O), D;
            }
          };
          Xt(v, "MAX_PATTERN_SIZE", 3e3);
          let m = v;
          e.TilingPattern = m;
        },
        /* 13 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.convertBlackAndWhiteToRGBA = o, e.convertToRGBA = s, e.grayToRGBA = c;
          var a = n(1);
          function s(u) {
            switch (u.kind) {
              case a.ImageKind.GRAYSCALE_1BPP:
                return o(u);
              case a.ImageKind.RGB_24BPP:
                return l(u);
            }
            return null;
          }
          function o({
            src: u,
            srcPos: d = 0,
            dest: f,
            width: h,
            height: g,
            nonBlackColor: x = 4294967295,
            inverseDecode: E = !1
          }) {
            const m = a.FeatureTest.isLittleEndian ? 4278190080 : 255, [v, y] = E ? [x, m] : [m, x], A = h >> 3, b = h & 7, C = u.length;
            f = new Uint32Array(f.buffer);
            let T = 0;
            for (let w = 0; w < g; w++) {
              for (const O = d + A; d < O; d++) {
                const D = d < C ? u[d] : 255;
                f[T++] = D & 128 ? y : v, f[T++] = D & 64 ? y : v, f[T++] = D & 32 ? y : v, f[T++] = D & 16 ? y : v, f[T++] = D & 8 ? y : v, f[T++] = D & 4 ? y : v, f[T++] = D & 2 ? y : v, f[T++] = D & 1 ? y : v;
              }
              if (b === 0)
                continue;
              const R = d < C ? u[d++] : 255;
              for (let O = 0; O < b; O++)
                f[T++] = R & 1 << 7 - O ? y : v;
            }
            return {
              srcPos: d,
              destPos: T
            };
          }
          function l({
            src: u,
            srcPos: d = 0,
            dest: f,
            destPos: h = 0,
            width: g,
            height: x
          }) {
            let E = 0;
            const m = u.length >> 2, v = new Uint32Array(u.buffer, d, m);
            if (a.FeatureTest.isLittleEndian) {
              for (; E < m - 2; E += 3, h += 4) {
                const y = v[E], A = v[E + 1], b = v[E + 2];
                f[h] = y | 4278190080, f[h + 1] = y >>> 24 | A << 8 | 4278190080, f[h + 2] = A >>> 16 | b << 16 | 4278190080, f[h + 3] = b >>> 8 | 4278190080;
              }
              for (let y = E * 4, A = u.length; y < A; y += 3)
                f[h++] = u[y] | u[y + 1] << 8 | u[y + 2] << 16 | 4278190080;
            } else {
              for (; E < m - 2; E += 3, h += 4) {
                const y = v[E], A = v[E + 1], b = v[E + 2];
                f[h] = y | 255, f[h + 1] = y << 24 | A >>> 8 | 255, f[h + 2] = A << 16 | b >>> 16 | 255, f[h + 3] = b << 8 | 255;
              }
              for (let y = E * 4, A = u.length; y < A; y += 3)
                f[h++] = u[y] << 24 | u[y + 1] << 16 | u[y + 2] << 8 | 255;
            }
            return {
              srcPos: d,
              destPos: h
            };
          }
          function c(u, d) {
            if (a.FeatureTest.isLittleEndian)
              for (let f = 0, h = u.length; f < h; f++)
                d[f] = u[f] * 65793 | 4278190080;
            else
              for (let f = 0, h = u.length; f < h; f++)
                d[f] = u[f] * 16843008 | 255;
          }
        },
        /* 14 */
        /***/
        (t, e) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.GlobalWorkerOptions = void 0;
          const n = /* @__PURE__ */ Object.create(null);
          e.GlobalWorkerOptions = n, n.workerPort = null, n.workerSrc = "";
        },
        /* 15 */
        /***/
        (t, e, n) => {
          var u, Ra, f, Ma, g, vr;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.MessageHandler = void 0;
          var a = n(1);
          const s = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, o = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function l(E) {
            switch (E instanceof Error || typeof E == "object" && E !== null || (0, a.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), E.name) {
              case "AbortException":
                return new a.AbortException(E.message);
              case "MissingPDFException":
                return new a.MissingPDFException(E.message);
              case "PasswordException":
                return new a.PasswordException(E.message, E.code);
              case "UnexpectedResponseException":
                return new a.UnexpectedResponseException(E.message, E.status);
              case "UnknownErrorException":
                return new a.UnknownErrorException(E.message, E.details);
              default:
                return new a.UnknownErrorException(E.message, E.toString());
            }
          }
          class c {
            constructor(m, v, y) {
              Ge(this, u);
              Ge(this, f);
              Ge(this, g);
              this.sourceName = m, this.targetName = v, this.comObj = y, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (A) => {
                const b = A.data;
                if (b.targetName !== this.sourceName)
                  return;
                if (b.stream) {
                  Ke(this, f, Ma).call(this, b);
                  return;
                }
                if (b.callback) {
                  const T = b.callbackId, w = this.callbackCapabilities[T];
                  if (!w)
                    throw new Error(`Cannot resolve callback ${T}`);
                  if (delete this.callbackCapabilities[T], b.callback === s.DATA)
                    w.resolve(b.data);
                  else if (b.callback === s.ERROR)
                    w.reject(l(b.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const C = this.actionHandler[b.action];
                if (!C)
                  throw new Error(`Unknown action from worker: ${b.action}`);
                if (b.callbackId) {
                  const T = this.sourceName, w = b.sourceName;
                  new Promise(function(R) {
                    R(C(b.data));
                  }).then(function(R) {
                    y.postMessage({
                      sourceName: T,
                      targetName: w,
                      callback: s.DATA,
                      callbackId: b.callbackId,
                      data: R
                    });
                  }, function(R) {
                    y.postMessage({
                      sourceName: T,
                      targetName: w,
                      callback: s.ERROR,
                      callbackId: b.callbackId,
                      reason: l(R)
                    });
                  });
                  return;
                }
                if (b.streamId) {
                  Ke(this, u, Ra).call(this, b);
                  return;
                }
                C(b.data);
              }, y.addEventListener("message", this._onComObjOnMessage);
            }
            on(m, v) {
              const y = this.actionHandler;
              if (y[m])
                throw new Error(`There is already an actionName called "${m}"`);
              y[m] = v;
            }
            send(m, v, y) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: m,
                data: v
              }, y);
            }
            sendWithPromise(m, v, y) {
              const A = this.callbackId++, b = new a.PromiseCapability();
              this.callbackCapabilities[A] = b;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: m,
                  callbackId: A,
                  data: v
                }, y);
              } catch (C) {
                b.reject(C);
              }
              return b.promise;
            }
            sendWithStream(m, v, y, A) {
              const b = this.streamId++, C = this.sourceName, T = this.targetName, w = this.comObj;
              return new ReadableStream({
                start: (R) => {
                  const O = new a.PromiseCapability();
                  return this.streamControllers[b] = {
                    controller: R,
                    startCall: O,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, w.postMessage({
                    sourceName: C,
                    targetName: T,
                    action: m,
                    streamId: b,
                    data: v,
                    desiredSize: R.desiredSize
                  }, A), O.promise;
                },
                pull: (R) => {
                  const O = new a.PromiseCapability();
                  return this.streamControllers[b].pullCall = O, w.postMessage({
                    sourceName: C,
                    targetName: T,
                    stream: o.PULL,
                    streamId: b,
                    desiredSize: R.desiredSize
                  }), O.promise;
                },
                cancel: (R) => {
                  (0, a.assert)(R instanceof Error, "cancel must have a valid reason");
                  const O = new a.PromiseCapability();
                  return this.streamControllers[b].cancelCall = O, this.streamControllers[b].isClosed = !0, w.postMessage({
                    sourceName: C,
                    targetName: T,
                    stream: o.CANCEL,
                    streamId: b,
                    reason: l(R)
                  }), O.promise;
                }
              }, y);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          u = new WeakSet(), Ra = function(m) {
            const v = m.streamId, y = this.sourceName, A = m.sourceName, b = this.comObj, C = this, T = this.actionHandler[m.action], w = {
              enqueue(R, O = 1, D) {
                if (this.isCancelled)
                  return;
                const k = this.desiredSize;
                this.desiredSize -= O, k > 0 && this.desiredSize <= 0 && (this.sinkCapability = new a.PromiseCapability(), this.ready = this.sinkCapability.promise), b.postMessage({
                  sourceName: y,
                  targetName: A,
                  stream: o.ENQUEUE,
                  streamId: v,
                  chunk: R
                }, D);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, b.postMessage({
                  sourceName: y,
                  targetName: A,
                  stream: o.CLOSE,
                  streamId: v
                }), delete C.streamSinks[v]);
              },
              error(R) {
                (0, a.assert)(R instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, b.postMessage({
                  sourceName: y,
                  targetName: A,
                  stream: o.ERROR,
                  streamId: v,
                  reason: l(R)
                }));
              },
              sinkCapability: new a.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: m.desiredSize,
              ready: null
            };
            w.sinkCapability.resolve(), w.ready = w.sinkCapability.promise, this.streamSinks[v] = w, new Promise(function(R) {
              R(T(m.data, w));
            }).then(function() {
              b.postMessage({
                sourceName: y,
                targetName: A,
                stream: o.START_COMPLETE,
                streamId: v,
                success: !0
              });
            }, function(R) {
              b.postMessage({
                sourceName: y,
                targetName: A,
                stream: o.START_COMPLETE,
                streamId: v,
                reason: l(R)
              });
            });
          }, f = new WeakSet(), Ma = function(m) {
            const v = m.streamId, y = this.sourceName, A = m.sourceName, b = this.comObj, C = this.streamControllers[v], T = this.streamSinks[v];
            switch (m.stream) {
              case o.START_COMPLETE:
                m.success ? C.startCall.resolve() : C.startCall.reject(l(m.reason));
                break;
              case o.PULL_COMPLETE:
                m.success ? C.pullCall.resolve() : C.pullCall.reject(l(m.reason));
                break;
              case o.PULL:
                if (!T) {
                  b.postMessage({
                    sourceName: y,
                    targetName: A,
                    stream: o.PULL_COMPLETE,
                    streamId: v,
                    success: !0
                  });
                  break;
                }
                T.desiredSize <= 0 && m.desiredSize > 0 && T.sinkCapability.resolve(), T.desiredSize = m.desiredSize, new Promise(function(w) {
                  var R;
                  w((R = T.onPull) == null ? void 0 : R.call(T));
                }).then(function() {
                  b.postMessage({
                    sourceName: y,
                    targetName: A,
                    stream: o.PULL_COMPLETE,
                    streamId: v,
                    success: !0
                  });
                }, function(w) {
                  b.postMessage({
                    sourceName: y,
                    targetName: A,
                    stream: o.PULL_COMPLETE,
                    streamId: v,
                    reason: l(w)
                  });
                });
                break;
              case o.ENQUEUE:
                if ((0, a.assert)(C, "enqueue should have stream controller"), C.isClosed)
                  break;
                C.controller.enqueue(m.chunk);
                break;
              case o.CLOSE:
                if ((0, a.assert)(C, "close should have stream controller"), C.isClosed)
                  break;
                C.isClosed = !0, C.controller.close(), Ke(this, g, vr).call(this, C, v);
                break;
              case o.ERROR:
                (0, a.assert)(C, "error should have stream controller"), C.controller.error(l(m.reason)), Ke(this, g, vr).call(this, C, v);
                break;
              case o.CANCEL_COMPLETE:
                m.success ? C.cancelCall.resolve() : C.cancelCall.reject(l(m.reason)), Ke(this, g, vr).call(this, C, v);
                break;
              case o.CANCEL:
                if (!T)
                  break;
                new Promise(function(w) {
                  var R;
                  w((R = T.onCancel) == null ? void 0 : R.call(T, l(m.reason)));
                }).then(function() {
                  b.postMessage({
                    sourceName: y,
                    targetName: A,
                    stream: o.CANCEL_COMPLETE,
                    streamId: v,
                    success: !0
                  });
                }, function(w) {
                  b.postMessage({
                    sourceName: y,
                    targetName: A,
                    stream: o.CANCEL_COMPLETE,
                    streamId: v,
                    reason: l(w)
                  });
                }), T.sinkCapability.reject(l(m.reason)), T.isCancelled = !0, delete this.streamSinks[v];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, g = new WeakSet(), vr = async function(m, v) {
            var y, A, b;
            await Promise.allSettled([(y = m.startCall) == null ? void 0 : y.promise, (A = m.pullCall) == null ? void 0 : A.promise, (b = m.cancelCall) == null ? void 0 : b.promise]), delete this.streamControllers[v];
          }, e.MessageHandler = c;
        },
        /* 16 */
        /***/
        (t, e, n) => {
          var o, l;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.Metadata = void 0;
          var a = n(1);
          class s {
            constructor({
              parsedData: u,
              rawData: d
            }) {
              Ge(this, o, void 0);
              Ge(this, l, void 0);
              at(this, o, u), at(this, l, d);
            }
            getRaw() {
              return se(this, l);
            }
            get(u) {
              return se(this, o).get(u) ?? null;
            }
            getAll() {
              return (0, a.objectFromMap)(se(this, o));
            }
            has(u) {
              return se(this, o).has(u);
            }
          }
          o = new WeakMap(), l = new WeakMap(), e.Metadata = s;
        },
        /* 17 */
        /***/
        (t, e, n) => {
          var u, d, f, h, g, x, oi;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.OptionalContentConfig = void 0;
          var a = n(1), s = n(8);
          const o = Symbol("INTERNAL");
          class l {
            constructor(v, y) {
              Ge(this, u, !0);
              this.name = v, this.intent = y;
            }
            get visible() {
              return se(this, u);
            }
            _setVisible(v, y) {
              v !== o && (0, a.unreachable)("Internal method `_setVisible` called."), at(this, u, y);
            }
          }
          u = new WeakMap();
          class c {
            constructor(v) {
              Ge(this, x);
              Ge(this, d, null);
              Ge(this, f, /* @__PURE__ */ new Map());
              Ge(this, h, null);
              Ge(this, g, null);
              if (this.name = null, this.creator = null, v !== null) {
                this.name = v.name, this.creator = v.creator, at(this, g, v.order);
                for (const y of v.groups)
                  se(this, f).set(y.id, new l(y.name, y.intent));
                if (v.baseState === "OFF")
                  for (const y of se(this, f).values())
                    y._setVisible(o, !1);
                for (const y of v.on)
                  se(this, f).get(y)._setVisible(o, !0);
                for (const y of v.off)
                  se(this, f).get(y)._setVisible(o, !1);
                at(this, h, this.getHash());
              }
            }
            isVisible(v) {
              if (se(this, f).size === 0)
                return !0;
              if (!v)
                return (0, a.warn)("Optional content group not defined."), !0;
              if (v.type === "OCG")
                return se(this, f).has(v.id) ? se(this, f).get(v.id).visible : ((0, a.warn)(`Optional content group not found: ${v.id}`), !0);
              if (v.type === "OCMD") {
                if (v.expression)
                  return Ke(this, x, oi).call(this, v.expression);
                if (!v.policy || v.policy === "AnyOn") {
                  for (const y of v.ids) {
                    if (!se(this, f).has(y))
                      return (0, a.warn)(`Optional content group not found: ${y}`), !0;
                    if (se(this, f).get(y).visible)
                      return !0;
                  }
                  return !1;
                } else if (v.policy === "AllOn") {
                  for (const y of v.ids) {
                    if (!se(this, f).has(y))
                      return (0, a.warn)(`Optional content group not found: ${y}`), !0;
                    if (!se(this, f).get(y).visible)
                      return !1;
                  }
                  return !0;
                } else if (v.policy === "AnyOff") {
                  for (const y of v.ids) {
                    if (!se(this, f).has(y))
                      return (0, a.warn)(`Optional content group not found: ${y}`), !0;
                    if (!se(this, f).get(y).visible)
                      return !0;
                  }
                  return !1;
                } else if (v.policy === "AllOff") {
                  for (const y of v.ids) {
                    if (!se(this, f).has(y))
                      return (0, a.warn)(`Optional content group not found: ${y}`), !0;
                    if (se(this, f).get(y).visible)
                      return !1;
                  }
                  return !0;
                }
                return (0, a.warn)(`Unknown optional content policy ${v.policy}.`), !0;
              }
              return (0, a.warn)(`Unknown group type ${v.type}.`), !0;
            }
            setVisibility(v, y = !0) {
              if (!se(this, f).has(v)) {
                (0, a.warn)(`Optional content group not found: ${v}`);
                return;
              }
              se(this, f).get(v)._setVisible(o, !!y), at(this, d, null);
            }
            get hasInitialVisibility() {
              return se(this, h) === null || this.getHash() === se(this, h);
            }
            getOrder() {
              return se(this, f).size ? se(this, g) ? se(this, g).slice() : [...se(this, f).keys()] : null;
            }
            getGroups() {
              return se(this, f).size > 0 ? (0, a.objectFromMap)(se(this, f)) : null;
            }
            getGroup(v) {
              return se(this, f).get(v) || null;
            }
            getHash() {
              if (se(this, d) !== null)
                return se(this, d);
              const v = new s.MurmurHash3_64();
              for (const [y, A] of se(this, f))
                v.update(`${y}:${A.visible}`);
              return at(this, d, v.hexdigest());
            }
          }
          d = new WeakMap(), f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakSet(), oi = function(v) {
            const y = v.length;
            if (y < 2)
              return !0;
            const A = v[0];
            for (let b = 1; b < y; b++) {
              const C = v[b];
              let T;
              if (Array.isArray(C))
                T = Ke(this, x, oi).call(this, C);
              else if (se(this, f).has(C))
                T = se(this, f).get(C).visible;
              else
                return (0, a.warn)(`Optional content group not found: ${C}`), !0;
              switch (A) {
                case "And":
                  if (!T)
                    return !1;
                  break;
                case "Or":
                  if (T)
                    return !0;
                  break;
                case "Not":
                  return !T;
                default:
                  return !0;
              }
            }
            return A === "And";
          }, e.OptionalContentConfig = c;
        },
        /* 18 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.PDFDataTransportStream = void 0;
          var a = n(1), s = n(6);
          class o {
            constructor({
              length: d,
              initialData: f,
              progressiveDone: h = !1,
              contentDispositionFilename: g = null,
              disableRange: x = !1,
              disableStream: E = !1
            }, m) {
              if ((0, a.assert)(m, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = h, this._contentDispositionFilename = g, (f == null ? void 0 : f.length) > 0) {
                const v = f instanceof Uint8Array && f.byteLength === f.buffer.byteLength ? f.buffer : new Uint8Array(f).buffer;
                this._queuedChunks.push(v);
              }
              this._pdfDataRangeTransport = m, this._isStreamingSupported = !E, this._isRangeSupported = !x, this._contentLength = d, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((v, y) => {
                this._onReceiveData({
                  begin: v,
                  chunk: y
                });
              }), this._pdfDataRangeTransport.addProgressListener((v, y) => {
                this._onProgress({
                  loaded: v,
                  total: y
                });
              }), this._pdfDataRangeTransport.addProgressiveReadListener((v) => {
                this._onReceiveData({
                  chunk: v
                });
              }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                this._onProgressiveDone();
              }), this._pdfDataRangeTransport.transportReady();
            }
            _onReceiveData({
              begin: d,
              chunk: f
            }) {
              const h = f instanceof Uint8Array && f.byteLength === f.buffer.byteLength ? f.buffer : new Uint8Array(f).buffer;
              if (d === void 0)
                this._fullRequestReader ? this._fullRequestReader._enqueue(h) : this._queuedChunks.push(h);
              else {
                const g = this._rangeReaders.some(function(x) {
                  return x._begin !== d ? !1 : (x._enqueue(h), !0);
                });
                (0, a.assert)(g, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
              }
            }
            get _progressiveDataLength() {
              var d;
              return ((d = this._fullRequestReader) == null ? void 0 : d._loaded) ?? 0;
            }
            _onProgress(d) {
              var f, h, g, x;
              d.total === void 0 ? (h = (f = this._rangeReaders[0]) == null ? void 0 : f.onProgress) == null || h.call(f, {
                loaded: d.loaded
              }) : (x = (g = this._fullRequestReader) == null ? void 0 : g.onProgress) == null || x.call(g, {
                loaded: d.loaded,
                total: d.total
              });
            }
            _onProgressiveDone() {
              var d;
              (d = this._fullRequestReader) == null || d.progressiveDone(), this._progressiveDone = !0;
            }
            _removeRangeReader(d) {
              const f = this._rangeReaders.indexOf(d);
              f >= 0 && this._rangeReaders.splice(f, 1);
            }
            getFullReader() {
              (0, a.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
              const d = this._queuedChunks;
              return this._queuedChunks = null, new l(this, d, this._progressiveDone, this._contentDispositionFilename);
            }
            getRangeReader(d, f) {
              if (f <= this._progressiveDataLength)
                return null;
              const h = new c(this, d, f);
              return this._pdfDataRangeTransport.requestDataRange(d, f), this._rangeReaders.push(h), h;
            }
            cancelAllRequests(d) {
              var f;
              (f = this._fullRequestReader) == null || f.cancel(d);
              for (const h of this._rangeReaders.slice(0))
                h.cancel(d);
              this._pdfDataRangeTransport.abort();
            }
          }
          e.PDFDataTransportStream = o;
          class l {
            constructor(d, f, h = !1, g = null) {
              this._stream = d, this._done = h || !1, this._filename = (0, s.isPdfFile)(g) ? g : null, this._queuedChunks = f || [], this._loaded = 0;
              for (const x of this._queuedChunks)
                this._loaded += x.byteLength;
              this._requests = [], this._headersReady = Promise.resolve(), d._fullRequestReader = this, this.onProgress = null;
            }
            _enqueue(d) {
              this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                value: d,
                done: !1
              }) : this._queuedChunks.push(d), this._loaded += d.byteLength);
            }
            get headersReady() {
              return this._headersReady;
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._stream._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._stream._isStreamingSupported;
            }
            get contentLength() {
              return this._stream._contentLength;
            }
            async read() {
              if (this._queuedChunks.length > 0)
                return {
                  value: this._queuedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const d = new a.PromiseCapability();
              return this._requests.push(d), d.promise;
            }
            cancel(d) {
              this._done = !0;
              for (const f of this._requests)
                f.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0;
            }
            progressiveDone() {
              this._done || (this._done = !0);
            }
          }
          class c {
            constructor(d, f, h) {
              this._stream = d, this._begin = f, this._end = h, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
            }
            _enqueue(d) {
              if (!this._done) {
                if (this._requests.length === 0)
                  this._queuedChunk = d;
                else {
                  this._requests.shift().resolve({
                    value: d,
                    done: !1
                  });
                  for (const h of this._requests)
                    h.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
                this._done = !0, this._stream._removeRangeReader(this);
              }
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._queuedChunk) {
                const f = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: f,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const d = new a.PromiseCapability();
              return this._requests.push(d), d.promise;
            }
            cancel(d) {
              this._done = !0;
              for (const f of this._requests)
                f.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._stream._removeRangeReader(this);
            }
          }
        },
        /* 19 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.PDFFetchStream = void 0;
          var a = n(1), s = n(20);
          function o(h, g, x) {
            return {
              method: "GET",
              headers: h,
              signal: x.signal,
              mode: "cors",
              credentials: g ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function l(h) {
            const g = new Headers();
            for (const x in h) {
              const E = h[x];
              E !== void 0 && g.append(x, E);
            }
            return g;
          }
          function c(h) {
            return h instanceof Uint8Array ? h.buffer : h instanceof ArrayBuffer ? h : ((0, a.warn)(`getArrayBuffer - unexpected data format: ${h}`), new Uint8Array(h).buffer);
          }
          class u {
            constructor(g) {
              this.source = g, this.isHttp = /^https?:/i.test(g.url), this.httpHeaders = this.isHttp && g.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var g;
              return ((g = this._fullRequestReader) == null ? void 0 : g._loaded) ?? 0;
            }
            getFullReader() {
              return (0, a.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new d(this), this._fullRequestReader;
            }
            getRangeReader(g, x) {
              if (x <= this._progressiveDataLength)
                return null;
              const E = new f(this, g, x);
              return this._rangeRequestReaders.push(E), E;
            }
            cancelAllRequests(g) {
              var x;
              (x = this._fullRequestReader) == null || x.cancel(g);
              for (const E of this._rangeRequestReaders.slice(0))
                E.cancel(g);
            }
          }
          e.PDFFetchStream = u;
          class d {
            constructor(g) {
              this._stream = g, this._reader = null, this._loaded = 0, this._filename = null;
              const x = g.source;
              this._withCredentials = x.withCredentials || !1, this._contentLength = x.length, this._headersCapability = new a.PromiseCapability(), this._disableRange = x.disableRange || !1, this._rangeChunkSize = x.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !x.disableStream, this._isRangeSupported = !x.disableRange, this._headers = l(this._stream.httpHeaders);
              const E = x.url;
              fetch(E, o(this._headers, this._withCredentials, this._abortController)).then((m) => {
                if (!(0, s.validateResponseStatus)(m.status))
                  throw (0, s.createResponseStatusError)(m.status, E);
                this._reader = m.body.getReader(), this._headersCapability.resolve();
                const v = (b) => m.headers.get(b), {
                  allowRangeRequests: y,
                  suggestedLength: A
                } = (0, s.validateRangeRequestCapabilities)({
                  getResponseHeader: v,
                  isHttp: this._stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = y, this._contentLength = A || this._contentLength, this._filename = (0, s.extractFilenameFromHeader)(v), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new a.AbortException("Streaming is disabled."));
              }).catch(this._headersCapability.reject), this.onProgress = null;
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var E;
              await this._headersCapability.promise;
              const {
                value: g,
                done: x
              } = await this._reader.read();
              return x ? {
                value: g,
                done: x
              } : (this._loaded += g.byteLength, (E = this.onProgress) == null || E.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: c(g),
                done: !1
              });
            }
            cancel(g) {
              var x;
              (x = this._reader) == null || x.cancel(g), this._abortController.abort();
            }
          }
          class f {
            constructor(g, x, E) {
              this._stream = g, this._reader = null, this._loaded = 0;
              const m = g.source;
              this._withCredentials = m.withCredentials || !1, this._readCapability = new a.PromiseCapability(), this._isStreamingSupported = !m.disableStream, this._abortController = new AbortController(), this._headers = l(this._stream.httpHeaders), this._headers.append("Range", `bytes=${x}-${E - 1}`);
              const v = m.url;
              fetch(v, o(this._headers, this._withCredentials, this._abortController)).then((y) => {
                if (!(0, s.validateResponseStatus)(y.status))
                  throw (0, s.createResponseStatusError)(y.status, v);
                this._readCapability.resolve(), this._reader = y.body.getReader();
              }).catch(this._readCapability.reject), this.onProgress = null;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var E;
              await this._readCapability.promise;
              const {
                value: g,
                done: x
              } = await this._reader.read();
              return x ? {
                value: g,
                done: x
              } : (this._loaded += g.byteLength, (E = this.onProgress) == null || E.call(this, {
                loaded: this._loaded
              }), {
                value: c(g),
                done: !1
              });
            }
            cancel(g) {
              var x;
              (x = this._reader) == null || x.cancel(g), this._abortController.abort();
            }
          }
        },
        /* 20 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.createResponseStatusError = u, e.extractFilenameFromHeader = c, e.validateRangeRequestCapabilities = l, e.validateResponseStatus = d;
          var a = n(1), s = n(21), o = n(6);
          function l({
            getResponseHeader: f,
            isHttp: h,
            rangeChunkSize: g,
            disableRange: x
          }) {
            const E = {
              allowRangeRequests: !1,
              suggestedLength: void 0
            }, m = parseInt(f("Content-Length"), 10);
            return !Number.isInteger(m) || (E.suggestedLength = m, m <= 2 * g) || x || !h || f("Accept-Ranges") !== "bytes" || (f("Content-Encoding") || "identity") !== "identity" || (E.allowRangeRequests = !0), E;
          }
          function c(f) {
            const h = f("Content-Disposition");
            if (h) {
              let g = (0, s.getFilenameFromContentDispositionHeader)(h);
              if (g.includes("%"))
                try {
                  g = decodeURIComponent(g);
                } catch {
                }
              if ((0, o.isPdfFile)(g))
                return g;
            }
            return null;
          }
          function u(f, h) {
            return f === 404 || f === 0 && h.startsWith("file:") ? new a.MissingPDFException('Missing PDF "' + h + '".') : new a.UnexpectedResponseException(`Unexpected server response (${f}) while retrieving PDF "${h}".`, f);
          }
          function d(f) {
            return f === 200 || f === 206;
          }
        },
        /* 21 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.getFilenameFromContentDispositionHeader = s;
          var a = n(1);
          function s(o) {
            let l = !0, c = u("filename\\*", "i").exec(o);
            if (c) {
              c = c[1];
              let m = g(c);
              return m = unescape(m), m = x(m), m = E(m), f(m);
            }
            if (c = h(o), c) {
              const m = E(c);
              return f(m);
            }
            if (c = u("filename", "i").exec(o), c) {
              c = c[1];
              let m = g(c);
              return m = E(m), f(m);
            }
            function u(m, v) {
              return new RegExp("(?:^|;)\\s*" + m + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', v);
            }
            function d(m, v) {
              if (m) {
                if (!/^[\x00-\xFF]+$/.test(v))
                  return v;
                try {
                  const y = new TextDecoder(m, {
                    fatal: !0
                  }), A = (0, a.stringToBytes)(v);
                  v = y.decode(A), l = !1;
                } catch {
                }
              }
              return v;
            }
            function f(m) {
              return l && /[\x80-\xff]/.test(m) && (m = d("utf-8", m), l && (m = d("iso-8859-1", m))), m;
            }
            function h(m) {
              const v = [];
              let y;
              const A = u("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              for (; (y = A.exec(m)) !== null; ) {
                let [, C, T, w] = y;
                if (C = parseInt(C, 10), C in v) {
                  if (C === 0)
                    break;
                  continue;
                }
                v[C] = [T, w];
              }
              const b = [];
              for (let C = 0; C < v.length && C in v; ++C) {
                let [T, w] = v[C];
                w = g(w), T && (w = unescape(w), C === 0 && (w = x(w))), b.push(w);
              }
              return b.join("");
            }
            function g(m) {
              if (m.startsWith('"')) {
                const v = m.slice(1).split('\\"');
                for (let y = 0; y < v.length; ++y) {
                  const A = v[y].indexOf('"');
                  A !== -1 && (v[y] = v[y].slice(0, A), v.length = y + 1), v[y] = v[y].replaceAll(/\\(.)/g, "$1");
                }
                m = v.join('"');
              }
              return m;
            }
            function x(m) {
              const v = m.indexOf("'");
              if (v === -1)
                return m;
              const y = m.slice(0, v), b = m.slice(v + 1).replace(/^[^']*'/, "");
              return d(y, b);
            }
            function E(m) {
              return !m.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(m) ? m : m.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(v, y, A, b) {
                if (A === "q" || A === "Q")
                  return b = b.replaceAll("_", " "), b = b.replaceAll(/=([0-9a-fA-F]{2})/g, function(C, T) {
                    return String.fromCharCode(parseInt(T, 16));
                  }), d(y, b);
                try {
                  b = atob(b);
                } catch {
                }
                return d(y, b);
              });
            }
            return "";
          }
        },
        /* 22 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.PDFNetworkStream = void 0;
          var a = n(1), s = n(20);
          const o = 200, l = 206;
          function c(g) {
            const x = g.response;
            return typeof x != "string" ? x : (0, a.stringToBytes)(x).buffer;
          }
          class u {
            constructor(x, E = {}) {
              this.url = x, this.isHttp = /^https?:/i.test(x), this.httpHeaders = this.isHttp && E.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = E.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            requestRange(x, E, m) {
              const v = {
                begin: x,
                end: E
              };
              for (const y in m)
                v[y] = m[y];
              return this.request(v);
            }
            requestFull(x) {
              return this.request(x);
            }
            request(x) {
              const E = new XMLHttpRequest(), m = this.currXhrId++, v = this.pendingRequests[m] = {
                xhr: E
              };
              E.open("GET", this.url), E.withCredentials = this.withCredentials;
              for (const y in this.httpHeaders) {
                const A = this.httpHeaders[y];
                A !== void 0 && E.setRequestHeader(y, A);
              }
              return this.isHttp && "begin" in x && "end" in x ? (E.setRequestHeader("Range", `bytes=${x.begin}-${x.end - 1}`), v.expectedStatus = l) : v.expectedStatus = o, E.responseType = "arraybuffer", x.onError && (E.onerror = function(y) {
                x.onError(E.status);
              }), E.onreadystatechange = this.onStateChange.bind(this, m), E.onprogress = this.onProgress.bind(this, m), v.onHeadersReceived = x.onHeadersReceived, v.onDone = x.onDone, v.onError = x.onError, v.onProgress = x.onProgress, E.send(null), m;
            }
            onProgress(x, E) {
              var v;
              const m = this.pendingRequests[x];
              m && ((v = m.onProgress) == null || v.call(m, E));
            }
            onStateChange(x, E) {
              var C, T, w;
              const m = this.pendingRequests[x];
              if (!m)
                return;
              const v = m.xhr;
              if (v.readyState >= 2 && m.onHeadersReceived && (m.onHeadersReceived(), delete m.onHeadersReceived), v.readyState !== 4 || !(x in this.pendingRequests))
                return;
              if (delete this.pendingRequests[x], v.status === 0 && this.isHttp) {
                (C = m.onError) == null || C.call(m, v.status);
                return;
              }
              const y = v.status || o;
              if (!(y === o && m.expectedStatus === l) && y !== m.expectedStatus) {
                (T = m.onError) == null || T.call(m, v.status);
                return;
              }
              const b = c(v);
              if (y === l) {
                const R = v.getResponseHeader("Content-Range"), O = /bytes (\d+)-(\d+)\/(\d+)/.exec(R);
                m.onDone({
                  begin: parseInt(O[1], 10),
                  chunk: b
                });
              } else
                b ? m.onDone({
                  begin: 0,
                  chunk: b
                }) : (w = m.onError) == null || w.call(m, v.status);
            }
            getRequestXhr(x) {
              return this.pendingRequests[x].xhr;
            }
            isPendingRequest(x) {
              return x in this.pendingRequests;
            }
            abortRequest(x) {
              const E = this.pendingRequests[x].xhr;
              delete this.pendingRequests[x], E.abort();
            }
          }
          class d {
            constructor(x) {
              this._source = x, this._manager = new u(x.url, {
                httpHeaders: x.httpHeaders,
                withCredentials: x.withCredentials
              }), this._rangeChunkSize = x.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            _onRangeRequestReaderClosed(x) {
              const E = this._rangeRequestReaders.indexOf(x);
              E >= 0 && this._rangeRequestReaders.splice(E, 1);
            }
            getFullReader() {
              return (0, a.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new f(this._manager, this._source), this._fullRequestReader;
            }
            getRangeReader(x, E) {
              const m = new h(this._manager, x, E);
              return m.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(m), m;
            }
            cancelAllRequests(x) {
              var E;
              (E = this._fullRequestReader) == null || E.cancel(x);
              for (const m of this._rangeRequestReaders.slice(0))
                m.cancel(x);
            }
          }
          e.PDFNetworkStream = d;
          class f {
            constructor(x, E) {
              this._manager = x;
              const m = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = E.url, this._fullRequestId = x.requestFull(m), this._headersReceivedCapability = new a.PromiseCapability(), this._disableRange = E.disableRange || !1, this._contentLength = E.length, this._rangeChunkSize = E.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
            }
            _onHeadersReceived() {
              const x = this._fullRequestId, E = this._manager.getRequestXhr(x), m = (A) => E.getResponseHeader(A), {
                allowRangeRequests: v,
                suggestedLength: y
              } = (0, s.validateRangeRequestCapabilities)({
                getResponseHeader: m,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              });
              v && (this._isRangeSupported = !0), this._contentLength = y || this._contentLength, this._filename = (0, s.extractFilenameFromHeader)(m), this._isRangeSupported && this._manager.abortRequest(x), this._headersReceivedCapability.resolve();
            }
            _onDone(x) {
              if (x && (this._requests.length > 0 ? this._requests.shift().resolve({
                value: x.chunk,
                done: !1
              }) : this._cachedChunks.push(x.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                for (const E of this._requests)
                  E.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
            }
            _onError(x) {
              this._storedError = (0, s.createResponseStatusError)(x, this._url), this._headersReceivedCapability.reject(this._storedError);
              for (const E of this._requests)
                E.reject(this._storedError);
              this._requests.length = 0, this._cachedChunks.length = 0;
            }
            _onProgress(x) {
              var E;
              (E = this.onProgress) == null || E.call(this, {
                loaded: x.loaded,
                total: x.lengthComputable ? x.total : this._contentLength
              });
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get contentLength() {
              return this._contentLength;
            }
            get headersReady() {
              return this._headersReceivedCapability.promise;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._cachedChunks.length > 0)
                return {
                  value: this._cachedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const x = new a.PromiseCapability();
              return this._requests.push(x), x.promise;
            }
            cancel(x) {
              this._done = !0, this._headersReceivedCapability.reject(x);
              for (const E of this._requests)
                E.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
            }
          }
          class h {
            constructor(x, E, m) {
              this._manager = x;
              const v = {
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = x.url, this._requestId = x.requestRange(E, m, v), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
            }
            _close() {
              var x;
              (x = this.onClosed) == null || x.call(this, this);
            }
            _onDone(x) {
              const E = x.chunk;
              this._requests.length > 0 ? this._requests.shift().resolve({
                value: E,
                done: !1
              }) : this._queuedChunk = E, this._done = !0;
              for (const m of this._requests)
                m.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._close();
            }
            _onError(x) {
              this._storedError = (0, s.createResponseStatusError)(x, this._url);
              for (const E of this._requests)
                E.reject(this._storedError);
              this._requests.length = 0, this._queuedChunk = null;
            }
            _onProgress(x) {
              var E;
              this.isStreamingSupported || (E = this.onProgress) == null || E.call(this, {
                loaded: x.loaded
              });
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._queuedChunk !== null) {
                const E = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: E,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const x = new a.PromiseCapability();
              return this._requests.push(x), x.promise;
            }
            cancel(x) {
              this._done = !0;
              for (const E of this._requests)
                E.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
            }
          }
        },
        /* 23 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.PDFNodeStream = void 0;
          var a = n(1), s = n(20);
          const o = /^file:\/\/\/[a-zA-Z]:\//;
          function l(m) {
            const v = require$$0$1, y = v.parse(m);
            return y.protocol === "file:" || y.host ? y : /^[a-z]:[/\\]/i.test(m) ? v.parse(`file:///${m}`) : (y.host || (y.protocol = "file:"), y);
          }
          class c {
            constructor(v) {
              this.source = v, this.url = l(v.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && v.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var v;
              return ((v = this._fullRequestReader) == null ? void 0 : v._loaded) ?? 0;
            }
            getFullReader() {
              return (0, a.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new x(this) : new h(this), this._fullRequestReader;
            }
            getRangeReader(v, y) {
              if (y <= this._progressiveDataLength)
                return null;
              const A = this.isFsUrl ? new E(this, v, y) : new g(this, v, y);
              return this._rangeRequestReaders.push(A), A;
            }
            cancelAllRequests(v) {
              var y;
              (y = this._fullRequestReader) == null || y.cancel(v);
              for (const A of this._rangeRequestReaders.slice(0))
                A.cancel(v);
            }
          }
          e.PDFNodeStream = c;
          class u {
            constructor(v) {
              this._url = v.url, this._done = !1, this._storedError = null, this.onProgress = null;
              const y = v.source;
              this._contentLength = y.length, this._loaded = 0, this._filename = null, this._disableRange = y.disableRange || !1, this._rangeChunkSize = y.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !y.disableStream, this._isRangeSupported = !y.disableRange, this._readableStream = null, this._readCapability = new a.PromiseCapability(), this._headersCapability = new a.PromiseCapability();
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var A;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const v = this._readableStream.read();
              return v === null ? (this._readCapability = new a.PromiseCapability(), this.read()) : (this._loaded += v.length, (A = this.onProgress) == null || A.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: new Uint8Array(v).buffer,
                done: !1
              });
            }
            cancel(v) {
              if (!this._readableStream) {
                this._error(v);
                return;
              }
              this._readableStream.destroy(v);
            }
            _error(v) {
              this._storedError = v, this._readCapability.resolve();
            }
            _setReadableStream(v) {
              this._readableStream = v, v.on("readable", () => {
                this._readCapability.resolve();
              }), v.on("end", () => {
                v.destroy(), this._done = !0, this._readCapability.resolve();
              }), v.on("error", (y) => {
                this._error(y);
              }), !this._isStreamingSupported && this._isRangeSupported && this._error(new a.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          class d {
            constructor(v) {
              this._url = v.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = new a.PromiseCapability();
              const y = v.source;
              this._isStreamingSupported = !y.disableStream;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var A;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const v = this._readableStream.read();
              return v === null ? (this._readCapability = new a.PromiseCapability(), this.read()) : (this._loaded += v.length, (A = this.onProgress) == null || A.call(this, {
                loaded: this._loaded
              }), {
                value: new Uint8Array(v).buffer,
                done: !1
              });
            }
            cancel(v) {
              if (!this._readableStream) {
                this._error(v);
                return;
              }
              this._readableStream.destroy(v);
            }
            _error(v) {
              this._storedError = v, this._readCapability.resolve();
            }
            _setReadableStream(v) {
              this._readableStream = v, v.on("readable", () => {
                this._readCapability.resolve();
              }), v.on("end", () => {
                v.destroy(), this._done = !0, this._readCapability.resolve();
              }), v.on("error", (y) => {
                this._error(y);
              }), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          function f(m, v) {
            return {
              protocol: m.protocol,
              auth: m.auth,
              host: m.hostname,
              port: m.port,
              path: m.path,
              method: "GET",
              headers: v
            };
          }
          class h extends u {
            constructor(v) {
              super(v);
              const y = (A) => {
                if (A.statusCode === 404) {
                  const w = new a.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = w, this._headersCapability.reject(w);
                  return;
                }
                this._headersCapability.resolve(), this._setReadableStream(A);
                const b = (w) => this._readableStream.headers[w.toLowerCase()], {
                  allowRangeRequests: C,
                  suggestedLength: T
                } = (0, s.validateRangeRequestCapabilities)({
                  getResponseHeader: b,
                  isHttp: v.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = C, this._contentLength = T || this._contentLength, this._filename = (0, s.extractFilenameFromHeader)(b);
              };
              if (this._request = null, this._url.protocol === "http:") {
                const A = require$$0$1;
                this._request = A.request(f(this._url, v.httpHeaders), y);
              } else {
                const A = require$$0$1;
                this._request = A.request(f(this._url, v.httpHeaders), y);
              }
              this._request.on("error", (A) => {
                this._storedError = A, this._headersCapability.reject(A);
              }), this._request.end();
            }
          }
          class g extends d {
            constructor(v, y, A) {
              super(v), this._httpHeaders = {};
              for (const C in v.httpHeaders) {
                const T = v.httpHeaders[C];
                T !== void 0 && (this._httpHeaders[C] = T);
              }
              this._httpHeaders.Range = `bytes=${y}-${A - 1}`;
              const b = (C) => {
                if (C.statusCode === 404) {
                  const T = new a.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = T;
                  return;
                }
                this._setReadableStream(C);
              };
              if (this._request = null, this._url.protocol === "http:") {
                const C = require$$0$1;
                this._request = C.request(f(this._url, this._httpHeaders), b);
              } else {
                const C = require$$0$1;
                this._request = C.request(f(this._url, this._httpHeaders), b);
              }
              this._request.on("error", (C) => {
                this._storedError = C;
              }), this._request.end();
            }
          }
          class x extends u {
            constructor(v) {
              super(v);
              let y = decodeURIComponent(this._url.path);
              o.test(this._url.href) && (y = y.replace(/^\//, ""));
              const A = require$$0$1;
              A.lstat(y, (b, C) => {
                if (b) {
                  b.code === "ENOENT" && (b = new a.MissingPDFException(`Missing PDF "${y}".`)), this._storedError = b, this._headersCapability.reject(b);
                  return;
                }
                this._contentLength = C.size, this._setReadableStream(A.createReadStream(y)), this._headersCapability.resolve();
              });
            }
          }
          class E extends d {
            constructor(v, y, A) {
              super(v);
              let b = decodeURIComponent(this._url.path);
              o.test(this._url.href) && (b = b.replace(/^\//, ""));
              const C = require$$0$1;
              this._setReadableStream(C.createReadStream(b, {
                start: y,
                end: A - 1
              }));
            }
          }
        },
        /* 24 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.SVGGraphics = void 0;
          var a = n(6), s = n(1);
          const o = {
            fontStyle: "normal",
            fontWeight: "normal",
            fillColor: "#000000"
          }, l = "http://www.w3.org/XML/1998/namespace", c = "http://www.w3.org/1999/xlink", u = ["butt", "round", "square"], d = ["miter", "round", "bevel"], f = function(C, T = "", w = !1) {
            if (URL.createObjectURL && typeof Blob < "u" && !w)
              return URL.createObjectURL(new Blob([C], {
                type: T
              }));
            const R = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            let O = `data:${T};base64,`;
            for (let D = 0, k = C.length; D < k; D += 3) {
              const W = C[D] & 255, L = C[D + 1] & 255, z = C[D + 2] & 255, P = W >> 2, Q = (W & 3) << 4 | L >> 4, Y = D + 1 < k ? (L & 15) << 2 | z >> 6 : 64, ie = D + 2 < k ? z & 63 : 64;
              O += R[P] + R[Q] + R[Y] + R[ie];
            }
            return O;
          }, h = function() {
            const C = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), T = 12, w = new Int32Array(256);
            for (let z = 0; z < 256; z++) {
              let P = z;
              for (let Q = 0; Q < 8; Q++)
                P = P & 1 ? 3988292384 ^ P >> 1 & 2147483647 : P >> 1 & 2147483647;
              w[z] = P;
            }
            function R(z, P, Q) {
              let Y = -1;
              for (let ie = P; ie < Q; ie++) {
                const te = (Y ^ z[ie]) & 255, Z = w[te];
                Y = Y >>> 8 ^ Z;
              }
              return Y ^ -1;
            }
            function O(z, P, Q, Y) {
              let ie = Y;
              const te = P.length;
              Q[ie] = te >> 24 & 255, Q[ie + 1] = te >> 16 & 255, Q[ie + 2] = te >> 8 & 255, Q[ie + 3] = te & 255, ie += 4, Q[ie] = z.charCodeAt(0) & 255, Q[ie + 1] = z.charCodeAt(1) & 255, Q[ie + 2] = z.charCodeAt(2) & 255, Q[ie + 3] = z.charCodeAt(3) & 255, ie += 4, Q.set(P, ie), ie += P.length;
              const Z = R(Q, Y + 4, ie);
              Q[ie] = Z >> 24 & 255, Q[ie + 1] = Z >> 16 & 255, Q[ie + 2] = Z >> 8 & 255, Q[ie + 3] = Z & 255;
            }
            function D(z, P, Q) {
              let Y = 1, ie = 0;
              for (let te = P; te < Q; ++te)
                Y = (Y + (z[te] & 255)) % 65521, ie = (ie + Y) % 65521;
              return ie << 16 | Y;
            }
            function k(z) {
              if (!s.isNodeJS)
                return W(z);
              try {
                const P = parseInt(process.versions.node) >= 8 ? z : Buffer.from(z), Q = require$$0$1.deflateSync(P, {
                  level: 9
                });
                return Q instanceof Uint8Array ? Q : new Uint8Array(Q);
              } catch (P) {
                (0, s.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + P);
              }
              return W(z);
            }
            function W(z) {
              let P = z.length;
              const Q = 65535, Y = Math.ceil(P / Q), ie = new Uint8Array(2 + P + Y * 5 + 4);
              let te = 0;
              ie[te++] = 120, ie[te++] = 156;
              let Z = 0;
              for (; P > Q; )
                ie[te++] = 0, ie[te++] = 255, ie[te++] = 255, ie[te++] = 0, ie[te++] = 0, ie.set(z.subarray(Z, Z + Q), te), te += Q, Z += Q, P -= Q;
              ie[te++] = 1, ie[te++] = P & 255, ie[te++] = P >> 8 & 255, ie[te++] = ~P & 65535 & 255, ie[te++] = (~P & 65535) >> 8 & 255, ie.set(z.subarray(Z), te), te += z.length - Z;
              const ae = D(z, 0, z.length);
              return ie[te++] = ae >> 24 & 255, ie[te++] = ae >> 16 & 255, ie[te++] = ae >> 8 & 255, ie[te++] = ae & 255, ie;
            }
            function L(z, P, Q, Y) {
              const ie = z.width, te = z.height;
              let Z, ae, G;
              const U = z.data;
              switch (P) {
                case s.ImageKind.GRAYSCALE_1BPP:
                  ae = 0, Z = 1, G = ie + 7 >> 3;
                  break;
                case s.ImageKind.RGB_24BPP:
                  ae = 2, Z = 8, G = ie * 3;
                  break;
                case s.ImageKind.RGBA_32BPP:
                  ae = 6, Z = 8, G = ie * 4;
                  break;
                default:
                  throw new Error("invalid format");
              }
              const F = new Uint8Array((1 + G) * te);
              let M = 0, I = 0;
              for (let he = 0; he < te; ++he)
                F[M++] = 0, F.set(U.subarray(I, I + G), M), I += G, M += G;
              if (P === s.ImageKind.GRAYSCALE_1BPP && Y) {
                M = 0;
                for (let he = 0; he < te; he++) {
                  M++;
                  for (let j = 0; j < G; j++)
                    F[M++] ^= 255;
                }
              }
              const N = new Uint8Array([ie >> 24 & 255, ie >> 16 & 255, ie >> 8 & 255, ie & 255, te >> 24 & 255, te >> 16 & 255, te >> 8 & 255, te & 255, Z, ae, 0, 0, 0]), V = k(F), q = C.length + T * 3 + N.length + V.length, H = new Uint8Array(q);
              let ne = 0;
              return H.set(C, ne), ne += C.length, O("IHDR", N, H, ne), ne += T + N.length, O("IDATA", V, H, ne), ne += T + V.length, O("IEND", new Uint8Array(0), H, ne), f(H, "image/png", Q);
            }
            return function(P, Q, Y) {
              const ie = P.kind === void 0 ? s.ImageKind.GRAYSCALE_1BPP : P.kind;
              return L(P, ie, Q, Y);
            };
          }();
          class g {
            constructor() {
              this.fontSizeScale = 1, this.fontWeight = o.fontWeight, this.fontSize = 0, this.textMatrix = s.IDENTITY_MATRIX, this.fontMatrix = s.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = s.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = o.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
            }
            clone() {
              return Object.create(this);
            }
            setCurrentPoint(T, w) {
              this.x = T, this.y = w;
            }
          }
          function x(C) {
            let T = [];
            const w = [];
            for (const R of C) {
              if (R.fn === "save") {
                T.push({
                  fnId: 92,
                  fn: "group",
                  items: []
                }), w.push(T), T = T.at(-1).items;
                continue;
              }
              R.fn === "restore" ? T = w.pop() : T.push(R);
            }
            return T;
          }
          function E(C) {
            if (Number.isInteger(C))
              return C.toString();
            const T = C.toFixed(10);
            let w = T.length - 1;
            if (T[w] !== "0")
              return T;
            do
              w--;
            while (T[w] === "0");
            return T.substring(0, T[w] === "." ? w : w + 1);
          }
          function m(C) {
            if (C[4] === 0 && C[5] === 0) {
              if (C[1] === 0 && C[2] === 0)
                return C[0] === 1 && C[3] === 1 ? "" : `scale(${E(C[0])} ${E(C[3])})`;
              if (C[0] === C[3] && C[1] === -C[2]) {
                const T = Math.acos(C[0]) * 180 / Math.PI;
                return `rotate(${E(T)})`;
              }
            } else if (C[0] === 1 && C[1] === 0 && C[2] === 0 && C[3] === 1)
              return `translate(${E(C[4])} ${E(C[5])})`;
            return `matrix(${E(C[0])} ${E(C[1])} ${E(C[2])} ${E(C[3])} ${E(C[4])} ${E(C[5])})`;
          }
          let v = 0, y = 0, A = 0;
          class b {
            constructor(T, w, R = !1) {
              (0, a.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new a.DOMSVGFactory(), this.current = new g(), this.transformMatrix = s.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = T, this.objs = w, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!R, this._operatorIdMapping = [];
              for (const O in s.OPS)
                this._operatorIdMapping[s.OPS[O]] = O;
            }
            getObject(T, w = null) {
              return typeof T == "string" ? T.startsWith("g_") ? this.commonObjs.get(T) : this.objs.get(T) : w;
            }
            save() {
              this.transformStack.push(this.transformMatrix);
              const T = this.current;
              this.extraStack.push(T), this.current = T.clone();
            }
            restore() {
              this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
            }
            group(T) {
              this.save(), this.executeOpTree(T), this.restore();
            }
            loadDependencies(T) {
              const w = T.fnArray, R = T.argsArray;
              for (let O = 0, D = w.length; O < D; O++)
                if (w[O] === s.OPS.dependency)
                  for (const k of R[O]) {
                    const W = k.startsWith("g_") ? this.commonObjs : this.objs, L = new Promise((z) => {
                      W.get(k, z);
                    });
                    this.current.dependencies.push(L);
                  }
              return Promise.all(this.current.dependencies);
            }
            transform(T, w, R, O, D, k) {
              const W = [T, w, R, O, D, k];
              this.transformMatrix = s.Util.transform(this.transformMatrix, W), this.tgrp = null;
            }
            getSVG(T, w) {
              this.viewport = w;
              const R = this._initialize(w);
              return this.loadDependencies(T).then(() => (this.transformMatrix = s.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(T)), R));
            }
            convertOpList(T) {
              const w = this._operatorIdMapping, R = T.argsArray, O = T.fnArray, D = [];
              for (let k = 0, W = O.length; k < W; k++) {
                const L = O[k];
                D.push({
                  fnId: L,
                  fn: w[L],
                  args: R[k]
                });
              }
              return x(D);
            }
            executeOpTree(T) {
              for (const w of T) {
                const R = w.fn, O = w.fnId, D = w.args;
                switch (O | 0) {
                  case s.OPS.beginText:
                    this.beginText();
                    break;
                  case s.OPS.dependency:
                    break;
                  case s.OPS.setLeading:
                    this.setLeading(D);
                    break;
                  case s.OPS.setLeadingMoveText:
                    this.setLeadingMoveText(D[0], D[1]);
                    break;
                  case s.OPS.setFont:
                    this.setFont(D);
                    break;
                  case s.OPS.showText:
                    this.showText(D[0]);
                    break;
                  case s.OPS.showSpacedText:
                    this.showText(D[0]);
                    break;
                  case s.OPS.endText:
                    this.endText();
                    break;
                  case s.OPS.moveText:
                    this.moveText(D[0], D[1]);
                    break;
                  case s.OPS.setCharSpacing:
                    this.setCharSpacing(D[0]);
                    break;
                  case s.OPS.setWordSpacing:
                    this.setWordSpacing(D[0]);
                    break;
                  case s.OPS.setHScale:
                    this.setHScale(D[0]);
                    break;
                  case s.OPS.setTextMatrix:
                    this.setTextMatrix(D[0], D[1], D[2], D[3], D[4], D[5]);
                    break;
                  case s.OPS.setTextRise:
                    this.setTextRise(D[0]);
                    break;
                  case s.OPS.setTextRenderingMode:
                    this.setTextRenderingMode(D[0]);
                    break;
                  case s.OPS.setLineWidth:
                    this.setLineWidth(D[0]);
                    break;
                  case s.OPS.setLineJoin:
                    this.setLineJoin(D[0]);
                    break;
                  case s.OPS.setLineCap:
                    this.setLineCap(D[0]);
                    break;
                  case s.OPS.setMiterLimit:
                    this.setMiterLimit(D[0]);
                    break;
                  case s.OPS.setFillRGBColor:
                    this.setFillRGBColor(D[0], D[1], D[2]);
                    break;
                  case s.OPS.setStrokeRGBColor:
                    this.setStrokeRGBColor(D[0], D[1], D[2]);
                    break;
                  case s.OPS.setStrokeColorN:
                    this.setStrokeColorN(D);
                    break;
                  case s.OPS.setFillColorN:
                    this.setFillColorN(D);
                    break;
                  case s.OPS.shadingFill:
                    this.shadingFill(D[0]);
                    break;
                  case s.OPS.setDash:
                    this.setDash(D[0], D[1]);
                    break;
                  case s.OPS.setRenderingIntent:
                    this.setRenderingIntent(D[0]);
                    break;
                  case s.OPS.setFlatness:
                    this.setFlatness(D[0]);
                    break;
                  case s.OPS.setGState:
                    this.setGState(D[0]);
                    break;
                  case s.OPS.fill:
                    this.fill();
                    break;
                  case s.OPS.eoFill:
                    this.eoFill();
                    break;
                  case s.OPS.stroke:
                    this.stroke();
                    break;
                  case s.OPS.fillStroke:
                    this.fillStroke();
                    break;
                  case s.OPS.eoFillStroke:
                    this.eoFillStroke();
                    break;
                  case s.OPS.clip:
                    this.clip("nonzero");
                    break;
                  case s.OPS.eoClip:
                    this.clip("evenodd");
                    break;
                  case s.OPS.paintSolidColorImageMask:
                    this.paintSolidColorImageMask();
                    break;
                  case s.OPS.paintImageXObject:
                    this.paintImageXObject(D[0]);
                    break;
                  case s.OPS.paintInlineImageXObject:
                    this.paintInlineImageXObject(D[0]);
                    break;
                  case s.OPS.paintImageMaskXObject:
                    this.paintImageMaskXObject(D[0]);
                    break;
                  case s.OPS.paintFormXObjectBegin:
                    this.paintFormXObjectBegin(D[0], D[1]);
                    break;
                  case s.OPS.paintFormXObjectEnd:
                    this.paintFormXObjectEnd();
                    break;
                  case s.OPS.closePath:
                    this.closePath();
                    break;
                  case s.OPS.closeStroke:
                    this.closeStroke();
                    break;
                  case s.OPS.closeFillStroke:
                    this.closeFillStroke();
                    break;
                  case s.OPS.closeEOFillStroke:
                    this.closeEOFillStroke();
                    break;
                  case s.OPS.nextLine:
                    this.nextLine();
                    break;
                  case s.OPS.transform:
                    this.transform(D[0], D[1], D[2], D[3], D[4], D[5]);
                    break;
                  case s.OPS.constructPath:
                    this.constructPath(D[0], D[1]);
                    break;
                  case s.OPS.endPath:
                    this.endPath();
                    break;
                  case 92:
                    this.group(w.items);
                    break;
                  default:
                    (0, s.warn)(`Unimplemented operator ${R}`);
                    break;
                }
              }
            }
            setWordSpacing(T) {
              this.current.wordSpacing = T;
            }
            setCharSpacing(T) {
              this.current.charSpacing = T;
            }
            nextLine() {
              this.moveText(0, this.current.leading);
            }
            setTextMatrix(T, w, R, O, D, k) {
              const W = this.current;
              W.textMatrix = W.lineMatrix = [T, w, R, O, D, k], W.textMatrixScale = Math.hypot(T, w), W.x = W.lineX = 0, W.y = W.lineY = 0, W.xcoords = [], W.ycoords = [], W.tspan = this.svgFactory.createElement("svg:tspan"), W.tspan.setAttributeNS(null, "font-family", W.fontFamily), W.tspan.setAttributeNS(null, "font-size", `${E(W.fontSize)}px`), W.tspan.setAttributeNS(null, "y", E(-W.y)), W.txtElement = this.svgFactory.createElement("svg:text"), W.txtElement.append(W.tspan);
            }
            beginText() {
              const T = this.current;
              T.x = T.lineX = 0, T.y = T.lineY = 0, T.textMatrix = s.IDENTITY_MATRIX, T.lineMatrix = s.IDENTITY_MATRIX, T.textMatrixScale = 1, T.tspan = this.svgFactory.createElement("svg:tspan"), T.txtElement = this.svgFactory.createElement("svg:text"), T.txtgrp = this.svgFactory.createElement("svg:g"), T.xcoords = [], T.ycoords = [];
            }
            moveText(T, w) {
              const R = this.current;
              R.x = R.lineX += T, R.y = R.lineY += w, R.xcoords = [], R.ycoords = [], R.tspan = this.svgFactory.createElement("svg:tspan"), R.tspan.setAttributeNS(null, "font-family", R.fontFamily), R.tspan.setAttributeNS(null, "font-size", `${E(R.fontSize)}px`), R.tspan.setAttributeNS(null, "y", E(-R.y));
            }
            showText(T) {
              const w = this.current, R = w.font, O = w.fontSize;
              if (O === 0)
                return;
              const D = w.fontSizeScale, k = w.charSpacing, W = w.wordSpacing, L = w.fontDirection, z = w.textHScale * L, P = R.vertical, Q = P ? 1 : -1, Y = R.defaultVMetrics, ie = O * w.fontMatrix[0];
              let te = 0;
              for (const G of T) {
                if (G === null) {
                  te += L * W;
                  continue;
                } else if (typeof G == "number") {
                  te += Q * G * O / 1e3;
                  continue;
                }
                const U = (G.isSpace ? W : 0) + k, F = G.fontChar;
                let M, I, N = G.width;
                if (P) {
                  let q;
                  const H = G.vmetric || Y;
                  q = G.vmetric ? H[1] : N * 0.5, q = -q * ie;
                  const ne = H[2] * ie;
                  N = H ? -H[0] : N, M = q / D, I = (te + ne) / D;
                } else
                  M = te / D, I = 0;
                (G.isInFont || R.missingFile) && (w.xcoords.push(w.x + M), P && w.ycoords.push(-w.y + I), w.tspan.textContent += F);
                const V = P ? N * ie - U * L : N * ie + U * L;
                te += V;
              }
              w.tspan.setAttributeNS(null, "x", w.xcoords.map(E).join(" ")), P ? w.tspan.setAttributeNS(null, "y", w.ycoords.map(E).join(" ")) : w.tspan.setAttributeNS(null, "y", E(-w.y)), P ? w.y -= te : w.x += te * z, w.tspan.setAttributeNS(null, "font-family", w.fontFamily), w.tspan.setAttributeNS(null, "font-size", `${E(w.fontSize)}px`), w.fontStyle !== o.fontStyle && w.tspan.setAttributeNS(null, "font-style", w.fontStyle), w.fontWeight !== o.fontWeight && w.tspan.setAttributeNS(null, "font-weight", w.fontWeight);
              const Z = w.textRenderingMode & s.TextRenderingMode.FILL_STROKE_MASK;
              if (Z === s.TextRenderingMode.FILL || Z === s.TextRenderingMode.FILL_STROKE ? (w.fillColor !== o.fillColor && w.tspan.setAttributeNS(null, "fill", w.fillColor), w.fillAlpha < 1 && w.tspan.setAttributeNS(null, "fill-opacity", w.fillAlpha)) : w.textRenderingMode === s.TextRenderingMode.ADD_TO_PATH ? w.tspan.setAttributeNS(null, "fill", "transparent") : w.tspan.setAttributeNS(null, "fill", "none"), Z === s.TextRenderingMode.STROKE || Z === s.TextRenderingMode.FILL_STROKE) {
                const G = 1 / (w.textMatrixScale || 1);
                this._setStrokeAttributes(w.tspan, G);
              }
              let ae = w.textMatrix;
              w.textRise !== 0 && (ae = ae.slice(), ae[5] += w.textRise), w.txtElement.setAttributeNS(null, "transform", `${m(ae)} scale(${E(z)}, -1)`), w.txtElement.setAttributeNS(l, "xml:space", "preserve"), w.txtElement.append(w.tspan), w.txtgrp.append(w.txtElement), this._ensureTransformGroup().append(w.txtElement);
            }
            setLeadingMoveText(T, w) {
              this.setLeading(-w), this.moveText(T, w);
            }
            addFontStyle(T) {
              if (!T.data)
                throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
              this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
              const w = f(T.data, T.mimetype, this.forceDataSchema);
              this.cssStyle.textContent += `@font-face { font-family: "${T.loadedName}"; src: url(${w}); }
`;
            }
            setFont(T) {
              const w = this.current, R = this.commonObjs.get(T[0]);
              let O = T[1];
              w.font = R, this.embedFonts && !R.missingFile && !this.embeddedFonts[R.loadedName] && (this.addFontStyle(R), this.embeddedFonts[R.loadedName] = R), w.fontMatrix = R.fontMatrix || s.FONT_IDENTITY_MATRIX;
              let D = "normal";
              R.black ? D = "900" : R.bold && (D = "bold");
              const k = R.italic ? "italic" : "normal";
              O < 0 ? (O = -O, w.fontDirection = -1) : w.fontDirection = 1, w.fontSize = O, w.fontFamily = R.loadedName, w.fontWeight = D, w.fontStyle = k, w.tspan = this.svgFactory.createElement("svg:tspan"), w.tspan.setAttributeNS(null, "y", E(-w.y)), w.xcoords = [], w.ycoords = [];
            }
            endText() {
              var w;
              const T = this.current;
              T.textRenderingMode & s.TextRenderingMode.ADD_TO_PATH_FLAG && ((w = T.txtElement) != null && w.hasChildNodes()) && (T.element = T.txtElement, this.clip("nonzero"), this.endPath());
            }
            setLineWidth(T) {
              T > 0 && (this.current.lineWidth = T);
            }
            setLineCap(T) {
              this.current.lineCap = u[T];
            }
            setLineJoin(T) {
              this.current.lineJoin = d[T];
            }
            setMiterLimit(T) {
              this.current.miterLimit = T;
            }
            setStrokeAlpha(T) {
              this.current.strokeAlpha = T;
            }
            setStrokeRGBColor(T, w, R) {
              this.current.strokeColor = s.Util.makeHexColor(T, w, R);
            }
            setFillAlpha(T) {
              this.current.fillAlpha = T;
            }
            setFillRGBColor(T, w, R) {
              this.current.fillColor = s.Util.makeHexColor(T, w, R), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
            }
            setStrokeColorN(T) {
              this.current.strokeColor = this._makeColorN_Pattern(T);
            }
            setFillColorN(T) {
              this.current.fillColor = this._makeColorN_Pattern(T);
            }
            shadingFill(T) {
              const {
                width: w,
                height: R
              } = this.viewport, O = s.Util.inverseTransform(this.transformMatrix), [D, k, W, L] = s.Util.getAxialAlignedBoundingBox([0, 0, w, R], O), z = this.svgFactory.createElement("svg:rect");
              z.setAttributeNS(null, "x", D), z.setAttributeNS(null, "y", k), z.setAttributeNS(null, "width", W - D), z.setAttributeNS(null, "height", L - k), z.setAttributeNS(null, "fill", this._makeShadingPattern(T)), this.current.fillAlpha < 1 && z.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(z);
            }
            _makeColorN_Pattern(T) {
              return T[0] === "TilingPattern" ? this._makeTilingPattern(T) : this._makeShadingPattern(T);
            }
            _makeTilingPattern(T) {
              const w = T[1], R = T[2], O = T[3] || s.IDENTITY_MATRIX, [D, k, W, L] = T[4], z = T[5], P = T[6], Q = T[7], Y = `shading${A++}`, [ie, te, Z, ae] = s.Util.normalizeRect([...s.Util.applyTransform([D, k], O), ...s.Util.applyTransform([W, L], O)]), [G, U] = s.Util.singularValueDecompose2dScale(O), F = z * G, M = P * U, I = this.svgFactory.createElement("svg:pattern");
              I.setAttributeNS(null, "id", Y), I.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), I.setAttributeNS(null, "width", F), I.setAttributeNS(null, "height", M), I.setAttributeNS(null, "x", `${ie}`), I.setAttributeNS(null, "y", `${te}`);
              const N = this.svg, V = this.transformMatrix, q = this.current.fillColor, H = this.current.strokeColor, ne = this.svgFactory.create(Z - ie, ae - te);
              if (this.svg = ne, this.transformMatrix = O, Q === 2) {
                const he = s.Util.makeHexColor(...w);
                this.current.fillColor = he, this.current.strokeColor = he;
              }
              return this.executeOpTree(this.convertOpList(R)), this.svg = N, this.transformMatrix = V, this.current.fillColor = q, this.current.strokeColor = H, I.append(ne.childNodes[0]), this.defs.append(I), `url(#${Y})`;
            }
            _makeShadingPattern(T) {
              switch (typeof T == "string" && (T = this.objs.get(T)), T[0]) {
                case "RadialAxial":
                  const w = `shading${A++}`, R = T[3];
                  let O;
                  switch (T[1]) {
                    case "axial":
                      const D = T[4], k = T[5];
                      O = this.svgFactory.createElement("svg:linearGradient"), O.setAttributeNS(null, "id", w), O.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), O.setAttributeNS(null, "x1", D[0]), O.setAttributeNS(null, "y1", D[1]), O.setAttributeNS(null, "x2", k[0]), O.setAttributeNS(null, "y2", k[1]);
                      break;
                    case "radial":
                      const W = T[4], L = T[5], z = T[6], P = T[7];
                      O = this.svgFactory.createElement("svg:radialGradient"), O.setAttributeNS(null, "id", w), O.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), O.setAttributeNS(null, "cx", L[0]), O.setAttributeNS(null, "cy", L[1]), O.setAttributeNS(null, "r", P), O.setAttributeNS(null, "fx", W[0]), O.setAttributeNS(null, "fy", W[1]), O.setAttributeNS(null, "fr", z);
                      break;
                    default:
                      throw new Error(`Unknown RadialAxial type: ${T[1]}`);
                  }
                  for (const D of R) {
                    const k = this.svgFactory.createElement("svg:stop");
                    k.setAttributeNS(null, "offset", D[0]), k.setAttributeNS(null, "stop-color", D[1]), O.append(k);
                  }
                  return this.defs.append(O), `url(#${w})`;
                case "Mesh":
                  return (0, s.warn)("Unimplemented pattern Mesh"), null;
                case "Dummy":
                  return "hotpink";
                default:
                  throw new Error(`Unknown IR type: ${T[0]}`);
              }
            }
            setDash(T, w) {
              this.current.dashArray = T, this.current.dashPhase = w;
            }
            constructPath(T, w) {
              const R = this.current;
              let O = R.x, D = R.y, k = [], W = 0;
              for (const L of T)
                switch (L | 0) {
                  case s.OPS.rectangle:
                    O = w[W++], D = w[W++];
                    const z = w[W++], P = w[W++], Q = O + z, Y = D + P;
                    k.push("M", E(O), E(D), "L", E(Q), E(D), "L", E(Q), E(Y), "L", E(O), E(Y), "Z");
                    break;
                  case s.OPS.moveTo:
                    O = w[W++], D = w[W++], k.push("M", E(O), E(D));
                    break;
                  case s.OPS.lineTo:
                    O = w[W++], D = w[W++], k.push("L", E(O), E(D));
                    break;
                  case s.OPS.curveTo:
                    O = w[W + 4], D = w[W + 5], k.push("C", E(w[W]), E(w[W + 1]), E(w[W + 2]), E(w[W + 3]), E(O), E(D)), W += 6;
                    break;
                  case s.OPS.curveTo2:
                    k.push("C", E(O), E(D), E(w[W]), E(w[W + 1]), E(w[W + 2]), E(w[W + 3])), O = w[W + 2], D = w[W + 3], W += 4;
                    break;
                  case s.OPS.curveTo3:
                    O = w[W + 2], D = w[W + 3], k.push("C", E(w[W]), E(w[W + 1]), E(O), E(D), E(O), E(D)), W += 4;
                    break;
                  case s.OPS.closePath:
                    k.push("Z");
                    break;
                }
              k = k.join(" "), R.path && T.length > 0 && T[0] !== s.OPS.rectangle && T[0] !== s.OPS.moveTo ? k = R.path.getAttributeNS(null, "d") + k : (R.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(R.path)), R.path.setAttributeNS(null, "d", k), R.path.setAttributeNS(null, "fill", "none"), R.element = R.path, R.setCurrentPoint(O, D);
            }
            endPath() {
              const T = this.current;
              if (T.path = null, !this.pendingClip)
                return;
              if (!T.element) {
                this.pendingClip = null;
                return;
              }
              const w = `clippath${v++}`, R = this.svgFactory.createElement("svg:clipPath");
              R.setAttributeNS(null, "id", w), R.setAttributeNS(null, "transform", m(this.transformMatrix));
              const O = T.element.cloneNode(!0);
              if (this.pendingClip === "evenodd" ? O.setAttributeNS(null, "clip-rule", "evenodd") : O.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, R.append(O), this.defs.append(R), T.activeClipUrl) {
                T.clipGroup = null;
                for (const D of this.extraStack)
                  D.clipGroup = null;
                R.setAttributeNS(null, "clip-path", T.activeClipUrl);
              }
              T.activeClipUrl = `url(#${w})`, this.tgrp = null;
            }
            clip(T) {
              this.pendingClip = T;
            }
            closePath() {
              const T = this.current;
              if (T.path) {
                const w = `${T.path.getAttributeNS(null, "d")}Z`;
                T.path.setAttributeNS(null, "d", w);
              }
            }
            setLeading(T) {
              this.current.leading = -T;
            }
            setTextRise(T) {
              this.current.textRise = T;
            }
            setTextRenderingMode(T) {
              this.current.textRenderingMode = T;
            }
            setHScale(T) {
              this.current.textHScale = T / 100;
            }
            setRenderingIntent(T) {
            }
            setFlatness(T) {
            }
            setGState(T) {
              for (const [w, R] of T)
                switch (w) {
                  case "LW":
                    this.setLineWidth(R);
                    break;
                  case "LC":
                    this.setLineCap(R);
                    break;
                  case "LJ":
                    this.setLineJoin(R);
                    break;
                  case "ML":
                    this.setMiterLimit(R);
                    break;
                  case "D":
                    this.setDash(R[0], R[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(R);
                    break;
                  case "FL":
                    this.setFlatness(R);
                    break;
                  case "Font":
                    this.setFont(R);
                    break;
                  case "CA":
                    this.setStrokeAlpha(R);
                    break;
                  case "ca":
                    this.setFillAlpha(R);
                    break;
                  default:
                    (0, s.warn)(`Unimplemented graphic state operator ${w}`);
                    break;
                }
            }
            fill() {
              const T = this.current;
              T.element && (T.element.setAttributeNS(null, "fill", T.fillColor), T.element.setAttributeNS(null, "fill-opacity", T.fillAlpha), this.endPath());
            }
            stroke() {
              const T = this.current;
              T.element && (this._setStrokeAttributes(T.element), T.element.setAttributeNS(null, "fill", "none"), this.endPath());
            }
            _setStrokeAttributes(T, w = 1) {
              const R = this.current;
              let O = R.dashArray;
              w !== 1 && O.length > 0 && (O = O.map(function(D) {
                return w * D;
              })), T.setAttributeNS(null, "stroke", R.strokeColor), T.setAttributeNS(null, "stroke-opacity", R.strokeAlpha), T.setAttributeNS(null, "stroke-miterlimit", E(R.miterLimit)), T.setAttributeNS(null, "stroke-linecap", R.lineCap), T.setAttributeNS(null, "stroke-linejoin", R.lineJoin), T.setAttributeNS(null, "stroke-width", E(w * R.lineWidth) + "px"), T.setAttributeNS(null, "stroke-dasharray", O.map(E).join(" ")), T.setAttributeNS(null, "stroke-dashoffset", E(w * R.dashPhase) + "px");
            }
            eoFill() {
              var T;
              (T = this.current.element) == null || T.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
            }
            fillStroke() {
              this.stroke(), this.fill();
            }
            eoFillStroke() {
              var T;
              (T = this.current.element) == null || T.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
            }
            closeStroke() {
              this.closePath(), this.stroke();
            }
            closeFillStroke() {
              this.closePath(), this.fillStroke();
            }
            closeEOFillStroke() {
              this.closePath(), this.eoFillStroke();
            }
            paintSolidColorImageMask() {
              const T = this.svgFactory.createElement("svg:rect");
              T.setAttributeNS(null, "x", "0"), T.setAttributeNS(null, "y", "0"), T.setAttributeNS(null, "width", "1px"), T.setAttributeNS(null, "height", "1px"), T.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(T);
            }
            paintImageXObject(T) {
              const w = this.getObject(T);
              if (!w) {
                (0, s.warn)(`Dependent image with object ID ${T} is not ready yet`);
                return;
              }
              this.paintInlineImageXObject(w);
            }
            paintInlineImageXObject(T, w) {
              const R = T.width, O = T.height, D = h(T, this.forceDataSchema, !!w), k = this.svgFactory.createElement("svg:rect");
              k.setAttributeNS(null, "x", "0"), k.setAttributeNS(null, "y", "0"), k.setAttributeNS(null, "width", E(R)), k.setAttributeNS(null, "height", E(O)), this.current.element = k, this.clip("nonzero");
              const W = this.svgFactory.createElement("svg:image");
              W.setAttributeNS(c, "xlink:href", D), W.setAttributeNS(null, "x", "0"), W.setAttributeNS(null, "y", E(-O)), W.setAttributeNS(null, "width", E(R) + "px"), W.setAttributeNS(null, "height", E(O) + "px"), W.setAttributeNS(null, "transform", `scale(${E(1 / R)} ${E(-1 / O)})`), w ? w.append(W) : this._ensureTransformGroup().append(W);
            }
            paintImageMaskXObject(T) {
              const w = this.getObject(T.data, T);
              if (w.bitmap) {
                (0, s.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                return;
              }
              const R = this.current, O = w.width, D = w.height, k = R.fillColor;
              R.maskId = `mask${y++}`;
              const W = this.svgFactory.createElement("svg:mask");
              W.setAttributeNS(null, "id", R.maskId);
              const L = this.svgFactory.createElement("svg:rect");
              L.setAttributeNS(null, "x", "0"), L.setAttributeNS(null, "y", "0"), L.setAttributeNS(null, "width", E(O)), L.setAttributeNS(null, "height", E(D)), L.setAttributeNS(null, "fill", k), L.setAttributeNS(null, "mask", `url(#${R.maskId})`), this.defs.append(W), this._ensureTransformGroup().append(L), this.paintInlineImageXObject(w, W);
            }
            paintFormXObjectBegin(T, w) {
              if (Array.isArray(T) && T.length === 6 && this.transform(T[0], T[1], T[2], T[3], T[4], T[5]), w) {
                const R = w[2] - w[0], O = w[3] - w[1], D = this.svgFactory.createElement("svg:rect");
                D.setAttributeNS(null, "x", w[0]), D.setAttributeNS(null, "y", w[1]), D.setAttributeNS(null, "width", E(R)), D.setAttributeNS(null, "height", E(O)), this.current.element = D, this.clip("nonzero"), this.endPath();
              }
            }
            paintFormXObjectEnd() {
            }
            _initialize(T) {
              const w = this.svgFactory.create(T.width, T.height), R = this.svgFactory.createElement("svg:defs");
              w.append(R), this.defs = R;
              const O = this.svgFactory.createElement("svg:g");
              return O.setAttributeNS(null, "transform", m(T.transform)), w.append(O), this.svg = O, w;
            }
            _ensureClipGroup() {
              if (!this.current.clipGroup) {
                const T = this.svgFactory.createElement("svg:g");
                T.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(T), this.current.clipGroup = T;
              }
              return this.current.clipGroup;
            }
            _ensureTransformGroup() {
              return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", m(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
            }
          }
          e.SVGGraphics = b;
        },
        /* 25 */
        /***/
        (t, e) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.XfaText = void 0;
          class n {
            static textContent(s) {
              const o = [], l = {
                items: o,
                styles: /* @__PURE__ */ Object.create(null)
              };
              function c(u) {
                var h;
                if (!u)
                  return;
                let d = null;
                const f = u.name;
                if (f === "#text")
                  d = u.value;
                else if (n.shouldBuildText(f))
                  (h = u == null ? void 0 : u.attributes) != null && h.textContent ? d = u.attributes.textContent : u.value && (d = u.value);
                else
                  return;
                if (d !== null && o.push({
                  str: d
                }), !!u.children)
                  for (const g of u.children)
                    c(g);
              }
              return c(s), l;
            }
            static shouldBuildText(s) {
              return !(s === "textarea" || s === "input" || s === "option" || s === "select");
            }
          }
          e.XfaText = n;
        },
        /* 26 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.TextLayerRenderTask = void 0, e.renderTextLayer = m, e.updateTextLayer = v;
          var a = n(1), s = n(6);
          const o = 1e5, l = 30, c = 0.8, u = /* @__PURE__ */ new Map();
          function d(y, A) {
            let b;
            if (A && a.FeatureTest.isOffscreenCanvasSupported)
              b = new OffscreenCanvas(y, y).getContext("2d", {
                alpha: !1
              });
            else {
              const C = document.createElement("canvas");
              C.width = C.height = y, b = C.getContext("2d", {
                alpha: !1
              });
            }
            return b;
          }
          function f(y, A) {
            const b = u.get(y);
            if (b)
              return b;
            const C = d(l, A);
            C.font = `${l}px ${y}`;
            const T = C.measureText("");
            let w = T.fontBoundingBoxAscent, R = Math.abs(T.fontBoundingBoxDescent);
            if (w) {
              const D = w / (w + R);
              return u.set(y, D), C.canvas.width = C.canvas.height = 0, D;
            }
            C.strokeStyle = "red", C.clearRect(0, 0, l, l), C.strokeText("g", 0, 0);
            let O = C.getImageData(0, 0, l, l).data;
            R = 0;
            for (let D = O.length - 1 - 3; D >= 0; D -= 4)
              if (O[D] > 0) {
                R = Math.ceil(D / 4 / l);
                break;
              }
            C.clearRect(0, 0, l, l), C.strokeText("A", 0, l), O = C.getImageData(0, 0, l, l).data, w = 0;
            for (let D = 0, k = O.length; D < k; D += 4)
              if (O[D] > 0) {
                w = l - Math.floor(D / 4 / l);
                break;
              }
            if (C.canvas.width = C.canvas.height = 0, w) {
              const D = w / (w + R);
              return u.set(y, D), D;
            }
            return u.set(y, c), c;
          }
          function h(y, A, b) {
            const C = document.createElement("span"), T = {
              angle: 0,
              canvasWidth: 0,
              hasText: A.str !== "",
              hasEOL: A.hasEOL,
              fontSize: 0
            };
            y._textDivs.push(C);
            const w = a.Util.transform(y._transform, A.transform);
            let R = Math.atan2(w[1], w[0]);
            const O = b[A.fontName];
            O.vertical && (R += Math.PI / 2);
            const D = Math.hypot(w[2], w[3]), k = D * f(O.fontFamily, y._isOffscreenCanvasSupported);
            let W, L;
            R === 0 ? (W = w[4], L = w[5] - k) : (W = w[4] + k * Math.sin(R), L = w[5] - k * Math.cos(R));
            const z = "calc(var(--scale-factor)*", P = C.style;
            y._container === y._rootContainer ? (P.left = `${(100 * W / y._pageWidth).toFixed(2)}%`, P.top = `${(100 * L / y._pageHeight).toFixed(2)}%`) : (P.left = `${z}${W.toFixed(2)}px)`, P.top = `${z}${L.toFixed(2)}px)`), P.fontSize = `${z}${D.toFixed(2)}px)`, P.fontFamily = O.fontFamily, T.fontSize = D, C.setAttribute("role", "presentation"), C.textContent = A.str, C.dir = A.dir, y._fontInspectorEnabled && (C.dataset.fontName = A.fontName), R !== 0 && (T.angle = R * (180 / Math.PI));
            let Q = !1;
            if (A.str.length > 1)
              Q = !0;
            else if (A.str !== " " && A.transform[0] !== A.transform[3]) {
              const Y = Math.abs(A.transform[0]), ie = Math.abs(A.transform[3]);
              Y !== ie && Math.max(Y, ie) / Math.min(Y, ie) > 1.5 && (Q = !0);
            }
            Q && (T.canvasWidth = O.vertical ? A.height : A.width), y._textDivProperties.set(C, T), y._isReadableStream && y._layoutText(C);
          }
          function g(y) {
            const {
              div: A,
              scale: b,
              properties: C,
              ctx: T,
              prevFontSize: w,
              prevFontFamily: R
            } = y, {
              style: O
            } = A;
            let D = "";
            if (C.canvasWidth !== 0 && C.hasText) {
              const {
                fontFamily: k
              } = O, {
                canvasWidth: W,
                fontSize: L
              } = C;
              (w !== L || R !== k) && (T.font = `${L * b}px ${k}`, y.prevFontSize = L, y.prevFontFamily = k);
              const {
                width: z
              } = T.measureText(A.textContent);
              z > 0 && (D = `scaleX(${W * b / z})`);
            }
            C.angle !== 0 && (D = `rotate(${C.angle}deg) ${D}`), D.length > 0 && (O.transform = D);
          }
          function x(y) {
            if (y._canceled)
              return;
            const A = y._textDivs, b = y._capability;
            if (A.length > o) {
              b.resolve();
              return;
            }
            if (!y._isReadableStream)
              for (const T of A)
                y._layoutText(T);
            b.resolve();
          }
          class E {
            constructor({
              textContentSource: A,
              container: b,
              viewport: C,
              textDivs: T,
              textDivProperties: w,
              textContentItemsStr: R,
              isOffscreenCanvasSupported: O
            }) {
              var z;
              this._textContentSource = A, this._isReadableStream = A instanceof ReadableStream, this._container = this._rootContainer = b, this._textDivs = T || [], this._textContentItemsStr = R || [], this._isOffscreenCanvasSupported = O, this._fontInspectorEnabled = !!((z = globalThis.FontInspector) != null && z.enabled), this._reader = null, this._textDivProperties = w || /* @__PURE__ */ new WeakMap(), this._canceled = !1, this._capability = new a.PromiseCapability(), this._layoutTextParams = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: C.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: d(0, O)
              };
              const {
                pageWidth: D,
                pageHeight: k,
                pageX: W,
                pageY: L
              } = C.rawDims;
              this._transform = [1, 0, 0, -1, -W, L + k], this._pageWidth = D, this._pageHeight = k, (0, s.setLayerDimensions)(b, C), this._capability.promise.finally(() => {
                this._layoutTextParams = null;
              }).catch(() => {
              });
            }
            get promise() {
              return this._capability.promise;
            }
            cancel() {
              this._canceled = !0, this._reader && (this._reader.cancel(new a.AbortException("TextLayer task cancelled.")).catch(() => {
              }), this._reader = null), this._capability.reject(new a.AbortException("TextLayer task cancelled."));
            }
            _processItems(A, b) {
              for (const C of A) {
                if (C.str === void 0) {
                  if (C.type === "beginMarkedContentProps" || C.type === "beginMarkedContent") {
                    const T = this._container;
                    this._container = document.createElement("span"), this._container.classList.add("markedContent"), C.id !== null && this._container.setAttribute("id", `${C.id}`), T.append(this._container);
                  } else
                    C.type === "endMarkedContent" && (this._container = this._container.parentNode);
                  continue;
                }
                this._textContentItemsStr.push(C.str), h(this, C, b);
              }
            }
            _layoutText(A) {
              const b = this._layoutTextParams.properties = this._textDivProperties.get(A);
              if (this._layoutTextParams.div = A, g(this._layoutTextParams), b.hasText && this._container.append(A), b.hasEOL) {
                const C = document.createElement("br");
                C.setAttribute("role", "presentation"), this._container.append(C);
              }
            }
            _render() {
              const A = new a.PromiseCapability();
              let b = /* @__PURE__ */ Object.create(null);
              if (this._isReadableStream) {
                const C = () => {
                  this._reader.read().then(({
                    value: T,
                    done: w
                  }) => {
                    if (w) {
                      A.resolve();
                      return;
                    }
                    Object.assign(b, T.styles), this._processItems(T.items, b), C();
                  }, A.reject);
                };
                this._reader = this._textContentSource.getReader(), C();
              } else if (this._textContentSource) {
                const {
                  items: C,
                  styles: T
                } = this._textContentSource;
                this._processItems(C, T), A.resolve();
              } else
                throw new Error('No "textContentSource" parameter specified.');
              A.promise.then(() => {
                b = null, x(this);
              }, this._capability.reject);
            }
          }
          e.TextLayerRenderTask = E;
          function m(y) {
            !y.textContentSource && (y.textContent || y.textContentStream) && ((0, s.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead."), y.textContentSource = y.textContent || y.textContentStream);
            const {
              container: A,
              viewport: b
            } = y, C = getComputedStyle(A), T = C.getPropertyValue("visibility"), w = parseFloat(C.getPropertyValue("--scale-factor"));
            T === "visible" && (!w || Math.abs(w - b.scale) > 1e-5) && console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
            const R = new E(y);
            return R._render(), R;
          }
          function v({
            container: y,
            viewport: A,
            textDivs: b,
            textDivProperties: C,
            isOffscreenCanvasSupported: T,
            mustRotate: w = !0,
            mustRescale: R = !0
          }) {
            if (w && (0, s.setLayerDimensions)(y, {
              rotation: A.rotation
            }), R) {
              const O = d(0, T), k = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: A.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: O
              };
              for (const W of b)
                k.properties = C.get(W), k.div = W, g(k);
            }
          }
        },
        /* 27 */
        /***/
        (t, e, n) => {
          var f, h, g, x, E, m, v, y, A, b, C, ci, w, xr, O, li, k, ui;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.AnnotationEditorLayer = void 0;
          var a = n(1), s = n(4), o = n(28), l = n(33), c = n(6), u = n(34);
          const L = class L {
            constructor({
              uiManager: P,
              pageIndex: Q,
              div: Y,
              accessibilityManager: ie,
              annotationLayer: te,
              viewport: Z,
              l10n: ae
            }) {
              Ge(this, C);
              Ge(this, w);
              Ge(this, O);
              Ge(this, k);
              Ge(this, f, void 0);
              Ge(this, h, !1);
              Ge(this, g, null);
              Ge(this, x, this.pointerup.bind(this));
              Ge(this, E, this.pointerdown.bind(this));
              Ge(this, m, /* @__PURE__ */ new Map());
              Ge(this, v, !1);
              Ge(this, y, !1);
              Ge(this, A, !1);
              Ge(this, b, void 0);
              const G = [o.FreeTextEditor, l.InkEditor, u.StampEditor];
              if (!L._initialized) {
                L._initialized = !0;
                for (const U of G)
                  U.initialize(ae);
              }
              P.registerEditorTypes(G), at(this, b, P), this.pageIndex = Q, this.div = Y, at(this, f, ie), at(this, g, te), this.viewport = Z, se(this, b).addLayer(this);
            }
            get isEmpty() {
              return se(this, m).size === 0;
            }
            updateToolbar(P) {
              se(this, b).updateToolbar(P);
            }
            updateMode(P = se(this, b).getMode()) {
              Ke(this, k, ui).call(this), P === a.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), P !== a.AnnotationEditorType.NONE && (this.div.classList.toggle("freeTextEditing", P === a.AnnotationEditorType.FREETEXT), this.div.classList.toggle("inkEditing", P === a.AnnotationEditorType.INK), this.div.classList.toggle("stampEditing", P === a.AnnotationEditorType.STAMP), this.div.hidden = !1);
            }
            addInkEditorIfNeeded(P) {
              if (!P && se(this, b).getMode() !== a.AnnotationEditorType.INK)
                return;
              if (!P) {
                for (const Y of se(this, m).values())
                  if (Y.isEmpty()) {
                    Y.setInBackground();
                    return;
                  }
              }
              Ke(this, w, xr).call(this, {
                offsetX: 0,
                offsetY: 0
              }, !1).setInBackground();
            }
            setEditingState(P) {
              se(this, b).setEditingState(P);
            }
            addCommands(P) {
              se(this, b).addCommands(P);
            }
            enable() {
              this.div.style.pointerEvents = "auto";
              const P = /* @__PURE__ */ new Set();
              for (const Y of se(this, m).values())
                Y.enableEditing(), Y.annotationElementId && P.add(Y.annotationElementId);
              if (!se(this, g))
                return;
              const Q = se(this, g).getEditableAnnotations();
              for (const Y of Q) {
                if (Y.hide(), se(this, b).isDeletedAnnotationElement(Y.data.id) || P.has(Y.data.id))
                  continue;
                const ie = this.deserialize(Y);
                ie && (this.addOrRebuild(ie), ie.enableEditing());
              }
            }
            disable() {
              var Q;
              at(this, A, !0), this.div.style.pointerEvents = "none";
              const P = /* @__PURE__ */ new Set();
              for (const Y of se(this, m).values()) {
                if (Y.disableEditing(), !Y.annotationElementId || Y.serialize() !== null) {
                  P.add(Y.annotationElementId);
                  continue;
                }
                (Q = this.getEditableAnnotation(Y.annotationElementId)) == null || Q.show(), Y.remove();
              }
              if (se(this, g)) {
                const Y = se(this, g).getEditableAnnotations();
                for (const ie of Y) {
                  const {
                    id: te
                  } = ie.data;
                  P.has(te) || se(this, b).isDeletedAnnotationElement(te) || ie.show();
                }
              }
              Ke(this, k, ui).call(this), this.isEmpty && (this.div.hidden = !0), at(this, A, !1);
            }
            getEditableAnnotation(P) {
              var Q;
              return ((Q = se(this, g)) == null ? void 0 : Q.getEditableAnnotation(P)) || null;
            }
            setActiveEditor(P) {
              se(this, b).getActive() !== P && se(this, b).setActiveEditor(P);
            }
            enableClick() {
              this.div.addEventListener("pointerdown", se(this, E)), this.div.addEventListener("pointerup", se(this, x));
            }
            disableClick() {
              this.div.removeEventListener("pointerdown", se(this, E)), this.div.removeEventListener("pointerup", se(this, x));
            }
            attach(P) {
              se(this, m).set(P.id, P);
              const {
                annotationElementId: Q
              } = P;
              Q && se(this, b).isDeletedAnnotationElement(Q) && se(this, b).removeDeletedAnnotationElement(P);
            }
            detach(P) {
              var Q;
              se(this, m).delete(P.id), (Q = se(this, f)) == null || Q.removePointerInTextLayer(P.contentDiv), !se(this, A) && P.annotationElementId && se(this, b).addDeletedAnnotationElement(P);
            }
            remove(P) {
              this.detach(P), se(this, b).removeEditor(P), P.div.contains(document.activeElement) && setTimeout(() => {
                se(this, b).focusMainContainer();
              }, 0), P.div.remove(), P.isAttachedToDOM = !1, se(this, y) || this.addInkEditorIfNeeded(!1);
            }
            changeParent(P) {
              var Q;
              P.parent !== this && (P.annotationElementId && (se(this, b).addDeletedAnnotationElement(P.annotationElementId), s.AnnotationEditor.deleteAnnotationElement(P), P.annotationElementId = null), this.attach(P), (Q = P.parent) == null || Q.detach(P), P.setParent(this), P.div && P.isAttachedToDOM && (P.div.remove(), this.div.append(P.div)));
            }
            add(P) {
              if (this.changeParent(P), se(this, b).addEditor(P), this.attach(P), !P.isAttachedToDOM) {
                const Q = P.render();
                this.div.append(Q), P.isAttachedToDOM = !0;
              }
              P.fixAndSetPosition(), P.onceAdded(), se(this, b).addToAnnotationStorage(P);
            }
            moveEditorInDOM(P) {
              var Y;
              if (!P.isAttachedToDOM)
                return;
              const {
                activeElement: Q
              } = document;
              P.div.contains(Q) && (P._focusEventsAllowed = !1, setTimeout(() => {
                P.div.contains(document.activeElement) ? P._focusEventsAllowed = !0 : (P.div.addEventListener("focusin", () => {
                  P._focusEventsAllowed = !0;
                }, {
                  once: !0
                }), Q.focus());
              }, 0)), P._structTreeParentId = (Y = se(this, f)) == null ? void 0 : Y.moveElementInDOM(this.div, P.div, P.contentDiv, !0);
            }
            addOrRebuild(P) {
              P.needsToBeRebuilt() ? P.rebuild() : this.add(P);
            }
            addUndoableEditor(P) {
              const Q = () => P._uiManager.rebuild(P), Y = () => {
                P.remove();
              };
              this.addCommands({
                cmd: Q,
                undo: Y,
                mustExec: !1
              });
            }
            getNextId() {
              return se(this, b).getId();
            }
            pasteEditor(P, Q) {
              se(this, b).updateToolbar(P), se(this, b).updateMode(P);
              const {
                offsetX: Y,
                offsetY: ie
              } = Ke(this, O, li).call(this), te = this.getNextId(), Z = Ke(this, C, ci).call(this, {
                parent: this,
                id: te,
                x: Y,
                y: ie,
                uiManager: se(this, b),
                isCentered: !0,
                ...Q
              });
              Z && this.add(Z);
            }
            deserialize(P) {
              switch (P.annotationType ?? P.annotationEditorType) {
                case a.AnnotationEditorType.FREETEXT:
                  return o.FreeTextEditor.deserialize(P, this, se(this, b));
                case a.AnnotationEditorType.INK:
                  return l.InkEditor.deserialize(P, this, se(this, b));
                case a.AnnotationEditorType.STAMP:
                  return u.StampEditor.deserialize(P, this, se(this, b));
              }
              return null;
            }
            addNewEditor() {
              Ke(this, w, xr).call(this, Ke(this, O, li).call(this), !0);
            }
            setSelected(P) {
              se(this, b).setSelected(P);
            }
            toggleSelected(P) {
              se(this, b).toggleSelected(P);
            }
            isSelected(P) {
              return se(this, b).isSelected(P);
            }
            unselect(P) {
              se(this, b).unselect(P);
            }
            pointerup(P) {
              const {
                isMac: Q
              } = a.FeatureTest.platform;
              if (!(P.button !== 0 || P.ctrlKey && Q) && P.target === this.div && se(this, v)) {
                if (at(this, v, !1), !se(this, h)) {
                  at(this, h, !0);
                  return;
                }
                if (se(this, b).getMode() === a.AnnotationEditorType.STAMP) {
                  se(this, b).unselectAll();
                  return;
                }
                Ke(this, w, xr).call(this, P, !1);
              }
            }
            pointerdown(P) {
              if (se(this, v)) {
                at(this, v, !1);
                return;
              }
              const {
                isMac: Q
              } = a.FeatureTest.platform;
              if (P.button !== 0 || P.ctrlKey && Q || P.target !== this.div)
                return;
              at(this, v, !0);
              const Y = se(this, b).getActive();
              at(this, h, !Y || Y.isEmpty());
            }
            findNewParent(P, Q, Y) {
              const ie = se(this, b).findParent(Q, Y);
              return ie === null || ie === this ? !1 : (ie.changeParent(P), !0);
            }
            destroy() {
              var P, Q;
              ((P = se(this, b).getActive()) == null ? void 0 : P.parent) === this && (se(this, b).commitOrRemove(), se(this, b).setActiveEditor(null));
              for (const Y of se(this, m).values())
                (Q = se(this, f)) == null || Q.removePointerInTextLayer(Y.contentDiv), Y.setParent(null), Y.isAttachedToDOM = !1, Y.div.remove();
              this.div = null, se(this, m).clear(), se(this, b).removeLayer(this);
            }
            render({
              viewport: P
            }) {
              this.viewport = P, (0, c.setLayerDimensions)(this.div, P);
              for (const Q of se(this, b).getEditors(this.pageIndex))
                this.add(Q);
              this.updateMode();
            }
            update({
              viewport: P
            }) {
              se(this, b).commitOrRemove(), this.viewport = P, (0, c.setLayerDimensions)(this.div, {
                rotation: P.rotation
              }), this.updateMode();
            }
            get pageDimensions() {
              const {
                pageWidth: P,
                pageHeight: Q
              } = this.viewport.rawDims;
              return [P, Q];
            }
          };
          f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakMap(), A = new WeakMap(), b = new WeakMap(), C = new WeakSet(), ci = function(P) {
            switch (se(this, b).getMode()) {
              case a.AnnotationEditorType.FREETEXT:
                return new o.FreeTextEditor(P);
              case a.AnnotationEditorType.INK:
                return new l.InkEditor(P);
              case a.AnnotationEditorType.STAMP:
                return new u.StampEditor(P);
            }
            return null;
          }, w = new WeakSet(), xr = function(P, Q) {
            const Y = this.getNextId(), ie = Ke(this, C, ci).call(this, {
              parent: this,
              id: Y,
              x: P.offsetX,
              y: P.offsetY,
              uiManager: se(this, b),
              isCentered: Q
            });
            return ie && this.add(ie), ie;
          }, O = new WeakSet(), li = function() {
            const {
              x: P,
              y: Q,
              width: Y,
              height: ie
            } = this.div.getBoundingClientRect(), te = Math.max(0, P), Z = Math.max(0, Q), ae = Math.min(window.innerWidth, P + Y), G = Math.min(window.innerHeight, Q + ie), U = (te + ae) / 2 - P, F = (Z + G) / 2 - Q, [M, I] = this.viewport.rotation % 180 === 0 ? [U, F] : [F, U];
            return {
              offsetX: M,
              offsetY: I
            };
          }, k = new WeakSet(), ui = function() {
            at(this, y, !0);
            for (const P of se(this, m).values())
              P.isEmpty() && P.remove();
            at(this, y, !1);
          }, Xt(L, "_initialized", !1);
          let d = L;
          e.AnnotationEditorLayer = d;
        },
        /* 28 */
        /***/
        (t, e, n) => {
          var u, d, f, h, g, x, E, m, v, y, Fa, b, Ia, T, Pa, R, Yn, D, di, W, La, z, fi;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.FreeTextEditor = void 0;
          var a = n(1), s = n(5), o = n(4), l = n(29);
          const Q = class Q extends o.AnnotationEditor {
            constructor(te) {
              super({
                ...te,
                name: "freeTextEditor"
              });
              Ge(this, y);
              Ge(this, b);
              Ge(this, T);
              Ge(this, R);
              Ge(this, D);
              Ge(this, W);
              Ge(this, z);
              Ge(this, u, this.editorDivBlur.bind(this));
              Ge(this, d, this.editorDivFocus.bind(this));
              Ge(this, f, this.editorDivInput.bind(this));
              Ge(this, h, this.editorDivKeydown.bind(this));
              Ge(this, g, void 0);
              Ge(this, x, "");
              Ge(this, E, `${this.id}-editor`);
              Ge(this, m, void 0);
              Ge(this, v, null);
              at(this, g, te.color || Q._defaultColor || o.AnnotationEditor._defaultLineColor), at(this, m, te.fontSize || Q._defaultFontSize);
            }
            static get _keyboardManager() {
              const te = Q.prototype, Z = (U) => U.isEmpty(), ae = s.AnnotationEditorUIManager.TRANSLATE_SMALL, G = s.AnnotationEditorUIManager.TRANSLATE_BIG;
              return (0, a.shadow)(this, "_keyboardManager", new s.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], te.commitOrRemove, {
                bubbles: !0
              }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], te.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], te._translateEmpty, {
                args: [-ae, 0],
                checker: Z
              }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], te._translateEmpty, {
                args: [-G, 0],
                checker: Z
              }], [["ArrowRight", "mac+ArrowRight"], te._translateEmpty, {
                args: [ae, 0],
                checker: Z
              }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], te._translateEmpty, {
                args: [G, 0],
                checker: Z
              }], [["ArrowUp", "mac+ArrowUp"], te._translateEmpty, {
                args: [0, -ae],
                checker: Z
              }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], te._translateEmpty, {
                args: [0, -G],
                checker: Z
              }], [["ArrowDown", "mac+ArrowDown"], te._translateEmpty, {
                args: [0, ae],
                checker: Z
              }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], te._translateEmpty, {
                args: [0, G],
                checker: Z
              }]]));
            }
            static initialize(te) {
              o.AnnotationEditor.initialize(te, {
                strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
              });
              const Z = getComputedStyle(document.documentElement);
              this._internalPadding = parseFloat(Z.getPropertyValue("--freetext-padding"));
            }
            static updateDefaultParams(te, Z) {
              switch (te) {
                case a.AnnotationEditorParamsType.FREETEXT_SIZE:
                  Q._defaultFontSize = Z;
                  break;
                case a.AnnotationEditorParamsType.FREETEXT_COLOR:
                  Q._defaultColor = Z;
                  break;
              }
            }
            updateParams(te, Z) {
              switch (te) {
                case a.AnnotationEditorParamsType.FREETEXT_SIZE:
                  Ke(this, y, Fa).call(this, Z);
                  break;
                case a.AnnotationEditorParamsType.FREETEXT_COLOR:
                  Ke(this, b, Ia).call(this, Z);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[a.AnnotationEditorParamsType.FREETEXT_SIZE, Q._defaultFontSize], [a.AnnotationEditorParamsType.FREETEXT_COLOR, Q._defaultColor || o.AnnotationEditor._defaultLineColor]];
            }
            get propertiesToUpdate() {
              return [[a.AnnotationEditorParamsType.FREETEXT_SIZE, se(this, m)], [a.AnnotationEditorParamsType.FREETEXT_COLOR, se(this, g)]];
            }
            _translateEmpty(te, Z) {
              this._uiManager.translateSelectedEditors(te, Z, !0);
            }
            getInitialTranslation() {
              const te = this.parentScale;
              return [-Q._internalPadding * te, -(Q._internalPadding + se(this, m)) * te];
            }
            rebuild() {
              this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
            }
            enableEditMode() {
              this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(a.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", se(this, h)), this.editorDiv.addEventListener("focus", se(this, d)), this.editorDiv.addEventListener("blur", se(this, u)), this.editorDiv.addEventListener("input", se(this, f)));
            }
            disableEditMode() {
              this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", se(this, E)), this._isDraggable = !0, this.editorDiv.removeEventListener("keydown", se(this, h)), this.editorDiv.removeEventListener("focus", se(this, d)), this.editorDiv.removeEventListener("blur", se(this, u)), this.editorDiv.removeEventListener("input", se(this, f)), this.div.focus({
                preventScroll: !0
              }), this.isEditing = !1, this.parent.div.classList.add("freeTextEditing"));
            }
            focusin(te) {
              this._focusEventsAllowed && (super.focusin(te), te.target !== this.editorDiv && this.editorDiv.focus());
            }
            onceAdded() {
              var te;
              if (this.width) {
                Ke(this, z, fi).call(this);
                return;
              }
              this.enableEditMode(), this.editorDiv.focus(), (te = this._initialOptions) != null && te.isCentered && this.center(), this._initialOptions = null;
            }
            isEmpty() {
              return !this.editorDiv || this.editorDiv.innerText.trim() === "";
            }
            remove() {
              this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freeTextEditing")), super.remove();
            }
            commit() {
              if (!this.isInEditMode())
                return;
              super.commit(), this.disableEditMode();
              const te = se(this, x), Z = at(this, x, Ke(this, T, Pa).call(this).trimEnd());
              if (te === Z)
                return;
              const ae = (G) => {
                if (at(this, x, G), !G) {
                  this.remove();
                  return;
                }
                Ke(this, D, di).call(this), this._uiManager.rebuild(this), Ke(this, R, Yn).call(this);
              };
              this.addCommands({
                cmd: () => {
                  ae(Z);
                },
                undo: () => {
                  ae(te);
                },
                mustExec: !1
              }), Ke(this, R, Yn).call(this);
            }
            shouldGetKeyboardEvents() {
              return this.isInEditMode();
            }
            enterInEditMode() {
              this.enableEditMode(), this.editorDiv.focus();
            }
            dblclick(te) {
              this.enterInEditMode();
            }
            keydown(te) {
              te.target === this.div && te.key === "Enter" && (this.enterInEditMode(), te.preventDefault());
            }
            editorDivKeydown(te) {
              Q._keyboardManager.exec(this, te);
            }
            editorDivFocus(te) {
              this.isEditing = !0;
            }
            editorDivBlur(te) {
              this.isEditing = !1;
            }
            editorDivInput(te) {
              this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
            }
            disableEditing() {
              this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
            }
            enableEditing() {
              this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
            }
            render() {
              if (this.div)
                return this.div;
              let te, Z;
              this.width && (te = this.x, Z = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", se(this, E)), this.enableEditing(), o.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((G) => {
                var U;
                return (U = this.editorDiv) == null ? void 0 : U.setAttribute("aria-label", G);
              }), o.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((G) => {
                var U;
                return (U = this.editorDiv) == null ? void 0 : U.setAttribute("default-content", G);
              }), this.editorDiv.contentEditable = !0;
              const {
                style: ae
              } = this.editorDiv;
              if (ae.fontSize = `calc(${se(this, m)}px * var(--scale-factor))`, ae.color = se(this, g), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, s.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                const [G, U] = this.parentDimensions;
                if (this.annotationElementId) {
                  const {
                    position: F
                  } = se(this, v);
                  let [M, I] = this.getInitialTranslation();
                  [M, I] = this.pageTranslationToScreen(M, I);
                  const [N, V] = this.pageDimensions, [q, H] = this.pageTranslation;
                  let ne, he;
                  switch (this.rotation) {
                    case 0:
                      ne = te + (F[0] - q) / N, he = Z + this.height - (F[1] - H) / V;
                      break;
                    case 90:
                      ne = te + (F[0] - q) / N, he = Z - (F[1] - H) / V, [M, I] = [I, -M];
                      break;
                    case 180:
                      ne = te - this.width + (F[0] - q) / N, he = Z - (F[1] - H) / V, [M, I] = [-M, -I];
                      break;
                    case 270:
                      ne = te + (F[0] - q - this.height * V) / N, he = Z + (F[1] - H - this.width * N) / V, [M, I] = [-I, M];
                      break;
                  }
                  this.setAt(ne * G, he * U, M, I);
                } else
                  this.setAt(te * G, Z * U, this.width * G, this.height * U);
                Ke(this, D, di).call(this), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
              } else
                this._isDraggable = !1, this.editorDiv.contentEditable = !0;
              return this.div;
            }
            get contentDiv() {
              return this.editorDiv;
            }
            static deserialize(te, Z, ae) {
              let G = null;
              if (te instanceof l.FreeTextAnnotationElement) {
                const {
                  data: {
                    defaultAppearanceData: {
                      fontSize: F,
                      fontColor: M
                    },
                    rect: I,
                    rotation: N,
                    id: V
                  },
                  textContent: q,
                  textPosition: H,
                  parent: {
                    page: {
                      pageNumber: ne
                    }
                  }
                } = te;
                if (!q || q.length === 0)
                  return null;
                G = te = {
                  annotationType: a.AnnotationEditorType.FREETEXT,
                  color: Array.from(M),
                  fontSize: F,
                  value: q.join(`
`),
                  position: H,
                  pageIndex: ne - 1,
                  rect: I,
                  rotation: N,
                  id: V,
                  deleted: !1
                };
              }
              const U = super.deserialize(te, Z, ae);
              return at(U, m, te.fontSize), at(U, g, a.Util.makeHexColor(...te.color)), at(U, x, te.value), U.annotationElementId = te.id || null, at(U, v, G), U;
            }
            serialize(te = !1) {
              if (this.isEmpty())
                return null;
              if (this.deleted)
                return {
                  pageIndex: this.pageIndex,
                  id: this.annotationElementId,
                  deleted: !0
                };
              const Z = Q._internalPadding * this.parentScale, ae = this.getRect(Z, Z), G = o.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : se(this, g)), U = {
                annotationType: a.AnnotationEditorType.FREETEXT,
                color: G,
                fontSize: se(this, m),
                value: se(this, x),
                pageIndex: this.pageIndex,
                rect: ae,
                rotation: this.rotation,
                structTreeParentId: this._structTreeParentId
              };
              return te ? U : this.annotationElementId && !Ke(this, W, La).call(this, U) ? null : (U.id = this.annotationElementId, U);
            }
          };
          u = new WeakMap(), d = new WeakMap(), f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakSet(), Fa = function(te) {
            const Z = (G) => {
              this.editorDiv.style.fontSize = `calc(${G}px * var(--scale-factor))`, this.translate(0, -(G - se(this, m)) * this.parentScale), at(this, m, G), Ke(this, R, Yn).call(this);
            }, ae = se(this, m);
            this.addCommands({
              cmd: () => {
                Z(te);
              },
              undo: () => {
                Z(ae);
              },
              mustExec: !0,
              type: a.AnnotationEditorParamsType.FREETEXT_SIZE,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, b = new WeakSet(), Ia = function(te) {
            const Z = se(this, g);
            this.addCommands({
              cmd: () => {
                at(this, g, this.editorDiv.style.color = te);
              },
              undo: () => {
                at(this, g, this.editorDiv.style.color = Z);
              },
              mustExec: !0,
              type: a.AnnotationEditorParamsType.FREETEXT_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, T = new WeakSet(), Pa = function() {
            const te = this.editorDiv.getElementsByTagName("div");
            if (te.length === 0)
              return this.editorDiv.innerText;
            const Z = [];
            for (const ae of te)
              Z.push(ae.innerText.replace(/\r\n?|\n/, ""));
            return Z.join(`
`);
          }, R = new WeakSet(), Yn = function() {
            const [te, Z] = this.parentDimensions;
            let ae;
            if (this.isAttachedToDOM)
              ae = this.div.getBoundingClientRect();
            else {
              const {
                currentLayer: G,
                div: U
              } = this, F = U.style.display;
              U.style.display = "hidden", G.div.append(this.div), ae = U.getBoundingClientRect(), U.remove(), U.style.display = F;
            }
            this.rotation % 180 === this.parentRotation % 180 ? (this.width = ae.width / te, this.height = ae.height / Z) : (this.width = ae.height / te, this.height = ae.width / Z), this.fixAndSetPosition();
          }, D = new WeakSet(), di = function() {
            if (this.editorDiv.replaceChildren(), !!se(this, x))
              for (const te of se(this, x).split(`
`)) {
                const Z = document.createElement("div");
                Z.append(te ? document.createTextNode(te) : document.createElement("br")), this.editorDiv.append(Z);
              }
          }, W = new WeakSet(), La = function(te) {
            const {
              value: Z,
              fontSize: ae,
              color: G,
              rect: U,
              pageIndex: F
            } = se(this, v);
            return te.value !== Z || te.fontSize !== ae || te.rect.some((M, I) => Math.abs(M - U[I]) >= 1) || te.color.some((M, I) => M !== G[I]) || te.pageIndex !== F;
          }, z = new WeakSet(), fi = function(te = !1) {
            if (!this.annotationElementId)
              return;
            if (Ke(this, R, Yn).call(this), !te && (this.width === 0 || this.height === 0)) {
              setTimeout(() => Ke(this, z, fi).call(this, !0), 0);
              return;
            }
            const Z = Q._internalPadding * this.parentScale;
            se(this, v).rect = this.getRect(Z, Z);
          }, Xt(Q, "_freeTextDefaultContent", ""), Xt(Q, "_internalPadding", 0), Xt(Q, "_defaultColor", null), Xt(Q, "_defaultFontSize", 10), Xt(Q, "_type", "freetext");
          let c = Q;
          e.FreeTextEditor = c;
        },
        /* 29 */
        /***/
        (t, e, n) => {
          var I, V, Rn, H, Ua, he, j, Fe, X, ye, Ae, fe, _e, Ie, Be, $e, Me, J, K, ge, Ce, Oe, qe, Oa, ze, yr, gt, hi, nt, pi, Ve, We, it, Je, Rt, je, ke, gi, Ze, rt, xt, bt, Na, mt, mi;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.StampAnnotationElement = e.InkAnnotationElement = e.FreeTextAnnotationElement = e.AnnotationLayer = void 0;
          var a = n(1), s = n(6), o = n(3), l = n(30), c = n(31), u = n(32);
          const d = 1e3, f = 9, h = /* @__PURE__ */ new WeakSet();
          function g(dt) {
            return {
              width: dt[2] - dt[0],
              height: dt[3] - dt[1]
            };
          }
          class x {
            static create(Le) {
              switch (Le.data.annotationType) {
                case a.AnnotationType.LINK:
                  return new m(Le);
                case a.AnnotationType.TEXT:
                  return new v(Le);
                case a.AnnotationType.WIDGET:
                  switch (Le.data.fieldType) {
                    case "Tx":
                      return new A(Le);
                    case "Btn":
                      return Le.data.radioButton ? new T(Le) : Le.data.checkBox ? new C(Le) : new w(Le);
                    case "Ch":
                      return new R(Le);
                    case "Sig":
                      return new b(Le);
                  }
                  return new y(Le);
                case a.AnnotationType.POPUP:
                  return new O(Le);
                case a.AnnotationType.FREETEXT:
                  return new k(Le);
                case a.AnnotationType.LINE:
                  return new W(Le);
                case a.AnnotationType.SQUARE:
                  return new L(Le);
                case a.AnnotationType.CIRCLE:
                  return new z(Le);
                case a.AnnotationType.POLYLINE:
                  return new P(Le);
                case a.AnnotationType.CARET:
                  return new Y(Le);
                case a.AnnotationType.INK:
                  return new ie(Le);
                case a.AnnotationType.POLYGON:
                  return new Q(Le);
                case a.AnnotationType.HIGHLIGHT:
                  return new te(Le);
                case a.AnnotationType.UNDERLINE:
                  return new Z(Le);
                case a.AnnotationType.SQUIGGLY:
                  return new ae(Le);
                case a.AnnotationType.STRIKEOUT:
                  return new G(Le);
                case a.AnnotationType.STAMP:
                  return new U(Le);
                case a.AnnotationType.FILEATTACHMENT:
                  return new F(Le);
                default:
                  return new E(Le);
              }
            }
          }
          const N = class N {
            constructor(Le, {
              isRenderable: ue = !1,
              ignoreBorder: De = !1,
              createQuadrilaterals: Ne = !1
            } = {}) {
              Ge(this, I, !1);
              this.isRenderable = ue, this.data = Le.data, this.layer = Le.layer, this.linkService = Le.linkService, this.downloadManager = Le.downloadManager, this.imageResourcesPath = Le.imageResourcesPath, this.renderForms = Le.renderForms, this.svgFactory = Le.svgFactory, this.annotationStorage = Le.annotationStorage, this.enableScripting = Le.enableScripting, this.hasJSActions = Le.hasJSActions, this._fieldObjects = Le.fieldObjects, this.parent = Le.parent, ue && (this.container = this._createContainer(De)), Ne && this._createQuadrilaterals();
            }
            static _hasPopupData({
              titleObj: Le,
              contentsObj: ue,
              richText: De
            }) {
              return !!(Le != null && Le.str || ue != null && ue.str || De != null && De.str);
            }
            get hasPopupData() {
              return N._hasPopupData(this.data);
            }
            _createContainer(Le) {
              const {
                data: ue,
                parent: {
                  page: De,
                  viewport: Ne
                }
              } = this, oe = document.createElement("section");
              oe.setAttribute("data-annotation-id", ue.id), this instanceof y || (oe.tabIndex = d), oe.style.zIndex = this.parent.zIndex++, this.data.popupRef && oe.setAttribute("aria-haspopup", "dialog"), ue.noRotate && oe.classList.add("norotate");
              const {
                pageWidth: ee,
                pageHeight: ce,
                pageX: pe,
                pageY: be
              } = Ne.rawDims;
              if (!ue.rect || this instanceof O) {
                const {
                  rotation: Se
                } = ue;
                return !ue.hasOwnCanvas && Se !== 0 && this.setRotation(Se, oe), oe;
              }
              const {
                width: Ee,
                height: He
              } = g(ue.rect), de = a.Util.normalizeRect([ue.rect[0], De.view[3] - ue.rect[1] + De.view[1], ue.rect[2], De.view[3] - ue.rect[3] + De.view[1]]);
              if (!Le && ue.borderStyle.width > 0) {
                oe.style.borderWidth = `${ue.borderStyle.width}px`;
                const Se = ue.borderStyle.horizontalCornerRadius, we = ue.borderStyle.verticalCornerRadius;
                if (Se > 0 || we > 0) {
                  const Qe = `calc(${Se}px * var(--scale-factor)) / calc(${we}px * var(--scale-factor))`;
                  oe.style.borderRadius = Qe;
                } else if (this instanceof T) {
                  const Qe = `calc(${Ee}px * var(--scale-factor)) / calc(${He}px * var(--scale-factor))`;
                  oe.style.borderRadius = Qe;
                }
                switch (ue.borderStyle.style) {
                  case a.AnnotationBorderStyleType.SOLID:
                    oe.style.borderStyle = "solid";
                    break;
                  case a.AnnotationBorderStyleType.DASHED:
                    oe.style.borderStyle = "dashed";
                    break;
                  case a.AnnotationBorderStyleType.BEVELED:
                    (0, a.warn)("Unimplemented border style: beveled");
                    break;
                  case a.AnnotationBorderStyleType.INSET:
                    (0, a.warn)("Unimplemented border style: inset");
                    break;
                  case a.AnnotationBorderStyleType.UNDERLINE:
                    oe.style.borderBottomStyle = "solid";
                    break;
                }
                const Ue = ue.borderColor || null;
                Ue ? (at(this, I, !0), oe.style.borderColor = a.Util.makeHexColor(Ue[0] | 0, Ue[1] | 0, Ue[2] | 0)) : oe.style.borderWidth = 0;
              }
              oe.style.left = `${100 * (de[0] - pe) / ee}%`, oe.style.top = `${100 * (de[1] - be) / ce}%`;
              const {
                rotation: ve
              } = ue;
              return ue.hasOwnCanvas || ve === 0 ? (oe.style.width = `${100 * Ee / ee}%`, oe.style.height = `${100 * He / ce}%`) : this.setRotation(ve, oe), oe;
            }
            setRotation(Le, ue = this.container) {
              if (!this.data.rect)
                return;
              const {
                pageWidth: De,
                pageHeight: Ne
              } = this.parent.viewport.rawDims, {
                width: oe,
                height: ee
              } = g(this.data.rect);
              let ce, pe;
              Le % 180 === 0 ? (ce = 100 * oe / De, pe = 100 * ee / Ne) : (ce = 100 * ee / De, pe = 100 * oe / Ne), ue.style.width = `${ce}%`, ue.style.height = `${pe}%`, ue.setAttribute("data-main-rotation", (360 - Le) % 360);
            }
            get _commonActions() {
              const Le = (ue, De, Ne) => {
                const oe = Ne.detail[ue], ee = oe[0], ce = oe.slice(1);
                Ne.target.style[De] = l.ColorConverters[`${ee}_HTML`](ce), this.annotationStorage.setValue(this.data.id, {
                  [De]: l.ColorConverters[`${ee}_rgb`](ce)
                });
              };
              return (0, a.shadow)(this, "_commonActions", {
                display: (ue) => {
                  const {
                    display: De
                  } = ue.detail, Ne = De % 2 === 1;
                  this.container.style.visibility = Ne ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    noView: Ne,
                    noPrint: De === 1 || De === 2
                  });
                },
                print: (ue) => {
                  this.annotationStorage.setValue(this.data.id, {
                    noPrint: !ue.detail.print
                  });
                },
                hidden: (ue) => {
                  const {
                    hidden: De
                  } = ue.detail;
                  this.container.style.visibility = De ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    noPrint: De,
                    noView: De
                  });
                },
                focus: (ue) => {
                  setTimeout(() => ue.target.focus({
                    preventScroll: !1
                  }), 0);
                },
                userName: (ue) => {
                  ue.target.title = ue.detail.userName;
                },
                readonly: (ue) => {
                  ue.target.disabled = ue.detail.readonly;
                },
                required: (ue) => {
                  this._setRequired(ue.target, ue.detail.required);
                },
                bgColor: (ue) => {
                  Le("bgColor", "backgroundColor", ue);
                },
                fillColor: (ue) => {
                  Le("fillColor", "backgroundColor", ue);
                },
                fgColor: (ue) => {
                  Le("fgColor", "color", ue);
                },
                textColor: (ue) => {
                  Le("textColor", "color", ue);
                },
                borderColor: (ue) => {
                  Le("borderColor", "borderColor", ue);
                },
                strokeColor: (ue) => {
                  Le("strokeColor", "borderColor", ue);
                },
                rotation: (ue) => {
                  const De = ue.detail.rotation;
                  this.setRotation(De), this.annotationStorage.setValue(this.data.id, {
                    rotation: De
                  });
                }
              });
            }
            _dispatchEventFromSandbox(Le, ue) {
              const De = this._commonActions;
              for (const Ne of Object.keys(ue.detail)) {
                const oe = Le[Ne] || De[Ne];
                oe == null || oe(ue);
              }
            }
            _setDefaultPropertiesFromJS(Le) {
              if (!this.enableScripting)
                return;
              const ue = this.annotationStorage.getRawValue(this.data.id);
              if (!ue)
                return;
              const De = this._commonActions;
              for (const [Ne, oe] of Object.entries(ue)) {
                const ee = De[Ne];
                if (ee) {
                  const ce = {
                    detail: {
                      [Ne]: oe
                    },
                    target: Le
                  };
                  ee(ce), delete ue[Ne];
                }
              }
            }
            _createQuadrilaterals() {
              if (!this.container)
                return;
              const {
                quadPoints: Le
              } = this.data;
              if (!Le)
                return;
              const [ue, De, Ne, oe] = this.data.rect;
              if (Le.length === 1) {
                const [, {
                  x: we,
                  y: Ue
                }, {
                  x: Qe,
                  y: ft
                }] = Le[0];
                if (Ne === we && oe === Ue && ue === Qe && De === ft)
                  return;
              }
              const {
                style: ee
              } = this.container;
              let ce;
              if (se(this, I)) {
                const {
                  borderColor: we,
                  borderWidth: Ue
                } = ee;
                ee.borderWidth = 0, ce = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${we}" stroke-width="${Ue}">`], this.container.classList.add("hasBorder");
              }
              const pe = Ne - ue, be = oe - De, {
                svgFactory: Ee
              } = this, He = Ee.createElement("svg");
              He.classList.add("quadrilateralsContainer"), He.setAttribute("width", 0), He.setAttribute("height", 0);
              const de = Ee.createElement("defs");
              He.append(de);
              const ve = Ee.createElement("clipPath"), Se = `clippath_${this.data.id}`;
              ve.setAttribute("id", Se), ve.setAttribute("clipPathUnits", "objectBoundingBox"), de.append(ve);
              for (const [, {
                x: we,
                y: Ue
              }, {
                x: Qe,
                y: ft
              }] of Le) {
                const ut = Ee.createElement("rect"), _t = (Qe - ue) / pe, At = (oe - Ue) / be, Dt = (we - Qe) / pe, Mt = (Ue - ft) / be;
                ut.setAttribute("x", _t), ut.setAttribute("y", At), ut.setAttribute("width", Dt), ut.setAttribute("height", Mt), ve.append(ut), ce == null || ce.push(`<rect vector-effect="non-scaling-stroke" x="${_t}" y="${At}" width="${Dt}" height="${Mt}"/>`);
              }
              se(this, I) && (ce.push("</g></svg>')"), ee.backgroundImage = ce.join("")), this.container.append(He), this.container.style.clipPath = `url(#${Se})`;
            }
            _createPopup() {
              const {
                container: Le,
                data: ue
              } = this;
              Le.setAttribute("aria-haspopup", "dialog");
              const De = new O({
                data: {
                  color: ue.color,
                  titleObj: ue.titleObj,
                  modificationDate: ue.modificationDate,
                  contentsObj: ue.contentsObj,
                  richText: ue.richText,
                  parentRect: ue.rect,
                  borderStyle: 0,
                  id: `popup_${ue.id}`,
                  rotation: ue.rotation
                },
                parent: this.parent,
                elements: [this]
              });
              this.parent.div.append(De.render());
            }
            render() {
              (0, a.unreachable)("Abstract method `AnnotationElement.render` called");
            }
            _getElementsByName(Le, ue = null) {
              const De = [];
              if (this._fieldObjects) {
                const Ne = this._fieldObjects[Le];
                if (Ne)
                  for (const {
                    page: oe,
                    id: ee,
                    exportValues: ce
                  } of Ne) {
                    if (oe === -1 || ee === ue)
                      continue;
                    const pe = typeof ce == "string" ? ce : null, be = document.querySelector(`[data-element-id="${ee}"]`);
                    if (be && !h.has(be)) {
                      (0, a.warn)(`_getElementsByName - element not allowed: ${ee}`);
                      continue;
                    }
                    De.push({
                      id: ee,
                      exportValue: pe,
                      domElement: be
                    });
                  }
                return De;
              }
              for (const Ne of document.getElementsByName(Le)) {
                const {
                  exportValue: oe
                } = Ne, ee = Ne.getAttribute("data-element-id");
                ee !== ue && h.has(Ne) && De.push({
                  id: ee,
                  exportValue: oe,
                  domElement: Ne
                });
              }
              return De;
            }
            show() {
              var Le;
              this.container && (this.container.hidden = !1), (Le = this.popup) == null || Le.maybeShow();
            }
            hide() {
              var Le;
              this.container && (this.container.hidden = !0), (Le = this.popup) == null || Le.forceHide();
            }
            getElementsToTriggerPopup() {
              return this.container;
            }
            addHighlightArea() {
              const Le = this.getElementsToTriggerPopup();
              if (Array.isArray(Le))
                for (const ue of Le)
                  ue.classList.add("highlightArea");
              else
                Le.classList.add("highlightArea");
            }
            _editOnDoubleClick() {
              const {
                annotationEditorType: Le,
                data: {
                  id: ue
                }
              } = this;
              this.container.addEventListener("dblclick", () => {
                var De;
                (De = this.linkService.eventBus) == null || De.dispatch("switchannotationeditormode", {
                  source: this,
                  mode: Le,
                  editId: ue
                });
              });
            }
          };
          I = new WeakMap();
          let E = N;
          class m extends E {
            constructor(ue, De = null) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !!(De != null && De.ignoreBorder),
                createQuadrilaterals: !0
              });
              Ge(this, V);
              Ge(this, H);
              this.isTooltipOnly = ue.data.isTooltipOnly;
            }
            render() {
              const {
                data: ue,
                linkService: De
              } = this, Ne = document.createElement("a");
              Ne.setAttribute("data-element-id", ue.id);
              let oe = !1;
              return ue.url ? (De.addLinkAttributes(Ne, ue.url, ue.newWindow), oe = !0) : ue.action ? (this._bindNamedAction(Ne, ue.action), oe = !0) : ue.attachment ? (this._bindAttachment(Ne, ue.attachment), oe = !0) : ue.setOCGState ? (Ke(this, H, Ua).call(this, Ne, ue.setOCGState), oe = !0) : ue.dest ? (this._bindLink(Ne, ue.dest), oe = !0) : (ue.actions && (ue.actions.Action || ue.actions["Mouse Up"] || ue.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(Ne, ue), oe = !0), ue.resetForm ? (this._bindResetFormAction(Ne, ue.resetForm), oe = !0) : this.isTooltipOnly && !oe && (this._bindLink(Ne, ""), oe = !0)), this.container.classList.add("linkAnnotation"), oe && this.container.append(Ne), this.container;
            }
            _bindLink(ue, De) {
              ue.href = this.linkService.getDestinationHash(De), ue.onclick = () => (De && this.linkService.goToDestination(De), !1), (De || De === "") && Ke(this, V, Rn).call(this);
            }
            _bindNamedAction(ue, De) {
              ue.href = this.linkService.getAnchorUrl(""), ue.onclick = () => (this.linkService.executeNamedAction(De), !1), Ke(this, V, Rn).call(this);
            }
            _bindAttachment(ue, De) {
              ue.href = this.linkService.getAnchorUrl(""), ue.onclick = () => {
                var Ne;
                return (Ne = this.downloadManager) == null || Ne.openOrDownloadData(this.container, De.content, De.filename), !1;
              }, Ke(this, V, Rn).call(this);
            }
            _bindJSAction(ue, De) {
              ue.href = this.linkService.getAnchorUrl("");
              const Ne = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
              for (const oe of Object.keys(De.actions)) {
                const ee = Ne.get(oe);
                ee && (ue[ee] = () => {
                  var ce;
                  return (ce = this.linkService.eventBus) == null || ce.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: De.id,
                      name: oe
                    }
                  }), !1;
                });
              }
              ue.onclick || (ue.onclick = () => !1), Ke(this, V, Rn).call(this);
            }
            _bindResetFormAction(ue, De) {
              const Ne = ue.onclick;
              if (Ne || (ue.href = this.linkService.getAnchorUrl("")), Ke(this, V, Rn).call(this), !this._fieldObjects) {
                (0, a.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), Ne || (ue.onclick = () => !1);
                return;
              }
              ue.onclick = () => {
                var He;
                Ne == null || Ne();
                const {
                  fields: oe,
                  refs: ee,
                  include: ce
                } = De, pe = [];
                if (oe.length !== 0 || ee.length !== 0) {
                  const de = new Set(ee);
                  for (const ve of oe) {
                    const Se = this._fieldObjects[ve] || [];
                    for (const {
                      id: we
                    } of Se)
                      de.add(we);
                  }
                  for (const ve of Object.values(this._fieldObjects))
                    for (const Se of ve)
                      de.has(Se.id) === ce && pe.push(Se);
                } else
                  for (const de of Object.values(this._fieldObjects))
                    pe.push(...de);
                const be = this.annotationStorage, Ee = [];
                for (const de of pe) {
                  const {
                    id: ve
                  } = de;
                  switch (Ee.push(ve), de.type) {
                    case "text": {
                      const we = de.defaultValue || "";
                      be.setValue(ve, {
                        value: we
                      });
                      break;
                    }
                    case "checkbox":
                    case "radiobutton": {
                      const we = de.defaultValue === de.exportValues;
                      be.setValue(ve, {
                        value: we
                      });
                      break;
                    }
                    case "combobox":
                    case "listbox": {
                      const we = de.defaultValue || "";
                      be.setValue(ve, {
                        value: we
                      });
                      break;
                    }
                    default:
                      continue;
                  }
                  const Se = document.querySelector(`[data-element-id="${ve}"]`);
                  if (Se) {
                    if (!h.has(Se)) {
                      (0, a.warn)(`_bindResetFormAction - element not allowed: ${ve}`);
                      continue;
                    }
                  } else
                    continue;
                  Se.dispatchEvent(new Event("resetform"));
                }
                return this.enableScripting && ((He = this.linkService.eventBus) == null || He.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: "app",
                    ids: Ee,
                    name: "ResetForm"
                  }
                })), !1;
              };
            }
          }
          V = new WeakSet(), Rn = function() {
            this.container.setAttribute("data-internal-link", "");
          }, H = new WeakSet(), Ua = function(ue, De) {
            ue.href = this.linkService.getAnchorUrl(""), ue.onclick = () => (this.linkService.executeSetOCGState(De), !1), Ke(this, V, Rn).call(this);
          };
          class v extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0
              });
            }
            render() {
              this.container.classList.add("textAnnotation");
              const Le = document.createElement("img");
              return Le.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", Le.alt = "[{{type}} Annotation]", Le.dataset.l10nId = "text_annotation_type", Le.dataset.l10nArgs = JSON.stringify({
                type: this.data.name
              }), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(Le), this.container;
            }
          }
          class y extends E {
            render() {
              return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
            }
            showElementAndHideCanvas(Le) {
              var ue;
              this.data.hasOwnCanvas && (((ue = Le.previousSibling) == null ? void 0 : ue.nodeName) === "CANVAS" && (Le.previousSibling.hidden = !0), Le.hidden = !1);
            }
            _getKeyModifier(Le) {
              const {
                isWin: ue,
                isMac: De
              } = a.FeatureTest.platform;
              return ue && Le.ctrlKey || De && Le.metaKey;
            }
            _setEventListener(Le, ue, De, Ne, oe) {
              De.includes("mouse") ? Le.addEventListener(De, (ee) => {
                var ce;
                (ce = this.linkService.eventBus) == null || ce.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: Ne,
                    value: oe(ee),
                    shift: ee.shiftKey,
                    modifier: this._getKeyModifier(ee)
                  }
                });
              }) : Le.addEventListener(De, (ee) => {
                var ce;
                if (De === "blur") {
                  if (!ue.focused || !ee.relatedTarget)
                    return;
                  ue.focused = !1;
                } else if (De === "focus") {
                  if (ue.focused)
                    return;
                  ue.focused = !0;
                }
                oe && ((ce = this.linkService.eventBus) == null || ce.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: Ne,
                    value: oe(ee)
                  }
                }));
              });
            }
            _setEventListeners(Le, ue, De, Ne) {
              var oe, ee, ce;
              for (const [pe, be] of De)
                (be === "Action" || (oe = this.data.actions) != null && oe[be]) && ((be === "Focus" || be === "Blur") && (ue || (ue = {
                  focused: !1
                })), this._setEventListener(Le, ue, pe, be, Ne), be === "Focus" && !((ee = this.data.actions) != null && ee.Blur) ? this._setEventListener(Le, ue, "blur", "Blur", null) : be === "Blur" && !((ce = this.data.actions) != null && ce.Focus) && this._setEventListener(Le, ue, "focus", "Focus", null));
            }
            _setBackgroundColor(Le) {
              const ue = this.data.backgroundColor || null;
              Le.style.backgroundColor = ue === null ? "transparent" : a.Util.makeHexColor(ue[0], ue[1], ue[2]);
            }
            _setTextStyle(Le) {
              const ue = ["left", "center", "right"], {
                fontColor: De
              } = this.data.defaultAppearanceData, Ne = this.data.defaultAppearanceData.fontSize || f, oe = Le.style;
              let ee;
              const ce = 2, pe = (be) => Math.round(10 * be) / 10;
              if (this.data.multiLine) {
                const be = Math.abs(this.data.rect[3] - this.data.rect[1] - ce), Ee = Math.round(be / (a.LINE_FACTOR * Ne)) || 1, He = be / Ee;
                ee = Math.min(Ne, pe(He / a.LINE_FACTOR));
              } else {
                const be = Math.abs(this.data.rect[3] - this.data.rect[1] - ce);
                ee = Math.min(Ne, pe(be / a.LINE_FACTOR));
              }
              oe.fontSize = `calc(${ee}px * var(--scale-factor))`, oe.color = a.Util.makeHexColor(De[0], De[1], De[2]), this.data.textAlignment !== null && (oe.textAlign = ue[this.data.textAlignment]);
            }
            _setRequired(Le, ue) {
              ue ? Le.setAttribute("required", !0) : Le.removeAttribute("required"), Le.setAttribute("aria-required", ue);
            }
          }
          class A extends y {
            constructor(Le) {
              const ue = Le.renderForms || !Le.data.hasAppearance && !!Le.data.fieldValue;
              super(Le, {
                isRenderable: ue
              });
            }
            setPropertyOnSiblings(Le, ue, De, Ne) {
              const oe = this.annotationStorage;
              for (const ee of this._getElementsByName(Le.name, Le.id))
                ee.domElement && (ee.domElement[ue] = De), oe.setValue(ee.id, {
                  [Ne]: De
                });
            }
            render() {
              var Ne, oe;
              const Le = this.annotationStorage, ue = this.data.id;
              this.container.classList.add("textWidgetAnnotation");
              let De = null;
              if (this.renderForms) {
                const ee = Le.getValue(ue, {
                  value: this.data.fieldValue
                });
                let ce = ee.value || "";
                const pe = Le.getValue(ue, {
                  charLimit: this.data.maxLen
                }).charLimit;
                pe && ce.length > pe && (ce = ce.slice(0, pe));
                let be = ee.formattedValue || ((Ne = this.data.textContent) == null ? void 0 : Ne.join(`
`)) || null;
                be && this.data.comb && (be = be.replaceAll(/\s+/g, ""));
                const Ee = {
                  userValue: ce,
                  formattedValue: be,
                  lastCommittedValue: null,
                  commitKey: 1,
                  focused: !1
                };
                this.data.multiLine ? (De = document.createElement("textarea"), De.textContent = be ?? ce, this.data.doNotScroll && (De.style.overflowY = "hidden")) : (De = document.createElement("input"), De.type = "text", De.setAttribute("value", be ?? ce), this.data.doNotScroll && (De.style.overflowX = "hidden")), this.data.hasOwnCanvas && (De.hidden = !0), h.add(De), De.setAttribute("data-element-id", ue), De.disabled = this.data.readOnly, De.name = this.data.fieldName, De.tabIndex = d, this._setRequired(De, this.data.required), pe && (De.maxLength = pe), De.addEventListener("input", (de) => {
                  Le.setValue(ue, {
                    value: de.target.value
                  }), this.setPropertyOnSiblings(De, "value", de.target.value, "value"), Ee.formattedValue = null;
                }), De.addEventListener("resetform", (de) => {
                  const ve = this.data.defaultFieldValue ?? "";
                  De.value = Ee.userValue = ve, Ee.formattedValue = null;
                });
                let He = (de) => {
                  const {
                    formattedValue: ve
                  } = Ee;
                  ve != null && (de.target.value = ve), de.target.scrollLeft = 0;
                };
                if (this.enableScripting && this.hasJSActions) {
                  De.addEventListener("focus", (ve) => {
                    if (Ee.focused)
                      return;
                    const {
                      target: Se
                    } = ve;
                    Ee.userValue && (Se.value = Ee.userValue), Ee.lastCommittedValue = Se.value, Ee.commitKey = 1, Ee.focused = !0;
                  }), De.addEventListener("updatefromsandbox", (ve) => {
                    this.showElementAndHideCanvas(ve.target);
                    const Se = {
                      value(we) {
                        Ee.userValue = we.detail.value ?? "", Le.setValue(ue, {
                          value: Ee.userValue.toString()
                        }), we.target.value = Ee.userValue;
                      },
                      formattedValue(we) {
                        const {
                          formattedValue: Ue
                        } = we.detail;
                        Ee.formattedValue = Ue, Ue != null && we.target !== document.activeElement && (we.target.value = Ue), Le.setValue(ue, {
                          formattedValue: Ue
                        });
                      },
                      selRange(we) {
                        we.target.setSelectionRange(...we.detail.selRange);
                      },
                      charLimit: (we) => {
                        var ut;
                        const {
                          charLimit: Ue
                        } = we.detail, {
                          target: Qe
                        } = we;
                        if (Ue === 0) {
                          Qe.removeAttribute("maxLength");
                          return;
                        }
                        Qe.setAttribute("maxLength", Ue);
                        let ft = Ee.userValue;
                        !ft || ft.length <= Ue || (ft = ft.slice(0, Ue), Qe.value = Ee.userValue = ft, Le.setValue(ue, {
                          value: ft
                        }), (ut = this.linkService.eventBus) == null || ut.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id: ue,
                            name: "Keystroke",
                            value: ft,
                            willCommit: !0,
                            commitKey: 1,
                            selStart: Qe.selectionStart,
                            selEnd: Qe.selectionEnd
                          }
                        }));
                      }
                    };
                    this._dispatchEventFromSandbox(Se, ve);
                  }), De.addEventListener("keydown", (ve) => {
                    var Ue;
                    Ee.commitKey = 1;
                    let Se = -1;
                    if (ve.key === "Escape" ? Se = 0 : ve.key === "Enter" && !this.data.multiLine ? Se = 2 : ve.key === "Tab" && (Ee.commitKey = 3), Se === -1)
                      return;
                    const {
                      value: we
                    } = ve.target;
                    Ee.lastCommittedValue !== we && (Ee.lastCommittedValue = we, Ee.userValue = we, (Ue = this.linkService.eventBus) == null || Ue.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: ue,
                        name: "Keystroke",
                        value: we,
                        willCommit: !0,
                        commitKey: Se,
                        selStart: ve.target.selectionStart,
                        selEnd: ve.target.selectionEnd
                      }
                    }));
                  });
                  const de = He;
                  He = null, De.addEventListener("blur", (ve) => {
                    var we;
                    if (!Ee.focused || !ve.relatedTarget)
                      return;
                    Ee.focused = !1;
                    const {
                      value: Se
                    } = ve.target;
                    Ee.userValue = Se, Ee.lastCommittedValue !== Se && ((we = this.linkService.eventBus) == null || we.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: ue,
                        name: "Keystroke",
                        value: Se,
                        willCommit: !0,
                        commitKey: Ee.commitKey,
                        selStart: ve.target.selectionStart,
                        selEnd: ve.target.selectionEnd
                      }
                    })), de(ve);
                  }), (oe = this.data.actions) != null && oe.Keystroke && De.addEventListener("beforeinput", (ve) => {
                    var At;
                    Ee.lastCommittedValue = null;
                    const {
                      data: Se,
                      target: we
                    } = ve, {
                      value: Ue,
                      selectionStart: Qe,
                      selectionEnd: ft
                    } = we;
                    let ut = Qe, _t = ft;
                    switch (ve.inputType) {
                      case "deleteWordBackward": {
                        const Dt = Ue.substring(0, Qe).match(/\w*[^\w]*$/);
                        Dt && (ut -= Dt[0].length);
                        break;
                      }
                      case "deleteWordForward": {
                        const Dt = Ue.substring(Qe).match(/^[^\w]*\w*/);
                        Dt && (_t += Dt[0].length);
                        break;
                      }
                      case "deleteContentBackward":
                        Qe === ft && (ut -= 1);
                        break;
                      case "deleteContentForward":
                        Qe === ft && (_t += 1);
                        break;
                    }
                    ve.preventDefault(), (At = this.linkService.eventBus) == null || At.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: ue,
                        name: "Keystroke",
                        value: Ue,
                        change: Se || "",
                        willCommit: !1,
                        selStart: ut,
                        selEnd: _t
                      }
                    });
                  }), this._setEventListeners(De, Ee, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (ve) => ve.target.value);
                }
                if (He && De.addEventListener("blur", He), this.data.comb) {
                  const ve = (this.data.rect[2] - this.data.rect[0]) / pe;
                  De.classList.add("comb"), De.style.letterSpacing = `calc(${ve}px * var(--scale-factor) - 1ch)`;
                }
              } else
                De = document.createElement("div"), De.textContent = this.data.fieldValue, De.style.verticalAlign = "middle", De.style.display = "table-cell";
              return this._setTextStyle(De), this._setBackgroundColor(De), this._setDefaultPropertiesFromJS(De), this.container.append(De), this.container;
            }
          }
          class b extends y {
            constructor(Le) {
              super(Le, {
                isRenderable: !!Le.data.hasOwnCanvas
              });
            }
          }
          class C extends y {
            constructor(Le) {
              super(Le, {
                isRenderable: Le.renderForms
              });
            }
            render() {
              const Le = this.annotationStorage, ue = this.data, De = ue.id;
              let Ne = Le.getValue(De, {
                value: ue.exportValue === ue.fieldValue
              }).value;
              typeof Ne == "string" && (Ne = Ne !== "Off", Le.setValue(De, {
                value: Ne
              })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
              const oe = document.createElement("input");
              return h.add(oe), oe.setAttribute("data-element-id", De), oe.disabled = ue.readOnly, this._setRequired(oe, this.data.required), oe.type = "checkbox", oe.name = ue.fieldName, Ne && oe.setAttribute("checked", !0), oe.setAttribute("exportValue", ue.exportValue), oe.tabIndex = d, oe.addEventListener("change", (ee) => {
                const {
                  name: ce,
                  checked: pe
                } = ee.target;
                for (const be of this._getElementsByName(ce, De)) {
                  const Ee = pe && be.exportValue === ue.exportValue;
                  be.domElement && (be.domElement.checked = Ee), Le.setValue(be.id, {
                    value: Ee
                  });
                }
                Le.setValue(De, {
                  value: pe
                });
              }), oe.addEventListener("resetform", (ee) => {
                const ce = ue.defaultFieldValue || "Off";
                ee.target.checked = ce === ue.exportValue;
              }), this.enableScripting && this.hasJSActions && (oe.addEventListener("updatefromsandbox", (ee) => {
                const ce = {
                  value(pe) {
                    pe.target.checked = pe.detail.value !== "Off", Le.setValue(De, {
                      value: pe.target.checked
                    });
                  }
                };
                this._dispatchEventFromSandbox(ce, ee);
              }), this._setEventListeners(oe, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (ee) => ee.target.checked)), this._setBackgroundColor(oe), this._setDefaultPropertiesFromJS(oe), this.container.append(oe), this.container;
            }
          }
          class T extends y {
            constructor(Le) {
              super(Le, {
                isRenderable: Le.renderForms
              });
            }
            render() {
              this.container.classList.add("buttonWidgetAnnotation", "radioButton");
              const Le = this.annotationStorage, ue = this.data, De = ue.id;
              let Ne = Le.getValue(De, {
                value: ue.fieldValue === ue.buttonValue
              }).value;
              typeof Ne == "string" && (Ne = Ne !== ue.buttonValue, Le.setValue(De, {
                value: Ne
              }));
              const oe = document.createElement("input");
              if (h.add(oe), oe.setAttribute("data-element-id", De), oe.disabled = ue.readOnly, this._setRequired(oe, this.data.required), oe.type = "radio", oe.name = ue.fieldName, Ne && oe.setAttribute("checked", !0), oe.tabIndex = d, oe.addEventListener("change", (ee) => {
                const {
                  name: ce,
                  checked: pe
                } = ee.target;
                for (const be of this._getElementsByName(ce, De))
                  Le.setValue(be.id, {
                    value: !1
                  });
                Le.setValue(De, {
                  value: pe
                });
              }), oe.addEventListener("resetform", (ee) => {
                const ce = ue.defaultFieldValue;
                ee.target.checked = ce != null && ce === ue.buttonValue;
              }), this.enableScripting && this.hasJSActions) {
                const ee = ue.buttonValue;
                oe.addEventListener("updatefromsandbox", (ce) => {
                  const pe = {
                    value: (be) => {
                      const Ee = ee === be.detail.value;
                      for (const He of this._getElementsByName(be.target.name)) {
                        const de = Ee && He.id === De;
                        He.domElement && (He.domElement.checked = de), Le.setValue(He.id, {
                          value: de
                        });
                      }
                    }
                  };
                  this._dispatchEventFromSandbox(pe, ce);
                }), this._setEventListeners(oe, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (ce) => ce.target.checked);
              }
              return this._setBackgroundColor(oe), this._setDefaultPropertiesFromJS(oe), this.container.append(oe), this.container;
            }
          }
          class w extends m {
            constructor(Le) {
              super(Le, {
                ignoreBorder: Le.data.hasAppearance
              });
            }
            render() {
              const Le = super.render();
              Le.classList.add("buttonWidgetAnnotation", "pushButton"), this.data.alternativeText && (Le.title = this.data.alternativeText);
              const ue = Le.lastChild;
              return this.enableScripting && this.hasJSActions && ue && (this._setDefaultPropertiesFromJS(ue), ue.addEventListener("updatefromsandbox", (De) => {
                this._dispatchEventFromSandbox({}, De);
              })), Le;
            }
          }
          class R extends y {
            constructor(Le) {
              super(Le, {
                isRenderable: Le.renderForms
              });
            }
            render() {
              this.container.classList.add("choiceWidgetAnnotation");
              const Le = this.annotationStorage, ue = this.data.id, De = Le.getValue(ue, {
                value: this.data.fieldValue
              }), Ne = document.createElement("select");
              h.add(Ne), Ne.setAttribute("data-element-id", ue), Ne.disabled = this.data.readOnly, this._setRequired(Ne, this.data.required), Ne.name = this.data.fieldName, Ne.tabIndex = d;
              let oe = this.data.combo && this.data.options.length > 0;
              this.data.combo || (Ne.size = this.data.options.length, this.data.multiSelect && (Ne.multiple = !0)), Ne.addEventListener("resetform", (Ee) => {
                const He = this.data.defaultFieldValue;
                for (const de of Ne.options)
                  de.selected = de.value === He;
              });
              for (const Ee of this.data.options) {
                const He = document.createElement("option");
                He.textContent = Ee.displayValue, He.value = Ee.exportValue, De.value.includes(Ee.exportValue) && (He.setAttribute("selected", !0), oe = !1), Ne.append(He);
              }
              let ee = null;
              if (oe) {
                const Ee = document.createElement("option");
                Ee.value = " ", Ee.setAttribute("hidden", !0), Ee.setAttribute("selected", !0), Ne.prepend(Ee), ee = () => {
                  Ee.remove(), Ne.removeEventListener("input", ee), ee = null;
                }, Ne.addEventListener("input", ee);
              }
              const ce = (Ee) => {
                const He = Ee ? "value" : "textContent", {
                  options: de,
                  multiple: ve
                } = Ne;
                return ve ? Array.prototype.filter.call(de, (Se) => Se.selected).map((Se) => Se[He]) : de.selectedIndex === -1 ? null : de[de.selectedIndex][He];
              };
              let pe = ce(!1);
              const be = (Ee) => {
                const He = Ee.target.options;
                return Array.prototype.map.call(He, (de) => ({
                  displayValue: de.textContent,
                  exportValue: de.value
                }));
              };
              return this.enableScripting && this.hasJSActions ? (Ne.addEventListener("updatefromsandbox", (Ee) => {
                const He = {
                  value(de) {
                    ee == null || ee();
                    const ve = de.detail.value, Se = new Set(Array.isArray(ve) ? ve : [ve]);
                    for (const we of Ne.options)
                      we.selected = Se.has(we.value);
                    Le.setValue(ue, {
                      value: ce(!0)
                    }), pe = ce(!1);
                  },
                  multipleSelection(de) {
                    Ne.multiple = !0;
                  },
                  remove(de) {
                    const ve = Ne.options, Se = de.detail.remove;
                    ve[Se].selected = !1, Ne.remove(Se), ve.length > 0 && Array.prototype.findIndex.call(ve, (Ue) => Ue.selected) === -1 && (ve[0].selected = !0), Le.setValue(ue, {
                      value: ce(!0),
                      items: be(de)
                    }), pe = ce(!1);
                  },
                  clear(de) {
                    for (; Ne.length !== 0; )
                      Ne.remove(0);
                    Le.setValue(ue, {
                      value: null,
                      items: []
                    }), pe = ce(!1);
                  },
                  insert(de) {
                    const {
                      index: ve,
                      displayValue: Se,
                      exportValue: we
                    } = de.detail.insert, Ue = Ne.children[ve], Qe = document.createElement("option");
                    Qe.textContent = Se, Qe.value = we, Ue ? Ue.before(Qe) : Ne.append(Qe), Le.setValue(ue, {
                      value: ce(!0),
                      items: be(de)
                    }), pe = ce(!1);
                  },
                  items(de) {
                    const {
                      items: ve
                    } = de.detail;
                    for (; Ne.length !== 0; )
                      Ne.remove(0);
                    for (const Se of ve) {
                      const {
                        displayValue: we,
                        exportValue: Ue
                      } = Se, Qe = document.createElement("option");
                      Qe.textContent = we, Qe.value = Ue, Ne.append(Qe);
                    }
                    Ne.options.length > 0 && (Ne.options[0].selected = !0), Le.setValue(ue, {
                      value: ce(!0),
                      items: be(de)
                    }), pe = ce(!1);
                  },
                  indices(de) {
                    const ve = new Set(de.detail.indices);
                    for (const Se of de.target.options)
                      Se.selected = ve.has(Se.index);
                    Le.setValue(ue, {
                      value: ce(!0)
                    }), pe = ce(!1);
                  },
                  editable(de) {
                    de.target.disabled = !de.detail.editable;
                  }
                };
                this._dispatchEventFromSandbox(He, Ee);
              }), Ne.addEventListener("input", (Ee) => {
                var de;
                const He = ce(!0);
                Le.setValue(ue, {
                  value: He
                }), Ee.preventDefault(), (de = this.linkService.eventBus) == null || de.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: ue,
                    name: "Keystroke",
                    value: pe,
                    changeEx: He,
                    willCommit: !1,
                    commitKey: 1,
                    keyDown: !1
                  }
                });
              }), this._setEventListeners(Ne, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (Ee) => Ee.target.value)) : Ne.addEventListener("input", function(Ee) {
                Le.setValue(ue, {
                  value: ce(!0)
                });
              }), this.data.combo && this._setTextStyle(Ne), this._setBackgroundColor(Ne), this._setDefaultPropertiesFromJS(Ne), this.container.append(Ne), this.container;
            }
          }
          class O extends E {
            constructor(Le) {
              const {
                data: ue,
                elements: De
              } = Le;
              super(Le, {
                isRenderable: E._hasPopupData(ue)
              }), this.elements = De;
            }
            render() {
              this.container.classList.add("popupAnnotation");
              const Le = new D({
                container: this.container,
                color: this.data.color,
                titleObj: this.data.titleObj,
                modificationDate: this.data.modificationDate,
                contentsObj: this.data.contentsObj,
                richText: this.data.richText,
                rect: this.data.rect,
                parentRect: this.data.parentRect || null,
                parent: this.parent,
                elements: this.elements,
                open: this.data.open
              }), ue = [];
              for (const De of this.elements)
                De.popup = Le, ue.push(De.data.id), De.addHighlightArea();
              return this.container.setAttribute("aria-controls", ue.map((De) => `${a.AnnotationPrefix}${De}`).join(",")), this.container;
            }
          }
          class D {
            constructor({
              container: Le,
              color: ue,
              elements: De,
              titleObj: Ne,
              modificationDate: oe,
              contentsObj: ee,
              richText: ce,
              parent: pe,
              rect: be,
              parentRect: Ee,
              open: He
            }) {
              Ge(this, qe);
              Ge(this, ze);
              Ge(this, gt);
              Ge(this, nt);
              Ge(this, he, null);
              Ge(this, j, Ke(this, qe, Oa).bind(this));
              Ge(this, Fe, Ke(this, nt, pi).bind(this));
              Ge(this, X, Ke(this, gt, hi).bind(this));
              Ge(this, ye, Ke(this, ze, yr).bind(this));
              Ge(this, Ae, null);
              Ge(this, fe, null);
              Ge(this, _e, null);
              Ge(this, Ie, null);
              Ge(this, Be, null);
              Ge(this, $e, null);
              Ge(this, Me, !1);
              Ge(this, J, null);
              Ge(this, K, null);
              Ge(this, ge, null);
              Ge(this, Ce, null);
              Ge(this, Oe, !1);
              var ve;
              at(this, fe, Le), at(this, Ce, Ne), at(this, _e, ee), at(this, ge, ce), at(this, Be, pe), at(this, Ae, ue), at(this, K, be), at(this, $e, Ee), at(this, Ie, De);
              const de = s.PDFDateString.toDateObject(oe);
              de && at(this, he, pe.l10n.get("annotation_date_string", {
                date: de.toLocaleDateString(),
                time: de.toLocaleTimeString()
              })), this.trigger = De.flatMap((Se) => Se.getElementsToTriggerPopup());
              for (const Se of this.trigger)
                Se.addEventListener("click", se(this, ye)), Se.addEventListener("mouseenter", se(this, X)), Se.addEventListener("mouseleave", se(this, Fe)), Se.classList.add("popupTriggerArea");
              for (const Se of De)
                (ve = Se.container) == null || ve.addEventListener("keydown", se(this, j));
              se(this, fe).hidden = !0, He && Ke(this, ze, yr).call(this);
            }
            render() {
              if (se(this, J))
                return;
              const {
                page: {
                  view: Le
                },
                viewport: {
                  rawDims: {
                    pageWidth: ue,
                    pageHeight: De,
                    pageX: Ne,
                    pageY: oe
                  }
                }
              } = se(this, Be), ee = at(this, J, document.createElement("div"));
              if (ee.className = "popup", se(this, Ae)) {
                const ut = ee.style.outlineColor = a.Util.makeHexColor(...se(this, Ae));
                CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? ee.style.backgroundColor = `color-mix(in srgb, ${ut} 30%, white)` : ee.style.backgroundColor = a.Util.makeHexColor(...se(this, Ae).map((At) => Math.floor(0.7 * (255 - At) + At)));
              }
              const ce = document.createElement("span");
              ce.className = "header";
              const pe = document.createElement("h1");
              if (ce.append(pe), {
                dir: pe.dir,
                str: pe.textContent
              } = se(this, Ce), ee.append(ce), se(this, he)) {
                const ut = document.createElement("span");
                ut.classList.add("popupDate"), se(this, he).then((_t) => {
                  ut.textContent = _t;
                }), ce.append(ut);
              }
              const be = se(this, _e), Ee = se(this, ge);
              if (Ee != null && Ee.str && (!(be != null && be.str) || be.str === Ee.str))
                u.XfaLayer.render({
                  xfaHtml: Ee.html,
                  intent: "richText",
                  div: ee
                }), ee.lastChild.classList.add("richText", "popupContent");
              else {
                const ut = this._formatContents(be);
                ee.append(ut);
              }
              let He = !!se(this, $e), de = He ? se(this, $e) : se(this, K);
              for (const ut of se(this, Ie))
                if (!de || a.Util.intersect(ut.data.rect, de) !== null) {
                  de = ut.data.rect, He = !0;
                  break;
                }
              const ve = a.Util.normalizeRect([de[0], Le[3] - de[1] + Le[1], de[2], Le[3] - de[3] + Le[1]]), Se = 5, we = He ? de[2] - de[0] + Se : 0, Ue = ve[0] + we, Qe = ve[1], {
                style: ft
              } = se(this, fe);
              ft.left = `${100 * (Ue - Ne) / ue}%`, ft.top = `${100 * (Qe - oe) / De}%`, se(this, fe).append(ee);
            }
            _formatContents({
              str: Le,
              dir: ue
            }) {
              const De = document.createElement("p");
              De.classList.add("popupContent"), De.dir = ue;
              const Ne = Le.split(/(?:\r\n?|\n)/);
              for (let oe = 0, ee = Ne.length; oe < ee; ++oe) {
                const ce = Ne[oe];
                De.append(document.createTextNode(ce)), oe < ee - 1 && De.append(document.createElement("br"));
              }
              return De;
            }
            forceHide() {
              at(this, Oe, this.isVisible), se(this, Oe) && (se(this, fe).hidden = !0);
            }
            maybeShow() {
              se(this, Oe) && (at(this, Oe, !1), se(this, fe).hidden = !1);
            }
            get isVisible() {
              return se(this, fe).hidden === !1;
            }
          }
          he = new WeakMap(), j = new WeakMap(), Fe = new WeakMap(), X = new WeakMap(), ye = new WeakMap(), Ae = new WeakMap(), fe = new WeakMap(), _e = new WeakMap(), Ie = new WeakMap(), Be = new WeakMap(), $e = new WeakMap(), Me = new WeakMap(), J = new WeakMap(), K = new WeakMap(), ge = new WeakMap(), Ce = new WeakMap(), Oe = new WeakMap(), qe = new WeakSet(), Oa = function(Le) {
            Le.altKey || Le.shiftKey || Le.ctrlKey || Le.metaKey || (Le.key === "Enter" || Le.key === "Escape" && se(this, Me)) && Ke(this, ze, yr).call(this);
          }, ze = new WeakSet(), yr = function() {
            at(this, Me, !se(this, Me)), se(this, Me) ? (Ke(this, gt, hi).call(this), se(this, fe).addEventListener("click", se(this, ye)), se(this, fe).addEventListener("keydown", se(this, j))) : (Ke(this, nt, pi).call(this), se(this, fe).removeEventListener("click", se(this, ye)), se(this, fe).removeEventListener("keydown", se(this, j)));
          }, gt = new WeakSet(), hi = function() {
            se(this, J) || this.render(), this.isVisible ? se(this, Me) && se(this, fe).classList.add("focused") : (se(this, fe).hidden = !1, se(this, fe).style.zIndex = parseInt(se(this, fe).style.zIndex) + 1e3);
          }, nt = new WeakSet(), pi = function() {
            se(this, fe).classList.remove("focused"), !(se(this, Me) || !this.isVisible) && (se(this, fe).hidden = !0, se(this, fe).style.zIndex = parseInt(se(this, fe).style.zIndex) - 1e3);
          };
          class k extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0
              }), this.textContent = Le.data.textContent, this.textPosition = Le.data.textPosition, this.annotationEditorType = a.AnnotationEditorType.FREETEXT;
            }
            render() {
              if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
                const Le = document.createElement("div");
                Le.classList.add("annotationTextContent"), Le.setAttribute("role", "comment");
                for (const ue of this.textContent) {
                  const De = document.createElement("span");
                  De.textContent = ue, Le.append(De);
                }
                this.container.append(Le);
              }
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
            }
          }
          e.FreeTextAnnotationElement = k;
          class W extends E {
            constructor(ue) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              Ge(this, Ve, null);
            }
            render() {
              this.container.classList.add("lineAnnotation");
              const ue = this.data, {
                width: De,
                height: Ne
              } = g(ue.rect), oe = this.svgFactory.create(De, Ne, !0), ee = at(this, Ve, this.svgFactory.createElement("svg:line"));
              return ee.setAttribute("x1", ue.rect[2] - ue.lineCoordinates[0]), ee.setAttribute("y1", ue.rect[3] - ue.lineCoordinates[1]), ee.setAttribute("x2", ue.rect[2] - ue.lineCoordinates[2]), ee.setAttribute("y2", ue.rect[3] - ue.lineCoordinates[3]), ee.setAttribute("stroke-width", ue.borderStyle.width || 1), ee.setAttribute("stroke", "transparent"), ee.setAttribute("fill", "transparent"), oe.append(ee), this.container.append(oe), !ue.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return se(this, Ve);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Ve = new WeakMap();
          class L extends E {
            constructor(ue) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              Ge(this, We, null);
            }
            render() {
              this.container.classList.add("squareAnnotation");
              const ue = this.data, {
                width: De,
                height: Ne
              } = g(ue.rect), oe = this.svgFactory.create(De, Ne, !0), ee = ue.borderStyle.width, ce = at(this, We, this.svgFactory.createElement("svg:rect"));
              return ce.setAttribute("x", ee / 2), ce.setAttribute("y", ee / 2), ce.setAttribute("width", De - ee), ce.setAttribute("height", Ne - ee), ce.setAttribute("stroke-width", ee || 1), ce.setAttribute("stroke", "transparent"), ce.setAttribute("fill", "transparent"), oe.append(ce), this.container.append(oe), !ue.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return se(this, We);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          We = new WeakMap();
          class z extends E {
            constructor(ue) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              Ge(this, it, null);
            }
            render() {
              this.container.classList.add("circleAnnotation");
              const ue = this.data, {
                width: De,
                height: Ne
              } = g(ue.rect), oe = this.svgFactory.create(De, Ne, !0), ee = ue.borderStyle.width, ce = at(this, it, this.svgFactory.createElement("svg:ellipse"));
              return ce.setAttribute("cx", De / 2), ce.setAttribute("cy", Ne / 2), ce.setAttribute("rx", De / 2 - ee / 2), ce.setAttribute("ry", Ne / 2 - ee / 2), ce.setAttribute("stroke-width", ee || 1), ce.setAttribute("stroke", "transparent"), ce.setAttribute("fill", "transparent"), oe.append(ce), this.container.append(oe), !ue.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return se(this, it);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          it = new WeakMap();
          class P extends E {
            constructor(ue) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              Ge(this, Je, null);
              this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const ue = this.data, {
                width: De,
                height: Ne
              } = g(ue.rect), oe = this.svgFactory.create(De, Ne, !0);
              let ee = [];
              for (const pe of ue.vertices) {
                const be = pe.x - ue.rect[0], Ee = ue.rect[3] - pe.y;
                ee.push(be + "," + Ee);
              }
              ee = ee.join(" ");
              const ce = at(this, Je, this.svgFactory.createElement(this.svgElementName));
              return ce.setAttribute("points", ee), ce.setAttribute("stroke-width", ue.borderStyle.width || 1), ce.setAttribute("stroke", "transparent"), ce.setAttribute("fill", "transparent"), oe.append(ce), this.container.append(oe), !ue.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return se(this, Je);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Je = new WeakMap();
          class Q extends P {
            constructor(Le) {
              super(Le), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
            }
          }
          class Y extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
          }
          class ie extends E {
            constructor(ue) {
              super(ue, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              Ge(this, Rt, []);
              this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = a.AnnotationEditorType.INK;
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const ue = this.data, {
                width: De,
                height: Ne
              } = g(ue.rect), oe = this.svgFactory.create(De, Ne, !0);
              for (const ee of ue.inkLists) {
                let ce = [];
                for (const be of ee) {
                  const Ee = be.x - ue.rect[0], He = ue.rect[3] - be.y;
                  ce.push(`${Ee},${He}`);
                }
                ce = ce.join(" ");
                const pe = this.svgFactory.createElement(this.svgElementName);
                se(this, Rt).push(pe), pe.setAttribute("points", ce), pe.setAttribute("stroke-width", ue.borderStyle.width || 1), pe.setAttribute("stroke", "transparent"), pe.setAttribute("fill", "transparent"), !ue.popupRef && this.hasPopupData && this._createPopup(), oe.append(pe);
              }
              return this.container.append(oe), this.container;
            }
            getElementsToTriggerPopup() {
              return se(this, Rt);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Rt = new WeakMap(), e.InkAnnotationElement = ie;
          class te extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this.container;
            }
          }
          class Z extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), this.container;
            }
          }
          class ae extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), this.container;
            }
          }
          class G extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), this.container;
            }
          }
          class U extends E {
            constructor(Le) {
              super(Le, {
                isRenderable: !0,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("stampAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
          }
          e.StampAnnotationElement = U;
          class F extends E {
            constructor(ue) {
              var oe;
              super(ue, {
                isRenderable: !0
              });
              Ge(this, ke);
              Ge(this, je, null);
              const {
                filename: De,
                content: Ne
              } = this.data.file;
              this.filename = (0, s.getFilenameFromUrl)(De, !0), this.content = Ne, (oe = this.linkService.eventBus) == null || oe.dispatch("fileattachmentannotation", {
                source: this,
                filename: De,
                content: Ne
              });
            }
            render() {
              this.container.classList.add("fileAttachmentAnnotation");
              const {
                container: ue,
                data: De
              } = this;
              let Ne;
              De.hasAppearance || De.fillAlpha === 0 ? Ne = document.createElement("div") : (Ne = document.createElement("img"), Ne.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(De.name) ? "paperclip" : "pushpin"}.svg`, De.fillAlpha && De.fillAlpha < 1 && (Ne.style = `filter: opacity(${Math.round(De.fillAlpha * 100)}%);`)), Ne.addEventListener("dblclick", Ke(this, ke, gi).bind(this)), at(this, je, Ne);
              const {
                isMac: oe
              } = a.FeatureTest.platform;
              return ue.addEventListener("keydown", (ee) => {
                ee.key === "Enter" && (oe ? ee.metaKey : ee.ctrlKey) && Ke(this, ke, gi).call(this);
              }), !De.popupRef && this.hasPopupData ? this._createPopup() : Ne.classList.add("popupTriggerArea"), ue.append(Ne), ue;
            }
            getElementsToTriggerPopup() {
              return se(this, je);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          je = new WeakMap(), ke = new WeakSet(), gi = function() {
            var ue;
            (ue = this.downloadManager) == null || ue.openOrDownloadData(this.container, this.content, this.filename);
          };
          class M {
            constructor({
              div: Le,
              accessibilityManager: ue,
              annotationCanvasMap: De,
              l10n: Ne,
              page: oe,
              viewport: ee
            }) {
              Ge(this, bt);
              Ge(this, mt);
              Ge(this, Ze, null);
              Ge(this, rt, null);
              Ge(this, xt, /* @__PURE__ */ new Map());
              this.div = Le, at(this, Ze, ue), at(this, rt, De), this.l10n = Ne, this.page = oe, this.viewport = ee, this.zIndex = 0, this.l10n || (this.l10n = c.NullL10n);
            }
            async render(Le) {
              const {
                annotations: ue
              } = Le, De = this.div;
              (0, s.setLayerDimensions)(De, this.viewport);
              const Ne = /* @__PURE__ */ new Map(), oe = {
                data: null,
                layer: De,
                linkService: Le.linkService,
                downloadManager: Le.downloadManager,
                imageResourcesPath: Le.imageResourcesPath || "",
                renderForms: Le.renderForms !== !1,
                svgFactory: new s.DOMSVGFactory(),
                annotationStorage: Le.annotationStorage || new o.AnnotationStorage(),
                enableScripting: Le.enableScripting === !0,
                hasJSActions: Le.hasJSActions,
                fieldObjects: Le.fieldObjects,
                parent: this,
                elements: null
              };
              for (const ee of ue) {
                if (ee.noHTML)
                  continue;
                const ce = ee.annotationType === a.AnnotationType.POPUP;
                if (ce) {
                  const Ee = Ne.get(ee.id);
                  if (!Ee)
                    continue;
                  oe.elements = Ee;
                } else {
                  const {
                    width: Ee,
                    height: He
                  } = g(ee.rect);
                  if (Ee <= 0 || He <= 0)
                    continue;
                }
                oe.data = ee;
                const pe = x.create(oe);
                if (!pe.isRenderable)
                  continue;
                if (!ce && ee.popupRef) {
                  const Ee = Ne.get(ee.popupRef);
                  Ee ? Ee.push(pe) : Ne.set(ee.popupRef, [pe]);
                }
                pe.annotationEditorType > 0 && se(this, xt).set(pe.data.id, pe);
                const be = pe.render();
                ee.hidden && (be.style.visibility = "hidden"), Ke(this, bt, Na).call(this, be, ee.id);
              }
              Ke(this, mt, mi).call(this), await this.l10n.translate(De);
            }
            update({
              viewport: Le
            }) {
              const ue = this.div;
              this.viewport = Le, (0, s.setLayerDimensions)(ue, {
                rotation: Le.rotation
              }), Ke(this, mt, mi).call(this), ue.hidden = !1;
            }
            getEditableAnnotations() {
              return Array.from(se(this, xt).values());
            }
            getEditableAnnotation(Le) {
              return se(this, xt).get(Le);
            }
          }
          Ze = new WeakMap(), rt = new WeakMap(), xt = new WeakMap(), bt = new WeakSet(), Na = function(Le, ue) {
            var Ne;
            const De = Le.firstChild || Le;
            De.id = `${a.AnnotationPrefix}${ue}`, this.div.append(Le), (Ne = se(this, Ze)) == null || Ne.moveElementInDOM(this.div, Le, De, !1);
          }, mt = new WeakSet(), mi = function() {
            if (!se(this, rt))
              return;
            const Le = this.div;
            for (const [ue, De] of se(this, rt)) {
              const Ne = Le.querySelector(`[data-annotation-id="${ue}"]`);
              if (!Ne)
                continue;
              const {
                firstChild: oe
              } = Ne;
              oe ? oe.nodeName === "CANVAS" ? oe.replaceWith(De) : oe.before(De) : Ne.append(De);
            }
            se(this, rt).clear();
          }, e.AnnotationLayer = M;
        },
        /* 30 */
        /***/
        (t, e) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.ColorConverters = void 0;
          function n(o) {
            return Math.floor(Math.max(0, Math.min(1, o)) * 255).toString(16).padStart(2, "0");
          }
          function a(o) {
            return Math.max(0, Math.min(255, 255 * o));
          }
          class s {
            static CMYK_G([l, c, u, d]) {
              return ["G", 1 - Math.min(1, 0.3 * l + 0.59 * u + 0.11 * c + d)];
            }
            static G_CMYK([l]) {
              return ["CMYK", 0, 0, 0, 1 - l];
            }
            static G_RGB([l]) {
              return ["RGB", l, l, l];
            }
            static G_rgb([l]) {
              return l = a(l), [l, l, l];
            }
            static G_HTML([l]) {
              const c = n(l);
              return `#${c}${c}${c}`;
            }
            static RGB_G([l, c, u]) {
              return ["G", 0.3 * l + 0.59 * c + 0.11 * u];
            }
            static RGB_rgb(l) {
              return l.map(a);
            }
            static RGB_HTML(l) {
              return `#${l.map(n).join("")}`;
            }
            static T_HTML() {
              return "#00000000";
            }
            static T_rgb() {
              return [null];
            }
            static CMYK_RGB([l, c, u, d]) {
              return ["RGB", 1 - Math.min(1, l + d), 1 - Math.min(1, u + d), 1 - Math.min(1, c + d)];
            }
            static CMYK_rgb([l, c, u, d]) {
              return [a(1 - Math.min(1, l + d)), a(1 - Math.min(1, u + d)), a(1 - Math.min(1, c + d))];
            }
            static CMYK_HTML(l) {
              const c = this.CMYK_RGB(l).slice(1);
              return this.RGB_HTML(c);
            }
            static RGB_CMYK([l, c, u]) {
              const d = 1 - l, f = 1 - c, h = 1 - u, g = Math.min(d, f, h);
              return ["CMYK", d, f, h, g];
            }
          }
          e.ColorConverters = s;
        },
        /* 31 */
        /***/
        (t, e) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.NullL10n = void 0, e.getL10nFallback = a;
          const n = {
            of_pages: "of {{pagesCount}}",
            page_of_pages: "({{pageNumber}} of {{pagesCount}})",
            document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
            document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
            document_properties_date_string: "{{date}}, {{time}}",
            document_properties_page_size_unit_inches: "in",
            document_properties_page_size_unit_millimeters: "mm",
            document_properties_page_size_orientation_portrait: "portrait",
            document_properties_page_size_orientation_landscape: "landscape",
            document_properties_page_size_name_a3: "A3",
            document_properties_page_size_name_a4: "A4",
            document_properties_page_size_name_letter: "Letter",
            document_properties_page_size_name_legal: "Legal",
            document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
            document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
            document_properties_linearized_yes: "Yes",
            document_properties_linearized_no: "No",
            additional_layers: "Additional Layers",
            page_landmark: "Page {{page}}",
            thumb_page_title: "Page {{page}}",
            thumb_page_canvas: "Thumbnail of Page {{page}}",
            find_reached_top: "Reached top of document, continued from bottom",
            find_reached_bottom: "Reached end of document, continued from top",
            "find_match_count[one]": "{{current}} of {{total}} match",
            "find_match_count[other]": "{{current}} of {{total}} matches",
            "find_match_count_limit[one]": "More than {{limit}} match",
            "find_match_count_limit[other]": "More than {{limit}} matches",
            find_not_found: "Phrase not found",
            page_scale_width: "Page Width",
            page_scale_fit: "Page Fit",
            page_scale_auto: "Automatic Zoom",
            page_scale_actual: "Actual Size",
            page_scale_percent: "{{scale}}%",
            loading_error: "An error occurred while loading the PDF.",
            invalid_file_error: "Invalid or corrupted PDF file.",
            missing_file_error: "Missing PDF file.",
            unexpected_response_error: "Unexpected server response.",
            rendering_error: "An error occurred while rendering the page.",
            annotation_date_string: "{{date}}, {{time}}",
            printing_not_supported: "Warning: Printing is not fully supported by this browser.",
            printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
            web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
            free_text2_default_content: "Start typing…",
            editor_free_text2_aria_label: "Text Editor",
            editor_ink2_aria_label: "Draw Editor",
            editor_ink_canvas_aria_label: "User-created image",
            editor_alt_text_button_label: "Alt text",
            editor_alt_text_edit_button_label: "Edit alt text",
            editor_alt_text_decorative_tooltip: "Marked as decorative"
          };
          n.print_progress_percent = "{{progress}}%";
          function a(l, c) {
            switch (l) {
              case "find_match_count":
                l = `find_match_count[${c.total === 1 ? "one" : "other"}]`;
                break;
              case "find_match_count_limit":
                l = `find_match_count_limit[${c.limit === 1 ? "one" : "other"}]`;
                break;
            }
            return n[l] || "";
          }
          function s(l, c) {
            return c ? l.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (u, d) => d in c ? c[d] : "{{" + d + "}}") : l;
          }
          const o = {
            async getLanguage() {
              return "en-us";
            },
            async getDirection() {
              return "ltr";
            },
            async get(l, c = null, u = a(l, c)) {
              return s(u, c);
            },
            async translate(l) {
            }
          };
          e.NullL10n = o;
        },
        /* 32 */
        /***/
        (t, e, n) => {
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.XfaLayer = void 0;
          var a = n(25);
          class s {
            static setupStorage(l, c, u, d, f) {
              const h = d.getValue(c, {
                value: null
              });
              switch (u.name) {
                case "textarea":
                  if (h.value !== null && (l.textContent = h.value), f === "print")
                    break;
                  l.addEventListener("input", (g) => {
                    d.setValue(c, {
                      value: g.target.value
                    });
                  });
                  break;
                case "input":
                  if (u.attributes.type === "radio" || u.attributes.type === "checkbox") {
                    if (h.value === u.attributes.xfaOn ? l.setAttribute("checked", !0) : h.value === u.attributes.xfaOff && l.removeAttribute("checked"), f === "print")
                      break;
                    l.addEventListener("change", (g) => {
                      d.setValue(c, {
                        value: g.target.checked ? g.target.getAttribute("xfaOn") : g.target.getAttribute("xfaOff")
                      });
                    });
                  } else {
                    if (h.value !== null && l.setAttribute("value", h.value), f === "print")
                      break;
                    l.addEventListener("input", (g) => {
                      d.setValue(c, {
                        value: g.target.value
                      });
                    });
                  }
                  break;
                case "select":
                  if (h.value !== null) {
                    l.setAttribute("value", h.value);
                    for (const g of u.children)
                      g.attributes.value === h.value ? g.attributes.selected = !0 : g.attributes.hasOwnProperty("selected") && delete g.attributes.selected;
                  }
                  l.addEventListener("input", (g) => {
                    const x = g.target.options, E = x.selectedIndex === -1 ? "" : x[x.selectedIndex].value;
                    d.setValue(c, {
                      value: E
                    });
                  });
                  break;
              }
            }
            static setAttributes({
              html: l,
              element: c,
              storage: u = null,
              intent: d,
              linkService: f
            }) {
              const {
                attributes: h
              } = c, g = l instanceof HTMLAnchorElement;
              h.type === "radio" && (h.name = `${h.name}-${d}`);
              for (const [x, E] of Object.entries(h))
                if (E != null)
                  switch (x) {
                    case "class":
                      E.length && l.setAttribute(x, E.join(" "));
                      break;
                    case "dataId":
                      break;
                    case "id":
                      l.setAttribute("data-element-id", E);
                      break;
                    case "style":
                      Object.assign(l.style, E);
                      break;
                    case "textContent":
                      l.textContent = E;
                      break;
                    default:
                      (!g || x !== "href" && x !== "newWindow") && l.setAttribute(x, E);
                  }
              g && f.addLinkAttributes(l, h.href, h.newWindow), u && h.dataId && this.setupStorage(l, h.dataId, c, u);
            }
            static render(l) {
              var m;
              const c = l.annotationStorage, u = l.linkService, d = l.xfaHtml, f = l.intent || "display", h = document.createElement(d.name);
              d.attributes && this.setAttributes({
                html: h,
                element: d,
                intent: f,
                linkService: u
              });
              const g = [[d, -1, h]], x = l.div;
              if (x.append(h), l.viewport) {
                const v = `matrix(${l.viewport.transform.join(",")})`;
                x.style.transform = v;
              }
              f !== "richText" && x.setAttribute("class", "xfaLayer xfaFont");
              const E = [];
              for (; g.length > 0; ) {
                const [v, y, A] = g.at(-1);
                if (y + 1 === v.children.length) {
                  g.pop();
                  continue;
                }
                const b = v.children[++g.at(-1)[1]];
                if (b === null)
                  continue;
                const {
                  name: C
                } = b;
                if (C === "#text") {
                  const w = document.createTextNode(b.value);
                  E.push(w), A.append(w);
                  continue;
                }
                const T = (m = b == null ? void 0 : b.attributes) != null && m.xmlns ? document.createElementNS(b.attributes.xmlns, C) : document.createElement(C);
                if (A.append(T), b.attributes && this.setAttributes({
                  html: T,
                  element: b,
                  storage: c,
                  intent: f,
                  linkService: u
                }), b.children && b.children.length > 0)
                  g.push([b, -1, T]);
                else if (b.value) {
                  const w = document.createTextNode(b.value);
                  a.XfaText.shouldBuildText(C) && E.push(w), T.append(w);
                }
              }
              for (const v of x.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                v.setAttribute("readOnly", !0);
              return {
                textDivs: E
              };
            }
            static update(l) {
              const c = `matrix(${l.viewport.transform.join(",")})`;
              l.div.style.transform = c, l.div.hidden = !1;
            }
          }
          e.XfaLayer = s;
        },
        /* 33 */
        /***/
        (t, e, n) => {
          var d, f, h, g, x, E, m, v, y, A, b, C, T, w, R, ka, D, Ba, W, Wa, z, Va, Q, vi, ie, Ga, Z, xi, G, Ha, F, za, I, Xa, V, qa, H, ja, he, xn, Fe, yi, ye, br, fe, Er, Ie, kn, $e, bi, J, Ar, ge, $a, Oe, Ei, ct, Ya, et, Ka, pt, Ai, tt, Tr, We, Bn;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.InkEditor = void 0;
          var a = n(1), s = n(4), o = n(29), l = n(6), c = n(5);
          const Je = class Je extends s.AnnotationEditor {
            constructor(ke) {
              super({
                ...ke,
                name: "inkEditor"
              });
              Ge(this, R);
              Ge(this, D);
              Ge(this, W);
              Ge(this, z);
              Ge(this, Q);
              Ge(this, ie);
              Ge(this, Z);
              Ge(this, G);
              Ge(this, F);
              Ge(this, I);
              Ge(this, V);
              Ge(this, H);
              Ge(this, he);
              Ge(this, Fe);
              Ge(this, ye);
              Ge(this, fe);
              Ge(this, Ie);
              Ge(this, $e);
              Ge(this, J);
              Ge(this, et);
              Ge(this, pt);
              Ge(this, tt);
              Ge(this, We);
              Ge(this, d, 0);
              Ge(this, f, 0);
              Ge(this, h, this.canvasPointermove.bind(this));
              Ge(this, g, this.canvasPointerleave.bind(this));
              Ge(this, x, this.canvasPointerup.bind(this));
              Ge(this, E, this.canvasPointerdown.bind(this));
              Ge(this, m, new Path2D());
              Ge(this, v, !1);
              Ge(this, y, !1);
              Ge(this, A, !1);
              Ge(this, b, null);
              Ge(this, C, 0);
              Ge(this, T, 0);
              Ge(this, w, null);
              this.color = ke.color || null, this.thickness = ke.thickness || null, this.opacity = ke.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0, this._willKeepAspectRatio = !0;
            }
            static initialize(ke) {
              s.AnnotationEditor.initialize(ke, {
                strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
              });
            }
            static updateDefaultParams(ke, Ye) {
              switch (ke) {
                case a.AnnotationEditorParamsType.INK_THICKNESS:
                  Je._defaultThickness = Ye;
                  break;
                case a.AnnotationEditorParamsType.INK_COLOR:
                  Je._defaultColor = Ye;
                  break;
                case a.AnnotationEditorParamsType.INK_OPACITY:
                  Je._defaultOpacity = Ye / 100;
                  break;
              }
            }
            updateParams(ke, Ye) {
              switch (ke) {
                case a.AnnotationEditorParamsType.INK_THICKNESS:
                  Ke(this, R, ka).call(this, Ye);
                  break;
                case a.AnnotationEditorParamsType.INK_COLOR:
                  Ke(this, D, Ba).call(this, Ye);
                  break;
                case a.AnnotationEditorParamsType.INK_OPACITY:
                  Ke(this, W, Wa).call(this, Ye);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[a.AnnotationEditorParamsType.INK_THICKNESS, Je._defaultThickness], [a.AnnotationEditorParamsType.INK_COLOR, Je._defaultColor || s.AnnotationEditor._defaultLineColor], [a.AnnotationEditorParamsType.INK_OPACITY, Math.round(Je._defaultOpacity * 100)]];
            }
            get propertiesToUpdate() {
              return [[a.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || Je._defaultThickness], [a.AnnotationEditorParamsType.INK_COLOR, this.color || Je._defaultColor || s.AnnotationEditor._defaultLineColor], [a.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? Je._defaultOpacity))]];
            }
            rebuild() {
              this.parent && (super.rebuild(), this.div !== null && (this.canvas || (Ke(this, ye, br).call(this), Ke(this, fe, Er).call(this)), this.isAttachedToDOM || (this.parent.add(this), Ke(this, Ie, kn).call(this)), Ke(this, We, Bn).call(this)));
            }
            remove() {
              this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, se(this, b).disconnect(), at(this, b, null), super.remove());
            }
            setParent(ke) {
              !this.parent && ke ? this._uiManager.removeShouldRescale(this) : this.parent && ke === null && this._uiManager.addShouldRescale(this), super.setParent(ke);
            }
            onScaleChanging() {
              const [ke, Ye] = this.parentDimensions, Ze = this.width * ke, rt = this.height * Ye;
              this.setDimensions(Ze, rt);
            }
            enableEditMode() {
              se(this, v) || this.canvas === null || (super.enableEditMode(), this._isDraggable = !1, this.canvas.addEventListener("pointerdown", se(this, E)));
            }
            disableEditMode() {
              !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", se(this, E)));
            }
            onceAdded() {
              this._isDraggable = !this.isEmpty();
            }
            isEmpty() {
              return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
            }
            commit() {
              se(this, v) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), at(this, v, !0), this.div.classList.add("disabled"), Ke(this, We, Bn).call(this, !0), this.makeResizable(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
                preventScroll: !0
              }));
            }
            focusin(ke) {
              this._focusEventsAllowed && (super.focusin(ke), this.enableEditMode());
            }
            canvasPointerdown(ke) {
              ke.button !== 0 || !this.isInEditMode() || se(this, v) || (this.setInForeground(), ke.preventDefault(), ke.type !== "mouse" && this.div.focus(), Ke(this, ie, Ga).call(this, ke.offsetX, ke.offsetY));
            }
            canvasPointermove(ke) {
              ke.preventDefault(), Ke(this, Z, xi).call(this, ke.offsetX, ke.offsetY);
            }
            canvasPointerup(ke) {
              ke.preventDefault(), Ke(this, Fe, yi).call(this, ke);
            }
            canvasPointerleave(ke) {
              Ke(this, Fe, yi).call(this, ke);
            }
            get isResizable() {
              return !this.isEmpty() && se(this, v);
            }
            render() {
              if (this.div)
                return this.div;
              let ke, Ye;
              this.width && (ke = this.x, Ye = this.y), super.render(), s.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((wt) => {
                var mt;
                return (mt = this.div) == null ? void 0 : mt.setAttribute("aria-label", wt);
              });
              const [Ze, rt, xt, bt] = Ke(this, z, Va).call(this);
              if (this.setAt(Ze, rt, 0, 0), this.setDims(xt, bt), Ke(this, ye, br).call(this), this.width) {
                const [wt, mt] = this.parentDimensions;
                this.setAspectRatio(this.width * wt, this.height * mt), this.setAt(ke * wt, Ye * mt, this.width * wt, this.height * mt), at(this, A, !0), Ke(this, Ie, kn).call(this), this.setDims(this.width * wt, this.height * mt), Ke(this, he, xn).call(this), this.div.classList.add("disabled");
              } else
                this.div.classList.add("editing"), this.enableEditMode();
              return Ke(this, fe, Er).call(this), this.div;
            }
            setDimensions(ke, Ye) {
              const Ze = Math.round(ke), rt = Math.round(Ye);
              if (se(this, C) === Ze && se(this, T) === rt)
                return;
              at(this, C, Ze), at(this, T, rt), this.canvas.style.visibility = "hidden";
              const [xt, bt] = this.parentDimensions;
              this.width = ke / xt, this.height = Ye / bt, this.fixAndSetPosition(), se(this, v) && Ke(this, $e, bi).call(this, ke, Ye), Ke(this, Ie, kn).call(this), Ke(this, he, xn).call(this), this.canvas.style.visibility = "visible", this.fixDims();
            }
            static deserialize(ke, Ye, Ze) {
              var oe, ee, ce;
              if (ke instanceof o.InkAnnotationElement)
                return null;
              const rt = super.deserialize(ke, Ye, Ze);
              rt.thickness = ke.thickness, rt.color = a.Util.makeHexColor(...ke.color), rt.opacity = ke.opacity;
              const [xt, bt] = rt.pageDimensions, wt = rt.width * xt, mt = rt.height * bt, St = rt.parentScale, dt = ke.thickness / 2;
              at(rt, v, !0), at(rt, C, Math.round(wt)), at(rt, T, Math.round(mt));
              const {
                paths: Le,
                rect: ue,
                rotation: De
              } = ke;
              for (let {
                bezier: pe
              } of Le) {
                pe = Ke(oe = Je, ct, Ya).call(oe, pe, ue, De);
                const be = [];
                rt.paths.push(be);
                let Ee = St * (pe[0] - dt), He = St * (pe[1] - dt);
                for (let ve = 2, Se = pe.length; ve < Se; ve += 6) {
                  const we = St * (pe[ve] - dt), Ue = St * (pe[ve + 1] - dt), Qe = St * (pe[ve + 2] - dt), ft = St * (pe[ve + 3] - dt), ut = St * (pe[ve + 4] - dt), _t = St * (pe[ve + 5] - dt);
                  be.push([[Ee, He], [we, Ue], [Qe, ft], [ut, _t]]), Ee = ut, He = _t;
                }
                const de = Ke(this, ge, $a).call(this, be);
                rt.bezierPath2D.push(de);
              }
              const Ne = Ke(ee = rt, pt, Ai).call(ee);
              return at(rt, f, Math.max(s.AnnotationEditor.MIN_SIZE, Ne[2] - Ne[0])), at(rt, d, Math.max(s.AnnotationEditor.MIN_SIZE, Ne[3] - Ne[1])), Ke(ce = rt, $e, bi).call(ce, wt, mt), rt;
            }
            serialize() {
              if (this.isEmpty())
                return null;
              const ke = this.getRect(0, 0), Ye = s.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
              return {
                annotationType: a.AnnotationEditorType.INK,
                color: Ye,
                thickness: this.thickness,
                opacity: this.opacity,
                paths: Ke(this, et, Ka).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, ke),
                pageIndex: this.pageIndex,
                rect: ke,
                rotation: this.rotation,
                structTreeParentId: this._structTreeParentId
              };
            }
          };
          d = new WeakMap(), f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakMap(), A = new WeakMap(), b = new WeakMap(), C = new WeakMap(), T = new WeakMap(), w = new WeakMap(), R = new WeakSet(), ka = function(ke) {
            const Ye = this.thickness;
            this.addCommands({
              cmd: () => {
                this.thickness = ke, Ke(this, We, Bn).call(this);
              },
              undo: () => {
                this.thickness = Ye, Ke(this, We, Bn).call(this);
              },
              mustExec: !0,
              type: a.AnnotationEditorParamsType.INK_THICKNESS,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, D = new WeakSet(), Ba = function(ke) {
            const Ye = this.color;
            this.addCommands({
              cmd: () => {
                this.color = ke, Ke(this, he, xn).call(this);
              },
              undo: () => {
                this.color = Ye, Ke(this, he, xn).call(this);
              },
              mustExec: !0,
              type: a.AnnotationEditorParamsType.INK_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, W = new WeakSet(), Wa = function(ke) {
            ke /= 100;
            const Ye = this.opacity;
            this.addCommands({
              cmd: () => {
                this.opacity = ke, Ke(this, he, xn).call(this);
              },
              undo: () => {
                this.opacity = Ye, Ke(this, he, xn).call(this);
              },
              mustExec: !0,
              type: a.AnnotationEditorParamsType.INK_OPACITY,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, z = new WeakSet(), Va = function() {
            const {
              parentRotation: ke,
              parentDimensions: [Ye, Ze]
            } = this;
            switch (ke) {
              case 90:
                return [0, Ze, Ze, Ye];
              case 180:
                return [Ye, Ze, Ye, Ze];
              case 270:
                return [Ye, 0, Ze, Ye];
              default:
                return [0, 0, Ye, Ze];
            }
          }, Q = new WeakSet(), vi = function() {
            const {
              ctx: ke,
              color: Ye,
              opacity: Ze,
              thickness: rt,
              parentScale: xt,
              scaleFactor: bt
            } = this;
            ke.lineWidth = rt * xt / bt, ke.lineCap = "round", ke.lineJoin = "round", ke.miterLimit = 10, ke.strokeStyle = `${Ye}${(0, c.opacityToHex)(Ze)}`;
          }, ie = new WeakSet(), Ga = function(ke, Ye) {
            this.canvas.addEventListener("contextmenu", l.noContextMenu), this.canvas.addEventListener("pointerleave", se(this, g)), this.canvas.addEventListener("pointermove", se(this, h)), this.canvas.addEventListener("pointerup", se(this, x)), this.canvas.removeEventListener("pointerdown", se(this, E)), this.isEditing = !0, se(this, A) || (at(this, A, !0), Ke(this, Ie, kn).call(this), this.thickness || (this.thickness = Je._defaultThickness), this.color || (this.color = Je._defaultColor || s.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = Je._defaultOpacity)), this.currentPath.push([ke, Ye]), at(this, y, !1), Ke(this, Q, vi).call(this), at(this, w, () => {
              Ke(this, I, Xa).call(this), se(this, w) && window.requestAnimationFrame(se(this, w));
            }), window.requestAnimationFrame(se(this, w));
          }, Z = new WeakSet(), xi = function(ke, Ye) {
            const [Ze, rt] = this.currentPath.at(-1);
            if (this.currentPath.length > 1 && ke === Ze && Ye === rt)
              return;
            const xt = this.currentPath;
            let bt = se(this, m);
            if (xt.push([ke, Ye]), at(this, y, !0), xt.length <= 2) {
              bt.moveTo(...xt[0]), bt.lineTo(ke, Ye);
              return;
            }
            xt.length === 3 && (at(this, m, bt = new Path2D()), bt.moveTo(...xt[0])), Ke(this, V, qa).call(this, bt, ...xt.at(-3), ...xt.at(-2), ke, Ye);
          }, G = new WeakSet(), Ha = function() {
            if (this.currentPath.length === 0)
              return;
            const ke = this.currentPath.at(-1);
            se(this, m).lineTo(...ke);
          }, F = new WeakSet(), za = function(ke, Ye) {
            at(this, w, null), ke = Math.min(Math.max(ke, 0), this.canvas.width), Ye = Math.min(Math.max(Ye, 0), this.canvas.height), Ke(this, Z, xi).call(this, ke, Ye), Ke(this, G, Ha).call(this);
            let Ze;
            if (this.currentPath.length !== 1)
              Ze = Ke(this, H, ja).call(this);
            else {
              const mt = [ke, Ye];
              Ze = [[mt, mt.slice(), mt.slice(), mt]];
            }
            const rt = se(this, m), xt = this.currentPath;
            this.currentPath = [], at(this, m, new Path2D());
            const bt = () => {
              this.allRawPaths.push(xt), this.paths.push(Ze), this.bezierPath2D.push(rt), this.rebuild();
            }, wt = () => {
              this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (Ke(this, ye, br).call(this), Ke(this, fe, Er).call(this)), Ke(this, We, Bn).call(this));
            };
            this.addCommands({
              cmd: bt,
              undo: wt,
              mustExec: !0
            });
          }, I = new WeakSet(), Xa = function() {
            if (!se(this, y))
              return;
            at(this, y, !1);
            const ke = Math.ceil(this.thickness * this.parentScale), Ye = this.currentPath.slice(-3), Ze = Ye.map((bt) => bt[0]), rt = Ye.map((bt) => bt[1]);
            Math.min(...Ze) - ke, Math.max(...Ze) + ke, Math.min(...rt) - ke, Math.max(...rt) + ke;
            const {
              ctx: xt
            } = this;
            xt.save(), xt.clearRect(0, 0, this.canvas.width, this.canvas.height);
            for (const bt of this.bezierPath2D)
              xt.stroke(bt);
            xt.stroke(se(this, m)), xt.restore();
          }, V = new WeakSet(), qa = function(ke, Ye, Ze, rt, xt, bt, wt) {
            const mt = (Ye + rt) / 2, St = (Ze + xt) / 2, dt = (rt + bt) / 2, Le = (xt + wt) / 2;
            ke.bezierCurveTo(mt + 2 * (rt - mt) / 3, St + 2 * (xt - St) / 3, dt + 2 * (rt - dt) / 3, Le + 2 * (xt - Le) / 3, dt, Le);
          }, H = new WeakSet(), ja = function() {
            const ke = this.currentPath;
            if (ke.length <= 2)
              return [[ke[0], ke[0], ke.at(-1), ke.at(-1)]];
            const Ye = [];
            let Ze, [rt, xt] = ke[0];
            for (Ze = 1; Ze < ke.length - 2; Ze++) {
              const [ue, De] = ke[Ze], [Ne, oe] = ke[Ze + 1], ee = (ue + Ne) / 2, ce = (De + oe) / 2, pe = [rt + 2 * (ue - rt) / 3, xt + 2 * (De - xt) / 3], be = [ee + 2 * (ue - ee) / 3, ce + 2 * (De - ce) / 3];
              Ye.push([[rt, xt], pe, be, [ee, ce]]), [rt, xt] = [ee, ce];
            }
            const [bt, wt] = ke[Ze], [mt, St] = ke[Ze + 1], dt = [rt + 2 * (bt - rt) / 3, xt + 2 * (wt - xt) / 3], Le = [mt + 2 * (bt - mt) / 3, St + 2 * (wt - St) / 3];
            return Ye.push([[rt, xt], dt, Le, [mt, St]]), Ye;
          }, he = new WeakSet(), xn = function() {
            if (this.isEmpty()) {
              Ke(this, J, Ar).call(this);
              return;
            }
            Ke(this, Q, vi).call(this);
            const {
              canvas: ke,
              ctx: Ye
            } = this;
            Ye.setTransform(1, 0, 0, 1, 0, 0), Ye.clearRect(0, 0, ke.width, ke.height), Ke(this, J, Ar).call(this);
            for (const Ze of this.bezierPath2D)
              Ye.stroke(Ze);
          }, Fe = new WeakSet(), yi = function(ke) {
            this.canvas.removeEventListener("pointerleave", se(this, g)), this.canvas.removeEventListener("pointermove", se(this, h)), this.canvas.removeEventListener("pointerup", se(this, x)), this.canvas.addEventListener("pointerdown", se(this, E)), setTimeout(() => {
              this.canvas.removeEventListener("contextmenu", l.noContextMenu);
            }, 10), Ke(this, F, za).call(this, ke.offsetX, ke.offsetY), this.addToAnnotationStorage(), this.setInBackground();
          }, ye = new WeakSet(), br = function() {
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", s.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((ke) => {
              var Ye;
              return (Ye = this.canvas) == null ? void 0 : Ye.setAttribute("aria-label", ke);
            }), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
          }, fe = new WeakSet(), Er = function() {
            at(this, b, new ResizeObserver((ke) => {
              const Ye = ke[0].contentRect;
              Ye.width && Ye.height && this.setDimensions(Ye.width, Ye.height);
            })), se(this, b).observe(this.div);
          }, Ie = new WeakSet(), kn = function() {
            if (!se(this, A))
              return;
            const [ke, Ye] = this.parentDimensions;
            this.canvas.width = Math.ceil(this.width * ke), this.canvas.height = Math.ceil(this.height * Ye), Ke(this, J, Ar).call(this);
          }, $e = new WeakSet(), bi = function(ke, Ye) {
            const Ze = Ke(this, tt, Tr).call(this), rt = (ke - Ze) / se(this, f), xt = (Ye - Ze) / se(this, d);
            this.scaleFactor = Math.min(rt, xt);
          }, J = new WeakSet(), Ar = function() {
            const ke = Ke(this, tt, Tr).call(this) / 2;
            this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + ke, this.translationY * this.scaleFactor + ke);
          }, ge = new WeakSet(), $a = function(ke) {
            const Ye = new Path2D();
            for (let Ze = 0, rt = ke.length; Ze < rt; Ze++) {
              const [xt, bt, wt, mt] = ke[Ze];
              Ze === 0 && Ye.moveTo(...xt), Ye.bezierCurveTo(bt[0], bt[1], wt[0], wt[1], mt[0], mt[1]);
            }
            return Ye;
          }, Oe = new WeakSet(), Ei = function(ke, Ye, Ze) {
            const [rt, xt, bt, wt] = Ye;
            switch (Ze) {
              case 0:
                for (let mt = 0, St = ke.length; mt < St; mt += 2)
                  ke[mt] += rt, ke[mt + 1] = wt - ke[mt + 1];
                break;
              case 90:
                for (let mt = 0, St = ke.length; mt < St; mt += 2) {
                  const dt = ke[mt];
                  ke[mt] = ke[mt + 1] + rt, ke[mt + 1] = dt + xt;
                }
                break;
              case 180:
                for (let mt = 0, St = ke.length; mt < St; mt += 2)
                  ke[mt] = bt - ke[mt], ke[mt + 1] += xt;
                break;
              case 270:
                for (let mt = 0, St = ke.length; mt < St; mt += 2) {
                  const dt = ke[mt];
                  ke[mt] = bt - ke[mt + 1], ke[mt + 1] = wt - dt;
                }
                break;
              default:
                throw new Error("Invalid rotation");
            }
            return ke;
          }, ct = new WeakSet(), Ya = function(ke, Ye, Ze) {
            const [rt, xt, bt, wt] = Ye;
            switch (Ze) {
              case 0:
                for (let mt = 0, St = ke.length; mt < St; mt += 2)
                  ke[mt] -= rt, ke[mt + 1] = wt - ke[mt + 1];
                break;
              case 90:
                for (let mt = 0, St = ke.length; mt < St; mt += 2) {
                  const dt = ke[mt];
                  ke[mt] = ke[mt + 1] - xt, ke[mt + 1] = dt - rt;
                }
                break;
              case 180:
                for (let mt = 0, St = ke.length; mt < St; mt += 2)
                  ke[mt] = bt - ke[mt], ke[mt + 1] -= xt;
                break;
              case 270:
                for (let mt = 0, St = ke.length; mt < St; mt += 2) {
                  const dt = ke[mt];
                  ke[mt] = wt - ke[mt + 1], ke[mt + 1] = bt - dt;
                }
                break;
              default:
                throw new Error("Invalid rotation");
            }
            return ke;
          }, et = new WeakSet(), Ka = function(ke, Ye, Ze, rt) {
            var St, dt;
            const xt = [], bt = this.thickness / 2, wt = ke * Ye + bt, mt = ke * Ze + bt;
            for (const Le of this.paths) {
              const ue = [], De = [];
              for (let Ne = 0, oe = Le.length; Ne < oe; Ne++) {
                const [ee, ce, pe, be] = Le[Ne], Ee = ke * ee[0] + wt, He = ke * ee[1] + mt, de = ke * ce[0] + wt, ve = ke * ce[1] + mt, Se = ke * pe[0] + wt, we = ke * pe[1] + mt, Ue = ke * be[0] + wt, Qe = ke * be[1] + mt;
                Ne === 0 && (ue.push(Ee, He), De.push(Ee, He)), ue.push(de, ve, Se, we, Ue, Qe), De.push(de, ve), Ne === oe - 1 && De.push(Ue, Qe);
              }
              xt.push({
                bezier: Ke(St = Je, Oe, Ei).call(St, ue, rt, this.rotation),
                points: Ke(dt = Je, Oe, Ei).call(dt, De, rt, this.rotation)
              });
            }
            return xt;
          }, pt = new WeakSet(), Ai = function() {
            let ke = 1 / 0, Ye = -1 / 0, Ze = 1 / 0, rt = -1 / 0;
            for (const xt of this.paths)
              for (const [bt, wt, mt, St] of xt) {
                const dt = a.Util.bezierBoundingBox(...bt, ...wt, ...mt, ...St);
                ke = Math.min(ke, dt[0]), Ze = Math.min(Ze, dt[1]), Ye = Math.max(Ye, dt[2]), rt = Math.max(rt, dt[3]);
              }
            return [ke, Ze, Ye, rt];
          }, tt = new WeakSet(), Tr = function() {
            return se(this, v) ? Math.ceil(this.thickness * this.parentScale) : 0;
          }, We = new WeakSet(), Bn = function(ke = !1) {
            if (this.isEmpty())
              return;
            if (!se(this, v)) {
              Ke(this, he, xn).call(this);
              return;
            }
            const Ye = Ke(this, pt, Ai).call(this), Ze = Ke(this, tt, Tr).call(this);
            at(this, f, Math.max(s.AnnotationEditor.MIN_SIZE, Ye[2] - Ye[0])), at(this, d, Math.max(s.AnnotationEditor.MIN_SIZE, Ye[3] - Ye[1]));
            const rt = Math.ceil(Ze + se(this, f) * this.scaleFactor), xt = Math.ceil(Ze + se(this, d) * this.scaleFactor), [bt, wt] = this.parentDimensions;
            this.width = rt / bt, this.height = xt / wt, this.setAspectRatio(rt, xt);
            const mt = this.translationX, St = this.translationY;
            this.translationX = -Ye[0], this.translationY = -Ye[1], Ke(this, Ie, kn).call(this), Ke(this, he, xn).call(this), at(this, C, rt), at(this, T, xt), this.setDims(rt, xt);
            const dt = ke ? Ze / this.scaleFactor / 2 : 0;
            this.translate(mt - this.translationX - dt, St - this.translationY - dt);
          }, Ge(Je, ge), Ge(Je, Oe), Ge(Je, ct), Xt(Je, "_defaultColor", null), Xt(Je, "_defaultOpacity", 1), Xt(Je, "_defaultThickness", 1), Xt(Je, "_type", "ink");
          let u = Je;
          e.InkEditor = u;
        },
        /* 34 */
        /***/
        (t, e, n) => {
          var u, d, f, h, g, x, E, m, v, y, A, Kn, C, Zn, w, Sr, O, Ti, k, Za, L, Qa, P, Si, Y, Cr, te, Ja;
          Object.defineProperty(e, "__esModule", {
            value: !0
          }), e.StampEditor = void 0;
          var a = n(1), s = n(4), o = n(6), l = n(29);
          const ae = class ae extends s.AnnotationEditor {
            constructor(F) {
              super({
                ...F,
                name: "stampEditor"
              });
              Ge(this, A);
              Ge(this, C);
              Ge(this, w);
              Ge(this, O);
              Ge(this, k);
              Ge(this, L);
              Ge(this, P);
              Ge(this, Y);
              Ge(this, te);
              Ge(this, u, null);
              Ge(this, d, null);
              Ge(this, f, null);
              Ge(this, h, null);
              Ge(this, g, null);
              Ge(this, x, null);
              Ge(this, E, null);
              Ge(this, m, null);
              Ge(this, v, !1);
              Ge(this, y, !1);
              at(this, h, F.bitmapUrl), at(this, g, F.bitmapFile);
            }
            static initialize(F) {
              s.AnnotationEditor.initialize(F);
            }
            static get supportedTypes() {
              const F = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
              return (0, a.shadow)(this, "supportedTypes", F.map((M) => `image/${M}`));
            }
            static get supportedTypesStr() {
              return (0, a.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
            }
            static isHandlingMimeForPasting(F) {
              return this.supportedTypes.includes(F);
            }
            static paste(F, M) {
              M.pasteEditor(a.AnnotationEditorType.STAMP, {
                bitmapFile: F.getAsFile()
              });
            }
            remove() {
              var F, M;
              se(this, d) && (at(this, u, null), this._uiManager.imageManager.deleteId(se(this, d)), (F = se(this, x)) == null || F.remove(), at(this, x, null), (M = se(this, E)) == null || M.disconnect(), at(this, E, null)), super.remove();
            }
            rebuild() {
              if (!this.parent) {
                se(this, d) && Ke(this, w, Sr).call(this);
                return;
              }
              super.rebuild(), this.div !== null && (se(this, d) && Ke(this, w, Sr).call(this), this.isAttachedToDOM || this.parent.add(this));
            }
            onceAdded() {
              this._isDraggable = !0, this.div.focus();
            }
            isEmpty() {
              return !(se(this, f) || se(this, u) || se(this, h) || se(this, g));
            }
            get isResizable() {
              return !0;
            }
            render() {
              if (this.div)
                return this.div;
              let F, M;
              if (this.width && (F = this.x, M = this.y), super.render(), this.div.hidden = !0, se(this, u) ? Ke(this, O, Ti).call(this) : Ke(this, w, Sr).call(this), this.width) {
                const [I, N] = this.parentDimensions;
                this.setAt(F * I, M * N, this.width * I, this.height * N);
              }
              return this.div;
            }
            static deserialize(F, M, I) {
              if (F instanceof l.StampAnnotationElement)
                return null;
              const N = super.deserialize(F, M, I), {
                rect: V,
                bitmapUrl: q,
                bitmapId: H,
                isSvg: ne,
                accessibilityData: he
              } = F;
              H && I.imageManager.isValidId(H) ? at(N, d, H) : at(N, h, q), at(N, v, ne);
              const [j, Fe] = N.pageDimensions;
              return N.width = (V[2] - V[0]) / j, N.height = (V[3] - V[1]) / Fe, he && (N.altTextData = he), N;
            }
            serialize(F = !1, M = null) {
              if (this.isEmpty())
                return null;
              const I = {
                annotationType: a.AnnotationEditorType.STAMP,
                bitmapId: se(this, d),
                pageIndex: this.pageIndex,
                rect: this.getRect(0, 0),
                rotation: this.rotation,
                isSvg: se(this, v),
                structTreeParentId: this._structTreeParentId
              };
              if (F)
                return I.bitmapUrl = Ke(this, Y, Cr).call(this, !0), I.accessibilityData = this.altTextData, I;
              const {
                decorative: N,
                altText: V
              } = this.altTextData;
              if (!N && V && (I.accessibilityData = {
                type: "Figure",
                alt: V
              }), M === null)
                return I;
              M.stamps || (M.stamps = /* @__PURE__ */ new Map());
              const q = se(this, v) ? (I.rect[2] - I.rect[0]) * (I.rect[3] - I.rect[1]) : null;
              if (!M.stamps.has(se(this, d)))
                M.stamps.set(se(this, d), {
                  area: q,
                  serialized: I
                }), I.bitmap = Ke(this, Y, Cr).call(this, !1);
              else if (se(this, v)) {
                const H = M.stamps.get(se(this, d));
                q > H.area && (H.area = q, H.serialized.bitmap.close(), H.serialized.bitmap = Ke(this, Y, Cr).call(this, !1));
              }
              return I;
            }
          };
          u = new WeakMap(), d = new WeakMap(), f = new WeakMap(), h = new WeakMap(), g = new WeakMap(), x = new WeakMap(), E = new WeakMap(), m = new WeakMap(), v = new WeakMap(), y = new WeakMap(), A = new WeakSet(), Kn = function(F, M = !1) {
            if (!F) {
              this.remove();
              return;
            }
            at(this, u, F.bitmap), M || (at(this, d, F.id), at(this, v, F.isSvg)), Ke(this, O, Ti).call(this);
          }, C = new WeakSet(), Zn = function() {
            at(this, f, null), this._uiManager.enableWaiting(!1), se(this, x) && this.div.focus();
          }, w = new WeakSet(), Sr = function() {
            if (se(this, d)) {
              this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(se(this, d)).then((M) => Ke(this, A, Kn).call(this, M, !0)).finally(() => Ke(this, C, Zn).call(this));
              return;
            }
            if (se(this, h)) {
              const M = se(this, h);
              at(this, h, null), this._uiManager.enableWaiting(!0), at(this, f, this._uiManager.imageManager.getFromUrl(M).then((I) => Ke(this, A, Kn).call(this, I)).finally(() => Ke(this, C, Zn).call(this)));
              return;
            }
            if (se(this, g)) {
              const M = se(this, g);
              at(this, g, null), this._uiManager.enableWaiting(!0), at(this, f, this._uiManager.imageManager.getFromFile(M).then((I) => Ke(this, A, Kn).call(this, I)).finally(() => Ke(this, C, Zn).call(this)));
              return;
            }
            const F = document.createElement("input");
            F.type = "file", F.accept = ae.supportedTypesStr, at(this, f, new Promise((M) => {
              F.addEventListener("change", async () => {
                if (!F.files || F.files.length === 0)
                  this.remove();
                else {
                  this._uiManager.enableWaiting(!0);
                  const I = await this._uiManager.imageManager.getFromFile(F.files[0]);
                  Ke(this, A, Kn).call(this, I);
                }
                M();
              }), F.addEventListener("cancel", () => {
                this.remove(), M();
              });
            }).finally(() => Ke(this, C, Zn).call(this))), F.click();
          }, O = new WeakSet(), Ti = function() {
            const {
              div: F
            } = this;
            let {
              width: M,
              height: I
            } = se(this, u);
            const [N, V] = this.pageDimensions, q = 0.75;
            if (this.width)
              M = this.width * N, I = this.height * V;
            else if (M > q * N || I > q * V) {
              const j = Math.min(q * N / M, q * V / I);
              M *= j, I *= j;
            }
            const [H, ne] = this.parentDimensions;
            this.setDims(M * H / N, I * ne / V), this._uiManager.enableWaiting(!1);
            const he = at(this, x, document.createElement("canvas"));
            F.append(he), F.hidden = !1, Ke(this, P, Si).call(this, M, I), Ke(this, te, Ja).call(this), se(this, y) || (this.parent.addUndoableEditor(this), at(this, y, !0)), this._uiManager._eventBus.dispatch("reporttelemetry", {
              source: this,
              details: {
                type: "editing",
                subtype: this.editorType,
                data: {
                  action: "inserted_image"
                }
              }
            }), this.addAltTextButton();
          }, k = new WeakSet(), Za = function(F, M) {
            var q;
            const [I, N] = this.parentDimensions;
            this.width = F / I, this.height = M / N, this.setDims(F, M), (q = this._initialOptions) != null && q.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, se(this, m) !== null && clearTimeout(se(this, m)), at(this, m, setTimeout(() => {
              at(this, m, null), Ke(this, P, Si).call(this, F, M);
            }, 200));
          }, L = new WeakSet(), Qa = function(F, M) {
            const {
              width: I,
              height: N
            } = se(this, u);
            let V = I, q = N, H = se(this, u);
            for (; V > 2 * F || q > 2 * M; ) {
              const ne = V, he = q;
              V > 2 * F && (V = V >= 16384 ? Math.floor(V / 2) - 1 : Math.ceil(V / 2)), q > 2 * M && (q = q >= 16384 ? Math.floor(q / 2) - 1 : Math.ceil(q / 2));
              const j = new OffscreenCanvas(V, q);
              j.getContext("2d").drawImage(H, 0, 0, ne, he, 0, 0, V, q), H = j.transferToImageBitmap();
            }
            return H;
          }, P = new WeakSet(), Si = function(F, M) {
            F = Math.ceil(F), M = Math.ceil(M);
            const I = se(this, x);
            if (!I || I.width === F && I.height === M)
              return;
            I.width = F, I.height = M;
            const N = se(this, v) ? se(this, u) : Ke(this, L, Qa).call(this, F, M), V = I.getContext("2d");
            V.filter = this._uiManager.hcmFilter, V.drawImage(N, 0, 0, N.width, N.height, 0, 0, F, M);
          }, Y = new WeakSet(), Cr = function(F) {
            if (F) {
              if (se(this, v)) {
                const N = this._uiManager.imageManager.getSvgUrl(se(this, d));
                if (N)
                  return N;
              }
              const M = document.createElement("canvas");
              return {
                width: M.width,
                height: M.height
              } = se(this, u), M.getContext("2d").drawImage(se(this, u), 0, 0), M.toDataURL();
            }
            if (se(this, v)) {
              const [M, I] = this.pageDimensions, N = Math.round(this.width * M * o.PixelsPerInch.PDF_TO_CSS_UNITS), V = Math.round(this.height * I * o.PixelsPerInch.PDF_TO_CSS_UNITS), q = new OffscreenCanvas(N, V);
              return q.getContext("2d").drawImage(se(this, u), 0, 0, se(this, u).width, se(this, u).height, 0, 0, N, V), q.transferToImageBitmap();
            }
            return structuredClone(se(this, u));
          }, te = new WeakSet(), Ja = function() {
            at(this, E, new ResizeObserver((F) => {
              const M = F[0].contentRect;
              M.width && M.height && Ke(this, k, Za).call(this, M.width, M.height);
            })), se(this, E).observe(this.div);
          }, Xt(ae, "_type", "stamp");
          let c = ae;
          e.StampEditor = c;
        }
        /******/
      ], __webpack_module_cache__ = {};
      function __w_pdfjs_require__(t) {
        var e = __webpack_module_cache__[t];
        if (e !== void 0)
          return e.exports;
        var n = __webpack_module_cache__[t] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return __webpack_modules__[t](n, n.exports, __w_pdfjs_require__), n.exports;
      }
      var __webpack_exports__ = {};
      return (() => {
        var t = __webpack_exports__;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "AbortException", {
          enumerable: !0,
          get: function() {
            return e.AbortException;
          }
        }), Object.defineProperty(t, "AnnotationEditorLayer", {
          enumerable: !0,
          get: function() {
            return o.AnnotationEditorLayer;
          }
        }), Object.defineProperty(t, "AnnotationEditorParamsType", {
          enumerable: !0,
          get: function() {
            return e.AnnotationEditorParamsType;
          }
        }), Object.defineProperty(t, "AnnotationEditorType", {
          enumerable: !0,
          get: function() {
            return e.AnnotationEditorType;
          }
        }), Object.defineProperty(t, "AnnotationEditorUIManager", {
          enumerable: !0,
          get: function() {
            return l.AnnotationEditorUIManager;
          }
        }), Object.defineProperty(t, "AnnotationLayer", {
          enumerable: !0,
          get: function() {
            return c.AnnotationLayer;
          }
        }), Object.defineProperty(t, "AnnotationMode", {
          enumerable: !0,
          get: function() {
            return e.AnnotationMode;
          }
        }), Object.defineProperty(t, "CMapCompressionType", {
          enumerable: !0,
          get: function() {
            return e.CMapCompressionType;
          }
        }), Object.defineProperty(t, "DOMSVGFactory", {
          enumerable: !0,
          get: function() {
            return a.DOMSVGFactory;
          }
        }), Object.defineProperty(t, "FeatureTest", {
          enumerable: !0,
          get: function() {
            return e.FeatureTest;
          }
        }), Object.defineProperty(t, "GlobalWorkerOptions", {
          enumerable: !0,
          get: function() {
            return u.GlobalWorkerOptions;
          }
        }), Object.defineProperty(t, "ImageKind", {
          enumerable: !0,
          get: function() {
            return e.ImageKind;
          }
        }), Object.defineProperty(t, "InvalidPDFException", {
          enumerable: !0,
          get: function() {
            return e.InvalidPDFException;
          }
        }), Object.defineProperty(t, "MissingPDFException", {
          enumerable: !0,
          get: function() {
            return e.MissingPDFException;
          }
        }), Object.defineProperty(t, "OPS", {
          enumerable: !0,
          get: function() {
            return e.OPS;
          }
        }), Object.defineProperty(t, "PDFDataRangeTransport", {
          enumerable: !0,
          get: function() {
            return n.PDFDataRangeTransport;
          }
        }), Object.defineProperty(t, "PDFDateString", {
          enumerable: !0,
          get: function() {
            return a.PDFDateString;
          }
        }), Object.defineProperty(t, "PDFWorker", {
          enumerable: !0,
          get: function() {
            return n.PDFWorker;
          }
        }), Object.defineProperty(t, "PasswordResponses", {
          enumerable: !0,
          get: function() {
            return e.PasswordResponses;
          }
        }), Object.defineProperty(t, "PermissionFlag", {
          enumerable: !0,
          get: function() {
            return e.PermissionFlag;
          }
        }), Object.defineProperty(t, "PixelsPerInch", {
          enumerable: !0,
          get: function() {
            return a.PixelsPerInch;
          }
        }), Object.defineProperty(t, "PromiseCapability", {
          enumerable: !0,
          get: function() {
            return e.PromiseCapability;
          }
        }), Object.defineProperty(t, "RenderingCancelledException", {
          enumerable: !0,
          get: function() {
            return a.RenderingCancelledException;
          }
        }), Object.defineProperty(t, "SVGGraphics", {
          enumerable: !0,
          get: function() {
            return n.SVGGraphics;
          }
        }), Object.defineProperty(t, "UnexpectedResponseException", {
          enumerable: !0,
          get: function() {
            return e.UnexpectedResponseException;
          }
        }), Object.defineProperty(t, "Util", {
          enumerable: !0,
          get: function() {
            return e.Util;
          }
        }), Object.defineProperty(t, "VerbosityLevel", {
          enumerable: !0,
          get: function() {
            return e.VerbosityLevel;
          }
        }), Object.defineProperty(t, "XfaLayer", {
          enumerable: !0,
          get: function() {
            return d.XfaLayer;
          }
        }), Object.defineProperty(t, "build", {
          enumerable: !0,
          get: function() {
            return n.build;
          }
        }), Object.defineProperty(t, "createValidAbsoluteUrl", {
          enumerable: !0,
          get: function() {
            return e.createValidAbsoluteUrl;
          }
        }), Object.defineProperty(t, "getDocument", {
          enumerable: !0,
          get: function() {
            return n.getDocument;
          }
        }), Object.defineProperty(t, "getFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return a.getFilenameFromUrl;
          }
        }), Object.defineProperty(t, "getPdfFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return a.getPdfFilenameFromUrl;
          }
        }), Object.defineProperty(t, "getXfaPageViewport", {
          enumerable: !0,
          get: function() {
            return a.getXfaPageViewport;
          }
        }), Object.defineProperty(t, "isDataScheme", {
          enumerable: !0,
          get: function() {
            return a.isDataScheme;
          }
        }), Object.defineProperty(t, "isPdfFile", {
          enumerable: !0,
          get: function() {
            return a.isPdfFile;
          }
        }), Object.defineProperty(t, "loadScript", {
          enumerable: !0,
          get: function() {
            return a.loadScript;
          }
        }), Object.defineProperty(t, "noContextMenu", {
          enumerable: !0,
          get: function() {
            return a.noContextMenu;
          }
        }), Object.defineProperty(t, "normalizeUnicode", {
          enumerable: !0,
          get: function() {
            return e.normalizeUnicode;
          }
        }), Object.defineProperty(t, "renderTextLayer", {
          enumerable: !0,
          get: function() {
            return s.renderTextLayer;
          }
        }), Object.defineProperty(t, "setLayerDimensions", {
          enumerable: !0,
          get: function() {
            return a.setLayerDimensions;
          }
        }), Object.defineProperty(t, "shadow", {
          enumerable: !0,
          get: function() {
            return e.shadow;
          }
        }), Object.defineProperty(t, "updateTextLayer", {
          enumerable: !0,
          get: function() {
            return s.updateTextLayer;
          }
        }), Object.defineProperty(t, "version", {
          enumerable: !0,
          get: function() {
            return n.version;
          }
        });
        var e = __w_pdfjs_require__(1), n = __w_pdfjs_require__(2), a = __w_pdfjs_require__(6), s = __w_pdfjs_require__(26), o = __w_pdfjs_require__(27), l = __w_pdfjs_require__(5), c = __w_pdfjs_require__(29), u = __w_pdfjs_require__(14), d = __w_pdfjs_require__(32);
      })(), __webpack_exports__;
    })()
  ));
})(pdf$1);
var pdfExports = pdf$1.exports;
const pdf = /* @__PURE__ */ getDefaultExportFromCjs(pdfExports), pdfjsModule = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: pdf
}, [pdfExports]), pdfjs = "default" in pdfjsModule ? pdf : pdfjsModule, pdfjs$1 = pdfjs;
var propTypes = { exports: {} }, ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = t, ReactPropTypesSecret_1;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var t = requireReactPropTypesSecret();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, factoryWithThrowingShims = function() {
    function a(l, c, u, d, f, h) {
      if (h !== t) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, factoryWithThrowingShims;
}
var reactIs = { exports: {} }, reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, h = t ? Symbol.for("react.suspense") : 60113, g = t ? Symbol.for("react.suspense_list") : 60120, x = t ? Symbol.for("react.memo") : 60115, E = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, A = t ? Symbol.for("react.scope") : 60119;
    function b(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === a || j === d || j === o || j === s || j === h || j === g || typeof j == "object" && j !== null && (j.$$typeof === E || j.$$typeof === x || j.$$typeof === l || j.$$typeof === c || j.$$typeof === f || j.$$typeof === v || j.$$typeof === y || j.$$typeof === A || j.$$typeof === m);
    }
    function C(j) {
      if (typeof j == "object" && j !== null) {
        var Fe = j.$$typeof;
        switch (Fe) {
          case e:
            var X = j.type;
            switch (X) {
              case u:
              case d:
              case a:
              case o:
              case s:
              case h:
                return X;
              default:
                var ye = X && X.$$typeof;
                switch (ye) {
                  case c:
                  case f:
                  case E:
                  case x:
                  case l:
                    return ye;
                  default:
                    return Fe;
                }
            }
          case n:
            return Fe;
        }
      }
    }
    var T = u, w = d, R = c, O = l, D = e, k = f, W = a, L = E, z = x, P = n, Q = o, Y = s, ie = h, te = !1;
    function Z(j) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ae(j) || C(j) === u;
    }
    function ae(j) {
      return C(j) === d;
    }
    function G(j) {
      return C(j) === c;
    }
    function U(j) {
      return C(j) === l;
    }
    function F(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function M(j) {
      return C(j) === f;
    }
    function I(j) {
      return C(j) === a;
    }
    function N(j) {
      return C(j) === E;
    }
    function V(j) {
      return C(j) === x;
    }
    function q(j) {
      return C(j) === n;
    }
    function H(j) {
      return C(j) === o;
    }
    function ne(j) {
      return C(j) === s;
    }
    function he(j) {
      return C(j) === h;
    }
    reactIs_development.AsyncMode = T, reactIs_development.ConcurrentMode = w, reactIs_development.ContextConsumer = R, reactIs_development.ContextProvider = O, reactIs_development.Element = D, reactIs_development.ForwardRef = k, reactIs_development.Fragment = W, reactIs_development.Lazy = L, reactIs_development.Memo = z, reactIs_development.Portal = P, reactIs_development.Profiler = Q, reactIs_development.StrictMode = Y, reactIs_development.Suspense = ie, reactIs_development.isAsyncMode = Z, reactIs_development.isConcurrentMode = ae, reactIs_development.isContextConsumer = G, reactIs_development.isContextProvider = U, reactIs_development.isElement = F, reactIs_development.isForwardRef = M, reactIs_development.isFragment = I, reactIs_development.isLazy = N, reactIs_development.isMemo = V, reactIs_development.isPortal = q, reactIs_development.isProfiler = H, reactIs_development.isStrictMode = ne, reactIs_development.isSuspense = he, reactIs_development.isValidElementType = b, reactIs_development.typeOf = C;
  }()), reactIs_development;
}
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, s = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, f = t ? Symbol.for("react.forward_ref") : 60112, h = t ? Symbol.for("react.suspense") : 60113, g = t ? Symbol.for("react.suspense_list") : 60120, x = t ? Symbol.for("react.memo") : 60115, E = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, A = t ? Symbol.for("react.scope") : 60119;
  function b(T) {
    if (typeof T == "object" && T !== null) {
      var w = T.$$typeof;
      switch (w) {
        case e:
          switch (T = T.type, T) {
            case u:
            case d:
            case a:
            case o:
            case s:
            case h:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case c:
                case f:
                case E:
                case x:
                case l:
                  return T;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  function C(T) {
    return b(T) === d;
  }
  return reactIs_production_min.AsyncMode = u, reactIs_production_min.ConcurrentMode = d, reactIs_production_min.ContextConsumer = c, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = f, reactIs_production_min.Fragment = a, reactIs_production_min.Lazy = E, reactIs_production_min.Memo = x, reactIs_production_min.Portal = n, reactIs_production_min.Profiler = o, reactIs_production_min.StrictMode = s, reactIs_production_min.Suspense = h, reactIs_production_min.isAsyncMode = function(T) {
    return C(T) || b(T) === u;
  }, reactIs_production_min.isConcurrentMode = C, reactIs_production_min.isContextConsumer = function(T) {
    return b(T) === c;
  }, reactIs_production_min.isContextProvider = function(T) {
    return b(T) === l;
  }, reactIs_production_min.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(T) {
    return b(T) === f;
  }, reactIs_production_min.isFragment = function(T) {
    return b(T) === a;
  }, reactIs_production_min.isLazy = function(T) {
    return b(T) === E;
  }, reactIs_production_min.isMemo = function(T) {
    return b(T) === x;
  }, reactIs_production_min.isPortal = function(T) {
    return b(T) === n;
  }, reactIs_production_min.isProfiler = function(T) {
    return b(T) === o;
  }, reactIs_production_min.isStrictMode = function(T) {
    return b(T) === s;
  }, reactIs_production_min.isSuspense = function(T) {
    return b(T) === h;
  }, reactIs_production_min.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === a || T === d || T === o || T === s || T === h || T === g || typeof T == "object" && T !== null && (T.$$typeof === E || T.$$typeof === x || T.$$typeof === l || T.$$typeof === c || T.$$typeof === f || T.$$typeof === v || T.$$typeof === y || T.$$typeof === A || T.$$typeof === m);
  }, reactIs_production_min.typeOf = b, reactIs_production_min;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function a(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(f) {
        return l[f];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(o, l) {
    for (var c, u = a(o), d, f = 1; f < arguments.length; f++) {
      c = Object(arguments[f]);
      for (var h in c)
        e.call(c, h) && (u[h] = c[h]);
      if (t) {
        d = t(c);
        for (var g = 0; g < d.length; g++)
          n.call(c, d[g]) && (u[d[g]] = c[d[g]]);
      }
    }
    return u;
  }, objectAssign;
}
var has$2, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$2 = Function.call.bind(Object.prototype.hasOwnProperty)), has$2;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = requireReactPropTypesSecret(), n = {}, a = requireHas();
    t = function(o) {
      var l = "Warning: " + o;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function s(o, l, c, u, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (a(o, f)) {
          var h;
          try {
            if (typeof o[f] != "function") {
              var g = Error(
                (u || "React class") + ": " + c + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            h = o[f](l, f, u, c, null, e);
          } catch (E) {
            h = E;
          }
          if (h && !(h instanceof Error) && t(
            (u || "React class") + ": type specification of " + c + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var x = d ? d() : "";
            t(
              "Failed " + c + " type: " + h.message + (x ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var t = requireReactIs(), e = requireObjectAssign(), n = requireReactPropTypesSecret(), a = requireHas(), s = requireCheckPropTypes(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(c) {
    var u = "Warning: " + c;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return factoryWithTypeCheckers = function(c, u) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(ae) {
      var G = ae && (d && ae[d] || ae[f]);
      if (typeof G == "function")
        return G;
    }
    var g = "<<anonymous>>", x = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: A(),
      arrayOf: b,
      element: C(),
      elementType: T(),
      instanceOf: w,
      node: k(),
      objectOf: O,
      oneOf: R,
      oneOfType: D,
      shape: L,
      exact: z
    };
    function E(ae, G) {
      return ae === G ? ae !== 0 || 1 / ae === 1 / G : ae !== ae && G !== G;
    }
    function m(ae, G) {
      this.message = ae, this.data = G && typeof G == "object" ? G : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(ae) {
      if (process.env.NODE_ENV !== "production")
        var G = {}, U = 0;
      function F(I, N, V, q, H, ne, he) {
        if (q = q || g, ne = ne || V, he !== n) {
          if (u) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = q + ":" + V;
            !G[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ne + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), G[Fe] = !0, U++);
          }
        }
        return N[V] == null ? I ? N[V] === null ? new m("The " + H + " `" + ne + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new m("The " + H + " `" + ne + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : ae(N, V, q, H, ne);
      }
      var M = F.bind(null, !1);
      return M.isRequired = F.bind(null, !0), M;
    }
    function y(ae) {
      function G(U, F, M, I, N, V) {
        var q = U[F], H = Y(q);
        if (H !== ae) {
          var ne = ie(q);
          return new m(
            "Invalid " + I + " `" + N + "` of type " + ("`" + ne + "` supplied to `" + M + "`, expected ") + ("`" + ae + "`."),
            { expectedType: ae }
          );
        }
        return null;
      }
      return v(G);
    }
    function A() {
      return v(l);
    }
    function b(ae) {
      function G(U, F, M, I, N) {
        if (typeof ae != "function")
          return new m("Property `" + N + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var V = U[F];
        if (!Array.isArray(V)) {
          var q = Y(V);
          return new m("Invalid " + I + " `" + N + "` of type " + ("`" + q + "` supplied to `" + M + "`, expected an array."));
        }
        for (var H = 0; H < V.length; H++) {
          var ne = ae(V, H, M, I, N + "[" + H + "]", n);
          if (ne instanceof Error)
            return ne;
        }
        return null;
      }
      return v(G);
    }
    function C() {
      function ae(G, U, F, M, I) {
        var N = G[U];
        if (!c(N)) {
          var V = Y(N);
          return new m("Invalid " + M + " `" + I + "` of type " + ("`" + V + "` supplied to `" + F + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(ae);
    }
    function T() {
      function ae(G, U, F, M, I) {
        var N = G[U];
        if (!t.isValidElementType(N)) {
          var V = Y(N);
          return new m("Invalid " + M + " `" + I + "` of type " + ("`" + V + "` supplied to `" + F + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(ae);
    }
    function w(ae) {
      function G(U, F, M, I, N) {
        if (!(U[F] instanceof ae)) {
          var V = ae.name || g, q = Z(U[F]);
          return new m("Invalid " + I + " `" + N + "` of type " + ("`" + q + "` supplied to `" + M + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return v(G);
    }
    function R(ae) {
      if (!Array.isArray(ae))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), l;
      function G(U, F, M, I, N) {
        for (var V = U[F], q = 0; q < ae.length; q++)
          if (E(V, ae[q]))
            return null;
        var H = JSON.stringify(ae, function(he, j) {
          var Fe = ie(j);
          return Fe === "symbol" ? String(j) : j;
        });
        return new m("Invalid " + I + " `" + N + "` of value `" + String(V) + "` " + ("supplied to `" + M + "`, expected one of " + H + "."));
      }
      return v(G);
    }
    function O(ae) {
      function G(U, F, M, I, N) {
        if (typeof ae != "function")
          return new m("Property `" + N + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var V = U[F], q = Y(V);
        if (q !== "object")
          return new m("Invalid " + I + " `" + N + "` of type " + ("`" + q + "` supplied to `" + M + "`, expected an object."));
        for (var H in V)
          if (a(V, H)) {
            var ne = ae(V, H, M, I, N + "." + H, n);
            if (ne instanceof Error)
              return ne;
          }
        return null;
      }
      return v(G);
    }
    function D(ae) {
      if (!Array.isArray(ae))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var G = 0; G < ae.length; G++) {
        var U = ae[G];
        if (typeof U != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(U) + " at index " + G + "."
          ), l;
      }
      function F(M, I, N, V, q) {
        for (var H = [], ne = 0; ne < ae.length; ne++) {
          var he = ae[ne], j = he(M, I, N, V, q, n);
          if (j == null)
            return null;
          j.data && a(j.data, "expectedType") && H.push(j.data.expectedType);
        }
        var Fe = H.length > 0 ? ", expected one of type [" + H.join(", ") + "]" : "";
        return new m("Invalid " + V + " `" + q + "` supplied to " + ("`" + N + "`" + Fe + "."));
      }
      return v(F);
    }
    function k() {
      function ae(G, U, F, M, I) {
        return P(G[U]) ? null : new m("Invalid " + M + " `" + I + "` supplied to " + ("`" + F + "`, expected a ReactNode."));
      }
      return v(ae);
    }
    function W(ae, G, U, F, M) {
      return new m(
        (ae || "React class") + ": " + G + " type `" + U + "." + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + M + "`."
      );
    }
    function L(ae) {
      function G(U, F, M, I, N) {
        var V = U[F], q = Y(V);
        if (q !== "object")
          return new m("Invalid " + I + " `" + N + "` of type `" + q + "` " + ("supplied to `" + M + "`, expected `object`."));
        for (var H in ae) {
          var ne = ae[H];
          if (typeof ne != "function")
            return W(M, I, N, H, ie(ne));
          var he = ne(V, H, M, I, N + "." + H, n);
          if (he)
            return he;
        }
        return null;
      }
      return v(G);
    }
    function z(ae) {
      function G(U, F, M, I, N) {
        var V = U[F], q = Y(V);
        if (q !== "object")
          return new m("Invalid " + I + " `" + N + "` of type `" + q + "` " + ("supplied to `" + M + "`, expected `object`."));
        var H = e({}, U[F], ae);
        for (var ne in H) {
          var he = ae[ne];
          if (a(ae, ne) && typeof he != "function")
            return W(M, I, N, ne, ie(he));
          if (!he)
            return new m(
              "Invalid " + I + " `" + N + "` key `" + ne + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(U[F], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ae), null, "  ")
            );
          var j = he(V, ne, M, I, N + "." + ne, n);
          if (j)
            return j;
        }
        return null;
      }
      return v(G);
    }
    function P(ae) {
      switch (typeof ae) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ae;
        case "object":
          if (Array.isArray(ae))
            return ae.every(P);
          if (ae === null || c(ae))
            return !0;
          var G = h(ae);
          if (G) {
            var U = G.call(ae), F;
            if (G !== ae.entries) {
              for (; !(F = U.next()).done; )
                if (!P(F.value))
                  return !1;
            } else
              for (; !(F = U.next()).done; ) {
                var M = F.value;
                if (M && !P(M[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(ae, G) {
      return ae === "symbol" ? !0 : G ? G["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && G instanceof Symbol : !1;
    }
    function Y(ae) {
      var G = typeof ae;
      return Array.isArray(ae) ? "array" : ae instanceof RegExp ? "object" : Q(G, ae) ? "symbol" : G;
    }
    function ie(ae) {
      if (typeof ae > "u" || ae === null)
        return "" + ae;
      var G = Y(ae);
      if (G === "object") {
        if (ae instanceof Date)
          return "date";
        if (ae instanceof RegExp)
          return "regexp";
      }
      return G;
    }
    function te(ae) {
      var G = ie(ae);
      switch (G) {
        case "array":
        case "object":
          return "an " + G;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + G;
        default:
          return G;
      }
    }
    function Z(ae) {
      return !ae.constructor || !ae.constructor.name ? g : ae.constructor.name;
    }
    return x.checkPropTypes = s, x.resetWarningCache = s.resetWarningCache, x.PropTypes = x, x;
  }, factoryWithTypeCheckers;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var __spreadArray = function(t, e, n) {
  if (n || arguments.length === 2)
    for (var a = 0, s = e.length, o; a < s; a++)
      (o || !(a in e)) && (o || (o = Array.prototype.slice.call(e, 0, a)), o[a] = e[a]);
  return t.concat(o || Array.prototype.slice.call(e));
}, clipboardEvents = ["onCopy", "onCut", "onPaste"], compositionEvents = [
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate"
], focusEvents = ["onFocus", "onBlur"], formEvents = ["onInput", "onInvalid", "onReset", "onSubmit"], imageEvents = ["onLoad", "onError"], keyboardEvents = ["onKeyDown", "onKeyPress", "onKeyUp"], mediaEvents = [
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onError",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting"
], mouseEvents = [
  "onClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp"
], dragEvents = [
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop"
], selectionEvents = ["onSelect"], touchEvents = ["onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"], pointerEvents = [
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut"
], uiEvents = ["onScroll"], wheelEvents = ["onWheel"], animationEvents = [
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration"
], transitionEvents = ["onTransitionEnd"], otherEvents = ["onToggle"], changeEvents = ["onChange"], allEvents = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], clipboardEvents, !0), compositionEvents, !0), focusEvents, !0), formEvents, !0), imageEvents, !0), keyboardEvents, !0), mediaEvents, !0), mouseEvents, !0), dragEvents, !0), selectionEvents, !0), touchEvents, !0), pointerEvents, !0), uiEvents, !0), wheelEvents, !0), animationEvents, !0), transitionEvents, !0), changeEvents, !0), otherEvents, !0);
function makeEventProps(t, e) {
  var n = {};
  return allEvents.forEach(function(a) {
    var s = t[a];
    s && (e ? n[a] = function(o) {
      return s(o, e(a));
    } : n[a] = s);
  }), n;
}
function makeCancellablePromise(t) {
  var e = !1, n = new Promise(function(a, s) {
    t.then(function(o) {
      return !e && a(o);
    }).catch(function(o) {
      return !e && s(o);
    });
  });
  return {
    promise: n,
    cancel: function() {
      e = !0;
    }
  };
}
var isProduction$1 = process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(t, e) {
  if (!t) {
    if (isProduction$1)
      throw new Error(prefix);
    var n = typeof e == "function" ? e() : e, a = n ? "".concat(prefix, ": ").concat(n) : prefix;
    throw new Error(a);
  }
}
var isProduction = process.env.NODE_ENV === "production";
function warning$2(t, e) {
  if (!isProduction) {
    if (t)
      return;
    var n = "Warning: " + e;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
const DocumentContext = createContext(null);
function Message({ children: t, type: e }) {
  return React.createElement("div", { className: `react-pdf__message react-pdf__message--${e}` }, t);
}
const DEFAULT_LINK_REL = "noopener noreferrer nofollow";
class LinkService {
  constructor() {
    this.externalLinkEnabled = !0, this.externalLinkRel = void 0, this.externalLinkTarget = void 0, this.isInPresentationMode = !1, this.pdfDocument = void 0, this.pdfViewer = void 0;
  }
  setDocument(e) {
    this.pdfDocument = e;
  }
  setViewer(e) {
    this.pdfViewer = e;
  }
  setExternalLinkRel(e) {
    this.externalLinkRel = e;
  }
  setExternalLinkTarget(e) {
    this.externalLinkTarget = e;
  }
  setHistory() {
  }
  get pagesCount() {
    return this.pdfDocument ? this.pdfDocument.numPages : 0;
  }
  get page() {
    return invariant(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber || 0;
  }
  set page(e) {
    invariant(this.pdfViewer, "PDF viewer is not initialized."), this.pdfViewer.currentPageNumber = e;
  }
  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get rotation() {
    return 0;
  }
  set rotation(e) {
  }
  goToDestination(e) {
    return new Promise((n) => {
      invariant(this.pdfDocument, "PDF document not loaded."), invariant(e, "Destination is not specified."), typeof e == "string" ? this.pdfDocument.getDestination(e).then(n) : Array.isArray(e) ? n(e) : e.then(n);
    }).then((n) => {
      invariant(Array.isArray(n), `"${n}" is not a valid destination array.`);
      const a = n[0];
      new Promise((s) => {
        invariant(this.pdfDocument, "PDF document not loaded."), a instanceof Object ? this.pdfDocument.getPageIndex(a).then((o) => {
          s(o);
        }).catch(() => {
          invariant(!1, `"${a}" is not a valid page reference.`);
        }) : typeof a == "number" ? s(a) : invariant(!1, `"${a}" is not a valid destination reference.`);
      }).then((s) => {
        const o = s + 1;
        invariant(this.pdfViewer, "PDF viewer is not initialized."), invariant(o >= 1 && o <= this.pagesCount, `"${o}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
          dest: n,
          pageIndex: s,
          pageNumber: o
        });
      });
    });
  }
  navigateTo(e) {
    this.goToDestination(e);
  }
  goToPage(e) {
    const n = e - 1;
    invariant(this.pdfViewer, "PDF viewer is not initialized."), invariant(e >= 1 && e <= this.pagesCount, `"${e}" is not a valid page number.`), this.pdfViewer.scrollPageIntoView({
      pageIndex: n,
      pageNumber: e
    });
  }
  addLinkAttributes(e, n, a) {
    e.href = n, e.rel = this.externalLinkRel || DEFAULT_LINK_REL, e.target = a ? "_blank" : this.externalLinkTarget || "";
  }
  getDestinationHash() {
    return "#";
  }
  getAnchorUrl() {
    return "#";
  }
  setHash() {
  }
  executeNamedAction() {
  }
  cachePageRef() {
  }
  isPageVisible() {
    return !0;
  }
  isPageCached() {
    return !0;
  }
  executeSetOCGState() {
  }
}
const PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
}, PasswordResponses$1 = PasswordResponses, isBrowser = typeof document < "u", isLocalFileSystem = isBrowser && window.location.protocol === "file:";
function isDefined(t) {
  return typeof t < "u";
}
function isProvided(t) {
  return isDefined(t) && t !== null;
}
function isString$1(t) {
  return typeof t == "string";
}
function isArrayBuffer$1(t) {
  return t instanceof ArrayBuffer;
}
function isBlob(t) {
  return invariant(isBrowser, "isBlob can only be used in a browser environment"), t instanceof Blob;
}
function isDataURI(t) {
  return isString$1(t) && /^data:/.test(t);
}
function dataURItoByteString(t) {
  invariant(isDataURI(t), "Invalid data URI.");
  const [e = "", n = ""] = t.split(",");
  return e.split(";").indexOf("base64") !== -1 ? atob(n) : unescape(n);
}
function getDevicePixelRatio() {
  return isBrowser && window.devicePixelRatio || 1;
}
const allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function displayCORSWarning() {
  warning$2(!isLocalFileSystem, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${allowFileAccessFromFilesTip}`);
}
function displayWorkerWarning() {
  warning$2(!isLocalFileSystem, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${allowFileAccessFromFilesTip}`);
}
function cancelRunningTask(t) {
  t && t.cancel && t.cancel();
}
function makePageCallback(t, e) {
  return Object.defineProperty(t, "width", {
    get() {
      return this.view[2] * e;
    },
    configurable: !0
  }), Object.defineProperty(t, "height", {
    get() {
      return this.view[3] * e;
    },
    configurable: !0
  }), Object.defineProperty(t, "originalWidth", {
    get() {
      return this.view[2];
    },
    configurable: !0
  }), Object.defineProperty(t, "originalHeight", {
    get() {
      return this.view[3];
    },
    configurable: !0
  }), t;
}
function isCancelException(t) {
  return t.name === "RenderingCancelledException";
}
function loadFromFile(t) {
  return new Promise((e, n) => {
    const a = new FileReader();
    a.onload = () => {
      if (!a.result)
        return n(new Error("Error while reading a file."));
      e(a.result);
    }, a.onerror = (s) => {
      if (!s.target)
        return n(new Error("Error while reading a file."));
      const { error: o } = s.target;
      if (!o)
        return n(new Error("Error while reading a file."));
      switch (o.code) {
        case o.NOT_FOUND_ERR:
          return n(new Error("Error while reading a file: File not found."));
        case o.SECURITY_ERR:
          return n(new Error("Error while reading a file: Security error."));
        case o.ABORT_ERR:
          return n(new Error("Error while reading a file: Aborted."));
        default:
          return n(new Error("Error while reading a file."));
      }
    }, a.readAsArrayBuffer(t);
  });
}
function reducer(t, e) {
  switch (e.type) {
    case "RESOLVE":
      return { value: e.value, error: void 0 };
    case "REJECT":
      return { value: !1, error: e.error };
    case "RESET":
      return { value: void 0, error: void 0 };
    default:
      return t;
  }
}
function useResolver() {
  return useReducer(reducer, { value: void 0, error: void 0 });
}
const { PDFDataRangeTransport: PDFDataRangeTransport$1 } = pdfjs$1, eventProps = (() => {
  const t = {};
  return allEvents.forEach((e) => {
    t[e] = PropTypes.func;
  }), t;
})(), isTypedArray$2 = PropTypes.oneOfType([
  PropTypes.instanceOf(Int8Array),
  PropTypes.instanceOf(Uint8Array),
  PropTypes.instanceOf(Uint8ClampedArray),
  PropTypes.instanceOf(Int16Array),
  PropTypes.instanceOf(Uint16Array),
  PropTypes.instanceOf(Int32Array),
  PropTypes.instanceOf(Uint32Array),
  PropTypes.instanceOf(Float32Array),
  PropTypes.instanceOf(Float64Array)
]), fileTypes = [
  PropTypes.string,
  PropTypes.instanceOf(ArrayBuffer),
  PropTypes.shape({
    data: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(ArrayBuffer),
      PropTypes.arrayOf(PropTypes.number.isRequired),
      isTypedArray$2
    ]).isRequired
  }),
  PropTypes.shape({
    range: PropTypes.instanceOf(PDFDataRangeTransport$1).isRequired
  }),
  PropTypes.shape({
    url: PropTypes.string.isRequired
  })
];
typeof Blob < "u" && fileTypes.push(PropTypes.instanceOf(Blob));
const isClassName = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.arrayOf(PropTypes.string)
]), isFile = PropTypes.oneOfType(fileTypes);
PropTypes.instanceOf(LinkService);
PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]);
PropTypes.shape({
  commonObjs: PropTypes.shape({}).isRequired,
  getAnnotations: PropTypes.func.isRequired,
  getTextContent: PropTypes.func.isRequired,
  getViewport: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired
});
const isPageIndex = function t(e, n, a) {
  const { [n]: s, pageNumber: o, pdf: l } = e;
  if (!isDefined(l))
    return null;
  if (isDefined(s)) {
    if (typeof s != "number")
      return new Error(`\`${n}\` of type \`${typeof s}\` supplied to \`${a}\`, expected \`number\`.`);
    if (s < 0)
      return new Error(`Expected \`${n}\` to be greater or equal to 0.`);
    const { numPages: c } = l;
    if (s + 1 > c)
      return new Error(`Expected \`${n}\` to be less or equal to ${c - 1}.`);
  } else if (!isDefined(o))
    return new Error(`\`${n}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${a}\`.`);
  return null;
}, isPageNumber = function t(e, n, a) {
  const { [n]: s, pageIndex: o, pdf: l } = e;
  if (!isDefined(l))
    return null;
  if (isDefined(s)) {
    if (typeof s != "number")
      return new Error(`\`${n}\` of type \`${typeof s}\` supplied to \`${a}\`, expected \`number\`.`);
    if (s < 1)
      return new Error(`Expected \`${n}\` to be greater or equal to 1.`);
    const { numPages: c } = l;
    if (s > c)
      return new Error(`Expected \`${n}\` to be less or equal to ${c}.`);
  } else if (!isDefined(o))
    return new Error(`\`${n}\` not supplied. Either pageIndex or pageNumber must be supplied to \`${a}\`.`);
  return null;
}, isPdf = PropTypes.oneOfType([
  // Ideally, this would be `PropTypes.instanceOf(PDFDocumentProxy)`, but it can't be imported.
  PropTypes.any,
  PropTypes.oneOf([!1])
]), isRef = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.exact({
    current: PropTypes.any
  })
]), isRenderMode = PropTypes.oneOf(["canvas", "custom", "none", "svg"]), isRotate = PropTypes.oneOf([0, 90, 180, 270]);
var __awaiter = function(t, e, n, a) {
  function s(o) {
    return o instanceof n ? o : new n(function(l) {
      l(o);
    });
  }
  return new (n || (n = Promise))(function(o, l) {
    function c(f) {
      try {
        d(a.next(f));
      } catch (h) {
        l(h);
      }
    }
    function u(f) {
      try {
        d(a.throw(f));
      } catch (h) {
        l(h);
      }
    }
    function d(f) {
      f.done ? o(f.value) : s(f.value).then(c, u);
    }
    d((a = a.apply(t, e || [])).next());
  });
}, __rest$1 = function(t, e) {
  var n = {};
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && e.indexOf(a) < 0 && (n[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(t); s < a.length; s++)
      e.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[s]) && (n[a[s]] = t[a[s]]);
  return n;
};
const { PDFDataRangeTransport } = pdfjs$1, defaultOnPassword = (t, e) => {
  switch (e) {
    case PasswordResponses$1.NEED_PASSWORD: {
      const n = prompt("Enter the password to open this PDF file.");
      t(n);
      break;
    }
    case PasswordResponses$1.INCORRECT_PASSWORD: {
      const n = prompt("Invalid password. Please try again.");
      t(n);
      break;
    }
  }
}, Document$2 = forwardRef(function t(e, n) {
  var { children: a, className: s, error: o = "Failed to load PDF file.", externalLinkRel: l, externalLinkTarget: c, file: u, inputRef: d, imageResourcesPath: f, loading: h = "Loading PDF…", noData: g = "No PDF file specified.", onItemClick: x, onLoadError: E, onLoadProgress: m, onLoadSuccess: v, onPassword: y = defaultOnPassword, onSourceError: A, onSourceSuccess: b, options: C, renderMode: T, rotate: w } = e, R = __rest$1(e, ["children", "className", "error", "externalLinkRel", "externalLinkTarget", "file", "inputRef", "imageResourcesPath", "loading", "noData", "onItemClick", "onLoadError", "onLoadProgress", "onLoadSuccess", "onPassword", "onSourceError", "onSourceSuccess", "options", "renderMode", "rotate"]);
  const [O, D] = useResolver(), { value: k, error: W } = O, [L, z] = useResolver(), { value: P, error: Q } = L, Y = useRef(new LinkService()), ie = useRef([]), te = useRef({
    // Handling jumping to internal links target
    scrollPageIntoView: (X) => {
      const { dest: ye, pageNumber: Ae, pageIndex: fe = Ae - 1 } = X;
      if (x) {
        x({ dest: ye, pageIndex: fe, pageNumber: Ae });
        return;
      }
      const _e = ie.current[fe];
      if (_e) {
        _e.scrollIntoView();
        return;
      }
      warning$2(!1, `An internal link leading to page ${Ae} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
    }
  });
  useImperativeHandle(n, () => ({
    linkService: Y,
    pages: ie,
    viewer: te
  }), []);
  function Z() {
    b && b();
  }
  function ae() {
    W && (warning$2(!1, W.toString()), A && A(W));
  }
  function G() {
    D({ type: "RESET" });
  }
  useEffect(G, [u, D]);
  const U = useCallback(() => __awaiter(this, void 0, void 0, function* () {
    if (!u)
      return null;
    if (typeof u == "string")
      return isDataURI(u) ? { data: dataURItoByteString(u) } : (displayCORSWarning(), { url: u });
    if (u instanceof PDFDataRangeTransport)
      return { range: u };
    if (isArrayBuffer$1(u))
      return { data: u };
    if (isBrowser && isBlob(u))
      return { data: yield loadFromFile(u) };
    if (invariant(typeof u == "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object"), invariant("data" in u || "range" in u || "url" in u, "Invalid parameter object: need either .data, .range or .url"), "url" in u && typeof u.url == "string") {
      if (isDataURI(u.url)) {
        const { url: X } = u, ye = __rest$1(u, ["url"]), Ae = dataURItoByteString(X);
        return Object.assign({ data: Ae }, ye);
      }
      displayCORSWarning();
    }
    return u;
  }), [u]);
  useEffect(() => {
    const X = makeCancellablePromise(U());
    return X.promise.then((ye) => {
      D({ type: "RESOLVE", value: ye });
    }).catch((ye) => {
      D({ type: "REJECT", error: ye });
    }), () => {
      cancelRunningTask(X);
    };
  }, [U, D]), useEffect(
    () => {
      if (!(typeof k > "u")) {
        if (k === !1) {
          ae();
          return;
        }
        Z();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [k]
  );
  function F() {
    P && (v && v(P), ie.current = new Array(P.numPages), Y.current.setDocument(P));
  }
  function M() {
    Q && (warning$2(!1, Q.toString()), E && E(Q));
  }
  function I() {
    z({ type: "RESET" });
  }
  useEffect(I, [z, k]);
  function N() {
    if (!k)
      return;
    const X = C ? Object.assign(Object.assign({}, k), C) : k, ye = pdfjs$1.getDocument(X);
    m && (ye.onProgress = m), y && (ye.onPassword = y);
    const Ae = ye;
    return Ae.promise.then((fe) => {
      z({ type: "RESOLVE", value: fe });
    }).catch((fe) => {
      Ae.destroyed || z({ type: "REJECT", error: fe });
    }), () => {
      Ae.destroy();
    };
  }
  useEffect(
    N,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [C, z, k]
  ), useEffect(
    () => {
      if (!(typeof P > "u")) {
        if (P === !1) {
          M();
          return;
        }
        F();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [P]
  );
  function V() {
    Y.current.setViewer(te.current), Y.current.setExternalLinkRel(l), Y.current.setExternalLinkTarget(c);
  }
  useEffect(V, [l, c]);
  function q(X, ye) {
    ie.current[X] = ye;
  }
  function H(X) {
    delete ie.current[X];
  }
  const ne = useMemo(() => ({
    imageResourcesPath: f,
    linkService: Y.current,
    onItemClick: x,
    pdf: P,
    registerPage: q,
    renderMode: T,
    rotate: w,
    unregisterPage: H
  }), [f, x, P, T, w]), he = useMemo(() => makeEventProps(R, () => P), [R, P]);
  function j() {
    return React.createElement(DocumentContext.Provider, { value: ne }, a);
  }
  function Fe() {
    return u ? P == null ? React.createElement(Message, { type: "loading" }, typeof h == "function" ? h() : h) : P === !1 ? React.createElement(Message, { type: "error" }, typeof o == "function" ? o() : o) : j() : React.createElement(Message, { type: "no-data" }, typeof g == "function" ? g() : g);
  }
  return React.createElement("div", Object.assign({ className: clsx("react-pdf__Document", s), ref: d, style: {
    "--scale-factor": "1"
  } }, he), Fe());
}), isFunctionOrNode$1 = PropTypes.oneOfType([PropTypes.func, PropTypes.node]);
Document$2.propTypes = Object.assign(Object.assign({}, eventProps), { children: PropTypes.node, className: isClassName, error: isFunctionOrNode$1, externalLinkRel: PropTypes.string, externalLinkTarget: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]), file: isFile, imageResourcesPath: PropTypes.string, inputRef: isRef, loading: isFunctionOrNode$1, noData: isFunctionOrNode$1, onItemClick: PropTypes.func, onLoadError: PropTypes.func, onLoadProgress: PropTypes.func, onLoadSuccess: PropTypes.func, onPassword: PropTypes.func, onSourceError: PropTypes.func, onSourceSuccess: PropTypes.func, options: PropTypes.shape({
  canvasFactory: PropTypes.any,
  canvasMaxAreaInBytes: PropTypes.number,
  cMapPacked: PropTypes.bool,
  CMapReaderFactory: PropTypes.any,
  cMapUrl: PropTypes.string,
  disableAutoFetch: PropTypes.bool,
  disableFontFace: PropTypes.bool,
  disableRange: PropTypes.bool,
  disableStream: PropTypes.bool,
  docBaseUrl: PropTypes.string,
  enableXfa: PropTypes.bool,
  filterFactory: PropTypes.any,
  fontExtraProperties: PropTypes.bool,
  httpHeaders: PropTypes.object,
  isEvalSupported: PropTypes.bool,
  isOffscreenCanvasSupported: PropTypes.bool,
  length: PropTypes.number,
  maxImageSize: PropTypes.number,
  ownerDocument: PropTypes.any,
  password: PropTypes.string,
  pdfBug: PropTypes.bool,
  rangeChunkSize: PropTypes.number,
  StandardFontDataFactory: PropTypes.any,
  standardFontDataUrl: PropTypes.string,
  stopAtErrors: PropTypes.bool,
  useSystemFonts: PropTypes.bool,
  useWorkerFetch: PropTypes.bool,
  verbosity: PropTypes.number,
  withCredentials: PropTypes.bool,
  worker: PropTypes.any
}), rotate: PropTypes.number });
const Document$3 = Document$2;
function useDocumentContext() {
  return useContext(DocumentContext);
}
function mergeRefs() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = t.filter(Boolean);
  if (n.length <= 1) {
    var a = n[0];
    return a || null;
  }
  return function(o) {
    n.forEach(function(l) {
      typeof l == "function" ? l(o) : l && (l.current = o);
    });
  };
}
const PageContext = createContext(null), PDF_ROLE_TO_HTML_ROLE = {
  // Document level structure types
  Document: null,
  DocumentFragment: null,
  // Grouping level structure types
  Part: "group",
  Sect: "group",
  Div: "group",
  Aside: "note",
  NonStruct: "none",
  // Block level structure types
  P: null,
  // H<n>,
  H: "heading",
  Title: null,
  FENote: "note",
  // Sub-block level structure type
  Sub: "group",
  // General inline level structure types
  Lbl: null,
  Span: null,
  Em: null,
  Strong: null,
  Link: "link",
  Annot: "note",
  Form: "form",
  // Ruby and Warichu structure types
  Ruby: null,
  RB: null,
  RT: null,
  RP: null,
  Warichu: null,
  WT: null,
  WP: null,
  // List standard structure types
  L: "list",
  LI: "listitem",
  LBody: null,
  // Table standard structure types
  Table: "table",
  TR: "row",
  TH: "columnheader",
  TD: "cell",
  THead: "columnheader",
  TBody: null,
  TFoot: null,
  // Standard structure type Caption
  Caption: null,
  // Standard structure type Figure
  Figure: "figure",
  // Standard structure type Formula
  Formula: null,
  // standard structure type Artifact
  Artifact: null
}, HEADING_PATTERN = /^H(\d+)$/;
function isPdfRole(t) {
  return t in PDF_ROLE_TO_HTML_ROLE;
}
function isStructTreeNode(t) {
  return "children" in t;
}
function isStructTreeNodeWithOnlyContentChild(t) {
  return isStructTreeNode(t) ? t.children.length === 1 && 0 in t.children && "id" in t.children[0] : !1;
}
function getRoleAttributes(t) {
  const e = {};
  if (isStructTreeNode(t)) {
    const { role: n } = t, a = n.match(HEADING_PATTERN);
    if (a)
      e.role = "heading", e["aria-level"] = Number(a[1]);
    else if (isPdfRole(n)) {
      const s = PDF_ROLE_TO_HTML_ROLE[n];
      s && (e.role = s);
    }
  }
  return e;
}
function getBaseAttributes(t) {
  const e = {};
  if (isStructTreeNode(t)) {
    if (t.alt !== void 0 && (e["aria-label"] = t.alt), t.lang !== void 0 && (e.lang = t.lang), isStructTreeNodeWithOnlyContentChild(t)) {
      const [n] = t.children;
      if (n) {
        const a = getBaseAttributes(n);
        return Object.assign(Object.assign({}, e), a);
      }
    }
  } else
    "id" in t && (e["aria-owns"] = t.id);
  return e;
}
function getAttributes(t) {
  return t ? Object.assign(Object.assign({}, getRoleAttributes(t)), getBaseAttributes(t)) : null;
}
function StructTreeItem({ className: t, node: e }) {
  const n = useMemo(() => getAttributes(e), [e]), a = useMemo(() => !isStructTreeNode(e) || isStructTreeNodeWithOnlyContentChild(e) ? null : e.children.map((s, o) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(StructTreeItem, { key: o, node: s })
  )), [e]);
  return React.createElement("span", Object.assign({ className: t }, n), a);
}
function usePageContext() {
  return useContext(PageContext);
}
function StructTree() {
  const t = usePageContext();
  invariant(t, "Unable to find Page context.");
  const { onGetStructTreeError: e, onGetStructTreeSuccess: n } = t, [a, s] = useResolver(), { value: o, error: l } = a, { customTextRenderer: c, page: u } = t;
  function d() {
    o && n && n(o);
  }
  function f() {
    l && (warning$2(!1, l.toString()), e && e(l));
  }
  function h() {
    s({ type: "RESET" });
  }
  useEffect(h, [s, u]);
  function g() {
    if (c || !u)
      return;
    const x = makeCancellablePromise(u.getStructTree()), E = x;
    return x.promise.then((m) => {
      s({ type: "RESOLVE", value: m });
    }).catch((m) => {
      s({ type: "REJECT", error: m });
    }), () => cancelRunningTask(E);
  }
  return useEffect(g, [c, u, s]), useEffect(
    () => {
      if (o !== void 0) {
        if (o === !1) {
          f();
          return;
        }
        d();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o]
  ), o ? React.createElement(StructTreeItem, { className: "react-pdf__Page__structTree structTree", node: o }) : null;
}
const ANNOTATION_MODE = pdfjs$1.AnnotationMode;
function PageCanvas(t) {
  const e = usePageContext();
  invariant(e, "Unable to find Page context.");
  const n = Object.assign(Object.assign({}, e), t), { _className: a, canvasBackground: s, devicePixelRatio: o = getDevicePixelRatio(), onRenderError: l, onRenderSuccess: c, page: u, renderForms: d, renderTextLayer: f, rotate: h, scale: g } = n, { canvasRef: x } = t;
  invariant(u, "Attempted to render page canvas, but no page was specified.");
  const E = useRef(null);
  function m() {
    u && c && c(makePageCallback(u, g));
  }
  function v(T) {
    isCancelException(T) || (warning$2(!1, T.toString()), l && l(T));
  }
  const y = useMemo(() => u.getViewport({ scale: g * o, rotation: h }), [o, u, h, g]), A = useMemo(() => u.getViewport({ scale: g, rotation: h }), [u, h, g]);
  function b() {
    if (!u)
      return;
    u.cleanup();
    const { current: T } = E;
    if (!T)
      return;
    T.width = y.width, T.height = y.height, T.style.width = `${Math.floor(A.width)}px`, T.style.height = `${Math.floor(A.height)}px`, T.style.visibility = "hidden";
    const w = {
      annotationMode: d ? ANNOTATION_MODE.ENABLE_FORMS : ANNOTATION_MODE.ENABLE,
      canvasContext: T.getContext("2d", { alpha: !1 }),
      viewport: y
    };
    s && (w.background = s);
    const R = u.render(w), O = R;
    return R.promise.then(() => {
      T.style.visibility = "", m();
    }).catch(v), () => cancelRunningTask(O);
  }
  useEffect(
    b,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      s,
      E,
      o,
      u,
      d,
      y,
      A
    ]
  );
  const C = useCallback(() => {
    const { current: T } = E;
    T && (T.width = 0, T.height = 0);
  }, [E]);
  return useEffect(() => C, [C]), React.createElement("canvas", { className: `${a}__canvas`, dir: "ltr", ref: mergeRefs(x, E), style: {
    display: "block",
    userSelect: "none"
  } }, f ? React.createElement(StructTree, null) : null);
}
function PageSVG() {
  const t = usePageContext();
  invariant(t, "Unable to find Page context.");
  const { _className: e, onRenderSuccess: n, onRenderError: a, page: s, rotate: o, scale: l } = t;
  invariant(s, "Attempted to render page SVG, but no page was specified.");
  const [c, u] = useResolver(), { value: d, error: f } = c;
  function h() {
    s && n && n(makePageCallback(s, l));
  }
  function g() {
    f && (isCancelException(f) || (warning$2(!1, f.toString()), a && a(f)));
  }
  const x = useMemo(() => s.getViewport({ scale: l, rotation: o }), [s, o, l]);
  function E() {
    u({ type: "RESET" });
  }
  useEffect(E, [s, u, x]);
  function m() {
    if (!s)
      return;
    const b = makeCancellablePromise(s.getOperatorList());
    return b.promise.then((C) => {
      new pdfjs$1.SVGGraphics(s.commonObjs, s.objs).getSVG(C, x).then((w) => {
        if (!(w instanceof SVGElement))
          throw new Error("getSVG returned unexpected result.");
        u({ type: "RESOLVE", value: w });
      }).catch((w) => {
        u({ type: "REJECT", error: w });
      });
    }).catch((C) => {
      u({ type: "REJECT", error: C });
    }), () => cancelRunningTask(b);
  }
  useEffect(m, [s, u, x]), useEffect(
    () => {
      if (d !== void 0) {
        if (d === !1) {
          g();
          return;
        }
        h();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d]
  );
  function v(b) {
    if (!b || !d)
      return;
    b.firstElementChild || b.appendChild(d);
    const { width: C, height: T } = x;
    d.setAttribute("width", `${C}`), d.setAttribute("height", `${T}`);
  }
  const { width: y, height: A } = x;
  return React.createElement("div", {
    className: `${e}__svg`,
    // Note: This cannot be shortened, as we need this function to be called with each render.
    ref: (b) => v(b),
    style: {
      display: "block",
      backgroundColor: "white",
      overflow: "hidden",
      width: y,
      height: A,
      userSelect: "none"
    }
  });
}
function isTextItem(t) {
  return "str" in t;
}
function TextLayer() {
  const t = usePageContext();
  invariant(t, "Unable to find Page context.");
  const { customTextRenderer: e, onGetTextError: n, onGetTextSuccess: a, onRenderTextLayerError: s, onRenderTextLayerSuccess: o, page: l, pageIndex: c, pageNumber: u, rotate: d, scale: f } = t;
  invariant(l, "Attempted to load page text content, but no page was specified.");
  const [h, g] = useResolver(), { value: x, error: E } = h, m = useRef(null), v = useRef();
  warning$2(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
  function y() {
    x && a && a(x);
  }
  function A() {
    E && (warning$2(!1, E.toString()), n && n(E));
  }
  function b() {
    g({ type: "RESET" });
  }
  useEffect(b, [l, g]);
  function C() {
    if (!l)
      return;
    const W = makeCancellablePromise(l.getTextContent()), L = W;
    return W.promise.then((z) => {
      g({ type: "RESOLVE", value: z });
    }).catch((z) => {
      g({ type: "REJECT", error: z });
    }), () => cancelRunningTask(L);
  }
  useEffect(C, [l, g]), useEffect(
    () => {
      if (x !== void 0) {
        if (x === !1) {
          A();
          return;
        }
        y();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [x]
  );
  const T = useCallback(() => {
    o && o();
  }, [o]), w = useCallback((W) => {
    warning$2(!1, W.toString()), s && s(W);
  }, [s]);
  function R() {
    const W = v.current;
    W && W.classList.add("active");
  }
  function O() {
    const W = v.current;
    W && W.classList.remove("active");
  }
  const D = useMemo(() => l.getViewport({ scale: f, rotation: d }), [l, d, f]);
  function k() {
    if (!l || !x)
      return;
    const { current: W } = m;
    if (!W)
      return;
    W.innerHTML = "";
    const L = l.streamTextContent({ includeMarkedContent: !0 }), z = {
      container: W,
      textContentSource: L,
      viewport: D
    }, P = pdfjs$1.renderTextLayer(z), Q = P;
    return P.promise.then(() => {
      const Y = document.createElement("div");
      Y.className = "endOfContent", W.append(Y), v.current = Y;
      const ie = W.querySelectorAll('[role="presentation"]');
      if (e) {
        let te = 0;
        x.items.forEach((Z, ae) => {
          if (!isTextItem(Z))
            return;
          const G = ie[te];
          if (!G)
            return;
          const U = e(Object.assign({
            pageIndex: c,
            pageNumber: u,
            itemIndex: ae
          }, Z));
          G.innerHTML = U, te += Z.str && Z.hasEOL ? 2 : 1;
        });
      }
      T();
    }).catch(w), () => cancelRunningTask(Q);
  }
  return useLayoutEffect$1(k, [
    e,
    w,
    T,
    l,
    c,
    u,
    x,
    D
  ]), // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  React.createElement("div", { className: clsx("react-pdf__Page__textContent", "textLayer"), onMouseUp: O, onMouseDown: R, ref: m });
}
function AnnotationLayer() {
  const t = useDocumentContext();
  invariant(t, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
  const e = usePageContext();
  invariant(e, "Unable to find Page context.");
  const n = Object.assign(Object.assign({}, t), e), { imageResourcesPath: a, linkService: s, onGetAnnotationsError: o, onGetAnnotationsSuccess: l, onRenderAnnotationLayerError: c, onRenderAnnotationLayerSuccess: u, page: d, pdf: f, renderForms: h, rotate: g, scale: x = 1 } = n;
  invariant(d, "Attempted to load page annotations, but no page was specified.");
  const [E, m] = useResolver(), { value: v, error: y } = E, A = useRef(null);
  warning$2(parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
  function b() {
    v && l && l(v);
  }
  function C() {
    y && (warning$2(!1, y.toString()), o && o(y));
  }
  function T() {
    m({ type: "RESET" });
  }
  useEffect(T, [m, d]);
  function w() {
    if (!d)
      return;
    const W = makeCancellablePromise(d.getAnnotations()), L = W;
    return W.promise.then((z) => {
      m({ type: "RESOLVE", value: z });
    }).catch((z) => {
      m({ type: "REJECT", error: z });
    }), () => {
      cancelRunningTask(L);
    };
  }
  useEffect(w, [m, d, h]), useEffect(
    () => {
      if (v !== void 0) {
        if (v === !1) {
          C();
          return;
        }
        b();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  );
  function R() {
    u && u();
  }
  function O(W) {
    warning$2(!1, `${W}`), c && c(W);
  }
  const D = useMemo(() => d.getViewport({ scale: x, rotation: g }), [d, g, x]);
  function k() {
    if (!f || !d || !v)
      return;
    const { current: W } = A;
    if (!W)
      return;
    const L = D.clone({ dontFlip: !0 }), z = {
      accessibilityManager: null,
      annotationCanvasMap: null,
      div: W,
      l10n: null,
      page: d,
      viewport: L
    }, P = {
      annotations: v,
      annotationStorage: f.annotationStorage,
      div: W,
      // See https://github.com/mozilla/pdf.js/issues/17029
      downloadManager: null,
      imageResourcesPath: a,
      linkService: s,
      page: d,
      renderForms: h,
      viewport: L
    };
    W.innerHTML = "";
    try {
      new pdfjs$1.AnnotationLayer(z).render(P), R();
    } catch (Q) {
      O(Q);
    }
    return () => {
    };
  }
  return useEffect(
    k,
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v, a, s, d, h, D]
  ), React.createElement("div", { className: clsx("react-pdf__Page__annotations", "annotationLayer"), ref: A });
}
var __rest = function(t, e) {
  var n = {};
  for (var a in t)
    Object.prototype.hasOwnProperty.call(t, a) && e.indexOf(a) < 0 && (n[a] = t[a]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(t); s < a.length; s++)
      e.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, a[s]) && (n[a[s]] = t[a[s]]);
  return n;
};
const defaultScale = 1, Page = function t(e) {
  const n = useDocumentContext();
  invariant(n, "Unable to find Document context. Did you wrap <Page /> in <Document />?");
  const a = Object.assign(Object.assign({}, n), e), { _className: s = "react-pdf__Page", _enableRegisterUnregisterPage: o = !0, canvasBackground: l, canvasRef: c, children: u, className: d, customRenderer: f, customTextRenderer: h, devicePixelRatio: g, error: x = "Failed to load the page.", height: E, inputRef: m, loading: v = "Loading page…", noData: y = "No page specified.", onGetAnnotationsError: A, onGetAnnotationsSuccess: b, onGetStructTreeError: C, onGetStructTreeSuccess: T, onGetTextError: w, onGetTextSuccess: R, onLoadError: O, onLoadSuccess: D, onRenderAnnotationLayerError: k, onRenderAnnotationLayerSuccess: W, onRenderError: L, onRenderSuccess: z, onRenderTextLayerError: P, onRenderTextLayerSuccess: Q, pageIndex: Y, pageNumber: ie, pdf: te, registerPage: Z, renderAnnotationLayer: ae = !0, renderForms: G = !1, renderMode: U = "canvas", renderTextLayer: F = !0, rotate: M, scale: I = defaultScale, unregisterPage: N, width: V } = a, q = __rest(a, ["_className", "_enableRegisterUnregisterPage", "canvasBackground", "canvasRef", "children", "className", "customRenderer", "customTextRenderer", "devicePixelRatio", "error", "height", "inputRef", "loading", "noData", "onGetAnnotationsError", "onGetAnnotationsSuccess", "onGetStructTreeError", "onGetStructTreeSuccess", "onGetTextError", "onGetTextSuccess", "onLoadError", "onLoadSuccess", "onRenderAnnotationLayerError", "onRenderAnnotationLayerSuccess", "onRenderError", "onRenderSuccess", "onRenderTextLayerError", "onRenderTextLayerSuccess", "pageIndex", "pageNumber", "pdf", "registerPage", "renderAnnotationLayer", "renderForms", "renderMode", "renderTextLayer", "rotate", "scale", "unregisterPage", "width"]), [H, ne] = useResolver(), { value: he, error: j } = H, Fe = useRef(null);
  invariant(te, "Attempted to load a page, but no document was specified.");
  const X = isProvided(ie) ? ie - 1 : Y ?? null, ye = ie ?? (isProvided(Y) ? Y + 1 : null), Ae = M ?? (he ? he.rotate : null), fe = useMemo(() => {
    if (!he)
      return null;
    let gt = 1;
    const pt = I ?? defaultScale;
    if (V || E) {
      const nt = he.getViewport({ scale: 1, rotation: Ae });
      V ? gt = V / nt.width : E && (gt = E / nt.height);
    }
    return pt * gt;
  }, [E, he, Ae, I, V]);
  function _e() {
    return () => {
      isProvided(X) && o && N && N(X);
    };
  }
  useEffect(_e, [o, te, X, N]);
  function Ie() {
    if (D) {
      if (!he || !fe)
        return;
      D(makePageCallback(he, fe));
    }
    if (o && Z) {
      if (!isProvided(X) || !Fe.current)
        return;
      Z(X, Fe.current);
    }
  }
  function Be() {
    j && (warning$2(!1, j.toString()), O && O(j));
  }
  function $e() {
    ne({ type: "RESET" });
  }
  useEffect($e, [ne, te, X]);
  function Me() {
    if (!te || !ye)
      return;
    const gt = makeCancellablePromise(te.getPage(ye)), pt = gt;
    return gt.promise.then((nt) => {
      ne({ type: "RESOLVE", value: nt });
    }).catch((nt) => {
      ne({ type: "REJECT", error: nt });
    }), () => cancelRunningTask(pt);
  }
  useEffect(Me, [ne, te, X, ye, Z]), useEffect(
    () => {
      if (he !== void 0) {
        if (he === !1) {
          Be();
          return;
        }
        Ie();
      }
    },
    // Ommitted callbacks so they are not called every time they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [he, fe]
  );
  const J = useMemo(() => (
    // Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
    he && isProvided(X) && ye && isProvided(Ae) && isProvided(fe) ? {
      _className: s,
      canvasBackground: l,
      customTextRenderer: h,
      devicePixelRatio: g,
      onGetAnnotationsError: A,
      onGetAnnotationsSuccess: b,
      onGetStructTreeError: C,
      onGetStructTreeSuccess: T,
      onGetTextError: w,
      onGetTextSuccess: R,
      onRenderAnnotationLayerError: k,
      onRenderAnnotationLayerSuccess: W,
      onRenderError: L,
      onRenderSuccess: z,
      onRenderTextLayerError: P,
      onRenderTextLayerSuccess: Q,
      page: he,
      pageIndex: X,
      pageNumber: ye,
      renderForms: G,
      renderTextLayer: F,
      rotate: Ae,
      scale: fe
    } : null
  ), [
    s,
    l,
    h,
    g,
    A,
    b,
    C,
    T,
    w,
    R,
    k,
    W,
    L,
    z,
    P,
    Q,
    he,
    X,
    ye,
    G,
    F,
    Ae,
    fe
  ]), K = useMemo(() => makeEventProps(q, () => he && (fe ? makePageCallback(he, fe) : void 0)), [q, he, fe]), ge = `${X}@${fe}/${Ae}`, Ce = `${X}/${Ae}`;
  function Oe() {
    switch (U) {
      case "custom":
        return invariant(f, 'renderMode was set to "custom", but no customRenderer was passed.'), React.createElement(f, { key: `${ge}_custom` });
      case "none":
        return null;
      case "svg":
        return React.createElement(PageSVG, { key: `${Ce}_svg` });
      case "canvas":
      default:
        return React.createElement(PageCanvas, { key: `${ge}_canvas`, canvasRef: c });
    }
  }
  function qe() {
    return F ? React.createElement(TextLayer, { key: `${ge}_text` }) : null;
  }
  function ct() {
    return ae ? React.createElement(AnnotationLayer, { key: `${ge}_annotations` }) : null;
  }
  function ze() {
    return React.createElement(
      PageContext.Provider,
      { value: J },
      Oe(),
      qe(),
      ct(),
      u
    );
  }
  function et() {
    return ye ? te === null || he === void 0 || he === null ? React.createElement(Message, { type: "loading" }, typeof v == "function" ? v() : v) : te === !1 || he === !1 ? React.createElement(Message, { type: "error" }, typeof x == "function" ? x() : x) : ze() : React.createElement(Message, { type: "no-data" }, typeof y == "function" ? y() : y);
  }
  return React.createElement("div", Object.assign({ className: clsx(s, d), "data-page-number": ye, ref: mergeRefs(m, Fe), style: {
    "--scale-factor": `${fe}`,
    backgroundColor: l || "white",
    position: "relative",
    minWidth: "min-content",
    minHeight: "min-content"
  } }, K), et());
}, isFunctionOrNode = PropTypes.oneOfType([PropTypes.func, PropTypes.node]);
Page.propTypes = Object.assign(Object.assign({}, eventProps), { canvasBackground: PropTypes.string, canvasRef: isRef, children: PropTypes.node, className: isClassName, customRenderer: PropTypes.func, customTextRenderer: PropTypes.func, devicePixelRatio: PropTypes.number, error: isFunctionOrNode, height: PropTypes.number, imageResourcesPath: PropTypes.string, inputRef: isRef, loading: isFunctionOrNode, noData: isFunctionOrNode, onGetTextError: PropTypes.func, onGetTextSuccess: PropTypes.func, onLoadError: PropTypes.func, onLoadSuccess: PropTypes.func, onRenderError: PropTypes.func, onRenderSuccess: PropTypes.func, onRenderTextLayerError: PropTypes.func, onRenderTextLayerSuccess: PropTypes.func, pageIndex: isPageIndex, pageNumber: isPageNumber, pdf: isPdf, renderAnnotationLayer: PropTypes.bool, renderForms: PropTypes.bool, renderMode: isRenderMode, renderTextLayer: PropTypes.bool, rotate: isRotate, scale: PropTypes.number, width: PropTypes.number });
const Page$1 = Page;
displayWorkerWarning();
pdfjs$1.GlobalWorkerOptions.workerSrc = "pdf.worker.js";
const base64FromArraybuffer = async (t) => (await new Promise((n) => {
  const a = new FileReader();
  a.onload = () => n(a.result), a.readAsDataURL(new Blob([t]));
})).split(",", 2)[1], PDFViewer = (t) => {
  const e = useRef(null), n = useRef(!1), [a, s] = useState(0), [o, l] = useState(!1), [c, u] = useState(""), [d, f] = useState(0), [h, g] = useState("0"), [x, E] = useState("");
  useEffect(() => {
    const b = async () => {
      if (e.current) {
        const { width: T } = e.current.getBoundingClientRect();
        s(T);
      }
      l(!0), fetch(t.filePath).then((T) => {
        T.arrayBuffer().then((R) => {
          const O = new Uint8Array(R);
          base64FromArraybuffer(O).then((D) => {
            u(D), l(!1);
          });
        });
      }).catch(() => {
        l(!1);
      });
    };
    t.filePath && !n.current && (n.current = !0, b());
  }, [t.filePath]);
  const m = (b) => {
    const C = (b.loaded / b.total * 100).toFixed();
    g(C);
  }, v = () => {
    f(Math.max(d - 1, 0));
  }, y = () => f(d + 1), A = () => f(0);
  return x ? t.errorComponent : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pdf-viewer-container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "pdf-viewer",
      ref: e,
      style: { width: `${a}px` },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pdf-controls-container", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "view-control", onClick: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "zoom-in" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "view-control", onClick: A, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "zoom-reset" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "view-control", onClick: v, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "zoom-out" }) })
        ] }),
        c ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Document$3,
          {
            onError: (b) => E(b.message),
            onLoadProgress: m,
            file: `data:application/pdf;base64,${c}`,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Page$1, { pageNumber: 1 })
          }
        ) : o ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pdf-loading", children: [
          "Loading (",
          h,
          "%)"
        ] }) : null
      ]
    }
  ) });
};
var lib$2 = {}, VERSION = "1.13.6", root = typeof self == "object" && self.self === self && self || typeof global == "object" && global.global === global && global || Function("return this")() || {}, ArrayProto = Array.prototype, ObjProto = Object.prototype, SymbolProto = typeof Symbol < "u" ? Symbol.prototype : null, push = ArrayProto.push, slice = ArrayProto.slice, toString$1 = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty, supportsArrayBuffer = typeof ArrayBuffer < "u", supportsDataView = typeof DataView < "u", nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeCreate = Object.create, nativeIsView = supportsArrayBuffer && ArrayBuffer.isView, _isNaN = isNaN, _isFinite = isFinite, hasEnumBug = !{ toString: null }.propertyIsEnumerable("toString"), nonEnumerableProps = [
  "valueOf",
  "isPrototypeOf",
  "toString",
  "propertyIsEnumerable",
  "hasOwnProperty",
  "toLocaleString"
], MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
function restArguments(t, e) {
  return e = e == null ? t.length - 1 : +e, function() {
    for (var n = Math.max(arguments.length - e, 0), a = Array(n), s = 0; s < n; s++)
      a[s] = arguments[s + e];
    switch (e) {
      case 0:
        return t.call(this, a);
      case 1:
        return t.call(this, arguments[0], a);
      case 2:
        return t.call(this, arguments[0], arguments[1], a);
    }
    var o = Array(e + 1);
    for (s = 0; s < e; s++)
      o[s] = arguments[s];
    return o[e] = a, t.apply(this, o);
  };
}
function isObject(t) {
  var e = typeof t;
  return e === "function" || e === "object" && !!t;
}
function isNull(t) {
  return t === null;
}
function isUndefined(t) {
  return t === void 0;
}
function isBoolean(t) {
  return t === !0 || t === !1 || toString$1.call(t) === "[object Boolean]";
}
function isElement(t) {
  return !!(t && t.nodeType === 1);
}
function tagTester(t) {
  var e = "[object " + t + "]";
  return function(n) {
    return toString$1.call(n) === e;
  };
}
const isString = tagTester("String"), isNumber = tagTester("Number"), isDate = tagTester("Date"), isRegExp = tagTester("RegExp"), isError = tagTester("Error"), isSymbol = tagTester("Symbol"), isArrayBuffer = tagTester("ArrayBuffer");
var isFunction = tagTester("Function"), nodelist = root.document && root.document.childNodes;
typeof /./ != "function" && typeof Int8Array != "object" && typeof nodelist != "function" && (isFunction = function(t) {
  return typeof t == "function" || !1;
});
const isFunction$1 = isFunction, hasObjectTag = tagTester("Object");
var hasStringTagBug = supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8))), isIE11 = typeof Map < "u" && hasObjectTag(/* @__PURE__ */ new Map()), isDataView = tagTester("DataView");
function ie10IsDataView(t) {
  return t != null && isFunction$1(t.getInt8) && isArrayBuffer(t.buffer);
}
const isDataView$1 = hasStringTagBug ? ie10IsDataView : isDataView, isArray = nativeIsArray || tagTester("Array");
function has$1(t, e) {
  return t != null && hasOwnProperty.call(t, e);
}
var isArguments = tagTester("Arguments");
(function() {
  isArguments(arguments) || (isArguments = function(t) {
    return has$1(t, "callee");
  });
})();
const isArguments$1 = isArguments;
function isFinite$1(t) {
  return !isSymbol(t) && _isFinite(t) && !isNaN(parseFloat(t));
}
function isNaN$1(t) {
  return isNumber(t) && _isNaN(t);
}
function constant(t) {
  return function() {
    return t;
  };
}
function createSizePropertyCheck(t) {
  return function(e) {
    var n = t(e);
    return typeof n == "number" && n >= 0 && n <= MAX_ARRAY_INDEX;
  };
}
function shallowProperty(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
const getByteLength = shallowProperty("byteLength"), isBufferLike = createSizePropertyCheck(getByteLength);
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(t) {
  return nativeIsView ? nativeIsView(t) && !isDataView$1(t) : isBufferLike(t) && typedArrayPattern.test(toString$1.call(t));
}
const isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(!1), getLength = shallowProperty("length");
function emulatedSet(t) {
  for (var e = {}, n = t.length, a = 0; a < n; ++a)
    e[t[a]] = !0;
  return {
    contains: function(s) {
      return e[s] === !0;
    },
    push: function(s) {
      return e[s] = !0, t.push(s);
    }
  };
}
function collectNonEnumProps(t, e) {
  e = emulatedSet(e);
  var n = nonEnumerableProps.length, a = t.constructor, s = isFunction$1(a) && a.prototype || ObjProto, o = "constructor";
  for (has$1(t, o) && !e.contains(o) && e.push(o); n--; )
    o = nonEnumerableProps[n], o in t && t[o] !== s[o] && !e.contains(o) && e.push(o);
}
function keys$1(t) {
  if (!isObject(t))
    return [];
  if (nativeKeys)
    return nativeKeys(t);
  var e = [];
  for (var n in t)
    has$1(t, n) && e.push(n);
  return hasEnumBug && collectNonEnumProps(t, e), e;
}
function isEmpty(t) {
  if (t == null)
    return !0;
  var e = getLength(t);
  return typeof e == "number" && (isArray(t) || isString(t) || isArguments$1(t)) ? e === 0 : getLength(keys$1(t)) === 0;
}
function isMatch(t, e) {
  var n = keys$1(e), a = n.length;
  if (t == null)
    return !a;
  for (var s = Object(t), o = 0; o < a; o++) {
    var l = n[o];
    if (e[l] !== s[l] || !(l in s))
      return !1;
  }
  return !0;
}
function _$i(t) {
  if (t instanceof _$i)
    return t;
  if (!(this instanceof _$i))
    return new _$i(t);
  this._wrapped = t;
}
_$i.VERSION = VERSION;
_$i.prototype.value = function() {
  return this._wrapped;
};
_$i.prototype.valueOf = _$i.prototype.toJSON = _$i.prototype.value;
_$i.prototype.toString = function() {
  return String(this._wrapped);
};
function toBufferView(t) {
  return new Uint8Array(
    t.buffer || t,
    t.byteOffset || 0,
    getByteLength(t)
  );
}
var tagDataView = "[object DataView]";
function eq(t, e, n, a) {
  if (t === e)
    return t !== 0 || 1 / t === 1 / e;
  if (t == null || e == null)
    return !1;
  if (t !== t)
    return e !== e;
  var s = typeof t;
  return s !== "function" && s !== "object" && typeof e != "object" ? !1 : deepEq(t, e, n, a);
}
function deepEq(t, e, n, a) {
  t instanceof _$i && (t = t._wrapped), e instanceof _$i && (e = e._wrapped);
  var s = toString$1.call(t);
  if (s !== toString$1.call(e))
    return !1;
  if (hasStringTagBug && s == "[object Object]" && isDataView$1(t)) {
    if (!isDataView$1(e))
      return !1;
    s = tagDataView;
  }
  switch (s) {
    case "[object RegExp]":
    case "[object String]":
      return "" + t == "" + e;
    case "[object Number]":
      return +t != +t ? +e != +e : +t == 0 ? 1 / +t === 1 / e : +t == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +t == +e;
    case "[object Symbol]":
      return SymbolProto.valueOf.call(t) === SymbolProto.valueOf.call(e);
    case "[object ArrayBuffer]":
    case tagDataView:
      return deepEq(toBufferView(t), toBufferView(e), n, a);
  }
  var o = s === "[object Array]";
  if (!o && isTypedArray$1(t)) {
    var l = getByteLength(t);
    if (l !== getByteLength(e))
      return !1;
    if (t.buffer === e.buffer && t.byteOffset === e.byteOffset)
      return !0;
    o = !0;
  }
  if (!o) {
    if (typeof t != "object" || typeof e != "object")
      return !1;
    var c = t.constructor, u = e.constructor;
    if (c !== u && !(isFunction$1(c) && c instanceof c && isFunction$1(u) && u instanceof u) && "constructor" in t && "constructor" in e)
      return !1;
  }
  n = n || [], a = a || [];
  for (var d = n.length; d--; )
    if (n[d] === t)
      return a[d] === e;
  if (n.push(t), a.push(e), o) {
    if (d = t.length, d !== e.length)
      return !1;
    for (; d--; )
      if (!eq(t[d], e[d], n, a))
        return !1;
  } else {
    var f = keys$1(t), h;
    if (d = f.length, keys$1(e).length !== d)
      return !1;
    for (; d--; )
      if (h = f[d], !(has$1(e, h) && eq(t[h], e[h], n, a)))
        return !1;
  }
  return n.pop(), a.pop(), !0;
}
function isEqual(t, e) {
  return eq(t, e);
}
function allKeys(t) {
  if (!isObject(t))
    return [];
  var e = [];
  for (var n in t)
    e.push(n);
  return hasEnumBug && collectNonEnumProps(t, e), e;
}
function ie11fingerprint(t) {
  var e = getLength(t);
  return function(n) {
    if (n == null)
      return !1;
    var a = allKeys(n);
    if (getLength(a))
      return !1;
    for (var s = 0; s < e; s++)
      if (!isFunction$1(n[t[s]]))
        return !1;
    return t !== weakMapMethods || !isFunction$1(n[forEachName]);
  };
}
var forEachName = "forEach", hasName = "has", commonInit = ["clear", "delete"], mapTail = ["get", hasName, "set"], mapMethods = commonInit.concat(forEachName, mapTail), weakMapMethods = commonInit.concat(mapTail), setMethods = ["add"].concat(commonInit, forEachName, hasName);
const isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester("Map"), isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester("WeakMap"), isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester("Set"), isWeakSet = tagTester("WeakSet");
function values(t) {
  for (var e = keys$1(t), n = e.length, a = Array(n), s = 0; s < n; s++)
    a[s] = t[e[s]];
  return a;
}
function pairs(t) {
  for (var e = keys$1(t), n = e.length, a = Array(n), s = 0; s < n; s++)
    a[s] = [e[s], t[e[s]]];
  return a;
}
function invert(t) {
  for (var e = {}, n = keys$1(t), a = 0, s = n.length; a < s; a++)
    e[t[n[a]]] = n[a];
  return e;
}
function functions(t) {
  var e = [];
  for (var n in t)
    isFunction$1(t[n]) && e.push(n);
  return e.sort();
}
function createAssigner(t, e) {
  return function(n) {
    var a = arguments.length;
    if (e && (n = Object(n)), a < 2 || n == null)
      return n;
    for (var s = 1; s < a; s++)
      for (var o = arguments[s], l = t(o), c = l.length, u = 0; u < c; u++) {
        var d = l[u];
        (!e || n[d] === void 0) && (n[d] = o[d]);
      }
    return n;
  };
}
const extend = createAssigner(allKeys), extendOwn = createAssigner(keys$1), defaults = createAssigner(allKeys, !0);
function ctor() {
  return function() {
  };
}
function baseCreate(t) {
  if (!isObject(t))
    return {};
  if (nativeCreate)
    return nativeCreate(t);
  var e = ctor();
  e.prototype = t;
  var n = new e();
  return e.prototype = null, n;
}
function create(t, e) {
  var n = baseCreate(t);
  return e && extendOwn(n, e), n;
}
function clone(t) {
  return isObject(t) ? isArray(t) ? t.slice() : extend({}, t) : t;
}
function tap(t, e) {
  return e(t), t;
}
function toPath$1(t) {
  return isArray(t) ? t : [t];
}
_$i.toPath = toPath$1;
function toPath(t) {
  return _$i.toPath(t);
}
function deepGet(t, e) {
  for (var n = e.length, a = 0; a < n; a++) {
    if (t == null)
      return;
    t = t[e[a]];
  }
  return n ? t : void 0;
}
function get(t, e, n) {
  var a = deepGet(t, toPath(e));
  return isUndefined(a) ? n : a;
}
function has(t, e) {
  e = toPath(e);
  for (var n = e.length, a = 0; a < n; a++) {
    var s = e[a];
    if (!has$1(t, s))
      return !1;
    t = t[s];
  }
  return !!n;
}
function identity$2(t) {
  return t;
}
function matcher(t) {
  return t = extendOwn({}, t), function(e) {
    return isMatch(e, t);
  };
}
function property(t) {
  return t = toPath(t), function(e) {
    return deepGet(e, t);
  };
}
function optimizeCb(t, e, n) {
  if (e === void 0)
    return t;
  switch (n ?? 3) {
    case 1:
      return function(a) {
        return t.call(e, a);
      };
    case 3:
      return function(a, s, o) {
        return t.call(e, a, s, o);
      };
    case 4:
      return function(a, s, o, l) {
        return t.call(e, a, s, o, l);
      };
  }
  return function() {
    return t.apply(e, arguments);
  };
}
function baseIteratee(t, e, n) {
  return t == null ? identity$2 : isFunction$1(t) ? optimizeCb(t, e, n) : isObject(t) && !isArray(t) ? matcher(t) : property(t);
}
function iteratee(t, e) {
  return baseIteratee(t, e, 1 / 0);
}
_$i.iteratee = iteratee;
function cb(t, e, n) {
  return _$i.iteratee !== iteratee ? _$i.iteratee(t, e) : baseIteratee(t, e, n);
}
function mapObject(t, e, n) {
  e = cb(e, n);
  for (var a = keys$1(t), s = a.length, o = {}, l = 0; l < s; l++) {
    var c = a[l];
    o[c] = e(t[c], c, t);
  }
  return o;
}
function noop() {
}
function propertyOf(t) {
  return t == null ? noop : function(e) {
    return get(t, e);
  };
}
function times(t, e, n) {
  var a = Array(Math.max(0, t));
  e = optimizeCb(e, n, 1);
  for (var s = 0; s < t; s++)
    a[s] = e(s);
  return a;
}
function random(t, e) {
  return e == null && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
}
const now = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function createEscaper(t) {
  var e = function(o) {
    return t[o];
  }, n = "(?:" + keys$1(t).join("|") + ")", a = RegExp(n), s = RegExp(n, "g");
  return function(o) {
    return o = o == null ? "" : "" + o, a.test(o) ? o.replace(s, e) : o;
  };
}
const escapeMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;"
}, escape$1 = createEscaper(escapeMap), unescapeMap = invert(escapeMap), unescape$1 = createEscaper(unescapeMap), templateSettings = _$i.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
};
var noMatch = /(.)^/, escapes = {
  "'": "'",
  "\\": "\\",
  "\r": "r",
  "\n": "n",
  "\u2028": "u2028",
  "\u2029": "u2029"
}, escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function escapeChar(t) {
  return "\\" + escapes[t];
}
var bareIdentifier = /^\s*(\w|\$)+\s*$/;
function template(t, e, n) {
  !e && n && (e = n), e = defaults({}, e, _$i.templateSettings);
  var a = RegExp([
    (e.escape || noMatch).source,
    (e.interpolate || noMatch).source,
    (e.evaluate || noMatch).source
  ].join("|") + "|$", "g"), s = 0, o = "__p+='";
  t.replace(a, function(d, f, h, g, x) {
    return o += t.slice(s, x).replace(escapeRegExp, escapeChar), s = x + d.length, f ? o += `'+
((__t=(` + f + `))==null?'':_.escape(__t))+
'` : h ? o += `'+
((__t=(` + h + `))==null?'':__t)+
'` : g && (o += `';
` + g + `
__p+='`), d;
  }), o += `';
`;
  var l = e.variable;
  if (l) {
    if (!bareIdentifier.test(l))
      throw new Error(
        "variable is not a bare identifier: " + l
      );
  } else
    o = `with(obj||{}){
` + o + `}
`, l = "obj";
  o = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + o + `return __p;
`;
  var c;
  try {
    c = new Function(l, "_", o);
  } catch (d) {
    throw d.source = o, d;
  }
  var u = function(d) {
    return c.call(this, d, _$i);
  };
  return u.source = "function(" + l + `){
` + o + "}", u;
}
function result(t, e, n) {
  e = toPath(e);
  var a = e.length;
  if (!a)
    return isFunction$1(n) ? n.call(t) : n;
  for (var s = 0; s < a; s++) {
    var o = t == null ? void 0 : t[e[s]];
    o === void 0 && (o = n, s = a), t = isFunction$1(o) ? o.call(t) : o;
  }
  return t;
}
var idCounter = 0;
function uniqueId(t) {
  var e = ++idCounter + "";
  return t ? t + e : e;
}
function chain(t) {
  var e = _$i(t);
  return e._chain = !0, e;
}
function executeBound(t, e, n, a, s) {
  if (!(a instanceof e))
    return t.apply(n, s);
  var o = baseCreate(t.prototype), l = t.apply(o, s);
  return isObject(l) ? l : o;
}
var partial = restArguments(function(t, e) {
  var n = partial.placeholder, a = function() {
    for (var s = 0, o = e.length, l = Array(o), c = 0; c < o; c++)
      l[c] = e[c] === n ? arguments[s++] : e[c];
    for (; s < arguments.length; )
      l.push(arguments[s++]);
    return executeBound(t, a, this, this, l);
  };
  return a;
});
partial.placeholder = _$i;
const bind$1 = restArguments(function(t, e, n) {
  if (!isFunction$1(t))
    throw new TypeError("Bind must be called on a function");
  var a = restArguments(function(s) {
    return executeBound(t, a, e, this, n.concat(s));
  });
  return a;
}), isArrayLike = createSizePropertyCheck(getLength);
function flatten$1(t, e, n, a) {
  if (a = a || [], !e && e !== 0)
    e = 1 / 0;
  else if (e <= 0)
    return a.concat(t);
  for (var s = a.length, o = 0, l = getLength(t); o < l; o++) {
    var c = t[o];
    if (isArrayLike(c) && (isArray(c) || isArguments$1(c)))
      if (e > 1)
        flatten$1(c, e - 1, n, a), s = a.length;
      else
        for (var u = 0, d = c.length; u < d; )
          a[s++] = c[u++];
    else
      n || (a[s++] = c);
  }
  return a;
}
const bindAll = restArguments(function(t, e) {
  e = flatten$1(e, !1, !1);
  var n = e.length;
  if (n < 1)
    throw new Error("bindAll must be passed function names");
  for (; n--; ) {
    var a = e[n];
    t[a] = bind$1(t[a], t);
  }
  return t;
});
function memoize(t, e) {
  var n = function(a) {
    var s = n.cache, o = "" + (e ? e.apply(this, arguments) : a);
    return has$1(s, o) || (s[o] = t.apply(this, arguments)), s[o];
  };
  return n.cache = {}, n;
}
const delay = restArguments(function(t, e, n) {
  return setTimeout(function() {
    return t.apply(null, n);
  }, e);
}), defer$1 = partial(delay, _$i, 1);
function throttle(t, e, n) {
  var a, s, o, l, c = 0;
  n || (n = {});
  var u = function() {
    c = n.leading === !1 ? 0 : now(), a = null, l = t.apply(s, o), a || (s = o = null);
  }, d = function() {
    var f = now();
    !c && n.leading === !1 && (c = f);
    var h = e - (f - c);
    return s = this, o = arguments, h <= 0 || h > e ? (a && (clearTimeout(a), a = null), c = f, l = t.apply(s, o), a || (s = o = null)) : !a && n.trailing !== !1 && (a = setTimeout(u, h)), l;
  };
  return d.cancel = function() {
    clearTimeout(a), c = 0, a = s = o = null;
  }, d;
}
function debounce(t, e, n) {
  var a, s, o, l, c, u = function() {
    var f = now() - s;
    e > f ? a = setTimeout(u, e - f) : (a = null, n || (l = t.apply(c, o)), a || (o = c = null));
  }, d = restArguments(function(f) {
    return c = this, o = f, s = now(), a || (a = setTimeout(u, e), n && (l = t.apply(c, o))), l;
  });
  return d.cancel = function() {
    clearTimeout(a), a = o = c = null;
  }, d;
}
function wrap(t, e) {
  return partial(e, t);
}
function negate(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function compose() {
  var t = arguments, e = t.length - 1;
  return function() {
    for (var n = e, a = t[e].apply(this, arguments); n--; )
      a = t[n].call(this, a);
    return a;
  };
}
function after(t, e) {
  return function() {
    if (--t < 1)
      return e.apply(this, arguments);
  };
}
function before(t, e) {
  var n;
  return function() {
    return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
  };
}
const once = partial(before, 2);
function findKey(t, e, n) {
  e = cb(e, n);
  for (var a = keys$1(t), s, o = 0, l = a.length; o < l; o++)
    if (s = a[o], e(t[s], s, t))
      return s;
}
function createPredicateIndexFinder(t) {
  return function(e, n, a) {
    n = cb(n, a);
    for (var s = getLength(e), o = t > 0 ? 0 : s - 1; o >= 0 && o < s; o += t)
      if (n(e[o], o, e))
        return o;
    return -1;
  };
}
const findIndex = createPredicateIndexFinder(1), findLastIndex = createPredicateIndexFinder(-1);
function sortedIndex(t, e, n, a) {
  n = cb(n, a, 1);
  for (var s = n(e), o = 0, l = getLength(t); o < l; ) {
    var c = Math.floor((o + l) / 2);
    n(t[c]) < s ? o = c + 1 : l = c;
  }
  return o;
}
function createIndexFinder(t, e, n) {
  return function(a, s, o) {
    var l = 0, c = getLength(a);
    if (typeof o == "number")
      t > 0 ? l = o >= 0 ? o : Math.max(o + c, l) : c = o >= 0 ? Math.min(o + 1, c) : o + c + 1;
    else if (n && o && c)
      return o = n(a, s), a[o] === s ? o : -1;
    if (s !== s)
      return o = e(slice.call(a, l, c), isNaN$1), o >= 0 ? o + l : -1;
    for (o = t > 0 ? l : c - 1; o >= 0 && o < c; o += t)
      if (a[o] === s)
        return o;
    return -1;
  };
}
const indexOf = createIndexFinder(1, findIndex, sortedIndex), lastIndexOf = createIndexFinder(-1, findLastIndex);
function find$2(t, e, n) {
  var a = isArrayLike(t) ? findIndex : findKey, s = a(t, e, n);
  if (s !== void 0 && s !== -1)
    return t[s];
}
function findWhere(t, e) {
  return find$2(t, matcher(e));
}
function each$1(t, e, n) {
  e = optimizeCb(e, n);
  var a, s;
  if (isArrayLike(t))
    for (a = 0, s = t.length; a < s; a++)
      e(t[a], a, t);
  else {
    var o = keys$1(t);
    for (a = 0, s = o.length; a < s; a++)
      e(t[o[a]], o[a], t);
  }
  return t;
}
function map$1(t, e, n) {
  e = cb(e, n);
  for (var a = !isArrayLike(t) && keys$1(t), s = (a || t).length, o = Array(s), l = 0; l < s; l++) {
    var c = a ? a[l] : l;
    o[l] = e(t[c], c, t);
  }
  return o;
}
function createReduce(t) {
  var e = function(n, a, s, o) {
    var l = !isArrayLike(n) && keys$1(n), c = (l || n).length, u = t > 0 ? 0 : c - 1;
    for (o || (s = n[l ? l[u] : u], u += t); u >= 0 && u < c; u += t) {
      var d = l ? l[u] : u;
      s = a(s, n[d], d, n);
    }
    return s;
  };
  return function(n, a, s, o) {
    var l = arguments.length >= 3;
    return e(n, optimizeCb(a, o, 4), s, l);
  };
}
const reduce$1 = createReduce(1), reduceRight = createReduce(-1);
function filter$1(t, e, n) {
  var a = [];
  return e = cb(e, n), each$1(t, function(s, o, l) {
    e(s, o, l) && a.push(s);
  }), a;
}
function reject(t, e, n) {
  return filter$1(t, negate(cb(e)), n);
}
function every(t, e, n) {
  e = cb(e, n);
  for (var a = !isArrayLike(t) && keys$1(t), s = (a || t).length, o = 0; o < s; o++) {
    var l = a ? a[o] : o;
    if (!e(t[l], l, t))
      return !1;
  }
  return !0;
}
function some$1(t, e, n) {
  e = cb(e, n);
  for (var a = !isArrayLike(t) && keys$1(t), s = (a || t).length, o = 0; o < s; o++) {
    var l = a ? a[o] : o;
    if (e(t[l], l, t))
      return !0;
  }
  return !1;
}
function contains(t, e, n, a) {
  return isArrayLike(t) || (t = values(t)), (typeof n != "number" || a) && (n = 0), indexOf(t, e, n) >= 0;
}
const invoke = restArguments(function(t, e, n) {
  var a, s;
  return isFunction$1(e) ? s = e : (e = toPath(e), a = e.slice(0, -1), e = e[e.length - 1]), map$1(t, function(o) {
    var l = s;
    if (!l) {
      if (a && a.length && (o = deepGet(o, a)), o == null)
        return;
      l = o[e];
    }
    return l == null ? l : l.apply(o, n);
  });
});
function pluck(t, e) {
  return map$1(t, property(e));
}
function where(t, e) {
  return filter$1(t, matcher(e));
}
function max(t, e, n) {
  var a = -1 / 0, s = -1 / 0, o, l;
  if (e == null || typeof e == "number" && typeof t[0] != "object" && t != null) {
    t = isArrayLike(t) ? t : values(t);
    for (var c = 0, u = t.length; c < u; c++)
      o = t[c], o != null && o > a && (a = o);
  } else
    e = cb(e, n), each$1(t, function(d, f, h) {
      l = e(d, f, h), (l > s || l === -1 / 0 && a === -1 / 0) && (a = d, s = l);
    });
  return a;
}
function min(t, e, n) {
  var a = 1 / 0, s = 1 / 0, o, l;
  if (e == null || typeof e == "number" && typeof t[0] != "object" && t != null) {
    t = isArrayLike(t) ? t : values(t);
    for (var c = 0, u = t.length; c < u; c++)
      o = t[c], o != null && o < a && (a = o);
  } else
    e = cb(e, n), each$1(t, function(d, f, h) {
      l = e(d, f, h), (l < s || l === 1 / 0 && a === 1 / 0) && (a = d, s = l);
    });
  return a;
}
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(t) {
  return t ? isArray(t) ? slice.call(t) : isString(t) ? t.match(reStrSymbol) : isArrayLike(t) ? map$1(t, identity$2) : values(t) : [];
}
function sample(t, e, n) {
  if (e == null || n)
    return isArrayLike(t) || (t = values(t)), t[random(t.length - 1)];
  var a = toArray(t), s = getLength(a);
  e = Math.max(Math.min(e, s), 0);
  for (var o = s - 1, l = 0; l < e; l++) {
    var c = random(l, o), u = a[l];
    a[l] = a[c], a[c] = u;
  }
  return a.slice(0, e);
}
function shuffle(t) {
  return sample(t, 1 / 0);
}
function sortBy(t, e, n) {
  var a = 0;
  return e = cb(e, n), pluck(map$1(t, function(s, o, l) {
    return {
      value: s,
      index: a++,
      criteria: e(s, o, l)
    };
  }).sort(function(s, o) {
    var l = s.criteria, c = o.criteria;
    if (l !== c) {
      if (l > c || l === void 0)
        return 1;
      if (l < c || c === void 0)
        return -1;
    }
    return s.index - o.index;
  }), "value");
}
function group(t, e) {
  return function(n, a, s) {
    var o = e ? [[], []] : {};
    return a = cb(a, s), each$1(n, function(l, c) {
      var u = a(l, c, n);
      t(o, l, u);
    }), o;
  };
}
const groupBy = group(function(t, e, n) {
  has$1(t, n) ? t[n].push(e) : t[n] = [e];
}), indexBy = group(function(t, e, n) {
  t[n] = e;
}), countBy = group(function(t, e, n) {
  has$1(t, n) ? t[n]++ : t[n] = 1;
}), partition = group(function(t, e, n) {
  t[n ? 0 : 1].push(e);
}, !0);
function size(t) {
  return t == null ? 0 : isArrayLike(t) ? t.length : keys$1(t).length;
}
function keyInObj(t, e, n) {
  return e in n;
}
const pick = restArguments(function(t, e) {
  var n = {}, a = e[0];
  if (t == null)
    return n;
  isFunction$1(a) ? (e.length > 1 && (a = optimizeCb(a, e[1])), e = allKeys(t)) : (a = keyInObj, e = flatten$1(e, !1, !1), t = Object(t));
  for (var s = 0, o = e.length; s < o; s++) {
    var l = e[s], c = t[l];
    a(c, l, t) && (n[l] = c);
  }
  return n;
}), omit = restArguments(function(t, e) {
  var n = e[0], a;
  return isFunction$1(n) ? (n = negate(n), e.length > 1 && (a = e[1])) : (e = map$1(flatten$1(e, !1, !1), String), n = function(s, o) {
    return !contains(e, o);
  }), pick(t, n, a);
});
function initial(t, e, n) {
  return slice.call(t, 0, Math.max(0, t.length - (e == null || n ? 1 : e)));
}
function first(t, e, n) {
  return t == null || t.length < 1 ? e == null || n ? void 0 : [] : e == null || n ? t[0] : initial(t, t.length - e);
}
function rest(t, e, n) {
  return slice.call(t, e == null || n ? 1 : e);
}
function last(t, e, n) {
  return t == null || t.length < 1 ? e == null || n ? void 0 : [] : e == null || n ? t[t.length - 1] : rest(t, Math.max(0, t.length - e));
}
function compact(t) {
  return filter$1(t, Boolean);
}
function flatten(t, e) {
  return flatten$1(t, e, !1);
}
const difference = restArguments(function(t, e) {
  return e = flatten$1(e, !0, !0), filter$1(t, function(n) {
    return !contains(e, n);
  });
}), without = restArguments(function(t, e) {
  return difference(t, e);
});
function uniq(t, e, n, a) {
  isBoolean(e) || (a = n, n = e, e = !1), n != null && (n = cb(n, a));
  for (var s = [], o = [], l = 0, c = getLength(t); l < c; l++) {
    var u = t[l], d = n ? n(u, l, t) : u;
    e && !n ? ((!l || o !== d) && s.push(u), o = d) : n ? contains(o, d) || (o.push(d), s.push(u)) : contains(s, u) || s.push(u);
  }
  return s;
}
const union = restArguments(function(t) {
  return uniq(flatten$1(t, !0, !0));
});
function intersection(t) {
  for (var e = [], n = arguments.length, a = 0, s = getLength(t); a < s; a++) {
    var o = t[a];
    if (!contains(e, o)) {
      var l;
      for (l = 1; l < n && contains(arguments[l], o); l++)
        ;
      l === n && e.push(o);
    }
  }
  return e;
}
function unzip$2(t) {
  for (var e = t && max(t, getLength).length || 0, n = Array(e), a = 0; a < e; a++)
    n[a] = pluck(t, a);
  return n;
}
const zip = restArguments(unzip$2);
function object(t, e) {
  for (var n = {}, a = 0, s = getLength(t); a < s; a++)
    e ? n[t[a]] = e[a] : n[t[a][0]] = t[a][1];
  return n;
}
function range(t, e, n) {
  e == null && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
  for (var a = Math.max(Math.ceil((e - t) / n), 0), s = Array(a), o = 0; o < a; o++, t += n)
    s[o] = t;
  return s;
}
function chunk(t, e) {
  if (e == null || e < 1)
    return [];
  for (var n = [], a = 0, s = t.length; a < s; )
    n.push(slice.call(t, a, a += e));
  return n;
}
function chainResult(t, e) {
  return t._chain ? _$i(e).chain() : e;
}
function mixin(t) {
  return each$1(functions(t), function(e) {
    var n = _$i[e] = t[e];
    _$i.prototype[e] = function() {
      var a = [this._wrapped];
      return push.apply(a, arguments), chainResult(this, n.apply(_$i, a));
    };
  }), _$i;
}
each$1(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(t) {
  var e = ArrayProto[t];
  _$i.prototype[t] = function() {
    var n = this._wrapped;
    return n != null && (e.apply(n, arguments), (t === "shift" || t === "splice") && n.length === 0 && delete n[0]), chainResult(this, n);
  };
});
each$1(["concat", "join", "slice"], function(t) {
  var e = ArrayProto[t];
  _$i.prototype[t] = function() {
    var n = this._wrapped;
    return n != null && (n = e.apply(n, arguments)), chainResult(this, n);
  };
});
const allExports = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VERSION,
  after,
  all: every,
  allKeys,
  any: some$1,
  assign: extendOwn,
  before,
  bind: bind$1,
  bindAll,
  chain,
  chunk,
  clone,
  collect: map$1,
  compact,
  compose,
  constant,
  contains,
  countBy,
  create,
  debounce,
  default: _$i,
  defaults,
  defer: defer$1,
  delay,
  detect: find$2,
  difference,
  drop: rest,
  each: each$1,
  escape: escape$1,
  every,
  extend,
  extendOwn,
  filter: filter$1,
  find: find$2,
  findIndex,
  findKey,
  findLastIndex,
  findWhere,
  first,
  flatten,
  foldl: reduce$1,
  foldr: reduceRight,
  forEach: each$1,
  functions,
  get,
  groupBy,
  has,
  head: first,
  identity: identity$2,
  include: contains,
  includes: contains,
  indexBy,
  indexOf,
  initial,
  inject: reduce$1,
  intersection,
  invert,
  invoke,
  isArguments: isArguments$1,
  isArray,
  isArrayBuffer,
  isBoolean,
  isDataView: isDataView$1,
  isDate,
  isElement,
  isEmpty,
  isEqual,
  isError,
  isFinite: isFinite$1,
  isFunction: isFunction$1,
  isMap,
  isMatch,
  isNaN: isNaN$1,
  isNull,
  isNumber,
  isObject,
  isRegExp,
  isSet,
  isString,
  isSymbol,
  isTypedArray: isTypedArray$1,
  isUndefined,
  isWeakMap,
  isWeakSet,
  iteratee,
  keys: keys$1,
  last,
  lastIndexOf,
  map: map$1,
  mapObject,
  matcher,
  matches: matcher,
  max,
  memoize,
  methods: functions,
  min,
  mixin,
  negate,
  noop,
  now,
  object,
  omit,
  once,
  pairs,
  partial,
  partition,
  pick,
  pluck,
  property,
  propertyOf,
  random,
  range,
  reduce: reduce$1,
  reduceRight,
  reject,
  rest,
  restArguments,
  result,
  sample,
  select: filter$1,
  shuffle,
  size,
  some: some$1,
  sortBy,
  sortedIndex,
  tail: rest,
  take: first,
  tap,
  template,
  templateSettings,
  throttle,
  times,
  toArray,
  toPath: toPath$1,
  transpose: unzip$2,
  unescape: unescape$1,
  union,
  uniq,
  unique: uniq,
  uniqueId,
  unzip: unzip$2,
  values,
  where,
  without,
  wrap,
  zip
}, Symbol.toStringTag, { value: "Module" }));
var _$h = mixin(allExports);
_$h._ = _$h;
const indexAll = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VERSION,
  after,
  all: every,
  allKeys,
  any: some$1,
  assign: extendOwn,
  before,
  bind: bind$1,
  bindAll,
  chain,
  chunk,
  clone,
  collect: map$1,
  compact,
  compose,
  constant,
  contains,
  countBy,
  create,
  debounce,
  default: _$h,
  defaults,
  defer: defer$1,
  delay,
  detect: find$2,
  difference,
  drop: rest,
  each: each$1,
  escape: escape$1,
  every,
  extend,
  extendOwn,
  filter: filter$1,
  find: find$2,
  findIndex,
  findKey,
  findLastIndex,
  findWhere,
  first,
  flatten,
  foldl: reduce$1,
  foldr: reduceRight,
  forEach: each$1,
  functions,
  get,
  groupBy,
  has,
  head: first,
  identity: identity$2,
  include: contains,
  includes: contains,
  indexBy,
  indexOf,
  initial,
  inject: reduce$1,
  intersection,
  invert,
  invoke,
  isArguments: isArguments$1,
  isArray,
  isArrayBuffer,
  isBoolean,
  isDataView: isDataView$1,
  isDate,
  isElement,
  isEmpty,
  isEqual,
  isError,
  isFinite: isFinite$1,
  isFunction: isFunction$1,
  isMap,
  isMatch,
  isNaN: isNaN$1,
  isNull,
  isNumber,
  isObject,
  isRegExp,
  isSet,
  isString,
  isSymbol,
  isTypedArray: isTypedArray$1,
  isUndefined,
  isWeakMap,
  isWeakSet,
  iteratee,
  keys: keys$1,
  last,
  lastIndexOf,
  map: map$1,
  mapObject,
  matcher,
  matches: matcher,
  max,
  memoize,
  methods: functions,
  min,
  mixin,
  negate,
  noop,
  now,
  object,
  omit,
  once,
  pairs,
  partial,
  partition,
  pick,
  pluck,
  property,
  propertyOf,
  random,
  range,
  reduce: reduce$1,
  reduceRight,
  reject,
  rest,
  restArguments,
  result,
  sample,
  select: filter$1,
  shuffle,
  size,
  some: some$1,
  sortBy,
  sortedIndex,
  tail: rest,
  take: first,
  tap,
  template,
  templateSettings,
  throttle,
  times,
  toArray,
  toPath: toPath$1,
  transpose: unzip$2,
  unescape: unescape$1,
  union,
  uniq,
  unique: uniq,
  uniqueId,
  unzip: unzip$2,
  values,
  where,
  without,
  wrap,
  zip
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(indexAll);
var docxReader$1 = {}, promises$7 = {}, promise = { exports: {} }, es5 = { exports: {} }, hasRequiredEs5;
function requireEs5() {
  if (hasRequiredEs5)
    return es5.exports;
  hasRequiredEs5 = 1;
  var t = /* @__PURE__ */ function() {
    return this === void 0;
  }();
  if (t)
    es5.exports = {
      freeze: Object.freeze,
      defineProperty: Object.defineProperty,
      getDescriptor: Object.getOwnPropertyDescriptor,
      keys: Object.keys,
      names: Object.getOwnPropertyNames,
      getPrototypeOf: Object.getPrototypeOf,
      isArray: Array.isArray,
      isES5: t,
      propertyIsWritable: function(f, h) {
        var g = Object.getOwnPropertyDescriptor(f, h);
        return !!(!g || g.writable || g.set);
      }
    };
  else {
    var e = {}.hasOwnProperty, n = {}.toString, a = {}.constructor.prototype, s = function(f) {
      var h = [];
      for (var g in f)
        e.call(f, g) && h.push(g);
      return h;
    }, o = function(f, h) {
      return { value: f[h] };
    }, l = function(f, h, g) {
      return f[h] = g.value, f;
    }, c = function(f) {
      return f;
    }, u = function(f) {
      try {
        return Object(f).constructor.prototype;
      } catch {
        return a;
      }
    }, d = function(f) {
      try {
        return n.call(f) === "[object Array]";
      } catch {
        return !1;
      }
    };
    es5.exports = {
      isArray: d,
      keys: s,
      names: s,
      defineProperty: l,
      getDescriptor: o,
      freeze: c,
      getPrototypeOf: u,
      isES5: t,
      propertyIsWritable: function() {
        return !0;
      }
    };
  }
  return es5.exports;
}
var util$2, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil)
    return util$2;
  hasRequiredUtil = 1;
  var t = requireEs5(), e = typeof navigator > "u", n = { e: {} }, a, s = typeof self < "u" ? self : typeof window < "u" ? window : typeof commonjsGlobal < "u" || commonjsGlobal !== void 0 ? commonjsGlobal : null;
  function o() {
    try {
      var U = a;
      return a = null, U.apply(this, arguments);
    } catch (F) {
      return n.e = F, n;
    }
  }
  function l(U) {
    return a = U, o;
  }
  var c = function(U, F) {
    var M = {}.hasOwnProperty;
    function I() {
      this.constructor = U, this.constructor$ = F;
      for (var N in F.prototype)
        M.call(F.prototype, N) && N.charAt(N.length - 1) !== "$" && (this[N + "$"] = F.prototype[N]);
    }
    return I.prototype = F.prototype, U.prototype = new I(), U.prototype;
  };
  function u(U) {
    return U == null || U === !0 || U === !1 || typeof U == "string" || typeof U == "number";
  }
  function d(U) {
    return typeof U == "function" || typeof U == "object" && U !== null;
  }
  function f(U) {
    return u(U) ? new Error(w(U)) : U;
  }
  function h(U, F) {
    var M = U.length, I = new Array(M + 1), N;
    for (N = 0; N < M; ++N)
      I[N] = U[N];
    return I[N] = F, I;
  }
  function g(U, F, M) {
    if (t.isES5) {
      var I = Object.getOwnPropertyDescriptor(U, F);
      if (I != null)
        return I.get == null && I.set == null ? I.value : M;
    } else
      return {}.hasOwnProperty.call(U, F) ? U[F] : void 0;
  }
  function x(U, F, M) {
    if (u(U))
      return U;
    var I = {
      value: M,
      configurable: !0,
      enumerable: !1,
      writable: !0
    };
    return t.defineProperty(U, F, I), U;
  }
  function E(U) {
    throw U;
  }
  var m = function() {
    var U = [
      Array.prototype,
      Object.prototype,
      Function.prototype
    ], F = function(N) {
      for (var V = 0; V < U.length; ++V)
        if (U[V] === N)
          return !0;
      return !1;
    };
    if (t.isES5) {
      var M = Object.getOwnPropertyNames;
      return function(N) {
        for (var V = [], q = /* @__PURE__ */ Object.create(null); N != null && !F(N); ) {
          var H;
          try {
            H = M(N);
          } catch {
            return V;
          }
          for (var ne = 0; ne < H.length; ++ne) {
            var he = H[ne];
            if (!q[he]) {
              q[he] = !0;
              var j = Object.getOwnPropertyDescriptor(N, he);
              j != null && j.get == null && j.set == null && V.push(he);
            }
          }
          N = t.getPrototypeOf(N);
        }
        return V;
      };
    } else {
      var I = {}.hasOwnProperty;
      return function(N) {
        if (F(N))
          return [];
        var V = [];
        e:
          for (var q in N)
            if (I.call(N, q))
              V.push(q);
            else {
              for (var H = 0; H < U.length; ++H)
                if (I.call(U[H], q))
                  continue e;
              V.push(q);
            }
        return V;
      };
    }
  }(), v = /this\s*\.\s*\S+\s*=/;
  function y(U) {
    try {
      if (typeof U == "function") {
        var F = t.names(U.prototype), M = t.isES5 && F.length > 1, I = F.length > 0 && !(F.length === 1 && F[0] === "constructor"), N = v.test(U + "") && t.names(U).length > 0;
        if (M || I || N)
          return !0;
      }
      return !1;
    } catch {
      return !1;
    }
  }
  function A(U) {
    return U;
  }
  var b = /^[a-z$_][a-z$_0-9]*$/i;
  function C(U) {
    return b.test(U);
  }
  function T(U, F, M) {
    for (var I = new Array(U), N = 0; N < U; ++N)
      I[N] = F + N + M;
    return I;
  }
  function w(U) {
    try {
      return U + "";
    } catch {
      return "[no string representation]";
    }
  }
  function R(U) {
    return U !== null && typeof U == "object" && typeof U.message == "string" && typeof U.name == "string";
  }
  function O(U) {
    try {
      x(U, "isOperational", !0);
    } catch {
    }
  }
  function D(U) {
    return U == null ? !1 : U instanceof Error.__BluebirdErrorTypes__.OperationalError || U.isOperational === !0;
  }
  function k(U) {
    return R(U) && t.propertyIsWritable(U, "stack");
  }
  var W = function() {
    return "stack" in new Error() ? function(U) {
      return k(U) ? U : new Error(w(U));
    } : function(U) {
      if (k(U))
        return U;
      try {
        throw new Error(w(U));
      } catch (F) {
        return F;
      }
    };
  }();
  function L(U) {
    return {}.toString.call(U);
  }
  function z(U, F, M) {
    for (var I = t.names(U), N = 0; N < I.length; ++N) {
      var V = I[N];
      if (M(V))
        try {
          t.defineProperty(F, V, t.getDescriptor(U, V));
        } catch {
        }
    }
  }
  var P = function(U) {
    return t.isArray(U) ? U : null;
  };
  if (typeof Symbol < "u" && Symbol.iterator) {
    var Q = typeof Array.from == "function" ? function(U) {
      return Array.from(U);
    } : function(U) {
      for (var F = [], M = U[Symbol.iterator](), I; !(I = M.next()).done; )
        F.push(I.value);
      return F;
    };
    P = function(U) {
      return t.isArray(U) ? U : U != null && typeof U[Symbol.iterator] == "function" ? Q(U) : null;
    };
  }
  var Y = typeof process < "u" && L(process).toLowerCase() === "[object process]", ie = typeof process < "u" && typeof process.env < "u";
  function te(U) {
    return ie ? process.env[U] : void 0;
  }
  function Z() {
    if (typeof Promise == "function")
      try {
        var U = new Promise(function() {
        });
        if ({}.toString.call(U) === "[object Promise]")
          return Promise;
      } catch {
      }
  }
  function ae(U, F) {
    return U.bind(F);
  }
  var G = {
    isClass: y,
    isIdentifier: C,
    inheritedDataKeys: m,
    getDataPropertyOrDefault: g,
    thrower: E,
    isArray: t.isArray,
    asArray: P,
    notEnumerableProp: x,
    isPrimitive: u,
    isObject: d,
    isError: R,
    canEvaluate: e,
    errorObj: n,
    tryCatch: l,
    inherits: c,
    withAppended: h,
    maybeWrapAsError: f,
    toFastProperties: A,
    filledRange: T,
    toString: w,
    canAttachTrace: k,
    ensureErrorObject: W,
    originatesFromRejection: D,
    markAsOriginatingFromRejection: O,
    classString: L,
    copyDescriptors: z,
    hasDevTools: typeof chrome < "u" && chrome && typeof chrome.loadTimes == "function",
    isNode: Y,
    hasEnvVariables: ie,
    env: te,
    global: s,
    getNativePromise: Z,
    domainBind: ae
  };
  G.isRecentNode = G.isNode && function() {
    var U = process.versions.node.split(".").map(Number);
    return U[0] === 0 && U[1] > 10 || U[0] > 0;
  }(), G.isNode && G.toFastProperties(process);
  try {
    throw new Error();
  } catch (U) {
    G.lastLineError = U;
  }
  return util$2 = G, util$2;
}
var async = { exports: {} }, schedule_1, hasRequiredSchedule;
function requireSchedule() {
  if (hasRequiredSchedule)
    return schedule_1;
  hasRequiredSchedule = 1;
  var t = requireUtil(), e, n = function() {
    throw new Error(`No async scheduler available

    See http://goo.gl/MqrFmX
`);
  }, a = t.getNativePromise();
  if (t.isNode && typeof MutationObserver > "u") {
    var s = commonjsGlobal.setImmediate, o = process.nextTick;
    e = t.isRecentNode ? function(c) {
      s.call(commonjsGlobal, c);
    } : function(c) {
      o.call(process, c);
    };
  } else if (typeof a == "function" && typeof a.resolve == "function") {
    var l = a.resolve();
    e = function(c) {
      l.then(c);
    };
  } else
    typeof MutationObserver < "u" && !(typeof window < "u" && window.navigator && (window.navigator.standalone || window.cordova)) ? e = function() {
      var c = document.createElement("div"), u = { attributes: !0 }, d = !1, f = document.createElement("div"), h = new MutationObserver(function() {
        c.classList.toggle("foo"), d = !1;
      });
      h.observe(f, u);
      var g = function() {
        d || (d = !0, f.classList.toggle("foo"));
      };
      return function(E) {
        var m = new MutationObserver(function() {
          m.disconnect(), E();
        });
        m.observe(c, u), g();
      };
    }() : typeof setImmediate < "u" ? e = function(c) {
      setImmediate(c);
    } : typeof setTimeout < "u" ? e = function(c) {
      setTimeout(c, 0);
    } : e = n;
  return schedule_1 = e, schedule_1;
}
var queue, hasRequiredQueue;
function requireQueue() {
  if (hasRequiredQueue)
    return queue;
  hasRequiredQueue = 1;
  function t(n, a, s, o, l) {
    for (var c = 0; c < l; ++c)
      s[c + o] = n[c + a], n[c + a] = void 0;
  }
  function e(n) {
    this._capacity = n, this._length = 0, this._front = 0;
  }
  return e.prototype._willBeOverCapacity = function(n) {
    return this._capacity < n;
  }, e.prototype._pushOne = function(n) {
    var a = this.length();
    this._checkCapacity(a + 1);
    var s = this._front + a & this._capacity - 1;
    this[s] = n, this._length = a + 1;
  }, e.prototype.push = function(n, a, s) {
    var o = this.length() + 3;
    if (this._willBeOverCapacity(o)) {
      this._pushOne(n), this._pushOne(a), this._pushOne(s);
      return;
    }
    var l = this._front + o - 3;
    this._checkCapacity(o);
    var c = this._capacity - 1;
    this[l + 0 & c] = n, this[l + 1 & c] = a, this[l + 2 & c] = s, this._length = o;
  }, e.prototype.shift = function() {
    var n = this._front, a = this[n];
    return this[n] = void 0, this._front = n + 1 & this._capacity - 1, this._length--, a;
  }, e.prototype.length = function() {
    return this._length;
  }, e.prototype._checkCapacity = function(n) {
    this._capacity < n && this._resizeTo(this._capacity << 1);
  }, e.prototype._resizeTo = function(n) {
    var a = this._capacity;
    this._capacity = n;
    var s = this._front, o = this._length, l = s + o & a - 1;
    t(this, 0, this, a, l);
  }, queue = e, queue;
}
var hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync)
    return async.exports;
  hasRequiredAsync = 1;
  var t;
  try {
    throw new Error();
  } catch (u) {
    t = u;
  }
  var e = requireSchedule(), n = requireQueue(), a = requireUtil();
  function s() {
    this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new n(16), this._normalQueue = new n(16), this._haveDrainedQueues = !1, this._trampolineEnabled = !0;
    var u = this;
    this.drainQueues = function() {
      u._drainQueues();
    }, this._schedule = e;
  }
  s.prototype.setScheduler = function(u) {
    var d = this._schedule;
    return this._schedule = u, this._customScheduler = !0, d;
  }, s.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
  }, s.prototype.enableTrampoline = function() {
    this._trampolineEnabled = !0;
  }, s.prototype.disableTrampolineIfNecessary = function() {
    a.hasDevTools && (this._trampolineEnabled = !1);
  }, s.prototype.haveItemsQueued = function() {
    return this._isTickUsed || this._haveDrainedQueues;
  }, s.prototype.fatalError = function(u, d) {
    d ? (process.stderr.write("Fatal " + (u instanceof Error ? u.stack : u) + `
`), process.exit(2)) : this.throwLater(u);
  }, s.prototype.throwLater = function(u, d) {
    if (arguments.length === 1 && (d = u, u = function() {
      throw d;
    }), typeof setTimeout < "u")
      setTimeout(function() {
        u(d);
      }, 0);
    else
      try {
        this._schedule(function() {
          u(d);
        });
      } catch {
        throw new Error(`No async scheduler available

    See http://goo.gl/MqrFmX
`);
      }
  };
  function o(u, d, f) {
    this._lateQueue.push(u, d, f), this._queueTick();
  }
  function l(u, d, f) {
    this._normalQueue.push(u, d, f), this._queueTick();
  }
  function c(u) {
    this._normalQueue._pushOne(u), this._queueTick();
  }
  return a.hasDevTools ? (s.prototype.invokeLater = function(u, d, f) {
    this._trampolineEnabled ? o.call(this, u, d, f) : this._schedule(function() {
      setTimeout(function() {
        u.call(d, f);
      }, 100);
    });
  }, s.prototype.invoke = function(u, d, f) {
    this._trampolineEnabled ? l.call(this, u, d, f) : this._schedule(function() {
      u.call(d, f);
    });
  }, s.prototype.settlePromises = function(u) {
    this._trampolineEnabled ? c.call(this, u) : this._schedule(function() {
      u._settlePromises();
    });
  }) : (s.prototype.invokeLater = o, s.prototype.invoke = l, s.prototype.settlePromises = c), s.prototype._drainQueue = function(u) {
    for (; u.length() > 0; ) {
      var d = u.shift();
      if (typeof d != "function") {
        d._settlePromises();
        continue;
      }
      var f = u.shift(), h = u.shift();
      d.call(f, h);
    }
  }, s.prototype._drainQueues = function() {
    this._drainQueue(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, this._drainQueue(this._lateQueue);
  }, s.prototype._queueTick = function() {
    this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues));
  }, s.prototype._reset = function() {
    this._isTickUsed = !1;
  }, async.exports = s, async.exports.firstLineError = t, async.exports;
}
var errors$1, hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors)
    return errors$1;
  hasRequiredErrors = 1;
  var t = requireEs5(), e = t.freeze, n = requireUtil(), a = n.inherits, s = n.notEnumerableProp;
  function o(y, A) {
    function b(C) {
      if (!(this instanceof b))
        return new b(C);
      s(
        this,
        "message",
        typeof C == "string" ? C : A
      ), s(this, "name", y), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
    }
    return a(b, Error), b;
  }
  var l, c, u = o("Warning", "warning"), d = o("CancellationError", "cancellation error"), f = o("TimeoutError", "timeout error"), h = o("AggregateError", "aggregate error");
  try {
    l = TypeError, c = RangeError;
  } catch {
    l = o("TypeError", "type error"), c = o("RangeError", "range error");
  }
  for (var g = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), x = 0; x < g.length; ++x)
    typeof Array.prototype[g[x]] == "function" && (h.prototype[g[x]] = Array.prototype[g[x]]);
  t.defineProperty(h.prototype, "length", {
    value: 0,
    configurable: !1,
    writable: !0,
    enumerable: !0
  }), h.prototype.isOperational = !0;
  var E = 0;
  h.prototype.toString = function() {
    var y = Array(E * 4 + 1).join(" "), A = `
` + y + `AggregateError of:
`;
    E++, y = Array(E * 4 + 1).join(" ");
    for (var b = 0; b < this.length; ++b) {
      for (var C = this[b] === this ? "[Circular AggregateError]" : this[b] + "", T = C.split(`
`), w = 0; w < T.length; ++w)
        T[w] = y + T[w];
      C = T.join(`
`), A += C + `
`;
    }
    return E--, A;
  };
  function m(y) {
    if (!(this instanceof m))
      return new m(y);
    s(this, "name", "OperationalError"), s(this, "message", y), this.cause = y, this.isOperational = !0, y instanceof Error ? (s(this, "message", y.message), s(this, "stack", y.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
  a(m, Error);
  var v = Error.__BluebirdErrorTypes__;
  return v || (v = e({
    CancellationError: d,
    TimeoutError: f,
    OperationalError: m,
    RejectionError: m,
    AggregateError: h
  }), t.defineProperty(Error, "__BluebirdErrorTypes__", {
    value: v,
    writable: !1,
    enumerable: !1,
    configurable: !1
  })), errors$1 = {
    Error,
    TypeError: l,
    RangeError: c,
    CancellationError: v.CancellationError,
    OperationalError: v.OperationalError,
    TimeoutError: v.TimeoutError,
    AggregateError: v.AggregateError,
    Warning: u
  }, errors$1;
}
var thenables, hasRequiredThenables;
function requireThenables() {
  return hasRequiredThenables || (hasRequiredThenables = 1, thenables = function(t, e) {
    var n = requireUtil(), a = n.errorObj, s = n.isObject;
    function o(h, g) {
      if (s(h)) {
        if (h instanceof t)
          return h;
        var x = c(h);
        if (x === a) {
          g && g._pushContext();
          var E = t.reject(x.e);
          return g && g._popContext(), E;
        } else if (typeof x == "function") {
          if (d(h)) {
            var E = new t(e);
            return h._then(
              E._fulfill,
              E._reject,
              void 0,
              E,
              null
            ), E;
          }
          return f(h, x, g);
        }
      }
      return h;
    }
    function l(h) {
      return h.then;
    }
    function c(h) {
      try {
        return l(h);
      } catch (g) {
        return a.e = g, a;
      }
    }
    var u = {}.hasOwnProperty;
    function d(h) {
      try {
        return u.call(h, "_promise0");
      } catch {
        return !1;
      }
    }
    function f(h, g, x) {
      var E = new t(e), m = E;
      x && x._pushContext(), E._captureStackTrace(), x && x._popContext();
      var v = !0, y = n.tryCatch(g).call(h, A, b);
      v = !1, E && y === a && (E._rejectCallback(y.e, !0, !0), E = null);
      function A(C) {
        E && (E._resolveCallback(C), E = null);
      }
      function b(C) {
        E && (E._rejectCallback(C, v, !0), E = null);
      }
      return m;
    }
    return o;
  }), thenables;
}
var promise_array, hasRequiredPromise_array;
function requirePromise_array() {
  return hasRequiredPromise_array || (hasRequiredPromise_array = 1, promise_array = function(t, e, n, a, s) {
    var o = requireUtil();
    o.isArray;
    function l(u) {
      switch (u) {
        case -2:
          return [];
        case -3:
          return {};
      }
    }
    function c(u) {
      var d = this._promise = new t(e);
      u instanceof t && d._propagateFrom(u, 3), d._setOnCancel(this), this._values = u, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
    }
    return o.inherits(c, s), c.prototype.length = function() {
      return this._length;
    }, c.prototype.promise = function() {
      return this._promise;
    }, c.prototype._init = function u(d, f) {
      var h = n(this._values, this._promise);
      if (h instanceof t) {
        h = h._target();
        var g = h._bitField;
        if (this._values = h, g & 50397184)
          if (g & 33554432)
            h = h._value();
          else
            return g & 16777216 ? this._reject(h._reason()) : this._cancel();
        else
          return this._promise._setAsyncGuaranteed(), h._then(
            u,
            this._reject,
            void 0,
            this,
            f
          );
      }
      if (h = o.asArray(h), h === null) {
        var x = a(
          "expecting an array or an iterable object but got " + o.classString(h)
        ).reason();
        this._promise._rejectCallback(x, !1);
        return;
      }
      if (h.length === 0) {
        f === -5 ? this._resolveEmptyArray() : this._resolve(l(f));
        return;
      }
      this._iterate(h);
    }, c.prototype._iterate = function(u) {
      var d = this.getActualLength(u.length);
      this._length = d, this._values = this.shouldCopyValues() ? new Array(d) : this._values;
      for (var f = this._promise, h = !1, g = null, x = 0; x < d; ++x) {
        var E = n(u[x], f);
        E instanceof t ? (E = E._target(), g = E._bitField) : g = null, h ? g !== null && E.suppressUnhandledRejections() : g !== null ? g & 50397184 ? g & 33554432 ? h = this._promiseFulfilled(E._value(), x) : g & 16777216 ? h = this._promiseRejected(E._reason(), x) : h = this._promiseCancelled(x) : (E._proxy(this, x), this._values[x] = E) : h = this._promiseFulfilled(E, x);
      }
      h || f._setAsyncGuaranteed();
    }, c.prototype._isResolved = function() {
      return this._values === null;
    }, c.prototype._resolve = function(u) {
      this._values = null, this._promise._fulfill(u);
    }, c.prototype._cancel = function() {
      this._isResolved() || !this._promise._isCancellable() || (this._values = null, this._promise._cancel());
    }, c.prototype._reject = function(u) {
      this._values = null, this._promise._rejectCallback(u, !1);
    }, c.prototype._promiseFulfilled = function(u, d) {
      this._values[d] = u;
      var f = ++this._totalResolved;
      return f >= this._length ? (this._resolve(this._values), !0) : !1;
    }, c.prototype._promiseCancelled = function() {
      return this._cancel(), !0;
    }, c.prototype._promiseRejected = function(u) {
      return this._totalResolved++, this._reject(u), !0;
    }, c.prototype._resultCancelled = function() {
      if (!this._isResolved()) {
        var u = this._values;
        if (this._cancel(), u instanceof t)
          u.cancel();
        else
          for (var d = 0; d < u.length; ++d)
            u[d] instanceof t && u[d].cancel();
      }
    }, c.prototype.shouldCopyValues = function() {
      return !0;
    }, c.prototype.getActualLength = function(u) {
      return u;
    }, c;
  }), promise_array;
}
var context, hasRequiredContext;
function requireContext() {
  return hasRequiredContext || (hasRequiredContext = 1, context = function(t) {
    var e = !1, n = [];
    t.prototype._promiseCreated = function() {
    }, t.prototype._pushContext = function() {
    }, t.prototype._popContext = function() {
      return null;
    }, t._peekContext = t.prototype._peekContext = function() {
    };
    function a() {
      this._trace = new a.CapturedTrace(o());
    }
    a.prototype._pushContext = function() {
      this._trace !== void 0 && (this._trace._promiseCreated = null, n.push(this._trace));
    }, a.prototype._popContext = function() {
      if (this._trace !== void 0) {
        var l = n.pop(), c = l._promiseCreated;
        return l._promiseCreated = null, c;
      }
      return null;
    };
    function s() {
      if (e)
        return new a();
    }
    function o() {
      var l = n.length - 1;
      if (l >= 0)
        return n[l];
    }
    return a.CapturedTrace = null, a.create = s, a.deactivateLongStackTraces = function() {
    }, a.activateLongStackTraces = function() {
      var l = t.prototype._pushContext, c = t.prototype._popContext, u = t._peekContext, d = t.prototype._peekContext, f = t.prototype._promiseCreated;
      a.deactivateLongStackTraces = function() {
        t.prototype._pushContext = l, t.prototype._popContext = c, t._peekContext = u, t.prototype._peekContext = d, t.prototype._promiseCreated = f, e = !1;
      }, e = !0, t.prototype._pushContext = a.prototype._pushContext, t.prototype._popContext = a.prototype._popContext, t._peekContext = t.prototype._peekContext = o, t.prototype._promiseCreated = function() {
        var h = this._peekContext();
        h && h._promiseCreated == null && (h._promiseCreated = this);
      };
    }, a;
  }), context;
}
var debuggability, hasRequiredDebuggability;
function requireDebuggability() {
  return hasRequiredDebuggability || (hasRequiredDebuggability = 1, debuggability = function(t, e) {
    var n = t._getDomain, a = t._async, s = requireErrors().Warning, o = requireUtil(), l = o.canAttachTrace, c, u, d = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/, f = /\((?:timers\.js):\d+:\d+\)/, h = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/, g = null, x = null, E = !1, m, v = !!(o.env("BLUEBIRD_DEBUG") != 0 && (o.env("BLUEBIRD_DEBUG") || o.env("NODE_ENV") === "development")), y = !!(o.env("BLUEBIRD_WARNINGS") != 0 && (v || o.env("BLUEBIRD_WARNINGS"))), A = !!(o.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (v || o.env("BLUEBIRD_LONG_STACK_TRACES"))), b = o.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (y || !!o.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
    t.prototype.suppressUnhandledRejections = function() {
      var J = this._target();
      J._bitField = J._bitField & -1048577 | 524288;
    }, t.prototype._ensurePossibleRejectionHandled = function() {
      this._bitField & 524288 || (this._setRejectionIsUnhandled(), a.invokeLater(this._notifyUnhandledRejection, this, void 0));
    }, t.prototype._notifyUnhandledRejectionIsHandled = function() {
      j(
        "rejectionHandled",
        c,
        void 0,
        this
      );
    }, t.prototype._setReturnedNonUndefined = function() {
      this._bitField = this._bitField | 268435456;
    }, t.prototype._returnedNonUndefined = function() {
      return (this._bitField & 268435456) !== 0;
    }, t.prototype._notifyUnhandledRejection = function() {
      if (this._isRejectionUnhandled()) {
        var J = this._settledValue();
        this._setUnhandledRejectionIsNotified(), j(
          "unhandledRejection",
          u,
          J,
          this
        );
      }
    }, t.prototype._setUnhandledRejectionIsNotified = function() {
      this._bitField = this._bitField | 262144;
    }, t.prototype._unsetUnhandledRejectionIsNotified = function() {
      this._bitField = this._bitField & -262145;
    }, t.prototype._isUnhandledRejectionNotified = function() {
      return (this._bitField & 262144) > 0;
    }, t.prototype._setRejectionIsUnhandled = function() {
      this._bitField = this._bitField | 1048576;
    }, t.prototype._unsetRejectionIsUnhandled = function() {
      this._bitField = this._bitField & -1048577, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
    }, t.prototype._isRejectionUnhandled = function() {
      return (this._bitField & 1048576) > 0;
    }, t.prototype._warn = function(J, K, ge) {
      return M(J, K, ge || this);
    }, t.onPossiblyUnhandledRejection = function(J) {
      var K = n();
      u = typeof J == "function" ? K === null ? J : o.domainBind(K, J) : void 0;
    }, t.onUnhandledRejectionHandled = function(J) {
      var K = n();
      c = typeof J == "function" ? K === null ? J : o.domainBind(K, J) : void 0;
    };
    var C = function() {
    };
    t.longStackTraces = function() {
      if (a.haveItemsQueued() && !Me.longStackTraces)
        throw new Error(`cannot enable long stack traces after promises have been created

    See http://goo.gl/MqrFmX
`);
      if (!Me.longStackTraces && ye()) {
        var J = t.prototype._captureStackTrace, K = t.prototype._attachExtraTrace;
        Me.longStackTraces = !0, C = function() {
          if (a.haveItemsQueued() && !Me.longStackTraces)
            throw new Error(`cannot enable long stack traces after promises have been created

    See http://goo.gl/MqrFmX
`);
          t.prototype._captureStackTrace = J, t.prototype._attachExtraTrace = K, e.deactivateLongStackTraces(), a.enableTrampoline(), Me.longStackTraces = !1;
        }, t.prototype._captureStackTrace = ae, t.prototype._attachExtraTrace = G, e.activateLongStackTraces(), a.disableTrampolineIfNecessary();
      }
    }, t.hasLongStackTraces = function() {
      return Me.longStackTraces && ye();
    };
    var T = function() {
      try {
        if (typeof CustomEvent == "function") {
          var J = new CustomEvent("CustomEvent");
          return o.global.dispatchEvent(J), function(K, ge) {
            var Ce = new CustomEvent(K.toLowerCase(), {
              detail: ge,
              cancelable: !0
            });
            return !o.global.dispatchEvent(Ce);
          };
        } else if (typeof Event == "function") {
          var J = new Event("CustomEvent");
          return o.global.dispatchEvent(J), function(ge, Ce) {
            var Oe = new Event(ge.toLowerCase(), {
              cancelable: !0
            });
            return Oe.detail = Ce, !o.global.dispatchEvent(Oe);
          };
        } else {
          var J = document.createEvent("CustomEvent");
          return J.initCustomEvent("testingtheevent", !1, !0, {}), o.global.dispatchEvent(J), function(ge, Ce) {
            var Oe = document.createEvent("CustomEvent");
            return Oe.initCustomEvent(
              ge.toLowerCase(),
              !1,
              !0,
              Ce
            ), !o.global.dispatchEvent(Oe);
          };
        }
      } catch {
      }
      return function() {
        return !1;
      };
    }(), w = function() {
      return o.isNode ? function() {
        return process.emit.apply(process, arguments);
      } : o.global ? function(J) {
        var K = "on" + J.toLowerCase(), ge = o.global[K];
        return ge ? (ge.apply(o.global, [].slice.call(arguments, 1)), !0) : !1;
      } : function() {
        return !1;
      };
    }();
    function R(J, K) {
      return { promise: K };
    }
    var O = {
      promiseCreated: R,
      promiseFulfilled: R,
      promiseRejected: R,
      promiseResolved: R,
      promiseCancelled: R,
      promiseChained: function(J, K, ge) {
        return { promise: K, child: ge };
      },
      warning: function(J, K) {
        return { warning: K };
      },
      unhandledRejection: function(J, K, ge) {
        return { reason: K, promise: ge };
      },
      rejectionHandled: R
    }, D = function(J) {
      var K = !1;
      try {
        K = w.apply(null, arguments);
      } catch (Ce) {
        a.throwLater(Ce), K = !0;
      }
      var ge = !1;
      try {
        ge = T(
          J,
          O[J].apply(null, arguments)
        );
      } catch (Ce) {
        a.throwLater(Ce), ge = !0;
      }
      return ge || K;
    };
    t.config = function(J) {
      if (J = Object(J), "longStackTraces" in J && (J.longStackTraces ? t.longStackTraces() : !J.longStackTraces && t.hasLongStackTraces() && C()), "warnings" in J) {
        var K = J.warnings;
        Me.warnings = !!K, b = Me.warnings, o.isObject(K) && "wForgottenReturn" in K && (b = !!K.wForgottenReturn);
      }
      if ("cancellation" in J && J.cancellation && !Me.cancellation) {
        if (a.haveItemsQueued())
          throw new Error(
            "cannot enable cancellation after promises are in use"
          );
        t.prototype._clearCancellationData = Q, t.prototype._propagateFrom = Y, t.prototype._onCancel = z, t.prototype._setOnCancel = P, t.prototype._attachCancellationCallback = L, t.prototype._execute = W, te = Y, Me.cancellation = !0;
      }
      return "monitoring" in J && (J.monitoring && !Me.monitoring ? (Me.monitoring = !0, t.prototype._fireEvent = D) : !J.monitoring && Me.monitoring && (Me.monitoring = !1, t.prototype._fireEvent = k)), t;
    };
    function k() {
      return !1;
    }
    t.prototype._fireEvent = k, t.prototype._execute = function(J, K, ge) {
      try {
        J(K, ge);
      } catch (Ce) {
        return Ce;
      }
    }, t.prototype._onCancel = function() {
    }, t.prototype._setOnCancel = function(J) {
    }, t.prototype._attachCancellationCallback = function(J) {
    }, t.prototype._captureStackTrace = function() {
    }, t.prototype._attachExtraTrace = function() {
    }, t.prototype._clearCancellationData = function() {
    }, t.prototype._propagateFrom = function(J, K) {
    };
    function W(J, K, ge) {
      var Ce = this;
      try {
        J(K, ge, function(Oe) {
          if (typeof Oe != "function")
            throw new TypeError("onCancel must be a function, got: " + o.toString(Oe));
          Ce._attachCancellationCallback(Oe);
        });
      } catch (Oe) {
        return Oe;
      }
    }
    function L(J) {
      if (!this._isCancellable())
        return this;
      var K = this._onCancel();
      K !== void 0 ? o.isArray(K) ? K.push(J) : this._setOnCancel([K, J]) : this._setOnCancel(J);
    }
    function z() {
      return this._onCancelField;
    }
    function P(J) {
      this._onCancelField = J;
    }
    function Q() {
      this._cancellationParent = void 0, this._onCancelField = void 0;
    }
    function Y(J, K) {
      if (K & 1) {
        this._cancellationParent = J;
        var ge = J._branchesRemainingToCancel;
        ge === void 0 && (ge = 0), J._branchesRemainingToCancel = ge + 1;
      }
      K & 2 && J._isBound() && this._setBoundTo(J._boundTo);
    }
    function ie(J, K) {
      K & 2 && J._isBound() && this._setBoundTo(J._boundTo);
    }
    var te = ie;
    function Z() {
      var J = this._boundTo;
      return J !== void 0 && J instanceof t ? J.isFulfilled() ? J.value() : void 0 : J;
    }
    function ae() {
      this._trace = new Be(this._peekContext());
    }
    function G(J, K) {
      if (l(J)) {
        var ge = this._trace;
        if (ge !== void 0 && K && (ge = ge._parent), ge !== void 0)
          ge.attachExtraTrace(J);
        else if (!J.__stackCleaned__) {
          var Ce = ne(J);
          o.notEnumerableProp(
            J,
            "stack",
            Ce.message + `
` + Ce.stack.join(`
`)
          ), o.notEnumerableProp(J, "__stackCleaned__", !0);
        }
      }
    }
    function U(J, K, ge, Ce, Oe) {
      if (J === void 0 && K !== null && b) {
        if (Oe !== void 0 && Oe._returnedNonUndefined() || !(Ce._bitField & 65535))
          return;
        ge && (ge = ge + " ");
        var qe = "", ct = "";
        if (K._trace) {
          for (var ze = K._trace.stack.split(`
`), et = q(ze), gt = et.length - 1; gt >= 0; --gt) {
            var pt = et[gt];
            if (!f.test(pt)) {
              var nt = pt.match(h);
              nt && (qe = "at " + nt[1] + ":" + nt[2] + ":" + nt[3] + " ");
              break;
            }
          }
          if (et.length > 0) {
            for (var tt = et[0], gt = 0; gt < ze.length; ++gt)
              if (ze[gt] === tt) {
                gt > 0 && (ct = `
` + ze[gt - 1]);
                break;
              }
          }
        }
        var Ve = "a promise was created in a " + ge + "handler " + qe + "but was not returned from it, see http://goo.gl/rRqMUw" + ct;
        Ce._warn(Ve, !0, K);
      }
    }
    function F(J, K) {
      var ge = J + " is deprecated and will be removed in a future version.";
      return K && (ge += " Use " + K + " instead."), M(ge);
    }
    function M(J, K, ge) {
      if (Me.warnings) {
        var Ce = new s(J), Oe;
        if (K)
          ge._attachExtraTrace(Ce);
        else if (Me.longStackTraces && (Oe = t._peekContext()))
          Oe.attachExtraTrace(Ce);
        else {
          var qe = ne(Ce);
          Ce.stack = qe.message + `
` + qe.stack.join(`
`);
        }
        D("warning", Ce) || he(Ce, "", !0);
      }
    }
    function I(J, K) {
      for (var ge = 0; ge < K.length - 1; ++ge)
        K[ge].push("From previous event:"), K[ge] = K[ge].join(`
`);
      return ge < K.length && (K[ge] = K[ge].join(`
`)), J + `
` + K.join(`
`);
    }
    function N(J) {
      for (var K = 0; K < J.length; ++K)
        (J[K].length === 0 || K + 1 < J.length && J[K][0] === J[K + 1][0]) && (J.splice(K, 1), K--);
    }
    function V(J) {
      for (var K = J[0], ge = 1; ge < J.length; ++ge) {
        for (var Ce = J[ge], Oe = K.length - 1, qe = K[Oe], ct = -1, ze = Ce.length - 1; ze >= 0; --ze)
          if (Ce[ze] === qe) {
            ct = ze;
            break;
          }
        for (var ze = ct; ze >= 0; --ze) {
          var et = Ce[ze];
          if (K[Oe] === et)
            K.pop(), Oe--;
          else
            break;
        }
        K = Ce;
      }
    }
    function q(J) {
      for (var K = [], ge = 0; ge < J.length; ++ge) {
        var Ce = J[ge], Oe = Ce === "    (No stack trace)" || g.test(Ce), qe = Oe && Ae(Ce);
        Oe && !qe && (E && Ce.charAt(0) !== " " && (Ce = "    " + Ce), K.push(Ce));
      }
      return K;
    }
    function H(J) {
      for (var K = J.stack.replace(/\s+$/g, "").split(`
`), ge = 0; ge < K.length; ++ge) {
        var Ce = K[ge];
        if (Ce === "    (No stack trace)" || g.test(Ce))
          break;
      }
      return ge > 0 && J.name != "SyntaxError" && (K = K.slice(ge)), K;
    }
    function ne(J) {
      var K = J.stack, ge = J.toString();
      return K = typeof K == "string" && K.length > 0 ? H(J) : ["    (No stack trace)"], {
        message: ge,
        stack: J.name == "SyntaxError" ? K : q(K)
      };
    }
    function he(J, K, ge) {
      if (typeof console < "u") {
        var Ce;
        if (o.isObject(J)) {
          var Oe = J.stack;
          Ce = K + x(Oe, J);
        } else
          Ce = K + String(J);
        typeof m == "function" ? m(Ce, ge) : (typeof console.log == "function" || typeof console.log == "object") && console.log(Ce);
      }
    }
    function j(J, K, ge, Ce) {
      var Oe = !1;
      try {
        typeof K == "function" && (Oe = !0, J === "rejectionHandled" ? K(Ce) : K(ge, Ce));
      } catch (qe) {
        a.throwLater(qe);
      }
      J === "unhandledRejection" ? !D(J, ge, Ce) && !Oe && he(ge, "Unhandled rejection ") : D(J, Ce);
    }
    function Fe(J) {
      var K;
      if (typeof J == "function")
        K = "[function " + (J.name || "anonymous") + "]";
      else {
        K = J && typeof J.toString == "function" ? J.toString() : o.toString(J);
        var ge = /\[object [a-zA-Z0-9$_]+\]/;
        if (ge.test(K))
          try {
            var Ce = JSON.stringify(J);
            K = Ce;
          } catch {
          }
        K.length === 0 && (K = "(empty array)");
      }
      return "(<" + X(K) + ">, no stack trace)";
    }
    function X(J) {
      var K = 41;
      return J.length < K ? J : J.substr(0, K - 3) + "...";
    }
    function ye() {
      return typeof $e == "function";
    }
    var Ae = function() {
      return !1;
    }, fe = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
    function _e(J) {
      var K = J.match(fe);
      if (K)
        return {
          fileName: K[1],
          line: parseInt(K[2], 10)
        };
    }
    function Ie(J, K) {
      if (ye()) {
        for (var ge = J.stack.split(`
`), Ce = K.stack.split(`
`), Oe = -1, qe = -1, ct, ze, et = 0; et < ge.length; ++et) {
          var gt = _e(ge[et]);
          if (gt) {
            ct = gt.fileName, Oe = gt.line;
            break;
          }
        }
        for (var et = 0; et < Ce.length; ++et) {
          var gt = _e(Ce[et]);
          if (gt) {
            ze = gt.fileName, qe = gt.line;
            break;
          }
        }
        Oe < 0 || qe < 0 || !ct || !ze || ct !== ze || Oe >= qe || (Ae = function(pt) {
          if (d.test(pt))
            return !0;
          var nt = _e(pt);
          return !!(nt && nt.fileName === ct && Oe <= nt.line && nt.line <= qe);
        });
      }
    }
    function Be(J) {
      this._parent = J, this._promisesCreated = 0;
      var K = this._length = 1 + (J === void 0 ? 0 : J._length);
      $e(this, Be), K > 32 && this.uncycle();
    }
    o.inherits(Be, Error), e.CapturedTrace = Be, Be.prototype.uncycle = function() {
      var J = this._length;
      if (!(J < 2)) {
        for (var K = [], ge = {}, Ce = 0, Oe = this; Oe !== void 0; ++Ce)
          K.push(Oe), Oe = Oe._parent;
        J = this._length = Ce;
        for (var Ce = J - 1; Ce >= 0; --Ce) {
          var qe = K[Ce].stack;
          ge[qe] === void 0 && (ge[qe] = Ce);
        }
        for (var Ce = 0; Ce < J; ++Ce) {
          var ct = K[Ce].stack, ze = ge[ct];
          if (ze !== void 0 && ze !== Ce) {
            ze > 0 && (K[ze - 1]._parent = void 0, K[ze - 1]._length = 1), K[Ce]._parent = void 0, K[Ce]._length = 1;
            var et = Ce > 0 ? K[Ce - 1] : this;
            ze < J - 1 ? (et._parent = K[ze + 1], et._parent.uncycle(), et._length = et._parent._length + 1) : (et._parent = void 0, et._length = 1);
            for (var gt = et._length + 1, pt = Ce - 2; pt >= 0; --pt)
              K[pt]._length = gt, gt++;
            return;
          }
        }
      }
    }, Be.prototype.attachExtraTrace = function(J) {
      if (!J.__stackCleaned__) {
        this.uncycle();
        for (var K = ne(J), ge = K.message, Ce = [K.stack], Oe = this; Oe !== void 0; )
          Ce.push(q(Oe.stack.split(`
`))), Oe = Oe._parent;
        V(Ce), N(Ce), o.notEnumerableProp(J, "stack", I(ge, Ce)), o.notEnumerableProp(J, "__stackCleaned__", !0);
      }
    };
    var $e = function() {
      var K = /^\s*at\s*/, ge = function(ct, ze) {
        return typeof ct == "string" ? ct : ze.name !== void 0 && ze.message !== void 0 ? ze.toString() : Fe(ze);
      };
      if (typeof Error.stackTraceLimit == "number" && typeof Error.captureStackTrace == "function") {
        Error.stackTraceLimit += 6, g = K, x = ge;
        var Ce = Error.captureStackTrace;
        return Ae = function(ct) {
          return d.test(ct);
        }, function(ct, ze) {
          Error.stackTraceLimit += 6, Ce(ct, ze), Error.stackTraceLimit -= 6;
        };
      }
      var Oe = new Error();
      if (typeof Oe.stack == "string" && Oe.stack.split(`
`)[0].indexOf("stackDetection@") >= 0)
        return g = /@/, x = ge, E = !0, function(ze) {
          ze.stack = new Error().stack;
        };
      var qe;
      try {
        throw new Error();
      } catch (ct) {
        qe = "stack" in ct;
      }
      return !("stack" in Oe) && qe && typeof Error.stackTraceLimit == "number" ? (g = K, x = ge, function(ze) {
        Error.stackTraceLimit += 6;
        try {
          throw new Error();
        } catch (et) {
          ze.stack = et.stack;
        }
        Error.stackTraceLimit -= 6;
      }) : (x = function(ct, ze) {
        return typeof ct == "string" ? ct : (typeof ze == "object" || typeof ze == "function") && ze.name !== void 0 && ze.message !== void 0 ? ze.toString() : Fe(ze);
      }, null);
    }();
    typeof console < "u" && typeof console.warn < "u" && (m = function(J) {
      console.warn(J);
    }, o.isNode && process.stderr.isTTY ? m = function(J, K) {
      var ge = K ? "\x1B[33m" : "\x1B[31m";
      console.warn(ge + J + `\x1B[0m
`);
    } : !o.isNode && typeof new Error().stack == "string" && (m = function(J, K) {
      console.warn(
        "%c" + J,
        K ? "color: darkorange" : "color: red"
      );
    }));
    var Me = {
      warnings: y,
      longStackTraces: !1,
      cancellation: !1,
      monitoring: !1
    };
    return A && t.longStackTraces(), {
      longStackTraces: function() {
        return Me.longStackTraces;
      },
      warnings: function() {
        return Me.warnings;
      },
      cancellation: function() {
        return Me.cancellation;
      },
      monitoring: function() {
        return Me.monitoring;
      },
      propagateFromFunction: function() {
        return te;
      },
      boundValueFunction: function() {
        return Z;
      },
      checkForgottenReturns: U,
      setBounds: Ie,
      warn: M,
      deprecated: F,
      CapturedTrace: Be,
      fireDomEvent: T,
      fireGlobalEvent: w
    };
  }), debuggability;
}
var _finally, hasRequired_finally;
function require_finally() {
  return hasRequired_finally || (hasRequired_finally = 1, _finally = function(t, e) {
    var n = requireUtil(), a = t.CancellationError, s = n.errorObj;
    function o(h, g, x) {
      this.promise = h, this.type = g, this.handler = x, this.called = !1, this.cancelPromise = null;
    }
    o.prototype.isFinallyHandler = function() {
      return this.type === 0;
    };
    function l(h) {
      this.finallyHandler = h;
    }
    l.prototype._resultCancelled = function() {
      c(this.finallyHandler);
    };
    function c(h, g) {
      return h.cancelPromise != null ? (arguments.length > 1 ? h.cancelPromise._reject(g) : h.cancelPromise._cancel(), h.cancelPromise = null, !0) : !1;
    }
    function u() {
      return f.call(this, this.promise._target()._settledValue());
    }
    function d(h) {
      if (!c(this, h))
        return s.e = h, s;
    }
    function f(h) {
      var g = this.promise, x = this.handler;
      if (!this.called) {
        this.called = !0;
        var E = this.isFinallyHandler() ? x.call(g._boundValue()) : x.call(g._boundValue(), h);
        if (E !== void 0) {
          g._setReturnedNonUndefined();
          var m = e(E, g);
          if (m instanceof t) {
            if (this.cancelPromise != null)
              if (m._isCancelled()) {
                var v = new a("late cancellation observer");
                return g._attachExtraTrace(v), s.e = v, s;
              } else
                m.isPending() && m._attachCancellationCallback(
                  new l(this)
                );
            return m._then(
              u,
              d,
              void 0,
              this,
              void 0
            );
          }
        }
      }
      return g.isRejected() ? (c(this), s.e = h, s) : (c(this), h);
    }
    return t.prototype._passThrough = function(h, g, x, E) {
      return typeof h != "function" ? this.then() : this._then(
        x,
        E,
        void 0,
        new o(this, g, h),
        void 0
      );
    }, t.prototype.lastly = t.prototype.finally = function(h) {
      return this._passThrough(
        h,
        0,
        f,
        f
      );
    }, t.prototype.tap = function(h) {
      return this._passThrough(h, 1, f);
    }, o;
  }), _finally;
}
var catch_filter, hasRequiredCatch_filter;
function requireCatch_filter() {
  return hasRequiredCatch_filter || (hasRequiredCatch_filter = 1, catch_filter = function(t) {
    var e = requireUtil(), n = requireEs5().keys, a = e.tryCatch, s = e.errorObj;
    function o(l, c, u) {
      return function(d) {
        var f = u._boundValue();
        e:
          for (var h = 0; h < l.length; ++h) {
            var g = l[h];
            if (g === Error || g != null && g.prototype instanceof Error) {
              if (d instanceof g)
                return a(c).call(f, d);
            } else if (typeof g == "function") {
              var x = a(g).call(f, d);
              if (x === s)
                return x;
              if (x)
                return a(c).call(f, d);
            } else if (e.isObject(d)) {
              for (var E = n(g), m = 0; m < E.length; ++m) {
                var v = E[m];
                if (g[v] != d[v])
                  continue e;
              }
              return a(c).call(f, d);
            }
          }
        return t;
      };
    }
    return o;
  }), catch_filter;
}
var nodeback, hasRequiredNodeback;
function requireNodeback() {
  if (hasRequiredNodeback)
    return nodeback;
  hasRequiredNodeback = 1;
  var t = requireUtil(), e = t.maybeWrapAsError, n = requireErrors(), a = n.OperationalError, s = requireEs5();
  function o(d) {
    return d instanceof Error && s.getPrototypeOf(d) === Error.prototype;
  }
  var l = /^(?:name|message|stack|cause)$/;
  function c(d) {
    var f;
    if (o(d)) {
      f = new a(d), f.name = d.name, f.message = d.message, f.stack = d.stack;
      for (var h = s.keys(d), g = 0; g < h.length; ++g) {
        var x = h[g];
        l.test(x) || (f[x] = d[x]);
      }
      return f;
    }
    return t.markAsOriginatingFromRejection(d), d;
  }
  function u(d, f) {
    return function(h, g) {
      if (d !== null) {
        if (h) {
          var x = c(e(h));
          d._attachExtraTrace(x), d._reject(x);
        } else if (!f)
          d._fulfill(g);
        else {
          for (var E = arguments.length, m = new Array(Math.max(E - 1, 0)), v = 1; v < E; ++v)
            m[v - 1] = arguments[v];
          d._fulfill(m);
        }
        d = null;
      }
    };
  }
  return nodeback = u, nodeback;
}
var method, hasRequiredMethod;
function requireMethod() {
  return hasRequiredMethod || (hasRequiredMethod = 1, method = function(t, e, n, a, s) {
    var o = requireUtil(), l = o.tryCatch;
    t.method = function(c) {
      if (typeof c != "function")
        throw new t.TypeError("expecting a function but got " + o.classString(c));
      return function() {
        var u = new t(e);
        u._captureStackTrace(), u._pushContext();
        var d = l(c).apply(this, arguments), f = u._popContext();
        return s.checkForgottenReturns(
          d,
          f,
          "Promise.method",
          u
        ), u._resolveFromSyncValue(d), u;
      };
    }, t.attempt = t.try = function(c) {
      if (typeof c != "function")
        return a("expecting a function but got " + o.classString(c));
      var u = new t(e);
      u._captureStackTrace(), u._pushContext();
      var d;
      if (arguments.length > 1) {
        s.deprecated("calling Promise.try with more than 1 argument");
        var f = arguments[1], h = arguments[2];
        d = o.isArray(f) ? l(c).apply(h, f) : l(c).call(h, f);
      } else
        d = l(c)();
      var g = u._popContext();
      return s.checkForgottenReturns(
        d,
        g,
        "Promise.try",
        u
      ), u._resolveFromSyncValue(d), u;
    }, t.prototype._resolveFromSyncValue = function(c) {
      c === o.errorObj ? this._rejectCallback(c.e, !1) : this._resolveCallback(c, !0);
    };
  }), method;
}
var bind, hasRequiredBind;
function requireBind() {
  return hasRequiredBind || (hasRequiredBind = 1, bind = function(t, e, n, a) {
    var s = !1, o = function(d, f) {
      this._reject(f);
    }, l = function(d, f) {
      f.promiseRejectionQueued = !0, f.bindingPromise._then(o, o, null, this, d);
    }, c = function(d, f) {
      this._bitField & 50397184 || this._resolveCallback(f.target);
    }, u = function(d, f) {
      f.promiseRejectionQueued || this._reject(d);
    };
    t.prototype.bind = function(d) {
      s || (s = !0, t.prototype._propagateFrom = a.propagateFromFunction(), t.prototype._boundValue = a.boundValueFunction());
      var f = n(d), h = new t(e);
      h._propagateFrom(this, 1);
      var g = this._target();
      if (h._setBoundTo(f), f instanceof t) {
        var x = {
          promiseRejectionQueued: !1,
          promise: h,
          target: g,
          bindingPromise: f
        };
        g._then(e, l, void 0, h, x), f._then(
          c,
          u,
          void 0,
          h,
          x
        ), h._setOnCancel(f);
      } else
        h._resolveCallback(g);
      return h;
    }, t.prototype._setBoundTo = function(d) {
      d !== void 0 ? (this._bitField = this._bitField | 2097152, this._boundTo = d) : this._bitField = this._bitField & -2097153;
    }, t.prototype._isBound = function() {
      return (this._bitField & 2097152) === 2097152;
    }, t.bind = function(d, f) {
      return t.resolve(f).bind(d);
    };
  }), bind;
}
var cancel, hasRequiredCancel;
function requireCancel() {
  return hasRequiredCancel || (hasRequiredCancel = 1, cancel = function(t, e, n, a) {
    var s = requireUtil(), o = s.tryCatch, l = s.errorObj, c = t._async;
    t.prototype.break = t.prototype.cancel = function() {
      if (!a.cancellation())
        return this._warn("cancellation is disabled");
      for (var u = this, d = u; u._isCancellable(); ) {
        if (!u._cancelBy(d)) {
          d._isFollowing() ? d._followee().cancel() : d._cancelBranched();
          break;
        }
        var f = u._cancellationParent;
        if (f == null || !f._isCancellable()) {
          u._isFollowing() ? u._followee().cancel() : u._cancelBranched();
          break;
        } else
          u._isFollowing() && u._followee().cancel(), u._setWillBeCancelled(), d = u, u = f;
      }
    }, t.prototype._branchHasCancelled = function() {
      this._branchesRemainingToCancel--;
    }, t.prototype._enoughBranchesHaveCancelled = function() {
      return this._branchesRemainingToCancel === void 0 || this._branchesRemainingToCancel <= 0;
    }, t.prototype._cancelBy = function(u) {
      return u === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), this._enoughBranchesHaveCancelled() ? (this._invokeOnCancel(), !0) : !1);
    }, t.prototype._cancelBranched = function() {
      this._enoughBranchesHaveCancelled() && this._cancel();
    }, t.prototype._cancel = function() {
      this._isCancellable() && (this._setCancelled(), c.invoke(this._cancelPromises, this, void 0));
    }, t.prototype._cancelPromises = function() {
      this._length() > 0 && this._settlePromises();
    }, t.prototype._unsetOnCancel = function() {
      this._onCancelField = void 0;
    }, t.prototype._isCancellable = function() {
      return this.isPending() && !this._isCancelled();
    }, t.prototype.isCancellable = function() {
      return this.isPending() && !this.isCancelled();
    }, t.prototype._doInvokeOnCancel = function(u, d) {
      if (s.isArray(u))
        for (var f = 0; f < u.length; ++f)
          this._doInvokeOnCancel(u[f], d);
      else if (u !== void 0)
        if (typeof u == "function") {
          if (!d) {
            var h = o(u).call(this._boundValue());
            h === l && (this._attachExtraTrace(h.e), c.throwLater(h.e));
          }
        } else
          u._resultCancelled(this);
    }, t.prototype._invokeOnCancel = function() {
      var u = this._onCancel();
      this._unsetOnCancel(), c.invoke(this._doInvokeOnCancel, this, u);
    }, t.prototype._invokeInternalOnCancel = function() {
      this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel());
    }, t.prototype._resultCancelled = function() {
      this.cancel();
    };
  }), cancel;
}
var direct_resolve, hasRequiredDirect_resolve;
function requireDirect_resolve() {
  return hasRequiredDirect_resolve || (hasRequiredDirect_resolve = 1, direct_resolve = function(t) {
    function e() {
      return this.value;
    }
    function n() {
      throw this.reason;
    }
    t.prototype.return = t.prototype.thenReturn = function(a) {
      return a instanceof t && a.suppressUnhandledRejections(), this._then(
        e,
        void 0,
        void 0,
        { value: a },
        void 0
      );
    }, t.prototype.throw = t.prototype.thenThrow = function(a) {
      return this._then(
        n,
        void 0,
        void 0,
        { reason: a },
        void 0
      );
    }, t.prototype.catchThrow = function(a) {
      if (arguments.length <= 1)
        return this._then(
          void 0,
          n,
          void 0,
          { reason: a },
          void 0
        );
      var s = arguments[1], o = function() {
        throw s;
      };
      return this.caught(a, o);
    }, t.prototype.catchReturn = function(a) {
      if (arguments.length <= 1)
        return a instanceof t && a.suppressUnhandledRejections(), this._then(
          void 0,
          e,
          void 0,
          { value: a },
          void 0
        );
      var s = arguments[1];
      s instanceof t && s.suppressUnhandledRejections();
      var o = function() {
        return s;
      };
      return this.caught(a, o);
    };
  }), direct_resolve;
}
var synchronous_inspection, hasRequiredSynchronous_inspection;
function requireSynchronous_inspection() {
  return hasRequiredSynchronous_inspection || (hasRequiredSynchronous_inspection = 1, synchronous_inspection = function(t) {
    function e(u) {
      u !== void 0 ? (u = u._target(), this._bitField = u._bitField, this._settledValueField = u._isFateSealed() ? u._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
    }
    e.prototype._settledValue = function() {
      return this._settledValueField;
    };
    var n = e.prototype.value = function() {
      if (!this.isFulfilled())
        throw new TypeError(`cannot get fulfillment value of a non-fulfilled promise

    See http://goo.gl/MqrFmX
`);
      return this._settledValue();
    }, a = e.prototype.error = e.prototype.reason = function() {
      if (!this.isRejected())
        throw new TypeError(`cannot get rejection reason of a non-rejected promise

    See http://goo.gl/MqrFmX
`);
      return this._settledValue();
    }, s = e.prototype.isFulfilled = function() {
      return (this._bitField & 33554432) !== 0;
    }, o = e.prototype.isRejected = function() {
      return (this._bitField & 16777216) !== 0;
    }, l = e.prototype.isPending = function() {
      return (this._bitField & 50397184) === 0;
    }, c = e.prototype.isResolved = function() {
      return (this._bitField & 50331648) !== 0;
    };
    e.prototype.isCancelled = function() {
      return (this._bitField & 8454144) !== 0;
    }, t.prototype.__isCancelled = function() {
      return (this._bitField & 65536) === 65536;
    }, t.prototype._isCancelled = function() {
      return this._target().__isCancelled();
    }, t.prototype.isCancelled = function() {
      return (this._target()._bitField & 8454144) !== 0;
    }, t.prototype.isPending = function() {
      return l.call(this._target());
    }, t.prototype.isRejected = function() {
      return o.call(this._target());
    }, t.prototype.isFulfilled = function() {
      return s.call(this._target());
    }, t.prototype.isResolved = function() {
      return c.call(this._target());
    }, t.prototype.value = function() {
      return n.call(this._target());
    }, t.prototype.reason = function() {
      var u = this._target();
      return u._unsetRejectionIsUnhandled(), a.call(u);
    }, t.prototype._value = function() {
      return this._settledValue();
    }, t.prototype._reason = function() {
      return this._unsetRejectionIsUnhandled(), this._settledValue();
    }, t.PromiseInspection = e;
  }), synchronous_inspection;
}
var join, hasRequiredJoin;
function requireJoin() {
  return hasRequiredJoin || (hasRequiredJoin = 1, join = function(t, e, n, a, s, o) {
    var l = requireUtil(), c = l.canEvaluate, u = l.tryCatch, d = l.errorObj, f;
    if (c) {
      for (var h = function(A) {
        return new Function("value", "holder", `                             
	            'use strict';                                                    
	            holder.pIndex = value;                                           
	            holder.checkFulfillment(this);                                   
	            `.replace(/Index/g, A));
      }, g = function(A) {
        return new Function("promise", "holder", `                           
	            'use strict';                                                    
	            holder.pIndex = promise;                                         
	            `.replace(/Index/g, A));
      }, x = function(A) {
        for (var b = new Array(A), C = 0; C < b.length; ++C)
          b[C] = "this.p" + (C + 1);
        var T = b.join(" = ") + " = null;", w = `var promise;
` + b.map(function(k) {
          return `                                                         
	                promise = ` + k + `;                                      
	                if (promise instanceof Promise) {                            
	                    promise.cancel();                                        
	                }                                                            
	            `;
        }).join(`
`), R = b.join(", "), O = "Holder$" + A, D = `return function(tryCatch, errorObj, Promise, async) {    
	            'use strict';                                                    
	            function [TheName](fn) {                                         
	                [TheProperties]                                              
	                this.fn = fn;                                                
	                this.asyncNeeded = true;                                     
	                this.now = 0;                                                
	            }                                                                
	                                                                             
	            [TheName].prototype._callFunction = function(promise) {          
	                promise._pushContext();                                      
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           
	                promise._popContext();                                       
	                if (ret === errorObj) {                                      
	                    promise._rejectCallback(ret.e, false);                   
	                } else {                                                     
	                    promise._resolveCallback(ret);                           
	                }                                                            
	            };                                                               
	                                                                             
	            [TheName].prototype.checkFulfillment = function(promise) {       
	                var now = ++this.now;                                        
	                if (now === [TheTotal]) {                                    
	                    if (this.asyncNeeded) {                                  
	                        async.invoke(this._callFunction, this, promise);     
	                    } else {                                                 
	                        this._callFunction(promise);                         
	                    }                                                        
	                                                                             
	                }                                                            
	            };                                                               
	                                                                             
	            [TheName].prototype._resultCancelled = function() {              
	                [CancellationCode]                                           
	            };                                                               
	                                                                             
	            return [TheName];                                                
	        }(tryCatch, errorObj, Promise, async);                               
	        `;
        return D = D.replace(/\[TheName\]/g, O).replace(/\[TheTotal\]/g, A).replace(/\[ThePassedArguments\]/g, R).replace(/\[TheProperties\]/g, T).replace(/\[CancellationCode\]/g, w), new Function("tryCatch", "errorObj", "Promise", "async", D)(u, d, t, s);
      }, E = [], m = [], v = [], y = 0; y < 8; ++y)
        E.push(x(y + 1)), m.push(h(y + 1)), v.push(g(y + 1));
      f = function(A) {
        this._reject(A);
      };
    }
    t.join = function() {
      var A = arguments.length - 1, b;
      if (A > 0 && typeof arguments[A] == "function" && (b = arguments[A], A <= 8 && c)) {
        var P = new t(a);
        P._captureStackTrace();
        for (var C = E[A - 1], T = new C(b), w = m, R = 0; R < A; ++R) {
          var O = n(arguments[R], P);
          if (O instanceof t) {
            O = O._target();
            var D = O._bitField;
            D & 50397184 ? D & 33554432 ? w[R].call(
              P,
              O._value(),
              T
            ) : D & 16777216 ? P._reject(O._reason()) : P._cancel() : (O._then(
              w[R],
              f,
              void 0,
              P,
              T
            ), v[R](O, T), T.asyncNeeded = !1);
          } else
            w[R].call(P, O, T);
        }
        if (!P._isFateSealed()) {
          if (T.asyncNeeded) {
            var k = o();
            k !== null && (T.fn = l.domainBind(k, T.fn));
          }
          P._setAsyncGuaranteed(), P._setOnCancel(T);
        }
        return P;
      }
      for (var W = arguments.length, L = new Array(W), z = 0; z < W; ++z)
        L[z] = arguments[z];
      b && L.pop();
      var P = new e(L).promise();
      return b !== void 0 ? P.spread(b) : P;
    };
  }), join;
}
var map, hasRequiredMap;
function requireMap() {
  return hasRequiredMap || (hasRequiredMap = 1, map = function(t, e, n, a, s, o) {
    var l = t._getDomain, c = requireUtil(), u = c.tryCatch, d = c.errorObj, f = t._async;
    function h(x, E, m, v) {
      this.constructor$(x), this._promise._captureStackTrace();
      var y = l();
      this._callback = y === null ? E : c.domainBind(y, E), this._preservedValues = v === s ? new Array(this.length()) : null, this._limit = m, this._inFlight = 0, this._queue = [], f.invoke(this._asyncInit, this, void 0);
    }
    c.inherits(h, e), h.prototype._asyncInit = function() {
      this._init$(void 0, -2);
    }, h.prototype._init = function() {
    }, h.prototype._promiseFulfilled = function(x, E) {
      var m = this._values, v = this.length(), y = this._preservedValues, A = this._limit;
      if (E < 0) {
        if (E = E * -1 - 1, m[E] = x, A >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved()))
          return !0;
      } else {
        if (A >= 1 && this._inFlight >= A)
          return m[E] = x, this._queue.push(E), !1;
        y !== null && (y[E] = x);
        var b = this._promise, C = this._callback, T = b._boundValue();
        b._pushContext();
        var w = u(C).call(T, x, E, v), R = b._popContext();
        if (o.checkForgottenReturns(
          w,
          R,
          y !== null ? "Promise.filter" : "Promise.map",
          b
        ), w === d)
          return this._reject(w.e), !0;
        var O = a(w, this._promise);
        if (O instanceof t) {
          O = O._target();
          var D = O._bitField;
          if (D & 50397184)
            if (D & 33554432)
              w = O._value();
            else
              return D & 16777216 ? (this._reject(O._reason()), !0) : (this._cancel(), !0);
          else
            return A >= 1 && this._inFlight++, m[E] = O, O._proxy(this, (E + 1) * -1), !1;
        }
        m[E] = w;
      }
      var k = ++this._totalResolved;
      return k >= v ? (y !== null ? this._filter(m, y) : this._resolve(m), !0) : !1;
    }, h.prototype._drainQueue = function() {
      for (var x = this._queue, E = this._limit, m = this._values; x.length > 0 && this._inFlight < E; ) {
        if (this._isResolved())
          return;
        var v = x.pop();
        this._promiseFulfilled(m[v], v);
      }
    }, h.prototype._filter = function(x, E) {
      for (var m = E.length, v = new Array(m), y = 0, A = 0; A < m; ++A)
        x[A] && (v[y++] = E[A]);
      v.length = y, this._resolve(v);
    }, h.prototype.preservedValues = function() {
      return this._preservedValues;
    };
    function g(x, E, m, v) {
      if (typeof E != "function")
        return n("expecting a function but got " + c.classString(E));
      var y = 0;
      if (m !== void 0)
        if (typeof m == "object" && m !== null) {
          if (typeof m.concurrency != "number")
            return t.reject(
              new TypeError("'concurrency' must be a number but it is " + c.classString(m.concurrency))
            );
          y = m.concurrency;
        } else
          return t.reject(new TypeError(
            "options argument must be an object but it is " + c.classString(m)
          ));
      return y = typeof y == "number" && isFinite(y) && y >= 1 ? y : 0, new h(x, E, y, v).promise();
    }
    t.prototype.map = function(x, E) {
      return g(this, x, E, null);
    }, t.map = function(x, E, m, v) {
      return g(x, E, m, v);
    };
  }), map;
}
var call_get, hasRequiredCall_get;
function requireCall_get() {
  if (hasRequiredCall_get)
    return call_get;
  hasRequiredCall_get = 1;
  var t = Object.create;
  if (t) {
    var e = t(null), n = t(null);
    e[" size"] = n[" size"] = 0;
  }
  return call_get = function(a) {
    var s = requireUtil(), o = s.canEvaluate, l = s.isIdentifier, c, u;
    {
      var d = function(v) {
        return new Function("ensureMethod", `                                    
	        return function(obj) {                                               
	            'use strict'                                                     
	            var len = this.length;                                           
	            ensureMethod(obj, 'methodName');                                 
	            switch(len) {                                                    
	                case 1: return obj.methodName(this[0]);                      
	                case 2: return obj.methodName(this[0], this[1]);             
	                case 3: return obj.methodName(this[0], this[1], this[2]);    
	                case 0: return obj.methodName();                             
	                default:                                                     
	                    return obj.methodName.apply(obj, this);                  
	            }                                                                
	        };                                                                   
	        `.replace(/methodName/g, v))(g);
      }, f = function(v) {
        return new Function("obj", `                                             
	        'use strict';                                                        
	        return obj.propertyName;                                             
	        `.replace("propertyName", v));
      }, h = function(v, y, A) {
        var b = A[v];
        if (typeof b != "function") {
          if (!l(v))
            return null;
          if (b = y(v), A[v] = b, A[" size"]++, A[" size"] > 512) {
            for (var C = Object.keys(A), T = 0; T < 256; ++T)
              delete A[C[T]];
            A[" size"] = C.length - 256;
          }
        }
        return b;
      };
      c = function(v) {
        return h(v, d, e);
      }, u = function(v) {
        return h(v, f, n);
      };
    }
    function g(v, y) {
      var A;
      if (v != null && (A = v[y]), typeof A != "function") {
        var b = "Object " + s.classString(v) + " has no method '" + s.toString(y) + "'";
        throw new a.TypeError(b);
      }
      return A;
    }
    function x(v) {
      var y = this.pop(), A = g(v, y);
      return A.apply(v, this);
    }
    a.prototype.call = function(v) {
      for (var y = arguments.length, A = new Array(Math.max(y - 1, 0)), b = 1; b < y; ++b)
        A[b - 1] = arguments[b];
      if (o) {
        var C = c(v);
        if (C !== null)
          return this._then(
            C,
            void 0,
            void 0,
            A,
            void 0
          );
      }
      return A.push(v), this._then(x, void 0, void 0, A, void 0);
    };
    function E(v) {
      return v[this];
    }
    function m(v) {
      var y = +this;
      return y < 0 && (y = Math.max(0, y + v.length)), v[y];
    }
    a.prototype.get = function(v) {
      var y = typeof v == "number", A;
      if (y)
        A = m;
      else if (o) {
        var b = u(v);
        A = b !== null ? b : E;
      } else
        A = E;
      return this._then(A, void 0, void 0, v, void 0);
    };
  }, call_get;
}
var using, hasRequiredUsing;
function requireUsing() {
  return hasRequiredUsing || (hasRequiredUsing = 1, using = function(t, e, n, a, s, o) {
    var l = requireUtil(), c = requireErrors().TypeError, u = requireUtil().inherits, d = l.errorObj, f = l.tryCatch, h = {};
    function g(b) {
      setTimeout(function() {
        throw b;
      }, 0);
    }
    function x(b) {
      var C = n(b);
      return C !== b && typeof b._isDisposable == "function" && typeof b._getDisposer == "function" && b._isDisposable() && C._setDisposable(b._getDisposer()), C;
    }
    function E(b, C) {
      var T = 0, w = b.length, R = new t(s);
      function O() {
        if (T >= w)
          return R._fulfill();
        var D = x(b[T++]);
        if (D instanceof t && D._isDisposable()) {
          try {
            D = n(
              D._getDisposer().tryDispose(C),
              b.promise
            );
          } catch (k) {
            return g(k);
          }
          if (D instanceof t)
            return D._then(
              O,
              g,
              null,
              null,
              null
            );
        }
        O();
      }
      return O(), R;
    }
    function m(b, C, T) {
      this._data = b, this._promise = C, this._context = T;
    }
    m.prototype.data = function() {
      return this._data;
    }, m.prototype.promise = function() {
      return this._promise;
    }, m.prototype.resource = function() {
      return this.promise().isFulfilled() ? this.promise().value() : h;
    }, m.prototype.tryDispose = function(b) {
      var C = this.resource(), T = this._context;
      T !== void 0 && T._pushContext();
      var w = C !== h ? this.doDispose(C, b) : null;
      return T !== void 0 && T._popContext(), this._promise._unsetDisposable(), this._data = null, w;
    }, m.isDisposer = function(b) {
      return b != null && typeof b.resource == "function" && typeof b.tryDispose == "function";
    };
    function v(b, C, T) {
      this.constructor$(b, C, T);
    }
    u(v, m), v.prototype.doDispose = function(b, C) {
      var T = this.data();
      return T.call(b, b, C);
    };
    function y(b) {
      return m.isDisposer(b) ? (this.resources[this.index]._setDisposable(b), b.promise()) : b;
    }
    function A(b) {
      this.length = b, this.promise = null, this[b - 1] = null;
    }
    A.prototype._resultCancelled = function() {
      for (var b = this.length, C = 0; C < b; ++C) {
        var T = this[C];
        T instanceof t && T.cancel();
      }
    }, t.using = function() {
      var b = arguments.length;
      if (b < 2)
        return e(
          "you must pass at least 2 arguments to Promise.using"
        );
      var C = arguments[b - 1];
      if (typeof C != "function")
        return e("expecting a function but got " + l.classString(C));
      var T, w = !0;
      b === 2 && Array.isArray(arguments[0]) ? (T = arguments[0], b = T.length, w = !1) : (T = arguments, b--);
      for (var R = new A(b), O = 0; O < b; ++O) {
        var D = T[O];
        if (m.isDisposer(D)) {
          var k = D;
          D = D.promise(), D._setDisposable(k);
        } else {
          var W = n(D);
          W instanceof t && (D = W._then(y, null, null, {
            resources: R,
            index: O
          }, void 0));
        }
        R[O] = D;
      }
      for (var L = new Array(R.length), O = 0; O < L.length; ++O)
        L[O] = t.resolve(R[O]).reflect();
      var z = t.all(L).then(function(Q) {
        for (var Y = 0; Y < Q.length; ++Y) {
          var ie = Q[Y];
          if (ie.isRejected())
            return d.e = ie.error(), d;
          if (!ie.isFulfilled()) {
            z.cancel();
            return;
          }
          Q[Y] = ie.value();
        }
        P._pushContext(), C = f(C);
        var te = w ? C.apply(void 0, Q) : C(Q), Z = P._popContext();
        return o.checkForgottenReturns(
          te,
          Z,
          "Promise.using",
          P
        ), te;
      }), P = z.lastly(function() {
        var Q = new t.PromiseInspection(z);
        return E(R, Q);
      });
      return R.promise = P, P._setOnCancel(R), P;
    }, t.prototype._setDisposable = function(b) {
      this._bitField = this._bitField | 131072, this._disposer = b;
    }, t.prototype._isDisposable = function() {
      return (this._bitField & 131072) > 0;
    }, t.prototype._getDisposer = function() {
      return this._disposer;
    }, t.prototype._unsetDisposable = function() {
      this._bitField = this._bitField & -131073, this._disposer = void 0;
    }, t.prototype.disposer = function(b) {
      if (typeof b == "function")
        return new v(b, this, a());
      throw new c();
    };
  }), using;
}
var timers, hasRequiredTimers;
function requireTimers() {
  return hasRequiredTimers || (hasRequiredTimers = 1, timers = function(t, e, n) {
    var a = requireUtil(), s = t.TimeoutError;
    function o(h) {
      this.handle = h;
    }
    o.prototype._resultCancelled = function() {
      clearTimeout(this.handle);
    };
    var l = function(h) {
      return c(+this).thenReturn(h);
    }, c = t.delay = function(h, g) {
      var x, E;
      return g !== void 0 ? (x = t.resolve(g)._then(l, null, null, h, void 0), n.cancellation() && g instanceof t && x._setOnCancel(g)) : (x = new t(e), E = setTimeout(function() {
        x._fulfill();
      }, +h), n.cancellation() && x._setOnCancel(new o(E)), x._captureStackTrace()), x._setAsyncGuaranteed(), x;
    };
    t.prototype.delay = function(h) {
      return c(h, this);
    };
    var u = function(h, g, x) {
      var E;
      typeof g != "string" ? g instanceof Error ? E = g : E = new s("operation timed out") : E = new s(g), a.markAsOriginatingFromRejection(E), h._attachExtraTrace(E), h._reject(E), x != null && x.cancel();
    };
    function d(h) {
      return clearTimeout(this.handle), h;
    }
    function f(h) {
      throw clearTimeout(this.handle), h;
    }
    t.prototype.timeout = function(h, g) {
      h = +h;
      var x, E, m = new o(setTimeout(function() {
        x.isPending() && u(x, g, E);
      }, h));
      return n.cancellation() ? (E = this.then(), x = E._then(
        d,
        f,
        void 0,
        m,
        void 0
      ), x._setOnCancel(m)) : x = this._then(
        d,
        f,
        void 0,
        m,
        void 0
      ), x;
    };
  }), timers;
}
var generators, hasRequiredGenerators;
function requireGenerators() {
  return hasRequiredGenerators || (hasRequiredGenerators = 1, generators = function(t, e, n, a, s, o) {
    var l = requireErrors(), c = l.TypeError, u = requireUtil(), d = u.errorObj, f = u.tryCatch, h = [];
    function g(E, m, v) {
      for (var y = 0; y < m.length; ++y) {
        v._pushContext();
        var A = f(m[y])(E);
        if (v._popContext(), A === d) {
          v._pushContext();
          var b = t.reject(d.e);
          return v._popContext(), b;
        }
        var C = a(A, v);
        if (C instanceof t)
          return C;
      }
      return null;
    }
    function x(E, m, v, y) {
      if (o.cancellation()) {
        var A = new t(n), b = this._finallyPromise = new t(n);
        this._promise = A.lastly(function() {
          return b;
        }), A._captureStackTrace(), A._setOnCancel(this);
      } else {
        var C = this._promise = new t(n);
        C._captureStackTrace();
      }
      this._stack = y, this._generatorFunction = E, this._receiver = m, this._generator = void 0, this._yieldHandlers = typeof v == "function" ? [v].concat(h) : h, this._yieldedPromise = null, this._cancellationPhase = !1;
    }
    u.inherits(x, s), x.prototype._isResolved = function() {
      return this._promise === null;
    }, x.prototype._cleanup = function() {
      this._promise = this._generator = null, o.cancellation() && this._finallyPromise !== null && (this._finallyPromise._fulfill(), this._finallyPromise = null);
    }, x.prototype._promiseCancelled = function() {
      if (!this._isResolved()) {
        var E = typeof this._generator.return < "u", m;
        if (E)
          this._promise._pushContext(), m = f(this._generator.return).call(
            this._generator,
            void 0
          ), this._promise._popContext();
        else {
          var v = new t.CancellationError(
            "generator .return() sentinel"
          );
          t.coroutine.returnSentinel = v, this._promise._attachExtraTrace(v), this._promise._pushContext(), m = f(this._generator.throw).call(
            this._generator,
            v
          ), this._promise._popContext();
        }
        this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(m);
      }
    }, x.prototype._promiseFulfilled = function(E) {
      this._yieldedPromise = null, this._promise._pushContext();
      var m = f(this._generator.next).call(this._generator, E);
      this._promise._popContext(), this._continue(m);
    }, x.prototype._promiseRejected = function(E) {
      this._yieldedPromise = null, this._promise._attachExtraTrace(E), this._promise._pushContext();
      var m = f(this._generator.throw).call(this._generator, E);
      this._promise._popContext(), this._continue(m);
    }, x.prototype._resultCancelled = function() {
      if (this._yieldedPromise instanceof t) {
        var E = this._yieldedPromise;
        this._yieldedPromise = null, E.cancel();
      }
    }, x.prototype.promise = function() {
      return this._promise;
    }, x.prototype._run = function() {
      this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
    }, x.prototype._continue = function(E) {
      var m = this._promise;
      if (E === d)
        return this._cleanup(), this._cancellationPhase ? m.cancel() : m._rejectCallback(E.e, !1);
      var v = E.value;
      if (E.done === !0)
        return this._cleanup(), this._cancellationPhase ? m.cancel() : m._resolveCallback(v);
      var y = a(v, this._promise);
      if (!(y instanceof t) && (y = g(
        y,
        this._yieldHandlers,
        this._promise
      ), y === null)) {
        this._promiseRejected(
          new c(
            `A value %s was yielded that could not be treated as a promise

    See http://goo.gl/MqrFmX

`.replace("%s", v) + `From coroutine:
` + this._stack.split(`
`).slice(1, -7).join(`
`)
          )
        );
        return;
      }
      y = y._target();
      var A = y._bitField;
      A & 50397184 ? A & 33554432 ? t._async.invoke(
        this._promiseFulfilled,
        this,
        y._value()
      ) : A & 16777216 ? t._async.invoke(
        this._promiseRejected,
        this,
        y._reason()
      ) : this._promiseCancelled() : (this._yieldedPromise = y, y._proxy(this, null));
    }, t.coroutine = function(E, m) {
      if (typeof E != "function")
        throw new c(`generatorFunction must be a function

    See http://goo.gl/MqrFmX
`);
      var v = Object(m).yieldHandler, y = x, A = new Error().stack;
      return function() {
        var b = E.apply(this, arguments), C = new y(
          void 0,
          void 0,
          v,
          A
        ), T = C.promise();
        return C._generator = b, C._promiseFulfilled(void 0), T;
      };
    }, t.coroutine.addYieldHandler = function(E) {
      if (typeof E != "function")
        throw new c("expecting a function but got " + u.classString(E));
      h.push(E);
    }, t.spawn = function(E) {
      if (o.deprecated("Promise.spawn()", "Promise.coroutine()"), typeof E != "function")
        return e(`generatorFunction must be a function

    See http://goo.gl/MqrFmX
`);
      var m = new x(E, this), v = m.promise();
      return m._run(t.spawn), v;
    };
  }), generators;
}
var nodeify, hasRequiredNodeify;
function requireNodeify() {
  return hasRequiredNodeify || (hasRequiredNodeify = 1, nodeify = function(t) {
    var e = requireUtil(), n = t._async, a = e.tryCatch, s = e.errorObj;
    function o(u, d) {
      var f = this;
      if (!e.isArray(u))
        return l.call(f, u, d);
      var h = a(d).apply(f._boundValue(), [null].concat(u));
      h === s && n.throwLater(h.e);
    }
    function l(u, d) {
      var f = this, h = f._boundValue(), g = u === void 0 ? a(d).call(h, null) : a(d).call(h, null, u);
      g === s && n.throwLater(g.e);
    }
    function c(u, d) {
      var f = this;
      if (!u) {
        var h = new Error(u + "");
        h.cause = u, u = h;
      }
      var g = a(d).call(f._boundValue(), u);
      g === s && n.throwLater(g.e);
    }
    t.prototype.asCallback = t.prototype.nodeify = function(u, d) {
      if (typeof u == "function") {
        var f = l;
        d !== void 0 && Object(d).spread && (f = o), this._then(
          f,
          c,
          void 0,
          this,
          u
        );
      }
      return this;
    };
  }), nodeify;
}
var promisify, hasRequiredPromisify;
function requirePromisify() {
  return hasRequiredPromisify || (hasRequiredPromisify = 1, promisify = function(t, e) {
    var n = {}, a = requireUtil(), s = requireNodeback(), o = a.withAppended, l = a.maybeWrapAsError, c = a.canEvaluate, u = requireErrors().TypeError, d = "Async", f = { __isPromisified__: !0 }, h = [
      "arity",
      "length",
      "name",
      "arguments",
      "caller",
      "callee",
      "prototype",
      "__isPromisified__"
    ], g = new RegExp("^(?:" + h.join("|") + ")$"), x = function(z) {
      return a.isIdentifier(z) && z.charAt(0) !== "_" && z !== "constructor";
    };
    function E(z) {
      return !g.test(z);
    }
    function m(z) {
      try {
        return z.__isPromisified__ === !0;
      } catch {
        return !1;
      }
    }
    function v(z, P, Q) {
      var Y = a.getDataPropertyOrDefault(
        z,
        P + Q,
        f
      );
      return Y ? m(Y) : !1;
    }
    function y(z, P, Q) {
      for (var Y = 0; Y < z.length; Y += 2) {
        var ie = z[Y];
        if (Q.test(ie)) {
          for (var te = ie.replace(Q, ""), Z = 0; Z < z.length; Z += 2)
            if (z[Z] === te)
              throw new u(`Cannot promisify an API that has normal methods with '%s'-suffix

    See http://goo.gl/MqrFmX
`.replace("%s", P));
        }
      }
    }
    function A(z, P, Q, Y) {
      for (var ie = a.inheritedDataKeys(z), te = [], Z = 0; Z < ie.length; ++Z) {
        var ae = ie[Z], G = z[ae], U = Y === x ? !0 : x(ae);
        typeof G == "function" && !m(G) && !v(z, ae, P) && Y(ae, G, z, U) && te.push(ae, G);
      }
      return y(te, P, Q), te;
    }
    var b = function(z) {
      return z.replace(/([$])/, "\\$");
    }, C;
    {
      var T = function(z) {
        for (var P = [z], Q = Math.max(0, z - 1 - 3), Y = z - 1; Y >= Q; --Y)
          P.push(Y);
        for (var Y = z + 1; Y <= 3; ++Y)
          P.push(Y);
        return P;
      }, w = function(z) {
        return a.filledRange(z, "_arg", "");
      }, R = function(z) {
        return a.filledRange(
          Math.max(z, 3),
          "_arg",
          ""
        );
      }, O = function(z) {
        return typeof z.length == "number" ? Math.max(Math.min(z.length, 1024), 0) : 0;
      };
      C = function(z, P, Q, Y, ie, te) {
        var Z = Math.max(0, O(Y) - 1), ae = T(Z), G = typeof z == "string" || P === n;
        function U(N) {
          var V = w(N).join(", "), q = N > 0 ? ", " : "", H;
          return G ? H = `ret = callback.call(this, {{args}}, nodeback); break;
` : H = P === void 0 ? `ret = callback({{args}}, nodeback); break;
` : `ret = callback.call(receiver, {{args}}, nodeback); break;
`, H.replace("{{args}}", V).replace(", ", q);
        }
        function F() {
          for (var N = "", V = 0; V < ae.length; ++V)
            N += "case " + ae[V] + ":" + U(ae[V]);
          return N += `                                                             
	        default:                                                             
	            var args = new Array(len + 1);                                   
	            var i = 0;                                                       
	            for (var i = 0; i < len; ++i) {                                  
	               args[i] = arguments[i];                                       
	            }                                                                
	            args[i] = nodeback;                                              
	            [CodeForCall]                                                    
	            break;                                                           
	        `.replace("[CodeForCall]", G ? `ret = callback.apply(this, args);
` : `ret = callback.apply(receiver, args);
`), N;
        }
        var M = typeof z == "string" ? "this != null ? this['" + z + "'] : fn" : "fn", I = `'use strict';                                                
	        var ret = function (Parameters) {                                    
	            'use strict';                                                    
	            var len = arguments.length;                                      
	            var promise = new Promise(INTERNAL);                             
	            promise._captureStackTrace();                                    
	            var nodeback = nodebackForPromise(promise, ` + te + `);   
	            var ret;                                                         
	            var callback = tryCatch([GetFunctionCode]);                      
	            switch(len) {                                                    
	                [CodeForSwitchCase]                                          
	            }                                                                
	            if (ret === errorObj) {                                          
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);
	            }                                                                
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     
	            return promise;                                                  
	        };                                                                   
	        notEnumerableProp(ret, '__isPromisified__', true);                   
	        return ret;                                                          
	    `.replace("[CodeForSwitchCase]", F()).replace("[GetFunctionCode]", M);
        return I = I.replace("Parameters", R(Z)), new Function(
          "Promise",
          "fn",
          "receiver",
          "withAppended",
          "maybeWrapAsError",
          "nodebackForPromise",
          "tryCatch",
          "errorObj",
          "notEnumerableProp",
          "INTERNAL",
          I
        )(
          t,
          Y,
          P,
          o,
          l,
          s,
          a.tryCatch,
          a.errorObj,
          a.notEnumerableProp,
          e
        );
      };
    }
    function D(z, P, Q, Y, ie, te) {
      var Z = /* @__PURE__ */ function() {
        return this;
      }(), ae = z;
      typeof ae == "string" && (z = Y);
      function G() {
        var U = P;
        P === n && (U = this);
        var F = new t(e);
        F._captureStackTrace();
        var M = typeof ae == "string" && this !== Z ? this[ae] : z, I = s(F, te);
        try {
          M.apply(U, o(arguments, I));
        } catch (N) {
          F._rejectCallback(l(N), !0, !0);
        }
        return F._isFateSealed() || F._setAsyncGuaranteed(), F;
      }
      return a.notEnumerableProp(G, "__isPromisified__", !0), G;
    }
    var k = c ? C : D;
    function W(z, P, Q, Y, ie) {
      for (var te = new RegExp(b(P) + "$"), Z = A(z, P, te, Q), ae = 0, G = Z.length; ae < G; ae += 2) {
        var U = Z[ae], F = Z[ae + 1], M = U + P;
        if (Y === k)
          z[M] = k(U, n, U, F, P, ie);
        else {
          var I = Y(F, function() {
            return k(
              U,
              n,
              U,
              F,
              P,
              ie
            );
          });
          a.notEnumerableProp(I, "__isPromisified__", !0), z[M] = I;
        }
      }
      return a.toFastProperties(z), z;
    }
    function L(z, P, Q) {
      return k(
        z,
        P,
        void 0,
        z,
        null,
        Q
      );
    }
    t.promisify = function(z, P) {
      if (typeof z != "function")
        throw new u("expecting a function but got " + a.classString(z));
      if (m(z))
        return z;
      P = Object(P);
      var Q = P.context === void 0 ? n : P.context, Y = !!P.multiArgs, ie = L(z, Q, Y);
      return a.copyDescriptors(z, ie, E), ie;
    }, t.promisifyAll = function(z, P) {
      if (typeof z != "function" && typeof z != "object")
        throw new u(`the target of promisifyAll must be an object or a function

    See http://goo.gl/MqrFmX
`);
      P = Object(P);
      var Q = !!P.multiArgs, Y = P.suffix;
      typeof Y != "string" && (Y = d);
      var ie = P.filter;
      typeof ie != "function" && (ie = x);
      var te = P.promisifier;
      if (typeof te != "function" && (te = k), !a.isIdentifier(Y))
        throw new RangeError(`suffix must be a valid identifier

    See http://goo.gl/MqrFmX
`);
      for (var Z = a.inheritedDataKeys(z), ae = 0; ae < Z.length; ++ae) {
        var G = z[Z[ae]];
        Z[ae] !== "constructor" && a.isClass(G) && (W(
          G.prototype,
          Y,
          ie,
          te,
          Q
        ), W(G, Y, ie, te, Q));
      }
      return W(z, Y, ie, te, Q);
    };
  }), promisify;
}
var props, hasRequiredProps;
function requireProps() {
  return hasRequiredProps || (hasRequiredProps = 1, props = function(t, e, n, a) {
    var s = requireUtil(), o = s.isObject, l = requireEs5(), c;
    typeof Map == "function" && (c = Map);
    var u = /* @__PURE__ */ function() {
      var g = 0, x = 0;
      function E(m, v) {
        this[g] = m, this[g + x] = v, g++;
      }
      return function(v) {
        x = v.size, g = 0;
        var y = new Array(v.size * 2);
        return v.forEach(E, y), y;
      };
    }(), d = function(g) {
      for (var x = new c(), E = g.length / 2 | 0, m = 0; m < E; ++m) {
        var v = g[E + m], y = g[m];
        x.set(v, y);
      }
      return x;
    };
    function f(g) {
      var x = !1, E;
      if (c !== void 0 && g instanceof c)
        E = u(g), x = !0;
      else {
        var m = l.keys(g), v = m.length;
        E = new Array(v * 2);
        for (var y = 0; y < v; ++y) {
          var A = m[y];
          E[y] = g[A], E[y + v] = A;
        }
      }
      this.constructor$(E), this._isMap = x, this._init$(void 0, -3);
    }
    s.inherits(f, e), f.prototype._init = function() {
    }, f.prototype._promiseFulfilled = function(g, x) {
      this._values[x] = g;
      var E = ++this._totalResolved;
      if (E >= this._length) {
        var m;
        if (this._isMap)
          m = d(this._values);
        else {
          m = {};
          for (var v = this.length(), y = 0, A = this.length(); y < A; ++y)
            m[this._values[y + v]] = this._values[y];
        }
        return this._resolve(m), !0;
      }
      return !1;
    }, f.prototype.shouldCopyValues = function() {
      return !1;
    }, f.prototype.getActualLength = function(g) {
      return g >> 1;
    };
    function h(g) {
      var x, E = n(g);
      if (o(E))
        E instanceof t ? x = E._then(
          t.props,
          void 0,
          void 0,
          void 0,
          void 0
        ) : x = new f(E).promise();
      else
        return a(`cannot await properties of a non-object

    See http://goo.gl/MqrFmX
`);
      return E instanceof t && x._propagateFrom(E, 2), x;
    }
    t.prototype.props = function() {
      return h(this);
    }, t.props = function(g) {
      return h(g);
    };
  }), props;
}
var race, hasRequiredRace;
function requireRace() {
  return hasRequiredRace || (hasRequiredRace = 1, race = function(t, e, n, a) {
    var s = requireUtil(), o = function(c) {
      return c.then(function(u) {
        return l(u, c);
      });
    };
    function l(c, u) {
      var d = n(c);
      if (d instanceof t)
        return o(d);
      if (c = s.asArray(c), c === null)
        return a("expecting an array or an iterable object but got " + s.classString(c));
      var f = new t(e);
      u !== void 0 && f._propagateFrom(u, 3);
      for (var h = f._fulfill, g = f._reject, x = 0, E = c.length; x < E; ++x) {
        var m = c[x];
        m === void 0 && !(x in c) || t.cast(m)._then(h, g, void 0, f, null);
      }
      return f;
    }
    t.race = function(c) {
      return l(c, void 0);
    }, t.prototype.race = function() {
      return l(this, void 0);
    };
  }), race;
}
var reduce, hasRequiredReduce;
function requireReduce() {
  return hasRequiredReduce || (hasRequiredReduce = 1, reduce = function(t, e, n, a, s, o) {
    var l = t._getDomain, c = requireUtil(), u = c.tryCatch;
    function d(E, m, v, y) {
      this.constructor$(E);
      var A = l();
      this._fn = A === null ? m : c.domainBind(A, m), v !== void 0 && (v = t.resolve(v), v._attachCancellationCallback(this)), this._initialValue = v, this._currentCancellable = null, y === s ? this._eachValues = Array(this._length) : y === 0 ? this._eachValues = null : this._eachValues = void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
    }
    c.inherits(d, e), d.prototype._gotAccum = function(E) {
      this._eachValues !== void 0 && this._eachValues !== null && E !== s && this._eachValues.push(E);
    }, d.prototype._eachComplete = function(E) {
      return this._eachValues !== null && this._eachValues.push(E), this._eachValues;
    }, d.prototype._init = function() {
    }, d.prototype._resolveEmptyArray = function() {
      this._resolve(this._eachValues !== void 0 ? this._eachValues : this._initialValue);
    }, d.prototype.shouldCopyValues = function() {
      return !1;
    }, d.prototype._resolve = function(E) {
      this._promise._resolveCallback(E), this._values = null;
    }, d.prototype._resultCancelled = function(E) {
      if (E === this._initialValue)
        return this._cancel();
      this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof t && this._currentCancellable.cancel(), this._initialValue instanceof t && this._initialValue.cancel());
    }, d.prototype._iterate = function(E) {
      this._values = E;
      var m, v, y = E.length;
      if (this._initialValue !== void 0 ? (m = this._initialValue, v = 0) : (m = t.resolve(E[0]), v = 1), this._currentCancellable = m, !m.isRejected())
        for (; v < y; ++v) {
          var A = {
            accum: null,
            value: E[v],
            index: v,
            length: y,
            array: this
          };
          m = m._then(g, void 0, void 0, A, void 0);
        }
      this._eachValues !== void 0 && (m = m._then(this._eachComplete, void 0, void 0, this, void 0)), m._then(f, f, void 0, m, this);
    }, t.prototype.reduce = function(E, m) {
      return h(this, E, m, null);
    }, t.reduce = function(E, m, v, y) {
      return h(E, m, v, y);
    };
    function f(E, m) {
      this.isFulfilled() ? m._resolve(E) : m._reject(E);
    }
    function h(E, m, v, y) {
      if (typeof m != "function")
        return n("expecting a function but got " + c.classString(m));
      var A = new d(E, m, v, y);
      return A.promise();
    }
    function g(E) {
      this.accum = E, this.array._gotAccum(E);
      var m = a(this.value, this.array._promise);
      return m instanceof t ? (this.array._currentCancellable = m, m._then(x, void 0, void 0, this, void 0)) : x.call(this, m);
    }
    function x(E) {
      var m = this.array, v = m._promise, y = u(m._fn);
      v._pushContext();
      var A;
      m._eachValues !== void 0 ? A = y.call(v._boundValue(), E, this.index, this.length) : A = y.call(
        v._boundValue(),
        this.accum,
        E,
        this.index,
        this.length
      ), A instanceof t && (m._currentCancellable = A);
      var b = v._popContext();
      return o.checkForgottenReturns(
        A,
        b,
        m._eachValues !== void 0 ? "Promise.each" : "Promise.reduce",
        v
      ), A;
    }
  }), reduce;
}
var settle, hasRequiredSettle;
function requireSettle() {
  return hasRequiredSettle || (hasRequiredSettle = 1, settle = function(t, e, n) {
    var a = t.PromiseInspection, s = requireUtil();
    function o(l) {
      this.constructor$(l);
    }
    s.inherits(o, e), o.prototype._promiseResolved = function(l, c) {
      this._values[l] = c;
      var u = ++this._totalResolved;
      return u >= this._length ? (this._resolve(this._values), !0) : !1;
    }, o.prototype._promiseFulfilled = function(l, c) {
      var u = new a();
      return u._bitField = 33554432, u._settledValueField = l, this._promiseResolved(c, u);
    }, o.prototype._promiseRejected = function(l, c) {
      var u = new a();
      return u._bitField = 16777216, u._settledValueField = l, this._promiseResolved(c, u);
    }, t.settle = function(l) {
      return n.deprecated(".settle()", ".reflect()"), new o(l).promise();
    }, t.prototype.settle = function() {
      return t.settle(this);
    };
  }), settle;
}
var some, hasRequiredSome;
function requireSome() {
  return hasRequiredSome || (hasRequiredSome = 1, some = function(t, e, n) {
    var a = requireUtil(), s = requireErrors().RangeError, o = requireErrors().AggregateError, l = a.isArray, c = {};
    function u(f) {
      this.constructor$(f), this._howMany = 0, this._unwrap = !1, this._initialized = !1;
    }
    a.inherits(u, e), u.prototype._init = function() {
      if (this._initialized) {
        if (this._howMany === 0) {
          this._resolve([]);
          return;
        }
        this._init$(void 0, -5);
        var f = l(this._values);
        !this._isResolved() && f && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
      }
    }, u.prototype.init = function() {
      this._initialized = !0, this._init();
    }, u.prototype.setUnwrap = function() {
      this._unwrap = !0;
    }, u.prototype.howMany = function() {
      return this._howMany;
    }, u.prototype.setHowMany = function(f) {
      this._howMany = f;
    }, u.prototype._promiseFulfilled = function(f) {
      return this._addFulfilled(f), this._fulfilled() === this.howMany() ? (this._values.length = this.howMany(), this.howMany() === 1 && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0) : !1;
    }, u.prototype._promiseRejected = function(f) {
      return this._addRejected(f), this._checkOutcome();
    }, u.prototype._promiseCancelled = function() {
      return this._values instanceof t || this._values == null ? this._cancel() : (this._addRejected(c), this._checkOutcome());
    }, u.prototype._checkOutcome = function() {
      if (this.howMany() > this._canPossiblyFulfill()) {
        for (var f = new o(), h = this.length(); h < this._values.length; ++h)
          this._values[h] !== c && f.push(this._values[h]);
        return f.length > 0 ? this._reject(f) : this._cancel(), !0;
      }
      return !1;
    }, u.prototype._fulfilled = function() {
      return this._totalResolved;
    }, u.prototype._rejected = function() {
      return this._values.length - this.length();
    }, u.prototype._addRejected = function(f) {
      this._values.push(f);
    }, u.prototype._addFulfilled = function(f) {
      this._values[this._totalResolved++] = f;
    }, u.prototype._canPossiblyFulfill = function() {
      return this.length() - this._rejected();
    }, u.prototype._getRangeError = function(f) {
      var h = "Input array must contain at least " + this._howMany + " items but contains only " + f + " items";
      return new s(h);
    }, u.prototype._resolveEmptyArray = function() {
      this._reject(this._getRangeError(0));
    };
    function d(f, h) {
      if ((h | 0) !== h || h < 0)
        return n(`expecting a positive integer

    See http://goo.gl/MqrFmX
`);
      var g = new u(f), x = g.promise();
      return g.setHowMany(h), g.init(), x;
    }
    t.some = function(f, h) {
      return d(f, h);
    }, t.prototype.some = function(f) {
      return d(this, f);
    }, t._SomePromiseArray = u;
  }), some;
}
var filter, hasRequiredFilter;
function requireFilter() {
  return hasRequiredFilter || (hasRequiredFilter = 1, filter = function(t, e) {
    var n = t.map;
    t.prototype.filter = function(a, s) {
      return n(this, a, s, e);
    }, t.filter = function(a, s, o) {
      return n(a, s, o, e);
    };
  }), filter;
}
var each, hasRequiredEach;
function requireEach() {
  return hasRequiredEach || (hasRequiredEach = 1, each = function(t, e) {
    var n = t.reduce, a = t.all;
    function s() {
      return a(this);
    }
    function o(l, c) {
      return n(l, c, e, e);
    }
    t.prototype.each = function(l) {
      return n(this, l, e, 0)._then(s, void 0, void 0, this, void 0);
    }, t.prototype.mapSeries = function(l) {
      return n(this, l, e, e);
    }, t.each = function(l, c) {
      return n(l, c, e, 0)._then(s, void 0, void 0, l, void 0);
    }, t.mapSeries = o;
  }), each;
}
var any, hasRequiredAny;
function requireAny() {
  return hasRequiredAny || (hasRequiredAny = 1, any = function(t) {
    var e = t._SomePromiseArray;
    function n(a) {
      var s = new e(a), o = s.promise();
      return s.setHowMany(1), s.setUnwrap(), s.init(), o;
    }
    t.any = function(a) {
      return n(a);
    }, t.prototype.any = function() {
      return n(this);
    };
  }), any;
}
(function(t) {
  t.exports = function() {
    var e = function() {
      return new g(`circular promise resolution chain

    See http://goo.gl/MqrFmX
`);
    }, n = function() {
      return new L.PromiseInspection(this._target());
    }, a = function(Y) {
      return L.reject(new g(Y));
    };
    function s() {
    }
    var o = {}, l = requireUtil(), c;
    l.isNode ? c = function() {
      var Y = process.domain;
      return Y === void 0 && (Y = null), Y;
    } : c = function() {
      return null;
    }, l.notEnumerableProp(L, "_getDomain", c);
    var u = requireEs5(), d = requireAsync(), f = new d();
    u.defineProperty(L, "_async", { value: f });
    var h = requireErrors(), g = L.TypeError = h.TypeError;
    L.RangeError = h.RangeError;
    var x = L.CancellationError = h.CancellationError;
    L.TimeoutError = h.TimeoutError, L.OperationalError = h.OperationalError, L.RejectionError = h.OperationalError, L.AggregateError = h.AggregateError;
    var E = function() {
    }, m = {}, v = {}, y = requireThenables()(L, E), A = requirePromise_array()(
      L,
      E,
      y,
      a,
      s
    ), b = requireContext()(L), C = b.create, T = requireDebuggability()(L, b);
    T.CapturedTrace;
    var w = require_finally()(L, y), R = requireCatch_filter()(v), O = requireNodeback(), D = l.errorObj, k = l.tryCatch;
    function W(Y, ie) {
      if (typeof ie != "function")
        throw new g("expecting a function but got " + l.classString(ie));
      if (Y.constructor !== L)
        throw new g(`the promise constructor cannot be invoked directly

    See http://goo.gl/MqrFmX
`);
    }
    function L(Y) {
      this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, Y !== E && (W(this, Y), this._resolveFromExecutor(Y)), this._promiseCreated(), this._fireEvent("promiseCreated", this);
    }
    L.prototype.toString = function() {
      return "[object Promise]";
    }, L.prototype.caught = L.prototype.catch = function(Y) {
      var ie = arguments.length;
      if (ie > 1) {
        var te = new Array(ie - 1), Z = 0, ae;
        for (ae = 0; ae < ie - 1; ++ae) {
          var G = arguments[ae];
          if (l.isObject(G))
            te[Z++] = G;
          else
            return a("expecting an object but got A catch statement predicate " + l.classString(G));
        }
        return te.length = Z, Y = arguments[ae], this.then(void 0, R(te, Y, this));
      }
      return this.then(void 0, Y);
    }, L.prototype.reflect = function() {
      return this._then(
        n,
        n,
        void 0,
        this,
        void 0
      );
    }, L.prototype.then = function(Y, ie) {
      if (T.warnings() && arguments.length > 0 && typeof Y != "function" && typeof ie != "function") {
        var te = ".then() only accepts functions but was passed: " + l.classString(Y);
        arguments.length > 1 && (te += ", " + l.classString(ie)), this._warn(te);
      }
      return this._then(Y, ie, void 0, void 0, void 0);
    }, L.prototype.done = function(Y, ie) {
      var te = this._then(Y, ie, void 0, void 0, void 0);
      te._setIsFinal();
    }, L.prototype.spread = function(Y) {
      return typeof Y != "function" ? a("expecting a function but got " + l.classString(Y)) : this.all()._then(Y, void 0, void 0, m, void 0);
    }, L.prototype.toJSON = function() {
      var Y = {
        isFulfilled: !1,
        isRejected: !1,
        fulfillmentValue: void 0,
        rejectionReason: void 0
      };
      return this.isFulfilled() ? (Y.fulfillmentValue = this.value(), Y.isFulfilled = !0) : this.isRejected() && (Y.rejectionReason = this.reason(), Y.isRejected = !0), Y;
    }, L.prototype.all = function() {
      return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new A(this).promise();
    }, L.prototype.error = function(Y) {
      return this.caught(l.originatesFromRejection, Y);
    }, L.getNewLibraryCopy = t.exports, L.is = function(Y) {
      return Y instanceof L;
    }, L.fromNode = L.fromCallback = function(Y) {
      var ie = new L(E);
      ie._captureStackTrace();
      var te = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : !1, Z = k(Y)(O(ie, te));
      return Z === D && ie._rejectCallback(Z.e, !0), ie._isFateSealed() || ie._setAsyncGuaranteed(), ie;
    }, L.all = function(Y) {
      return new A(Y).promise();
    }, L.cast = function(Y) {
      var ie = y(Y);
      return ie instanceof L || (ie = new L(E), ie._captureStackTrace(), ie._setFulfilled(), ie._rejectionHandler0 = Y), ie;
    }, L.resolve = L.fulfilled = L.cast, L.reject = L.rejected = function(Y) {
      var ie = new L(E);
      return ie._captureStackTrace(), ie._rejectCallback(Y, !0), ie;
    }, L.setScheduler = function(Y) {
      if (typeof Y != "function")
        throw new g("expecting a function but got " + l.classString(Y));
      return f.setScheduler(Y);
    }, L.prototype._then = function(Y, ie, te, Z, ae) {
      var G = ae !== void 0, U = G ? ae : new L(E), F = this._target(), M = F._bitField;
      G || (U._propagateFrom(this, 3), U._captureStackTrace(), Z === void 0 && this._bitField & 2097152 && (M & 50397184 ? Z = this._boundValue() : Z = F === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, U));
      var I = c();
      if (M & 50397184) {
        var N, V, q = F._settlePromiseCtx;
        M & 33554432 ? (V = F._rejectionHandler0, N = Y) : M & 16777216 ? (V = F._fulfillmentHandler0, N = ie, F._unsetRejectionIsUnhandled()) : (q = F._settlePromiseLateCancellationObserver, V = new x("late cancellation observer"), F._attachExtraTrace(V), N = ie), f.invoke(q, F, {
          handler: I === null ? N : typeof N == "function" && l.domainBind(I, N),
          promise: U,
          receiver: Z,
          value: V
        });
      } else
        F._addCallbacks(Y, ie, U, Z, I);
      return U;
    }, L.prototype._length = function() {
      return this._bitField & 65535;
    }, L.prototype._isFateSealed = function() {
      return (this._bitField & 117506048) !== 0;
    }, L.prototype._isFollowing = function() {
      return (this._bitField & 67108864) === 67108864;
    }, L.prototype._setLength = function(Y) {
      this._bitField = this._bitField & -65536 | Y & 65535;
    }, L.prototype._setFulfilled = function() {
      this._bitField = this._bitField | 33554432, this._fireEvent("promiseFulfilled", this);
    }, L.prototype._setRejected = function() {
      this._bitField = this._bitField | 16777216, this._fireEvent("promiseRejected", this);
    }, L.prototype._setFollowing = function() {
      this._bitField = this._bitField | 67108864, this._fireEvent("promiseResolved", this);
    }, L.prototype._setIsFinal = function() {
      this._bitField = this._bitField | 4194304;
    }, L.prototype._isFinal = function() {
      return (this._bitField & 4194304) > 0;
    }, L.prototype._unsetCancelled = function() {
      this._bitField = this._bitField & -65537;
    }, L.prototype._setCancelled = function() {
      this._bitField = this._bitField | 65536, this._fireEvent("promiseCancelled", this);
    }, L.prototype._setWillBeCancelled = function() {
      this._bitField = this._bitField | 8388608;
    }, L.prototype._setAsyncGuaranteed = function() {
      f.hasCustomScheduler() || (this._bitField = this._bitField | 134217728);
    }, L.prototype._receiverAt = function(Y) {
      var ie = Y === 0 ? this._receiver0 : this[Y * 4 - 4 + 3];
      if (ie !== o)
        return ie === void 0 && this._isBound() ? this._boundValue() : ie;
    }, L.prototype._promiseAt = function(Y) {
      return this[Y * 4 - 4 + 2];
    }, L.prototype._fulfillmentHandlerAt = function(Y) {
      return this[Y * 4 - 4 + 0];
    }, L.prototype._rejectionHandlerAt = function(Y) {
      return this[Y * 4 - 4 + 1];
    }, L.prototype._boundValue = function() {
    }, L.prototype._migrateCallback0 = function(Y) {
      Y._bitField;
      var ie = Y._fulfillmentHandler0, te = Y._rejectionHandler0, Z = Y._promise0, ae = Y._receiverAt(0);
      ae === void 0 && (ae = o), this._addCallbacks(ie, te, Z, ae, null);
    }, L.prototype._migrateCallbackAt = function(Y, ie) {
      var te = Y._fulfillmentHandlerAt(ie), Z = Y._rejectionHandlerAt(ie), ae = Y._promiseAt(ie), G = Y._receiverAt(ie);
      G === void 0 && (G = o), this._addCallbacks(te, Z, ae, G, null);
    }, L.prototype._addCallbacks = function(Y, ie, te, Z, ae) {
      var G = this._length();
      if (G >= 65531 && (G = 0, this._setLength(0)), G === 0)
        this._promise0 = te, this._receiver0 = Z, typeof Y == "function" && (this._fulfillmentHandler0 = ae === null ? Y : l.domainBind(ae, Y)), typeof ie == "function" && (this._rejectionHandler0 = ae === null ? ie : l.domainBind(ae, ie));
      else {
        var U = G * 4 - 4;
        this[U + 2] = te, this[U + 3] = Z, typeof Y == "function" && (this[U + 0] = ae === null ? Y : l.domainBind(ae, Y)), typeof ie == "function" && (this[U + 1] = ae === null ? ie : l.domainBind(ae, ie));
      }
      return this._setLength(G + 1), G;
    }, L.prototype._proxy = function(Y, ie) {
      this._addCallbacks(void 0, void 0, ie, Y, null);
    }, L.prototype._resolveCallback = function(Y, ie) {
      if (!(this._bitField & 117506048)) {
        if (Y === this)
          return this._rejectCallback(e(), !1);
        var te = y(Y, this);
        if (!(te instanceof L))
          return this._fulfill(Y);
        ie && this._propagateFrom(te, 2);
        var Z = te._target();
        if (Z === this) {
          this._reject(e());
          return;
        }
        var ae = Z._bitField;
        if (ae & 50397184)
          if (ae & 33554432)
            this._fulfill(Z._value());
          else if (ae & 16777216)
            this._reject(Z._reason());
          else {
            var F = new x("late cancellation observer");
            Z._attachExtraTrace(F), this._reject(F);
          }
        else {
          var G = this._length();
          G > 0 && Z._migrateCallback0(this);
          for (var U = 1; U < G; ++U)
            Z._migrateCallbackAt(this, U);
          this._setFollowing(), this._setLength(0), this._setFollowee(Z);
        }
      }
    }, L.prototype._rejectCallback = function(Y, ie, te) {
      var Z = l.ensureErrorObject(Y), ae = Z === Y;
      if (!ae && !te && T.warnings()) {
        var G = "a promise was rejected with a non-error: " + l.classString(Y);
        this._warn(G, !0);
      }
      this._attachExtraTrace(Z, ie ? ae : !1), this._reject(Y);
    }, L.prototype._resolveFromExecutor = function(Y) {
      var ie = this;
      this._captureStackTrace(), this._pushContext();
      var te = !0, Z = this._execute(Y, function(ae) {
        ie._resolveCallback(ae);
      }, function(ae) {
        ie._rejectCallback(ae, te);
      });
      te = !1, this._popContext(), Z !== void 0 && ie._rejectCallback(Z, !0);
    }, L.prototype._settlePromiseFromHandler = function(Y, ie, te, Z) {
      var ae = Z._bitField;
      if (!(ae & 65536)) {
        Z._pushContext();
        var G;
        ie === m ? !te || typeof te.length != "number" ? (G = D, G.e = new g("cannot .spread() a non-array: " + l.classString(te))) : G = k(Y).apply(this._boundValue(), te) : G = k(Y).call(ie, te);
        var U = Z._popContext();
        ae = Z._bitField, !(ae & 65536) && (G === v ? Z._reject(te) : G === D ? Z._rejectCallback(G.e, !1) : (T.checkForgottenReturns(G, U, "", Z, this), Z._resolveCallback(G)));
      }
    }, L.prototype._target = function() {
      for (var Y = this; Y._isFollowing(); )
        Y = Y._followee();
      return Y;
    }, L.prototype._followee = function() {
      return this._rejectionHandler0;
    }, L.prototype._setFollowee = function(Y) {
      this._rejectionHandler0 = Y;
    }, L.prototype._settlePromise = function(Y, ie, te, Z) {
      var ae = Y instanceof L, G = this._bitField, U = (G & 134217728) !== 0;
      G & 65536 ? (ae && Y._invokeInternalOnCancel(), te instanceof w && te.isFinallyHandler() ? (te.cancelPromise = Y, k(ie).call(te, Z) === D && Y._reject(D.e)) : ie === n ? Y._fulfill(n.call(te)) : te instanceof s ? te._promiseCancelled(Y) : ae || Y instanceof A ? Y._cancel() : te.cancel()) : typeof ie == "function" ? ae ? (U && Y._setAsyncGuaranteed(), this._settlePromiseFromHandler(ie, te, Z, Y)) : ie.call(te, Z, Y) : te instanceof s ? te._isResolved() || (G & 33554432 ? te._promiseFulfilled(Z, Y) : te._promiseRejected(Z, Y)) : ae && (U && Y._setAsyncGuaranteed(), G & 33554432 ? Y._fulfill(Z) : Y._reject(Z));
    }, L.prototype._settlePromiseLateCancellationObserver = function(Y) {
      var ie = Y.handler, te = Y.promise, Z = Y.receiver, ae = Y.value;
      typeof ie == "function" ? te instanceof L ? this._settlePromiseFromHandler(ie, Z, ae, te) : ie.call(Z, ae, te) : te instanceof L && te._reject(ae);
    }, L.prototype._settlePromiseCtx = function(Y) {
      this._settlePromise(Y.promise, Y.handler, Y.receiver, Y.value);
    }, L.prototype._settlePromise0 = function(Y, ie, te) {
      var Z = this._promise0, ae = this._receiverAt(0);
      this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(Z, Y, ae, ie);
    }, L.prototype._clearCallbackDataAtIndex = function(Y) {
      var ie = Y * 4 - 4;
      this[ie + 2] = this[ie + 3] = this[ie + 0] = this[ie + 1] = void 0;
    }, L.prototype._fulfill = function(Y) {
      var ie = this._bitField;
      if (!((ie & 117506048) >>> 16)) {
        if (Y === this) {
          var te = e();
          return this._attachExtraTrace(te), this._reject(te);
        }
        this._setFulfilled(), this._rejectionHandler0 = Y, (ie & 65535) > 0 && (ie & 134217728 ? this._settlePromises() : f.settlePromises(this));
      }
    }, L.prototype._reject = function(Y) {
      var ie = this._bitField;
      if (!((ie & 117506048) >>> 16)) {
        if (this._setRejected(), this._fulfillmentHandler0 = Y, this._isFinal())
          return f.fatalError(Y, l.isNode);
        (ie & 65535) > 0 ? f.settlePromises(this) : this._ensurePossibleRejectionHandled();
      }
    }, L.prototype._fulfillPromises = function(Y, ie) {
      for (var te = 1; te < Y; te++) {
        var Z = this._fulfillmentHandlerAt(te), ae = this._promiseAt(te), G = this._receiverAt(te);
        this._clearCallbackDataAtIndex(te), this._settlePromise(ae, Z, G, ie);
      }
    }, L.prototype._rejectPromises = function(Y, ie) {
      for (var te = 1; te < Y; te++) {
        var Z = this._rejectionHandlerAt(te), ae = this._promiseAt(te), G = this._receiverAt(te);
        this._clearCallbackDataAtIndex(te), this._settlePromise(ae, Z, G, ie);
      }
    }, L.prototype._settlePromises = function() {
      var Y = this._bitField, ie = Y & 65535;
      if (ie > 0) {
        if (Y & 16842752) {
          var te = this._fulfillmentHandler0;
          this._settlePromise0(this._rejectionHandler0, te, Y), this._rejectPromises(ie, te);
        } else {
          var Z = this._rejectionHandler0;
          this._settlePromise0(this._fulfillmentHandler0, Z, Y), this._fulfillPromises(ie, Z);
        }
        this._setLength(0);
      }
      this._clearCancellationData();
    }, L.prototype._settledValue = function() {
      var Y = this._bitField;
      if (Y & 33554432)
        return this._rejectionHandler0;
      if (Y & 16777216)
        return this._fulfillmentHandler0;
    };
    function z(Y) {
      this.promise._resolveCallback(Y);
    }
    function P(Y) {
      this.promise._rejectCallback(Y, !1);
    }
    L.defer = L.pending = function() {
      T.deprecated("Promise.defer", "new Promise");
      var Y = new L(E);
      return {
        promise: Y,
        resolve: z,
        reject: P
      };
    }, l.notEnumerableProp(
      L,
      "_makeSelfResolutionError",
      e
    ), requireMethod()(
      L,
      E,
      y,
      a,
      T
    ), requireBind()(L, E, y, T), requireCancel()(L, A, a, T), requireDirect_resolve()(L), requireSynchronous_inspection()(L), requireJoin()(
      L,
      A,
      y,
      E,
      f,
      c
    ), L.Promise = L, L.version = "3.4.7", requireMap()(L, A, a, y, E, T), requireCall_get()(L), requireUsing()(L, a, y, C, E, T), requireTimers()(L, E, T), requireGenerators()(L, a, E, y, s, T), requireNodeify()(L), requirePromisify()(L, E), requireProps()(L, A, y, a), requireRace()(L, E, y, a), requireReduce()(L, A, a, y, E, T), requireSettle()(L, A, T), requireSome()(L, A, a), requireFilter()(L, E), requireEach()(L, E), requireAny()(L), l.toFastProperties(L), l.toFastProperties(L.prototype);
    function Q(Y) {
      var ie = new L(E);
      ie._fulfillmentHandler0 = Y, ie._rejectionHandler0 = Y, ie._promise0 = Y, ie._receiver0 = Y;
    }
    return Q({ a: 1 }), Q({ b: 2 }), Q({ c: 3 }), Q(1), Q(function() {
    }), Q(void 0), Q(!1), Q(new L(E)), T.setBounds(d.firstLineError, l.lastLineError), L;
  };
})(promise);
var promiseExports = promise.exports, _$g = require$$0, bluebird = promiseExports();
promises$7.defer = defer;
promises$7.when = bluebird.resolve;
promises$7.resolve = bluebird.resolve;
promises$7.all = bluebird.all;
promises$7.props = bluebird.props;
promises$7.reject = bluebird.reject;
promises$7.promisify = bluebird.promisify;
promises$7.mapSeries = bluebird.mapSeries;
promises$7.attempt = bluebird.attempt;
promises$7.nfcall = function(t) {
  var e = Array.prototype.slice.call(arguments, 1), n = bluebird.promisify(t);
  return n.apply(null, e);
};
bluebird.prototype.fail = bluebird.prototype.caught;
bluebird.prototype.also = function(t) {
  return this.then(function(e) {
    var n = _$g.extend({}, e, t(e));
    return bluebird.props(n);
  });
};
function defer() {
  var t, e, n = new bluebird.Promise(function(a, s) {
    t = a, e = s;
  });
  return {
    resolve: t,
    reject: e,
    promise: n
  };
}
var documents$7 = {}, _$f = require$$0, types = documents$7.types = {
  document: "document",
  paragraph: "paragraph",
  run: "run",
  text: "text",
  tab: "tab",
  hyperlink: "hyperlink",
  noteReference: "noteReference",
  image: "image",
  note: "note",
  commentReference: "commentReference",
  comment: "comment",
  table: "table",
  tableRow: "tableRow",
  tableCell: "tableCell",
  break: "break",
  bookmarkStart: "bookmarkStart"
};
function Document$1(t, e) {
  return e = e || {}, {
    type: types.document,
    children: t,
    notes: e.notes || new Notes({}),
    comments: e.comments || []
  };
}
function Paragraph(t, e) {
  e = e || {};
  var n = e.indent || {};
  return {
    type: types.paragraph,
    children: t,
    styleId: e.styleId || null,
    styleName: e.styleName || null,
    numbering: e.numbering || null,
    alignment: e.alignment || null,
    indent: {
      start: n.start || null,
      end: n.end || null,
      firstLine: n.firstLine || null,
      hanging: n.hanging || null
    }
  };
}
function Run(t, e) {
  return e = e || {}, {
    type: types.run,
    children: t,
    styleId: e.styleId || null,
    styleName: e.styleName || null,
    isBold: !!e.isBold,
    isUnderline: !!e.isUnderline,
    isItalic: !!e.isItalic,
    isStrikethrough: !!e.isStrikethrough,
    isAllCaps: !!e.isAllCaps,
    isSmallCaps: !!e.isSmallCaps,
    verticalAlignment: e.verticalAlignment || verticalAlignment.baseline,
    font: e.font || null,
    fontSize: e.fontSize || null
  };
}
var verticalAlignment = {
  baseline: "baseline",
  superscript: "superscript",
  subscript: "subscript"
};
function Text$1(t) {
  return {
    type: types.text,
    value: t
  };
}
function Tab() {
  return {
    type: types.tab
  };
}
function Hyperlink(t, e) {
  return {
    type: types.hyperlink,
    children: t,
    href: e.href,
    anchor: e.anchor,
    targetFrame: e.targetFrame
  };
}
function NoteReference(t) {
  return {
    type: types.noteReference,
    noteType: t.noteType,
    noteId: t.noteId
  };
}
function Notes(t) {
  this._notes = _$f.indexBy(t, function(e) {
    return noteKey(e.noteType, e.noteId);
  });
}
Notes.prototype.resolve = function(t) {
  return this.findNoteByKey(noteKey(t.noteType, t.noteId));
};
Notes.prototype.findNoteByKey = function(t) {
  return this._notes[t] || null;
};
function Note(t) {
  return {
    type: types.note,
    noteType: t.noteType,
    noteId: t.noteId,
    body: t.body
  };
}
function commentReference(t) {
  return {
    type: types.commentReference,
    commentId: t.commentId
  };
}
function comment(t) {
  return {
    type: types.comment,
    commentId: t.commentId,
    body: t.body,
    authorName: t.authorName,
    authorInitials: t.authorInitials
  };
}
function noteKey(t, e) {
  return t + "-" + e;
}
function Image$1(t) {
  return {
    type: types.image,
    // `read` is retained for backwards compatibility, but other read
    // methods should be preferred.
    read: function(e) {
      return e ? t.readImage(e) : t.readImage().then(function(n) {
        return Buffer.from(n);
      });
    },
    readAsArrayBuffer: function() {
      return t.readImage();
    },
    readAsBase64String: function() {
      return t.readImage("base64");
    },
    readAsBuffer: function() {
      return t.readImage().then(function(e) {
        return Buffer.from(e);
      });
    },
    altText: t.altText,
    contentType: t.contentType
  };
}
function Table(t, e) {
  return e = e || {}, {
    type: types.table,
    children: t,
    styleId: e.styleId || null,
    styleName: e.styleName || null
  };
}
function TableRow(t, e) {
  return e = e || {}, {
    type: types.tableRow,
    children: t,
    isHeader: e.isHeader || !1
  };
}
function TableCell(t, e) {
  return e = e || {}, {
    type: types.tableCell,
    children: t,
    colSpan: e.colSpan == null ? 1 : e.colSpan,
    rowSpan: e.rowSpan == null ? 1 : e.rowSpan
  };
}
function Break(t) {
  return {
    type: types.break,
    breakType: t
  };
}
function BookmarkStart(t) {
  return {
    type: types.bookmarkStart,
    name: t.name
  };
}
documents$7.document = documents$7.Document = Document$1;
documents$7.paragraph = documents$7.Paragraph = Paragraph;
documents$7.run = documents$7.Run = Run;
documents$7.text = documents$7.Text = Text$1;
documents$7.tab = documents$7.Tab = Tab;
documents$7.Hyperlink = Hyperlink;
documents$7.noteReference = documents$7.NoteReference = NoteReference;
documents$7.Notes = Notes;
documents$7.Note = Note;
documents$7.commentReference = commentReference;
documents$7.comment = comment;
documents$7.Image = Image$1;
documents$7.Table = Table;
documents$7.TableRow = TableRow;
documents$7.TableCell = TableCell;
documents$7.lineBreak = Break("line");
documents$7.pageBreak = Break("page");
documents$7.columnBreak = Break("column");
documents$7.BookmarkStart = BookmarkStart;
documents$7.verticalAlignment = verticalAlignment;
var results$2 = {}, _$e = require$$0;
results$2.Result = Result$7;
results$2.success = success;
results$2.warning = warning$1;
results$2.error = error;
function Result$7(t, e) {
  this.value = t, this.messages = e || [];
}
Result$7.prototype.map = function(t) {
  return new Result$7(t(this.value), this.messages);
};
Result$7.prototype.flatMap = function(t) {
  var e = t(this.value);
  return new Result$7(e.value, combineMessages([this, e]));
};
Result$7.prototype.flatMapThen = function(t) {
  var e = this;
  return t(this.value).then(function(n) {
    return new Result$7(n.value, combineMessages([e, n]));
  });
};
Result$7.combine = function(t) {
  var e = _$e.flatten(_$e.pluck(t, "value")), n = combineMessages(t);
  return new Result$7(e, n);
};
function success(t) {
  return new Result$7(t, []);
}
function warning$1(t) {
  return {
    type: "warning",
    message: t
  };
}
function error(t) {
  return {
    type: "error",
    message: t.message,
    error: t
  };
}
function combineMessages(t) {
  var e = [];
  return _$e.flatten(_$e.pluck(t, "messages"), !0).forEach(function(n) {
    containsMessage(e, n) || e.push(n);
  }), e;
}
function containsMessage(t, e) {
  return _$e.find(t, isSameMessage.bind(null, e)) !== void 0;
}
function isSameMessage(t, e) {
  return t.type === e.type && t.message === e.message;
}
var zipfile$2 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i)
  lookup[i] = code[i], revLookup[code.charCodeAt(i)] = i;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = t.indexOf("=");
  n === -1 && (n = e);
  var a = n === e ? 0 : 4 - n % 4;
  return [n, a];
}
function byteLength(t) {
  var e = getLens(t), n = e[0], a = e[1];
  return (n + a) * 3 / 4 - a;
}
function _byteLength(t, e, n) {
  return (e + n) * 3 / 4 - n;
}
function toByteArray(t) {
  var e, n = getLens(t), a = n[0], s = n[1], o = new Arr(_byteLength(t, a, s)), l = 0, c = s > 0 ? a - 4 : a, u;
  for (u = 0; u < c; u += 4)
    e = revLookup[t.charCodeAt(u)] << 18 | revLookup[t.charCodeAt(u + 1)] << 12 | revLookup[t.charCodeAt(u + 2)] << 6 | revLookup[t.charCodeAt(u + 3)], o[l++] = e >> 16 & 255, o[l++] = e >> 8 & 255, o[l++] = e & 255;
  return s === 2 && (e = revLookup[t.charCodeAt(u)] << 2 | revLookup[t.charCodeAt(u + 1)] >> 4, o[l++] = e & 255), s === 1 && (e = revLookup[t.charCodeAt(u)] << 10 | revLookup[t.charCodeAt(u + 1)] << 4 | revLookup[t.charCodeAt(u + 2)] >> 2, o[l++] = e >> 8 & 255, o[l++] = e & 255), o;
}
function tripletToBase64(t) {
  return lookup[t >> 18 & 63] + lookup[t >> 12 & 63] + lookup[t >> 6 & 63] + lookup[t & 63];
}
function encodeChunk(t, e, n) {
  for (var a, s = [], o = e; o < n; o += 3)
    a = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (t[o + 2] & 255), s.push(tripletToBase64(a));
  return s.join("");
}
function fromByteArray(t) {
  for (var e, n = t.length, a = n % 3, s = [], o = 16383, l = 0, c = n - a; l < c; l += o)
    s.push(encodeChunk(t, l, l + o > c ? c : l + o));
  return a === 1 ? (e = t[n - 1], s.push(
    lookup[e >> 2] + lookup[e << 4 & 63] + "=="
  )) : a === 2 && (e = (t[n - 2] << 8) + t[n - 1], s.push(
    lookup[e >> 10] + lookup[e >> 4 & 63] + lookup[e << 2 & 63] + "="
  )), s.join("");
}
var jszip_min = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(t, e) {
  (function(n) {
    t.exports = n();
  })(function() {
    return function n(a, s, o) {
      function l(d, f) {
        if (!s[d]) {
          if (!a[d]) {
            var h = typeof commonjsRequire == "function" && commonjsRequire;
            if (!f && h)
              return h(d, !0);
            if (c)
              return c(d, !0);
            var g = new Error("Cannot find module '" + d + "'");
            throw g.code = "MODULE_NOT_FOUND", g;
          }
          var x = s[d] = { exports: {} };
          a[d][0].call(x.exports, function(E) {
            var m = a[d][1][E];
            return l(m || E);
          }, x, x.exports, n, a, s, o);
        }
        return s[d].exports;
      }
      for (var c = typeof commonjsRequire == "function" && commonjsRequire, u = 0; u < o.length; u++)
        l(o[u]);
      return l;
    }({ 1: [function(n, a, s) {
      var o = n("./utils"), l = n("./support"), c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      s.encode = function(u) {
        for (var d, f, h, g, x, E, m, v = [], y = 0, A = u.length, b = A, C = o.getTypeOf(u) !== "string"; y < u.length; )
          b = A - y, h = C ? (d = u[y++], f = y < A ? u[y++] : 0, y < A ? u[y++] : 0) : (d = u.charCodeAt(y++), f = y < A ? u.charCodeAt(y++) : 0, y < A ? u.charCodeAt(y++) : 0), g = d >> 2, x = (3 & d) << 4 | f >> 4, E = 1 < b ? (15 & f) << 2 | h >> 6 : 64, m = 2 < b ? 63 & h : 64, v.push(c.charAt(g) + c.charAt(x) + c.charAt(E) + c.charAt(m));
        return v.join("");
      }, s.decode = function(u) {
        var d, f, h, g, x, E, m = 0, v = 0, y = "data:";
        if (u.substr(0, y.length) === y)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var A, b = 3 * (u = u.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (u.charAt(u.length - 1) === c.charAt(64) && b--, u.charAt(u.length - 2) === c.charAt(64) && b--, b % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (A = l.uint8array ? new Uint8Array(0 | b) : new Array(0 | b); m < u.length; )
          d = c.indexOf(u.charAt(m++)) << 2 | (g = c.indexOf(u.charAt(m++))) >> 4, f = (15 & g) << 4 | (x = c.indexOf(u.charAt(m++))) >> 2, h = (3 & x) << 6 | (E = c.indexOf(u.charAt(m++))), A[v++] = d, x !== 64 && (A[v++] = f), E !== 64 && (A[v++] = h);
        return A;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(n, a, s) {
      var o = n("./external"), l = n("./stream/DataWorker"), c = n("./stream/Crc32Probe"), u = n("./stream/DataLengthProbe");
      function d(f, h, g, x, E) {
        this.compressedSize = f, this.uncompressedSize = h, this.crc32 = g, this.compression = x, this.compressedContent = E;
      }
      d.prototype = { getContentWorker: function() {
        var f = new l(o.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new u("data_length")), h = this;
        return f.on("end", function() {
          if (this.streamInfo.data_length !== h.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), f;
      }, getCompressedWorker: function() {
        return new l(o.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, d.createWorkerFrom = function(f, h, g) {
        return f.pipe(new c()).pipe(new u("uncompressedSize")).pipe(h.compressWorker(g)).pipe(new u("compressedSize")).withStreamInfo("compression", h);
      }, a.exports = d;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(n, a, s) {
      var o = n("./stream/GenericWorker");
      s.STORE = { magic: "\0\0", compressWorker: function() {
        return new o("STORE compression");
      }, uncompressWorker: function() {
        return new o("STORE decompression");
      } }, s.DEFLATE = n("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(n, a, s) {
      var o = n("./utils"), l = function() {
        for (var c, u = [], d = 0; d < 256; d++) {
          c = d;
          for (var f = 0; f < 8; f++)
            c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          u[d] = c;
        }
        return u;
      }();
      a.exports = function(c, u) {
        return c !== void 0 && c.length ? o.getTypeOf(c) !== "string" ? function(d, f, h, g) {
          var x = l, E = g + h;
          d ^= -1;
          for (var m = g; m < E; m++)
            d = d >>> 8 ^ x[255 & (d ^ f[m])];
          return -1 ^ d;
        }(0 | u, c, c.length, 0) : function(d, f, h, g) {
          var x = l, E = g + h;
          d ^= -1;
          for (var m = g; m < E; m++)
            d = d >>> 8 ^ x[255 & (d ^ f.charCodeAt(m))];
          return -1 ^ d;
        }(0 | u, c, c.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(n, a, s) {
      s.base64 = !1, s.binary = !1, s.dir = !1, s.createFolders = !0, s.date = null, s.compression = null, s.compressionOptions = null, s.comment = null, s.unixPermissions = null, s.dosPermissions = null;
    }, {}], 6: [function(n, a, s) {
      var o = null;
      o = typeof Promise < "u" ? Promise : n("lie"), a.exports = { Promise: o };
    }, { lie: 37 }], 7: [function(n, a, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", l = n("pako"), c = n("./utils"), u = n("./stream/GenericWorker"), d = o ? "uint8array" : "array";
      function f(h, g) {
        u.call(this, "FlateWorker/" + h), this._pako = null, this._pakoAction = h, this._pakoOptions = g, this.meta = {};
      }
      s.magic = "\b\0", c.inherits(f, u), f.prototype.processChunk = function(h) {
        this.meta = h.meta, this._pako === null && this._createPako(), this._pako.push(c.transformTo(d, h.data), !1);
      }, f.prototype.flush = function() {
        u.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, f.prototype.cleanUp = function() {
        u.prototype.cleanUp.call(this), this._pako = null;
      }, f.prototype._createPako = function() {
        this._pako = new l[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var h = this;
        this._pako.onData = function(g) {
          h.push({ data: g, meta: h.meta });
        };
      }, s.compressWorker = function(h) {
        return new f("Deflate", h);
      }, s.uncompressWorker = function() {
        return new f("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(n, a, s) {
      function o(x, E) {
        var m, v = "";
        for (m = 0; m < E; m++)
          v += String.fromCharCode(255 & x), x >>>= 8;
        return v;
      }
      function l(x, E, m, v, y, A) {
        var b, C, T = x.file, w = x.compression, R = A !== d.utf8encode, O = c.transformTo("string", A(T.name)), D = c.transformTo("string", d.utf8encode(T.name)), k = T.comment, W = c.transformTo("string", A(k)), L = c.transformTo("string", d.utf8encode(k)), z = D.length !== T.name.length, P = L.length !== k.length, Q = "", Y = "", ie = "", te = T.dir, Z = T.date, ae = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        E && !m || (ae.crc32 = x.crc32, ae.compressedSize = x.compressedSize, ae.uncompressedSize = x.uncompressedSize);
        var G = 0;
        E && (G |= 8), R || !z && !P || (G |= 2048);
        var U = 0, F = 0;
        te && (U |= 16), y === "UNIX" ? (F = 798, U |= function(I, N) {
          var V = I;
          return I || (V = N ? 16893 : 33204), (65535 & V) << 16;
        }(T.unixPermissions, te)) : (F = 20, U |= function(I) {
          return 63 & (I || 0);
        }(T.dosPermissions)), b = Z.getUTCHours(), b <<= 6, b |= Z.getUTCMinutes(), b <<= 5, b |= Z.getUTCSeconds() / 2, C = Z.getUTCFullYear() - 1980, C <<= 4, C |= Z.getUTCMonth() + 1, C <<= 5, C |= Z.getUTCDate(), z && (Y = o(1, 1) + o(f(O), 4) + D, Q += "up" + o(Y.length, 2) + Y), P && (ie = o(1, 1) + o(f(W), 4) + L, Q += "uc" + o(ie.length, 2) + ie);
        var M = "";
        return M += `
\0`, M += o(G, 2), M += w.magic, M += o(b, 2), M += o(C, 2), M += o(ae.crc32, 4), M += o(ae.compressedSize, 4), M += o(ae.uncompressedSize, 4), M += o(O.length, 2), M += o(Q.length, 2), { fileRecord: h.LOCAL_FILE_HEADER + M + O + Q, dirRecord: h.CENTRAL_FILE_HEADER + o(F, 2) + M + o(W.length, 2) + "\0\0\0\0" + o(U, 4) + o(v, 4) + O + Q + W };
      }
      var c = n("../utils"), u = n("../stream/GenericWorker"), d = n("../utf8"), f = n("../crc32"), h = n("../signature");
      function g(x, E, m, v) {
        u.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = E, this.zipPlatform = m, this.encodeFileName = v, this.streamFiles = x, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      c.inherits(g, u), g.prototype.push = function(x) {
        var E = x.meta.percent || 0, m = this.entriesCount, v = this._sources.length;
        this.accumulate ? this.contentBuffer.push(x) : (this.bytesWritten += x.data.length, u.prototype.push.call(this, { data: x.data, meta: { currentFile: this.currentFile, percent: m ? (E + 100 * (m - v - 1)) / m : 100 } }));
      }, g.prototype.openedSource = function(x) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = x.file.name;
        var E = this.streamFiles && !x.file.dir;
        if (E) {
          var m = l(x, E, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: m.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, g.prototype.closedSource = function(x) {
        this.accumulate = !1;
        var E = this.streamFiles && !x.file.dir, m = l(x, E, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(m.dirRecord), E)
          this.push({ data: function(v) {
            return h.DATA_DESCRIPTOR + o(v.crc32, 4) + o(v.compressedSize, 4) + o(v.uncompressedSize, 4);
          }(x), meta: { percent: 100 } });
        else
          for (this.push({ data: m.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, g.prototype.flush = function() {
        for (var x = this.bytesWritten, E = 0; E < this.dirRecords.length; E++)
          this.push({ data: this.dirRecords[E], meta: { percent: 100 } });
        var m = this.bytesWritten - x, v = function(y, A, b, C, T) {
          var w = c.transformTo("string", T(C));
          return h.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(y, 2) + o(y, 2) + o(A, 4) + o(b, 4) + o(w.length, 2) + w;
        }(this.dirRecords.length, m, x, this.zipComment, this.encodeFileName);
        this.push({ data: v, meta: { percent: 100 } });
      }, g.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, g.prototype.registerPrevious = function(x) {
        this._sources.push(x);
        var E = this;
        return x.on("data", function(m) {
          E.processChunk(m);
        }), x.on("end", function() {
          E.closedSource(E.previous.streamInfo), E._sources.length ? E.prepareNextSource() : E.end();
        }), x.on("error", function(m) {
          E.error(m);
        }), this;
      }, g.prototype.resume = function() {
        return !!u.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, g.prototype.error = function(x) {
        var E = this._sources;
        if (!u.prototype.error.call(this, x))
          return !1;
        for (var m = 0; m < E.length; m++)
          try {
            E[m].error(x);
          } catch {
          }
        return !0;
      }, g.prototype.lock = function() {
        u.prototype.lock.call(this);
        for (var x = this._sources, E = 0; E < x.length; E++)
          x[E].lock();
      }, a.exports = g;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(n, a, s) {
      var o = n("../compressions"), l = n("./ZipFileWorker");
      s.generateWorker = function(c, u, d) {
        var f = new l(u.streamFiles, d, u.platform, u.encodeFileName), h = 0;
        try {
          c.forEach(function(g, x) {
            h++;
            var E = function(A, b) {
              var C = A || b, T = o[C];
              if (!T)
                throw new Error(C + " is not a valid compression method !");
              return T;
            }(x.options.compression, u.compression), m = x.options.compressionOptions || u.compressionOptions || {}, v = x.dir, y = x.date;
            x._compressWorker(E, m).withStreamInfo("file", { name: g, dir: v, date: y, comment: x.comment || "", unixPermissions: x.unixPermissions, dosPermissions: x.dosPermissions }).pipe(f);
          }), f.entriesCount = h;
        } catch (g) {
          f.error(g);
        }
        return f;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(n, a, s) {
      function o() {
        if (!(this instanceof o))
          return new o();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var l = new o();
          for (var c in this)
            typeof this[c] != "function" && (l[c] = this[c]);
          return l;
        };
      }
      (o.prototype = n("./object")).loadAsync = n("./load"), o.support = n("./support"), o.defaults = n("./defaults"), o.version = "3.10.1", o.loadAsync = function(l, c) {
        return new o().loadAsync(l, c);
      }, o.external = n("./external"), a.exports = o;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(n, a, s) {
      var o = n("./utils"), l = n("./external"), c = n("./utf8"), u = n("./zipEntries"), d = n("./stream/Crc32Probe"), f = n("./nodejsUtils");
      function h(g) {
        return new l.Promise(function(x, E) {
          var m = g.decompressed.getContentWorker().pipe(new d());
          m.on("error", function(v) {
            E(v);
          }).on("end", function() {
            m.streamInfo.crc32 !== g.decompressed.crc32 ? E(new Error("Corrupted zip : CRC32 mismatch")) : x();
          }).resume();
        });
      }
      a.exports = function(g, x) {
        var E = this;
        return x = o.extend(x || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: c.utf8decode }), f.isNode && f.isStream(g) ? l.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : o.prepareContent("the loaded zip file", g, !0, x.optimizedBinaryString, x.base64).then(function(m) {
          var v = new u(x);
          return v.load(m), v;
        }).then(function(m) {
          var v = [l.Promise.resolve(m)], y = m.files;
          if (x.checkCRC32)
            for (var A = 0; A < y.length; A++)
              v.push(h(y[A]));
          return l.Promise.all(v);
        }).then(function(m) {
          for (var v = m.shift(), y = v.files, A = 0; A < y.length; A++) {
            var b = y[A], C = b.fileNameStr, T = o.resolve(b.fileNameStr);
            E.file(T, b.decompressed, { binary: !0, optimizedBinaryString: !0, date: b.date, dir: b.dir, comment: b.fileCommentStr.length ? b.fileCommentStr : null, unixPermissions: b.unixPermissions, dosPermissions: b.dosPermissions, createFolders: x.createFolders }), b.dir || (E.file(T).unsafeOriginalName = C);
          }
          return v.zipComment.length && (E.comment = v.zipComment), E;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(n, a, s) {
      var o = n("../utils"), l = n("../stream/GenericWorker");
      function c(u, d) {
        l.call(this, "Nodejs stream input adapter for " + u), this._upstreamEnded = !1, this._bindStream(d);
      }
      o.inherits(c, l), c.prototype._bindStream = function(u) {
        var d = this;
        (this._stream = u).pause(), u.on("data", function(f) {
          d.push({ data: f, meta: { percent: 0 } });
        }).on("error", function(f) {
          d.isPaused ? this.generatedError = f : d.error(f);
        }).on("end", function() {
          d.isPaused ? d._upstreamEnded = !0 : d.end();
        });
      }, c.prototype.pause = function() {
        return !!l.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, c.prototype.resume = function() {
        return !!l.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, a.exports = c;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(n, a, s) {
      var o = n("readable-stream").Readable;
      function l(c, u, d) {
        o.call(this, u), this._helper = c;
        var f = this;
        c.on("data", function(h, g) {
          f.push(h) || f._helper.pause(), d && d(g);
        }).on("error", function(h) {
          f.emit("error", h);
        }).on("end", function() {
          f.push(null);
        });
      }
      n("../utils").inherits(l, o), l.prototype._read = function() {
        this._helper.resume();
      }, a.exports = l;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(n, a, s) {
      a.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(o, l) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(o, l);
        if (typeof o == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(o, l);
      }, allocBuffer: function(o) {
        if (Buffer.alloc)
          return Buffer.alloc(o);
        var l = new Buffer(o);
        return l.fill(0), l;
      }, isBuffer: function(o) {
        return Buffer.isBuffer(o);
      }, isStream: function(o) {
        return o && typeof o.on == "function" && typeof o.pause == "function" && typeof o.resume == "function";
      } };
    }, {}], 15: [function(n, a, s) {
      function o(T, w, R) {
        var O, D = c.getTypeOf(w), k = c.extend(R || {}, f);
        k.date = k.date || /* @__PURE__ */ new Date(), k.compression !== null && (k.compression = k.compression.toUpperCase()), typeof k.unixPermissions == "string" && (k.unixPermissions = parseInt(k.unixPermissions, 8)), k.unixPermissions && 16384 & k.unixPermissions && (k.dir = !0), k.dosPermissions && 16 & k.dosPermissions && (k.dir = !0), k.dir && (T = y(T)), k.createFolders && (O = v(T)) && A.call(this, O, !0);
        var W = D === "string" && k.binary === !1 && k.base64 === !1;
        R && R.binary !== void 0 || (k.binary = !W), (w instanceof h && w.uncompressedSize === 0 || k.dir || !w || w.length === 0) && (k.base64 = !1, k.binary = !0, w = "", k.compression = "STORE", D = "string");
        var L = null;
        L = w instanceof h || w instanceof u ? w : E.isNode && E.isStream(w) ? new m(T, w) : c.prepareContent(T, w, k.binary, k.optimizedBinaryString, k.base64);
        var z = new g(T, L, k);
        this.files[T] = z;
      }
      var l = n("./utf8"), c = n("./utils"), u = n("./stream/GenericWorker"), d = n("./stream/StreamHelper"), f = n("./defaults"), h = n("./compressedObject"), g = n("./zipObject"), x = n("./generate"), E = n("./nodejsUtils"), m = n("./nodejs/NodejsStreamInputAdapter"), v = function(T) {
        T.slice(-1) === "/" && (T = T.substring(0, T.length - 1));
        var w = T.lastIndexOf("/");
        return 0 < w ? T.substring(0, w) : "";
      }, y = function(T) {
        return T.slice(-1) !== "/" && (T += "/"), T;
      }, A = function(T, w) {
        return w = w !== void 0 ? w : f.createFolders, T = y(T), this.files[T] || o.call(this, T, null, { dir: !0, createFolders: w }), this.files[T];
      };
      function b(T) {
        return Object.prototype.toString.call(T) === "[object RegExp]";
      }
      var C = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(T) {
        var w, R, O;
        for (w in this.files)
          O = this.files[w], (R = w.slice(this.root.length, w.length)) && w.slice(0, this.root.length) === this.root && T(R, O);
      }, filter: function(T) {
        var w = [];
        return this.forEach(function(R, O) {
          T(R, O) && w.push(O);
        }), w;
      }, file: function(T, w, R) {
        if (arguments.length !== 1)
          return T = this.root + T, o.call(this, T, w, R), this;
        if (b(T)) {
          var O = T;
          return this.filter(function(k, W) {
            return !W.dir && O.test(k);
          });
        }
        var D = this.files[this.root + T];
        return D && !D.dir ? D : null;
      }, folder: function(T) {
        if (!T)
          return this;
        if (b(T))
          return this.filter(function(D, k) {
            return k.dir && T.test(D);
          });
        var w = this.root + T, R = A.call(this, w), O = this.clone();
        return O.root = R.name, O;
      }, remove: function(T) {
        T = this.root + T;
        var w = this.files[T];
        if (w || (T.slice(-1) !== "/" && (T += "/"), w = this.files[T]), w && !w.dir)
          delete this.files[T];
        else
          for (var R = this.filter(function(D, k) {
            return k.name.slice(0, T.length) === T;
          }), O = 0; O < R.length; O++)
            delete this.files[R[O].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(T) {
        var w, R = {};
        try {
          if ((R = c.extend(T || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: l.utf8encode })).type = R.type.toLowerCase(), R.compression = R.compression.toUpperCase(), R.type === "binarystring" && (R.type = "string"), !R.type)
            throw new Error("No output type specified.");
          c.checkSupport(R.type), R.platform !== "darwin" && R.platform !== "freebsd" && R.platform !== "linux" && R.platform !== "sunos" || (R.platform = "UNIX"), R.platform === "win32" && (R.platform = "DOS");
          var O = R.comment || this.comment || "";
          w = x.generateWorker(this, R, O);
        } catch (D) {
          (w = new u("error")).error(D);
        }
        return new d(w, R.type || "string", R.mimeType);
      }, generateAsync: function(T, w) {
        return this.generateInternalStream(T).accumulate(w);
      }, generateNodeStream: function(T, w) {
        return (T = T || {}).type || (T.type = "nodebuffer"), this.generateInternalStream(T).toNodejsStream(w);
      } };
      a.exports = C;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(n, a, s) {
      a.exports = n("stream");
    }, { stream: void 0 }], 17: [function(n, a, s) {
      var o = n("./DataReader");
      function l(c) {
        o.call(this, c);
        for (var u = 0; u < this.data.length; u++)
          c[u] = 255 & c[u];
      }
      n("../utils").inherits(l, o), l.prototype.byteAt = function(c) {
        return this.data[this.zero + c];
      }, l.prototype.lastIndexOfSignature = function(c) {
        for (var u = c.charCodeAt(0), d = c.charCodeAt(1), f = c.charCodeAt(2), h = c.charCodeAt(3), g = this.length - 4; 0 <= g; --g)
          if (this.data[g] === u && this.data[g + 1] === d && this.data[g + 2] === f && this.data[g + 3] === h)
            return g - this.zero;
        return -1;
      }, l.prototype.readAndCheckSignature = function(c) {
        var u = c.charCodeAt(0), d = c.charCodeAt(1), f = c.charCodeAt(2), h = c.charCodeAt(3), g = this.readData(4);
        return u === g[0] && d === g[1] && f === g[2] && h === g[3];
      }, l.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return [];
        var u = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, u;
      }, a.exports = l;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(n, a, s) {
      var o = n("../utils");
      function l(c) {
        this.data = c, this.length = c.length, this.index = 0, this.zero = 0;
      }
      l.prototype = { checkOffset: function(c) {
        this.checkIndex(this.index + c);
      }, checkIndex: function(c) {
        if (this.length < this.zero + c || c < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + c + "). Corrupted zip ?");
      }, setIndex: function(c) {
        this.checkIndex(c), this.index = c;
      }, skip: function(c) {
        this.setIndex(this.index + c);
      }, byteAt: function() {
      }, readInt: function(c) {
        var u, d = 0;
        for (this.checkOffset(c), u = this.index + c - 1; u >= this.index; u--)
          d = (d << 8) + this.byteAt(u);
        return this.index += c, d;
      }, readString: function(c) {
        return o.transformTo("string", this.readData(c));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var c = this.readInt(4);
        return new Date(Date.UTC(1980 + (c >> 25 & 127), (c >> 21 & 15) - 1, c >> 16 & 31, c >> 11 & 31, c >> 5 & 63, (31 & c) << 1));
      } }, a.exports = l;
    }, { "../utils": 32 }], 19: [function(n, a, s) {
      var o = n("./Uint8ArrayReader");
      function l(c) {
        o.call(this, c);
      }
      n("../utils").inherits(l, o), l.prototype.readData = function(c) {
        this.checkOffset(c);
        var u = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, u;
      }, a.exports = l;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(n, a, s) {
      var o = n("./DataReader");
      function l(c) {
        o.call(this, c);
      }
      n("../utils").inherits(l, o), l.prototype.byteAt = function(c) {
        return this.data.charCodeAt(this.zero + c);
      }, l.prototype.lastIndexOfSignature = function(c) {
        return this.data.lastIndexOf(c) - this.zero;
      }, l.prototype.readAndCheckSignature = function(c) {
        return c === this.readData(4);
      }, l.prototype.readData = function(c) {
        this.checkOffset(c);
        var u = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, u;
      }, a.exports = l;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(n, a, s) {
      var o = n("./ArrayReader");
      function l(c) {
        o.call(this, c);
      }
      n("../utils").inherits(l, o), l.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return new Uint8Array(0);
        var u = this.data.subarray(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, u;
      }, a.exports = l;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(n, a, s) {
      var o = n("../utils"), l = n("../support"), c = n("./ArrayReader"), u = n("./StringReader"), d = n("./NodeBufferReader"), f = n("./Uint8ArrayReader");
      a.exports = function(h) {
        var g = o.getTypeOf(h);
        return o.checkSupport(g), g !== "string" || l.uint8array ? g === "nodebuffer" ? new d(h) : l.uint8array ? new f(o.transformTo("uint8array", h)) : new c(o.transformTo("array", h)) : new u(h);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(n, a, s) {
      s.LOCAL_FILE_HEADER = "PK", s.CENTRAL_FILE_HEADER = "PK", s.CENTRAL_DIRECTORY_END = "PK", s.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", s.ZIP64_CENTRAL_DIRECTORY_END = "PK", s.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(n, a, s) {
      var o = n("./GenericWorker"), l = n("../utils");
      function c(u) {
        o.call(this, "ConvertWorker to " + u), this.destType = u;
      }
      l.inherits(c, o), c.prototype.processChunk = function(u) {
        this.push({ data: l.transformTo(this.destType, u.data), meta: u.meta });
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(n, a, s) {
      var o = n("./GenericWorker"), l = n("../crc32");
      function c() {
        o.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      n("../utils").inherits(c, o), c.prototype.processChunk = function(u) {
        this.streamInfo.crc32 = l(u.data, this.streamInfo.crc32 || 0), this.push(u);
      }, a.exports = c;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(n, a, s) {
      var o = n("../utils"), l = n("./GenericWorker");
      function c(u) {
        l.call(this, "DataLengthProbe for " + u), this.propName = u, this.withStreamInfo(u, 0);
      }
      o.inherits(c, l), c.prototype.processChunk = function(u) {
        if (u) {
          var d = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = d + u.data.length;
        }
        l.prototype.processChunk.call(this, u);
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(n, a, s) {
      var o = n("../utils"), l = n("./GenericWorker");
      function c(u) {
        l.call(this, "DataWorker");
        var d = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, u.then(function(f) {
          d.dataIsReady = !0, d.data = f, d.max = f && f.length || 0, d.type = o.getTypeOf(f), d.isPaused || d._tickAndRepeat();
        }, function(f) {
          d.error(f);
        });
      }
      o.inherits(c, l), c.prototype.cleanUp = function() {
        l.prototype.cleanUp.call(this), this.data = null;
      }, c.prototype.resume = function() {
        return !!l.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, o.delay(this._tickAndRepeat, [], this)), !0);
      }, c.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (o.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, c.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var u = null, d = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            u = this.data.substring(this.index, d);
            break;
          case "uint8array":
            u = this.data.subarray(this.index, d);
            break;
          case "array":
          case "nodebuffer":
            u = this.data.slice(this.index, d);
        }
        return this.index = d, this.push({ data: u, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, a.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(n, a, s) {
      function o(l) {
        this.name = l || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      o.prototype = { push: function(l) {
        this.emit("data", l);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (l) {
          this.emit("error", l);
        }
        return !0;
      }, error: function(l) {
        return !this.isFinished && (this.isPaused ? this.generatedError = l : (this.isFinished = !0, this.emit("error", l), this.previous && this.previous.error(l), this.cleanUp()), !0);
      }, on: function(l, c) {
        return this._listeners[l].push(c), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(l, c) {
        if (this._listeners[l])
          for (var u = 0; u < this._listeners[l].length; u++)
            this._listeners[l][u].call(this, c);
      }, pipe: function(l) {
        return l.registerPrevious(this);
      }, registerPrevious: function(l) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = l.streamInfo, this.mergeStreamInfo(), this.previous = l;
        var c = this;
        return l.on("data", function(u) {
          c.processChunk(u);
        }), l.on("end", function() {
          c.end();
        }), l.on("error", function(u) {
          c.error(u);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var l = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), l = !0), this.previous && this.previous.resume(), !l;
      }, flush: function() {
      }, processChunk: function(l) {
        this.push(l);
      }, withStreamInfo: function(l, c) {
        return this.extraStreamInfo[l] = c, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var l in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, l) && (this.streamInfo[l] = this.extraStreamInfo[l]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var l = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + l : l;
      } }, a.exports = o;
    }, {}], 29: [function(n, a, s) {
      var o = n("../utils"), l = n("./ConvertWorker"), c = n("./GenericWorker"), u = n("../base64"), d = n("../support"), f = n("../external"), h = null;
      if (d.nodestream)
        try {
          h = n("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function g(E, m) {
        return new f.Promise(function(v, y) {
          var A = [], b = E._internalType, C = E._outputType, T = E._mimeType;
          E.on("data", function(w, R) {
            A.push(w), m && m(R);
          }).on("error", function(w) {
            A = [], y(w);
          }).on("end", function() {
            try {
              var w = function(R, O, D) {
                switch (R) {
                  case "blob":
                    return o.newBlob(o.transformTo("arraybuffer", O), D);
                  case "base64":
                    return u.encode(O);
                  default:
                    return o.transformTo(R, O);
                }
              }(C, function(R, O) {
                var D, k = 0, W = null, L = 0;
                for (D = 0; D < O.length; D++)
                  L += O[D].length;
                switch (R) {
                  case "string":
                    return O.join("");
                  case "array":
                    return Array.prototype.concat.apply([], O);
                  case "uint8array":
                    for (W = new Uint8Array(L), D = 0; D < O.length; D++)
                      W.set(O[D], k), k += O[D].length;
                    return W;
                  case "nodebuffer":
                    return Buffer.concat(O);
                  default:
                    throw new Error("concat : unsupported type '" + R + "'");
                }
              }(b, A), T);
              v(w);
            } catch (R) {
              y(R);
            }
            A = [];
          }).resume();
        });
      }
      function x(E, m, v) {
        var y = m;
        switch (m) {
          case "blob":
          case "arraybuffer":
            y = "uint8array";
            break;
          case "base64":
            y = "string";
        }
        try {
          this._internalType = y, this._outputType = m, this._mimeType = v, o.checkSupport(y), this._worker = E.pipe(new l(y)), E.lock();
        } catch (A) {
          this._worker = new c("error"), this._worker.error(A);
        }
      }
      x.prototype = { accumulate: function(E) {
        return g(this, E);
      }, on: function(E, m) {
        var v = this;
        return E === "data" ? this._worker.on(E, function(y) {
          m.call(v, y.data, y.meta);
        }) : this._worker.on(E, function() {
          o.delay(m, arguments, v);
        }), this;
      }, resume: function() {
        return o.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(E) {
        if (o.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new h(this, { objectMode: this._outputType !== "nodebuffer" }, E);
      } }, a.exports = x;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(n, a, s) {
      if (s.base64 = !0, s.array = !0, s.string = !0, s.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", s.nodebuffer = typeof Buffer < "u", s.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        s.blob = !1;
      else {
        var o = new ArrayBuffer(0);
        try {
          s.blob = new Blob([o], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var l = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            l.append(o), s.blob = l.getBlob("application/zip").size === 0;
          } catch {
            s.blob = !1;
          }
        }
      }
      try {
        s.nodestream = !!n("readable-stream").Readable;
      } catch {
        s.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(n, a, s) {
      for (var o = n("./utils"), l = n("./support"), c = n("./nodejsUtils"), u = n("./stream/GenericWorker"), d = new Array(256), f = 0; f < 256; f++)
        d[f] = 252 <= f ? 6 : 248 <= f ? 5 : 240 <= f ? 4 : 224 <= f ? 3 : 192 <= f ? 2 : 1;
      d[254] = d[254] = 1;
      function h() {
        u.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function g() {
        u.call(this, "utf-8 encode");
      }
      s.utf8encode = function(x) {
        return l.nodebuffer ? c.newBufferFrom(x, "utf-8") : function(E) {
          var m, v, y, A, b, C = E.length, T = 0;
          for (A = 0; A < C; A++)
            (64512 & (v = E.charCodeAt(A))) == 55296 && A + 1 < C && (64512 & (y = E.charCodeAt(A + 1))) == 56320 && (v = 65536 + (v - 55296 << 10) + (y - 56320), A++), T += v < 128 ? 1 : v < 2048 ? 2 : v < 65536 ? 3 : 4;
          for (m = l.uint8array ? new Uint8Array(T) : new Array(T), A = b = 0; b < T; A++)
            (64512 & (v = E.charCodeAt(A))) == 55296 && A + 1 < C && (64512 & (y = E.charCodeAt(A + 1))) == 56320 && (v = 65536 + (v - 55296 << 10) + (y - 56320), A++), v < 128 ? m[b++] = v : (v < 2048 ? m[b++] = 192 | v >>> 6 : (v < 65536 ? m[b++] = 224 | v >>> 12 : (m[b++] = 240 | v >>> 18, m[b++] = 128 | v >>> 12 & 63), m[b++] = 128 | v >>> 6 & 63), m[b++] = 128 | 63 & v);
          return m;
        }(x);
      }, s.utf8decode = function(x) {
        return l.nodebuffer ? o.transformTo("nodebuffer", x).toString("utf-8") : function(E) {
          var m, v, y, A, b = E.length, C = new Array(2 * b);
          for (m = v = 0; m < b; )
            if ((y = E[m++]) < 128)
              C[v++] = y;
            else if (4 < (A = d[y]))
              C[v++] = 65533, m += A - 1;
            else {
              for (y &= A === 2 ? 31 : A === 3 ? 15 : 7; 1 < A && m < b; )
                y = y << 6 | 63 & E[m++], A--;
              1 < A ? C[v++] = 65533 : y < 65536 ? C[v++] = y : (y -= 65536, C[v++] = 55296 | y >> 10 & 1023, C[v++] = 56320 | 1023 & y);
            }
          return C.length !== v && (C.subarray ? C = C.subarray(0, v) : C.length = v), o.applyFromCharCode(C);
        }(x = o.transformTo(l.uint8array ? "uint8array" : "array", x));
      }, o.inherits(h, u), h.prototype.processChunk = function(x) {
        var E = o.transformTo(l.uint8array ? "uint8array" : "array", x.data);
        if (this.leftOver && this.leftOver.length) {
          if (l.uint8array) {
            var m = E;
            (E = new Uint8Array(m.length + this.leftOver.length)).set(this.leftOver, 0), E.set(m, this.leftOver.length);
          } else
            E = this.leftOver.concat(E);
          this.leftOver = null;
        }
        var v = function(A, b) {
          var C;
          for ((b = b || A.length) > A.length && (b = A.length), C = b - 1; 0 <= C && (192 & A[C]) == 128; )
            C--;
          return C < 0 || C === 0 ? b : C + d[A[C]] > b ? C : b;
        }(E), y = E;
        v !== E.length && (l.uint8array ? (y = E.subarray(0, v), this.leftOver = E.subarray(v, E.length)) : (y = E.slice(0, v), this.leftOver = E.slice(v, E.length))), this.push({ data: s.utf8decode(y), meta: x.meta });
      }, h.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, s.Utf8DecodeWorker = h, o.inherits(g, u), g.prototype.processChunk = function(x) {
        this.push({ data: s.utf8encode(x.data), meta: x.meta });
      }, s.Utf8EncodeWorker = g;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(n, a, s) {
      var o = n("./support"), l = n("./base64"), c = n("./nodejsUtils"), u = n("./external");
      function d(m) {
        return m;
      }
      function f(m, v) {
        for (var y = 0; y < m.length; ++y)
          v[y] = 255 & m.charCodeAt(y);
        return v;
      }
      n("setimmediate"), s.newBlob = function(m, v) {
        s.checkSupport("blob");
        try {
          return new Blob([m], { type: v });
        } catch {
          try {
            var y = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return y.append(m), y.getBlob(v);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var h = { stringifyByChunk: function(m, v, y) {
        var A = [], b = 0, C = m.length;
        if (C <= y)
          return String.fromCharCode.apply(null, m);
        for (; b < C; )
          v === "array" || v === "nodebuffer" ? A.push(String.fromCharCode.apply(null, m.slice(b, Math.min(b + y, C)))) : A.push(String.fromCharCode.apply(null, m.subarray(b, Math.min(b + y, C)))), b += y;
        return A.join("");
      }, stringifyByChar: function(m) {
        for (var v = "", y = 0; y < m.length; y++)
          v += String.fromCharCode(m[y]);
        return v;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return o.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return o.nodebuffer && String.fromCharCode.apply(null, c.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function g(m) {
        var v = 65536, y = s.getTypeOf(m), A = !0;
        if (y === "uint8array" ? A = h.applyCanBeUsed.uint8array : y === "nodebuffer" && (A = h.applyCanBeUsed.nodebuffer), A)
          for (; 1 < v; )
            try {
              return h.stringifyByChunk(m, y, v);
            } catch {
              v = Math.floor(v / 2);
            }
        return h.stringifyByChar(m);
      }
      function x(m, v) {
        for (var y = 0; y < m.length; y++)
          v[y] = m[y];
        return v;
      }
      s.applyFromCharCode = g;
      var E = {};
      E.string = { string: d, array: function(m) {
        return f(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return E.string.uint8array(m).buffer;
      }, uint8array: function(m) {
        return f(m, new Uint8Array(m.length));
      }, nodebuffer: function(m) {
        return f(m, c.allocBuffer(m.length));
      } }, E.array = { string: g, array: d, arraybuffer: function(m) {
        return new Uint8Array(m).buffer;
      }, uint8array: function(m) {
        return new Uint8Array(m);
      }, nodebuffer: function(m) {
        return c.newBufferFrom(m);
      } }, E.arraybuffer = { string: function(m) {
        return g(new Uint8Array(m));
      }, array: function(m) {
        return x(new Uint8Array(m), new Array(m.byteLength));
      }, arraybuffer: d, uint8array: function(m) {
        return new Uint8Array(m);
      }, nodebuffer: function(m) {
        return c.newBufferFrom(new Uint8Array(m));
      } }, E.uint8array = { string: g, array: function(m) {
        return x(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return m.buffer;
      }, uint8array: d, nodebuffer: function(m) {
        return c.newBufferFrom(m);
      } }, E.nodebuffer = { string: g, array: function(m) {
        return x(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return E.nodebuffer.uint8array(m).buffer;
      }, uint8array: function(m) {
        return x(m, new Uint8Array(m.length));
      }, nodebuffer: d }, s.transformTo = function(m, v) {
        if (v = v || "", !m)
          return v;
        s.checkSupport(m);
        var y = s.getTypeOf(v);
        return E[y][m](v);
      }, s.resolve = function(m) {
        for (var v = m.split("/"), y = [], A = 0; A < v.length; A++) {
          var b = v[A];
          b === "." || b === "" && A !== 0 && A !== v.length - 1 || (b === ".." ? y.pop() : y.push(b));
        }
        return y.join("/");
      }, s.getTypeOf = function(m) {
        return typeof m == "string" ? "string" : Object.prototype.toString.call(m) === "[object Array]" ? "array" : o.nodebuffer && c.isBuffer(m) ? "nodebuffer" : o.uint8array && m instanceof Uint8Array ? "uint8array" : o.arraybuffer && m instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, s.checkSupport = function(m) {
        if (!o[m.toLowerCase()])
          throw new Error(m + " is not supported by this platform");
      }, s.MAX_VALUE_16BITS = 65535, s.MAX_VALUE_32BITS = -1, s.pretty = function(m) {
        var v, y, A = "";
        for (y = 0; y < (m || "").length; y++)
          A += "\\x" + ((v = m.charCodeAt(y)) < 16 ? "0" : "") + v.toString(16).toUpperCase();
        return A;
      }, s.delay = function(m, v, y) {
        setImmediate(function() {
          m.apply(y || null, v || []);
        });
      }, s.inherits = function(m, v) {
        function y() {
        }
        y.prototype = v.prototype, m.prototype = new y();
      }, s.extend = function() {
        var m, v, y = {};
        for (m = 0; m < arguments.length; m++)
          for (v in arguments[m])
            Object.prototype.hasOwnProperty.call(arguments[m], v) && y[v] === void 0 && (y[v] = arguments[m][v]);
        return y;
      }, s.prepareContent = function(m, v, y, A, b) {
        return u.Promise.resolve(v).then(function(C) {
          return o.blob && (C instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(C)) !== -1) && typeof FileReader < "u" ? new u.Promise(function(T, w) {
            var R = new FileReader();
            R.onload = function(O) {
              T(O.target.result);
            }, R.onerror = function(O) {
              w(O.target.error);
            }, R.readAsArrayBuffer(C);
          }) : C;
        }).then(function(C) {
          var T = s.getTypeOf(C);
          return T ? (T === "arraybuffer" ? C = s.transformTo("uint8array", C) : T === "string" && (b ? C = l.decode(C) : y && A !== !0 && (C = function(w) {
            return f(w, o.uint8array ? new Uint8Array(w.length) : new Array(w.length));
          }(C))), C) : u.Promise.reject(new Error("Can't read the data of '" + m + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(n, a, s) {
      var o = n("./reader/readerFor"), l = n("./utils"), c = n("./signature"), u = n("./zipEntry"), d = n("./support");
      function f(h) {
        this.files = [], this.loadOptions = h;
      }
      f.prototype = { checkSignature: function(h) {
        if (!this.reader.readAndCheckSignature(h)) {
          this.reader.index -= 4;
          var g = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + l.pretty(g) + ", expected " + l.pretty(h) + ")");
        }
      }, isSignature: function(h, g) {
        var x = this.reader.index;
        this.reader.setIndex(h);
        var E = this.reader.readString(4) === g;
        return this.reader.setIndex(x), E;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var h = this.reader.readData(this.zipCommentLength), g = d.uint8array ? "uint8array" : "array", x = l.transformTo(g, h);
        this.zipComment = this.loadOptions.decodeFileName(x);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var h, g, x, E = this.zip64EndOfCentralSize - 44; 0 < E; )
          h = this.reader.readInt(2), g = this.reader.readInt(4), x = this.reader.readData(g), this.zip64ExtensibleData[h] = { id: h, length: g, value: x };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var h, g;
        for (h = 0; h < this.files.length; h++)
          g = this.files[h], this.reader.setIndex(g.localHeaderOffset), this.checkSignature(c.LOCAL_FILE_HEADER), g.readLocalPart(this.reader), g.handleUTF8(), g.processAttributes();
      }, readCentralDir: function() {
        var h;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(c.CENTRAL_FILE_HEADER); )
          (h = new u({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(h);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var h = this.reader.lastIndexOfSignature(c.CENTRAL_DIRECTORY_END);
        if (h < 0)
          throw this.isSignature(0, c.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(h);
        var g = h;
        if (this.checkSignature(c.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === l.MAX_VALUE_16BITS || this.diskWithCentralDirStart === l.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === l.MAX_VALUE_16BITS || this.centralDirRecords === l.MAX_VALUE_16BITS || this.centralDirSize === l.MAX_VALUE_32BITS || this.centralDirOffset === l.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (h = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(h), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, c.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var x = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (x += 20, x += 12 + this.zip64EndOfCentralSize);
        var E = g - x;
        if (0 < E)
          this.isSignature(g, c.CENTRAL_FILE_HEADER) || (this.reader.zero = E);
        else if (E < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(E) + " bytes.");
      }, prepareReader: function(h) {
        this.reader = o(h);
      }, load: function(h) {
        this.prepareReader(h), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, a.exports = f;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(n, a, s) {
      var o = n("./reader/readerFor"), l = n("./utils"), c = n("./compressedObject"), u = n("./crc32"), d = n("./utf8"), f = n("./compressions"), h = n("./support");
      function g(x, E) {
        this.options = x, this.loadOptions = E;
      }
      g.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(x) {
        var E, m;
        if (x.skip(22), this.fileNameLength = x.readInt(2), m = x.readInt(2), this.fileName = x.readData(this.fileNameLength), x.skip(m), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((E = function(v) {
          for (var y in f)
            if (Object.prototype.hasOwnProperty.call(f, y) && f[y].magic === v)
              return f[y];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + l.pretty(this.compressionMethod) + " unknown (inner file : " + l.transformTo("string", this.fileName) + ")");
        this.decompressed = new c(this.compressedSize, this.uncompressedSize, this.crc32, E, x.readData(this.compressedSize));
      }, readCentralPart: function(x) {
        this.versionMadeBy = x.readInt(2), x.skip(2), this.bitFlag = x.readInt(2), this.compressionMethod = x.readString(2), this.date = x.readDate(), this.crc32 = x.readInt(4), this.compressedSize = x.readInt(4), this.uncompressedSize = x.readInt(4);
        var E = x.readInt(2);
        if (this.extraFieldsLength = x.readInt(2), this.fileCommentLength = x.readInt(2), this.diskNumberStart = x.readInt(2), this.internalFileAttributes = x.readInt(2), this.externalFileAttributes = x.readInt(4), this.localHeaderOffset = x.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        x.skip(E), this.readExtraFields(x), this.parseZIP64ExtraField(x), this.fileComment = x.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var x = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), x == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), x == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var x = o(this.extraFields[1].value);
          this.uncompressedSize === l.MAX_VALUE_32BITS && (this.uncompressedSize = x.readInt(8)), this.compressedSize === l.MAX_VALUE_32BITS && (this.compressedSize = x.readInt(8)), this.localHeaderOffset === l.MAX_VALUE_32BITS && (this.localHeaderOffset = x.readInt(8)), this.diskNumberStart === l.MAX_VALUE_32BITS && (this.diskNumberStart = x.readInt(4));
        }
      }, readExtraFields: function(x) {
        var E, m, v, y = x.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); x.index + 4 < y; )
          E = x.readInt(2), m = x.readInt(2), v = x.readData(m), this.extraFields[E] = { id: E, length: m, value: v };
        x.setIndex(y);
      }, handleUTF8: function() {
        var x = h.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = d.utf8decode(this.fileName), this.fileCommentStr = d.utf8decode(this.fileComment);
        else {
          var E = this.findExtraFieldUnicodePath();
          if (E !== null)
            this.fileNameStr = E;
          else {
            var m = l.transformTo(x, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(m);
          }
          var v = this.findExtraFieldUnicodeComment();
          if (v !== null)
            this.fileCommentStr = v;
          else {
            var y = l.transformTo(x, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(y);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var x = this.extraFields[28789];
        if (x) {
          var E = o(x.value);
          return E.readInt(1) !== 1 || u(this.fileName) !== E.readInt(4) ? null : d.utf8decode(E.readData(x.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var x = this.extraFields[25461];
        if (x) {
          var E = o(x.value);
          return E.readInt(1) !== 1 || u(this.fileComment) !== E.readInt(4) ? null : d.utf8decode(E.readData(x.length - 5));
        }
        return null;
      } }, a.exports = g;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(n, a, s) {
      function o(E, m, v) {
        this.name = E, this.dir = v.dir, this.date = v.date, this.comment = v.comment, this.unixPermissions = v.unixPermissions, this.dosPermissions = v.dosPermissions, this._data = m, this._dataBinary = v.binary, this.options = { compression: v.compression, compressionOptions: v.compressionOptions };
      }
      var l = n("./stream/StreamHelper"), c = n("./stream/DataWorker"), u = n("./utf8"), d = n("./compressedObject"), f = n("./stream/GenericWorker");
      o.prototype = { internalStream: function(E) {
        var m = null, v = "string";
        try {
          if (!E)
            throw new Error("No output type specified.");
          var y = (v = E.toLowerCase()) === "string" || v === "text";
          v !== "binarystring" && v !== "text" || (v = "string"), m = this._decompressWorker();
          var A = !this._dataBinary;
          A && !y && (m = m.pipe(new u.Utf8EncodeWorker())), !A && y && (m = m.pipe(new u.Utf8DecodeWorker()));
        } catch (b) {
          (m = new f("error")).error(b);
        }
        return new l(m, v, "");
      }, async: function(E, m) {
        return this.internalStream(E).accumulate(m);
      }, nodeStream: function(E, m) {
        return this.internalStream(E || "nodebuffer").toNodejsStream(m);
      }, _compressWorker: function(E, m) {
        if (this._data instanceof d && this._data.compression.magic === E.magic)
          return this._data.getCompressedWorker();
        var v = this._decompressWorker();
        return this._dataBinary || (v = v.pipe(new u.Utf8EncodeWorker())), d.createWorkerFrom(v, E, m);
      }, _decompressWorker: function() {
        return this._data instanceof d ? this._data.getContentWorker() : this._data instanceof f ? this._data : new c(this._data);
      } };
      for (var h = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], g = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, x = 0; x < h.length; x++)
        o.prototype[h[x]] = g;
      a.exports = o;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(n, a, s) {
      (function(o) {
        var l, c, u = o.MutationObserver || o.WebKitMutationObserver;
        if (u) {
          var d = 0, f = new u(E), h = o.document.createTextNode("");
          f.observe(h, { characterData: !0 }), l = function() {
            h.data = d = ++d % 2;
          };
        } else if (o.setImmediate || o.MessageChannel === void 0)
          l = "document" in o && "onreadystatechange" in o.document.createElement("script") ? function() {
            var m = o.document.createElement("script");
            m.onreadystatechange = function() {
              E(), m.onreadystatechange = null, m.parentNode.removeChild(m), m = null;
            }, o.document.documentElement.appendChild(m);
          } : function() {
            setTimeout(E, 0);
          };
        else {
          var g = new o.MessageChannel();
          g.port1.onmessage = E, l = function() {
            g.port2.postMessage(0);
          };
        }
        var x = [];
        function E() {
          var m, v;
          c = !0;
          for (var y = x.length; y; ) {
            for (v = x, x = [], m = -1; ++m < y; )
              v[m]();
            y = x.length;
          }
          c = !1;
        }
        a.exports = function(m) {
          x.push(m) !== 1 || c || l();
        };
      }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(n, a, s) {
      var o = n("immediate");
      function l() {
      }
      var c = {}, u = ["REJECTED"], d = ["FULFILLED"], f = ["PENDING"];
      function h(y) {
        if (typeof y != "function")
          throw new TypeError("resolver must be a function");
        this.state = f, this.queue = [], this.outcome = void 0, y !== l && m(this, y);
      }
      function g(y, A, b) {
        this.promise = y, typeof A == "function" && (this.onFulfilled = A, this.callFulfilled = this.otherCallFulfilled), typeof b == "function" && (this.onRejected = b, this.callRejected = this.otherCallRejected);
      }
      function x(y, A, b) {
        o(function() {
          var C;
          try {
            C = A(b);
          } catch (T) {
            return c.reject(y, T);
          }
          C === y ? c.reject(y, new TypeError("Cannot resolve promise with itself")) : c.resolve(y, C);
        });
      }
      function E(y) {
        var A = y && y.then;
        if (y && (typeof y == "object" || typeof y == "function") && typeof A == "function")
          return function() {
            A.apply(y, arguments);
          };
      }
      function m(y, A) {
        var b = !1;
        function C(R) {
          b || (b = !0, c.reject(y, R));
        }
        function T(R) {
          b || (b = !0, c.resolve(y, R));
        }
        var w = v(function() {
          A(T, C);
        });
        w.status === "error" && C(w.value);
      }
      function v(y, A) {
        var b = {};
        try {
          b.value = y(A), b.status = "success";
        } catch (C) {
          b.status = "error", b.value = C;
        }
        return b;
      }
      (a.exports = h).prototype.finally = function(y) {
        if (typeof y != "function")
          return this;
        var A = this.constructor;
        return this.then(function(b) {
          return A.resolve(y()).then(function() {
            return b;
          });
        }, function(b) {
          return A.resolve(y()).then(function() {
            throw b;
          });
        });
      }, h.prototype.catch = function(y) {
        return this.then(null, y);
      }, h.prototype.then = function(y, A) {
        if (typeof y != "function" && this.state === d || typeof A != "function" && this.state === u)
          return this;
        var b = new this.constructor(l);
        return this.state !== f ? x(b, this.state === d ? y : A, this.outcome) : this.queue.push(new g(b, y, A)), b;
      }, g.prototype.callFulfilled = function(y) {
        c.resolve(this.promise, y);
      }, g.prototype.otherCallFulfilled = function(y) {
        x(this.promise, this.onFulfilled, y);
      }, g.prototype.callRejected = function(y) {
        c.reject(this.promise, y);
      }, g.prototype.otherCallRejected = function(y) {
        x(this.promise, this.onRejected, y);
      }, c.resolve = function(y, A) {
        var b = v(E, A);
        if (b.status === "error")
          return c.reject(y, b.value);
        var C = b.value;
        if (C)
          m(y, C);
        else {
          y.state = d, y.outcome = A;
          for (var T = -1, w = y.queue.length; ++T < w; )
            y.queue[T].callFulfilled(A);
        }
        return y;
      }, c.reject = function(y, A) {
        y.state = u, y.outcome = A;
        for (var b = -1, C = y.queue.length; ++b < C; )
          y.queue[b].callRejected(A);
        return y;
      }, h.resolve = function(y) {
        return y instanceof this ? y : c.resolve(new this(l), y);
      }, h.reject = function(y) {
        var A = new this(l);
        return c.reject(A, y);
      }, h.all = function(y) {
        var A = this;
        if (Object.prototype.toString.call(y) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var b = y.length, C = !1;
        if (!b)
          return this.resolve([]);
        for (var T = new Array(b), w = 0, R = -1, O = new this(l); ++R < b; )
          D(y[R], R);
        return O;
        function D(k, W) {
          A.resolve(k).then(function(L) {
            T[W] = L, ++w !== b || C || (C = !0, c.resolve(O, T));
          }, function(L) {
            C || (C = !0, c.reject(O, L));
          });
        }
      }, h.race = function(y) {
        var A = this;
        if (Object.prototype.toString.call(y) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var b = y.length, C = !1;
        if (!b)
          return this.resolve([]);
        for (var T = -1, w = new this(l); ++T < b; )
          R = y[T], A.resolve(R).then(function(O) {
            C || (C = !0, c.resolve(w, O));
          }, function(O) {
            C || (C = !0, c.reject(w, O));
          });
        var R;
        return w;
      };
    }, { immediate: 36 }], 38: [function(n, a, s) {
      var o = {};
      (0, n("./lib/utils/common").assign)(o, n("./lib/deflate"), n("./lib/inflate"), n("./lib/zlib/constants")), a.exports = o;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(n, a, s) {
      var o = n("./zlib/deflate"), l = n("./utils/common"), c = n("./utils/strings"), u = n("./zlib/messages"), d = n("./zlib/zstream"), f = Object.prototype.toString, h = 0, g = -1, x = 0, E = 8;
      function m(y) {
        if (!(this instanceof m))
          return new m(y);
        this.options = l.assign({ level: g, method: E, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: x, to: "" }, y || {});
        var A = this.options;
        A.raw && 0 < A.windowBits ? A.windowBits = -A.windowBits : A.gzip && 0 < A.windowBits && A.windowBits < 16 && (A.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new d(), this.strm.avail_out = 0;
        var b = o.deflateInit2(this.strm, A.level, A.method, A.windowBits, A.memLevel, A.strategy);
        if (b !== h)
          throw new Error(u[b]);
        if (A.header && o.deflateSetHeader(this.strm, A.header), A.dictionary) {
          var C;
          if (C = typeof A.dictionary == "string" ? c.string2buf(A.dictionary) : f.call(A.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(A.dictionary) : A.dictionary, (b = o.deflateSetDictionary(this.strm, C)) !== h)
            throw new Error(u[b]);
          this._dict_set = !0;
        }
      }
      function v(y, A) {
        var b = new m(A);
        if (b.push(y, !0), b.err)
          throw b.msg || u[b.err];
        return b.result;
      }
      m.prototype.push = function(y, A) {
        var b, C, T = this.strm, w = this.options.chunkSize;
        if (this.ended)
          return !1;
        C = A === ~~A ? A : A === !0 ? 4 : 0, typeof y == "string" ? T.input = c.string2buf(y) : f.call(y) === "[object ArrayBuffer]" ? T.input = new Uint8Array(y) : T.input = y, T.next_in = 0, T.avail_in = T.input.length;
        do {
          if (T.avail_out === 0 && (T.output = new l.Buf8(w), T.next_out = 0, T.avail_out = w), (b = o.deflate(T, C)) !== 1 && b !== h)
            return this.onEnd(b), !(this.ended = !0);
          T.avail_out !== 0 && (T.avail_in !== 0 || C !== 4 && C !== 2) || (this.options.to === "string" ? this.onData(c.buf2binstring(l.shrinkBuf(T.output, T.next_out))) : this.onData(l.shrinkBuf(T.output, T.next_out)));
        } while ((0 < T.avail_in || T.avail_out === 0) && b !== 1);
        return C === 4 ? (b = o.deflateEnd(this.strm), this.onEnd(b), this.ended = !0, b === h) : C !== 2 || (this.onEnd(h), !(T.avail_out = 0));
      }, m.prototype.onData = function(y) {
        this.chunks.push(y);
      }, m.prototype.onEnd = function(y) {
        y === h && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = l.flattenChunks(this.chunks)), this.chunks = [], this.err = y, this.msg = this.strm.msg;
      }, s.Deflate = m, s.deflate = v, s.deflateRaw = function(y, A) {
        return (A = A || {}).raw = !0, v(y, A);
      }, s.gzip = function(y, A) {
        return (A = A || {}).gzip = !0, v(y, A);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(n, a, s) {
      var o = n("./zlib/inflate"), l = n("./utils/common"), c = n("./utils/strings"), u = n("./zlib/constants"), d = n("./zlib/messages"), f = n("./zlib/zstream"), h = n("./zlib/gzheader"), g = Object.prototype.toString;
      function x(m) {
        if (!(this instanceof x))
          return new x(m);
        this.options = l.assign({ chunkSize: 16384, windowBits: 0, to: "" }, m || {});
        var v = this.options;
        v.raw && 0 <= v.windowBits && v.windowBits < 16 && (v.windowBits = -v.windowBits, v.windowBits === 0 && (v.windowBits = -15)), !(0 <= v.windowBits && v.windowBits < 16) || m && m.windowBits || (v.windowBits += 32), 15 < v.windowBits && v.windowBits < 48 && !(15 & v.windowBits) && (v.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new f(), this.strm.avail_out = 0;
        var y = o.inflateInit2(this.strm, v.windowBits);
        if (y !== u.Z_OK)
          throw new Error(d[y]);
        this.header = new h(), o.inflateGetHeader(this.strm, this.header);
      }
      function E(m, v) {
        var y = new x(v);
        if (y.push(m, !0), y.err)
          throw y.msg || d[y.err];
        return y.result;
      }
      x.prototype.push = function(m, v) {
        var y, A, b, C, T, w, R = this.strm, O = this.options.chunkSize, D = this.options.dictionary, k = !1;
        if (this.ended)
          return !1;
        A = v === ~~v ? v : v === !0 ? u.Z_FINISH : u.Z_NO_FLUSH, typeof m == "string" ? R.input = c.binstring2buf(m) : g.call(m) === "[object ArrayBuffer]" ? R.input = new Uint8Array(m) : R.input = m, R.next_in = 0, R.avail_in = R.input.length;
        do {
          if (R.avail_out === 0 && (R.output = new l.Buf8(O), R.next_out = 0, R.avail_out = O), (y = o.inflate(R, u.Z_NO_FLUSH)) === u.Z_NEED_DICT && D && (w = typeof D == "string" ? c.string2buf(D) : g.call(D) === "[object ArrayBuffer]" ? new Uint8Array(D) : D, y = o.inflateSetDictionary(this.strm, w)), y === u.Z_BUF_ERROR && k === !0 && (y = u.Z_OK, k = !1), y !== u.Z_STREAM_END && y !== u.Z_OK)
            return this.onEnd(y), !(this.ended = !0);
          R.next_out && (R.avail_out !== 0 && y !== u.Z_STREAM_END && (R.avail_in !== 0 || A !== u.Z_FINISH && A !== u.Z_SYNC_FLUSH) || (this.options.to === "string" ? (b = c.utf8border(R.output, R.next_out), C = R.next_out - b, T = c.buf2string(R.output, b), R.next_out = C, R.avail_out = O - C, C && l.arraySet(R.output, R.output, b, C, 0), this.onData(T)) : this.onData(l.shrinkBuf(R.output, R.next_out)))), R.avail_in === 0 && R.avail_out === 0 && (k = !0);
        } while ((0 < R.avail_in || R.avail_out === 0) && y !== u.Z_STREAM_END);
        return y === u.Z_STREAM_END && (A = u.Z_FINISH), A === u.Z_FINISH ? (y = o.inflateEnd(this.strm), this.onEnd(y), this.ended = !0, y === u.Z_OK) : A !== u.Z_SYNC_FLUSH || (this.onEnd(u.Z_OK), !(R.avail_out = 0));
      }, x.prototype.onData = function(m) {
        this.chunks.push(m);
      }, x.prototype.onEnd = function(m) {
        m === u.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = l.flattenChunks(this.chunks)), this.chunks = [], this.err = m, this.msg = this.strm.msg;
      }, s.Inflate = x, s.inflate = E, s.inflateRaw = function(m, v) {
        return (v = v || {}).raw = !0, E(m, v);
      }, s.ungzip = E;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(n, a, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      s.assign = function(u) {
        for (var d = Array.prototype.slice.call(arguments, 1); d.length; ) {
          var f = d.shift();
          if (f) {
            if (typeof f != "object")
              throw new TypeError(f + "must be non-object");
            for (var h in f)
              f.hasOwnProperty(h) && (u[h] = f[h]);
          }
        }
        return u;
      }, s.shrinkBuf = function(u, d) {
        return u.length === d ? u : u.subarray ? u.subarray(0, d) : (u.length = d, u);
      };
      var l = { arraySet: function(u, d, f, h, g) {
        if (d.subarray && u.subarray)
          u.set(d.subarray(f, f + h), g);
        else
          for (var x = 0; x < h; x++)
            u[g + x] = d[f + x];
      }, flattenChunks: function(u) {
        var d, f, h, g, x, E;
        for (d = h = 0, f = u.length; d < f; d++)
          h += u[d].length;
        for (E = new Uint8Array(h), d = g = 0, f = u.length; d < f; d++)
          x = u[d], E.set(x, g), g += x.length;
        return E;
      } }, c = { arraySet: function(u, d, f, h, g) {
        for (var x = 0; x < h; x++)
          u[g + x] = d[f + x];
      }, flattenChunks: function(u) {
        return [].concat.apply([], u);
      } };
      s.setTyped = function(u) {
        u ? (s.Buf8 = Uint8Array, s.Buf16 = Uint16Array, s.Buf32 = Int32Array, s.assign(s, l)) : (s.Buf8 = Array, s.Buf16 = Array, s.Buf32 = Array, s.assign(s, c));
      }, s.setTyped(o);
    }, {}], 42: [function(n, a, s) {
      var o = n("./common"), l = !0, c = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        l = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        c = !1;
      }
      for (var u = new o.Buf8(256), d = 0; d < 256; d++)
        u[d] = 252 <= d ? 6 : 248 <= d ? 5 : 240 <= d ? 4 : 224 <= d ? 3 : 192 <= d ? 2 : 1;
      function f(h, g) {
        if (g < 65537 && (h.subarray && c || !h.subarray && l))
          return String.fromCharCode.apply(null, o.shrinkBuf(h, g));
        for (var x = "", E = 0; E < g; E++)
          x += String.fromCharCode(h[E]);
        return x;
      }
      u[254] = u[254] = 1, s.string2buf = function(h) {
        var g, x, E, m, v, y = h.length, A = 0;
        for (m = 0; m < y; m++)
          (64512 & (x = h.charCodeAt(m))) == 55296 && m + 1 < y && (64512 & (E = h.charCodeAt(m + 1))) == 56320 && (x = 65536 + (x - 55296 << 10) + (E - 56320), m++), A += x < 128 ? 1 : x < 2048 ? 2 : x < 65536 ? 3 : 4;
        for (g = new o.Buf8(A), m = v = 0; v < A; m++)
          (64512 & (x = h.charCodeAt(m))) == 55296 && m + 1 < y && (64512 & (E = h.charCodeAt(m + 1))) == 56320 && (x = 65536 + (x - 55296 << 10) + (E - 56320), m++), x < 128 ? g[v++] = x : (x < 2048 ? g[v++] = 192 | x >>> 6 : (x < 65536 ? g[v++] = 224 | x >>> 12 : (g[v++] = 240 | x >>> 18, g[v++] = 128 | x >>> 12 & 63), g[v++] = 128 | x >>> 6 & 63), g[v++] = 128 | 63 & x);
        return g;
      }, s.buf2binstring = function(h) {
        return f(h, h.length);
      }, s.binstring2buf = function(h) {
        for (var g = new o.Buf8(h.length), x = 0, E = g.length; x < E; x++)
          g[x] = h.charCodeAt(x);
        return g;
      }, s.buf2string = function(h, g) {
        var x, E, m, v, y = g || h.length, A = new Array(2 * y);
        for (x = E = 0; x < y; )
          if ((m = h[x++]) < 128)
            A[E++] = m;
          else if (4 < (v = u[m]))
            A[E++] = 65533, x += v - 1;
          else {
            for (m &= v === 2 ? 31 : v === 3 ? 15 : 7; 1 < v && x < y; )
              m = m << 6 | 63 & h[x++], v--;
            1 < v ? A[E++] = 65533 : m < 65536 ? A[E++] = m : (m -= 65536, A[E++] = 55296 | m >> 10 & 1023, A[E++] = 56320 | 1023 & m);
          }
        return f(A, E);
      }, s.utf8border = function(h, g) {
        var x;
        for ((g = g || h.length) > h.length && (g = h.length), x = g - 1; 0 <= x && (192 & h[x]) == 128; )
          x--;
        return x < 0 || x === 0 ? g : x + u[h[x]] > g ? x : g;
      };
    }, { "./common": 41 }], 43: [function(n, a, s) {
      a.exports = function(o, l, c, u) {
        for (var d = 65535 & o | 0, f = o >>> 16 & 65535 | 0, h = 0; c !== 0; ) {
          for (c -= h = 2e3 < c ? 2e3 : c; f = f + (d = d + l[u++] | 0) | 0, --h; )
            ;
          d %= 65521, f %= 65521;
        }
        return d | f << 16 | 0;
      };
    }, {}], 44: [function(n, a, s) {
      a.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(n, a, s) {
      var o = function() {
        for (var l, c = [], u = 0; u < 256; u++) {
          l = u;
          for (var d = 0; d < 8; d++)
            l = 1 & l ? 3988292384 ^ l >>> 1 : l >>> 1;
          c[u] = l;
        }
        return c;
      }();
      a.exports = function(l, c, u, d) {
        var f = o, h = d + u;
        l ^= -1;
        for (var g = d; g < h; g++)
          l = l >>> 8 ^ f[255 & (l ^ c[g])];
        return -1 ^ l;
      };
    }, {}], 46: [function(n, a, s) {
      var o, l = n("../utils/common"), c = n("./trees"), u = n("./adler32"), d = n("./crc32"), f = n("./messages"), h = 0, g = 4, x = 0, E = -2, m = -1, v = 4, y = 2, A = 8, b = 9, C = 286, T = 30, w = 19, R = 2 * C + 1, O = 15, D = 3, k = 258, W = k + D + 1, L = 42, z = 113, P = 1, Q = 2, Y = 3, ie = 4;
      function te(X, ye) {
        return X.msg = f[ye], ye;
      }
      function Z(X) {
        return (X << 1) - (4 < X ? 9 : 0);
      }
      function ae(X) {
        for (var ye = X.length; 0 <= --ye; )
          X[ye] = 0;
      }
      function G(X) {
        var ye = X.state, Ae = ye.pending;
        Ae > X.avail_out && (Ae = X.avail_out), Ae !== 0 && (l.arraySet(X.output, ye.pending_buf, ye.pending_out, Ae, X.next_out), X.next_out += Ae, ye.pending_out += Ae, X.total_out += Ae, X.avail_out -= Ae, ye.pending -= Ae, ye.pending === 0 && (ye.pending_out = 0));
      }
      function U(X, ye) {
        c._tr_flush_block(X, 0 <= X.block_start ? X.block_start : -1, X.strstart - X.block_start, ye), X.block_start = X.strstart, G(X.strm);
      }
      function F(X, ye) {
        X.pending_buf[X.pending++] = ye;
      }
      function M(X, ye) {
        X.pending_buf[X.pending++] = ye >>> 8 & 255, X.pending_buf[X.pending++] = 255 & ye;
      }
      function I(X, ye) {
        var Ae, fe, _e = X.max_chain_length, Ie = X.strstart, Be = X.prev_length, $e = X.nice_match, Me = X.strstart > X.w_size - W ? X.strstart - (X.w_size - W) : 0, J = X.window, K = X.w_mask, ge = X.prev, Ce = X.strstart + k, Oe = J[Ie + Be - 1], qe = J[Ie + Be];
        X.prev_length >= X.good_match && (_e >>= 2), $e > X.lookahead && ($e = X.lookahead);
        do
          if (J[(Ae = ye) + Be] === qe && J[Ae + Be - 1] === Oe && J[Ae] === J[Ie] && J[++Ae] === J[Ie + 1]) {
            Ie += 2, Ae++;
            do
              ;
            while (J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && J[++Ie] === J[++Ae] && Ie < Ce);
            if (fe = k - (Ce - Ie), Ie = Ce - k, Be < fe) {
              if (X.match_start = ye, $e <= (Be = fe))
                break;
              Oe = J[Ie + Be - 1], qe = J[Ie + Be];
            }
          }
        while ((ye = ge[ye & K]) > Me && --_e != 0);
        return Be <= X.lookahead ? Be : X.lookahead;
      }
      function N(X) {
        var ye, Ae, fe, _e, Ie, Be, $e, Me, J, K, ge = X.w_size;
        do {
          if (_e = X.window_size - X.lookahead - X.strstart, X.strstart >= ge + (ge - W)) {
            for (l.arraySet(X.window, X.window, ge, ge, 0), X.match_start -= ge, X.strstart -= ge, X.block_start -= ge, ye = Ae = X.hash_size; fe = X.head[--ye], X.head[ye] = ge <= fe ? fe - ge : 0, --Ae; )
              ;
            for (ye = Ae = ge; fe = X.prev[--ye], X.prev[ye] = ge <= fe ? fe - ge : 0, --Ae; )
              ;
            _e += ge;
          }
          if (X.strm.avail_in === 0)
            break;
          if (Be = X.strm, $e = X.window, Me = X.strstart + X.lookahead, J = _e, K = void 0, K = Be.avail_in, J < K && (K = J), Ae = K === 0 ? 0 : (Be.avail_in -= K, l.arraySet($e, Be.input, Be.next_in, K, Me), Be.state.wrap === 1 ? Be.adler = u(Be.adler, $e, K, Me) : Be.state.wrap === 2 && (Be.adler = d(Be.adler, $e, K, Me)), Be.next_in += K, Be.total_in += K, K), X.lookahead += Ae, X.lookahead + X.insert >= D)
            for (Ie = X.strstart - X.insert, X.ins_h = X.window[Ie], X.ins_h = (X.ins_h << X.hash_shift ^ X.window[Ie + 1]) & X.hash_mask; X.insert && (X.ins_h = (X.ins_h << X.hash_shift ^ X.window[Ie + D - 1]) & X.hash_mask, X.prev[Ie & X.w_mask] = X.head[X.ins_h], X.head[X.ins_h] = Ie, Ie++, X.insert--, !(X.lookahead + X.insert < D)); )
              ;
        } while (X.lookahead < W && X.strm.avail_in !== 0);
      }
      function V(X, ye) {
        for (var Ae, fe; ; ) {
          if (X.lookahead < W) {
            if (N(X), X.lookahead < W && ye === h)
              return P;
            if (X.lookahead === 0)
              break;
          }
          if (Ae = 0, X.lookahead >= D && (X.ins_h = (X.ins_h << X.hash_shift ^ X.window[X.strstart + D - 1]) & X.hash_mask, Ae = X.prev[X.strstart & X.w_mask] = X.head[X.ins_h], X.head[X.ins_h] = X.strstart), Ae !== 0 && X.strstart - Ae <= X.w_size - W && (X.match_length = I(X, Ae)), X.match_length >= D)
            if (fe = c._tr_tally(X, X.strstart - X.match_start, X.match_length - D), X.lookahead -= X.match_length, X.match_length <= X.max_lazy_match && X.lookahead >= D) {
              for (X.match_length--; X.strstart++, X.ins_h = (X.ins_h << X.hash_shift ^ X.window[X.strstart + D - 1]) & X.hash_mask, Ae = X.prev[X.strstart & X.w_mask] = X.head[X.ins_h], X.head[X.ins_h] = X.strstart, --X.match_length != 0; )
                ;
              X.strstart++;
            } else
              X.strstart += X.match_length, X.match_length = 0, X.ins_h = X.window[X.strstart], X.ins_h = (X.ins_h << X.hash_shift ^ X.window[X.strstart + 1]) & X.hash_mask;
          else
            fe = c._tr_tally(X, 0, X.window[X.strstart]), X.lookahead--, X.strstart++;
          if (fe && (U(X, !1), X.strm.avail_out === 0))
            return P;
        }
        return X.insert = X.strstart < D - 1 ? X.strstart : D - 1, ye === g ? (U(X, !0), X.strm.avail_out === 0 ? Y : ie) : X.last_lit && (U(X, !1), X.strm.avail_out === 0) ? P : Q;
      }
      function q(X, ye) {
        for (var Ae, fe, _e; ; ) {
          if (X.lookahead < W) {
            if (N(X), X.lookahead < W && ye === h)
              return P;
            if (X.lookahead === 0)
              break;
          }
          if (Ae = 0, X.lookahead >= D && (X.ins_h = (X.ins_h << X.hash_shift ^ X.window[X.strstart + D - 1]) & X.hash_mask, Ae = X.prev[X.strstart & X.w_mask] = X.head[X.ins_h], X.head[X.ins_h] = X.strstart), X.prev_length = X.match_length, X.prev_match = X.match_start, X.match_length = D - 1, Ae !== 0 && X.prev_length < X.max_lazy_match && X.strstart - Ae <= X.w_size - W && (X.match_length = I(X, Ae), X.match_length <= 5 && (X.strategy === 1 || X.match_length === D && 4096 < X.strstart - X.match_start) && (X.match_length = D - 1)), X.prev_length >= D && X.match_length <= X.prev_length) {
            for (_e = X.strstart + X.lookahead - D, fe = c._tr_tally(X, X.strstart - 1 - X.prev_match, X.prev_length - D), X.lookahead -= X.prev_length - 1, X.prev_length -= 2; ++X.strstart <= _e && (X.ins_h = (X.ins_h << X.hash_shift ^ X.window[X.strstart + D - 1]) & X.hash_mask, Ae = X.prev[X.strstart & X.w_mask] = X.head[X.ins_h], X.head[X.ins_h] = X.strstart), --X.prev_length != 0; )
              ;
            if (X.match_available = 0, X.match_length = D - 1, X.strstart++, fe && (U(X, !1), X.strm.avail_out === 0))
              return P;
          } else if (X.match_available) {
            if ((fe = c._tr_tally(X, 0, X.window[X.strstart - 1])) && U(X, !1), X.strstart++, X.lookahead--, X.strm.avail_out === 0)
              return P;
          } else
            X.match_available = 1, X.strstart++, X.lookahead--;
        }
        return X.match_available && (fe = c._tr_tally(X, 0, X.window[X.strstart - 1]), X.match_available = 0), X.insert = X.strstart < D - 1 ? X.strstart : D - 1, ye === g ? (U(X, !0), X.strm.avail_out === 0 ? Y : ie) : X.last_lit && (U(X, !1), X.strm.avail_out === 0) ? P : Q;
      }
      function H(X, ye, Ae, fe, _e) {
        this.good_length = X, this.max_lazy = ye, this.nice_length = Ae, this.max_chain = fe, this.func = _e;
      }
      function ne() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = A, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new l.Buf16(2 * R), this.dyn_dtree = new l.Buf16(2 * (2 * T + 1)), this.bl_tree = new l.Buf16(2 * (2 * w + 1)), ae(this.dyn_ltree), ae(this.dyn_dtree), ae(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new l.Buf16(O + 1), this.heap = new l.Buf16(2 * C + 1), ae(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new l.Buf16(2 * C + 1), ae(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function he(X) {
        var ye;
        return X && X.state ? (X.total_in = X.total_out = 0, X.data_type = y, (ye = X.state).pending = 0, ye.pending_out = 0, ye.wrap < 0 && (ye.wrap = -ye.wrap), ye.status = ye.wrap ? L : z, X.adler = ye.wrap === 2 ? 0 : 1, ye.last_flush = h, c._tr_init(ye), x) : te(X, E);
      }
      function j(X) {
        var ye = he(X);
        return ye === x && function(Ae) {
          Ae.window_size = 2 * Ae.w_size, ae(Ae.head), Ae.max_lazy_match = o[Ae.level].max_lazy, Ae.good_match = o[Ae.level].good_length, Ae.nice_match = o[Ae.level].nice_length, Ae.max_chain_length = o[Ae.level].max_chain, Ae.strstart = 0, Ae.block_start = 0, Ae.lookahead = 0, Ae.insert = 0, Ae.match_length = Ae.prev_length = D - 1, Ae.match_available = 0, Ae.ins_h = 0;
        }(X.state), ye;
      }
      function Fe(X, ye, Ae, fe, _e, Ie) {
        if (!X)
          return E;
        var Be = 1;
        if (ye === m && (ye = 6), fe < 0 ? (Be = 0, fe = -fe) : 15 < fe && (Be = 2, fe -= 16), _e < 1 || b < _e || Ae !== A || fe < 8 || 15 < fe || ye < 0 || 9 < ye || Ie < 0 || v < Ie)
          return te(X, E);
        fe === 8 && (fe = 9);
        var $e = new ne();
        return (X.state = $e).strm = X, $e.wrap = Be, $e.gzhead = null, $e.w_bits = fe, $e.w_size = 1 << $e.w_bits, $e.w_mask = $e.w_size - 1, $e.hash_bits = _e + 7, $e.hash_size = 1 << $e.hash_bits, $e.hash_mask = $e.hash_size - 1, $e.hash_shift = ~~(($e.hash_bits + D - 1) / D), $e.window = new l.Buf8(2 * $e.w_size), $e.head = new l.Buf16($e.hash_size), $e.prev = new l.Buf16($e.w_size), $e.lit_bufsize = 1 << _e + 6, $e.pending_buf_size = 4 * $e.lit_bufsize, $e.pending_buf = new l.Buf8($e.pending_buf_size), $e.d_buf = 1 * $e.lit_bufsize, $e.l_buf = 3 * $e.lit_bufsize, $e.level = ye, $e.strategy = Ie, $e.method = Ae, j(X);
      }
      o = [new H(0, 0, 0, 0, function(X, ye) {
        var Ae = 65535;
        for (Ae > X.pending_buf_size - 5 && (Ae = X.pending_buf_size - 5); ; ) {
          if (X.lookahead <= 1) {
            if (N(X), X.lookahead === 0 && ye === h)
              return P;
            if (X.lookahead === 0)
              break;
          }
          X.strstart += X.lookahead, X.lookahead = 0;
          var fe = X.block_start + Ae;
          if ((X.strstart === 0 || X.strstart >= fe) && (X.lookahead = X.strstart - fe, X.strstart = fe, U(X, !1), X.strm.avail_out === 0) || X.strstart - X.block_start >= X.w_size - W && (U(X, !1), X.strm.avail_out === 0))
            return P;
        }
        return X.insert = 0, ye === g ? (U(X, !0), X.strm.avail_out === 0 ? Y : ie) : (X.strstart > X.block_start && (U(X, !1), X.strm.avail_out), P);
      }), new H(4, 4, 8, 4, V), new H(4, 5, 16, 8, V), new H(4, 6, 32, 32, V), new H(4, 4, 16, 16, q), new H(8, 16, 32, 32, q), new H(8, 16, 128, 128, q), new H(8, 32, 128, 256, q), new H(32, 128, 258, 1024, q), new H(32, 258, 258, 4096, q)], s.deflateInit = function(X, ye) {
        return Fe(X, ye, A, 15, 8, 0);
      }, s.deflateInit2 = Fe, s.deflateReset = j, s.deflateResetKeep = he, s.deflateSetHeader = function(X, ye) {
        return X && X.state ? X.state.wrap !== 2 ? E : (X.state.gzhead = ye, x) : E;
      }, s.deflate = function(X, ye) {
        var Ae, fe, _e, Ie;
        if (!X || !X.state || 5 < ye || ye < 0)
          return X ? te(X, E) : E;
        if (fe = X.state, !X.output || !X.input && X.avail_in !== 0 || fe.status === 666 && ye !== g)
          return te(X, X.avail_out === 0 ? -5 : E);
        if (fe.strm = X, Ae = fe.last_flush, fe.last_flush = ye, fe.status === L)
          if (fe.wrap === 2)
            X.adler = 0, F(fe, 31), F(fe, 139), F(fe, 8), fe.gzhead ? (F(fe, (fe.gzhead.text ? 1 : 0) + (fe.gzhead.hcrc ? 2 : 0) + (fe.gzhead.extra ? 4 : 0) + (fe.gzhead.name ? 8 : 0) + (fe.gzhead.comment ? 16 : 0)), F(fe, 255 & fe.gzhead.time), F(fe, fe.gzhead.time >> 8 & 255), F(fe, fe.gzhead.time >> 16 & 255), F(fe, fe.gzhead.time >> 24 & 255), F(fe, fe.level === 9 ? 2 : 2 <= fe.strategy || fe.level < 2 ? 4 : 0), F(fe, 255 & fe.gzhead.os), fe.gzhead.extra && fe.gzhead.extra.length && (F(fe, 255 & fe.gzhead.extra.length), F(fe, fe.gzhead.extra.length >> 8 & 255)), fe.gzhead.hcrc && (X.adler = d(X.adler, fe.pending_buf, fe.pending, 0)), fe.gzindex = 0, fe.status = 69) : (F(fe, 0), F(fe, 0), F(fe, 0), F(fe, 0), F(fe, 0), F(fe, fe.level === 9 ? 2 : 2 <= fe.strategy || fe.level < 2 ? 4 : 0), F(fe, 3), fe.status = z);
          else {
            var Be = A + (fe.w_bits - 8 << 4) << 8;
            Be |= (2 <= fe.strategy || fe.level < 2 ? 0 : fe.level < 6 ? 1 : fe.level === 6 ? 2 : 3) << 6, fe.strstart !== 0 && (Be |= 32), Be += 31 - Be % 31, fe.status = z, M(fe, Be), fe.strstart !== 0 && (M(fe, X.adler >>> 16), M(fe, 65535 & X.adler)), X.adler = 1;
          }
        if (fe.status === 69)
          if (fe.gzhead.extra) {
            for (_e = fe.pending; fe.gzindex < (65535 & fe.gzhead.extra.length) && (fe.pending !== fe.pending_buf_size || (fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), G(X), _e = fe.pending, fe.pending !== fe.pending_buf_size)); )
              F(fe, 255 & fe.gzhead.extra[fe.gzindex]), fe.gzindex++;
            fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), fe.gzindex === fe.gzhead.extra.length && (fe.gzindex = 0, fe.status = 73);
          } else
            fe.status = 73;
        if (fe.status === 73)
          if (fe.gzhead.name) {
            _e = fe.pending;
            do {
              if (fe.pending === fe.pending_buf_size && (fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), G(X), _e = fe.pending, fe.pending === fe.pending_buf_size)) {
                Ie = 1;
                break;
              }
              Ie = fe.gzindex < fe.gzhead.name.length ? 255 & fe.gzhead.name.charCodeAt(fe.gzindex++) : 0, F(fe, Ie);
            } while (Ie !== 0);
            fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), Ie === 0 && (fe.gzindex = 0, fe.status = 91);
          } else
            fe.status = 91;
        if (fe.status === 91)
          if (fe.gzhead.comment) {
            _e = fe.pending;
            do {
              if (fe.pending === fe.pending_buf_size && (fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), G(X), _e = fe.pending, fe.pending === fe.pending_buf_size)) {
                Ie = 1;
                break;
              }
              Ie = fe.gzindex < fe.gzhead.comment.length ? 255 & fe.gzhead.comment.charCodeAt(fe.gzindex++) : 0, F(fe, Ie);
            } while (Ie !== 0);
            fe.gzhead.hcrc && fe.pending > _e && (X.adler = d(X.adler, fe.pending_buf, fe.pending - _e, _e)), Ie === 0 && (fe.status = 103);
          } else
            fe.status = 103;
        if (fe.status === 103 && (fe.gzhead.hcrc ? (fe.pending + 2 > fe.pending_buf_size && G(X), fe.pending + 2 <= fe.pending_buf_size && (F(fe, 255 & X.adler), F(fe, X.adler >> 8 & 255), X.adler = 0, fe.status = z)) : fe.status = z), fe.pending !== 0) {
          if (G(X), X.avail_out === 0)
            return fe.last_flush = -1, x;
        } else if (X.avail_in === 0 && Z(ye) <= Z(Ae) && ye !== g)
          return te(X, -5);
        if (fe.status === 666 && X.avail_in !== 0)
          return te(X, -5);
        if (X.avail_in !== 0 || fe.lookahead !== 0 || ye !== h && fe.status !== 666) {
          var $e = fe.strategy === 2 ? function(Me, J) {
            for (var K; ; ) {
              if (Me.lookahead === 0 && (N(Me), Me.lookahead === 0)) {
                if (J === h)
                  return P;
                break;
              }
              if (Me.match_length = 0, K = c._tr_tally(Me, 0, Me.window[Me.strstart]), Me.lookahead--, Me.strstart++, K && (U(Me, !1), Me.strm.avail_out === 0))
                return P;
            }
            return Me.insert = 0, J === g ? (U(Me, !0), Me.strm.avail_out === 0 ? Y : ie) : Me.last_lit && (U(Me, !1), Me.strm.avail_out === 0) ? P : Q;
          }(fe, ye) : fe.strategy === 3 ? function(Me, J) {
            for (var K, ge, Ce, Oe, qe = Me.window; ; ) {
              if (Me.lookahead <= k) {
                if (N(Me), Me.lookahead <= k && J === h)
                  return P;
                if (Me.lookahead === 0)
                  break;
              }
              if (Me.match_length = 0, Me.lookahead >= D && 0 < Me.strstart && (ge = qe[Ce = Me.strstart - 1]) === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce]) {
                Oe = Me.strstart + k;
                do
                  ;
                while (ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && ge === qe[++Ce] && Ce < Oe);
                Me.match_length = k - (Oe - Ce), Me.match_length > Me.lookahead && (Me.match_length = Me.lookahead);
              }
              if (Me.match_length >= D ? (K = c._tr_tally(Me, 1, Me.match_length - D), Me.lookahead -= Me.match_length, Me.strstart += Me.match_length, Me.match_length = 0) : (K = c._tr_tally(Me, 0, Me.window[Me.strstart]), Me.lookahead--, Me.strstart++), K && (U(Me, !1), Me.strm.avail_out === 0))
                return P;
            }
            return Me.insert = 0, J === g ? (U(Me, !0), Me.strm.avail_out === 0 ? Y : ie) : Me.last_lit && (U(Me, !1), Me.strm.avail_out === 0) ? P : Q;
          }(fe, ye) : o[fe.level].func(fe, ye);
          if ($e !== Y && $e !== ie || (fe.status = 666), $e === P || $e === Y)
            return X.avail_out === 0 && (fe.last_flush = -1), x;
          if ($e === Q && (ye === 1 ? c._tr_align(fe) : ye !== 5 && (c._tr_stored_block(fe, 0, 0, !1), ye === 3 && (ae(fe.head), fe.lookahead === 0 && (fe.strstart = 0, fe.block_start = 0, fe.insert = 0))), G(X), X.avail_out === 0))
            return fe.last_flush = -1, x;
        }
        return ye !== g ? x : fe.wrap <= 0 ? 1 : (fe.wrap === 2 ? (F(fe, 255 & X.adler), F(fe, X.adler >> 8 & 255), F(fe, X.adler >> 16 & 255), F(fe, X.adler >> 24 & 255), F(fe, 255 & X.total_in), F(fe, X.total_in >> 8 & 255), F(fe, X.total_in >> 16 & 255), F(fe, X.total_in >> 24 & 255)) : (M(fe, X.adler >>> 16), M(fe, 65535 & X.adler)), G(X), 0 < fe.wrap && (fe.wrap = -fe.wrap), fe.pending !== 0 ? x : 1);
      }, s.deflateEnd = function(X) {
        var ye;
        return X && X.state ? (ye = X.state.status) !== L && ye !== 69 && ye !== 73 && ye !== 91 && ye !== 103 && ye !== z && ye !== 666 ? te(X, E) : (X.state = null, ye === z ? te(X, -3) : x) : E;
      }, s.deflateSetDictionary = function(X, ye) {
        var Ae, fe, _e, Ie, Be, $e, Me, J, K = ye.length;
        if (!X || !X.state || (Ie = (Ae = X.state).wrap) === 2 || Ie === 1 && Ae.status !== L || Ae.lookahead)
          return E;
        for (Ie === 1 && (X.adler = u(X.adler, ye, K, 0)), Ae.wrap = 0, K >= Ae.w_size && (Ie === 0 && (ae(Ae.head), Ae.strstart = 0, Ae.block_start = 0, Ae.insert = 0), J = new l.Buf8(Ae.w_size), l.arraySet(J, ye, K - Ae.w_size, Ae.w_size, 0), ye = J, K = Ae.w_size), Be = X.avail_in, $e = X.next_in, Me = X.input, X.avail_in = K, X.next_in = 0, X.input = ye, N(Ae); Ae.lookahead >= D; ) {
          for (fe = Ae.strstart, _e = Ae.lookahead - (D - 1); Ae.ins_h = (Ae.ins_h << Ae.hash_shift ^ Ae.window[fe + D - 1]) & Ae.hash_mask, Ae.prev[fe & Ae.w_mask] = Ae.head[Ae.ins_h], Ae.head[Ae.ins_h] = fe, fe++, --_e; )
            ;
          Ae.strstart = fe, Ae.lookahead = D - 1, N(Ae);
        }
        return Ae.strstart += Ae.lookahead, Ae.block_start = Ae.strstart, Ae.insert = Ae.lookahead, Ae.lookahead = 0, Ae.match_length = Ae.prev_length = D - 1, Ae.match_available = 0, X.next_in = $e, X.input = Me, X.avail_in = Be, Ae.wrap = Ie, x;
      }, s.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(n, a, s) {
      a.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(n, a, s) {
      a.exports = function(o, l) {
        var c, u, d, f, h, g, x, E, m, v, y, A, b, C, T, w, R, O, D, k, W, L, z, P, Q;
        c = o.state, u = o.next_in, P = o.input, d = u + (o.avail_in - 5), f = o.next_out, Q = o.output, h = f - (l - o.avail_out), g = f + (o.avail_out - 257), x = c.dmax, E = c.wsize, m = c.whave, v = c.wnext, y = c.window, A = c.hold, b = c.bits, C = c.lencode, T = c.distcode, w = (1 << c.lenbits) - 1, R = (1 << c.distbits) - 1;
        e:
          do {
            b < 15 && (A += P[u++] << b, b += 8, A += P[u++] << b, b += 8), O = C[A & w];
            t:
              for (; ; ) {
                if (A >>>= D = O >>> 24, b -= D, (D = O >>> 16 & 255) === 0)
                  Q[f++] = 65535 & O;
                else {
                  if (!(16 & D)) {
                    if (!(64 & D)) {
                      O = C[(65535 & O) + (A & (1 << D) - 1)];
                      continue t;
                    }
                    if (32 & D) {
                      c.mode = 12;
                      break e;
                    }
                    o.msg = "invalid literal/length code", c.mode = 30;
                    break e;
                  }
                  k = 65535 & O, (D &= 15) && (b < D && (A += P[u++] << b, b += 8), k += A & (1 << D) - 1, A >>>= D, b -= D), b < 15 && (A += P[u++] << b, b += 8, A += P[u++] << b, b += 8), O = T[A & R];
                  n:
                    for (; ; ) {
                      if (A >>>= D = O >>> 24, b -= D, !(16 & (D = O >>> 16 & 255))) {
                        if (!(64 & D)) {
                          O = T[(65535 & O) + (A & (1 << D) - 1)];
                          continue n;
                        }
                        o.msg = "invalid distance code", c.mode = 30;
                        break e;
                      }
                      if (W = 65535 & O, b < (D &= 15) && (A += P[u++] << b, (b += 8) < D && (A += P[u++] << b, b += 8)), x < (W += A & (1 << D) - 1)) {
                        o.msg = "invalid distance too far back", c.mode = 30;
                        break e;
                      }
                      if (A >>>= D, b -= D, (D = f - h) < W) {
                        if (m < (D = W - D) && c.sane) {
                          o.msg = "invalid distance too far back", c.mode = 30;
                          break e;
                        }
                        if (z = y, (L = 0) === v) {
                          if (L += E - D, D < k) {
                            for (k -= D; Q[f++] = y[L++], --D; )
                              ;
                            L = f - W, z = Q;
                          }
                        } else if (v < D) {
                          if (L += E + v - D, (D -= v) < k) {
                            for (k -= D; Q[f++] = y[L++], --D; )
                              ;
                            if (L = 0, v < k) {
                              for (k -= D = v; Q[f++] = y[L++], --D; )
                                ;
                              L = f - W, z = Q;
                            }
                          }
                        } else if (L += v - D, D < k) {
                          for (k -= D; Q[f++] = y[L++], --D; )
                            ;
                          L = f - W, z = Q;
                        }
                        for (; 2 < k; )
                          Q[f++] = z[L++], Q[f++] = z[L++], Q[f++] = z[L++], k -= 3;
                        k && (Q[f++] = z[L++], 1 < k && (Q[f++] = z[L++]));
                      } else {
                        for (L = f - W; Q[f++] = Q[L++], Q[f++] = Q[L++], Q[f++] = Q[L++], 2 < (k -= 3); )
                          ;
                        k && (Q[f++] = Q[L++], 1 < k && (Q[f++] = Q[L++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (u < d && f < g);
        u -= k = b >> 3, A &= (1 << (b -= k << 3)) - 1, o.next_in = u, o.next_out = f, o.avail_in = u < d ? d - u + 5 : 5 - (u - d), o.avail_out = f < g ? g - f + 257 : 257 - (f - g), c.hold = A, c.bits = b;
      };
    }, {}], 49: [function(n, a, s) {
      var o = n("../utils/common"), l = n("./adler32"), c = n("./crc32"), u = n("./inffast"), d = n("./inftrees"), f = 1, h = 2, g = 0, x = -2, E = 1, m = 852, v = 592;
      function y(L) {
        return (L >>> 24 & 255) + (L >>> 8 & 65280) + ((65280 & L) << 8) + ((255 & L) << 24);
      }
      function A() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new o.Buf16(320), this.work = new o.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function b(L) {
        var z;
        return L && L.state ? (z = L.state, L.total_in = L.total_out = z.total = 0, L.msg = "", z.wrap && (L.adler = 1 & z.wrap), z.mode = E, z.last = 0, z.havedict = 0, z.dmax = 32768, z.head = null, z.hold = 0, z.bits = 0, z.lencode = z.lendyn = new o.Buf32(m), z.distcode = z.distdyn = new o.Buf32(v), z.sane = 1, z.back = -1, g) : x;
      }
      function C(L) {
        var z;
        return L && L.state ? ((z = L.state).wsize = 0, z.whave = 0, z.wnext = 0, b(L)) : x;
      }
      function T(L, z) {
        var P, Q;
        return L && L.state ? (Q = L.state, z < 0 ? (P = 0, z = -z) : (P = 1 + (z >> 4), z < 48 && (z &= 15)), z && (z < 8 || 15 < z) ? x : (Q.window !== null && Q.wbits !== z && (Q.window = null), Q.wrap = P, Q.wbits = z, C(L))) : x;
      }
      function w(L, z) {
        var P, Q;
        return L ? (Q = new A(), (L.state = Q).window = null, (P = T(L, z)) !== g && (L.state = null), P) : x;
      }
      var R, O, D = !0;
      function k(L) {
        if (D) {
          var z;
          for (R = new o.Buf32(512), O = new o.Buf32(32), z = 0; z < 144; )
            L.lens[z++] = 8;
          for (; z < 256; )
            L.lens[z++] = 9;
          for (; z < 280; )
            L.lens[z++] = 7;
          for (; z < 288; )
            L.lens[z++] = 8;
          for (d(f, L.lens, 0, 288, R, 0, L.work, { bits: 9 }), z = 0; z < 32; )
            L.lens[z++] = 5;
          d(h, L.lens, 0, 32, O, 0, L.work, { bits: 5 }), D = !1;
        }
        L.lencode = R, L.lenbits = 9, L.distcode = O, L.distbits = 5;
      }
      function W(L, z, P, Q) {
        var Y, ie = L.state;
        return ie.window === null && (ie.wsize = 1 << ie.wbits, ie.wnext = 0, ie.whave = 0, ie.window = new o.Buf8(ie.wsize)), Q >= ie.wsize ? (o.arraySet(ie.window, z, P - ie.wsize, ie.wsize, 0), ie.wnext = 0, ie.whave = ie.wsize) : (Q < (Y = ie.wsize - ie.wnext) && (Y = Q), o.arraySet(ie.window, z, P - Q, Y, ie.wnext), (Q -= Y) ? (o.arraySet(ie.window, z, P - Q, Q, 0), ie.wnext = Q, ie.whave = ie.wsize) : (ie.wnext += Y, ie.wnext === ie.wsize && (ie.wnext = 0), ie.whave < ie.wsize && (ie.whave += Y))), 0;
      }
      s.inflateReset = C, s.inflateReset2 = T, s.inflateResetKeep = b, s.inflateInit = function(L) {
        return w(L, 15);
      }, s.inflateInit2 = w, s.inflate = function(L, z) {
        var P, Q, Y, ie, te, Z, ae, G, U, F, M, I, N, V, q, H, ne, he, j, Fe, X, ye, Ae, fe, _e = 0, Ie = new o.Buf8(4), Be = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!L || !L.state || !L.output || !L.input && L.avail_in !== 0)
          return x;
        (P = L.state).mode === 12 && (P.mode = 13), te = L.next_out, Y = L.output, ae = L.avail_out, ie = L.next_in, Q = L.input, Z = L.avail_in, G = P.hold, U = P.bits, F = Z, M = ae, ye = g;
        e:
          for (; ; )
            switch (P.mode) {
              case E:
                if (P.wrap === 0) {
                  P.mode = 13;
                  break;
                }
                for (; U < 16; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if (2 & P.wrap && G === 35615) {
                  Ie[P.check = 0] = 255 & G, Ie[1] = G >>> 8 & 255, P.check = c(P.check, Ie, 2, 0), U = G = 0, P.mode = 2;
                  break;
                }
                if (P.flags = 0, P.head && (P.head.done = !1), !(1 & P.wrap) || (((255 & G) << 8) + (G >> 8)) % 31) {
                  L.msg = "incorrect header check", P.mode = 30;
                  break;
                }
                if ((15 & G) != 8) {
                  L.msg = "unknown compression method", P.mode = 30;
                  break;
                }
                if (U -= 4, X = 8 + (15 & (G >>>= 4)), P.wbits === 0)
                  P.wbits = X;
                else if (X > P.wbits) {
                  L.msg = "invalid window size", P.mode = 30;
                  break;
                }
                P.dmax = 1 << X, L.adler = P.check = 1, P.mode = 512 & G ? 10 : 12, U = G = 0;
                break;
              case 2:
                for (; U < 16; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if (P.flags = G, (255 & P.flags) != 8) {
                  L.msg = "unknown compression method", P.mode = 30;
                  break;
                }
                if (57344 & P.flags) {
                  L.msg = "unknown header flags set", P.mode = 30;
                  break;
                }
                P.head && (P.head.text = G >> 8 & 1), 512 & P.flags && (Ie[0] = 255 & G, Ie[1] = G >>> 8 & 255, P.check = c(P.check, Ie, 2, 0)), U = G = 0, P.mode = 3;
              case 3:
                for (; U < 32; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                P.head && (P.head.time = G), 512 & P.flags && (Ie[0] = 255 & G, Ie[1] = G >>> 8 & 255, Ie[2] = G >>> 16 & 255, Ie[3] = G >>> 24 & 255, P.check = c(P.check, Ie, 4, 0)), U = G = 0, P.mode = 4;
              case 4:
                for (; U < 16; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                P.head && (P.head.xflags = 255 & G, P.head.os = G >> 8), 512 & P.flags && (Ie[0] = 255 & G, Ie[1] = G >>> 8 & 255, P.check = c(P.check, Ie, 2, 0)), U = G = 0, P.mode = 5;
              case 5:
                if (1024 & P.flags) {
                  for (; U < 16; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  P.length = G, P.head && (P.head.extra_len = G), 512 & P.flags && (Ie[0] = 255 & G, Ie[1] = G >>> 8 & 255, P.check = c(P.check, Ie, 2, 0)), U = G = 0;
                } else
                  P.head && (P.head.extra = null);
                P.mode = 6;
              case 6:
                if (1024 & P.flags && (Z < (I = P.length) && (I = Z), I && (P.head && (X = P.head.extra_len - P.length, P.head.extra || (P.head.extra = new Array(P.head.extra_len)), o.arraySet(P.head.extra, Q, ie, I, X)), 512 & P.flags && (P.check = c(P.check, Q, I, ie)), Z -= I, ie += I, P.length -= I), P.length))
                  break e;
                P.length = 0, P.mode = 7;
              case 7:
                if (2048 & P.flags) {
                  if (Z === 0)
                    break e;
                  for (I = 0; X = Q[ie + I++], P.head && X && P.length < 65536 && (P.head.name += String.fromCharCode(X)), X && I < Z; )
                    ;
                  if (512 & P.flags && (P.check = c(P.check, Q, I, ie)), Z -= I, ie += I, X)
                    break e;
                } else
                  P.head && (P.head.name = null);
                P.length = 0, P.mode = 8;
              case 8:
                if (4096 & P.flags) {
                  if (Z === 0)
                    break e;
                  for (I = 0; X = Q[ie + I++], P.head && X && P.length < 65536 && (P.head.comment += String.fromCharCode(X)), X && I < Z; )
                    ;
                  if (512 & P.flags && (P.check = c(P.check, Q, I, ie)), Z -= I, ie += I, X)
                    break e;
                } else
                  P.head && (P.head.comment = null);
                P.mode = 9;
              case 9:
                if (512 & P.flags) {
                  for (; U < 16; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  if (G !== (65535 & P.check)) {
                    L.msg = "header crc mismatch", P.mode = 30;
                    break;
                  }
                  U = G = 0;
                }
                P.head && (P.head.hcrc = P.flags >> 9 & 1, P.head.done = !0), L.adler = P.check = 0, P.mode = 12;
                break;
              case 10:
                for (; U < 32; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                L.adler = P.check = y(G), U = G = 0, P.mode = 11;
              case 11:
                if (P.havedict === 0)
                  return L.next_out = te, L.avail_out = ae, L.next_in = ie, L.avail_in = Z, P.hold = G, P.bits = U, 2;
                L.adler = P.check = 1, P.mode = 12;
              case 12:
                if (z === 5 || z === 6)
                  break e;
              case 13:
                if (P.last) {
                  G >>>= 7 & U, U -= 7 & U, P.mode = 27;
                  break;
                }
                for (; U < 3; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                switch (P.last = 1 & G, U -= 1, 3 & (G >>>= 1)) {
                  case 0:
                    P.mode = 14;
                    break;
                  case 1:
                    if (k(P), P.mode = 20, z !== 6)
                      break;
                    G >>>= 2, U -= 2;
                    break e;
                  case 2:
                    P.mode = 17;
                    break;
                  case 3:
                    L.msg = "invalid block type", P.mode = 30;
                }
                G >>>= 2, U -= 2;
                break;
              case 14:
                for (G >>>= 7 & U, U -= 7 & U; U < 32; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if ((65535 & G) != (G >>> 16 ^ 65535)) {
                  L.msg = "invalid stored block lengths", P.mode = 30;
                  break;
                }
                if (P.length = 65535 & G, U = G = 0, P.mode = 15, z === 6)
                  break e;
              case 15:
                P.mode = 16;
              case 16:
                if (I = P.length) {
                  if (Z < I && (I = Z), ae < I && (I = ae), I === 0)
                    break e;
                  o.arraySet(Y, Q, ie, I, te), Z -= I, ie += I, ae -= I, te += I, P.length -= I;
                  break;
                }
                P.mode = 12;
                break;
              case 17:
                for (; U < 14; ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if (P.nlen = 257 + (31 & G), G >>>= 5, U -= 5, P.ndist = 1 + (31 & G), G >>>= 5, U -= 5, P.ncode = 4 + (15 & G), G >>>= 4, U -= 4, 286 < P.nlen || 30 < P.ndist) {
                  L.msg = "too many length or distance symbols", P.mode = 30;
                  break;
                }
                P.have = 0, P.mode = 18;
              case 18:
                for (; P.have < P.ncode; ) {
                  for (; U < 3; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  P.lens[Be[P.have++]] = 7 & G, G >>>= 3, U -= 3;
                }
                for (; P.have < 19; )
                  P.lens[Be[P.have++]] = 0;
                if (P.lencode = P.lendyn, P.lenbits = 7, Ae = { bits: P.lenbits }, ye = d(0, P.lens, 0, 19, P.lencode, 0, P.work, Ae), P.lenbits = Ae.bits, ye) {
                  L.msg = "invalid code lengths set", P.mode = 30;
                  break;
                }
                P.have = 0, P.mode = 19;
              case 19:
                for (; P.have < P.nlen + P.ndist; ) {
                  for (; H = (_e = P.lencode[G & (1 << P.lenbits) - 1]) >>> 16 & 255, ne = 65535 & _e, !((q = _e >>> 24) <= U); ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  if (ne < 16)
                    G >>>= q, U -= q, P.lens[P.have++] = ne;
                  else {
                    if (ne === 16) {
                      for (fe = q + 2; U < fe; ) {
                        if (Z === 0)
                          break e;
                        Z--, G += Q[ie++] << U, U += 8;
                      }
                      if (G >>>= q, U -= q, P.have === 0) {
                        L.msg = "invalid bit length repeat", P.mode = 30;
                        break;
                      }
                      X = P.lens[P.have - 1], I = 3 + (3 & G), G >>>= 2, U -= 2;
                    } else if (ne === 17) {
                      for (fe = q + 3; U < fe; ) {
                        if (Z === 0)
                          break e;
                        Z--, G += Q[ie++] << U, U += 8;
                      }
                      U -= q, X = 0, I = 3 + (7 & (G >>>= q)), G >>>= 3, U -= 3;
                    } else {
                      for (fe = q + 7; U < fe; ) {
                        if (Z === 0)
                          break e;
                        Z--, G += Q[ie++] << U, U += 8;
                      }
                      U -= q, X = 0, I = 11 + (127 & (G >>>= q)), G >>>= 7, U -= 7;
                    }
                    if (P.have + I > P.nlen + P.ndist) {
                      L.msg = "invalid bit length repeat", P.mode = 30;
                      break;
                    }
                    for (; I--; )
                      P.lens[P.have++] = X;
                  }
                }
                if (P.mode === 30)
                  break;
                if (P.lens[256] === 0) {
                  L.msg = "invalid code -- missing end-of-block", P.mode = 30;
                  break;
                }
                if (P.lenbits = 9, Ae = { bits: P.lenbits }, ye = d(f, P.lens, 0, P.nlen, P.lencode, 0, P.work, Ae), P.lenbits = Ae.bits, ye) {
                  L.msg = "invalid literal/lengths set", P.mode = 30;
                  break;
                }
                if (P.distbits = 6, P.distcode = P.distdyn, Ae = { bits: P.distbits }, ye = d(h, P.lens, P.nlen, P.ndist, P.distcode, 0, P.work, Ae), P.distbits = Ae.bits, ye) {
                  L.msg = "invalid distances set", P.mode = 30;
                  break;
                }
                if (P.mode = 20, z === 6)
                  break e;
              case 20:
                P.mode = 21;
              case 21:
                if (6 <= Z && 258 <= ae) {
                  L.next_out = te, L.avail_out = ae, L.next_in = ie, L.avail_in = Z, P.hold = G, P.bits = U, u(L, M), te = L.next_out, Y = L.output, ae = L.avail_out, ie = L.next_in, Q = L.input, Z = L.avail_in, G = P.hold, U = P.bits, P.mode === 12 && (P.back = -1);
                  break;
                }
                for (P.back = 0; H = (_e = P.lencode[G & (1 << P.lenbits) - 1]) >>> 16 & 255, ne = 65535 & _e, !((q = _e >>> 24) <= U); ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if (H && !(240 & H)) {
                  for (he = q, j = H, Fe = ne; H = (_e = P.lencode[Fe + ((G & (1 << he + j) - 1) >> he)]) >>> 16 & 255, ne = 65535 & _e, !(he + (q = _e >>> 24) <= U); ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  G >>>= he, U -= he, P.back += he;
                }
                if (G >>>= q, U -= q, P.back += q, P.length = ne, H === 0) {
                  P.mode = 26;
                  break;
                }
                if (32 & H) {
                  P.back = -1, P.mode = 12;
                  break;
                }
                if (64 & H) {
                  L.msg = "invalid literal/length code", P.mode = 30;
                  break;
                }
                P.extra = 15 & H, P.mode = 22;
              case 22:
                if (P.extra) {
                  for (fe = P.extra; U < fe; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  P.length += G & (1 << P.extra) - 1, G >>>= P.extra, U -= P.extra, P.back += P.extra;
                }
                P.was = P.length, P.mode = 23;
              case 23:
                for (; H = (_e = P.distcode[G & (1 << P.distbits) - 1]) >>> 16 & 255, ne = 65535 & _e, !((q = _e >>> 24) <= U); ) {
                  if (Z === 0)
                    break e;
                  Z--, G += Q[ie++] << U, U += 8;
                }
                if (!(240 & H)) {
                  for (he = q, j = H, Fe = ne; H = (_e = P.distcode[Fe + ((G & (1 << he + j) - 1) >> he)]) >>> 16 & 255, ne = 65535 & _e, !(he + (q = _e >>> 24) <= U); ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  G >>>= he, U -= he, P.back += he;
                }
                if (G >>>= q, U -= q, P.back += q, 64 & H) {
                  L.msg = "invalid distance code", P.mode = 30;
                  break;
                }
                P.offset = ne, P.extra = 15 & H, P.mode = 24;
              case 24:
                if (P.extra) {
                  for (fe = P.extra; U < fe; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  P.offset += G & (1 << P.extra) - 1, G >>>= P.extra, U -= P.extra, P.back += P.extra;
                }
                if (P.offset > P.dmax) {
                  L.msg = "invalid distance too far back", P.mode = 30;
                  break;
                }
                P.mode = 25;
              case 25:
                if (ae === 0)
                  break e;
                if (I = M - ae, P.offset > I) {
                  if ((I = P.offset - I) > P.whave && P.sane) {
                    L.msg = "invalid distance too far back", P.mode = 30;
                    break;
                  }
                  N = I > P.wnext ? (I -= P.wnext, P.wsize - I) : P.wnext - I, I > P.length && (I = P.length), V = P.window;
                } else
                  V = Y, N = te - P.offset, I = P.length;
                for (ae < I && (I = ae), ae -= I, P.length -= I; Y[te++] = V[N++], --I; )
                  ;
                P.length === 0 && (P.mode = 21);
                break;
              case 26:
                if (ae === 0)
                  break e;
                Y[te++] = P.length, ae--, P.mode = 21;
                break;
              case 27:
                if (P.wrap) {
                  for (; U < 32; ) {
                    if (Z === 0)
                      break e;
                    Z--, G |= Q[ie++] << U, U += 8;
                  }
                  if (M -= ae, L.total_out += M, P.total += M, M && (L.adler = P.check = P.flags ? c(P.check, Y, M, te - M) : l(P.check, Y, M, te - M)), M = ae, (P.flags ? G : y(G)) !== P.check) {
                    L.msg = "incorrect data check", P.mode = 30;
                    break;
                  }
                  U = G = 0;
                }
                P.mode = 28;
              case 28:
                if (P.wrap && P.flags) {
                  for (; U < 32; ) {
                    if (Z === 0)
                      break e;
                    Z--, G += Q[ie++] << U, U += 8;
                  }
                  if (G !== (4294967295 & P.total)) {
                    L.msg = "incorrect length check", P.mode = 30;
                    break;
                  }
                  U = G = 0;
                }
                P.mode = 29;
              case 29:
                ye = 1;
                break e;
              case 30:
                ye = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return x;
            }
        return L.next_out = te, L.avail_out = ae, L.next_in = ie, L.avail_in = Z, P.hold = G, P.bits = U, (P.wsize || M !== L.avail_out && P.mode < 30 && (P.mode < 27 || z !== 4)) && W(L, L.output, L.next_out, M - L.avail_out) ? (P.mode = 31, -4) : (F -= L.avail_in, M -= L.avail_out, L.total_in += F, L.total_out += M, P.total += M, P.wrap && M && (L.adler = P.check = P.flags ? c(P.check, Y, M, L.next_out - M) : l(P.check, Y, M, L.next_out - M)), L.data_type = P.bits + (P.last ? 64 : 0) + (P.mode === 12 ? 128 : 0) + (P.mode === 20 || P.mode === 15 ? 256 : 0), (F == 0 && M === 0 || z === 4) && ye === g && (ye = -5), ye);
      }, s.inflateEnd = function(L) {
        if (!L || !L.state)
          return x;
        var z = L.state;
        return z.window && (z.window = null), L.state = null, g;
      }, s.inflateGetHeader = function(L, z) {
        var P;
        return L && L.state && 2 & (P = L.state).wrap ? ((P.head = z).done = !1, g) : x;
      }, s.inflateSetDictionary = function(L, z) {
        var P, Q = z.length;
        return L && L.state ? (P = L.state).wrap !== 0 && P.mode !== 11 ? x : P.mode === 11 && l(1, z, Q, 0) !== P.check ? -3 : W(L, z, Q, Q) ? (P.mode = 31, -4) : (P.havedict = 1, g) : x;
      }, s.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(n, a, s) {
      var o = n("../utils/common"), l = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], c = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], u = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], d = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      a.exports = function(f, h, g, x, E, m, v, y) {
        var A, b, C, T, w, R, O, D, k, W = y.bits, L = 0, z = 0, P = 0, Q = 0, Y = 0, ie = 0, te = 0, Z = 0, ae = 0, G = 0, U = null, F = 0, M = new o.Buf16(16), I = new o.Buf16(16), N = null, V = 0;
        for (L = 0; L <= 15; L++)
          M[L] = 0;
        for (z = 0; z < x; z++)
          M[h[g + z]]++;
        for (Y = W, Q = 15; 1 <= Q && M[Q] === 0; Q--)
          ;
        if (Q < Y && (Y = Q), Q === 0)
          return E[m++] = 20971520, E[m++] = 20971520, y.bits = 1, 0;
        for (P = 1; P < Q && M[P] === 0; P++)
          ;
        for (Y < P && (Y = P), L = Z = 1; L <= 15; L++)
          if (Z <<= 1, (Z -= M[L]) < 0)
            return -1;
        if (0 < Z && (f === 0 || Q !== 1))
          return -1;
        for (I[1] = 0, L = 1; L < 15; L++)
          I[L + 1] = I[L] + M[L];
        for (z = 0; z < x; z++)
          h[g + z] !== 0 && (v[I[h[g + z]]++] = z);
        if (R = f === 0 ? (U = N = v, 19) : f === 1 ? (U = l, F -= 257, N = c, V -= 257, 256) : (U = u, N = d, -1), L = P, w = m, te = z = G = 0, C = -1, T = (ae = 1 << (ie = Y)) - 1, f === 1 && 852 < ae || f === 2 && 592 < ae)
          return 1;
        for (; ; ) {
          for (O = L - te, k = v[z] < R ? (D = 0, v[z]) : v[z] > R ? (D = N[V + v[z]], U[F + v[z]]) : (D = 96, 0), A = 1 << L - te, P = b = 1 << ie; E[w + (G >> te) + (b -= A)] = O << 24 | D << 16 | k | 0, b !== 0; )
            ;
          for (A = 1 << L - 1; G & A; )
            A >>= 1;
          if (A !== 0 ? (G &= A - 1, G += A) : G = 0, z++, --M[L] == 0) {
            if (L === Q)
              break;
            L = h[g + v[z]];
          }
          if (Y < L && (G & T) !== C) {
            for (te === 0 && (te = Y), w += P, Z = 1 << (ie = L - te); ie + te < Q && !((Z -= M[ie + te]) <= 0); )
              ie++, Z <<= 1;
            if (ae += 1 << ie, f === 1 && 852 < ae || f === 2 && 592 < ae)
              return 1;
            E[C = G & T] = Y << 24 | ie << 16 | w - m | 0;
          }
        }
        return G !== 0 && (E[w + G] = L - te << 24 | 64 << 16 | 0), y.bits = Y, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(n, a, s) {
      a.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(n, a, s) {
      var o = n("../utils/common"), l = 0, c = 1;
      function u(_e) {
        for (var Ie = _e.length; 0 <= --Ie; )
          _e[Ie] = 0;
      }
      var d = 0, f = 29, h = 256, g = h + 1 + f, x = 30, E = 19, m = 2 * g + 1, v = 15, y = 16, A = 7, b = 256, C = 16, T = 17, w = 18, R = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], O = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], D = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], k = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], W = new Array(2 * (g + 2));
      u(W);
      var L = new Array(2 * x);
      u(L);
      var z = new Array(512);
      u(z);
      var P = new Array(256);
      u(P);
      var Q = new Array(f);
      u(Q);
      var Y, ie, te, Z = new Array(x);
      function ae(_e, Ie, Be, $e, Me) {
        this.static_tree = _e, this.extra_bits = Ie, this.extra_base = Be, this.elems = $e, this.max_length = Me, this.has_stree = _e && _e.length;
      }
      function G(_e, Ie) {
        this.dyn_tree = _e, this.max_code = 0, this.stat_desc = Ie;
      }
      function U(_e) {
        return _e < 256 ? z[_e] : z[256 + (_e >>> 7)];
      }
      function F(_e, Ie) {
        _e.pending_buf[_e.pending++] = 255 & Ie, _e.pending_buf[_e.pending++] = Ie >>> 8 & 255;
      }
      function M(_e, Ie, Be) {
        _e.bi_valid > y - Be ? (_e.bi_buf |= Ie << _e.bi_valid & 65535, F(_e, _e.bi_buf), _e.bi_buf = Ie >> y - _e.bi_valid, _e.bi_valid += Be - y) : (_e.bi_buf |= Ie << _e.bi_valid & 65535, _e.bi_valid += Be);
      }
      function I(_e, Ie, Be) {
        M(_e, Be[2 * Ie], Be[2 * Ie + 1]);
      }
      function N(_e, Ie) {
        for (var Be = 0; Be |= 1 & _e, _e >>>= 1, Be <<= 1, 0 < --Ie; )
          ;
        return Be >>> 1;
      }
      function V(_e, Ie, Be) {
        var $e, Me, J = new Array(v + 1), K = 0;
        for ($e = 1; $e <= v; $e++)
          J[$e] = K = K + Be[$e - 1] << 1;
        for (Me = 0; Me <= Ie; Me++) {
          var ge = _e[2 * Me + 1];
          ge !== 0 && (_e[2 * Me] = N(J[ge]++, ge));
        }
      }
      function q(_e) {
        var Ie;
        for (Ie = 0; Ie < g; Ie++)
          _e.dyn_ltree[2 * Ie] = 0;
        for (Ie = 0; Ie < x; Ie++)
          _e.dyn_dtree[2 * Ie] = 0;
        for (Ie = 0; Ie < E; Ie++)
          _e.bl_tree[2 * Ie] = 0;
        _e.dyn_ltree[2 * b] = 1, _e.opt_len = _e.static_len = 0, _e.last_lit = _e.matches = 0;
      }
      function H(_e) {
        8 < _e.bi_valid ? F(_e, _e.bi_buf) : 0 < _e.bi_valid && (_e.pending_buf[_e.pending++] = _e.bi_buf), _e.bi_buf = 0, _e.bi_valid = 0;
      }
      function ne(_e, Ie, Be, $e) {
        var Me = 2 * Ie, J = 2 * Be;
        return _e[Me] < _e[J] || _e[Me] === _e[J] && $e[Ie] <= $e[Be];
      }
      function he(_e, Ie, Be) {
        for (var $e = _e.heap[Be], Me = Be << 1; Me <= _e.heap_len && (Me < _e.heap_len && ne(Ie, _e.heap[Me + 1], _e.heap[Me], _e.depth) && Me++, !ne(Ie, $e, _e.heap[Me], _e.depth)); )
          _e.heap[Be] = _e.heap[Me], Be = Me, Me <<= 1;
        _e.heap[Be] = $e;
      }
      function j(_e, Ie, Be) {
        var $e, Me, J, K, ge = 0;
        if (_e.last_lit !== 0)
          for (; $e = _e.pending_buf[_e.d_buf + 2 * ge] << 8 | _e.pending_buf[_e.d_buf + 2 * ge + 1], Me = _e.pending_buf[_e.l_buf + ge], ge++, $e === 0 ? I(_e, Me, Ie) : (I(_e, (J = P[Me]) + h + 1, Ie), (K = R[J]) !== 0 && M(_e, Me -= Q[J], K), I(_e, J = U(--$e), Be), (K = O[J]) !== 0 && M(_e, $e -= Z[J], K)), ge < _e.last_lit; )
            ;
        I(_e, b, Ie);
      }
      function Fe(_e, Ie) {
        var Be, $e, Me, J = Ie.dyn_tree, K = Ie.stat_desc.static_tree, ge = Ie.stat_desc.has_stree, Ce = Ie.stat_desc.elems, Oe = -1;
        for (_e.heap_len = 0, _e.heap_max = m, Be = 0; Be < Ce; Be++)
          J[2 * Be] !== 0 ? (_e.heap[++_e.heap_len] = Oe = Be, _e.depth[Be] = 0) : J[2 * Be + 1] = 0;
        for (; _e.heap_len < 2; )
          J[2 * (Me = _e.heap[++_e.heap_len] = Oe < 2 ? ++Oe : 0)] = 1, _e.depth[Me] = 0, _e.opt_len--, ge && (_e.static_len -= K[2 * Me + 1]);
        for (Ie.max_code = Oe, Be = _e.heap_len >> 1; 1 <= Be; Be--)
          he(_e, J, Be);
        for (Me = Ce; Be = _e.heap[1], _e.heap[1] = _e.heap[_e.heap_len--], he(_e, J, 1), $e = _e.heap[1], _e.heap[--_e.heap_max] = Be, _e.heap[--_e.heap_max] = $e, J[2 * Me] = J[2 * Be] + J[2 * $e], _e.depth[Me] = (_e.depth[Be] >= _e.depth[$e] ? _e.depth[Be] : _e.depth[$e]) + 1, J[2 * Be + 1] = J[2 * $e + 1] = Me, _e.heap[1] = Me++, he(_e, J, 1), 2 <= _e.heap_len; )
          ;
        _e.heap[--_e.heap_max] = _e.heap[1], function(qe, ct) {
          var ze, et, gt, pt, nt, tt, Ve = ct.dyn_tree, We = ct.max_code, it = ct.stat_desc.static_tree, Je = ct.stat_desc.has_stree, Rt = ct.stat_desc.extra_bits, je = ct.stat_desc.extra_base, ke = ct.stat_desc.max_length, Ye = 0;
          for (pt = 0; pt <= v; pt++)
            qe.bl_count[pt] = 0;
          for (Ve[2 * qe.heap[qe.heap_max] + 1] = 0, ze = qe.heap_max + 1; ze < m; ze++)
            ke < (pt = Ve[2 * Ve[2 * (et = qe.heap[ze]) + 1] + 1] + 1) && (pt = ke, Ye++), Ve[2 * et + 1] = pt, We < et || (qe.bl_count[pt]++, nt = 0, je <= et && (nt = Rt[et - je]), tt = Ve[2 * et], qe.opt_len += tt * (pt + nt), Je && (qe.static_len += tt * (it[2 * et + 1] + nt)));
          if (Ye !== 0) {
            do {
              for (pt = ke - 1; qe.bl_count[pt] === 0; )
                pt--;
              qe.bl_count[pt]--, qe.bl_count[pt + 1] += 2, qe.bl_count[ke]--, Ye -= 2;
            } while (0 < Ye);
            for (pt = ke; pt !== 0; pt--)
              for (et = qe.bl_count[pt]; et !== 0; )
                We < (gt = qe.heap[--ze]) || (Ve[2 * gt + 1] !== pt && (qe.opt_len += (pt - Ve[2 * gt + 1]) * Ve[2 * gt], Ve[2 * gt + 1] = pt), et--);
          }
        }(_e, Ie), V(J, Oe, _e.bl_count);
      }
      function X(_e, Ie, Be) {
        var $e, Me, J = -1, K = Ie[1], ge = 0, Ce = 7, Oe = 4;
        for (K === 0 && (Ce = 138, Oe = 3), Ie[2 * (Be + 1) + 1] = 65535, $e = 0; $e <= Be; $e++)
          Me = K, K = Ie[2 * ($e + 1) + 1], ++ge < Ce && Me === K || (ge < Oe ? _e.bl_tree[2 * Me] += ge : Me !== 0 ? (Me !== J && _e.bl_tree[2 * Me]++, _e.bl_tree[2 * C]++) : ge <= 10 ? _e.bl_tree[2 * T]++ : _e.bl_tree[2 * w]++, J = Me, Oe = (ge = 0) === K ? (Ce = 138, 3) : Me === K ? (Ce = 6, 3) : (Ce = 7, 4));
      }
      function ye(_e, Ie, Be) {
        var $e, Me, J = -1, K = Ie[1], ge = 0, Ce = 7, Oe = 4;
        for (K === 0 && (Ce = 138, Oe = 3), $e = 0; $e <= Be; $e++)
          if (Me = K, K = Ie[2 * ($e + 1) + 1], !(++ge < Ce && Me === K)) {
            if (ge < Oe)
              for (; I(_e, Me, _e.bl_tree), --ge != 0; )
                ;
            else
              Me !== 0 ? (Me !== J && (I(_e, Me, _e.bl_tree), ge--), I(_e, C, _e.bl_tree), M(_e, ge - 3, 2)) : ge <= 10 ? (I(_e, T, _e.bl_tree), M(_e, ge - 3, 3)) : (I(_e, w, _e.bl_tree), M(_e, ge - 11, 7));
            J = Me, Oe = (ge = 0) === K ? (Ce = 138, 3) : Me === K ? (Ce = 6, 3) : (Ce = 7, 4);
          }
      }
      u(Z);
      var Ae = !1;
      function fe(_e, Ie, Be, $e) {
        M(_e, (d << 1) + ($e ? 1 : 0), 3), function(Me, J, K, ge) {
          H(Me), ge && (F(Me, K), F(Me, ~K)), o.arraySet(Me.pending_buf, Me.window, J, K, Me.pending), Me.pending += K;
        }(_e, Ie, Be, !0);
      }
      s._tr_init = function(_e) {
        Ae || (function() {
          var Ie, Be, $e, Me, J, K = new Array(v + 1);
          for (Me = $e = 0; Me < f - 1; Me++)
            for (Q[Me] = $e, Ie = 0; Ie < 1 << R[Me]; Ie++)
              P[$e++] = Me;
          for (P[$e - 1] = Me, Me = J = 0; Me < 16; Me++)
            for (Z[Me] = J, Ie = 0; Ie < 1 << O[Me]; Ie++)
              z[J++] = Me;
          for (J >>= 7; Me < x; Me++)
            for (Z[Me] = J << 7, Ie = 0; Ie < 1 << O[Me] - 7; Ie++)
              z[256 + J++] = Me;
          for (Be = 0; Be <= v; Be++)
            K[Be] = 0;
          for (Ie = 0; Ie <= 143; )
            W[2 * Ie + 1] = 8, Ie++, K[8]++;
          for (; Ie <= 255; )
            W[2 * Ie + 1] = 9, Ie++, K[9]++;
          for (; Ie <= 279; )
            W[2 * Ie + 1] = 7, Ie++, K[7]++;
          for (; Ie <= 287; )
            W[2 * Ie + 1] = 8, Ie++, K[8]++;
          for (V(W, g + 1, K), Ie = 0; Ie < x; Ie++)
            L[2 * Ie + 1] = 5, L[2 * Ie] = N(Ie, 5);
          Y = new ae(W, R, h + 1, g, v), ie = new ae(L, O, 0, x, v), te = new ae(new Array(0), D, 0, E, A);
        }(), Ae = !0), _e.l_desc = new G(_e.dyn_ltree, Y), _e.d_desc = new G(_e.dyn_dtree, ie), _e.bl_desc = new G(_e.bl_tree, te), _e.bi_buf = 0, _e.bi_valid = 0, q(_e);
      }, s._tr_stored_block = fe, s._tr_flush_block = function(_e, Ie, Be, $e) {
        var Me, J, K = 0;
        0 < _e.level ? (_e.strm.data_type === 2 && (_e.strm.data_type = function(ge) {
          var Ce, Oe = 4093624447;
          for (Ce = 0; Ce <= 31; Ce++, Oe >>>= 1)
            if (1 & Oe && ge.dyn_ltree[2 * Ce] !== 0)
              return l;
          if (ge.dyn_ltree[18] !== 0 || ge.dyn_ltree[20] !== 0 || ge.dyn_ltree[26] !== 0)
            return c;
          for (Ce = 32; Ce < h; Ce++)
            if (ge.dyn_ltree[2 * Ce] !== 0)
              return c;
          return l;
        }(_e)), Fe(_e, _e.l_desc), Fe(_e, _e.d_desc), K = function(ge) {
          var Ce;
          for (X(ge, ge.dyn_ltree, ge.l_desc.max_code), X(ge, ge.dyn_dtree, ge.d_desc.max_code), Fe(ge, ge.bl_desc), Ce = E - 1; 3 <= Ce && ge.bl_tree[2 * k[Ce] + 1] === 0; Ce--)
            ;
          return ge.opt_len += 3 * (Ce + 1) + 5 + 5 + 4, Ce;
        }(_e), Me = _e.opt_len + 3 + 7 >>> 3, (J = _e.static_len + 3 + 7 >>> 3) <= Me && (Me = J)) : Me = J = Be + 5, Be + 4 <= Me && Ie !== -1 ? fe(_e, Ie, Be, $e) : _e.strategy === 4 || J === Me ? (M(_e, 2 + ($e ? 1 : 0), 3), j(_e, W, L)) : (M(_e, 4 + ($e ? 1 : 0), 3), function(ge, Ce, Oe, qe) {
          var ct;
          for (M(ge, Ce - 257, 5), M(ge, Oe - 1, 5), M(ge, qe - 4, 4), ct = 0; ct < qe; ct++)
            M(ge, ge.bl_tree[2 * k[ct] + 1], 3);
          ye(ge, ge.dyn_ltree, Ce - 1), ye(ge, ge.dyn_dtree, Oe - 1);
        }(_e, _e.l_desc.max_code + 1, _e.d_desc.max_code + 1, K + 1), j(_e, _e.dyn_ltree, _e.dyn_dtree)), q(_e), $e && H(_e);
      }, s._tr_tally = function(_e, Ie, Be) {
        return _e.pending_buf[_e.d_buf + 2 * _e.last_lit] = Ie >>> 8 & 255, _e.pending_buf[_e.d_buf + 2 * _e.last_lit + 1] = 255 & Ie, _e.pending_buf[_e.l_buf + _e.last_lit] = 255 & Be, _e.last_lit++, Ie === 0 ? _e.dyn_ltree[2 * Be]++ : (_e.matches++, Ie--, _e.dyn_ltree[2 * (P[Be] + h + 1)]++, _e.dyn_dtree[2 * U(Ie)]++), _e.last_lit === _e.lit_bufsize - 1;
      }, s._tr_align = function(_e) {
        M(_e, 2, 3), I(_e, b, W), function(Ie) {
          Ie.bi_valid === 16 ? (F(Ie, Ie.bi_buf), Ie.bi_buf = 0, Ie.bi_valid = 0) : 8 <= Ie.bi_valid && (Ie.pending_buf[Ie.pending++] = 255 & Ie.bi_buf, Ie.bi_buf >>= 8, Ie.bi_valid -= 8);
        }(_e);
      };
    }, { "../utils/common": 41 }], 53: [function(n, a, s) {
      a.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(n, a, s) {
      (function(o) {
        (function(l, c) {
          if (!l.setImmediate) {
            var u, d, f, h, g = 1, x = {}, E = !1, m = l.document, v = Object.getPrototypeOf && Object.getPrototypeOf(l);
            v = v && v.setTimeout ? v : l, u = {}.toString.call(l.process) === "[object process]" ? function(C) {
              process.nextTick(function() {
                A(C);
              });
            } : function() {
              if (l.postMessage && !l.importScripts) {
                var C = !0, T = l.onmessage;
                return l.onmessage = function() {
                  C = !1;
                }, l.postMessage("", "*"), l.onmessage = T, C;
              }
            }() ? (h = "setImmediate$" + Math.random() + "$", l.addEventListener ? l.addEventListener("message", b, !1) : l.attachEvent("onmessage", b), function(C) {
              l.postMessage(h + C, "*");
            }) : l.MessageChannel ? ((f = new MessageChannel()).port1.onmessage = function(C) {
              A(C.data);
            }, function(C) {
              f.port2.postMessage(C);
            }) : m && "onreadystatechange" in m.createElement("script") ? (d = m.documentElement, function(C) {
              var T = m.createElement("script");
              T.onreadystatechange = function() {
                A(C), T.onreadystatechange = null, d.removeChild(T), T = null;
              }, d.appendChild(T);
            }) : function(C) {
              setTimeout(A, 0, C);
            }, v.setImmediate = function(C) {
              typeof C != "function" && (C = new Function("" + C));
              for (var T = new Array(arguments.length - 1), w = 0; w < T.length; w++)
                T[w] = arguments[w + 1];
              var R = { callback: C, args: T };
              return x[g] = R, u(g), g++;
            }, v.clearImmediate = y;
          }
          function y(C) {
            delete x[C];
          }
          function A(C) {
            if (E)
              setTimeout(A, 0, C);
            else {
              var T = x[C];
              if (T) {
                E = !0;
                try {
                  (function(w) {
                    var R = w.callback, O = w.args;
                    switch (O.length) {
                      case 0:
                        R();
                        break;
                      case 1:
                        R(O[0]);
                        break;
                      case 2:
                        R(O[0], O[1]);
                        break;
                      case 3:
                        R(O[0], O[1], O[2]);
                        break;
                      default:
                        R.apply(c, O);
                    }
                  })(T);
                } finally {
                  y(C), E = !1;
                }
              }
            }
          }
          function b(C) {
            C.source === l && typeof C.data == "string" && C.data.indexOf(h) === 0 && A(+C.data.slice(h.length));
          }
        })(typeof self > "u" ? o === void 0 ? this : o : self);
      }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(jszip_min);
var jszip_minExports = jszip_min.exports, base64js = base64Js, JSZip = jszip_minExports;
zipfile$2.openArrayBuffer = openArrayBuffer;
zipfile$2.splitPath = splitPath;
zipfile$2.joinPath = joinPath;
function openArrayBuffer(t) {
  return JSZip.loadAsync(t).then(function(e) {
    function n(l) {
      return e.file(l) !== null;
    }
    function a(l, c) {
      return e.file(l).async("uint8array").then(function(u) {
        if (c === "base64")
          return base64js.fromByteArray(u);
        if (c) {
          var d = new TextDecoder(c);
          return d.decode(u);
        } else
          return u;
      });
    }
    function s(l, c) {
      e.file(l, c);
    }
    function o() {
      return e.generateAsync({ type: "arraybuffer" });
    }
    return {
      exists: n,
      read: a,
      write: s,
      toArrayBuffer: o
    };
  });
}
function splitPath(t) {
  var e = t.lastIndexOf("/");
  return e === -1 ? { dirname: "", basename: t } : {
    dirname: t.substring(0, e),
    basename: t.substring(e + 1)
  };
}
function joinPath() {
  var t = Array.prototype.filter.call(arguments, function(n) {
    return n;
  }), e = [];
  return t.forEach(function(n) {
    /^\//.test(n) ? e = [n] : e.push(n);
  }), e.join("/");
}
var officeXmlReader = {}, xml$2 = {}, nodes$2 = {}, _$d = require$$0;
nodes$2.Element = Element$3;
nodes$2.element = function(t, e, n) {
  return new Element$3(t, e, n);
};
nodes$2.text = function(t) {
  return {
    type: "text",
    value: t
  };
};
var emptyElement = {
  first: function() {
    return null;
  },
  firstOrEmpty: function() {
    return emptyElement;
  },
  attributes: {}
};
function Element$3(t, e, n) {
  this.type = "element", this.name = t, this.attributes = e || {}, this.children = n || [];
}
Element$3.prototype.first = function(t) {
  return _$d.find(this.children, function(e) {
    return e.name === t;
  });
};
Element$3.prototype.firstOrEmpty = function(t) {
  return this.first(t) || emptyElement;
};
Element$3.prototype.getElementsByTagName = function(t) {
  var e = _$d.filter(this.children, function(n) {
    return n.name === t;
  });
  return toElementList(e);
};
Element$3.prototype.text = function() {
  if (this.children.length === 0)
    return "";
  if (this.children.length !== 1 || this.children[0].type !== "text")
    throw new Error("Not implemented");
  return this.children[0].value;
};
var elementListPrototype = {
  getElementsByTagName: function(t) {
    return toElementList(_$d.flatten(this.map(function(e) {
      return e.getElementsByTagName(t);
    }, !0)));
  }
};
function toElementList(t) {
  return _$d.extend(t, elementListPrototype);
}
var reader = {}, xmldom$2 = {}, lib$1 = {}, dom$3 = {}, conventions$2 = {};
function find$1(t, e, n) {
  if (n === void 0 && (n = Array.prototype), t && typeof n.find == "function")
    return n.find.call(t, e);
  for (var a = 0; a < t.length; a++)
    if (Object.prototype.hasOwnProperty.call(t, a)) {
      var s = t[a];
      if (e.call(void 0, s, a, t))
        return s;
    }
}
function freeze(t, e) {
  return e === void 0 && (e = Object), e && typeof e.freeze == "function" ? e.freeze(t) : t;
}
function assign(t, e) {
  if (t === null || typeof t != "object")
    throw new TypeError("target is not an object");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
var MIME_TYPE = freeze({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(t) {
    return t === MIME_TYPE.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), NAMESPACE$3 = freeze({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(t) {
    return t === NAMESPACE$3.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
conventions$2.assign = assign;
conventions$2.find = find$1;
conventions$2.freeze = freeze;
conventions$2.MIME_TYPE = MIME_TYPE;
conventions$2.NAMESPACE = NAMESPACE$3;
var conventions$1 = conventions$2, find = conventions$1.find, NAMESPACE$2 = conventions$1.NAMESPACE;
function notEmptyString(t) {
  return t !== "";
}
function splitOnASCIIWhitespace(t) {
  return t ? t.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
}
function orderedSetReducer(t, e) {
  return t.hasOwnProperty(e) || (t[e] = !0), t;
}
function toOrderedSet(t) {
  if (!t)
    return [];
  var e = splitOnASCIIWhitespace(t);
  return Object.keys(e.reduce(orderedSetReducer, {}));
}
function arrayIncludes(t) {
  return function(e) {
    return t && t.indexOf(e) !== -1;
  };
}
function copy(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function _extends(t, e) {
  var n = t.prototype;
  if (!(n instanceof e)) {
    let a = function() {
    };
    a.prototype = e.prototype, a = new a(), copy(n, a), t.prototype = n = a;
  }
  n.constructor != t && (typeof t != "function" && console.error("unknown Class:" + t), n.constructor = t);
}
var NodeType = {}, ELEMENT_NODE = NodeType.ELEMENT_NODE = 1, ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2, TEXT_NODE = NodeType.TEXT_NODE = 3, CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4, ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5, ENTITY_NODE = NodeType.ENTITY_NODE = 6, PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7, COMMENT_NODE = NodeType.COMMENT_NODE = 8, DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9, DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10, DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11, NOTATION_NODE = NodeType.NOTATION_NODE = 12, ExceptionCode = {}, ExceptionMessage = {};
ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);
function DOMException(t, e) {
  if (e instanceof Error)
    var n = e;
  else
    n = this, Error.call(this, ExceptionMessage[t]), this.message = ExceptionMessage[t], Error.captureStackTrace && Error.captureStackTrace(this, DOMException);
  return n.code = t, e && (this.message = this.message + ": " + e), n;
}
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);
function NodeList() {
}
NodeList.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(t) {
    return t >= 0 && t < this.length ? this[t] : null;
  },
  toString: function(t, e) {
    for (var n = [], a = 0; a < this.length; a++)
      serializeToString(this[a], n, t, e);
    return n.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(t) {
    return Array.prototype.filter.call(this, t);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(t) {
    return Array.prototype.indexOf.call(this, t);
  }
};
function LiveNodeList(t, e) {
  this._node = t, this._refresh = e, _updateLiveList(this);
}
function _updateLiveList(t) {
  var e = t._node._inc || t._node.ownerDocument._inc;
  if (t._inc !== e) {
    var n = t._refresh(t._node);
    if (__set__(t, "length", n.length), !t.$$length || n.length < t.$$length)
      for (var a = n.length; a in t; a++)
        Object.prototype.hasOwnProperty.call(t, a) && delete t[a];
    copy(n, t), t._inc = e;
  }
}
LiveNodeList.prototype.item = function(t) {
  return _updateLiveList(this), this[t] || null;
};
_extends(LiveNodeList, NodeList);
function NamedNodeMap() {
}
function _findNodeIndex(t, e) {
  for (var n = t.length; n--; )
    if (t[n] === e)
      return n;
}
function _addNamedNode(t, e, n, a) {
  if (a ? e[_findNodeIndex(e, a)] = n : e[e.length++] = n, t) {
    n.ownerElement = t;
    var s = t.ownerDocument;
    s && (a && _onRemoveAttribute(s, t, a), _onAddAttribute(s, t, n));
  }
}
function _removeNamedNode(t, e, n) {
  var a = _findNodeIndex(e, n);
  if (a >= 0) {
    for (var s = e.length - 1; a < s; )
      e[a] = e[++a];
    if (e.length = s, t) {
      var o = t.ownerDocument;
      o && (_onRemoveAttribute(o, t, n), n.ownerElement = null);
    }
  } else
    throw new DOMException(NOT_FOUND_ERR, new Error(t.tagName + "@" + n));
}
NamedNodeMap.prototype = {
  length: 0,
  item: NodeList.prototype.item,
  getNamedItem: function(t) {
    for (var e = this.length; e--; ) {
      var n = this[e];
      if (n.nodeName == t)
        return n;
    }
  },
  setNamedItem: function(t) {
    var e = t.ownerElement;
    if (e && e != this._ownerElement)
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    var n = this.getNamedItem(t.nodeName);
    return _addNamedNode(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  setNamedItemNS: function(t) {
    var e = t.ownerElement, n;
    if (e && e != this._ownerElement)
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    return n = this.getNamedItemNS(t.namespaceURI, t.localName), _addNamedNode(this._ownerElement, this, t, n), n;
  },
  /* returns Node */
  removeNamedItem: function(t) {
    var e = this.getNamedItem(t);
    return _removeNamedNode(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(t, e) {
    var n = this.getNamedItemNS(t, e);
    return _removeNamedNode(this._ownerElement, this, n), n;
  },
  getNamedItemNS: function(t, e) {
    for (var n = this.length; n--; ) {
      var a = this[n];
      if (a.localName == e && a.namespaceURI == t)
        return a;
    }
    return null;
  }
};
function DOMImplementation$1() {
}
DOMImplementation$1.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(t, e) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(t, e, n) {
    var a = new Document();
    if (a.implementation = this, a.childNodes = new NodeList(), a.doctype = n || null, n && a.appendChild(n), e) {
      var s = a.createElementNS(t, e);
      a.appendChild(s);
    }
    return a;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(t, e, n) {
    var a = new DocumentType();
    return a.name = t, a.nodeName = t, a.publicId = e || "", a.systemId = n || "", a;
  }
};
function Node$1() {
}
Node$1.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(t, e) {
    return _insertBefore(this, t, e);
  },
  replaceChild: function(t, e) {
    _insertBefore(this, t, e, assertPreReplacementValidityInDocument), e && this.removeChild(e);
  },
  removeChild: function(t) {
    return _removeChild(this, t);
  },
  appendChild: function(t) {
    return this.insertBefore(t, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(t) {
    return cloneNode(this.ownerDocument || this, this, t);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var t = this.firstChild; t; ) {
      var e = t.nextSibling;
      e && e.nodeType == TEXT_NODE && t.nodeType == TEXT_NODE ? (this.removeChild(e), t.appendData(e.data)) : (t.normalize(), t = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(t, e) {
    return this.ownerDocument.implementation.hasFeature(t, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n) {
        for (var a in n)
          if (Object.prototype.hasOwnProperty.call(n, a) && n[a] === t)
            return a;
      }
      e = e.nodeType == ATTRIBUTE_NODE ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(t) {
    for (var e = this; e; ) {
      var n = e._nsMap;
      if (n && Object.prototype.hasOwnProperty.call(n, t))
        return n[t];
      e = e.nodeType == ATTRIBUTE_NODE ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(t) {
    var e = this.lookupPrefix(t);
    return e == null;
  }
};
function _xmlEncoder(t) {
  return t == "<" && "&lt;" || t == ">" && "&gt;" || t == "&" && "&amp;" || t == '"' && "&quot;" || "&#" + t.charCodeAt() + ";";
}
copy(NodeType, Node$1);
copy(NodeType, Node$1.prototype);
function _visitNode(t, e) {
  if (e(t))
    return !0;
  if (t = t.firstChild)
    do
      if (_visitNode(t, e))
        return !0;
    while (t = t.nextSibling);
}
function Document() {
  this.ownerDocument = this;
}
function _onAddAttribute(t, e, n) {
  t && t._inc++;
  var a = n.namespaceURI;
  a === NAMESPACE$2.XMLNS && (e._nsMap[n.prefix ? n.localName : ""] = n.value);
}
function _onRemoveAttribute(t, e, n, a) {
  t && t._inc++;
  var s = n.namespaceURI;
  s === NAMESPACE$2.XMLNS && delete e._nsMap[n.prefix ? n.localName : ""];
}
function _onUpdateChild(t, e, n) {
  if (t && t._inc) {
    t._inc++;
    var a = e.childNodes;
    if (n)
      a[a.length++] = n;
    else {
      for (var s = e.firstChild, o = 0; s; )
        a[o++] = s, s = s.nextSibling;
      a.length = o, delete a[a.length];
    }
  }
}
function _removeChild(t, e) {
  var n = e.previousSibling, a = e.nextSibling;
  return n ? n.nextSibling = a : t.firstChild = a, a ? a.previousSibling = n : t.lastChild = n, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, _onUpdateChild(t.ownerDocument, t), e;
}
function hasValidParentNodeType(t) {
  return t && (t.nodeType === Node$1.DOCUMENT_NODE || t.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE || t.nodeType === Node$1.ELEMENT_NODE);
}
function hasInsertableNodeType(t) {
  return t && (isElementNode(t) || isTextNode(t) || isDocTypeNode(t) || t.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE || t.nodeType === Node$1.COMMENT_NODE || t.nodeType === Node$1.PROCESSING_INSTRUCTION_NODE);
}
function isDocTypeNode(t) {
  return t && t.nodeType === Node$1.DOCUMENT_TYPE_NODE;
}
function isElementNode(t) {
  return t && t.nodeType === Node$1.ELEMENT_NODE;
}
function isTextNode(t) {
  return t && t.nodeType === Node$1.TEXT_NODE;
}
function isElementInsertionPossible(t, e) {
  var n = t.childNodes || [];
  if (find(n, isElementNode) || isDocTypeNode(e))
    return !1;
  var a = find(n, isDocTypeNode);
  return !(e && a && n.indexOf(a) > n.indexOf(e));
}
function isElementReplacementPossible(t, e) {
  var n = t.childNodes || [];
  function a(o) {
    return isElementNode(o) && o !== e;
  }
  if (find(n, a))
    return !1;
  var s = find(n, isDocTypeNode);
  return !(e && s && n.indexOf(s) > n.indexOf(e));
}
function assertPreInsertionValidity1to5(t, e, n) {
  if (!hasValidParentNodeType(t))
    throw new DOMException(HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + t.nodeType);
  if (n && n.parentNode !== t)
    throw new DOMException(NOT_FOUND_ERR, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !hasInsertableNodeType(e) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    isDocTypeNode(e) && t.nodeType !== Node$1.DOCUMENT_NODE
  )
    throw new DOMException(
      HIERARCHY_REQUEST_ERR,
      "Unexpected node type " + e.nodeType + " for parent node type " + t.nodeType
    );
}
function assertPreInsertionValidityInDocument(t, e, n) {
  var a = t.childNodes || [], s = e.childNodes || [];
  if (e.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE) {
    var o = s.filter(isElementNode);
    if (o.length > 1 || find(s, isTextNode))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
    if (o.length === 1 && !isElementInsertionPossible(t, n))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
  }
  if (isElementNode(e) && !isElementInsertionPossible(t, n))
    throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
  if (isDocTypeNode(e)) {
    if (find(a, isDocTypeNode))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
    var l = find(a, isElementNode);
    if (n && a.indexOf(l) < a.indexOf(n))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    if (!n && l)
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
  }
}
function assertPreReplacementValidityInDocument(t, e, n) {
  var a = t.childNodes || [], s = e.childNodes || [];
  if (e.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE) {
    var o = s.filter(isElementNode);
    if (o.length > 1 || find(s, isTextNode))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
    if (o.length === 1 && !isElementReplacementPossible(t, n))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
  }
  if (isElementNode(e) && !isElementReplacementPossible(t, n))
    throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
  if (isDocTypeNode(e)) {
    if (find(a, function(u) {
      return isDocTypeNode(u) && u !== n;
    }))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
    var l = find(a, isElementNode);
    if (n && a.indexOf(l) < a.indexOf(n))
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
  }
}
function _insertBefore(t, e, n, a) {
  assertPreInsertionValidity1to5(t, e, n), t.nodeType === Node$1.DOCUMENT_NODE && (a || assertPreInsertionValidityInDocument)(t, e, n);
  var s = e.parentNode;
  if (s && s.removeChild(e), e.nodeType === DOCUMENT_FRAGMENT_NODE) {
    var o = e.firstChild;
    if (o == null)
      return e;
    var l = e.lastChild;
  } else
    o = l = e;
  var c = n ? n.previousSibling : t.lastChild;
  o.previousSibling = c, l.nextSibling = n, c ? c.nextSibling = o : t.firstChild = o, n == null ? t.lastChild = l : n.previousSibling = l;
  do
    o.parentNode = t;
  while (o !== l && (o = o.nextSibling));
  return _onUpdateChild(t.ownerDocument || t, t), e.nodeType == DOCUMENT_FRAGMENT_NODE && (e.firstChild = e.lastChild = null), e;
}
function _appendSingleChild(t, e) {
  return e.parentNode && e.parentNode.removeChild(e), e.parentNode = t, e.previousSibling = t.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : t.firstChild = e, t.lastChild = e, _onUpdateChild(t.ownerDocument, t, e), e;
}
Document.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: DOCUMENT_NODE,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(t, e) {
    if (t.nodeType == DOCUMENT_FRAGMENT_NODE) {
      for (var n = t.firstChild; n; ) {
        var a = n.nextSibling;
        this.insertBefore(n, e), n = a;
      }
      return t;
    }
    return _insertBefore(this, t, e), t.ownerDocument = this, this.documentElement === null && t.nodeType === ELEMENT_NODE && (this.documentElement = t), t;
  },
  removeChild: function(t) {
    return this.documentElement == t && (this.documentElement = null), _removeChild(this, t);
  },
  replaceChild: function(t, e) {
    _insertBefore(this, t, e, assertPreReplacementValidityInDocument), t.ownerDocument = this, e && this.removeChild(e), isElementNode(t) && (this.documentElement = t);
  },
  // Introduced in DOM Level 2:
  importNode: function(t, e) {
    return importNode(this, t, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(t) {
    var e = null;
    return _visitNode(this.documentElement, function(n) {
      if (n.nodeType == ELEMENT_NODE && n.getAttribute("id") == t)
        return e = n, !0;
    }), e;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(t) {
    var e = toOrderedSet(t);
    return new LiveNodeList(this, function(n) {
      var a = [];
      return e.length > 0 && _visitNode(n.documentElement, function(s) {
        if (s !== n && s.nodeType === ELEMENT_NODE) {
          var o = s.getAttribute("class");
          if (o) {
            var l = t === o;
            if (!l) {
              var c = toOrderedSet(o);
              l = e.every(arrayIncludes(c));
            }
            l && a.push(s);
          }
        }
      }), a;
    });
  },
  //document factory method:
  createElement: function(t) {
    var e = new Element$2();
    e.ownerDocument = this, e.nodeName = t, e.tagName = t, e.localName = t, e.childNodes = new NodeList();
    var n = e.attributes = new NamedNodeMap();
    return n._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var t = new DocumentFragment();
    return t.ownerDocument = this, t.childNodes = new NodeList(), t;
  },
  createTextNode: function(t) {
    var e = new Text();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createComment: function(t) {
    var e = new Comment();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createCDATASection: function(t) {
    var e = new CDATASection();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createProcessingInstruction: function(t, e) {
    var n = new ProcessingInstruction();
    return n.ownerDocument = this, n.tagName = n.nodeName = n.target = t, n.nodeValue = n.data = e, n;
  },
  createAttribute: function(t) {
    var e = new Attr();
    return e.ownerDocument = this, e.name = t, e.nodeName = t, e.localName = t, e.specified = !0, e;
  },
  createEntityReference: function(t) {
    var e = new EntityReference();
    return e.ownerDocument = this, e.nodeName = t, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(t, e) {
    var n = new Element$2(), a = e.split(":"), s = n.attributes = new NamedNodeMap();
    return n.childNodes = new NodeList(), n.ownerDocument = this, n.nodeName = e, n.tagName = e, n.namespaceURI = t, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, s._ownerElement = n, n;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(t, e) {
    var n = new Attr(), a = e.split(":");
    return n.ownerDocument = this, n.nodeName = e, n.name = e, n.namespaceURI = t, n.specified = !0, a.length == 2 ? (n.prefix = a[0], n.localName = a[1]) : n.localName = e, n;
  }
};
_extends(Document, Node$1);
function Element$2() {
  this._nsMap = {};
}
Element$2.prototype = {
  nodeType: ELEMENT_NODE,
  hasAttribute: function(t) {
    return this.getAttributeNode(t) != null;
  },
  getAttribute: function(t) {
    var e = this.getAttributeNode(t);
    return e && e.value || "";
  },
  getAttributeNode: function(t) {
    return this.attributes.getNamedItem(t);
  },
  setAttribute: function(t, e) {
    var n = this.ownerDocument.createAttribute(t);
    n.value = n.nodeValue = "" + e, this.setAttributeNode(n);
  },
  removeAttribute: function(t) {
    var e = this.getAttributeNode(t);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(t) {
    return t.nodeType === DOCUMENT_FRAGMENT_NODE ? this.insertBefore(t, null) : _appendSingleChild(this, t);
  },
  setAttributeNode: function(t) {
    return this.attributes.setNamedItem(t);
  },
  setAttributeNodeNS: function(t) {
    return this.attributes.setNamedItemNS(t);
  },
  removeAttributeNode: function(t) {
    return this.attributes.removeNamedItem(t.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    n && this.removeAttributeNode(n);
  },
  hasAttributeNS: function(t, e) {
    return this.getAttributeNodeNS(t, e) != null;
  },
  getAttributeNS: function(t, e) {
    var n = this.getAttributeNodeNS(t, e);
    return n && n.value || "";
  },
  setAttributeNS: function(t, e, n) {
    var a = this.ownerDocument.createAttributeNS(t, e);
    a.value = a.nodeValue = "" + n, this.setAttributeNode(a);
  },
  getAttributeNodeNS: function(t, e) {
    return this.attributes.getNamedItemNS(t, e);
  },
  getElementsByTagName: function(t) {
    return new LiveNodeList(this, function(e) {
      var n = [];
      return _visitNode(e, function(a) {
        a !== e && a.nodeType == ELEMENT_NODE && (t === "*" || a.tagName == t) && n.push(a);
      }), n;
    });
  },
  getElementsByTagNameNS: function(t, e) {
    return new LiveNodeList(this, function(n) {
      var a = [];
      return _visitNode(n, function(s) {
        s !== n && s.nodeType === ELEMENT_NODE && (t === "*" || s.namespaceURI === t) && (e === "*" || s.localName == e) && a.push(s);
      }), a;
    });
  }
};
Document.prototype.getElementsByTagName = Element$2.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element$2.prototype.getElementsByTagNameNS;
_extends(Element$2, Node$1);
function Attr() {
}
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node$1);
function CharacterData() {
}
CharacterData.prototype = {
  data: "",
  substringData: function(t, e) {
    return this.data.substring(t, t + e);
  },
  appendData: function(t) {
    t = this.data + t, this.nodeValue = this.data = t, this.length = t.length;
  },
  insertData: function(t, e) {
    this.replaceData(t, 0, e);
  },
  appendChild: function(t) {
    throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
  },
  deleteData: function(t, e) {
    this.replaceData(t, e, "");
  },
  replaceData: function(t, e, n) {
    var a = this.data.substring(0, t), s = this.data.substring(t + e);
    n = a + n + s, this.nodeValue = this.data = n, this.length = n.length;
  }
};
_extends(CharacterData, Node$1);
function Text() {
}
Text.prototype = {
  nodeName: "#text",
  nodeType: TEXT_NODE,
  splitText: function(t) {
    var e = this.data, n = e.substring(t);
    e = e.substring(0, t), this.data = this.nodeValue = e, this.length = e.length;
    var a = this.ownerDocument.createTextNode(n);
    return this.parentNode && this.parentNode.insertBefore(a, this.nextSibling), a;
  }
};
_extends(Text, CharacterData);
function Comment() {
}
Comment.prototype = {
  nodeName: "#comment",
  nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);
function CDATASection() {
}
CDATASection.prototype = {
  nodeName: "#cdata-section",
  nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);
function DocumentType() {
}
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node$1);
function Notation() {
}
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node$1);
function Entity() {
}
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node$1);
function EntityReference() {
}
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node$1);
function DocumentFragment() {
}
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node$1);
function ProcessingInstruction() {
}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node$1);
function XMLSerializer() {
}
XMLSerializer.prototype.serializeToString = function(t, e, n) {
  return nodeSerializeToString.call(t, e, n);
};
Node$1.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(t, e) {
  var n = [], a = this.nodeType == 9 && this.documentElement || this, s = a.prefix, o = a.namespaceURI;
  if (o && s == null) {
    var s = a.lookupPrefix(o);
    if (s == null)
      var l = [
        { namespace: o, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return serializeToString(this, n, t, e, l), n.join("");
}
function needNamespaceDefine(t, e, n) {
  var a = t.prefix || "", s = t.namespaceURI;
  if (!s || a === "xml" && s === NAMESPACE$2.XML || s === NAMESPACE$2.XMLNS)
    return !1;
  for (var o = n.length; o--; ) {
    var l = n[o];
    if (l.prefix === a)
      return l.namespace !== s;
  }
  return !0;
}
function addSerializedAttribute(t, e, n) {
  t.push(" ", e, '="', n.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
}
function serializeToString(t, e, n, a, s) {
  if (s || (s = []), a)
    if (t = a(t), t) {
      if (typeof t == "string") {
        e.push(t);
        return;
      }
    } else
      return;
  switch (t.nodeType) {
    case ELEMENT_NODE:
      var o = t.attributes, l = o.length, y = t.firstChild, c = t.tagName;
      n = NAMESPACE$2.isHTML(t.namespaceURI) || n;
      var u = c;
      if (!n && !t.prefix && t.namespaceURI) {
        for (var d, f = 0; f < o.length; f++)
          if (o.item(f).name === "xmlns") {
            d = o.item(f).value;
            break;
          }
        if (!d)
          for (var h = s.length - 1; h >= 0; h--) {
            var g = s[h];
            if (g.prefix === "" && g.namespace === t.namespaceURI) {
              d = g.namespace;
              break;
            }
          }
        if (d !== t.namespaceURI)
          for (var h = s.length - 1; h >= 0; h--) {
            var g = s[h];
            if (g.namespace === t.namespaceURI) {
              g.prefix && (u = g.prefix + ":" + c);
              break;
            }
          }
      }
      e.push("<", u);
      for (var x = 0; x < l; x++) {
        var E = o.item(x);
        E.prefix == "xmlns" ? s.push({ prefix: E.localName, namespace: E.value }) : E.nodeName == "xmlns" && s.push({ prefix: "", namespace: E.value });
      }
      for (var x = 0; x < l; x++) {
        var E = o.item(x);
        if (needNamespaceDefine(E, n, s)) {
          var m = E.prefix || "", v = E.namespaceURI;
          addSerializedAttribute(e, m ? "xmlns:" + m : "xmlns", v), s.push({ prefix: m, namespace: v });
        }
        serializeToString(E, e, n, a, s);
      }
      if (c === u && needNamespaceDefine(t, n, s)) {
        var m = t.prefix || "", v = t.namespaceURI;
        addSerializedAttribute(e, m ? "xmlns:" + m : "xmlns", v), s.push({ prefix: m, namespace: v });
      }
      if (y || n && !/^(?:meta|link|img|br|hr|input)$/i.test(c)) {
        if (e.push(">"), n && /^script$/i.test(c))
          for (; y; )
            y.data ? e.push(y.data) : serializeToString(y, e, n, a, s.slice()), y = y.nextSibling;
        else
          for (; y; )
            serializeToString(y, e, n, a, s.slice()), y = y.nextSibling;
        e.push("</", u, ">");
      } else
        e.push("/>");
      return;
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      for (var y = t.firstChild; y; )
        serializeToString(y, e, n, a, s.slice()), y = y.nextSibling;
      return;
    case ATTRIBUTE_NODE:
      return addSerializedAttribute(e, t.name, t.value);
    case TEXT_NODE:
      return e.push(
        t.data.replace(/[<&>]/g, _xmlEncoder)
      );
    case CDATA_SECTION_NODE:
      return e.push("<![CDATA[", t.data, "]]>");
    case COMMENT_NODE:
      return e.push("<!--", t.data, "-->");
    case DOCUMENT_TYPE_NODE:
      var A = t.publicId, b = t.systemId;
      if (e.push("<!DOCTYPE ", t.name), A)
        e.push(" PUBLIC ", A), b && b != "." && e.push(" ", b), e.push(">");
      else if (b && b != ".")
        e.push(" SYSTEM ", b, ">");
      else {
        var C = t.internalSubset;
        C && e.push(" [", C, "]"), e.push(">");
      }
      return;
    case PROCESSING_INSTRUCTION_NODE:
      return e.push("<?", t.target, " ", t.data, "?>");
    case ENTITY_REFERENCE_NODE:
      return e.push("&", t.nodeName, ";");
    default:
      e.push("??", t.nodeName);
  }
}
function importNode(t, e, n) {
  var a;
  switch (e.nodeType) {
    case ELEMENT_NODE:
      a = e.cloneNode(!1), a.ownerDocument = t;
    case DOCUMENT_FRAGMENT_NODE:
      break;
    case ATTRIBUTE_NODE:
      n = !0;
      break;
  }
  if (a || (a = e.cloneNode(!1)), a.ownerDocument = t, a.parentNode = null, n)
    for (var s = e.firstChild; s; )
      a.appendChild(importNode(t, s, n)), s = s.nextSibling;
  return a;
}
function cloneNode(t, e, n) {
  var a = new e.constructor();
  for (var s in e)
    if (Object.prototype.hasOwnProperty.call(e, s)) {
      var o = e[s];
      typeof o != "object" && o != a[s] && (a[s] = o);
    }
  switch (e.childNodes && (a.childNodes = new NodeList()), a.ownerDocument = t, a.nodeType) {
    case ELEMENT_NODE:
      var l = e.attributes, c = a.attributes = new NamedNodeMap(), u = l.length;
      c._ownerElement = a;
      for (var d = 0; d < u; d++)
        a.setAttributeNode(cloneNode(t, l.item(d), !0));
      break;
    case ATTRIBUTE_NODE:
      n = !0;
  }
  if (n)
    for (var f = e.firstChild; f; )
      a.appendChild(cloneNode(t, f, n)), f = f.nextSibling;
  return a;
}
function __set__(t, e, n) {
  t[e] = n;
}
try {
  if (Object.defineProperty) {
    let t = function(e) {
      switch (e.nodeType) {
        case ELEMENT_NODE:
        case DOCUMENT_FRAGMENT_NODE:
          var n = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && n.push(t(e)), e = e.nextSibling;
          return n.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(LiveNodeList.prototype, "length", {
      get: function() {
        return _updateLiveList(this), this.$$length;
      }
    }), Object.defineProperty(Node$1.prototype, "textContent", {
      get: function() {
        return t(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case ELEMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), __set__ = function(e, n, a) {
      e["$$" + n] = a;
    };
  }
} catch (t) {
}
dom$3.DocumentType = DocumentType;
dom$3.DOMException = DOMException;
dom$3.DOMImplementation = DOMImplementation$1;
dom$3.Element = Element$2;
dom$3.Node = Node$1;
dom$3.NodeList = NodeList;
dom$3.XMLSerializer = XMLSerializer;
var domParser = {}, entities$1 = {};
(function(t) {
  var e = conventions$2.freeze;
  t.XML_ENTITIES = e({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), t.HTML_ENTITIES = e({
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    AMP: "&",
    amp: "&",
    And: "⩓",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    ap: "≈",
    apacir: "⩯",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    Barwed: "⌆",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    Because: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxDL: "╗",
    boxDl: "╖",
    boxdL: "╕",
    boxdl: "┐",
    boxDR: "╔",
    boxDr: "╓",
    boxdR: "╒",
    boxdr: "┌",
    boxH: "═",
    boxh: "─",
    boxHD: "╦",
    boxHd: "╤",
    boxhD: "╥",
    boxhd: "┬",
    boxHU: "╩",
    boxHu: "╧",
    boxhU: "╨",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxUL: "╝",
    boxUl: "╜",
    boxuL: "╛",
    boxul: "┘",
    boxUR: "╚",
    boxUr: "╙",
    boxuR: "╘",
    boxur: "└",
    boxV: "║",
    boxv: "│",
    boxVH: "╬",
    boxVh: "╫",
    boxvH: "╪",
    boxvh: "┼",
    boxVL: "╣",
    boxVl: "╢",
    boxvL: "╡",
    boxvl: "┤",
    boxVR: "╠",
    boxVr: "╟",
    boxvR: "╞",
    boxvr: "├",
    bprime: "‵",
    Breve: "˘",
    breve: "˘",
    brvbar: "¦",
    Bscr: "ℬ",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    Cap: "⋒",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    CenterDot: "·",
    centerdot: "·",
    Cfr: "ℭ",
    cfr: "𝔠",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    cir: "○",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    Colon: "∷",
    colon: ":",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    Conint: "∯",
    conint: "∮",
    ContourIntegral: "∮",
    Copf: "ℂ",
    copf: "𝕔",
    coprod: "∐",
    Coproduct: "∐",
    COPY: "©",
    copy: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    Cross: "⨯",
    cross: "✗",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    Cup: "⋓",
    cup: "∪",
    cupbrcap: "⩈",
    CupCap: "≍",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    Dagger: "‡",
    dagger: "†",
    daleth: "ℸ",
    Darr: "↡",
    dArr: "⇓",
    darr: "↓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    DD: "ⅅ",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    Diamond: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    Downarrow: "⇓",
    downarrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    ecir: "≖",
    Ecirc: "Ê",
    ecirc: "ê",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    eDot: "≑",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp: " ",
    emsp13: " ",
    emsp14: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    Escr: "ℰ",
    escr: "ℯ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    ExponentialE: "ⅇ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    ForAll: "∀",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    Fscr: "ℱ",
    fscr: "𝒻",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    gE: "≧",
    ge: "≥",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    Gg: "⋙",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gl: "≷",
    gla: "⪥",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gnE: "≩",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    Gt: "≫",
    GT: ">",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    hArr: "⇔",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    Hfr: "ℌ",
    hfr: "𝔥",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    Hopf: "ℍ",
    hopf: "𝕙",
    horbar: "―",
    HorizontalLine: "─",
    Hscr: "ℋ",
    hscr: "𝒽",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    Ifr: "ℑ",
    ifr: "𝔦",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Im: "ℑ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    Int: "∬",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    Iscr: "ℐ",
    iscr: "𝒾",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    Lang: "⟪",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    Larr: "↞",
    lArr: "⇐",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    lAtail: "⤛",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lBarr: "⤎",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    lE: "≦",
    le: "≤",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    Leftarrow: "⇐",
    leftarrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    Ll: "⋘",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lnE: "≨",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftarrow: "⟵",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    Lscr: "ℒ",
    lscr: "𝓁",
    Lsh: "↰",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    Lt: "≪",
    LT: "<",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    Mscr: "ℳ",
    mscr: "𝓂",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    nearhk: "⤤",
    neArr: "⇗",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlArr: "⇍",
    nlarr: "↚",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nLeftarrow: "⇍",
    nleftarrow: "↚",
    nLeftrightarrow: "⇎",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    nopf: "𝕟",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nRightarrow: "⇏",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nVDash: "⊯",
    nVdash: "⊮",
    nvDash: "⊭",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwArr: "⇖",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    Ocirc: "Ô",
    ocirc: "ô",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    Or: "⩔",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    Otimes: "⨷",
    otimes: "⊗",
    otimesas: "⨶",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    Popf: "ℙ",
    popf: "𝕡",
    pound: "£",
    Pr: "⪻",
    pr: "≺",
    prap: "⪷",
    prcue: "≼",
    prE: "⪳",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    Prime: "″",
    prime: "′",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportion: "∷",
    Proportional: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    Qopf: "ℚ",
    qopf: "𝕢",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    QUOT: '"',
    quot: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    Rang: "⟫",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    Rarr: "↠",
    rArr: "⇒",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    rAtail: "⤜",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    RBarr: "⤐",
    rBarr: "⤏",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    Re: "ℜ",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    REG: "®",
    reg: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    Rfr: "ℜ",
    rfr: "𝔯",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    Rightarrow: "⇒",
    rightarrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    Ropf: "ℝ",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    Rscr: "ℛ",
    rscr: "𝓇",
    Rsh: "↱",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    Sc: "⪼",
    sc: "≻",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    sccue: "≽",
    scE: "⪴",
    sce: "⪰",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    searhk: "⤥",
    seArr: "⇘",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    Square: "□",
    square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    Sub: "⋐",
    sub: "⊂",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    Subset: "⋐",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    Sum: "∑",
    sum: "∑",
    sung: "♪",
    Sup: "⋑",
    sup: "⊃",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    Supset: "⋑",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swArr: "⇙",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    Therefore: "∴",
    therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    thinsp: " ",
    ThinSpace: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    Tilde: "∼",
    tilde: "˜",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    TRADE: "™",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    Uarr: "↟",
    uArr: "⇑",
    uarr: "↑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrow: "↑",
    Uparrow: "⇑",
    uparrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    updownarrow: "↕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    upsi: "υ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    vArr: "⇕",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    Vbar: "⫫",
    vBar: "⫨",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    VDash: "⊫",
    Vdash: "⊩",
    vDash: "⊨",
    vdash: "⊢",
    Vdashl: "⫦",
    Vee: "⋁",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    Verbar: "‖",
    verbar: "|",
    Vert: "‖",
    vert: "|",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    Wedge: "⋀",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    Xi: "Ξ",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    Yuml: "Ÿ",
    yuml: "ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    Zfr: "ℨ",
    zfr: "𝔷",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    Zopf: "ℤ",
    zopf: "𝕫",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  }), t.entityMap = t.HTML_ENTITIES;
})(entities$1);
var sax$1 = {}, NAMESPACE$1 = conventions$2.NAMESPACE, nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), tagNamePattern = new RegExp("^" + nameStartChar.source + nameChar.source + "*(?::" + nameStartChar.source + nameChar.source + "*)?$"), S_TAG = 0, S_ATTR = 1, S_ATTR_SPACE = 2, S_EQ = 3, S_ATTR_NOQUOT_VALUE = 4, S_ATTR_END = 5, S_TAG_SPACE = 6, S_TAG_CLOSE = 7;
function ParseError$1(t, e) {
  this.message = t, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, ParseError$1);
}
ParseError$1.prototype = new Error();
ParseError$1.prototype.name = ParseError$1.name;
function XMLReader$1() {
}
XMLReader$1.prototype = {
  parse: function(t, e, n) {
    var a = this.domBuilder;
    a.startDocument(), _copy(e, e = {}), parse(
      t,
      e,
      n,
      a,
      this.errorHandler
    ), a.endDocument();
  }
};
function parse(t, e, n, a, s) {
  function o(Y) {
    if (Y > 65535) {
      Y -= 65536;
      var ie = 55296 + (Y >> 10), te = 56320 + (Y & 1023);
      return String.fromCharCode(ie, te);
    } else
      return String.fromCharCode(Y);
  }
  function l(Y) {
    var ie = Y.slice(1, -1);
    return Object.hasOwnProperty.call(n, ie) ? n[ie] : ie.charAt(0) === "#" ? o(parseInt(ie.substr(1).replace("x", "0x"))) : (s.error("entity not found:" + Y), Y);
  }
  function c(Y) {
    if (Y > m) {
      var ie = t.substring(m, Y).replace(/&#?\w+;/g, l);
      g && u(m), a.characters(ie, 0, Y - m), m = Y;
    }
  }
  function u(Y, ie) {
    for (; Y >= f && (ie = h.exec(t)); )
      d = ie.index, f = d + ie[0].length, g.lineNumber++;
    g.columnNumber = Y - d + 1;
  }
  for (var d = 0, f = 0, h = /.*(?:\r\n?|\n)|.*$/g, g = a.locator, x = [{ currentNSMap: e }], E = {}, m = 0; ; ) {
    try {
      var v = t.indexOf("<", m);
      if (v < 0) {
        if (!t.substr(m).match(/^\s*$/)) {
          var y = a.doc, A = y.createTextNode(t.substr(m));
          y.appendChild(A), a.currentElement = A;
        }
        return;
      }
      switch (v > m && c(v), t.charAt(v + 1)) {
        case "/":
          var W = t.indexOf(">", v + 3), b = t.substring(v + 2, W).replace(/[ \t\n\r]+$/g, ""), C = x.pop();
          W < 0 ? (b = t.substring(v + 2).replace(/[\s<].*/, ""), s.error("end tag name: " + b + " is not complete:" + C.tagName), W = v + 1 + b.length) : b.match(/\s</) && (b = b.replace(/[\s<].*/, ""), s.error("end tag name: " + b + " maybe not complete"), W = v + 1 + b.length);
          var T = C.localNSMap, w = C.tagName == b, R = w || C.tagName && C.tagName.toLowerCase() == b.toLowerCase();
          if (R) {
            if (a.endElement(C.uri, C.localName, b), T)
              for (var O in T)
                Object.prototype.hasOwnProperty.call(T, O) && a.endPrefixMapping(O);
            w || s.fatalError("end tag name: " + b + " is not match the current start tagName:" + C.tagName);
          } else
            x.push(C);
          W++;
          break;
        case "?":
          g && u(v), W = parseInstruction(t, v, a);
          break;
        case "!":
          g && u(v), W = parseDCC(t, v, a, s);
          break;
        default:
          g && u(v);
          var D = new ElementAttributes(), k = x[x.length - 1].currentNSMap, W = parseElementStartPart(t, v, D, k, l, s), L = D.length;
          if (!D.closed && fixSelfClosed(t, W, D.tagName, E) && (D.closed = !0, n.nbsp || s.warning("unclosed xml attribute")), g && L) {
            for (var z = copyLocator(g, {}), P = 0; P < L; P++) {
              var Q = D[P];
              u(Q.offset), Q.locator = copyLocator(g, {});
            }
            a.locator = z, appendElement$1(D, a, k) && x.push(D), a.locator = g;
          } else
            appendElement$1(D, a, k) && x.push(D);
          NAMESPACE$1.isHTML(D.uri) && !D.closed ? W = parseHtmlSpecialContent(t, W, D.tagName, l, a) : W++;
      }
    } catch (Y) {
      if (Y instanceof ParseError$1)
        throw Y;
      s.error("element parse error: " + Y), W = -1;
    }
    W > m ? m = W : c(Math.max(v, m) + 1);
  }
}
function copyLocator(t, e) {
  return e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber, e;
}
function parseElementStartPart(t, e, n, a, s, o) {
  function l(g, x, E) {
    n.attributeNames.hasOwnProperty(g) && o.fatalError("Attribute " + g + " redefined"), n.addValue(
      g,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      x.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, s),
      E
    );
  }
  for (var c, u, d = ++e, f = S_TAG; ; ) {
    var h = t.charAt(d);
    switch (h) {
      case "=":
        if (f === S_ATTR)
          c = t.slice(e, d), f = S_EQ;
        else if (f === S_ATTR_SPACE)
          f = S_EQ;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (f === S_EQ || f === S_ATTR)
          if (f === S_ATTR && (o.warning('attribute value must after "="'), c = t.slice(e, d)), e = d + 1, d = t.indexOf(h, e), d > 0)
            u = t.slice(e, d), l(c, u, e - 1), f = S_ATTR_END;
          else
            throw new Error("attribute value no end '" + h + "' match");
        else if (f == S_ATTR_NOQUOT_VALUE)
          u = t.slice(e, d), l(c, u, e), o.warning('attribute "' + c + '" missed start quot(' + h + ")!!"), e = d + 1, f = S_ATTR_END;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (f) {
          case S_TAG:
            n.setTagName(t.slice(e, d));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            f = S_TAG_CLOSE, n.closed = !0;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            break;
          case S_ATTR_SPACE:
            n.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return o.error("unexpected end of input"), f == S_TAG && n.setTagName(t.slice(e, d)), d;
      case ">":
        switch (f) {
          case S_TAG:
            n.setTagName(t.slice(e, d));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            break;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            u = t.slice(e, d), u.slice(-1) === "/" && (n.closed = !0, u = u.slice(0, -1));
          case S_ATTR_SPACE:
            f === S_ATTR_SPACE && (u = c), f == S_ATTR_NOQUOT_VALUE ? (o.warning('attribute "' + u + '" missed quot(")!'), l(c, u, e)) : ((!NAMESPACE$1.isHTML(a[""]) || !u.match(/^(?:disabled|checked|selected)$/i)) && o.warning('attribute "' + u + '" missed value!! "' + u + '" instead!!'), l(u, u, e));
            break;
          case S_EQ:
            throw new Error("attribute value missed!!");
        }
        return d;
      case "":
        h = " ";
      default:
        if (h <= " ")
          switch (f) {
            case S_TAG:
              n.setTagName(t.slice(e, d)), f = S_TAG_SPACE;
              break;
            case S_ATTR:
              c = t.slice(e, d), f = S_ATTR_SPACE;
              break;
            case S_ATTR_NOQUOT_VALUE:
              var u = t.slice(e, d);
              o.warning('attribute "' + u + '" missed quot(")!!'), l(c, u, e);
            case S_ATTR_END:
              f = S_TAG_SPACE;
              break;
          }
        else
          switch (f) {
            case S_ATTR_SPACE:
              n.tagName, (!NAMESPACE$1.isHTML(a[""]) || !c.match(/^(?:disabled|checked|selected)$/i)) && o.warning('attribute "' + c + '" missed value!! "' + c + '" instead2!!'), l(c, c, e), e = d, f = S_ATTR;
              break;
            case S_ATTR_END:
              o.warning('attribute space is required"' + c + '"!!');
            case S_TAG_SPACE:
              f = S_ATTR, e = d;
              break;
            case S_EQ:
              f = S_ATTR_NOQUOT_VALUE, e = d;
              break;
            case S_TAG_CLOSE:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    d++;
  }
}
function appendElement$1(t, e, n) {
  for (var a = t.tagName, s = null, h = t.length; h--; ) {
    var o = t[h], l = o.qName, c = o.value, g = l.indexOf(":");
    if (g > 0)
      var u = o.prefix = l.slice(0, g), d = l.slice(g + 1), f = u === "xmlns" && d;
    else
      d = l, u = null, f = l === "xmlns" && "";
    o.localName = d, f !== !1 && (s == null && (s = {}, _copy(n, n = {})), n[f] = s[f] = c, o.uri = NAMESPACE$1.XMLNS, e.startPrefixMapping(f, c));
  }
  for (var h = t.length; h--; ) {
    o = t[h];
    var u = o.prefix;
    u && (u === "xml" && (o.uri = NAMESPACE$1.XML), u !== "xmlns" && (o.uri = n[u || ""]));
  }
  var g = a.indexOf(":");
  g > 0 ? (u = t.prefix = a.slice(0, g), d = t.localName = a.slice(g + 1)) : (u = null, d = t.localName = a);
  var x = t.uri = n[u || ""];
  if (e.startElement(x, d, a, t), t.closed) {
    if (e.endElement(x, d, a), s)
      for (u in s)
        Object.prototype.hasOwnProperty.call(s, u) && e.endPrefixMapping(u);
  } else
    return t.currentNSMap = n, t.localNSMap = s, !0;
}
function parseHtmlSpecialContent(t, e, n, a, s) {
  if (/^(?:script|textarea)$/i.test(n)) {
    var o = t.indexOf("</" + n + ">", e), l = t.substring(e + 1, o);
    if (/[&<]/.test(l))
      return /^script$/i.test(n) ? (s.characters(l, 0, l.length), o) : (l = l.replace(/&#?\w+;/g, a), s.characters(l, 0, l.length), o);
  }
  return e + 1;
}
function fixSelfClosed(t, e, n, a) {
  var s = a[n];
  return s == null && (s = t.lastIndexOf("</" + n + ">"), s < e && (s = t.lastIndexOf("</" + n)), a[n] = s), s < e;
}
function _copy(t, e) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
}
function parseDCC(t, e, n, a) {
  var s = t.charAt(e + 2);
  switch (s) {
    case "-":
      if (t.charAt(e + 3) === "-") {
        var o = t.indexOf("-->", e + 4);
        return o > e ? (n.comment(t, e + 4, o - e - 4), o + 3) : (a.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (t.substr(e + 3, 6) == "CDATA[") {
        var o = t.indexOf("]]>", e + 9);
        return n.startCDATA(), n.characters(t, e + 9, o - e - 9), n.endCDATA(), o + 3;
      }
      var l = split(t, e), c = l.length;
      if (c > 1 && /!doctype/i.test(l[0][0])) {
        var u = l[1][0], d = !1, f = !1;
        c > 3 && (/^public$/i.test(l[2][0]) ? (d = l[3][0], f = c > 4 && l[4][0]) : /^system$/i.test(l[2][0]) && (f = l[3][0]));
        var h = l[c - 1];
        return n.startDTD(u, d, f), n.endDTD(), h.index + h[0].length;
      }
  }
  return -1;
}
function parseInstruction(t, e, n) {
  var a = t.indexOf("?>", e);
  if (a) {
    var s = t.substring(e, a).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return s ? (s[0].length, n.processingInstruction(s[1], s[2]), a + 2) : -1;
  }
  return -1;
}
function ElementAttributes() {
  this.attributeNames = {};
}
ElementAttributes.prototype = {
  setTagName: function(t) {
    if (!tagNamePattern.test(t))
      throw new Error("invalid tagName:" + t);
    this.tagName = t;
  },
  addValue: function(t, e, n) {
    if (!tagNamePattern.test(t))
      throw new Error("invalid attribute:" + t);
    this.attributeNames[t] = this.length, this[this.length++] = { qName: t, value: e, offset: n };
  },
  length: 0,
  getLocalName: function(t) {
    return this[t].localName;
  },
  getLocator: function(t) {
    return this[t].locator;
  },
  getQName: function(t) {
    return this[t].qName;
  },
  getURI: function(t) {
    return this[t].uri;
  },
  getValue: function(t) {
    return this[t].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function split(t, e) {
  var n, a = [], s = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (s.lastIndex = e, s.exec(t); n = s.exec(t); )
    if (a.push(n), n[1])
      return a;
}
sax$1.XMLReader = XMLReader$1;
sax$1.ParseError = ParseError$1;
var conventions = conventions$2, dom$2 = dom$3, entities = entities$1, sax = sax$1, DOMImplementation = dom$2.DOMImplementation, NAMESPACE = conventions.NAMESPACE, ParseError = sax.ParseError, XMLReader = sax.XMLReader;
function normalizeLineEndings(t) {
  return t.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function DOMParser(t) {
  this.options = t || { locator: {} };
}
DOMParser.prototype.parseFromString = function(t, e) {
  var n = this.options, a = new XMLReader(), s = n.domBuilder || new DOMHandler(), o = n.errorHandler, l = n.locator, c = n.xmlns || {}, u = /\/x?html?$/.test(e), d = u ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
  l && s.setDocumentLocator(l), a.errorHandler = buildErrorHandler(o, s, l), a.domBuilder = n.domBuilder || s, u && (c[""] = NAMESPACE.HTML), c.xml = c.xml || NAMESPACE.XML;
  var f = n.normalizeLineEndings || normalizeLineEndings;
  return t && typeof t == "string" ? a.parse(
    f(t),
    c,
    d
  ) : a.errorHandler.error("invalid doc source"), s.doc;
};
function buildErrorHandler(t, e, n) {
  if (!t) {
    if (e instanceof DOMHandler)
      return e;
    t = e;
  }
  var a = {}, s = t instanceof Function;
  n = n || {};
  function o(l) {
    var c = t[l];
    !c && s && (c = t.length == 2 ? function(u) {
      t(l, u);
    } : t), a[l] = c && function(u) {
      c("[xmldom " + l + "]	" + u + _locator(n));
    } || function() {
    };
  }
  return o("warning"), o("error"), o("fatalError"), a;
}
function DOMHandler() {
  this.cdata = !1;
}
function position(t, e) {
  e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber;
}
DOMHandler.prototype = {
  startDocument: function() {
    this.doc = new DOMImplementation().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(t, e, n, a) {
    var s = this.doc, o = s.createElementNS(t, n || e), l = a.length;
    appendElement(this, o), this.currentElement = o, this.locator && position(this.locator, o);
    for (var c = 0; c < l; c++) {
      var t = a.getURI(c), u = a.getValue(c), n = a.getQName(c), d = s.createAttributeNS(t, n);
      this.locator && position(a.getLocator(c), d), d.value = d.nodeValue = u, o.setAttributeNode(d);
    }
  },
  endElement: function(t, e, n) {
    var a = this.currentElement;
    a.tagName, this.currentElement = a.parentNode;
  },
  startPrefixMapping: function(t, e) {
  },
  endPrefixMapping: function(t) {
  },
  processingInstruction: function(t, e) {
    var n = this.doc.createProcessingInstruction(t, e);
    this.locator && position(this.locator, n), appendElement(this, n);
  },
  ignorableWhitespace: function(t, e, n) {
  },
  characters: function(t, e, n) {
    if (t = _toString.apply(this, arguments), t) {
      if (this.cdata)
        var a = this.doc.createCDATASection(t);
      else
        var a = this.doc.createTextNode(t);
      this.currentElement ? this.currentElement.appendChild(a) : /^\s*$/.test(t) && this.doc.appendChild(a), this.locator && position(this.locator, a);
    }
  },
  skippedEntity: function(t) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(t) {
    (this.locator = t) && (t.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(t, e, n) {
    t = _toString.apply(this, arguments);
    var a = this.doc.createComment(t);
    this.locator && position(this.locator, a), appendElement(this, a);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(t, e, n) {
    var a = this.doc.implementation;
    if (a && a.createDocumentType) {
      var s = a.createDocumentType(t, e, n);
      this.locator && position(this.locator, s), appendElement(this, s), this.doc.doctype = s;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(t) {
    console.warn("[xmldom warning]	" + t, _locator(this.locator));
  },
  error: function(t) {
    console.error("[xmldom error]	" + t, _locator(this.locator));
  },
  fatalError: function(t) {
    throw new ParseError(t, this.locator);
  }
};
function _locator(t) {
  if (t)
    return `
@` + (t.systemId || "") + "#[line:" + t.lineNumber + ",col:" + t.columnNumber + "]";
}
function _toString(t, e, n) {
  return typeof t == "string" ? t.substr(e, n) : t.length >= e + n || e ? new java.lang.String(t, e, n) + "" : t;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(t) {
  DOMHandler.prototype[t] = function() {
    return null;
  };
});
function appendElement(t, e) {
  t.currentElement ? t.currentElement.appendChild(e) : t.doc.appendChild(e);
}
domParser.__DOMHandler = DOMHandler;
domParser.normalizeLineEndings = normalizeLineEndings;
domParser.DOMParser = DOMParser;
var dom$1 = dom$3;
lib$1.DOMImplementation = dom$1.DOMImplementation;
lib$1.XMLSerializer = dom$1.XMLSerializer;
lib$1.DOMParser = domParser.DOMParser;
var xmldom$1 = lib$1, dom = dom$3;
function parseFromString(t) {
  var e = null, n = new xmldom$1.DOMParser({
    errorHandler: function(s, o) {
      e = { level: s, message: o };
    }
  }), a = n.parseFromString(t);
  if (e === null)
    return a;
  throw new Error(e.level + ": " + e.message);
}
xmldom$2.parseFromString = parseFromString;
xmldom$2.Node = dom.Node;
var promises$6 = promises$7, _$c = require$$0, xmldom = xmldom$2, nodes$1 = nodes$2, Element$1 = nodes$1.Element;
reader.readString = readString;
var Node = xmldom.Node;
function readString(t, e) {
  e = e || {};
  try {
    var n = xmldom.parseFromString(t, "text/xml");
  } catch (l) {
    return promises$6.reject(l);
  }
  if (n.documentElement.tagName === "parsererror")
    return promises$6.resolve(new Error(n.documentElement.textContent));
  function a(l) {
    switch (l.nodeType) {
      case Node.ELEMENT_NODE:
        return s(l);
      case Node.TEXT_NODE:
        return nodes$1.text(l.nodeValue);
    }
  }
  function s(l) {
    var c = o(l), u = [];
    _$c.forEach(l.childNodes, function(f) {
      var h = a(f);
      h && u.push(h);
    });
    var d = {};
    return _$c.forEach(l.attributes, function(f) {
      d[o(f)] = f.value;
    }), new Element$1(c, d, u);
  }
  function o(l) {
    if (l.namespaceURI) {
      var c = e[l.namespaceURI], u;
      return c ? u = c + ":" : u = "{" + l.namespaceURI + "}", u + l.localName;
    } else
      return l.localName;
  }
  return promises$6.resolve(a(n.documentElement));
}
var writer$2 = {}, lib = {}, Utility = {}, hasRequiredUtility;
function requireUtility() {
  return hasRequiredUtility || (hasRequiredUtility = 1, (function() {
    var t, e, n, a, s, o, l, c = [].slice, u = {}.hasOwnProperty;
    t = function() {
      var d, f, h, g, x, E;
      if (E = arguments[0], x = 2 <= arguments.length ? c.call(arguments, 1) : [], s(Object.assign))
        Object.assign.apply(null, arguments);
      else
        for (d = 0, h = x.length; d < h; d++)
          if (g = x[d], g != null)
            for (f in g)
              u.call(g, f) && (E[f] = g[f]);
      return E;
    }, s = function(d) {
      return !!d && Object.prototype.toString.call(d) === "[object Function]";
    }, o = function(d) {
      var f;
      return !!d && ((f = typeof d) == "function" || f === "object");
    }, n = function(d) {
      return s(Array.isArray) ? Array.isArray(d) : Object.prototype.toString.call(d) === "[object Array]";
    }, a = function(d) {
      var f;
      if (n(d))
        return !d.length;
      for (f in d)
        if (u.call(d, f))
          return !1;
      return !0;
    }, l = function(d) {
      var f, h;
      return o(d) && (h = Object.getPrototypeOf(d)) && (f = h.constructor) && typeof f == "function" && f instanceof f && Function.prototype.toString.call(f) === Function.prototype.toString.call(Object);
    }, e = function(d) {
      return s(d.valueOf) ? d.valueOf() : d;
    }, Utility.assign = t, Utility.isFunction = s, Utility.isObject = o, Utility.isArray = n, Utility.isEmpty = a, Utility.isPlainObject = l, Utility.getValue = e;
  }).call(commonjsGlobal)), Utility;
}
var XMLDocument = { exports: {} }, XMLNode = { exports: {} }, XMLElement = { exports: {} }, XMLAttribute = { exports: {} }, hasRequiredXMLAttribute;
function requireXMLAttribute() {
  return hasRequiredXMLAttribute || (hasRequiredXMLAttribute = 1, (function() {
    XMLAttribute.exports = function() {
      function t(e, n, a) {
        if (this.options = e.options, this.stringify = e.stringify, this.parent = e, n == null)
          throw new Error("Missing attribute name. " + this.debugInfo(n));
        if (a == null)
          throw new Error("Missing attribute value. " + this.debugInfo(n));
        this.name = this.stringify.attName(n), this.value = this.stringify.attValue(a);
      }
      return t.prototype.clone = function() {
        return Object.create(this);
      }, t.prototype.toString = function(e) {
        return this.options.writer.set(e).attribute(this);
      }, t.prototype.debugInfo = function(e) {
        return e = e || this.name, e == null ? "parent: <" + this.parent.name + ">" : "attribute: {" + e + "}, parent: <" + this.parent.name + ">";
      }, t;
    }();
  }).call(commonjsGlobal)), XMLAttribute.exports;
}
var hasRequiredXMLElement;
function requireXMLElement() {
  return hasRequiredXMLElement || (hasRequiredXMLElement = 1, (function() {
    var t, e, n, a, s, o, l = function(u, d) {
      for (var f in d)
        c.call(d, f) && (u[f] = d[f]);
      function h() {
        this.constructor = u;
      }
      return h.prototype = d.prototype, u.prototype = new h(), u.__super__ = d.prototype, u;
    }, c = {}.hasOwnProperty;
    o = requireUtility(), s = o.isObject, a = o.isFunction, n = o.getValue, e = requireXMLNode(), t = requireXMLAttribute(), XMLElement.exports = function(u) {
      l(d, u);
      function d(f, h, g) {
        if (d.__super__.constructor.call(this, f), h == null)
          throw new Error("Missing element name. " + this.debugInfo());
        this.name = this.stringify.eleName(h), this.attributes = {}, g != null && this.attribute(g), f.isDocument && (this.isRoot = !0, this.documentObject = f, f.rootObject = this);
      }
      return d.prototype.clone = function() {
        var f, h, g, x;
        g = Object.create(this), g.isRoot && (g.documentObject = null), g.attributes = {}, x = this.attributes;
        for (h in x)
          c.call(x, h) && (f = x[h], g.attributes[h] = f.clone());
        return g.children = [], this.children.forEach(function(E) {
          var m;
          return m = E.clone(), m.parent = g, g.children.push(m);
        }), g;
      }, d.prototype.attribute = function(f, h) {
        var g, x;
        if (f != null && (f = n(f)), s(f))
          for (g in f)
            c.call(f, g) && (x = f[g], this.attribute(g, x));
        else
          a(h) && (h = h.apply()), (!this.options.skipNullAttributes || h != null) && (this.attributes[f] = new t(this, f, h));
        return this;
      }, d.prototype.removeAttribute = function(f) {
        var h, g, x;
        if (f == null)
          throw new Error("Missing attribute name. " + this.debugInfo());
        if (f = n(f), Array.isArray(f))
          for (g = 0, x = f.length; g < x; g++)
            h = f[g], delete this.attributes[h];
        else
          delete this.attributes[f];
        return this;
      }, d.prototype.toString = function(f) {
        return this.options.writer.set(f).element(this);
      }, d.prototype.att = function(f, h) {
        return this.attribute(f, h);
      }, d.prototype.a = function(f, h) {
        return this.attribute(f, h);
      }, d;
    }(e);
  }).call(commonjsGlobal)), XMLElement.exports;
}
var XMLCData = { exports: {} }, hasRequiredXMLCData;
function requireXMLCData() {
  return hasRequiredXMLCData || (hasRequiredXMLCData = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLCData.exports = function(a) {
      e(s, a);
      function s(o, l) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing CDATA text. " + this.debugInfo());
        this.text = this.stringify.cdata(l);
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return this.options.writer.set(o).cdata(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLCData.exports;
}
var XMLComment = { exports: {} }, hasRequiredXMLComment;
function requireXMLComment() {
  return hasRequiredXMLComment || (hasRequiredXMLComment = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLComment.exports = function(a) {
      e(s, a);
      function s(o, l) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing comment text. " + this.debugInfo());
        this.text = this.stringify.comment(l);
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return this.options.writer.set(o).comment(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLComment.exports;
}
var XMLDeclaration = { exports: {} }, hasRequiredXMLDeclaration;
function requireXMLDeclaration() {
  return hasRequiredXMLDeclaration || (hasRequiredXMLDeclaration = 1, (function() {
    var t, e, n = function(s, o) {
      for (var l in o)
        a.call(o, l) && (s[l] = o[l]);
      function c() {
        this.constructor = s;
      }
      return c.prototype = o.prototype, s.prototype = new c(), s.__super__ = o.prototype, s;
    }, a = {}.hasOwnProperty;
    e = requireUtility().isObject, t = requireXMLNode(), XMLDeclaration.exports = function(s) {
      n(o, s);
      function o(l, c, u, d) {
        var f;
        o.__super__.constructor.call(this, l), e(c) && (f = c, c = f.version, u = f.encoding, d = f.standalone), c || (c = "1.0"), this.version = this.stringify.xmlVersion(c), u != null && (this.encoding = this.stringify.xmlEncoding(u)), d != null && (this.standalone = this.stringify.xmlStandalone(d));
      }
      return o.prototype.toString = function(l) {
        return this.options.writer.set(l).declaration(this);
      }, o;
    }(t);
  }).call(commonjsGlobal)), XMLDeclaration.exports;
}
var XMLDocType = { exports: {} }, XMLDTDAttList = { exports: {} }, hasRequiredXMLDTDAttList;
function requireXMLDTDAttList() {
  return hasRequiredXMLDTDAttList || (hasRequiredXMLDTDAttList = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLDTDAttList.exports = function(a) {
      e(s, a);
      function s(o, l, c, u, d, f) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing DTD element name. " + this.debugInfo());
        if (c == null)
          throw new Error("Missing DTD attribute name. " + this.debugInfo(l));
        if (!u)
          throw new Error("Missing DTD attribute type. " + this.debugInfo(l));
        if (!d)
          throw new Error("Missing DTD attribute default. " + this.debugInfo(l));
        if (d.indexOf("#") !== 0 && (d = "#" + d), !d.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/))
          throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(l));
        if (f && !d.match(/^(#FIXED|#DEFAULT)$/))
          throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(l));
        this.elementName = this.stringify.eleName(l), this.attributeName = this.stringify.attName(c), this.attributeType = this.stringify.dtdAttType(u), this.defaultValue = this.stringify.dtdAttDefault(f), this.defaultValueType = d;
      }
      return s.prototype.toString = function(o) {
        return this.options.writer.set(o).dtdAttList(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLDTDAttList.exports;
}
var XMLDTDEntity = { exports: {} }, hasRequiredXMLDTDEntity;
function requireXMLDTDEntity() {
  return hasRequiredXMLDTDEntity || (hasRequiredXMLDTDEntity = 1, (function() {
    var t, e, n = function(s, o) {
      for (var l in o)
        a.call(o, l) && (s[l] = o[l]);
      function c() {
        this.constructor = s;
      }
      return c.prototype = o.prototype, s.prototype = new c(), s.__super__ = o.prototype, s;
    }, a = {}.hasOwnProperty;
    e = requireUtility().isObject, t = requireXMLNode(), XMLDTDEntity.exports = function(s) {
      n(o, s);
      function o(l, c, u, d) {
        if (o.__super__.constructor.call(this, l), u == null)
          throw new Error("Missing DTD entity name. " + this.debugInfo(u));
        if (d == null)
          throw new Error("Missing DTD entity value. " + this.debugInfo(u));
        if (this.pe = !!c, this.name = this.stringify.eleName(u), !e(d))
          this.value = this.stringify.dtdEntityValue(d);
        else {
          if (!d.pubID && !d.sysID)
            throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(u));
          if (d.pubID && !d.sysID)
            throw new Error("System identifier is required for a public external entity. " + this.debugInfo(u));
          if (d.pubID != null && (this.pubID = this.stringify.dtdPubID(d.pubID)), d.sysID != null && (this.sysID = this.stringify.dtdSysID(d.sysID)), d.nData != null && (this.nData = this.stringify.dtdNData(d.nData)), this.pe && this.nData)
            throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(u));
        }
      }
      return o.prototype.toString = function(l) {
        return this.options.writer.set(l).dtdEntity(this);
      }, o;
    }(t);
  }).call(commonjsGlobal)), XMLDTDEntity.exports;
}
var XMLDTDElement = { exports: {} }, hasRequiredXMLDTDElement;
function requireXMLDTDElement() {
  return hasRequiredXMLDTDElement || (hasRequiredXMLDTDElement = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLDTDElement.exports = function(a) {
      e(s, a);
      function s(o, l, c) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing DTD element name. " + this.debugInfo());
        c || (c = "(#PCDATA)"), Array.isArray(c) && (c = "(" + c.join(",") + ")"), this.name = this.stringify.eleName(l), this.value = this.stringify.dtdElementValue(c);
      }
      return s.prototype.toString = function(o) {
        return this.options.writer.set(o).dtdElement(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLDTDElement.exports;
}
var XMLDTDNotation = { exports: {} }, hasRequiredXMLDTDNotation;
function requireXMLDTDNotation() {
  return hasRequiredXMLDTDNotation || (hasRequiredXMLDTDNotation = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLDTDNotation.exports = function(a) {
      e(s, a);
      function s(o, l, c) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing DTD notation name. " + this.debugInfo(l));
        if (!c.pubID && !c.sysID)
          throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(l));
        this.name = this.stringify.eleName(l), c.pubID != null && (this.pubID = this.stringify.dtdPubID(c.pubID)), c.sysID != null && (this.sysID = this.stringify.dtdSysID(c.sysID));
      }
      return s.prototype.toString = function(o) {
        return this.options.writer.set(o).dtdNotation(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLDTDNotation.exports;
}
var hasRequiredXMLDocType;
function requireXMLDocType() {
  return hasRequiredXMLDocType || (hasRequiredXMLDocType = 1, (function() {
    var t, e, n, a, s, o, l = function(u, d) {
      for (var f in d)
        c.call(d, f) && (u[f] = d[f]);
      function h() {
        this.constructor = u;
      }
      return h.prototype = d.prototype, u.prototype = new h(), u.__super__ = d.prototype, u;
    }, c = {}.hasOwnProperty;
    o = requireUtility().isObject, s = requireXMLNode(), t = requireXMLDTDAttList(), n = requireXMLDTDEntity(), e = requireXMLDTDElement(), a = requireXMLDTDNotation(), XMLDocType.exports = function(u) {
      l(d, u);
      function d(f, h, g) {
        var x, E;
        d.__super__.constructor.call(this, f), this.name = "!DOCTYPE", this.documentObject = f, o(h) && (x = h, h = x.pubID, g = x.sysID), g == null && (E = [h, g], g = E[0], h = E[1]), h != null && (this.pubID = this.stringify.dtdPubID(h)), g != null && (this.sysID = this.stringify.dtdSysID(g));
      }
      return d.prototype.element = function(f, h) {
        var g;
        return g = new e(this, f, h), this.children.push(g), this;
      }, d.prototype.attList = function(f, h, g, x, E) {
        var m;
        return m = new t(this, f, h, g, x, E), this.children.push(m), this;
      }, d.prototype.entity = function(f, h) {
        var g;
        return g = new n(this, !1, f, h), this.children.push(g), this;
      }, d.prototype.pEntity = function(f, h) {
        var g;
        return g = new n(this, !0, f, h), this.children.push(g), this;
      }, d.prototype.notation = function(f, h) {
        var g;
        return g = new a(this, f, h), this.children.push(g), this;
      }, d.prototype.toString = function(f) {
        return this.options.writer.set(f).docType(this);
      }, d.prototype.ele = function(f, h) {
        return this.element(f, h);
      }, d.prototype.att = function(f, h, g, x, E) {
        return this.attList(f, h, g, x, E);
      }, d.prototype.ent = function(f, h) {
        return this.entity(f, h);
      }, d.prototype.pent = function(f, h) {
        return this.pEntity(f, h);
      }, d.prototype.not = function(f, h) {
        return this.notation(f, h);
      }, d.prototype.up = function() {
        return this.root() || this.documentObject;
      }, d;
    }(s);
  }).call(commonjsGlobal)), XMLDocType.exports;
}
var XMLRaw = { exports: {} }, hasRequiredXMLRaw;
function requireXMLRaw() {
  return hasRequiredXMLRaw || (hasRequiredXMLRaw = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLRaw.exports = function(a) {
      e(s, a);
      function s(o, l) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing raw text. " + this.debugInfo());
        this.value = this.stringify.raw(l);
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return this.options.writer.set(o).raw(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLRaw.exports;
}
var XMLText = { exports: {} }, hasRequiredXMLText;
function requireXMLText() {
  return hasRequiredXMLText || (hasRequiredXMLText = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLText.exports = function(a) {
      e(s, a);
      function s(o, l) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing element text. " + this.debugInfo());
        this.value = this.stringify.eleText(l);
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return this.options.writer.set(o).text(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLText.exports;
}
var XMLProcessingInstruction = { exports: {} }, hasRequiredXMLProcessingInstruction;
function requireXMLProcessingInstruction() {
  return hasRequiredXMLProcessingInstruction || (hasRequiredXMLProcessingInstruction = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLProcessingInstruction.exports = function(a) {
      e(s, a);
      function s(o, l, c) {
        if (s.__super__.constructor.call(this, o), l == null)
          throw new Error("Missing instruction target. " + this.debugInfo());
        this.target = this.stringify.insTarget(l), c && (this.value = this.stringify.insValue(c));
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return this.options.writer.set(o).processingInstruction(this);
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLProcessingInstruction.exports;
}
var XMLDummy = { exports: {} }, hasRequiredXMLDummy;
function requireXMLDummy() {
  return hasRequiredXMLDummy || (hasRequiredXMLDummy = 1, (function() {
    var t, e = function(a, s) {
      for (var o in s)
        n.call(s, o) && (a[o] = s[o]);
      function l() {
        this.constructor = a;
      }
      return l.prototype = s.prototype, a.prototype = new l(), a.__super__ = s.prototype, a;
    }, n = {}.hasOwnProperty;
    t = requireXMLNode(), XMLDummy.exports = function(a) {
      e(s, a);
      function s(o) {
        s.__super__.constructor.call(this, o), this.isDummy = !0;
      }
      return s.prototype.clone = function() {
        return Object.create(this);
      }, s.prototype.toString = function(o) {
        return "";
      }, s;
    }(t);
  }).call(commonjsGlobal)), XMLDummy.exports;
}
var hasRequiredXMLNode;
function requireXMLNode() {
  return hasRequiredXMLNode || (hasRequiredXMLNode = 1, (function() {
    var t, e, n, a, s, o, l, c, u, d, f, h, g, x, E = {}.hasOwnProperty;
    x = requireUtility(), g = x.isObject, h = x.isFunction, f = x.isEmpty, d = x.getValue, o = null, t = null, e = null, n = null, a = null, c = null, u = null, l = null, s = null, XMLNode.exports = function() {
      function m(v) {
        this.parent = v, this.parent && (this.options = this.parent.options, this.stringify = this.parent.stringify), this.children = [], o || (o = requireXMLElement(), t = requireXMLCData(), e = requireXMLComment(), n = requireXMLDeclaration(), a = requireXMLDocType(), c = requireXMLRaw(), u = requireXMLText(), l = requireXMLProcessingInstruction(), s = requireXMLDummy());
      }
      return m.prototype.element = function(v, y, A) {
        var b, C, T, w, R, O, D, k, W, L, z;
        if (O = null, y === null && A == null && (W = [{}, null], y = W[0], A = W[1]), y == null && (y = {}), y = d(y), g(y) || (L = [y, A], A = L[0], y = L[1]), v != null && (v = d(v)), Array.isArray(v))
          for (T = 0, D = v.length; T < D; T++)
            C = v[T], O = this.element(C);
        else if (h(v))
          O = this.element(v.apply());
        else if (g(v)) {
          for (R in v)
            if (E.call(v, R))
              if (z = v[R], h(z) && (z = z.apply()), g(z) && f(z) && (z = null), !this.options.ignoreDecorators && this.stringify.convertAttKey && R.indexOf(this.stringify.convertAttKey) === 0)
                O = this.attribute(R.substr(this.stringify.convertAttKey.length), z);
              else if (!this.options.separateArrayItems && Array.isArray(z))
                for (w = 0, k = z.length; w < k; w++)
                  C = z[w], b = {}, b[R] = C, O = this.element(b);
              else
                g(z) ? (O = this.element(R), O.element(z)) : O = this.element(R, z);
        } else
          this.options.skipNullNodes && A === null ? O = this.dummy() : !this.options.ignoreDecorators && this.stringify.convertTextKey && v.indexOf(this.stringify.convertTextKey) === 0 ? O = this.text(A) : !this.options.ignoreDecorators && this.stringify.convertCDataKey && v.indexOf(this.stringify.convertCDataKey) === 0 ? O = this.cdata(A) : !this.options.ignoreDecorators && this.stringify.convertCommentKey && v.indexOf(this.stringify.convertCommentKey) === 0 ? O = this.comment(A) : !this.options.ignoreDecorators && this.stringify.convertRawKey && v.indexOf(this.stringify.convertRawKey) === 0 ? O = this.raw(A) : !this.options.ignoreDecorators && this.stringify.convertPIKey && v.indexOf(this.stringify.convertPIKey) === 0 ? O = this.instruction(v.substr(this.stringify.convertPIKey.length), A) : O = this.node(v, y, A);
        if (O == null)
          throw new Error("Could not create any elements with: " + v + ". " + this.debugInfo());
        return O;
      }, m.prototype.insertBefore = function(v, y, A) {
        var b, C, T;
        if (this.isRoot)
          throw new Error("Cannot insert elements at root level. " + this.debugInfo(v));
        return C = this.parent.children.indexOf(this), T = this.parent.children.splice(C), b = this.parent.element(v, y, A), Array.prototype.push.apply(this.parent.children, T), b;
      }, m.prototype.insertAfter = function(v, y, A) {
        var b, C, T;
        if (this.isRoot)
          throw new Error("Cannot insert elements at root level. " + this.debugInfo(v));
        return C = this.parent.children.indexOf(this), T = this.parent.children.splice(C + 1), b = this.parent.element(v, y, A), Array.prototype.push.apply(this.parent.children, T), b;
      }, m.prototype.remove = function() {
        var v;
        if (this.isRoot)
          throw new Error("Cannot remove the root element. " + this.debugInfo());
        return v = this.parent.children.indexOf(this), [].splice.apply(this.parent.children, [v, v - v + 1].concat([])), this.parent;
      }, m.prototype.node = function(v, y, A) {
        var b, C;
        return v != null && (v = d(v)), y || (y = {}), y = d(y), g(y) || (C = [y, A], A = C[0], y = C[1]), b = new o(this, v, y), A != null && b.text(A), this.children.push(b), b;
      }, m.prototype.text = function(v) {
        var y;
        return y = new u(this, v), this.children.push(y), this;
      }, m.prototype.cdata = function(v) {
        var y;
        return y = new t(this, v), this.children.push(y), this;
      }, m.prototype.comment = function(v) {
        var y;
        return y = new e(this, v), this.children.push(y), this;
      }, m.prototype.commentBefore = function(v) {
        var y, A;
        return y = this.parent.children.indexOf(this), A = this.parent.children.splice(y), this.parent.comment(v), Array.prototype.push.apply(this.parent.children, A), this;
      }, m.prototype.commentAfter = function(v) {
        var y, A;
        return y = this.parent.children.indexOf(this), A = this.parent.children.splice(y + 1), this.parent.comment(v), Array.prototype.push.apply(this.parent.children, A), this;
      }, m.prototype.raw = function(v) {
        var y;
        return y = new c(this, v), this.children.push(y), this;
      }, m.prototype.dummy = function() {
        var v;
        return v = new s(this), this.children.push(v), v;
      }, m.prototype.instruction = function(v, y) {
        var A, b, C, T, w;
        if (v != null && (v = d(v)), y != null && (y = d(y)), Array.isArray(v))
          for (T = 0, w = v.length; T < w; T++)
            A = v[T], this.instruction(A);
        else if (g(v))
          for (A in v)
            E.call(v, A) && (b = v[A], this.instruction(A, b));
        else
          h(y) && (y = y.apply()), C = new l(this, v, y), this.children.push(C);
        return this;
      }, m.prototype.instructionBefore = function(v, y) {
        var A, b;
        return A = this.parent.children.indexOf(this), b = this.parent.children.splice(A), this.parent.instruction(v, y), Array.prototype.push.apply(this.parent.children, b), this;
      }, m.prototype.instructionAfter = function(v, y) {
        var A, b;
        return A = this.parent.children.indexOf(this), b = this.parent.children.splice(A + 1), this.parent.instruction(v, y), Array.prototype.push.apply(this.parent.children, b), this;
      }, m.prototype.declaration = function(v, y, A) {
        var b, C;
        return b = this.document(), C = new n(b, v, y, A), b.children[0] instanceof n ? b.children[0] = C : b.children.unshift(C), b.root() || b;
      }, m.prototype.doctype = function(v, y) {
        var A, b, C, T, w, R, O, D, k, W;
        for (b = this.document(), C = new a(b, v, y), k = b.children, T = w = 0, O = k.length; w < O; T = ++w)
          if (A = k[T], A instanceof a)
            return b.children[T] = C, C;
        for (W = b.children, T = R = 0, D = W.length; R < D; T = ++R)
          if (A = W[T], A.isRoot)
            return b.children.splice(T, 0, C), C;
        return b.children.push(C), C;
      }, m.prototype.up = function() {
        if (this.isRoot)
          throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
        return this.parent;
      }, m.prototype.root = function() {
        var v;
        for (v = this; v; ) {
          if (v.isDocument)
            return v.rootObject;
          if (v.isRoot)
            return v;
          v = v.parent;
        }
      }, m.prototype.document = function() {
        var v;
        for (v = this; v; ) {
          if (v.isDocument)
            return v;
          v = v.parent;
        }
      }, m.prototype.end = function(v) {
        return this.document().end(v);
      }, m.prototype.prev = function() {
        var v;
        for (v = this.parent.children.indexOf(this); v > 0 && this.parent.children[v - 1].isDummy; )
          v = v - 1;
        if (v < 1)
          throw new Error("Already at the first node. " + this.debugInfo());
        return this.parent.children[v - 1];
      }, m.prototype.next = function() {
        var v;
        for (v = this.parent.children.indexOf(this); v < this.parent.children.length - 1 && this.parent.children[v + 1].isDummy; )
          v = v + 1;
        if (v === -1 || v === this.parent.children.length - 1)
          throw new Error("Already at the last node. " + this.debugInfo());
        return this.parent.children[v + 1];
      }, m.prototype.importDocument = function(v) {
        var y;
        return y = v.root().clone(), y.parent = this, y.isRoot = !1, this.children.push(y), this;
      }, m.prototype.debugInfo = function(v) {
        var y, A;
        return v = v || this.name, v == null && !((y = this.parent) != null && y.name) ? "" : v == null ? "parent: <" + this.parent.name + ">" : (A = this.parent) != null && A.name ? "node: <" + v + ">, parent: <" + this.parent.name + ">" : "node: <" + v + ">";
      }, m.prototype.ele = function(v, y, A) {
        return this.element(v, y, A);
      }, m.prototype.nod = function(v, y, A) {
        return this.node(v, y, A);
      }, m.prototype.txt = function(v) {
        return this.text(v);
      }, m.prototype.dat = function(v) {
        return this.cdata(v);
      }, m.prototype.com = function(v) {
        return this.comment(v);
      }, m.prototype.ins = function(v, y) {
        return this.instruction(v, y);
      }, m.prototype.doc = function() {
        return this.document();
      }, m.prototype.dec = function(v, y, A) {
        return this.declaration(v, y, A);
      }, m.prototype.dtd = function(v, y) {
        return this.doctype(v, y);
      }, m.prototype.e = function(v, y, A) {
        return this.element(v, y, A);
      }, m.prototype.n = function(v, y, A) {
        return this.node(v, y, A);
      }, m.prototype.t = function(v) {
        return this.text(v);
      }, m.prototype.d = function(v) {
        return this.cdata(v);
      }, m.prototype.c = function(v) {
        return this.comment(v);
      }, m.prototype.r = function(v) {
        return this.raw(v);
      }, m.prototype.i = function(v, y) {
        return this.instruction(v, y);
      }, m.prototype.u = function() {
        return this.up();
      }, m.prototype.importXMLBuilder = function(v) {
        return this.importDocument(v);
      }, m;
    }();
  }).call(commonjsGlobal)), XMLNode.exports;
}
var XMLStringifier = { exports: {} }, hasRequiredXMLStringifier;
function requireXMLStringifier() {
  return hasRequiredXMLStringifier || (hasRequiredXMLStringifier = 1, (function() {
    var t = function(n, a) {
      return function() {
        return n.apply(a, arguments);
      };
    }, e = {}.hasOwnProperty;
    XMLStringifier.exports = function() {
      function n(a) {
        this.assertLegalChar = t(this.assertLegalChar, this);
        var s, o, l;
        a || (a = {}), this.noDoubleEncoding = a.noDoubleEncoding, o = a.stringify || {};
        for (s in o)
          e.call(o, s) && (l = o[s], this[s] = l);
      }
      return n.prototype.eleName = function(a) {
        return a = "" + a || "", this.assertLegalChar(a);
      }, n.prototype.eleText = function(a) {
        return a = "" + a || "", this.assertLegalChar(this.elEscape(a));
      }, n.prototype.cdata = function(a) {
        return a = "" + a || "", a = a.replace("]]>", "]]]]><![CDATA[>"), this.assertLegalChar(a);
      }, n.prototype.comment = function(a) {
        if (a = "" + a || "", a.match(/--/))
          throw new Error("Comment text cannot contain double-hypen: " + a);
        return this.assertLegalChar(a);
      }, n.prototype.raw = function(a) {
        return "" + a || "";
      }, n.prototype.attName = function(a) {
        return a = "" + a || "";
      }, n.prototype.attValue = function(a) {
        return a = "" + a || "", this.attEscape(a);
      }, n.prototype.insTarget = function(a) {
        return "" + a || "";
      }, n.prototype.insValue = function(a) {
        if (a = "" + a || "", a.match(/\?>/))
          throw new Error("Invalid processing instruction value: " + a);
        return a;
      }, n.prototype.xmlVersion = function(a) {
        if (a = "" + a || "", !a.match(/1\.[0-9]+/))
          throw new Error("Invalid version number: " + a);
        return a;
      }, n.prototype.xmlEncoding = function(a) {
        if (a = "" + a || "", !a.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/))
          throw new Error("Invalid encoding: " + a);
        return a;
      }, n.prototype.xmlStandalone = function(a) {
        return a ? "yes" : "no";
      }, n.prototype.dtdPubID = function(a) {
        return "" + a || "";
      }, n.prototype.dtdSysID = function(a) {
        return "" + a || "";
      }, n.prototype.dtdElementValue = function(a) {
        return "" + a || "";
      }, n.prototype.dtdAttType = function(a) {
        return "" + a || "";
      }, n.prototype.dtdAttDefault = function(a) {
        return a != null ? "" + a || "" : a;
      }, n.prototype.dtdEntityValue = function(a) {
        return "" + a || "";
      }, n.prototype.dtdNData = function(a) {
        return "" + a || "";
      }, n.prototype.convertAttKey = "@", n.prototype.convertPIKey = "?", n.prototype.convertTextKey = "#text", n.prototype.convertCDataKey = "#cdata", n.prototype.convertCommentKey = "#comment", n.prototype.convertRawKey = "#raw", n.prototype.assertLegalChar = function(a) {
        var s;
        if (s = a.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), s)
          throw new Error("Invalid character in string: " + a + " at index " + s.index);
        return a;
      }, n.prototype.elEscape = function(a) {
        var s;
        return s = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g, a.replace(s, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
      }, n.prototype.attEscape = function(a) {
        var s;
        return s = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g, a.replace(s, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
      }, n;
    }();
  }).call(commonjsGlobal)), XMLStringifier.exports;
}
var XMLStringWriter = { exports: {} }, XMLWriterBase = { exports: {} }, hasRequiredXMLWriterBase;
function requireXMLWriterBase() {
  return hasRequiredXMLWriterBase || (hasRequiredXMLWriterBase = 1, (function() {
    var t = {}.hasOwnProperty;
    XMLWriterBase.exports = function() {
      function e(n) {
        var a, s, o, l, c, u, d, f, h;
        n || (n = {}), this.pretty = n.pretty || !1, this.allowEmpty = (s = n.allowEmpty) != null ? s : !1, this.pretty ? (this.indent = (o = n.indent) != null ? o : "  ", this.newline = (l = n.newline) != null ? l : `
`, this.offset = (c = n.offset) != null ? c : 0, this.dontprettytextnodes = (u = n.dontprettytextnodes) != null ? u : 0) : (this.indent = "", this.newline = "", this.offset = 0, this.dontprettytextnodes = 0), this.spacebeforeslash = (d = n.spacebeforeslash) != null ? d : "", this.spacebeforeslash === !0 && (this.spacebeforeslash = " "), this.newlinedefault = this.newline, this.prettydefault = this.pretty, f = n.writer || {};
        for (a in f)
          t.call(f, a) && (h = f[a], this[a] = h);
      }
      return e.prototype.set = function(n) {
        var a, s, o;
        n || (n = {}), "pretty" in n && (this.pretty = n.pretty), "allowEmpty" in n && (this.allowEmpty = n.allowEmpty), this.pretty ? (this.indent = "indent" in n ? n.indent : "  ", this.newline = "newline" in n ? n.newline : `
`, this.offset = "offset" in n ? n.offset : 0, this.dontprettytextnodes = "dontprettytextnodes" in n ? n.dontprettytextnodes : 0) : (this.indent = "", this.newline = "", this.offset = 0, this.dontprettytextnodes = 0), this.spacebeforeslash = "spacebeforeslash" in n ? n.spacebeforeslash : "", this.spacebeforeslash === !0 && (this.spacebeforeslash = " "), this.newlinedefault = this.newline, this.prettydefault = this.pretty, s = n.writer || {};
        for (a in s)
          t.call(s, a) && (o = s[a], this[a] = o);
        return this;
      }, e.prototype.space = function(n) {
        var a;
        return this.pretty ? (a = (n || 0) + this.offset + 1, a > 0 ? new Array(a).join(this.indent) : "") : "";
      }, e;
    }();
  }).call(commonjsGlobal)), XMLWriterBase.exports;
}
var hasRequiredXMLStringWriter;
function requireXMLStringWriter() {
  return hasRequiredXMLStringWriter || (hasRequiredXMLStringWriter = 1, (function() {
    var t, e, n, a, s, o, l, c, u, d, f, h, g, x, E = function(v, y) {
      for (var A in y)
        m.call(y, A) && (v[A] = y[A]);
      function b() {
        this.constructor = v;
      }
      return b.prototype = y.prototype, v.prototype = new b(), v.__super__ = y.prototype, v;
    }, m = {}.hasOwnProperty;
    l = requireXMLDeclaration(), c = requireXMLDocType(), t = requireXMLCData(), e = requireXMLComment(), d = requireXMLElement(), h = requireXMLRaw(), g = requireXMLText(), f = requireXMLProcessingInstruction(), u = requireXMLDummy(), n = requireXMLDTDAttList(), a = requireXMLDTDElement(), s = requireXMLDTDEntity(), o = requireXMLDTDNotation(), x = requireXMLWriterBase(), XMLStringWriter.exports = function(v) {
      E(y, v);
      function y(A) {
        y.__super__.constructor.call(this, A);
      }
      return y.prototype.document = function(A) {
        var b, C, T, w, R;
        for (this.textispresent = !1, w = "", R = A.children, C = 0, T = R.length; C < T; C++)
          b = R[C], !(b instanceof u) && (w += (function() {
            switch (!1) {
              case !(b instanceof l):
                return this.declaration(b);
              case !(b instanceof c):
                return this.docType(b);
              case !(b instanceof e):
                return this.comment(b);
              case !(b instanceof f):
                return this.processingInstruction(b);
              default:
                return this.element(b, 0);
            }
          }).call(this));
        return this.pretty && w.slice(-this.newline.length) === this.newline && (w = w.slice(0, -this.newline.length)), w;
      }, y.prototype.attribute = function(A) {
        return " " + A.name + '="' + A.value + '"';
      }, y.prototype.cdata = function(A, b) {
        return this.space(b) + "<![CDATA[" + A.text + "]]>" + this.newline;
      }, y.prototype.comment = function(A, b) {
        return this.space(b) + "<!-- " + A.text + " -->" + this.newline;
      }, y.prototype.declaration = function(A, b) {
        var C;
        return C = this.space(b), C += '<?xml version="' + A.version + '"', A.encoding != null && (C += ' encoding="' + A.encoding + '"'), A.standalone != null && (C += ' standalone="' + A.standalone + '"'), C += this.spacebeforeslash + "?>", C += this.newline, C;
      }, y.prototype.docType = function(A, b) {
        var C, T, w, R, O;
        if (b || (b = 0), R = this.space(b), R += "<!DOCTYPE " + A.root().name, A.pubID && A.sysID ? R += ' PUBLIC "' + A.pubID + '" "' + A.sysID + '"' : A.sysID && (R += ' SYSTEM "' + A.sysID + '"'), A.children.length > 0) {
          for (R += " [", R += this.newline, O = A.children, T = 0, w = O.length; T < w; T++)
            C = O[T], R += (function() {
              switch (!1) {
                case !(C instanceof n):
                  return this.dtdAttList(C, b + 1);
                case !(C instanceof a):
                  return this.dtdElement(C, b + 1);
                case !(C instanceof s):
                  return this.dtdEntity(C, b + 1);
                case !(C instanceof o):
                  return this.dtdNotation(C, b + 1);
                case !(C instanceof t):
                  return this.cdata(C, b + 1);
                case !(C instanceof e):
                  return this.comment(C, b + 1);
                case !(C instanceof f):
                  return this.processingInstruction(C, b + 1);
                default:
                  throw new Error("Unknown DTD node type: " + C.constructor.name);
              }
            }).call(this);
          R += "]";
        }
        return R += this.spacebeforeslash + ">", R += this.newline, R;
      }, y.prototype.element = function(A, b) {
        var C, T, w, R, O, D, k, W, L, z, P, Q, Y;
        b || (b = 0), Y = !1, this.textispresent ? (this.newline = "", this.pretty = !1) : (this.newline = this.newlinedefault, this.pretty = this.prettydefault), Q = this.space(b), W = "", W += Q + "<" + A.name, L = A.attributes;
        for (k in L)
          m.call(L, k) && (C = L[k], W += this.attribute(C));
        if (A.children.length === 0 || A.children.every(function(ie) {
          return ie.value === "";
        }))
          this.allowEmpty ? W += "></" + A.name + ">" + this.newline : W += this.spacebeforeslash + "/>" + this.newline;
        else if (this.pretty && A.children.length === 1 && A.children[0].value != null)
          W += ">", W += A.children[0].value, W += "</" + A.name + ">" + this.newline;
        else {
          if (this.dontprettytextnodes) {
            for (z = A.children, w = 0, O = z.length; w < O; w++)
              if (T = z[w], T.value != null) {
                this.textispresent++, Y = !0;
                break;
              }
          }
          for (this.textispresent && (this.newline = "", this.pretty = !1, Q = this.space(b)), W += ">" + this.newline, P = A.children, R = 0, D = P.length; R < D; R++)
            T = P[R], W += (function() {
              switch (!1) {
                case !(T instanceof t):
                  return this.cdata(T, b + 1);
                case !(T instanceof e):
                  return this.comment(T, b + 1);
                case !(T instanceof d):
                  return this.element(T, b + 1);
                case !(T instanceof h):
                  return this.raw(T, b + 1);
                case !(T instanceof g):
                  return this.text(T, b + 1);
                case !(T instanceof f):
                  return this.processingInstruction(T, b + 1);
                case !(T instanceof u):
                  return "";
                default:
                  throw new Error("Unknown XML node type: " + T.constructor.name);
              }
            }).call(this);
          Y && this.textispresent--, this.textispresent || (this.newline = this.newlinedefault, this.pretty = this.prettydefault), W += Q + "</" + A.name + ">" + this.newline;
        }
        return W;
      }, y.prototype.processingInstruction = function(A, b) {
        var C;
        return C = this.space(b) + "<?" + A.target, A.value && (C += " " + A.value), C += this.spacebeforeslash + "?>" + this.newline, C;
      }, y.prototype.raw = function(A, b) {
        return this.space(b) + A.value + this.newline;
      }, y.prototype.text = function(A, b) {
        return this.space(b) + A.value + this.newline;
      }, y.prototype.dtdAttList = function(A, b) {
        var C;
        return C = this.space(b) + "<!ATTLIST " + A.elementName + " " + A.attributeName + " " + A.attributeType, A.defaultValueType !== "#DEFAULT" && (C += " " + A.defaultValueType), A.defaultValue && (C += ' "' + A.defaultValue + '"'), C += this.spacebeforeslash + ">" + this.newline, C;
      }, y.prototype.dtdElement = function(A, b) {
        return this.space(b) + "<!ELEMENT " + A.name + " " + A.value + this.spacebeforeslash + ">" + this.newline;
      }, y.prototype.dtdEntity = function(A, b) {
        var C;
        return C = this.space(b) + "<!ENTITY", A.pe && (C += " %"), C += " " + A.name, A.value ? C += ' "' + A.value + '"' : (A.pubID && A.sysID ? C += ' PUBLIC "' + A.pubID + '" "' + A.sysID + '"' : A.sysID && (C += ' SYSTEM "' + A.sysID + '"'), A.nData && (C += " NDATA " + A.nData)), C += this.spacebeforeslash + ">" + this.newline, C;
      }, y.prototype.dtdNotation = function(A, b) {
        var C;
        return C = this.space(b) + "<!NOTATION " + A.name, A.pubID && A.sysID ? C += ' PUBLIC "' + A.pubID + '" "' + A.sysID + '"' : A.pubID ? C += ' PUBLIC "' + A.pubID + '"' : A.sysID && (C += ' SYSTEM "' + A.sysID + '"'), C += this.spacebeforeslash + ">" + this.newline, C;
      }, y.prototype.openNode = function(A, b) {
        var C, T, w, R;
        if (b || (b = 0), A instanceof d) {
          w = this.space(b) + "<" + A.name, R = A.attributes;
          for (T in R)
            m.call(R, T) && (C = R[T], w += this.attribute(C));
          return w += (A.children ? ">" : "/>") + this.newline, w;
        } else
          return w = this.space(b) + "<!DOCTYPE " + A.rootNodeName, A.pubID && A.sysID ? w += ' PUBLIC "' + A.pubID + '" "' + A.sysID + '"' : A.sysID && (w += ' SYSTEM "' + A.sysID + '"'), w += (A.children ? " [" : ">") + this.newline, w;
      }, y.prototype.closeNode = function(A, b) {
        switch (b || (b = 0), !1) {
          case !(A instanceof d):
            return this.space(b) + "</" + A.name + ">" + this.newline;
          case !(A instanceof c):
            return this.space(b) + "]>" + this.newline;
        }
      }, y;
    }(x);
  }).call(commonjsGlobal)), XMLStringWriter.exports;
}
var hasRequiredXMLDocument;
function requireXMLDocument() {
  return hasRequiredXMLDocument || (hasRequiredXMLDocument = 1, (function() {
    var t, e, n, a, s = function(l, c) {
      for (var u in c)
        o.call(c, u) && (l[u] = c[u]);
      function d() {
        this.constructor = l;
      }
      return d.prototype = c.prototype, l.prototype = new d(), l.__super__ = c.prototype, l;
    }, o = {}.hasOwnProperty;
    a = requireUtility().isPlainObject, t = requireXMLNode(), n = requireXMLStringifier(), e = requireXMLStringWriter(), XMLDocument.exports = function(l) {
      s(c, l);
      function c(u) {
        c.__super__.constructor.call(this, null), this.name = "?xml", u || (u = {}), u.writer || (u.writer = new e()), this.options = u, this.stringify = new n(u), this.isDocument = !0;
      }
      return c.prototype.end = function(u) {
        var d;
        return u ? a(u) && (d = u, u = this.options.writer.set(d)) : u = this.options.writer, u.document(this);
      }, c.prototype.toString = function(u) {
        return this.options.writer.set(u).document(this);
      }, c;
    }(t);
  }).call(commonjsGlobal)), XMLDocument.exports;
}
var XMLDocumentCB = { exports: {} }, hasRequiredXMLDocumentCB;
function requireXMLDocumentCB() {
  return hasRequiredXMLDocumentCB || (hasRequiredXMLDocumentCB = 1, (function() {
    var t, e, n, a, s, o, l, c, u, d, f, h, g, x, E, m, v, y, A, b, C = {}.hasOwnProperty;
    b = requireUtility(), y = b.isObject, v = b.isFunction, A = b.isPlainObject, m = b.getValue, d = requireXMLElement(), e = requireXMLCData(), n = requireXMLComment(), h = requireXMLRaw(), E = requireXMLText(), f = requireXMLProcessingInstruction(), c = requireXMLDeclaration(), u = requireXMLDocType(), a = requireXMLDTDAttList(), o = requireXMLDTDEntity(), s = requireXMLDTDElement(), l = requireXMLDTDNotation(), t = requireXMLAttribute(), x = requireXMLStringifier(), g = requireXMLStringWriter(), XMLDocumentCB.exports = function() {
      function T(w, R, O) {
        var D;
        this.name = "?xml", w || (w = {}), w.writer ? A(w.writer) && (D = w.writer, w.writer = new g(D)) : w.writer = new g(w), this.options = w, this.writer = w.writer, this.stringify = new x(w), this.onDataCallback = R || function() {
        }, this.onEndCallback = O || function() {
        }, this.currentNode = null, this.currentLevel = -1, this.openTags = {}, this.documentStarted = !1, this.documentCompleted = !1, this.root = null;
      }
      return T.prototype.node = function(w, R, O) {
        var D, k;
        if (w == null)
          throw new Error("Missing node name.");
        if (this.root && this.currentLevel === -1)
          throw new Error("Document can only have one root node. " + this.debugInfo(w));
        return this.openCurrent(), w = m(w), R === null && O == null && (D = [{}, null], R = D[0], O = D[1]), R == null && (R = {}), R = m(R), y(R) || (k = [R, O], O = k[0], R = k[1]), this.currentNode = new d(this, w, R), this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, O != null && this.text(O), this;
      }, T.prototype.element = function(w, R, O) {
        return this.currentNode && this.currentNode instanceof u ? this.dtdElement.apply(this, arguments) : this.node(w, R, O);
      }, T.prototype.attribute = function(w, R) {
        var O, D;
        if (!this.currentNode || this.currentNode.children)
          throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(w));
        if (w != null && (w = m(w)), y(w))
          for (O in w)
            C.call(w, O) && (D = w[O], this.attribute(O, D));
        else
          v(R) && (R = R.apply()), (!this.options.skipNullAttributes || R != null) && (this.currentNode.attributes[w] = new t(this, w, R));
        return this;
      }, T.prototype.text = function(w) {
        var R;
        return this.openCurrent(), R = new E(this, w), this.onData(this.writer.text(R, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.cdata = function(w) {
        var R;
        return this.openCurrent(), R = new e(this, w), this.onData(this.writer.cdata(R, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.comment = function(w) {
        var R;
        return this.openCurrent(), R = new n(this, w), this.onData(this.writer.comment(R, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.raw = function(w) {
        var R;
        return this.openCurrent(), R = new h(this, w), this.onData(this.writer.raw(R, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.instruction = function(w, R) {
        var O, D, k, W, L;
        if (this.openCurrent(), w != null && (w = m(w)), R != null && (R = m(R)), Array.isArray(w))
          for (O = 0, W = w.length; O < W; O++)
            D = w[O], this.instruction(D);
        else if (y(w))
          for (D in w)
            C.call(w, D) && (k = w[D], this.instruction(D, k));
        else
          v(R) && (R = R.apply()), L = new f(this, w, R), this.onData(this.writer.processingInstruction(L, this.currentLevel + 1), this.currentLevel + 1);
        return this;
      }, T.prototype.declaration = function(w, R, O) {
        var D;
        if (this.openCurrent(), this.documentStarted)
          throw new Error("declaration() must be the first node.");
        return D = new c(this, w, R, O), this.onData(this.writer.declaration(D, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.doctype = function(w, R, O) {
        if (this.openCurrent(), w == null)
          throw new Error("Missing root node name.");
        if (this.root)
          throw new Error("dtd() must come before the root node.");
        return this.currentNode = new u(this, R, O), this.currentNode.rootNodeName = w, this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, this;
      }, T.prototype.dtdElement = function(w, R) {
        var O;
        return this.openCurrent(), O = new s(this, w, R), this.onData(this.writer.dtdElement(O, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.attList = function(w, R, O, D, k) {
        var W;
        return this.openCurrent(), W = new a(this, w, R, O, D, k), this.onData(this.writer.dtdAttList(W, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.entity = function(w, R) {
        var O;
        return this.openCurrent(), O = new o(this, !1, w, R), this.onData(this.writer.dtdEntity(O, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.pEntity = function(w, R) {
        var O;
        return this.openCurrent(), O = new o(this, !0, w, R), this.onData(this.writer.dtdEntity(O, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.notation = function(w, R) {
        var O;
        return this.openCurrent(), O = new l(this, w, R), this.onData(this.writer.dtdNotation(O, this.currentLevel + 1), this.currentLevel + 1), this;
      }, T.prototype.up = function() {
        if (this.currentLevel < 0)
          throw new Error("The document node has no parent.");
        return this.currentNode ? (this.currentNode.children ? this.closeNode(this.currentNode) : this.openNode(this.currentNode), this.currentNode = null) : this.closeNode(this.openTags[this.currentLevel]), delete this.openTags[this.currentLevel], this.currentLevel--, this;
      }, T.prototype.end = function() {
        for (; this.currentLevel >= 0; )
          this.up();
        return this.onEnd();
      }, T.prototype.openCurrent = function() {
        if (this.currentNode)
          return this.currentNode.children = !0, this.openNode(this.currentNode);
      }, T.prototype.openNode = function(w) {
        if (!w.isOpen)
          return !this.root && this.currentLevel === 0 && w instanceof d && (this.root = w), this.onData(this.writer.openNode(w, this.currentLevel), this.currentLevel), w.isOpen = !0;
      }, T.prototype.closeNode = function(w) {
        if (!w.isClosed)
          return this.onData(this.writer.closeNode(w, this.currentLevel), this.currentLevel), w.isClosed = !0;
      }, T.prototype.onData = function(w, R) {
        return this.documentStarted = !0, this.onDataCallback(w, R + 1);
      }, T.prototype.onEnd = function() {
        return this.documentCompleted = !0, this.onEndCallback();
      }, T.prototype.debugInfo = function(w) {
        return w == null ? "" : "node: <" + w + ">";
      }, T.prototype.ele = function() {
        return this.element.apply(this, arguments);
      }, T.prototype.nod = function(w, R, O) {
        return this.node(w, R, O);
      }, T.prototype.txt = function(w) {
        return this.text(w);
      }, T.prototype.dat = function(w) {
        return this.cdata(w);
      }, T.prototype.com = function(w) {
        return this.comment(w);
      }, T.prototype.ins = function(w, R) {
        return this.instruction(w, R);
      }, T.prototype.dec = function(w, R, O) {
        return this.declaration(w, R, O);
      }, T.prototype.dtd = function(w, R, O) {
        return this.doctype(w, R, O);
      }, T.prototype.e = function(w, R, O) {
        return this.element(w, R, O);
      }, T.prototype.n = function(w, R, O) {
        return this.node(w, R, O);
      }, T.prototype.t = function(w) {
        return this.text(w);
      }, T.prototype.d = function(w) {
        return this.cdata(w);
      }, T.prototype.c = function(w) {
        return this.comment(w);
      }, T.prototype.r = function(w) {
        return this.raw(w);
      }, T.prototype.i = function(w, R) {
        return this.instruction(w, R);
      }, T.prototype.att = function() {
        return this.currentNode && this.currentNode instanceof u ? this.attList.apply(this, arguments) : this.attribute.apply(this, arguments);
      }, T.prototype.a = function() {
        return this.currentNode && this.currentNode instanceof u ? this.attList.apply(this, arguments) : this.attribute.apply(this, arguments);
      }, T.prototype.ent = function(w, R) {
        return this.entity(w, R);
      }, T.prototype.pent = function(w, R) {
        return this.pEntity(w, R);
      }, T.prototype.not = function(w, R) {
        return this.notation(w, R);
      }, T;
    }();
  }).call(commonjsGlobal)), XMLDocumentCB.exports;
}
var XMLStreamWriter = { exports: {} }, hasRequiredXMLStreamWriter;
function requireXMLStreamWriter() {
  return hasRequiredXMLStreamWriter || (hasRequiredXMLStreamWriter = 1, (function() {
    var t, e, n, a, s, o, l, c, u, d, f, h, g, x, E = function(v, y) {
      for (var A in y)
        m.call(y, A) && (v[A] = y[A]);
      function b() {
        this.constructor = v;
      }
      return b.prototype = y.prototype, v.prototype = new b(), v.__super__ = y.prototype, v;
    }, m = {}.hasOwnProperty;
    l = requireXMLDeclaration(), c = requireXMLDocType(), t = requireXMLCData(), e = requireXMLComment(), d = requireXMLElement(), h = requireXMLRaw(), g = requireXMLText(), f = requireXMLProcessingInstruction(), u = requireXMLDummy(), n = requireXMLDTDAttList(), a = requireXMLDTDElement(), s = requireXMLDTDEntity(), o = requireXMLDTDNotation(), x = requireXMLWriterBase(), XMLStreamWriter.exports = function(v) {
      E(y, v);
      function y(A, b) {
        y.__super__.constructor.call(this, b), this.stream = A;
      }
      return y.prototype.document = function(A) {
        var b, C, T, w, R, O, D, k;
        for (O = A.children, C = 0, w = O.length; C < w; C++)
          b = O[C], b.isLastRootNode = !1;
        for (A.children[A.children.length - 1].isLastRootNode = !0, D = A.children, k = [], T = 0, R = D.length; T < R; T++)
          if (b = D[T], !(b instanceof u))
            switch (!1) {
              case !(b instanceof l):
                k.push(this.declaration(b));
                break;
              case !(b instanceof c):
                k.push(this.docType(b));
                break;
              case !(b instanceof e):
                k.push(this.comment(b));
                break;
              case !(b instanceof f):
                k.push(this.processingInstruction(b));
                break;
              default:
                k.push(this.element(b));
            }
        return k;
      }, y.prototype.attribute = function(A) {
        return this.stream.write(" " + A.name + '="' + A.value + '"');
      }, y.prototype.cdata = function(A, b) {
        return this.stream.write(this.space(b) + "<![CDATA[" + A.text + "]]>" + this.endline(A));
      }, y.prototype.comment = function(A, b) {
        return this.stream.write(this.space(b) + "<!-- " + A.text + " -->" + this.endline(A));
      }, y.prototype.declaration = function(A, b) {
        return this.stream.write(this.space(b)), this.stream.write('<?xml version="' + A.version + '"'), A.encoding != null && this.stream.write(' encoding="' + A.encoding + '"'), A.standalone != null && this.stream.write(' standalone="' + A.standalone + '"'), this.stream.write(this.spacebeforeslash + "?>"), this.stream.write(this.endline(A));
      }, y.prototype.docType = function(A, b) {
        var C, T, w, R;
        if (b || (b = 0), this.stream.write(this.space(b)), this.stream.write("<!DOCTYPE " + A.root().name), A.pubID && A.sysID ? this.stream.write(' PUBLIC "' + A.pubID + '" "' + A.sysID + '"') : A.sysID && this.stream.write(' SYSTEM "' + A.sysID + '"'), A.children.length > 0) {
          for (this.stream.write(" ["), this.stream.write(this.endline(A)), R = A.children, T = 0, w = R.length; T < w; T++)
            switch (C = R[T], !1) {
              case !(C instanceof n):
                this.dtdAttList(C, b + 1);
                break;
              case !(C instanceof a):
                this.dtdElement(C, b + 1);
                break;
              case !(C instanceof s):
                this.dtdEntity(C, b + 1);
                break;
              case !(C instanceof o):
                this.dtdNotation(C, b + 1);
                break;
              case !(C instanceof t):
                this.cdata(C, b + 1);
                break;
              case !(C instanceof e):
                this.comment(C, b + 1);
                break;
              case !(C instanceof f):
                this.processingInstruction(C, b + 1);
                break;
              default:
                throw new Error("Unknown DTD node type: " + C.constructor.name);
            }
          this.stream.write("]");
        }
        return this.stream.write(this.spacebeforeslash + ">"), this.stream.write(this.endline(A));
      }, y.prototype.element = function(A, b) {
        var C, T, w, R, O, D, k, W;
        b || (b = 0), W = this.space(b), this.stream.write(W + "<" + A.name), D = A.attributes;
        for (O in D)
          m.call(D, O) && (C = D[O], this.attribute(C));
        if (A.children.length === 0 || A.children.every(function(L) {
          return L.value === "";
        }))
          this.allowEmpty ? this.stream.write("></" + A.name + ">") : this.stream.write(this.spacebeforeslash + "/>");
        else if (this.pretty && A.children.length === 1 && A.children[0].value != null)
          this.stream.write(">"), this.stream.write(A.children[0].value), this.stream.write("</" + A.name + ">");
        else {
          for (this.stream.write(">" + this.newline), k = A.children, w = 0, R = k.length; w < R; w++)
            switch (T = k[w], !1) {
              case !(T instanceof t):
                this.cdata(T, b + 1);
                break;
              case !(T instanceof e):
                this.comment(T, b + 1);
                break;
              case !(T instanceof d):
                this.element(T, b + 1);
                break;
              case !(T instanceof h):
                this.raw(T, b + 1);
                break;
              case !(T instanceof g):
                this.text(T, b + 1);
                break;
              case !(T instanceof f):
                this.processingInstruction(T, b + 1);
                break;
              case !(T instanceof u):
                break;
              default:
                throw new Error("Unknown XML node type: " + T.constructor.name);
            }
          this.stream.write(W + "</" + A.name + ">");
        }
        return this.stream.write(this.endline(A));
      }, y.prototype.processingInstruction = function(A, b) {
        return this.stream.write(this.space(b) + "<?" + A.target), A.value && this.stream.write(" " + A.value), this.stream.write(this.spacebeforeslash + "?>" + this.endline(A));
      }, y.prototype.raw = function(A, b) {
        return this.stream.write(this.space(b) + A.value + this.endline(A));
      }, y.prototype.text = function(A, b) {
        return this.stream.write(this.space(b) + A.value + this.endline(A));
      }, y.prototype.dtdAttList = function(A, b) {
        return this.stream.write(this.space(b) + "<!ATTLIST " + A.elementName + " " + A.attributeName + " " + A.attributeType), A.defaultValueType !== "#DEFAULT" && this.stream.write(" " + A.defaultValueType), A.defaultValue && this.stream.write(' "' + A.defaultValue + '"'), this.stream.write(this.spacebeforeslash + ">" + this.endline(A));
      }, y.prototype.dtdElement = function(A, b) {
        return this.stream.write(this.space(b) + "<!ELEMENT " + A.name + " " + A.value), this.stream.write(this.spacebeforeslash + ">" + this.endline(A));
      }, y.prototype.dtdEntity = function(A, b) {
        return this.stream.write(this.space(b) + "<!ENTITY"), A.pe && this.stream.write(" %"), this.stream.write(" " + A.name), A.value ? this.stream.write(' "' + A.value + '"') : (A.pubID && A.sysID ? this.stream.write(' PUBLIC "' + A.pubID + '" "' + A.sysID + '"') : A.sysID && this.stream.write(' SYSTEM "' + A.sysID + '"'), A.nData && this.stream.write(" NDATA " + A.nData)), this.stream.write(this.spacebeforeslash + ">" + this.endline(A));
      }, y.prototype.dtdNotation = function(A, b) {
        return this.stream.write(this.space(b) + "<!NOTATION " + A.name), A.pubID && A.sysID ? this.stream.write(' PUBLIC "' + A.pubID + '" "' + A.sysID + '"') : A.pubID ? this.stream.write(' PUBLIC "' + A.pubID + '"') : A.sysID && this.stream.write(' SYSTEM "' + A.sysID + '"'), this.stream.write(this.spacebeforeslash + ">" + this.endline(A));
      }, y.prototype.endline = function(A) {
        return A.isLastRootNode ? "" : this.newline;
      }, y;
    }(x);
  }).call(commonjsGlobal)), XMLStreamWriter.exports;
}
(function() {
  var t, e, n, a, s, o, l;
  l = requireUtility(), s = l.assign, o = l.isFunction, t = requireXMLDocument(), e = requireXMLDocumentCB(), a = requireXMLStringWriter(), n = requireXMLStreamWriter(), lib.create = function(c, u, d, f) {
    var h, g;
    if (c == null)
      throw new Error("Root element needs a name.");
    return f = s({}, u, d, f), h = new t(f), g = h.element(c), f.headless || (h.declaration(f), (f.pubID != null || f.sysID != null) && h.doctype(f)), g;
  }, lib.begin = function(c, u, d) {
    var f;
    return o(c) && (f = [c, u], u = f[0], d = f[1], c = {}), u ? new e(c, u, d) : new t(c);
  }, lib.stringWriter = function(c) {
    return new a(c);
  }, lib.streamWriter = function(c, u) {
    return new n(c, u);
  };
}).call(commonjsGlobal);
var _$b = require$$0, xmlbuilder = lib;
writer$2.writeString = writeString;
function writeString(t, e) {
  var n = _$b.invert(e), a = {
    element: o,
    text: writeTextNode
  };
  function s(u, d) {
    return a[d.type](u, d);
  }
  function o(u, d) {
    var f = u.element(l(d.name), d.attributes);
    d.children.forEach(function(h) {
      s(f, h);
    });
  }
  function l(u) {
    var d = /^\{(.*)\}(.*)$/.exec(u);
    if (d) {
      var f = n[d[1]];
      return f + (f === "" ? "" : ":") + d[2];
    } else
      return u;
  }
  function c(u) {
    var d = xmlbuilder.create(l(u.name), {
      version: "1.0",
      encoding: "UTF-8",
      standalone: !0
    });
    return _$b.forEach(e, function(f, h) {
      var g = "xmlns" + (h === "" ? "" : ":" + h);
      d.attribute(g, f);
    }), u.children.forEach(function(f) {
      s(d, f);
    }), d.end();
  }
  return c(t);
}
function writeTextNode(t, e) {
  t.text(e.value);
}
var nodes = nodes$2;
xml$2.Element = nodes.Element;
xml$2.element = nodes.element;
xml$2.text = nodes.text;
xml$2.readString = reader.readString;
xml$2.writeString = writer$2.writeString;
var _$a = require$$0, promises$5 = promises$7, xml$1 = xml$2;
officeXmlReader.read = read$1;
officeXmlReader.readXmlFromZipFile = readXmlFromZipFile$1;
var xmlNamespaceMap = {
  "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
  "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
  "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
  "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
  "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",
  "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
  "urn:schemas-microsoft-com:vml": "v",
  "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
  "urn:schemas-microsoft-com:office:word": "office-word"
};
function read$1(t) {
  return xml$1.readString(t, xmlNamespaceMap).then(function(e) {
    return collapseAlternateContent(e)[0];
  });
}
function readXmlFromZipFile$1(t, e) {
  return t.exists(e) ? t.read(e, "utf-8").then(stripUtf8Bom).then(read$1) : promises$5.resolve(null);
}
function stripUtf8Bom(t) {
  return t.replace(/^\uFEFF/g, "");
}
function collapseAlternateContent(t) {
  return t.type === "element" ? t.name === "mc:AlternateContent" ? t.first("mc:Fallback").children : (t.children = _$a.flatten(t.children.map(collapseAlternateContent, !0)), [t]) : [t];
}
var bodyReader = {}, dist = {}, dingbats$1 = {};
Object.defineProperty(dingbats$1, "__esModule", { value: !0 });
var dingbats = [
  { "Typeface name": "Symbol", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
  { "Typeface name": "Symbol", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "33", "Unicode hex": "21" },
  { "Typeface name": "Symbol", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "8704", "Unicode hex": "2200" },
  { "Typeface name": "Symbol", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "35", "Unicode hex": "23" },
  { "Typeface name": "Symbol", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "8707", "Unicode hex": "2203" },
  { "Typeface name": "Symbol", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "37", "Unicode hex": "25" },
  { "Typeface name": "Symbol", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "38", "Unicode hex": "26" },
  { "Typeface name": "Symbol", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "8717", "Unicode hex": "220D" },
  { "Typeface name": "Symbol", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "40", "Unicode hex": "28" },
  { "Typeface name": "Symbol", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "41", "Unicode hex": "29" },
  { "Typeface name": "Symbol", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "42", "Unicode hex": "2A" },
  { "Typeface name": "Symbol", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "43", "Unicode hex": "2B" },
  { "Typeface name": "Symbol", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "44", "Unicode hex": "2C" },
  { "Typeface name": "Symbol", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "8722", "Unicode hex": "2212" },
  { "Typeface name": "Symbol", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "46", "Unicode hex": "2E" },
  { "Typeface name": "Symbol", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "47", "Unicode hex": "2F" },
  { "Typeface name": "Symbol", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "48", "Unicode hex": "30" },
  { "Typeface name": "Symbol", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "49", "Unicode hex": "31" },
  { "Typeface name": "Symbol", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "50", "Unicode hex": "32" },
  { "Typeface name": "Symbol", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "51", "Unicode hex": "33" },
  { "Typeface name": "Symbol", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "52", "Unicode hex": "34" },
  { "Typeface name": "Symbol", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "53", "Unicode hex": "35" },
  { "Typeface name": "Symbol", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "54", "Unicode hex": "36" },
  { "Typeface name": "Symbol", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "55", "Unicode hex": "37" },
  { "Typeface name": "Symbol", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "56", "Unicode hex": "38" },
  { "Typeface name": "Symbol", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "57", "Unicode hex": "39" },
  { "Typeface name": "Symbol", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "58", "Unicode hex": "3A" },
  { "Typeface name": "Symbol", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "59", "Unicode hex": "3B" },
  { "Typeface name": "Symbol", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "60", "Unicode hex": "3C" },
  { "Typeface name": "Symbol", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "61", "Unicode hex": "3D" },
  { "Typeface name": "Symbol", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "62", "Unicode hex": "3E" },
  { "Typeface name": "Symbol", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "63", "Unicode hex": "3F" },
  { "Typeface name": "Symbol", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "8773", "Unicode hex": "2245" },
  { "Typeface name": "Symbol", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "913", "Unicode hex": "391" },
  { "Typeface name": "Symbol", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "914", "Unicode hex": "392" },
  { "Typeface name": "Symbol", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "935", "Unicode hex": "3A7" },
  { "Typeface name": "Symbol", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "916", "Unicode hex": "394" },
  { "Typeface name": "Symbol", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "917", "Unicode hex": "395" },
  { "Typeface name": "Symbol", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "934", "Unicode hex": "3A6" },
  { "Typeface name": "Symbol", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "915", "Unicode hex": "393" },
  { "Typeface name": "Symbol", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "919", "Unicode hex": "397" },
  { "Typeface name": "Symbol", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "921", "Unicode hex": "399" },
  { "Typeface name": "Symbol", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "977", "Unicode hex": "3D1" },
  { "Typeface name": "Symbol", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "922", "Unicode hex": "39A" },
  { "Typeface name": "Symbol", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "923", "Unicode hex": "39B" },
  { "Typeface name": "Symbol", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "924", "Unicode hex": "39C" },
  { "Typeface name": "Symbol", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "925", "Unicode hex": "39D" },
  { "Typeface name": "Symbol", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "927", "Unicode hex": "39F" },
  { "Typeface name": "Symbol", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "928", "Unicode hex": "3A0" },
  { "Typeface name": "Symbol", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "920", "Unicode hex": "398" },
  { "Typeface name": "Symbol", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "929", "Unicode hex": "3A1" },
  { "Typeface name": "Symbol", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "931", "Unicode hex": "3A3" },
  { "Typeface name": "Symbol", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "932", "Unicode hex": "3A4" },
  { "Typeface name": "Symbol", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "933", "Unicode hex": "3A5" },
  { "Typeface name": "Symbol", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "962", "Unicode hex": "3C2" },
  { "Typeface name": "Symbol", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "937", "Unicode hex": "3A9" },
  { "Typeface name": "Symbol", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "926", "Unicode hex": "39E" },
  { "Typeface name": "Symbol", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "936", "Unicode hex": "3A8" },
  { "Typeface name": "Symbol", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "918", "Unicode hex": "396" },
  { "Typeface name": "Symbol", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "91", "Unicode hex": "5B" },
  { "Typeface name": "Symbol", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "8756", "Unicode hex": "2234" },
  { "Typeface name": "Symbol", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "93", "Unicode hex": "5D" },
  { "Typeface name": "Symbol", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "8869", "Unicode hex": "22A5" },
  { "Typeface name": "Symbol", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "95", "Unicode hex": "5F" },
  { "Typeface name": "Symbol", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "8254", "Unicode hex": "203E" },
  { "Typeface name": "Symbol", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "945", "Unicode hex": "3B1" },
  { "Typeface name": "Symbol", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "946", "Unicode hex": "3B2" },
  { "Typeface name": "Symbol", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "967", "Unicode hex": "3C7" },
  { "Typeface name": "Symbol", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "948", "Unicode hex": "3B4" },
  { "Typeface name": "Symbol", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "949", "Unicode hex": "3B5" },
  { "Typeface name": "Symbol", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "966", "Unicode hex": "3C6" },
  { "Typeface name": "Symbol", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "947", "Unicode hex": "3B3" },
  { "Typeface name": "Symbol", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "951", "Unicode hex": "3B7" },
  { "Typeface name": "Symbol", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "953", "Unicode hex": "3B9" },
  { "Typeface name": "Symbol", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "981", "Unicode hex": "3D5" },
  { "Typeface name": "Symbol", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "954", "Unicode hex": "3BA" },
  { "Typeface name": "Symbol", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "955", "Unicode hex": "3BB" },
  { "Typeface name": "Symbol", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "956", "Unicode hex": "3BC" },
  { "Typeface name": "Symbol", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "957", "Unicode hex": "3BD" },
  { "Typeface name": "Symbol", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "959", "Unicode hex": "3BF" },
  { "Typeface name": "Symbol", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "960", "Unicode hex": "3C0" },
  { "Typeface name": "Symbol", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "952", "Unicode hex": "3B8" },
  { "Typeface name": "Symbol", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "961", "Unicode hex": "3C1" },
  { "Typeface name": "Symbol", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "963", "Unicode hex": "3C3" },
  { "Typeface name": "Symbol", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "964", "Unicode hex": "3C4" },
  { "Typeface name": "Symbol", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "965", "Unicode hex": "3C5" },
  { "Typeface name": "Symbol", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "982", "Unicode hex": "3D6" },
  { "Typeface name": "Symbol", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "969", "Unicode hex": "3C9" },
  { "Typeface name": "Symbol", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "958", "Unicode hex": "3BE" },
  { "Typeface name": "Symbol", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "968", "Unicode hex": "3C8" },
  { "Typeface name": "Symbol", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "950", "Unicode hex": "3B6" },
  { "Typeface name": "Symbol", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "123", "Unicode hex": "7B" },
  { "Typeface name": "Symbol", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "124", "Unicode hex": "7C" },
  { "Typeface name": "Symbol", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "125", "Unicode hex": "7D" },
  { "Typeface name": "Symbol", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "126", "Unicode hex": "7E" },
  { "Typeface name": "Symbol", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "8364", "Unicode hex": "20AC" },
  { "Typeface name": "Symbol", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "978", "Unicode hex": "3D2" },
  { "Typeface name": "Symbol", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "8242", "Unicode hex": "2032" },
  { "Typeface name": "Symbol", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "8804", "Unicode hex": "2264" },
  { "Typeface name": "Symbol", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "8260", "Unicode hex": "2044" },
  { "Typeface name": "Symbol", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "8734", "Unicode hex": "221E" },
  { "Typeface name": "Symbol", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "402", "Unicode hex": "192" },
  { "Typeface name": "Symbol", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "9827", "Unicode hex": "2663" },
  { "Typeface name": "Symbol", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "9830", "Unicode hex": "2666" },
  { "Typeface name": "Symbol", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "9829", "Unicode hex": "2665" },
  { "Typeface name": "Symbol", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "9824", "Unicode hex": "2660" },
  { "Typeface name": "Symbol", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "8596", "Unicode hex": "2194" },
  { "Typeface name": "Symbol", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "8592", "Unicode hex": "2190" },
  { "Typeface name": "Symbol", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "8593", "Unicode hex": "2191" },
  { "Typeface name": "Symbol", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "8594", "Unicode hex": "2192" },
  { "Typeface name": "Symbol", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "8595", "Unicode hex": "2193" },
  { "Typeface name": "Symbol", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "176", "Unicode hex": "B0" },
  { "Typeface name": "Symbol", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "177", "Unicode hex": "B1" },
  { "Typeface name": "Symbol", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "8243", "Unicode hex": "2033" },
  { "Typeface name": "Symbol", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "8805", "Unicode hex": "2265" },
  { "Typeface name": "Symbol", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "215", "Unicode hex": "D7" },
  { "Typeface name": "Symbol", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "8733", "Unicode hex": "221D" },
  { "Typeface name": "Symbol", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "8706", "Unicode hex": "2202" },
  { "Typeface name": "Symbol", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "8226", "Unicode hex": "2022" },
  { "Typeface name": "Symbol", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "247", "Unicode hex": "F7" },
  { "Typeface name": "Symbol", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "8800", "Unicode hex": "2260" },
  { "Typeface name": "Symbol", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "8801", "Unicode hex": "2261" },
  { "Typeface name": "Symbol", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "8776", "Unicode hex": "2248" },
  { "Typeface name": "Symbol", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "8230", "Unicode hex": "2026" },
  { "Typeface name": "Symbol", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "9168", "Unicode hex": "23D0" },
  { "Typeface name": "Symbol", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "9135", "Unicode hex": "23AF" },
  { "Typeface name": "Symbol", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "8629", "Unicode hex": "21B5" },
  { "Typeface name": "Symbol", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "8501", "Unicode hex": "2135" },
  { "Typeface name": "Symbol", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "8465", "Unicode hex": "2111" },
  { "Typeface name": "Symbol", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "8476", "Unicode hex": "211C" },
  { "Typeface name": "Symbol", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "8472", "Unicode hex": "2118" },
  { "Typeface name": "Symbol", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "8855", "Unicode hex": "2297" },
  { "Typeface name": "Symbol", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "8853", "Unicode hex": "2295" },
  { "Typeface name": "Symbol", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "8709", "Unicode hex": "2205" },
  { "Typeface name": "Symbol", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "8745", "Unicode hex": "2229" },
  { "Typeface name": "Symbol", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "8746", "Unicode hex": "222A" },
  { "Typeface name": "Symbol", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "8835", "Unicode hex": "2283" },
  { "Typeface name": "Symbol", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "8839", "Unicode hex": "2287" },
  { "Typeface name": "Symbol", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "8836", "Unicode hex": "2284" },
  { "Typeface name": "Symbol", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "8834", "Unicode hex": "2282" },
  { "Typeface name": "Symbol", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "8838", "Unicode hex": "2286" },
  { "Typeface name": "Symbol", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "8712", "Unicode hex": "2208" },
  { "Typeface name": "Symbol", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "8713", "Unicode hex": "2209" },
  { "Typeface name": "Symbol", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "8736", "Unicode hex": "2220" },
  { "Typeface name": "Symbol", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "8711", "Unicode hex": "2207" },
  { "Typeface name": "Symbol", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "174", "Unicode hex": "AE" },
  { "Typeface name": "Symbol", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "169", "Unicode hex": "A9" },
  { "Typeface name": "Symbol", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "8482", "Unicode hex": "2122" },
  { "Typeface name": "Symbol", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "8719", "Unicode hex": "220F" },
  { "Typeface name": "Symbol", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "8730", "Unicode hex": "221A" },
  { "Typeface name": "Symbol", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "8901", "Unicode hex": "22C5" },
  { "Typeface name": "Symbol", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "172", "Unicode hex": "AC" },
  { "Typeface name": "Symbol", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "8743", "Unicode hex": "2227" },
  { "Typeface name": "Symbol", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "8744", "Unicode hex": "2228" },
  { "Typeface name": "Symbol", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "8660", "Unicode hex": "21D4" },
  { "Typeface name": "Symbol", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "8656", "Unicode hex": "21D0" },
  { "Typeface name": "Symbol", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "8657", "Unicode hex": "21D1" },
  { "Typeface name": "Symbol", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "8658", "Unicode hex": "21D2" },
  { "Typeface name": "Symbol", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "8659", "Unicode hex": "21D3" },
  { "Typeface name": "Symbol", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "9674", "Unicode hex": "25CA" },
  { "Typeface name": "Symbol", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "12296", "Unicode hex": "3008" },
  { "Typeface name": "Symbol", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "174", "Unicode hex": "AE" },
  { "Typeface name": "Symbol", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "169", "Unicode hex": "A9" },
  { "Typeface name": "Symbol", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "8482", "Unicode hex": "2122" },
  { "Typeface name": "Symbol", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "8721", "Unicode hex": "2211" },
  { "Typeface name": "Symbol", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "9115", "Unicode hex": "239B" },
  { "Typeface name": "Symbol", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "9116", "Unicode hex": "239C" },
  { "Typeface name": "Symbol", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "9117", "Unicode hex": "239D" },
  { "Typeface name": "Symbol", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "9121", "Unicode hex": "23A1" },
  { "Typeface name": "Symbol", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "9122", "Unicode hex": "23A2" },
  { "Typeface name": "Symbol", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "9123", "Unicode hex": "23A3" },
  { "Typeface name": "Symbol", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "9127", "Unicode hex": "23A7" },
  { "Typeface name": "Symbol", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "9128", "Unicode hex": "23A8" },
  { "Typeface name": "Symbol", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "9129", "Unicode hex": "23A9" },
  { "Typeface name": "Symbol", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "9130", "Unicode hex": "23AA" },
  { "Typeface name": "Symbol", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "63743", "Unicode hex": "F8FF" },
  { "Typeface name": "Symbol", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "12297", "Unicode hex": "3009" },
  { "Typeface name": "Symbol", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "8747", "Unicode hex": "222B" },
  { "Typeface name": "Symbol", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "8992", "Unicode hex": "2320" },
  { "Typeface name": "Symbol", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "9134", "Unicode hex": "23AE" },
  { "Typeface name": "Symbol", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "8993", "Unicode hex": "2321" },
  { "Typeface name": "Symbol", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "9118", "Unicode hex": "239E" },
  { "Typeface name": "Symbol", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "9119", "Unicode hex": "239F" },
  { "Typeface name": "Symbol", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "9120", "Unicode hex": "23A0" },
  { "Typeface name": "Symbol", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "9124", "Unicode hex": "23A4" },
  { "Typeface name": "Symbol", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "9125", "Unicode hex": "23A5" },
  { "Typeface name": "Symbol", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "9126", "Unicode hex": "23A6" },
  { "Typeface name": "Symbol", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "9131", "Unicode hex": "23AB" },
  { "Typeface name": "Symbol", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "9132", "Unicode hex": "23AC" },
  { "Typeface name": "Symbol", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "9133", "Unicode hex": "23AD" },
  { "Typeface name": "Webdings", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
  { "Typeface name": "Webdings", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128375", "Unicode hex": "1F577" },
  { "Typeface name": "Webdings", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "128376", "Unicode hex": "1F578" },
  { "Typeface name": "Webdings", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "128370", "Unicode hex": "1F572" },
  { "Typeface name": "Webdings", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128374", "Unicode hex": "1F576" },
  { "Typeface name": "Webdings", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "127942", "Unicode hex": "1F3C6" },
  { "Typeface name": "Webdings", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "127894", "Unicode hex": "1F396" },
  { "Typeface name": "Webdings", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128391", "Unicode hex": "1F587" },
  { "Typeface name": "Webdings", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128488", "Unicode hex": "1F5E8" },
  { "Typeface name": "Webdings", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "128489", "Unicode hex": "1F5E9" },
  { "Typeface name": "Webdings", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128496", "Unicode hex": "1F5F0" },
  { "Typeface name": "Webdings", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128497", "Unicode hex": "1F5F1" },
  { "Typeface name": "Webdings", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "127798", "Unicode hex": "1F336" },
  { "Typeface name": "Webdings", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "127895", "Unicode hex": "1F397" },
  { "Typeface name": "Webdings", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128638", "Unicode hex": "1F67E" },
  { "Typeface name": "Webdings", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128636", "Unicode hex": "1F67C" },
  { "Typeface name": "Webdings", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128469", "Unicode hex": "1F5D5" },
  { "Typeface name": "Webdings", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128470", "Unicode hex": "1F5D6" },
  { "Typeface name": "Webdings", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128471", "Unicode hex": "1F5D7" },
  { "Typeface name": "Webdings", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "9204", "Unicode hex": "23F4" },
  { "Typeface name": "Webdings", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "9205", "Unicode hex": "23F5" },
  { "Typeface name": "Webdings", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "9206", "Unicode hex": "23F6" },
  { "Typeface name": "Webdings", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "9207", "Unicode hex": "23F7" },
  { "Typeface name": "Webdings", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "9194", "Unicode hex": "23EA" },
  { "Typeface name": "Webdings", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "9193", "Unicode hex": "23E9" },
  { "Typeface name": "Webdings", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "9198", "Unicode hex": "23EE" },
  { "Typeface name": "Webdings", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "9197", "Unicode hex": "23ED" },
  { "Typeface name": "Webdings", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "9208", "Unicode hex": "23F8" },
  { "Typeface name": "Webdings", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "9209", "Unicode hex": "23F9" },
  { "Typeface name": "Webdings", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "9210", "Unicode hex": "23FA" },
  { "Typeface name": "Webdings", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "128474", "Unicode hex": "1F5DA" },
  { "Typeface name": "Webdings", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "128499", "Unicode hex": "1F5F3" },
  { "Typeface name": "Webdings", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128736", "Unicode hex": "1F6E0" },
  { "Typeface name": "Webdings", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "127959", "Unicode hex": "1F3D7" },
  { "Typeface name": "Webdings", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "127960", "Unicode hex": "1F3D8" },
  { "Typeface name": "Webdings", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "127961", "Unicode hex": "1F3D9" },
  { "Typeface name": "Webdings", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "127962", "Unicode hex": "1F3DA" },
  { "Typeface name": "Webdings", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "127964", "Unicode hex": "1F3DC" },
  { "Typeface name": "Webdings", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "127981", "Unicode hex": "1F3ED" },
  { "Typeface name": "Webdings", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "127963", "Unicode hex": "1F3DB" },
  { "Typeface name": "Webdings", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "127968", "Unicode hex": "1F3E0" },
  { "Typeface name": "Webdings", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "127958", "Unicode hex": "1F3D6" },
  { "Typeface name": "Webdings", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "127965", "Unicode hex": "1F3DD" },
  { "Typeface name": "Webdings", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128739", "Unicode hex": "1F6E3" },
  { "Typeface name": "Webdings", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "128269", "Unicode hex": "1F50D" },
  { "Typeface name": "Webdings", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "127956", "Unicode hex": "1F3D4" },
  { "Typeface name": "Webdings", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128065", "Unicode hex": "1F441" },
  { "Typeface name": "Webdings", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "128066", "Unicode hex": "1F442" },
  { "Typeface name": "Webdings", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "127966", "Unicode hex": "1F3DE" },
  { "Typeface name": "Webdings", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "127957", "Unicode hex": "1F3D5" },
  { "Typeface name": "Webdings", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "128740", "Unicode hex": "1F6E4" },
  { "Typeface name": "Webdings", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "127967", "Unicode hex": "1F3DF" },
  { "Typeface name": "Webdings", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "128755", "Unicode hex": "1F6F3" },
  { "Typeface name": "Webdings", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "128364", "Unicode hex": "1F56C" },
  { "Typeface name": "Webdings", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "128363", "Unicode hex": "1F56B" },
  { "Typeface name": "Webdings", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128360", "Unicode hex": "1F568" },
  { "Typeface name": "Webdings", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "128264", "Unicode hex": "1F508" },
  { "Typeface name": "Webdings", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "127892", "Unicode hex": "1F394" },
  { "Typeface name": "Webdings", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "127893", "Unicode hex": "1F395" },
  { "Typeface name": "Webdings", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "128492", "Unicode hex": "1F5EC" },
  { "Typeface name": "Webdings", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128637", "Unicode hex": "1F67D" },
  { "Typeface name": "Webdings", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "128493", "Unicode hex": "1F5ED" },
  { "Typeface name": "Webdings", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "128490", "Unicode hex": "1F5EA" },
  { "Typeface name": "Webdings", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "128491", "Unicode hex": "1F5EB" },
  { "Typeface name": "Webdings", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "11156", "Unicode hex": "2B94" },
  { "Typeface name": "Webdings", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "10004", "Unicode hex": "2714" },
  { "Typeface name": "Webdings", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "128690", "Unicode hex": "1F6B2" },
  { "Typeface name": "Webdings", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "11036", "Unicode hex": "2B1C" },
  { "Typeface name": "Webdings", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "128737", "Unicode hex": "1F6E1" },
  { "Typeface name": "Webdings", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "128230", "Unicode hex": "1F4E6" },
  { "Typeface name": "Webdings", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "128753", "Unicode hex": "1F6F1" },
  { "Typeface name": "Webdings", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "11035", "Unicode hex": "2B1B" },
  { "Typeface name": "Webdings", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "128657", "Unicode hex": "1F691" },
  { "Typeface name": "Webdings", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "128712", "Unicode hex": "1F6C8" },
  { "Typeface name": "Webdings", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "128745", "Unicode hex": "1F6E9" },
  { "Typeface name": "Webdings", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "128752", "Unicode hex": "1F6F0" },
  { "Typeface name": "Webdings", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "128968", "Unicode hex": "1F7C8" },
  { "Typeface name": "Webdings", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "128372", "Unicode hex": "1F574" },
  { "Typeface name": "Webdings", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "11044", "Unicode hex": "2B24" },
  { "Typeface name": "Webdings", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "128741", "Unicode hex": "1F6E5" },
  { "Typeface name": "Webdings", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "128660", "Unicode hex": "1F694" },
  { "Typeface name": "Webdings", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "128472", "Unicode hex": "1F5D8" },
  { "Typeface name": "Webdings", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "128473", "Unicode hex": "1F5D9" },
  { "Typeface name": "Webdings", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "10067", "Unicode hex": "2753" },
  { "Typeface name": "Webdings", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "128754", "Unicode hex": "1F6F2" },
  { "Typeface name": "Webdings", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "128647", "Unicode hex": "1F687" },
  { "Typeface name": "Webdings", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "128653", "Unicode hex": "1F68D" },
  { "Typeface name": "Webdings", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "9971", "Unicode hex": "26F3" },
  { "Typeface name": "Webdings", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "10680", "Unicode hex": "29B8" },
  { "Typeface name": "Webdings", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "8854", "Unicode hex": "2296" },
  { "Typeface name": "Webdings", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "128685", "Unicode hex": "1F6AD" },
  { "Typeface name": "Webdings", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "128494", "Unicode hex": "1F5EE" },
  { "Typeface name": "Webdings", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "9168", "Unicode hex": "23D0" },
  { "Typeface name": "Webdings", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128495", "Unicode hex": "1F5EF" },
  { "Typeface name": "Webdings", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128498", "Unicode hex": "1F5F2" },
  { "Typeface name": "Webdings", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "128697", "Unicode hex": "1F6B9" },
  { "Typeface name": "Webdings", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "128698", "Unicode hex": "1F6BA" },
  { "Typeface name": "Webdings", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "128713", "Unicode hex": "1F6C9" },
  { "Typeface name": "Webdings", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "128714", "Unicode hex": "1F6CA" },
  { "Typeface name": "Webdings", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "128700", "Unicode hex": "1F6BC" },
  { "Typeface name": "Webdings", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "128125", "Unicode hex": "1F47D" },
  { "Typeface name": "Webdings", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "127947", "Unicode hex": "1F3CB" },
  { "Typeface name": "Webdings", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "9975", "Unicode hex": "26F7" },
  { "Typeface name": "Webdings", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "127938", "Unicode hex": "1F3C2" },
  { "Typeface name": "Webdings", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "127948", "Unicode hex": "1F3CC" },
  { "Typeface name": "Webdings", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "127946", "Unicode hex": "1F3CA" },
  { "Typeface name": "Webdings", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "127940", "Unicode hex": "1F3C4" },
  { "Typeface name": "Webdings", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "127949", "Unicode hex": "1F3CD" },
  { "Typeface name": "Webdings", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "127950", "Unicode hex": "1F3CE" },
  { "Typeface name": "Webdings", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "128664", "Unicode hex": "1F698" },
  { "Typeface name": "Webdings", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "128480", "Unicode hex": "1F5E0" },
  { "Typeface name": "Webdings", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "128738", "Unicode hex": "1F6E2" },
  { "Typeface name": "Webdings", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "128176", "Unicode hex": "1F4B0" },
  { "Typeface name": "Webdings", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "127991", "Unicode hex": "1F3F7" },
  { "Typeface name": "Webdings", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "128179", "Unicode hex": "1F4B3" },
  { "Typeface name": "Webdings", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "128106", "Unicode hex": "1F46A" },
  { "Typeface name": "Webdings", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "128481", "Unicode hex": "1F5E1" },
  { "Typeface name": "Webdings", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128482", "Unicode hex": "1F5E2" },
  { "Typeface name": "Webdings", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "128483", "Unicode hex": "1F5E3" },
  { "Typeface name": "Webdings", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "10031", "Unicode hex": "272F" },
  { "Typeface name": "Webdings", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "128388", "Unicode hex": "1F584" },
  { "Typeface name": "Webdings", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128389", "Unicode hex": "1F585" },
  { "Typeface name": "Webdings", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128387", "Unicode hex": "1F583" },
  { "Typeface name": "Webdings", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128390", "Unicode hex": "1F586" },
  { "Typeface name": "Webdings", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "128441", "Unicode hex": "1F5B9" },
  { "Typeface name": "Webdings", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "128442", "Unicode hex": "1F5BA" },
  { "Typeface name": "Webdings", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "128443", "Unicode hex": "1F5BB" },
  { "Typeface name": "Webdings", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "128373", "Unicode hex": "1F575" },
  { "Typeface name": "Webdings", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "128368", "Unicode hex": "1F570" },
  { "Typeface name": "Webdings", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "128445", "Unicode hex": "1F5BD" },
  { "Typeface name": "Webdings", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "128446", "Unicode hex": "1F5BE" },
  { "Typeface name": "Webdings", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128203", "Unicode hex": "1F4CB" },
  { "Typeface name": "Webdings", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128466", "Unicode hex": "1F5D2" },
  { "Typeface name": "Webdings", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128467", "Unicode hex": "1F5D3" },
  { "Typeface name": "Webdings", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "128366", "Unicode hex": "1F56E" },
  { "Typeface name": "Webdings", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "128218", "Unicode hex": "1F4DA" },
  { "Typeface name": "Webdings", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128478", "Unicode hex": "1F5DE" },
  { "Typeface name": "Webdings", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128479", "Unicode hex": "1F5DF" },
  { "Typeface name": "Webdings", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "128451", "Unicode hex": "1F5C3" },
  { "Typeface name": "Webdings", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128450", "Unicode hex": "1F5C2" },
  { "Typeface name": "Webdings", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "128444", "Unicode hex": "1F5BC" },
  { "Typeface name": "Webdings", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "127917", "Unicode hex": "1F3AD" },
  { "Typeface name": "Webdings", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "127900", "Unicode hex": "1F39C" },
  { "Typeface name": "Webdings", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "127896", "Unicode hex": "1F398" },
  { "Typeface name": "Webdings", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "127897", "Unicode hex": "1F399" },
  { "Typeface name": "Webdings", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "127911", "Unicode hex": "1F3A7" },
  { "Typeface name": "Webdings", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "128191", "Unicode hex": "1F4BF" },
  { "Typeface name": "Webdings", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "127902", "Unicode hex": "1F39E" },
  { "Typeface name": "Webdings", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "128247", "Unicode hex": "1F4F7" },
  { "Typeface name": "Webdings", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "127903", "Unicode hex": "1F39F" },
  { "Typeface name": "Webdings", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "127916", "Unicode hex": "1F3AC" },
  { "Typeface name": "Webdings", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "128253", "Unicode hex": "1F4FD" },
  { "Typeface name": "Webdings", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128249", "Unicode hex": "1F4F9" },
  { "Typeface name": "Webdings", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "128254", "Unicode hex": "1F4FE" },
  { "Typeface name": "Webdings", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "128251", "Unicode hex": "1F4FB" },
  { "Typeface name": "Webdings", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "127898", "Unicode hex": "1F39A" },
  { "Typeface name": "Webdings", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "127899", "Unicode hex": "1F39B" },
  { "Typeface name": "Webdings", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "128250", "Unicode hex": "1F4FA" },
  { "Typeface name": "Webdings", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "128187", "Unicode hex": "1F4BB" },
  { "Typeface name": "Webdings", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "128421", "Unicode hex": "1F5A5" },
  { "Typeface name": "Webdings", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "128422", "Unicode hex": "1F5A6" },
  { "Typeface name": "Webdings", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "128423", "Unicode hex": "1F5A7" },
  { "Typeface name": "Webdings", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "128377", "Unicode hex": "1F579" },
  { "Typeface name": "Webdings", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "127918", "Unicode hex": "1F3AE" },
  { "Typeface name": "Webdings", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "128379", "Unicode hex": "1F57B" },
  { "Typeface name": "Webdings", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "128380", "Unicode hex": "1F57C" },
  { "Typeface name": "Webdings", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "128223", "Unicode hex": "1F4DF" },
  { "Typeface name": "Webdings", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "128385", "Unicode hex": "1F581" },
  { "Typeface name": "Webdings", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "128384", "Unicode hex": "1F580" },
  { "Typeface name": "Webdings", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "128424", "Unicode hex": "1F5A8" },
  { "Typeface name": "Webdings", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128425", "Unicode hex": "1F5A9" },
  { "Typeface name": "Webdings", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128447", "Unicode hex": "1F5BF" },
  { "Typeface name": "Webdings", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128426", "Unicode hex": "1F5AA" },
  { "Typeface name": "Webdings", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128476", "Unicode hex": "1F5DC" },
  { "Typeface name": "Webdings", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128274", "Unicode hex": "1F512" },
  { "Typeface name": "Webdings", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128275", "Unicode hex": "1F513" },
  { "Typeface name": "Webdings", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128477", "Unicode hex": "1F5DD" },
  { "Typeface name": "Webdings", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128229", "Unicode hex": "1F4E5" },
  { "Typeface name": "Webdings", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128228", "Unicode hex": "1F4E4" },
  { "Typeface name": "Webdings", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128371", "Unicode hex": "1F573" },
  { "Typeface name": "Webdings", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "127779", "Unicode hex": "1F323" },
  { "Typeface name": "Webdings", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "127780", "Unicode hex": "1F324" },
  { "Typeface name": "Webdings", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "127781", "Unicode hex": "1F325" },
  { "Typeface name": "Webdings", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "127782", "Unicode hex": "1F326" },
  { "Typeface name": "Webdings", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "9729", "Unicode hex": "2601" },
  { "Typeface name": "Webdings", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "127784", "Unicode hex": "1F328" },
  { "Typeface name": "Webdings", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "127783", "Unicode hex": "1F327" },
  { "Typeface name": "Webdings", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "127785", "Unicode hex": "1F329" },
  { "Typeface name": "Webdings", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "127786", "Unicode hex": "1F32A" },
  { "Typeface name": "Webdings", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "127788", "Unicode hex": "1F32C" },
  { "Typeface name": "Webdings", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "127787", "Unicode hex": "1F32B" },
  { "Typeface name": "Webdings", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "127772", "Unicode hex": "1F31C" },
  { "Typeface name": "Webdings", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "127777", "Unicode hex": "1F321" },
  { "Typeface name": "Webdings", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "128715", "Unicode hex": "1F6CB" },
  { "Typeface name": "Webdings", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "128719", "Unicode hex": "1F6CF" },
  { "Typeface name": "Webdings", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "127869", "Unicode hex": "1F37D" },
  { "Typeface name": "Webdings", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "127864", "Unicode hex": "1F378" },
  { "Typeface name": "Webdings", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "128718", "Unicode hex": "1F6CE" },
  { "Typeface name": "Webdings", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "128717", "Unicode hex": "1F6CD" },
  { "Typeface name": "Webdings", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "9413", "Unicode hex": "24C5" },
  { "Typeface name": "Webdings", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "9855", "Unicode hex": "267F" },
  { "Typeface name": "Webdings", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "128710", "Unicode hex": "1F6C6" },
  { "Typeface name": "Webdings", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "128392", "Unicode hex": "1F588" },
  { "Typeface name": "Webdings", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "127891", "Unicode hex": "1F393" },
  { "Typeface name": "Webdings", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "128484", "Unicode hex": "1F5E4" },
  { "Typeface name": "Webdings", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "128485", "Unicode hex": "1F5E5" },
  { "Typeface name": "Webdings", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "128486", "Unicode hex": "1F5E6" },
  { "Typeface name": "Webdings", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "128487", "Unicode hex": "1F5E7" },
  { "Typeface name": "Webdings", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "128746", "Unicode hex": "1F6EA" },
  { "Typeface name": "Webdings", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "128063", "Unicode hex": "1F43F" },
  { "Typeface name": "Webdings", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "128038", "Unicode hex": "1F426" },
  { "Typeface name": "Webdings", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "128031", "Unicode hex": "1F41F" },
  { "Typeface name": "Webdings", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "128021", "Unicode hex": "1F415" },
  { "Typeface name": "Webdings", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "128008", "Unicode hex": "1F408" },
  { "Typeface name": "Webdings", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "128620", "Unicode hex": "1F66C" },
  { "Typeface name": "Webdings", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "128622", "Unicode hex": "1F66E" },
  { "Typeface name": "Webdings", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "128621", "Unicode hex": "1F66D" },
  { "Typeface name": "Webdings", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "128623", "Unicode hex": "1F66F" },
  { "Typeface name": "Webdings", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "128506", "Unicode hex": "1F5FA" },
  { "Typeface name": "Webdings", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "127757", "Unicode hex": "1F30D" },
  { "Typeface name": "Webdings", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "127759", "Unicode hex": "1F30F" },
  { "Typeface name": "Webdings", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "127758", "Unicode hex": "1F30E" },
  { "Typeface name": "Webdings", "Dingbat dec": "255", "Dingbat hex": "FF", "Unicode dec": "128330", "Unicode hex": "1F54A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
  { "Typeface name": "Wingdings", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128393", "Unicode hex": "1F589" },
  { "Typeface name": "Wingdings", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "9986", "Unicode hex": "2702" },
  { "Typeface name": "Wingdings", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "9985", "Unicode hex": "2701" },
  { "Typeface name": "Wingdings", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128083", "Unicode hex": "1F453" },
  { "Typeface name": "Wingdings", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "128365", "Unicode hex": "1F56D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "128366", "Unicode hex": "1F56E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128367", "Unicode hex": "1F56F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128383", "Unicode hex": "1F57F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "9990", "Unicode hex": "2706" },
  { "Typeface name": "Wingdings", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128386", "Unicode hex": "1F582" },
  { "Typeface name": "Wingdings", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128387", "Unicode hex": "1F583" },
  { "Typeface name": "Wingdings", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "128234", "Unicode hex": "1F4EA" },
  { "Typeface name": "Wingdings", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "128235", "Unicode hex": "1F4EB" },
  { "Typeface name": "Wingdings", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128236", "Unicode hex": "1F4EC" },
  { "Typeface name": "Wingdings", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128237", "Unicode hex": "1F4ED" },
  { "Typeface name": "Wingdings", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128448", "Unicode hex": "1F5C0" },
  { "Typeface name": "Wingdings", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128449", "Unicode hex": "1F5C1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128462", "Unicode hex": "1F5CE" },
  { "Typeface name": "Wingdings", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "128463", "Unicode hex": "1F5CF" },
  { "Typeface name": "Wingdings", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "128464", "Unicode hex": "1F5D0" },
  { "Typeface name": "Wingdings", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "128452", "Unicode hex": "1F5C4" },
  { "Typeface name": "Wingdings", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "8987", "Unicode hex": "231B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "128430", "Unicode hex": "1F5AE" },
  { "Typeface name": "Wingdings", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "128432", "Unicode hex": "1F5B0" },
  { "Typeface name": "Wingdings", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "128434", "Unicode hex": "1F5B2" },
  { "Typeface name": "Wingdings", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "128435", "Unicode hex": "1F5B3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "128436", "Unicode hex": "1F5B4" },
  { "Typeface name": "Wingdings", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "128427", "Unicode hex": "1F5AB" },
  { "Typeface name": "Wingdings", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "128428", "Unicode hex": "1F5AC" },
  { "Typeface name": "Wingdings", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "9991", "Unicode hex": "2707" },
  { "Typeface name": "Wingdings", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "9997", "Unicode hex": "270D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128398", "Unicode hex": "1F58E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "9996", "Unicode hex": "270C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "128399", "Unicode hex": "1F58F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "128077", "Unicode hex": "1F44D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "128078", "Unicode hex": "1F44E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "9756", "Unicode hex": "261C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "9758", "Unicode hex": "261E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "9757", "Unicode hex": "261D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "9759", "Unicode hex": "261F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "128400", "Unicode hex": "1F590" },
  { "Typeface name": "Wingdings", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "9786", "Unicode hex": "263A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128528", "Unicode hex": "1F610" },
  { "Typeface name": "Wingdings", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "9785", "Unicode hex": "2639" },
  { "Typeface name": "Wingdings", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "128163", "Unicode hex": "1F4A3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128369", "Unicode hex": "1F571" },
  { "Typeface name": "Wingdings", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "127987", "Unicode hex": "1F3F3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "127985", "Unicode hex": "1F3F1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "9992", "Unicode hex": "2708" },
  { "Typeface name": "Wingdings", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9788", "Unicode hex": "263C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "127778", "Unicode hex": "1F322" },
  { "Typeface name": "Wingdings", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "10052", "Unicode hex": "2744" },
  { "Typeface name": "Wingdings", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "128326", "Unicode hex": "1F546" },
  { "Typeface name": "Wingdings", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "10014", "Unicode hex": "271E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128328", "Unicode hex": "1F548" },
  { "Typeface name": "Wingdings", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "10016", "Unicode hex": "2720" },
  { "Typeface name": "Wingdings", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "10017", "Unicode hex": "2721" },
  { "Typeface name": "Wingdings", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "9770", "Unicode hex": "262A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "9775", "Unicode hex": "262F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128329", "Unicode hex": "1F549" },
  { "Typeface name": "Wingdings", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "9784", "Unicode hex": "2638" },
  { "Typeface name": "Wingdings", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "9800", "Unicode hex": "2648" },
  { "Typeface name": "Wingdings", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "9801", "Unicode hex": "2649" },
  { "Typeface name": "Wingdings", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "9802", "Unicode hex": "264A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "9803", "Unicode hex": "264B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "9804", "Unicode hex": "264C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "9805", "Unicode hex": "264D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "9806", "Unicode hex": "264E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "9807", "Unicode hex": "264F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "9808", "Unicode hex": "2650" },
  { "Typeface name": "Wingdings", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "9809", "Unicode hex": "2651" },
  { "Typeface name": "Wingdings", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "9810", "Unicode hex": "2652" },
  { "Typeface name": "Wingdings", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "9811", "Unicode hex": "2653" },
  { "Typeface name": "Wingdings", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "128624", "Unicode hex": "1F670" },
  { "Typeface name": "Wingdings", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "128629", "Unicode hex": "1F675" },
  { "Typeface name": "Wingdings", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "9899", "Unicode hex": "26AB" },
  { "Typeface name": "Wingdings", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "128318", "Unicode hex": "1F53E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "9724", "Unicode hex": "25FC" },
  { "Typeface name": "Wingdings", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "128911", "Unicode hex": "1F78F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "128912", "Unicode hex": "1F790" },
  { "Typeface name": "Wingdings", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "10065", "Unicode hex": "2751" },
  { "Typeface name": "Wingdings", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "10066", "Unicode hex": "2752" },
  { "Typeface name": "Wingdings", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "128927", "Unicode hex": "1F79F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "10731", "Unicode hex": "29EB" },
  { "Typeface name": "Wingdings", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "9670", "Unicode hex": "25C6" },
  { "Typeface name": "Wingdings", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "10070", "Unicode hex": "2756" },
  { "Typeface name": "Wingdings", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "11049", "Unicode hex": "2B29" },
  { "Typeface name": "Wingdings", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "8999", "Unicode hex": "2327" },
  { "Typeface name": "Wingdings", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "11193", "Unicode hex": "2BB9" },
  { "Typeface name": "Wingdings", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "8984", "Unicode hex": "2318" },
  { "Typeface name": "Wingdings", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "127989", "Unicode hex": "1F3F5" },
  { "Typeface name": "Wingdings", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "127990", "Unicode hex": "1F3F6" },
  { "Typeface name": "Wingdings", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128630", "Unicode hex": "1F676" },
  { "Typeface name": "Wingdings", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128631", "Unicode hex": "1F677" },
  { "Typeface name": "Wingdings", "Dingbat dec": "127", "Dingbat hex": "7F", "Unicode dec": "9647", "Unicode hex": "25AF" },
  { "Typeface name": "Wingdings", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "127243", "Unicode hex": "1F10B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "10112", "Unicode hex": "2780" },
  { "Typeface name": "Wingdings", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "10113", "Unicode hex": "2781" },
  { "Typeface name": "Wingdings", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "10114", "Unicode hex": "2782" },
  { "Typeface name": "Wingdings", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "10115", "Unicode hex": "2783" },
  { "Typeface name": "Wingdings", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "10116", "Unicode hex": "2784" },
  { "Typeface name": "Wingdings", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "10117", "Unicode hex": "2785" },
  { "Typeface name": "Wingdings", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "10118", "Unicode hex": "2786" },
  { "Typeface name": "Wingdings", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "10119", "Unicode hex": "2787" },
  { "Typeface name": "Wingdings", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "10120", "Unicode hex": "2788" },
  { "Typeface name": "Wingdings", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "10121", "Unicode hex": "2789" },
  { "Typeface name": "Wingdings", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "127244", "Unicode hex": "1F10C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "10122", "Unicode hex": "278A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "10123", "Unicode hex": "278B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "10124", "Unicode hex": "278C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "10125", "Unicode hex": "278D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "10126", "Unicode hex": "278E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "10127", "Unicode hex": "278F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "10128", "Unicode hex": "2790" },
  { "Typeface name": "Wingdings", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "10129", "Unicode hex": "2791" },
  { "Typeface name": "Wingdings", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "10130", "Unicode hex": "2792" },
  { "Typeface name": "Wingdings", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "10131", "Unicode hex": "2793" },
  { "Typeface name": "Wingdings", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128610", "Unicode hex": "1F662" },
  { "Typeface name": "Wingdings", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "128608", "Unicode hex": "1F660" },
  { "Typeface name": "Wingdings", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "128609", "Unicode hex": "1F661" },
  { "Typeface name": "Wingdings", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "128611", "Unicode hex": "1F663" },
  { "Typeface name": "Wingdings", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128606", "Unicode hex": "1F65E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128604", "Unicode hex": "1F65C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128605", "Unicode hex": "1F65D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "128607", "Unicode hex": "1F65F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "8729", "Unicode hex": "2219" },
  { "Typeface name": "Wingdings", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "8226", "Unicode hex": "2022" },
  { "Typeface name": "Wingdings", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "11037", "Unicode hex": "2B1D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "11096", "Unicode hex": "2B58" },
  { "Typeface name": "Wingdings", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "128902", "Unicode hex": "1F786" },
  { "Typeface name": "Wingdings", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "128904", "Unicode hex": "1F788" },
  { "Typeface name": "Wingdings", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128906", "Unicode hex": "1F78A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128907", "Unicode hex": "1F78B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128319", "Unicode hex": "1F53F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "9642", "Unicode hex": "25AA" },
  { "Typeface name": "Wingdings", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "128910", "Unicode hex": "1F78E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128961", "Unicode hex": "1F7C1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128965", "Unicode hex": "1F7C5" },
  { "Typeface name": "Wingdings", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "9733", "Unicode hex": "2605" },
  { "Typeface name": "Wingdings", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128971", "Unicode hex": "1F7CB" },
  { "Typeface name": "Wingdings", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "128975", "Unicode hex": "1F7CF" },
  { "Typeface name": "Wingdings", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "128979", "Unicode hex": "1F7D3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "128977", "Unicode hex": "1F7D1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "11216", "Unicode hex": "2BD0" },
  { "Typeface name": "Wingdings", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "8982", "Unicode hex": "2316" },
  { "Typeface name": "Wingdings", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "11214", "Unicode hex": "2BCE" },
  { "Typeface name": "Wingdings", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "11215", "Unicode hex": "2BCF" },
  { "Typeface name": "Wingdings", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "11217", "Unicode hex": "2BD1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "10026", "Unicode hex": "272A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "10032", "Unicode hex": "2730" },
  { "Typeface name": "Wingdings", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "128336", "Unicode hex": "1F550" },
  { "Typeface name": "Wingdings", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "128337", "Unicode hex": "1F551" },
  { "Typeface name": "Wingdings", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128338", "Unicode hex": "1F552" },
  { "Typeface name": "Wingdings", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "128339", "Unicode hex": "1F553" },
  { "Typeface name": "Wingdings", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "128340", "Unicode hex": "1F554" },
  { "Typeface name": "Wingdings", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "128341", "Unicode hex": "1F555" },
  { "Typeface name": "Wingdings", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "128342", "Unicode hex": "1F556" },
  { "Typeface name": "Wingdings", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "128343", "Unicode hex": "1F557" },
  { "Typeface name": "Wingdings", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "128344", "Unicode hex": "1F558" },
  { "Typeface name": "Wingdings", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "128345", "Unicode hex": "1F559" },
  { "Typeface name": "Wingdings", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "128346", "Unicode hex": "1F55A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "128347", "Unicode hex": "1F55B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "11184", "Unicode hex": "2BB0" },
  { "Typeface name": "Wingdings", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "11185", "Unicode hex": "2BB1" },
  { "Typeface name": "Wingdings", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "11186", "Unicode hex": "2BB2" },
  { "Typeface name": "Wingdings", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "11187", "Unicode hex": "2BB3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "11188", "Unicode hex": "2BB4" },
  { "Typeface name": "Wingdings", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "11189", "Unicode hex": "2BB5" },
  { "Typeface name": "Wingdings", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "11190", "Unicode hex": "2BB6" },
  { "Typeface name": "Wingdings", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "11191", "Unicode hex": "2BB7" },
  { "Typeface name": "Wingdings", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128618", "Unicode hex": "1F66A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128619", "Unicode hex": "1F66B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128597", "Unicode hex": "1F655" },
  { "Typeface name": "Wingdings", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128596", "Unicode hex": "1F654" },
  { "Typeface name": "Wingdings", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128599", "Unicode hex": "1F657" },
  { "Typeface name": "Wingdings", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128598", "Unicode hex": "1F656" },
  { "Typeface name": "Wingdings", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128592", "Unicode hex": "1F650" },
  { "Typeface name": "Wingdings", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128593", "Unicode hex": "1F651" },
  { "Typeface name": "Wingdings", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128594", "Unicode hex": "1F652" },
  { "Typeface name": "Wingdings", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128595", "Unicode hex": "1F653" },
  { "Typeface name": "Wingdings", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "9003", "Unicode hex": "232B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "8998", "Unicode hex": "2326" },
  { "Typeface name": "Wingdings", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "11160", "Unicode hex": "2B98" },
  { "Typeface name": "Wingdings", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "11162", "Unicode hex": "2B9A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "11161", "Unicode hex": "2B99" },
  { "Typeface name": "Wingdings", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "11163", "Unicode hex": "2B9B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "11144", "Unicode hex": "2B88" },
  { "Typeface name": "Wingdings", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "11146", "Unicode hex": "2B8A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "11145", "Unicode hex": "2B89" },
  { "Typeface name": "Wingdings", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "11147", "Unicode hex": "2B8B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "129128", "Unicode hex": "1F868" },
  { "Typeface name": "Wingdings", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "129130", "Unicode hex": "1F86A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "129129", "Unicode hex": "1F869" },
  { "Typeface name": "Wingdings", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "129131", "Unicode hex": "1F86B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "129132", "Unicode hex": "1F86C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "129133", "Unicode hex": "1F86D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "129135", "Unicode hex": "1F86F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "129134", "Unicode hex": "1F86E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "129144", "Unicode hex": "1F878" },
  { "Typeface name": "Wingdings", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "129146", "Unicode hex": "1F87A" },
  { "Typeface name": "Wingdings", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "129145", "Unicode hex": "1F879" },
  { "Typeface name": "Wingdings", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "129147", "Unicode hex": "1F87B" },
  { "Typeface name": "Wingdings", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "129148", "Unicode hex": "1F87C" },
  { "Typeface name": "Wingdings", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "129149", "Unicode hex": "1F87D" },
  { "Typeface name": "Wingdings", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "129151", "Unicode hex": "1F87F" },
  { "Typeface name": "Wingdings", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "129150", "Unicode hex": "1F87E" },
  { "Typeface name": "Wingdings", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "8678", "Unicode hex": "21E6" },
  { "Typeface name": "Wingdings", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "8680", "Unicode hex": "21E8" },
  { "Typeface name": "Wingdings", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "8679", "Unicode hex": "21E7" },
  { "Typeface name": "Wingdings", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "8681", "Unicode hex": "21E9" },
  { "Typeface name": "Wingdings", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "11012", "Unicode hex": "2B04" },
  { "Typeface name": "Wingdings", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "8691", "Unicode hex": "21F3" },
  { "Typeface name": "Wingdings", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "11009", "Unicode hex": "2B01" },
  { "Typeface name": "Wingdings", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "11008", "Unicode hex": "2B00" },
  { "Typeface name": "Wingdings", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "11011", "Unicode hex": "2B03" },
  { "Typeface name": "Wingdings", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "11010", "Unicode hex": "2B02" },
  { "Typeface name": "Wingdings", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "129196", "Unicode hex": "1F8AC" },
  { "Typeface name": "Wingdings", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "129197", "Unicode hex": "1F8AD" },
  { "Typeface name": "Wingdings", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "128502", "Unicode hex": "1F5F6" },
  { "Typeface name": "Wingdings", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "10003", "Unicode hex": "2713" },
  { "Typeface name": "Wingdings", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "128503", "Unicode hex": "1F5F7" },
  { "Typeface name": "Wingdings", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "128505", "Unicode hex": "1F5F9" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128394", "Unicode hex": "1F58A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "128395", "Unicode hex": "1F58B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "128396", "Unicode hex": "1F58C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128397", "Unicode hex": "1F58D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "9988", "Unicode hex": "2704" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "9984", "Unicode hex": "2700" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128382", "Unicode hex": "1F57E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128381", "Unicode hex": "1F57D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "128453", "Unicode hex": "1F5C5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128454", "Unicode hex": "1F5C6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128455", "Unicode hex": "1F5C7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "128456", "Unicode hex": "1F5C8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "128457", "Unicode hex": "1F5C9" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128458", "Unicode hex": "1F5CA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128459", "Unicode hex": "1F5CB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128460", "Unicode hex": "1F5CC" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128461", "Unicode hex": "1F5CD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128203", "Unicode hex": "1F4CB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "128465", "Unicode hex": "1F5D1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "128468", "Unicode hex": "1F5D4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "128437", "Unicode hex": "1F5B5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "128438", "Unicode hex": "1F5B6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "128439", "Unicode hex": "1F5B7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "128440", "Unicode hex": "1F5B8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "128429", "Unicode hex": "1F5AD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "128431", "Unicode hex": "1F5AF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "128433", "Unicode hex": "1F5B1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "128402", "Unicode hex": "1F592" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "128403", "Unicode hex": "1F593" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "128408", "Unicode hex": "1F598" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "128409", "Unicode hex": "1F599" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128410", "Unicode hex": "1F59A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "128411", "Unicode hex": "1F59B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "128072", "Unicode hex": "1F448" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "128073", "Unicode hex": "1F449" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "128412", "Unicode hex": "1F59C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "128413", "Unicode hex": "1F59D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "128414", "Unicode hex": "1F59E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "128415", "Unicode hex": "1F59F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "128416", "Unicode hex": "1F5A0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "128417", "Unicode hex": "1F5A1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "128070", "Unicode hex": "1F446" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128071", "Unicode hex": "1F447" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "128418", "Unicode hex": "1F5A2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "128419", "Unicode hex": "1F5A3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128401", "Unicode hex": "1F591" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "128500", "Unicode hex": "1F5F4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "128504", "Unicode hex": "1F5F8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "128501", "Unicode hex": "1F5F5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9745", "Unicode hex": "2611" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "11197", "Unicode hex": "2BBD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "9746", "Unicode hex": "2612" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "11198", "Unicode hex": "2BBE" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "11199", "Unicode hex": "2BBF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128711", "Unicode hex": "1F6C7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "10680", "Unicode hex": "29B8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "128625", "Unicode hex": "1F671" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "128628", "Unicode hex": "1F674" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "128626", "Unicode hex": "1F672" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128627", "Unicode hex": "1F673" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "8253", "Unicode hex": "203D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "128633", "Unicode hex": "1F679" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "128634", "Unicode hex": "1F67A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "128635", "Unicode hex": "1F67B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "128614", "Unicode hex": "1F666" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "128612", "Unicode hex": "1F664" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "128613", "Unicode hex": "1F665" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "128615", "Unicode hex": "1F667" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "128602", "Unicode hex": "1F65A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "128600", "Unicode hex": "1F658" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "128601", "Unicode hex": "1F659" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "128603", "Unicode hex": "1F65B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "9450", "Unicode hex": "24EA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "9312", "Unicode hex": "2460" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "9313", "Unicode hex": "2461" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "9314", "Unicode hex": "2462" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "9315", "Unicode hex": "2463" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "9316", "Unicode hex": "2464" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "9317", "Unicode hex": "2465" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "9318", "Unicode hex": "2466" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "9319", "Unicode hex": "2467" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "9320", "Unicode hex": "2468" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "9321", "Unicode hex": "2469" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "9471", "Unicode hex": "24FF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "10102", "Unicode hex": "2776" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "10103", "Unicode hex": "2777" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "10104", "Unicode hex": "2778" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "10105", "Unicode hex": "2779" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "10106", "Unicode hex": "277A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "10107", "Unicode hex": "277B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "10108", "Unicode hex": "277C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "10109", "Unicode hex": "277D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "10110", "Unicode hex": "277E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "10111", "Unicode hex": "277F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "9737", "Unicode hex": "2609" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "127765", "Unicode hex": "1F315" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "9789", "Unicode hex": "263D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "9790", "Unicode hex": "263E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "11839", "Unicode hex": "2E3F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "10013", "Unicode hex": "271D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "128327", "Unicode hex": "1F547" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "128348", "Unicode hex": "1F55C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "128349", "Unicode hex": "1F55D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "128350", "Unicode hex": "1F55E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "128351", "Unicode hex": "1F55F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "128352", "Unicode hex": "1F560" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "128353", "Unicode hex": "1F561" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "128354", "Unicode hex": "1F562" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "128355", "Unicode hex": "1F563" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "128356", "Unicode hex": "1F564" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "128357", "Unicode hex": "1F565" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "128358", "Unicode hex": "1F566" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "128359", "Unicode hex": "1F567" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "128616", "Unicode hex": "1F668" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "128617", "Unicode hex": "1F669" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "8901", "Unicode hex": "22C5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128900", "Unicode hex": "1F784" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "10625", "Unicode hex": "2981" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "9679", "Unicode hex": "25CF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "9675", "Unicode hex": "25CB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128901", "Unicode hex": "1F785" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128903", "Unicode hex": "1F787" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128905", "Unicode hex": "1F789" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "8857", "Unicode hex": "2299" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "10687", "Unicode hex": "29BF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "128908", "Unicode hex": "1F78C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "128909", "Unicode hex": "1F78D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "9726", "Unicode hex": "25FE" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "9632", "Unicode hex": "25A0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "9633", "Unicode hex": "25A1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128913", "Unicode hex": "1F791" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128914", "Unicode hex": "1F792" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128915", "Unicode hex": "1F793" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "128916", "Unicode hex": "1F794" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "9635", "Unicode hex": "25A3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128917", "Unicode hex": "1F795" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128918", "Unicode hex": "1F796" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "128919", "Unicode hex": "1F797" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128920", "Unicode hex": "1F798" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "11049", "Unicode hex": "2B29" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "11045", "Unicode hex": "2B25" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "9671", "Unicode hex": "25C7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "128922", "Unicode hex": "1F79A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "9672", "Unicode hex": "25C8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "128923", "Unicode hex": "1F79B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "128924", "Unicode hex": "1F79C" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "128925", "Unicode hex": "1F79D" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "128926", "Unicode hex": "1F79E" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "11050", "Unicode hex": "2B2A" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "11047", "Unicode hex": "2B27" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "9674", "Unicode hex": "25CA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128928", "Unicode hex": "1F7A0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "9686", "Unicode hex": "25D6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "9687", "Unicode hex": "25D7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "11210", "Unicode hex": "2BCA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "11211", "Unicode hex": "2BCB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "11200", "Unicode hex": "2BC0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "11201", "Unicode hex": "2BC1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "11039", "Unicode hex": "2B1F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "11202", "Unicode hex": "2BC2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "11043", "Unicode hex": "2B23" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "11042", "Unicode hex": "2B22" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "11203", "Unicode hex": "2BC3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "11204", "Unicode hex": "2BC4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "128929", "Unicode hex": "1F7A1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "128930", "Unicode hex": "1F7A2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "128931", "Unicode hex": "1F7A3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "128932", "Unicode hex": "1F7A4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "128933", "Unicode hex": "1F7A5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128934", "Unicode hex": "1F7A6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128935", "Unicode hex": "1F7A7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128936", "Unicode hex": "1F7A8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128937", "Unicode hex": "1F7A9" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128938", "Unicode hex": "1F7AA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128939", "Unicode hex": "1F7AB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128940", "Unicode hex": "1F7AC" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128941", "Unicode hex": "1F7AD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128942", "Unicode hex": "1F7AE" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128943", "Unicode hex": "1F7AF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "128944", "Unicode hex": "1F7B0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "128945", "Unicode hex": "1F7B1" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "128946", "Unicode hex": "1F7B2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "128947", "Unicode hex": "1F7B3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "128948", "Unicode hex": "1F7B4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "128949", "Unicode hex": "1F7B5" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "128950", "Unicode hex": "1F7B6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "128951", "Unicode hex": "1F7B7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "128952", "Unicode hex": "1F7B8" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "128953", "Unicode hex": "1F7B9" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "128954", "Unicode hex": "1F7BA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "128955", "Unicode hex": "1F7BB" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "128956", "Unicode hex": "1F7BC" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "128957", "Unicode hex": "1F7BD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "128958", "Unicode hex": "1F7BE" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "128959", "Unicode hex": "1F7BF" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "128960", "Unicode hex": "1F7C0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "128962", "Unicode hex": "1F7C2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "128964", "Unicode hex": "1F7C4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "128966", "Unicode hex": "1F7C6" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "128969", "Unicode hex": "1F7C9" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "128970", "Unicode hex": "1F7CA" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "10038", "Unicode hex": "2736" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "128972", "Unicode hex": "1F7CC" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "128974", "Unicode hex": "1F7CE" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "128976", "Unicode hex": "1F7D0" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "128978", "Unicode hex": "1F7D2" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "10041", "Unicode hex": "2739" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "128963", "Unicode hex": "1F7C3" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "128967", "Unicode hex": "1F7C7" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "10031", "Unicode hex": "272F" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "128973", "Unicode hex": "1F7CD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "128980", "Unicode hex": "1F7D4" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "11212", "Unicode hex": "2BCC" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "11213", "Unicode hex": "2BCD" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "8251", "Unicode hex": "203B" },
  { "Typeface name": "Wingdings 2", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "8258", "Unicode hex": "2042" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "11104", "Unicode hex": "2B60" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "11106", "Unicode hex": "2B62" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "11105", "Unicode hex": "2B61" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "11107", "Unicode hex": "2B63" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "11110", "Unicode hex": "2B66" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "11111", "Unicode hex": "2B67" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "11113", "Unicode hex": "2B69" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "11112", "Unicode hex": "2B68" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "11120", "Unicode hex": "2B70" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "11122", "Unicode hex": "2B72" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "11121", "Unicode hex": "2B71" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "11123", "Unicode hex": "2B73" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "11126", "Unicode hex": "2B76" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "11128", "Unicode hex": "2B78" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "11131", "Unicode hex": "2B7B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "11133", "Unicode hex": "2B7D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "11108", "Unicode hex": "2B64" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "11109", "Unicode hex": "2B65" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "11114", "Unicode hex": "2B6A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "11116", "Unicode hex": "2B6C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "11115", "Unicode hex": "2B6B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "11117", "Unicode hex": "2B6D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "11085", "Unicode hex": "2B4D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "11168", "Unicode hex": "2BA0" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "11169", "Unicode hex": "2BA1" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "11170", "Unicode hex": "2BA2" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "11171", "Unicode hex": "2BA3" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "11172", "Unicode hex": "2BA4" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "11173", "Unicode hex": "2BA5" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "11174", "Unicode hex": "2BA6" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "11175", "Unicode hex": "2BA7" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "11152", "Unicode hex": "2B90" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "11153", "Unicode hex": "2B91" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "11154", "Unicode hex": "2B92" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "11155", "Unicode hex": "2B93" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "11136", "Unicode hex": "2B80" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "11139", "Unicode hex": "2B83" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "11134", "Unicode hex": "2B7E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "11135", "Unicode hex": "2B7F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "11140", "Unicode hex": "2B84" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "11142", "Unicode hex": "2B86" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "11141", "Unicode hex": "2B85" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "11143", "Unicode hex": "2B87" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "11151", "Unicode hex": "2B8F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "11149", "Unicode hex": "2B8D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "11150", "Unicode hex": "2B8E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "11148", "Unicode hex": "2B8C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "11118", "Unicode hex": "2B6E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "11119", "Unicode hex": "2B6F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9099", "Unicode hex": "238B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "8996", "Unicode hex": "2324" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "8963", "Unicode hex": "2303" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "8997", "Unicode hex": "2325" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "9251", "Unicode hex": "2423" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "9085", "Unicode hex": "237D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "8682", "Unicode hex": "21EA" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "11192", "Unicode hex": "2BB8" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "129184", "Unicode hex": "1F8A0" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "129185", "Unicode hex": "1F8A1" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "129186", "Unicode hex": "1F8A2" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "129187", "Unicode hex": "1F8A3" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "129188", "Unicode hex": "1F8A4" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "129189", "Unicode hex": "1F8A5" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "129190", "Unicode hex": "1F8A6" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "129191", "Unicode hex": "1F8A7" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "129192", "Unicode hex": "1F8A8" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "129193", "Unicode hex": "1F8A9" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "129194", "Unicode hex": "1F8AA" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "129195", "Unicode hex": "1F8AB" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "129104", "Unicode hex": "1F850" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "129106", "Unicode hex": "1F852" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "129105", "Unicode hex": "1F851" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "129107", "Unicode hex": "1F853" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "129108", "Unicode hex": "1F854" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "129109", "Unicode hex": "1F855" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "129111", "Unicode hex": "1F857" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "129110", "Unicode hex": "1F856" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "129112", "Unicode hex": "1F858" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "129113", "Unicode hex": "1F859" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "9650", "Unicode hex": "25B2" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "9660", "Unicode hex": "25BC" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "9651", "Unicode hex": "25B3" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "9661", "Unicode hex": "25BD" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "9664", "Unicode hex": "25C0" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "9654", "Unicode hex": "25B6" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "9665", "Unicode hex": "25C1" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "9655", "Unicode hex": "25B7" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "9699", "Unicode hex": "25E3" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "9698", "Unicode hex": "25E2" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "9700", "Unicode hex": "25E4" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "9701", "Unicode hex": "25E5" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "128896", "Unicode hex": "1F780" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128898", "Unicode hex": "1F782" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128897", "Unicode hex": "1F781" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "128899", "Unicode hex": "1F783" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "11205", "Unicode hex": "2BC5" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "11206", "Unicode hex": "2BC6" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "11207", "Unicode hex": "2BC7" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "11208", "Unicode hex": "2BC8" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "11164", "Unicode hex": "2B9C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "11166", "Unicode hex": "2B9E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "11165", "Unicode hex": "2B9D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "11167", "Unicode hex": "2B9F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "129040", "Unicode hex": "1F810" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "129042", "Unicode hex": "1F812" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "129041", "Unicode hex": "1F811" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "129043", "Unicode hex": "1F813" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "129044", "Unicode hex": "1F814" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "129046", "Unicode hex": "1F816" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "129045", "Unicode hex": "1F815" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "129047", "Unicode hex": "1F817" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "129048", "Unicode hex": "1F818" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "129050", "Unicode hex": "1F81A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "129049", "Unicode hex": "1F819" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "129051", "Unicode hex": "1F81B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "129052", "Unicode hex": "1F81C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "129054", "Unicode hex": "1F81E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "129053", "Unicode hex": "1F81D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "129055", "Unicode hex": "1F81F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "129024", "Unicode hex": "1F800" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "129026", "Unicode hex": "1F802" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "129025", "Unicode hex": "1F801" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "129027", "Unicode hex": "1F803" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "129028", "Unicode hex": "1F804" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "129030", "Unicode hex": "1F806" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "129029", "Unicode hex": "1F805" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "129031", "Unicode hex": "1F807" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "129032", "Unicode hex": "1F808" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "129034", "Unicode hex": "1F80A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "129033", "Unicode hex": "1F809" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "129035", "Unicode hex": "1F80B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "129056", "Unicode hex": "1F820" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "129058", "Unicode hex": "1F822" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "129060", "Unicode hex": "1F824" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "129062", "Unicode hex": "1F826" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "129064", "Unicode hex": "1F828" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "129066", "Unicode hex": "1F82A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "129068", "Unicode hex": "1F82C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "129180", "Unicode hex": "1F89C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "129181", "Unicode hex": "1F89D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "129182", "Unicode hex": "1F89E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "129183", "Unicode hex": "1F89F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "129070", "Unicode hex": "1F82E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "129072", "Unicode hex": "1F830" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "129074", "Unicode hex": "1F832" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "129076", "Unicode hex": "1F834" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "129078", "Unicode hex": "1F836" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "129080", "Unicode hex": "1F838" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "129082", "Unicode hex": "1F83A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "129081", "Unicode hex": "1F839" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "129083", "Unicode hex": "1F83B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "129176", "Unicode hex": "1F898" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "129178", "Unicode hex": "1F89A" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "129177", "Unicode hex": "1F899" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "129179", "Unicode hex": "1F89B" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "129084", "Unicode hex": "1F83C" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "129086", "Unicode hex": "1F83E" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "129085", "Unicode hex": "1F83D" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "129087", "Unicode hex": "1F83F" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "129088", "Unicode hex": "1F840" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "129090", "Unicode hex": "1F842" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "129089", "Unicode hex": "1F841" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "129091", "Unicode hex": "1F843" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "129092", "Unicode hex": "1F844" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "129094", "Unicode hex": "1F846" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "129093", "Unicode hex": "1F845" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "129095", "Unicode hex": "1F847" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "11176", "Unicode hex": "2BA8" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "11177", "Unicode hex": "2BA9" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "11178", "Unicode hex": "2BAA" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "11179", "Unicode hex": "2BAB" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "11180", "Unicode hex": "2BAC" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "11181", "Unicode hex": "2BAD" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "11182", "Unicode hex": "2BAE" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "11183", "Unicode hex": "2BAF" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "129120", "Unicode hex": "1F860" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "129122", "Unicode hex": "1F862" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "129121", "Unicode hex": "1F861" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "129123", "Unicode hex": "1F863" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "129124", "Unicode hex": "1F864" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "129125", "Unicode hex": "1F865" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "129127", "Unicode hex": "1F867" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "129126", "Unicode hex": "1F866" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "129136", "Unicode hex": "1F870" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "129138", "Unicode hex": "1F872" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "129137", "Unicode hex": "1F871" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "129139", "Unicode hex": "1F873" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "129140", "Unicode hex": "1F874" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "129141", "Unicode hex": "1F875" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "129143", "Unicode hex": "1F877" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "129142", "Unicode hex": "1F876" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "129152", "Unicode hex": "1F880" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "129154", "Unicode hex": "1F882" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "129153", "Unicode hex": "1F881" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "129155", "Unicode hex": "1F883" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "129156", "Unicode hex": "1F884" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "129157", "Unicode hex": "1F885" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "129159", "Unicode hex": "1F887" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "129158", "Unicode hex": "1F886" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "129168", "Unicode hex": "1F890" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "129170", "Unicode hex": "1F892" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "129169", "Unicode hex": "1F891" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "129171", "Unicode hex": "1F893" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "129172", "Unicode hex": "1F894" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "129174", "Unicode hex": "1F896" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "129173", "Unicode hex": "1F895" },
  { "Typeface name": "Wingdings 3", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "129175", "Unicode hex": "1F897" }
];
dingbats$1.default = dingbats;
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(dist, "__esModule", { value: !0 });
dist.hex = dist.dec = dist.codePoint = void 0;
var dingbats_1 = __importDefault(dingbats$1), dingbatsByCodePoint = {}, fromCodePoint = String.fromCodePoint ? String.fromCodePoint : fromCodePointPolyfill;
for (var _i = 0, dingbats_2 = dingbats_1.default; _i < dingbats_2.length; _i++) {
  var dingbat = dingbats_2[_i], codePoint_1 = parseInt(dingbat["Unicode dec"], 10), scalarValue = {
    codePoint: codePoint_1,
    string: fromCodePoint(codePoint_1)
  };
  dingbatsByCodePoint[dingbat["Typeface name"].toUpperCase() + "_" + dingbat["Dingbat dec"]] = scalarValue;
}
function codePoint(t, e) {
  return dingbatsByCodePoint[t.toUpperCase() + "_" + e];
}
dist.codePoint = codePoint;
function dec$1(t, e) {
  return codePoint(t, parseInt(e, 10));
}
dist.dec = dec$1;
function hex(t, e) {
  return codePoint(t, parseInt(e, 16));
}
dist.hex = hex;
function fromCodePointPolyfill(t) {
  if (t <= 65535)
    return String.fromCharCode(t);
  var e = Math.floor((t - 65536) / 1024) + 55296, n = (t - 65536) % 1024 + 56320;
  return String.fromCharCode(e, n);
}
var uris$1 = {};
uris$1.uriToZipEntryName = uriToZipEntryName;
uris$1.replaceFragment = replaceFragment;
function uriToZipEntryName(t, e) {
  return e.charAt(0) === "/" ? e.substr(1) : t + "/" + e;
}
function replaceFragment(t, e) {
  var n = t.indexOf("#");
  return n !== -1 && (t = t.substring(0, n)), t + "#" + e;
}
bodyReader.createBodyReader = createBodyReader$1;
bodyReader._readNumberingProperties = readNumberingProperties;
var dingbatToUnicode = dist, _$9 = require$$0, documents$6 = documents$7, Result$6 = results$2.Result, warning = results$2.warning, uris = uris$1;
function createBodyReader$1(t) {
  return {
    readXmlElement: function(e) {
      return new BodyReader(t).readXmlElement(e);
    },
    readXmlElements: function(e) {
      return new BodyReader(t).readXmlElements(e);
    }
  };
}
function BodyReader(t) {
  var e = [], n = [], a = [], s = t.relationships, o = t.contentTypes, l = t.docxFile, c = t.files, u = t.numbering, d = t.styles;
  function f(H) {
    var ne = H.map(h);
    return combineResults(ne);
  }
  function h(H) {
    if (H.type === "element") {
      var ne = P[H.name];
      if (ne)
        return ne(H);
      if (!Object.prototype.hasOwnProperty.call(ignoreElements, H.name)) {
        var he = warning("An unrecognised element was ignored: " + H.name);
        return emptyResultWithMessages([he]);
      }
    }
    return emptyResult();
  }
  function g(H) {
    return y(H).map(function(ne) {
      return {
        type: "paragraphProperties",
        styleId: ne.styleId,
        styleName: ne.name,
        alignment: H.firstOrEmpty("w:jc").attributes["w:val"],
        numbering: readNumberingProperties(ne.styleId, H.firstOrEmpty("w:numPr"), u),
        indent: x(H.firstOrEmpty("w:ind"))
      };
    });
  }
  function x(H) {
    return {
      start: H.attributes["w:start"] || H.attributes["w:left"],
      end: H.attributes["w:end"] || H.attributes["w:right"],
      firstLine: H.attributes["w:firstLine"],
      hanging: H.attributes["w:hanging"]
    };
  }
  function E(H) {
    return A(H).map(function(ne) {
      var he = H.firstOrEmpty("w:sz").attributes["w:val"], j = /^[0-9]+$/.test(he) ? parseInt(he, 10) / 2 : null;
      return {
        type: "runProperties",
        styleId: ne.styleId,
        styleName: ne.name,
        verticalAlignment: H.firstOrEmpty("w:vertAlign").attributes["w:val"],
        font: H.firstOrEmpty("w:rFonts").attributes["w:ascii"],
        fontSize: j,
        isBold: v(H.first("w:b")),
        isUnderline: m(H.first("w:u")),
        isItalic: v(H.first("w:i")),
        isStrikethrough: v(H.first("w:strike")),
        isAllCaps: v(H.first("w:caps")),
        isSmallCaps: v(H.first("w:smallCaps"))
      };
    });
  }
  function m(H) {
    if (H) {
      var ne = H.attributes["w:val"];
      return ne !== void 0 && ne !== "false" && ne !== "0" && ne !== "none";
    } else
      return !1;
  }
  function v(H) {
    if (H) {
      var ne = H.attributes["w:val"];
      return ne !== "false" && ne !== "0";
    } else
      return !1;
  }
  function y(H) {
    return C(H, "w:pStyle", "Paragraph", d.findParagraphStyleById);
  }
  function A(H) {
    return C(H, "w:rStyle", "Run", d.findCharacterStyleById);
  }
  function b(H) {
    return C(H, "w:tblStyle", "Table", d.findTableStyleById);
  }
  function C(H, ne, he, j) {
    var Fe = [], X = H.first(ne), ye = null, Ae = null;
    if (X && (ye = X.attributes["w:val"], ye)) {
      var fe = j(ye);
      fe ? Ae = fe.name : Fe.push(q(he, ye));
    }
    return elementResultWithMessages({ styleId: ye, name: Ae }, Fe);
  }
  var T = { type: "unknown" };
  function w(H) {
    var ne = H.attributes["w:fldCharType"];
    if (ne === "begin")
      e.push(T), n = [];
    else if (ne === "end")
      e.pop();
    else if (ne === "separate") {
      var he = O(n.join("")), j = he === null ? T : { type: "hyperlink", options: he };
      e.pop(), e.push(j);
    }
    return emptyResult();
  }
  function R() {
    var H = _$9.last(e.filter(function(ne) {
      return ne.type === "hyperlink";
    }));
    return H ? H.options : null;
  }
  function O(H) {
    var ne = /\s*HYPERLINK "(.*)"/.exec(H);
    if (ne)
      return { href: ne[1] };
    var he = /\s*HYPERLINK\s+\\l\s+"(.*)"/.exec(H);
    return he ? { anchor: he[1] } : null;
  }
  function D(H) {
    return n.push(H.text()), emptyResult();
  }
  function k(H) {
    var ne = H.attributes["w:font"], he = H.attributes["w:char"], j = dingbatToUnicode.hex(ne, he);
    return j == null && /^F0..$/.test(he) && (j = dingbatToUnicode.hex(ne, he.substring(2))), j == null ? emptyResultWithMessages([warning(
      "A w:sym element with an unsupported character was ignored: char " + he + " in font " + ne
    )]) : elementResult(new documents$6.Text(j.string));
  }
  function W(H) {
    return function(ne) {
      var he = ne.attributes["w:id"];
      return elementResult(new documents$6.NoteReference({
        noteType: H,
        noteId: he
      }));
    };
  }
  function L(H) {
    return elementResult(documents$6.commentReference({
      commentId: H.attributes["w:id"]
    }));
  }
  function z(H) {
    return f(H.children);
  }
  var P = {
    "w:p": function(H) {
      var ne = H.firstOrEmpty("w:pPr"), he = !!ne.firstOrEmpty("w:rPr").first("w:del");
      if (he)
        return H.children.forEach(function(Fe) {
          a.push(Fe);
        }), emptyResult();
      var j = H.children;
      return a.length > 0 && (j = a.concat(j), a = []), ReadResult.map(
        g(ne),
        f(j),
        function(Fe, X) {
          return new documents$6.Paragraph(X, Fe);
        }
      ).insertExtra();
    },
    "w:r": function(H) {
      return ReadResult.map(
        E(H.firstOrEmpty("w:rPr")),
        f(H.children),
        function(ne, he) {
          var j = R();
          return j !== null && (he = [new documents$6.Hyperlink(he, j)]), new documents$6.Run(he, ne);
        }
      );
    },
    "w:fldChar": w,
    "w:instrText": D,
    "w:t": function(H) {
      return elementResult(new documents$6.Text(H.text()));
    },
    "w:tab": function(H) {
      return elementResult(new documents$6.Tab());
    },
    "w:noBreakHyphen": function() {
      return elementResult(new documents$6.Text("‑"));
    },
    "w:softHyphen": function(H) {
      return elementResult(new documents$6.Text("­"));
    },
    "w:sym": k,
    "w:hyperlink": function(H) {
      var ne = H.attributes["r:id"], he = H.attributes["w:anchor"];
      return f(H.children).map(function(j) {
        function Fe(ye) {
          var Ae = H.attributes["w:tgtFrame"] || null;
          return new documents$6.Hyperlink(
            j,
            _$9.extend({ targetFrame: Ae }, ye)
          );
        }
        if (ne) {
          var X = s.findTargetByRelationshipId(ne);
          return he && (X = uris.replaceFragment(X, he)), Fe({ href: X });
        } else
          return he ? Fe({ anchor: he }) : j;
      });
    },
    "w:tbl": Q,
    "w:tr": ie,
    "w:tc": te,
    "w:footnoteReference": W("footnote"),
    "w:endnoteReference": W("endnote"),
    "w:commentReference": L,
    "w:br": function(H) {
      var ne = H.attributes["w:type"];
      return ne == null || ne === "textWrapping" ? elementResult(documents$6.lineBreak) : ne === "page" ? elementResult(documents$6.pageBreak) : ne === "column" ? elementResult(documents$6.columnBreak) : emptyResultWithMessages([warning("Unsupported break type: " + ne)]);
    },
    "w:bookmarkStart": function(H) {
      var ne = H.attributes["w:name"];
      return ne === "_GoBack" ? emptyResult() : elementResult(new documents$6.BookmarkStart({ name: ne }));
    },
    "mc:AlternateContent": function(H) {
      return z(H.first("mc:Fallback"));
    },
    "w:sdt": function(H) {
      return f(H.firstOrEmpty("w:sdtContent").children);
    },
    "w:ins": z,
    "w:object": z,
    "w:smartTag": z,
    "w:drawing": z,
    "w:pict": function(H) {
      return z(H).toExtra();
    },
    "v:roundrect": z,
    "v:shape": z,
    "v:textbox": z,
    "w:txbxContent": z,
    "wp:inline": G,
    "wp:anchor": G,
    "v:imagedata": I,
    "v:group": z,
    "v:rect": z
  };
  return {
    readXmlElement: h,
    readXmlElements: f
  };
  function Q(H) {
    var ne = Y(H.firstOrEmpty("w:tblPr"));
    return f(H.children).flatMap(ae).flatMap(function(he) {
      return ne.map(function(j) {
        return documents$6.Table(he, j);
      });
    });
  }
  function Y(H) {
    return b(H).map(function(ne) {
      return {
        styleId: ne.styleId,
        styleName: ne.name
      };
    });
  }
  function ie(H) {
    var ne = H.firstOrEmpty("w:trPr"), he = !!ne.first("w:tblHeader");
    return f(H.children).map(function(j) {
      return documents$6.TableRow(j, { isHeader: he });
    });
  }
  function te(H) {
    return f(H.children).map(function(ne) {
      var he = H.firstOrEmpty("w:tcPr"), j = he.firstOrEmpty("w:gridSpan").attributes["w:val"], Fe = j ? parseInt(j, 10) : 1, X = documents$6.TableCell(ne, { colSpan: Fe });
      return X._vMerge = Z(he), X;
    });
  }
  function Z(H) {
    var ne = H.first("w:vMerge");
    if (ne) {
      var he = ne.attributes["w:val"];
      return he === "continue" || !he;
    } else
      return null;
  }
  function ae(H) {
    var ne = _$9.any(H, function(Fe) {
      return Fe.type !== documents$6.types.tableRow;
    });
    if (ne)
      return elementResultWithMessages(H, [warning(
        "unexpected non-row element in table, cell merging may be incorrect"
      )]);
    var he = _$9.any(H, function(Fe) {
      return _$9.any(Fe.children, function(X) {
        return X.type !== documents$6.types.tableCell;
      });
    });
    if (he)
      return elementResultWithMessages(H, [warning(
        "unexpected non-cell element in table row, cell merging may be incorrect"
      )]);
    var j = {};
    return H.forEach(function(Fe) {
      var X = 0;
      Fe.children.forEach(function(ye) {
        ye._vMerge && j[X] ? j[X].rowSpan++ : (j[X] = ye, ye._vMerge = !1), X += ye.colSpan;
      });
    }), H.forEach(function(Fe) {
      Fe.children = Fe.children.filter(function(X) {
        return !X._vMerge;
      }), Fe.children.forEach(function(X) {
        delete X._vMerge;
      });
    }), elementResult(H);
  }
  function G(H) {
    var ne = H.getElementsByTagName("a:graphic").getElementsByTagName("a:graphicData").getElementsByTagName("pic:pic").getElementsByTagName("pic:blipFill").getElementsByTagName("a:blip");
    return combineResults(ne.map(U.bind(null, H)));
  }
  function U(H, ne) {
    var he = H.first("wp:docPr").attributes, j = F(he.descr) ? he.title : he.descr, Fe = M(ne);
    return Fe === null ? emptyResultWithMessages([warning("Could not find image file for a:blip element")]) : V(Fe, j);
  }
  function F(H) {
    return H == null || /^\s*$/.test(H);
  }
  function M(H) {
    var ne = H.attributes["r:embed"], he = H.attributes["r:link"];
    if (ne)
      return N(ne);
    if (he) {
      var j = s.findTargetByRelationshipId(he);
      return {
        path: j,
        read: c.read.bind(c, j)
      };
    } else
      return null;
  }
  function I(H) {
    var ne = H.attributes["r:id"];
    return ne ? V(
      N(ne),
      H.attributes["o:title"]
    ) : emptyResultWithMessages([warning("A v:imagedata element without a relationship ID was ignored")]);
  }
  function N(H) {
    var ne = uris.uriToZipEntryName("word", s.findTargetByRelationshipId(H));
    return {
      path: ne,
      read: l.read.bind(l, ne)
    };
  }
  function V(H, ne) {
    var he = o.findContentType(H.path), j = documents$6.Image({
      readImage: H.read,
      altText: ne,
      contentType: he
    }), Fe = supportedImageTypes[he] ? [] : warning("Image of type " + he + " is unlikely to display in web browsers");
    return elementResultWithMessages(j, Fe);
  }
  function q(H, ne) {
    return warning(
      H + " style with ID " + ne + " was referenced but not defined in the document"
    );
  }
}
function readNumberingProperties(t, e, n) {
  if (t != null) {
    var a = n.findLevelByParagraphStyleId(t);
    if (a != null)
      return a;
  }
  var s = e.firstOrEmpty("w:ilvl").attributes["w:val"], o = e.firstOrEmpty("w:numId").attributes["w:val"];
  return s === void 0 || o === void 0 ? null : n.findLevel(o, s);
}
var supportedImageTypes = {
  "image/png": !0,
  "image/gif": !0,
  "image/jpeg": !0,
  "image/svg+xml": !0,
  "image/tiff": !0
}, ignoreElements = {
  "office-word:wrap": !0,
  "v:shadow": !0,
  "v:shapetype": !0,
  "w:annotationRef": !0,
  "w:bookmarkEnd": !0,
  "w:sectPr": !0,
  "w:proofErr": !0,
  "w:lastRenderedPageBreak": !0,
  "w:commentRangeStart": !0,
  "w:commentRangeEnd": !0,
  "w:del": !0,
  "w:footnoteRef": !0,
  "w:endnoteRef": !0,
  "w:pPr": !0,
  "w:rPr": !0,
  "w:tblPr": !0,
  "w:tblGrid": !0,
  "w:trPr": !0,
  "w:tcPr": !0
};
function emptyResultWithMessages(t) {
  return new ReadResult(null, null, t);
}
function emptyResult() {
  return new ReadResult(null);
}
function elementResult(t) {
  return new ReadResult(t);
}
function elementResultWithMessages(t, e) {
  return new ReadResult(t, null, e);
}
function ReadResult(t, e, n) {
  this.value = t || [], this.extra = e || [], this._result = new Result$6({
    element: this.value,
    extra: e
  }, n), this.messages = this._result.messages;
}
ReadResult.prototype.toExtra = function() {
  return new ReadResult(null, joinElements(this.extra, this.value), this.messages);
};
ReadResult.prototype.insertExtra = function() {
  var t = this.extra;
  return t && t.length ? new ReadResult(joinElements(this.value, t), null, this.messages) : this;
};
ReadResult.prototype.map = function(t) {
  var e = this._result.map(function(n) {
    return t(n.element);
  });
  return new ReadResult(e.value, this.extra, e.messages);
};
ReadResult.prototype.flatMap = function(t) {
  var e = this._result.flatMap(function(n) {
    return t(n.element)._result;
  });
  return new ReadResult(e.value.element, joinElements(this.extra, e.value.extra), e.messages);
};
ReadResult.map = function(t, e, n) {
  return new ReadResult(
    n(t.value, e.value),
    joinElements(t.extra, e.extra),
    t.messages.concat(e.messages)
  );
};
function combineResults(t) {
  var e = Result$6.combine(_$9.pluck(t, "_result"));
  return new ReadResult(
    _$9.flatten(_$9.pluck(e.value, "element")),
    _$9.filter(_$9.flatten(_$9.pluck(e.value, "extra")), identity$1),
    e.messages
  );
}
function joinElements(t, e) {
  return _$9.flatten([t, e]);
}
function identity$1(t) {
  return t;
}
var documentXmlReader = {};
documentXmlReader.DocumentXmlReader = DocumentXmlReader$1;
var documents$5 = documents$7, Result$5 = results$2.Result;
function DocumentXmlReader$1(t) {
  var e = t.bodyReader;
  function n(a) {
    var s = a.first("w:body"), o = e.readXmlElements(s.children).map(function(l) {
      return new documents$5.Document(l, {
        notes: t.notes,
        comments: t.comments
      });
    });
    return new Result$5(o.value, o.messages);
  }
  return {
    convertXmlToDocument: n
  };
}
var relationshipsReader$1 = {};
relationshipsReader$1.readRelationships = readRelationships;
relationshipsReader$1.defaultValue = new Relationships([]);
relationshipsReader$1.Relationships = Relationships;
function readRelationships(t) {
  var e = [];
  return t.children.forEach(function(n) {
    if (n.name === "{http://schemas.openxmlformats.org/package/2006/relationships}Relationship") {
      var a = {
        relationshipId: n.attributes.Id,
        target: n.attributes.Target,
        type: n.attributes.Type
      };
      e.push(a);
    }
  }), new Relationships(e);
}
function Relationships(t) {
  var e = {};
  t.forEach(function(a) {
    e[a.relationshipId] = a.target;
  });
  var n = {};
  return t.forEach(function(a) {
    n[a.type] || (n[a.type] = []), n[a.type].push(a.target);
  }), {
    findTargetByRelationshipId: function(a) {
      return e[a];
    },
    findTargetsByType: function(a) {
      return n[a] || [];
    }
  };
}
var contentTypesReader$1 = {};
contentTypesReader$1.readContentTypesFromXml = readContentTypesFromXml;
var fallbackContentTypes = {
  png: "png",
  gif: "gif",
  jpeg: "jpeg",
  jpg: "jpeg",
  tif: "tiff",
  tiff: "tiff",
  bmp: "bmp"
};
contentTypesReader$1.defaultContentTypes = contentTypes({}, {});
function readContentTypesFromXml(t) {
  var e = {}, n = {};
  return t.children.forEach(function(a) {
    if (a.name === "content-types:Default" && (e[a.attributes.Extension] = a.attributes.ContentType), a.name === "content-types:Override") {
      var s = a.attributes.PartName;
      s.charAt(0) === "/" && (s = s.substring(1)), n[s] = a.attributes.ContentType;
    }
  }), contentTypes(n, e);
}
function contentTypes(t, e) {
  return {
    findContentType: function(n) {
      var a = t[n];
      if (a)
        return a;
      var s = n.split("."), o = s[s.length - 1];
      if (e.hasOwnProperty(o))
        return e[o];
      var l = fallbackContentTypes[o.toLowerCase()];
      return l ? "image/" + l : null;
    }
  };
}
var numberingXml$1 = {}, _$8 = require$$0;
numberingXml$1.readNumberingXml = readNumberingXml;
numberingXml$1.Numbering = Numbering;
numberingXml$1.defaultNumbering = new Numbering({}, {});
function Numbering(t, e, n) {
  var a = _$8.flatten(_$8.values(e).map(function(c) {
    return _$8.values(c.levels);
  })), s = _$8.indexBy(
    a.filter(function(c) {
      return c.paragraphStyleId != null;
    }),
    "paragraphStyleId"
  );
  function o(c, u) {
    var d = t[c];
    if (d) {
      var f = e[d.abstractNumId];
      if (f) {
        if (f.numStyleLink == null)
          return e[d.abstractNumId].levels[u];
        var h = n.findNumberingStyleById(f.numStyleLink);
        return o(h.numId, u);
      } else
        return null;
    } else
      return null;
  }
  function l(c) {
    return s[c] || null;
  }
  return {
    findLevel: o,
    findLevelByParagraphStyleId: l
  };
}
function readNumberingXml(t, e) {
  if (!e || !e.styles)
    throw new Error("styles is missing");
  var n = readAbstractNums(t), a = readNums(t);
  return new Numbering(a, n, e.styles);
}
function readAbstractNums(t) {
  var e = {};
  return t.getElementsByTagName("w:abstractNum").forEach(function(n) {
    var a = n.attributes["w:abstractNumId"];
    e[a] = readAbstractNum(n);
  }), e;
}
function readAbstractNum(t) {
  var e = {};
  t.getElementsByTagName("w:lvl").forEach(function(a) {
    var s = a.attributes["w:ilvl"], o = a.first("w:numFmt").attributes["w:val"], l = a.firstOrEmpty("w:pStyle").attributes["w:val"];
    e[s] = {
      isOrdered: o !== "bullet",
      level: s,
      paragraphStyleId: l
    };
  });
  var n = t.firstOrEmpty("w:numStyleLink").attributes["w:val"];
  return { levels: e, numStyleLink: n };
}
function readNums(t) {
  var e = {};
  return t.getElementsByTagName("w:num").forEach(function(n) {
    var a = n.attributes["w:numId"], s = n.first("w:abstractNumId").attributes["w:val"];
    e[a] = { abstractNumId: s };
  }), e;
}
var stylesReader$1 = {};
stylesReader$1.readStylesXml = readStylesXml;
stylesReader$1.Styles = Styles;
stylesReader$1.defaultStyles = new Styles({}, {});
function Styles(t, e, n, a) {
  return {
    findParagraphStyleById: function(s) {
      return t[s];
    },
    findCharacterStyleById: function(s) {
      return e[s];
    },
    findTableStyleById: function(s) {
      return n[s];
    },
    findNumberingStyleById: function(s) {
      return a[s];
    }
  };
}
Styles.EMPTY = new Styles({}, {}, {}, {});
function readStylesXml(t) {
  var e = {}, n = {}, a = {}, s = {}, o = {
    paragraph: e,
    character: n,
    table: a
  };
  return t.getElementsByTagName("w:style").forEach(function(l) {
    var c = readStyleElement(l);
    if (c.type === "numbering")
      s[c.styleId] = readNumberingStyleElement(l);
    else {
      var u = o[c.type];
      u && (u[c.styleId] = c);
    }
  }), new Styles(e, n, a, s);
}
function readStyleElement(t) {
  var e = t.attributes["w:type"], n = t.attributes["w:styleId"], a = styleName(t);
  return { type: e, styleId: n, name: a };
}
function styleName(t) {
  var e = t.first("w:name");
  return e ? e.attributes["w:val"] : null;
}
function readNumberingStyleElement(t) {
  var e = t.firstOrEmpty("w:pPr").firstOrEmpty("w:numPr").firstOrEmpty("w:numId").attributes["w:val"];
  return { numId: e };
}
var notesReader$1 = {}, documents$4 = documents$7, Result$4 = results$2.Result;
notesReader$1.createFootnotesReader = createReader.bind(commonjsGlobal, "footnote");
notesReader$1.createEndnotesReader = createReader.bind(commonjsGlobal, "endnote");
function createReader(t, e) {
  function n(o) {
    return Result$4.combine(o.getElementsByTagName("w:" + t).filter(a).map(s));
  }
  function a(o) {
    var l = o.attributes["w:type"];
    return l !== "continuationSeparator" && l !== "separator";
  }
  function s(o) {
    var l = o.attributes["w:id"];
    return e.readXmlElements(o.children).map(function(c) {
      return documents$4.Note({ noteType: t, noteId: l, body: c });
    });
  }
  return n;
}
var commentsReader$1 = {}, documents$3 = documents$7, Result$3 = results$2.Result;
function createCommentsReader(t) {
  function e(a) {
    return Result$3.combine(a.getElementsByTagName("w:comment").map(n));
  }
  function n(a) {
    var s = a.attributes["w:id"];
    function o(l) {
      return (a.attributes[l] || "").trim() || null;
    }
    return t.readXmlElements(a.children).map(function(l) {
      return documents$3.comment({
        commentId: s,
        body: l,
        authorName: o("w:author"),
        authorInitials: o("w:initials")
      });
    });
  }
  return e;
}
commentsReader$1.createCommentsReader = createCommentsReader;
var files = {}, promises$4 = promises$7;
files.Files = Files$1;
function Files$1() {
  function t(e) {
    return promises$4.reject(new Error("could not open external image: '" + e + `'
cannot open linked files from a web browser`));
  }
  return {
    read: t
  };
}
docxReader$1.read = read;
docxReader$1._findPartPaths = findPartPaths;
var path = require$$0$1, promises$3 = promises$7, documents$2 = documents$7, Result$2 = results$2.Result, zipfile$1 = zipfile$2, readXmlFromZipFile = officeXmlReader.readXmlFromZipFile, createBodyReader = bodyReader.createBodyReader, DocumentXmlReader = documentXmlReader.DocumentXmlReader, relationshipsReader = relationshipsReader$1, contentTypesReader = contentTypesReader$1, numberingXml = numberingXml$1, stylesReader = stylesReader$1, notesReader = notesReader$1, commentsReader = commentsReader$1, Files = files.Files;
function read(t, e) {
  return e = e || {}, promises$3.props({
    contentTypes: readContentTypesFromZipFile(t),
    partPaths: findPartPaths(t),
    docxFile: t,
    files: new Files(e.path ? path.dirname(e.path) : null)
  }).also(function(n) {
    return {
      styles: readStylesFromZipFile(t, n.partPaths.styles)
    };
  }).also(function(n) {
    return {
      numbering: readNumberingFromZipFile(t, n.partPaths.numbering, n.styles)
    };
  }).also(function(n) {
    return {
      footnotes: readXmlFileWithBody(n.partPaths.footnotes, n, function(a, s) {
        return s ? notesReader.createFootnotesReader(a)(s) : new Result$2([]);
      }),
      endnotes: readXmlFileWithBody(n.partPaths.endnotes, n, function(a, s) {
        return s ? notesReader.createEndnotesReader(a)(s) : new Result$2([]);
      }),
      comments: readXmlFileWithBody(n.partPaths.comments, n, function(a, s) {
        return s ? commentsReader.createCommentsReader(a)(s) : new Result$2([]);
      })
    };
  }).also(function(n) {
    return {
      notes: n.footnotes.flatMap(function(a) {
        return n.endnotes.map(function(s) {
          return new documents$2.Notes(a.concat(s));
        });
      })
    };
  }).then(function(n) {
    return readXmlFileWithBody(n.partPaths.mainDocument, n, function(a, s) {
      return n.notes.flatMap(function(o) {
        return n.comments.flatMap(function(l) {
          var c = new DocumentXmlReader({
            bodyReader: a,
            notes: o,
            comments: l
          });
          return c.convertXmlToDocument(s);
        });
      });
    });
  });
}
function findPartPaths(t) {
  return readPackageRelationships(t).then(function(e) {
    var n = findPartPath({
      docxFile: t,
      relationships: e,
      relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
      basePath: "",
      fallbackPath: "word/document.xml"
    });
    if (!t.exists(n))
      throw new Error("Could not find main document part. Are you sure this is a valid .docx file?");
    return xmlFileReader({
      filename: relationshipsFilename(n),
      readElement: relationshipsReader.readRelationships,
      defaultValue: relationshipsReader.defaultValue
    })(t).then(function(a) {
      function s(o) {
        return findPartPath({
          docxFile: t,
          relationships: a,
          relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/" + o,
          basePath: zipfile$1.splitPath(n).dirname,
          fallbackPath: "word/" + o + ".xml"
        });
      }
      return {
        mainDocument: n,
        comments: s("comments"),
        endnotes: s("endnotes"),
        footnotes: s("footnotes"),
        numbering: s("numbering"),
        styles: s("styles")
      };
    });
  });
}
function findPartPath(t) {
  var e = t.docxFile, n = t.relationships, a = t.relationshipType, s = t.basePath, o = t.fallbackPath, l = n.findTargetsByType(a), c = l.map(function(d) {
    return stripPrefix(zipfile$1.joinPath(s, d), "/");
  }), u = c.filter(function(d) {
    return e.exists(d);
  });
  return u.length === 0 ? o : u[0];
}
function stripPrefix(t, e) {
  return t.substring(0, e.length) === e ? t.substring(e.length) : t;
}
function xmlFileReader(t) {
  return function(e) {
    return readXmlFromZipFile(e, t.filename).then(function(n) {
      return n ? t.readElement(n) : t.defaultValue;
    });
  };
}
function readXmlFileWithBody(t, e, n) {
  var a = xmlFileReader({
    filename: relationshipsFilename(t),
    readElement: relationshipsReader.readRelationships,
    defaultValue: relationshipsReader.defaultValue
  });
  return a(e.docxFile).then(function(s) {
    var o = new createBodyReader({
      relationships: s,
      contentTypes: e.contentTypes,
      docxFile: e.docxFile,
      numbering: e.numbering,
      styles: e.styles,
      files: e.files
    });
    return readXmlFromZipFile(e.docxFile, t).then(function(l) {
      return n(o, l);
    });
  });
}
function relationshipsFilename(t) {
  var e = zipfile$1.splitPath(t);
  return zipfile$1.joinPath(e.dirname, "_rels", e.basename + ".rels");
}
var readContentTypesFromZipFile = xmlFileReader({
  filename: "[Content_Types].xml",
  readElement: contentTypesReader.readContentTypesFromXml,
  defaultValue: contentTypesReader.defaultContentTypes
});
function readNumberingFromZipFile(t, e, n) {
  return xmlFileReader({
    filename: e,
    readElement: function(a) {
      return numberingXml.readNumberingXml(a, { styles: n });
    },
    defaultValue: numberingXml.defaultNumbering
  })(t);
}
function readStylesFromZipFile(t, e) {
  return xmlFileReader({
    filename: e,
    readElement: stylesReader.readStylesXml,
    defaultValue: stylesReader.defaultStyles
  })(t);
}
var readPackageRelationships = xmlFileReader({
  filename: "_rels/.rels",
  readElement: relationshipsReader.readRelationships,
  defaultValue: relationshipsReader.defaultValue
}), styleMap = {}, _$7 = require$$0, promises$2 = promises$7, xml = xml$2;
styleMap.writeStyleMap = writeStyleMap;
styleMap.readStyleMap = readStyleMap$1;
var schema = "http://schemas.zwobble.org/mammoth/style-map", styleMapPath = "mammoth/style-map", styleMapAbsolutePath = "/" + styleMapPath;
function writeStyleMap(t, e) {
  return t.write(styleMapPath, e), updateRelationships(t).then(function() {
    return updateContentTypes(t);
  });
}
function updateRelationships(t) {
  var e = "word/_rels/document.xml.rels", n = "http://schemas.openxmlformats.org/package/2006/relationships", a = "{" + n + "}Relationship";
  return t.read(e, "utf8").then(xml.readString).then(function(s) {
    var o = s.children;
    addOrUpdateElement(o, a, "Id", {
      Id: "rMammothStyleMap",
      Type: schema,
      Target: styleMapAbsolutePath
    });
    var l = { "": n };
    return t.write(e, xml.writeString(s, l));
  });
}
function updateContentTypes(t) {
  var e = "[Content_Types].xml", n = "http://schemas.openxmlformats.org/package/2006/content-types", a = "{" + n + "}Override";
  return t.read(e, "utf8").then(xml.readString).then(function(s) {
    var o = s.children;
    addOrUpdateElement(o, a, "PartName", {
      PartName: styleMapAbsolutePath,
      ContentType: "text/prs.mammoth.style-map"
    });
    var l = { "": n };
    return t.write(e, xml.writeString(s, l));
  });
}
function addOrUpdateElement(t, e, n, a) {
  var s = _$7.find(t, function(o) {
    return o.name === e && o.attributes[n] === a[n];
  });
  s ? s.attributes = a : t.push(xml.element(e, a));
}
function readStyleMap$1(t) {
  return t.exists(styleMapPath) ? t.read(styleMapPath, "utf8") : promises$2.resolve(null);
}
var documentToHtml = {}, htmlPaths$3 = {}, html = {}, ast = {}, hasRequiredAst;
function requireAst() {
  if (hasRequiredAst)
    return ast;
  hasRequiredAst = 1;
  var t = requireHtmlPaths();
  function e(u, d, f) {
    return a(
      t.element(u, d, { fresh: !1 }),
      f
    );
  }
  function n(u, d, f) {
    var h = t.element(u, d, { fresh: !0 });
    return a(h, f);
  }
  function a(u, d) {
    return {
      type: "element",
      tag: u,
      children: d || []
    };
  }
  function s(u) {
    return {
      type: "text",
      value: u
    };
  }
  var o = {
    type: "forceWrite"
  };
  ast.freshElement = n, ast.nonFreshElement = e, ast.elementWithTag = a, ast.text = s, ast.forceWrite = o;
  var l = {
    br: !0,
    hr: !0,
    img: !0
  };
  function c(u) {
    return u.children.length === 0 && l[u.tag.tagName];
  }
  return ast.isVoidElement = c, ast;
}
var simplify_1, hasRequiredSimplify;
function requireSimplify() {
  if (hasRequiredSimplify)
    return simplify_1;
  hasRequiredSimplify = 1;
  var t = require$$0, e = requireAst();
  function n(m) {
    return a(d(m));
  }
  function a(m) {
    var v = [];
    return m.map(s).forEach(function(y) {
      u(v, y);
    }), v;
  }
  function s(m) {
    return o[m.type](m);
  }
  var o = {
    element: l,
    text: c,
    forceWrite: c
  };
  function l(m) {
    return e.elementWithTag(m.tag, a(m.children));
  }
  function c(m) {
    return m;
  }
  function u(m, v) {
    var y = m[m.length - 1];
    v.type === "element" && !v.tag.fresh && y && y.type === "element" && v.tag.matchesElement(y.tag) ? (v.tag.separator && u(y.children, e.text(v.tag.separator)), v.children.forEach(function(A) {
      u(y.children, A);
    })) : m.push(v);
  }
  function d(m) {
    return f(m, function(v) {
      return h[v.type](v);
    });
  }
  function f(m, v) {
    return t.flatten(t.map(m, v), !0);
  }
  var h = {
    element: x,
    text: E,
    forceWrite: g
  };
  function g(m) {
    return [m];
  }
  function x(m) {
    var v = d(m.children);
    return v.length === 0 && !e.isVoidElement(m) ? [] : [e.elementWithTag(m.tag, v)];
  }
  function E(m) {
    return m.value.length === 0 ? [] : [m];
  }
  return simplify_1 = n, simplify_1;
}
var hasRequiredHtml;
function requireHtml() {
  if (hasRequiredHtml)
    return html;
  hasRequiredHtml = 1;
  var t = requireAst();
  html.freshElement = t.freshElement, html.nonFreshElement = t.nonFreshElement, html.elementWithTag = t.elementWithTag, html.text = t.text, html.forceWrite = t.forceWrite, html.simplify = requireSimplify();
  function e(l, c) {
    c.forEach(function(u) {
      n(l, u);
    });
  }
  function n(l, c) {
    a[c.type](l, c);
  }
  var a = {
    element: s,
    text: o,
    forceWrite: function() {
    }
  };
  function s(l, c) {
    t.isVoidElement(c) ? l.selfClosing(c.tag.tagName, c.tag.attributes) : (l.open(c.tag.tagName, c.tag.attributes), e(l, c.children), l.close(c.tag.tagName));
  }
  function o(l, c) {
    l.text(c.value);
  }
  return html.write = e, html;
}
var hasRequiredHtmlPaths;
function requireHtmlPaths() {
  if (hasRequiredHtmlPaths)
    return htmlPaths$3;
  hasRequiredHtmlPaths = 1;
  var t = require$$0, e = requireHtml();
  htmlPaths$3.topLevelElement = n, htmlPaths$3.elements = a, htmlPaths$3.element = o;
  function n(c, u) {
    return a([o(c, u, { fresh: !0 })]);
  }
  function a(c) {
    return new s(c.map(function(u) {
      return t.isString(u) ? o(u) : u;
    }));
  }
  function s(c) {
    this._elements = c;
  }
  s.prototype.wrap = function(u) {
    for (var d = u(), f = this._elements.length - 1; f >= 0; f--)
      d = this._elements[f].wrapNodes(d);
    return d;
  };
  function o(c, u, d) {
    return d = d || {}, new l(c, u, d);
  }
  function l(c, u, d) {
    var f = {};
    t.isArray(c) ? (c.forEach(function(h) {
      f[h] = !0;
    }), c = c[0]) : f[c] = !0, this.tagName = c, this.tagNames = f, this.attributes = u || {}, this.fresh = d.fresh, this.separator = d.separator;
  }
  return l.prototype.matchesElement = function(c) {
    return this.tagNames[c.tagName] && t.isEqual(this.attributes || {}, c.attributes || {});
  }, l.prototype.wrap = function(u) {
    return this.wrapNodes(u());
  }, l.prototype.wrapNodes = function(u) {
    return [e.elementWithTag(this, u)];
  }, htmlPaths$3.empty = a([]), htmlPaths$3.ignore = {
    wrap: function() {
      return [];
    }
  }, htmlPaths$3;
}
var images$1 = {};
(function(t) {
  var e = require$$0, n = promises$7, a = requireHtml();
  t.imgElement = s;
  function s(o) {
    return function(l, c) {
      return n.when(o(l)).then(function(u) {
        var d = {};
        return l.altText && (d.alt = l.altText), e.extend(d, u), [a.freshElement("img", d)];
      });
    };
  }
  t.inline = t.imgElement, t.dataUri = s(function(o) {
    return o.readAsBase64String().then(function(l) {
      return {
        src: "data:" + o.contentType + ";base64," + l
      };
    });
  });
})(images$1);
var writers$1 = {}, htmlWriter$1 = {}, _$6 = require$$0;
htmlWriter$1.writer = writer$1;
function writer$1(t) {
  return t = t || {}, t.prettyPrint ? prettyWriter() : simpleWriter();
}
var indentedElements = {
  div: !0,
  p: !0,
  ul: !0,
  li: !0
};
function prettyWriter() {
  var t = 0, e = "  ", n = [], a = !0, s = !1, o = simpleWriter();
  function l(E, m) {
    indentedElements[E] && g(), n.push(E), o.open(E, m), indentedElements[E] && t++, a = !1;
  }
  function c(E) {
    indentedElements[E] && (t--, g()), n.pop(), o.close(E);
  }
  function u(E) {
    h();
    var m = x() ? E : E.replace(`
`, `
` + e);
    o.text(m);
  }
  function d(E, m) {
    g(), o.selfClosing(E, m);
  }
  function f() {
    return n.length === 0 || indentedElements[n[n.length - 1]];
  }
  function h() {
    s || (g(), s = !0);
  }
  function g() {
    if (s = !1, !a && f() && !x()) {
      o._append(`
`);
      for (var E = 0; E < t; E++)
        o._append(e);
    }
  }
  function x() {
    return _$6.some(n, function(E) {
      return E === "pre";
    });
  }
  return {
    asString: o.asString,
    open: l,
    close: c,
    text: u,
    selfClosing: d
  };
}
function simpleWriter() {
  var t = [];
  function e(u, d) {
    var f = s(d);
    t.push("<" + u + f + ">");
  }
  function n(u) {
    t.push("</" + u + ">");
  }
  function a(u, d) {
    var f = s(d);
    t.push("<" + u + f + " />");
  }
  function s(u) {
    return _$6.map(u, function(d, f) {
      return " " + f + '="' + escapeHtmlAttribute(d) + '"';
    }).join("");
  }
  function o(u) {
    t.push(escapeHtmlText(u));
  }
  function l(u) {
    t.push(u);
  }
  function c() {
    return t.join("");
  }
  return {
    asString: c,
    open: e,
    close: n,
    text: o,
    selfClosing: a,
    _append: l
  };
}
function escapeHtmlText(t) {
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function escapeHtmlAttribute(t) {
  return t.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
var markdownWriter$2 = {}, _$5 = require$$0;
function symmetricMarkdownElement(t) {
  return markdownElement(t, t);
}
function markdownElement(t, e) {
  return function() {
    return { start: t, end: e };
  };
}
function markdownLink(t) {
  var e = t.href || "";
  return e ? {
    start: "[",
    end: "](" + e + ")",
    anchorPosition: "before"
  } : {};
}
function markdownImage(t) {
  var e = t.src || "", n = t.alt || "";
  return e || n ? { start: "![" + n + "](" + e + ")" } : {};
}
function markdownList(t) {
  return function(e, n) {
    return {
      start: n ? `
` : "",
      end: n ? "" : `
`,
      list: {
        isOrdered: t.isOrdered,
        indent: n ? n.indent + 1 : 0,
        count: 0
      }
    };
  };
}
function markdownListItem(t, e, n) {
  e = e || { indent: 0, isOrdered: !1, count: 0 }, e.count++, n.hasClosed = !1;
  var a = e.isOrdered ? e.count + "." : "-", s = repeatString("	", e.indent) + a + " ";
  return {
    start: s,
    end: function() {
      if (!n.hasClosed)
        return n.hasClosed = !0, `
`;
    }
  };
}
var htmlToMarkdown = {
  p: markdownElement("", `

`),
  br: markdownElement("", `  
`),
  ul: markdownList({ isOrdered: !1 }),
  ol: markdownList({ isOrdered: !0 }),
  li: markdownListItem,
  strong: symmetricMarkdownElement("__"),
  em: symmetricMarkdownElement("*"),
  a: markdownLink,
  img: markdownImage
};
(function() {
  for (var t = 1; t <= 6; t++)
    htmlToMarkdown["h" + t] = markdownElement(repeatString("#", t) + " ", `

`);
})();
function repeatString(t, e) {
  return new Array(e + 1).join(t);
}
function markdownWriter$1() {
  var t = [], e = [], n = null, a = {};
  function s(f, h) {
    h = h || {};
    var g = htmlToMarkdown[f] || function() {
      return {};
    }, x = g(h, n, a);
    e.push({ end: x.end, list: n }), x.list && (n = x.list);
    var E = x.anchorPosition === "before";
    E && o(h), t.push(x.start || ""), E || o(h);
  }
  function o(f) {
    f.id && t.push('<a id="' + f.id + '"></a>');
  }
  function l(f) {
    var h = e.pop();
    n = h.list;
    var g = _$5.isFunction(h.end) ? h.end() : h.end;
    t.push(g || "");
  }
  function c(f, h) {
    s(f, h), l();
  }
  function u(f) {
    t.push(escapeMarkdown(f));
  }
  function d() {
    return t.join("");
  }
  return {
    asString: d,
    open: s,
    close: l,
    text: u,
    selfClosing: c
  };
}
markdownWriter$2.writer = markdownWriter$1;
function escapeMarkdown(t) {
  return t.replace(/\\/g, "\\\\").replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, "\\$1");
}
var htmlWriter = htmlWriter$1, markdownWriter = markdownWriter$2;
writers$1.writer = writer;
function writer(t) {
  return t = t || {}, t.outputFormat === "markdown" ? markdownWriter.writer() : htmlWriter.writer(t);
}
var _$4 = require$$0, promises$1 = promises$7, documents$1 = documents$7, htmlPaths$2 = requireHtmlPaths(), results$1 = results$2, images = images$1, Html$1 = requireHtml(), writers = writers$1;
documentToHtml.DocumentConverter = DocumentConverter$1;
function DocumentConverter$1(t) {
  return {
    convertToHtml: function(e) {
      var n = _$4.indexBy(
        e.type === documents$1.types.document ? e.comments : [],
        "commentId"
      ), a = new DocumentConversion(t, n);
      return a.convertToHtml(e);
    }
  };
}
function DocumentConversion(t, e) {
  var n = 1, a = [], s = [];
  t = _$4.extend({ ignoreEmptyParagraphs: !0 }, t);
  var o = t.idPrefix === void 0 ? "" : t.idPrefix, l = t.ignoreEmptyParagraphs, c = htmlPaths$2.topLevelElement("p"), u = t.styleMap || [];
  function d(te) {
    var Z = [], ae = h(te, Z, {}), G = [];
    walkHtml(ae, function(F) {
      F.type === "deferred" && G.push(F);
    });
    var U = {};
    return promises$1.mapSeries(G, function(F) {
      return F.value().then(function(M) {
        U[F.id] = M;
      });
    }).then(function() {
      function F(I) {
        return flatMap(I, function(N) {
          return N.type === "deferred" ? U[N.id] : N.children ? [
            _$4.extend({}, N, {
              children: F(N.children)
            })
          ] : [N];
        });
      }
      var M = writers.writer({
        prettyPrint: t.prettyPrint,
        outputFormat: t.outputFormat
      });
      return Html$1.write(M, Html$1.simplify(F(ae))), new results$1.Result(M.asString(), Z);
    });
  }
  function f(te, Z, ae) {
    return flatMap(te, function(G) {
      return h(G, Z, ae);
    });
  }
  function h(te, Z, ae) {
    if (!ae)
      throw new Error("options not set");
    var G = ie[te.type];
    return G ? G(te, Z, ae) : [];
  }
  function g(te, Z, ae) {
    return x(te, Z).wrap(function() {
      var G = f(te.children, Z, ae);
      return l ? G : [Html$1.forceWrite].concat(G);
    });
  }
  function x(te, Z) {
    var ae = y(te);
    return ae ? ae.to : (te.styleId && Z.push(unrecognisedStyleWarning("paragraph", te)), c);
  }
  function E(te, Z, ae) {
    var G = function() {
      return f(te.children, Z, ae);
    }, U = [];
    te.isSmallCaps && U.push(m("smallCaps")), te.isAllCaps && U.push(m("allCaps")), te.isStrikethrough && U.push(m("strikethrough", "s")), te.isUnderline && U.push(m("underline")), te.verticalAlignment === documents$1.verticalAlignment.subscript && U.push(htmlPaths$2.element("sub", {}, { fresh: !1 })), te.verticalAlignment === documents$1.verticalAlignment.superscript && U.push(htmlPaths$2.element("sup", {}, { fresh: !1 })), te.isItalic && U.push(m("italic", "em")), te.isBold && U.push(m("bold", "strong"));
    var F = htmlPaths$2.empty, M = y(te);
    return M ? F = M.to : te.styleId && Z.push(unrecognisedStyleWarning("run", te)), U.push(F), U.forEach(function(I) {
      G = I.wrap.bind(I, G);
    }), G();
  }
  function m(te, Z) {
    var ae = v({ type: te });
    return ae || (Z ? htmlPaths$2.element(Z, {}, { fresh: !1 }) : htmlPaths$2.empty);
  }
  function v(te, Z) {
    var ae = y(te);
    return ae ? ae.to : Z;
  }
  function y(te) {
    for (var Z = 0; Z < u.length; Z++)
      if (u[Z].from.matches(te))
        return u[Z];
  }
  function A(te) {
    return function(Z, ae) {
      return promises$1.attempt(function() {
        return te(Z, ae);
      }).caught(function(G) {
        return ae.push(results$1.error(G)), [];
      });
    };
  }
  function b(te) {
    return T(te.noteType, te.noteId);
  }
  function C(te) {
    return w(te.noteType, te.noteId);
  }
  function T(te, Z) {
    return R(te + "-" + Z);
  }
  function w(te, Z) {
    return R(te + "-ref-" + Z);
  }
  function R(te) {
    return o + te;
  }
  var O = htmlPaths$2.elements([
    htmlPaths$2.element("table", {}, { fresh: !0 })
  ]);
  function D(te, Z, ae) {
    return v(te, O).wrap(function() {
      return k(te, Z, ae);
    });
  }
  function k(te, Z, ae) {
    var G = _$4.findIndex(te.children, function(I) {
      return !I.type === documents$1.types.tableRow || !I.isHeader;
    });
    G === -1 && (G = te.children.length);
    var U;
    if (G === 0)
      U = f(
        te.children,
        Z,
        _$4.extend({}, ae, { isTableHeader: !1 })
      );
    else {
      var F = f(
        te.children.slice(0, G),
        Z,
        _$4.extend({}, ae, { isTableHeader: !0 })
      ), M = f(
        te.children.slice(G),
        Z,
        _$4.extend({}, ae, { isTableHeader: !1 })
      );
      U = [
        Html$1.freshElement("thead", {}, F),
        Html$1.freshElement("tbody", {}, M)
      ];
    }
    return [Html$1.forceWrite].concat(U);
  }
  function W(te, Z, ae) {
    var G = f(te.children, Z, ae);
    return [
      Html$1.freshElement("tr", {}, [Html$1.forceWrite].concat(G))
    ];
  }
  function L(te, Z, ae) {
    var G = ae.isTableHeader ? "th" : "td", U = f(te.children, Z, ae), F = {};
    return te.colSpan !== 1 && (F.colspan = te.colSpan.toString()), te.rowSpan !== 1 && (F.rowspan = te.rowSpan.toString()), [
      Html$1.freshElement(G, F, [Html$1.forceWrite].concat(U))
    ];
  }
  function z(te, Z, ae) {
    return v(te, htmlPaths$2.ignore).wrap(function() {
      var G = e[te.commentId], U = s.length + 1, F = "[" + commentAuthorLabel(G) + U + "]";
      return s.push({ label: F, comment: G }), [
        Html$1.freshElement("a", {
          href: "#" + T("comment", te.commentId),
          id: w("comment", te.commentId)
        }, [Html$1.text(F)])
      ];
    });
  }
  function P(te, Z, ae) {
    var G = te.label, U = te.comment, F = f(U.body, Z, ae).concat([
      Html$1.nonFreshElement("p", {}, [
        Html$1.text(" "),
        Html$1.freshElement("a", { href: "#" + w("comment", U.commentId) }, [
          Html$1.text("↑")
        ])
      ])
    ]);
    return [
      Html$1.freshElement(
        "dt",
        { id: T("comment", U.commentId) },
        [Html$1.text("Comment " + G)]
      ),
      Html$1.freshElement("dd", {}, F)
    ];
  }
  function Q(te, Z, ae) {
    return Y(te).wrap(function() {
      return [];
    });
  }
  function Y(te) {
    var Z = y(te);
    return Z ? Z.to : te.breakType === "line" ? htmlPaths$2.topLevelElement("br") : htmlPaths$2.empty;
  }
  var ie = {
    document: function(te, Z, ae) {
      var G = f(te.children, Z, ae), U = a.map(function(M) {
        return te.notes.resolve(M);
      }), F = f(U, Z, ae);
      return G.concat([
        Html$1.freshElement("ol", {}, F),
        Html$1.freshElement("dl", {}, flatMap(s, function(M) {
          return P(M, Z, ae);
        }))
      ]);
    },
    paragraph: g,
    run: E,
    text: function(te, Z, ae) {
      return [Html$1.text(te.value)];
    },
    tab: function(te, Z, ae) {
      return [Html$1.text("	")];
    },
    hyperlink: function(te, Z, ae) {
      var G = te.anchor ? "#" + R(te.anchor) : te.href, U = { href: G };
      te.targetFrame != null && (U.target = te.targetFrame);
      var F = f(te.children, Z, ae);
      return [Html$1.nonFreshElement("a", U, F)];
    },
    bookmarkStart: function(te, Z, ae) {
      var G = Html$1.freshElement("a", {
        id: R(te.name)
      }, [Html$1.forceWrite]);
      return [G];
    },
    noteReference: function(te, Z, ae) {
      a.push(te);
      var G = Html$1.freshElement("a", {
        href: "#" + b(te),
        id: C(te)
      }, [Html$1.text("[" + n++ + "]")]);
      return [Html$1.freshElement("sup", {}, [G])];
    },
    note: function(te, Z, ae) {
      var G = f(te.body, Z, ae), U = Html$1.elementWithTag(htmlPaths$2.element("p", {}, { fresh: !1 }), [
        Html$1.text(" "),
        Html$1.freshElement("a", { href: "#" + C(te) }, [Html$1.text("↑")])
      ]), F = G.concat([U]);
      return Html$1.freshElement("li", { id: b(te) }, F);
    },
    commentReference: z,
    comment: P,
    image: deferredConversion(A(t.convertImage || images.dataUri)),
    table: D,
    tableRow: W,
    tableCell: L,
    break: Q
  };
  return {
    convertToHtml: d
  };
}
var deferredId = 1;
function deferredConversion(t) {
  return function(e, n, a) {
    return [
      {
        type: "deferred",
        id: deferredId++,
        value: function() {
          return t(e, n, a);
        }
      }
    ];
  };
}
function unrecognisedStyleWarning(t, e) {
  return results$1.warning(
    "Unrecognised " + t + " style: '" + e.styleName + "' (Style ID: " + e.styleId + ")"
  );
}
function flatMap(t, e) {
  return _$4.flatten(t.map(e), !0);
}
function walkHtml(t, e) {
  t.forEach(function(n) {
    e(n), n.children && walkHtml(n.children, e);
  });
}
var commentAuthorLabel = documentToHtml.commentAuthorLabel = function t(e) {
  return e.authorInitials || "";
}, rawText = {}, documents = documents$7;
function convertElementToRawText$1(t) {
  if (t.type === "text")
    return t.value;
  if (t.type === documents.types.tab)
    return "	";
  var e = t.type === "paragraph" ? `

` : "";
  return (t.children || []).map(convertElementToRawText$1).join("") + e;
}
rawText.convertElementToRawText = convertElementToRawText$1;
var styleReader = {}, lop$2 = {}, parser = {}, TokenIterator$2 = { exports: {} }, TokenIterator$1 = TokenIterator$2.exports = function(t, e) {
  this._tokens = t, this._startIndex = e || 0;
};
TokenIterator$1.prototype.head = function() {
  return this._tokens[this._startIndex];
};
TokenIterator$1.prototype.tail = function(t) {
  return new TokenIterator$1(this._tokens, this._startIndex + 1);
};
TokenIterator$1.prototype.toArray = function() {
  return this._tokens.slice(this._startIndex);
};
TokenIterator$1.prototype.end = function() {
  return this._tokens[this._tokens.length - 1];
};
TokenIterator$1.prototype.to = function(t) {
  var e = this.head().source, n = t.head() || t.end();
  return e.to(n.source);
};
var TokenIteratorExports = TokenIterator$2.exports, TokenIterator = TokenIteratorExports;
parser.Parser = function(t) {
  var e = function(n, a) {
    return n(new TokenIterator(a));
  };
  return {
    parseTokens: e
  };
};
var rules = {}, option = {};
(function(t) {
  t.none = /* @__PURE__ */ Object.create({
    value: function() {
      throw new Error("Called value on none");
    },
    isNone: function() {
      return !0;
    },
    isSome: function() {
      return !1;
    },
    map: function() {
      return t.none;
    },
    flatMap: function() {
      return t.none;
    },
    filter: function() {
      return t.none;
    },
    toArray: function() {
      return [];
    },
    orElse: e,
    valueOrElse: e
  });
  function e(a) {
    return typeof a == "function" ? a() : a;
  }
  t.some = function(a) {
    return new n(a);
  };
  var n = function(a) {
    this._value = a;
  };
  n.prototype.value = function() {
    return this._value;
  }, n.prototype.isNone = function() {
    return !1;
  }, n.prototype.isSome = function() {
    return !0;
  }, n.prototype.map = function(a) {
    return new n(a(this._value));
  }, n.prototype.flatMap = function(a) {
    return a(this._value);
  }, n.prototype.filter = function(a) {
    return a(this._value) ? this : t.none;
  }, n.prototype.toArray = function() {
    return [this._value];
  }, n.prototype.orElse = function(a) {
    return this;
  }, n.prototype.valueOrElse = function(a) {
    return this._value;
  }, t.isOption = function(a) {
    return a === t.none || a instanceof n;
  }, t.fromNullable = function(a) {
    return a == null ? t.none : new n(a);
  };
})(option);
var parsingResults = {
  failure: function(t, e) {
    if (t.length < 1)
      throw new Error("Failure must have errors");
    return new Result$1({
      status: "failure",
      remaining: e,
      errors: t
    });
  },
  error: function(t, e) {
    if (t.length < 1)
      throw new Error("Failure must have errors");
    return new Result$1({
      status: "error",
      remaining: e,
      errors: t
    });
  },
  success: function(t, e, n) {
    return new Result$1({
      status: "success",
      value: t,
      source: n,
      remaining: e,
      errors: []
    });
  },
  cut: function(t) {
    return new Result$1({
      status: "cut",
      remaining: t,
      errors: []
    });
  }
}, Result$1 = function(t) {
  this._value = t.value, this._status = t.status, this._hasValue = t.value !== void 0, this._remaining = t.remaining, this._source = t.source, this._errors = t.errors;
};
Result$1.prototype.map = function(t) {
  return this._hasValue ? new Result$1({
    value: t(this._value, this._source),
    status: this._status,
    remaining: this._remaining,
    source: this._source,
    errors: this._errors
  }) : this;
};
Result$1.prototype.changeRemaining = function(t) {
  return new Result$1({
    value: this._value,
    status: this._status,
    remaining: t,
    source: this._source,
    errors: this._errors
  });
};
Result$1.prototype.isSuccess = function() {
  return this._status === "success" || this._status === "cut";
};
Result$1.prototype.isFailure = function() {
  return this._status === "failure";
};
Result$1.prototype.isError = function() {
  return this._status === "error";
};
Result$1.prototype.isCut = function() {
  return this._status === "cut";
};
Result$1.prototype.value = function() {
  return this._value;
};
Result$1.prototype.remaining = function() {
  return this._remaining;
};
Result$1.prototype.source = function() {
  return this._source;
};
Result$1.prototype.errors = function() {
  return this._errors;
};
var errors = {};
errors.error = function(t) {
  return new Error$1(t);
};
var Error$1 = function(t) {
  this.expected = t.expected, this.actual = t.actual, this._location = t.location;
};
Error$1.prototype.describe = function() {
  var t = this._location ? this._location.describe() + `:
` : "";
  return t + "Expected " + this.expected + `
but got ` + this.actual;
};
Error$1.prototype.lineNumber = function() {
  return this._location.lineNumber();
};
Error$1.prototype.characterNumber = function() {
  return this._location.characterNumber();
};
var lazyIterators = {};
lazyIterators.fromArray = function(t) {
  var e = 0, n = function() {
    return e < t.length;
  };
  return new LazyIterator({
    hasNext: n,
    next: function() {
      if (n())
        return t[e++];
      throw new Error("No more elements");
    }
  });
};
var LazyIterator = function(t) {
  this._iterator = t;
};
LazyIterator.prototype.map = function(t) {
  var e = this._iterator;
  return new LazyIterator({
    hasNext: function() {
      return e.hasNext();
    },
    next: function() {
      return t(e.next());
    }
  });
};
LazyIterator.prototype.filter = function(t) {
  var e = this._iterator, n = !1, a = !1, s, o = function() {
    if (!n)
      for (n = !0, a = !1; e.hasNext() && !a; )
        s = e.next(), a = t(s);
  };
  return new LazyIterator({
    hasNext: function() {
      return o(), a;
    },
    next: function() {
      o();
      var l = s;
      return n = !1, l;
    }
  });
};
LazyIterator.prototype.first = function() {
  var t = this._iterator;
  return this._iterator.hasNext() ? t.next() : null;
};
LazyIterator.prototype.toArray = function() {
  for (var t = []; this._iterator.hasNext(); )
    t.push(this._iterator.next());
  return t;
};
(function(t) {
  var e = require$$0, n = option, a = parsingResults, s = errors, o = lazyIterators;
  t.token = function(g, x) {
    var E = x !== void 0;
    return function(m) {
      var v = m.head();
      if (v && v.name === g && (!E || v.value === x))
        return a.success(v.value, m.tail(), v.source);
      var y = f({ name: g, value: x });
      return h(m, y);
    };
  }, t.tokenOfType = function(g) {
    return t.token(g);
  }, t.firstOf = function(g, x) {
    return e.isArray(x) || (x = Array.prototype.slice.call(arguments, 1)), function(E) {
      return o.fromArray(x).map(function(m) {
        return m(E);
      }).filter(function(m) {
        return m.isSuccess() || m.isError();
      }).first() || h(E, g);
    };
  }, t.then = function(g, x) {
    return function(E) {
      var m = g(E);
      return m.map || console.log(m), m.map(x);
    };
  }, t.sequence = function() {
    var g = Array.prototype.slice.call(arguments, 0), x = function(m) {
      var v = e.foldl(g, function(A, b) {
        var C = A.result, T = A.hasCut;
        if (!C.isSuccess())
          return { result: C, hasCut: T };
        var w = b(C.remaining());
        if (w.isCut())
          return { result: C, hasCut: !0 };
        if (w.isSuccess()) {
          var R;
          b.isCaptured ? R = C.value().withValue(b, w.value()) : R = C.value();
          var O = w.remaining(), D = m.to(O);
          return {
            result: a.success(R, O, D),
            hasCut: T
          };
        } else
          return T ? { result: a.error(w.errors(), w.remaining()), hasCut: T } : { result: w, hasCut: T };
      }, { result: a.success(new l(), m), hasCut: !1 }).result, y = m.to(v.remaining());
      return v.map(function(A) {
        return A.withValue(t.sequence.source, y);
      });
    };
    x.head = function() {
      var m = e.find(g, E);
      return t.then(
        x,
        t.sequence.extract(m)
      );
    }, x.map = function(m) {
      return t.then(
        x,
        function(v) {
          return m.apply(this, v.toArray());
        }
      );
    };
    function E(m) {
      return m.isCaptured;
    }
    return x;
  };
  var l = function(g, x) {
    this._values = g || {}, this._valuesArray = x || [];
  };
  l.prototype.withValue = function(g, x) {
    if (g.captureName && g.captureName in this._values)
      throw new Error('Cannot add second value for capture "' + g.captureName + '"');
    var E = e.clone(this._values);
    E[g.captureName] = x;
    var m = this._valuesArray.concat([x]);
    return new l(E, m);
  }, l.prototype.get = function(g) {
    if (g.captureName in this._values)
      return this._values[g.captureName];
    throw new Error('No value for capture "' + g.captureName + '"');
  }, l.prototype.toArray = function() {
    return this._valuesArray;
  }, t.sequence.capture = function(g, x) {
    var E = function() {
      return g.apply(this, arguments);
    };
    return E.captureName = x, E.isCaptured = !0, E;
  }, t.sequence.extract = function(g) {
    return function(x) {
      return x.get(g);
    };
  }, t.sequence.applyValues = function(g) {
    var x = Array.prototype.slice.call(arguments, 1);
    return function(E) {
      var m = x.map(function(v) {
        return E.get(v);
      });
      return g.apply(this, m);
    };
  }, t.sequence.source = {
    captureName: "☃source☃"
  }, t.sequence.cut = function() {
    return function(g) {
      return a.cut(g);
    };
  }, t.optional = function(g) {
    return function(x) {
      var E = g(x);
      return E.isSuccess() ? E.map(n.some) : E.isFailure() ? a.success(n.none, x) : E;
    };
  }, t.zeroOrMoreWithSeparator = function(g, x) {
    return d(g, x, !1);
  }, t.oneOrMoreWithSeparator = function(g, x) {
    return d(g, x, !0);
  };
  var c = t.zeroOrMore = function(g) {
    return function(x) {
      for (var E = [], m; (m = g(x)) && m.isSuccess(); )
        x = m.remaining(), E.push(m.value());
      return m.isError() ? m : a.success(E, x);
    };
  };
  t.oneOrMore = function(g) {
    return t.oneOrMoreWithSeparator(g, u);
  };
  function u(g) {
    return a.success(null, g);
  }
  var d = function(g, x, E) {
    return function(m) {
      var v = g(m);
      if (v.isSuccess()) {
        var y = t.sequence.capture(g, "main"), A = c(t.then(
          t.sequence(x, y),
          t.sequence.extract(y)
        )), b = A(v.remaining());
        return a.success([v.value()].concat(b.value()), b.remaining());
      } else
        return E || v.isError() ? v : a.success([], m);
    };
  };
  t.leftAssociative = function(g, x, E) {
    var m;
    E ? m = [{ func: E, rule: x }] : m = x, m = m.map(function(y) {
      return t.then(y.rule, function(A) {
        return function(b, C) {
          return y.func(b, A, C);
        };
      });
    });
    var v = t.firstOf.apply(null, ["rules"].concat(m));
    return function(y) {
      var A = y, b = g(y);
      if (!b.isSuccess())
        return b;
      for (var C = v(b.remaining()); C.isSuccess(); ) {
        var T = C.remaining(), w = A.to(C.remaining()), R = C.value();
        b = a.success(
          R(b.value(), w),
          T,
          w
        ), C = v(b.remaining());
      }
      return C.isError() ? C : b;
    };
  }, t.leftAssociative.firstOf = function() {
    return Array.prototype.slice.call(arguments, 0);
  }, t.nonConsuming = function(g) {
    return function(x) {
      return g(x).changeRemaining(x);
    };
  };
  var f = function(g) {
    return g.value ? g.name + ' "' + g.value + '"' : g.name;
  };
  function h(g, x) {
    var E, m = g.head();
    return m ? E = s.error({
      expected: x,
      actual: f(m),
      location: m.source
    }) : E = s.error({
      expected: x,
      actual: "end of tokens"
    }), a.failure([E], g);
  }
})(rules);
var StringSource$1 = { exports: {} }, util$1 = {}, isBufferBrowser = function t(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
}, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(e, n) {
  e.super_ = n, e.prototype = Object.create(n.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : inherits_browser.exports = function(e, n) {
  e.super_ = n;
  var a = function() {
  };
  a.prototype = n.prototype, e.prototype = new a(), e.prototype.constructor = e;
};
var inherits_browserExports = inherits_browser.exports;
(function(t) {
  var e = Object.getOwnPropertyDescriptors || function(U) {
    for (var F = Object.keys(U), M = {}, I = 0; I < F.length; I++)
      M[F[I]] = Object.getOwnPropertyDescriptor(U, F[I]);
    return M;
  }, n = /%[sdj%]/g;
  t.format = function(G) {
    if (!C(G)) {
      for (var U = [], F = 0; F < arguments.length; F++)
        U.push(o(arguments[F]));
      return U.join(" ");
    }
    for (var F = 1, M = arguments, I = M.length, N = String(G).replace(n, function(q) {
      if (q === "%%")
        return "%";
      if (F >= I)
        return q;
      switch (q) {
        case "%s":
          return String(M[F++]);
        case "%d":
          return Number(M[F++]);
        case "%j":
          try {
            return JSON.stringify(M[F++]);
          } catch {
            return "[Circular]";
          }
        default:
          return q;
      }
    }), V = M[F]; F < I; V = M[++F])
      y(V) || !O(V) ? N += " " + V : N += " " + o(V);
    return N;
  }, t.deprecate = function(G, U) {
    if (typeof process < "u" && process.noDeprecation === !0)
      return G;
    if (typeof process > "u")
      return function() {
        return t.deprecate(G, U).apply(this, arguments);
      };
    var F = !1;
    function M() {
      if (!F) {
        if (process.throwDeprecation)
          throw new Error(U);
        process.traceDeprecation ? console.trace(U) : console.error(U), F = !0;
      }
      return G.apply(this, arguments);
    }
    return M;
  };
  var a = {}, s;
  t.debuglog = function(G) {
    if (w(s) && (s = process.env.NODE_DEBUG || ""), G = G.toUpperCase(), !a[G])
      if (new RegExp("\\b" + G + "\\b", "i").test(s)) {
        var U = process.pid;
        a[G] = function() {
          var F = t.format.apply(t, arguments);
          console.error("%s %d: %s", G, U, F);
        };
      } else
        a[G] = function() {
        };
    return a[G];
  };
  function o(G, U) {
    var F = {
      seen: [],
      stylize: c
    };
    return arguments.length >= 3 && (F.depth = arguments[2]), arguments.length >= 4 && (F.colors = arguments[3]), v(U) ? F.showHidden = U : U && t._extend(F, U), w(F.showHidden) && (F.showHidden = !1), w(F.depth) && (F.depth = 2), w(F.colors) && (F.colors = !1), w(F.customInspect) && (F.customInspect = !0), F.colors && (F.stylize = l), d(F, G, F.depth);
  }
  t.inspect = o, o.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, o.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function l(G, U) {
    var F = o.styles[U];
    return F ? "\x1B[" + o.colors[F][0] + "m" + G + "\x1B[" + o.colors[F][1] + "m" : G;
  }
  function c(G, U) {
    return G;
  }
  function u(G) {
    var U = {};
    return G.forEach(function(F, M) {
      U[F] = !0;
    }), U;
  }
  function d(G, U, F) {
    if (G.customInspect && U && W(U.inspect) && // Filter out the util module, it's inspect function is special
    U.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
    !(U.constructor && U.constructor.prototype === U)) {
      var M = U.inspect(F, G);
      return C(M) || (M = d(G, M, F)), M;
    }
    var I = f(G, U);
    if (I)
      return I;
    var N = Object.keys(U), V = u(N);
    if (G.showHidden && (N = Object.getOwnPropertyNames(U)), k(U) && (N.indexOf("message") >= 0 || N.indexOf("description") >= 0))
      return h(U);
    if (N.length === 0) {
      if (W(U)) {
        var q = U.name ? ": " + U.name : "";
        return G.stylize("[Function" + q + "]", "special");
      }
      if (R(U))
        return G.stylize(RegExp.prototype.toString.call(U), "regexp");
      if (D(U))
        return G.stylize(Date.prototype.toString.call(U), "date");
      if (k(U))
        return h(U);
    }
    var H = "", ne = !1, he = ["{", "}"];
    if (m(U) && (ne = !0, he = ["[", "]"]), W(U)) {
      var j = U.name ? ": " + U.name : "";
      H = " [Function" + j + "]";
    }
    if (R(U) && (H = " " + RegExp.prototype.toString.call(U)), D(U) && (H = " " + Date.prototype.toUTCString.call(U)), k(U) && (H = " " + h(U)), N.length === 0 && (!ne || U.length == 0))
      return he[0] + H + he[1];
    if (F < 0)
      return R(U) ? G.stylize(RegExp.prototype.toString.call(U), "regexp") : G.stylize("[Object]", "special");
    G.seen.push(U);
    var Fe;
    return ne ? Fe = g(G, U, F, V, N) : Fe = N.map(function(X) {
      return x(G, U, F, V, X, ne);
    }), G.seen.pop(), E(Fe, H, he);
  }
  function f(G, U) {
    if (w(U))
      return G.stylize("undefined", "undefined");
    if (C(U)) {
      var F = "'" + JSON.stringify(U).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return G.stylize(F, "string");
    }
    if (b(U))
      return G.stylize("" + U, "number");
    if (v(U))
      return G.stylize("" + U, "boolean");
    if (y(U))
      return G.stylize("null", "null");
  }
  function h(G) {
    return "[" + Error.prototype.toString.call(G) + "]";
  }
  function g(G, U, F, M, I) {
    for (var N = [], V = 0, q = U.length; V < q; ++V)
      ie(U, String(V)) ? N.push(x(
        G,
        U,
        F,
        M,
        String(V),
        !0
      )) : N.push("");
    return I.forEach(function(H) {
      H.match(/^\d+$/) || N.push(x(
        G,
        U,
        F,
        M,
        H,
        !0
      ));
    }), N;
  }
  function x(G, U, F, M, I, N) {
    var V, q, H;
    if (H = Object.getOwnPropertyDescriptor(U, I) || { value: U[I] }, H.get ? H.set ? q = G.stylize("[Getter/Setter]", "special") : q = G.stylize("[Getter]", "special") : H.set && (q = G.stylize("[Setter]", "special")), ie(M, I) || (V = "[" + I + "]"), q || (G.seen.indexOf(H.value) < 0 ? (y(F) ? q = d(G, H.value, null) : q = d(G, H.value, F - 1), q.indexOf(`
`) > -1 && (N ? q = q.split(`
`).map(function(ne) {
      return "  " + ne;
    }).join(`
`).substr(2) : q = `
` + q.split(`
`).map(function(ne) {
      return "   " + ne;
    }).join(`
`))) : q = G.stylize("[Circular]", "special")), w(V)) {
      if (N && I.match(/^\d+$/))
        return q;
      V = JSON.stringify("" + I), V.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (V = V.substr(1, V.length - 2), V = G.stylize(V, "name")) : (V = V.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), V = G.stylize(V, "string"));
    }
    return V + ": " + q;
  }
  function E(G, U, F) {
    var M = G.reduce(function(I, N) {
      return N.indexOf(`
`) >= 0, I + N.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return M > 60 ? F[0] + (U === "" ? "" : U + `
 `) + " " + G.join(`,
  `) + " " + F[1] : F[0] + U + " " + G.join(", ") + " " + F[1];
  }
  function m(G) {
    return Array.isArray(G);
  }
  t.isArray = m;
  function v(G) {
    return typeof G == "boolean";
  }
  t.isBoolean = v;
  function y(G) {
    return G === null;
  }
  t.isNull = y;
  function A(G) {
    return G == null;
  }
  t.isNullOrUndefined = A;
  function b(G) {
    return typeof G == "number";
  }
  t.isNumber = b;
  function C(G) {
    return typeof G == "string";
  }
  t.isString = C;
  function T(G) {
    return typeof G == "symbol";
  }
  t.isSymbol = T;
  function w(G) {
    return G === void 0;
  }
  t.isUndefined = w;
  function R(G) {
    return O(G) && z(G) === "[object RegExp]";
  }
  t.isRegExp = R;
  function O(G) {
    return typeof G == "object" && G !== null;
  }
  t.isObject = O;
  function D(G) {
    return O(G) && z(G) === "[object Date]";
  }
  t.isDate = D;
  function k(G) {
    return O(G) && (z(G) === "[object Error]" || G instanceof Error);
  }
  t.isError = k;
  function W(G) {
    return typeof G == "function";
  }
  t.isFunction = W;
  function L(G) {
    return G === null || typeof G == "boolean" || typeof G == "number" || typeof G == "string" || typeof G == "symbol" || // ES6 symbol
    typeof G > "u";
  }
  t.isPrimitive = L, t.isBuffer = isBufferBrowser;
  function z(G) {
    return Object.prototype.toString.call(G);
  }
  function P(G) {
    return G < 10 ? "0" + G.toString(10) : G.toString(10);
  }
  var Q = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function Y() {
    var G = /* @__PURE__ */ new Date(), U = [
      P(G.getHours()),
      P(G.getMinutes()),
      P(G.getSeconds())
    ].join(":");
    return [G.getDate(), Q[G.getMonth()], U].join(" ");
  }
  t.log = function() {
    console.log("%s - %s", Y(), t.format.apply(t, arguments));
  }, t.inherits = inherits_browserExports, t._extend = function(G, U) {
    if (!U || !O(U))
      return G;
    for (var F = Object.keys(U), M = F.length; M--; )
      G[F[M]] = U[F[M]];
    return G;
  };
  function ie(G, U) {
    return Object.prototype.hasOwnProperty.call(G, U);
  }
  var te = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  t.promisify = function(U) {
    if (typeof U != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (te && U[te]) {
      var F = U[te];
      if (typeof F != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(F, te, {
        value: F,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), F;
    }
    function F() {
      for (var M, I, N = new Promise(function(H, ne) {
        M = H, I = ne;
      }), V = [], q = 0; q < arguments.length; q++)
        V.push(arguments[q]);
      V.push(function(H, ne) {
        H ? I(H) : M(ne);
      });
      try {
        U.apply(this, V);
      } catch (H) {
        I(H);
      }
      return N;
    }
    return Object.setPrototypeOf(F, Object.getPrototypeOf(U)), te && Object.defineProperty(F, te, {
      value: F,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      F,
      e(U)
    );
  }, t.promisify.custom = te;
  function Z(G, U) {
    if (!G) {
      var F = new Error("Promise was rejected with a falsy value");
      F.reason = G, G = F;
    }
    return U(G);
  }
  function ae(G) {
    if (typeof G != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function U() {
      for (var F = [], M = 0; M < arguments.length; M++)
        F.push(arguments[M]);
      var I = F.pop();
      if (typeof I != "function")
        throw new TypeError("The last argument must be of type Function");
      var N = this, V = function() {
        return I.apply(N, arguments);
      };
      G.apply(this, F).then(
        function(q) {
          process.nextTick(V, null, q);
        },
        function(q) {
          process.nextTick(Z, q, V);
        }
      );
    }
    return Object.setPrototypeOf(U, Object.getPrototypeOf(G)), Object.defineProperties(
      U,
      e(G)
    ), U;
  }
  t.callbackify = ae;
})(util$1);
var util = util$1;
StringSource$1.exports = function(t, e) {
  var n = {
    asString: function() {
      return t;
    },
    range: function(a, s) {
      return new StringSourceRange(t, e, a, s);
    }
  };
  return n;
};
var StringSourceRange = function(t, e, n, a) {
  this._string = t, this._description = e, this._startIndex = n, this._endIndex = a;
};
StringSourceRange.prototype.to = function(t) {
  return new StringSourceRange(this._string, this._description, this._startIndex, t._endIndex);
};
StringSourceRange.prototype.describe = function() {
  var t = this._position(), e = this._description ? this._description + `
` : "";
  return util.format(
    `%sLine number: %s
Character number: %s`,
    e,
    t.lineNumber,
    t.characterNumber
  );
};
StringSourceRange.prototype.lineNumber = function() {
  return this._position().lineNumber;
};
StringSourceRange.prototype.characterNumber = function() {
  return this._position().characterNumber;
};
StringSourceRange.prototype._position = function() {
  for (var t = this, e = 0, n = function() {
    return t._string.indexOf(`
`, e);
  }, a = 1; n() !== -1 && n() < this._startIndex; )
    e = n() + 1, a += 1;
  var s = this._startIndex - e + 1;
  return { lineNumber: a, characterNumber: s };
};
var StringSourceExports = StringSource$1.exports, Token$1 = function(t, e, n) {
  this.name = t, this.value = e, n && (this.source = n);
}, bottomUp = {};
(function(t) {
  var e = rules, n = parsingResults;
  t.parser = function(o, l, c) {
    var u = {
      rule: g,
      leftAssociative: x,
      rightAssociative: E
    }, d = new a(c.map(h)), f = e.firstOf(o, l);
    function h(y) {
      return {
        name: y.name,
        rule: s(y.ruleBuilder.bind(null, u))
      };
    }
    function g() {
      return m(d);
    }
    function x(y) {
      return m(d.untilExclusive(y));
    }
    function E(y) {
      return m(d.untilInclusive(y));
    }
    function m(y) {
      return v.bind(null, y);
    }
    function v(y, A) {
      var b = f(A);
      return b.isSuccess() ? y.apply(b) : b;
    }
    return u;
  };
  function a(o) {
    function l(h) {
      return new a(o.slice(0, u().indexOf(h)));
    }
    function c(h) {
      return new a(o.slice(0, u().indexOf(h) + 1));
    }
    function u() {
      return o.map(function(h) {
        return h.name;
      });
    }
    function d(h) {
      for (var g, x; ; )
        if (g = f(h.remaining()), g.isSuccess())
          x = h.source().to(g.source()), h = n.success(
            g.value()(h.value(), x),
            g.remaining(),
            x
          );
        else
          return g.isFailure() ? h : g;
    }
    function f(h) {
      return e.firstOf("infix", o.map(function(g) {
        return g.rule;
      }))(h);
    }
    return {
      apply: d,
      untilExclusive: l,
      untilInclusive: c
    };
  }
  t.infix = function(o, l) {
    function c(u) {
      return t.infix(o, function(d) {
        var f = l(d);
        return function(h) {
          var g = f(h);
          return g.map(function(x) {
            return function(E, m) {
              return u(E, x, m);
            };
          });
        };
      });
    }
    return {
      name: o,
      ruleBuilder: l,
      map: c
    };
  };
  var s = function(o) {
    var l;
    return function(c) {
      return l || (l = o()), l(c);
    };
  };
})(bottomUp);
var regexTokeniser = {}, Token = Token$1, StringSource = StringSourceExports;
regexTokeniser.RegexTokeniser = RegexTokeniser$1;
function RegexTokeniser$1(t) {
  t = t.map(function(s) {
    return {
      name: s.name,
      regex: new RegExp(s.regex.source, "g")
    };
  });
  function e(s, o) {
    for (var l = new StringSource(s, o), c = 0, u = []; c < s.length; ) {
      var d = n(s, c, l);
      c = d.endIndex, u.push(d.token);
    }
    return u.push(a(s, l)), u;
  }
  function n(s, o, l) {
    for (var c = 0; c < t.length; c++) {
      var u = t[c].regex;
      u.lastIndex = o;
      var d = u.exec(s);
      if (d) {
        var h = o + d[0].length;
        if (d.index === o && h > o) {
          var f = d[1], g = new Token(
            t[c].name,
            f,
            l.range(o, h)
          );
          return { token: g, endIndex: h };
        }
      }
    }
    var h = o + 1, g = new Token(
      "unrecognisedCharacter",
      s.substring(o, h),
      l.range(o, h)
    );
    return { token: g, endIndex: h };
  }
  function a(s, o) {
    return new Token(
      "end",
      null,
      o.range(s.length, s.length)
    );
  }
  return {
    tokenise: e
  };
}
lop$2.Parser = parser.Parser;
lop$2.rules = rules;
lop$2.errors = errors;
lop$2.results = parsingResults;
lop$2.StringSource = StringSourceExports;
lop$2.Token = Token$1;
lop$2.bottomUp = bottomUp;
lop$2.RegexTokeniser = regexTokeniser.RegexTokeniser;
lop$2.rule = function(t) {
  var e;
  return function(n) {
    return e || (e = t()), e(n);
  };
};
var documentMatchers$1 = {};
documentMatchers$1.paragraph = paragraph$1;
documentMatchers$1.run = run$1;
documentMatchers$1.table = table;
documentMatchers$1.bold = new Matcher("bold");
documentMatchers$1.italic = new Matcher("italic");
documentMatchers$1.underline = new Matcher("underline");
documentMatchers$1.strikethrough = new Matcher("strikethrough");
documentMatchers$1.allCaps = new Matcher("allCaps");
documentMatchers$1.smallCaps = new Matcher("smallCaps");
documentMatchers$1.commentReference = new Matcher("commentReference");
documentMatchers$1.lineBreak = new Matcher("break", { breakType: "line" });
documentMatchers$1.pageBreak = new Matcher("break", { breakType: "page" });
documentMatchers$1.columnBreak = new Matcher("break", { breakType: "column" });
documentMatchers$1.equalTo = equalTo;
documentMatchers$1.startsWith = startsWith;
function paragraph$1(t) {
  return new Matcher("paragraph", t);
}
function run$1(t) {
  return new Matcher("run", t);
}
function table(t) {
  return new Matcher("table", t);
}
function Matcher(t, e) {
  e = e || {}, this._elementType = t, this._styleId = e.styleId, this._styleName = e.styleName, e.list && (this._listIndex = e.list.levelIndex, this._listIsOrdered = e.list.isOrdered);
}
Matcher.prototype.matches = function(t) {
  return t.type === this._elementType && (this._styleId === void 0 || t.styleId === this._styleId) && (this._styleName === void 0 || t.styleName && this._styleName.operator(this._styleName.operand, t.styleName)) && (this._listIndex === void 0 || isList(t, this._listIndex, this._listIsOrdered)) && (this._breakType === void 0 || this._breakType === t.breakType);
};
function isList(t, e, n) {
  return t.numbering && t.numbering.level == e && t.numbering.isOrdered == n;
}
function equalTo(t) {
  return {
    operator: operatorEqualTo,
    operand: t
  };
}
function startsWith(t) {
  return {
    operator: operatorStartsWith,
    operand: t
  };
}
function operatorEqualTo(t, e) {
  return t.toUpperCase() === e.toUpperCase();
}
function operatorStartsWith(t, e) {
  return e.toUpperCase().indexOf(t.toUpperCase()) === 0;
}
var tokeniser = {}, lop$1 = lop$2, RegexTokeniser = lop$1.RegexTokeniser;
tokeniser.tokenise = tokenise$1;
var stringPrefix = "'((?:\\\\.|[^'])*)";
function tokenise$1(t) {
  var e = "(?:[a-zA-Z\\-_]|\\\\.)", n = new RegexTokeniser([
    { name: "identifier", regex: new RegExp("(" + e + "(?:" + e + "|[0-9])*)") },
    { name: "dot", regex: /\./ },
    { name: "colon", regex: /:/ },
    { name: "gt", regex: />/ },
    { name: "whitespace", regex: /\s+/ },
    { name: "arrow", regex: /=>/ },
    { name: "equals", regex: /=/ },
    { name: "startsWith", regex: /\^=/ },
    { name: "open-paren", regex: /\(/ },
    { name: "close-paren", regex: /\)/ },
    { name: "open-square-bracket", regex: /\[/ },
    { name: "close-square-bracket", regex: /\]/ },
    { name: "string", regex: new RegExp(stringPrefix + "'") },
    { name: "unterminated-string", regex: new RegExp(stringPrefix) },
    { name: "integer", regex: /([0-9]+)/ },
    { name: "choice", regex: /\|/ },
    { name: "bang", regex: /(!)/ }
  ]);
  return n.tokenise(t);
}
var _$3 = require$$0, lop = lop$2, documentMatchers = documentMatchers$1, htmlPaths$1 = requireHtmlPaths(), tokenise = tokeniser.tokenise, results = results$2;
styleReader.readHtmlPath = readHtmlPath;
styleReader.readDocumentMatcher = readDocumentMatcher;
styleReader.readStyle = readStyle$1;
function readStyle$1(t) {
  return parseString(styleRule, t);
}
function createStyleRule() {
  return lop.rules.sequence(
    lop.rules.sequence.capture(documentMatcherRule()),
    lop.rules.tokenOfType("whitespace"),
    lop.rules.tokenOfType("arrow"),
    lop.rules.sequence.capture(lop.rules.optional(lop.rules.sequence(
      lop.rules.tokenOfType("whitespace"),
      lop.rules.sequence.capture(htmlPathRule())
    ).head())),
    lop.rules.tokenOfType("end")
  ).map(function(t, e) {
    return {
      from: t,
      to: e.valueOrElse(htmlPaths$1.empty)
    };
  });
}
function readDocumentMatcher(t) {
  return parseString(documentMatcherRule(), t);
}
function documentMatcherRule() {
  var t = lop.rules.sequence, e = function(T, w) {
    return lop.rules.then(
      lop.rules.token("identifier", T),
      function() {
        return w;
      }
    );
  }, n = e("p", documentMatchers.paragraph), a = e("r", documentMatchers.run), s = lop.rules.firstOf(
    "p or r or table",
    n,
    a
  ), o = lop.rules.then(
    classRule,
    function(T) {
      return { styleId: T };
    }
  ), l = lop.rules.firstOf(
    "style name matcher",
    lop.rules.then(
      lop.rules.sequence(
        lop.rules.tokenOfType("equals"),
        lop.rules.sequence.cut(),
        lop.rules.sequence.capture(stringRule)
      ).head(),
      function(T) {
        return { styleName: documentMatchers.equalTo(T) };
      }
    ),
    lop.rules.then(
      lop.rules.sequence(
        lop.rules.tokenOfType("startsWith"),
        lop.rules.sequence.cut(),
        lop.rules.sequence.capture(stringRule)
      ).head(),
      function(T) {
        return { styleName: documentMatchers.startsWith(T) };
      }
    )
  ), c = lop.rules.sequence(
    lop.rules.tokenOfType("open-square-bracket"),
    lop.rules.sequence.cut(),
    lop.rules.token("identifier", "style-name"),
    lop.rules.sequence.capture(l),
    lop.rules.tokenOfType("close-square-bracket")
  ).head(), u = lop.rules.firstOf(
    "list type",
    e("ordered-list", { isOrdered: !0 }),
    e("unordered-list", { isOrdered: !1 })
  ), d = t(
    lop.rules.tokenOfType("colon"),
    t.capture(u),
    t.cut(),
    lop.rules.tokenOfType("open-paren"),
    t.capture(integerRule),
    lop.rules.tokenOfType("close-paren")
  ).map(function(T, w) {
    return {
      list: {
        isOrdered: T.isOrdered,
        levelIndex: w - 1
      }
    };
  });
  function f(T) {
    var w = lop.rules.firstOf.apply(
      lop.rules.firstOf,
      ["matcher suffix"].concat(T)
    ), R = lop.rules.zeroOrMore(w);
    return lop.rules.then(R, function(O) {
      var D = {};
      return O.forEach(function(k) {
        _$3.extend(D, k);
      }), D;
    });
  }
  var h = t(
    t.capture(s),
    t.capture(f([
      o,
      c,
      d
    ]))
  ).map(function(T, w) {
    return T(w);
  }), g = t(
    lop.rules.token("identifier", "table"),
    t.capture(f([
      o,
      c
    ]))
  ).map(function(T) {
    return documentMatchers.table(T);
  }), x = e("b", documentMatchers.bold), E = e("i", documentMatchers.italic), m = e("u", documentMatchers.underline), v = e("strike", documentMatchers.strikethrough), y = e("all-caps", documentMatchers.allCaps), A = e("small-caps", documentMatchers.smallCaps), b = e("comment-reference", documentMatchers.commentReference), C = t(
    lop.rules.token("identifier", "br"),
    t.cut(),
    lop.rules.tokenOfType("open-square-bracket"),
    lop.rules.token("identifier", "type"),
    lop.rules.tokenOfType("equals"),
    t.capture(stringRule),
    lop.rules.tokenOfType("close-square-bracket")
  ).map(function(T) {
    switch (T) {
      case "line":
        return documentMatchers.lineBreak;
      case "page":
        return documentMatchers.pageBreak;
      case "column":
        return documentMatchers.columnBreak;
    }
  });
  return lop.rules.firstOf(
    "element type",
    h,
    g,
    x,
    E,
    m,
    v,
    y,
    A,
    b,
    C
  );
}
function readHtmlPath(t) {
  return parseString(htmlPathRule(), t);
}
function htmlPathRule() {
  var t = lop.rules.sequence.capture, e = lop.rules.tokenOfType("whitespace"), n = lop.rules.then(
    lop.rules.optional(lop.rules.sequence(
      lop.rules.tokenOfType("colon"),
      lop.rules.token("identifier", "fresh")
    )),
    function(l) {
      return l.map(function() {
        return !0;
      }).valueOrElse(!1);
    }
  ), a = lop.rules.then(
    lop.rules.optional(lop.rules.sequence(
      lop.rules.tokenOfType("colon"),
      lop.rules.token("identifier", "separator"),
      lop.rules.tokenOfType("open-paren"),
      t(stringRule),
      lop.rules.tokenOfType("close-paren")
    ).head()),
    function(l) {
      return l.valueOrElse("");
    }
  ), s = lop.rules.oneOrMoreWithSeparator(
    identifierRule,
    lop.rules.tokenOfType("choice")
  ), o = lop.rules.sequence(
    t(s),
    t(lop.rules.zeroOrMore(classRule)),
    t(n),
    t(a)
  ).map(function(l, c, u, d) {
    var f = {}, h = {};
    return c.length > 0 && (f.class = c.join(" ")), u && (h.fresh = !0), d && (h.separator = d), htmlPaths$1.element(l, f, h);
  });
  return lop.rules.firstOf(
    "html path",
    lop.rules.then(lop.rules.tokenOfType("bang"), function() {
      return htmlPaths$1.ignore;
    }),
    lop.rules.then(
      lop.rules.zeroOrMoreWithSeparator(
        o,
        lop.rules.sequence(
          e,
          lop.rules.tokenOfType("gt"),
          e
        )
      ),
      htmlPaths$1.elements
    )
  );
}
var identifierRule = lop.rules.then(
  lop.rules.tokenOfType("identifier"),
  decodeEscapeSequences
), integerRule = lop.rules.tokenOfType("integer"), stringRule = lop.rules.then(
  lop.rules.tokenOfType("string"),
  decodeEscapeSequences
), escapeSequences = {
  n: `
`,
  r: "\r",
  t: "	"
};
function decodeEscapeSequences(t) {
  return t.replace(/\\(.)/g, function(e, n) {
    return escapeSequences[n] || n;
  });
}
var classRule = lop.rules.sequence(
  lop.rules.tokenOfType("dot"),
  lop.rules.sequence.cut(),
  lop.rules.sequence.capture(identifierRule)
).head();
function parseString(t, e) {
  var n = tokenise(e), a = lop.Parser(), s = a.parseTokens(t, n);
  return s.isSuccess() ? results.success(s.value()) : new results.Result(null, [results.warning(describeFailure(e, s))]);
}
function describeFailure(t, e) {
  return "Did not understand this style mapping, so ignored it: " + t + `
` + e.errors().map(describeError).join(`
`);
}
function describeError(t) {
  return "Error was at character number " + t.characterNumber() + ": Expected " + t.expected + " but got " + t.actual;
}
var styleRule = createStyleRule(), optionsReader = {};
optionsReader.readOptions = readOptions$1;
var _$2 = require$$0, defaultStyleMap = optionsReader._defaultStyleMap = [
  "p.Heading1 => h1:fresh",
  "p.Heading2 => h2:fresh",
  "p.Heading3 => h3:fresh",
  "p.Heading4 => h4:fresh",
  "p.Heading5 => h5:fresh",
  "p.Heading6 => h6:fresh",
  "p[style-name='Heading 1'] => h1:fresh",
  "p[style-name='Heading 2'] => h2:fresh",
  "p[style-name='Heading 3'] => h3:fresh",
  "p[style-name='Heading 4'] => h4:fresh",
  "p[style-name='Heading 5'] => h5:fresh",
  "p[style-name='Heading 6'] => h6:fresh",
  "p[style-name='heading 1'] => h1:fresh",
  "p[style-name='heading 2'] => h2:fresh",
  "p[style-name='heading 3'] => h3:fresh",
  "p[style-name='heading 4'] => h4:fresh",
  "p[style-name='heading 5'] => h5:fresh",
  "p[style-name='heading 6'] => h6:fresh",
  "r[style-name='Strong'] => strong",
  "p[style-name='footnote text'] => p:fresh",
  "r[style-name='footnote reference'] =>",
  "p[style-name='endnote text'] => p:fresh",
  "r[style-name='endnote reference'] =>",
  "p[style-name='annotation text'] => p:fresh",
  "r[style-name='annotation reference'] =>",
  // LibreOffice
  "p[style-name='Footnote'] => p:fresh",
  "r[style-name='Footnote anchor'] =>",
  "p[style-name='Endnote'] => p:fresh",
  "r[style-name='Endnote anchor'] =>",
  "p:unordered-list(1) => ul > li:fresh",
  "p:unordered-list(2) => ul|ol > li > ul > li:fresh",
  "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh",
  "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
  "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
  "p:ordered-list(1) => ol > li:fresh",
  "p:ordered-list(2) => ul|ol > li > ol > li:fresh",
  "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh",
  "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
  "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
  "r[style-name='Hyperlink'] =>",
  "p[style-name='Normal'] => p:fresh"
], standardOptions = optionsReader._standardOptions = {
  transformDocument: identity,
  includeDefaultStyleMap: !0,
  includeEmbeddedStyleMap: !0
};
function readOptions$1(t) {
  return t = t || {}, _$2.extend({}, standardOptions, t, {
    customStyleMap: readStyleMap(t.styleMap),
    readStyleMap: function() {
      var e = this.customStyleMap;
      return this.includeEmbeddedStyleMap && (e = e.concat(readStyleMap(this.embeddedStyleMap))), this.includeDefaultStyleMap && (e = e.concat(defaultStyleMap)), e;
    }
  });
}
function readStyleMap(t) {
  return t ? _$2.isString(t) ? t.split(`
`).map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e !== "" && e.charAt(0) !== "#";
  }) : t : [];
}
function identity(t) {
  return t;
}
var unzip$1 = {}, promises = promises$7, zipfile = zipfile$2;
unzip$1.openZip = openZip;
function openZip(t) {
  return t.arrayBuffer ? promises.resolve(zipfile.openArrayBuffer(t.arrayBuffer)) : promises.reject(new Error("Could not find file in options"));
}
var transforms = {}, _$1 = require$$0;
transforms.paragraph = paragraph;
transforms.run = run;
transforms._elements = elements;
transforms.getDescendantsOfType = getDescendantsOfType;
transforms.getDescendants = getDescendants;
function paragraph(t) {
  return elementsOfType("paragraph", t);
}
function run(t) {
  return elementsOfType("run", t);
}
function elementsOfType(t, e) {
  return elements(function(n) {
    return n.type === t ? e(n) : n;
  });
}
function elements(t) {
  return function e(n) {
    if (n.children) {
      var a = _$1.map(n.children, e);
      n = _$1.extend(n, { children: a });
    }
    return t(n);
  };
}
function getDescendantsOfType(t, e) {
  return getDescendants(t).filter(function(n) {
    return n.type === e;
  });
}
function getDescendants(t) {
  var e = [];
  return visitDescendants(t, function(n) {
    e.push(n);
  }), e;
}
function visitDescendants(t, e) {
  t.children && t.children.forEach(function(n) {
    visitDescendants(n, e), e(n);
  });
}
var underline = {}, htmlPaths = requireHtmlPaths(), Html = requireHtml();
underline.element = element;
function element(t) {
  return function(e) {
    return Html.elementWithTag(htmlPaths.element(t), [e]);
  };
}
var _ = require$$0, docxReader = docxReader$1, docxStyleMap = styleMap, DocumentConverter = documentToHtml.DocumentConverter, convertElementToRawText = rawText.convertElementToRawText, readStyle = styleReader.readStyle, readOptions = optionsReader.readOptions, unzip = unzip$1, Result = results$2.Result;
lib$2.convertToHtml = convertToHtml;
lib$2.convertToMarkdown = convertToMarkdown;
lib$2.convert = convert;
lib$2.extractRawText = extractRawText;
lib$2.images = images$1;
lib$2.transforms = transforms;
lib$2.underline = underline;
lib$2.embedStyleMap = embedStyleMap;
lib$2.readEmbeddedStyleMap = readEmbeddedStyleMap;
function convertToHtml(t, e) {
  return convert(t, e);
}
function convertToMarkdown(t, e) {
  var n = Object.create(e || {});
  return n.outputFormat = "markdown", convert(t, n);
}
function convert(t, e) {
  return e = readOptions(e), unzip.openZip(t).tap(function(n) {
    return docxStyleMap.readStyleMap(n).then(function(a) {
      e.embeddedStyleMap = a;
    });
  }).then(function(n) {
    return docxReader.read(n, t).then(function(a) {
      return a.map(e.transformDocument);
    }).then(function(a) {
      return convertDocumentToHtml(a, e);
    });
  });
}
function readEmbeddedStyleMap(t) {
  return unzip.openZip(t).then(docxStyleMap.readStyleMap);
}
function convertDocumentToHtml(t, e) {
  var n = parseStyleMap(e.readStyleMap()), a = _.extend({}, e, {
    styleMap: n.value
  }), s = new DocumentConverter(a);
  return t.flatMapThen(function(o) {
    return n.flatMapThen(function(l) {
      return s.convertToHtml(o);
    });
  });
}
function parseStyleMap(t) {
  return Result.combine((t || []).map(readStyle)).map(function(e) {
    return e.filter(function(n) {
      return !!n;
    });
  });
}
function extractRawText(t) {
  return unzip.openZip(t).then(docxReader.read).then(function(e) {
    return e.map(convertElementToRawText);
  });
}
function embedStyleMap(t, e) {
  return unzip.openZip(t).tap(function(n) {
    return docxStyleMap.writeStyleMap(n, e);
  }).then(function(n) {
    return n.toArrayBuffer();
  }).then(function(n) {
    return {
      toArrayBuffer: function() {
        return n;
      },
      toBuffer: function() {
        return Buffer.from(n);
      }
    };
  });
}
lib$2.styleMapping = function() {
  throw new Error(`Use a raw string instead of mammoth.styleMapping e.g. "p[style-name='Title'] => h1" instead of mammoth.styleMapping("p[style-name='Title'] => h1")`);
};
const DocxViewer = ({
  filePath: t,
  errorComponent: e
}) => {
  const [n, a] = useState(!1), [s, o] = useState(""), [l, c] = useState("");
  return useEffect(() => {
    (async () => {
      a(!0), o("");
      const d = new FileReader();
      d.onloadend = function() {
        const h = d.result;
        h && lib$2.convertToHtml(
          { arrayBuffer: h },
          { includeDefaultStyleMap: !0 }
        ).then((g) => {
          o(g.value), a(!1);
        }).catch((g) => {
          console.log("alexei: something went wrong", g), c("An error happened"), a(!1);
        });
      };
      const f = await fetch(t);
      d.readAsArrayBuffer(await f.blob());
    })();
  }, [t]), l ? e : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "docx", className: "document-viewer", children: n ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: s } }) });
}, VideoViewer = (t) => {
  const [e, n] = useState(!0), [a, s] = useState(null);
  return a ? t.errorComponent : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-driver-view", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "video-container", children: [
    e ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "video",
      {
        style: { visibility: e ? "hidden" : "visible" },
        controls: !0,
        onCanPlay: () => n(!1),
        onError: (o) => s(o),
        src: t.filePath,
        children: "Video playback is not supported by your browser."
      }
    )
  ] }) });
};
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var current_ansi = 1252, VALID_ANSI = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], CS2CP = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, set_ansi = function(t) {
  VALID_ANSI.indexOf(t) != -1 && (current_ansi = CS2CP[0] = t);
};
function reset_ansi() {
  set_ansi(1252);
}
var set_cp = function(t) {
  set_ansi(t);
};
function reset_cp() {
  set_cp(1200), reset_ansi();
}
function char_codes(t) {
  for (var e = [], n = 0, a = t.length; n < a; ++n)
    e[n] = t.charCodeAt(n);
  return e;
}
function utf16leread(t) {
  for (var e = [], n = 0; n < t.length >> 1; ++n)
    e[n] = String.fromCharCode(t.charCodeAt(2 * n) + (t.charCodeAt(2 * n + 1) << 8));
  return e.join("");
}
function utf16beread(t) {
  for (var e = [], n = 0; n < t.length >> 1; ++n)
    e[n] = String.fromCharCode(t.charCodeAt(2 * n + 1) + (t.charCodeAt(2 * n) << 8));
  return e.join("");
}
var debom = function(t) {
  var e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e == 255 && n == 254 ? utf16leread(t.slice(2)) : e == 254 && n == 255 ? utf16beread(t.slice(2)) : e == 65279 ? t.slice(1) : t;
}, _getchar = function t(e) {
  return String.fromCharCode(e);
}, _getansi = function t(e) {
  return String.fromCharCode(e);
}, $cptable, Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Base64_encode(t) {
  for (var e = "", n = 0, a = 0, s = 0, o = 0, l = 0, c = 0, u = 0, d = 0; d < t.length; )
    n = t.charCodeAt(d++), o = n >> 2, a = t.charCodeAt(d++), l = (n & 3) << 4 | a >> 4, s = t.charCodeAt(d++), c = (a & 15) << 2 | s >> 6, u = s & 63, isNaN(a) ? c = u = 64 : isNaN(s) && (u = 64), e += Base64_map.charAt(o) + Base64_map.charAt(l) + Base64_map.charAt(c) + Base64_map.charAt(u);
  return e;
}
function Base64_decode(t) {
  var e = "", n = 0, a = 0, s = 0, o = 0, l = 0, c = 0, u = 0;
  t = t.replace(/[^\w\+\/\=]/g, "");
  for (var d = 0; d < t.length; )
    o = Base64_map.indexOf(t.charAt(d++)), l = Base64_map.indexOf(t.charAt(d++)), n = o << 2 | l >> 4, e += String.fromCharCode(n), c = Base64_map.indexOf(t.charAt(d++)), a = (l & 15) << 4 | c >> 2, c !== 64 && (e += String.fromCharCode(a)), u = Base64_map.indexOf(t.charAt(d++)), s = (c & 3) << 6 | u, u !== 64 && (e += String.fromCharCode(s));
  return e;
}
var has_buf = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), Buffer_from = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var t = !Buffer.from;
    if (!t)
      try {
        Buffer.from("foo", "utf8");
      } catch {
        t = !0;
      }
    return t ? function(e, n) {
      return n ? new Buffer(e, n) : new Buffer(e);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function new_raw_buf(t) {
  return has_buf ? Buffer.alloc ? Buffer.alloc(t) : new Buffer(t) : typeof Uint8Array < "u" ? new Uint8Array(t) : new Array(t);
}
function new_unsafe_buf(t) {
  return has_buf ? Buffer.allocUnsafe ? Buffer.allocUnsafe(t) : new Buffer(t) : typeof Uint8Array < "u" ? new Uint8Array(t) : new Array(t);
}
var s2a = function t(e) {
  return has_buf ? Buffer_from(e, "binary") : e.split("").map(function(n) {
    return n.charCodeAt(0) & 255;
  });
};
function a2s(t) {
  if (Array.isArray(t))
    return t.map(function(a) {
      return String.fromCharCode(a);
    }).join("");
  for (var e = [], n = 0; n < t.length; ++n)
    e[n] = String.fromCharCode(t[n]);
  return e.join("");
}
function ab2a(t) {
  if (typeof ArrayBuffer > "u")
    throw new Error("Unsupported");
  if (t instanceof ArrayBuffer)
    return ab2a(new Uint8Array(t));
  for (var e = new Array(t.length), n = 0; n < t.length; ++n)
    e[n] = t[n];
  return e;
}
var bconcat = has_buf ? function(t) {
  return Buffer.concat(t.map(function(e) {
    return Buffer.isBuffer(e) ? e : Buffer_from(e);
  }));
} : function(t) {
  if (typeof Uint8Array < "u") {
    var e = 0, n = 0;
    for (e = 0; e < t.length; ++e)
      n += t[e].length;
    var a = new Uint8Array(n), s = 0;
    for (e = 0, n = 0; e < t.length; n += s, ++e)
      if (s = t[e].length, t[e] instanceof Uint8Array)
        a.set(t[e], n);
      else {
        if (typeof t[e] == "string")
          throw "wtf";
        a.set(new Uint8Array(t[e]), n);
      }
    return a;
  }
  return [].concat.apply([], t.map(function(o) {
    return Array.isArray(o) ? o : [].slice.call(o);
  }));
};
function utf8decode(t) {
  for (var e = [], n = 0, a = t.length + 250, s = new_raw_buf(t.length + 255), o = 0; o < t.length; ++o) {
    var l = t.charCodeAt(o);
    if (l < 128)
      s[n++] = l;
    else if (l < 2048)
      s[n++] = 192 | l >> 6 & 31, s[n++] = 128 | l & 63;
    else if (l >= 55296 && l < 57344) {
      l = (l & 1023) + 64;
      var c = t.charCodeAt(++o) & 1023;
      s[n++] = 240 | l >> 8 & 7, s[n++] = 128 | l >> 2 & 63, s[n++] = 128 | c >> 6 & 15 | (l & 3) << 4, s[n++] = 128 | c & 63;
    } else
      s[n++] = 224 | l >> 12 & 15, s[n++] = 128 | l >> 6 & 63, s[n++] = 128 | l & 63;
    n > a && (e.push(s.slice(0, n)), n = 0, s = new_raw_buf(65535), a = 65530);
  }
  return e.push(s.slice(0, n)), bconcat(e);
}
var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
function _strrev(t) {
  for (var e = "", n = t.length - 1; n >= 0; )
    e += t.charAt(n--);
  return e;
}
function pad0(t, e) {
  var n = "" + t;
  return n.length >= e ? n : fill("0", e - n.length) + n;
}
function pad_(t, e) {
  var n = "" + t;
  return n.length >= e ? n : fill(" ", e - n.length) + n;
}
function rpad_(t, e) {
  var n = "" + t;
  return n.length >= e ? n : n + fill(" ", e - n.length);
}
function pad0r1(t, e) {
  var n = "" + Math.round(t);
  return n.length >= e ? n : fill("0", e - n.length) + n;
}
function pad0r2(t, e) {
  var n = "" + t;
  return n.length >= e ? n : fill("0", e - n.length) + n;
}
var p2_32 = /* @__PURE__ */ Math.pow(2, 32);
function pad0r(t, e) {
  if (t > p2_32 || t < -p2_32)
    return pad0r1(t, e);
  var n = Math.round(t);
  return pad0r2(n, e);
}
function SSF_isgeneral(t, e) {
  return e = e || 0, t.length >= 7 + e && (t.charCodeAt(e) | 32) === 103 && (t.charCodeAt(e + 1) | 32) === 101 && (t.charCodeAt(e + 2) | 32) === 110 && (t.charCodeAt(e + 3) | 32) === 101 && (t.charCodeAt(e + 4) | 32) === 114 && (t.charCodeAt(e + 5) | 32) === 97 && (t.charCodeAt(e + 6) | 32) === 108;
}
var days = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], months = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function SSF_init_table(t) {
  return t || (t = {}), t[0] = "General", t[1] = "0", t[2] = "0.00", t[3] = "#,##0", t[4] = "#,##0.00", t[9] = "0%", t[10] = "0.00%", t[11] = "0.00E+00", t[12] = "# ?/?", t[13] = "# ??/??", t[14] = "m/d/yy", t[15] = "d-mmm-yy", t[16] = "d-mmm", t[17] = "mmm-yy", t[18] = "h:mm AM/PM", t[19] = "h:mm:ss AM/PM", t[20] = "h:mm", t[21] = "h:mm:ss", t[22] = "m/d/yy h:mm", t[37] = "#,##0 ;(#,##0)", t[38] = "#,##0 ;[Red](#,##0)", t[39] = "#,##0.00;(#,##0.00)", t[40] = "#,##0.00;[Red](#,##0.00)", t[45] = "mm:ss", t[46] = "[h]:mm:ss", t[47] = "mmss.0", t[48] = "##0.0E+0", t[49] = "@", t[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', t;
}
var table_fmt = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, SSF_default_map = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, SSF_default_str = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function SSF_frac(t, e, n) {
  for (var a = t < 0 ? -1 : 1, s = t * a, o = 0, l = 1, c = 0, u = 1, d = 0, f = 0, h = Math.floor(s); d < e && (h = Math.floor(s), c = h * l + o, f = h * d + u, !(s - h < 5e-8)); )
    s = 1 / (s - h), o = l, l = c, u = d, d = f;
  if (f > e && (d > e ? (f = u, c = o) : (f = d, c = l)), !n)
    return [0, a * c, f];
  var g = Math.floor(a * c / f);
  return [g, a * c - g * f, f];
}
function SSF_parse_date_code(t, e, n) {
  if (t > 2958465 || t < 0)
    return null;
  var a = t | 0, s = Math.floor(86400 * (t - a)), o = 0, l = [], c = { D: a, T: s, u: 86400 * (t - a) - s, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(c.u) < 1e-6 && (c.u = 0), e && e.date1904 && (a += 1462), c.u > 0.9999 && (c.u = 0, ++s == 86400 && (c.T = s = 0, ++a, ++c.D)), a === 60)
    l = n ? [1317, 10, 29] : [1900, 2, 29], o = 3;
  else if (a === 0)
    l = n ? [1317, 8, 29] : [1900, 1, 0], o = 6;
  else {
    a > 60 && --a;
    var u = new Date(1900, 0, 1);
    u.setDate(u.getDate() + a - 1), l = [u.getFullYear(), u.getMonth() + 1, u.getDate()], o = u.getDay(), a < 60 && (o = (o + 6) % 7), n && (o = SSF_fix_hijri(u, l));
  }
  return c.y = l[0], c.m = l[1], c.d = l[2], c.S = s % 60, s = Math.floor(s / 60), c.M = s % 60, s = Math.floor(s / 60), c.H = s, c.q = o, c;
}
var SSFbasedate = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), SSFdnthresh = /* @__PURE__ */ SSFbasedate.getTime(), SSFbase1904 = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(t, e) {
  var n = /* @__PURE__ */ t.getTime();
  return e ? n -= 1461 * 24 * 60 * 60 * 1e3 : t >= SSFbase1904 && (n += 24 * 60 * 60 * 1e3), (n - (SSFdnthresh + (/* @__PURE__ */ t.getTimezoneOffset() - /* @__PURE__ */ SSFbasedate.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function SSF_strip_decimal(t) {
  return t.indexOf(".") == -1 ? t : t.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function SSF_normalize_exp(t) {
  return t.indexOf("E") == -1 ? t : t.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function SSF_small_exp(t) {
  var e = t < 0 ? 12 : 11, n = SSF_strip_decimal(t.toFixed(12));
  return n.length <= e || (n = t.toPrecision(10), n.length <= e) ? n : t.toExponential(5);
}
function SSF_large_exp(t) {
  var e = SSF_strip_decimal(t.toFixed(11));
  return e.length > (t < 0 ? 12 : 11) || e === "0" || e === "-0" ? t.toPrecision(6) : e;
}
function SSF_general_num(t) {
  var e = Math.floor(Math.log(Math.abs(t)) * Math.LOG10E), n;
  return e >= -4 && e <= -1 ? n = t.toPrecision(10 + e) : Math.abs(e) <= 9 ? n = SSF_small_exp(t) : e === 10 ? n = t.toFixed(10).substr(0, 12) : n = SSF_large_exp(t), SSF_strip_decimal(SSF_normalize_exp(n.toUpperCase()));
}
function SSF_general(t, e) {
  switch (typeof t) {
    case "string":
      return t;
    case "boolean":
      return t ? "TRUE" : "FALSE";
    case "number":
      return (t | 0) === t ? t.toString(10) : SSF_general_num(t);
    case "undefined":
      return "";
    case "object":
      if (t == null)
        return "";
      if (t instanceof Date)
        return SSF_format(14, datenum_local(t, e && e.date1904), e);
  }
  throw new Error("unsupported value in General format: " + t);
}
function SSF_fix_hijri(t, e) {
  e[0] -= 581;
  var n = t.getDay();
  return t < 60 && (n = (n + 6) % 7), n;
}
function SSF_write_date(t, e, n, a) {
  var s = "", o = 0, l = 0, c = n.y, u, d = 0;
  switch (t) {
    case 98:
      c = n.y + 543;
    case 121:
      switch (e.length) {
        case 1:
        case 2:
          u = c % 100, d = 2;
          break;
        default:
          u = c % 1e4, d = 4;
          break;
      }
      break;
    case 109:
      switch (e.length) {
        case 1:
        case 2:
          u = n.m, d = e.length;
          break;
        case 3:
          return months[n.m - 1][1];
        case 5:
          return months[n.m - 1][0];
        default:
          return months[n.m - 1][2];
      }
      break;
    case 100:
      switch (e.length) {
        case 1:
        case 2:
          u = n.d, d = e.length;
          break;
        case 3:
          return days[n.q][0];
        default:
          return days[n.q][1];
      }
      break;
    case 104:
      switch (e.length) {
        case 1:
        case 2:
          u = 1 + (n.H + 11) % 12, d = e.length;
          break;
        default:
          throw "bad hour format: " + e;
      }
      break;
    case 72:
      switch (e.length) {
        case 1:
        case 2:
          u = n.H, d = e.length;
          break;
        default:
          throw "bad hour format: " + e;
      }
      break;
    case 77:
      switch (e.length) {
        case 1:
        case 2:
          u = n.M, d = e.length;
          break;
        default:
          throw "bad minute format: " + e;
      }
      break;
    case 115:
      if (e != "s" && e != "ss" && e != ".0" && e != ".00" && e != ".000")
        throw "bad second format: " + e;
      return n.u === 0 && (e == "s" || e == "ss") ? pad0(n.S, e.length) : (a >= 2 ? l = a === 3 ? 1e3 : 100 : l = a === 1 ? 10 : 1, o = Math.round(l * (n.S + n.u)), o >= 60 * l && (o = 0), e === "s" ? o === 0 ? "0" : "" + o / l : (s = pad0(o, 2 + a), e === "ss" ? s.substr(0, 2) : "." + s.substr(2, e.length - 1)));
    case 90:
      switch (e) {
        case "[h]":
        case "[hh]":
          u = n.D * 24 + n.H;
          break;
        case "[m]":
        case "[mm]":
          u = (n.D * 24 + n.H) * 60 + n.M;
          break;
        case "[s]":
        case "[ss]":
          u = ((n.D * 24 + n.H) * 60 + n.M) * 60 + Math.round(n.S + n.u);
          break;
        default:
          throw "bad abstime format: " + e;
      }
      d = e.length === 3 ? 1 : 2;
      break;
    case 101:
      u = c, d = 1;
      break;
  }
  var f = d > 0 ? pad0(u, d) : "";
  return f;
}
function commaify(t) {
  var e = 3;
  if (t.length <= e)
    return t;
  for (var n = t.length % e, a = t.substr(0, n); n != t.length; n += e)
    a += (a.length > 0 ? "," : "") + t.substr(n, e);
  return a;
}
var pct1 = /%/g;
function write_num_pct(t, e, n) {
  var a = e.replace(pct1, ""), s = e.length - a.length;
  return write_num(t, a, n * Math.pow(10, 2 * s)) + fill("%", s);
}
function write_num_cm(t, e, n) {
  for (var a = e.length - 1; e.charCodeAt(a - 1) === 44; )
    --a;
  return write_num(t, e.substr(0, a), n / Math.pow(10, 3 * (e.length - a)));
}
function write_num_exp(t, e) {
  var n, a = t.indexOf("E") - t.indexOf(".") - 1;
  if (t.match(/^#+0.0E\+0$/)) {
    if (e == 0)
      return "0.0E+0";
    if (e < 0)
      return "-" + write_num_exp(t, -e);
    var s = t.indexOf(".");
    s === -1 && (s = t.indexOf("E"));
    var o = Math.floor(Math.log(e) * Math.LOG10E) % s;
    if (o < 0 && (o += s), n = (e / Math.pow(10, o)).toPrecision(a + 1 + (s + o) % s), n.indexOf("e") === -1) {
      var l = Math.floor(Math.log(e) * Math.LOG10E);
      for (n.indexOf(".") === -1 ? n = n.charAt(0) + "." + n.substr(1) + "E+" + (l - n.length + o) : n += "E+" + (l - o); n.substr(0, 2) === "0."; )
        n = n.charAt(0) + n.substr(2, s) + "." + n.substr(2 + s), n = n.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      n = n.replace(/\+-/, "-");
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(c, u, d, f) {
      return u + d + f.substr(0, (s + o) % s) + "." + f.substr(o) + "E";
    });
  } else
    n = e.toExponential(a);
  return t.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + "0" + n.charAt(n.length - 1)), t.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, "e")), n.replace("e", "E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(t, e, n) {
  var a = parseInt(t[4], 10), s = Math.round(e * a), o = Math.floor(s / a), l = s - o * a, c = a;
  return n + (o === 0 ? "" : "" + o) + " " + (l === 0 ? fill(" ", t[1].length + 1 + t[4].length) : pad_(l, t[1].length) + t[2] + "/" + t[3] + pad0(c, t[4].length));
}
function write_num_f2(t, e, n) {
  return n + (e === 0 ? "" : "" + e) + fill(" ", t[1].length + 2 + t[4].length);
}
var dec1 = /^#*0*\.([0#]+)/, closeparen = /\).*[0#]/, phone = /\(###\) ###\\?-####/;
function hashq(t) {
  for (var e = "", n, a = 0; a != t.length; ++a)
    switch (n = t.charCodeAt(a)) {
      case 35:
        break;
      case 63:
        e += " ";
        break;
      case 48:
        e += "0";
        break;
      default:
        e += String.fromCharCode(n);
    }
  return e;
}
function rnd(t, e) {
  var n = Math.pow(10, e);
  return "" + Math.round(t * n) / n;
}
function dec(t, e) {
  var n = t - Math.floor(t), a = Math.pow(10, e);
  return e < ("" + Math.round(n * a)).length ? 0 : Math.round(n * a);
}
function carry(t, e) {
  return e < ("" + Math.round((t - Math.floor(t)) * Math.pow(10, e))).length ? 1 : 0;
}
function flr(t) {
  return t < 2147483647 && t > -2147483648 ? "" + (t >= 0 ? t | 0 : t - 1 | 0) : "" + Math.floor(t);
}
function write_num_flt(t, e, n) {
  if (t.charCodeAt(0) === 40 && !e.match(closeparen)) {
    var a = e.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return n >= 0 ? write_num_flt("n", a, n) : "(" + write_num_flt("n", a, -n) + ")";
  }
  if (e.charCodeAt(e.length - 1) === 44)
    return write_num_cm(t, e, n);
  if (e.indexOf("%") !== -1)
    return write_num_pct(t, e, n);
  if (e.indexOf("E") !== -1)
    return write_num_exp(e, n);
  if (e.charCodeAt(0) === 36)
    return "$" + write_num_flt(t, e.substr(e.charAt(1) == " " ? 2 : 1), n);
  var s, o, l, c, u = Math.abs(n), d = n < 0 ? "-" : "";
  if (e.match(/^00+$/))
    return d + pad0r(u, e.length);
  if (e.match(/^[#?]+$/))
    return s = pad0r(n, 0), s === "0" && (s = ""), s.length > e.length ? s : hashq(e.substr(0, e.length - s.length)) + s;
  if (o = e.match(frac1))
    return write_num_f1(o, u, d);
  if (e.match(/^#+0+$/))
    return d + pad0r(u, e.length - e.indexOf("0"));
  if (o = e.match(dec1))
    return s = rnd(n, o[1].length).replace(/^([^\.]+)$/, "$1." + hashq(o[1])).replace(/\.$/, "." + hashq(o[1])).replace(/\.(\d*)$/, function(E, m) {
      return "." + m + fill("0", hashq(
        /*::(*/
        o[1]
      ).length - m.length);
    }), e.indexOf("0.") !== -1 ? s : s.replace(/^0\./, ".");
  if (e = e.replace(/^#+([0.])/, "$1"), o = e.match(/^(0*)\.(#*)$/))
    return d + rnd(u, o[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, o[1].length ? "0." : ".");
  if (o = e.match(/^#{1,3},##0(\.?)$/))
    return d + commaify(pad0r(u, 0));
  if (o = e.match(/^#,##0\.([#0]*0)$/))
    return n < 0 ? "-" + write_num_flt(t, e, -n) : commaify("" + (Math.floor(n) + carry(n, o[1].length))) + "." + pad0(dec(n, o[1].length), o[1].length);
  if (o = e.match(/^#,#*,#0/))
    return write_num_flt(t, e.replace(/^#,#*,/, ""), n);
  if (o = e.match(/^([0#]+)(\\?-([0#]+))+$/))
    return s = _strrev(write_num_flt(t, e.replace(/[\\-]/g, ""), n)), l = 0, _strrev(_strrev(e.replace(/\\/g, "")).replace(/[0#]/g, function(E) {
      return l < s.length ? s.charAt(l++) : E === "0" ? "0" : "";
    }));
  if (e.match(phone))
    return s = write_num_flt(t, "##########", n), "(" + s.substr(0, 3) + ") " + s.substr(3, 3) + "-" + s.substr(6);
  var f = "";
  if (o = e.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return l = Math.min(
      /*::String(*/
      o[4].length,
      7
    ), c = SSF_frac(u, Math.pow(10, l) - 1, !1), s = "" + d, f = write_num(
      "n",
      /*::String(*/
      o[1],
      c[1]
    ), f.charAt(f.length - 1) == " " && (f = f.substr(0, f.length - 1) + "0"), s += f + /*::String(*/
    o[2] + "/" + /*::String(*/
    o[3], f = rpad_(c[2], l), f.length < o[4].length && (f = hashq(o[4].substr(o[4].length - f.length)) + f), s += f, s;
  if (o = e.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return l = Math.min(Math.max(o[1].length, o[4].length), 7), c = SSF_frac(u, Math.pow(10, l) - 1, !0), d + (c[0] || (c[1] ? "" : "0")) + " " + (c[1] ? pad_(c[1], l) + o[2] + "/" + o[3] + rpad_(c[2], l) : fill(" ", 2 * l + 1 + o[2].length + o[3].length));
  if (o = e.match(/^[#0?]+$/))
    return s = pad0r(n, 0), e.length <= s.length ? s : hashq(e.substr(0, e.length - s.length)) + s;
  if (o = e.match(/^([#0?]+)\.([#0]+)$/)) {
    s = "" + n.toFixed(Math.min(o[2].length, 10)).replace(/([^0])0+$/, "$1"), l = s.indexOf(".");
    var h = e.indexOf(".") - l, g = e.length - s.length - h;
    return hashq(e.substr(0, h) + s + e.substr(e.length - g));
  }
  if (o = e.match(/^00,000\.([#0]*0)$/))
    return l = dec(n, o[1].length), n < 0 ? "-" + write_num_flt(t, e, -n) : commaify(flr(n)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(E) {
      return "00," + (E.length < 3 ? pad0(0, 3 - E.length) : "") + E;
    }) + "." + pad0(l, o[1].length);
  switch (e) {
    case "###,##0.00":
      return write_num_flt(t, "#,##0.00", n);
    case "###,###":
    case "##,###":
    case "#,###":
      var x = commaify(pad0r(u, 0));
      return x !== "0" ? d + x : "";
    case "###,###.00":
      return write_num_flt(t, "###,##0.00", n).replace(/^0\./, ".");
    case "#,###.00":
      return write_num_flt(t, "#,##0.00", n).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + e + "|");
}
function write_num_cm2(t, e, n) {
  for (var a = e.length - 1; e.charCodeAt(a - 1) === 44; )
    --a;
  return write_num(t, e.substr(0, a), n / Math.pow(10, 3 * (e.length - a)));
}
function write_num_pct2(t, e, n) {
  var a = e.replace(pct1, ""), s = e.length - a.length;
  return write_num(t, a, n * Math.pow(10, 2 * s)) + fill("%", s);
}
function write_num_exp2(t, e) {
  var n, a = t.indexOf("E") - t.indexOf(".") - 1;
  if (t.match(/^#+0.0E\+0$/)) {
    if (e == 0)
      return "0.0E+0";
    if (e < 0)
      return "-" + write_num_exp2(t, -e);
    var s = t.indexOf(".");
    s === -1 && (s = t.indexOf("E"));
    var o = Math.floor(Math.log(e) * Math.LOG10E) % s;
    if (o < 0 && (o += s), n = (e / Math.pow(10, o)).toPrecision(a + 1 + (s + o) % s), !n.match(/[Ee]/)) {
      var l = Math.floor(Math.log(e) * Math.LOG10E);
      n.indexOf(".") === -1 ? n = n.charAt(0) + "." + n.substr(1) + "E+" + (l - n.length + o) : n += "E+" + (l - o), n = n.replace(/\+-/, "-");
    }
    n = n.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(c, u, d, f) {
      return u + d + f.substr(0, (s + o) % s) + "." + f.substr(o) + "E";
    });
  } else
    n = e.toExponential(a);
  return t.match(/E\+00$/) && n.match(/e[+-]\d$/) && (n = n.substr(0, n.length - 1) + "0" + n.charAt(n.length - 1)), t.match(/E\-/) && n.match(/e\+/) && (n = n.replace(/e\+/, "e")), n.replace("e", "E");
}
function write_num_int(t, e, n) {
  if (t.charCodeAt(0) === 40 && !e.match(closeparen)) {
    var a = e.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return n >= 0 ? write_num_int("n", a, n) : "(" + write_num_int("n", a, -n) + ")";
  }
  if (e.charCodeAt(e.length - 1) === 44)
    return write_num_cm2(t, e, n);
  if (e.indexOf("%") !== -1)
    return write_num_pct2(t, e, n);
  if (e.indexOf("E") !== -1)
    return write_num_exp2(e, n);
  if (e.charCodeAt(0) === 36)
    return "$" + write_num_int(t, e.substr(e.charAt(1) == " " ? 2 : 1), n);
  var s, o, l, c, u = Math.abs(n), d = n < 0 ? "-" : "";
  if (e.match(/^00+$/))
    return d + pad0(u, e.length);
  if (e.match(/^[#?]+$/))
    return s = "" + n, n === 0 && (s = ""), s.length > e.length ? s : hashq(e.substr(0, e.length - s.length)) + s;
  if (o = e.match(frac1))
    return write_num_f2(o, u, d);
  if (e.match(/^#+0+$/))
    return d + pad0(u, e.length - e.indexOf("0"));
  if (o = e.match(dec1))
    return s = ("" + n).replace(/^([^\.]+)$/, "$1." + hashq(o[1])).replace(/\.$/, "." + hashq(o[1])), s = s.replace(/\.(\d*)$/, function(E, m) {
      return "." + m + fill("0", hashq(o[1]).length - m.length);
    }), e.indexOf("0.") !== -1 ? s : s.replace(/^0\./, ".");
  if (e = e.replace(/^#+([0.])/, "$1"), o = e.match(/^(0*)\.(#*)$/))
    return d + ("" + u).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, o[1].length ? "0." : ".");
  if (o = e.match(/^#{1,3},##0(\.?)$/))
    return d + commaify("" + u);
  if (o = e.match(/^#,##0\.([#0]*0)$/))
    return n < 0 ? "-" + write_num_int(t, e, -n) : commaify("" + n) + "." + fill("0", o[1].length);
  if (o = e.match(/^#,#*,#0/))
    return write_num_int(t, e.replace(/^#,#*,/, ""), n);
  if (o = e.match(/^([0#]+)(\\?-([0#]+))+$/))
    return s = _strrev(write_num_int(t, e.replace(/[\\-]/g, ""), n)), l = 0, _strrev(_strrev(e.replace(/\\/g, "")).replace(/[0#]/g, function(E) {
      return l < s.length ? s.charAt(l++) : E === "0" ? "0" : "";
    }));
  if (e.match(phone))
    return s = write_num_int(t, "##########", n), "(" + s.substr(0, 3) + ") " + s.substr(3, 3) + "-" + s.substr(6);
  var f = "";
  if (o = e.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return l = Math.min(
      /*::String(*/
      o[4].length,
      7
    ), c = SSF_frac(u, Math.pow(10, l) - 1, !1), s = "" + d, f = write_num(
      "n",
      /*::String(*/
      o[1],
      c[1]
    ), f.charAt(f.length - 1) == " " && (f = f.substr(0, f.length - 1) + "0"), s += f + /*::String(*/
    o[2] + "/" + /*::String(*/
    o[3], f = rpad_(c[2], l), f.length < o[4].length && (f = hashq(o[4].substr(o[4].length - f.length)) + f), s += f, s;
  if (o = e.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return l = Math.min(Math.max(o[1].length, o[4].length), 7), c = SSF_frac(u, Math.pow(10, l) - 1, !0), d + (c[0] || (c[1] ? "" : "0")) + " " + (c[1] ? pad_(c[1], l) + o[2] + "/" + o[3] + rpad_(c[2], l) : fill(" ", 2 * l + 1 + o[2].length + o[3].length));
  if (o = e.match(/^[#0?]+$/))
    return s = "" + n, e.length <= s.length ? s : hashq(e.substr(0, e.length - s.length)) + s;
  if (o = e.match(/^([#0]+)\.([#0]+)$/)) {
    s = "" + n.toFixed(Math.min(o[2].length, 10)).replace(/([^0])0+$/, "$1"), l = s.indexOf(".");
    var h = e.indexOf(".") - l, g = e.length - s.length - h;
    return hashq(e.substr(0, h) + s + e.substr(e.length - g));
  }
  if (o = e.match(/^00,000\.([#0]*0)$/))
    return n < 0 ? "-" + write_num_int(t, e, -n) : commaify("" + n).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(E) {
      return "00," + (E.length < 3 ? pad0(0, 3 - E.length) : "") + E;
    }) + "." + pad0(0, o[1].length);
  switch (e) {
    case "###,###":
    case "##,###":
    case "#,###":
      var x = commaify("" + u);
      return x !== "0" ? d + x : "";
    default:
      if (e.match(/\.[0#?]*$/))
        return write_num_int(t, e.slice(0, e.lastIndexOf(".")), n) + hashq(e.slice(e.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + e + "|");
}
function write_num(t, e, n) {
  return (n | 0) === n ? write_num_int(t, e, n) : write_num_flt(t, e, n);
}
function SSF_split_fmt(t) {
  for (var e = [], n = !1, a = 0, s = 0; a < t.length; ++a)
    switch (
      /*cc=*/
      t.charCodeAt(a)
    ) {
      case 34:
        n = !n;
        break;
      case 95:
      case 42:
      case 92:
        ++a;
        break;
      case 59:
        e[e.length] = t.substr(s, a - s), s = a + 1;
    }
  if (e[e.length] = t.substr(s), n === !0)
    throw new Error("Format |" + t + "| unterminated string ");
  return e;
}
var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(t) {
  for (var e = 0, n = "", a = ""; e < t.length; )
    switch (n = t.charAt(e)) {
      case "G":
        SSF_isgeneral(t, e) && (e += 6), e++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          t.charCodeAt(++e) !== 34 && e < t.length;
        )
          ;
        ++e;
        break;
      case "\\":
        e += 2;
        break;
      case "_":
        e += 2;
        break;
      case "@":
        ++e;
        break;
      case "B":
      case "b":
        if (t.charAt(e + 1) === "1" || t.charAt(e + 1) === "2")
          return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (t.substr(e, 3).toUpperCase() === "A/P" || t.substr(e, 5).toUpperCase() === "AM/PM" || t.substr(e, 5).toUpperCase() === "上午/下午")
          return !0;
        ++e;
        break;
      case "[":
        for (a = n; t.charAt(e++) !== "]" && e < t.length; )
          a += t.charAt(e);
        if (a.match(SSF_abstime))
          return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; e < t.length && ("0#?.,E+-%".indexOf(n = t.charAt(++e)) > -1 || n == "\\" && t.charAt(e + 1) == "-" && "0#".indexOf(t.charAt(e + 2)) > -1); )
          ;
        break;
      case "?":
        for (; t.charAt(++e) === n; )
          ;
        break;
      case "*":
        ++e, (t.charAt(e) == " " || t.charAt(e) == "*") && ++e;
        break;
      case "(":
      case ")":
        ++e;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; e < t.length && "0123456789".indexOf(t.charAt(++e)) > -1; )
          ;
        break;
      case " ":
        ++e;
        break;
      default:
        ++e;
        break;
    }
  return !1;
}
function eval_fmt(t, e, n, a) {
  for (var s = [], o = "", l = 0, c = "", u = "t", d, f, h, g = "H"; l < t.length; )
    switch (c = t.charAt(l)) {
      case "G":
        if (!SSF_isgeneral(t, l))
          throw new Error("unrecognized character " + c + " in " + t);
        s[s.length] = { t: "G", v: "General" }, l += 7;
        break;
      case '"':
        for (o = ""; (h = t.charCodeAt(++l)) !== 34 && l < t.length; )
          o += String.fromCharCode(h);
        s[s.length] = { t: "t", v: o }, ++l;
        break;
      case "\\":
        var x = t.charAt(++l), E = x === "(" || x === ")" ? x : "t";
        s[s.length] = { t: E, v: x }, ++l;
        break;
      case "_":
        s[s.length] = { t: "t", v: " " }, l += 2;
        break;
      case "@":
        s[s.length] = { t: "T", v: e }, ++l;
        break;
      case "B":
      case "b":
        if (t.charAt(l + 1) === "1" || t.charAt(l + 1) === "2") {
          if (d == null && (d = SSF_parse_date_code(e, n, t.charAt(l + 1) === "2"), d == null))
            return "";
          s[s.length] = { t: "X", v: t.substr(l, 2) }, u = c, l += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        c = c.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (e < 0 || d == null && (d = SSF_parse_date_code(e, n), d == null))
          return "";
        for (o = c; ++l < t.length && t.charAt(l).toLowerCase() === c; )
          o += c;
        c === "m" && u.toLowerCase() === "h" && (c = "M"), c === "h" && (c = g), s[s.length] = { t: c, v: o }, u = c;
        break;
      case "A":
      case "a":
      case "上":
        var m = { t: c, v: c };
        if (d == null && (d = SSF_parse_date_code(e, n)), t.substr(l, 3).toUpperCase() === "A/P" ? (d != null && (m.v = d.H >= 12 ? "P" : "A"), m.t = "T", g = "h", l += 3) : t.substr(l, 5).toUpperCase() === "AM/PM" ? (d != null && (m.v = d.H >= 12 ? "PM" : "AM"), m.t = "T", l += 5, g = "h") : t.substr(l, 5).toUpperCase() === "上午/下午" ? (d != null && (m.v = d.H >= 12 ? "下午" : "上午"), m.t = "T", l += 5, g = "h") : (m.t = "t", ++l), d == null && m.t === "T")
          return "";
        s[s.length] = m, u = c;
        break;
      case "[":
        for (o = c; t.charAt(l++) !== "]" && l < t.length; )
          o += t.charAt(l);
        if (o.slice(-1) !== "]")
          throw 'unterminated "[" block: |' + o + "|";
        if (o.match(SSF_abstime)) {
          if (d == null && (d = SSF_parse_date_code(e, n), d == null))
            return "";
          s[s.length] = { t: "Z", v: o.toLowerCase() }, u = o.charAt(1);
        } else
          o.indexOf("$") > -1 && (o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$", fmt_is_date(t) || (s[s.length] = { t: "t", v: o }));
        break;
      case ".":
        if (d != null) {
          for (o = c; ++l < t.length && (c = t.charAt(l)) === "0"; )
            o += c;
          s[s.length] = { t: "s", v: o };
          break;
        }
      case "0":
      case "#":
        for (o = c; ++l < t.length && "0#?.,E+-%".indexOf(c = t.charAt(l)) > -1; )
          o += c;
        s[s.length] = { t: "n", v: o };
        break;
      case "?":
        for (o = c; t.charAt(++l) === c; )
          o += c;
        s[s.length] = { t: c, v: o }, u = c;
        break;
      case "*":
        ++l, (t.charAt(l) == " " || t.charAt(l) == "*") && ++l;
        break;
      case "(":
      case ")":
        s[s.length] = { t: a === 1 ? "t" : c, v: c }, ++l;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (o = c; l < t.length && "0123456789".indexOf(t.charAt(++l)) > -1; )
          o += t.charAt(l);
        s[s.length] = { t: "D", v: o };
        break;
      case " ":
        s[s.length] = { t: c, v: c }, ++l;
        break;
      case "$":
        s[s.length] = { t: "t", v: "$" }, ++l;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1)
          throw new Error("unrecognized character " + c + " in " + t);
        s[s.length] = { t: "t", v: c }, ++l;
        break;
    }
  var v = 0, y = 0, A;
  for (l = s.length - 1, u = "t"; l >= 0; --l)
    switch (s[l].t) {
      case "h":
      case "H":
        s[l].t = g, u = "h", v < 1 && (v = 1);
        break;
      case "s":
        (A = s[l].v.match(/\.0+$/)) && (y = Math.max(y, A[0].length - 1)), v < 3 && (v = 3);
      case "d":
      case "y":
      case "M":
      case "e":
        u = s[l].t;
        break;
      case "m":
        u === "s" && (s[l].t = "M", v < 2 && (v = 2));
        break;
      case "X":
        break;
      case "Z":
        v < 1 && s[l].v.match(/[Hh]/) && (v = 1), v < 2 && s[l].v.match(/[Mm]/) && (v = 2), v < 3 && s[l].v.match(/[Ss]/) && (v = 3);
    }
  switch (v) {
    case 0:
      break;
    case 1:
      d.u >= 0.5 && (d.u = 0, ++d.S), d.S >= 60 && (d.S = 0, ++d.M), d.M >= 60 && (d.M = 0, ++d.H);
      break;
    case 2:
      d.u >= 0.5 && (d.u = 0, ++d.S), d.S >= 60 && (d.S = 0, ++d.M);
      break;
  }
  var b = "", C;
  for (l = 0; l < s.length; ++l)
    switch (s[l].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        s[l].v = "", s[l].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        s[l].v = SSF_write_date(s[l].t.charCodeAt(0), s[l].v, d, y), s[l].t = "t";
        break;
      case "n":
      case "?":
        for (C = l + 1; s[C] != null && ((c = s[C].t) === "?" || c === "D" || (c === " " || c === "t") && s[C + 1] != null && (s[C + 1].t === "?" || s[C + 1].t === "t" && s[C + 1].v === "/") || s[l].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (s[C].v === "/" || s[C].v === " " && s[C + 1] != null && s[C + 1].t == "?")); )
          s[l].v += s[C].v, s[C] = { v: "", t: ";" }, ++C;
        b += s[l].v, l = C - 1;
        break;
      case "G":
        s[l].t = "t", s[l].v = SSF_general(e, n);
        break;
    }
  var T = "", w, R;
  if (b.length > 0) {
    b.charCodeAt(0) == 40 ? (w = e < 0 && b.charCodeAt(0) === 45 ? -e : e, R = write_num("n", b, w)) : (w = e < 0 && a > 1 ? -e : e, R = write_num("n", b, w), w < 0 && s[0] && s[0].t == "t" && (R = R.substr(1), s[0].v = "-" + s[0].v)), C = R.length - 1;
    var O = s.length;
    for (l = 0; l < s.length; ++l)
      if (s[l] != null && s[l].t != "t" && s[l].v.indexOf(".") > -1) {
        O = l;
        break;
      }
    var D = s.length;
    if (O === s.length && R.indexOf("E") === -1) {
      for (l = s.length - 1; l >= 0; --l)
        s[l] == null || "n?".indexOf(s[l].t) === -1 || (C >= s[l].v.length - 1 ? (C -= s[l].v.length, s[l].v = R.substr(C + 1, s[l].v.length)) : C < 0 ? s[l].v = "" : (s[l].v = R.substr(0, C + 1), C = -1), s[l].t = "t", D = l);
      C >= 0 && D < s.length && (s[D].v = R.substr(0, C + 1) + s[D].v);
    } else if (O !== s.length && R.indexOf("E") === -1) {
      for (C = R.indexOf(".") - 1, l = O; l >= 0; --l)
        if (!(s[l] == null || "n?".indexOf(s[l].t) === -1)) {
          for (f = s[l].v.indexOf(".") > -1 && l === O ? s[l].v.indexOf(".") - 1 : s[l].v.length - 1, T = s[l].v.substr(f + 1); f >= 0; --f)
            C >= 0 && (s[l].v.charAt(f) === "0" || s[l].v.charAt(f) === "#") && (T = R.charAt(C--) + T);
          s[l].v = T, s[l].t = "t", D = l;
        }
      for (C >= 0 && D < s.length && (s[D].v = R.substr(0, C + 1) + s[D].v), C = R.indexOf(".") + 1, l = O; l < s.length; ++l)
        if (!(s[l] == null || "n?(".indexOf(s[l].t) === -1 && l !== O)) {
          for (f = s[l].v.indexOf(".") > -1 && l === O ? s[l].v.indexOf(".") + 1 : 0, T = s[l].v.substr(0, f); f < s[l].v.length; ++f)
            C < R.length && (T += R.charAt(C++));
          s[l].v = T, s[l].t = "t", D = l;
        }
    }
  }
  for (l = 0; l < s.length; ++l)
    s[l] != null && "n?".indexOf(s[l].t) > -1 && (w = a > 1 && e < 0 && l > 0 && s[l - 1].v === "-" ? -e : e, s[l].v = write_num(s[l].t, s[l].v, w), s[l].t = "t");
  var k = "";
  for (l = 0; l !== s.length; ++l)
    s[l] != null && (k += s[l].v);
  return k;
}
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(t, e) {
  if (e == null)
    return !1;
  var n = parseFloat(e[2]);
  switch (e[1]) {
    case "=":
      if (t == n)
        return !0;
      break;
    case ">":
      if (t > n)
        return !0;
      break;
    case "<":
      if (t < n)
        return !0;
      break;
    case "<>":
      if (t != n)
        return !0;
      break;
    case ">=":
      if (t >= n)
        return !0;
      break;
    case "<=":
      if (t <= n)
        return !0;
      break;
  }
  return !1;
}
function choose_fmt(t, e) {
  var n = SSF_split_fmt(t), a = n.length, s = n[a - 1].indexOf("@");
  if (a < 4 && s > -1 && --a, n.length > 4)
    throw new Error("cannot find right format for |" + n.join("|") + "|");
  if (typeof e != "number")
    return [4, n.length === 4 || s > -1 ? n[n.length - 1] : "@"];
  switch (n.length) {
    case 1:
      n = s > -1 ? ["General", "General", "General", n[0]] : [n[0], n[0], n[0], "@"];
      break;
    case 2:
      n = s > -1 ? [n[0], n[0], n[0], n[1]] : [n[0], n[1], n[0], "@"];
      break;
    case 3:
      n = s > -1 ? [n[0], n[1], n[0], n[2]] : [n[0], n[1], n[2], "@"];
      break;
  }
  var o = e > 0 ? n[0] : e < 0 ? n[1] : n[2];
  if (n[0].indexOf("[") === -1 && n[1].indexOf("[") === -1)
    return [a, o];
  if (n[0].match(/\[[=<>]/) != null || n[1].match(/\[[=<>]/) != null) {
    var l = n[0].match(cfregex2), c = n[1].match(cfregex2);
    return chkcond(e, l) ? [a, n[0]] : chkcond(e, c) ? [a, n[1]] : [a, n[l != null && c != null ? 2 : 1]];
  }
  return [a, o];
}
function SSF_format(t, e, n) {
  n == null && (n = {});
  var a = "";
  switch (typeof t) {
    case "string":
      t == "m/d/yy" && n.dateNF ? a = n.dateNF : a = t;
      break;
    case "number":
      t == 14 && n.dateNF ? a = n.dateNF : a = (n.table != null ? n.table : table_fmt)[t], a == null && (a = n.table && n.table[SSF_default_map[t]] || table_fmt[SSF_default_map[t]]), a == null && (a = SSF_default_str[t] || "General");
      break;
  }
  if (SSF_isgeneral(a, 0))
    return SSF_general(e, n);
  e instanceof Date && (e = datenum_local(e, n.date1904));
  var s = choose_fmt(a, e);
  if (SSF_isgeneral(s[1]))
    return SSF_general(e, n);
  if (e === !0)
    e = "TRUE";
  else if (e === !1)
    e = "FALSE";
  else if (e === "" || e == null)
    return "";
  return eval_fmt(s[1], e, n, s[0]);
}
function SSF_load(t, e) {
  if (typeof e != "number") {
    e = +e || -1;
    for (var n = 0; n < 392; ++n) {
      if (table_fmt[n] == null) {
        e < 0 && (e = n);
        continue;
      }
      if (table_fmt[n] == t) {
        e = n;
        break;
      }
    }
    e < 0 && (e = 391);
  }
  return table_fmt[e] = t, e;
}
function make_ssf() {
  table_fmt = SSF_init_table();
}
var SSFImplicit = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(t) {
  var e = typeof t == "number" ? table_fmt[t] : t;
  return e = e.replace(dateNFregex, "(\\d+)"), new RegExp("^" + e + "$");
}
function dateNF_fix(t, e, n) {
  var a = -1, s = -1, o = -1, l = -1, c = -1, u = -1;
  (e.match(dateNFregex) || []).forEach(function(h, g) {
    var x = parseInt(n[g + 1], 10);
    switch (h.toLowerCase().charAt(0)) {
      case "y":
        a = x;
        break;
      case "d":
        o = x;
        break;
      case "h":
        l = x;
        break;
      case "s":
        u = x;
        break;
      case "m":
        l >= 0 ? c = x : s = x;
        break;
    }
  }), u >= 0 && c == -1 && s >= 0 && (c = s, s = -1);
  var d = ("" + (a >= 0 ? a : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (s >= 1 ? s : 1)).slice(-2) + "-" + ("00" + (o >= 1 ? o : 1)).slice(-2);
  d.length == 7 && (d = "0" + d), d.length == 8 && (d = "20" + d);
  var f = ("00" + (l >= 0 ? l : 0)).slice(-2) + ":" + ("00" + (c >= 0 ? c : 0)).slice(-2) + ":" + ("00" + (u >= 0 ? u : 0)).slice(-2);
  return l == -1 && c == -1 && u == -1 ? d : a == -1 && s == -1 && o == -1 ? f : d + "T" + f;
}
var CRC32 = /* @__PURE__ */ function() {
  var t = {};
  t.version = "1.2.0";
  function e() {
    for (var R = 0, O = new Array(256), D = 0; D != 256; ++D)
      R = D, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, R = R & 1 ? -306674912 ^ R >>> 1 : R >>> 1, O[D] = R;
    return typeof Int32Array < "u" ? new Int32Array(O) : O;
  }
  var n = e();
  function a(R) {
    var O = 0, D = 0, k = 0, W = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (k = 0; k != 256; ++k)
      W[k] = R[k];
    for (k = 0; k != 256; ++k)
      for (D = R[k], O = 256 + k; O < 4096; O += 256)
        D = W[O] = D >>> 8 ^ R[D & 255];
    var L = [];
    for (k = 1; k != 16; ++k)
      L[k - 1] = typeof Int32Array < "u" ? W.subarray(k * 256, k * 256 + 256) : W.slice(k * 256, k * 256 + 256);
    return L;
  }
  var s = a(n), o = s[0], l = s[1], c = s[2], u = s[3], d = s[4], f = s[5], h = s[6], g = s[7], x = s[8], E = s[9], m = s[10], v = s[11], y = s[12], A = s[13], b = s[14];
  function C(R, O) {
    for (var D = O ^ -1, k = 0, W = R.length; k < W; )
      D = D >>> 8 ^ n[(D ^ R.charCodeAt(k++)) & 255];
    return ~D;
  }
  function T(R, O) {
    for (var D = O ^ -1, k = R.length - 15, W = 0; W < k; )
      D = b[R[W++] ^ D & 255] ^ A[R[W++] ^ D >> 8 & 255] ^ y[R[W++] ^ D >> 16 & 255] ^ v[R[W++] ^ D >>> 24] ^ m[R[W++]] ^ E[R[W++]] ^ x[R[W++]] ^ g[R[W++]] ^ h[R[W++]] ^ f[R[W++]] ^ d[R[W++]] ^ u[R[W++]] ^ c[R[W++]] ^ l[R[W++]] ^ o[R[W++]] ^ n[R[W++]];
    for (k += 15; W < k; )
      D = D >>> 8 ^ n[(D ^ R[W++]) & 255];
    return ~D;
  }
  function w(R, O) {
    for (var D = O ^ -1, k = 0, W = R.length, L = 0, z = 0; k < W; )
      L = R.charCodeAt(k++), L < 128 ? D = D >>> 8 ^ n[(D ^ L) & 255] : L < 2048 ? (D = D >>> 8 ^ n[(D ^ (192 | L >> 6 & 31)) & 255], D = D >>> 8 ^ n[(D ^ (128 | L & 63)) & 255]) : L >= 55296 && L < 57344 ? (L = (L & 1023) + 64, z = R.charCodeAt(k++) & 1023, D = D >>> 8 ^ n[(D ^ (240 | L >> 8 & 7)) & 255], D = D >>> 8 ^ n[(D ^ (128 | L >> 2 & 63)) & 255], D = D >>> 8 ^ n[(D ^ (128 | z >> 6 & 15 | (L & 3) << 4)) & 255], D = D >>> 8 ^ n[(D ^ (128 | z & 63)) & 255]) : (D = D >>> 8 ^ n[(D ^ (224 | L >> 12 & 15)) & 255], D = D >>> 8 ^ n[(D ^ (128 | L >> 6 & 63)) & 255], D = D >>> 8 ^ n[(D ^ (128 | L & 63)) & 255]);
    return ~D;
  }
  return t.table = n, t.bstr = C, t.buf = T, t.str = w, t;
}(), CFB = /* @__PURE__ */ function t() {
  var e = {};
  e.version = "1.2.1";
  function n(oe, ee) {
    for (var ce = oe.split("/"), pe = ee.split("/"), be = 0, Ee = 0, He = Math.min(ce.length, pe.length); be < He; ++be) {
      if (Ee = ce[be].length - pe[be].length)
        return Ee;
      if (ce[be] != pe[be])
        return ce[be] < pe[be] ? -1 : 1;
    }
    return ce.length - pe.length;
  }
  function a(oe) {
    if (oe.charAt(oe.length - 1) == "/")
      return oe.slice(0, -1).indexOf("/") === -1 ? oe : a(oe.slice(0, -1));
    var ee = oe.lastIndexOf("/");
    return ee === -1 ? oe : oe.slice(0, ee + 1);
  }
  function s(oe) {
    if (oe.charAt(oe.length - 1) == "/")
      return s(oe.slice(0, -1));
    var ee = oe.lastIndexOf("/");
    return ee === -1 ? oe : oe.slice(ee + 1);
  }
  function o(oe, ee) {
    typeof ee == "string" && (ee = new Date(ee));
    var ce = ee.getHours();
    ce = ce << 6 | ee.getMinutes(), ce = ce << 5 | ee.getSeconds() >>> 1, oe.write_shift(2, ce);
    var pe = ee.getFullYear() - 1980;
    pe = pe << 4 | ee.getMonth() + 1, pe = pe << 5 | ee.getDate(), oe.write_shift(2, pe);
  }
  function l(oe) {
    var ee = oe.read_shift(2) & 65535, ce = oe.read_shift(2) & 65535, pe = /* @__PURE__ */ new Date(), be = ce & 31;
    ce >>>= 5;
    var Ee = ce & 15;
    ce >>>= 4, pe.setMilliseconds(0), pe.setFullYear(ce + 1980), pe.setMonth(Ee - 1), pe.setDate(be);
    var He = ee & 31;
    ee >>>= 5;
    var de = ee & 63;
    return ee >>>= 6, pe.setHours(ee), pe.setMinutes(de), pe.setSeconds(He << 1), pe;
  }
  function c(oe) {
    prep_blob(oe, 0);
    for (var ee = (
      /*::(*/
      {}
    ), ce = 0; oe.l <= oe.length - 4; ) {
      var pe = oe.read_shift(2), be = oe.read_shift(2), Ee = oe.l + be, He = {};
      switch (pe) {
        case 21589:
          ce = oe.read_shift(1), ce & 1 && (He.mtime = oe.read_shift(4)), be > 5 && (ce & 2 && (He.atime = oe.read_shift(4)), ce & 4 && (He.ctime = oe.read_shift(4))), He.mtime && (He.mt = new Date(He.mtime * 1e3));
          break;
      }
      oe.l = Ee, ee[pe] = He;
    }
    return ee;
  }
  var u;
  function d() {
    return u || (u = {});
  }
  function f(oe, ee) {
    if (oe[0] == 80 && oe[1] == 75)
      return Rt(oe, ee);
    if ((oe[0] | 32) == 109 && (oe[1] | 32) == 105)
      return mt(oe, ee);
    if (oe.length < 512)
      throw new Error("CFB file size " + oe.length + " < 512");
    var ce = 3, pe = 512, be = 0, Ee = 0, He = 0, de = 0, ve = 0, Se = [], we = (
      /*::(*/
      oe.slice(0, 512)
    );
    prep_blob(we, 0);
    var Ue = h(we);
    switch (ce = Ue[0], ce) {
      case 3:
        pe = 512;
        break;
      case 4:
        pe = 4096;
        break;
      case 0:
        if (Ue[1] == 0)
          return Rt(oe, ee);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + ce);
    }
    pe !== 512 && (we = /*::(*/
    oe.slice(0, pe), prep_blob(
      we,
      28
      /* blob.l */
    ));
    var Qe = oe.slice(0, pe);
    g(we, ce);
    var ft = we.read_shift(4, "i");
    if (ce === 3 && ft !== 0)
      throw new Error("# Directory Sectors: Expected 0 saw " + ft);
    we.l += 4, He = we.read_shift(4, "i"), we.l += 4, we.chk("00100000", "Mini Stream Cutoff Size: "), de = we.read_shift(4, "i"), be = we.read_shift(4, "i"), ve = we.read_shift(4, "i"), Ee = we.read_shift(4, "i");
    for (var ut = -1, _t = 0; _t < 109 && (ut = we.read_shift(4, "i"), !(ut < 0)); ++_t)
      Se[_t] = ut;
    var At = x(oe, pe);
    v(ve, Ee, At, pe, Se);
    var Dt = A(At, He, Se, pe);
    Dt[He].name = "!Directory", be > 0 && de !== z && (Dt[de].name = "!MiniFAT"), Dt[Se[0]].name = "!FAT", Dt.fat_addrs = Se, Dt.ssz = pe;
    var Mt = {}, Ut = [], Qt = [], zt = [];
    b(He, Dt, At, Ut, be, Mt, Qt, de), E(Qt, zt, Ut), Ut.shift();
    var sn = {
      FileIndex: Qt,
      FullPaths: zt
    };
    return ee && ee.raw && (sn.raw = { header: Qe, sectors: At }), sn;
  }
  function h(oe) {
    if (oe[oe.l] == 80 && oe[oe.l + 1] == 75)
      return [0, 0];
    oe.chk(P, "Header Signature: "), oe.l += 16;
    var ee = oe.read_shift(2, "u");
    return [oe.read_shift(2, "u"), ee];
  }
  function g(oe, ee) {
    var ce = 9;
    switch (oe.l += 2, ce = oe.read_shift(2)) {
      case 9:
        if (ee != 3)
          throw new Error("Sector Shift: Expected 9 saw " + ce);
        break;
      case 12:
        if (ee != 4)
          throw new Error("Sector Shift: Expected 12 saw " + ce);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + ce);
    }
    oe.chk("0600", "Mini Sector Shift: "), oe.chk("000000000000", "Reserved: ");
  }
  function x(oe, ee) {
    for (var ce = Math.ceil(oe.length / ee) - 1, pe = [], be = 1; be < ce; ++be)
      pe[be - 1] = oe.slice(be * ee, (be + 1) * ee);
    return pe[ce - 1] = oe.slice(ce * ee), pe;
  }
  function E(oe, ee, ce) {
    for (var pe = 0, be = 0, Ee = 0, He = 0, de = 0, ve = ce.length, Se = [], we = []; pe < ve; ++pe)
      Se[pe] = we[pe] = pe, ee[pe] = ce[pe];
    for (; de < we.length; ++de)
      pe = we[de], be = oe[pe].L, Ee = oe[pe].R, He = oe[pe].C, Se[pe] === pe && (be !== -1 && Se[be] !== be && (Se[pe] = Se[be]), Ee !== -1 && Se[Ee] !== Ee && (Se[pe] = Se[Ee])), He !== -1 && (Se[He] = pe), be !== -1 && pe != Se[pe] && (Se[be] = Se[pe], we.lastIndexOf(be) < de && we.push(be)), Ee !== -1 && pe != Se[pe] && (Se[Ee] = Se[pe], we.lastIndexOf(Ee) < de && we.push(Ee));
    for (pe = 1; pe < ve; ++pe)
      Se[pe] === pe && (Ee !== -1 && Se[Ee] !== Ee ? Se[pe] = Se[Ee] : be !== -1 && Se[be] !== be && (Se[pe] = Se[be]));
    for (pe = 1; pe < ve; ++pe)
      if (oe[pe].type !== 0) {
        if (de = pe, de != Se[de])
          do
            de = Se[de], ee[pe] = ee[de] + "/" + ee[pe];
          while (de !== 0 && Se[de] !== -1 && de != Se[de]);
        Se[pe] = -1;
      }
    for (ee[0] += "/", pe = 1; pe < ve; ++pe)
      oe[pe].type !== 2 && (ee[pe] += "/");
  }
  function m(oe, ee, ce) {
    for (var pe = oe.start, be = oe.size, Ee = [], He = pe; ce && be > 0 && He >= 0; )
      Ee.push(ee.slice(He * L, He * L + L)), be -= L, He = __readInt32LE(ce, He * 4);
    return Ee.length === 0 ? new_buf(0) : bconcat(Ee).slice(0, oe.size);
  }
  function v(oe, ee, ce, pe, be) {
    var Ee = z;
    if (oe === z) {
      if (ee !== 0)
        throw new Error("DIFAT chain shorter than expected");
    } else if (oe !== -1) {
      var He = ce[oe], de = (pe >>> 2) - 1;
      if (!He)
        return;
      for (var ve = 0; ve < de && (Ee = __readInt32LE(He, ve * 4)) !== z; ++ve)
        be.push(Ee);
      v(__readInt32LE(He, pe - 4), ee - 1, ce, pe, be);
    }
  }
  function y(oe, ee, ce, pe, be) {
    var Ee = [], He = [];
    be || (be = []);
    var de = pe - 1, ve = 0, Se = 0;
    for (ve = ee; ve >= 0; ) {
      be[ve] = !0, Ee[Ee.length] = ve, He.push(oe[ve]);
      var we = ce[Math.floor(ve * 4 / pe)];
      if (Se = ve * 4 & de, pe < 4 + Se)
        throw new Error("FAT boundary crossed: " + ve + " 4 " + pe);
      if (!oe[we])
        break;
      ve = __readInt32LE(oe[we], Se);
    }
    return { nodes: Ee, data: __toBuffer([He]) };
  }
  function A(oe, ee, ce, pe) {
    var be = oe.length, Ee = [], He = [], de = [], ve = [], Se = pe - 1, we = 0, Ue = 0, Qe = 0, ft = 0;
    for (we = 0; we < be; ++we)
      if (de = [], Qe = we + ee, Qe >= be && (Qe -= be), !He[Qe]) {
        ve = [];
        var ut = [];
        for (Ue = Qe; Ue >= 0; ) {
          ut[Ue] = !0, He[Ue] = !0, de[de.length] = Ue, ve.push(oe[Ue]);
          var _t = ce[Math.floor(Ue * 4 / pe)];
          if (ft = Ue * 4 & Se, pe < 4 + ft)
            throw new Error("FAT boundary crossed: " + Ue + " 4 " + pe);
          if (!oe[_t] || (Ue = __readInt32LE(oe[_t], ft), ut[Ue]))
            break;
        }
        Ee[Qe] = { nodes: de, data: __toBuffer([ve]) };
      }
    return Ee;
  }
  function b(oe, ee, ce, pe, be, Ee, He, de) {
    for (var ve = 0, Se = pe.length ? 2 : 0, we = ee[oe].data, Ue = 0, Qe = 0, ft; Ue < we.length; Ue += 128) {
      var ut = (
        /*::(*/
        we.slice(Ue, Ue + 128)
      );
      prep_blob(ut, 64), Qe = ut.read_shift(2), ft = __utf16le(ut, 0, Qe - Se), pe.push(ft);
      var _t = {
        name: ft,
        type: ut.read_shift(1),
        color: ut.read_shift(1),
        L: ut.read_shift(4, "i"),
        R: ut.read_shift(4, "i"),
        C: ut.read_shift(4, "i"),
        clsid: ut.read_shift(16),
        state: ut.read_shift(4, "i"),
        start: 0,
        size: 0
      }, At = ut.read_shift(2) + ut.read_shift(2) + ut.read_shift(2) + ut.read_shift(2);
      At !== 0 && (_t.ct = C(ut, ut.l - 8));
      var Dt = ut.read_shift(2) + ut.read_shift(2) + ut.read_shift(2) + ut.read_shift(2);
      Dt !== 0 && (_t.mt = C(ut, ut.l - 8)), _t.start = ut.read_shift(4, "i"), _t.size = ut.read_shift(4, "i"), _t.size < 0 && _t.start < 0 && (_t.size = _t.type = 0, _t.start = z, _t.name = ""), _t.type === 5 ? (ve = _t.start, be > 0 && ve !== z && (ee[ve].name = "!StreamData")) : _t.size >= 4096 ? (_t.storage = "fat", ee[_t.start] === void 0 && (ee[_t.start] = y(ce, _t.start, ee.fat_addrs, ee.ssz)), ee[_t.start].name = _t.name, _t.content = ee[_t.start].data.slice(0, _t.size)) : (_t.storage = "minifat", _t.size < 0 ? _t.size = 0 : ve !== z && _t.start !== z && ee[ve] && (_t.content = m(_t, ee[ve].data, (ee[de] || {}).data))), _t.content && prep_blob(_t.content, 0), Ee[ft] = _t, He.push(_t);
    }
  }
  function C(oe, ee) {
    return new Date((__readUInt32LE(oe, ee + 4) / 1e7 * Math.pow(2, 32) + __readUInt32LE(oe, ee) / 1e7 - 11644473600) * 1e3);
  }
  function T(oe, ee) {
    return d(), f(u.readFileSync(oe), ee);
  }
  function w(oe, ee) {
    var ce = ee && ee.type;
    switch (ce || has_buf && Buffer.isBuffer(oe) && (ce = "buffer"), ce || "base64") {
      case "file":
        return T(oe, ee);
      case "base64":
        return f(s2a(Base64_decode(oe)), ee);
      case "binary":
        return f(s2a(oe), ee);
    }
    return f(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      oe,
      ee
    );
  }
  function R(oe, ee) {
    var ce = ee || {}, pe = ce.root || "Root Entry";
    if (oe.FullPaths || (oe.FullPaths = []), oe.FileIndex || (oe.FileIndex = []), oe.FullPaths.length !== oe.FileIndex.length)
      throw new Error("inconsistent CFB structure");
    oe.FullPaths.length === 0 && (oe.FullPaths[0] = pe + "/", oe.FileIndex[0] = { name: pe, type: 5 }), ce.CLSID && (oe.FileIndex[0].clsid = ce.CLSID), O(oe);
  }
  function O(oe) {
    var ee = "Sh33tJ5";
    if (!CFB.find(oe, "/" + ee)) {
      var ce = new_buf(4);
      ce[0] = 55, ce[1] = ce[3] = 50, ce[2] = 54, oe.FileIndex.push({ name: ee, type: 2, content: ce, size: 4, L: 69, R: 69, C: 69 }), oe.FullPaths.push(oe.FullPaths[0] + ee), D(oe);
    }
  }
  function D(oe, ee) {
    R(oe);
    for (var ce = !1, pe = !1, be = oe.FullPaths.length - 1; be >= 0; --be) {
      var Ee = oe.FileIndex[be];
      switch (Ee.type) {
        case 0:
          pe ? ce = !0 : (oe.FileIndex.pop(), oe.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          pe = !0, isNaN(Ee.R * Ee.L * Ee.C) && (ce = !0), Ee.R > -1 && Ee.L > -1 && Ee.R == Ee.L && (ce = !0);
          break;
        default:
          ce = !0;
          break;
      }
    }
    if (!(!ce && !ee)) {
      var He = new Date(1987, 1, 19), de = 0, ve = Object.create ? /* @__PURE__ */ Object.create(null) : {}, Se = [];
      for (be = 0; be < oe.FullPaths.length; ++be)
        ve[oe.FullPaths[be]] = !0, oe.FileIndex[be].type !== 0 && Se.push([oe.FullPaths[be], oe.FileIndex[be]]);
      for (be = 0; be < Se.length; ++be) {
        var we = a(Se[be][0]);
        pe = ve[we], pe || (Se.push([we, {
          name: s(we).replace("/", ""),
          type: 1,
          clsid: Y,
          ct: He,
          mt: He,
          content: null
        }]), ve[we] = !0);
      }
      for (Se.sort(function(ft, ut) {
        return n(ft[0], ut[0]);
      }), oe.FullPaths = [], oe.FileIndex = [], be = 0; be < Se.length; ++be)
        oe.FullPaths[be] = Se[be][0], oe.FileIndex[be] = Se[be][1];
      for (be = 0; be < Se.length; ++be) {
        var Ue = oe.FileIndex[be], Qe = oe.FullPaths[be];
        if (Ue.name = s(Qe).replace("/", ""), Ue.L = Ue.R = Ue.C = -(Ue.color = 1), Ue.size = Ue.content ? Ue.content.length : 0, Ue.start = 0, Ue.clsid = Ue.clsid || Y, be === 0)
          Ue.C = Se.length > 1 ? 1 : -1, Ue.size = 0, Ue.type = 5;
        else if (Qe.slice(-1) == "/") {
          for (de = be + 1; de < Se.length && a(oe.FullPaths[de]) != Qe; ++de)
            ;
          for (Ue.C = de >= Se.length ? -1 : de, de = be + 1; de < Se.length && a(oe.FullPaths[de]) != a(Qe); ++de)
            ;
          Ue.R = de >= Se.length ? -1 : de, Ue.type = 1;
        } else
          a(oe.FullPaths[be + 1] || "") == a(Qe) && (Ue.R = be + 1), Ue.type = 2;
      }
    }
  }
  function k(oe, ee) {
    var ce = ee || {};
    if (ce.fileType == "mad")
      return St(oe, ce);
    switch (D(oe), ce.fileType) {
      case "zip":
        return ke(oe, ce);
    }
    var pe = function(ft) {
      for (var ut = 0, _t = 0, At = 0; At < ft.FileIndex.length; ++At) {
        var Dt = ft.FileIndex[At];
        if (Dt.content) {
          var Mt = Dt.content.length;
          Mt > 0 && (Mt < 4096 ? ut += Mt + 63 >> 6 : _t += Mt + 511 >> 9);
        }
      }
      for (var Ut = ft.FullPaths.length + 3 >> 2, Qt = ut + 7 >> 3, zt = ut + 127 >> 7, sn = Qt + _t + Ut + zt, Vt = sn + 127 >> 7, Wt = Vt <= 109 ? 0 : Math.ceil((Vt - 109) / 127); sn + Vt + Wt + 127 >> 7 > Vt; )
        Wt = ++Vt <= 109 ? 0 : Math.ceil((Vt - 109) / 127);
      var an = [1, Wt, Vt, zt, Ut, _t, ut, 0];
      return ft.FileIndex[0].size = ut << 6, an[7] = (ft.FileIndex[0].start = an[0] + an[1] + an[2] + an[3] + an[4] + an[5]) + (an[6] + 7 >> 3), an;
    }(oe), be = new_buf(pe[7] << 9), Ee = 0, He = 0;
    {
      for (Ee = 0; Ee < 8; ++Ee)
        be.write_shift(1, Q[Ee]);
      for (Ee = 0; Ee < 8; ++Ee)
        be.write_shift(2, 0);
      for (be.write_shift(2, 62), be.write_shift(2, 3), be.write_shift(2, 65534), be.write_shift(2, 9), be.write_shift(2, 6), Ee = 0; Ee < 3; ++Ee)
        be.write_shift(2, 0);
      for (be.write_shift(4, 0), be.write_shift(4, pe[2]), be.write_shift(4, pe[0] + pe[1] + pe[2] + pe[3] - 1), be.write_shift(4, 0), be.write_shift(4, 4096), be.write_shift(4, pe[3] ? pe[0] + pe[1] + pe[2] - 1 : z), be.write_shift(4, pe[3]), be.write_shift(-4, pe[1] ? pe[0] - 1 : z), be.write_shift(4, pe[1]), Ee = 0; Ee < 109; ++Ee)
        be.write_shift(-4, Ee < pe[2] ? pe[1] + Ee : -1);
    }
    if (pe[1])
      for (He = 0; He < pe[1]; ++He) {
        for (; Ee < 236 + He * 127; ++Ee)
          be.write_shift(-4, Ee < pe[2] ? pe[1] + Ee : -1);
        be.write_shift(-4, He === pe[1] - 1 ? z : He + 1);
      }
    var de = function(ft) {
      for (He += ft; Ee < He - 1; ++Ee)
        be.write_shift(-4, Ee + 1);
      ft && (++Ee, be.write_shift(-4, z));
    };
    for (He = Ee = 0, He += pe[1]; Ee < He; ++Ee)
      be.write_shift(-4, ie.DIFSECT);
    for (He += pe[2]; Ee < He; ++Ee)
      be.write_shift(-4, ie.FATSECT);
    de(pe[3]), de(pe[4]);
    for (var ve = 0, Se = 0, we = oe.FileIndex[0]; ve < oe.FileIndex.length; ++ve)
      we = oe.FileIndex[ve], we.content && (Se = we.content.length, !(Se < 4096) && (we.start = He, de(Se + 511 >> 9)));
    for (de(pe[6] + 7 >> 3); be.l & 511; )
      be.write_shift(-4, ie.ENDOFCHAIN);
    for (He = Ee = 0, ve = 0; ve < oe.FileIndex.length; ++ve)
      we = oe.FileIndex[ve], we.content && (Se = we.content.length, !(!Se || Se >= 4096) && (we.start = He, de(Se + 63 >> 6)));
    for (; be.l & 511; )
      be.write_shift(-4, ie.ENDOFCHAIN);
    for (Ee = 0; Ee < pe[4] << 2; ++Ee) {
      var Ue = oe.FullPaths[Ee];
      if (!Ue || Ue.length === 0) {
        for (ve = 0; ve < 17; ++ve)
          be.write_shift(4, 0);
        for (ve = 0; ve < 3; ++ve)
          be.write_shift(4, -1);
        for (ve = 0; ve < 12; ++ve)
          be.write_shift(4, 0);
        continue;
      }
      we = oe.FileIndex[Ee], Ee === 0 && (we.start = we.size ? we.start - 1 : z);
      var Qe = Ee === 0 && ce.root || we.name;
      if (Se = 2 * (Qe.length + 1), be.write_shift(64, Qe, "utf16le"), be.write_shift(2, Se), be.write_shift(1, we.type), be.write_shift(1, we.color), be.write_shift(-4, we.L), be.write_shift(-4, we.R), be.write_shift(-4, we.C), we.clsid)
        be.write_shift(16, we.clsid, "hex");
      else
        for (ve = 0; ve < 4; ++ve)
          be.write_shift(4, 0);
      be.write_shift(4, we.state || 0), be.write_shift(4, 0), be.write_shift(4, 0), be.write_shift(4, 0), be.write_shift(4, 0), be.write_shift(4, we.start), be.write_shift(4, we.size), be.write_shift(4, 0);
    }
    for (Ee = 1; Ee < oe.FileIndex.length; ++Ee)
      if (we = oe.FileIndex[Ee], we.size >= 4096)
        if (be.l = we.start + 1 << 9, has_buf && Buffer.isBuffer(we.content))
          we.content.copy(be, be.l, 0, we.size), be.l += we.size + 511 & -512;
        else {
          for (ve = 0; ve < we.size; ++ve)
            be.write_shift(1, we.content[ve]);
          for (; ve & 511; ++ve)
            be.write_shift(1, 0);
        }
    for (Ee = 1; Ee < oe.FileIndex.length; ++Ee)
      if (we = oe.FileIndex[Ee], we.size > 0 && we.size < 4096)
        if (has_buf && Buffer.isBuffer(we.content))
          we.content.copy(be, be.l, 0, we.size), be.l += we.size + 63 & -64;
        else {
          for (ve = 0; ve < we.size; ++ve)
            be.write_shift(1, we.content[ve]);
          for (; ve & 63; ++ve)
            be.write_shift(1, 0);
        }
    if (has_buf)
      be.l = be.length;
    else
      for (; be.l < be.length; )
        be.write_shift(1, 0);
    return be;
  }
  function W(oe, ee) {
    var ce = oe.FullPaths.map(function(ve) {
      return ve.toUpperCase();
    }), pe = ce.map(function(ve) {
      var Se = ve.split("/");
      return Se[Se.length - (ve.slice(-1) == "/" ? 2 : 1)];
    }), be = !1;
    ee.charCodeAt(0) === 47 ? (be = !0, ee = ce[0].slice(0, -1) + ee) : be = ee.indexOf("/") !== -1;
    var Ee = ee.toUpperCase(), He = be === !0 ? ce.indexOf(Ee) : pe.indexOf(Ee);
    if (He !== -1)
      return oe.FileIndex[He];
    var de = !Ee.match(chr1);
    for (Ee = Ee.replace(chr0, ""), de && (Ee = Ee.replace(chr1, "!")), He = 0; He < ce.length; ++He)
      if ((de ? ce[He].replace(chr1, "!") : ce[He]).replace(chr0, "") == Ee || (de ? pe[He].replace(chr1, "!") : pe[He]).replace(chr0, "") == Ee)
        return oe.FileIndex[He];
    return null;
  }
  var L = 64, z = -2, P = "d0cf11e0a1b11ae1", Q = [208, 207, 17, 224, 161, 177, 26, 225], Y = "00000000000000000000000000000000", ie = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: z,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: P,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: Y,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function te(oe, ee, ce) {
    d();
    var pe = k(oe, ce);
    u.writeFileSync(ee, pe);
  }
  function Z(oe) {
    for (var ee = new Array(oe.length), ce = 0; ce < oe.length; ++ce)
      ee[ce] = String.fromCharCode(oe[ce]);
    return ee.join("");
  }
  function ae(oe, ee) {
    var ce = k(oe, ee);
    switch (ee && ee.type || "buffer") {
      case "file":
        return d(), u.writeFileSync(ee.filename, ce), ce;
      case "binary":
        return typeof ce == "string" ? ce : Z(ce);
      case "base64":
        return Base64_encode(typeof ce == "string" ? ce : Z(ce));
      case "buffer":
        if (has_buf)
          return Buffer.isBuffer(ce) ? ce : Buffer_from(ce);
      case "array":
        return typeof ce == "string" ? s2a(ce) : ce;
    }
    return ce;
  }
  var G;
  function U(oe) {
    try {
      var ee = oe.InflateRaw, ce = new ee();
      if (ce._processChunk(new Uint8Array([3, 0]), ce._finishFlushFlag), ce.bytesRead)
        G = oe;
      else
        throw new Error("zlib does not expose bytesRead");
    } catch (pe) {
      console.error("cannot use native zlib: " + (pe.message || pe));
    }
  }
  function F(oe, ee) {
    if (!G)
      return it(oe, ee);
    var ce = G.InflateRaw, pe = new ce(), be = pe._processChunk(oe.slice(oe.l), pe._finishFlushFlag);
    return oe.l += pe.bytesRead, be;
  }
  function M(oe) {
    return G ? G.deflateRawSync(oe) : ze(oe);
  }
  var I = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], N = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], V = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function q(oe) {
    var ee = (oe << 1 | oe << 11) & 139536 | (oe << 5 | oe << 15) & 558144;
    return (ee >> 16 | ee >> 8 | ee) & 255;
  }
  for (var H = typeof Uint8Array < "u", ne = H ? new Uint8Array(256) : [], he = 0; he < 256; ++he)
    ne[he] = q(he);
  function j(oe, ee) {
    var ce = ne[oe & 255];
    return ee <= 8 ? ce >>> 8 - ee : (ce = ce << 8 | ne[oe >> 8 & 255], ee <= 16 ? ce >>> 16 - ee : (ce = ce << 8 | ne[oe >> 16 & 255], ce >>> 24 - ee));
  }
  function Fe(oe, ee) {
    var ce = ee & 7, pe = ee >>> 3;
    return (oe[pe] | (ce <= 6 ? 0 : oe[pe + 1] << 8)) >>> ce & 3;
  }
  function X(oe, ee) {
    var ce = ee & 7, pe = ee >>> 3;
    return (oe[pe] | (ce <= 5 ? 0 : oe[pe + 1] << 8)) >>> ce & 7;
  }
  function ye(oe, ee) {
    var ce = ee & 7, pe = ee >>> 3;
    return (oe[pe] | (ce <= 4 ? 0 : oe[pe + 1] << 8)) >>> ce & 15;
  }
  function Ae(oe, ee) {
    var ce = ee & 7, pe = ee >>> 3;
    return (oe[pe] | (ce <= 3 ? 0 : oe[pe + 1] << 8)) >>> ce & 31;
  }
  function fe(oe, ee) {
    var ce = ee & 7, pe = ee >>> 3;
    return (oe[pe] | (ce <= 1 ? 0 : oe[pe + 1] << 8)) >>> ce & 127;
  }
  function _e(oe, ee, ce) {
    var pe = ee & 7, be = ee >>> 3, Ee = (1 << ce) - 1, He = oe[be] >>> pe;
    return ce < 8 - pe || (He |= oe[be + 1] << 8 - pe, ce < 16 - pe) || (He |= oe[be + 2] << 16 - pe, ce < 24 - pe) || (He |= oe[be + 3] << 24 - pe), He & Ee;
  }
  function Ie(oe, ee, ce) {
    var pe = ee & 7, be = ee >>> 3;
    return pe <= 5 ? oe[be] |= (ce & 7) << pe : (oe[be] |= ce << pe & 255, oe[be + 1] = (ce & 7) >> 8 - pe), ee + 3;
  }
  function Be(oe, ee, ce) {
    var pe = ee & 7, be = ee >>> 3;
    return ce = (ce & 1) << pe, oe[be] |= ce, ee + 1;
  }
  function $e(oe, ee, ce) {
    var pe = ee & 7, be = ee >>> 3;
    return ce <<= pe, oe[be] |= ce & 255, ce >>>= 8, oe[be + 1] = ce, ee + 8;
  }
  function Me(oe, ee, ce) {
    var pe = ee & 7, be = ee >>> 3;
    return ce <<= pe, oe[be] |= ce & 255, ce >>>= 8, oe[be + 1] = ce & 255, oe[be + 2] = ce >>> 8, ee + 16;
  }
  function J(oe, ee) {
    var ce = oe.length, pe = 2 * ce > ee ? 2 * ce : ee + 5, be = 0;
    if (ce >= ee)
      return oe;
    if (has_buf) {
      var Ee = new_unsafe_buf(pe);
      if (oe.copy)
        oe.copy(Ee);
      else
        for (; be < oe.length; ++be)
          Ee[be] = oe[be];
      return Ee;
    } else if (H) {
      var He = new Uint8Array(pe);
      if (He.set)
        He.set(oe);
      else
        for (; be < ce; ++be)
          He[be] = oe[be];
      return He;
    }
    return oe.length = pe, oe;
  }
  function K(oe) {
    for (var ee = new Array(oe), ce = 0; ce < oe; ++ce)
      ee[ce] = 0;
    return ee;
  }
  function ge(oe, ee, ce) {
    var pe = 1, be = 0, Ee = 0, He = 0, de = 0, ve = oe.length, Se = H ? new Uint16Array(32) : K(32);
    for (Ee = 0; Ee < 32; ++Ee)
      Se[Ee] = 0;
    for (Ee = ve; Ee < ce; ++Ee)
      oe[Ee] = 0;
    ve = oe.length;
    var we = H ? new Uint16Array(ve) : K(ve);
    for (Ee = 0; Ee < ve; ++Ee)
      Se[be = oe[Ee]]++, pe < be && (pe = be), we[Ee] = 0;
    for (Se[0] = 0, Ee = 1; Ee <= pe; ++Ee)
      Se[Ee + 16] = de = de + Se[Ee - 1] << 1;
    for (Ee = 0; Ee < ve; ++Ee)
      de = oe[Ee], de != 0 && (we[Ee] = Se[de + 16]++);
    var Ue = 0;
    for (Ee = 0; Ee < ve; ++Ee)
      if (Ue = oe[Ee], Ue != 0)
        for (de = j(we[Ee], pe) >> pe - Ue, He = (1 << pe + 4 - Ue) - 1; He >= 0; --He)
          ee[de | He << Ue] = Ue & 15 | Ee << 4;
    return pe;
  }
  var Ce = H ? new Uint16Array(512) : K(512), Oe = H ? new Uint16Array(32) : K(32);
  if (!H) {
    for (var qe = 0; qe < 512; ++qe)
      Ce[qe] = 0;
    for (qe = 0; qe < 32; ++qe)
      Oe[qe] = 0;
  }
  (function() {
    for (var oe = [], ee = 0; ee < 32; ee++)
      oe.push(5);
    ge(oe, Oe, 32);
    var ce = [];
    for (ee = 0; ee <= 143; ee++)
      ce.push(8);
    for (; ee <= 255; ee++)
      ce.push(9);
    for (; ee <= 279; ee++)
      ce.push(7);
    for (; ee <= 287; ee++)
      ce.push(8);
    ge(ce, Ce, 288);
  })();
  var ct = /* @__PURE__ */ function() {
    for (var ee = H ? new Uint8Array(32768) : [], ce = 0, pe = 0; ce < V.length - 1; ++ce)
      for (; pe < V[ce + 1]; ++pe)
        ee[pe] = ce;
    for (; pe < 32768; ++pe)
      ee[pe] = 29;
    var be = H ? new Uint8Array(259) : [];
    for (ce = 0, pe = 0; ce < N.length - 1; ++ce)
      for (; pe < N[ce + 1]; ++pe)
        be[pe] = ce;
    function Ee(de, ve) {
      for (var Se = 0; Se < de.length; ) {
        var we = Math.min(65535, de.length - Se), Ue = Se + we == de.length;
        for (ve.write_shift(1, +Ue), ve.write_shift(2, we), ve.write_shift(2, ~we & 65535); we-- > 0; )
          ve[ve.l++] = de[Se++];
      }
      return ve.l;
    }
    function He(de, ve) {
      for (var Se = 0, we = 0, Ue = H ? new Uint16Array(32768) : []; we < de.length; ) {
        var Qe = (
          /* data.length - boff; */
          Math.min(65535, de.length - we)
        );
        if (Qe < 10) {
          for (Se = Ie(ve, Se, +(we + Qe == de.length)), Se & 7 && (Se += 8 - (Se & 7)), ve.l = Se / 8 | 0, ve.write_shift(2, Qe), ve.write_shift(2, ~Qe & 65535); Qe-- > 0; )
            ve[ve.l++] = de[we++];
          Se = ve.l * 8;
          continue;
        }
        Se = Ie(ve, Se, +(we + Qe == de.length) + 2);
        for (var ft = 0; Qe-- > 0; ) {
          var ut = de[we];
          ft = (ft << 5 ^ ut) & 32767;
          var _t = -1, At = 0;
          if ((_t = Ue[ft]) && (_t |= we & -32768, _t > we && (_t -= 32768), _t < we))
            for (; de[_t + At] == de[we + At] && At < 250; )
              ++At;
          if (At > 2) {
            ut = be[At], ut <= 22 ? Se = $e(ve, Se, ne[ut + 1] >> 1) - 1 : ($e(ve, Se, 3), Se += 5, $e(ve, Se, ne[ut - 23] >> 5), Se += 3);
            var Dt = ut < 8 ? 0 : ut - 4 >> 2;
            Dt > 0 && (Me(ve, Se, At - N[ut]), Se += Dt), ut = ee[we - _t], Se = $e(ve, Se, ne[ut] >> 3), Se -= 3;
            var Mt = ut < 4 ? 0 : ut - 2 >> 1;
            Mt > 0 && (Me(ve, Se, we - _t - V[ut]), Se += Mt);
            for (var Ut = 0; Ut < At; ++Ut)
              Ue[ft] = we & 32767, ft = (ft << 5 ^ de[we]) & 32767, ++we;
            Qe -= At - 1;
          } else
            ut <= 143 ? ut = ut + 48 : Se = Be(ve, Se, 1), Se = $e(ve, Se, ne[ut]), Ue[ft] = we & 32767, ++we;
        }
        Se = $e(ve, Se, 0) - 1;
      }
      return ve.l = (Se + 7) / 8 | 0, ve.l;
    }
    return function(ve, Se) {
      return ve.length < 8 ? Ee(ve, Se) : He(ve, Se);
    };
  }();
  function ze(oe) {
    var ee = new_buf(50 + Math.floor(oe.length * 1.1)), ce = ct(oe, ee);
    return ee.slice(0, ce);
  }
  var et = H ? new Uint16Array(32768) : K(32768), gt = H ? new Uint16Array(32768) : K(32768), pt = H ? new Uint16Array(128) : K(128), nt = 1, tt = 1;
  function Ve(oe, ee) {
    var ce = Ae(oe, ee) + 257;
    ee += 5;
    var pe = Ae(oe, ee) + 1;
    ee += 5;
    var be = ye(oe, ee) + 4;
    ee += 4;
    for (var Ee = 0, He = H ? new Uint8Array(19) : K(19), de = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ve = 1, Se = H ? new Uint8Array(8) : K(8), we = H ? new Uint8Array(8) : K(8), Ue = He.length, Qe = 0; Qe < be; ++Qe)
      He[I[Qe]] = Ee = X(oe, ee), ve < Ee && (ve = Ee), Se[Ee]++, ee += 3;
    var ft = 0;
    for (Se[0] = 0, Qe = 1; Qe <= ve; ++Qe)
      we[Qe] = ft = ft + Se[Qe - 1] << 1;
    for (Qe = 0; Qe < Ue; ++Qe)
      (ft = He[Qe]) != 0 && (de[Qe] = we[ft]++);
    var ut = 0;
    for (Qe = 0; Qe < Ue; ++Qe)
      if (ut = He[Qe], ut != 0) {
        ft = ne[de[Qe]] >> 8 - ut;
        for (var _t = (1 << 7 - ut) - 1; _t >= 0; --_t)
          pt[ft | _t << ut] = ut & 7 | Qe << 3;
      }
    var At = [];
    for (ve = 1; At.length < ce + pe; )
      switch (ft = pt[fe(oe, ee)], ee += ft & 7, ft >>>= 3) {
        case 16:
          for (Ee = 3 + Fe(oe, ee), ee += 2, ft = At[At.length - 1]; Ee-- > 0; )
            At.push(ft);
          break;
        case 17:
          for (Ee = 3 + X(oe, ee), ee += 3; Ee-- > 0; )
            At.push(0);
          break;
        case 18:
          for (Ee = 11 + fe(oe, ee), ee += 7; Ee-- > 0; )
            At.push(0);
          break;
        default:
          At.push(ft), ve < ft && (ve = ft);
          break;
      }
    var Dt = At.slice(0, ce), Mt = At.slice(ce);
    for (Qe = ce; Qe < 286; ++Qe)
      Dt[Qe] = 0;
    for (Qe = pe; Qe < 30; ++Qe)
      Mt[Qe] = 0;
    return nt = ge(Dt, et, 286), tt = ge(Mt, gt, 30), ee;
  }
  function We(oe, ee) {
    if (oe[0] == 3 && !(oe[1] & 3))
      return [new_raw_buf(ee), 2];
    for (var ce = 0, pe = 0, be = new_unsafe_buf(ee || 1 << 18), Ee = 0, He = be.length >>> 0, de = 0, ve = 0; !(pe & 1); ) {
      if (pe = X(oe, ce), ce += 3, pe >>> 1)
        pe >> 1 == 1 ? (de = 9, ve = 5) : (ce = Ve(oe, ce), de = nt, ve = tt);
      else {
        ce & 7 && (ce += 8 - (ce & 7));
        var Se = oe[ce >>> 3] | oe[(ce >>> 3) + 1] << 8;
        if (ce += 32, Se > 0)
          for (!ee && He < Ee + Se && (be = J(be, Ee + Se), He = be.length); Se-- > 0; )
            be[Ee++] = oe[ce >>> 3], ce += 8;
        continue;
      }
      for (; ; ) {
        !ee && He < Ee + 32767 && (be = J(be, Ee + 32767), He = be.length);
        var we = _e(oe, ce, de), Ue = pe >>> 1 == 1 ? Ce[we] : et[we];
        if (ce += Ue & 15, Ue >>>= 4, !(Ue >>> 8 & 255))
          be[Ee++] = Ue;
        else {
          if (Ue == 256)
            break;
          Ue -= 257;
          var Qe = Ue < 8 ? 0 : Ue - 4 >> 2;
          Qe > 5 && (Qe = 0);
          var ft = Ee + N[Ue];
          Qe > 0 && (ft += _e(oe, ce, Qe), ce += Qe), we = _e(oe, ce, ve), Ue = pe >>> 1 == 1 ? Oe[we] : gt[we], ce += Ue & 15, Ue >>>= 4;
          var ut = Ue < 4 ? 0 : Ue - 2 >> 1, _t = V[Ue];
          for (ut > 0 && (_t += _e(oe, ce, ut), ce += ut), !ee && He < ft && (be = J(be, ft + 100), He = be.length); Ee < ft; )
            be[Ee] = be[Ee - _t], ++Ee;
        }
      }
    }
    return ee ? [be, ce + 7 >>> 3] : [be.slice(0, Ee), ce + 7 >>> 3];
  }
  function it(oe, ee) {
    var ce = oe.slice(oe.l || 0), pe = We(ce, ee);
    return oe.l += pe[1], pe[0];
  }
  function Je(oe, ee) {
    if (oe)
      typeof console < "u" && console.error(ee);
    else
      throw new Error(ee);
  }
  function Rt(oe, ee) {
    var ce = (
      /*::(*/
      oe
    );
    prep_blob(ce, 0);
    var pe = [], be = [], Ee = {
      FileIndex: pe,
      FullPaths: be
    };
    R(Ee, { root: ee.root });
    for (var He = ce.length - 4; (ce[He] != 80 || ce[He + 1] != 75 || ce[He + 2] != 5 || ce[He + 3] != 6) && He >= 0; )
      --He;
    ce.l = He + 4, ce.l += 4;
    var de = ce.read_shift(2);
    ce.l += 6;
    var ve = ce.read_shift(4);
    for (ce.l = ve, He = 0; He < de; ++He) {
      ce.l += 20;
      var Se = ce.read_shift(4), we = ce.read_shift(4), Ue = ce.read_shift(2), Qe = ce.read_shift(2), ft = ce.read_shift(2);
      ce.l += 8;
      var ut = ce.read_shift(4), _t = c(
        /*::(*/
        ce.slice(ce.l + Ue, ce.l + Ue + Qe)
        /*:: :any)*/
      );
      ce.l += Ue + Qe + ft;
      var At = ce.l;
      ce.l = ut + 4, je(ce, Se, we, Ee, _t), ce.l = At;
    }
    return Ee;
  }
  function je(oe, ee, ce, pe, be) {
    oe.l += 2;
    var Ee = oe.read_shift(2), He = oe.read_shift(2), de = l(oe);
    if (Ee & 8257)
      throw new Error("Unsupported ZIP encryption");
    for (var ve = oe.read_shift(4), Se = oe.read_shift(4), we = oe.read_shift(4), Ue = oe.read_shift(2), Qe = oe.read_shift(2), ft = "", ut = 0; ut < Ue; ++ut)
      ft += String.fromCharCode(oe[oe.l++]);
    if (Qe) {
      var _t = c(
        /*::(*/
        oe.slice(oe.l, oe.l + Qe)
        /*:: :any)*/
      );
      (_t[21589] || {}).mt && (de = _t[21589].mt), ((be || {})[21589] || {}).mt && (de = be[21589].mt);
    }
    oe.l += Qe;
    var At = oe.slice(oe.l, oe.l + Se);
    switch (He) {
      case 8:
        At = F(oe, we);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + He);
    }
    var Dt = !1;
    Ee & 8 && (ve = oe.read_shift(4), ve == 134695760 && (ve = oe.read_shift(4), Dt = !0), Se = oe.read_shift(4), we = oe.read_shift(4)), Se != ee && Je(Dt, "Bad compressed size: " + ee + " != " + Se), we != ce && Je(Dt, "Bad uncompressed size: " + ce + " != " + we), Le(pe, ft, At, { unsafe: !0, mt: de });
  }
  function ke(oe, ee) {
    var ce = ee || {}, pe = [], be = [], Ee = new_buf(1), He = ce.compression ? 8 : 0, de = 0, ve = 0, Se = 0, we = 0, Ue = 0, Qe = oe.FullPaths[0], ft = Qe, ut = oe.FileIndex[0], _t = [], At = 0;
    for (ve = 1; ve < oe.FullPaths.length; ++ve)
      if (ft = oe.FullPaths[ve].slice(Qe.length), ut = oe.FileIndex[ve], !(!ut.size || !ut.content || ft == "Sh33tJ5")) {
        var Dt = we, Mt = new_buf(ft.length);
        for (Se = 0; Se < ft.length; ++Se)
          Mt.write_shift(1, ft.charCodeAt(Se) & 127);
        Mt = Mt.slice(0, Mt.l), _t[Ue] = CRC32.buf(
          /*::((*/
          ut.content,
          0
        );
        var Ut = ut.content;
        He == 8 && (Ut = M(Ut)), Ee = new_buf(30), Ee.write_shift(4, 67324752), Ee.write_shift(2, 20), Ee.write_shift(2, de), Ee.write_shift(2, He), ut.mt ? o(Ee, ut.mt) : Ee.write_shift(4, 0), Ee.write_shift(-4, _t[Ue]), Ee.write_shift(4, Ut.length), Ee.write_shift(
          4,
          /*::(*/
          ut.content.length
        ), Ee.write_shift(2, Mt.length), Ee.write_shift(2, 0), we += Ee.length, pe.push(Ee), we += Mt.length, pe.push(Mt), we += Ut.length, pe.push(Ut), Ee = new_buf(46), Ee.write_shift(4, 33639248), Ee.write_shift(2, 0), Ee.write_shift(2, 20), Ee.write_shift(2, de), Ee.write_shift(2, He), Ee.write_shift(4, 0), Ee.write_shift(-4, _t[Ue]), Ee.write_shift(4, Ut.length), Ee.write_shift(
          4,
          /*::(*/
          ut.content.length
        ), Ee.write_shift(2, Mt.length), Ee.write_shift(2, 0), Ee.write_shift(2, 0), Ee.write_shift(2, 0), Ee.write_shift(2, 0), Ee.write_shift(4, 0), Ee.write_shift(4, Dt), At += Ee.l, be.push(Ee), At += Mt.length, be.push(Mt), ++Ue;
      }
    return Ee = new_buf(22), Ee.write_shift(4, 101010256), Ee.write_shift(2, 0), Ee.write_shift(2, 0), Ee.write_shift(2, Ue), Ee.write_shift(2, Ue), Ee.write_shift(4, At), Ee.write_shift(4, we), Ee.write_shift(2, 0), bconcat([bconcat(pe), bconcat(be), Ee]);
  }
  var Ye = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function Ze(oe, ee) {
    if (oe.ctype)
      return oe.ctype;
    var ce = oe.name || "", pe = ce.match(/\.([^\.]+)$/);
    return pe && Ye[pe[1]] || ee && (pe = (ce = ee).match(/[\.\\]([^\.\\])+$/), pe && Ye[pe[1]]) ? Ye[pe[1]] : "application/octet-stream";
  }
  function rt(oe) {
    for (var ee = Base64_encode(oe), ce = [], pe = 0; pe < ee.length; pe += 76)
      ce.push(ee.slice(pe, pe + 76));
    return ce.join(`\r
`) + `\r
`;
  }
  function xt(oe) {
    var ee = oe.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(Se) {
      var we = Se.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (we.length == 1 ? "0" + we : we);
    });
    ee = ee.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), ee.charAt(0) == `
` && (ee = "=0D" + ee.slice(1)), ee = ee.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var ce = [], pe = ee.split(`\r
`), be = 0; be < pe.length; ++be) {
      var Ee = pe[be];
      if (Ee.length == 0) {
        ce.push("");
        continue;
      }
      for (var He = 0; He < Ee.length; ) {
        var de = 76, ve = Ee.slice(He, He + de);
        ve.charAt(de - 1) == "=" ? de-- : ve.charAt(de - 2) == "=" ? de -= 2 : ve.charAt(de - 3) == "=" && (de -= 3), ve = Ee.slice(He, He + de), He += de, He < Ee.length && (ve += "="), ce.push(ve);
      }
    }
    return ce.join(`\r
`);
  }
  function bt(oe) {
    for (var ee = [], ce = 0; ce < oe.length; ++ce) {
      for (var pe = oe[ce]; ce <= oe.length && pe.charAt(pe.length - 1) == "="; )
        pe = pe.slice(0, pe.length - 1) + oe[++ce];
      ee.push(pe);
    }
    for (var be = 0; be < ee.length; ++be)
      ee[be] = ee[be].replace(/[=][0-9A-Fa-f]{2}/g, function(Ee) {
        return String.fromCharCode(parseInt(Ee.slice(1), 16));
      });
    return s2a(ee.join(`\r
`));
  }
  function wt(oe, ee, ce) {
    for (var pe = "", be = "", Ee = "", He, de = 0; de < 10; ++de) {
      var ve = ee[de];
      if (!ve || ve.match(/^\s*$/))
        break;
      var Se = ve.match(/^(.*?):\s*([^\s].*)$/);
      if (Se)
        switch (Se[1].toLowerCase()) {
          case "content-location":
            pe = Se[2].trim();
            break;
          case "content-type":
            Ee = Se[2].trim();
            break;
          case "content-transfer-encoding":
            be = Se[2].trim();
            break;
        }
    }
    switch (++de, be.toLowerCase()) {
      case "base64":
        He = s2a(Base64_decode(ee.slice(de).join("")));
        break;
      case "quoted-printable":
        He = bt(ee.slice(de));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + be);
    }
    var we = Le(oe, pe.slice(ce.length), He, { unsafe: !0 });
    Ee && (we.ctype = Ee);
  }
  function mt(oe, ee) {
    if (Z(oe.slice(0, 13)).toLowerCase() != "mime-version:")
      throw new Error("Unsupported MAD header");
    var ce = ee && ee.root || "", pe = (has_buf && Buffer.isBuffer(oe) ? oe.toString("binary") : Z(oe)).split(`\r
`), be = 0, Ee = "";
    for (be = 0; be < pe.length; ++be)
      if (Ee = pe[be], !!/^Content-Location:/i.test(Ee) && (Ee = Ee.slice(Ee.indexOf("file")), ce || (ce = Ee.slice(0, Ee.lastIndexOf("/") + 1)), Ee.slice(0, ce.length) != ce))
        for (; ce.length > 0 && (ce = ce.slice(0, ce.length - 1), ce = ce.slice(0, ce.lastIndexOf("/") + 1), Ee.slice(0, ce.length) != ce); )
          ;
    var He = (pe[1] || "").match(/boundary="(.*?)"/);
    if (!He)
      throw new Error("MAD cannot find boundary");
    var de = "--" + (He[1] || ""), ve = [], Se = [], we = {
      FileIndex: ve,
      FullPaths: Se
    };
    R(we);
    var Ue, Qe = 0;
    for (be = 0; be < pe.length; ++be) {
      var ft = pe[be];
      ft !== de && ft !== de + "--" || (Qe++ && wt(we, pe.slice(Ue, be), ce), Ue = be);
    }
    return we;
  }
  function St(oe, ee) {
    var ce = ee || {}, pe = ce.boundary || "SheetJS";
    pe = "------=" + pe;
    for (var be = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + pe.slice(2) + '"',
      "",
      "",
      ""
    ], Ee = oe.FullPaths[0], He = Ee, de = oe.FileIndex[0], ve = 1; ve < oe.FullPaths.length; ++ve)
      if (He = oe.FullPaths[ve].slice(Ee.length), de = oe.FileIndex[ve], !(!de.size || !de.content || He == "Sh33tJ5")) {
        He = He.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(At) {
          return "_x" + At.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(At) {
          return "_u" + At.charCodeAt(0).toString(16) + "_";
        });
        for (var Se = de.content, we = has_buf && Buffer.isBuffer(Se) ? Se.toString("binary") : Z(Se), Ue = 0, Qe = Math.min(1024, we.length), ft = 0, ut = 0; ut <= Qe; ++ut)
          (ft = we.charCodeAt(ut)) >= 32 && ft < 128 && ++Ue;
        var _t = Ue >= Qe * 4 / 5;
        be.push(pe), be.push("Content-Location: " + (ce.root || "file:///C:/SheetJS/") + He), be.push("Content-Transfer-Encoding: " + (_t ? "quoted-printable" : "base64")), be.push("Content-Type: " + Ze(de, He)), be.push(""), be.push(_t ? xt(we) : rt(we));
      }
    return be.push(pe + `--\r
`), be.join(`\r
`);
  }
  function dt(oe) {
    var ee = {};
    return R(ee, oe), ee;
  }
  function Le(oe, ee, ce, pe) {
    var be = pe && pe.unsafe;
    be || R(oe);
    var Ee = !be && CFB.find(oe, ee);
    if (!Ee) {
      var He = oe.FullPaths[0];
      ee.slice(0, He.length) == He ? He = ee : (He.slice(-1) != "/" && (He += "/"), He = (He + ee).replace("//", "/")), Ee = { name: s(ee), type: 2 }, oe.FileIndex.push(Ee), oe.FullPaths.push(He), be || CFB.utils.cfb_gc(oe);
    }
    return Ee.content = ce, Ee.size = ce ? ce.length : 0, pe && (pe.CLSID && (Ee.clsid = pe.CLSID), pe.mt && (Ee.mt = pe.mt), pe.ct && (Ee.ct = pe.ct)), Ee;
  }
  function ue(oe, ee) {
    R(oe);
    var ce = CFB.find(oe, ee);
    if (ce) {
      for (var pe = 0; pe < oe.FileIndex.length; ++pe)
        if (oe.FileIndex[pe] == ce)
          return oe.FileIndex.splice(pe, 1), oe.FullPaths.splice(pe, 1), !0;
    }
    return !1;
  }
  function De(oe, ee, ce) {
    R(oe);
    var pe = CFB.find(oe, ee);
    if (pe) {
      for (var be = 0; be < oe.FileIndex.length; ++be)
        if (oe.FileIndex[be] == pe)
          return oe.FileIndex[be].name = s(ce), oe.FullPaths[be] = ce, !0;
    }
    return !1;
  }
  function Ne(oe) {
    D(oe, !0);
  }
  return e.find = W, e.read = w, e.parse = f, e.write = ae, e.writeFile = te, e.utils = {
    cfb_new: dt,
    cfb_add: Le,
    cfb_del: ue,
    cfb_mov: De,
    cfb_gc: Ne,
    ReadShift,
    CheckField,
    prep_blob,
    bconcat,
    use_zlib: U,
    _deflateRaw: ze,
    _inflateRaw: it,
    consts: ie
  }, e;
}();
function read_binary(t) {
  if (typeof Deno < "u")
    return Deno.readFileSync(t);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
    try {
      var e = File(t);
      e.open("r"), e.encoding = "binary";
      var n = e.read();
      return e.close(), n;
    } catch (a) {
      if (!a.message || !a.message.match(/onstruct/))
        throw a;
    }
  throw new Error("Cannot access file " + t);
}
function keys(t) {
  for (var e = Object.keys(t), n = [], a = 0; a < e.length; ++a)
    Object.prototype.hasOwnProperty.call(t, e[a]) && n.push(e[a]);
  return n;
}
function evert(t) {
  for (var e = [], n = keys(t), a = 0; a !== n.length; ++a)
    e[t[n[a]]] = n[a];
  return e;
}
var basedate = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function datenum(t, e) {
  var n = /* @__PURE__ */ t.getTime();
  e && (n -= 1462 * 24 * 60 * 60 * 1e3);
  var a = /* @__PURE__ */ basedate.getTime() + (/* @__PURE__ */ t.getTimezoneOffset() - /* @__PURE__ */ basedate.getTimezoneOffset()) * 6e4;
  return (n - a) / (24 * 60 * 60 * 1e3);
}
var refdate = /* @__PURE__ */ new Date(), dnthresh = /* @__PURE__ */ basedate.getTime() + (/* @__PURE__ */ refdate.getTimezoneOffset() - /* @__PURE__ */ basedate.getTimezoneOffset()) * 6e4, refoffset = /* @__PURE__ */ refdate.getTimezoneOffset();
function numdate(t) {
  var e = /* @__PURE__ */ new Date();
  return e.setTime(t * 24 * 60 * 60 * 1e3 + dnthresh), e.getTimezoneOffset() !== refoffset && e.setTime(e.getTime() + (e.getTimezoneOffset() - refoffset) * 6e4), e;
}
function parse_isodur(t) {
  var e = 0, n = 0, a = !1, s = t.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!s)
    throw new Error("|" + t + "| is not an ISO8601 Duration");
  for (var o = 1; o != s.length; ++o)
    if (s[o]) {
      switch (n = 1, o > 3 && (a = !0), s[o].slice(s[o].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + s[o].slice(s[o].length - 1));
        case "D":
          n *= 24;
        case "H":
          n *= 60;
        case "M":
          if (a)
            n *= 60;
          else
            throw new Error("Unsupported ISO Duration Field: M");
      }
      e += n * parseInt(s[o], 10);
    }
  return e;
}
var good_pd_date_1 = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), good_pd_date = /* @__PURE__ */ isNaN(/* @__PURE__ */ good_pd_date_1.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : good_pd_date_1, good_pd = /* @__PURE__ */ good_pd_date.getFullYear() == 2017;
function parseDate(t, e) {
  var n = new Date(t);
  if (good_pd)
    return e > 0 ? n.setTime(n.getTime() + n.getTimezoneOffset() * 60 * 1e3) : e < 0 && n.setTime(n.getTime() - n.getTimezoneOffset() * 60 * 1e3), n;
  if (t instanceof Date)
    return t;
  if (good_pd_date.getFullYear() == 1917 && !isNaN(n.getFullYear())) {
    var a = n.getFullYear();
    return t.indexOf("" + a) > -1 || n.setFullYear(n.getFullYear() + 100), n;
  }
  var s = t.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], o = new Date(+s[0], +s[1] - 1, +s[2], +s[3] || 0, +s[4] || 0, +s[5] || 0);
  return t.indexOf("Z") > -1 && (o = new Date(o.getTime() - o.getTimezoneOffset() * 60 * 1e3)), o;
}
function cc2str(t, e) {
  if (has_buf && Buffer.isBuffer(t)) {
    if (e) {
      if (t[0] == 255 && t[1] == 254)
        return utf8write(t.slice(2).toString("utf16le"));
      if (t[1] == 254 && t[2] == 255)
        return utf8write(utf16beread(t.slice(2).toString("binary")));
    }
    return t.toString("binary");
  }
  if (typeof TextDecoder < "u")
    try {
      if (e) {
        if (t[0] == 255 && t[1] == 254)
          return utf8write(new TextDecoder("utf-16le").decode(t.slice(2)));
        if (t[0] == 254 && t[1] == 255)
          return utf8write(new TextDecoder("utf-16be").decode(t.slice(2)));
      }
      var n = {
        "€": "",
        "‚": "",
        ƒ: "",
        "„": "",
        "…": "",
        "†": "",
        "‡": "",
        "ˆ": "",
        "‰": "",
        Š: "",
        "‹": "",
        Œ: "",
        Ž: "",
        "‘": "",
        "’": "",
        "“": "",
        "”": "",
        "•": "",
        "–": "",
        "—": "",
        "˜": "",
        "™": "",
        š: "",
        "›": "",
        œ: "",
        ž: "",
        Ÿ: ""
      };
      return Array.isArray(t) && (t = new Uint8Array(t)), new TextDecoder("latin1").decode(t).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(o) {
        return n[o] || o;
      });
    } catch {
    }
  for (var a = [], s = 0; s != t.length; ++s)
    a.push(String.fromCharCode(t[s]));
  return a.join("");
}
function dup(t) {
  if (typeof JSON < "u" && !Array.isArray(t))
    return JSON.parse(JSON.stringify(t));
  if (typeof t != "object" || t == null)
    return t;
  if (t instanceof Date)
    return new Date(t.getTime());
  var e = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = dup(t[n]));
  return e;
}
function fill(t, e) {
  for (var n = ""; n.length < e; )
    n += t;
  return n;
}
function fuzzynum(t) {
  var e = Number(t);
  if (!isNaN(e))
    return isFinite(e) ? e : NaN;
  if (!/\d/.test(t))
    return e;
  var n = 1, a = t.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return n *= 100, "";
  });
  return !isNaN(e = Number(a)) || (a = a.replace(/[(](.*)[)]/, function(s, o) {
    return n = -n, o;
  }), !isNaN(e = Number(a))) ? e / n : e;
}
var lower_months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function fuzzydate(t) {
  var e = new Date(t), n = /* @__PURE__ */ new Date(NaN), a = e.getYear(), s = e.getMonth(), o = e.getDate();
  if (isNaN(o))
    return n;
  var l = t.toLowerCase();
  if (l.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (l = l.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), l.length > 3 && lower_months.indexOf(l) == -1)
      return n;
  } else if (l.match(/[a-z]/))
    return n;
  return a < 0 || a > 8099 ? n : (s > 0 || o > 1) && a != 101 ? e : t.match(/[^-0-9:,\/\\]/) ? n : e;
}
var split_regex = /* @__PURE__ */ function() {
  var t = "abacaba".split(/(:?b)/i).length == 5;
  return function(n, a, s) {
    if (t || typeof a == "string")
      return n.split(a);
    for (var o = n.split(a), l = [o[0]], c = 1; c < o.length; ++c)
      l.push(s), l.push(o[c]);
    return l;
  };
}();
function getdatastr(t) {
  return t ? t.content && t.type ? cc2str(t.content, !0) : t.data ? debom(t.data) : t.asNodeBuffer && has_buf ? debom(t.asNodeBuffer().toString("binary")) : t.asBinary ? debom(t.asBinary()) : t._data && t._data.getContent ? debom(cc2str(Array.prototype.slice.call(t._data.getContent(), 0))) : null : null;
}
function getdatabin(t) {
  if (!t)
    return null;
  if (t.data)
    return char_codes(t.data);
  if (t.asNodeBuffer && has_buf)
    return t.asNodeBuffer();
  if (t._data && t._data.getContent) {
    var e = t._data.getContent();
    return typeof e == "string" ? char_codes(e) : Array.prototype.slice.call(e);
  }
  return t.content && t.type ? t.content : null;
}
function getdata(t) {
  return t && t.name.slice(-4) === ".bin" ? getdatabin(t) : getdatastr(t);
}
function safegetzipfile(t, e) {
  for (var n = t.FullPaths || keys(t.files), a = e.toLowerCase().replace(/[\/]/g, "\\"), s = a.replace(/\\/g, "/"), o = 0; o < n.length; ++o) {
    var l = n[o].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (a == l || s == l)
      return t.files ? t.files[n[o]] : t.FileIndex[o];
  }
  return null;
}
function getzipfile(t, e) {
  var n = safegetzipfile(t, e);
  if (n == null)
    throw new Error("Cannot find file " + e + " in zip");
  return n;
}
function getzipdata(t, e, n) {
  if (!n)
    return getdata(getzipfile(t, e));
  if (!e)
    return null;
  try {
    return getzipdata(t, e);
  } catch {
    return null;
  }
}
function getzipstr(t, e, n) {
  if (!n)
    return getdatastr(getzipfile(t, e));
  if (!e)
    return null;
  try {
    return getzipstr(t, e);
  } catch {
    return null;
  }
}
function getzipbin(t, e, n) {
  if (!n)
    return getdatabin(getzipfile(t, e));
  if (!e)
    return null;
  try {
    return getzipbin(t, e);
  } catch {
    return null;
  }
}
function zipentries(t) {
  for (var e = t.FullPaths || keys(t.files), n = [], a = 0; a < e.length; ++a)
    e[a].slice(-1) != "/" && n.push(e[a].replace(/^Root Entry[\/]/, ""));
  return n.sort();
}
function zip_add_file(t, e, n) {
  if (t.FullPaths) {
    if (typeof n == "string") {
      var a;
      return has_buf ? a = Buffer_from(n) : a = utf8decode(n), CFB.utils.cfb_add(t, e, a);
    }
    CFB.utils.cfb_add(t, e, n);
  } else
    t.file(e, n);
}
function zip_read(t, e) {
  switch (e.type) {
    case "base64":
      return CFB.read(t, { type: "base64" });
    case "binary":
      return CFB.read(t, { type: "binary" });
    case "buffer":
    case "array":
      return CFB.read(t, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + e.type);
}
function resolve_path(t, e) {
  if (t.charAt(0) == "/")
    return t.slice(1);
  var n = e.split("/");
  e.slice(-1) != "/" && n.pop();
  for (var a = t.split("/"); a.length !== 0; ) {
    var s = a.shift();
    s === ".." ? n.pop() : s !== "." && n.push(s);
  }
  return n.join("/");
}
var XML_HEADER = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g, tagregex = /* @__PURE__ */ XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2, nsregex = /<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(t, e, n) {
  for (var a = {}, s = 0, o = 0; s !== t.length && !((o = t.charCodeAt(s)) === 32 || o === 10 || o === 13); ++s)
    ;
  if (e || (a[0] = t.slice(0, s)), s === t.length)
    return a;
  var l = t.match(attregexg), c = 0, u = "", d = 0, f = "", h = "", g = 1;
  if (l)
    for (d = 0; d != l.length; ++d) {
      for (h = l[d], o = 0; o != h.length && h.charCodeAt(o) !== 61; ++o)
        ;
      for (f = h.slice(0, o).trim(); h.charCodeAt(o + 1) == 32; )
        ++o;
      for (g = (s = h.charCodeAt(o + 1)) == 34 || s == 39 ? 1 : 0, u = h.slice(o + 1 + g, h.length - g), c = 0; c != f.length && f.charCodeAt(c) !== 58; ++c)
        ;
      if (c === f.length)
        f.indexOf("_") > 0 && (f = f.slice(0, f.indexOf("_"))), a[f] = u, n || (a[f.toLowerCase()] = u);
      else {
        var x = (c === 5 && f.slice(0, 5) === "xmlns" ? "xmlns" : "") + f.slice(c + 1);
        if (a[x] && f.slice(c - 3, c) == "ext")
          continue;
        a[x] = u, n || (a[x.toLowerCase()] = u);
      }
    }
  return a;
}
function strip_ns(t) {
  return t.replace(nsregex2, "<$1");
}
var encodings = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, rencoding = /* @__PURE__ */ evert(encodings), unescapexml = /* @__PURE__ */ function() {
  var t = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, e = /_x([\da-fA-F]{4})_/ig;
  return function n(a) {
    var s = a + "", o = s.indexOf("<![CDATA[");
    if (o == -1)
      return s.replace(t, function(c, u) {
        return encodings[c] || String.fromCharCode(parseInt(u, c.indexOf("x") > -1 ? 16 : 10)) || c;
      }).replace(e, function(c, u) {
        return String.fromCharCode(parseInt(u, 16));
      });
    var l = s.indexOf("]]>");
    return n(s.slice(0, o)) + s.slice(o + 9, l) + n(s.slice(l + 3));
  };
}(), decregex = /[&<>'"]/g, htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(t) {
  var e = t + "";
  return e.replace(decregex, function(n) {
    return rencoding[n];
  }).replace(/\n/g, "<br/>").replace(htmlcharegex, function(n) {
    return "&#x" + ("000" + n.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
var xlml_fixstr = /* @__PURE__ */ function() {
  var t = /&#(\d+);/g;
  function e(n, a) {
    return String.fromCharCode(parseInt(a, 10));
  }
  return function(a) {
    return a.replace(t, e);
  };
}();
function parsexmlbool(t) {
  switch (t) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    default:
      return !1;
  }
}
function utf8reada(t) {
  for (var e = "", n = 0, a = 0, s = 0, o = 0, l = 0, c = 0; n < t.length; ) {
    if (a = t.charCodeAt(n++), a < 128) {
      e += String.fromCharCode(a);
      continue;
    }
    if (s = t.charCodeAt(n++), a > 191 && a < 224) {
      l = (a & 31) << 6, l |= s & 63, e += String.fromCharCode(l);
      continue;
    }
    if (o = t.charCodeAt(n++), a < 240) {
      e += String.fromCharCode((a & 15) << 12 | (s & 63) << 6 | o & 63);
      continue;
    }
    l = t.charCodeAt(n++), c = ((a & 7) << 18 | (s & 63) << 12 | (o & 63) << 6 | l & 63) - 65536, e += String.fromCharCode(55296 + (c >>> 10 & 1023)), e += String.fromCharCode(56320 + (c & 1023));
  }
  return e;
}
function utf8readb(t) {
  var e = new_raw_buf(2 * t.length), n, a, s = 1, o = 0, l = 0, c;
  for (a = 0; a < t.length; a += s)
    s = 1, (c = t.charCodeAt(a)) < 128 ? n = c : c < 224 ? (n = (c & 31) * 64 + (t.charCodeAt(a + 1) & 63), s = 2) : c < 240 ? (n = (c & 15) * 4096 + (t.charCodeAt(a + 1) & 63) * 64 + (t.charCodeAt(a + 2) & 63), s = 3) : (s = 4, n = (c & 7) * 262144 + (t.charCodeAt(a + 1) & 63) * 4096 + (t.charCodeAt(a + 2) & 63) * 64 + (t.charCodeAt(a + 3) & 63), n -= 65536, l = 55296 + (n >>> 10 & 1023), n = 56320 + (n & 1023)), l !== 0 && (e[o++] = l & 255, e[o++] = l >>> 8, l = 0), e[o++] = n % 256, e[o++] = n >>> 8;
  return e.slice(0, o).toString("ucs2");
}
function utf8readc(t) {
  return Buffer_from(t, "binary").toString("utf8");
}
var utf8corpus = "foo bar bazâð£", utf8read = has_buf && (/* @__PURE__ */ utf8readc(utf8corpus) == /* @__PURE__ */ utf8reada(utf8corpus) && utf8readc || /* @__PURE__ */ utf8readb(utf8corpus) == /* @__PURE__ */ utf8reada(utf8corpus) && utf8readb) || utf8reada, utf8write = has_buf ? function(t) {
  return Buffer_from(t, "utf8").toString("binary");
} : function(t) {
  for (var e = [], n = 0, a = 0, s = 0; n < t.length; )
    switch (a = t.charCodeAt(n++), !0) {
      case a < 128:
        e.push(String.fromCharCode(a));
        break;
      case a < 2048:
        e.push(String.fromCharCode(192 + (a >> 6))), e.push(String.fromCharCode(128 + (a & 63)));
        break;
      case (a >= 55296 && a < 57344):
        a -= 55296, s = t.charCodeAt(n++) - 56320 + (a << 10), e.push(String.fromCharCode(240 + (s >> 18 & 7))), e.push(String.fromCharCode(144 + (s >> 12 & 63))), e.push(String.fromCharCode(128 + (s >> 6 & 63))), e.push(String.fromCharCode(128 + (s & 63)));
        break;
      default:
        e.push(String.fromCharCode(224 + (a >> 12))), e.push(String.fromCharCode(128 + (a >> 6 & 63))), e.push(String.fromCharCode(128 + (a & 63)));
    }
  return e.join("");
}, matchtag = /* @__PURE__ */ function() {
  var t = {};
  return function(n, a) {
    var s = n + "|" + (a || "");
    return t[s] ? t[s] : t[s] = new RegExp("<(?:\\w+:)?" + n + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + n + ">", a || "");
  };
}(), htmldecode = /* @__PURE__ */ function() {
  var t = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(e) {
    return [new RegExp("&" + e[0] + ";", "ig"), e[1]];
  });
  return function(n) {
    for (var a = n.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), s = 0; s < t.length; ++s)
      a = a.replace(t[s][0], t[s][1]);
    return a;
  };
}(), vtregex = /* @__PURE__ */ function() {
  var t = {};
  return function(n) {
    return t[n] !== void 0 ? t[n] : t[n] = new RegExp("<(?:vt:)?" + n + ">([\\s\\S]*?)</(?:vt:)?" + n + ">", "g");
  };
}(), vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(t, e) {
  var n = parsexmltag(t), a = t.match(vtregex(n.baseType)) || [], s = [];
  if (a.length != n.size) {
    if (e.WTF)
      throw new Error("unexpected vector length " + a.length + " != " + n.size);
    return s;
  }
  return a.forEach(function(o) {
    var l = o.replace(vtvregex, "").match(vtmregex);
    l && s.push({ v: utf8read(l[2]), t: l[1] });
  }), s;
}
var wtregex = /(^\s|\s$|\n)/;
function wxt_helper(t) {
  return keys(t).map(function(e) {
    return " " + e + '="' + t[e] + '"';
  }).join("");
}
function writextag(t, e, n) {
  return "<" + t + (n != null ? wxt_helper(n) : "") + (e != null ? (e.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + e + "</" + t : "/") + ">";
}
function xlml_normalize(t) {
  if (has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(t))
    return t.toString("utf8");
  if (typeof t == "string")
    return t;
  if (typeof Uint8Array < "u" && t instanceof Uint8Array)
    return utf8read(a2s(ab2a(t)));
  throw new Error("Bad input format: expected Buffer or string");
}
var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg, XMLNS = {
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
  CT: "http://schemas.openxmlformats.org/package/2006/content-types",
  RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
  TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
  dc: "http://purl.org/dc/elements/1.1/",
  dcterms: "http://purl.org/dc/terms/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
  r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
  sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
  vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
  xsi: "http://www.w3.org/2001/XMLSchema-instance",
  xsd: "http://www.w3.org/2001/XMLSchema"
}, XMLNS_main = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
];
function read_double_le(t, e) {
  for (var n = 1 - 2 * (t[e + 7] >>> 7), a = ((t[e + 7] & 127) << 4) + (t[e + 6] >>> 4 & 15), s = t[e + 6] & 15, o = 5; o >= 0; --o)
    s = s * 256 + t[e + o];
  return a == 2047 ? s == 0 ? n * (1 / 0) : NaN : (a == 0 ? a = -1022 : (a -= 1023, s += Math.pow(2, 52)), n * Math.pow(2, a - 52) * s);
}
function write_double_le(t, e, n) {
  var a = (e < 0 || 1 / e == -1 / 0 ? 1 : 0) << 7, s = 0, o = 0, l = a ? -e : e;
  isFinite(l) ? l == 0 ? s = o = 0 : (s = Math.floor(Math.log(l) / Math.LN2), o = l * Math.pow(2, 52 - s), s <= -1023 && (!isFinite(o) || o < Math.pow(2, 52)) ? s = -1022 : (o -= Math.pow(2, 52), s += 1023)) : (s = 2047, o = isNaN(e) ? 26985 : 0);
  for (var c = 0; c <= 5; ++c, o /= 256)
    t[n + c] = o & 255;
  t[n + 6] = (s & 15) << 4 | o & 15, t[n + 7] = s >> 4 | a;
}
var ___toBuffer = function(t) {
  for (var e = [], n = 10240, a = 0; a < t[0].length; ++a)
    if (t[0][a])
      for (var s = 0, o = t[0][a].length; s < o; s += n)
        e.push.apply(e, t[0][a].slice(s, s + n));
  return e;
}, __toBuffer = has_buf ? function(t) {
  return t[0].length > 0 && Buffer.isBuffer(t[0][0]) ? Buffer.concat(t[0].map(function(e) {
    return Buffer.isBuffer(e) ? e : Buffer_from(e);
  })) : ___toBuffer(t);
} : ___toBuffer, ___utf16le = function(t, e, n) {
  for (var a = [], s = e; s < n; s += 2)
    a.push(String.fromCharCode(__readUInt16LE(t, s)));
  return a.join("").replace(chr0, "");
}, __utf16le = has_buf ? function(t, e, n) {
  return Buffer.isBuffer(t) ? t.toString("utf16le", e, n).replace(chr0, "") : ___utf16le(t, e, n);
} : ___utf16le, ___hexlify = function(t, e, n) {
  for (var a = [], s = e; s < e + n; ++s)
    a.push(("0" + t[s].toString(16)).slice(-2));
  return a.join("");
}, __hexlify = has_buf ? function(t, e, n) {
  return Buffer.isBuffer(t) ? t.toString("hex", e, e + n) : ___hexlify(t, e, n);
} : ___hexlify, ___utf8 = function(t, e, n) {
  for (var a = [], s = e; s < n; s++)
    a.push(String.fromCharCode(__readUInt8(t, s)));
  return a.join("");
}, __utf8 = has_buf ? function t(e, n, a) {
  return Buffer.isBuffer(e) ? e.toString("utf8", n, a) : ___utf8(e, n, a);
} : ___utf8, ___lpstr = function(t, e) {
  var n = __readUInt32LE(t, e);
  return n > 0 ? __utf8(t, e + 4, e + 4 + n - 1) : "";
}, __lpstr = ___lpstr, ___cpstr = function(t, e) {
  var n = __readUInt32LE(t, e);
  return n > 0 ? __utf8(t, e + 4, e + 4 + n - 1) : "";
}, __cpstr = ___cpstr, ___lpwstr = function(t, e) {
  var n = 2 * __readUInt32LE(t, e);
  return n > 0 ? __utf8(t, e + 4, e + 4 + n - 1) : "";
}, __lpwstr = ___lpwstr, ___lpp4 = function t(e, n) {
  var a = __readUInt32LE(e, n);
  return a > 0 ? __utf16le(e, n + 4, n + 4 + a) : "";
}, __lpp4 = ___lpp4, ___8lpp4 = function(t, e) {
  var n = __readUInt32LE(t, e);
  return n > 0 ? __utf8(t, e + 4, e + 4 + n) : "";
}, __8lpp4 = ___8lpp4, ___double = function(t, e) {
  return read_double_le(t, e);
}, __double = ___double, is_buf = function t(e) {
  return Array.isArray(e) || typeof Uint8Array < "u" && e instanceof Uint8Array;
};
has_buf && (__lpstr = function(e, n) {
  if (!Buffer.isBuffer(e))
    return ___lpstr(e, n);
  var a = e.readUInt32LE(n);
  return a > 0 ? e.toString("utf8", n + 4, n + 4 + a - 1) : "";
}, __cpstr = function(e, n) {
  if (!Buffer.isBuffer(e))
    return ___cpstr(e, n);
  var a = e.readUInt32LE(n);
  return a > 0 ? e.toString("utf8", n + 4, n + 4 + a - 1) : "";
}, __lpwstr = function(e, n) {
  if (!Buffer.isBuffer(e))
    return ___lpwstr(e, n);
  var a = 2 * e.readUInt32LE(n);
  return e.toString("utf16le", n + 4, n + 4 + a - 1);
}, __lpp4 = function(e, n) {
  if (!Buffer.isBuffer(e))
    return ___lpp4(e, n);
  var a = e.readUInt32LE(n);
  return e.toString("utf16le", n + 4, n + 4 + a);
}, __8lpp4 = function(e, n) {
  if (!Buffer.isBuffer(e))
    return ___8lpp4(e, n);
  var a = e.readUInt32LE(n);
  return e.toString("utf8", n + 4, n + 4 + a);
}, __double = function(e, n) {
  return Buffer.isBuffer(e) ? e.readDoubleLE(n) : ___double(e, n);
}, is_buf = function(e) {
  return Buffer.isBuffer(e) || Array.isArray(e) || typeof Uint8Array < "u" && e instanceof Uint8Array;
});
var __readUInt8 = function(t, e) {
  return t[e];
}, __readUInt16LE = function(t, e) {
  return t[e + 1] * 256 + t[e];
}, __readInt16LE = function(t, e) {
  var n = t[e + 1] * 256 + t[e];
  return n < 32768 ? n : (65535 - n + 1) * -1;
}, __readUInt32LE = function(t, e) {
  return t[e + 3] * (1 << 24) + (t[e + 2] << 16) + (t[e + 1] << 8) + t[e];
}, __readInt32LE = function(t, e) {
  return t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e];
}, __readInt32BE = function(t, e) {
  return t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3];
};
function ReadShift(t, e) {
  var n = "", a, s, o = [], l, c, u, d;
  switch (e) {
    case "dbcs":
      if (d = this.l, has_buf && Buffer.isBuffer(this))
        n = this.slice(this.l, this.l + 2 * t).toString("utf16le");
      else
        for (u = 0; u < t; ++u)
          n += String.fromCharCode(__readUInt16LE(this, d)), d += 2;
      t *= 2;
      break;
    case "utf8":
      n = __utf8(this, this.l, this.l + t);
      break;
    case "utf16le":
      t *= 2, n = __utf16le(this, this.l, this.l + t);
      break;
    case "wstr":
      return ReadShift.call(this, t, "dbcs");
    case "lpstr-ansi":
      n = __lpstr(this, this.l), t = 4 + __readUInt32LE(this, this.l);
      break;
    case "lpstr-cp":
      n = __cpstr(this, this.l), t = 4 + __readUInt32LE(this, this.l);
      break;
    case "lpwstr":
      n = __lpwstr(this, this.l), t = 4 + 2 * __readUInt32LE(this, this.l);
      break;
    case "lpp4":
      t = 4 + __readUInt32LE(this, this.l), n = __lpp4(this, this.l), t & 2 && (t += 2);
      break;
    case "8lpp4":
      t = 4 + __readUInt32LE(this, this.l), n = __8lpp4(this, this.l), t & 3 && (t += 4 - (t & 3));
      break;
    case "cstr":
      for (t = 0, n = ""; (l = __readUInt8(this, this.l + t++)) !== 0; )
        o.push(_getchar(l));
      n = o.join("");
      break;
    case "_wstr":
      for (t = 0, n = ""; (l = __readUInt16LE(this, this.l + t)) !== 0; )
        o.push(_getchar(l)), t += 2;
      t += 2, n = o.join("");
      break;
    case "dbcs-cont":
      for (n = "", d = this.l, u = 0; u < t; ++u) {
        if (this.lens && this.lens.indexOf(d) !== -1)
          return l = __readUInt8(this, d), this.l = d + 1, c = ReadShift.call(this, t - u, l ? "dbcs-cont" : "sbcs-cont"), o.join("") + c;
        o.push(_getchar(__readUInt16LE(this, d))), d += 2;
      }
      n = o.join(""), t *= 2;
      break;
    case "cpstr":
    case "sbcs-cont":
      for (n = "", d = this.l, u = 0; u != t; ++u) {
        if (this.lens && this.lens.indexOf(d) !== -1)
          return l = __readUInt8(this, d), this.l = d + 1, c = ReadShift.call(this, t - u, l ? "dbcs-cont" : "sbcs-cont"), o.join("") + c;
        o.push(_getchar(__readUInt8(this, d))), d += 1;
      }
      n = o.join("");
      break;
    default:
      switch (t) {
        case 1:
          return a = __readUInt8(this, this.l), this.l++, a;
        case 2:
          return a = (e === "i" ? __readInt16LE : __readUInt16LE)(this, this.l), this.l += 2, a;
        case 4:
        case -4:
          return e === "i" || !(this[this.l + 3] & 128) ? (a = (t > 0 ? __readInt32LE : __readInt32BE)(this, this.l), this.l += 4, a) : (s = __readUInt32LE(this, this.l), this.l += 4, s);
        case 8:
        case -8:
          if (e === "f")
            return t == 8 ? s = __double(this, this.l) : s = __double([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, s;
          t = 8;
        case 16:
          n = __hexlify(this, this.l, t);
          break;
      }
  }
  return this.l += t, n;
}
var __writeUInt32LE = function(t, e, n) {
  t[n] = e & 255, t[n + 1] = e >>> 8 & 255, t[n + 2] = e >>> 16 & 255, t[n + 3] = e >>> 24 & 255;
}, __writeInt32LE = function(t, e, n) {
  t[n] = e & 255, t[n + 1] = e >> 8 & 255, t[n + 2] = e >> 16 & 255, t[n + 3] = e >> 24 & 255;
}, __writeUInt16LE = function(t, e, n) {
  t[n] = e & 255, t[n + 1] = e >>> 8 & 255;
};
function WriteShift(t, e, n) {
  var a = 0, s = 0;
  if (n === "dbcs") {
    for (s = 0; s != e.length; ++s)
      __writeUInt16LE(this, e.charCodeAt(s), this.l + 2 * s);
    a = 2 * e.length;
  } else if (n === "sbcs") {
    for (e = e.replace(/[^\x00-\x7F]/g, "_"), s = 0; s != e.length; ++s)
      this[this.l + s] = e.charCodeAt(s) & 255;
    a = e.length;
  } else if (n === "hex") {
    for (; s < t; ++s)
      this[this.l++] = parseInt(e.slice(2 * s, 2 * s + 2), 16) || 0;
    return this;
  } else if (n === "utf16le") {
    var o = Math.min(this.l + t, this.length);
    for (s = 0; s < Math.min(e.length, t); ++s) {
      var l = e.charCodeAt(s);
      this[this.l++] = l & 255, this[this.l++] = l >> 8;
    }
    for (; this.l < o; )
      this[this.l++] = 0;
    return this;
  } else
    switch (t) {
      case 1:
        a = 1, this[this.l] = e & 255;
        break;
      case 2:
        a = 2, this[this.l] = e & 255, e >>>= 8, this[this.l + 1] = e & 255;
        break;
      case 3:
        a = 3, this[this.l] = e & 255, e >>>= 8, this[this.l + 1] = e & 255, e >>>= 8, this[this.l + 2] = e & 255;
        break;
      case 4:
        a = 4, __writeUInt32LE(this, e, this.l);
        break;
      case 8:
        if (a = 8, n === "f") {
          write_double_le(this, e, this.l);
          break;
        }
      case 16:
        break;
      case -4:
        a = 4, __writeInt32LE(this, e, this.l);
        break;
    }
  return this.l += a, this;
}
function CheckField(t, e) {
  var n = __hexlify(this, this.l, t.length >> 1);
  if (n !== t)
    throw new Error(e + "Expected " + t + " saw " + n);
  this.l += t.length >> 1;
}
function prep_blob(t, e) {
  t.l = e, t.read_shift = /*::(*/
  ReadShift, t.chk = CheckField, t.write_shift = WriteShift;
}
function parsenoop(t, e) {
  t.l += e;
}
function new_buf(t) {
  var e = new_raw_buf(t);
  return prep_blob(e, 0), e;
}
function recordhopper(t, e, n) {
  if (t) {
    var a, s, o;
    prep_blob(t, t.l || 0);
    for (var l = t.length, c = 0, u = 0; t.l < l; ) {
      c = t.read_shift(1), c & 128 && (c = (c & 127) + ((t.read_shift(1) & 127) << 7));
      var d = XLSBRecordEnum[c] || XLSBRecordEnum[65535];
      for (a = t.read_shift(1), o = a & 127, s = 1; s < 4 && a & 128; ++s)
        o += ((a = t.read_shift(1)) & 127) << 7 * s;
      u = t.l + o;
      var f = d.f && d.f(t, o, n);
      if (t.l = u, e(f, d, c))
        return;
    }
  }
}
function buf_array() {
  var t = [], e = has_buf ? 256 : 2048, n = function(d) {
    var f = new_buf(d);
    return prep_blob(f, 0), f;
  }, a = n(e), s = function() {
    a && (a.length > a.l && (a = a.slice(0, a.l), a.l = a.length), a.length > 0 && t.push(a), a = null);
  }, o = function(d) {
    return a && d < a.length - a.l ? a : (s(), a = n(Math.max(d + 1, e)));
  }, l = function() {
    return s(), bconcat(t);
  }, c = function(d) {
    s(), a = d, a.l == null && (a.l = a.length), o(e);
  };
  return { next: o, push: c, end: l, _bufs: t };
}
function shift_cell_xls(t, e, n) {
  var a = dup(t);
  if (e.s ? (a.cRel && (a.c += e.s.c), a.rRel && (a.r += e.s.r)) : (a.cRel && (a.c += e.c), a.rRel && (a.r += e.r)), !n || n.biff < 12) {
    for (; a.c >= 256; )
      a.c -= 256;
    for (; a.r >= 65536; )
      a.r -= 65536;
  }
  return a;
}
function shift_range_xls(t, e, n) {
  var a = dup(t);
  return a.s = shift_cell_xls(a.s, e.s, n), a.e = shift_cell_xls(a.e, e.s, n), a;
}
function encode_cell_xls(t, e) {
  if (t.cRel && t.c < 0)
    for (t = dup(t); t.c < 0; )
      t.c += e > 8 ? 16384 : 256;
  if (t.rRel && t.r < 0)
    for (t = dup(t); t.r < 0; )
      t.r += e > 8 ? 1048576 : e > 5 ? 65536 : 16384;
  var n = encode_cell(t);
  return !t.cRel && t.cRel != null && (n = fix_col(n)), !t.rRel && t.rRel != null && (n = fix_row(n)), n;
}
function encode_range_xls(t, e) {
  return t.s.r == 0 && !t.s.rRel && t.e.r == (e.biff >= 12 ? 1048575 : e.biff >= 8 ? 65536 : 16384) && !t.e.rRel ? (t.s.cRel ? "" : "$") + encode_col(t.s.c) + ":" + (t.e.cRel ? "" : "$") + encode_col(t.e.c) : t.s.c == 0 && !t.s.cRel && t.e.c == (e.biff >= 12 ? 16383 : 255) && !t.e.cRel ? (t.s.rRel ? "" : "$") + encode_row(t.s.r) + ":" + (t.e.rRel ? "" : "$") + encode_row(t.e.r) : encode_cell_xls(t.s, e.biff) + ":" + encode_cell_xls(t.e, e.biff);
}
function decode_row(t) {
  return parseInt(unfix_row(t), 10) - 1;
}
function encode_row(t) {
  return "" + (t + 1);
}
function fix_row(t) {
  return t.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function unfix_row(t) {
  return t.replace(/\$(\d+)$/, "$1");
}
function decode_col(t) {
  for (var e = unfix_col(t), n = 0, a = 0; a !== e.length; ++a)
    n = 26 * n + e.charCodeAt(a) - 64;
  return n - 1;
}
function encode_col(t) {
  if (t < 0)
    throw new Error("invalid column " + t);
  var e = "";
  for (++t; t; t = Math.floor((t - 1) / 26))
    e = String.fromCharCode((t - 1) % 26 + 65) + e;
  return e;
}
function fix_col(t) {
  return t.replace(/^([A-Z])/, "$$$1");
}
function unfix_col(t) {
  return t.replace(/^\$([A-Z])/, "$1");
}
function split_cell(t) {
  return t.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function decode_cell(t) {
  for (var e = 0, n = 0, a = 0; a < t.length; ++a) {
    var s = t.charCodeAt(a);
    s >= 48 && s <= 57 ? e = 10 * e + (s - 48) : s >= 65 && s <= 90 && (n = 26 * n + (s - 64));
  }
  return { c: n - 1, r: e - 1 };
}
function encode_cell(t) {
  for (var e = t.c + 1, n = ""; e; e = (e - 1) / 26 | 0)
    n = String.fromCharCode((e - 1) % 26 + 65) + n;
  return n + (t.r + 1);
}
function decode_range(t) {
  var e = t.indexOf(":");
  return e == -1 ? { s: decode_cell(t), e: decode_cell(t) } : { s: decode_cell(t.slice(0, e)), e: decode_cell(t.slice(e + 1)) };
}
function encode_range(t, e) {
  return typeof e > "u" || typeof e == "number" ? encode_range(t.s, t.e) : (typeof t != "string" && (t = encode_cell(t)), typeof e != "string" && (e = encode_cell(e)), t == e ? t : t + ":" + e);
}
function safe_decode_range(t) {
  var e = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, n = 0, a = 0, s = 0, o = t.length;
  for (n = 0; a < o && !((s = t.charCodeAt(a) - 64) < 1 || s > 26); ++a)
    n = 26 * n + s;
  for (e.s.c = --n, n = 0; a < o && !((s = t.charCodeAt(a) - 48) < 0 || s > 9); ++a)
    n = 10 * n + s;
  if (e.s.r = --n, a === o || s != 10)
    return e.e.c = e.s.c, e.e.r = e.s.r, e;
  for (++a, n = 0; a != o && !((s = t.charCodeAt(a) - 64) < 1 || s > 26); ++a)
    n = 26 * n + s;
  for (e.e.c = --n, n = 0; a != o && !((s = t.charCodeAt(a) - 48) < 0 || s > 9); ++a)
    n = 10 * n + s;
  return e.e.r = --n, e;
}
function safe_format_cell(t, e) {
  var n = t.t == "d" && e instanceof Date;
  if (t.z != null)
    try {
      return t.w = SSF_format(t.z, n ? datenum(e) : e);
    } catch {
    }
  try {
    return t.w = SSF_format((t.XF || {}).numFmtId || (n ? 14 : 0), n ? datenum(e) : e);
  } catch {
    return "" + e;
  }
}
function format_cell(t, e, n) {
  return t == null || t.t == null || t.t == "z" ? "" : t.w !== void 0 ? t.w : (t.t == "d" && !t.z && n && n.dateNF && (t.z = n.dateNF), t.t == "e" ? BErr[t.v] || t.v : e == null ? safe_format_cell(t, t.v) : safe_format_cell(t, e));
}
function sheet_to_workbook(t, e) {
  var n = e && e.sheet ? e.sheet : "Sheet1", a = {};
  return a[n] = t, { SheetNames: [n], Sheets: a };
}
function sheet_add_aoa(t, e, n) {
  var a = n || {}, s = t ? Array.isArray(t) : a.dense, o = t || (s ? [] : {}), l = 0, c = 0;
  if (o && a.origin != null) {
    if (typeof a.origin == "number")
      l = a.origin;
    else {
      var u = typeof a.origin == "string" ? decode_cell(a.origin) : a.origin;
      l = u.r, c = u.c;
    }
    o["!ref"] || (o["!ref"] = "A1:A1");
  }
  var d = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (o["!ref"]) {
    var f = safe_decode_range(o["!ref"]);
    d.s.c = f.s.c, d.s.r = f.s.r, d.e.c = Math.max(d.e.c, f.e.c), d.e.r = Math.max(d.e.r, f.e.r), l == -1 && (d.e.r = l = f.e.r + 1);
  }
  for (var h = 0; h != e.length; ++h)
    if (e[h]) {
      if (!Array.isArray(e[h]))
        throw new Error("aoa_to_sheet expects an array of arrays");
      for (var g = 0; g != e[h].length; ++g)
        if (!(typeof e[h][g] > "u")) {
          var x = { v: e[h][g] }, E = l + h, m = c + g;
          if (d.s.r > E && (d.s.r = E), d.s.c > m && (d.s.c = m), d.e.r < E && (d.e.r = E), d.e.c < m && (d.e.c = m), e[h][g] && typeof e[h][g] == "object" && !Array.isArray(e[h][g]) && !(e[h][g] instanceof Date))
            x = e[h][g];
          else if (Array.isArray(x.v) && (x.f = e[h][g][1], x.v = x.v[0]), x.v === null)
            if (x.f)
              x.t = "n";
            else if (a.nullError)
              x.t = "e", x.v = 0;
            else if (a.sheetStubs)
              x.t = "z";
            else
              continue;
          else
            typeof x.v == "number" ? x.t = "n" : typeof x.v == "boolean" ? x.t = "b" : x.v instanceof Date ? (x.z = a.dateNF || table_fmt[14], a.cellDates ? (x.t = "d", x.w = SSF_format(x.z, datenum(x.v))) : (x.t = "n", x.v = datenum(x.v), x.w = SSF_format(x.z, x.v))) : x.t = "s";
          if (s)
            o[E] || (o[E] = []), o[E][m] && o[E][m].z && (x.z = o[E][m].z), o[E][m] = x;
          else {
            var v = encode_cell({ c: m, r: E });
            o[v] && o[v].z && (x.z = o[v].z), o[v] = x;
          }
        }
    }
  return d.s.c < 1e7 && (o["!ref"] = encode_range(d)), o;
}
function aoa_to_sheet(t, e) {
  return sheet_add_aoa(null, t, e);
}
function parse_Int32LE(t) {
  return t.read_shift(4, "i");
}
function parse_XLWideString(t) {
  var e = t.read_shift(4);
  return e === 0 ? "" : t.read_shift(e, "dbcs");
}
function parse_StrRun(t) {
  return { ich: t.read_shift(2), ifnt: t.read_shift(2) };
}
function parse_RichStr(t, e) {
  var n = t.l, a = t.read_shift(1), s = parse_XLWideString(t), o = [], l = { t: s, h: s };
  if (a & 1) {
    for (var c = t.read_shift(4), u = 0; u != c; ++u)
      o.push(parse_StrRun(t));
    l.r = o;
  } else
    l.r = [{ ich: 0, ifnt: 0 }];
  return t.l = n + e, l;
}
var parse_BrtCommentText = parse_RichStr;
function parse_XLSBCell(t) {
  var e = t.read_shift(4), n = t.read_shift(2);
  return n += t.read_shift(1) << 16, t.l++, { c: e, iStyleRef: n };
}
function parse_XLSBShortCell(t) {
  var e = t.read_shift(2);
  return e += t.read_shift(1) << 16, t.l++, { c: -1, iStyleRef: e };
}
var parse_XLSBCodeName = parse_XLWideString;
function parse_XLNullableWideString(t) {
  var e = t.read_shift(4);
  return e === 0 || e === 4294967295 ? "" : t.read_shift(e, "dbcs");
}
var parse_XLNameWideString = parse_XLWideString, parse_RelID = parse_XLNullableWideString;
function parse_RkNumber(t) {
  var e = t.slice(t.l, t.l + 4), n = e[0] & 1, a = e[0] & 2;
  t.l += 4;
  var s = a === 0 ? __double([0, 0, 0, 0, e[0] & 252, e[1], e[2], e[3]], 0) : __readInt32LE(e, 0) >> 2;
  return n ? s / 100 : s;
}
function parse_RfX(t) {
  var e = { s: {}, e: {} };
  return e.s.r = t.read_shift(4), e.e.r = t.read_shift(4), e.s.c = t.read_shift(4), e.e.c = t.read_shift(4), e;
}
var parse_UncheckedRfX = parse_RfX;
function parse_Xnum(t) {
  if (t.length - t.l < 8)
    throw "XLS Xnum Buffer underflow";
  return t.read_shift(8, "f");
}
function parse_BrtColor(t) {
  var e = {}, n = t.read_shift(1), a = n >>> 1, s = t.read_shift(1), o = t.read_shift(2, "i"), l = t.read_shift(1), c = t.read_shift(1), u = t.read_shift(1);
  switch (t.l++, a) {
    case 0:
      e.auto = 1;
      break;
    case 1:
      e.index = s;
      var d = XLSIcv[s];
      d && (e.rgb = rgb2Hex(d));
      break;
    case 2:
      e.rgb = rgb2Hex([l, c, u]);
      break;
    case 3:
      e.theme = s;
      break;
  }
  return o != 0 && (e.tint = o > 0 ? o / 32767 : o / 32768), e;
}
function parse_FontFlags(t) {
  var e = t.read_shift(1);
  t.l++;
  var n = {
    fBold: e & 1,
    fItalic: e & 2,
    fUnderline: e & 4,
    fStrikeout: e & 8,
    fOutline: e & 16,
    fShadow: e & 32,
    fCondense: e & 64,
    fExtend: e & 128
  };
  return n;
}
function parse_ClipboardFormatOrString(t, e) {
  var n = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, a = t.read_shift(4);
  switch (a) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return n[t.read_shift(4)] || "";
  }
  if (a > 400)
    throw new Error("Unsupported Clipboard: " + a.toString(16));
  return t.l -= 4, t.read_shift(0, e == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(t) {
  return parse_ClipboardFormatOrString(t, 1);
}
function parse_ClipboardFormatOrUnicodeString(t) {
  return parse_ClipboardFormatOrString(t, 2);
}
var VT_I2 = 2, VT_I4 = 3, VT_BOOL = 11, VT_VARIANT = 12, VT_UI4 = 19, VT_FILETIME = 64, VT_BLOB = 65, VT_CF = 71, VT_VECTOR_VARIANT = 4108, VT_VECTOR_LPSTR = 4126, VT_STRING = 80, VT_USTR = 81, VT_CUSTOM = [VT_STRING, VT_USTR], DocSummaryPIDDSI = {
  /*::[*/
  1: { n: "CodePage", t: VT_I2 },
  /*::[*/
  2: { n: "Category", t: VT_STRING },
  /*::[*/
  3: { n: "PresentationFormat", t: VT_STRING },
  /*::[*/
  4: { n: "ByteCount", t: VT_I4 },
  /*::[*/
  5: { n: "LineCount", t: VT_I4 },
  /*::[*/
  6: { n: "ParagraphCount", t: VT_I4 },
  /*::[*/
  7: { n: "SlideCount", t: VT_I4 },
  /*::[*/
  8: { n: "NoteCount", t: VT_I4 },
  /*::[*/
  9: { n: "HiddenCount", t: VT_I4 },
  /*::[*/
  10: { n: "MultimediaClipCount", t: VT_I4 },
  /*::[*/
  11: { n: "ScaleCrop", t: VT_BOOL },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: VT_VECTOR_VARIANT
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: VT_VECTOR_LPSTR
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: VT_STRING },
  /*::[*/
  15: { n: "Company", t: VT_STRING },
  /*::[*/
  16: { n: "LinksUpToDate", t: VT_BOOL },
  /*::[*/
  17: { n: "CharacterCount", t: VT_I4 },
  /*::[*/
  19: { n: "SharedDoc", t: VT_BOOL },
  /*::[*/
  22: { n: "HyperlinksChanged", t: VT_BOOL },
  /*::[*/
  23: { n: "AppVersion", t: VT_I4, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: VT_BLOB },
  /*::[*/
  26: { n: "ContentType", t: VT_STRING },
  /*::[*/
  27: { n: "ContentStatus", t: VT_STRING },
  /*::[*/
  28: { n: "Language", t: VT_STRING },
  /*::[*/
  29: { n: "Version", t: VT_STRING },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: VT_UI4 },
  /*::[*/
  2147483651: { n: "Behavior", t: VT_UI4 },
  /*::[*/
  1919054434: {}
}, SummaryPIDSI = {
  /*::[*/
  1: { n: "CodePage", t: VT_I2 },
  /*::[*/
  2: { n: "Title", t: VT_STRING },
  /*::[*/
  3: { n: "Subject", t: VT_STRING },
  /*::[*/
  4: { n: "Author", t: VT_STRING },
  /*::[*/
  5: { n: "Keywords", t: VT_STRING },
  /*::[*/
  6: { n: "Comments", t: VT_STRING },
  /*::[*/
  7: { n: "Template", t: VT_STRING },
  /*::[*/
  8: { n: "LastAuthor", t: VT_STRING },
  /*::[*/
  9: { n: "RevNumber", t: VT_STRING },
  /*::[*/
  10: { n: "EditTime", t: VT_FILETIME },
  /*::[*/
  11: { n: "LastPrinted", t: VT_FILETIME },
  /*::[*/
  12: { n: "CreatedDate", t: VT_FILETIME },
  /*::[*/
  13: { n: "ModifiedDate", t: VT_FILETIME },
  /*::[*/
  14: { n: "PageCount", t: VT_I4 },
  /*::[*/
  15: { n: "WordCount", t: VT_I4 },
  /*::[*/
  16: { n: "CharCount", t: VT_I4 },
  /*::[*/
  17: { n: "Thumbnail", t: VT_CF },
  /*::[*/
  18: { n: "Application", t: VT_STRING },
  /*::[*/
  19: { n: "DocSecurity", t: VT_I4 },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: VT_UI4 },
  /*::[*/
  2147483651: { n: "Behavior", t: VT_UI4 },
  /*::[*/
  1919054434: {}
}, CountryEnum = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, XLSFillPattern = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function rgbify(t) {
  return t.map(function(e) {
    return [e >> 16 & 255, e >> 8 & 255, e & 255];
  });
}
var _XLSIcv = /* @__PURE__ */ rgbify([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), XLSIcv = /* @__PURE__ */ dup(_XLSIcv), BErr = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, RBErr = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, ct2type = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
};
function new_ct() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function parse_ct(t) {
  var e = new_ct();
  if (!t || !t.match)
    return e;
  var n = {};
  if ((t.match(tagregex) || []).forEach(function(a) {
    var s = parsexmltag(a);
    switch (s[0].replace(nsregex, "<")) {
      case "<?xml":
        break;
      case "<Types":
        e.xmlns = s["xmlns" + (s[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        n[s.Extension] = s.ContentType;
        break;
      case "<Override":
        e[ct2type[s.ContentType]] !== void 0 && e[ct2type[s.ContentType]].push(s.PartName);
        break;
    }
  }), e.xmlns !== XMLNS.CT)
    throw new Error("Unknown Namespace: " + e.xmlns);
  return e.calcchain = e.calcchains.length > 0 ? e.calcchains[0] : "", e.sst = e.strs.length > 0 ? e.strs[0] : "", e.style = e.styles.length > 0 ? e.styles[0] : "", e.defaults = n, delete e.calcchains, e;
}
var RELS = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function get_rels_path(t) {
  var e = t.lastIndexOf("/");
  return t.slice(0, e + 1) + "_rels/" + t.slice(e + 1) + ".rels";
}
function parse_rels(t, e) {
  var n = { "!id": {} };
  if (!t)
    return n;
  e.charAt(0) !== "/" && (e = "/" + e);
  var a = {};
  return (t.match(tagregex) || []).forEach(function(s) {
    var o = parsexmltag(s);
    if (o[0] === "<Relationship") {
      var l = {};
      l.Type = o.Type, l.Target = o.Target, l.Id = o.Id, o.TargetMode && (l.TargetMode = o.TargetMode);
      var c = o.TargetMode === "External" ? o.Target : resolve_path(o.Target, e);
      n[c] = l, a[o.Id] = l;
    }
  }), n["!id"] = a, n;
}
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(t, e) {
  for (var n = xlml_normalize(t), a, s; a = xlmlregex.exec(n); )
    switch (a[3]) {
      case "manifest":
        break;
      case "file-entry":
        if (s = parsexmltag(a[0], !1), s.path == "/" && s.type !== CT_ODS)
          throw new Error("This OpenDocument is not a spreadsheet");
        break;
      case "encryption-data":
      case "algorithm":
      case "start-key-generation":
      case "key-derivation":
        throw new Error("Unsupported ODS Encryption");
      default:
        if (e && e.WTF)
          throw a;
    }
}
var CORE_PROPS = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], CORE_PROPS_REGEX = /* @__PURE__ */ function() {
  for (var t = new Array(CORE_PROPS.length), e = 0; e < CORE_PROPS.length; ++e) {
    var n = CORE_PROPS[e], a = "(?:" + n[0].slice(0, n[0].indexOf(":")) + ":)" + n[0].slice(n[0].indexOf(":") + 1);
    t[e] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
  }
  return t;
}();
function parse_core_props(t) {
  var e = {};
  t = utf8read(t);
  for (var n = 0; n < CORE_PROPS.length; ++n) {
    var a = CORE_PROPS[n], s = t.match(CORE_PROPS_REGEX[n]);
    s != null && s.length > 0 && (e[a[1]] = unescapexml(s[1])), a[2] === "date" && e[a[1]] && (e[a[1]] = parseDate(e[a[1]]));
  }
  return e;
}
var EXT_PROPS = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
];
function load_props_pairs(t, e, n, a) {
  var s = [];
  if (typeof t == "string")
    s = parseVector(t, a);
  else
    for (var o = 0; o < t.length; ++o)
      s = s.concat(t[o].map(function(f) {
        return { v: f };
      }));
  var l = typeof e == "string" ? parseVector(e, a).map(function(f) {
    return f.v;
  }) : e, c = 0, u = 0;
  if (l.length > 0)
    for (var d = 0; d !== s.length; d += 2) {
      switch (u = +s[d + 1].v, s[d].v) {
        case "Worksheets":
        case "工作表":
        case "Листы":
        case "أوراق العمل":
        case "ワークシート":
        case "גליונות עבודה":
        case "Arbeitsblätter":
        case "Çalışma Sayfaları":
        case "Feuilles de calcul":
        case "Fogli di lavoro":
        case "Folhas de cálculo":
        case "Planilhas":
        case "Regneark":
        case "Hojas de cálculo":
        case "Werkbladen":
          n.Worksheets = u, n.SheetNames = l.slice(c, c + u);
          break;
        case "Named Ranges":
        case "Rangos con nombre":
        case "名前付き一覧":
        case "Benannte Bereiche":
        case "Navngivne områder":
          n.NamedRanges = u, n.DefinedNames = l.slice(c, c + u);
          break;
        case "Charts":
        case "Diagramme":
          n.Chartsheets = u, n.ChartNames = l.slice(c, c + u);
          break;
      }
      c += u;
    }
}
function parse_ext_props(t, e, n) {
  var a = {};
  return e || (e = {}), t = utf8read(t), EXT_PROPS.forEach(function(s) {
    var o = (t.match(matchtag(s[0])) || [])[1];
    switch (s[2]) {
      case "string":
        o && (e[s[1]] = unescapexml(o));
        break;
      case "bool":
        e[s[1]] = o === "true";
        break;
      case "raw":
        var l = t.match(new RegExp("<" + s[0] + "[^>]*>([\\s\\S]*?)</" + s[0] + ">"));
        l && l.length > 0 && (a[s[1]] = l[1]);
        break;
    }
  }), a.HeadingPairs && a.TitlesOfParts && load_props_pairs(a.HeadingPairs, a.TitlesOfParts, e, n), e;
}
var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(t, e) {
  var n = {}, a = "", s = t.match(custregex);
  if (s)
    for (var o = 0; o != s.length; ++o) {
      var l = s[o], c = parsexmltag(l);
      switch (c[0]) {
        case "<?xml":
          break;
        case "<Properties":
          break;
        case "<property":
          a = unescapexml(c.name);
          break;
        case "</property>":
          a = null;
          break;
        default:
          if (l.indexOf("<vt:") === 0) {
            var u = l.split(">"), d = u[0].slice(4), f = u[1];
            switch (d) {
              case "lpstr":
              case "bstr":
              case "lpwstr":
                n[a] = unescapexml(f);
                break;
              case "bool":
                n[a] = parsexmlbool(f);
                break;
              case "i1":
              case "i2":
              case "i4":
              case "i8":
              case "int":
              case "uint":
                n[a] = parseInt(f, 10);
                break;
              case "r4":
              case "r8":
              case "decimal":
                n[a] = parseFloat(f);
                break;
              case "filetime":
              case "date":
                n[a] = parseDate(f);
                break;
              case "cy":
              case "error":
                n[a] = unescapexml(f);
                break;
              default:
                if (d.slice(-1) == "/")
                  break;
                e.WTF && typeof console < "u" && console.warn("Unexpected", l, d, u);
            }
          } else if (l.slice(0, 2) !== "</") {
            if (e.WTF)
              throw new Error(l);
          }
      }
    }
  return n;
}
var XLMLDocPropsMap = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, evert_XLMLDPM;
function xlml_set_prop(t, e, n) {
  evert_XLMLDPM || (evert_XLMLDPM = evert(XLMLDocPropsMap)), e = evert_XLMLDPM[e] || e, t[e] = n;
}
function parse_FILETIME(t) {
  var e = t.read_shift(4), n = t.read_shift(4);
  return new Date((n / 1e7 * Math.pow(2, 32) + e / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function parse_lpstr(t, e, n) {
  var a = t.l, s = t.read_shift(0, "lpstr-cp");
  if (n)
    for (; t.l - a & 3; )
      ++t.l;
  return s;
}
function parse_lpwstr(t, e, n) {
  var a = t.read_shift(0, "lpwstr");
  return n && (t.l += 4 - (a.length + 1 & 3) & 3), a;
}
function parse_VtStringBase(t, e, n) {
  return e === 31 ? parse_lpwstr(t) : parse_lpstr(t, e, n);
}
function parse_VtString(t, e, n) {
  return parse_VtStringBase(t, e, n === !1 ? 0 : 4);
}
function parse_VtUnalignedString(t, e) {
  if (!e)
    throw new Error("VtUnalignedString must have positive length");
  return parse_VtStringBase(t, e, 0);
}
function parse_VtVecLpwstrValue(t) {
  for (var e = t.read_shift(4), n = [], a = 0; a != e; ++a) {
    var s = t.l;
    n[a] = t.read_shift(0, "lpwstr").replace(chr0, ""), t.l - s & 2 && (t.l += 2);
  }
  return n;
}
function parse_VtVecUnalignedLpstrValue(t) {
  for (var e = t.read_shift(4), n = [], a = 0; a != e; ++a)
    n[a] = t.read_shift(0, "lpstr-cp").replace(chr0, "");
  return n;
}
function parse_VtHeadingPair(t) {
  var e = t.l, n = parse_TypedPropertyValue(t, VT_USTR);
  t[t.l] == 0 && t[t.l + 1] == 0 && t.l - e & 2 && (t.l += 2);
  var a = parse_TypedPropertyValue(t, VT_I4);
  return [n, a];
}
function parse_VtVecHeadingPairValue(t) {
  for (var e = t.read_shift(4), n = [], a = 0; a < e / 2; ++a)
    n.push(parse_VtHeadingPair(t));
  return n;
}
function parse_dictionary(t, e) {
  for (var n = t.read_shift(4), a = {}, s = 0; s != n; ++s) {
    var o = t.read_shift(4), l = t.read_shift(4);
    a[o] = t.read_shift(l, e === 1200 ? "utf16le" : "utf8").replace(chr0, "").replace(chr1, "!"), e === 1200 && l % 2 && (t.l += 2);
  }
  return t.l & 3 && (t.l = t.l >> 3 << 2), a;
}
function parse_BLOB(t) {
  var e = t.read_shift(4), n = t.slice(t.l, t.l + e);
  return t.l += e, (e & 3) > 0 && (t.l += 4 - (e & 3) & 3), n;
}
function parse_ClipboardData(t) {
  var e = {};
  return e.Size = t.read_shift(4), t.l += e.Size + 3 - (e.Size - 1) % 4, e;
}
function parse_TypedPropertyValue(t, e, n) {
  var a = t.read_shift(2), s, o = n || {};
  if (t.l += 2, e !== VT_VARIANT && a !== e && VT_CUSTOM.indexOf(e) === -1 && !((e & 65534) == 4126 && (a & 65534) == 4126))
    throw new Error("Expected type " + e + " saw " + a);
  switch (e === VT_VARIANT ? a : e) {
    case 2:
      return s = t.read_shift(2, "i"), o.raw || (t.l += 2), s;
    case 3:
      return s = t.read_shift(4, "i"), s;
    case 11:
      return t.read_shift(4) !== 0;
    case 19:
      return s = t.read_shift(4), s;
    case 30:
      return parse_lpstr(t, a, 4).replace(chr0, "");
    case 31:
      return parse_lpwstr(t);
    case 64:
      return parse_FILETIME(t);
    case 65:
      return parse_BLOB(t);
    case 71:
      return parse_ClipboardData(t);
    case 80:
      return parse_VtString(t, a, !o.raw).replace(chr0, "");
    case 81:
      return parse_VtUnalignedString(
        t,
        a
        /*, 4*/
      ).replace(chr0, "");
    case 4108:
      return parse_VtVecHeadingPairValue(t);
    case 4126:
    case 4127:
      return a == 4127 ? parse_VtVecLpwstrValue(t) : parse_VtVecUnalignedLpstrValue(t);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + e + " " + a);
  }
}
function parse_PropertySet(t, e) {
  var n = t.l, a = t.read_shift(4), s = t.read_shift(4), o = [], l = 0, c = 0, u = -1, d = {};
  for (l = 0; l != s; ++l) {
    var f = t.read_shift(4), h = t.read_shift(4);
    o[l] = [f, h + n];
  }
  o.sort(function(A, b) {
    return A[1] - b[1];
  });
  var g = {};
  for (l = 0; l != s; ++l) {
    if (t.l !== o[l][1]) {
      var x = !0;
      if (l > 0 && e)
        switch (e[o[l - 1][0]].t) {
          case 2:
            t.l + 2 === o[l][1] && (t.l += 2, x = !1);
            break;
          case 80:
            t.l <= o[l][1] && (t.l = o[l][1], x = !1);
            break;
          case 4108:
            t.l <= o[l][1] && (t.l = o[l][1], x = !1);
            break;
        }
      if ((!e || l == 0) && t.l <= o[l][1] && (x = !1, t.l = o[l][1]), x)
        throw new Error("Read Error: Expected address " + o[l][1] + " at " + t.l + " :" + l);
    }
    if (e) {
      var E = e[o[l][0]];
      if (g[E.n] = parse_TypedPropertyValue(t, E.t, { raw: !0 }), E.p === "version" && (g[E.n] = String(g[E.n] >> 16) + "." + ("0000" + String(g[E.n] & 65535)).slice(-4)), E.n == "CodePage")
        switch (g[E.n]) {
          case 0:
            g[E.n] = 1252;
          case 874:
          case 932:
          case 936:
          case 949:
          case 950:
          case 1250:
          case 1251:
          case 1253:
          case 1254:
          case 1255:
          case 1256:
          case 1257:
          case 1258:
          case 1e4:
          case 1200:
          case 1201:
          case 1252:
          case 65e3:
          case -536:
          case 65001:
          case -535:
            set_cp(c = g[E.n] >>> 0 & 65535);
            break;
          default:
            throw new Error("Unsupported CodePage: " + g[E.n]);
        }
    } else if (o[l][0] === 1) {
      if (c = g.CodePage = parse_TypedPropertyValue(t, VT_I2), set_cp(c), u !== -1) {
        var m = t.l;
        t.l = o[u][1], d = parse_dictionary(t, c), t.l = m;
      }
    } else if (o[l][0] === 0) {
      if (c === 0) {
        u = l, t.l = o[l + 1][1];
        continue;
      }
      d = parse_dictionary(t, c);
    } else {
      var v = d[o[l][0]], y;
      switch (t[t.l]) {
        case 65:
          t.l += 4, y = parse_BLOB(t);
          break;
        case 30:
          t.l += 4, y = parse_VtString(t, t[t.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          t.l += 4, y = parse_VtString(t, t[t.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          t.l += 4, y = t.read_shift(4, "i");
          break;
        case 19:
          t.l += 4, y = t.read_shift(4);
          break;
        case 5:
          t.l += 4, y = t.read_shift(8, "f");
          break;
        case 11:
          t.l += 4, y = parsebool(t, 4);
          break;
        case 64:
          t.l += 4, y = parseDate(parse_FILETIME(t));
          break;
        default:
          throw new Error("unparsed value: " + t[t.l]);
      }
      g[v] = y;
    }
  }
  return t.l = n + a, g;
}
function parse_PropertySetStream(t, e, n) {
  var a = t.content;
  if (!a)
    return {};
  prep_blob(a, 0);
  var s, o, l, c, u = 0;
  a.chk("feff", "Byte Order: "), a.read_shift(2);
  var d = a.read_shift(4), f = a.read_shift(16);
  if (f !== CFB.utils.consts.HEADER_CLSID && f !== n)
    throw new Error("Bad PropertySet CLSID " + f);
  if (s = a.read_shift(4), s !== 1 && s !== 2)
    throw new Error("Unrecognized #Sets: " + s);
  if (o = a.read_shift(16), c = a.read_shift(4), s === 1 && c !== a.l)
    throw new Error("Length mismatch: " + c + " !== " + a.l);
  s === 2 && (l = a.read_shift(16), u = a.read_shift(4));
  var h = parse_PropertySet(a, e), g = { SystemIdentifier: d };
  for (var x in h)
    g[x] = h[x];
  if (g.FMTID = o, s === 1)
    return g;
  if (u - a.l == 2 && (a.l += 2), a.l !== u)
    throw new Error("Length mismatch 2: " + a.l + " !== " + u);
  var E;
  try {
    E = parse_PropertySet(a, null);
  } catch {
  }
  for (x in E)
    g[x] = E[x];
  return g.FMTID = [o, l], g;
}
function parsenoop2(t, e) {
  return t.read_shift(e), null;
}
function parslurp(t, e, n) {
  for (var a = [], s = t.l + e; t.l < s; )
    a.push(n(t, s - t.l));
  if (s !== t.l)
    throw new Error("Slurp error");
  return a;
}
function parsebool(t, e) {
  return t.read_shift(e) === 1;
}
function parseuint16(t) {
  return t.read_shift(2, "u");
}
function parseuint16a(t, e) {
  return parslurp(t, e, parseuint16);
}
function parse_Bes(t) {
  var e = t.read_shift(1), n = t.read_shift(1);
  return n === 1 ? e : e === 1;
}
function parse_ShortXLUnicodeString(t, e, n) {
  var a = t.read_shift(n && n.biff >= 12 ? 2 : 1), s = "sbcs-cont";
  if (n && n.biff >= 8, !n || n.biff == 8) {
    var o = t.read_shift(1);
    o && (s = "dbcs-cont");
  } else
    n.biff == 12 && (s = "wstr");
  n.biff >= 2 && n.biff <= 5 && (s = "cpstr");
  var l = a ? t.read_shift(a, s) : "";
  return l;
}
function parse_XLUnicodeRichExtendedString(t) {
  var e = t.read_shift(2), n = t.read_shift(1), a = n & 4, s = n & 8, o = 1 + (n & 1), l = 0, c, u = {};
  s && (l = t.read_shift(2)), a && (c = t.read_shift(4));
  var d = o == 2 ? "dbcs-cont" : "sbcs-cont", f = e === 0 ? "" : t.read_shift(e, d);
  return s && (t.l += 4 * l), a && (t.l += c), u.t = f, s || (u.raw = "<t>" + u.t + "</t>", u.r = u.t), u;
}
function parse_XLUnicodeStringNoCch(t, e, n) {
  var a;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5)
      return t.read_shift(e, "cpstr");
    if (n.biff >= 12)
      return t.read_shift(e, "dbcs-cont");
  }
  var s = t.read_shift(1);
  return s === 0 ? a = t.read_shift(e, "sbcs-cont") : a = t.read_shift(e, "dbcs-cont"), a;
}
function parse_XLUnicodeString(t, e, n) {
  var a = t.read_shift(n && n.biff == 2 ? 1 : 2);
  return a === 0 ? (t.l++, "") : parse_XLUnicodeStringNoCch(t, a, n);
}
function parse_XLUnicodeString2(t, e, n) {
  if (n.biff > 5)
    return parse_XLUnicodeString(t, e, n);
  var a = t.read_shift(1);
  return a === 0 ? (t.l++, "") : t.read_shift(a, n.biff <= 4 || !t.lens ? "cpstr" : "sbcs-cont");
}
function parse_ControlInfo(t) {
  var e = t.read_shift(1);
  t.l++;
  var n = t.read_shift(2);
  return t.l += 2, [e, n];
}
function parse_URLMoniker(t) {
  var e = t.read_shift(4), n = t.l, a = !1;
  e > 24 && (t.l += e - 24, t.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (a = !0), t.l = n);
  var s = t.read_shift((a ? e - 24 : e) >> 1, "utf16le").replace(chr0, "");
  return a && (t.l += 24), s;
}
function parse_FileMoniker(t) {
  for (var e = t.read_shift(2), n = ""; e-- > 0; )
    n += "../";
  var a = t.read_shift(0, "lpstr-ansi");
  if (t.l += 2, t.read_shift(2) != 57005)
    throw new Error("Bad FileMoniker");
  var s = t.read_shift(4);
  if (s === 0)
    return n + a.replace(/\\/g, "/");
  var o = t.read_shift(4);
  if (t.read_shift(2) != 3)
    throw new Error("Bad FileMoniker");
  var l = t.read_shift(o >> 1, "utf16le").replace(chr0, "");
  return n + l;
}
function parse_HyperlinkMoniker(t, e) {
  var n = t.read_shift(16);
  switch (n) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return parse_URLMoniker(t);
    case "0303000000000000c000000000000046":
      return parse_FileMoniker(t);
    default:
      throw new Error("Unsupported Moniker " + n);
  }
}
function parse_HyperlinkString(t) {
  var e = t.read_shift(4), n = e > 0 ? t.read_shift(e, "utf16le").replace(chr0, "") : "";
  return n;
}
function parse_Hyperlink(t, e) {
  var n = t.l + e, a = t.read_shift(4);
  if (a !== 2)
    throw new Error("Unrecognized streamVersion: " + a);
  var s = t.read_shift(2);
  t.l += 2;
  var o, l, c, u, d = "", f, h;
  s & 16 && (o = parse_HyperlinkString(t, n - t.l)), s & 128 && (l = parse_HyperlinkString(t, n - t.l)), (s & 257) === 257 && (c = parse_HyperlinkString(t, n - t.l)), (s & 257) === 1 && (u = parse_HyperlinkMoniker(t, n - t.l)), s & 8 && (d = parse_HyperlinkString(t, n - t.l)), s & 32 && (f = t.read_shift(16)), s & 64 && (h = parse_FILETIME(
    t
    /*, 8*/
  )), t.l = n;
  var g = l || c || u || "";
  g && d && (g += "#" + d), g || (g = "#" + d), s & 2 && g.charAt(0) == "/" && g.charAt(1) != "/" && (g = "file://" + g);
  var x = { Target: g };
  return f && (x.guid = f), h && (x.time = h), o && (x.Tooltip = o), x;
}
function parse_LongRGBA(t) {
  var e = t.read_shift(1), n = t.read_shift(1), a = t.read_shift(1), s = t.read_shift(1);
  return [e, n, a, s];
}
function parse_LongRGB(t, e) {
  var n = parse_LongRGBA(t);
  return n[3] = 0, n;
}
function parse_XLSCell(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(2);
  return { r: e, c: n, ixfe: a };
}
function parse_frtHeader(t) {
  var e = t.read_shift(2), n = t.read_shift(2);
  return t.l += 8, { type: e, flags: n };
}
function parse_OptXLUnicodeString(t, e, n) {
  return e === 0 ? "" : parse_XLUnicodeString2(t, e, n);
}
function parse_XTI(t, e, n) {
  var a = n.biff > 8 ? 4 : 2, s = t.read_shift(a), o = t.read_shift(a, "i"), l = t.read_shift(a, "i");
  return [s, o, l];
}
function parse_RkRec(t) {
  var e = t.read_shift(2), n = parse_RkNumber(t);
  return [e, n];
}
function parse_AddinUdf(t, e, n) {
  t.l += 4, e -= 4;
  var a = t.l + e, s = parse_ShortXLUnicodeString(t, e, n), o = t.read_shift(2);
  if (a -= t.l, o !== a)
    throw new Error("Malformed AddinUdf: padding = " + a + " != " + o);
  return t.l += o, s;
}
function parse_Ref8U(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(2), s = t.read_shift(2);
  return { s: { c: a, r: e }, e: { c: s, r: n } };
}
function parse_RefU(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(1), s = t.read_shift(1);
  return { s: { c: a, r: e }, e: { c: s, r: n } };
}
var parse_Ref = parse_RefU;
function parse_FtCmo(t) {
  t.l += 4;
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(2);
  return t.l += 12, [n, e, a];
}
function parse_FtNts(t) {
  var e = {};
  return t.l += 4, t.l += 16, e.fSharedNote = t.read_shift(2), t.l += 4, e;
}
function parse_FtCf(t) {
  var e = {};
  return t.l += 4, t.cf = t.read_shift(2), e;
}
function parse_FtSkip(t) {
  t.l += 2, t.l += t.read_shift(2);
}
var FtTab = {
  /*::[*/
  0: parse_FtSkip,
  /* FtEnd */
  /*::[*/
  4: parse_FtSkip,
  /* FtMacro */
  /*::[*/
  5: parse_FtSkip,
  /* FtButton */
  /*::[*/
  6: parse_FtSkip,
  /* FtGmo */
  /*::[*/
  7: parse_FtCf,
  /* FtCf */
  /*::[*/
  8: parse_FtSkip,
  /* FtPioGrbit */
  /*::[*/
  9: parse_FtSkip,
  /* FtPictFmla */
  /*::[*/
  10: parse_FtSkip,
  /* FtCbls */
  /*::[*/
  11: parse_FtSkip,
  /* FtRbo */
  /*::[*/
  12: parse_FtSkip,
  /* FtSbs */
  /*::[*/
  13: parse_FtNts,
  /* FtNts */
  /*::[*/
  14: parse_FtSkip,
  /* FtSbsFmla */
  /*::[*/
  15: parse_FtSkip,
  /* FtGboData */
  /*::[*/
  16: parse_FtSkip,
  /* FtEdoData */
  /*::[*/
  17: parse_FtSkip,
  /* FtRboData */
  /*::[*/
  18: parse_FtSkip,
  /* FtCblsData */
  /*::[*/
  19: parse_FtSkip,
  /* FtLbsData */
  /*::[*/
  20: parse_FtSkip,
  /* FtCblsFmla */
  /*::[*/
  21: parse_FtCmo
};
function parse_FtArray(t, e) {
  for (var n = t.l + e, a = []; t.l < n; ) {
    var s = t.read_shift(2);
    t.l -= 2;
    try {
      a.push(FtTab[s](t, n - t.l));
    } catch {
      return t.l = n, a;
    }
  }
  return t.l != n && (t.l = n), a;
}
function parse_BOF(t, e) {
  var n = { BIFFVer: 0, dt: 0 };
  switch (n.BIFFVer = t.read_shift(2), e -= 2, e >= 2 && (n.dt = t.read_shift(2), t.l -= 2), n.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (e > 6)
        throw new Error("Unexpected BIFF Ver " + n.BIFFVer);
  }
  return t.read_shift(e), n;
}
function parse_InterfaceHdr(t, e) {
  return e === 0 || t.read_shift(2), 1200;
}
function parse_WriteAccess(t, e, n) {
  if (n.enc)
    return t.l += e, "";
  var a = t.l, s = parse_XLUnicodeString2(t, 0, n);
  return t.read_shift(e + a - t.l), s;
}
function parse_WsBool(t, e, n) {
  var a = n && n.biff == 8 || e == 2 ? t.read_shift(2) : (t.l += e, 0);
  return { fDialog: a & 16, fBelow: a & 64, fRight: a & 128 };
}
function parse_BoundSheet8(t, e, n) {
  var a = t.read_shift(4), s = t.read_shift(1) & 3, o = t.read_shift(1);
  switch (o) {
    case 0:
      o = "Worksheet";
      break;
    case 1:
      o = "Macrosheet";
      break;
    case 2:
      o = "Chartsheet";
      break;
    case 6:
      o = "VBAModule";
      break;
  }
  var l = parse_ShortXLUnicodeString(t, 0, n);
  return l.length === 0 && (l = "Sheet1"), { pos: a, hs: s, dt: o, name: l };
}
function parse_SST(t, e) {
  for (var n = t.l + e, a = t.read_shift(4), s = t.read_shift(4), o = [], l = 0; l != s && t.l < n; ++l)
    o.push(parse_XLUnicodeRichExtendedString(t));
  return o.Count = a, o.Unique = s, o;
}
function parse_ExtSST(t, e) {
  var n = {};
  return n.dsst = t.read_shift(2), t.l += e - 2, n;
}
function parse_Row(t) {
  var e = {};
  e.r = t.read_shift(2), e.c = t.read_shift(2), e.cnt = t.read_shift(2) - e.c;
  var n = t.read_shift(2);
  t.l += 4;
  var a = t.read_shift(1);
  return t.l += 3, a & 7 && (e.level = a & 7), a & 32 && (e.hidden = !0), a & 64 && (e.hpt = n / 20), e;
}
function parse_ForceFullCalculation(t) {
  var e = parse_frtHeader(t);
  if (e.type != 2211)
    throw new Error("Invalid Future Record " + e.type);
  var n = t.read_shift(4);
  return n !== 0;
}
function parse_RecalcId(t) {
  return t.read_shift(2), t.read_shift(4);
}
function parse_DefaultRowHeight(t, e, n) {
  var a = 0;
  n && n.biff == 2 || (a = t.read_shift(2));
  var s = t.read_shift(2);
  n && n.biff == 2 && (a = 1 - (s >> 15), s &= 32767);
  var o = { Unsynced: a & 1, DyZero: (a & 2) >> 1, ExAsc: (a & 4) >> 2, ExDsc: (a & 8) >> 3 };
  return [o, s];
}
function parse_Window1(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(2), s = t.read_shift(2), o = t.read_shift(2), l = t.read_shift(2), c = t.read_shift(2), u = t.read_shift(2), d = t.read_shift(2);
  return {
    Pos: [e, n],
    Dim: [a, s],
    Flags: o,
    CurTab: l,
    FirstTab: c,
    Selected: u,
    TabRatio: d
  };
}
function parse_Window2(t, e, n) {
  if (n && n.biff >= 2 && n.biff < 5)
    return {};
  var a = t.read_shift(2);
  return { RTL: a & 64 };
}
function parse_Pane() {
}
function parse_Font(t, e, n) {
  var a = {
    dyHeight: t.read_shift(2),
    fl: t.read_shift(2)
  };
  switch (n && n.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      t.l += 2;
      break;
    default:
      t.l += 10;
      break;
  }
  return a.name = parse_ShortXLUnicodeString(t, 0, n), a;
}
function parse_LabelSst(t) {
  var e = parse_XLSCell(t);
  return e.isst = t.read_shift(4), e;
}
function parse_Label(t, e, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var a = t.l + e, s = parse_XLSCell(t);
  n.biff == 2 && t.l++;
  var o = parse_XLUnicodeString(t, a - t.l, n);
  return s.val = o, s;
}
function parse_Format(t, e, n) {
  var a = t.read_shift(2), s = parse_XLUnicodeString2(t, 0, n);
  return [a, s];
}
var parse_BIFF2Format = parse_XLUnicodeString2;
function parse_Dimensions(t, e, n) {
  var a = t.l + e, s = n.biff == 8 || !n.biff ? 4 : 2, o = t.read_shift(s), l = t.read_shift(s), c = t.read_shift(2), u = t.read_shift(2);
  return t.l = a, { s: { r: o, c }, e: { r: l, c: u } };
}
function parse_RK(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = parse_RkRec(t);
  return { r: e, c: n, ixfe: a[0], rknum: a[1] };
}
function parse_MulRk(t, e) {
  for (var n = t.l + e - 2, a = t.read_shift(2), s = t.read_shift(2), o = []; t.l < n; )
    o.push(parse_RkRec(t));
  if (t.l !== n)
    throw new Error("MulRK read error");
  var l = t.read_shift(2);
  if (o.length != l - s + 1)
    throw new Error("MulRK length mismatch");
  return { r: a, c: s, C: l, rkrec: o };
}
function parse_MulBlank(t, e) {
  for (var n = t.l + e - 2, a = t.read_shift(2), s = t.read_shift(2), o = []; t.l < n; )
    o.push(t.read_shift(2));
  if (t.l !== n)
    throw new Error("MulBlank read error");
  var l = t.read_shift(2);
  if (o.length != l - s + 1)
    throw new Error("MulBlank length mismatch");
  return { r: a, c: s, C: l, ixfe: o };
}
function parse_CellStyleXF(t, e, n, a) {
  var s = {}, o = t.read_shift(4), l = t.read_shift(4), c = t.read_shift(4), u = t.read_shift(2);
  return s.patternType = XLSFillPattern[c >> 26], a.cellStyles && (s.alc = o & 7, s.fWrap = o >> 3 & 1, s.alcV = o >> 4 & 7, s.fJustLast = o >> 7 & 1, s.trot = o >> 8 & 255, s.cIndent = o >> 16 & 15, s.fShrinkToFit = o >> 20 & 1, s.iReadOrder = o >> 22 & 2, s.fAtrNum = o >> 26 & 1, s.fAtrFnt = o >> 27 & 1, s.fAtrAlc = o >> 28 & 1, s.fAtrBdr = o >> 29 & 1, s.fAtrPat = o >> 30 & 1, s.fAtrProt = o >> 31 & 1, s.dgLeft = l & 15, s.dgRight = l >> 4 & 15, s.dgTop = l >> 8 & 15, s.dgBottom = l >> 12 & 15, s.icvLeft = l >> 16 & 127, s.icvRight = l >> 23 & 127, s.grbitDiag = l >> 30 & 3, s.icvTop = c & 127, s.icvBottom = c >> 7 & 127, s.icvDiag = c >> 14 & 127, s.dgDiag = c >> 21 & 15, s.icvFore = u & 127, s.icvBack = u >> 7 & 127, s.fsxButton = u >> 14 & 1), s;
}
function parse_XF(t, e, n) {
  var a = {};
  return a.ifnt = t.read_shift(2), a.numFmtId = t.read_shift(2), a.flags = t.read_shift(2), a.fStyle = a.flags >> 2 & 1, e -= 6, a.data = parse_CellStyleXF(t, e, a.fStyle, n), a;
}
function parse_Guts(t) {
  t.l += 4;
  var e = [t.read_shift(2), t.read_shift(2)];
  if (e[0] !== 0 && e[0]--, e[1] !== 0 && e[1]--, e[0] > 7 || e[1] > 7)
    throw new Error("Bad Gutters: " + e.join("|"));
  return e;
}
function parse_BoolErr(t, e, n) {
  var a = parse_XLSCell(t);
  (n.biff == 2 || e == 9) && ++t.l;
  var s = parse_Bes(t);
  return a.val = s, a.t = s === !0 || s === !1 ? "b" : "e", a;
}
function parse_Number(t, e, n) {
  n.biffguess && n.biff == 2 && (n.biff = 5);
  var a = parse_XLSCell(t), s = parse_Xnum(t);
  return a.val = s, a;
}
var parse_XLHeaderFooter = parse_OptXLUnicodeString;
function parse_SupBook(t, e, n) {
  var a = t.l + e, s = t.read_shift(2), o = t.read_shift(2);
  if (n.sbcch = o, o == 1025 || o == 14849)
    return [o, s];
  if (o < 1 || o > 255)
    throw new Error("Unexpected SupBook type: " + o);
  for (var l = parse_XLUnicodeStringNoCch(t, o), c = []; a > t.l; )
    c.push(parse_XLUnicodeString(t));
  return [o, s, l, c];
}
function parse_ExternName(t, e, n) {
  var a = t.read_shift(2), s, o = {
    fBuiltIn: a & 1,
    fWantAdvise: a >>> 1 & 1,
    fWantPict: a >>> 2 & 1,
    fOle: a >>> 3 & 1,
    fOleLink: a >>> 4 & 1,
    cf: a >>> 5 & 1023,
    fIcon: a >>> 15 & 1
  };
  return n.sbcch === 14849 && (s = parse_AddinUdf(t, e - 2, n)), o.body = s || t.read_shift(e - 2), typeof s == "string" && (o.Name = s), o;
}
var XLSLblBuiltIn = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
];
function parse_Lbl(t, e, n) {
  var a = t.l + e, s = t.read_shift(2), o = t.read_shift(1), l = t.read_shift(1), c = t.read_shift(n && n.biff == 2 ? 1 : 2), u = 0;
  (!n || n.biff >= 5) && (n.biff != 5 && (t.l += 2), u = t.read_shift(2), n.biff == 5 && (t.l += 2), t.l += 4);
  var d = parse_XLUnicodeStringNoCch(t, l, n);
  s & 32 && (d = XLSLblBuiltIn[d.charCodeAt(0)]);
  var f = a - t.l;
  n && n.biff == 2 && --f;
  var h = a == t.l || c === 0 || !(f > 0) ? [] : parse_NameParsedFormula(t, f, n, c);
  return {
    chKey: o,
    Name: d,
    itab: u,
    rgce: h
  };
}
function parse_ExternSheet(t, e, n) {
  if (n.biff < 8)
    return parse_BIFF5ExternSheet(t, e, n);
  for (var a = [], s = t.l + e, o = t.read_shift(n.biff > 8 ? 4 : 2); o-- !== 0; )
    a.push(parse_XTI(t, n.biff > 8 ? 12 : 6, n));
  if (t.l != s)
    throw new Error("Bad ExternSheet: " + t.l + " != " + s);
  return a;
}
function parse_BIFF5ExternSheet(t, e, n) {
  t[t.l + 1] == 3 && t[t.l]++;
  var a = parse_ShortXLUnicodeString(t, e, n);
  return a.charCodeAt(0) == 3 ? a.slice(1) : a;
}
function parse_NameCmt(t, e, n) {
  if (n.biff < 8) {
    t.l += e;
    return;
  }
  var a = t.read_shift(2), s = t.read_shift(2), o = parse_XLUnicodeStringNoCch(t, a, n), l = parse_XLUnicodeStringNoCch(t, s, n);
  return [o, l];
}
function parse_ShrFmla(t, e, n) {
  var a = parse_RefU(t);
  t.l++;
  var s = t.read_shift(1);
  return e -= 8, [parse_SharedParsedFormula(t, e, n), s, a];
}
function parse_Array(t, e, n) {
  var a = parse_Ref(t);
  switch (n.biff) {
    case 2:
      t.l++, e -= 7;
      break;
    case 3:
    case 4:
      t.l += 2, e -= 8;
      break;
    default:
      t.l += 6, e -= 12;
  }
  return [a, parse_ArrayParsedFormula(t, e, n)];
}
function parse_MTRSettings(t) {
  var e = t.read_shift(4) !== 0, n = t.read_shift(4) !== 0, a = t.read_shift(4);
  return [e, n, a];
}
function parse_NoteSh(t, e, n) {
  if (!(n.biff < 8)) {
    var a = t.read_shift(2), s = t.read_shift(2), o = t.read_shift(2), l = t.read_shift(2), c = parse_XLUnicodeString2(t, 0, n);
    return n.biff < 8 && t.read_shift(1), [{ r: a, c: s }, c, l, o];
  }
}
function parse_Note(t, e, n) {
  return parse_NoteSh(t, e, n);
}
function parse_MergeCells(t, e) {
  for (var n = [], a = t.read_shift(2); a--; )
    n.push(parse_Ref8U(t));
  return n;
}
function parse_Obj(t, e, n) {
  if (n && n.biff < 8)
    return parse_BIFF5Obj(t, e, n);
  var a = parse_FtCmo(t), s = parse_FtArray(t, e - 22, a[1]);
  return { cmo: a, ft: s };
}
var parse_BIFF5OT = {
  8: function(t, e) {
    var n = t.l + e;
    t.l += 10;
    var a = t.read_shift(2);
    t.l += 4, t.l += 2, t.l += 2, t.l += 2, t.l += 4;
    var s = t.read_shift(1);
    return t.l += s, t.l = n, { fmt: a };
  }
};
function parse_BIFF5Obj(t, e, n) {
  t.l += 4;
  var a = t.read_shift(2), s = t.read_shift(2), o = t.read_shift(2);
  t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 2, t.l += 6, e -= 36;
  var l = [];
  return l.push((parse_BIFF5OT[a] || parsenoop)(t, e, n)), { cmo: [s, a, o], ft: l };
}
function parse_TxO(t, e, n) {
  var a = t.l, s = "";
  try {
    t.l += 4;
    var o = (n.lastobj || { cmo: [0, 0] }).cmo[1], l;
    [0, 5, 7, 11, 12, 14].indexOf(o) == -1 ? t.l += 6 : l = parse_ControlInfo(t, 6, n);
    var c = t.read_shift(2);
    t.read_shift(2), parseuint16(t, 2);
    var u = t.read_shift(2);
    t.l += u;
    for (var d = 1; d < t.lens.length - 1; ++d) {
      if (t.l - a != t.lens[d])
        throw new Error("TxO: bad continue record");
      var f = t[t.l], h = parse_XLUnicodeStringNoCch(t, t.lens[d + 1] - t.lens[d] - 1);
      if (s += h, s.length >= (f ? c : 2 * c))
        break;
    }
    if (s.length !== c && s.length !== c * 2)
      throw new Error("cchText: " + c + " != " + s.length);
    return t.l = a + e, { t: s };
  } catch {
    return t.l = a + e, { t: s };
  }
}
function parse_HLink(t, e) {
  var n = parse_Ref8U(t);
  t.l += 16;
  var a = parse_Hyperlink(t, e - 24);
  return [n, a];
}
function parse_HLinkTooltip(t, e) {
  t.read_shift(2);
  var n = parse_Ref8U(t), a = t.read_shift((e - 10) / 2, "dbcs-cont");
  return a = a.replace(chr0, ""), [n, a];
}
function parse_Country(t) {
  var e = [0, 0], n;
  return n = t.read_shift(2), e[0] = CountryEnum[n] || n, n = t.read_shift(2), e[1] = CountryEnum[n] || n, e;
}
function parse_ClrtClient(t) {
  for (var e = t.read_shift(2), n = []; e-- > 0; )
    n.push(parse_LongRGB(t));
  return n;
}
function parse_Palette(t) {
  for (var e = t.read_shift(2), n = []; e-- > 0; )
    n.push(parse_LongRGB(t));
  return n;
}
function parse_XFCRC(t) {
  t.l += 2;
  var e = { cxfs: 0, crc: 0 };
  return e.cxfs = t.read_shift(2), e.crc = t.read_shift(4), e;
}
function parse_ColInfo(t, e, n) {
  if (!n.cellStyles)
    return parsenoop(t, e);
  var a = n && n.biff >= 12 ? 4 : 2, s = t.read_shift(a), o = t.read_shift(a), l = t.read_shift(a), c = t.read_shift(a), u = t.read_shift(2);
  a == 2 && (t.l += 2);
  var d = { s, e: o, w: l, ixfe: c, flags: u };
  return (n.biff >= 5 || !n.biff) && (d.level = u >> 8 & 7), d;
}
function parse_Setup(t, e) {
  var n = {};
  return e < 32 || (t.l += 16, n.header = parse_Xnum(t), n.footer = parse_Xnum(t), t.l += 2), n;
}
function parse_ShtProps(t, e, n) {
  var a = { area: !1 };
  if (n.biff != 5)
    return t.l += e, a;
  var s = t.read_shift(1);
  return t.l += 3, s & 16 && (a.area = !0), a;
}
var parse_Blank = parse_XLSCell, parse_Scl = parseuint16a, parse_String = parse_XLUnicodeString;
function parse_ImData(t) {
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(4), s = { fmt: e, env: n, len: a, data: t.slice(t.l, t.l + a) };
  return t.l += a, s;
}
function parse_BIFF2STR(t, e, n) {
  n.biffguess && n.biff == 5 && (n.biff = 2);
  var a = parse_XLSCell(t);
  ++t.l;
  var s = parse_XLUnicodeString2(t, e - 7, n);
  return a.t = "str", a.val = s, a;
}
function parse_BIFF2NUM(t) {
  var e = parse_XLSCell(t);
  ++t.l;
  var n = parse_Xnum(t);
  return e.t = "n", e.val = n, e;
}
function parse_BIFF2INT(t) {
  var e = parse_XLSCell(t);
  ++t.l;
  var n = t.read_shift(2);
  return e.t = "n", e.val = n, e;
}
function parse_BIFF2STRING(t) {
  var e = t.read_shift(1);
  return e === 0 ? (t.l++, "") : t.read_shift(e, "sbcs-cont");
}
function parse_BIFF2FONTXTRA(t, e) {
  t.l += 6, t.l += 2, t.l += 1, t.l += 3, t.l += 1, t.l += e - 13;
}
function parse_RString(t, e, n) {
  var a = t.l + e, s = parse_XLSCell(t), o = t.read_shift(2), l = parse_XLUnicodeStringNoCch(t, o, n);
  return t.l = a, s.t = "str", s.val = l, s;
}
var DBF_SUPPORTED_VERSIONS = [2, 3, 48, 49, 131, 139, 140, 245], DBF = /* @__PURE__ */ function() {
  var t = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, e = evert({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function n(c, u) {
    var d = [], f = new_raw_buf(1);
    switch (u.type) {
      case "base64":
        f = s2a(Base64_decode(c));
        break;
      case "binary":
        f = s2a(c);
        break;
      case "buffer":
      case "array":
        f = c;
        break;
    }
    prep_blob(f, 0);
    var h = f.read_shift(1), g = !!(h & 136), x = !1, E = !1;
    switch (h) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        x = !0, g = !0;
        break;
      case 49:
        x = !0, g = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        E = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + h.toString(16));
    }
    var m = 0, v = 521;
    h == 2 && (m = f.read_shift(2)), f.l += 3, h != 2 && (m = f.read_shift(4)), m > 1048576 && (m = 1e6), h != 2 && (v = f.read_shift(2));
    var y = f.read_shift(2), A = u.codepage || 1252;
    h != 2 && (f.l += 16, f.read_shift(1), f[f.l] !== 0 && (A = t[f[f.l]]), f.l += 1, f.l += 2), E && (f.l += 36);
    for (var b = [], C = {}, T = Math.min(f.length, h == 2 ? 521 : v - 10 - (x ? 264 : 0)), w = E ? 32 : 11; f.l < T && f[f.l] != 13; )
      switch (C = {}, C.name = $cptable.utils.decode(A, f.slice(f.l, f.l + w)).replace(/[\u0000\r\n].*$/g, ""), f.l += w, C.type = String.fromCharCode(f.read_shift(1)), h != 2 && !E && (C.offset = f.read_shift(4)), C.len = f.read_shift(1), h == 2 && (C.offset = f.read_shift(2)), C.dec = f.read_shift(1), C.name.length && b.push(C), h != 2 && (f.l += E ? 13 : 14), C.type) {
        case "B":
          (!x || C.len != 8) && u.WTF && console.log("Skipping " + C.name + ":" + C.type);
          break;
        case "G":
        case "P":
          u.WTF && console.log("Skipping " + C.name + ":" + C.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + C.type);
      }
    if (f[f.l] !== 13 && (f.l = v - 1), f.read_shift(1) !== 13)
      throw new Error("DBF Terminator not found " + f.l + " " + f[f.l]);
    f.l = v;
    var R = 0, O = 0;
    for (d[0] = [], O = 0; O != b.length; ++O)
      d[0][O] = b[O].name;
    for (; m-- > 0; ) {
      if (f[f.l] === 42) {
        f.l += y;
        continue;
      }
      for (++f.l, d[++R] = [], O = 0, O = 0; O != b.length; ++O) {
        var D = f.slice(f.l, f.l + b[O].len);
        f.l += b[O].len, prep_blob(D, 0);
        var k = $cptable.utils.decode(A, D);
        switch (b[O].type) {
          case "C":
            k.trim().length && (d[R][O] = k.replace(/\s+$/, ""));
            break;
          case "D":
            k.length === 8 ? d[R][O] = new Date(+k.slice(0, 4), +k.slice(4, 6) - 1, +k.slice(6, 8)) : d[R][O] = k;
            break;
          case "F":
            d[R][O] = parseFloat(k.trim());
            break;
          case "+":
          case "I":
            d[R][O] = E ? D.read_shift(-4, "i") ^ 2147483648 : D.read_shift(4, "i");
            break;
          case "L":
            switch (k.trim().toUpperCase()) {
              case "Y":
              case "T":
                d[R][O] = !0;
                break;
              case "N":
              case "F":
                d[R][O] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + k + "|");
            }
            break;
          case "M":
            if (!g)
              throw new Error("DBF Unexpected MEMO for type " + h.toString(16));
            d[R][O] = "##MEMO##" + (E ? parseInt(k.trim(), 10) : D.read_shift(4));
            break;
          case "N":
            k = k.replace(/\u0000/g, "").trim(), k && k != "." && (d[R][O] = +k || 0);
            break;
          case "@":
            d[R][O] = new Date(D.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            d[R][O] = new Date((D.read_shift(4) - 2440588) * 864e5 + D.read_shift(4));
            break;
          case "Y":
            d[R][O] = D.read_shift(4, "i") / 1e4 + D.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            d[R][O] = -D.read_shift(-8, "f");
            break;
          case "B":
            if (x && b[O].len == 8) {
              d[R][O] = D.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            D.l += b[O].len;
            break;
          case "0":
            if (b[O].name === "_NullFlags")
              break;
          default:
            throw new Error("DBF Unsupported data type " + b[O].type);
        }
      }
    }
    if (h != 2 && f.l < f.length && f[f.l++] != 26)
      throw new Error("DBF EOF Marker missing " + (f.l - 1) + " of " + f.length + " " + f[f.l - 1].toString(16));
    return u && u.sheetRows && (d = d.slice(0, u.sheetRows)), u.DBF = b, d;
  }
  function a(c, u) {
    var d = u || {};
    d.dateNF || (d.dateNF = "yyyymmdd");
    var f = aoa_to_sheet(n(c, d), d);
    return f["!cols"] = d.DBF.map(function(h) {
      return {
        wch: h.len,
        DBF: h
      };
    }), delete d.DBF, f;
  }
  function s(c, u) {
    try {
      return sheet_to_workbook(a(c, u), u);
    } catch (d) {
      if (u && u.WTF)
        throw d;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var o = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function l(c, u) {
    var d = u || {};
    if (+d.codepage >= 0 && set_cp(+d.codepage), d.type == "string")
      throw new Error("Cannot write DBF to JS string");
    var f = buf_array(), h = sheet_to_json(c, { header: 1, raw: !0, cellDates: !0 }), g = h[0], x = h.slice(1), E = c["!cols"] || [], m = 0, v = 0, y = 0, A = 1;
    for (m = 0; m < g.length; ++m) {
      if (((E[m] || {}).DBF || {}).name) {
        g[m] = E[m].DBF.name, ++y;
        continue;
      }
      if (g[m] != null) {
        if (++y, typeof g[m] == "number" && (g[m] = g[m].toString(10)), typeof g[m] != "string")
          throw new Error("DBF Invalid column name " + g[m] + " |" + typeof g[m] + "|");
        if (g.indexOf(g[m]) !== m) {
          for (v = 0; v < 1024; ++v)
            if (g.indexOf(g[m] + "_" + v) == -1) {
              g[m] += "_" + v;
              break;
            }
        }
      }
    }
    var b = safe_decode_range(c["!ref"]), C = [], T = [], w = [];
    for (m = 0; m <= b.e.c - b.s.c; ++m) {
      var R = "", O = "", D = 0, k = [];
      for (v = 0; v < x.length; ++v)
        x[v][m] != null && k.push(x[v][m]);
      if (k.length == 0 || g[m] == null) {
        C[m] = "?";
        continue;
      }
      for (v = 0; v < k.length; ++v) {
        switch (typeof k[v]) {
          case "number":
            O = "B";
            break;
          case "string":
            O = "C";
            break;
          case "boolean":
            O = "L";
            break;
          case "object":
            O = k[v] instanceof Date ? "D" : "C";
            break;
          default:
            O = "C";
        }
        D = Math.max(D, String(k[v]).length), R = R && R != O ? "C" : O;
      }
      D > 250 && (D = 250), O = ((E[m] || {}).DBF || {}).type, O == "C" && E[m].DBF.len > D && (D = E[m].DBF.len), R == "B" && O == "N" && (R = "N", w[m] = E[m].DBF.dec, D = E[m].DBF.len), T[m] = R == "C" || O == "N" ? D : o[R] || 0, A += T[m], C[m] = R;
    }
    var W = f.next(32);
    for (W.write_shift(4, 318902576), W.write_shift(4, x.length), W.write_shift(2, 296 + 32 * y), W.write_shift(2, A), m = 0; m < 4; ++m)
      W.write_shift(4, 0);
    for (W.write_shift(4, 0 | (+e[
      /*::String(*/
      current_ansi
      /*::)*/
    ] || 3) << 8), m = 0, v = 0; m < g.length; ++m)
      if (g[m] != null) {
        var L = f.next(32), z = (g[m].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        L.write_shift(1, z, "sbcs"), L.write_shift(1, C[m] == "?" ? "C" : C[m], "sbcs"), L.write_shift(4, v), L.write_shift(1, T[m] || o[C[m]] || 0), L.write_shift(1, w[m] || 0), L.write_shift(1, 2), L.write_shift(4, 0), L.write_shift(1, 0), L.write_shift(4, 0), L.write_shift(4, 0), v += T[m] || o[C[m]] || 0;
      }
    var P = f.next(264);
    for (P.write_shift(4, 13), m = 0; m < 65; ++m)
      P.write_shift(4, 0);
    for (m = 0; m < x.length; ++m) {
      var Q = f.next(A);
      for (Q.write_shift(1, 0), v = 0; v < g.length; ++v)
        if (g[v] != null)
          switch (C[v]) {
            case "L":
              Q.write_shift(1, x[m][v] == null ? 63 : x[m][v] ? 84 : 70);
              break;
            case "B":
              Q.write_shift(8, x[m][v] || 0, "f");
              break;
            case "N":
              var Y = "0";
              for (typeof x[m][v] == "number" && (Y = x[m][v].toFixed(w[v] || 0)), y = 0; y < T[v] - Y.length; ++y)
                Q.write_shift(1, 32);
              Q.write_shift(1, Y, "sbcs");
              break;
            case "D":
              x[m][v] ? (Q.write_shift(4, ("0000" + x[m][v].getFullYear()).slice(-4), "sbcs"), Q.write_shift(2, ("00" + (x[m][v].getMonth() + 1)).slice(-2), "sbcs"), Q.write_shift(2, ("00" + x[m][v].getDate()).slice(-2), "sbcs")) : Q.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var ie = String(x[m][v] != null ? x[m][v] : "").slice(0, T[v]);
              for (Q.write_shift(1, ie, "sbcs"), y = 0; y < T[v] - ie.length; ++y)
                Q.write_shift(1, 32);
              break;
          }
    }
    return f.next(1).write_shift(1, 26), f.end();
  }
  return {
    to_workbook: s,
    to_sheet: a,
    from_sheet: l
  };
}(), SYLK = /* @__PURE__ */ function() {
  var t = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, e = new RegExp("\x1BN(" + keys(t).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), n = function(g, x) {
    var E = t[x];
    return typeof E == "number" ? _getansi(E) : E;
  }, a = function(g, x, E) {
    var m = x.charCodeAt(0) - 32 << 4 | E.charCodeAt(0) - 48;
    return m == 59 ? g : _getansi(m);
  };
  t["|"] = 254;
  function s(g, x) {
    switch (x.type) {
      case "base64":
        return o(Base64_decode(g), x);
      case "binary":
        return o(g, x);
      case "buffer":
        return o(has_buf && Buffer.isBuffer(g) ? g.toString("binary") : a2s(g), x);
      case "array":
        return o(cc2str(g), x);
    }
    throw new Error("Unrecognized type " + x.type);
  }
  function o(g, x) {
    var E = g.split(/[\n\r]+/), m = -1, v = -1, y = 0, A = 0, b = [], C = [], T = null, w = {}, R = [], O = [], D = [], k = 0, W;
    for (+x.codepage >= 0 && set_cp(+x.codepage); y !== E.length; ++y) {
      k = 0;
      var L = E[y].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, a).replace(e, n), z = L.replace(/;;/g, "\0").split(";").map(function(I) {
        return I.replace(/\u0000/g, ";");
      }), P = z[0], Q;
      if (L.length > 0)
        switch (P) {
          case "ID":
            break;
          case "E":
            break;
          case "B":
            break;
          case "O":
            break;
          case "W":
            break;
          case "P":
            z[1].charAt(0) == "P" && C.push(L.slice(3).replace(/;;/g, ";"));
            break;
          case "C":
            var Y = !1, ie = !1, te = !1, Z = !1, ae = -1, G = -1;
            for (A = 1; A < z.length; ++A)
              switch (z[A].charAt(0)) {
                case "A":
                  break;
                case "X":
                  v = parseInt(z[A].slice(1)) - 1, ie = !0;
                  break;
                case "Y":
                  for (m = parseInt(z[A].slice(1)) - 1, ie || (v = 0), W = b.length; W <= m; ++W)
                    b[W] = [];
                  break;
                case "K":
                  Q = z[A].slice(1), Q.charAt(0) === '"' ? Q = Q.slice(1, Q.length - 1) : Q === "TRUE" ? Q = !0 : Q === "FALSE" ? Q = !1 : isNaN(fuzzynum(Q)) ? isNaN(fuzzydate(Q).getDate()) || (Q = parseDate(Q)) : (Q = fuzzynum(Q), T !== null && fmt_is_date(T) && (Q = numdate(Q))), Y = !0;
                  break;
                case "E":
                  Z = !0;
                  var U = rc_to_a1(z[A].slice(1), { r: m, c: v });
                  b[m][v] = [b[m][v], U];
                  break;
                case "S":
                  te = !0, b[m][v] = [b[m][v], "S5S"];
                  break;
                case "G":
                  break;
                case "R":
                  ae = parseInt(z[A].slice(1)) - 1;
                  break;
                case "C":
                  G = parseInt(z[A].slice(1)) - 1;
                  break;
                default:
                  if (x && x.WTF)
                    throw new Error("SYLK bad record " + L);
              }
            if (Y && (b[m][v] && b[m][v].length == 2 ? b[m][v][0] = Q : b[m][v] = Q, T = null), te) {
              if (Z)
                throw new Error("SYLK shared formula cannot have own formula");
              var F = ae > -1 && b[ae][G];
              if (!F || !F[1])
                throw new Error("SYLK shared formula cannot find base");
              b[m][v][1] = shift_formula_str(F[1], { r: m - ae, c: v - G });
            }
            break;
          case "F":
            var M = 0;
            for (A = 1; A < z.length; ++A)
              switch (z[A].charAt(0)) {
                case "X":
                  v = parseInt(z[A].slice(1)) - 1, ++M;
                  break;
                case "Y":
                  for (m = parseInt(z[A].slice(1)) - 1, W = b.length; W <= m; ++W)
                    b[W] = [];
                  break;
                case "M":
                  k = parseInt(z[A].slice(1)) / 20;
                  break;
                case "F":
                  break;
                case "G":
                  break;
                case "P":
                  T = C[parseInt(z[A].slice(1))];
                  break;
                case "S":
                  break;
                case "D":
                  break;
                case "N":
                  break;
                case "W":
                  for (D = z[A].slice(1).split(" "), W = parseInt(D[0], 10); W <= parseInt(D[1], 10); ++W)
                    k = parseInt(D[2], 10), O[W - 1] = k === 0 ? { hidden: !0 } : { wch: k }, process_col(O[W - 1]);
                  break;
                case "C":
                  v = parseInt(z[A].slice(1)) - 1, O[v] || (O[v] = {});
                  break;
                case "R":
                  m = parseInt(z[A].slice(1)) - 1, R[m] || (R[m] = {}), k > 0 ? (R[m].hpt = k, R[m].hpx = pt2px(k)) : k === 0 && (R[m].hidden = !0);
                  break;
                default:
                  if (x && x.WTF)
                    throw new Error("SYLK bad record " + L);
              }
            M < 1 && (T = null);
            break;
          default:
            if (x && x.WTF)
              throw new Error("SYLK bad record " + L);
        }
    }
    return R.length > 0 && (w["!rows"] = R), O.length > 0 && (w["!cols"] = O), x && x.sheetRows && (b = b.slice(0, x.sheetRows)), [b, w];
  }
  function l(g, x) {
    var E = s(g, x), m = E[0], v = E[1], y = aoa_to_sheet(m, x);
    return keys(v).forEach(function(A) {
      y[A] = v[A];
    }), y;
  }
  function c(g, x) {
    return sheet_to_workbook(l(g, x), x);
  }
  function u(g, x, E, m) {
    var v = "C;Y" + (E + 1) + ";X" + (m + 1) + ";K";
    switch (g.t) {
      case "n":
        v += g.v || 0, g.f && !g.F && (v += ";E" + a1_to_rc(g.f, { r: E, c: m }));
        break;
      case "b":
        v += g.v ? "TRUE" : "FALSE";
        break;
      case "e":
        v += g.w || g.v;
        break;
      case "d":
        v += '"' + (g.w || g.v) + '"';
        break;
      case "s":
        v += '"' + g.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return v;
  }
  function d(g, x) {
    x.forEach(function(E, m) {
      var v = "F;W" + (m + 1) + " " + (m + 1) + " ";
      E.hidden ? v += "0" : (typeof E.width == "number" && !E.wpx && (E.wpx = width2px(E.width)), typeof E.wpx == "number" && !E.wch && (E.wch = px2char(E.wpx)), typeof E.wch == "number" && (v += Math.round(E.wch))), v.charAt(v.length - 1) != " " && g.push(v);
    });
  }
  function f(g, x) {
    x.forEach(function(E, m) {
      var v = "F;";
      E.hidden ? v += "M0;" : E.hpt ? v += "M" + 20 * E.hpt + ";" : E.hpx && (v += "M" + 20 * px2pt(E.hpx) + ";"), v.length > 2 && g.push(v + "R" + (m + 1));
    });
  }
  function h(g, x) {
    var E = ["ID;PWXL;N;E"], m = [], v = safe_decode_range(g["!ref"]), y, A = Array.isArray(g), b = `\r
`;
    E.push("P;PGeneral"), E.push("F;P0;DG0G8;M255"), g["!cols"] && d(E, g["!cols"]), g["!rows"] && f(E, g["!rows"]), E.push("B;Y" + (v.e.r - v.s.r + 1) + ";X" + (v.e.c - v.s.c + 1) + ";D" + [v.s.c, v.s.r, v.e.c, v.e.r].join(" "));
    for (var C = v.s.r; C <= v.e.r; ++C)
      for (var T = v.s.c; T <= v.e.c; ++T) {
        var w = encode_cell({ r: C, c: T });
        y = A ? (g[C] || [])[T] : g[w], !(!y || y.v == null && (!y.f || y.F)) && m.push(u(y, g, C, T));
      }
    return E.join(b) + b + m.join(b) + b + "E" + b;
  }
  return {
    to_workbook: c,
    to_sheet: l,
    from_sheet: h
  };
}(), DIF = /* @__PURE__ */ function() {
  function t(o, l) {
    switch (l.type) {
      case "base64":
        return e(Base64_decode(o), l);
      case "binary":
        return e(o, l);
      case "buffer":
        return e(has_buf && Buffer.isBuffer(o) ? o.toString("binary") : a2s(o), l);
      case "array":
        return e(cc2str(o), l);
    }
    throw new Error("Unrecognized type " + l.type);
  }
  function e(o, l) {
    for (var c = o.split(`
`), u = -1, d = -1, f = 0, h = []; f !== c.length; ++f) {
      if (c[f].trim() === "BOT") {
        h[++u] = [], d = 0;
        continue;
      }
      if (!(u < 0)) {
        var g = c[f].trim().split(","), x = g[0], E = g[1];
        ++f;
        for (var m = c[f] || ""; (m.match(/["]/g) || []).length & 1 && f < c.length - 1; )
          m += `
` + c[++f];
        switch (m = m.trim(), +x) {
          case -1:
            if (m === "BOT") {
              h[++u] = [], d = 0;
              continue;
            } else if (m !== "EOD")
              throw new Error("Unrecognized DIF special command " + m);
            break;
          case 0:
            m === "TRUE" ? h[u][d] = !0 : m === "FALSE" ? h[u][d] = !1 : isNaN(fuzzynum(E)) ? isNaN(fuzzydate(E).getDate()) ? h[u][d] = E : h[u][d] = parseDate(E) : h[u][d] = fuzzynum(E), ++d;
            break;
          case 1:
            m = m.slice(1, m.length - 1), m = m.replace(/""/g, '"'), m && m.match(/^=".*"$/) && (m = m.slice(2, -1)), h[u][d++] = m !== "" ? m : null;
            break;
        }
        if (m === "EOD")
          break;
      }
    }
    return l && l.sheetRows && (h = h.slice(0, l.sheetRows)), h;
  }
  function n(o, l) {
    return aoa_to_sheet(t(o, l), l);
  }
  function a(o, l) {
    return sheet_to_workbook(n(o, l), l);
  }
  var s = /* @__PURE__ */ function() {
    var o = function(u, d, f, h, g) {
      u.push(d), u.push(f + "," + h), u.push('"' + g.replace(/"/g, '""') + '"');
    }, l = function(u, d, f, h) {
      u.push(d + "," + f), u.push(d == 1 ? '"' + h.replace(/"/g, '""') + '"' : h);
    };
    return function(u) {
      var d = [], f = safe_decode_range(u["!ref"]), h, g = Array.isArray(u);
      o(d, "TABLE", 0, 1, "sheetjs"), o(d, "VECTORS", 0, f.e.r - f.s.r + 1, ""), o(d, "TUPLES", 0, f.e.c - f.s.c + 1, ""), o(d, "DATA", 0, 0, "");
      for (var x = f.s.r; x <= f.e.r; ++x) {
        l(d, -1, 0, "BOT");
        for (var E = f.s.c; E <= f.e.c; ++E) {
          var m = encode_cell({ r: x, c: E });
          if (h = g ? (u[x] || [])[E] : u[m], !h) {
            l(d, 1, 0, "");
            continue;
          }
          switch (h.t) {
            case "n":
              var v = h.w;
              !v && h.v != null && (v = h.v), v == null ? h.f && !h.F ? l(d, 1, 0, "=" + h.f) : l(d, 1, 0, "") : l(d, 0, v, "V");
              break;
            case "b":
              l(d, 0, h.v ? 1 : 0, h.v ? "TRUE" : "FALSE");
              break;
            case "s":
              l(d, 1, 0, isNaN(h.v) ? h.v : '="' + h.v + '"');
              break;
            case "d":
              h.w || (h.w = SSF_format(h.z || table_fmt[14], datenum(parseDate(h.v)))), l(d, 0, h.w, "V");
              break;
            default:
              l(d, 1, 0, "");
          }
        }
      }
      l(d, -1, 0, "EOD");
      var y = `\r
`, A = d.join(y);
      return A;
    };
  }();
  return {
    to_workbook: a,
    to_sheet: n,
    from_sheet: s
  };
}(), ETH = /* @__PURE__ */ function() {
  function t(h) {
    return h.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function e(h) {
    return h.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function n(h, g) {
    for (var x = h.split(`
`), E = -1, m = -1, v = 0, y = []; v !== x.length; ++v) {
      var A = x[v].trim().split(":");
      if (A[0] === "cell") {
        var b = decode_cell(A[1]);
        if (y.length <= b.r)
          for (E = y.length; E <= b.r; ++E)
            y[E] || (y[E] = []);
        switch (E = b.r, m = b.c, A[2]) {
          case "t":
            y[E][m] = t(A[3]);
            break;
          case "v":
            y[E][m] = +A[3];
            break;
          case "vtf":
            var C = A[A.length - 1];
          case "vtc":
            switch (A[3]) {
              case "nl":
                y[E][m] = !!+A[4];
                break;
              default:
                y[E][m] = +A[4];
                break;
            }
            A[2] == "vtf" && (y[E][m] = [y[E][m], C]);
        }
      }
    }
    return g && g.sheetRows && (y = y.slice(0, g.sheetRows)), y;
  }
  function a(h, g) {
    return aoa_to_sheet(n(h, g), g);
  }
  function s(h, g) {
    return sheet_to_workbook(a(h, g), g);
  }
  var o = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), l = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, c = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), u = "--SocialCalcSpreadsheetControlSave--";
  function d(h) {
    if (!h || !h["!ref"])
      return "";
    for (var g = [], x = [], E, m = "", v = decode_range(h["!ref"]), y = Array.isArray(h), A = v.s.r; A <= v.e.r; ++A)
      for (var b = v.s.c; b <= v.e.c; ++b)
        if (m = encode_cell({ r: A, c: b }), E = y ? (h[A] || [])[b] : h[m], !(!E || E.v == null || E.t === "z")) {
          switch (x = ["cell", m, "t"], E.t) {
            case "s":
            case "str":
              x.push(e(E.v));
              break;
            case "n":
              E.f ? (x[2] = "vtf", x[3] = "n", x[4] = E.v, x[5] = e(E.f)) : (x[2] = "v", x[3] = E.v);
              break;
            case "b":
              x[2] = "vt" + (E.f ? "f" : "c"), x[3] = "nl", x[4] = E.v ? "1" : "0", x[5] = e(E.f || (E.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var C = datenum(parseDate(E.v));
              x[2] = "vtc", x[3] = "nd", x[4] = "" + C, x[5] = E.w || SSF_format(E.z || table_fmt[14], C);
              break;
            case "e":
              continue;
          }
          g.push(x.join(":"));
        }
    return g.push("sheet:c:" + (v.e.c - v.s.c + 1) + ":r:" + (v.e.r - v.s.r + 1) + ":tvf:1"), g.push("valueformat:1:text-wiki"), g.join(`
`);
  }
  function f(h) {
    return [o, l, c, l, d(h), u].join(`
`);
  }
  return {
    to_workbook: s,
    to_sheet: a,
    from_sheet: f
  };
}(), PRN = /* @__PURE__ */ function() {
  function t(f, h, g, x, E) {
    E.raw ? h[g][x] = f : f === "" || (f === "TRUE" ? h[g][x] = !0 : f === "FALSE" ? h[g][x] = !1 : isNaN(fuzzynum(f)) ? isNaN(fuzzydate(f).getDate()) ? h[g][x] = f : h[g][x] = parseDate(f) : h[g][x] = fuzzynum(f));
  }
  function e(f, h) {
    var g = h || {}, x = [];
    if (!f || f.length === 0)
      return x;
    for (var E = f.split(/[\r\n]/), m = E.length - 1; m >= 0 && E[m].length === 0; )
      --m;
    for (var v = 10, y = 0, A = 0; A <= m; ++A)
      y = E[A].indexOf(" "), y == -1 ? y = E[A].length : y++, v = Math.max(v, y);
    for (A = 0; A <= m; ++A) {
      x[A] = [];
      var b = 0;
      for (t(E[A].slice(0, v).trim(), x, A, b, g), b = 1; b <= (E[A].length - v) / 10 + 1; ++b)
        t(E[A].slice(v + (b - 1) * 10, v + b * 10).trim(), x, A, b, g);
    }
    return g.sheetRows && (x = x.slice(0, g.sheetRows)), x;
  }
  var n = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, a = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function s(f) {
    for (var h = {}, g = !1, x = 0, E = 0; x < f.length; ++x)
      (E = f.charCodeAt(x)) == 34 ? g = !g : !g && E in n && (h[E] = (h[E] || 0) + 1);
    E = [];
    for (x in h)
      Object.prototype.hasOwnProperty.call(h, x) && E.push([h[x], x]);
    if (!E.length) {
      h = a;
      for (x in h)
        Object.prototype.hasOwnProperty.call(h, x) && E.push([h[x], x]);
    }
    return E.sort(function(m, v) {
      return m[0] - v[0] || a[m[1]] - a[v[1]];
    }), n[E.pop()[1]] || 44;
  }
  function o(f, h) {
    var g = h || {}, x = "", E = g.dense ? [] : {}, m = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    f.slice(0, 4) == "sep=" ? f.charCodeAt(5) == 13 && f.charCodeAt(6) == 10 ? (x = f.charAt(4), f = f.slice(7)) : f.charCodeAt(5) == 13 || f.charCodeAt(5) == 10 ? (x = f.charAt(4), f = f.slice(6)) : x = s(f.slice(0, 1024)) : g && g.FS ? x = g.FS : x = s(f.slice(0, 1024));
    var v = 0, y = 0, A = 0, b = 0, C = 0, T = x.charCodeAt(0), w = !1, R = 0, O = f.charCodeAt(0);
    f = f.replace(/\r\n/mg, `
`);
    var D = g.dateNF != null ? dateNF_regex(g.dateNF) : null;
    function k() {
      var W = f.slice(b, C), L = {};
      if (W.charAt(0) == '"' && W.charAt(W.length - 1) == '"' && (W = W.slice(1, -1).replace(/""/g, '"')), W.length === 0)
        L.t = "z";
      else if (g.raw)
        L.t = "s", L.v = W;
      else if (W.trim().length === 0)
        L.t = "s", L.v = W;
      else if (W.charCodeAt(0) == 61)
        W.charCodeAt(1) == 34 && W.charCodeAt(W.length - 1) == 34 ? (L.t = "s", L.v = W.slice(2, -1).replace(/""/g, '"')) : fuzzyfmla(W) ? (L.t = "n", L.f = W.slice(1)) : (L.t = "s", L.v = W);
      else if (W == "TRUE")
        L.t = "b", L.v = !0;
      else if (W == "FALSE")
        L.t = "b", L.v = !1;
      else if (!isNaN(A = fuzzynum(W)))
        L.t = "n", g.cellText !== !1 && (L.w = W), L.v = A;
      else if (!isNaN(fuzzydate(W).getDate()) || D && W.match(D)) {
        L.z = g.dateNF || table_fmt[14];
        var z = 0;
        D && W.match(D) && (W = dateNF_fix(W, g.dateNF, W.match(D) || []), z = 1), g.cellDates ? (L.t = "d", L.v = parseDate(W, z)) : (L.t = "n", L.v = datenum(parseDate(W, z))), g.cellText !== !1 && (L.w = SSF_format(L.z, L.v instanceof Date ? datenum(L.v) : L.v)), g.cellNF || delete L.z;
      } else
        L.t = "s", L.v = W;
      if (L.t == "z" || (g.dense ? (E[v] || (E[v] = []), E[v][y] = L) : E[encode_cell({ c: y, r: v })] = L), b = C + 1, O = f.charCodeAt(b), m.e.c < y && (m.e.c = y), m.e.r < v && (m.e.r = v), R == T)
        ++y;
      else if (y = 0, ++v, g.sheetRows && g.sheetRows <= v)
        return !0;
    }
    e:
      for (; C < f.length; ++C)
        switch (R = f.charCodeAt(C)) {
          case 34:
            O === 34 && (w = !w);
            break;
          case T:
          case 10:
          case 13:
            if (!w && k())
              break e;
            break;
        }
    return C - b > 0 && k(), E["!ref"] = encode_range(m), E;
  }
  function l(f, h) {
    return !(h && h.PRN) || h.FS || f.slice(0, 4) == "sep=" || f.indexOf("	") >= 0 || f.indexOf(",") >= 0 || f.indexOf(";") >= 0 ? o(f, h) : aoa_to_sheet(e(f, h), h);
  }
  function c(f, h) {
    var g = "", x = h.type == "string" ? [0, 0, 0, 0] : firstbyte(f, h);
    switch (h.type) {
      case "base64":
        g = Base64_decode(f);
        break;
      case "binary":
        g = f;
        break;
      case "buffer":
        h.codepage == 65001 ? g = f.toString("utf8") : h.codepage && typeof $cptable < "u" ? g = $cptable.utils.decode(h.codepage, f) : g = has_buf && Buffer.isBuffer(f) ? f.toString("binary") : a2s(f);
        break;
      case "array":
        g = cc2str(f);
        break;
      case "string":
        g = f;
        break;
      default:
        throw new Error("Unrecognized type " + h.type);
    }
    return x[0] == 239 && x[1] == 187 && x[2] == 191 ? g = utf8read(g.slice(3)) : h.type != "string" && h.type != "buffer" && h.codepage == 65001 ? g = utf8read(g) : h.type == "binary" && typeof $cptable < "u" && h.codepage && (g = $cptable.utils.decode(h.codepage, $cptable.utils.encode(28591, g))), g.slice(0, 19) == "socialcalc:version:" ? ETH.to_sheet(h.type == "string" ? g : utf8read(g), h) : l(g, h);
  }
  function u(f, h) {
    return sheet_to_workbook(c(f, h), h);
  }
  function d(f) {
    for (var h = [], g = safe_decode_range(f["!ref"]), x, E = Array.isArray(f), m = g.s.r; m <= g.e.r; ++m) {
      for (var v = [], y = g.s.c; y <= g.e.c; ++y) {
        var A = encode_cell({ r: m, c: y });
        if (x = E ? (f[m] || [])[y] : f[A], !x || x.v == null) {
          v.push("          ");
          continue;
        }
        for (var b = (x.w || (format_cell(x), x.w) || "").slice(0, 10); b.length < 10; )
          b += " ";
        v.push(b + (y === 0 ? " " : ""));
      }
      h.push(v.join(""));
    }
    return h.join(`
`);
  }
  return {
    to_workbook: u,
    to_sheet: c,
    from_sheet: d
  };
}();
function read_wb_ID(t, e) {
  var n = e || {}, a = !!n.WTF;
  n.WTF = !0;
  try {
    var s = SYLK.to_workbook(t, n);
    return n.WTF = a, s;
  } catch (o) {
    if (n.WTF = a, !o.message.match(/SYLK bad record ID/) && a)
      throw o;
    return PRN.to_workbook(t, e);
  }
}
var WK_ = /* @__PURE__ */ function() {
  function t(U, F, M) {
    if (U) {
      prep_blob(U, U.l || 0);
      for (var I = M.Enum || ae; U.l < U.length; ) {
        var N = U.read_shift(2), V = I[N] || I[65535], q = U.read_shift(2), H = U.l + q, ne = V.f && V.f(U, q, M);
        if (U.l = H, F(ne, V, N))
          return;
      }
    }
  }
  function e(U, F) {
    switch (F.type) {
      case "base64":
        return n(s2a(Base64_decode(U)), F);
      case "binary":
        return n(s2a(U), F);
      case "buffer":
      case "array":
        return n(U, F);
    }
    throw "Unsupported type " + F.type;
  }
  function n(U, F) {
    if (!U)
      return U;
    var M = F || {}, I = M.dense ? [] : {}, N = "Sheet1", V = "", q = 0, H = {}, ne = [], he = [], j = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, Fe = M.sheetRows || 0;
    if (U[2] == 0 && (U[3] == 8 || U[3] == 9) && U.length >= 16 && U[14] == 5 && U[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (U[2] == 2)
      M.Enum = ae, t(U, function(fe, _e, Ie) {
        switch (Ie) {
          case 0:
            M.vers = fe, fe >= 4096 && (M.qpro = !0);
            break;
          case 6:
            j = fe;
            break;
          case 204:
            fe && (V = fe);
            break;
          case 222:
            V = fe;
            break;
          case 15:
          case 51:
            M.qpro || (fe[1].v = fe[1].v.slice(1));
          case 13:
          case 14:
          case 16:
            Ie == 14 && (fe[2] & 112) == 112 && (fe[2] & 15) > 1 && (fe[2] & 15) < 15 && (fe[1].z = M.dateNF || table_fmt[14], M.cellDates && (fe[1].t = "d", fe[1].v = numdate(fe[1].v))), M.qpro && fe[3] > q && (I["!ref"] = encode_range(j), H[N] = I, ne.push(N), I = M.dense ? [] : {}, j = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, q = fe[3], N = V || "Sheet" + (q + 1), V = "");
            var Be = M.dense ? (I[fe[0].r] || [])[fe[0].c] : I[encode_cell(fe[0])];
            if (Be) {
              Be.t = fe[1].t, Be.v = fe[1].v, fe[1].z != null && (Be.z = fe[1].z), fe[1].f != null && (Be.f = fe[1].f);
              break;
            }
            M.dense ? (I[fe[0].r] || (I[fe[0].r] = []), I[fe[0].r][fe[0].c] = fe[1]) : I[encode_cell(fe[0])] = fe[1];
            break;
        }
      }, M);
    else if (U[2] == 26 || U[2] == 14)
      M.Enum = G, U[2] == 14 && (M.qpro = !0, U.l = 0), t(U, function(fe, _e, Ie) {
        switch (Ie) {
          case 204:
            N = fe;
            break;
          case 22:
            fe[1].v = fe[1].v.slice(1);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (fe[3] > q && (I["!ref"] = encode_range(j), H[N] = I, ne.push(N), I = M.dense ? [] : {}, j = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, q = fe[3], N = "Sheet" + (q + 1)), Fe > 0 && fe[0].r >= Fe)
              break;
            M.dense ? (I[fe[0].r] || (I[fe[0].r] = []), I[fe[0].r][fe[0].c] = fe[1]) : I[encode_cell(fe[0])] = fe[1], j.e.c < fe[0].c && (j.e.c = fe[0].c), j.e.r < fe[0].r && (j.e.r = fe[0].r);
            break;
          case 27:
            fe[14e3] && (he[fe[14e3][0]] = fe[14e3][1]);
            break;
          case 1537:
            he[fe[0]] = fe[1], fe[0] == q && (N = fe[1]);
            break;
        }
      }, M);
    else
      throw new Error("Unrecognized LOTUS BOF " + U[2]);
    if (I["!ref"] = encode_range(j), H[V || N] = I, ne.push(V || N), !he.length)
      return { SheetNames: ne, Sheets: H };
    for (var X = {}, ye = [], Ae = 0; Ae < he.length; ++Ae)
      H[ne[Ae]] ? (ye.push(he[Ae] || ne[Ae]), X[he[Ae]] = H[he[Ae]] || H[ne[Ae]]) : (ye.push(he[Ae]), X[he[Ae]] = { "!ref": "A1" });
    return { SheetNames: ye, Sheets: X };
  }
  function a(U, F) {
    var M = F || {};
    if (+M.codepage >= 0 && set_cp(+M.codepage), M.type == "string")
      throw new Error("Cannot write WK1 to JS string");
    var I = buf_array(), N = safe_decode_range(U["!ref"]), V = Array.isArray(U), q = [];
    write_biff_rec(I, 0, o(1030)), write_biff_rec(I, 6, u(N));
    for (var H = Math.min(N.e.r, 8191), ne = N.s.r; ne <= H; ++ne)
      for (var he = encode_row(ne), j = N.s.c; j <= N.e.c; ++j) {
        ne === N.s.r && (q[j] = encode_col(j));
        var Fe = q[j] + he, X = V ? (U[ne] || [])[j] : U[Fe];
        if (!(!X || X.t == "z"))
          if (X.t == "n")
            (X.v | 0) == X.v && X.v >= -32768 && X.v <= 32767 ? write_biff_rec(I, 13, x(ne, j, X.v)) : write_biff_rec(I, 14, m(ne, j, X.v));
          else {
            var ye = format_cell(X);
            write_biff_rec(I, 15, h(ne, j, ye.slice(0, 239)));
          }
      }
    return write_biff_rec(I, 1), I.end();
  }
  function s(U, F) {
    var M = F || {};
    if (+M.codepage >= 0 && set_cp(+M.codepage), M.type == "string")
      throw new Error("Cannot write WK3 to JS string");
    var I = buf_array();
    write_biff_rec(I, 0, l(U));
    for (var N = 0, V = 0; N < U.SheetNames.length; ++N)
      (U.Sheets[U.SheetNames[N]] || {})["!ref"] && write_biff_rec(I, 27, Z(U.SheetNames[N], V++));
    var q = 0;
    for (N = 0; N < U.SheetNames.length; ++N) {
      var H = U.Sheets[U.SheetNames[N]];
      if (!(!H || !H["!ref"])) {
        for (var ne = safe_decode_range(H["!ref"]), he = Array.isArray(H), j = [], Fe = Math.min(ne.e.r, 8191), X = ne.s.r; X <= Fe; ++X)
          for (var ye = encode_row(X), Ae = ne.s.c; Ae <= ne.e.c; ++Ae) {
            X === ne.s.r && (j[Ae] = encode_col(Ae));
            var fe = j[Ae] + ye, _e = he ? (H[X] || [])[Ae] : H[fe];
            if (!(!_e || _e.t == "z"))
              if (_e.t == "n")
                write_biff_rec(I, 23, k(X, Ae, q, _e.v));
              else {
                var Ie = format_cell(_e);
                write_biff_rec(I, 22, R(X, Ae, q, Ie.slice(0, 239)));
              }
          }
        ++q;
      }
    }
    return write_biff_rec(I, 1), I.end();
  }
  function o(U) {
    var F = new_buf(2);
    return F.write_shift(2, U), F;
  }
  function l(U) {
    var F = new_buf(26);
    F.write_shift(2, 4096), F.write_shift(2, 4), F.write_shift(4, 0);
    for (var M = 0, I = 0, N = 0, V = 0; V < U.SheetNames.length; ++V) {
      var q = U.SheetNames[V], H = U.Sheets[q];
      if (!(!H || !H["!ref"])) {
        ++N;
        var ne = decode_range(H["!ref"]);
        M < ne.e.r && (M = ne.e.r), I < ne.e.c && (I = ne.e.c);
      }
    }
    return M > 8191 && (M = 8191), F.write_shift(2, M), F.write_shift(1, N), F.write_shift(1, I), F.write_shift(2, 0), F.write_shift(2, 0), F.write_shift(1, 1), F.write_shift(1, 2), F.write_shift(4, 0), F.write_shift(4, 0), F;
  }
  function c(U, F, M) {
    var I = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return F == 8 && M.qpro ? (I.s.c = U.read_shift(1), U.l++, I.s.r = U.read_shift(2), I.e.c = U.read_shift(1), U.l++, I.e.r = U.read_shift(2), I) : (I.s.c = U.read_shift(2), I.s.r = U.read_shift(2), F == 12 && M.qpro && (U.l += 2), I.e.c = U.read_shift(2), I.e.r = U.read_shift(2), F == 12 && M.qpro && (U.l += 2), I.s.c == 65535 && (I.s.c = I.e.c = I.s.r = I.e.r = 0), I);
  }
  function u(U) {
    var F = new_buf(8);
    return F.write_shift(2, U.s.c), F.write_shift(2, U.s.r), F.write_shift(2, U.e.c), F.write_shift(2, U.e.r), F;
  }
  function d(U, F, M) {
    var I = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return M.qpro && M.vers != 20768 ? (I[0].c = U.read_shift(1), I[3] = U.read_shift(1), I[0].r = U.read_shift(2), U.l += 2) : (I[2] = U.read_shift(1), I[0].c = U.read_shift(2), I[0].r = U.read_shift(2)), I;
  }
  function f(U, F, M) {
    var I = U.l + F, N = d(U, F, M);
    if (N[1].t = "s", M.vers == 20768) {
      U.l++;
      var V = U.read_shift(1);
      return N[1].v = U.read_shift(V, "utf8"), N;
    }
    return M.qpro && U.l++, N[1].v = U.read_shift(I - U.l, "cstr"), N;
  }
  function h(U, F, M) {
    var I = new_buf(7 + M.length);
    I.write_shift(1, 255), I.write_shift(2, F), I.write_shift(2, U), I.write_shift(1, 39);
    for (var N = 0; N < I.length; ++N) {
      var V = M.charCodeAt(N);
      I.write_shift(1, V >= 128 ? 95 : V);
    }
    return I.write_shift(1, 0), I;
  }
  function g(U, F, M) {
    var I = d(U, F, M);
    return I[1].v = U.read_shift(2, "i"), I;
  }
  function x(U, F, M) {
    var I = new_buf(7);
    return I.write_shift(1, 255), I.write_shift(2, F), I.write_shift(2, U), I.write_shift(2, M, "i"), I;
  }
  function E(U, F, M) {
    var I = d(U, F, M);
    return I[1].v = U.read_shift(8, "f"), I;
  }
  function m(U, F, M) {
    var I = new_buf(13);
    return I.write_shift(1, 255), I.write_shift(2, F), I.write_shift(2, U), I.write_shift(8, M, "f"), I;
  }
  function v(U, F, M) {
    var I = U.l + F, N = d(U, F, M);
    if (N[1].v = U.read_shift(8, "f"), M.qpro)
      U.l = I;
    else {
      var V = U.read_shift(2);
      C(U.slice(U.l, U.l + V), N), U.l += V;
    }
    return N;
  }
  function y(U, F, M) {
    var I = F & 32768;
    return F &= -32769, F = (I ? U : 0) + (F >= 8192 ? F - 16384 : F), (I ? "" : "$") + (M ? encode_col(F) : encode_row(F));
  }
  var A = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, b = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function C(U, F) {
    prep_blob(U, 0);
    for (var M = [], I = 0, N = "", V = "", q = "", H = ""; U.l < U.length; ) {
      var ne = U[U.l++];
      switch (ne) {
        case 0:
          M.push(U.read_shift(8, "f"));
          break;
        case 1:
          V = y(F[0].c, U.read_shift(2), !0), N = y(F[0].r, U.read_shift(2), !1), M.push(V + N);
          break;
        case 2:
          {
            var he = y(F[0].c, U.read_shift(2), !0), j = y(F[0].r, U.read_shift(2), !1);
            V = y(F[0].c, U.read_shift(2), !0), N = y(F[0].r, U.read_shift(2), !1), M.push(he + j + ":" + V + N);
          }
          break;
        case 3:
          if (U.l < U.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          M.push("(" + M.pop() + ")");
          break;
        case 5:
          M.push(U.read_shift(2));
          break;
        case 6:
          {
            for (var Fe = ""; ne = U[U.l++]; )
              Fe += String.fromCharCode(ne);
            M.push('"' + Fe.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          M.push("-" + M.pop());
          break;
        case 23:
          M.push("+" + M.pop());
          break;
        case 22:
          M.push("NOT(" + M.pop() + ")");
          break;
        case 20:
        case 21:
          H = M.pop(), q = M.pop(), M.push(["AND", "OR"][ne - 20] + "(" + q + "," + H + ")");
          break;
        default:
          if (ne < 32 && b[ne])
            H = M.pop(), q = M.pop(), M.push(q + b[ne] + H);
          else if (A[ne]) {
            if (I = A[ne][1], I == 69 && (I = U[U.l++]), I > M.length) {
              console.error("WK1 bad formula parse 0x" + ne.toString(16) + ":|" + M.join("|") + "|");
              return;
            }
            var X = M.slice(-I);
            M.length -= I, M.push(A[ne][0] + "(" + X.join(",") + ")");
          } else
            return ne <= 7 ? console.error("WK1 invalid opcode " + ne.toString(16)) : ne <= 24 ? console.error("WK1 unsupported op " + ne.toString(16)) : ne <= 30 ? console.error("WK1 invalid opcode " + ne.toString(16)) : ne <= 115 ? console.error("WK1 unsupported function opcode " + ne.toString(16)) : console.error("WK1 unrecognized opcode " + ne.toString(16));
      }
    }
    M.length == 1 ? F[1].f = "" + M[0] : console.error("WK1 bad formula parse |" + M.join("|") + "|");
  }
  function T(U) {
    var F = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return F[0].r = U.read_shift(2), F[3] = U[U.l++], F[0].c = U[U.l++], F;
  }
  function w(U, F) {
    var M = T(U);
    return M[1].t = "s", M[1].v = U.read_shift(F - 4, "cstr"), M;
  }
  function R(U, F, M, I) {
    var N = new_buf(6 + I.length);
    N.write_shift(2, U), N.write_shift(1, M), N.write_shift(1, F), N.write_shift(1, 39);
    for (var V = 0; V < I.length; ++V) {
      var q = I.charCodeAt(V);
      N.write_shift(1, q >= 128 ? 95 : q);
    }
    return N.write_shift(1, 0), N;
  }
  function O(U, F) {
    var M = T(U);
    M[1].v = U.read_shift(2);
    var I = M[1].v >> 1;
    if (M[1].v & 1)
      switch (I & 7) {
        case 0:
          I = (I >> 3) * 5e3;
          break;
        case 1:
          I = (I >> 3) * 500;
          break;
        case 2:
          I = (I >> 3) / 20;
          break;
        case 3:
          I = (I >> 3) / 200;
          break;
        case 4:
          I = (I >> 3) / 2e3;
          break;
        case 5:
          I = (I >> 3) / 2e4;
          break;
        case 6:
          I = (I >> 3) / 16;
          break;
        case 7:
          I = (I >> 3) / 64;
          break;
      }
    return M[1].v = I, M;
  }
  function D(U, F) {
    var M = T(U), I = U.read_shift(4), N = U.read_shift(4), V = U.read_shift(2);
    if (V == 65535)
      return I === 0 && N === 3221225472 ? (M[1].t = "e", M[1].v = 15) : I === 0 && N === 3489660928 ? (M[1].t = "e", M[1].v = 42) : M[1].v = 0, M;
    var q = V & 32768;
    return V = (V & 32767) - 16446, M[1].v = (1 - q * 2) * (N * Math.pow(2, V + 32) + I * Math.pow(2, V)), M;
  }
  function k(U, F, M, I) {
    var N = new_buf(14);
    if (N.write_shift(2, U), N.write_shift(1, M), N.write_shift(1, F), I == 0)
      return N.write_shift(4, 0), N.write_shift(4, 0), N.write_shift(2, 65535), N;
    var V = 0, q = 0, H = 0, ne = 0;
    return I < 0 && (V = 1, I = -I), q = Math.log2(I) | 0, I /= Math.pow(2, q - 31), ne = I >>> 0, ne & 2147483648 || (I /= 2, ++q, ne = I >>> 0), I -= ne, ne |= 2147483648, ne >>>= 0, I *= Math.pow(2, 32), H = I >>> 0, N.write_shift(4, H), N.write_shift(4, ne), q += 16383 + (V ? 32768 : 0), N.write_shift(2, q), N;
  }
  function W(U, F) {
    var M = D(U);
    return U.l += F - 14, M;
  }
  function L(U, F) {
    var M = T(U), I = U.read_shift(4);
    return M[1].v = I >> 6, M;
  }
  function z(U, F) {
    var M = T(U), I = U.read_shift(8, "f");
    return M[1].v = I, M;
  }
  function P(U, F) {
    var M = z(U);
    return U.l += F - 10, M;
  }
  function Q(U, F) {
    return U[U.l + F - 1] == 0 ? U.read_shift(F, "cstr") : "";
  }
  function Y(U, F) {
    var M = U[U.l++];
    M > F - 1 && (M = F - 1);
    for (var I = ""; I.length < M; )
      I += String.fromCharCode(U[U.l++]);
    return I;
  }
  function ie(U, F, M) {
    if (!(!M.qpro || F < 21)) {
      var I = U.read_shift(1);
      U.l += 17, U.l += 1, U.l += 2;
      var N = U.read_shift(F - 21, "cstr");
      return [I, N];
    }
  }
  function te(U, F) {
    for (var M = {}, I = U.l + F; U.l < I; ) {
      var N = U.read_shift(2);
      if (N == 14e3) {
        for (M[N] = [0, ""], M[N][0] = U.read_shift(2); U[U.l]; )
          M[N][1] += String.fromCharCode(U[U.l]), U.l++;
        U.l++;
      }
    }
    return M;
  }
  function Z(U, F) {
    var M = new_buf(5 + U.length);
    M.write_shift(2, 14e3), M.write_shift(2, F);
    for (var I = 0; I < U.length; ++I) {
      var N = U.charCodeAt(I);
      M[M.l++] = N > 127 ? 95 : N;
    }
    return M[M.l++] = 0, M;
  }
  var ae = {
    /*::[*/
    0: { n: "BOF", f: parseuint16 },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: c },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: g },
    /*::[*/
    14: { n: "NUMBER", f: E },
    /*::[*/
    15: { n: "LABEL", f },
    /*::[*/
    16: { n: "FORMULA", f: v },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: Q },
    /*::[*/
    222: { n: "SHEETNAMELP", f: Y },
    /*::[*/
    65535: { n: "" }
  }, G = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: w },
    /*::[*/
    23: { n: "NUMBER17", f: D },
    /*::[*/
    24: { n: "NUMBER18", f: O },
    /*::[*/
    25: { n: "FORMULA19", f: W },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: te },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: L },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: z },
    /*::[*/
    40: { n: "FORMULA28", f: P },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: Q },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: ie },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: a,
    book_to_wk3: s,
    to_workbook: e
  };
}();
function parse_rpr(t) {
  var e = {}, n = t.match(tagregex), a = 0, s = !1;
  if (n)
    for (; a != n.length; ++a) {
      var o = parsexmltag(n[a]);
      switch (o[0].replace(/\w*:/g, "")) {
        case "<condense":
          break;
        case "<extend":
          break;
        case "<shadow":
          if (!o.val)
            break;
        case "<shadow>":
        case "<shadow/>":
          e.shadow = 1;
          break;
        case "</shadow>":
          break;
        case "<charset":
          if (o.val == "1")
            break;
          e.cp = CS2CP[parseInt(o.val, 10)];
          break;
        case "<outline":
          if (!o.val)
            break;
        case "<outline>":
        case "<outline/>":
          e.outline = 1;
          break;
        case "</outline>":
          break;
        case "<rFont":
          e.name = o.val;
          break;
        case "<sz":
          e.sz = o.val;
          break;
        case "<strike":
          if (!o.val)
            break;
        case "<strike>":
        case "<strike/>":
          e.strike = 1;
          break;
        case "</strike>":
          break;
        case "<u":
          if (!o.val)
            break;
          switch (o.val) {
            case "double":
              e.uval = "double";
              break;
            case "singleAccounting":
              e.uval = "single-accounting";
              break;
            case "doubleAccounting":
              e.uval = "double-accounting";
              break;
          }
        case "<u>":
        case "<u/>":
          e.u = 1;
          break;
        case "</u>":
          break;
        case "<b":
          if (o.val == "0")
            break;
        case "<b>":
        case "<b/>":
          e.b = 1;
          break;
        case "</b>":
          break;
        case "<i":
          if (o.val == "0")
            break;
        case "<i>":
        case "<i/>":
          e.i = 1;
          break;
        case "</i>":
          break;
        case "<color":
          o.rgb && (e.color = o.rgb.slice(2, 8));
          break;
        case "<color>":
        case "<color/>":
        case "</color>":
          break;
        case "<family":
          e.family = o.val;
          break;
        case "<family>":
        case "<family/>":
        case "</family>":
          break;
        case "<vertAlign":
          e.valign = o.val;
          break;
        case "<vertAlign>":
        case "<vertAlign/>":
        case "</vertAlign>":
          break;
        case "<scheme":
          break;
        case "<scheme>":
        case "<scheme/>":
        case "</scheme>":
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
          break;
        case "<ext":
          s = !0;
          break;
        case "</ext>":
          s = !1;
          break;
        default:
          if (o[0].charCodeAt(1) !== 47 && !s)
            throw new Error("Unrecognized rich format " + o[0]);
      }
    }
  return e;
}
var parse_rs = /* @__PURE__ */ function() {
  var t = matchtag("t"), e = matchtag("rPr");
  function n(o) {
    var l = o.match(t);
    if (!l)
      return { t: "s", v: "" };
    var c = { t: "s", v: unescapexml(l[1]) }, u = o.match(e);
    return u && (c.s = parse_rpr(u[1])), c;
  }
  var a = /<(?:\w+:)?r>/g, s = /<\/(?:\w+:)?r>/;
  return function(l) {
    return l.replace(a, "").split(s).map(n).filter(function(c) {
      return c.v;
    });
  };
}(), rs_to_html = /* @__PURE__ */ function t() {
  var e = /(\r\n|\n)/g;
  function n(s, o, l) {
    var c = [];
    s.u && c.push("text-decoration: underline;"), s.uval && c.push("text-underline-style:" + s.uval + ";"), s.sz && c.push("font-size:" + s.sz + "pt;"), s.outline && c.push("text-effect: outline;"), s.shadow && c.push("text-shadow: auto;"), o.push('<span style="' + c.join("") + '">'), s.b && (o.push("<b>"), l.push("</b>")), s.i && (o.push("<i>"), l.push("</i>")), s.strike && (o.push("<s>"), l.push("</s>"));
    var u = s.valign || "";
    return u == "superscript" || u == "super" ? u = "sup" : u == "subscript" && (u = "sub"), u != "" && (o.push("<" + u + ">"), l.push("</" + u + ">")), l.push("</span>"), s;
  }
  function a(s) {
    var o = [[], s.v, []];
    return s.v ? (s.s && n(s.s, o[0], o[2]), o[0].join("") + o[1].replace(e, "<br/>") + o[2].join("")) : "";
  }
  return function(o) {
    return o.map(a).join("");
  };
}(), sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/, sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(t, e) {
  var n = e ? e.cellHTML : !0, a = {};
  return t ? (t.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (a.t = unescapexml(utf8read(t.slice(t.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), a.r = utf8read(t), n && (a.h = escapehtml(a.t))) : (
    /*y = */
    t.match(sirregex) && (a.r = utf8read(t), a.t = unescapexml(utf8read((t.replace(sirphregex, "").match(sitregex) || []).join("").replace(tagregex, ""))), n && (a.h = rs_to_html(parse_rs(a.r))))
  ), a) : { t: "" };
}
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g, sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(t, e) {
  var n = [], a = "";
  if (!t)
    return n;
  var s = t.match(sstr0);
  if (s) {
    a = s[2].replace(sstr1, "").split(sstr2);
    for (var o = 0; o != a.length; ++o) {
      var l = parse_si(a[o].trim(), e);
      l != null && (n[n.length] = l);
    }
    s = parsexmltag(s[1]), n.Count = s.count, n.Unique = s.uniqueCount;
  }
  return n;
}
function parse_BrtBeginSst(t) {
  return [t.read_shift(4), t.read_shift(4)];
}
function parse_sst_bin(t, e) {
  var n = [], a = !1;
  return recordhopper(t, function(o, l, c) {
    switch (c) {
      case 159:
        n.Count = o[0], n.Unique = o[1];
        break;
      case 19:
        n.push(o);
        break;
      case 160:
        return !0;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      default:
        if (l.T, !a || e.WTF)
          throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), n;
}
function _JS2ANSI(t) {
  for (var e = [], n = t.split(""), a = 0; a < n.length; ++a)
    e[a] = n[a].charCodeAt(0);
  return e;
}
function parse_CRYPTOVersion(t, e) {
  var n = {};
  return n.Major = t.read_shift(2), n.Minor = t.read_shift(2), e >= 4 && (t.l += e - 4), n;
}
function parse_DataSpaceVersionInfo(t) {
  var e = {};
  return e.id = t.read_shift(0, "lpp4"), e.R = parse_CRYPTOVersion(t, 4), e.U = parse_CRYPTOVersion(t, 4), e.W = parse_CRYPTOVersion(t, 4), e;
}
function parse_DataSpaceMapEntry(t) {
  for (var e = t.read_shift(4), n = t.l + e - 4, a = {}, s = t.read_shift(4), o = []; s-- > 0; )
    o.push({ t: t.read_shift(4), v: t.read_shift(0, "lpp4") });
  if (a.name = t.read_shift(0, "lpp4"), a.comps = o, t.l != n)
    throw new Error("Bad DataSpaceMapEntry: " + t.l + " != " + n);
  return a;
}
function parse_DataSpaceMap(t) {
  var e = [];
  t.l += 4;
  for (var n = t.read_shift(4); n-- > 0; )
    e.push(parse_DataSpaceMapEntry(t));
  return e;
}
function parse_DataSpaceDefinition(t) {
  var e = [];
  t.l += 4;
  for (var n = t.read_shift(4); n-- > 0; )
    e.push(t.read_shift(0, "lpp4"));
  return e;
}
function parse_TransformInfoHeader(t) {
  var e = {};
  return t.read_shift(4), t.l += 4, e.id = t.read_shift(0, "lpp4"), e.name = t.read_shift(0, "lpp4"), e.R = parse_CRYPTOVersion(t, 4), e.U = parse_CRYPTOVersion(t, 4), e.W = parse_CRYPTOVersion(t, 4), e;
}
function parse_Primary(t) {
  var e = parse_TransformInfoHeader(t);
  if (e.ename = t.read_shift(0, "8lpp4"), e.blksz = t.read_shift(4), e.cmode = t.read_shift(4), t.read_shift(4) != 4)
    throw new Error("Bad !Primary record");
  return e;
}
function parse_EncryptionHeader(t, e) {
  var n = t.l + e, a = {};
  a.Flags = t.read_shift(4) & 63, t.l += 4, a.AlgID = t.read_shift(4);
  var s = !1;
  switch (a.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      s = a.Flags == 36;
      break;
    case 26625:
      s = a.Flags == 4;
      break;
    case 0:
      s = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + a.AlgID;
  }
  if (!s)
    throw new Error("Encryption Flags/AlgID mismatch");
  return a.AlgIDHash = t.read_shift(4), a.KeySize = t.read_shift(4), a.ProviderType = t.read_shift(4), t.l += 8, a.CSPName = t.read_shift(n - t.l >> 1, "utf16le"), t.l = n, a;
}
function parse_EncryptionVerifier(t, e) {
  var n = {}, a = t.l + e;
  return t.l += 4, n.Salt = t.slice(t.l, t.l + 16), t.l += 16, n.Verifier = t.slice(t.l, t.l + 16), t.l += 16, t.read_shift(4), n.VerifierHash = t.slice(t.l, a), t.l = a, n;
}
function parse_EncryptionInfo(t) {
  var e = parse_CRYPTOVersion(t);
  switch (e.Minor) {
    case 2:
      return [e.Minor, parse_EncInfoStd(t)];
    case 3:
      return [e.Minor, parse_EncInfoExt()];
    case 4:
      return [e.Minor, parse_EncInfoAgl(t)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + e.Minor);
}
function parse_EncInfoStd(t) {
  var e = t.read_shift(4);
  if ((e & 63) != 36)
    throw new Error("EncryptionInfo mismatch");
  var n = t.read_shift(4), a = parse_EncryptionHeader(t, n), s = parse_EncryptionVerifier(t, t.length - t.l);
  return { t: "Std", h: a, v: s };
}
function parse_EncInfoExt() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function parse_EncInfoAgl(t) {
  var e = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  t.l += 4;
  var n = t.read_shift(t.length - t.l, "utf8"), a = {};
  return n.replace(tagregex, function(o) {
    var l = parsexmltag(o);
    switch (strip_ns(l[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        e.forEach(function(c) {
          a[c] = l[c];
        });
        break;
      case "<dataIntegrity":
        a.encryptedHmacKey = l.encryptedHmacKey, a.encryptedHmacValue = l.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        a.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        a.uri = l.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        a.encs.push(l);
        break;
      default:
        throw l[0];
    }
  }), a;
}
function parse_RC4CryptoHeader(t, e) {
  var n = {}, a = n.EncryptionVersionInfo = parse_CRYPTOVersion(t, 4);
  if (e -= 4, a.Minor != 2)
    throw new Error("unrecognized minor version code: " + a.Minor);
  if (a.Major > 4 || a.Major < 2)
    throw new Error("unrecognized major version code: " + a.Major);
  n.Flags = t.read_shift(4), e -= 4;
  var s = t.read_shift(4);
  return e -= 4, n.EncryptionHeader = parse_EncryptionHeader(t, s), e -= s, n.EncryptionVerifier = parse_EncryptionVerifier(t, e), n;
}
function parse_RC4Header(t) {
  var e = {}, n = e.EncryptionVersionInfo = parse_CRYPTOVersion(t, 4);
  if (n.Major != 1 || n.Minor != 1)
    throw "unrecognized version code " + n.Major + " : " + n.Minor;
  return e.Salt = t.read_shift(16), e.EncryptedVerifier = t.read_shift(16), e.EncryptedVerifierHash = t.read_shift(16), e;
}
function crypto_CreatePasswordVerifier_Method1(t) {
  var e = 0, n, a = _JS2ANSI(t), s = a.length + 1, o, l, c, u, d;
  for (n = new_raw_buf(s), n[0] = a.length, o = 1; o != s; ++o)
    n[o] = a[o - 1];
  for (o = s - 1; o >= 0; --o)
    l = n[o], c = e & 16384 ? 1 : 0, u = e << 1 & 32767, d = c | u, e = d ^ l;
  return e ^ 52811;
}
var crypto_CreateXorArray_Method1 = /* @__PURE__ */ function() {
  var t = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], e = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], n = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], a = function(l) {
    return (l / 2 | l * 128) & 255;
  }, s = function(l, c) {
    return a(l ^ c);
  }, o = function(l) {
    for (var c = e[l.length - 1], u = 104, d = l.length - 1; d >= 0; --d)
      for (var f = l[d], h = 0; h != 7; ++h)
        f & 64 && (c ^= n[u]), f *= 2, --u;
    return c;
  };
  return function(l) {
    for (var c = _JS2ANSI(l), u = o(c), d = c.length, f = new_raw_buf(16), h = 0; h != 16; ++h)
      f[h] = 0;
    var g, x, E;
    for ((d & 1) === 1 && (g = u >> 8, f[d] = s(t[0], g), --d, g = u & 255, x = c[c.length - 1], f[d] = s(x, g)); d > 0; )
      --d, g = u >> 8, f[d] = s(c[d], g), --d, g = u & 255, f[d] = s(c[d], g);
    for (d = 15, E = 15 - c.length; E > 0; )
      g = u >> 8, f[d] = s(t[E], g), --d, --E, g = u & 255, f[d] = s(c[d], g), --d, --E;
    return f;
  };
}(), crypto_DecryptData_Method1 = function(t, e, n, a, s) {
  s || (s = e), a || (a = crypto_CreateXorArray_Method1(t));
  var o, l;
  for (o = 0; o != e.length; ++o)
    l = e[o], l ^= a[n], l = (l >> 5 | l << 3) & 255, s[o] = l, ++n;
  return [s, n, a];
}, crypto_MakeXorDecryptor = function(t) {
  var e = 0, n = crypto_CreateXorArray_Method1(t);
  return function(a) {
    var s = crypto_DecryptData_Method1("", a, e, n);
    return e = s[1], s[0];
  };
};
function parse_XORObfuscation(t, e, n, a) {
  var s = { key: parseuint16(t), verificationBytes: parseuint16(t) };
  return n.password && (s.verifier = crypto_CreatePasswordVerifier_Method1(n.password)), a.valid = s.verificationBytes === s.verifier, a.valid && (a.insitu = crypto_MakeXorDecryptor(n.password)), s;
}
function parse_FilePassHeader(t, e, n) {
  var a = n || {};
  return a.Info = t.read_shift(2), t.l -= 2, a.Info === 1 ? a.Data = parse_RC4Header(t) : a.Data = parse_RC4CryptoHeader(t, e), a;
}
function parse_FilePass(t, e, n) {
  var a = { Type: n.biff >= 8 ? t.read_shift(2) : 0 };
  return a.Type ? parse_FilePassHeader(t, e - 2, a) : parse_XORObfuscation(t, n.biff >= 8 ? e : e - 2, n, a), a;
}
var RTF = /* @__PURE__ */ function() {
  function t(s, o) {
    switch (o.type) {
      case "base64":
        return e(Base64_decode(s), o);
      case "binary":
        return e(s, o);
      case "buffer":
        return e(has_buf && Buffer.isBuffer(s) ? s.toString("binary") : a2s(s), o);
      case "array":
        return e(cc2str(s), o);
    }
    throw new Error("Unrecognized type " + o.type);
  }
  function e(s, o) {
    var l = o || {}, c = l.dense ? [] : {}, u = s.match(/\\trowd.*?\\row\b/g);
    if (!u.length)
      throw new Error("RTF missing table");
    var d = { s: { c: 0, r: 0 }, e: { c: 0, r: u.length - 1 } };
    return u.forEach(function(f, h) {
      Array.isArray(c) && (c[h] = []);
      for (var g = /\\\w+\b/g, x = 0, E, m = -1; E = g.exec(f); ) {
        switch (E[0]) {
          case "\\cell":
            var v = f.slice(x, g.lastIndex - E[0].length);
            if (v[0] == " " && (v = v.slice(1)), ++m, v.length) {
              var y = { v, t: "s" };
              Array.isArray(c) ? c[h][m] = y : c[encode_cell({ r: h, c: m })] = y;
            }
            break;
        }
        x = g.lastIndex;
      }
      m > d.e.c && (d.e.c = m);
    }), c["!ref"] = encode_range(d), c;
  }
  function n(s, o) {
    return sheet_to_workbook(t(s, o), o);
  }
  function a(s) {
    for (var o = ["{\\rtf1\\ansi"], l = safe_decode_range(s["!ref"]), c, u = Array.isArray(s), d = l.s.r; d <= l.e.r; ++d) {
      o.push("\\trowd\\trautofit1");
      for (var f = l.s.c; f <= l.e.c; ++f)
        o.push("\\cellx" + (f + 1));
      for (o.push("\\pard\\intbl"), f = l.s.c; f <= l.e.c; ++f) {
        var h = encode_cell({ r: d, c: f });
        c = u ? (s[d] || [])[f] : s[h], !(!c || c.v == null && (!c.f || c.F)) && (o.push(" " + (c.w || (format_cell(c), c.w))), o.push("\\cell"));
      }
      o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
  }
  return {
    to_workbook: n,
    to_sheet: t,
    from_sheet: a
  };
}();
function hex2RGB(t) {
  var e = t.slice(t[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(e.slice(0, 2), 16), parseInt(e.slice(2, 4), 16), parseInt(e.slice(4, 6), 16)];
}
function rgb2Hex(t) {
  for (var e = 0, n = 1; e != 3; ++e)
    n = n * 256 + (t[e] > 255 ? 255 : t[e] < 0 ? 0 : t[e]);
  return n.toString(16).toUpperCase().slice(1);
}
function rgb2HSL(t) {
  var e = t[0] / 255, n = t[1] / 255, a = t[2] / 255, s = Math.max(e, n, a), o = Math.min(e, n, a), l = s - o;
  if (l === 0)
    return [0, 0, e];
  var c = 0, u = 0, d = s + o;
  switch (u = l / (d > 1 ? 2 - d : d), s) {
    case e:
      c = ((n - a) / l + 6) % 6;
      break;
    case n:
      c = (a - e) / l + 2;
      break;
    case a:
      c = (e - n) / l + 4;
      break;
  }
  return [c / 6, u, d / 2];
}
function hsl2RGB(t) {
  var e = t[0], n = t[1], a = t[2], s = n * 2 * (a < 0.5 ? a : 1 - a), o = a - s / 2, l = [o, o, o], c = 6 * e, u;
  if (n !== 0)
    switch (c | 0) {
      case 0:
      case 6:
        u = s * c, l[0] += s, l[1] += u;
        break;
      case 1:
        u = s * (2 - c), l[0] += u, l[1] += s;
        break;
      case 2:
        u = s * (c - 2), l[1] += s, l[2] += u;
        break;
      case 3:
        u = s * (4 - c), l[1] += u, l[2] += s;
        break;
      case 4:
        u = s * (c - 4), l[2] += s, l[0] += u;
        break;
      case 5:
        u = s * (6 - c), l[2] += u, l[0] += s;
        break;
    }
  for (var d = 0; d != 3; ++d)
    l[d] = Math.round(l[d] * 255);
  return l;
}
function rgb_tint(t, e) {
  if (e === 0)
    return t;
  var n = rgb2HSL(hex2RGB(t));
  return e < 0 ? n[2] = n[2] * (1 + e) : n[2] = 1 - (1 - n[2]) * (1 - e), rgb2Hex(hsl2RGB(n));
}
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(t) {
  return Math.floor((t + Math.round(128 / MDW) / 256) * MDW);
}
function px2char(t) {
  return Math.floor((t - 5) / MDW * 100 + 0.5) / 100;
}
function char2width(t) {
  return Math.round((t * MDW + 5) / MDW * 256) / 256;
}
function cycle_width(t) {
  return char2width(px2char(width2px(t)));
}
function find_mdw_colw(t) {
  var e = Math.abs(t - cycle_width(t)), n = MDW;
  if (e > 5e-3)
    for (MDW = MIN_MDW; MDW < MAX_MDW; ++MDW)
      Math.abs(t - cycle_width(t)) <= e && (e = Math.abs(t - cycle_width(t)), n = MDW);
  MDW = n;
}
function process_col(t) {
  t.width ? (t.wpx = width2px(t.width), t.wch = px2char(t.wpx), t.MDW = MDW) : t.wpx ? (t.wch = px2char(t.wpx), t.width = char2width(t.wch), t.MDW = MDW) : typeof t.wch == "number" && (t.width = char2width(t.wch), t.wpx = width2px(t.width), t.MDW = MDW), t.customWidth && delete t.customWidth;
}
var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(t) {
  return t * 96 / PPI;
}
function pt2px(t) {
  return t * PPI / 96;
}
var XLMLPatternTypeMap = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function parse_borders(t, e, n, a) {
  e.Borders = [];
  var s = {}, o = !1;
  (t[0].match(tagregex) || []).forEach(function(l) {
    var c = parsexmltag(l);
    switch (strip_ns(c[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      case "<border":
      case "<border>":
      case "<border/>":
        s = /*::(*/
        {}, c.diagonalUp && (s.diagonalUp = parsexmlbool(c.diagonalUp)), c.diagonalDown && (s.diagonalDown = parsexmlbool(c.diagonalDown)), e.Borders.push(s);
        break;
      case "</border>":
        break;
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (a && a.WTF && !o)
          throw new Error("unrecognized " + c[0] + " in borders");
    }
  });
}
function parse_fills(t, e, n, a) {
  e.Fills = [];
  var s = {}, o = !1;
  (t[0].match(tagregex) || []).forEach(function(l) {
    var c = parsexmltag(l);
    switch (strip_ns(c[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      case "<fill>":
      case "<fill":
      case "<fill/>":
        s = {}, e.Fills.push(s);
        break;
      case "</fill>":
        break;
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        e.Fills.push(s), s = {};
        break;
      case "<patternFill":
      case "<patternFill>":
        c.patternType && (s.patternType = c.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      case "<bgColor":
        s.bgColor || (s.bgColor = {}), c.indexed && (s.bgColor.indexed = parseInt(c.indexed, 10)), c.theme && (s.bgColor.theme = parseInt(c.theme, 10)), c.tint && (s.bgColor.tint = parseFloat(c.tint)), c.rgb && (s.bgColor.rgb = c.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      case "<fgColor":
        s.fgColor || (s.fgColor = {}), c.theme && (s.fgColor.theme = parseInt(c.theme, 10)), c.tint && (s.fgColor.tint = parseFloat(c.tint)), c.rgb != null && (s.fgColor.rgb = c.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (a && a.WTF && !o)
          throw new Error("unrecognized " + c[0] + " in fills");
    }
  });
}
function parse_fonts(t, e, n, a) {
  e.Fonts = [];
  var s = {}, o = !1;
  (t[0].match(tagregex) || []).forEach(function(l) {
    var c = parsexmltag(l);
    switch (strip_ns(c[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        e.Fonts.push(s), s = {};
        break;
      case "<name":
        c.val && (s.name = utf8read(c.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      case "<b":
        s.bold = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<b/>":
        s.bold = 1;
        break;
      case "<i":
        s.italic = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<i/>":
        s.italic = 1;
        break;
      case "<u":
        switch (c.val) {
          case "none":
            s.underline = 0;
            break;
          case "single":
            s.underline = 1;
            break;
          case "double":
            s.underline = 2;
            break;
          case "singleAccounting":
            s.underline = 33;
            break;
          case "doubleAccounting":
            s.underline = 34;
            break;
        }
        break;
      case "<u/>":
        s.underline = 1;
        break;
      case "<strike":
        s.strike = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<strike/>":
        s.strike = 1;
        break;
      case "<outline":
        s.outline = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<outline/>":
        s.outline = 1;
        break;
      case "<shadow":
        s.shadow = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<shadow/>":
        s.shadow = 1;
        break;
      case "<condense":
        s.condense = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<condense/>":
        s.condense = 1;
        break;
      case "<extend":
        s.extend = c.val ? parsexmlbool(c.val) : 1;
        break;
      case "<extend/>":
        s.extend = 1;
        break;
      case "<sz":
        c.val && (s.sz = +c.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      case "<vertAlign":
        c.val && (s.vertAlign = c.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<family":
        c.val && (s.family = parseInt(c.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      case "<scheme":
        c.val && (s.scheme = c.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<charset":
        if (c.val == "1")
          break;
        c.codepage = CS2CP[parseInt(c.val, 10)];
        break;
      case "<color":
        if (s.color || (s.color = {}), c.auto && (s.color.auto = parsexmlbool(c.auto)), c.rgb)
          s.color.rgb = c.rgb.slice(-6);
        else if (c.indexed) {
          s.color.index = parseInt(c.indexed, 10);
          var u = XLSIcv[s.color.index];
          s.color.index == 81 && (u = XLSIcv[1]), u || (u = XLSIcv[1]), s.color.rgb = u[0].toString(16) + u[1].toString(16) + u[2].toString(16);
        } else
          c.theme && (s.color.theme = parseInt(c.theme, 10), c.tint && (s.color.tint = parseFloat(c.tint)), c.theme && n.themeElements && n.themeElements.clrScheme && (s.color.rgb = rgb_tint(n.themeElements.clrScheme[s.color.theme].rgb, s.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<AlternateContent":
        o = !0;
        break;
      case "</AlternateContent>":
        o = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        o = !0;
        break;
      case "</ext>":
        o = !1;
        break;
      default:
        if (a && a.WTF && !o)
          throw new Error("unrecognized " + c[0] + " in fonts");
    }
  });
}
function parse_numFmts(t, e, n) {
  e.NumberFmt = [];
  for (var a = keys(table_fmt), s = 0; s < a.length; ++s)
    e.NumberFmt[a[s]] = table_fmt[a[s]];
  var o = t[0].match(tagregex);
  if (o)
    for (s = 0; s < o.length; ++s) {
      var l = parsexmltag(o[s]);
      switch (strip_ns(l[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var c = unescapexml(utf8read(l.formatCode)), u = parseInt(l.numFmtId, 10);
            if (e.NumberFmt[u] = c, u > 0) {
              if (u > 392) {
                for (u = 392; u > 60 && e.NumberFmt[u] != null; --u)
                  ;
                e.NumberFmt[u] = c;
              }
              SSF_load(c, u);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (n.WTF)
            throw new Error("unrecognized " + l[0] + " in numFmts");
      }
    }
}
var cellXF_uint = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], cellXF_bool = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function parse_cellXfs(t, e, n) {
  e.CellXf = [];
  var a, s = !1;
  (t[0].match(tagregex) || []).forEach(function(o) {
    var l = parsexmltag(o), c = 0;
    switch (strip_ns(l[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      case "<xf":
      case "<xf/>":
        for (a = l, delete a[0], c = 0; c < cellXF_uint.length; ++c)
          a[cellXF_uint[c]] && (a[cellXF_uint[c]] = parseInt(a[cellXF_uint[c]], 10));
        for (c = 0; c < cellXF_bool.length; ++c)
          a[cellXF_bool[c]] && (a[cellXF_bool[c]] = parsexmlbool(a[cellXF_bool[c]]));
        if (e.NumberFmt && a.numFmtId > 392) {
          for (c = 392; c > 60; --c)
            if (e.NumberFmt[a.numFmtId] == e.NumberFmt[c]) {
              a.numFmtId = c;
              break;
            }
        }
        e.CellXf.push(a);
        break;
      case "</xf>":
        break;
      case "<alignment":
      case "<alignment/>":
        var u = {};
        l.vertical && (u.vertical = l.vertical), l.horizontal && (u.horizontal = l.horizontal), l.textRotation != null && (u.textRotation = l.textRotation), l.indent && (u.indent = l.indent), l.wrapText && (u.wrapText = parsexmlbool(l.wrapText)), a.alignment = u;
        break;
      case "</alignment>":
        break;
      case "<protection":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      case "<AlternateContent":
        s = !0;
        break;
      case "</AlternateContent>":
        s = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        s = !0;
        break;
      case "</ext>":
        s = !1;
        break;
      default:
        if (n && n.WTF && !s)
          throw new Error("unrecognized " + l[0] + " in cellXfs");
    }
  });
}
var parse_sty_xml = /* @__PURE__ */ function t() {
  var e = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, n = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, a = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, s = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, o = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(c, u, d) {
    var f = {};
    if (!c)
      return f;
    c = c.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var h;
    return (h = c.match(e)) && parse_numFmts(h, f, d), (h = c.match(s)) && parse_fonts(h, f, u, d), (h = c.match(a)) && parse_fills(h, f, u, d), (h = c.match(o)) && parse_borders(h, f, u, d), (h = c.match(n)) && parse_cellXfs(h, f, d), f;
  };
}();
function parse_BrtFmt(t, e) {
  var n = t.read_shift(2), a = parse_XLWideString(t);
  return [n, a];
}
function parse_BrtFont(t, e, n) {
  var a = {};
  a.sz = t.read_shift(2) / 20;
  var s = parse_FontFlags(t);
  s.fItalic && (a.italic = 1), s.fCondense && (a.condense = 1), s.fExtend && (a.extend = 1), s.fShadow && (a.shadow = 1), s.fOutline && (a.outline = 1), s.fStrikeout && (a.strike = 1);
  var o = t.read_shift(2);
  switch (o === 700 && (a.bold = 1), t.read_shift(2)) {
    case 1:
      a.vertAlign = "superscript";
      break;
    case 2:
      a.vertAlign = "subscript";
      break;
  }
  var l = t.read_shift(1);
  l != 0 && (a.underline = l);
  var c = t.read_shift(1);
  c > 0 && (a.family = c);
  var u = t.read_shift(1);
  switch (u > 0 && (a.charset = u), t.l++, a.color = parse_BrtColor(t), t.read_shift(1)) {
    case 1:
      a.scheme = "major";
      break;
    case 2:
      a.scheme = "minor";
      break;
  }
  return a.name = parse_XLWideString(t), a;
}
var parse_BrtFill = parsenoop;
function parse_BrtXF(t, e) {
  var n = t.l + e, a = t.read_shift(2), s = t.read_shift(2);
  return t.l = n, { ixfe: a, numFmtId: s };
}
var parse_BrtBorder = parsenoop;
function parse_sty_bin(t, e, n) {
  var a = {};
  a.NumberFmt = [];
  for (var s in table_fmt)
    a.NumberFmt[s] = table_fmt[s];
  a.CellXf = [], a.Fonts = [];
  var o = [], l = !1;
  return recordhopper(t, function(u, d, f) {
    switch (f) {
      case 44:
        a.NumberFmt[u[0]] = u[1], SSF_load(u[1], u[0]);
        break;
      case 43:
        a.Fonts.push(u), u.color.theme != null && e && e.themeElements && e.themeElements.clrScheme && (u.color.rgb = rgb_tint(e.themeElements.clrScheme[u.color.theme].rgb, u.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        o[o.length - 1] == 617 && a.CellXf.push(u);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        l = !0;
        break;
      case 36:
        l = !1;
        break;
      case 37:
        o.push(f), l = !0;
        break;
      case 38:
        o.pop(), l = !1;
        break;
      default:
        if (d.T > 0)
          o.push(f);
        else if (d.T < 0)
          o.pop();
        else if (!l || n.WTF && o[o.length - 1] != 37)
          throw new Error("Unexpected record 0x" + f.toString(16));
    }
  }), a;
}
var XLSXThemeClrScheme = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function parse_clrScheme(t, e, n) {
  e.themeElements.clrScheme = [];
  var a = {};
  (t[0].match(tagregex) || []).forEach(function(s) {
    var o = parsexmltag(s);
    switch (o[0]) {
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      case "<a:srgbClr":
        a.rgb = o.val;
        break;
      case "<a:sysClr":
        a.rgb = o.lastClr;
        break;
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        o[0].charAt(1) === "/" ? (e.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(o[0])] = a, a = {}) : a.name = o[0].slice(3, o[0].length - 1);
        break;
      default:
        if (n && n.WTF)
          throw new Error("Unrecognized " + o[0] + " in clrScheme");
    }
  });
}
function parse_fontScheme() {
}
function parse_fmtScheme() {
}
var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function parse_themeElements(t, e, n) {
  e.themeElements = {};
  var a;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", clrsregex, parse_clrScheme],
    /* fontScheme CT_FontScheme */
    ["fontScheme", fntsregex, parse_fontScheme],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", fmtsregex, parse_fmtScheme]
  ].forEach(function(s) {
    if (!(a = t.match(s[1])))
      throw new Error(s[0] + " not found in themeElements");
    s[2](a, e, n);
  });
}
var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function parse_theme_xml(t, e) {
  (!t || t.length === 0) && (t = write_theme());
  var n, a = {};
  if (!(n = t.match(themeltregex)))
    throw new Error("themeElements not found in theme");
  return parse_themeElements(n[0], a, e), a.raw = t, a;
}
function write_theme(t, e) {
  if (e && e.themeXLSX)
    return e.themeXLSX;
  if (t && typeof t.raw == "string")
    return t.raw;
  var n = [XML_HEADER];
  return n[n.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', n[n.length] = "<a:themeElements>", n[n.length] = '<a:clrScheme name="Office">', n[n.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', n[n.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', n[n.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', n[n.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', n[n.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', n[n.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', n[n.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', n[n.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', n[n.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', n[n.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', n[n.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', n[n.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', n[n.length] = "</a:clrScheme>", n[n.length] = '<a:fontScheme name="Office">', n[n.length] = "<a:majorFont>", n[n.length] = '<a:latin typeface="Cambria"/>', n[n.length] = '<a:ea typeface=""/>', n[n.length] = '<a:cs typeface=""/>', n[n.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', n[n.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', n[n.length] = '<a:font script="Hans" typeface="宋体"/>', n[n.length] = '<a:font script="Hant" typeface="新細明體"/>', n[n.length] = '<a:font script="Arab" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Thai" typeface="Tahoma"/>', n[n.length] = '<a:font script="Ethi" typeface="Nyala"/>', n[n.length] = '<a:font script="Beng" typeface="Vrinda"/>', n[n.length] = '<a:font script="Gujr" typeface="Shruti"/>', n[n.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', n[n.length] = '<a:font script="Knda" typeface="Tunga"/>', n[n.length] = '<a:font script="Guru" typeface="Raavi"/>', n[n.length] = '<a:font script="Cans" typeface="Euphemia"/>', n[n.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', n[n.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', n[n.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', n[n.length] = '<a:font script="Thaa" typeface="MV Boli"/>', n[n.length] = '<a:font script="Deva" typeface="Mangal"/>', n[n.length] = '<a:font script="Telu" typeface="Gautami"/>', n[n.length] = '<a:font script="Taml" typeface="Latha"/>', n[n.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', n[n.length] = '<a:font script="Orya" typeface="Kalinga"/>', n[n.length] = '<a:font script="Mlym" typeface="Kartika"/>', n[n.length] = '<a:font script="Laoo" typeface="DokChampa"/>', n[n.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', n[n.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', n[n.length] = '<a:font script="Viet" typeface="Times New Roman"/>', n[n.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', n[n.length] = '<a:font script="Geor" typeface="Sylfaen"/>', n[n.length] = "</a:majorFont>", n[n.length] = "<a:minorFont>", n[n.length] = '<a:latin typeface="Calibri"/>', n[n.length] = '<a:ea typeface=""/>', n[n.length] = '<a:cs typeface=""/>', n[n.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', n[n.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', n[n.length] = '<a:font script="Hans" typeface="宋体"/>', n[n.length] = '<a:font script="Hant" typeface="新細明體"/>', n[n.length] = '<a:font script="Arab" typeface="Arial"/>', n[n.length] = '<a:font script="Hebr" typeface="Arial"/>', n[n.length] = '<a:font script="Thai" typeface="Tahoma"/>', n[n.length] = '<a:font script="Ethi" typeface="Nyala"/>', n[n.length] = '<a:font script="Beng" typeface="Vrinda"/>', n[n.length] = '<a:font script="Gujr" typeface="Shruti"/>', n[n.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', n[n.length] = '<a:font script="Knda" typeface="Tunga"/>', n[n.length] = '<a:font script="Guru" typeface="Raavi"/>', n[n.length] = '<a:font script="Cans" typeface="Euphemia"/>', n[n.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', n[n.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', n[n.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', n[n.length] = '<a:font script="Thaa" typeface="MV Boli"/>', n[n.length] = '<a:font script="Deva" typeface="Mangal"/>', n[n.length] = '<a:font script="Telu" typeface="Gautami"/>', n[n.length] = '<a:font script="Taml" typeface="Latha"/>', n[n.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', n[n.length] = '<a:font script="Orya" typeface="Kalinga"/>', n[n.length] = '<a:font script="Mlym" typeface="Kartika"/>', n[n.length] = '<a:font script="Laoo" typeface="DokChampa"/>', n[n.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', n[n.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', n[n.length] = '<a:font script="Viet" typeface="Arial"/>', n[n.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', n[n.length] = '<a:font script="Geor" typeface="Sylfaen"/>', n[n.length] = "</a:minorFont>", n[n.length] = "</a:fontScheme>", n[n.length] = '<a:fmtScheme name="Office">', n[n.length] = "<a:fillStyleLst>", n[n.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:lin ang="16200000" scaled="1"/>', n[n.length] = "</a:gradFill>", n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:lin ang="16200000" scaled="0"/>', n[n.length] = "</a:gradFill>", n[n.length] = "</a:fillStyleLst>", n[n.length] = "<a:lnStyleLst>", n[n.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', n[n.length] = "</a:lnStyleLst>", n[n.length] = "<a:effectStyleLst>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = "</a:effectStyle>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = "</a:effectStyle>", n[n.length] = "<a:effectStyle>", n[n.length] = "<a:effectLst>", n[n.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', n[n.length] = "</a:effectLst>", n[n.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', n[n.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', n[n.length] = "</a:effectStyle>", n[n.length] = "</a:effectStyleLst>", n[n.length] = "<a:bgFillStyleLst>", n[n.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', n[n.length] = "</a:gradFill>", n[n.length] = '<a:gradFill rotWithShape="1">', n[n.length] = "<a:gsLst>", n[n.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', n[n.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', n[n.length] = "</a:gsLst>", n[n.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', n[n.length] = "</a:gradFill>", n[n.length] = "</a:bgFillStyleLst>", n[n.length] = "</a:fmtScheme>", n[n.length] = "</a:themeElements>", n[n.length] = "<a:objectDefaults>", n[n.length] = "<a:spDef>", n[n.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', n[n.length] = "</a:spDef>", n[n.length] = "<a:lnDef>", n[n.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', n[n.length] = "</a:lnDef>", n[n.length] = "</a:objectDefaults>", n[n.length] = "<a:extraClrSchemeLst/>", n[n.length] = "</a:theme>", n.join("");
}
function parse_Theme(t, e, n) {
  var a = t.l + e, s = t.read_shift(4);
  if (s !== 124226) {
    if (!n.cellStyles) {
      t.l = a;
      return;
    }
    var o = t.slice(t.l);
    t.l = a;
    var l;
    try {
      l = zip_read(o, { type: "array" });
    } catch {
      return;
    }
    var c = getzipstr(l, "theme/theme/theme1.xml", !0);
    if (c)
      return parse_theme_xml(c, n);
  }
}
function parse_ColorTheme(t) {
  return t.read_shift(4);
}
function parse_FullColorExt(t) {
  var e = {};
  switch (e.xclrType = t.read_shift(2), e.nTintShade = t.read_shift(2), e.xclrType) {
    case 0:
      t.l += 4;
      break;
    case 1:
      e.xclrValue = parse_IcvXF(t, 4);
      break;
    case 2:
      e.xclrValue = parse_LongRGBA(t);
      break;
    case 3:
      e.xclrValue = parse_ColorTheme(t);
      break;
    case 4:
      t.l += 4;
      break;
  }
  return t.l += 8, e;
}
function parse_IcvXF(t, e) {
  return parsenoop(t, e);
}
function parse_XFExtGradient(t, e) {
  return parsenoop(t, e);
}
function parse_ExtProp(t) {
  var e = t.read_shift(2), n = t.read_shift(2) - 4, a = [e];
  switch (e) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      a[1] = parse_FullColorExt(t);
      break;
    case 6:
      a[1] = parse_XFExtGradient(t, n);
      break;
    case 14:
    case 15:
      a[1] = t.read_shift(n === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + e + " " + n);
  }
  return a;
}
function parse_XFExt(t, e) {
  var n = t.l + e;
  t.l += 2;
  var a = t.read_shift(2);
  t.l += 2;
  for (var s = t.read_shift(2), o = []; s-- > 0; )
    o.push(parse_ExtProp(t, n - t.l));
  return { ixfe: a, ext: o };
}
function update_xfext(t, e) {
  e.forEach(function(n) {
    switch (n[0]) {
    }
  });
}
function parse_BrtMdtinfo(t, e) {
  return {
    flags: t.read_shift(4),
    version: t.read_shift(4),
    name: parse_XLWideString(t)
  };
}
function parse_BrtMdb(t) {
  for (var e = [], n = t.read_shift(4); n-- > 0; )
    e.push([t.read_shift(4), t.read_shift(4)]);
  return e;
}
function parse_BrtBeginEsmdb(t) {
  return t.l += 4, t.read_shift(4) != 0;
}
function parse_xlmeta_bin(t, e, n) {
  var a = { Types: [], Cell: [], Value: [] }, s = n || {}, o = [], l = !1, c = 2;
  return recordhopper(t, function(u, d, f) {
    switch (f) {
      case 335:
        a.Types.push({ name: u.name });
        break;
      case 51:
        u.forEach(function(h) {
          c == 1 ? a.Cell.push({ type: a.Types[h[0] - 1].name, index: h[1] }) : c == 0 && a.Value.push({ type: a.Types[h[0] - 1].name, index: h[1] });
        });
        break;
      case 337:
        c = u ? 1 : 0;
        break;
      case 338:
        c = 2;
        break;
      case 35:
        o.push(f), l = !0;
        break;
      case 36:
        o.pop(), l = !1;
        break;
      default:
        if (!d.T) {
          if (!l || s.WTF && o[o.length - 1] != 35)
            throw new Error("Unexpected record 0x" + f.toString(16));
        }
    }
  }), a;
}
function parse_xlmeta_xml(t, e, n) {
  var a = { Types: [], Cell: [], Value: [] };
  if (!t)
    return a;
  var s = !1, o = 2, l;
  return t.replace(tagregex, function(c) {
    var u = parsexmltag(c);
    switch (strip_ns(u[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        a.Types.push({ name: u.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var d = 0; d < a.Types.length; ++d)
          a.Types[d].name == u.name && (l = a.Types[d]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        o == 1 ? a.Cell.push({ type: a.Types[u.t - 1].name, index: +u.v }) : o == 0 && a.Value.push({ type: a.Types[u.t - 1].name, index: +u.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        o = 1;
        break;
      case "</cellMetadata>":
        o = 2;
        break;
      case "<valueMetadata":
        o = 0;
        break;
      case "</valueMetadata>":
        o = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        s = !0;
        break;
      case "</ext>":
        s = !1;
        break;
      case "<rvb":
        if (!l)
          break;
        l.offsets || (l.offsets = []), l.offsets.push(+u.i);
        break;
      default:
        if (!s && n.WTF)
          throw new Error("unrecognized " + u[0] + " in metadata");
    }
    return c;
  }), a;
}
function parse_cc_xml(t) {
  var e = [];
  if (!t)
    return e;
  var n = 1;
  return (t.match(tagregex) || []).forEach(function(a) {
    var s = parsexmltag(a);
    switch (s[0]) {
      case "<?xml":
        break;
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      case "<c":
        delete s[0], s.i ? n = s.i : s.i = n, e.push(s);
        break;
    }
  }), e;
}
function parse_BrtCalcChainItem$(t) {
  var e = {};
  e.i = t.read_shift(4);
  var n = {};
  n.r = t.read_shift(4), n.c = t.read_shift(4), e.r = encode_cell(n);
  var a = t.read_shift(1);
  return a & 2 && (e.l = "1"), a & 8 && (e.a = "1"), e;
}
function parse_cc_bin(t, e, n) {
  var a = [];
  return recordhopper(t, function(o, l, c) {
    switch (c) {
      case 63:
        a.push(o);
        break;
      default:
        if (!l.T)
          throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), a;
}
function parse_xlink_xml() {
}
function parse_xlink_bin(t, e, n, a) {
  if (!t)
    return t;
  var s = a || {}, o = !1;
  recordhopper(t, function(c, u, d) {
    switch (d) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        o = !0;
        break;
      case 36:
        o = !1;
        break;
      default:
        if (!u.T) {
          if (!o || s.WTF)
            throw new Error("Unexpected record 0x" + d.toString(16));
        }
    }
  }, s);
}
function parse_drawing(t, e) {
  if (!t)
    return "??";
  var n = (t.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return e["!id"][n].Target;
}
function sheet_insert_comments(t, e, n, a) {
  var s = Array.isArray(t), o;
  e.forEach(function(l) {
    var c = decode_cell(l.ref);
    if (s ? (t[c.r] || (t[c.r] = []), o = t[c.r][c.c]) : o = t[l.ref], !o) {
      o = { t: "z" }, s ? t[c.r][c.c] = o : t[l.ref] = o;
      var u = safe_decode_range(t["!ref"] || "BDWGO1000001:A1");
      u.s.r > c.r && (u.s.r = c.r), u.e.r < c.r && (u.e.r = c.r), u.s.c > c.c && (u.s.c = c.c), u.e.c < c.c && (u.e.c = c.c);
      var d = encode_range(u);
      d !== t["!ref"] && (t["!ref"] = d);
    }
    o.c || (o.c = []);
    var f = { a: l.author, t: l.t, r: l.r, T: n };
    l.h && (f.h = l.h);
    for (var h = o.c.length - 1; h >= 0; --h) {
      if (!n && o.c[h].T)
        return;
      n && !o.c[h].T && o.c.splice(h, 1);
    }
    if (n && a) {
      for (h = 0; h < a.length; ++h)
        if (f.a == a[h].id) {
          f.a = a[h].name || f.a;
          break;
        }
    }
    o.c.push(f);
  });
}
function parse_comments_xml(t, e) {
  if (t.match(/<(?:\w+:)?comments *\/>/))
    return [];
  var n = [], a = [], s = t.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  s && s[1] && s[1].split(/<\/\w*:?author>/).forEach(function(l) {
    if (!(l === "" || l.trim() === "")) {
      var c = l.match(/<(?:\w+:)?author[^>]*>(.*)/);
      c && n.push(c[1]);
    }
  });
  var o = t.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return o && o[1] && o[1].split(/<\/\w*:?comment>/).forEach(function(l) {
    if (!(l === "" || l.trim() === "")) {
      var c = l.match(/<(?:\w+:)?comment[^>]*>/);
      if (c) {
        var u = parsexmltag(c[0]), d = { author: u.authorId && n[u.authorId] || "sheetjsghost", ref: u.ref, guid: u.guid }, f = decode_cell(u.ref);
        if (!(e.sheetRows && e.sheetRows <= f.r)) {
          var h = l.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), g = !!h && !!h[1] && parse_si(h[1]) || { r: "", t: "", h: "" };
          d.r = g.r, g.r == "<t></t>" && (g.t = g.h = ""), d.t = (g.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.cellHTML && (d.h = g.h), a.push(d);
        }
      }
    }
  }), a;
}
function parse_tcmnt_xml(t, e) {
  var n = [], a = !1, s = {}, o = 0;
  return t.replace(tagregex, function(c, u) {
    var d = parsexmltag(c);
    switch (strip_ns(d[0])) {
      case "<?xml":
        break;
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      case "<threadedComment":
        s = { author: d.personId, guid: d.id, ref: d.ref, T: 1 };
        break;
      case "</threadedComment>":
        s.t != null && n.push(s);
        break;
      case "<text>":
      case "<text":
        o = u + c.length;
        break;
      case "</text>":
        s.t = t.slice(o, u).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case "<mentions":
      case "<mentions>":
        a = !0;
        break;
      case "</mentions>":
        a = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && e.WTF)
          throw new Error("unrecognized " + d[0] + " in threaded comments");
    }
    return c;
  }), n;
}
function parse_people_xml(t, e) {
  var n = [], a = !1;
  return t.replace(tagregex, function(o) {
    var l = parsexmltag(o);
    switch (strip_ns(l[0])) {
      case "<?xml":
        break;
      case "<personList":
        break;
      case "</personList>":
        break;
      case "<person":
        n.push({ name: l.displayname, id: l.id });
        break;
      case "</person>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && e.WTF)
          throw new Error("unrecognized " + l[0] + " in threaded comments");
    }
    return o;
  }), n;
}
function parse_BrtBeginComment(t) {
  var e = {};
  e.iauthor = t.read_shift(4);
  var n = parse_UncheckedRfX(t);
  return e.rfx = n.s, e.ref = encode_cell(n.s), t.l += 16, e;
}
var parse_BrtCommentAuthor = parse_XLWideString;
function parse_comments_bin(t, e) {
  var n = [], a = [], s = {}, o = !1;
  return recordhopper(t, function(c, u, d) {
    switch (d) {
      case 632:
        a.push(c);
        break;
      case 635:
        s = c;
        break;
      case 637:
        s.t = c.t, s.h = c.h, s.r = c.r;
        break;
      case 636:
        if (s.author = a[s.iauthor], delete s.iauthor, e.sheetRows && s.rfx && e.sheetRows <= s.rfx.r)
          break;
        s.t || (s.t = ""), delete s.rfx, n.push(s);
        break;
      case 3072:
        break;
      case 35:
        o = !0;
        break;
      case 36:
        o = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!u.T) {
          if (!o || e.WTF)
            throw new Error("Unexpected record 0x" + d.toString(16));
        }
    }
  }), n;
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(t) {
  var e = CFB.utils.cfb_new({ root: "R" });
  return t.FullPaths.forEach(function(n, a) {
    if (!(n.slice(-1) === "/" || !n.match(/_VBA_PROJECT_CUR/))) {
      var s = n.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      CFB.utils.cfb_add(e, s, t.FileIndex[a].content);
    }
  }), CFB.write(e);
}
function parse_ds_bin() {
  return { "!type": "dialog" };
}
function parse_ds_xml() {
  return { "!type": "dialog" };
}
function parse_ms_bin() {
  return { "!type": "macro" };
}
function parse_ms_xml() {
  return { "!type": "macro" };
}
var rc_to_a1 = /* @__PURE__ */ function() {
  var t = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, e = { r: 0, c: 0 };
  function n(a, s, o, l) {
    var c = !1, u = !1;
    o.length == 0 ? u = !0 : o.charAt(0) == "[" && (u = !0, o = o.slice(1, -1)), l.length == 0 ? c = !0 : l.charAt(0) == "[" && (c = !0, l = l.slice(1, -1));
    var d = o.length > 0 ? parseInt(o, 10) | 0 : 0, f = l.length > 0 ? parseInt(l, 10) | 0 : 0;
    return c ? f += e.c : --f, u ? d += e.r : --d, s + (c ? "" : "$") + encode_col(f) + (u ? "" : "$") + encode_row(d);
  }
  return function(s, o) {
    return e = o, s.replace(t, n);
  };
}(), crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, a1_to_rc = /* @__PURE__ */ function() {
  return function(e, n) {
    return e.replace(crefregex, function(a, s, o, l, c, u) {
      var d = decode_col(l) - (o ? 0 : n.c), f = decode_row(u) - (c ? 0 : n.r), h = f == 0 ? "" : c ? f + 1 : "[" + f + "]", g = d == 0 ? "" : o ? d + 1 : "[" + d + "]";
      return s + "R" + h + "C" + g;
    });
  };
}();
function shift_formula_str(t, e) {
  return t.replace(crefregex, function(n, a, s, o, l, c) {
    return a + (s == "$" ? s + o : encode_col(decode_col(o) + e.c)) + (l == "$" ? l + c : encode_row(decode_row(c) + e.r));
  });
}
function shift_formula_xlsx(t, e, n) {
  var a = decode_range(e), s = a.s, o = decode_cell(n), l = { r: o.r - s.r, c: o.c - s.c };
  return shift_formula_str(t, l);
}
function fuzzyfmla(t) {
  return t.length != 1;
}
function _xlfn(t) {
  return t.replace(/_xlfn\./g, "");
}
function parseread1(t) {
  t.l += 1;
}
function parse_ColRelU(t, e) {
  var n = t.read_shift(e == 1 ? 1 : 2);
  return [n & 16383, n >> 14 & 1, n >> 15 & 1];
}
function parse_RgceArea(t, e, n) {
  var a = 2;
  if (n) {
    if (n.biff >= 2 && n.biff <= 5)
      return parse_RgceArea_BIFF2(t);
    n.biff == 12 && (a = 4);
  }
  var s = t.read_shift(a), o = t.read_shift(a), l = parse_ColRelU(t, 2), c = parse_ColRelU(t, 2);
  return { s: { r: s, c: l[0], cRel: l[1], rRel: l[2] }, e: { r: o, c: c[0], cRel: c[1], rRel: c[2] } };
}
function parse_RgceArea_BIFF2(t) {
  var e = parse_ColRelU(t, 2), n = parse_ColRelU(t, 2), a = t.read_shift(1), s = t.read_shift(1);
  return { s: { r: e[0], c: a, cRel: e[1], rRel: e[2] }, e: { r: n[0], c: s, cRel: n[1], rRel: n[2] } };
}
function parse_RgceAreaRel(t, e, n) {
  if (n.biff < 8)
    return parse_RgceArea_BIFF2(t);
  var a = t.read_shift(n.biff == 12 ? 4 : 2), s = t.read_shift(n.biff == 12 ? 4 : 2), o = parse_ColRelU(t, 2), l = parse_ColRelU(t, 2);
  return { s: { r: a, c: o[0], cRel: o[1], rRel: o[2] }, e: { r: s, c: l[0], cRel: l[1], rRel: l[2] } };
}
function parse_RgceLoc(t, e, n) {
  if (n && n.biff >= 2 && n.biff <= 5)
    return parse_RgceLoc_BIFF2(t);
  var a = t.read_shift(n && n.biff == 12 ? 4 : 2), s = parse_ColRelU(t, 2);
  return { r: a, c: s[0], cRel: s[1], rRel: s[2] };
}
function parse_RgceLoc_BIFF2(t) {
  var e = parse_ColRelU(t, 2), n = t.read_shift(1);
  return { r: e[0], c: n, cRel: e[1], rRel: e[2] };
}
function parse_RgceElfLoc(t) {
  var e = t.read_shift(2), n = t.read_shift(2);
  return { r: e, c: n & 255, fQuoted: !!(n & 16384), cRel: n >> 15, rRel: n >> 15 };
}
function parse_RgceLocRel(t, e, n) {
  var a = n && n.biff ? n.biff : 8;
  if (a >= 2 && a <= 5)
    return parse_RgceLocRel_BIFF2(t);
  var s = t.read_shift(a >= 12 ? 4 : 2), o = t.read_shift(2), l = (o & 16384) >> 14, c = (o & 32768) >> 15;
  if (o &= 16383, c == 1)
    for (; s > 524287; )
      s -= 1048576;
  if (l == 1)
    for (; o > 8191; )
      o = o - 16384;
  return { r: s, c: o, cRel: l, rRel: c };
}
function parse_RgceLocRel_BIFF2(t) {
  var e = t.read_shift(2), n = t.read_shift(1), a = (e & 32768) >> 15, s = (e & 16384) >> 14;
  return e &= 16383, a == 1 && e >= 8192 && (e = e - 16384), s == 1 && n >= 128 && (n = n - 256), { r: e, c: n, cRel: s, rRel: a };
}
function parse_PtgArea(t, e, n) {
  var a = (t[t.l++] & 96) >> 5, s = parse_RgceArea(t, n.biff >= 2 && n.biff <= 5 ? 6 : 8, n);
  return [a, s];
}
function parse_PtgArea3d(t, e, n) {
  var a = (t[t.l++] & 96) >> 5, s = t.read_shift(2, "i"), o = 8;
  if (n)
    switch (n.biff) {
      case 5:
        t.l += 12, o = 6;
        break;
      case 12:
        o = 12;
        break;
    }
  var l = parse_RgceArea(t, o, n);
  return [a, s, l];
}
function parse_PtgAreaErr(t, e, n) {
  var a = (t[t.l++] & 96) >> 5;
  return t.l += n && n.biff > 8 ? 12 : n.biff < 8 ? 6 : 8, [a];
}
function parse_PtgAreaErr3d(t, e, n) {
  var a = (t[t.l++] & 96) >> 5, s = t.read_shift(2), o = 8;
  if (n)
    switch (n.biff) {
      case 5:
        t.l += 12, o = 6;
        break;
      case 12:
        o = 12;
        break;
    }
  return t.l += o, [a, s];
}
function parse_PtgAreaN(t, e, n) {
  var a = (t[t.l++] & 96) >> 5, s = parse_RgceAreaRel(t, e - 1, n);
  return [a, s];
}
function parse_PtgArray(t, e, n) {
  var a = (t[t.l++] & 96) >> 5;
  return t.l += n.biff == 2 ? 6 : n.biff == 12 ? 14 : 7, [a];
}
function parse_PtgAttrBaxcel(t) {
  var e = t[t.l + 1] & 1, n = 1;
  return t.l += 4, [e, n];
}
function parse_PtgAttrChoose(t, e, n) {
  t.l += 2;
  for (var a = t.read_shift(n && n.biff == 2 ? 1 : 2), s = [], o = 0; o <= a; ++o)
    s.push(t.read_shift(n && n.biff == 2 ? 1 : 2));
  return s;
}
function parse_PtgAttrGoto(t, e, n) {
  var a = t[t.l + 1] & 255 ? 1 : 0;
  return t.l += 2, [a, t.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function parse_PtgAttrIf(t, e, n) {
  var a = t[t.l + 1] & 255 ? 1 : 0;
  return t.l += 2, [a, t.read_shift(n && n.biff == 2 ? 1 : 2)];
}
function parse_PtgAttrIfError(t) {
  var e = t[t.l + 1] & 255 ? 1 : 0;
  return t.l += 2, [e, t.read_shift(2)];
}
function parse_PtgAttrSemi(t, e, n) {
  var a = t[t.l + 1] & 255 ? 1 : 0;
  return t.l += n && n.biff == 2 ? 3 : 4, [a];
}
function parse_PtgAttrSpaceType(t) {
  var e = t.read_shift(1), n = t.read_shift(1);
  return [e, n];
}
function parse_PtgAttrSpace(t) {
  return t.read_shift(2), parse_PtgAttrSpaceType(t);
}
function parse_PtgAttrSpaceSemi(t) {
  return t.read_shift(2), parse_PtgAttrSpaceType(t);
}
function parse_PtgRef(t, e, n) {
  var a = (t[t.l] & 96) >> 5;
  t.l += 1;
  var s = parse_RgceLoc(t, 0, n);
  return [a, s];
}
function parse_PtgRefN(t, e, n) {
  var a = (t[t.l] & 96) >> 5;
  t.l += 1;
  var s = parse_RgceLocRel(t, 0, n);
  return [a, s];
}
function parse_PtgRef3d(t, e, n) {
  var a = (t[t.l] & 96) >> 5;
  t.l += 1;
  var s = t.read_shift(2);
  n && n.biff == 5 && (t.l += 12);
  var o = parse_RgceLoc(t, 0, n);
  return [a, s, o];
}
function parse_PtgFunc(t, e, n) {
  var a = (t[t.l] & 96) >> 5;
  t.l += 1;
  var s = t.read_shift(n && n.biff <= 3 ? 1 : 2);
  return [FtabArgc[s], Ftab[s], a];
}
function parse_PtgFuncVar(t, e, n) {
  var a = t[t.l++], s = t.read_shift(1), o = n && n.biff <= 3 ? [a == 88 ? -1 : 0, t.read_shift(1)] : parsetab(t);
  return [s, (o[0] === 0 ? Ftab : Cetab)[o[1]]];
}
function parsetab(t) {
  return [t[t.l + 1] >> 7, t.read_shift(2) & 32767];
}
function parse_PtgAttrSum(t, e, n) {
  t.l += n && n.biff == 2 ? 3 : 4;
}
function parse_PtgExp(t, e, n) {
  if (t.l++, n && n.biff == 12)
    return [t.read_shift(4, "i"), 0];
  var a = t.read_shift(2), s = t.read_shift(n && n.biff == 2 ? 1 : 2);
  return [a, s];
}
function parse_PtgErr(t) {
  return t.l++, BErr[t.read_shift(1)];
}
function parse_PtgInt(t) {
  return t.l++, t.read_shift(2);
}
function parse_PtgBool(t) {
  return t.l++, t.read_shift(1) !== 0;
}
function parse_PtgNum(t) {
  return t.l++, parse_Xnum(t);
}
function parse_PtgStr(t, e, n) {
  return t.l++, parse_ShortXLUnicodeString(t, e - 1, n);
}
function parse_SerAr(t, e) {
  var n = [t.read_shift(1)];
  if (e == 12)
    switch (n[0]) {
      case 2:
        n[0] = 4;
        break;
      case 4:
        n[0] = 16;
        break;
      case 0:
        n[0] = 1;
        break;
      case 1:
        n[0] = 2;
        break;
    }
  switch (n[0]) {
    case 4:
      n[1] = parsebool(t, 1) ? "TRUE" : "FALSE", e != 12 && (t.l += 7);
      break;
    case 37:
    case 16:
      n[1] = BErr[t[t.l]], t.l += e == 12 ? 4 : 8;
      break;
    case 0:
      t.l += 8;
      break;
    case 1:
      n[1] = parse_Xnum(t);
      break;
    case 2:
      n[1] = parse_XLUnicodeString2(t, 0, { biff: e > 0 && e < 8 ? 2 : e });
      break;
    default:
      throw new Error("Bad SerAr: " + n[0]);
  }
  return n;
}
function parse_PtgExtraMem(t, e, n) {
  for (var a = t.read_shift(n.biff == 12 ? 4 : 2), s = [], o = 0; o != a; ++o)
    s.push((n.biff == 12 ? parse_UncheckedRfX : parse_Ref8U)(t));
  return s;
}
function parse_PtgExtraArray(t, e, n) {
  var a = 0, s = 0;
  n.biff == 12 ? (a = t.read_shift(4), s = t.read_shift(4)) : (s = 1 + t.read_shift(1), a = 1 + t.read_shift(2)), n.biff >= 2 && n.biff < 8 && (--a, --s == 0 && (s = 256));
  for (var o = 0, l = []; o != a && (l[o] = []); ++o)
    for (var c = 0; c != s; ++c)
      l[o][c] = parse_SerAr(t, n.biff);
  return l;
}
function parse_PtgName(t, e, n) {
  var a = t.read_shift(1) >>> 5 & 3, s = !n || n.biff >= 8 ? 4 : 2, o = t.read_shift(s);
  switch (n.biff) {
    case 2:
      t.l += 5;
      break;
    case 3:
    case 4:
      t.l += 8;
      break;
    case 5:
      t.l += 12;
      break;
  }
  return [a, 0, o];
}
function parse_PtgNameX(t, e, n) {
  if (n.biff == 5)
    return parse_PtgNameX_BIFF5(t);
  var a = t.read_shift(1) >>> 5 & 3, s = t.read_shift(2), o = t.read_shift(4);
  return [a, s, o];
}
function parse_PtgNameX_BIFF5(t) {
  var e = t.read_shift(1) >>> 5 & 3, n = t.read_shift(2, "i");
  t.l += 8;
  var a = t.read_shift(2);
  return t.l += 12, [e, n, a];
}
function parse_PtgMemArea(t, e, n) {
  var a = t.read_shift(1) >>> 5 & 3;
  t.l += n && n.biff == 2 ? 3 : 4;
  var s = t.read_shift(n && n.biff == 2 ? 1 : 2);
  return [a, s];
}
function parse_PtgMemFunc(t, e, n) {
  var a = t.read_shift(1) >>> 5 & 3, s = t.read_shift(n && n.biff == 2 ? 1 : 2);
  return [a, s];
}
function parse_PtgRefErr(t, e, n) {
  var a = t.read_shift(1) >>> 5 & 3;
  return t.l += 4, n.biff < 8 && t.l--, n.biff == 12 && (t.l += 2), [a];
}
function parse_PtgRefErr3d(t, e, n) {
  var a = (t[t.l++] & 96) >> 5, s = t.read_shift(2), o = 4;
  if (n)
    switch (n.biff) {
      case 5:
        o = 15;
        break;
      case 12:
        o = 6;
        break;
    }
  return t.l += o, [a, s];
}
var parse_PtgMemErr = parsenoop, parse_PtgMemNoMem = parsenoop, parse_PtgTbl = parsenoop;
function parse_PtgElfLoc(t, e, n) {
  return t.l += 2, [parse_RgceElfLoc(t)];
}
function parse_PtgElfNoop(t) {
  return t.l += 6, [];
}
var parse_PtgElfCol = parse_PtgElfLoc, parse_PtgElfColS = parse_PtgElfNoop, parse_PtgElfColSV = parse_PtgElfNoop, parse_PtgElfColV = parse_PtgElfLoc;
function parse_PtgElfLel(t) {
  return t.l += 2, [parseuint16(t), t.read_shift(2) & 1];
}
var parse_PtgElfRadical = parse_PtgElfLoc, parse_PtgElfRadicalLel = parse_PtgElfLel, parse_PtgElfRadicalS = parse_PtgElfNoop, parse_PtgElfRw = parse_PtgElfLoc, parse_PtgElfRwV = parse_PtgElfLoc, PtgListRT = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function parse_PtgList(t) {
  t.l += 2;
  var e = t.read_shift(2), n = t.read_shift(2), a = t.read_shift(4), s = t.read_shift(2), o = t.read_shift(2), l = PtgListRT[n >> 2 & 31];
  return { ixti: e, coltype: n & 3, rt: l, idx: a, c: s, C: o };
}
function parse_PtgSxName(t) {
  return t.l += 2, [t.read_shift(4)];
}
function parse_PtgSheet(t, e, n) {
  return t.l += 5, t.l += 2, t.l += n.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function parse_PtgEndSheet(t, e, n) {
  return t.l += n.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(t) {
  var e = t.read_shift(1) >>> 5 & 3, n = t.read_shift(2);
  return [e, n];
}
function parse_PtgMemNoMemN(t) {
  var e = t.read_shift(1) >>> 5 & 3, n = t.read_shift(2);
  return [e, n];
}
function parse_PtgAttrNoop(t) {
  return t.l += 4, [0, 0];
}
var PtgTypes = {
  /*::[*/
  1: { n: "PtgExp", f: parse_PtgExp },
  /*::[*/
  2: { n: "PtgTbl", f: parse_PtgTbl },
  /*::[*/
  3: { n: "PtgAdd", f: parseread1 },
  /*::[*/
  4: { n: "PtgSub", f: parseread1 },
  /*::[*/
  5: { n: "PtgMul", f: parseread1 },
  /*::[*/
  6: { n: "PtgDiv", f: parseread1 },
  /*::[*/
  7: { n: "PtgPower", f: parseread1 },
  /*::[*/
  8: { n: "PtgConcat", f: parseread1 },
  /*::[*/
  9: { n: "PtgLt", f: parseread1 },
  /*::[*/
  10: { n: "PtgLe", f: parseread1 },
  /*::[*/
  11: { n: "PtgEq", f: parseread1 },
  /*::[*/
  12: { n: "PtgGe", f: parseread1 },
  /*::[*/
  13: { n: "PtgGt", f: parseread1 },
  /*::[*/
  14: { n: "PtgNe", f: parseread1 },
  /*::[*/
  15: { n: "PtgIsect", f: parseread1 },
  /*::[*/
  16: { n: "PtgUnion", f: parseread1 },
  /*::[*/
  17: { n: "PtgRange", f: parseread1 },
  /*::[*/
  18: { n: "PtgUplus", f: parseread1 },
  /*::[*/
  19: { n: "PtgUminus", f: parseread1 },
  /*::[*/
  20: { n: "PtgPercent", f: parseread1 },
  /*::[*/
  21: { n: "PtgParen", f: parseread1 },
  /*::[*/
  22: { n: "PtgMissArg", f: parseread1 },
  /*::[*/
  23: { n: "PtgStr", f: parse_PtgStr },
  /*::[*/
  26: { n: "PtgSheet", f: parse_PtgSheet },
  /*::[*/
  27: { n: "PtgEndSheet", f: parse_PtgEndSheet },
  /*::[*/
  28: { n: "PtgErr", f: parse_PtgErr },
  /*::[*/
  29: { n: "PtgBool", f: parse_PtgBool },
  /*::[*/
  30: { n: "PtgInt", f: parse_PtgInt },
  /*::[*/
  31: { n: "PtgNum", f: parse_PtgNum },
  /*::[*/
  32: { n: "PtgArray", f: parse_PtgArray },
  /*::[*/
  33: { n: "PtgFunc", f: parse_PtgFunc },
  /*::[*/
  34: { n: "PtgFuncVar", f: parse_PtgFuncVar },
  /*::[*/
  35: { n: "PtgName", f: parse_PtgName },
  /*::[*/
  36: { n: "PtgRef", f: parse_PtgRef },
  /*::[*/
  37: { n: "PtgArea", f: parse_PtgArea },
  /*::[*/
  38: { n: "PtgMemArea", f: parse_PtgMemArea },
  /*::[*/
  39: { n: "PtgMemErr", f: parse_PtgMemErr },
  /*::[*/
  40: { n: "PtgMemNoMem", f: parse_PtgMemNoMem },
  /*::[*/
  41: { n: "PtgMemFunc", f: parse_PtgMemFunc },
  /*::[*/
  42: { n: "PtgRefErr", f: parse_PtgRefErr },
  /*::[*/
  43: { n: "PtgAreaErr", f: parse_PtgAreaErr },
  /*::[*/
  44: { n: "PtgRefN", f: parse_PtgRefN },
  /*::[*/
  45: { n: "PtgAreaN", f: parse_PtgAreaN },
  /*::[*/
  46: { n: "PtgMemAreaN", f: parse_PtgMemAreaN },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: parse_PtgMemNoMemN },
  /*::[*/
  57: { n: "PtgNameX", f: parse_PtgNameX },
  /*::[*/
  58: { n: "PtgRef3d", f: parse_PtgRef3d },
  /*::[*/
  59: { n: "PtgArea3d", f: parse_PtgArea3d },
  /*::[*/
  60: { n: "PtgRefErr3d", f: parse_PtgRefErr3d },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: parse_PtgAreaErr3d },
  /*::[*/
  255: {}
}, PtgDupes = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, Ptg18 = {
  /*::[*/
  1: { n: "PtgElfLel", f: parse_PtgElfLel },
  /*::[*/
  2: { n: "PtgElfRw", f: parse_PtgElfRw },
  /*::[*/
  3: { n: "PtgElfCol", f: parse_PtgElfCol },
  /*::[*/
  6: { n: "PtgElfRwV", f: parse_PtgElfRwV },
  /*::[*/
  7: { n: "PtgElfColV", f: parse_PtgElfColV },
  /*::[*/
  10: { n: "PtgElfRadical", f: parse_PtgElfRadical },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: parse_PtgElfRadicalS },
  /*::[*/
  13: { n: "PtgElfColS", f: parse_PtgElfColS },
  /*::[*/
  15: { n: "PtgElfColSV", f: parse_PtgElfColSV },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: parse_PtgElfRadicalLel },
  /*::[*/
  25: { n: "PtgList", f: parse_PtgList },
  /*::[*/
  29: { n: "PtgSxName", f: parse_PtgSxName },
  /*::[*/
  255: {}
}, Ptg19 = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: parse_PtgAttrNoop },
  /*::[*/
  1: { n: "PtgAttrSemi", f: parse_PtgAttrSemi },
  /*::[*/
  2: { n: "PtgAttrIf", f: parse_PtgAttrIf },
  /*::[*/
  4: { n: "PtgAttrChoose", f: parse_PtgAttrChoose },
  /*::[*/
  8: { n: "PtgAttrGoto", f: parse_PtgAttrGoto },
  /*::[*/
  16: { n: "PtgAttrSum", f: parse_PtgAttrSum },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: parse_PtgAttrBaxcel },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: parse_PtgAttrBaxcel },
  /*::[*/
  64: { n: "PtgAttrSpace", f: parse_PtgAttrSpace },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: parse_PtgAttrSpaceSemi },
  /*::[*/
  128: { n: "PtgAttrIfError", f: parse_PtgAttrIfError },
  /*::[*/
  255: {}
};
function parse_RgbExtra(t, e, n, a) {
  if (a.biff < 8)
    return parsenoop(t, e);
  for (var s = t.l + e, o = [], l = 0; l !== n.length; ++l)
    switch (n[l][0]) {
      case "PtgArray":
        n[l][1] = parse_PtgExtraArray(t, 0, a), o.push(n[l][1]);
        break;
      case "PtgMemArea":
        n[l][2] = parse_PtgExtraMem(t, n[l][1], a), o.push(n[l][2]);
        break;
      case "PtgExp":
        a && a.biff == 12 && (n[l][1][1] = t.read_shift(4), o.push(n[l][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + n[l][0];
    }
  return e = s - t.l, e !== 0 && o.push(parsenoop(t, e)), o;
}
function parse_Rgce(t, e, n) {
  for (var a = t.l + e, s, o, l = []; a != t.l; )
    e = a - t.l, o = t[t.l], s = PtgTypes[o] || PtgTypes[PtgDupes[o]], (o === 24 || o === 25) && (s = (o === 24 ? Ptg18 : Ptg19)[t[t.l + 1]]), !s || !s.f ? parsenoop(t, e) : l.push([s.n, s.f(t, e, n)]);
  return l;
}
function stringify_array(t) {
  for (var e = [], n = 0; n < t.length; ++n) {
    for (var a = t[n], s = [], o = 0; o < a.length; ++o) {
      var l = a[o];
      if (l)
        switch (l[0]) {
          case 2:
            s.push('"' + l[1].replace(/"/g, '""') + '"');
            break;
          default:
            s.push(l[1]);
        }
      else
        s.push("");
    }
    e.push(s.join(","));
  }
  return e.join(";");
}
var PtgBinOp = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function formula_quote_sheet_name(t, e) {
  if (!t && !(e && e.biff <= 5 && e.biff >= 2))
    throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(t) ? "'" + t + "'" : t;
}
function get_ixti_raw(t, e, n) {
  if (!t)
    return "SH33TJSERR0";
  if (n.biff > 8 && (!t.XTI || !t.XTI[e]))
    return t.SheetNames[e];
  if (!t.XTI)
    return "SH33TJSERR6";
  var a = t.XTI[e];
  if (n.biff < 8)
    return e > 1e4 && (e -= 65536), e < 0 && (e = -e), e == 0 ? "" : t.XTI[e - 1];
  if (!a)
    return "SH33TJSERR1";
  var s = "";
  if (n.biff > 8)
    switch (t[a[0]][0]) {
      case 357:
        return s = a[1] == -1 ? "#REF" : t.SheetNames[a[1]], a[1] == a[2] ? s : s + ":" + t.SheetNames[a[2]];
      case 358:
        return n.SID != null ? t.SheetNames[n.SID] : "SH33TJSSAME" + t[a[0]][0];
      case 355:
      default:
        return "SH33TJSSRC" + t[a[0]][0];
    }
  switch (t[a[0]][0][0]) {
    case 1025:
      return s = a[1] == -1 ? "#REF" : t.SheetNames[a[1]] || "SH33TJSERR3", a[1] == a[2] ? s : s + ":" + t.SheetNames[a[2]];
    case 14849:
      return t[a[0]].slice(1).map(function(o) {
        return o.Name;
      }).join(";;");
    default:
      return t[a[0]][0][3] ? (s = a[1] == -1 ? "#REF" : t[a[0]][0][3][a[1]] || "SH33TJSERR4", a[1] == a[2] ? s : s + ":" + t[a[0]][0][3][a[2]]) : "SH33TJSERR2";
  }
}
function get_ixti(t, e, n) {
  var a = get_ixti_raw(t, e, n);
  return a == "#REF" ? a : formula_quote_sheet_name(a, n);
}
function stringify_formula(t, e, n, a, s) {
  var o = s && s.biff || 8, l = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }
  ), c = [], u, d, f, h = 0, g = 0, x, E = "";
  if (!t[0] || !t[0][0])
    return "";
  for (var m = -1, v = "", y = 0, A = t[0].length; y < A; ++y) {
    var b = t[0][y];
    switch (b[0]) {
      case "PtgUminus":
        c.push("-" + c.pop());
        break;
      case "PtgUplus":
        c.push("+" + c.pop());
        break;
      case "PtgPercent":
        c.push(c.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (u = c.pop(), d = c.pop(), m >= 0) {
          switch (t[0][m][1][0]) {
            case 0:
              v = fill(" ", t[0][m][1][1]);
              break;
            case 1:
              v = fill("\r", t[0][m][1][1]);
              break;
            default:
              if (v = "", s.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + t[0][m][1][0]);
          }
          d = d + v, m = -1;
        }
        c.push(d + PtgBinOp[b[0]] + u);
        break;
      case "PtgIsect":
        u = c.pop(), d = c.pop(), c.push(d + " " + u);
        break;
      case "PtgUnion":
        u = c.pop(), d = c.pop(), c.push(d + "," + u);
        break;
      case "PtgRange":
        u = c.pop(), d = c.pop(), c.push(d + ":" + u);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        f = shift_cell_xls(b[1][1], l, s), c.push(encode_cell_xls(f, o));
        break;
      case "PtgRefN":
        f = n ? shift_cell_xls(b[1][1], n, s) : b[1][1], c.push(encode_cell_xls(f, o));
        break;
      case "PtgRef3d":
        h = /*::Number(*/
        b[1][1], f = shift_cell_xls(b[1][2], l, s), E = get_ixti(a, h, s), c.push(E + "!" + encode_cell_xls(f, o));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var C = b[1][0], T = b[1][1];
        C || (C = 0), C &= 127;
        var w = C == 0 ? [] : c.slice(-C);
        c.length -= C, T === "User" && (T = w.shift()), c.push(T + "(" + w.join(",") + ")");
        break;
      case "PtgBool":
        c.push(b[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        c.push(
          /*::String(*/
          b[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        c.push(String(b[1]));
        break;
      case "PtgStr":
        c.push('"' + b[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        c.push(
          /*::String(*/
          b[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        x = shift_range_xls(b[1][1], n ? { s: n } : l, s), c.push(encode_range_xls(x, s));
        break;
      case "PtgArea":
        x = shift_range_xls(b[1][1], l, s), c.push(encode_range_xls(x, s));
        break;
      case "PtgArea3d":
        h = /*::Number(*/
        b[1][1], x = b[1][2], E = get_ixti(a, h, s), c.push(E + "!" + encode_range_xls(x, s));
        break;
      case "PtgAttrSum":
        c.push("SUM(" + c.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        g = b[1][2];
        var R = (a.names || [])[g - 1] || (a[0] || [])[g], O = R ? R.Name : "SH33TJSNAME" + String(g);
        O && O.slice(0, 6) == "_xlfn." && !s.xlfn && (O = O.slice(6)), c.push(O);
        break;
      case "PtgNameX":
        var D = b[1][1];
        g = b[1][2];
        var k;
        if (s.biff <= 5)
          D < 0 && (D = -D), a[D] && (k = a[D][g]);
        else {
          var W = "";
          if (((a[D] || [])[0] || [])[0] == 14849 || (((a[D] || [])[0] || [])[0] == 1025 ? a[D][g] && a[D][g].itab > 0 && (W = a.SheetNames[a[D][g].itab - 1] + "!") : W = a.SheetNames[g - 1] + "!"), a[D] && a[D][g])
            W += a[D][g].Name;
          else if (a[0] && a[0][g])
            W += a[0][g].Name;
          else {
            var L = (get_ixti_raw(a, D, s) || "").split(";;");
            L[g - 1] ? W = L[g - 1] : W += "SH33TJSERRX";
          }
          c.push(W);
          break;
        }
        k || (k = { Name: "SH33TJSERRY" }), c.push(k.Name);
        break;
      case "PtgParen":
        var z = "(", P = ")";
        if (m >= 0) {
          switch (v = "", t[0][m][1][0]) {
            case 2:
              z = fill(" ", t[0][m][1][1]) + z;
              break;
            case 3:
              z = fill("\r", t[0][m][1][1]) + z;
              break;
            case 4:
              P = fill(" ", t[0][m][1][1]) + P;
              break;
            case 5:
              P = fill("\r", t[0][m][1][1]) + P;
              break;
            default:
              if (s.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + t[0][m][1][0]);
          }
          m = -1;
        }
        c.push(z + c.pop() + P);
        break;
      case "PtgRefErr":
        c.push("#REF!");
        break;
      case "PtgRefErr3d":
        c.push("#REF!");
        break;
      case "PtgExp":
        f = { c: b[1][1], r: b[1][0] };
        var Q = { c: n.c, r: n.r };
        if (a.sharedf[encode_cell(f)]) {
          var Y = a.sharedf[encode_cell(f)];
          c.push(stringify_formula(Y, l, Q, a, s));
        } else {
          var ie = !1;
          for (u = 0; u != a.arrayf.length; ++u)
            if (d = a.arrayf[u], !(f.c < d[0].s.c || f.c > d[0].e.c) && !(f.r < d[0].s.r || f.r > d[0].e.r)) {
              c.push(stringify_formula(d[1], l, Q, a, s)), ie = !0;
              break;
            }
          ie || c.push(
            /*::String(*/
            b[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        c.push("{" + stringify_array(
          /*::(*/
          b[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        m = y;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        c.push("");
        break;
      case "PtgAreaErr":
        c.push("#REF!");
        break;
      case "PtgAreaErr3d":
        c.push("#REF!");
        break;
      case "PtgList":
        c.push("Table" + b[1].idx + "[#" + b[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(b));
      default:
        throw new Error("Unrecognized Formula Token: " + String(b));
    }
    var te = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (s.biff != 3 && m >= 0 && te.indexOf(t[0][y][0]) == -1) {
      b = t[0][m];
      var Z = !0;
      switch (b[1][0]) {
        case 4:
          Z = !1;
        case 0:
          v = fill(" ", b[1][1]);
          break;
        case 5:
          Z = !1;
        case 1:
          v = fill("\r", b[1][1]);
          break;
        default:
          if (v = "", s.WTF)
            throw new Error("Unexpected PtgAttrSpaceType " + b[1][0]);
      }
      c.push((Z ? v : "") + c.pop() + (Z ? "" : v)), m = -1;
    }
  }
  if (c.length > 1 && s.WTF)
    throw new Error("bad formula stack");
  return c[0];
}
function parse_ArrayParsedFormula(t, e, n) {
  var a = t.l + e, s = n.biff == 2 ? 1 : 2, o, l = t.read_shift(s);
  if (l == 65535)
    return [[], parsenoop(t, e - 2)];
  var c = parse_Rgce(t, l, n);
  return e !== l + s && (o = parse_RgbExtra(t, e - l - s, c, n)), t.l = a, [c, o];
}
function parse_XLSCellParsedFormula(t, e, n) {
  var a = t.l + e, s = n.biff == 2 ? 1 : 2, o, l = t.read_shift(s);
  if (l == 65535)
    return [[], parsenoop(t, e - 2)];
  var c = parse_Rgce(t, l, n);
  return e !== l + s && (o = parse_RgbExtra(t, e - l - s, c, n)), t.l = a, [c, o];
}
function parse_NameParsedFormula(t, e, n, a) {
  var s = t.l + e, o = parse_Rgce(t, a, n), l;
  return s !== t.l && (l = parse_RgbExtra(t, s - t.l, o, n)), [o, l];
}
function parse_SharedParsedFormula(t, e, n) {
  var a = t.l + e, s, o = t.read_shift(2), l = parse_Rgce(t, o, n);
  return o == 65535 ? [[], parsenoop(t, e - 2)] : (e !== o + 2 && (s = parse_RgbExtra(t, a - o - 2, l, n)), [l, s]);
}
function parse_FormulaValue(t) {
  var e;
  if (__readUInt16LE(t, t.l + 6) !== 65535)
    return [parse_Xnum(t), "n"];
  switch (t[t.l]) {
    case 0:
      return t.l += 8, ["String", "s"];
    case 1:
      return e = t[t.l + 2] === 1, t.l += 8, [e, "b"];
    case 2:
      return e = t[t.l + 2], t.l += 8, [e, "e"];
    case 3:
      return t.l += 8, ["", "s"];
  }
  return [];
}
function parse_Formula(t, e, n) {
  var a = t.l + e, s = parse_XLSCell(t);
  n.biff == 2 && ++t.l;
  var o = parse_FormulaValue(t), l = t.read_shift(1);
  n.biff != 2 && (t.read_shift(1), n.biff >= 5 && t.read_shift(4));
  var c = parse_XLSCellParsedFormula(t, a - t.l, n);
  return { cell: s, val: o[0], formula: c, shared: l >> 3 & 1, tt: o[1] };
}
function parse_XLSBParsedFormula(t, e, n) {
  var a = t.read_shift(4), s = parse_Rgce(t, a, n), o = t.read_shift(4), l = o > 0 ? parse_RgbExtra(t, o, s, n) : null;
  return [s, l];
}
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula, parse_XLSBCellParsedFormula = parse_XLSBParsedFormula, parse_XLSBNameParsedFormula = parse_XLSBParsedFormula, parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula, Cetab = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, Ftab = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, FtabArgc = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function ods_to_csf_formula(t) {
  return t.slice(0, 3) == "of:" && (t = t.slice(3)), t.charCodeAt(0) == 61 && (t = t.slice(1), t.charCodeAt(0) == 61 && (t = t.slice(1))), t = t.replace(/COM\.MICROSOFT\./g, ""), t = t.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(e, n) {
    return n.replace(/\./g, "");
  }), t = t.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), t.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function ods_to_csf_3D(t) {
  var e = t.split(":"), n = e[0].split(".")[0];
  return [n, e[0].split(".")[1] + (e.length > 1 ? ":" + (e[1].split(".")[1] || e[1].split(".")[0]) : "")];
}
var strs = {}, _ssfopts = {};
function default_margins(t, e) {
  if (t) {
    var n = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    e == "xlml" && (n = [1, 1, 1, 1, 0.5, 0.5]), t.left == null && (t.left = n[0]), t.right == null && (t.right = n[1]), t.top == null && (t.top = n[2]), t.bottom == null && (t.bottom = n[3]), t.header == null && (t.header = n[4]), t.footer == null && (t.footer = n[5]);
  }
}
function safe_format(t, e, n, a, s, o) {
  try {
    a.cellNF && (t.z = table_fmt[e]);
  } catch (c) {
    if (a.WTF)
      throw c;
  }
  if (!(t.t === "z" && !a.cellStyles)) {
    if (t.t === "d" && typeof t.v == "string" && (t.v = parseDate(t.v)), (!a || a.cellText !== !1) && t.t !== "z")
      try {
        if (table_fmt[e] == null && SSF_load(SSFImplicit[e] || "General", e), t.t === "e")
          t.w = t.w || BErr[t.v];
        else if (e === 0)
          if (t.t === "n")
            (t.v | 0) === t.v ? t.w = t.v.toString(10) : t.w = SSF_general_num(t.v);
          else if (t.t === "d") {
            var l = datenum(t.v);
            (l | 0) === l ? t.w = l.toString(10) : t.w = SSF_general_num(l);
          } else {
            if (t.v === void 0)
              return "";
            t.w = SSF_general(t.v, _ssfopts);
          }
        else
          t.t === "d" ? t.w = SSF_format(e, datenum(t.v), _ssfopts) : t.w = SSF_format(e, t.v, _ssfopts);
      } catch (c) {
        if (a.WTF)
          throw c;
      }
    if (a.cellStyles && n != null)
      try {
        t.s = o.Fills[n], t.s.fgColor && t.s.fgColor.theme && !t.s.fgColor.rgb && (t.s.fgColor.rgb = rgb_tint(s.themeElements.clrScheme[t.s.fgColor.theme].rgb, t.s.fgColor.tint || 0), a.WTF && (t.s.fgColor.raw_rgb = s.themeElements.clrScheme[t.s.fgColor.theme].rgb)), t.s.bgColor && t.s.bgColor.theme && (t.s.bgColor.rgb = rgb_tint(s.themeElements.clrScheme[t.s.bgColor.theme].rgb, t.s.bgColor.tint || 0), a.WTF && (t.s.bgColor.raw_rgb = s.themeElements.clrScheme[t.s.bgColor.theme].rgb));
      } catch (c) {
        if (a.WTF && o.Fills)
          throw c;
      }
  }
}
function parse_ws_xml_dim(t, e) {
  var n = safe_decode_range(e);
  n.s.r <= n.e.r && n.s.c <= n.e.c && n.s.r >= 0 && n.s.c >= 0 && (t["!ref"] = encode_range(n));
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg, dimregex = /"(\w*:\w*)"/, colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g, afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g, sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function parse_ws_xml(t, e, n, a, s, o, l) {
  if (!t)
    return t;
  a || (a = { "!id": {} });
  var c = e.dense ? [] : {}, u = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, d = "", f = "", h = t.match(sheetdataregex);
  h ? (d = t.slice(0, h.index), f = t.slice(h.index + h[0].length)) : d = f = t;
  var g = d.match(sheetprregex);
  g ? parse_ws_xml_sheetpr(g[0], c, s, n) : (g = d.match(sheetprregex2)) && parse_ws_xml_sheetpr2(g[0], g[1] || "", c, s, n);
  var x = (d.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (x > 0) {
    var E = d.slice(x, x + 50).match(dimregex);
    E && parse_ws_xml_dim(c, E[1]);
  }
  var m = d.match(svsregex);
  m && m[1] && parse_ws_xml_sheetviews(m[1], s);
  var v = [];
  if (e.cellStyles) {
    var y = d.match(colregex);
    y && parse_ws_xml_cols(v, y);
  }
  h && parse_ws_xml_data(h[1], c, e, u, o, l);
  var A = f.match(afregex);
  A && (c["!autofilter"] = parse_ws_xml_autofilter(A[0]));
  var b = [], C = f.match(mergecregex);
  if (C)
    for (x = 0; x != C.length; ++x)
      b[x] = safe_decode_range(C[x].slice(C[x].indexOf('"') + 1));
  var T = f.match(hlinkregex);
  T && parse_ws_xml_hlinks(c, T, a);
  var w = f.match(marginregex);
  if (w && (c["!margins"] = parse_ws_xml_margins(parsexmltag(w[0]))), !c["!ref"] && u.e.c >= u.s.c && u.e.r >= u.s.r && (c["!ref"] = encode_range(u)), e.sheetRows > 0 && c["!ref"]) {
    var R = safe_decode_range(c["!ref"]);
    e.sheetRows <= +R.e.r && (R.e.r = e.sheetRows - 1, R.e.r > u.e.r && (R.e.r = u.e.r), R.e.r < R.s.r && (R.s.r = R.e.r), R.e.c > u.e.c && (R.e.c = u.e.c), R.e.c < R.s.c && (R.s.c = R.e.c), c["!fullref"] = c["!ref"], c["!ref"] = encode_range(R));
  }
  return v.length > 0 && (c["!cols"] = v), b.length > 0 && (c["!merges"] = b), c;
}
function parse_ws_xml_sheetpr(t, e, n, a) {
  var s = parsexmltag(t);
  n.Sheets[a] || (n.Sheets[a] = {}), s.codeName && (n.Sheets[a].CodeName = unescapexml(utf8read(s.codeName)));
}
function parse_ws_xml_sheetpr2(t, e, n, a, s) {
  parse_ws_xml_sheetpr(t.slice(0, t.indexOf(">")), n, a, s);
}
function parse_ws_xml_hlinks(t, e, n) {
  for (var a = Array.isArray(t), s = 0; s != e.length; ++s) {
    var o = parsexmltag(utf8read(e[s]), !0);
    if (!o.ref)
      return;
    var l = ((n || {})["!id"] || [])[o.id];
    l ? (o.Target = l.Target, o.location && (o.Target += "#" + unescapexml(o.location))) : (o.Target = "#" + unescapexml(o.location), l = { Target: o.Target, TargetMode: "Internal" }), o.Rel = l, o.tooltip && (o.Tooltip = o.tooltip, delete o.tooltip);
    for (var c = safe_decode_range(o.ref), u = c.s.r; u <= c.e.r; ++u)
      for (var d = c.s.c; d <= c.e.c; ++d) {
        var f = encode_cell({ c: d, r: u });
        a ? (t[u] || (t[u] = []), t[u][d] || (t[u][d] = { t: "z", v: void 0 }), t[u][d].l = o) : (t[f] || (t[f] = { t: "z", v: void 0 }), t[f].l = o);
      }
  }
}
function parse_ws_xml_margins(t) {
  var e = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(n) {
    t[n] && (e[n] = parseFloat(t[n]));
  }), e;
}
function parse_ws_xml_cols(t, e) {
  for (var n = !1, a = 0; a != e.length; ++a) {
    var s = parsexmltag(e[a], !0);
    s.hidden && (s.hidden = parsexmlbool(s.hidden));
    var o = parseInt(s.min, 10) - 1, l = parseInt(s.max, 10) - 1;
    for (s.outlineLevel && (s.level = +s.outlineLevel || 0), delete s.min, delete s.max, s.width = +s.width, !n && s.width && (n = !0, find_mdw_colw(s.width)), process_col(s); o <= l; )
      t[o++] = dup(s);
  }
}
function parse_ws_xml_autofilter(t) {
  var e = { ref: (t.match(/ref="([^"]*)"/) || [])[1] };
  return e;
}
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function parse_ws_xml_sheetviews(t, e) {
  e.Views || (e.Views = [{}]), (t.match(sviewregex) || []).forEach(function(n, a) {
    var s = parsexmltag(n);
    e.Views[a] || (e.Views[a] = {}), +s.zoomScale && (e.Views[a].zoom = +s.zoomScale), parsexmlbool(s.rightToLeft) && (e.Views[a].RTL = !0);
  });
}
var parse_ws_xml_data = /* @__PURE__ */ function() {
  var t = /<(?:\w+:)?c[ \/>]/, e = /<\/(?:\w+:)?row>/, n = /r=["']([^"']*)["']/, a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, s = /ref=["']([^"']*)["']/, o = matchtag("v"), l = matchtag("f");
  return function(u, d, f, h, g, x) {
    for (var E = 0, m = "", v = [], y = [], A = 0, b = 0, C = 0, T = "", w, R, O = 0, D = 0, k, W, L = 0, z = 0, P = Array.isArray(x.CellXf), Q, Y = [], ie = [], te = Array.isArray(d), Z = [], ae = {}, G = !1, U = !!f.sheetStubs, F = u.split(e), M = 0, I = F.length; M != I; ++M) {
      m = F[M].trim();
      var N = m.length;
      if (N !== 0) {
        var V = 0;
        e:
          for (E = 0; E < N; ++E)
            switch (
              /*x.charCodeAt(ri)*/
              m[E]
            ) {
              case ">":
                if (
                  /*x.charCodeAt(ri-1) != 47*/
                  m[E - 1] != "/"
                ) {
                  ++E;
                  break e;
                }
                if (f && f.cellStyles) {
                  if (R = parsexmltag(m.slice(V, E), !0), O = R.r != null ? parseInt(R.r, 10) : O + 1, D = -1, f.sheetRows && f.sheetRows < O)
                    continue;
                  ae = {}, G = !1, R.ht && (G = !0, ae.hpt = parseFloat(R.ht), ae.hpx = pt2px(ae.hpt)), R.hidden == "1" && (G = !0, ae.hidden = !0), R.outlineLevel != null && (G = !0, ae.level = +R.outlineLevel), G && (Z[O - 1] = ae);
                }
                break;
              case "<":
                V = E;
                break;
            }
        if (V >= E)
          break;
        if (R = parsexmltag(m.slice(V, E), !0), O = R.r != null ? parseInt(R.r, 10) : O + 1, D = -1, !(f.sheetRows && f.sheetRows < O)) {
          h.s.r > O - 1 && (h.s.r = O - 1), h.e.r < O - 1 && (h.e.r = O - 1), f && f.cellStyles && (ae = {}, G = !1, R.ht && (G = !0, ae.hpt = parseFloat(R.ht), ae.hpx = pt2px(ae.hpt)), R.hidden == "1" && (G = !0, ae.hidden = !0), R.outlineLevel != null && (G = !0, ae.level = +R.outlineLevel), G && (Z[O - 1] = ae)), v = m.slice(E).split(t);
          for (var q = 0; q != v.length && v[q].trim().charAt(0) == "<"; ++q)
            ;
          for (v = v.slice(q), E = 0; E != v.length; ++E)
            if (m = v[E].trim(), m.length !== 0) {
              if (y = m.match(n), A = E, b = 0, C = 0, m = "<c " + (m.slice(0, 1) == "<" ? ">" : "") + m, y != null && y.length === 2) {
                for (A = 0, T = y[1], b = 0; b != T.length && !((C = T.charCodeAt(b) - 64) < 1 || C > 26); ++b)
                  A = 26 * A + C;
                --A, D = A;
              } else
                ++D;
              for (b = 0; b != m.length && m.charCodeAt(b) !== 62; ++b)
                ;
              if (++b, R = parsexmltag(m.slice(0, b), !0), R.r || (R.r = encode_cell({ r: O - 1, c: D })), T = m.slice(b), w = { t: "" }, (y = T.match(o)) != null && /*::cref != null && */
              y[1] !== "" && (w.v = unescapexml(y[1])), f.cellFormula) {
                if ((y = T.match(l)) != null && /*::cref != null && */
                y[1] !== "") {
                  if (w.f = unescapexml(utf8read(y[1])).replace(/\r\n/g, `
`), f.xlfn || (w.f = _xlfn(w.f)), /*::cref != null && cref[0] != null && */
                  y[0].indexOf('t="array"') > -1)
                    w.F = (T.match(s) || [])[1], w.F.indexOf(":") > -1 && Y.push([safe_decode_range(w.F), w.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    y[0].indexOf('t="shared"') > -1
                  ) {
                    W = parsexmltag(y[0]);
                    var H = unescapexml(utf8read(y[1]));
                    f.xlfn || (H = _xlfn(H)), ie[parseInt(W.si, 10)] = [W, H, R.r];
                  }
                } else
                  (y = T.match(/<f[^>]*\/>/)) && (W = parsexmltag(y[0]), ie[W.si] && (w.f = shift_formula_xlsx(ie[W.si][1], ie[W.si][2], R.r)));
                var ne = decode_cell(R.r);
                for (b = 0; b < Y.length; ++b)
                  ne.r >= Y[b][0].s.r && ne.r <= Y[b][0].e.r && ne.c >= Y[b][0].s.c && ne.c <= Y[b][0].e.c && (w.F = Y[b][1]);
              }
              if (R.t == null && w.v === void 0)
                if (w.f || w.F)
                  w.v = 0, w.t = "n";
                else if (U)
                  w.t = "z";
                else
                  continue;
              else
                w.t = R.t || "n";
              switch (h.s.c > D && (h.s.c = D), h.e.c < D && (h.e.c = D), w.t) {
                case "n":
                  if (w.v == "" || w.v == null) {
                    if (!U)
                      continue;
                    w.t = "z";
                  } else
                    w.v = parseFloat(w.v);
                  break;
                case "s":
                  if (typeof w.v > "u") {
                    if (!U)
                      continue;
                    w.t = "z";
                  } else
                    k = strs[parseInt(w.v, 10)], w.v = k.t, w.r = k.r, f.cellHTML && (w.h = k.h);
                  break;
                case "str":
                  w.t = "s", w.v = w.v != null ? utf8read(w.v) : "", f.cellHTML && (w.h = escapehtml(w.v));
                  break;
                case "inlineStr":
                  y = T.match(a), w.t = "s", y != null && (k = parse_si(y[1])) ? (w.v = k.t, f.cellHTML && (w.h = k.h)) : w.v = "";
                  break;
                case "b":
                  w.v = parsexmlbool(w.v);
                  break;
                case "d":
                  f.cellDates ? w.v = parseDate(w.v, 1) : (w.v = datenum(parseDate(w.v, 1)), w.t = "n");
                  break;
                case "e":
                  (!f || f.cellText !== !1) && (w.w = w.v), w.v = RBErr[w.v];
                  break;
              }
              if (L = z = 0, Q = null, P && R.s !== void 0 && (Q = x.CellXf[R.s], Q != null && (Q.numFmtId != null && (L = Q.numFmtId), f.cellStyles && Q.fillId != null && (z = Q.fillId))), safe_format(w, L, z, f, g, x), f.cellDates && P && w.t == "n" && fmt_is_date(table_fmt[L]) && (w.t = "d", w.v = numdate(w.v)), R.cm && f.xlmeta) {
                var he = (f.xlmeta.Cell || [])[+R.cm - 1];
                he && he.type == "XLDAPR" && (w.D = !0);
              }
              if (te) {
                var j = decode_cell(R.r);
                d[j.r] || (d[j.r] = []), d[j.r][j.c] = w;
              } else
                d[R.r] = w;
            }
        }
      }
    }
    Z.length > 0 && (d["!rows"] = Z);
  };
}();
function parse_BrtRowHdr(t, e) {
  var n = {}, a = t.l + e;
  n.r = t.read_shift(4), t.l += 4;
  var s = t.read_shift(2);
  t.l += 1;
  var o = t.read_shift(1);
  return t.l = a, o & 7 && (n.level = o & 7), o & 16 && (n.hidden = !0), o & 32 && (n.hpt = s / 20), n;
}
var parse_BrtWsDim = parse_UncheckedRfX;
function parse_BrtWsFmtInfo() {
}
function parse_BrtWsProp(t, e) {
  var n = {}, a = t[t.l];
  return ++t.l, n.above = !(a & 64), n.left = !(a & 128), t.l += 18, n.name = parse_XLSBCodeName(t), n;
}
function parse_BrtCellBlank(t) {
  var e = parse_XLSBCell(t);
  return [e];
}
function parse_BrtShortBlank(t) {
  var e = parse_XLSBShortCell(t);
  return [e];
}
function parse_BrtCellBool(t) {
  var e = parse_XLSBCell(t), n = t.read_shift(1);
  return [e, n, "b"];
}
function parse_BrtShortBool(t) {
  var e = parse_XLSBShortCell(t), n = t.read_shift(1);
  return [e, n, "b"];
}
function parse_BrtCellError(t) {
  var e = parse_XLSBCell(t), n = t.read_shift(1);
  return [e, n, "e"];
}
function parse_BrtShortError(t) {
  var e = parse_XLSBShortCell(t), n = t.read_shift(1);
  return [e, n, "e"];
}
function parse_BrtCellIsst(t) {
  var e = parse_XLSBCell(t), n = t.read_shift(4);
  return [e, n, "s"];
}
function parse_BrtShortIsst(t) {
  var e = parse_XLSBShortCell(t), n = t.read_shift(4);
  return [e, n, "s"];
}
function parse_BrtCellReal(t) {
  var e = parse_XLSBCell(t), n = parse_Xnum(t);
  return [e, n, "n"];
}
function parse_BrtShortReal(t) {
  var e = parse_XLSBShortCell(t), n = parse_Xnum(t);
  return [e, n, "n"];
}
function parse_BrtCellRk(t) {
  var e = parse_XLSBCell(t), n = parse_RkNumber(t);
  return [e, n, "n"];
}
function parse_BrtShortRk(t) {
  var e = parse_XLSBShortCell(t), n = parse_RkNumber(t);
  return [e, n, "n"];
}
function parse_BrtCellRString(t) {
  var e = parse_XLSBCell(t), n = parse_RichStr(t);
  return [e, n, "is"];
}
function parse_BrtCellSt(t) {
  var e = parse_XLSBCell(t), n = parse_XLWideString(t);
  return [e, n, "str"];
}
function parse_BrtShortSt(t) {
  var e = parse_XLSBShortCell(t), n = parse_XLWideString(t);
  return [e, n, "str"];
}
function parse_BrtFmlaBool(t, e, n) {
  var a = t.l + e, s = parse_XLSBCell(t);
  s.r = n["!row"];
  var o = t.read_shift(1), l = [s, o, "b"];
  if (n.cellFormula) {
    t.l += 2;
    var c = parse_XLSBCellParsedFormula(t, a - t.l, n);
    l[3] = stringify_formula(c, null, s, n.supbooks, n);
  } else
    t.l = a;
  return l;
}
function parse_BrtFmlaError(t, e, n) {
  var a = t.l + e, s = parse_XLSBCell(t);
  s.r = n["!row"];
  var o = t.read_shift(1), l = [s, o, "e"];
  if (n.cellFormula) {
    t.l += 2;
    var c = parse_XLSBCellParsedFormula(t, a - t.l, n);
    l[3] = stringify_formula(c, null, s, n.supbooks, n);
  } else
    t.l = a;
  return l;
}
function parse_BrtFmlaNum(t, e, n) {
  var a = t.l + e, s = parse_XLSBCell(t);
  s.r = n["!row"];
  var o = parse_Xnum(t), l = [s, o, "n"];
  if (n.cellFormula) {
    t.l += 2;
    var c = parse_XLSBCellParsedFormula(t, a - t.l, n);
    l[3] = stringify_formula(c, null, s, n.supbooks, n);
  } else
    t.l = a;
  return l;
}
function parse_BrtFmlaString(t, e, n) {
  var a = t.l + e, s = parse_XLSBCell(t);
  s.r = n["!row"];
  var o = parse_XLWideString(t), l = [s, o, "str"];
  if (n.cellFormula) {
    t.l += 2;
    var c = parse_XLSBCellParsedFormula(t, a - t.l, n);
    l[3] = stringify_formula(c, null, s, n.supbooks, n);
  } else
    t.l = a;
  return l;
}
var parse_BrtMergeCell = parse_UncheckedRfX;
function parse_BrtHLink(t, e) {
  var n = t.l + e, a = parse_UncheckedRfX(t), s = parse_XLNullableWideString(t), o = parse_XLWideString(t), l = parse_XLWideString(t), c = parse_XLWideString(t);
  t.l = n;
  var u = { rfx: a, relId: s, loc: o, display: c };
  return l && (u.Tooltip = l), u;
}
function parse_BrtPane() {
}
function parse_BrtArrFmla(t, e, n) {
  var a = t.l + e, s = parse_RfX(t), o = t.read_shift(1), l = [s];
  if (l[2] = o, n.cellFormula) {
    var c = parse_XLSBArrayParsedFormula(t, a - t.l, n);
    l[1] = c;
  } else
    t.l = a;
  return l;
}
function parse_BrtShrFmla(t, e, n) {
  var a = t.l + e, s = parse_UncheckedRfX(t), o = [s];
  if (n.cellFormula) {
    var l = parse_XLSBSharedParsedFormula(t, a - t.l, n);
    o[1] = l, t.l = a;
  } else
    t.l = a;
  return o;
}
var BrtMarginKeys = ["left", "right", "top", "bottom", "header", "footer"];
function parse_BrtMargins(t) {
  var e = {};
  return BrtMarginKeys.forEach(function(n) {
    e[n] = parse_Xnum(t);
  }), e;
}
function parse_BrtBeginWsView(t) {
  var e = t.read_shift(2);
  return t.l += 28, { RTL: e & 32 };
}
function parse_BrtDVal() {
}
function parse_BrtDVal14() {
}
function parse_ws_bin(t, e, n, a, s, o, l) {
  if (!t)
    return t;
  var c = e || {};
  a || (a = { "!id": {} });
  var u = c.dense ? [] : {}, d, f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, h = !1, g = !1, x, E, m, v, y, A, b, C, T, w = [];
  c.biff = 12, c["!row"] = 0;
  var R = 0, O = !1, D = [], k = {}, W = c.supbooks || /*::(*/
  s.supbooks || [[]];
  if (W.sharedf = k, W.arrayf = D, W.SheetNames = s.SheetNames || s.Sheets.map(function(te) {
    return te.name;
  }), !c.supbooks && (c.supbooks = W, s.Names))
    for (var L = 0; L < s.Names.length; ++L)
      W[0][L + 1] = s.Names[L];
  var z = [], P = [], Q = !1;
  XLSBRecordEnum[16] = { n: "BrtShortReal", f: parse_BrtShortReal };
  var Y;
  if (recordhopper(t, function(Z, ae, G) {
    if (!g)
      switch (G) {
        case 148:
          d = Z;
          break;
        case 0:
          x = Z, c.sheetRows && c.sheetRows <= x.r && (g = !0), C = encode_row(v = x.r), c["!row"] = x.r, (Z.hidden || Z.hpt || Z.level != null) && (Z.hpt && (Z.hpx = pt2px(Z.hpt)), P[Z.r] = Z);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 62:
          switch (E = { t: Z[2] }, Z[2]) {
            case "n":
              E.v = Z[1];
              break;
            case "s":
              b = strs[Z[1]], E.v = b.t, E.r = b.r;
              break;
            case "b":
              E.v = !!Z[1];
              break;
            case "e":
              E.v = Z[1], c.cellText !== !1 && (E.w = BErr[E.v]);
              break;
            case "str":
              E.t = "s", E.v = Z[1];
              break;
            case "is":
              E.t = "s", E.v = Z[1].t;
              break;
          }
          if ((m = l.CellXf[Z[0].iStyleRef]) && safe_format(E, m.numFmtId, null, c, o, l), y = Z[0].c == -1 ? y + 1 : Z[0].c, c.dense ? (u[v] || (u[v] = []), u[v][y] = E) : u[encode_col(y) + C] = E, c.cellFormula) {
            for (O = !1, R = 0; R < D.length; ++R) {
              var U = D[R];
              x.r >= U[0].s.r && x.r <= U[0].e.r && y >= U[0].s.c && y <= U[0].e.c && (E.F = encode_range(U[0]), O = !0);
            }
            !O && Z.length > 3 && (E.f = Z[3]);
          }
          if (f.s.r > x.r && (f.s.r = x.r), f.s.c > y && (f.s.c = y), f.e.r < x.r && (f.e.r = x.r), f.e.c < y && (f.e.c = y), c.cellDates && m && E.t == "n" && fmt_is_date(table_fmt[m.numFmtId])) {
            var F = SSF_parse_date_code(E.v);
            F && (E.t = "d", E.v = new Date(F.y, F.m - 1, F.d, F.H, F.M, F.S, F.u));
          }
          Y && (Y.type == "XLDAPR" && (E.D = !0), Y = void 0);
          break;
        case 1:
        case 12:
          if (!c.sheetStubs || h)
            break;
          E = { t: "z", v: void 0 }, y = Z[0].c == -1 ? y + 1 : Z[0].c, c.dense ? (u[v] || (u[v] = []), u[v][y] = E) : u[encode_col(y) + C] = E, f.s.r > x.r && (f.s.r = x.r), f.s.c > y && (f.s.c = y), f.e.r < x.r && (f.e.r = x.r), f.e.c < y && (f.e.c = y), Y && (Y.type == "XLDAPR" && (E.D = !0), Y = void 0);
          break;
        case 176:
          w.push(Z);
          break;
        case 49:
          Y = ((c.xlmeta || {}).Cell || [])[Z - 1];
          break;
        case 494:
          var M = a["!id"][Z.relId];
          for (M ? (Z.Target = M.Target, Z.loc && (Z.Target += "#" + Z.loc), Z.Rel = M) : Z.relId == "" && (Z.Target = "#" + Z.loc), v = Z.rfx.s.r; v <= Z.rfx.e.r; ++v)
            for (y = Z.rfx.s.c; y <= Z.rfx.e.c; ++y)
              c.dense ? (u[v] || (u[v] = []), u[v][y] || (u[v][y] = { t: "z", v: void 0 }), u[v][y].l = Z) : (A = encode_cell({ c: y, r: v }), u[A] || (u[A] = { t: "z", v: void 0 }), u[A].l = Z);
          break;
        case 426:
          if (!c.cellFormula)
            break;
          D.push(Z), T = c.dense ? u[v][y] : u[encode_col(y) + C], T.f = stringify_formula(Z[1], f, { r: x.r, c: y }, W, c), T.F = encode_range(Z[0]);
          break;
        case 427:
          if (!c.cellFormula)
            break;
          k[encode_cell(Z[0].s)] = Z[1], T = c.dense ? u[v][y] : u[encode_col(y) + C], T.f = stringify_formula(Z[1], f, { r: x.r, c: y }, W, c);
          break;
        case 60:
          if (!c.cellStyles)
            break;
          for (; Z.e >= Z.s; )
            z[Z.e--] = { width: Z.w / 256, hidden: !!(Z.flags & 1), level: Z.level }, Q || (Q = !0, find_mdw_colw(Z.w / 256)), process_col(z[Z.e + 1]);
          break;
        case 161:
          u["!autofilter"] = { ref: encode_range(Z) };
          break;
        case 476:
          u["!margins"] = Z;
          break;
        case 147:
          s.Sheets[n] || (s.Sheets[n] = {}), Z.name && (s.Sheets[n].CodeName = Z.name), (Z.above || Z.left) && (u["!outline"] = { above: Z.above, left: Z.left });
          break;
        case 137:
          s.Views || (s.Views = [{}]), s.Views[0] || (s.Views[0] = {}), Z.RTL && (s.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        case 1053:
          break;
        case 151:
          break;
        case 152:
        case 175:
        case 644:
        case 625:
        case 562:
        case 396:
        case 1112:
        case 1146:
        case 471:
        case 1050:
        case 649:
        case 1105:
        case 589:
        case 607:
        case 564:
        case 1055:
        case 168:
        case 174:
        case 1180:
        case 499:
        case 507:
        case 550:
        case 171:
        case 167:
        case 1177:
        case 169:
        case 1181:
        case 551:
        case 552:
        case 661:
        case 639:
        case 478:
        case 537:
        case 477:
        case 536:
        case 1103:
        case 680:
        case 1104:
        case 1024:
        case 663:
        case 535:
        case 678:
        case 504:
        case 1043:
        case 428:
        case 170:
        case 3072:
        case 50:
        case 2070:
        case 1045:
          break;
        case 35:
          h = !0;
          break;
        case 36:
          h = !1;
          break;
        case 37:
          h = !0;
          break;
        case 38:
          h = !1;
          break;
        default:
          if (!ae.T) {
            if (!h || c.WTF)
              throw new Error("Unexpected record 0x" + G.toString(16));
          }
      }
  }, c), delete c.supbooks, delete c["!row"], !u["!ref"] && (f.s.r < 2e6 || d && (d.e.r > 0 || d.e.c > 0 || d.s.r > 0 || d.s.c > 0)) && (u["!ref"] = encode_range(d || f)), c.sheetRows && u["!ref"]) {
    var ie = safe_decode_range(u["!ref"]);
    c.sheetRows <= +ie.e.r && (ie.e.r = c.sheetRows - 1, ie.e.r > f.e.r && (ie.e.r = f.e.r), ie.e.r < ie.s.r && (ie.s.r = ie.e.r), ie.e.c > f.e.c && (ie.e.c = f.e.c), ie.e.c < ie.s.c && (ie.s.c = ie.e.c), u["!fullref"] = u["!ref"], u["!ref"] = encode_range(ie));
  }
  return w.length > 0 && (u["!merges"] = w), z.length > 0 && (u["!cols"] = z), P.length > 0 && (u["!rows"] = P), u;
}
function parse_Cache(t) {
  var e = [], n = t.match(/^<c:numCache>/), a;
  (t.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(o) {
    var l = o.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    l && (e[+l[1]] = n ? +l[2] : l[2]);
  });
  var s = unescapexml((t.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (t.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(o) {
    a = o.replace(/<.*?>/g, "");
  }), [e, s, a];
}
function parse_chart(t, e, n, a, s, o) {
  var l = o || { "!type": "chart" };
  if (!t)
    return o;
  var c = 0, u = 0, d = "A", f = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (t.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(h) {
    var g = parse_Cache(h);
    f.s.r = f.s.c = 0, f.e.c = c, d = encode_col(c), g[0].forEach(function(x, E) {
      l[d + encode_row(E)] = { t: "n", v: x, z: g[1] }, u = E;
    }), f.e.r < u && (f.e.r = u), ++c;
  }), c > 0 && (l["!ref"] = encode_range(f)), l;
}
function parse_cs_xml(t, e, n, a, s) {
  if (!t)
    return t;
  a || (a = { "!id": {} });
  var o = { "!type": "chart", "!drawel": null, "!rel": "" }, l, c = t.match(sheetprregex);
  return c && parse_ws_xml_sheetpr(c[0], o, s, n), (l = t.match(/drawing r:id="(.*?)"/)) && (o["!rel"] = l[1]), a["!id"][o["!rel"]] && (o["!drawel"] = a["!id"][o["!rel"]]), o;
}
function parse_BrtCsProp(t, e) {
  t.l += 10;
  var n = parse_XLWideString(t);
  return { name: n };
}
function parse_cs_bin(t, e, n, a, s) {
  if (!t)
    return t;
  a || (a = { "!id": {} });
  var o = { "!type": "chart", "!drawel": null, "!rel": "" }, l = !1;
  return recordhopper(t, function(u, d, f) {
    switch (f) {
      case 550:
        o["!rel"] = u;
        break;
      case 651:
        s.Sheets[n] || (s.Sheets[n] = {}), u.name && (s.Sheets[n].CodeName = u.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        l = !0;
        break;
      case 36:
        l = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(d.T > 0)) {
          if (!(d.T < 0)) {
            if (!l || e.WTF)
              throw new Error("Unexpected record 0x" + f.toString(16));
          }
        }
    }
  }, e), a["!id"][o["!rel"]] && (o["!drawel"] = a["!id"][o["!rel"]]), o;
}
var WBPropsDef = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], WBViewDef = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], SheetDef = [
  //['state', 'visible']
], CalcPrDef = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function push_defaults_array(t, e) {
  for (var n = 0; n != t.length; ++n)
    for (var a = t[n], s = 0; s != e.length; ++s) {
      var o = e[s];
      if (a[o[0]] == null)
        a[o[0]] = o[1];
      else
        switch (o[2]) {
          case "bool":
            typeof a[o[0]] == "string" && (a[o[0]] = parsexmlbool(a[o[0]]));
            break;
          case "int":
            typeof a[o[0]] == "string" && (a[o[0]] = parseInt(a[o[0]], 10));
            break;
        }
    }
}
function push_defaults(t, e) {
  for (var n = 0; n != e.length; ++n) {
    var a = e[n];
    if (t[a[0]] == null)
      t[a[0]] = a[1];
    else
      switch (a[2]) {
        case "bool":
          typeof t[a[0]] == "string" && (t[a[0]] = parsexmlbool(t[a[0]]));
          break;
        case "int":
          typeof t[a[0]] == "string" && (t[a[0]] = parseInt(t[a[0]], 10));
          break;
      }
  }
}
function parse_wb_defaults(t) {
  push_defaults(t.WBProps, WBPropsDef), push_defaults(t.CalcPr, CalcPrDef), push_defaults_array(t.WBView, WBViewDef), push_defaults_array(t.Sheets, SheetDef), _ssfopts.date1904 = parsexmlbool(t.WBProps.date1904);
}
var badchars = /* @__PURE__ */ "][*?/\\".split("");
function check_ws_name(t, e) {
  if (t.length > 31) {
    if (e)
      return !1;
    throw new Error("Sheet names cannot exceed 31 chars");
  }
  var n = !0;
  return badchars.forEach(function(a) {
    if (t.indexOf(a) != -1) {
      if (!e)
        throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
      n = !1;
    }
  }), n;
}
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(t, e) {
  if (!t)
    throw new Error("Could not find file");
  var n = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), a = !1, s = "xmlns", o = {}, l = 0;
  if (t.replace(tagregex, function(u, d) {
    var f = parsexmltag(u);
    switch (strip_ns(f[0])) {
      case "<?xml":
        break;
      case "<workbook":
        u.match(wbnsregex) && (s = "xmlns" + u.match(/<(\w+):/)[1]), n.xmlns = f[s];
        break;
      case "</workbook>":
        break;
      case "<fileVersion":
        delete f[0], n.AppVersion = f;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      case "<workbookPr":
      case "<workbookPr/>":
        WBPropsDef.forEach(function(h) {
          if (f[h[0]] != null)
            switch (h[2]) {
              case "bool":
                n.WBProps[h[0]] = parsexmlbool(f[h[0]]);
                break;
              case "int":
                n.WBProps[h[0]] = parseInt(f[h[0]], 10);
                break;
              default:
                n.WBProps[h[0]] = f[h[0]];
            }
        }), f.codeName && (n.WBProps.CodeName = utf8read(f.codeName));
        break;
      case "</workbookPr>":
        break;
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      case "<workbookView":
      case "<workbookView/>":
        delete f[0], n.WBView.push(f);
        break;
      case "</workbookView>":
        break;
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      case "<sheet":
        switch (f.state) {
          case "hidden":
            f.Hidden = 1;
            break;
          case "veryHidden":
            f.Hidden = 2;
            break;
          default:
            f.Hidden = 0;
        }
        delete f.state, f.name = unescapexml(utf8read(f.name)), delete f[0], n.Sheets.push(f);
        break;
      case "</sheet>":
        break;
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      case "<functionGroup":
        break;
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      case "<externalReference":
        break;
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        a = !0;
        break;
      case "</definedNames>":
        a = !1;
        break;
      case "<definedName":
        o = {}, o.Name = utf8read(f.name), f.comment && (o.Comment = f.comment), f.localSheetId && (o.Sheet = +f.localSheetId), parsexmlbool(f.hidden || "0") && (o.Hidden = !0), l = d + u.length;
        break;
      case "</definedName>":
        o.Ref = unescapexml(utf8read(t.slice(l, d))), n.Names.push(o);
        break;
      case "<definedName/>":
        break;
      case "<calcPr":
        delete f[0], n.CalcPr = f;
        break;
      case "<calcPr/>":
        delete f[0], n.CalcPr = f;
        break;
      case "</calcPr>":
        break;
      case "<oleSize":
        break;
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      case "<pivotCache":
        break;
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      case "<smartTagType":
        break;
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      case "<webPublishObject":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        a = !0;
        break;
      case "</AlternateContent>":
        a = !1;
        break;
      case "<revisionPtr":
        break;
      default:
        if (!a && e.WTF)
          throw new Error("unrecognized " + f[0] + " in workbook");
    }
    return u;
  }), XMLNS_main.indexOf(n.xmlns) === -1)
    throw new Error("Unknown Namespace: " + n.xmlns);
  return parse_wb_defaults(n), n;
}
function parse_BrtBundleSh(t, e) {
  var n = {};
  return n.Hidden = t.read_shift(4), n.iTabID = t.read_shift(4), n.strRelID = parse_RelID(t), n.name = parse_XLWideString(t), n;
}
function parse_BrtWbProp(t, e) {
  var n = {}, a = t.read_shift(4);
  n.defaultThemeVersion = t.read_shift(4);
  var s = e > 8 ? parse_XLWideString(t) : "";
  return s.length > 0 && (n.CodeName = s), n.autoCompressPictures = !!(a & 65536), n.backupFile = !!(a & 64), n.checkCompatibility = !!(a & 4096), n.date1904 = !!(a & 1), n.filterPrivacy = !!(a & 8), n.hidePivotFieldList = !!(a & 1024), n.promptedSolutions = !!(a & 16), n.publishItems = !!(a & 2048), n.refreshAllConnections = !!(a & 262144), n.saveExternalLinkValues = !!(a & 128), n.showBorderUnselectedTables = !!(a & 4), n.showInkAnnotation = !!(a & 32), n.showObjects = ["all", "placeholders", "none"][a >> 13 & 3], n.showPivotChartFilter = !!(a & 32768), n.updateLinks = ["userSet", "never", "always"][a >> 8 & 3], n;
}
function parse_BrtFRTArchID$(t, e) {
  var n = {};
  return t.read_shift(4), n.ArchID = t.read_shift(4), t.l += e - 8, n;
}
function parse_BrtName(t, e, n) {
  var a = t.l + e;
  t.l += 4, t.l += 1;
  var s = t.read_shift(4), o = parse_XLNameWideString(t), l = parse_XLSBNameParsedFormula(t, 0, n), c = parse_XLNullableWideString(t);
  t.l = a;
  var u = { Name: o, Ptg: l };
  return s < 268435455 && (u.Sheet = s), c && (u.Comment = c), u;
}
function parse_wb_bin(t, e) {
  var n = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, a = [], s = !1;
  e || (e = {}), e.biff = 12;
  var o = [], l = [[]];
  return l.SheetNames = [], l.XTI = [], XLSBRecordEnum[16] = { n: "BrtFRTArchID$", f: parse_BrtFRTArchID$ }, recordhopper(t, function(u, d, f) {
    switch (f) {
      case 156:
        l.SheetNames.push(u.name), n.Sheets.push(u);
        break;
      case 153:
        n.WBProps = u;
        break;
      case 39:
        u.Sheet != null && (e.SID = u.Sheet), u.Ref = stringify_formula(u.Ptg, null, null, l, e), delete e.SID, delete u.Ptg, o.push(u);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        l[0].length ? l.push([f, u]) : l[0] = [f, u], l[l.length - 1].XTI = [];
        break;
      case 362:
        l.length === 0 && (l[0] = [], l[0].XTI = []), l[l.length - 1].XTI = l[l.length - 1].XTI.concat(u), l.XTI = l.XTI.concat(u);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        a.push(f), s = !0;
        break;
      case 36:
        a.pop(), s = !1;
        break;
      case 37:
        a.push(f), s = !0;
        break;
      case 38:
        a.pop(), s = !1;
        break;
      case 16:
        break;
      default:
        if (!d.T) {
          if (!s || e.WTF && a[a.length - 1] != 37 && a[a.length - 1] != 35)
            throw new Error("Unexpected record 0x" + f.toString(16));
        }
    }
  }, e), parse_wb_defaults(n), n.Names = o, n.supbooks = l, n;
}
function parse_wb(t, e, n) {
  return e.slice(-4) === ".bin" ? parse_wb_bin(t, n) : parse_wb_xml(t, n);
}
function parse_ws(t, e, n, a, s, o, l, c) {
  return e.slice(-4) === ".bin" ? parse_ws_bin(t, a, n, s, o, l, c) : parse_ws_xml(t, a, n, s, o, l, c);
}
function parse_cs(t, e, n, a, s, o, l, c) {
  return e.slice(-4) === ".bin" ? parse_cs_bin(t, a, n, s, o) : parse_cs_xml(t, a, n, s, o);
}
function parse_ms(t, e, n, a, s, o, l, c) {
  return e.slice(-4) === ".bin" ? parse_ms_bin() : parse_ms_xml();
}
function parse_ds(t, e, n, a, s, o, l, c) {
  return e.slice(-4) === ".bin" ? parse_ds_bin() : parse_ds_xml();
}
function parse_sty(t, e, n, a) {
  return e.slice(-4) === ".bin" ? parse_sty_bin(t, n, a) : parse_sty_xml(t, n, a);
}
function parse_theme(t, e, n) {
  return parse_theme_xml(t, n);
}
function parse_sst(t, e, n) {
  return e.slice(-4) === ".bin" ? parse_sst_bin(t, n) : parse_sst_xml(t, n);
}
function parse_cmnt(t, e, n) {
  return e.slice(-4) === ".bin" ? parse_comments_bin(t, n) : parse_comments_xml(t, n);
}
function parse_cc(t, e, n) {
  return e.slice(-4) === ".bin" ? parse_cc_bin(t) : parse_cc_xml(t);
}
function parse_xlink(t, e, n, a) {
  return n.slice(-4) === ".bin" ? parse_xlink_bin(t, e, n, a) : void 0;
}
function parse_xlmeta(t, e, n) {
  return e.slice(-4) === ".bin" ? parse_xlmeta_bin(t, e, n) : parse_xlmeta_xml(t, e, n);
}
var attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(t, e) {
  var n = t.split(/\s+/), a = [];
  if (e || (a[0] = n[0]), n.length === 1)
    return a;
  var s = t.match(attregexg2), o, l, c, u;
  if (s)
    for (u = 0; u != s.length; ++u)
      o = s[u].match(attregex2), (l = o[1].indexOf(":")) === -1 ? a[o[1]] = o[2].slice(1, o[2].length - 1) : (o[1].slice(0, 6) === "xmlns:" ? c = "xmlns" + o[1].slice(6) : c = o[1].slice(l + 1), a[c] = o[2].slice(1, o[2].length - 1));
  return a;
}
function xlml_parsexmltagobj(t) {
  var e = t.split(/\s+/), n = {};
  if (e.length === 1)
    return n;
  var a = t.match(attregexg2), s, o, l, c;
  if (a)
    for (c = 0; c != a.length; ++c)
      s = a[c].match(attregex2), (o = s[1].indexOf(":")) === -1 ? n[s[1]] = s[2].slice(1, s[2].length - 1) : (s[1].slice(0, 6) === "xmlns:" ? l = "xmlns" + s[1].slice(6) : l = s[1].slice(o + 1), n[l] = s[2].slice(1, s[2].length - 1));
  return n;
}
var XLMLFormatMap;
function xlml_format(t, e) {
  var n = XLMLFormatMap[t] || unescapexml(t);
  return n === "General" ? SSF_general(e) : SSF_format(n, e);
}
function xlml_set_custprop(t, e, n, a) {
  var s = a;
  switch ((n[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      s = parsexmlbool(a);
      break;
    case "i2":
    case "int":
      s = parseInt(a, 10);
      break;
    case "r4":
    case "float":
      s = parseFloat(a);
      break;
    case "date":
    case "dateTime.tz":
      s = parseDate(a);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + n[0]);
  }
  t[unescapexml(e)] = s;
}
function safe_format_xlml(t, e, n) {
  if (t.t !== "z") {
    if (!n || n.cellText !== !1)
      try {
        t.t === "e" ? t.w = t.w || BErr[t.v] : e === "General" ? t.t === "n" ? (t.v | 0) === t.v ? t.w = t.v.toString(10) : t.w = SSF_general_num(t.v) : t.w = SSF_general(t.v) : t.w = xlml_format(e || "General", t.v);
      } catch (o) {
        if (n.WTF)
          throw o;
      }
    try {
      var a = XLMLFormatMap[e] || e || "General";
      if (n.cellNF && (t.z = a), n.cellDates && t.t == "n" && fmt_is_date(a)) {
        var s = SSF_parse_date_code(t.v);
        s && (t.t = "d", t.v = new Date(s.y, s.m - 1, s.d, s.H, s.M, s.S, s.u));
      }
    } catch (o) {
      if (n.WTF)
        throw o;
    }
  }
}
function process_style_xlml(t, e, n) {
  if (n.cellStyles && e.Interior) {
    var a = e.Interior;
    a.Pattern && (a.patternType = XLMLPatternTypeMap[a.Pattern] || a.Pattern);
  }
  t[e.ID] = e;
}
function parse_xlml_data(t, e, n, a, s, o, l, c, u, d) {
  var f = "General", h = a.StyleID, g = {};
  d = d || {};
  var x = [], E = 0;
  for (h === void 0 && c && (h = c.StyleID), h === void 0 && l && (h = l.StyleID); o[h] !== void 0 && (o[h].nf && (f = o[h].nf), o[h].Interior && x.push(o[h].Interior), !!o[h].Parent); )
    h = o[h].Parent;
  switch (n.Type) {
    case "Boolean":
      a.t = "b", a.v = parsexmlbool(t);
      break;
    case "String":
      a.t = "s", a.r = xlml_fixstr(unescapexml(t)), a.v = t.indexOf("<") > -1 ? unescapexml(e || t).replace(/<.*?>/g, "") : a.r;
      break;
    case "DateTime":
      t.slice(-1) != "Z" && (t += "Z"), a.v = (parseDate(t) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3), a.v !== a.v ? a.v = unescapexml(t) : a.v < 60 && (a.v = a.v - 1), (!f || f == "General") && (f = "yyyy-mm-dd");
    case "Number":
      a.v === void 0 && (a.v = +t), a.t || (a.t = "n");
      break;
    case "Error":
      a.t = "e", a.v = RBErr[t], d.cellText !== !1 && (a.w = t);
      break;
    default:
      t == "" && e == "" ? a.t = "z" : (a.t = "s", a.v = xlml_fixstr(e || t));
      break;
  }
  if (safe_format_xlml(a, f, d), d.cellFormula !== !1)
    if (a.Formula) {
      var m = unescapexml(a.Formula);
      m.charCodeAt(0) == 61 && (m = m.slice(1)), a.f = rc_to_a1(m, s), delete a.Formula, a.ArrayRange == "RC" ? a.F = rc_to_a1("RC:RC", s) : a.ArrayRange && (a.F = rc_to_a1(a.ArrayRange, s), u.push([safe_decode_range(a.F), a.F]));
    } else
      for (E = 0; E < u.length; ++E)
        s.r >= u[E][0].s.r && s.r <= u[E][0].e.r && s.c >= u[E][0].s.c && s.c <= u[E][0].e.c && (a.F = u[E][1]);
  d.cellStyles && (x.forEach(function(v) {
    !g.patternType && v.patternType && (g.patternType = v.patternType);
  }), a.s = g), a.StyleID !== void 0 && (a.ixfe = a.StyleID);
}
function xlml_clean_comment(t) {
  t.t = t.v || "", t.t = t.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), t.v = t.w = t.ixfe = void 0;
}
function parse_xlml_xml(t, e) {
  var n = e || {};
  make_ssf();
  var a = debom(xlml_normalize(t));
  (n.type == "binary" || n.type == "array" || n.type == "base64") && (a = utf8read(a));
  var s = a.slice(0, 1024).toLowerCase(), o = !1;
  if (s = s.replace(/".*?"/g, ""), (s.indexOf(">") & 1023) > Math.min(s.indexOf(",") & 1023, s.indexOf(";") & 1023)) {
    var l = dup(n);
    return l.type = "string", PRN.to_workbook(a, l);
  }
  if (s.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(_e) {
    s.indexOf("<" + _e) >= 0 && (o = !0);
  }), o)
    return html_to_workbook(a, n);
  XLMLFormatMap = {
    "General Number": "General",
    "General Date": table_fmt[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": table_fmt[15],
    "Short Date": table_fmt[14],
    "Long Time": table_fmt[19],
    "Medium Time": table_fmt[18],
    "Short Time": table_fmt[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: table_fmt[2],
    Standard: table_fmt[4],
    Percent: table_fmt[10],
    Scientific: table_fmt[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var c, u = [], d, f = {}, h = [], g = n.dense ? [] : {}, x = "", E = {}, m = {}, v = xlml_parsexmltag('<Data ss:Type="String">'), y = 0, A = 0, b = 0, C = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, T = {}, w = {}, R = "", O = 0, D = [], k = {}, W = {}, L = 0, z = [], P = [], Q = {}, Y = [], ie, te = !1, Z = [], ae = [], G = {}, U = 0, F = 0, M = { Sheets: [], WBProps: { date1904: !1 } }, I = {};
  xlmlregex.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var N = ""; c = xlmlregex.exec(a); )
    switch (c[3] = (N = c[3]).toLowerCase()) {
      case "data":
        if (N == "data") {
          if (c[1] === "/") {
            if ((d = u.pop())[0] !== c[3])
              throw new Error("Bad state: " + d.join("|"));
          } else
            c[0].charAt(c[0].length - 2) !== "/" && u.push([c[3], !0]);
          break;
        }
        if (u[u.length - 1][1])
          break;
        c[1] === "/" ? parse_xlml_data(a.slice(y, c.index), R, v, u[u.length - 1][0] == /*"Comment"*/
        "comment" ? Q : E, { c: A, r: b }, T, Y[A], m, Z, n) : (R = "", v = xlml_parsexmltag(c[0]), y = c.index + c[0].length);
        break;
      case "cell":
        if (c[1] === "/")
          if (P.length > 0 && (E.c = P), (!n.sheetRows || n.sheetRows > b) && E.v !== void 0 && (n.dense ? (g[b] || (g[b] = []), g[b][A] = E) : g[encode_col(A) + encode_row(b)] = E), E.HRef && (E.l = { Target: unescapexml(E.HRef) }, E.HRefScreenTip && (E.l.Tooltip = E.HRefScreenTip), delete E.HRef, delete E.HRefScreenTip), (E.MergeAcross || E.MergeDown) && (U = A + (parseInt(E.MergeAcross, 10) | 0), F = b + (parseInt(E.MergeDown, 10) | 0), D.push({ s: { c: A, r: b }, e: { c: U, r: F } })), !n.sheetStubs)
            E.MergeAcross ? A = U + 1 : ++A;
          else if (E.MergeAcross || E.MergeDown) {
            for (var V = A; V <= U; ++V)
              for (var q = b; q <= F; ++q)
                (V > A || q > b) && (n.dense ? (g[q] || (g[q] = []), g[q][V] = { t: "z" }) : g[encode_col(V) + encode_row(q)] = { t: "z" });
            A = U + 1;
          } else
            ++A;
        else
          E = xlml_parsexmltagobj(c[0]), E.Index && (A = +E.Index - 1), A < C.s.c && (C.s.c = A), A > C.e.c && (C.e.c = A), c[0].slice(-2) === "/>" && ++A, P = [];
        break;
      case "row":
        c[1] === "/" || c[0].slice(-2) === "/>" ? (b < C.s.r && (C.s.r = b), b > C.e.r && (C.e.r = b), c[0].slice(-2) === "/>" && (m = xlml_parsexmltag(c[0]), m.Index && (b = +m.Index - 1)), A = 0, ++b) : (m = xlml_parsexmltag(c[0]), m.Index && (b = +m.Index - 1), G = {}, (m.AutoFitHeight == "0" || m.Height) && (G.hpx = parseInt(m.Height, 10), G.hpt = px2pt(G.hpx), ae[b] = G), m.Hidden == "1" && (G.hidden = !0, ae[b] = G));
        break;
      case "worksheet":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
          h.push(x), C.s.r <= C.e.r && C.s.c <= C.e.c && (g["!ref"] = encode_range(C), n.sheetRows && n.sheetRows <= C.e.r && (g["!fullref"] = g["!ref"], C.e.r = n.sheetRows - 1, g["!ref"] = encode_range(C))), D.length && (g["!merges"] = D), Y.length > 0 && (g["!cols"] = Y), ae.length > 0 && (g["!rows"] = ae), f[x] = g;
        } else
          C = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, b = A = 0, u.push([c[3], !1]), d = xlml_parsexmltag(c[0]), x = unescapexml(d.Name), g = n.dense ? [] : {}, D = [], Z = [], ae = [], I = { name: x, Hidden: 0 }, M.Sheets.push(I);
        break;
      case "table":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
        } else {
          if (c[0].slice(-2) == "/>")
            break;
          u.push([c[3], !1]), Y = [], te = !1;
        }
        break;
      case "style":
        c[1] === "/" ? process_style_xlml(T, w, n) : w = xlml_parsexmltag(c[0]);
        break;
      case "numberformat":
        w.nf = unescapexml(xlml_parsexmltag(c[0]).Format || "General"), XLMLFormatMap[w.nf] && (w.nf = XLMLFormatMap[w.nf]);
        for (var H = 0; H != 392 && table_fmt[H] != w.nf; ++H)
          ;
        if (H == 392) {
          for (H = 57; H != 392; ++H)
            if (table_fmt[H] == null) {
              SSF_load(w.nf, H);
              break;
            }
        }
        break;
      case "column":
        if (u[u.length - 1][0] !== /*'Table'*/
        "table")
          break;
        if (ie = xlml_parsexmltag(c[0]), ie.Hidden && (ie.hidden = !0, delete ie.Hidden), ie.Width && (ie.wpx = parseInt(ie.Width, 10)), !te && ie.wpx > 10) {
          te = !0, MDW = DEF_MDW;
          for (var ne = 0; ne < Y.length; ++ne)
            Y[ne] && process_col(Y[ne]);
        }
        te && process_col(ie), Y[ie.Index - 1 || Y.length] = ie;
        for (var he = 0; he < +ie.Span; ++he)
          Y[Y.length] = dup(ie);
        break;
      case "namedrange":
        if (c[1] === "/")
          break;
        M.Names || (M.Names = []);
        var j = parsexmltag(c[0]), Fe = {
          Name: j.Name,
          Ref: rc_to_a1(j.RefersTo.slice(1), { r: 0, c: 0 })
        };
        M.Sheets.length > 0 && (Fe.Sheet = M.Sheets.length - 1), M.Names.push(Fe);
        break;
      case "namedcell":
        break;
      case "b":
        break;
      case "i":
        break;
      case "u":
        break;
      case "s":
        break;
      case "em":
        break;
      case "h2":
        break;
      case "h3":
        break;
      case "sub":
        break;
      case "sup":
        break;
      case "span":
        break;
      case "alignment":
        break;
      case "borders":
        break;
      case "border":
        break;
      case "font":
        if (c[0].slice(-2) === "/>")
          break;
        c[1] === "/" ? R += a.slice(O, c.index) : O = c.index + c[0].length;
        break;
      case "interior":
        if (!n.cellStyles)
          break;
        w.Interior = xlml_parsexmltag(c[0]);
        break;
      case "protection":
        break;
      case "author":
      case "title":
      case "description":
      case "created":
      case "keywords":
      case "subject":
      case "category":
      case "company":
      case "lastauthor":
      case "lastsaved":
      case "lastprinted":
      case "version":
      case "revision":
      case "totaltime":
      case "hyperlinkbase":
      case "manager":
      case "contentstatus":
      case "identifier":
      case "language":
      case "appname":
        if (c[0].slice(-2) === "/>")
          break;
        c[1] === "/" ? xlml_set_prop(k, N, a.slice(L, c.index)) : L = c.index + c[0].length;
        break;
      case "paragraphs":
        break;
      case "styles":
      case "workbook":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
        } else
          u.push([c[3], !1]);
        break;
      case "comment":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
          xlml_clean_comment(Q), P.push(Q);
        } else
          u.push([c[3], !1]), d = xlml_parsexmltag(c[0]), Q = { a: d.Author };
        break;
      case "autofilter":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
        } else if (c[0].charAt(c[0].length - 2) !== "/") {
          var X = xlml_parsexmltag(c[0]);
          g["!autofilter"] = { ref: rc_to_a1(X.Range).replace(/\$/g, "") }, u.push([c[3], !0]);
        }
        break;
      case "name":
        break;
      case "datavalidation":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
        } else
          c[0].charAt(c[0].length - 2) !== "/" && u.push([c[3], !0]);
        break;
      case "pixelsperinch":
        break;
      case "componentoptions":
      case "documentproperties":
      case "customdocumentproperties":
      case "officedocumentsettings":
      case "pivottable":
      case "pivotcache":
      case "names":
      case "mapinfo":
      case "pagebreaks":
      case "querytable":
      case "sorting":
      case "schema":
      case "conditionalformatting":
      case "smarttagtype":
      case "smarttags":
      case "excelworkbook":
      case "workbookoptions":
      case "worksheetoptions":
        if (c[1] === "/") {
          if ((d = u.pop())[0] !== c[3])
            throw new Error("Bad state: " + d.join("|"));
        } else
          c[0].charAt(c[0].length - 2) !== "/" && u.push([c[3], !0]);
        break;
      case "null":
        break;
      default:
        if (u.length == 0 && c[3] == "document" || u.length == 0 && c[3] == "uof")
          return parse_fods(a, n);
        var ye = !0;
        switch (u[u.length - 1][0]) {
          case "officedocumentsettings":
            switch (c[3]) {
              case "allowpng":
                break;
              case "removepersonalinformation":
                break;
              case "downloadcomponents":
                break;
              case "locationofcomponents":
                break;
              case "colors":
                break;
              case "color":
                break;
              case "index":
                break;
              case "rgb":
                break;
              case "targetscreensize":
                break;
              case "readonlyrecommended":
                break;
              default:
                ye = !1;
            }
            break;
          case "componentoptions":
            switch (c[3]) {
              case "toolbar":
                break;
              case "hideofficelogo":
                break;
              case "spreadsheetautofit":
                break;
              case "label":
                break;
              case "caption":
                break;
              case "maxheight":
                break;
              case "maxwidth":
                break;
              case "nextsheetnumber":
                break;
              default:
                ye = !1;
            }
            break;
          case "excelworkbook":
            switch (c[3]) {
              case "date1904":
                M.WBProps.date1904 = !0;
                break;
              case "windowheight":
                break;
              case "windowwidth":
                break;
              case "windowtopx":
                break;
              case "windowtopy":
                break;
              case "tabratio":
                break;
              case "protectstructure":
                break;
              case "protectwindow":
                break;
              case "protectwindows":
                break;
              case "activesheet":
                break;
              case "displayinknotes":
                break;
              case "firstvisiblesheet":
                break;
              case "supbook":
                break;
              case "sheetname":
                break;
              case "sheetindex":
                break;
              case "sheetindexfirst":
                break;
              case "sheetindexlast":
                break;
              case "dll":
                break;
              case "acceptlabelsinformulas":
                break;
              case "donotsavelinkvalues":
                break;
              case "iteration":
                break;
              case "maxiterations":
                break;
              case "maxchange":
                break;
              case "path":
                break;
              case "xct":
                break;
              case "count":
                break;
              case "selectedsheets":
                break;
              case "calculation":
                break;
              case "uncalced":
                break;
              case "startupprompt":
                break;
              case "crn":
                break;
              case "externname":
                break;
              case "formula":
                break;
              case "colfirst":
                break;
              case "collast":
                break;
              case "wantadvise":
                break;
              case "boolean":
                break;
              case "error":
                break;
              case "text":
                break;
              case "ole":
                break;
              case "noautorecover":
                break;
              case "publishobjects":
                break;
              case "donotcalculatebeforesave":
                break;
              case "number":
                break;
              case "refmoder1c1":
                break;
              case "embedsavesmarttags":
                break;
              default:
                ye = !1;
            }
            break;
          case "workbookoptions":
            switch (c[3]) {
              case "owcversion":
                break;
              case "height":
                break;
              case "width":
                break;
              default:
                ye = !1;
            }
            break;
          case "worksheetoptions":
            switch (c[3]) {
              case "visible":
                if (c[0].slice(-2) !== "/>")
                  if (c[1] === "/")
                    switch (a.slice(L, c.index)) {
                      case "SheetHidden":
                        I.Hidden = 1;
                        break;
                      case "SheetVeryHidden":
                        I.Hidden = 2;
                        break;
                    }
                  else
                    L = c.index + c[0].length;
                break;
              case "header":
                g["!margins"] || default_margins(g["!margins"] = {}, "xlml"), isNaN(+parsexmltag(c[0]).Margin) || (g["!margins"].header = +parsexmltag(c[0]).Margin);
                break;
              case "footer":
                g["!margins"] || default_margins(g["!margins"] = {}, "xlml"), isNaN(+parsexmltag(c[0]).Margin) || (g["!margins"].footer = +parsexmltag(c[0]).Margin);
                break;
              case "pagemargins":
                var Ae = parsexmltag(c[0]);
                g["!margins"] || default_margins(g["!margins"] = {}, "xlml"), isNaN(+Ae.Top) || (g["!margins"].top = +Ae.Top), isNaN(+Ae.Left) || (g["!margins"].left = +Ae.Left), isNaN(+Ae.Right) || (g["!margins"].right = +Ae.Right), isNaN(+Ae.Bottom) || (g["!margins"].bottom = +Ae.Bottom);
                break;
              case "displayrighttoleft":
                M.Views || (M.Views = []), M.Views[0] || (M.Views[0] = {}), M.Views[0].RTL = !0;
                break;
              case "freezepanes":
                break;
              case "frozennosplit":
                break;
              case "splithorizontal":
              case "splitvertical":
                break;
              case "donotdisplaygridlines":
                break;
              case "activerow":
                break;
              case "activecol":
                break;
              case "toprowbottompane":
                break;
              case "leftcolumnrightpane":
                break;
              case "unsynced":
                break;
              case "print":
                break;
              case "printerrors":
                break;
              case "panes":
                break;
              case "scale":
                break;
              case "pane":
                break;
              case "number":
                break;
              case "layout":
                break;
              case "pagesetup":
                break;
              case "selected":
                break;
              case "protectobjects":
                break;
              case "enableselection":
                break;
              case "protectscenarios":
                break;
              case "validprinterinfo":
                break;
              case "horizontalresolution":
                break;
              case "verticalresolution":
                break;
              case "numberofcopies":
                break;
              case "activepane":
                break;
              case "toprowvisible":
                break;
              case "leftcolumnvisible":
                break;
              case "fittopage":
                break;
              case "rangeselection":
                break;
              case "papersizeindex":
                break;
              case "pagelayoutzoom":
                break;
              case "pagebreakzoom":
                break;
              case "filteron":
                break;
              case "fitwidth":
                break;
              case "fitheight":
                break;
              case "commentslayout":
                break;
              case "zoom":
                break;
              case "lefttoright":
                break;
              case "gridlines":
                break;
              case "allowsort":
                break;
              case "allowfilter":
                break;
              case "allowinsertrows":
                break;
              case "allowdeleterows":
                break;
              case "allowinsertcols":
                break;
              case "allowdeletecols":
                break;
              case "allowinserthyperlinks":
                break;
              case "allowformatcells":
                break;
              case "allowsizecols":
                break;
              case "allowsizerows":
                break;
              case "nosummaryrowsbelowdetail":
                g["!outline"] || (g["!outline"] = {}), g["!outline"].above = !0;
                break;
              case "tabcolorindex":
                break;
              case "donotdisplayheadings":
                break;
              case "showpagelayoutzoom":
                break;
              case "nosummarycolumnsrightdetail":
                g["!outline"] || (g["!outline"] = {}), g["!outline"].left = !0;
                break;
              case "blackandwhite":
                break;
              case "donotdisplayzeros":
                break;
              case "displaypagebreak":
                break;
              case "rowcolheadings":
                break;
              case "donotdisplayoutline":
                break;
              case "noorientation":
                break;
              case "allowusepivottables":
                break;
              case "zeroheight":
                break;
              case "viewablerange":
                break;
              case "selection":
                break;
              case "protectcontents":
                break;
              default:
                ye = !1;
            }
            break;
          case "pivottable":
          case "pivotcache":
            switch (c[3]) {
              case "immediateitemsondrop":
                break;
              case "showpagemultipleitemlabel":
                break;
              case "compactrowindent":
                break;
              case "location":
                break;
              case "pivotfield":
                break;
              case "orientation":
                break;
              case "layoutform":
                break;
              case "layoutsubtotallocation":
                break;
              case "layoutcompactrow":
                break;
              case "position":
                break;
              case "pivotitem":
                break;
              case "datatype":
                break;
              case "datafield":
                break;
              case "sourcename":
                break;
              case "parentfield":
                break;
              case "ptlineitems":
                break;
              case "ptlineitem":
                break;
              case "countofsameitems":
                break;
              case "item":
                break;
              case "itemtype":
                break;
              case "ptsource":
                break;
              case "cacheindex":
                break;
              case "consolidationreference":
                break;
              case "filename":
                break;
              case "reference":
                break;
              case "nocolumngrand":
                break;
              case "norowgrand":
                break;
              case "blanklineafteritems":
                break;
              case "hidden":
                break;
              case "subtotal":
                break;
              case "basefield":
                break;
              case "mapchilditems":
                break;
              case "function":
                break;
              case "refreshonfileopen":
                break;
              case "printsettitles":
                break;
              case "mergelabels":
                break;
              case "defaultversion":
                break;
              case "refreshname":
                break;
              case "refreshdate":
                break;
              case "refreshdatecopy":
                break;
              case "versionlastrefresh":
                break;
              case "versionlastupdate":
                break;
              case "versionupdateablemin":
                break;
              case "versionrefreshablemin":
                break;
              case "calculation":
                break;
              default:
                ye = !1;
            }
            break;
          case "pagebreaks":
            switch (c[3]) {
              case "colbreaks":
                break;
              case "colbreak":
                break;
              case "rowbreaks":
                break;
              case "rowbreak":
                break;
              case "colstart":
                break;
              case "colend":
                break;
              case "rowend":
                break;
              default:
                ye = !1;
            }
            break;
          case "autofilter":
            switch (c[3]) {
              case "autofiltercolumn":
                break;
              case "autofiltercondition":
                break;
              case "autofilterand":
                break;
              case "autofilteror":
                break;
              default:
                ye = !1;
            }
            break;
          case "querytable":
            switch (c[3]) {
              case "id":
                break;
              case "autoformatfont":
                break;
              case "autoformatpattern":
                break;
              case "querysource":
                break;
              case "querytype":
                break;
              case "enableredirections":
                break;
              case "refreshedinxl9":
                break;
              case "urlstring":
                break;
              case "htmltables":
                break;
              case "connection":
                break;
              case "commandtext":
                break;
              case "refreshinfo":
                break;
              case "notitles":
                break;
              case "nextid":
                break;
              case "columninfo":
                break;
              case "overwritecells":
                break;
              case "donotpromptforfile":
                break;
              case "textwizardsettings":
                break;
              case "source":
                break;
              case "number":
                break;
              case "decimal":
                break;
              case "thousandseparator":
                break;
              case "trailingminusnumbers":
                break;
              case "formatsettings":
                break;
              case "fieldtype":
                break;
              case "delimiters":
                break;
              case "tab":
                break;
              case "comma":
                break;
              case "autoformatname":
                break;
              case "versionlastedit":
                break;
              case "versionlastrefresh":
                break;
              default:
                ye = !1;
            }
            break;
          case "datavalidation":
            switch (c[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              case "cellrangelist":
                break;
              default:
                ye = !1;
            }
            break;
          case "sorting":
          case "conditionalformatting":
            switch (c[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "cellrangelist":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              default:
                ye = !1;
            }
            break;
          case "mapinfo":
          case "schema":
          case "data":
            switch (c[3]) {
              case "map":
                break;
              case "entry":
                break;
              case "range":
                break;
              case "xpath":
                break;
              case "field":
                break;
              case "xsdtype":
                break;
              case "filteron":
                break;
              case "aggregate":
                break;
              case "elementtype":
                break;
              case "attributetype":
                break;
              case "schema":
              case "element":
              case "complextype":
              case "datatype":
              case "all":
              case "attribute":
              case "extends":
                break;
              case "row":
                break;
              default:
                ye = !1;
            }
            break;
          case "smarttags":
            break;
          default:
            ye = !1;
            break;
        }
        if (ye || c[3].match(/!\[CDATA/))
          break;
        if (!u[u.length - 1][1])
          throw "Unrecognized tag: " + c[3] + "|" + u.join("|");
        if (u[u.length - 1][0] === /*'CustomDocumentProperties'*/
        "customdocumentproperties") {
          if (c[0].slice(-2) === "/>")
            break;
          c[1] === "/" ? xlml_set_custprop(W, N, z, a.slice(L, c.index)) : (z = c, L = c.index + c[0].length);
          break;
        }
        if (n.WTF)
          throw "Unrecognized tag: " + c[3] + "|" + u.join("|");
    }
  var fe = {};
  return !n.bookSheets && !n.bookProps && (fe.Sheets = f), fe.SheetNames = h, fe.Workbook = M, fe.SSF = dup(table_fmt), fe.Props = k, fe.Custprops = W, fe;
}
function parse_xlml(t, e) {
  switch (fix_read_opts(e = e || {}), e.type || "base64") {
    case "base64":
      return parse_xlml_xml(Base64_decode(t), e);
    case "binary":
    case "buffer":
    case "file":
      return parse_xlml_xml(t, e);
    case "array":
      return parse_xlml_xml(a2s(t), e);
  }
}
function parse_compobj(t) {
  var e = {}, n = t.content;
  if (n.l = 28, e.AnsiUserType = n.read_shift(0, "lpstr-ansi"), e.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(n), n.length - n.l <= 4)
    return e;
  var a = n.read_shift(4);
  if (a == 0 || a > 40 || (n.l -= 4, e.Reserved1 = n.read_shift(0, "lpstr-ansi"), n.length - n.l <= 4) || (a = n.read_shift(4), a !== 1907505652) || (e.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(n), a = n.read_shift(4), a == 0 || a > 40))
    return e;
  n.l -= 4, e.Reserved2 = n.read_shift(0, "lpwstr");
}
var CONTINUE_RT = [60, 1084, 2066, 2165, 2175];
function slurp(t, e, n, a, s) {
  var o = a, l = [], c = n.slice(n.l, n.l + o);
  if (s && s.enc && s.enc.insitu && c.length > 0)
    switch (t) {
      case 9:
      case 521:
      case 1033:
      case 2057:
      case 47:
      case 405:
      case 225:
      case 406:
      case 312:
      case 404:
      case 10:
        break;
      case 133:
        break;
      default:
        s.enc.insitu(c);
    }
  l.push(c), n.l += o;
  for (var u = __readUInt16LE(n, n.l), d = XLSRecordEnum[u], f = 0; d != null && CONTINUE_RT.indexOf(u) > -1; )
    o = __readUInt16LE(n, n.l + 2), f = n.l + 4, u == 2066 ? f += 4 : (u == 2165 || u == 2175) && (f += 12), c = n.slice(f, n.l + 4 + o), l.push(c), n.l += 4 + o, d = XLSRecordEnum[u = __readUInt16LE(n, n.l)];
  var h = bconcat(l);
  prep_blob(h, 0);
  var g = 0;
  h.lens = [];
  for (var x = 0; x < l.length; ++x)
    h.lens.push(g), g += l[x].length;
  if (h.length < a)
    throw "XLS Record 0x" + t.toString(16) + " Truncated: " + h.length + " < " + a;
  return e.f(h, h.length, s);
}
function safe_format_xf(t, e, n) {
  if (t.t !== "z" && t.XF) {
    var a = 0;
    try {
      a = t.z || t.XF.numFmtId || 0, e.cellNF && (t.z = table_fmt[a]);
    } catch (o) {
      if (e.WTF)
        throw o;
    }
    if (!e || e.cellText !== !1)
      try {
        t.t === "e" ? t.w = t.w || BErr[t.v] : a === 0 || a == "General" ? t.t === "n" ? (t.v | 0) === t.v ? t.w = t.v.toString(10) : t.w = SSF_general_num(t.v) : t.w = SSF_general(t.v) : t.w = SSF_format(a, t.v, { date1904: !!n, dateNF: e && e.dateNF });
      } catch (o) {
        if (e.WTF)
          throw o;
      }
    if (e.cellDates && a && t.t == "n" && fmt_is_date(table_fmt[a] || String(a))) {
      var s = SSF_parse_date_code(t.v);
      s && (t.t = "d", t.v = new Date(s.y, s.m - 1, s.d, s.H, s.M, s.S, s.u));
    }
  }
}
function make_cell(t, e, n) {
  return { v: t, ixfe: e, t: n };
}
function parse_workbook(t, e) {
  var n = { opts: {} }, a = {}, s = e.dense ? [] : {}, o = {}, l = {}, c = null, u = [], d = "", f = {}, h, g = "", x, E, m, v, y = {}, A = [], b, C, T = [], w = [], R = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, O = {}, D = function(ze) {
    return ze < 8 ? XLSIcv[ze] : ze < 64 && w[ze - 8] || XLSIcv[ze];
  }, k = function(ze, et, gt) {
    var pt = et.XF.data;
    if (!(!pt || !pt.patternType || !gt || !gt.cellStyles)) {
      et.s = {}, et.s.patternType = pt.patternType;
      var nt;
      (nt = rgb2Hex(D(pt.icvFore))) && (et.s.fgColor = { rgb: nt }), (nt = rgb2Hex(D(pt.icvBack))) && (et.s.bgColor = { rgb: nt });
    }
  }, W = function(ze, et, gt) {
    if (!(G > 1) && !(gt.sheetRows && ze.r >= gt.sheetRows)) {
      if (gt.cellStyles && et.XF && et.XF.data && k(ze, et, gt), delete et.ixfe, delete et.XF, h = ze, g = encode_cell(ze), (!l || !l.s || !l.e) && (l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), ze.r < l.s.r && (l.s.r = ze.r), ze.c < l.s.c && (l.s.c = ze.c), ze.r + 1 > l.e.r && (l.e.r = ze.r + 1), ze.c + 1 > l.e.c && (l.e.c = ze.c + 1), gt.cellFormula && et.f) {
        for (var pt = 0; pt < A.length; ++pt)
          if (!(A[pt][0].s.c > ze.c || A[pt][0].s.r > ze.r) && !(A[pt][0].e.c < ze.c || A[pt][0].e.r < ze.r)) {
            et.F = encode_range(A[pt][0]), (A[pt][0].s.c != ze.c || A[pt][0].s.r != ze.r) && delete et.f, et.f && (et.f = "" + stringify_formula(A[pt][1], l, ze, Z, L));
            break;
          }
      }
      gt.dense ? (s[ze.r] || (s[ze.r] = []), s[ze.r][ze.c] = et) : s[g] = et;
    }
  }, L = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: y,
    // shared formulae by address
    arrayf: A,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!e && !!e.cellStyles,
    WTF: !!e && !!e.wtf
  };
  e.password && (L.password = e.password);
  var z, P = [], Q = [], Y = [], ie = [], te = !1, Z = [];
  Z.SheetNames = L.snames, Z.sharedf = L.sharedf, Z.arrayf = L.arrayf, Z.names = [], Z.XTI = [];
  var ae = 0, G = 0, U = 0, F = [], M = [], I;
  L.codepage = 1200, set_cp(1200);
  for (var N = !1; t.l < t.length - 1; ) {
    var V = t.l, q = t.read_shift(2);
    if (q === 0 && ae === 10)
      break;
    var H = t.l === t.length ? 0 : t.read_shift(2), ne = XLSRecordEnum[q];
    if (ne && ne.f) {
      if (e.bookSheets && ae === 133 && q !== 133)
        break;
      if (ae = q, ne.r === 2 || ne.r == 12) {
        var he = t.read_shift(2);
        if (H -= 2, !L.enc && he !== q && ((he & 255) << 8 | he >> 8) !== q)
          throw new Error("rt mismatch: " + he + "!=" + q);
        ne.r == 12 && (t.l += 10, H -= 10);
      }
      var j = {};
      if (q === 10 ? j = /*::(*/
      ne.f(t, H, L) : j = /*::(*/
      slurp(q, ne, t, H, L), G == 0 && [9, 521, 1033, 2057].indexOf(ae) === -1)
        continue;
      switch (q) {
        case 34:
          n.opts.Date1904 = R.WBProps.date1904 = j;
          break;
        case 134:
          n.opts.WriteProtect = !0;
          break;
        case 47:
          if (L.enc || (t.l = 0), L.enc = j, !e.password)
            throw new Error("File is password-protected");
          if (j.valid == null)
            throw new Error("Encryption scheme unsupported");
          if (!j.valid)
            throw new Error("Password is incorrect");
          break;
        case 92:
          L.lastuser = j;
          break;
        case 66:
          var Fe = Number(j);
          switch (Fe) {
            case 21010:
              Fe = 1200;
              break;
            case 32768:
              Fe = 1e4;
              break;
            case 32769:
              Fe = 1252;
              break;
          }
          set_cp(L.codepage = Fe), N = !0;
          break;
        case 317:
          L.rrtabid = j;
          break;
        case 25:
          L.winlocked = j;
          break;
        case 439:
          n.opts.RefreshAll = j;
          break;
        case 12:
          n.opts.CalcCount = j;
          break;
        case 16:
          n.opts.CalcDelta = j;
          break;
        case 17:
          n.opts.CalcIter = j;
          break;
        case 13:
          n.opts.CalcMode = j;
          break;
        case 14:
          n.opts.CalcPrecision = j;
          break;
        case 95:
          n.opts.CalcSaveRecalc = j;
          break;
        case 15:
          L.CalcRefMode = j;
          break;
        case 2211:
          n.opts.FullCalc = j;
          break;
        case 129:
          j.fDialog && (s["!type"] = "dialog"), j.fBelow || ((s["!outline"] || (s["!outline"] = {})).above = !0), j.fRight || ((s["!outline"] || (s["!outline"] = {})).left = !0);
          break;
        case 224:
          T.push(j);
          break;
        case 430:
          Z.push([j]), Z[Z.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          Z[Z.length - 1].push(j);
          break;
        case 24:
        case 536:
          I = {
            Name: j.Name,
            Ref: stringify_formula(j.rgce, l, null, Z, L)
          }, j.itab > 0 && (I.Sheet = j.itab - 1), Z.names.push(I), Z[0] || (Z[0] = [], Z[0].XTI = []), Z[Z.length - 1].push(j), j.Name == "_xlnm._FilterDatabase" && j.itab > 0 && j.rgce && j.rgce[0] && j.rgce[0][0] && j.rgce[0][0][0] == "PtgArea3d" && (M[j.itab - 1] = { ref: encode_range(j.rgce[0][0][1][2]) });
          break;
        case 22:
          L.ExternCount = j;
          break;
        case 23:
          Z.length == 0 && (Z[0] = [], Z[0].XTI = []), Z[Z.length - 1].XTI = Z[Z.length - 1].XTI.concat(j), Z.XTI = Z.XTI.concat(j);
          break;
        case 2196:
          if (L.biff < 8)
            break;
          I != null && (I.Comment = j[1]);
          break;
        case 18:
          s["!protect"] = j;
          break;
        case 19:
          j !== 0 && L.WTF && console.error("Password verifier: " + j);
          break;
        case 133:
          o[j.pos] = j, L.snames.push(j.name);
          break;
        case 10:
          {
            if (--G)
              break;
            if (l.e) {
              if (l.e.r > 0 && l.e.c > 0) {
                if (l.e.r--, l.e.c--, s["!ref"] = encode_range(l), e.sheetRows && e.sheetRows <= l.e.r) {
                  var X = l.e.r;
                  l.e.r = e.sheetRows - 1, s["!fullref"] = s["!ref"], s["!ref"] = encode_range(l), l.e.r = X;
                }
                l.e.r++, l.e.c++;
              }
              P.length > 0 && (s["!merges"] = P), Q.length > 0 && (s["!objects"] = Q), Y.length > 0 && (s["!cols"] = Y), ie.length > 0 && (s["!rows"] = ie), R.Sheets.push(O);
            }
            d === "" ? f = s : a[d] = s, s = e.dense ? [] : {};
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (L.biff === 8 && (L.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[q] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[j.BIFFVer] || 8), L.biffguess = j.BIFFVer == 0, j.BIFFVer == 0 && j.dt == 4096 && (L.biff = 5, N = !0, set_cp(L.codepage = 28591)), L.biff == 8 && j.BIFFVer == 0 && j.dt == 16 && (L.biff = 2), G++)
              break;
            if (s = e.dense ? [] : {}, L.biff < 8 && !N && (N = !0, set_cp(L.codepage = e.codepage || 1252)), L.biff < 5 || j.BIFFVer == 0 && j.dt == 4096) {
              d === "" && (d = "Sheet1"), l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var ye = { pos: t.l - H, name: d };
              o[ye.pos] = ye, L.snames.push(d);
            } else
              d = (o[V] || { name: "" }).name;
            j.dt == 32 && (s["!type"] = "chart"), j.dt == 64 && (s["!type"] = "macro"), P = [], Q = [], L.arrayf = A = [], Y = [], ie = [], te = !1, O = { Hidden: (o[V] || { hs: 0 }).hs, name: d };
          }
          break;
        case 515:
        case 3:
        case 2:
          s["!type"] == "chart" && (e.dense ? (s[j.r] || [])[j.c] : s[encode_cell({ c: j.c, r: j.r })]) && ++j.c, b = { ixfe: j.ixfe, XF: T[j.ixfe] || {}, v: j.val, t: "n" }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e);
          break;
        case 5:
        case 517:
          b = { ixfe: j.ixfe, XF: T[j.ixfe], v: j.val, t: j.t }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e);
          break;
        case 638:
          b = { ixfe: j.ixfe, XF: T[j.ixfe], v: j.rknum, t: "n" }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e);
          break;
        case 189:
          for (var Ae = j.c; Ae <= j.C; ++Ae) {
            var fe = j.rkrec[Ae - j.c][0];
            b = { ixfe: fe, XF: T[fe], v: j.rkrec[Ae - j.c][1], t: "n" }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: Ae, r: j.r }, b, e);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (j.val == "String") {
              c = j;
              break;
            }
            if (b = make_cell(j.val, j.cell.ixfe, j.tt), b.XF = T[b.ixfe], e.cellFormula) {
              var _e = j.formula;
              if (_e && _e[0] && _e[0][0] && _e[0][0][0] == "PtgExp") {
                var Ie = _e[0][0][1][0], Be = _e[0][0][1][1], $e = encode_cell({ r: Ie, c: Be });
                y[$e] ? b.f = "" + stringify_formula(j.formula, l, j.cell, Z, L) : b.F = ((e.dense ? (s[Ie] || [])[Be] : s[$e]) || {}).F;
              } else
                b.f = "" + stringify_formula(j.formula, l, j.cell, Z, L);
            }
            U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W(j.cell, b, e), c = j;
          }
          break;
        case 7:
        case 519:
          if (c)
            c.val = j, b = make_cell(j, c.cell.ixfe, "s"), b.XF = T[b.ixfe], e.cellFormula && (b.f = "" + stringify_formula(c.formula, l, c.cell, Z, L)), U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W(c.cell, b, e), c = null;
          else
            throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            A.push(j);
            var Me = encode_cell(j[0].s);
            if (x = e.dense ? (s[j[0].s.r] || [])[j[0].s.c] : s[Me], e.cellFormula && x) {
              if (!c || !Me || !x)
                break;
              x.f = "" + stringify_formula(j[1], l, j[0], Z, L), x.F = encode_range(j[0]);
            }
          }
          break;
        case 1212:
          {
            if (!e.cellFormula)
              break;
            if (g) {
              if (!c)
                break;
              y[encode_cell(c.cell)] = j[0], x = e.dense ? (s[c.cell.r] || [])[c.cell.c] : s[encode_cell(c.cell)], (x || {}).f = "" + stringify_formula(j[0], l, h, Z, L);
            }
          }
          break;
        case 253:
          b = make_cell(u[j.isst].t, j.ixfe, "s"), u[j.isst].h && (b.h = u[j.isst].h), b.XF = T[b.ixfe], U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e);
          break;
        case 513:
          e.sheetStubs && (b = { ixfe: j.ixfe, XF: T[j.ixfe], t: "z" }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e));
          break;
        case 190:
          if (e.sheetStubs)
            for (var J = j.c; J <= j.C; ++J) {
              var K = j.ixfe[J - j.c];
              b = { ixfe: K, XF: T[K], t: "z" }, U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: J, r: j.r }, b, e);
            }
          break;
        case 214:
        case 516:
        case 4:
          b = make_cell(j.val, j.ixfe, "s"), b.XF = T[b.ixfe], U > 0 && (b.z = F[b.ixfe >> 8 & 63]), safe_format_xf(b, e, n.opts.Date1904), W({ c: j.c, r: j.r }, b, e);
          break;
        case 0:
        case 512:
          G === 1 && (l = j);
          break;
        case 252:
          u = j;
          break;
        case 1054:
          if (L.biff == 4) {
            F[U++] = j[1];
            for (var ge = 0; ge < U + 163 && table_fmt[ge] != j[1]; ++ge)
              ;
            ge >= 163 && SSF_load(j[1], U + 163);
          } else
            SSF_load(j[1], j[0]);
          break;
        case 30:
          {
            F[U++] = j;
            for (var Ce = 0; Ce < U + 163 && table_fmt[Ce] != j; ++Ce)
              ;
            Ce >= 163 && SSF_load(j, U + 163);
          }
          break;
        case 229:
          P = P.concat(j);
          break;
        case 93:
          Q[j.cmo[0]] = L.lastobj = j;
          break;
        case 438:
          L.lastobj.TxO = j;
          break;
        case 127:
          L.lastobj.ImData = j;
          break;
        case 440:
          for (v = j[0].s.r; v <= j[0].e.r; ++v)
            for (m = j[0].s.c; m <= j[0].e.c; ++m)
              x = e.dense ? (s[v] || [])[m] : s[encode_cell({ c: m, r: v })], x && (x.l = j[1]);
          break;
        case 2048:
          for (v = j[0].s.r; v <= j[0].e.r; ++v)
            for (m = j[0].s.c; m <= j[0].e.c; ++m)
              x = e.dense ? (s[v] || [])[m] : s[encode_cell({ c: m, r: v })], x && x.l && (x.l.Tooltip = j[1]);
          break;
        case 28:
          {
            if (L.biff <= 5 && L.biff >= 2)
              break;
            x = e.dense ? (s[j[0].r] || [])[j[0].c] : s[encode_cell(j[0])];
            var Oe = Q[j[2]];
            x || (e.dense ? (s[j[0].r] || (s[j[0].r] = []), x = s[j[0].r][j[0].c] = { t: "z" }) : x = s[encode_cell(j[0])] = { t: "z" }, l.e.r = Math.max(l.e.r, j[0].r), l.s.r = Math.min(l.s.r, j[0].r), l.e.c = Math.max(l.e.c, j[0].c), l.s.c = Math.min(l.s.c, j[0].c)), x.c || (x.c = []), E = { a: j[1], t: Oe.TxO.t }, x.c.push(E);
          }
          break;
        case 2173:
          update_xfext(T[j.ixfe], j.ext);
          break;
        case 125:
          {
            if (!L.cellStyles)
              break;
            for (; j.e >= j.s; )
              Y[j.e--] = { width: j.w / 256, level: j.level || 0, hidden: !!(j.flags & 1) }, te || (te = !0, find_mdw_colw(j.w / 256)), process_col(Y[j.e + 1]);
          }
          break;
        case 520:
          {
            var qe = {};
            j.level != null && (ie[j.r] = qe, qe.level = j.level), j.hidden && (ie[j.r] = qe, qe.hidden = !0), j.hpt && (ie[j.r] = qe, qe.hpt = j.hpt, qe.hpx = pt2px(j.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          s["!margins"] || default_margins(s["!margins"] = {}), s["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[q]] = j;
          break;
        case 161:
          s["!margins"] || default_margins(s["!margins"] = {}), s["!margins"].header = j.header, s["!margins"].footer = j.footer;
          break;
        case 574:
          j.RTL && (R.Views[0].RTL = !0);
          break;
        case 146:
          w = j;
          break;
        case 2198:
          z = j;
          break;
        case 140:
          C = j;
          break;
        case 442:
          d ? O.CodeName = j || O.name : R.WBProps.CodeName = j || "ThisWorkbook";
          break;
      }
    } else
      ne || console.error("Missing Info for XLS Record 0x" + q.toString(16)), t.l += H;
  }
  return n.SheetNames = keys(o).sort(function(ct, ze) {
    return Number(ct) - Number(ze);
  }).map(function(ct) {
    return o[ct].name;
  }), e.bookSheets || (n.Sheets = a), !n.SheetNames.length && f["!ref"] ? (n.SheetNames.push("Sheet1"), n.Sheets && (n.Sheets.Sheet1 = f)) : n.Preamble = f, n.Sheets && M.forEach(function(ct, ze) {
    n.Sheets[n.SheetNames[ze]]["!autofilter"] = ct;
  }), n.Strings = u, n.SSF = dup(table_fmt), L.enc && (n.Encryption = L.enc), z && (n.Themes = z), n.Metadata = {}, C !== void 0 && (n.Metadata.Country = C), Z.names.length > 0 && (R.Names = Z.names), n.Workbook = R, n;
}
var PSCLSID = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(t, e, n) {
  var a = CFB.find(t, "/!DocumentSummaryInformation");
  if (a && a.size > 0)
    try {
      var s = parse_PropertySetStream(a, DocSummaryPIDDSI, PSCLSID.DSI);
      for (var o in s)
        e[o] = s[o];
    } catch (d) {
      if (n.WTF)
        throw d;
    }
  var l = CFB.find(t, "/!SummaryInformation");
  if (l && l.size > 0)
    try {
      var c = parse_PropertySetStream(l, SummaryPIDSI, PSCLSID.SI);
      for (var u in c)
        e[u] == null && (e[u] = c[u]);
    } catch (d) {
      if (n.WTF)
        throw d;
    }
  e.HeadingPairs && e.TitlesOfParts && (load_props_pairs(e.HeadingPairs, e.TitlesOfParts, e, n), delete e.HeadingPairs, delete e.TitlesOfParts);
}
function parse_xlscfb(t, e) {
  e || (e = {}), fix_read_opts(e), reset_cp(), e.codepage && set_ansi(e.codepage);
  var n, a;
  if (t.FullPaths) {
    if (CFB.find(t, "/encryption"))
      throw new Error("File is password-protected");
    n = CFB.find(t, "!CompObj"), a = CFB.find(t, "/Workbook") || CFB.find(t, "/Book");
  } else {
    switch (e.type) {
      case "base64":
        t = s2a(Base64_decode(t));
        break;
      case "binary":
        t = s2a(t);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(t) || (t = Array.prototype.slice.call(t));
        break;
    }
    prep_blob(t, 0), a = { content: t };
  }
  var s, o;
  if (n && parse_compobj(n), e.bookProps && !e.bookSheets)
    s = {};
  else {
    var l = has_buf ? "buffer" : "array";
    if (a && a.content)
      s = parse_workbook(a.content, e);
    else if ((o = CFB.find(t, "PerfectOffice_MAIN")) && o.content)
      s = WK_.to_workbook(o.content, (e.type = l, e));
    else if ((o = CFB.find(t, "NativeContent_MAIN")) && o.content)
      s = WK_.to_workbook(o.content, (e.type = l, e));
    else
      throw (o = CFB.find(t, "MN0")) && o.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    e.bookVBA && t.FullPaths && CFB.find(t, "/_VBA_PROJECT_CUR/VBA/dir") && (s.vbaraw = make_vba_xls(t));
  }
  var c = {};
  return t.FullPaths && parse_xls_props(
    /*::((*/
    t,
    c,
    e
  ), s.Props = s.Custprops = c, e.bookFiles && (s.cfb = t), s;
}
var XLSBRecordEnum = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: parse_BrtRowHdr
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: parse_BrtCellBlank
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: parse_BrtCellRk
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: parse_BrtCellError
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: parse_BrtCellBool
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: parse_BrtCellReal
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: parse_BrtCellSt
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: parse_BrtCellIsst
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: parse_BrtFmlaString
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: parse_BrtFmlaNum
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: parse_BrtFmlaBool
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: parse_BrtFmlaError
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: parse_BrtShortBlank
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: parse_BrtShortRk
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: parse_BrtShortError
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: parse_BrtShortBool
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: parse_BrtShortReal
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: parse_BrtShortSt
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: parse_BrtShortIsst
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: parse_RichStr
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: parse_BrtName
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: parse_BrtFont
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: parse_BrtFmt
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: parse_BrtFill
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: parse_BrtBorder
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: parse_BrtXF
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: parse_Int32LE
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: parse_BrtMdb
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: parse_ColInfo
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: parse_BrtCellRString
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: parse_BrtCalcChainItem$
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: parse_BrtDVal
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: parsenoop,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: parse_BrtBeginWsView
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: parse_BrtWsProp
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: parse_BrtWsDim,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: parse_BrtPane
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: parse_BrtWbProp
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: parse_BrtBundleSh
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: parse_BrtBeginSst
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: parse_UncheckedRfX
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: parse_BrtMergeCell
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: parse_BrtMdtinfo
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: parse_BrtBeginEsmdb,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: parse_RelID
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: parse_ExternSheet
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: parse_BrtArrFmla
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: parse_BrtShrFmla
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: parse_BrtMargins
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: parse_BrtWsFmtInfo
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: parse_BrtHLink
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: parse_RelID
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: parse_BrtCommentAuthor
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: parse_BrtBeginComment
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: parse_BrtCommentText
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: parse_BrtCsProp
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: parse_BrtDVal14
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, XLSRecordEnum = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: parsenoop2
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: parseuint16
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: parseuint16
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: parsebool
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: parsebool
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: parse_Xnum
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: parsebool
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: parsebool
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: parseuint16
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: parse_XLHeaderFooter
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: parse_XLHeaderFooter
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: parse_ExternSheet
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: parse_Lbl
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: parsebool
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: parse_Note
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: parsebool
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: parse_ExternName
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: parse_Xnum
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: parsebool
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: parsebool
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: parse_FilePass
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: parse_Font
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: parseuint16
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: parse_Window1
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: parsebool
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: parse_Pane
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: parseuint16
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: parseuint16
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: parse_WriteAccess
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: parse_Obj
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: parsebool
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: parsebool
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: parse_ColInfo
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: parse_Guts
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: parse_WsBool
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: parseuint16
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: parsebool
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: parsebool
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: parse_BoundSheet8
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: parse_Country
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: parseuint16
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: parse_Palette
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: parseuint16
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: parse_Scl
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: parse_Setup
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: parse_MulRk
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: parse_MulBlank
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: parsenoop2
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: parsebool
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: parseuint16
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: parsebool
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: parse_XF
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: parse_InterfaceHdr
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: parsenoop2
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: parse_MergeCells
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: parse_SST
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: parse_LabelSst
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: parse_ExtSST
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: parseuint16a
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: parsebool
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: parsenoop2
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: parse_SupBook
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: parsebool
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: parse_TxO
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: parsebool
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: parse_HLink
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: parse_XLUnicodeString
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: parseuint16
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: parsenoop2
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: parse_RecalcId,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: parsenoop2
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: parse_Dimensions
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: parse_Blank
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: parse_Number
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: parse_Label
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: parse_BoolErr
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: parse_String
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: parse_Row
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: parse_Array
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: parse_DefaultRowHeight
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: parse_Window2
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: parse_RK
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: parse_Format
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: parse_ShrFmla
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: parse_HLinkTooltip
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: parsenoop2
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: parse_XFCRC,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: parse_XFExt,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: parsebool,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: parse_NameCmt,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: parse_Theme,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: parse_MTRSettings,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: parsenoop2
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: parse_ForceFullCalculation
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: parseuint16
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: parse_ShtProps
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: parse_ClrtClient
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: parse_Dimensions
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: parse_BIFF2INT
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: parse_BIFF2NUM
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: parse_BIFF2STR
  },
  /*::[*/
  5: {
    /* n:"BoolErr", */
    f: parse_BoolErr
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: parse_BIFF2STRING
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: parseuint16
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: parse_BIFF2Format
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: parse_Array
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: parse_DefaultRowHeight
  },
  // 0x2c ??
  // 0x2d ??
  // 0x2e ??
  // 0x30 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: parse_BIFF2FONTXTRA
  },
  // 0x35: INFOOPTS
  // 0x36: TABLE (BIFF2 only)
  // 0x37: TABLE2 (BIFF2 only)
  // 0x38: WNDESK
  // 0x39 ??
  // 0x3a: BEGINPREF
  // 0x3b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x3f ??
  // 0x46: SHOWSCROLL
  // 0x47: SHOWFORMULA
  // 0x48: STATUSBAR
  // 0x49: SHORTMENUS
  // 0x4A:
  // 0x4B:
  // 0x4C:
  // 0x4E:
  // 0x4F:
  // 0x58: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: parseuint16
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: parse_ImData
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  // 0x8F
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: parse_RString
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: parse_Lbl
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: parse_ExternName
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: parse_Formula
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: parse_BOF
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /*::[*/
  29282: {}
};
function write_biff_rec(t, e, n, a) {
  var s = e;
  if (!isNaN(s)) {
    var o = a || (n || []).length || 0, l = t.next(4);
    l.write_shift(2, s), l.write_shift(2, o), /*:: len != null &&*/
    o > 0 && is_buf(n) && t.push(n);
  }
}
function html_to_sheet(t, e) {
  var n = e || {}, a = n.dense ? [] : {};
  t = t.replace(/<!--.*?-->/g, "");
  var s = t.match(/<table/i);
  if (!s)
    throw new Error("Invalid HTML: could not find <table>");
  var o = t.match(/<\/table/i), l = s.index, c = o && o.index || t.length, u = split_regex(t.slice(l, c), /(:?<tr[^>]*>)/i, "<tr>"), d = -1, f = 0, h = 0, g = 0, x = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, E = [];
  for (l = 0; l < u.length; ++l) {
    var m = u[l].trim(), v = m.slice(0, 3).toLowerCase();
    if (v == "<tr") {
      if (++d, n.sheetRows && n.sheetRows <= d) {
        --d;
        break;
      }
      f = 0;
      continue;
    }
    if (!(v != "<td" && v != "<th")) {
      var y = m.split(/<\/t[dh]>/i);
      for (c = 0; c < y.length; ++c) {
        var A = y[c].trim();
        if (A.match(/<t[dh]/i)) {
          for (var b = A, C = 0; b.charAt(0) == "<" && (C = b.indexOf(">")) > -1; )
            b = b.slice(C + 1);
          for (var T = 0; T < E.length; ++T) {
            var w = E[T];
            w.s.c == f && w.s.r < d && d <= w.e.r && (f = w.e.c + 1, T = -1);
          }
          var R = parsexmltag(A.slice(0, A.indexOf(">")));
          g = R.colspan ? +R.colspan : 1, ((h = +R.rowspan) > 1 || g > 1) && E.push({ s: { r: d, c: f }, e: { r: d + (h || 1) - 1, c: f + g - 1 } });
          var O = R.t || R["data-t"] || "";
          if (!b.length) {
            f += g;
            continue;
          }
          if (b = htmldecode(b), x.s.r > d && (x.s.r = d), x.e.r < d && (x.e.r = d), x.s.c > f && (x.s.c = f), x.e.c < f && (x.e.c = f), !b.length) {
            f += g;
            continue;
          }
          var D = { t: "s", v: b };
          n.raw || !b.trim().length || O == "s" || (b === "TRUE" ? D = { t: "b", v: !0 } : b === "FALSE" ? D = { t: "b", v: !1 } : isNaN(fuzzynum(b)) ? isNaN(fuzzydate(b).getDate()) || (D = { t: "d", v: parseDate(b) }, n.cellDates || (D = { t: "n", v: datenum(D.v) }), D.z = n.dateNF || table_fmt[14]) : D = { t: "n", v: fuzzynum(b) }), n.dense ? (a[d] || (a[d] = []), a[d][f] = D) : a[encode_cell({ r: d, c: f })] = D, f += g;
        }
      }
    }
  }
  return a["!ref"] = encode_range(x), E.length && (a["!merges"] = E), a;
}
function make_html_row(t, e, n, a) {
  for (var s = t["!merges"] || [], o = [], l = e.s.c; l <= e.e.c; ++l) {
    for (var c = 0, u = 0, d = 0; d < s.length; ++d)
      if (!(s[d].s.r > n || s[d].s.c > l) && !(s[d].e.r < n || s[d].e.c < l)) {
        if (s[d].s.r < n || s[d].s.c < l) {
          c = -1;
          break;
        }
        c = s[d].e.r - s[d].s.r + 1, u = s[d].e.c - s[d].s.c + 1;
        break;
      }
    if (!(c < 0)) {
      var f = encode_cell({ r: n, c: l }), h = a.dense ? (t[n] || [])[l] : t[f], g = h && h.v != null && (h.h || escapehtml(h.w || (format_cell(h), h.w) || "")) || "", x = {};
      c > 1 && (x.rowspan = c), u > 1 && (x.colspan = u), a.editable ? g = '<span contenteditable="true">' + g + "</span>" : h && (x["data-t"] = h && h.t || "z", h.v != null && (x["data-v"] = h.v), h.z != null && (x["data-z"] = h.z), h.l && (h.l.Target || "#").charAt(0) != "#" && (g = '<a href="' + h.l.Target + '">' + g + "</a>")), x.id = (a.id || "sjs") + "-" + f, o.push(writextag("td", g, x));
    }
  }
  var E = "<tr>";
  return E + o.join("") + "</tr>";
}
var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', HTML_END = "</body></html>";
function html_to_workbook(t, e) {
  var n = t.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!n || n.length == 0)
    throw new Error("Invalid HTML: could not find <table>");
  if (n.length == 1)
    return sheet_to_workbook(html_to_sheet(n[0], e), e);
  var a = book_new();
  return n.forEach(function(s, o) {
    book_append_sheet(a, html_to_sheet(s, e), "Sheet" + (o + 1));
  }), a;
}
function make_html_preamble(t, e, n) {
  var a = [];
  return a.join("") + "<table" + (n && n.id ? ' id="' + n.id + '"' : "") + ">";
}
function sheet_to_html(t, e) {
  var n = e || {}, a = n.header != null ? n.header : HTML_BEGIN, s = n.footer != null ? n.footer : HTML_END, o = [a], l = decode_range(t["!ref"]);
  n.dense = Array.isArray(t), o.push(make_html_preamble(t, l, n));
  for (var c = l.s.r; c <= l.e.r; ++c)
    o.push(make_html_row(t, l, c, n));
  return o.push("</table>" + s), o.join("");
}
function sheet_add_dom(t, e, n) {
  var a = n || {}, s = 0, o = 0;
  if (a.origin != null)
    if (typeof a.origin == "number")
      s = a.origin;
    else {
      var l = typeof a.origin == "string" ? decode_cell(a.origin) : a.origin;
      s = l.r, o = l.c;
    }
  var c = e.getElementsByTagName("tr"), u = Math.min(a.sheetRows || 1e7, c.length), d = { s: { r: 0, c: 0 }, e: { r: s, c: o } };
  if (t["!ref"]) {
    var f = decode_range(t["!ref"]);
    d.s.r = Math.min(d.s.r, f.s.r), d.s.c = Math.min(d.s.c, f.s.c), d.e.r = Math.max(d.e.r, f.e.r), d.e.c = Math.max(d.e.c, f.e.c), s == -1 && (d.e.r = s = f.e.r + 1);
  }
  var h = [], g = 0, x = t["!rows"] || (t["!rows"] = []), E = 0, m = 0, v = 0, y = 0, A = 0, b = 0;
  for (t["!cols"] || (t["!cols"] = []); E < c.length && m < u; ++E) {
    var C = c[E];
    if (is_dom_element_hidden(C)) {
      if (a.display)
        continue;
      x[m] = { hidden: !0 };
    }
    var T = C.children;
    for (v = y = 0; v < T.length; ++v) {
      var w = T[v];
      if (!(a.display && is_dom_element_hidden(w))) {
        var R = w.hasAttribute("data-v") ? w.getAttribute("data-v") : w.hasAttribute("v") ? w.getAttribute("v") : htmldecode(w.innerHTML), O = w.getAttribute("data-z") || w.getAttribute("z");
        for (g = 0; g < h.length; ++g) {
          var D = h[g];
          D.s.c == y + o && D.s.r < m + s && m + s <= D.e.r && (y = D.e.c + 1 - o, g = -1);
        }
        b = +w.getAttribute("colspan") || 1, ((A = +w.getAttribute("rowspan") || 1) > 1 || b > 1) && h.push({ s: { r: m + s, c: y + o }, e: { r: m + s + (A || 1) - 1, c: y + o + (b || 1) - 1 } });
        var k = { t: "s", v: R }, W = w.getAttribute("data-t") || w.getAttribute("t") || "";
        R != null && (R.length == 0 ? k.t = W || "z" : a.raw || R.trim().length == 0 || W == "s" || (R === "TRUE" ? k = { t: "b", v: !0 } : R === "FALSE" ? k = { t: "b", v: !1 } : isNaN(fuzzynum(R)) ? isNaN(fuzzydate(R).getDate()) || (k = { t: "d", v: parseDate(R) }, a.cellDates || (k = { t: "n", v: datenum(k.v) }), k.z = a.dateNF || table_fmt[14]) : k = { t: "n", v: fuzzynum(R) })), k.z === void 0 && O != null && (k.z = O);
        var L = "", z = w.getElementsByTagName("A");
        if (z && z.length)
          for (var P = 0; P < z.length && !(z[P].hasAttribute("href") && (L = z[P].getAttribute("href"), L.charAt(0) != "#")); ++P)
            ;
        L && L.charAt(0) != "#" && (k.l = { Target: L }), a.dense ? (t[m + s] || (t[m + s] = []), t[m + s][y + o] = k) : t[encode_cell({ c: y + o, r: m + s })] = k, d.e.c < y + o && (d.e.c = y + o), y += b;
      }
    }
    ++m;
  }
  return h.length && (t["!merges"] = (t["!merges"] || []).concat(h)), d.e.r = Math.max(d.e.r, m - 1 + s), t["!ref"] = encode_range(d), m >= u && (t["!fullref"] = encode_range((d.e.r = c.length - E + m - 1 + s, d))), t;
}
function parse_dom_table(t, e) {
  var n = e || {}, a = n.dense ? [] : {};
  return sheet_add_dom(a, t, e);
}
function table_to_book(t, e) {
  return sheet_to_workbook(parse_dom_table(t, e), e);
}
function is_dom_element_hidden(t) {
  var e = "", n = get_get_computed_style_function(t);
  return n && (e = n(t).getPropertyValue("display")), e || (e = t.style && t.style.display), e === "none";
}
function get_get_computed_style_function(t) {
  return t.ownerDocument.defaultView && typeof t.ownerDocument.defaultView.getComputedStyle == "function" ? t.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
function parse_text_p(t) {
  var e = t.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(a, s) {
    return Array(parseInt(s, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), n = unescapexml(e.replace(/<[^>]*>/g, ""));
  return [n];
}
var number_formats_ods = {
  /* ods name: [short ssf fmt, long ssf fmt] */
  day: ["d", "dd"],
  month: ["m", "mm"],
  year: ["y", "yy"],
  hours: ["h", "hh"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  "am-pm": ["A/P", "AM/PM"],
  "day-of-week": ["ddd", "dddd"],
  era: ["e", "ee"],
  /* there is no native representation of LO "Q" format */
  quarter: ["\\Qm", 'm\\"th quarter"']
};
function parse_content_xml(t, e) {
  var n = e || {}, a = xlml_normalize(t), s = [], o, l, c = { name: "" }, u = "", d = 0, f, h, g = {}, x = [], E = n.dense ? [] : {}, m, v, y = { value: "" }, A = "", b = 0, C = [], T = -1, w = -1, R = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, O = 0, D = {}, k = [], W = {}, L = 0, z = 0, P = [], Q = 1, Y = 1, ie = [], te = { Names: [] }, Z = {}, ae = ["", ""], G = [], U = {}, F = "", M = 0, I = !1, N = !1, V = 0;
  for (xlmlregex.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); m = xlmlregex.exec(a); )
    switch (m[3] = m[3].replace(/_.*$/, "")) {
      case "table":
      case "工作表":
        m[1] === "/" ? (R.e.c >= R.s.c && R.e.r >= R.s.r ? E["!ref"] = encode_range(R) : E["!ref"] = "A1:A1", n.sheetRows > 0 && n.sheetRows <= R.e.r && (E["!fullref"] = E["!ref"], R.e.r = n.sheetRows - 1, E["!ref"] = encode_range(R)), k.length && (E["!merges"] = k), P.length && (E["!rows"] = P), f.name = f.名称 || f.name, typeof JSON < "u" && JSON.stringify(f), x.push(f.name), g[f.name] = E, N = !1) : m[0].charAt(m[0].length - 2) !== "/" && (f = parsexmltag(m[0], !1), T = w = -1, R.s.r = R.s.c = 1e7, R.e.r = R.e.c = 0, E = n.dense ? [] : {}, k = [], P = [], N = !0);
        break;
      case "table-row-group":
        m[1] === "/" ? --O : ++O;
        break;
      case "table-row":
      case "行":
        if (m[1] === "/") {
          T += Q, Q = 1;
          break;
        }
        if (h = parsexmltag(m[0], !1), h.行号 ? T = h.行号 - 1 : T == -1 && (T = 0), Q = +h["number-rows-repeated"] || 1, Q < 10)
          for (V = 0; V < Q; ++V)
            O > 0 && (P[T + V] = { level: O });
        w = -1;
        break;
      case "covered-table-cell":
        m[1] !== "/" && ++w, n.sheetStubs && (n.dense ? (E[T] || (E[T] = []), E[T][w] = { t: "z" }) : E[encode_cell({ r: T, c: w })] = { t: "z" }), A = "", C = [];
        break;
      case "table-cell":
      case "数据":
        if (m[0].charAt(m[0].length - 2) === "/")
          ++w, y = parsexmltag(m[0], !1), Y = parseInt(y["number-columns-repeated"] || "1", 10), v = {
            t: "z",
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, y.formula && n.cellFormula != !1 && (v.f = ods_to_csf_formula(unescapexml(y.formula))), (y.数据类型 || y["value-type"]) == "string" && (v.t = "s", v.v = unescapexml(y["string-value"] || ""), n.dense ? (E[T] || (E[T] = []), E[T][w] = v) : E[encode_cell({ r: T, c: w })] = v), w += Y - 1;
        else if (m[1] !== "/") {
          ++w, A = "", b = 0, C = [], Y = 1;
          var q = Q ? T + Q - 1 : T;
          if (w > R.e.c && (R.e.c = w), w < R.s.c && (R.s.c = w), T < R.s.r && (R.s.r = T), q > R.e.r && (R.e.r = q), y = parsexmltag(m[0], !1), G = [], U = {}, v = {
            t: y.数据类型 || y["value-type"],
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, n.cellFormula)
            if (y.formula && (y.formula = unescapexml(y.formula)), y["number-matrix-columns-spanned"] && y["number-matrix-rows-spanned"] && (L = parseInt(y["number-matrix-rows-spanned"], 10) || 0, z = parseInt(y["number-matrix-columns-spanned"], 10) || 0, W = { s: { r: T, c: w }, e: { r: T + L - 1, c: w + z - 1 } }, v.F = encode_range(W), ie.push([W, v.F])), y.formula)
              v.f = ods_to_csf_formula(y.formula);
            else
              for (V = 0; V < ie.length; ++V)
                T >= ie[V][0].s.r && T <= ie[V][0].e.r && w >= ie[V][0].s.c && w <= ie[V][0].e.c && (v.F = ie[V][1]);
          switch ((y["number-columns-spanned"] || y["number-rows-spanned"]) && (L = parseInt(y["number-rows-spanned"], 10) || 0, z = parseInt(y["number-columns-spanned"], 10) || 0, W = { s: { r: T, c: w }, e: { r: T + L - 1, c: w + z - 1 } }, k.push(W)), y["number-columns-repeated"] && (Y = parseInt(y["number-columns-repeated"], 10)), v.t) {
            case "boolean":
              v.t = "b", v.v = parsexmlbool(y["boolean-value"]);
              break;
            case "float":
              v.t = "n", v.v = parseFloat(y.value);
              break;
            case "percentage":
              v.t = "n", v.v = parseFloat(y.value);
              break;
            case "currency":
              v.t = "n", v.v = parseFloat(y.value);
              break;
            case "date":
              v.t = "d", v.v = parseDate(y["date-value"]), n.cellDates || (v.t = "n", v.v = datenum(v.v)), v.z = "m/d/yy";
              break;
            case "time":
              v.t = "n", v.v = parse_isodur(y["time-value"]) / 86400, n.cellDates && (v.t = "d", v.v = numdate(v.v)), v.z = "HH:MM:SS";
              break;
            case "number":
              v.t = "n", v.v = parseFloat(y.数据数值);
              break;
            default:
              if (v.t === "string" || v.t === "text" || !v.t)
                v.t = "s", y["string-value"] != null && (A = unescapexml(y["string-value"]), C = []);
              else
                throw new Error("Unsupported value type " + v.t);
          }
        } else {
          if (I = !1, v.t === "s" && (v.v = A || "", C.length && (v.R = C), I = b == 0), Z.Target && (v.l = Z), G.length > 0 && (v.c = G, G = []), A && n.cellText !== !1 && (v.w = A), I && (v.t = "z", delete v.v), (!I || n.sheetStubs) && !(n.sheetRows && n.sheetRows <= T))
            for (var H = 0; H < Q; ++H) {
              if (Y = parseInt(y["number-columns-repeated"] || "1", 10), n.dense)
                for (E[T + H] || (E[T + H] = []), E[T + H][w] = H == 0 ? v : dup(v); --Y > 0; )
                  E[T + H][w + Y] = dup(v);
              else
                for (E[encode_cell({ r: T + H, c: w })] = v; --Y > 0; )
                  E[encode_cell({ r: T + H, c: w + Y })] = dup(v);
              R.e.c <= w && (R.e.c = w);
            }
          Y = parseInt(y["number-columns-repeated"] || "1", 10), w += Y - 1, Y = 0, v = {
            /*:: t:"", v:null, z:null, w:"",c:[]*/
          }, A = "", C = [];
        }
        Z = {};
        break;
      case "document":
      case "document-content":
      case "电子表格文档":
      case "spreadsheet":
      case "主体":
      case "scripts":
      case "styles":
      case "font-face-decls":
      case "master-styles":
        if (m[1] === "/") {
          if ((o = s.pop())[0] !== m[3])
            throw "Bad state: " + o;
        } else
          m[0].charAt(m[0].length - 2) !== "/" && s.push([m[3], !0]);
        break;
      case "annotation":
        if (m[1] === "/") {
          if ((o = s.pop())[0] !== m[3])
            throw "Bad state: " + o;
          U.t = A, C.length && (U.R = C), U.a = F, G.push(U);
        } else
          m[0].charAt(m[0].length - 2) !== "/" && s.push([m[3], !1]);
        F = "", M = 0, A = "", b = 0, C = [];
        break;
      case "creator":
        m[1] === "/" ? F = a.slice(M, m.index) : M = m.index + m[0].length;
        break;
      case "meta":
      case "元数据":
      case "settings":
      case "config-item-set":
      case "config-item-map-indexed":
      case "config-item-map-entry":
      case "config-item-map-named":
      case "shapes":
      case "frame":
      case "text-box":
      case "image":
      case "data-pilot-tables":
      case "list-style":
      case "form":
      case "dde-links":
      case "event-listeners":
      case "chart":
        if (m[1] === "/") {
          if ((o = s.pop())[0] !== m[3])
            throw "Bad state: " + o;
        } else
          m[0].charAt(m[0].length - 2) !== "/" && s.push([m[3], !1]);
        A = "", b = 0, C = [];
        break;
      case "scientific-number":
        break;
      case "currency-symbol":
        break;
      case "currency-style":
        break;
      case "number-style":
      case "percentage-style":
      case "date-style":
      case "time-style":
        if (m[1] === "/") {
          if (D[c.name] = u, (o = s.pop())[0] !== m[3])
            throw "Bad state: " + o;
        } else
          m[0].charAt(m[0].length - 2) !== "/" && (u = "", c = parsexmltag(m[0], !1), s.push([m[3], !0]));
        break;
      case "script":
        break;
      case "libraries":
        break;
      case "automatic-styles":
        break;
      case "default-style":
      case "page-layout":
        break;
      case "style":
        break;
      case "map":
        break;
      case "font-face":
        break;
      case "paragraph-properties":
        break;
      case "table-properties":
        break;
      case "table-column-properties":
        break;
      case "table-row-properties":
        break;
      case "table-cell-properties":
        break;
      case "number":
        switch (s[s.length - 1][0]) {
          case "time-style":
          case "date-style":
            l = parsexmltag(m[0], !1), u += number_formats_ods[m[3]][l.style === "long" ? 1 : 0];
            break;
        }
        break;
      case "fraction":
        break;
      case "day":
      case "month":
      case "year":
      case "era":
      case "day-of-week":
      case "week-of-year":
      case "quarter":
      case "hours":
      case "minutes":
      case "seconds":
      case "am-pm":
        switch (s[s.length - 1][0]) {
          case "time-style":
          case "date-style":
            l = parsexmltag(m[0], !1), u += number_formats_ods[m[3]][l.style === "long" ? 1 : 0];
            break;
        }
        break;
      case "boolean-style":
        break;
      case "boolean":
        break;
      case "text-style":
        break;
      case "text":
        if (m[0].slice(-2) === "/>")
          break;
        if (m[1] === "/")
          switch (s[s.length - 1][0]) {
            case "number-style":
            case "date-style":
            case "time-style":
              u += a.slice(d, m.index);
              break;
          }
        else
          d = m.index + m[0].length;
        break;
      case "named-range":
        l = parsexmltag(m[0], !1), ae = ods_to_csf_3D(l["cell-range-address"]);
        var ne = { Name: l.name, Ref: ae[0] + "!" + ae[1] };
        N && (ne.Sheet = x.length), te.Names.push(ne);
        break;
      case "text-content":
        break;
      case "text-properties":
        break;
      case "embedded-text":
        break;
      case "body":
      case "电子表格":
        break;
      case "forms":
        break;
      case "table-column":
        break;
      case "table-header-rows":
        break;
      case "table-rows":
        break;
      case "table-column-group":
        break;
      case "table-header-columns":
        break;
      case "table-columns":
        break;
      case "null-date":
        break;
      case "graphic-properties":
        break;
      case "calculation-settings":
        break;
      case "named-expressions":
        break;
      case "label-range":
        break;
      case "label-ranges":
        break;
      case "named-expression":
        break;
      case "sort":
        break;
      case "sort-by":
        break;
      case "sort-groups":
        break;
      case "tab":
        break;
      case "line-break":
        break;
      case "span":
        break;
      case "p":
      case "文本串":
        if (["master-styles"].indexOf(s[s.length - 1][0]) > -1)
          break;
        if (m[1] === "/" && (!y || !y["string-value"])) {
          var he = parse_text_p(a.slice(b, m.index));
          A = (A.length > 0 ? A + `
` : "") + he[0];
        } else
          parsexmltag(m[0], !1), b = m.index + m[0].length;
        break;
      case "s":
        break;
      case "database-range":
        if (m[1] === "/")
          break;
        try {
          ae = ods_to_csf_3D(parsexmltag(m[0])["target-range-address"]), g[ae[0]]["!autofilter"] = { ref: ae[1] };
        } catch {
        }
        break;
      case "date":
        break;
      case "object":
        break;
      case "title":
      case "标题":
        break;
      case "desc":
        break;
      case "binary-data":
        break;
      case "table-source":
        break;
      case "scenario":
        break;
      case "iteration":
        break;
      case "content-validations":
        break;
      case "content-validation":
        break;
      case "help-message":
        break;
      case "error-message":
        break;
      case "database-ranges":
        break;
      case "filter":
        break;
      case "filter-and":
        break;
      case "filter-or":
        break;
      case "filter-condition":
        break;
      case "list-level-style-bullet":
        break;
      case "list-level-style-number":
        break;
      case "list-level-properties":
        break;
      case "sender-firstname":
      case "sender-lastname":
      case "sender-initials":
      case "sender-title":
      case "sender-position":
      case "sender-email":
      case "sender-phone-private":
      case "sender-fax":
      case "sender-company":
      case "sender-phone-work":
      case "sender-street":
      case "sender-city":
      case "sender-postal-code":
      case "sender-country":
      case "sender-state-or-province":
      case "author-name":
      case "author-initials":
      case "chapter":
      case "file-name":
      case "template-name":
      case "sheet-name":
        break;
      case "event-listener":
        break;
      case "initial-creator":
      case "creation-date":
      case "print-date":
      case "generator":
      case "document-statistic":
      case "user-defined":
      case "editing-duration":
      case "editing-cycles":
        break;
      case "config-item":
        break;
      case "page-number":
        break;
      case "page-count":
        break;
      case "time":
        break;
      case "cell-range-source":
        break;
      case "detective":
        break;
      case "operation":
        break;
      case "highlighted-range":
        break;
      case "data-pilot-table":
      case "source-cell-range":
      case "source-service":
      case "data-pilot-field":
      case "data-pilot-level":
      case "data-pilot-subtotals":
      case "data-pilot-subtotal":
      case "data-pilot-members":
      case "data-pilot-member":
      case "data-pilot-display-info":
      case "data-pilot-sort-info":
      case "data-pilot-layout-info":
      case "data-pilot-field-reference":
      case "data-pilot-groups":
      case "data-pilot-group":
      case "data-pilot-group-member":
        break;
      case "rect":
        break;
      case "dde-connection-decls":
      case "dde-connection-decl":
      case "dde-link":
      case "dde-source":
        break;
      case "properties":
        break;
      case "property":
        break;
      case "a":
        if (m[1] !== "/") {
          if (Z = parsexmltag(m[0], !1), !Z.href)
            break;
          Z.Target = unescapexml(Z.href), delete Z.href, Z.Target.charAt(0) == "#" && Z.Target.indexOf(".") > -1 ? (ae = ods_to_csf_3D(Z.Target.slice(1)), Z.Target = "#" + ae[0] + "!" + ae[1]) : Z.Target.match(/^\.\.[\\\/]/) && (Z.Target = Z.Target.slice(3));
        }
        break;
      case "table-protection":
        break;
      case "data-pilot-grand-total":
        break;
      case "office-document-common-attrs":
        break;
      default:
        switch (m[2]) {
          case "dc:":
          case "calcext:":
          case "loext:":
          case "ooo:":
          case "chartooo:":
          case "draw:":
          case "style:":
          case "chart:":
          case "form:":
          case "uof:":
          case "表:":
          case "字:":
            break;
          default:
            if (n.WTF)
              throw new Error(m);
        }
    }
  var j = {
    Sheets: g,
    SheetNames: x,
    Workbook: te
  };
  return n.bookSheets && delete /*::(*/
  j.Sheets, j;
}
function parse_ods(t, e) {
  e = e || {}, safegetzipfile(t, "META-INF/manifest.xml") && parse_manifest(getzipdata(t, "META-INF/manifest.xml"), e);
  var n = getzipstr(t, "content.xml");
  if (!n)
    throw new Error("Missing content.xml in ODS / UOF file");
  var a = parse_content_xml(utf8read(n), e);
  return safegetzipfile(t, "meta.xml") && (a.Props = parse_core_props(getzipdata(t, "meta.xml"))), a;
}
function parse_fods(t, e) {
  return parse_content_xml(t, e);
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function u8_to_dataview(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
function u8str(t) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(t) : utf8read(a2s(t));
}
function u8concat(t) {
  var e = t.reduce(function(s, o) {
    return s + o.length;
  }, 0), n = new Uint8Array(e), a = 0;
  return t.forEach(function(s) {
    n.set(s, a), a += s.length;
  }), n;
}
function popcnt(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), (t + (t >> 4) & 252645135) * 16843009 >>> 24;
}
function readDecimal128LE(t, e) {
  for (var n = (t[e + 15] & 127) << 7 | t[e + 14] >> 1, a = t[e + 14] & 1, s = e + 13; s >= e; --s)
    a = a * 256 + t[s];
  return (t[e + 15] & 128 ? -a : a) * Math.pow(10, n - 6176);
}
function parse_varint49(t, e) {
  var n = e ? e[0] : 0, a = t[n] & 127;
  e:
    if (t[n++] >= 128 && (a |= (t[n] & 127) << 7, t[n++] < 128 || (a |= (t[n] & 127) << 14, t[n++] < 128) || (a |= (t[n] & 127) << 21, t[n++] < 128) || (a += (t[n] & 127) * Math.pow(2, 28), ++n, t[n++] < 128) || (a += (t[n] & 127) * Math.pow(2, 35), ++n, t[n++] < 128) || (a += (t[n] & 127) * Math.pow(2, 42), ++n, t[n++] < 128)))
      break e;
  return e && (e[0] = n), a;
}
function varint_to_i32(t) {
  var e = 0, n = t[e] & 127;
  e:
    if (t[e++] >= 128) {
      if (n |= (t[e] & 127) << 7, t[e++] < 128 || (n |= (t[e] & 127) << 14, t[e++] < 128) || (n |= (t[e] & 127) << 21, t[e++] < 128))
        break e;
      n |= (t[e] & 127) << 28;
    }
  return n;
}
function parse_shallow(t) {
  for (var e = [], n = [0]; n[0] < t.length; ) {
    var a = n[0], s = parse_varint49(t, n), o = s & 7;
    s = Math.floor(s / 8);
    var l = 0, c;
    if (s == 0)
      break;
    switch (o) {
      case 0:
        {
          for (var u = n[0]; t[n[0]++] >= 128; )
            ;
          c = t.slice(u, n[0]);
        }
        break;
      case 5:
        l = 4, c = t.slice(n[0], n[0] + l), n[0] += l;
        break;
      case 1:
        l = 8, c = t.slice(n[0], n[0] + l), n[0] += l;
        break;
      case 2:
        l = parse_varint49(t, n), c = t.slice(n[0], n[0] + l), n[0] += l;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(o, " for Field ").concat(s, " at offset ").concat(a));
    }
    var d = { data: c, type: o };
    e[s] == null ? e[s] = [d] : e[s].push(d);
  }
  return e;
}
function mappa(t, e) {
  return (t == null ? void 0 : t.map(function(n) {
    return e(n.data);
  })) || [];
}
function parse_iwa_file(t) {
  for (var e, n = [], a = [0]; a[0] < t.length; ) {
    var s = parse_varint49(t, a), o = parse_shallow(t.slice(a[0], a[0] + s));
    a[0] += s;
    var l = {
      id: varint_to_i32(o[1][0].data),
      messages: []
    };
    o[2].forEach(function(c) {
      var u = parse_shallow(c.data), d = varint_to_i32(u[3][0].data);
      l.messages.push({
        meta: u,
        data: t.slice(a[0], a[0] + d)
      }), a[0] += d;
    }), (e = o[3]) != null && e[0] && (l.merge = varint_to_i32(o[3][0].data) >>> 0 > 0), n.push(l);
  }
  return n;
}
function parse_snappy_chunk(t, e) {
  if (t != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(t));
  for (var n = [0], a = parse_varint49(e, n), s = []; n[0] < e.length; ) {
    var o = e[n[0]] & 3;
    if (o == 0) {
      var l = e[n[0]++] >> 2;
      if (l < 60)
        ++l;
      else {
        var c = l - 59;
        l = e[n[0]], c > 1 && (l |= e[n[0] + 1] << 8), c > 2 && (l |= e[n[0] + 2] << 16), c > 3 && (l |= e[n[0] + 3] << 24), l >>>= 0, l++, n[0] += c;
      }
      s.push(e.slice(n[0], n[0] + l)), n[0] += l;
      continue;
    } else {
      var u = 0, d = 0;
      if (o == 1 ? (d = (e[n[0]] >> 2 & 7) + 4, u = (e[n[0]++] & 224) << 3, u |= e[n[0]++]) : (d = (e[n[0]++] >> 2) + 1, o == 2 ? (u = e[n[0]] | e[n[0] + 1] << 8, n[0] += 2) : (u = (e[n[0]] | e[n[0] + 1] << 8 | e[n[0] + 2] << 16 | e[n[0] + 3] << 24) >>> 0, n[0] += 4)), s = [u8concat(s)], u == 0)
        throw new Error("Invalid offset 0");
      if (u > s[0].length)
        throw new Error("Invalid offset beyond length");
      if (d >= u)
        for (s.push(s[0].slice(-u)), d -= u; d >= s[s.length - 1].length; )
          s.push(s[s.length - 1]), d -= s[s.length - 1].length;
      s.push(s[0].slice(-u, -u + d));
    }
  }
  var f = u8concat(s);
  if (f.length != a)
    throw new Error("Unexpected length: ".concat(f.length, " != ").concat(a));
  return f;
}
function decompress_iwa_file(t) {
  for (var e = [], n = 0; n < t.length; ) {
    var a = t[n++], s = t[n] | t[n + 1] << 8 | t[n + 2] << 16;
    n += 3, e.push(parse_snappy_chunk(a, t.slice(n, n + s))), n += s;
  }
  if (n !== t.length)
    throw new Error("data is not a valid framed stream!");
  return u8concat(e);
}
function parse_old_storage(t, e, n, a) {
  var s = u8_to_dataview(t), o = s.getUint32(4, !0), l = (a > 1 ? 12 : 8) + popcnt(o & (a > 1 ? 3470 : 398)) * 4, c = -1, u = -1, d = NaN, f = new Date(2001, 0, 1);
  o & 512 && (c = s.getUint32(l, !0), l += 4), l += popcnt(o & (a > 1 ? 12288 : 4096)) * 4, o & 16 && (u = s.getUint32(l, !0), l += 4), o & 32 && (d = s.getFloat64(l, !0), l += 8), o & 64 && (f.setTime(f.getTime() + s.getFloat64(l, !0) * 1e3), l += 8);
  var h;
  switch (t[2]) {
    case 0:
      break;
    case 2:
      h = { t: "n", v: d };
      break;
    case 3:
      h = { t: "s", v: e[u] };
      break;
    case 5:
      h = { t: "d", v: f };
      break;
    case 6:
      h = { t: "b", v: d > 0 };
      break;
    case 7:
      h = { t: "n", v: d / 86400 };
      break;
    case 8:
      h = { t: "e", v: 0 };
      break;
    case 9:
      if (c > -1)
        h = { t: "s", v: n[c] };
      else if (u > -1)
        h = { t: "s", v: e[u] };
      else if (!isNaN(d))
        h = { t: "n", v: d };
      else
        throw new Error("Unsupported cell type ".concat(t.slice(0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(t.slice(0, 4)));
  }
  return h;
}
function parse_new_storage(t, e, n) {
  var a = u8_to_dataview(t), s = a.getUint32(8, !0), o = 12, l = -1, c = -1, u = NaN, d = NaN, f = new Date(2001, 0, 1);
  s & 1 && (u = readDecimal128LE(t, o), o += 16), s & 2 && (d = a.getFloat64(o, !0), o += 8), s & 4 && (f.setTime(f.getTime() + a.getFloat64(o, !0) * 1e3), o += 8), s & 8 && (c = a.getUint32(o, !0), o += 4), s & 16 && (l = a.getUint32(o, !0), o += 4);
  var h;
  switch (t[1]) {
    case 0:
      break;
    case 2:
      h = { t: "n", v: u };
      break;
    case 3:
      h = { t: "s", v: e[c] };
      break;
    case 5:
      h = { t: "d", v: f };
      break;
    case 6:
      h = { t: "b", v: d > 0 };
      break;
    case 7:
      h = { t: "n", v: d / 86400 };
      break;
    case 8:
      h = { t: "e", v: 0 };
      break;
    case 9:
      if (l > -1)
        h = { t: "s", v: n[l] };
      else
        throw new Error("Unsupported cell type ".concat(t[1], " : ").concat(s & 31, " : ").concat(t.slice(0, 4)));
      break;
    case 10:
      h = { t: "n", v: u };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(t[1], " : ").concat(s & 31, " : ").concat(t.slice(0, 4)));
  }
  return h;
}
function parse_cell_storage(t, e, n) {
  switch (t[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return parse_old_storage(t, e, n, t[0]);
    case 5:
      return parse_new_storage(t, e, n);
    default:
      throw new Error("Unsupported payload version ".concat(t[0]));
  }
}
function parse_TSP_Reference(t) {
  var e = parse_shallow(t);
  return parse_varint49(e[1][0].data);
}
function parse_TST_TableDataList(t, e) {
  var n = parse_shallow(e.data), a = varint_to_i32(n[1][0].data), s = n[3], o = [];
  return (s || []).forEach(function(l) {
    var c = parse_shallow(l.data), u = varint_to_i32(c[1][0].data) >>> 0;
    switch (a) {
      case 1:
        o[u] = u8str(c[3][0].data);
        break;
      case 8:
        {
          var d = t[parse_TSP_Reference(c[9][0].data)][0], f = parse_shallow(d.data), h = t[parse_TSP_Reference(f[1][0].data)][0], g = varint_to_i32(h.meta[1][0].data);
          if (g != 2001)
            throw new Error("2000 unexpected reference to ".concat(g));
          var x = parse_shallow(h.data);
          o[u] = x[3].map(function(E) {
            return u8str(E.data);
          }).join("");
        }
        break;
    }
  }), o;
}
function parse_TST_TileRowInfo(t, e) {
  var n, a, s, o, l, c, u, d, f, h, g, x, E, m, v = parse_shallow(t), y = varint_to_i32(v[1][0].data) >>> 0, A = varint_to_i32(v[2][0].data) >>> 0, b = ((a = (n = v[8]) == null ? void 0 : n[0]) == null ? void 0 : a.data) && varint_to_i32(v[8][0].data) > 0 || !1, C, T;
  if ((o = (s = v[7]) == null ? void 0 : s[0]) != null && o.data && e != 0)
    C = (c = (l = v[7]) == null ? void 0 : l[0]) == null ? void 0 : c.data, T = (d = (u = v[6]) == null ? void 0 : u[0]) == null ? void 0 : d.data;
  else if ((h = (f = v[4]) == null ? void 0 : f[0]) != null && h.data && e != 1)
    C = (x = (g = v[4]) == null ? void 0 : g[0]) == null ? void 0 : x.data, T = (m = (E = v[3]) == null ? void 0 : E[0]) == null ? void 0 : m.data;
  else
    throw "NUMBERS Tile missing ".concat(e, " cell storage");
  for (var w = b ? 4 : 1, R = u8_to_dataview(C), O = [], D = 0; D < C.length / 2; ++D) {
    var k = R.getUint16(D * 2, !0);
    k < 65535 && O.push([D, k]);
  }
  if (O.length != A)
    throw "Expected ".concat(A, " cells, found ").concat(O.length);
  var W = [];
  for (D = 0; D < O.length - 1; ++D)
    W[O[D][0]] = T.subarray(O[D][1] * w, O[D + 1][1] * w);
  return O.length >= 1 && (W[O[O.length - 1][0]] = T.subarray(O[O.length - 1][1] * w)), { R: y, cells: W };
}
function parse_TST_Tile(t, e) {
  var n, a = parse_shallow(e.data), s = (n = a == null ? void 0 : a[7]) != null && n[0] ? varint_to_i32(a[7][0].data) >>> 0 > 0 ? 1 : 0 : -1, o = mappa(a[5], function(l) {
    return parse_TST_TileRowInfo(l, s);
  });
  return {
    nrows: varint_to_i32(a[4][0].data) >>> 0,
    data: o.reduce(function(l, c) {
      return l[c.R] || (l[c.R] = []), c.cells.forEach(function(u, d) {
        if (l[c.R][d])
          throw new Error("Duplicate cell r=".concat(c.R, " c=").concat(d));
        l[c.R][d] = u;
      }), l;
    }, [])
  };
}
function parse_TST_TableModelArchive(t, e, n) {
  var a, s = parse_shallow(e.data), o = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (o.e.r = (varint_to_i32(s[6][0].data) >>> 0) - 1, o.e.r < 0)
    throw new Error("Invalid row varint ".concat(s[6][0].data));
  if (o.e.c = (varint_to_i32(s[7][0].data) >>> 0) - 1, o.e.c < 0)
    throw new Error("Invalid col varint ".concat(s[7][0].data));
  n["!ref"] = encode_range(o);
  var l = parse_shallow(s[4][0].data), c = parse_TST_TableDataList(t, t[parse_TSP_Reference(l[4][0].data)][0]), u = (a = l[17]) != null && a[0] ? parse_TST_TableDataList(t, t[parse_TSP_Reference(l[17][0].data)][0]) : [], d = parse_shallow(l[3][0].data), f = 0;
  d[1].forEach(function(h) {
    var g = parse_shallow(h.data), x = t[parse_TSP_Reference(g[2][0].data)][0], E = varint_to_i32(x.meta[1][0].data);
    if (E != 6002)
      throw new Error("6001 unexpected reference to ".concat(E));
    var m = parse_TST_Tile(t, x);
    m.data.forEach(function(v, y) {
      v.forEach(function(A, b) {
        var C = encode_cell({ r: f + y, c: b }), T = parse_cell_storage(A, c, u);
        T && (n[C] = T);
      });
    }), f += m.nrows;
  });
}
function parse_TST_TableInfoArchive(t, e) {
  var n = parse_shallow(e.data), a = { "!ref": "A1" }, s = t[parse_TSP_Reference(n[2][0].data)], o = varint_to_i32(s[0].meta[1][0].data);
  if (o != 6001)
    throw new Error("6000 unexpected reference to ".concat(o));
  return parse_TST_TableModelArchive(t, s[0], a), a;
}
function parse_TN_SheetArchive(t, e) {
  var n, a = parse_shallow(e.data), s = {
    name: (n = a[1]) != null && n[0] ? u8str(a[1][0].data) : "",
    sheets: []
  }, o = mappa(a[2], parse_TSP_Reference);
  return o.forEach(function(l) {
    t[l].forEach(function(c) {
      var u = varint_to_i32(c.meta[1][0].data);
      u == 6e3 && s.sheets.push(parse_TST_TableInfoArchive(t, c));
    });
  }), s;
}
function parse_TN_DocumentArchive(t, e) {
  var n = book_new(), a = parse_shallow(e.data), s = mappa(a[1], parse_TSP_Reference);
  if (s.forEach(function(o) {
    t[o].forEach(function(l) {
      var c = varint_to_i32(l.meta[1][0].data);
      if (c == 2) {
        var u = parse_TN_SheetArchive(t, l);
        u.sheets.forEach(function(d, f) {
          book_append_sheet(n, d, f == 0 ? u.name : u.name + "_" + f, !0);
        });
      }
    });
  }), n.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return n;
}
function parse_numbers_iwa(t) {
  var e, n, a, s, o = {}, l = [];
  if (t.FullPaths.forEach(function(u) {
    if (u.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), t.FileIndex.forEach(function(u) {
    if (u.name.match(/\.iwa$/)) {
      var d;
      try {
        d = decompress_iwa_file(u.content);
      } catch (h) {
        return console.log("?? " + u.content.length + " " + (h.message || h));
      }
      var f;
      try {
        f = parse_iwa_file(d);
      } catch (h) {
        return console.log("## " + (h.message || h));
      }
      f.forEach(function(h) {
        o[h.id] = h.messages, l.push(h.id);
      });
    }
  }), !l.length)
    throw new Error("File has no messages");
  var c = ((s = (a = (n = (e = o == null ? void 0 : o[1]) == null ? void 0 : e[0]) == null ? void 0 : n.meta) == null ? void 0 : a[1]) == null ? void 0 : s[0].data) && varint_to_i32(o[1][0].meta[1][0].data) == 1 && o[1][0];
  if (c || l.forEach(function(u) {
    o[u].forEach(function(d) {
      var f = varint_to_i32(d.meta[1][0].data) >>> 0;
      if (f == 1)
        if (!c)
          c = d;
        else
          throw new Error("Document has multiple roots");
    });
  }), !c)
    throw new Error("Cannot find Document root");
  return parse_TN_DocumentArchive(o, c);
}
function fix_opts_func(t) {
  return function(n) {
    for (var a = 0; a != t.length; ++a) {
      var s = t[a];
      n[s[0]] === void 0 && (n[s[0]] = s[1]), s[2] === "n" && (n[s[0]] = Number(n[s[0]]));
    }
  };
}
function fix_read_opts(t) {
  fix_opts_func([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(t);
}
function get_sheet_type(t) {
  return RELS.WS.indexOf(t) > -1 ? "sheet" : t == RELS.CS ? "chart" : t == RELS.DS ? "dialog" : t == RELS.MS ? "macro" : t && t.length ? t : "sheet";
}
function safe_parse_wbrels(t, e) {
  if (!t)
    return 0;
  try {
    t = e.map(function(a) {
      return a.id || (a.id = a.strRelID), [a.name, t["!id"][a.id].Target, get_sheet_type(t["!id"][a.id].Type)];
    });
  } catch {
    return null;
  }
  return !t || t.length === 0 ? null : t;
}
function safe_parse_sheet(t, e, n, a, s, o, l, c, u, d, f, h) {
  try {
    o[a] = parse_rels(getzipstr(t, n, !0), e);
    var g = getzipdata(t, e), x;
    switch (c) {
      case "sheet":
        x = parse_ws(g, e, s, u, o[a], d, f, h);
        break;
      case "chart":
        if (x = parse_cs(g, e, s, u, o[a], d, f, h), !x || !x["!drawel"])
          break;
        var E = resolve_path(x["!drawel"].Target, e), m = get_rels_path(E), v = parse_drawing(getzipstr(t, E, !0), parse_rels(getzipstr(t, m, !0), E)), y = resolve_path(v, E), A = get_rels_path(y);
        x = parse_chart(getzipstr(t, y, !0), y, u, parse_rels(getzipstr(t, A, !0), y), d, x);
        break;
      case "macro":
        x = parse_ms(g, e, s, u, o[a], d, f, h);
        break;
      case "dialog":
        x = parse_ds(g, e, s, u, o[a], d, f, h);
        break;
      default:
        throw new Error("Unrecognized sheet type " + c);
    }
    l[a] = x;
    var b = [];
    o && o[a] && keys(o[a]).forEach(function(C) {
      var T = "";
      if (o[a][C].Type == RELS.CMNT) {
        T = resolve_path(o[a][C].Target, e);
        var w = parse_cmnt(getzipdata(t, T, !0), T, u);
        if (!w || !w.length)
          return;
        sheet_insert_comments(x, w, !1);
      }
      o[a][C].Type == RELS.TCMNT && (T = resolve_path(o[a][C].Target, e), b = b.concat(parse_tcmnt_xml(getzipdata(t, T, !0), u)));
    }), b && b.length && sheet_insert_comments(x, b, !0, u.people || []);
  } catch (C) {
    if (u.WTF)
      throw C;
  }
}
function strip_front_slash(t) {
  return t.charAt(0) == "/" ? t.slice(1) : t;
}
function parse_zip(t, e) {
  if (make_ssf(), e = e || {}, fix_read_opts(e), safegetzipfile(t, "META-INF/manifest.xml") || safegetzipfile(t, "objectdata.xml"))
    return parse_ods(t, e);
  if (safegetzipfile(t, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u")
      throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof parse_numbers_iwa < "u") {
      if (t.FileIndex)
        return parse_numbers_iwa(t);
      var n = CFB.utils.cfb_new();
      return zipentries(t).forEach(function(P) {
        zip_add_file(n, P, getzipbin(t, P));
      }), parse_numbers_iwa(n);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!safegetzipfile(t, "[Content_Types].xml"))
    throw safegetzipfile(t, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : safegetzipfile(t, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
  var a = zipentries(t), s = parse_ct(getzipstr(t, "[Content_Types].xml")), o = !1, l, c;
  if (s.workbooks.length === 0 && (c = "xl/workbook.xml", getzipdata(t, c, !0) && s.workbooks.push(c)), s.workbooks.length === 0) {
    if (c = "xl/workbook.bin", !getzipdata(t, c, !0))
      throw new Error("Could not find workbook");
    s.workbooks.push(c), o = !0;
  }
  s.workbooks[0].slice(-3) == "bin" && (o = !0);
  var u = {}, d = {};
  if (!e.bookSheets && !e.bookProps) {
    if (strs = [], s.sst)
      try {
        strs = parse_sst(getzipdata(t, strip_front_slash(s.sst)), s.sst, e);
      } catch (P) {
        if (e.WTF)
          throw P;
      }
    e.cellStyles && s.themes.length && (u = parse_theme(getzipstr(t, s.themes[0].replace(/^\//, ""), !0) || "", s.themes[0], e)), s.style && (d = parse_sty(getzipdata(t, strip_front_slash(s.style)), s.style, u, e));
  }
  s.links.map(function(P) {
    try {
      var Q = parse_rels(getzipstr(t, get_rels_path(strip_front_slash(P))), P);
      return parse_xlink(getzipdata(t, strip_front_slash(P)), Q, P, e);
    } catch {
    }
  });
  var f = parse_wb(getzipdata(t, strip_front_slash(s.workbooks[0])), s.workbooks[0], e), h = {}, g = "";
  s.coreprops.length && (g = getzipdata(t, strip_front_slash(s.coreprops[0]), !0), g && (h = parse_core_props(g)), s.extprops.length !== 0 && (g = getzipdata(t, strip_front_slash(s.extprops[0]), !0), g && parse_ext_props(g, h, e)));
  var x = {};
  (!e.bookSheets || e.bookProps) && s.custprops.length !== 0 && (g = getzipstr(t, strip_front_slash(s.custprops[0]), !0), g && (x = parse_cust_props(g, e)));
  var E = {};
  if ((e.bookSheets || e.bookProps) && (f.Sheets ? l = f.Sheets.map(function(Q) {
    return Q.name;
  }) : h.Worksheets && h.SheetNames.length > 0 && (l = h.SheetNames), e.bookProps && (E.Props = h, E.Custprops = x), e.bookSheets && typeof l < "u" && (E.SheetNames = l), e.bookSheets ? E.SheetNames : e.bookProps))
    return E;
  l = {};
  var m = {};
  e.bookDeps && s.calcchain && (m = parse_cc(getzipdata(t, strip_front_slash(s.calcchain)), s.calcchain));
  var v = 0, y = {}, A, b;
  {
    var C = f.Sheets;
    h.Worksheets = C.length, h.SheetNames = [];
    for (var T = 0; T != C.length; ++T)
      h.SheetNames[T] = C[T].name;
  }
  var w = o ? "bin" : "xml", R = s.workbooks[0].lastIndexOf("/"), O = (s.workbooks[0].slice(0, R + 1) + "_rels/" + s.workbooks[0].slice(R + 1) + ".rels").replace(/^\//, "");
  safegetzipfile(t, O) || (O = "xl/_rels/workbook." + w + ".rels");
  var D = parse_rels(getzipstr(t, O, !0), O.replace(/_rels.*/, "s5s"));
  (s.metadata || []).length >= 1 && (e.xlmeta = parse_xlmeta(getzipdata(t, strip_front_slash(s.metadata[0])), s.metadata[0], e)), (s.people || []).length >= 1 && (e.people = parse_people_xml(getzipdata(t, strip_front_slash(s.people[0])), e)), D && (D = safe_parse_wbrels(D, f.Sheets));
  var k = getzipdata(t, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e:
    for (v = 0; v != h.Worksheets; ++v) {
      var W = "sheet";
      if (D && D[v] ? (A = "xl/" + D[v][1].replace(/[\/]?xl\//, ""), safegetzipfile(t, A) || (A = D[v][1]), safegetzipfile(t, A) || (A = O.replace(/_rels\/.*$/, "") + D[v][1]), W = D[v][2]) : (A = "xl/worksheets/sheet" + (v + 1 - k) + "." + w, A = A.replace(/sheet0\./, "sheet.")), b = A.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), e && e.sheets != null)
        switch (typeof e.sheets) {
          case "number":
            if (v != e.sheets)
              continue e;
            break;
          case "string":
            if (h.SheetNames[v].toLowerCase() != e.sheets.toLowerCase())
              continue e;
            break;
          default:
            if (Array.isArray && Array.isArray(e.sheets)) {
              for (var L = !1, z = 0; z != e.sheets.length; ++z)
                typeof e.sheets[z] == "number" && e.sheets[z] == v && (L = 1), typeof e.sheets[z] == "string" && e.sheets[z].toLowerCase() == h.SheetNames[v].toLowerCase() && (L = 1);
              if (!L)
                continue e;
            }
        }
      safe_parse_sheet(t, A, b, h.SheetNames[v], v, y, l, W, e, f, u, d);
    }
  return E = {
    Directory: s,
    Workbook: f,
    Props: h,
    Custprops: x,
    Deps: m,
    Sheets: l,
    SheetNames: h.SheetNames,
    Strings: strs,
    Styles: d,
    Themes: u,
    SSF: dup(table_fmt)
  }, e && e.bookFiles && (t.files ? (E.keys = a, E.files = t.files) : (E.keys = [], E.files = {}, t.FullPaths.forEach(function(P, Q) {
    P = P.replace(/^Root Entry[\/]/, ""), E.keys.push(P), E.files[P] = t.FileIndex[Q];
  }))), e && e.bookVBA && (s.vba.length > 0 ? E.vbaraw = getzipdata(t, strip_front_slash(s.vba[0]), !0) : s.defaults && s.defaults.bin === CT_VBA && (E.vbaraw = getzipdata(t, "xl/vbaProject.bin", !0))), E;
}
function parse_xlsxcfb(t, e) {
  var n = e || {}, a = "Workbook", s = CFB.find(t, a);
  try {
    if (a = "/!DataSpaces/Version", s = CFB.find(t, a), !s || !s.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    if (parse_DataSpaceVersionInfo(s.content), a = "/!DataSpaces/DataSpaceMap", s = CFB.find(t, a), !s || !s.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var o = parse_DataSpaceMap(s.content);
    if (o.length !== 1 || o[0].comps.length !== 1 || o[0].comps[0].t !== 0 || o[0].name !== "StrongEncryptionDataSpace" || o[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", s = CFB.find(t, a), !s || !s.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var l = parse_DataSpaceDefinition(s.content);
    if (l.length != 1 || l[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", s = CFB.find(t, a), !s || !s.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    parse_Primary(s.content);
  } catch {
  }
  if (a = "/EncryptionInfo", s = CFB.find(t, a), !s || !s.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  var c = parse_EncryptionInfo(s.content);
  if (a = "/EncryptedPackage", s = CFB.find(t, a), !s || !s.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  if (c[0] == 4 && typeof decrypt_agile < "u")
    return decrypt_agile(c[1], s.content, n.password || "", n);
  if (c[0] == 2 && typeof decrypt_std76 < "u")
    return decrypt_std76(c[1], s.content, n.password || "", n);
  throw new Error("File is password-protected");
}
function firstbyte(t, e) {
  var n = "";
  switch ((e || {}).type || "base64") {
    case "buffer":
      return [t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7]];
    case "base64":
      n = Base64_decode(t.slice(0, 12));
      break;
    case "binary":
      n = t;
      break;
    case "array":
      return [t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7]];
    default:
      throw new Error("Unrecognized type " + (e && e.type || "undefined"));
  }
  return [n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2), n.charCodeAt(3), n.charCodeAt(4), n.charCodeAt(5), n.charCodeAt(6), n.charCodeAt(7)];
}
function read_cfb(t, e) {
  return CFB.find(t, "EncryptedPackage") ? parse_xlsxcfb(t, e) : parse_xlscfb(t, e);
}
function read_zip(t, e) {
  var n, a = t, s = e || {};
  return s.type || (s.type = has_buf && Buffer.isBuffer(t) ? "buffer" : "base64"), n = zip_read(a, s), parse_zip(n, s);
}
function read_plaintext(t, e) {
  var n = 0;
  e:
    for (; n < t.length; )
      switch (t.charCodeAt(n)) {
        case 10:
        case 13:
        case 32:
          ++n;
          break;
        case 60:
          return parse_xlml(t.slice(n), e);
        default:
          break e;
      }
  return PRN.to_workbook(t, e);
}
function read_plaintext_raw(t, e) {
  var n = "", a = firstbyte(t, e);
  switch (e.type) {
    case "base64":
      n = Base64_decode(t);
      break;
    case "binary":
      n = t;
      break;
    case "buffer":
      n = t.toString("binary");
      break;
    case "array":
      n = cc2str(t);
      break;
    default:
      throw new Error("Unrecognized type " + e.type);
  }
  return a[0] == 239 && a[1] == 187 && a[2] == 191 && (n = utf8read(n)), e.type = "binary", read_plaintext(n, e);
}
function read_utf16(t, e) {
  var n = t;
  return e.type == "base64" && (n = Base64_decode(n)), n = $cptable.utils.decode(1200, n.slice(2), "str"), e.type = "binary", read_plaintext(n, e);
}
function bstrify(t) {
  return t.match(/[^\x00-\x7F]/) ? utf8write(t) : t;
}
function read_prn(t, e, n, a) {
  return a ? (n.type = "string", PRN.to_workbook(t, n)) : PRN.to_workbook(e, n);
}
function readSync(t, e) {
  reset_cp();
  var n = e || {};
  if (typeof ArrayBuffer < "u" && t instanceof ArrayBuffer)
    return readSync(new Uint8Array(t), (n = dup(n), n.type = "array", n));
  typeof Uint8Array < "u" && t instanceof Uint8Array && !n.type && (n.type = typeof Deno < "u" ? "buffer" : "array");
  var a = t, s = [0, 0, 0, 0], o = !1;
  if (n.cellStyles && (n.cellNF = !0, n.sheetStubs = !0), _ssfopts = {}, n.dateNF && (_ssfopts.dateNF = n.dateNF), n.type || (n.type = has_buf && Buffer.isBuffer(t) ? "buffer" : "base64"), n.type == "file" && (n.type = has_buf ? "buffer" : "binary", a = read_binary(t), typeof Uint8Array < "u" && !has_buf && (n.type = "array")), n.type == "string" && (o = !0, n.type = "binary", n.codepage = 65001, a = bstrify(t)), n.type == "array" && typeof Uint8Array < "u" && t instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var l = new ArrayBuffer(3), c = new Uint8Array(l);
    if (c.foo = "bar", !c.foo)
      return n = dup(n), n.type = "array", readSync(ab2a(a), n);
  }
  switch ((s = firstbyte(a, n))[0]) {
    case 208:
      if (s[1] === 207 && s[2] === 17 && s[3] === 224 && s[4] === 161 && s[5] === 177 && s[6] === 26 && s[7] === 225)
        return read_cfb(CFB.read(a, n), n);
      break;
    case 9:
      if (s[1] <= 8)
        return parse_xlscfb(a, n);
      break;
    case 60:
      return parse_xlml(a, n);
    case 73:
      if (s[1] === 73 && s[2] === 42 && s[3] === 0)
        throw new Error("TIFF Image File is not a spreadsheet");
      if (s[1] === 68)
        return read_wb_ID(a, n);
      break;
    case 84:
      if (s[1] === 65 && s[2] === 66 && s[3] === 76)
        return DIF.to_workbook(a, n);
      break;
    case 80:
      return s[1] === 75 && s[2] < 9 && s[3] < 9 ? read_zip(a, n) : read_prn(t, a, n, o);
    case 239:
      return s[3] === 60 ? parse_xlml(a, n) : read_prn(t, a, n, o);
    case 255:
      if (s[1] === 254)
        return read_utf16(a, n);
      if (s[1] === 0 && s[2] === 2 && s[3] === 0)
        return WK_.to_workbook(a, n);
      break;
    case 0:
      if (s[1] === 0 && (s[2] >= 2 && s[3] === 0 || s[2] === 0 && (s[3] === 8 || s[3] === 9)))
        return WK_.to_workbook(a, n);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return DBF.to_workbook(a, n);
    case 123:
      if (s[1] === 92 && s[2] === 114 && s[3] === 116)
        return RTF.to_workbook(a, n);
      break;
    case 10:
    case 13:
    case 32:
      return read_plaintext_raw(a, n);
    case 137:
      if (s[1] === 80 && s[2] === 78 && s[3] === 71)
        throw new Error("PNG Image File is not a spreadsheet");
      break;
  }
  return DBF_SUPPORTED_VERSIONS.indexOf(s[0]) > -1 && s[2] <= 12 && s[3] <= 31 ? DBF.to_workbook(a, n) : read_prn(t, a, n, o);
}
function make_json_row(t, e, n, a, s, o, l, c) {
  var u = encode_row(n), d = c.defval, f = c.raw || !Object.prototype.hasOwnProperty.call(c, "raw"), h = !0, g = s === 1 ? [] : {};
  if (s !== 1)
    if (Object.defineProperty)
      try {
        Object.defineProperty(g, "__rowNum__", { value: n, enumerable: !1 });
      } catch {
        g.__rowNum__ = n;
      }
    else
      g.__rowNum__ = n;
  if (!l || t[n])
    for (var x = e.s.c; x <= e.e.c; ++x) {
      var E = l ? t[n][x] : t[a[x] + u];
      if (E === void 0 || E.t === void 0) {
        if (d === void 0)
          continue;
        o[x] != null && (g[o[x]] = d);
        continue;
      }
      var m = E.v;
      switch (E.t) {
        case "z":
          if (m == null)
            break;
          continue;
        case "e":
          m = m == 0 ? null : void 0;
          break;
        case "s":
        case "d":
        case "b":
        case "n":
          break;
        default:
          throw new Error("unrecognized type " + E.t);
      }
      if (o[x] != null) {
        if (m == null)
          if (E.t == "e" && m === null)
            g[o[x]] = null;
          else if (d !== void 0)
            g[o[x]] = d;
          else if (f && m === null)
            g[o[x]] = null;
          else
            continue;
        else
          g[o[x]] = f && (E.t !== "n" || E.t === "n" && c.rawNumbers !== !1) ? m : format_cell(E, m, c);
        m != null && (h = !1);
      }
    }
  return { row: g, isempty: h };
}
function sheet_to_json(t, e) {
  if (t == null || t["!ref"] == null)
    return [];
  var n = { t: "n", v: 0 }, a = 0, s = 1, o = [], l = 0, c = "", u = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, d = e || {}, f = d.range != null ? d.range : t["!ref"];
  switch (d.header === 1 ? a = 1 : d.header === "A" ? a = 2 : Array.isArray(d.header) ? a = 3 : d.header == null && (a = 0), typeof f) {
    case "string":
      u = safe_decode_range(f);
      break;
    case "number":
      u = safe_decode_range(t["!ref"]), u.s.r = f;
      break;
    default:
      u = f;
  }
  a > 0 && (s = 0);
  var h = encode_row(u.s.r), g = [], x = [], E = 0, m = 0, v = Array.isArray(t), y = u.s.r, A = 0, b = {};
  v && !t[y] && (t[y] = []);
  var C = d.skipHidden && t["!cols"] || [], T = d.skipHidden && t["!rows"] || [];
  for (A = u.s.c; A <= u.e.c; ++A)
    if (!(C[A] || {}).hidden)
      switch (g[A] = encode_col(A), n = v ? t[y][A] : t[g[A] + h], a) {
        case 1:
          o[A] = A - u.s.c;
          break;
        case 2:
          o[A] = g[A];
          break;
        case 3:
          o[A] = d.header[A - u.s.c];
          break;
        default:
          if (n == null && (n = { w: "__EMPTY", t: "s" }), c = l = format_cell(n, null, d), m = b[l] || 0, !m)
            b[l] = 1;
          else {
            do
              c = l + "_" + m++;
            while (b[c]);
            b[l] = m, b[c] = 1;
          }
          o[A] = c;
      }
  for (y = u.s.r + s; y <= u.e.r; ++y)
    if (!(T[y] || {}).hidden) {
      var w = make_json_row(t, u, y, g, a, o, v, d);
      (w.isempty === !1 || (a === 1 ? d.blankrows !== !1 : d.blankrows)) && (x[E++] = w.row);
    }
  return x.length = E, x;
}
var qreg = /"/g;
function make_csv_row(t, e, n, a, s, o, l, c) {
  for (var u = !0, d = [], f = "", h = encode_row(n), g = e.s.c; g <= e.e.c; ++g)
    if (a[g]) {
      var x = c.dense ? (t[n] || [])[g] : t[a[g] + h];
      if (x == null)
        f = "";
      else if (x.v != null) {
        u = !1, f = "" + (c.rawNumbers && x.t == "n" ? x.v : format_cell(x, null, c));
        for (var E = 0, m = 0; E !== f.length; ++E)
          if ((m = f.charCodeAt(E)) === s || m === o || m === 34 || c.forceQuotes) {
            f = '"' + f.replace(qreg, '""') + '"';
            break;
          }
        f == "ID" && (f = '"ID"');
      } else
        x.f != null && !x.F ? (u = !1, f = "=" + x.f, f.indexOf(",") >= 0 && (f = '"' + f.replace(qreg, '""') + '"')) : f = "";
      d.push(f);
    }
  return c.blankrows === !1 && u ? null : d.join(l);
}
function sheet_to_csv(t, e) {
  var n = [], a = e ?? {};
  if (t == null || t["!ref"] == null)
    return "";
  var s = safe_decode_range(t["!ref"]), o = a.FS !== void 0 ? a.FS : ",", l = o.charCodeAt(0), c = a.RS !== void 0 ? a.RS : `
`, u = c.charCodeAt(0), d = new RegExp((o == "|" ? "\\|" : o) + "+$"), f = "", h = [];
  a.dense = Array.isArray(t);
  for (var g = a.skipHidden && t["!cols"] || [], x = a.skipHidden && t["!rows"] || [], E = s.s.c; E <= s.e.c; ++E)
    (g[E] || {}).hidden || (h[E] = encode_col(E));
  for (var m = 0, v = s.s.r; v <= s.e.r; ++v)
    (x[v] || {}).hidden || (f = make_csv_row(t, s, v, h, l, u, o, a), f != null && (a.strip && (f = f.replace(d, "")), (f || a.blankrows !== !1) && n.push((m++ ? c : "") + f)));
  return delete a.dense, n.join("");
}
function sheet_to_txt(t, e) {
  e || (e = {}), e.FS = "	", e.RS = `
`;
  var n = sheet_to_csv(t, e);
  return n;
}
function sheet_to_formulae(t) {
  var e = "", n, a = "";
  if (t == null || t["!ref"] == null)
    return [];
  var s = safe_decode_range(t["!ref"]), o = "", l = [], c, u = [], d = Array.isArray(t);
  for (c = s.s.c; c <= s.e.c; ++c)
    l[c] = encode_col(c);
  for (var f = s.s.r; f <= s.e.r; ++f)
    for (o = encode_row(f), c = s.s.c; c <= s.e.c; ++c)
      if (e = l[c] + o, n = d ? (t[f] || [])[c] : t[e], a = "", n !== void 0) {
        if (n.F != null) {
          if (e = n.F, !n.f)
            continue;
          a = n.f, e.indexOf(":") == -1 && (e = e + ":" + e);
        }
        if (n.f != null)
          a = n.f;
        else {
          if (n.t == "z")
            continue;
          if (n.t == "n" && n.v != null)
            a = "" + n.v;
          else if (n.t == "b")
            a = n.v ? "TRUE" : "FALSE";
          else if (n.w !== void 0)
            a = "'" + n.w;
          else {
            if (n.v === void 0)
              continue;
            n.t == "s" ? a = "'" + n.v : a = "" + n.v;
          }
        }
        u[u.length] = e + "=" + a;
      }
  return u;
}
function sheet_add_json(t, e, n) {
  var a = n || {}, s = +!a.skipHeader, o = t || {}, l = 0, c = 0;
  if (o && a.origin != null)
    if (typeof a.origin == "number")
      l = a.origin;
    else {
      var u = typeof a.origin == "string" ? decode_cell(a.origin) : a.origin;
      l = u.r, c = u.c;
    }
  var d, f = { s: { c: 0, r: 0 }, e: { c, r: l + e.length - 1 + s } };
  if (o["!ref"]) {
    var h = safe_decode_range(o["!ref"]);
    f.e.c = Math.max(f.e.c, h.e.c), f.e.r = Math.max(f.e.r, h.e.r), l == -1 && (l = h.e.r + 1, f.e.r = l + e.length - 1 + s);
  } else
    l == -1 && (l = 0, f.e.r = e.length - 1 + s);
  var g = a.header || [], x = 0;
  e.forEach(function(m, v) {
    keys(m).forEach(function(y) {
      (x = g.indexOf(y)) == -1 && (g[x = g.length] = y);
      var A = m[y], b = "z", C = "", T = encode_cell({ c: c + x, r: l + v + s });
      d = ws_get_cell_stub(o, T), A && typeof A == "object" && !(A instanceof Date) ? o[T] = A : (typeof A == "number" ? b = "n" : typeof A == "boolean" ? b = "b" : typeof A == "string" ? b = "s" : A instanceof Date ? (b = "d", a.cellDates || (b = "n", A = datenum(A)), C = a.dateNF || table_fmt[14]) : A === null && a.nullError && (b = "e", A = 0), d ? (d.t = b, d.v = A, delete d.w, delete d.R, C && (d.z = C)) : o[T] = d = { t: b, v: A }, C && (d.z = C));
    });
  }), f.e.c = Math.max(f.e.c, c + g.length - 1);
  var E = encode_row(l);
  if (s)
    for (x = 0; x < g.length; ++x)
      o[encode_col(x + c) + E] = { t: "s", v: g[x] };
  return o["!ref"] = encode_range(f), o;
}
function json_to_sheet(t, e) {
  return sheet_add_json(null, t, e);
}
function ws_get_cell_stub(t, e, n) {
  if (typeof e == "string") {
    if (Array.isArray(t)) {
      var a = decode_cell(e);
      return t[a.r] || (t[a.r] = []), t[a.r][a.c] || (t[a.r][a.c] = { t: "z" });
    }
    return t[e] || (t[e] = { t: "z" });
  }
  return typeof e != "number" ? ws_get_cell_stub(t, encode_cell(e)) : ws_get_cell_stub(t, encode_cell({ r: e, c: n || 0 }));
}
function wb_sheet_idx(t, e) {
  if (typeof e == "number") {
    if (e >= 0 && t.SheetNames.length > e)
      return e;
    throw new Error("Cannot find sheet # " + e);
  } else if (typeof e == "string") {
    var n = t.SheetNames.indexOf(e);
    if (n > -1)
      return n;
    throw new Error("Cannot find sheet name |" + e + "|");
  } else
    throw new Error("Cannot find sheet |" + e + "|");
}
function book_new() {
  return { SheetNames: [], Sheets: {} };
}
function book_append_sheet(t, e, n, a) {
  var s = 1;
  if (!n)
    for (; s <= 65535 && t.SheetNames.indexOf(n = "Sheet" + s) != -1; ++s, n = void 0)
      ;
  if (!n || t.SheetNames.length >= 65535)
    throw new Error("Too many worksheets");
  if (a && t.SheetNames.indexOf(n) >= 0) {
    var o = n.match(/(^.*?)(\d+)$/);
    s = o && +o[2] || 0;
    var l = o && o[1] || n;
    for (++s; s <= 65535 && t.SheetNames.indexOf(n = l + s) != -1; ++s)
      ;
  }
  if (check_ws_name(n), t.SheetNames.indexOf(n) >= 0)
    throw new Error("Worksheet with name |" + n + "| already exists!");
  return t.SheetNames.push(n), t.Sheets[n] = e, n;
}
function book_set_sheet_visibility(t, e, n) {
  t.Workbook || (t.Workbook = {}), t.Workbook.Sheets || (t.Workbook.Sheets = []);
  var a = wb_sheet_idx(t, e);
  switch (t.Workbook.Sheets[a] || (t.Workbook.Sheets[a] = {}), n) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + n);
  }
  t.Workbook.Sheets[a].Hidden = n;
}
function cell_set_number_format(t, e) {
  return t.z = e, t;
}
function cell_set_hyperlink(t, e, n) {
  return e ? (t.l = { Target: e }, n && (t.l.Tooltip = n)) : delete t.l, t;
}
function cell_set_internal_link(t, e, n) {
  return cell_set_hyperlink(t, "#" + e, n);
}
function cell_add_comment(t, e, n) {
  t.c || (t.c = []), t.c.push({ t: e, a: n || "SheetJS" });
}
function sheet_set_array_formula(t, e, n, a) {
  for (var s = typeof e != "string" ? e : safe_decode_range(e), o = typeof e == "string" ? e : encode_range(e), l = s.s.r; l <= s.e.r; ++l)
    for (var c = s.s.c; c <= s.e.c; ++c) {
      var u = ws_get_cell_stub(t, l, c);
      u.t = "n", u.F = o, delete u.v, l == s.s.r && c == s.s.c && (u.f = n, a && (u.D = !0));
    }
  return t;
}
var utils = {
  encode_col,
  encode_row,
  encode_cell,
  encode_range,
  decode_col,
  decode_row,
  split_cell,
  decode_cell,
  decode_range,
  format_cell,
  sheet_add_aoa,
  sheet_add_json,
  sheet_add_dom,
  aoa_to_sheet,
  json_to_sheet,
  table_to_sheet: parse_dom_table,
  table_to_book,
  sheet_to_csv,
  sheet_to_txt,
  sheet_to_json,
  sheet_to_html,
  sheet_to_formulae,
  sheet_to_row_object_array: sheet_to_json,
  sheet_get_cell: ws_get_cell_stub,
  book_new,
  book_append_sheet,
  book_set_sheet_visibility,
  cell_set_number_format,
  cell_set_hyperlink,
  cell_set_internal_link,
  cell_add_comment,
  sheet_set_array_formula,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
};
const XlsxViewer = (t) => {
  const [e, n] = useState([]), [a, s] = useState([]), [o, l] = useState(0), [c, u] = useState("");
  return useEffect(() => {
    const d = new Uint8Array(t.data), f = [];
    for (let h = 0; h !== d.length; h += 1)
      f.push(String.fromCharCode(d[h]));
    try {
      const h = readSync(f.join(""), { type: "binary" }), g = Object.keys(h.Sheets), x = g.map(
        (E) => utils.sheet_to_csv(h.Sheets[E])
      );
      n(x), s(g), l(0);
    } catch {
      u("Error converting file to CSV");
    }
  }, [t.data]), c ? t.errorComponent : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "spreadsheet-viewer", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "sheet-names", children: a.map((d, f) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        type: "button",
        value: d,
        onClick: () => {
          l(f);
        }
      },
      d
    )) }),
    e.length > 0 && e[o || 0] != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(CsvViewer, { data: e[o || 0] }) : null
  ] });
};
var viewer = { exports: {} };
(function(t, e) {
  (function(n, a) {
    t.exports = a();
  })(self, () => (() => {
    var n = { 887: (o, l, c) => {
      c.r(l), c.d(l, { glMatrix: () => u, mat2: () => d, mat2d: () => f, mat3: () => h, mat4: () => g, quat: () => m, quat2: () => v, vec2: () => y, vec3: () => x, vec4: () => E });
      var u = {};
      c.r(u), c.d(u, { ARRAY_TYPE: () => b, EPSILON: () => A, RANDOM: () => C, equals: () => O, setMatrixArrayType: () => T, toRadian: () => R });
      var d = {};
      c.r(d), c.d(d, { LDU: () => N, add: () => V, adjoint: () => ie, clone: () => k, copy: () => W, create: () => D, determinant: () => te, equals: () => ne, exactEquals: () => H, frob: () => I, fromRotation: () => U, fromScaling: () => F, fromValues: () => z, identity: () => L, invert: () => Y, mul: () => Fe, multiply: () => Z, multiplyScalar: () => he, multiplyScalarAndAdd: () => j, rotate: () => ae, scale: () => G, set: () => P, str: () => M, sub: () => X, subtract: () => q, transpose: () => Q });
      var f = {};
      c.r(f), c.d(f, { add: () => gt, clone: () => Ae, copy: () => fe, create: () => ye, determinant: () => Me, equals: () => We, exactEquals: () => Ve, frob: () => et, fromRotation: () => Oe, fromScaling: () => qe, fromTranslation: () => ct, fromValues: () => Ie, identity: () => _e, invert: () => $e, mul: () => it, multiply: () => J, multiplyScalar: () => nt, multiplyScalarAndAdd: () => tt, rotate: () => K, scale: () => ge, set: () => Be, str: () => ze, sub: () => Je, subtract: () => pt, translate: () => Ce });
      var h = {};
      c.r(h), c.d(h, { add: () => ve, adjoint: () => mt, clone: () => ke, copy: () => Ye, create: () => Rt, determinant: () => St, equals: () => ft, exactEquals: () => Qe, frob: () => de, fromMat2d: () => ce, fromMat4: () => je, fromQuat: () => pe, fromRotation: () => oe, fromScaling: () => ee, fromTranslation: () => Ne, fromValues: () => Ze, identity: () => xt, invert: () => wt, mul: () => ut, multiply: () => dt, multiplyScalar: () => we, multiplyScalarAndAdd: () => Ue, normalFromMat4: () => be, projection: () => Ee, rotate: () => ue, scale: () => De, set: () => rt, str: () => He, sub: () => _t, subtract: () => Se, translate: () => Le, transpose: () => bt });
      var g = {};
      c.r(g), c.d(g, { add: () => Ir, adjoint: () => Wt, clone: () => Dt, copy: () => Mt, create: () => At, determinant: () => an, equals: () => It, exactEquals: () => Ct, frob: () => wn, fromQuat: () => bn, fromQuat2: () => Fn, fromRotation: () => yn, fromRotationTranslation: () => Qn, fromRotationTranslationScale: () => Dr, fromRotationTranslationScaleOrigin: () => tr, fromScaling: () => cn, fromTranslation: () => An, fromValues: () => Ut, fromXRotation: () => Tn, fromYRotation: () => Sn, fromZRotation: () => wr, frustum: () => Vn, getRotation: () => er, getScaling: () => Jn, getTranslation: () => Wn, identity: () => zt, invert: () => Vt, lookAt: () => sr, mul: () => Pt, multiply: () => Kt, multiplyScalar: () => or, multiplyScalarAndAdd: () => Et, ortho: () => ar, orthoNO: () => ir, orthoZO: () => Rr, perspective: () => rr, perspectiveFromFieldOfView: () => Cn, perspectiveNO: () => nr, perspectiveZO: () => In, rotate: () => mn, rotateX: () => En, rotateY: () => on, rotateZ: () => fn, scale: () => Mn, set: () => Qt, str: () => Fr, sub: () => Gt, subtract: () => Dn, targetTo: () => Mr, translate: () => dn, transpose: () => sn });
      var x = {};
      c.r(x), c.d(x, { add: () => Pr, angle: () => xs, bezier: () => ds, ceil: () => es, clone: () => qt, copy: () => ln, create: () => Ht, cross: () => lr, dist: () => ws, distance: () => Ci, div: () => Cs, divide: () => cr, dot: () => Lr, equals: () => As, exactEquals: () => Es, floor: () => ts, forEach: () => Ms, fromValues: () => nn, hermite: () => us, inverse: () => cs, len: () => Mi, length: () => jt, lerp: () => ls, max: () => rs, min: () => ns, mul: () => Ss, multiply: () => Ln, negate: () => os, normalize: () => Ri, random: () => fs, rotateX: () => ms, rotateY: () => _s, rotateZ: () => vs, round: () => is, scale: () => as, scaleAndAdd: () => ss, set: () => _n, sqrDist: () => Ds, sqrLen: () => Rs, squaredDistance: () => wi, squaredLength: () => Di, str: () => bs, sub: () => Ts, subtract: () => Pn, transformMat3: () => ps, transformMat4: () => hs, transformQuat: () => gs, zero: () => ys });
      var E = {};
      c.r(E), c.d(E, { add: () => Oi, ceil: () => Fs, clone: () => Ii, copy: () => Li, create: () => Fi, cross: () => Bs, dist: () => $s, distance: () => Vi, div: () => js, divide: () => Bi, dot: () => zi, equals: () => ji, exactEquals: () => qi, floor: () => Is, forEach: () => Qs, fromValues: () => Pi, inverse: () => ks, len: () => Ks, length: () => Ur, lerp: () => Xi, max: () => Ls, min: () => Ps, mul: () => qs, multiply: () => ki, negate: () => Ns, normalize: () => Hi, random: () => Ws, round: () => Us, scale: () => Wi, scaleAndAdd: () => Os, set: () => Ui, sqrDist: () => Ys, sqrLen: () => Zs, squaredDistance: () => Gi, squaredLength: () => Or, str: () => zs, sub: () => Xs, subtract: () => Ni, transformMat4: () => Vs, transformQuat: () => Gs, zero: () => Hs });
      var m = {};
      c.r(m), c.d(m, { add: () => ho, calculateW: () => no, clone: () => lo, conjugate: () => so, copy: () => Br, create: () => ur, dot: () => Wr, equals: () => xo, exactEquals: () => vo, exp: () => Ji, fromEuler: () => oo, fromMat3: () => ta, fromValues: () => uo, getAngle: () => to, getAxisAngle: () => eo, identity: () => Js, invert: () => ao, len: () => mo, length: () => Vr, lerp: () => go, ln: () => ea, mul: () => po, multiply: () => Yi, normalize: () => Hr, pow: () => ro, random: () => io, rotateX: () => Ki, rotateY: () => Zi, rotateZ: () => Qi, rotationTo: () => yo, scale: () => ia, set: () => fo, setAxes: () => Eo, setAxisAngle: () => $i, slerp: () => dr, sqlerp: () => bo, sqrLen: () => _o, squaredLength: () => Gr, str: () => co });
      var v = {};
      c.r(v), c.d(v, { add: () => zo, clone: () => To, conjugate: () => Yo, copy: () => sa, create: () => Ao, dot: () => ca, equals: () => tc, exactEquals: () => ec, fromMat4: () => Ro, fromRotation: () => Do, fromRotationTranslation: () => aa, fromRotationTranslationValues: () => Co, fromTranslation: () => wo, fromValues: () => So, getDual: () => Po, getReal: () => Io, getTranslation: () => Oo, identity: () => Mo, invert: () => $o, len: () => Ko, length: () => la, lerp: () => jo, mul: () => Xo, multiply: () => oa, normalize: () => Qo, rotateAroundAxis: () => Ho, rotateByQuatAppend: () => Vo, rotateByQuatPrepend: () => Go, rotateX: () => ko, rotateY: () => Bo, rotateZ: () => Wo, scale: () => qo, set: () => Fo, setDual: () => Uo, setReal: () => Lo, sqrLen: () => Zo, squaredLength: () => fr, str: () => Jo, translate: () => No });
      var y = {};
      c.r(y), c.d(y, { add: () => sc, angle: () => Cc, ceil: () => oc, clone: () => nc, copy: () => ic, create: () => ua, cross: () => vc, dist: () => Uc, distance: () => pa, div: () => Lc, divide: () => ha, dot: () => _c, equals: () => Mc, exactEquals: () => Rc, floor: () => cc, forEach: () => kc, fromValues: () => rc, inverse: () => gc, len: () => Fc, length: () => ma, lerp: () => xc, max: () => uc, min: () => lc, mul: () => Pc, multiply: () => fa, negate: () => pc, normalize: () => mc, random: () => yc, rotate: () => Sc, round: () => dc, scale: () => fc, scaleAndAdd: () => hc, set: () => ac, sqrDist: () => Oc, sqrLen: () => Nc, squaredDistance: () => ga, squaredLength: () => _a, str: () => Dc, sub: () => Ic, subtract: () => da, transformMat2: () => bc, transformMat2d: () => Ec, transformMat3: () => Ac, transformMat4: () => Tc, zero: () => wc });
      var A = 1e-6, b = typeof Float32Array < "u" ? Float32Array : Array, C = Math.random;
      function T(p) {
        b = p;
      }
      var w = Math.PI / 180;
      function R(p) {
        return p * w;
      }
      function O(p, S) {
        return Math.abs(p - S) <= A * Math.max(1, Math.abs(p), Math.abs(S));
      }
      function D() {
        var p = new b(4);
        return b != Float32Array && (p[1] = 0, p[2] = 0), p[0] = 1, p[3] = 1, p;
      }
      function k(p) {
        var S = new b(4);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S;
      }
      function W(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p;
      }
      function L(p) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 1, p;
      }
      function z(p, S, B, re) {
        var le = new b(4);
        return le[0] = p, le[1] = S, le[2] = B, le[3] = re, le;
      }
      function P(p, S, B, re, le) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p;
      }
      function Q(p, S) {
        if (p === S) {
          var B = S[1];
          p[1] = S[2], p[2] = B;
        } else
          p[0] = S[0], p[1] = S[2], p[2] = S[1], p[3] = S[3];
        return p;
      }
      function Y(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = B * me - le * re;
        return xe ? (xe = 1 / xe, p[0] = me * xe, p[1] = -re * xe, p[2] = -le * xe, p[3] = B * xe, p) : null;
      }
      function ie(p, S) {
        var B = S[0];
        return p[0] = S[3], p[1] = -S[1], p[2] = -S[2], p[3] = B, p;
      }
      function te(p) {
        return p[0] * p[3] - p[2] * p[1];
      }
      function Z(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = B[0], Re = B[1], Pe = B[2], Xe = B[3];
        return p[0] = re * Te + me * Re, p[1] = le * Te + xe * Re, p[2] = re * Pe + me * Xe, p[3] = le * Pe + xe * Xe, p;
      }
      function ae(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = Math.sin(B), Re = Math.cos(B);
        return p[0] = re * Re + me * Te, p[1] = le * Re + xe * Te, p[2] = re * -Te + me * Re, p[3] = le * -Te + xe * Re, p;
      }
      function G(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = B[0], Re = B[1];
        return p[0] = re * Te, p[1] = le * Te, p[2] = me * Re, p[3] = xe * Re, p;
      }
      function U(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = re, p[1] = B, p[2] = -B, p[3] = re, p;
      }
      function F(p, S) {
        return p[0] = S[0], p[1] = 0, p[2] = 0, p[3] = S[1], p;
      }
      function M(p) {
        return "mat2(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ")";
      }
      function I(p) {
        return Math.hypot(p[0], p[1], p[2], p[3]);
      }
      function N(p, S, B, re) {
        return p[2] = re[2] / re[0], B[0] = re[0], B[1] = re[1], B[3] = re[3] - p[2] * B[1], [p, S, B];
      }
      function V(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p;
      }
      function q(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p[3] = S[3] - B[3], p;
      }
      function H(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3];
      }
      function ne(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = S[0], Te = S[1], Re = S[2], Pe = S[3];
        return Math.abs(B - xe) <= A * Math.max(1, Math.abs(B), Math.abs(xe)) && Math.abs(re - Te) <= A * Math.max(1, Math.abs(re), Math.abs(Te)) && Math.abs(le - Re) <= A * Math.max(1, Math.abs(le), Math.abs(Re)) && Math.abs(me - Pe) <= A * Math.max(1, Math.abs(me), Math.abs(Pe));
      }
      function he(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p;
      }
      function j(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p[3] = S[3] + B[3] * re, p;
      }
      Math.hypot || (Math.hypot = function() {
        for (var p = 0, S = arguments.length; S--; )
          p += arguments[S] * arguments[S];
        return Math.sqrt(p);
      });
      var Fe = Z, X = q;
      function ye() {
        var p = new b(6);
        return b != Float32Array && (p[1] = 0, p[2] = 0, p[4] = 0, p[5] = 0), p[0] = 1, p[3] = 1, p;
      }
      function Ae(p) {
        var S = new b(6);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S[4] = p[4], S[5] = p[5], S;
      }
      function fe(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[4] = S[4], p[5] = S[5], p;
      }
      function _e(p) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 1, p[4] = 0, p[5] = 0, p;
      }
      function Ie(p, S, B, re, le, me) {
        var xe = new b(6);
        return xe[0] = p, xe[1] = S, xe[2] = B, xe[3] = re, xe[4] = le, xe[5] = me, xe;
      }
      function Be(p, S, B, re, le, me, xe) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p[4] = me, p[5] = xe, p;
      }
      function $e(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = B * me - re * le;
        return Re ? (Re = 1 / Re, p[0] = me * Re, p[1] = -re * Re, p[2] = -le * Re, p[3] = B * Re, p[4] = (le * Te - me * xe) * Re, p[5] = (re * xe - B * Te) * Re, p) : null;
      }
      function Me(p) {
        return p[0] * p[3] - p[1] * p[2];
      }
      function J(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = B[0], Xe = B[1], st = B[2], ot = B[3], lt = B[4], vt = B[5];
        return p[0] = re * Pe + me * Xe, p[1] = le * Pe + xe * Xe, p[2] = re * st + me * ot, p[3] = le * st + xe * ot, p[4] = re * lt + me * vt + Te, p[5] = le * lt + xe * vt + Re, p;
      }
      function K(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = Math.sin(B), Xe = Math.cos(B);
        return p[0] = re * Xe + me * Pe, p[1] = le * Xe + xe * Pe, p[2] = re * -Pe + me * Xe, p[3] = le * -Pe + xe * Xe, p[4] = Te, p[5] = Re, p;
      }
      function ge(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = B[0], Xe = B[1];
        return p[0] = re * Pe, p[1] = le * Pe, p[2] = me * Xe, p[3] = xe * Xe, p[4] = Te, p[5] = Re, p;
      }
      function Ce(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = B[0], Xe = B[1];
        return p[0] = re, p[1] = le, p[2] = me, p[3] = xe, p[4] = re * Pe + me * Xe + Te, p[5] = le * Pe + xe * Xe + Re, p;
      }
      function Oe(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = re, p[1] = B, p[2] = -B, p[3] = re, p[4] = 0, p[5] = 0, p;
      }
      function qe(p, S) {
        return p[0] = S[0], p[1] = 0, p[2] = 0, p[3] = S[1], p[4] = 0, p[5] = 0, p;
      }
      function ct(p, S) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 1, p[4] = S[0], p[5] = S[1], p;
      }
      function ze(p) {
        return "mat2d(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ", " + p[4] + ", " + p[5] + ")";
      }
      function et(p) {
        return Math.hypot(p[0], p[1], p[2], p[3], p[4], p[5], 1);
      }
      function gt(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p[4] = S[4] + B[4], p[5] = S[5] + B[5], p;
      }
      function pt(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p[3] = S[3] - B[3], p[4] = S[4] - B[4], p[5] = S[5] - B[5], p;
      }
      function nt(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p[4] = S[4] * B, p[5] = S[5] * B, p;
      }
      function tt(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p[3] = S[3] + B[3] * re, p[4] = S[4] + B[4] * re, p[5] = S[5] + B[5] * re, p;
      }
      function Ve(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3] && p[4] === S[4] && p[5] === S[5];
      }
      function We(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = p[4], Te = p[5], Re = S[0], Pe = S[1], Xe = S[2], st = S[3], ot = S[4], lt = S[5];
        return Math.abs(B - Re) <= A * Math.max(1, Math.abs(B), Math.abs(Re)) && Math.abs(re - Pe) <= A * Math.max(1, Math.abs(re), Math.abs(Pe)) && Math.abs(le - Xe) <= A * Math.max(1, Math.abs(le), Math.abs(Xe)) && Math.abs(me - st) <= A * Math.max(1, Math.abs(me), Math.abs(st)) && Math.abs(xe - ot) <= A * Math.max(1, Math.abs(xe), Math.abs(ot)) && Math.abs(Te - lt) <= A * Math.max(1, Math.abs(Te), Math.abs(lt));
      }
      var it = J, Je = pt;
      function Rt() {
        var p = new b(9);
        return b != Float32Array && (p[1] = 0, p[2] = 0, p[3] = 0, p[5] = 0, p[6] = 0, p[7] = 0), p[0] = 1, p[4] = 1, p[8] = 1, p;
      }
      function je(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[4], p[4] = S[5], p[5] = S[6], p[6] = S[8], p[7] = S[9], p[8] = S[10], p;
      }
      function ke(p) {
        var S = new b(9);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S[4] = p[4], S[5] = p[5], S[6] = p[6], S[7] = p[7], S[8] = p[8], S;
      }
      function Ye(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[4] = S[4], p[5] = S[5], p[6] = S[6], p[7] = S[7], p[8] = S[8], p;
      }
      function Ze(p, S, B, re, le, me, xe, Te, Re) {
        var Pe = new b(9);
        return Pe[0] = p, Pe[1] = S, Pe[2] = B, Pe[3] = re, Pe[4] = le, Pe[5] = me, Pe[6] = xe, Pe[7] = Te, Pe[8] = Re, Pe;
      }
      function rt(p, S, B, re, le, me, xe, Te, Re, Pe) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p[4] = me, p[5] = xe, p[6] = Te, p[7] = Re, p[8] = Pe, p;
      }
      function xt(p) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 1, p[5] = 0, p[6] = 0, p[7] = 0, p[8] = 1, p;
      }
      function bt(p, S) {
        if (p === S) {
          var B = S[1], re = S[2], le = S[5];
          p[1] = S[3], p[2] = S[6], p[3] = B, p[5] = S[7], p[6] = re, p[7] = le;
        } else
          p[0] = S[0], p[1] = S[3], p[2] = S[6], p[3] = S[1], p[4] = S[4], p[5] = S[7], p[6] = S[2], p[7] = S[5], p[8] = S[8];
        return p;
      }
      function wt(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = S[6], Pe = S[7], Xe = S[8], st = Xe * xe - Te * Pe, ot = -Xe * me + Te * Re, lt = Pe * me - xe * Re, vt = B * st + re * ot + le * lt;
        return vt ? (vt = 1 / vt, p[0] = st * vt, p[1] = (-Xe * re + le * Pe) * vt, p[2] = (Te * re - le * xe) * vt, p[3] = ot * vt, p[4] = (Xe * B - le * Re) * vt, p[5] = (-Te * B + le * me) * vt, p[6] = lt * vt, p[7] = (-Pe * B + re * Re) * vt, p[8] = (xe * B - re * me) * vt, p) : null;
      }
      function mt(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = S[6], Pe = S[7], Xe = S[8];
        return p[0] = xe * Xe - Te * Pe, p[1] = le * Pe - re * Xe, p[2] = re * Te - le * xe, p[3] = Te * Re - me * Xe, p[4] = B * Xe - le * Re, p[5] = le * me - B * Te, p[6] = me * Pe - xe * Re, p[7] = re * Re - B * Pe, p[8] = B * xe - re * me, p;
      }
      function St(p) {
        var S = p[0], B = p[1], re = p[2], le = p[3], me = p[4], xe = p[5], Te = p[6], Re = p[7], Pe = p[8];
        return S * (Pe * me - xe * Re) + B * (-Pe * le + xe * Te) + re * (Re * le - me * Te);
      }
      function dt(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = S[8], ot = B[0], lt = B[1], vt = B[2], yt = B[3], ht = B[4], Tt = B[5], Ot = B[6], Ft = B[7], Lt = B[8];
        return p[0] = ot * re + lt * xe + vt * Pe, p[1] = ot * le + lt * Te + vt * Xe, p[2] = ot * me + lt * Re + vt * st, p[3] = yt * re + ht * xe + Tt * Pe, p[4] = yt * le + ht * Te + Tt * Xe, p[5] = yt * me + ht * Re + Tt * st, p[6] = Ot * re + Ft * xe + Lt * Pe, p[7] = Ot * le + Ft * Te + Lt * Xe, p[8] = Ot * me + Ft * Re + Lt * st, p;
      }
      function Le(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = S[8], ot = B[0], lt = B[1];
        return p[0] = re, p[1] = le, p[2] = me, p[3] = xe, p[4] = Te, p[5] = Re, p[6] = ot * re + lt * xe + Pe, p[7] = ot * le + lt * Te + Xe, p[8] = ot * me + lt * Re + st, p;
      }
      function ue(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = S[8], ot = Math.sin(B), lt = Math.cos(B);
        return p[0] = lt * re + ot * xe, p[1] = lt * le + ot * Te, p[2] = lt * me + ot * Re, p[3] = lt * xe - ot * re, p[4] = lt * Te - ot * le, p[5] = lt * Re - ot * me, p[6] = Pe, p[7] = Xe, p[8] = st, p;
      }
      function De(p, S, B) {
        var re = B[0], le = B[1];
        return p[0] = re * S[0], p[1] = re * S[1], p[2] = re * S[2], p[3] = le * S[3], p[4] = le * S[4], p[5] = le * S[5], p[6] = S[6], p[7] = S[7], p[8] = S[8], p;
      }
      function Ne(p, S) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 1, p[5] = 0, p[6] = S[0], p[7] = S[1], p[8] = 1, p;
      }
      function oe(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = re, p[1] = B, p[2] = 0, p[3] = -B, p[4] = re, p[5] = 0, p[6] = 0, p[7] = 0, p[8] = 1, p;
      }
      function ee(p, S) {
        return p[0] = S[0], p[1] = 0, p[2] = 0, p[3] = 0, p[4] = S[1], p[5] = 0, p[6] = 0, p[7] = 0, p[8] = 1, p;
      }
      function ce(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = 0, p[3] = S[2], p[4] = S[3], p[5] = 0, p[6] = S[4], p[7] = S[5], p[8] = 1, p;
      }
      function pe(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = B + B, Te = re + re, Re = le + le, Pe = B * xe, Xe = re * xe, st = re * Te, ot = le * xe, lt = le * Te, vt = le * Re, yt = me * xe, ht = me * Te, Tt = me * Re;
        return p[0] = 1 - st - vt, p[3] = Xe - Tt, p[6] = ot + ht, p[1] = Xe + Tt, p[4] = 1 - Pe - vt, p[7] = lt - yt, p[2] = ot - ht, p[5] = lt + yt, p[8] = 1 - Pe - st, p;
      }
      function be(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = S[6], Pe = S[7], Xe = S[8], st = S[9], ot = S[10], lt = S[11], vt = S[12], yt = S[13], ht = S[14], Tt = S[15], Ot = B * Te - re * xe, Ft = B * Re - le * xe, Lt = B * Pe - me * xe, Bt = re * Re - le * Te, Nt = re * Pe - me * Te, tn = le * Pe - me * Re, Jt = Xe * yt - st * vt, en = Xe * ht - ot * vt, Zt = Xe * Tt - lt * vt, rn = st * ht - ot * yt, $t = st * Tt - lt * yt, Yt = ot * Tt - lt * ht, kt = Ot * Yt - Ft * $t + Lt * rn + Bt * Zt - Nt * en + tn * Jt;
        return kt ? (kt = 1 / kt, p[0] = (Te * Yt - Re * $t + Pe * rn) * kt, p[1] = (Re * Zt - xe * Yt - Pe * en) * kt, p[2] = (xe * $t - Te * Zt + Pe * Jt) * kt, p[3] = (le * $t - re * Yt - me * rn) * kt, p[4] = (B * Yt - le * Zt + me * en) * kt, p[5] = (re * Zt - B * $t - me * Jt) * kt, p[6] = (yt * tn - ht * Nt + Tt * Bt) * kt, p[7] = (ht * Lt - vt * tn - Tt * Ft) * kt, p[8] = (vt * Nt - yt * Lt + Tt * Ot) * kt, p) : null;
      }
      function Ee(p, S, B) {
        return p[0] = 2 / S, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = -2 / B, p[5] = 0, p[6] = -1, p[7] = 1, p[8] = 1, p;
      }
      function He(p) {
        return "mat3(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ", " + p[4] + ", " + p[5] + ", " + p[6] + ", " + p[7] + ", " + p[8] + ")";
      }
      function de(p) {
        return Math.hypot(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8]);
      }
      function ve(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p[4] = S[4] + B[4], p[5] = S[5] + B[5], p[6] = S[6] + B[6], p[7] = S[7] + B[7], p[8] = S[8] + B[8], p;
      }
      function Se(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p[3] = S[3] - B[3], p[4] = S[4] - B[4], p[5] = S[5] - B[5], p[6] = S[6] - B[6], p[7] = S[7] - B[7], p[8] = S[8] - B[8], p;
      }
      function we(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p[4] = S[4] * B, p[5] = S[5] * B, p[6] = S[6] * B, p[7] = S[7] * B, p[8] = S[8] * B, p;
      }
      function Ue(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p[3] = S[3] + B[3] * re, p[4] = S[4] + B[4] * re, p[5] = S[5] + B[5] * re, p[6] = S[6] + B[6] * re, p[7] = S[7] + B[7] * re, p[8] = S[8] + B[8] * re, p;
      }
      function Qe(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3] && p[4] === S[4] && p[5] === S[5] && p[6] === S[6] && p[7] === S[7] && p[8] === S[8];
      }
      function ft(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = p[4], Te = p[5], Re = p[6], Pe = p[7], Xe = p[8], st = S[0], ot = S[1], lt = S[2], vt = S[3], yt = S[4], ht = S[5], Tt = S[6], Ot = S[7], Ft = S[8];
        return Math.abs(B - st) <= A * Math.max(1, Math.abs(B), Math.abs(st)) && Math.abs(re - ot) <= A * Math.max(1, Math.abs(re), Math.abs(ot)) && Math.abs(le - lt) <= A * Math.max(1, Math.abs(le), Math.abs(lt)) && Math.abs(me - vt) <= A * Math.max(1, Math.abs(me), Math.abs(vt)) && Math.abs(xe - yt) <= A * Math.max(1, Math.abs(xe), Math.abs(yt)) && Math.abs(Te - ht) <= A * Math.max(1, Math.abs(Te), Math.abs(ht)) && Math.abs(Re - Tt) <= A * Math.max(1, Math.abs(Re), Math.abs(Tt)) && Math.abs(Pe - Ot) <= A * Math.max(1, Math.abs(Pe), Math.abs(Ot)) && Math.abs(Xe - Ft) <= A * Math.max(1, Math.abs(Xe), Math.abs(Ft));
      }
      var ut = dt, _t = Se;
      function At() {
        var p = new b(16);
        return b != Float32Array && (p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0), p[0] = 1, p[5] = 1, p[10] = 1, p[15] = 1, p;
      }
      function Dt(p) {
        var S = new b(16);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S[4] = p[4], S[5] = p[5], S[6] = p[6], S[7] = p[7], S[8] = p[8], S[9] = p[9], S[10] = p[10], S[11] = p[11], S[12] = p[12], S[13] = p[13], S[14] = p[14], S[15] = p[15], S;
      }
      function Mt(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[4] = S[4], p[5] = S[5], p[6] = S[6], p[7] = S[7], p[8] = S[8], p[9] = S[9], p[10] = S[10], p[11] = S[11], p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15], p;
      }
      function Ut(p, S, B, re, le, me, xe, Te, Re, Pe, Xe, st, ot, lt, vt, yt) {
        var ht = new b(16);
        return ht[0] = p, ht[1] = S, ht[2] = B, ht[3] = re, ht[4] = le, ht[5] = me, ht[6] = xe, ht[7] = Te, ht[8] = Re, ht[9] = Pe, ht[10] = Xe, ht[11] = st, ht[12] = ot, ht[13] = lt, ht[14] = vt, ht[15] = yt, ht;
      }
      function Qt(p, S, B, re, le, me, xe, Te, Re, Pe, Xe, st, ot, lt, vt, yt, ht) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p[4] = me, p[5] = xe, p[6] = Te, p[7] = Re, p[8] = Pe, p[9] = Xe, p[10] = st, p[11] = ot, p[12] = lt, p[13] = vt, p[14] = yt, p[15] = ht, p;
      }
      function zt(p) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = 1, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = 1, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function sn(p, S) {
        if (p === S) {
          var B = S[1], re = S[2], le = S[3], me = S[6], xe = S[7], Te = S[11];
          p[1] = S[4], p[2] = S[8], p[3] = S[12], p[4] = B, p[6] = S[9], p[7] = S[13], p[8] = re, p[9] = me, p[11] = S[14], p[12] = le, p[13] = xe, p[14] = Te;
        } else
          p[0] = S[0], p[1] = S[4], p[2] = S[8], p[3] = S[12], p[4] = S[1], p[5] = S[5], p[6] = S[9], p[7] = S[13], p[8] = S[2], p[9] = S[6], p[10] = S[10], p[11] = S[14], p[12] = S[3], p[13] = S[7], p[14] = S[11], p[15] = S[15];
        return p;
      }
      function Vt(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = S[6], Pe = S[7], Xe = S[8], st = S[9], ot = S[10], lt = S[11], vt = S[12], yt = S[13], ht = S[14], Tt = S[15], Ot = B * Te - re * xe, Ft = B * Re - le * xe, Lt = B * Pe - me * xe, Bt = re * Re - le * Te, Nt = re * Pe - me * Te, tn = le * Pe - me * Re, Jt = Xe * yt - st * vt, en = Xe * ht - ot * vt, Zt = Xe * Tt - lt * vt, rn = st * ht - ot * yt, $t = st * Tt - lt * yt, Yt = ot * Tt - lt * ht, kt = Ot * Yt - Ft * $t + Lt * rn + Bt * Zt - Nt * en + tn * Jt;
        return kt ? (kt = 1 / kt, p[0] = (Te * Yt - Re * $t + Pe * rn) * kt, p[1] = (le * $t - re * Yt - me * rn) * kt, p[2] = (yt * tn - ht * Nt + Tt * Bt) * kt, p[3] = (ot * Nt - st * tn - lt * Bt) * kt, p[4] = (Re * Zt - xe * Yt - Pe * en) * kt, p[5] = (B * Yt - le * Zt + me * en) * kt, p[6] = (ht * Lt - vt * tn - Tt * Ft) * kt, p[7] = (Xe * tn - ot * Lt + lt * Ft) * kt, p[8] = (xe * $t - Te * Zt + Pe * Jt) * kt, p[9] = (re * Zt - B * $t - me * Jt) * kt, p[10] = (vt * Nt - yt * Lt + Tt * Ot) * kt, p[11] = (st * Lt - Xe * Nt - lt * Ot) * kt, p[12] = (Te * en - xe * rn - Re * Jt) * kt, p[13] = (B * rn - re * en + le * Jt) * kt, p[14] = (yt * Ft - vt * Bt - ht * Ot) * kt, p[15] = (Xe * Bt - st * Ft + ot * Ot) * kt, p) : null;
      }
      function Wt(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = S[4], Te = S[5], Re = S[6], Pe = S[7], Xe = S[8], st = S[9], ot = S[10], lt = S[11], vt = S[12], yt = S[13], ht = S[14], Tt = S[15];
        return p[0] = Te * (ot * Tt - lt * ht) - st * (Re * Tt - Pe * ht) + yt * (Re * lt - Pe * ot), p[1] = -(re * (ot * Tt - lt * ht) - st * (le * Tt - me * ht) + yt * (le * lt - me * ot)), p[2] = re * (Re * Tt - Pe * ht) - Te * (le * Tt - me * ht) + yt * (le * Pe - me * Re), p[3] = -(re * (Re * lt - Pe * ot) - Te * (le * lt - me * ot) + st * (le * Pe - me * Re)), p[4] = -(xe * (ot * Tt - lt * ht) - Xe * (Re * Tt - Pe * ht) + vt * (Re * lt - Pe * ot)), p[5] = B * (ot * Tt - lt * ht) - Xe * (le * Tt - me * ht) + vt * (le * lt - me * ot), p[6] = -(B * (Re * Tt - Pe * ht) - xe * (le * Tt - me * ht) + vt * (le * Pe - me * Re)), p[7] = B * (Re * lt - Pe * ot) - xe * (le * lt - me * ot) + Xe * (le * Pe - me * Re), p[8] = xe * (st * Tt - lt * yt) - Xe * (Te * Tt - Pe * yt) + vt * (Te * lt - Pe * st), p[9] = -(B * (st * Tt - lt * yt) - Xe * (re * Tt - me * yt) + vt * (re * lt - me * st)), p[10] = B * (Te * Tt - Pe * yt) - xe * (re * Tt - me * yt) + vt * (re * Pe - me * Te), p[11] = -(B * (Te * lt - Pe * st) - xe * (re * lt - me * st) + Xe * (re * Pe - me * Te)), p[12] = -(xe * (st * ht - ot * yt) - Xe * (Te * ht - Re * yt) + vt * (Te * ot - Re * st)), p[13] = B * (st * ht - ot * yt) - Xe * (re * ht - le * yt) + vt * (re * ot - le * st), p[14] = -(B * (Te * ht - Re * yt) - xe * (re * ht - le * yt) + vt * (re * Re - le * Te)), p[15] = B * (Te * ot - Re * st) - xe * (re * ot - le * st) + Xe * (re * Re - le * Te), p;
      }
      function an(p) {
        var S = p[0], B = p[1], re = p[2], le = p[3], me = p[4], xe = p[5], Te = p[6], Re = p[7], Pe = p[8], Xe = p[9], st = p[10], ot = p[11], lt = p[12], vt = p[13], yt = p[14], ht = p[15];
        return (S * xe - B * me) * (st * ht - ot * yt) - (S * Te - re * me) * (Xe * ht - ot * vt) + (S * Re - le * me) * (Xe * yt - st * vt) + (B * Te - re * xe) * (Pe * ht - ot * lt) - (B * Re - le * xe) * (Pe * yt - st * lt) + (re * Re - le * Te) * (Pe * vt - Xe * lt);
      }
      function Kt(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = S[8], ot = S[9], lt = S[10], vt = S[11], yt = S[12], ht = S[13], Tt = S[14], Ot = S[15], Ft = B[0], Lt = B[1], Bt = B[2], Nt = B[3];
        return p[0] = Ft * re + Lt * Te + Bt * st + Nt * yt, p[1] = Ft * le + Lt * Re + Bt * ot + Nt * ht, p[2] = Ft * me + Lt * Pe + Bt * lt + Nt * Tt, p[3] = Ft * xe + Lt * Xe + Bt * vt + Nt * Ot, Ft = B[4], Lt = B[5], Bt = B[6], Nt = B[7], p[4] = Ft * re + Lt * Te + Bt * st + Nt * yt, p[5] = Ft * le + Lt * Re + Bt * ot + Nt * ht, p[6] = Ft * me + Lt * Pe + Bt * lt + Nt * Tt, p[7] = Ft * xe + Lt * Xe + Bt * vt + Nt * Ot, Ft = B[8], Lt = B[9], Bt = B[10], Nt = B[11], p[8] = Ft * re + Lt * Te + Bt * st + Nt * yt, p[9] = Ft * le + Lt * Re + Bt * ot + Nt * ht, p[10] = Ft * me + Lt * Pe + Bt * lt + Nt * Tt, p[11] = Ft * xe + Lt * Xe + Bt * vt + Nt * Ot, Ft = B[12], Lt = B[13], Bt = B[14], Nt = B[15], p[12] = Ft * re + Lt * Te + Bt * st + Nt * yt, p[13] = Ft * le + Lt * Re + Bt * ot + Nt * ht, p[14] = Ft * me + Lt * Pe + Bt * lt + Nt * Tt, p[15] = Ft * xe + Lt * Xe + Bt * vt + Nt * Ot, p;
      }
      function dn(p, S, B) {
        var re, le, me, xe, Te, Re, Pe, Xe, st, ot, lt, vt, yt = B[0], ht = B[1], Tt = B[2];
        return S === p ? (p[12] = S[0] * yt + S[4] * ht + S[8] * Tt + S[12], p[13] = S[1] * yt + S[5] * ht + S[9] * Tt + S[13], p[14] = S[2] * yt + S[6] * ht + S[10] * Tt + S[14], p[15] = S[3] * yt + S[7] * ht + S[11] * Tt + S[15]) : (re = S[0], le = S[1], me = S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = S[8], ot = S[9], lt = S[10], vt = S[11], p[0] = re, p[1] = le, p[2] = me, p[3] = xe, p[4] = Te, p[5] = Re, p[6] = Pe, p[7] = Xe, p[8] = st, p[9] = ot, p[10] = lt, p[11] = vt, p[12] = re * yt + Te * ht + st * Tt + S[12], p[13] = le * yt + Re * ht + ot * Tt + S[13], p[14] = me * yt + Pe * ht + lt * Tt + S[14], p[15] = xe * yt + Xe * ht + vt * Tt + S[15]), p;
      }
      function Mn(p, S, B) {
        var re = B[0], le = B[1], me = B[2];
        return p[0] = S[0] * re, p[1] = S[1] * re, p[2] = S[2] * re, p[3] = S[3] * re, p[4] = S[4] * le, p[5] = S[5] * le, p[6] = S[6] * le, p[7] = S[7] * le, p[8] = S[8] * me, p[9] = S[9] * me, p[10] = S[10] * me, p[11] = S[11] * me, p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15], p;
      }
      function mn(p, S, B, re) {
        var le, me, xe, Te, Re, Pe, Xe, st, ot, lt, vt, yt, ht, Tt, Ot, Ft, Lt, Bt, Nt, tn, Jt, en, Zt, rn, $t = re[0], Yt = re[1], kt = re[2], gn = Math.hypot($t, Yt, kt);
        return gn < A ? null : ($t *= gn = 1 / gn, Yt *= gn, kt *= gn, le = Math.sin(B), xe = 1 - (me = Math.cos(B)), Te = S[0], Re = S[1], Pe = S[2], Xe = S[3], st = S[4], ot = S[5], lt = S[6], vt = S[7], yt = S[8], ht = S[9], Tt = S[10], Ot = S[11], Ft = $t * $t * xe + me, Lt = Yt * $t * xe + kt * le, Bt = kt * $t * xe - Yt * le, Nt = $t * Yt * xe - kt * le, tn = Yt * Yt * xe + me, Jt = kt * Yt * xe + $t * le, en = $t * kt * xe + Yt * le, Zt = Yt * kt * xe - $t * le, rn = kt * kt * xe + me, p[0] = Te * Ft + st * Lt + yt * Bt, p[1] = Re * Ft + ot * Lt + ht * Bt, p[2] = Pe * Ft + lt * Lt + Tt * Bt, p[3] = Xe * Ft + vt * Lt + Ot * Bt, p[4] = Te * Nt + st * tn + yt * Jt, p[5] = Re * Nt + ot * tn + ht * Jt, p[6] = Pe * Nt + lt * tn + Tt * Jt, p[7] = Xe * Nt + vt * tn + Ot * Jt, p[8] = Te * en + st * Zt + yt * rn, p[9] = Re * en + ot * Zt + ht * rn, p[10] = Pe * en + lt * Zt + Tt * rn, p[11] = Xe * en + vt * Zt + Ot * rn, S !== p && (p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15]), p);
      }
      function En(p, S, B) {
        var re = Math.sin(B), le = Math.cos(B), me = S[4], xe = S[5], Te = S[6], Re = S[7], Pe = S[8], Xe = S[9], st = S[10], ot = S[11];
        return S !== p && (p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15]), p[4] = me * le + Pe * re, p[5] = xe * le + Xe * re, p[6] = Te * le + st * re, p[7] = Re * le + ot * re, p[8] = Pe * le - me * re, p[9] = Xe * le - xe * re, p[10] = st * le - Te * re, p[11] = ot * le - Re * re, p;
      }
      function on(p, S, B) {
        var re = Math.sin(B), le = Math.cos(B), me = S[0], xe = S[1], Te = S[2], Re = S[3], Pe = S[8], Xe = S[9], st = S[10], ot = S[11];
        return S !== p && (p[4] = S[4], p[5] = S[5], p[6] = S[6], p[7] = S[7], p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15]), p[0] = me * le - Pe * re, p[1] = xe * le - Xe * re, p[2] = Te * le - st * re, p[3] = Re * le - ot * re, p[8] = me * re + Pe * le, p[9] = xe * re + Xe * le, p[10] = Te * re + st * le, p[11] = Re * re + ot * le, p;
      }
      function fn(p, S, B) {
        var re = Math.sin(B), le = Math.cos(B), me = S[0], xe = S[1], Te = S[2], Re = S[3], Pe = S[4], Xe = S[5], st = S[6], ot = S[7];
        return S !== p && (p[8] = S[8], p[9] = S[9], p[10] = S[10], p[11] = S[11], p[12] = S[12], p[13] = S[13], p[14] = S[14], p[15] = S[15]), p[0] = me * le + Pe * re, p[1] = xe * le + Xe * re, p[2] = Te * le + st * re, p[3] = Re * le + ot * re, p[4] = Pe * le - me * re, p[5] = Xe * le - xe * re, p[6] = st * le - Te * re, p[7] = ot * le - Re * re, p;
      }
      function An(p, S) {
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = 1, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = 1, p[11] = 0, p[12] = S[0], p[13] = S[1], p[14] = S[2], p[15] = 1, p;
      }
      function cn(p, S) {
        return p[0] = S[0], p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = S[1], p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = S[2], p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function yn(p, S, B) {
        var re, le, me, xe = B[0], Te = B[1], Re = B[2], Pe = Math.hypot(xe, Te, Re);
        return Pe < A ? null : (xe *= Pe = 1 / Pe, Te *= Pe, Re *= Pe, re = Math.sin(S), me = 1 - (le = Math.cos(S)), p[0] = xe * xe * me + le, p[1] = Te * xe * me + Re * re, p[2] = Re * xe * me - Te * re, p[3] = 0, p[4] = xe * Te * me - Re * re, p[5] = Te * Te * me + le, p[6] = Re * Te * me + xe * re, p[7] = 0, p[8] = xe * Re * me + Te * re, p[9] = Te * Re * me - xe * re, p[10] = Re * Re * me + le, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p);
      }
      function Tn(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = 1, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = re, p[6] = B, p[7] = 0, p[8] = 0, p[9] = -B, p[10] = re, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function Sn(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = re, p[1] = 0, p[2] = -B, p[3] = 0, p[4] = 0, p[5] = 1, p[6] = 0, p[7] = 0, p[8] = B, p[9] = 0, p[10] = re, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function wr(p, S) {
        var B = Math.sin(S), re = Math.cos(S);
        return p[0] = re, p[1] = B, p[2] = 0, p[3] = 0, p[4] = -B, p[5] = re, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = 1, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function Qn(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = re + re, Re = le + le, Pe = me + me, Xe = re * Te, st = re * Re, ot = re * Pe, lt = le * Re, vt = le * Pe, yt = me * Pe, ht = xe * Te, Tt = xe * Re, Ot = xe * Pe;
        return p[0] = 1 - (lt + yt), p[1] = st + Ot, p[2] = ot - Tt, p[3] = 0, p[4] = st - Ot, p[5] = 1 - (Xe + yt), p[6] = vt + ht, p[7] = 0, p[8] = ot + Tt, p[9] = vt - ht, p[10] = 1 - (Xe + lt), p[11] = 0, p[12] = B[0], p[13] = B[1], p[14] = B[2], p[15] = 1, p;
      }
      function Fn(p, S) {
        var B = new b(3), re = -S[0], le = -S[1], me = -S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = re * re + le * le + me * me + xe * xe;
        return st > 0 ? (B[0] = 2 * (Te * xe + Xe * re + Re * me - Pe * le) / st, B[1] = 2 * (Re * xe + Xe * le + Pe * re - Te * me) / st, B[2] = 2 * (Pe * xe + Xe * me + Te * le - Re * re) / st) : (B[0] = 2 * (Te * xe + Xe * re + Re * me - Pe * le), B[1] = 2 * (Re * xe + Xe * le + Pe * re - Te * me), B[2] = 2 * (Pe * xe + Xe * me + Te * le - Re * re)), Qn(p, S, B), p;
      }
      function Wn(p, S) {
        return p[0] = S[12], p[1] = S[13], p[2] = S[14], p;
      }
      function Jn(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[4], xe = S[5], Te = S[6], Re = S[8], Pe = S[9], Xe = S[10];
        return p[0] = Math.hypot(B, re, le), p[1] = Math.hypot(me, xe, Te), p[2] = Math.hypot(Re, Pe, Xe), p;
      }
      function er(p, S) {
        var B = new b(3);
        Jn(B, S);
        var re = 1 / B[0], le = 1 / B[1], me = 1 / B[2], xe = S[0] * re, Te = S[1] * le, Re = S[2] * me, Pe = S[4] * re, Xe = S[5] * le, st = S[6] * me, ot = S[8] * re, lt = S[9] * le, vt = S[10] * me, yt = xe + Xe + vt, ht = 0;
        return yt > 0 ? (ht = 2 * Math.sqrt(yt + 1), p[3] = 0.25 * ht, p[0] = (st - lt) / ht, p[1] = (ot - Re) / ht, p[2] = (Te - Pe) / ht) : xe > Xe && xe > vt ? (ht = 2 * Math.sqrt(1 + xe - Xe - vt), p[3] = (st - lt) / ht, p[0] = 0.25 * ht, p[1] = (Te + Pe) / ht, p[2] = (ot + Re) / ht) : Xe > vt ? (ht = 2 * Math.sqrt(1 + Xe - xe - vt), p[3] = (ot - Re) / ht, p[0] = (Te + Pe) / ht, p[1] = 0.25 * ht, p[2] = (st + lt) / ht) : (ht = 2 * Math.sqrt(1 + vt - xe - Xe), p[3] = (Te - Pe) / ht, p[0] = (ot + Re) / ht, p[1] = (st + lt) / ht, p[2] = 0.25 * ht), p;
      }
      function Dr(p, S, B, re) {
        var le = S[0], me = S[1], xe = S[2], Te = S[3], Re = le + le, Pe = me + me, Xe = xe + xe, st = le * Re, ot = le * Pe, lt = le * Xe, vt = me * Pe, yt = me * Xe, ht = xe * Xe, Tt = Te * Re, Ot = Te * Pe, Ft = Te * Xe, Lt = re[0], Bt = re[1], Nt = re[2];
        return p[0] = (1 - (vt + ht)) * Lt, p[1] = (ot + Ft) * Lt, p[2] = (lt - Ot) * Lt, p[3] = 0, p[4] = (ot - Ft) * Bt, p[5] = (1 - (st + ht)) * Bt, p[6] = (yt + Tt) * Bt, p[7] = 0, p[8] = (lt + Ot) * Nt, p[9] = (yt - Tt) * Nt, p[10] = (1 - (st + vt)) * Nt, p[11] = 0, p[12] = B[0], p[13] = B[1], p[14] = B[2], p[15] = 1, p;
      }
      function tr(p, S, B, re, le) {
        var me = S[0], xe = S[1], Te = S[2], Re = S[3], Pe = me + me, Xe = xe + xe, st = Te + Te, ot = me * Pe, lt = me * Xe, vt = me * st, yt = xe * Xe, ht = xe * st, Tt = Te * st, Ot = Re * Pe, Ft = Re * Xe, Lt = Re * st, Bt = re[0], Nt = re[1], tn = re[2], Jt = le[0], en = le[1], Zt = le[2], rn = (1 - (yt + Tt)) * Bt, $t = (lt + Lt) * Bt, Yt = (vt - Ft) * Bt, kt = (lt - Lt) * Nt, gn = (1 - (ot + Tt)) * Nt, Gn = (ht + Ot) * Nt, Hn = (vt + Ft) * tn, va = (ht - Ot) * tn, xa = (1 - (ot + yt)) * tn;
        return p[0] = rn, p[1] = $t, p[2] = Yt, p[3] = 0, p[4] = kt, p[5] = gn, p[6] = Gn, p[7] = 0, p[8] = Hn, p[9] = va, p[10] = xa, p[11] = 0, p[12] = B[0] + Jt - (rn * Jt + kt * en + Hn * Zt), p[13] = B[1] + en - ($t * Jt + gn * en + va * Zt), p[14] = B[2] + Zt - (Yt * Jt + Gn * en + xa * Zt), p[15] = 1, p;
      }
      function bn(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = B + B, Te = re + re, Re = le + le, Pe = B * xe, Xe = re * xe, st = re * Te, ot = le * xe, lt = le * Te, vt = le * Re, yt = me * xe, ht = me * Te, Tt = me * Re;
        return p[0] = 1 - st - vt, p[1] = Xe + Tt, p[2] = ot - ht, p[3] = 0, p[4] = Xe - Tt, p[5] = 1 - Pe - vt, p[6] = lt + yt, p[7] = 0, p[8] = ot + ht, p[9] = lt - yt, p[10] = 1 - Pe - st, p[11] = 0, p[12] = 0, p[13] = 0, p[14] = 0, p[15] = 1, p;
      }
      function Vn(p, S, B, re, le, me, xe) {
        var Te = 1 / (B - S), Re = 1 / (le - re), Pe = 1 / (me - xe);
        return p[0] = 2 * me * Te, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = 2 * me * Re, p[6] = 0, p[7] = 0, p[8] = (B + S) * Te, p[9] = (le + re) * Re, p[10] = (xe + me) * Pe, p[11] = -1, p[12] = 0, p[13] = 0, p[14] = xe * me * 2 * Pe, p[15] = 0, p;
      }
      function nr(p, S, B, re, le) {
        var me, xe = 1 / Math.tan(S / 2);
        return p[0] = xe / B, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = xe, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[11] = -1, p[12] = 0, p[13] = 0, p[15] = 0, le != null && le !== 1 / 0 ? (me = 1 / (re - le), p[10] = (le + re) * me, p[14] = 2 * le * re * me) : (p[10] = -1, p[14] = -2 * re), p;
      }
      var rr = nr;
      function In(p, S, B, re, le) {
        var me, xe = 1 / Math.tan(S / 2);
        return p[0] = xe / B, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = xe, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[11] = -1, p[12] = 0, p[13] = 0, p[15] = 0, le != null && le !== 1 / 0 ? (me = 1 / (re - le), p[10] = le * me, p[14] = le * re * me) : (p[10] = -1, p[14] = -re), p;
      }
      function Cn(p, S, B, re) {
        var le = Math.tan(S.upDegrees * Math.PI / 180), me = Math.tan(S.downDegrees * Math.PI / 180), xe = Math.tan(S.leftDegrees * Math.PI / 180), Te = Math.tan(S.rightDegrees * Math.PI / 180), Re = 2 / (xe + Te), Pe = 2 / (le + me);
        return p[0] = Re, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = Pe, p[6] = 0, p[7] = 0, p[8] = -(xe - Te) * Re * 0.5, p[9] = (le - me) * Pe * 0.5, p[10] = re / (B - re), p[11] = -1, p[12] = 0, p[13] = 0, p[14] = re * B / (B - re), p[15] = 0, p;
      }
      function ir(p, S, B, re, le, me, xe) {
        var Te = 1 / (S - B), Re = 1 / (re - le), Pe = 1 / (me - xe);
        return p[0] = -2 * Te, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = -2 * Re, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = 2 * Pe, p[11] = 0, p[12] = (S + B) * Te, p[13] = (le + re) * Re, p[14] = (xe + me) * Pe, p[15] = 1, p;
      }
      var ar = ir;
      function Rr(p, S, B, re, le, me, xe) {
        var Te = 1 / (S - B), Re = 1 / (re - le), Pe = 1 / (me - xe);
        return p[0] = -2 * Te, p[1] = 0, p[2] = 0, p[3] = 0, p[4] = 0, p[5] = -2 * Re, p[6] = 0, p[7] = 0, p[8] = 0, p[9] = 0, p[10] = Pe, p[11] = 0, p[12] = (S + B) * Te, p[13] = (le + re) * Re, p[14] = me * Pe, p[15] = 1, p;
      }
      function sr(p, S, B, re) {
        var le, me, xe, Te, Re, Pe, Xe, st, ot, lt, vt = S[0], yt = S[1], ht = S[2], Tt = re[0], Ot = re[1], Ft = re[2], Lt = B[0], Bt = B[1], Nt = B[2];
        return Math.abs(vt - Lt) < A && Math.abs(yt - Bt) < A && Math.abs(ht - Nt) < A ? zt(p) : (Xe = vt - Lt, st = yt - Bt, ot = ht - Nt, le = Ot * (ot *= lt = 1 / Math.hypot(Xe, st, ot)) - Ft * (st *= lt), me = Ft * (Xe *= lt) - Tt * ot, xe = Tt * st - Ot * Xe, (lt = Math.hypot(le, me, xe)) ? (le *= lt = 1 / lt, me *= lt, xe *= lt) : (le = 0, me = 0, xe = 0), Te = st * xe - ot * me, Re = ot * le - Xe * xe, Pe = Xe * me - st * le, (lt = Math.hypot(Te, Re, Pe)) ? (Te *= lt = 1 / lt, Re *= lt, Pe *= lt) : (Te = 0, Re = 0, Pe = 0), p[0] = le, p[1] = Te, p[2] = Xe, p[3] = 0, p[4] = me, p[5] = Re, p[6] = st, p[7] = 0, p[8] = xe, p[9] = Pe, p[10] = ot, p[11] = 0, p[12] = -(le * vt + me * yt + xe * ht), p[13] = -(Te * vt + Re * yt + Pe * ht), p[14] = -(Xe * vt + st * yt + ot * ht), p[15] = 1, p);
      }
      function Mr(p, S, B, re) {
        var le = S[0], me = S[1], xe = S[2], Te = re[0], Re = re[1], Pe = re[2], Xe = le - B[0], st = me - B[1], ot = xe - B[2], lt = Xe * Xe + st * st + ot * ot;
        lt > 0 && (Xe *= lt = 1 / Math.sqrt(lt), st *= lt, ot *= lt);
        var vt = Re * ot - Pe * st, yt = Pe * Xe - Te * ot, ht = Te * st - Re * Xe;
        return (lt = vt * vt + yt * yt + ht * ht) > 0 && (vt *= lt = 1 / Math.sqrt(lt), yt *= lt, ht *= lt), p[0] = vt, p[1] = yt, p[2] = ht, p[3] = 0, p[4] = st * ht - ot * yt, p[5] = ot * vt - Xe * ht, p[6] = Xe * yt - st * vt, p[7] = 0, p[8] = Xe, p[9] = st, p[10] = ot, p[11] = 0, p[12] = le, p[13] = me, p[14] = xe, p[15] = 1, p;
      }
      function Fr(p) {
        return "mat4(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ", " + p[4] + ", " + p[5] + ", " + p[6] + ", " + p[7] + ", " + p[8] + ", " + p[9] + ", " + p[10] + ", " + p[11] + ", " + p[12] + ", " + p[13] + ", " + p[14] + ", " + p[15] + ")";
      }
      function wn(p) {
        return Math.hypot(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], p[9], p[10], p[11], p[12], p[13], p[14], p[15]);
      }
      function Ir(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p[4] = S[4] + B[4], p[5] = S[5] + B[5], p[6] = S[6] + B[6], p[7] = S[7] + B[7], p[8] = S[8] + B[8], p[9] = S[9] + B[9], p[10] = S[10] + B[10], p[11] = S[11] + B[11], p[12] = S[12] + B[12], p[13] = S[13] + B[13], p[14] = S[14] + B[14], p[15] = S[15] + B[15], p;
      }
      function Dn(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p[3] = S[3] - B[3], p[4] = S[4] - B[4], p[5] = S[5] - B[5], p[6] = S[6] - B[6], p[7] = S[7] - B[7], p[8] = S[8] - B[8], p[9] = S[9] - B[9], p[10] = S[10] - B[10], p[11] = S[11] - B[11], p[12] = S[12] - B[12], p[13] = S[13] - B[13], p[14] = S[14] - B[14], p[15] = S[15] - B[15], p;
      }
      function or(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p[4] = S[4] * B, p[5] = S[5] * B, p[6] = S[6] * B, p[7] = S[7] * B, p[8] = S[8] * B, p[9] = S[9] * B, p[10] = S[10] * B, p[11] = S[11] * B, p[12] = S[12] * B, p[13] = S[13] * B, p[14] = S[14] * B, p[15] = S[15] * B, p;
      }
      function Et(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p[3] = S[3] + B[3] * re, p[4] = S[4] + B[4] * re, p[5] = S[5] + B[5] * re, p[6] = S[6] + B[6] * re, p[7] = S[7] + B[7] * re, p[8] = S[8] + B[8] * re, p[9] = S[9] + B[9] * re, p[10] = S[10] + B[10] * re, p[11] = S[11] + B[11] * re, p[12] = S[12] + B[12] * re, p[13] = S[13] + B[13] * re, p[14] = S[14] + B[14] * re, p[15] = S[15] + B[15] * re, p;
      }
      function Ct(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3] && p[4] === S[4] && p[5] === S[5] && p[6] === S[6] && p[7] === S[7] && p[8] === S[8] && p[9] === S[9] && p[10] === S[10] && p[11] === S[11] && p[12] === S[12] && p[13] === S[13] && p[14] === S[14] && p[15] === S[15];
      }
      function It(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = p[4], Te = p[5], Re = p[6], Pe = p[7], Xe = p[8], st = p[9], ot = p[10], lt = p[11], vt = p[12], yt = p[13], ht = p[14], Tt = p[15], Ot = S[0], Ft = S[1], Lt = S[2], Bt = S[3], Nt = S[4], tn = S[5], Jt = S[6], en = S[7], Zt = S[8], rn = S[9], $t = S[10], Yt = S[11], kt = S[12], gn = S[13], Gn = S[14], Hn = S[15];
        return Math.abs(B - Ot) <= A * Math.max(1, Math.abs(B), Math.abs(Ot)) && Math.abs(re - Ft) <= A * Math.max(1, Math.abs(re), Math.abs(Ft)) && Math.abs(le - Lt) <= A * Math.max(1, Math.abs(le), Math.abs(Lt)) && Math.abs(me - Bt) <= A * Math.max(1, Math.abs(me), Math.abs(Bt)) && Math.abs(xe - Nt) <= A * Math.max(1, Math.abs(xe), Math.abs(Nt)) && Math.abs(Te - tn) <= A * Math.max(1, Math.abs(Te), Math.abs(tn)) && Math.abs(Re - Jt) <= A * Math.max(1, Math.abs(Re), Math.abs(Jt)) && Math.abs(Pe - en) <= A * Math.max(1, Math.abs(Pe), Math.abs(en)) && Math.abs(Xe - Zt) <= A * Math.max(1, Math.abs(Xe), Math.abs(Zt)) && Math.abs(st - rn) <= A * Math.max(1, Math.abs(st), Math.abs(rn)) && Math.abs(ot - $t) <= A * Math.max(1, Math.abs(ot), Math.abs($t)) && Math.abs(lt - Yt) <= A * Math.max(1, Math.abs(lt), Math.abs(Yt)) && Math.abs(vt - kt) <= A * Math.max(1, Math.abs(vt), Math.abs(kt)) && Math.abs(yt - gn) <= A * Math.max(1, Math.abs(yt), Math.abs(gn)) && Math.abs(ht - Gn) <= A * Math.max(1, Math.abs(ht), Math.abs(Gn)) && Math.abs(Tt - Hn) <= A * Math.max(1, Math.abs(Tt), Math.abs(Hn));
      }
      var Pt = Kt, Gt = Dn;
      function Ht() {
        var p = new b(3);
        return b != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0), p;
      }
      function qt(p) {
        var S = new b(3);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S;
      }
      function jt(p) {
        var S = p[0], B = p[1], re = p[2];
        return Math.hypot(S, B, re);
      }
      function nn(p, S, B) {
        var re = new b(3);
        return re[0] = p, re[1] = S, re[2] = B, re;
      }
      function ln(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p;
      }
      function _n(p, S, B, re) {
        return p[0] = S, p[1] = B, p[2] = re, p;
      }
      function Pr(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p;
      }
      function Pn(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p;
      }
      function Ln(p, S, B) {
        return p[0] = S[0] * B[0], p[1] = S[1] * B[1], p[2] = S[2] * B[2], p;
      }
      function cr(p, S, B) {
        return p[0] = S[0] / B[0], p[1] = S[1] / B[1], p[2] = S[2] / B[2], p;
      }
      function es(p, S) {
        return p[0] = Math.ceil(S[0]), p[1] = Math.ceil(S[1]), p[2] = Math.ceil(S[2]), p;
      }
      function ts(p, S) {
        return p[0] = Math.floor(S[0]), p[1] = Math.floor(S[1]), p[2] = Math.floor(S[2]), p;
      }
      function ns(p, S, B) {
        return p[0] = Math.min(S[0], B[0]), p[1] = Math.min(S[1], B[1]), p[2] = Math.min(S[2], B[2]), p;
      }
      function rs(p, S, B) {
        return p[0] = Math.max(S[0], B[0]), p[1] = Math.max(S[1], B[1]), p[2] = Math.max(S[2], B[2]), p;
      }
      function is(p, S) {
        return p[0] = Math.round(S[0]), p[1] = Math.round(S[1]), p[2] = Math.round(S[2]), p;
      }
      function as(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p;
      }
      function ss(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p;
      }
      function Ci(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1], le = S[2] - p[2];
        return Math.hypot(B, re, le);
      }
      function wi(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1], le = S[2] - p[2];
        return B * B + re * re + le * le;
      }
      function Di(p) {
        var S = p[0], B = p[1], re = p[2];
        return S * S + B * B + re * re;
      }
      function os(p, S) {
        return p[0] = -S[0], p[1] = -S[1], p[2] = -S[2], p;
      }
      function cs(p, S) {
        return p[0] = 1 / S[0], p[1] = 1 / S[1], p[2] = 1 / S[2], p;
      }
      function Ri(p, S) {
        var B = S[0], re = S[1], le = S[2], me = B * B + re * re + le * le;
        return me > 0 && (me = 1 / Math.sqrt(me)), p[0] = S[0] * me, p[1] = S[1] * me, p[2] = S[2] * me, p;
      }
      function Lr(p, S) {
        return p[0] * S[0] + p[1] * S[1] + p[2] * S[2];
      }
      function lr(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = B[0], Te = B[1], Re = B[2];
        return p[0] = le * Re - me * Te, p[1] = me * xe - re * Re, p[2] = re * Te - le * xe, p;
      }
      function ls(p, S, B, re) {
        var le = S[0], me = S[1], xe = S[2];
        return p[0] = le + re * (B[0] - le), p[1] = me + re * (B[1] - me), p[2] = xe + re * (B[2] - xe), p;
      }
      function us(p, S, B, re, le, me) {
        var xe = me * me, Te = xe * (2 * me - 3) + 1, Re = xe * (me - 2) + me, Pe = xe * (me - 1), Xe = xe * (3 - 2 * me);
        return p[0] = S[0] * Te + B[0] * Re + re[0] * Pe + le[0] * Xe, p[1] = S[1] * Te + B[1] * Re + re[1] * Pe + le[1] * Xe, p[2] = S[2] * Te + B[2] * Re + re[2] * Pe + le[2] * Xe, p;
      }
      function ds(p, S, B, re, le, me) {
        var xe = 1 - me, Te = xe * xe, Re = me * me, Pe = Te * xe, Xe = 3 * me * Te, st = 3 * Re * xe, ot = Re * me;
        return p[0] = S[0] * Pe + B[0] * Xe + re[0] * st + le[0] * ot, p[1] = S[1] * Pe + B[1] * Xe + re[1] * st + le[1] * ot, p[2] = S[2] * Pe + B[2] * Xe + re[2] * st + le[2] * ot, p;
      }
      function fs(p, S) {
        S = S || 1;
        var B = 2 * C() * Math.PI, re = 2 * C() - 1, le = Math.sqrt(1 - re * re) * S;
        return p[0] = Math.cos(B) * le, p[1] = Math.sin(B) * le, p[2] = re * S, p;
      }
      function hs(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = B[3] * re + B[7] * le + B[11] * me + B[15];
        return xe = xe || 1, p[0] = (B[0] * re + B[4] * le + B[8] * me + B[12]) / xe, p[1] = (B[1] * re + B[5] * le + B[9] * me + B[13]) / xe, p[2] = (B[2] * re + B[6] * le + B[10] * me + B[14]) / xe, p;
      }
      function ps(p, S, B) {
        var re = S[0], le = S[1], me = S[2];
        return p[0] = re * B[0] + le * B[3] + me * B[6], p[1] = re * B[1] + le * B[4] + me * B[7], p[2] = re * B[2] + le * B[5] + me * B[8], p;
      }
      function gs(p, S, B) {
        var re = B[0], le = B[1], me = B[2], xe = B[3], Te = S[0], Re = S[1], Pe = S[2], Xe = le * Pe - me * Re, st = me * Te - re * Pe, ot = re * Re - le * Te, lt = le * ot - me * st, vt = me * Xe - re * ot, yt = re * st - le * Xe, ht = 2 * xe;
        return Xe *= ht, st *= ht, ot *= ht, lt *= 2, vt *= 2, yt *= 2, p[0] = Te + Xe + lt, p[1] = Re + st + vt, p[2] = Pe + ot + yt, p;
      }
      function ms(p, S, B, re) {
        var le = [], me = [];
        return le[0] = S[0] - B[0], le[1] = S[1] - B[1], le[2] = S[2] - B[2], me[0] = le[0], me[1] = le[1] * Math.cos(re) - le[2] * Math.sin(re), me[2] = le[1] * Math.sin(re) + le[2] * Math.cos(re), p[0] = me[0] + B[0], p[1] = me[1] + B[1], p[2] = me[2] + B[2], p;
      }
      function _s(p, S, B, re) {
        var le = [], me = [];
        return le[0] = S[0] - B[0], le[1] = S[1] - B[1], le[2] = S[2] - B[2], me[0] = le[2] * Math.sin(re) + le[0] * Math.cos(re), me[1] = le[1], me[2] = le[2] * Math.cos(re) - le[0] * Math.sin(re), p[0] = me[0] + B[0], p[1] = me[1] + B[1], p[2] = me[2] + B[2], p;
      }
      function vs(p, S, B, re) {
        var le = [], me = [];
        return le[0] = S[0] - B[0], le[1] = S[1] - B[1], le[2] = S[2] - B[2], me[0] = le[0] * Math.cos(re) - le[1] * Math.sin(re), me[1] = le[0] * Math.sin(re) + le[1] * Math.cos(re), me[2] = le[2], p[0] = me[0] + B[0], p[1] = me[1] + B[1], p[2] = me[2] + B[2], p;
      }
      function xs(p, S) {
        var B = p[0], re = p[1], le = p[2], me = S[0], xe = S[1], Te = S[2], Re = Math.sqrt(B * B + re * re + le * le) * Math.sqrt(me * me + xe * xe + Te * Te), Pe = Re && Lr(p, S) / Re;
        return Math.acos(Math.min(Math.max(Pe, -1), 1));
      }
      function ys(p) {
        return p[0] = 0, p[1] = 0, p[2] = 0, p;
      }
      function bs(p) {
        return "vec3(" + p[0] + ", " + p[1] + ", " + p[2] + ")";
      }
      function Es(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2];
      }
      function As(p, S) {
        var B = p[0], re = p[1], le = p[2], me = S[0], xe = S[1], Te = S[2];
        return Math.abs(B - me) <= A * Math.max(1, Math.abs(B), Math.abs(me)) && Math.abs(re - xe) <= A * Math.max(1, Math.abs(re), Math.abs(xe)) && Math.abs(le - Te) <= A * Math.max(1, Math.abs(le), Math.abs(Te));
      }
      var vn, Ts = Pn, Ss = Ln, Cs = cr, ws = Ci, Ds = wi, Mi = jt, Rs = Di, Ms = (vn = Ht(), function(p, S, B, re, le, me) {
        var xe, Te;
        for (S || (S = 3), B || (B = 0), Te = re ? Math.min(re * S + B, p.length) : p.length, xe = B; xe < Te; xe += S)
          vn[0] = p[xe], vn[1] = p[xe + 1], vn[2] = p[xe + 2], le(vn, vn, me), p[xe] = vn[0], p[xe + 1] = vn[1], p[xe + 2] = vn[2];
        return p;
      });
      function Fi() {
        var p = new b(4);
        return b != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 0), p;
      }
      function Ii(p) {
        var S = new b(4);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S;
      }
      function Pi(p, S, B, re) {
        var le = new b(4);
        return le[0] = p, le[1] = S, le[2] = B, le[3] = re, le;
      }
      function Li(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p;
      }
      function Ui(p, S, B, re, le) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p;
      }
      function Oi(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p;
      }
      function Ni(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p[2] = S[2] - B[2], p[3] = S[3] - B[3], p;
      }
      function ki(p, S, B) {
        return p[0] = S[0] * B[0], p[1] = S[1] * B[1], p[2] = S[2] * B[2], p[3] = S[3] * B[3], p;
      }
      function Bi(p, S, B) {
        return p[0] = S[0] / B[0], p[1] = S[1] / B[1], p[2] = S[2] / B[2], p[3] = S[3] / B[3], p;
      }
      function Fs(p, S) {
        return p[0] = Math.ceil(S[0]), p[1] = Math.ceil(S[1]), p[2] = Math.ceil(S[2]), p[3] = Math.ceil(S[3]), p;
      }
      function Is(p, S) {
        return p[0] = Math.floor(S[0]), p[1] = Math.floor(S[1]), p[2] = Math.floor(S[2]), p[3] = Math.floor(S[3]), p;
      }
      function Ps(p, S, B) {
        return p[0] = Math.min(S[0], B[0]), p[1] = Math.min(S[1], B[1]), p[2] = Math.min(S[2], B[2]), p[3] = Math.min(S[3], B[3]), p;
      }
      function Ls(p, S, B) {
        return p[0] = Math.max(S[0], B[0]), p[1] = Math.max(S[1], B[1]), p[2] = Math.max(S[2], B[2]), p[3] = Math.max(S[3], B[3]), p;
      }
      function Us(p, S) {
        return p[0] = Math.round(S[0]), p[1] = Math.round(S[1]), p[2] = Math.round(S[2]), p[3] = Math.round(S[3]), p;
      }
      function Wi(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p;
      }
      function Os(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p[2] = S[2] + B[2] * re, p[3] = S[3] + B[3] * re, p;
      }
      function Vi(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1], le = S[2] - p[2], me = S[3] - p[3];
        return Math.hypot(B, re, le, me);
      }
      function Gi(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1], le = S[2] - p[2], me = S[3] - p[3];
        return B * B + re * re + le * le + me * me;
      }
      function Ur(p) {
        var S = p[0], B = p[1], re = p[2], le = p[3];
        return Math.hypot(S, B, re, le);
      }
      function Or(p) {
        var S = p[0], B = p[1], re = p[2], le = p[3];
        return S * S + B * B + re * re + le * le;
      }
      function Ns(p, S) {
        return p[0] = -S[0], p[1] = -S[1], p[2] = -S[2], p[3] = -S[3], p;
      }
      function ks(p, S) {
        return p[0] = 1 / S[0], p[1] = 1 / S[1], p[2] = 1 / S[2], p[3] = 1 / S[3], p;
      }
      function Hi(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = B * B + re * re + le * le + me * me;
        return xe > 0 && (xe = 1 / Math.sqrt(xe)), p[0] = B * xe, p[1] = re * xe, p[2] = le * xe, p[3] = me * xe, p;
      }
      function zi(p, S) {
        return p[0] * S[0] + p[1] * S[1] + p[2] * S[2] + p[3] * S[3];
      }
      function Bs(p, S, B, re) {
        var le = B[0] * re[1] - B[1] * re[0], me = B[0] * re[2] - B[2] * re[0], xe = B[0] * re[3] - B[3] * re[0], Te = B[1] * re[2] - B[2] * re[1], Re = B[1] * re[3] - B[3] * re[1], Pe = B[2] * re[3] - B[3] * re[2], Xe = S[0], st = S[1], ot = S[2], lt = S[3];
        return p[0] = st * Pe - ot * Re + lt * Te, p[1] = -Xe * Pe + ot * xe - lt * me, p[2] = Xe * Re - st * xe + lt * le, p[3] = -Xe * Te + st * me - ot * le, p;
      }
      function Xi(p, S, B, re) {
        var le = S[0], me = S[1], xe = S[2], Te = S[3];
        return p[0] = le + re * (B[0] - le), p[1] = me + re * (B[1] - me), p[2] = xe + re * (B[2] - xe), p[3] = Te + re * (B[3] - Te), p;
      }
      function Ws(p, S) {
        var B, re, le, me, xe, Te;
        S = S || 1;
        do
          xe = (B = 2 * C() - 1) * B + (re = 2 * C() - 1) * re;
        while (xe >= 1);
        do
          Te = (le = 2 * C() - 1) * le + (me = 2 * C() - 1) * me;
        while (Te >= 1);
        var Re = Math.sqrt((1 - xe) / Te);
        return p[0] = S * B, p[1] = S * re, p[2] = S * le * Re, p[3] = S * me * Re, p;
      }
      function Vs(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3];
        return p[0] = B[0] * re + B[4] * le + B[8] * me + B[12] * xe, p[1] = B[1] * re + B[5] * le + B[9] * me + B[13] * xe, p[2] = B[2] * re + B[6] * le + B[10] * me + B[14] * xe, p[3] = B[3] * re + B[7] * le + B[11] * me + B[15] * xe, p;
      }
      function Gs(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = B[0], Te = B[1], Re = B[2], Pe = B[3], Xe = Pe * re + Te * me - Re * le, st = Pe * le + Re * re - xe * me, ot = Pe * me + xe * le - Te * re, lt = -xe * re - Te * le - Re * me;
        return p[0] = Xe * Pe + lt * -xe + st * -Re - ot * -Te, p[1] = st * Pe + lt * -Te + ot * -xe - Xe * -Re, p[2] = ot * Pe + lt * -Re + Xe * -Te - st * -xe, p[3] = S[3], p;
      }
      function Hs(p) {
        return p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 0, p;
      }
      function zs(p) {
        return "vec4(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ")";
      }
      function qi(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3];
      }
      function ji(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = S[0], Te = S[1], Re = S[2], Pe = S[3];
        return Math.abs(B - xe) <= A * Math.max(1, Math.abs(B), Math.abs(xe)) && Math.abs(re - Te) <= A * Math.max(1, Math.abs(re), Math.abs(Te)) && Math.abs(le - Re) <= A * Math.max(1, Math.abs(le), Math.abs(Re)) && Math.abs(me - Pe) <= A * Math.max(1, Math.abs(me), Math.abs(Pe));
      }
      var Xs = Ni, qs = ki, js = Bi, $s = Vi, Ys = Gi, Ks = Ur, Zs = Or, Qs = function() {
        var p = Fi();
        return function(S, B, re, le, me, xe) {
          var Te, Re;
          for (B || (B = 4), re || (re = 0), Re = le ? Math.min(le * B + re, S.length) : S.length, Te = re; Te < Re; Te += B)
            p[0] = S[Te], p[1] = S[Te + 1], p[2] = S[Te + 2], p[3] = S[Te + 3], me(p, p, xe), S[Te] = p[0], S[Te + 1] = p[1], S[Te + 2] = p[2], S[Te + 3] = p[3];
          return S;
        };
      }();
      function ur() {
        var p = new b(4);
        return b != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0), p[3] = 1, p;
      }
      function Js(p) {
        return p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 1, p;
      }
      function $i(p, S, B) {
        B *= 0.5;
        var re = Math.sin(B);
        return p[0] = re * S[0], p[1] = re * S[1], p[2] = re * S[2], p[3] = Math.cos(B), p;
      }
      function eo(p, S) {
        var B = 2 * Math.acos(S[3]), re = Math.sin(B / 2);
        return re > A ? (p[0] = S[0] / re, p[1] = S[1] / re, p[2] = S[2] / re) : (p[0] = 1, p[1] = 0, p[2] = 0), B;
      }
      function to(p, S) {
        var B = Wr(p, S);
        return Math.acos(2 * B * B - 1);
      }
      function Yi(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = B[0], Re = B[1], Pe = B[2], Xe = B[3];
        return p[0] = re * Xe + xe * Te + le * Pe - me * Re, p[1] = le * Xe + xe * Re + me * Te - re * Pe, p[2] = me * Xe + xe * Pe + re * Re - le * Te, p[3] = xe * Xe - re * Te - le * Re - me * Pe, p;
      }
      function Ki(p, S, B) {
        B *= 0.5;
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = Math.sin(B), Re = Math.cos(B);
        return p[0] = re * Re + xe * Te, p[1] = le * Re + me * Te, p[2] = me * Re - le * Te, p[3] = xe * Re - re * Te, p;
      }
      function Zi(p, S, B) {
        B *= 0.5;
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = Math.sin(B), Re = Math.cos(B);
        return p[0] = re * Re - me * Te, p[1] = le * Re + xe * Te, p[2] = me * Re + re * Te, p[3] = xe * Re - le * Te, p;
      }
      function Qi(p, S, B) {
        B *= 0.5;
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = Math.sin(B), Re = Math.cos(B);
        return p[0] = re * Re + le * Te, p[1] = le * Re - re * Te, p[2] = me * Re + xe * Te, p[3] = xe * Re - me * Te, p;
      }
      function no(p, S) {
        var B = S[0], re = S[1], le = S[2];
        return p[0] = B, p[1] = re, p[2] = le, p[3] = Math.sqrt(Math.abs(1 - B * B - re * re - le * le)), p;
      }
      function Ji(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = Math.sqrt(B * B + re * re + le * le), Te = Math.exp(me), Re = xe > 0 ? Te * Math.sin(xe) / xe : 0;
        return p[0] = B * Re, p[1] = re * Re, p[2] = le * Re, p[3] = Te * Math.cos(xe), p;
      }
      function ea(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = Math.sqrt(B * B + re * re + le * le), Te = xe > 0 ? Math.atan2(xe, me) / xe : 0;
        return p[0] = B * Te, p[1] = re * Te, p[2] = le * Te, p[3] = 0.5 * Math.log(B * B + re * re + le * le + me * me), p;
      }
      function ro(p, S, B) {
        return ea(p, S), ia(p, p, B), Ji(p, p), p;
      }
      function dr(p, S, B, re) {
        var le, me, xe, Te, Re, Pe = S[0], Xe = S[1], st = S[2], ot = S[3], lt = B[0], vt = B[1], yt = B[2], ht = B[3];
        return (me = Pe * lt + Xe * vt + st * yt + ot * ht) < 0 && (me = -me, lt = -lt, vt = -vt, yt = -yt, ht = -ht), 1 - me > A ? (le = Math.acos(me), xe = Math.sin(le), Te = Math.sin((1 - re) * le) / xe, Re = Math.sin(re * le) / xe) : (Te = 1 - re, Re = re), p[0] = Te * Pe + Re * lt, p[1] = Te * Xe + Re * vt, p[2] = Te * st + Re * yt, p[3] = Te * ot + Re * ht, p;
      }
      function io(p) {
        var S = C(), B = C(), re = C(), le = Math.sqrt(1 - S), me = Math.sqrt(S);
        return p[0] = le * Math.sin(2 * Math.PI * B), p[1] = le * Math.cos(2 * Math.PI * B), p[2] = me * Math.sin(2 * Math.PI * re), p[3] = me * Math.cos(2 * Math.PI * re), p;
      }
      function ao(p, S) {
        var B = S[0], re = S[1], le = S[2], me = S[3], xe = B * B + re * re + le * le + me * me, Te = xe ? 1 / xe : 0;
        return p[0] = -B * Te, p[1] = -re * Te, p[2] = -le * Te, p[3] = me * Te, p;
      }
      function so(p, S) {
        return p[0] = -S[0], p[1] = -S[1], p[2] = -S[2], p[3] = S[3], p;
      }
      function ta(p, S) {
        var B, re = S[0] + S[4] + S[8];
        if (re > 0)
          B = Math.sqrt(re + 1), p[3] = 0.5 * B, B = 0.5 / B, p[0] = (S[5] - S[7]) * B, p[1] = (S[6] - S[2]) * B, p[2] = (S[1] - S[3]) * B;
        else {
          var le = 0;
          S[4] > S[0] && (le = 1), S[8] > S[3 * le + le] && (le = 2);
          var me = (le + 1) % 3, xe = (le + 2) % 3;
          B = Math.sqrt(S[3 * le + le] - S[3 * me + me] - S[3 * xe + xe] + 1), p[le] = 0.5 * B, B = 0.5 / B, p[3] = (S[3 * me + xe] - S[3 * xe + me]) * B, p[me] = (S[3 * me + le] + S[3 * le + me]) * B, p[xe] = (S[3 * xe + le] + S[3 * le + xe]) * B;
        }
        return p;
      }
      function oo(p, S, B, re) {
        var le = 0.5 * Math.PI / 180;
        S *= le, B *= le, re *= le;
        var me = Math.sin(S), xe = Math.cos(S), Te = Math.sin(B), Re = Math.cos(B), Pe = Math.sin(re), Xe = Math.cos(re);
        return p[0] = me * Re * Xe - xe * Te * Pe, p[1] = xe * Te * Xe + me * Re * Pe, p[2] = xe * Re * Pe - me * Te * Xe, p[3] = xe * Re * Xe + me * Te * Pe, p;
      }
      function co(p) {
        return "quat(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ")";
      }
      var hn, na, ra, Nr, kr, pn, lo = Ii, uo = Pi, Br = Li, fo = Ui, ho = Oi, po = Yi, ia = Wi, Wr = zi, go = Xi, Vr = Ur, mo = Vr, Gr = Or, _o = Gr, Hr = Hi, vo = qi, xo = ji, yo = (hn = Ht(), na = nn(1, 0, 0), ra = nn(0, 1, 0), function(p, S, B) {
        var re = Lr(S, B);
        return re < -0.999999 ? (lr(hn, na, S), Mi(hn) < 1e-6 && lr(hn, ra, S), Ri(hn, hn), $i(p, hn, Math.PI), p) : re > 0.999999 ? (p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 1, p) : (lr(hn, S, B), p[0] = hn[0], p[1] = hn[1], p[2] = hn[2], p[3] = 1 + re, Hr(p, p));
      }), bo = (Nr = ur(), kr = ur(), function(p, S, B, re, le, me) {
        return dr(Nr, S, le, me), dr(kr, B, re, me), dr(p, Nr, kr, 2 * me * (1 - me)), p;
      }), Eo = (pn = Rt(), function(p, S, B, re) {
        return pn[0] = B[0], pn[3] = B[1], pn[6] = B[2], pn[1] = re[0], pn[4] = re[1], pn[7] = re[2], pn[2] = -S[0], pn[5] = -S[1], pn[8] = -S[2], Hr(p, ta(p, pn));
      });
      function Ao() {
        var p = new b(8);
        return b != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0, p[4] = 0, p[5] = 0, p[6] = 0, p[7] = 0), p[3] = 1, p;
      }
      function To(p) {
        var S = new b(8);
        return S[0] = p[0], S[1] = p[1], S[2] = p[2], S[3] = p[3], S[4] = p[4], S[5] = p[5], S[6] = p[6], S[7] = p[7], S;
      }
      function So(p, S, B, re, le, me, xe, Te) {
        var Re = new b(8);
        return Re[0] = p, Re[1] = S, Re[2] = B, Re[3] = re, Re[4] = le, Re[5] = me, Re[6] = xe, Re[7] = Te, Re;
      }
      function Co(p, S, B, re, le, me, xe) {
        var Te = new b(8);
        Te[0] = p, Te[1] = S, Te[2] = B, Te[3] = re;
        var Re = 0.5 * le, Pe = 0.5 * me, Xe = 0.5 * xe;
        return Te[4] = Re * re + Pe * B - Xe * S, Te[5] = Pe * re + Xe * p - Re * B, Te[6] = Xe * re + Re * S - Pe * p, Te[7] = -Re * p - Pe * S - Xe * B, Te;
      }
      function aa(p, S, B) {
        var re = 0.5 * B[0], le = 0.5 * B[1], me = 0.5 * B[2], xe = S[0], Te = S[1], Re = S[2], Pe = S[3];
        return p[0] = xe, p[1] = Te, p[2] = Re, p[3] = Pe, p[4] = re * Pe + le * Re - me * Te, p[5] = le * Pe + me * xe - re * Re, p[6] = me * Pe + re * Te - le * xe, p[7] = -re * xe - le * Te - me * Re, p;
      }
      function wo(p, S) {
        return p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 1, p[4] = 0.5 * S[0], p[5] = 0.5 * S[1], p[6] = 0.5 * S[2], p[7] = 0, p;
      }
      function Do(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[4] = 0, p[5] = 0, p[6] = 0, p[7] = 0, p;
      }
      function Ro(p, S) {
        var B = ur();
        er(B, S);
        var re = new b(3);
        return Wn(re, S), aa(p, B, re), p;
      }
      function sa(p, S) {
        return p[0] = S[0], p[1] = S[1], p[2] = S[2], p[3] = S[3], p[4] = S[4], p[5] = S[5], p[6] = S[6], p[7] = S[7], p;
      }
      function Mo(p) {
        return p[0] = 0, p[1] = 0, p[2] = 0, p[3] = 1, p[4] = 0, p[5] = 0, p[6] = 0, p[7] = 0, p;
      }
      function Fo(p, S, B, re, le, me, xe, Te, Re) {
        return p[0] = S, p[1] = B, p[2] = re, p[3] = le, p[4] = me, p[5] = xe, p[6] = Te, p[7] = Re, p;
      }
      var Io = Br;
      function Po(p, S) {
        return p[0] = S[4], p[1] = S[5], p[2] = S[6], p[3] = S[7], p;
      }
      var Lo = Br;
      function Uo(p, S) {
        return p[4] = S[0], p[5] = S[1], p[6] = S[2], p[7] = S[3], p;
      }
      function Oo(p, S) {
        var B = S[4], re = S[5], le = S[6], me = S[7], xe = -S[0], Te = -S[1], Re = -S[2], Pe = S[3];
        return p[0] = 2 * (B * Pe + me * xe + re * Re - le * Te), p[1] = 2 * (re * Pe + me * Te + le * xe - B * Re), p[2] = 2 * (le * Pe + me * Re + B * Te - re * xe), p;
      }
      function No(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = 0.5 * B[0], Re = 0.5 * B[1], Pe = 0.5 * B[2], Xe = S[4], st = S[5], ot = S[6], lt = S[7];
        return p[0] = re, p[1] = le, p[2] = me, p[3] = xe, p[4] = xe * Te + le * Pe - me * Re + Xe, p[5] = xe * Re + me * Te - re * Pe + st, p[6] = xe * Pe + re * Re - le * Te + ot, p[7] = -re * Te - le * Re - me * Pe + lt, p;
      }
      function ko(p, S, B) {
        var re = -S[0], le = -S[1], me = -S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = Te * xe + Xe * re + Re * me - Pe * le, ot = Re * xe + Xe * le + Pe * re - Te * me, lt = Pe * xe + Xe * me + Te * le - Re * re, vt = Xe * xe - Te * re - Re * le - Pe * me;
        return Ki(p, S, B), re = p[0], le = p[1], me = p[2], xe = p[3], p[4] = st * xe + vt * re + ot * me - lt * le, p[5] = ot * xe + vt * le + lt * re - st * me, p[6] = lt * xe + vt * me + st * le - ot * re, p[7] = vt * xe - st * re - ot * le - lt * me, p;
      }
      function Bo(p, S, B) {
        var re = -S[0], le = -S[1], me = -S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = Te * xe + Xe * re + Re * me - Pe * le, ot = Re * xe + Xe * le + Pe * re - Te * me, lt = Pe * xe + Xe * me + Te * le - Re * re, vt = Xe * xe - Te * re - Re * le - Pe * me;
        return Zi(p, S, B), re = p[0], le = p[1], me = p[2], xe = p[3], p[4] = st * xe + vt * re + ot * me - lt * le, p[5] = ot * xe + vt * le + lt * re - st * me, p[6] = lt * xe + vt * me + st * le - ot * re, p[7] = vt * xe - st * re - ot * le - lt * me, p;
      }
      function Wo(p, S, B) {
        var re = -S[0], le = -S[1], me = -S[2], xe = S[3], Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = Te * xe + Xe * re + Re * me - Pe * le, ot = Re * xe + Xe * le + Pe * re - Te * me, lt = Pe * xe + Xe * me + Te * le - Re * re, vt = Xe * xe - Te * re - Re * le - Pe * me;
        return Qi(p, S, B), re = p[0], le = p[1], me = p[2], xe = p[3], p[4] = st * xe + vt * re + ot * me - lt * le, p[5] = ot * xe + vt * le + lt * re - st * me, p[6] = lt * xe + vt * me + st * le - ot * re, p[7] = vt * xe - st * re - ot * le - lt * me, p;
      }
      function Vo(p, S, B) {
        var re = B[0], le = B[1], me = B[2], xe = B[3], Te = S[0], Re = S[1], Pe = S[2], Xe = S[3];
        return p[0] = Te * xe + Xe * re + Re * me - Pe * le, p[1] = Re * xe + Xe * le + Pe * re - Te * me, p[2] = Pe * xe + Xe * me + Te * le - Re * re, p[3] = Xe * xe - Te * re - Re * le - Pe * me, Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], p[4] = Te * xe + Xe * re + Re * me - Pe * le, p[5] = Re * xe + Xe * le + Pe * re - Te * me, p[6] = Pe * xe + Xe * me + Te * le - Re * re, p[7] = Xe * xe - Te * re - Re * le - Pe * me, p;
      }
      function Go(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = B[0], Re = B[1], Pe = B[2], Xe = B[3];
        return p[0] = re * Xe + xe * Te + le * Pe - me * Re, p[1] = le * Xe + xe * Re + me * Te - re * Pe, p[2] = me * Xe + xe * Pe + re * Re - le * Te, p[3] = xe * Xe - re * Te - le * Re - me * Pe, Te = B[4], Re = B[5], Pe = B[6], Xe = B[7], p[4] = re * Xe + xe * Te + le * Pe - me * Re, p[5] = le * Xe + xe * Re + me * Te - re * Pe, p[6] = me * Xe + xe * Pe + re * Re - le * Te, p[7] = xe * Xe - re * Te - le * Re - me * Pe, p;
      }
      function Ho(p, S, B, re) {
        if (Math.abs(re) < A)
          return sa(p, S);
        var le = Math.hypot(B[0], B[1], B[2]);
        re *= 0.5;
        var me = Math.sin(re), xe = me * B[0] / le, Te = me * B[1] / le, Re = me * B[2] / le, Pe = Math.cos(re), Xe = S[0], st = S[1], ot = S[2], lt = S[3];
        p[0] = Xe * Pe + lt * xe + st * Re - ot * Te, p[1] = st * Pe + lt * Te + ot * xe - Xe * Re, p[2] = ot * Pe + lt * Re + Xe * Te - st * xe, p[3] = lt * Pe - Xe * xe - st * Te - ot * Re;
        var vt = S[4], yt = S[5], ht = S[6], Tt = S[7];
        return p[4] = vt * Pe + Tt * xe + yt * Re - ht * Te, p[5] = yt * Pe + Tt * Te + ht * xe - vt * Re, p[6] = ht * Pe + Tt * Re + vt * Te - yt * xe, p[7] = Tt * Pe - vt * xe - yt * Te - ht * Re, p;
      }
      function zo(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p[2] = S[2] + B[2], p[3] = S[3] + B[3], p[4] = S[4] + B[4], p[5] = S[5] + B[5], p[6] = S[6] + B[6], p[7] = S[7] + B[7], p;
      }
      function oa(p, S, B) {
        var re = S[0], le = S[1], me = S[2], xe = S[3], Te = B[4], Re = B[5], Pe = B[6], Xe = B[7], st = S[4], ot = S[5], lt = S[6], vt = S[7], yt = B[0], ht = B[1], Tt = B[2], Ot = B[3];
        return p[0] = re * Ot + xe * yt + le * Tt - me * ht, p[1] = le * Ot + xe * ht + me * yt - re * Tt, p[2] = me * Ot + xe * Tt + re * ht - le * yt, p[3] = xe * Ot - re * yt - le * ht - me * Tt, p[4] = re * Xe + xe * Te + le * Pe - me * Re + st * Ot + vt * yt + ot * Tt - lt * ht, p[5] = le * Xe + xe * Re + me * Te - re * Pe + ot * Ot + vt * ht + lt * yt - st * Tt, p[6] = me * Xe + xe * Pe + re * Re - le * Te + lt * Ot + vt * Tt + st * ht - ot * yt, p[7] = xe * Xe - re * Te - le * Re - me * Pe + vt * Ot - st * yt - ot * ht - lt * Tt, p;
      }
      var Xo = oa;
      function qo(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p[2] = S[2] * B, p[3] = S[3] * B, p[4] = S[4] * B, p[5] = S[5] * B, p[6] = S[6] * B, p[7] = S[7] * B, p;
      }
      var ca = Wr;
      function jo(p, S, B, re) {
        var le = 1 - re;
        return ca(S, B) < 0 && (re = -re), p[0] = S[0] * le + B[0] * re, p[1] = S[1] * le + B[1] * re, p[2] = S[2] * le + B[2] * re, p[3] = S[3] * le + B[3] * re, p[4] = S[4] * le + B[4] * re, p[5] = S[5] * le + B[5] * re, p[6] = S[6] * le + B[6] * re, p[7] = S[7] * le + B[7] * re, p;
      }
      function $o(p, S) {
        var B = fr(S);
        return p[0] = -S[0] / B, p[1] = -S[1] / B, p[2] = -S[2] / B, p[3] = S[3] / B, p[4] = -S[4] / B, p[5] = -S[5] / B, p[6] = -S[6] / B, p[7] = S[7] / B, p;
      }
      function Yo(p, S) {
        return p[0] = -S[0], p[1] = -S[1], p[2] = -S[2], p[3] = S[3], p[4] = -S[4], p[5] = -S[5], p[6] = -S[6], p[7] = S[7], p;
      }
      var la = Vr, Ko = la, fr = Gr, Zo = fr;
      function Qo(p, S) {
        var B = fr(S);
        if (B > 0) {
          B = Math.sqrt(B);
          var re = S[0] / B, le = S[1] / B, me = S[2] / B, xe = S[3] / B, Te = S[4], Re = S[5], Pe = S[6], Xe = S[7], st = re * Te + le * Re + me * Pe + xe * Xe;
          p[0] = re, p[1] = le, p[2] = me, p[3] = xe, p[4] = (Te - re * st) / B, p[5] = (Re - le * st) / B, p[6] = (Pe - me * st) / B, p[7] = (Xe - xe * st) / B;
        }
        return p;
      }
      function Jo(p) {
        return "quat2(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + p[3] + ", " + p[4] + ", " + p[5] + ", " + p[6] + ", " + p[7] + ")";
      }
      function ec(p, S) {
        return p[0] === S[0] && p[1] === S[1] && p[2] === S[2] && p[3] === S[3] && p[4] === S[4] && p[5] === S[5] && p[6] === S[6] && p[7] === S[7];
      }
      function tc(p, S) {
        var B = p[0], re = p[1], le = p[2], me = p[3], xe = p[4], Te = p[5], Re = p[6], Pe = p[7], Xe = S[0], st = S[1], ot = S[2], lt = S[3], vt = S[4], yt = S[5], ht = S[6], Tt = S[7];
        return Math.abs(B - Xe) <= A * Math.max(1, Math.abs(B), Math.abs(Xe)) && Math.abs(re - st) <= A * Math.max(1, Math.abs(re), Math.abs(st)) && Math.abs(le - ot) <= A * Math.max(1, Math.abs(le), Math.abs(ot)) && Math.abs(me - lt) <= A * Math.max(1, Math.abs(me), Math.abs(lt)) && Math.abs(xe - vt) <= A * Math.max(1, Math.abs(xe), Math.abs(vt)) && Math.abs(Te - yt) <= A * Math.max(1, Math.abs(Te), Math.abs(yt)) && Math.abs(Re - ht) <= A * Math.max(1, Math.abs(Re), Math.abs(ht)) && Math.abs(Pe - Tt) <= A * Math.max(1, Math.abs(Pe), Math.abs(Tt));
      }
      function ua() {
        var p = new b(2);
        return b != Float32Array && (p[0] = 0, p[1] = 0), p;
      }
      function nc(p) {
        var S = new b(2);
        return S[0] = p[0], S[1] = p[1], S;
      }
      function rc(p, S) {
        var B = new b(2);
        return B[0] = p, B[1] = S, B;
      }
      function ic(p, S) {
        return p[0] = S[0], p[1] = S[1], p;
      }
      function ac(p, S, B) {
        return p[0] = S, p[1] = B, p;
      }
      function sc(p, S, B) {
        return p[0] = S[0] + B[0], p[1] = S[1] + B[1], p;
      }
      function da(p, S, B) {
        return p[0] = S[0] - B[0], p[1] = S[1] - B[1], p;
      }
      function fa(p, S, B) {
        return p[0] = S[0] * B[0], p[1] = S[1] * B[1], p;
      }
      function ha(p, S, B) {
        return p[0] = S[0] / B[0], p[1] = S[1] / B[1], p;
      }
      function oc(p, S) {
        return p[0] = Math.ceil(S[0]), p[1] = Math.ceil(S[1]), p;
      }
      function cc(p, S) {
        return p[0] = Math.floor(S[0]), p[1] = Math.floor(S[1]), p;
      }
      function lc(p, S, B) {
        return p[0] = Math.min(S[0], B[0]), p[1] = Math.min(S[1], B[1]), p;
      }
      function uc(p, S, B) {
        return p[0] = Math.max(S[0], B[0]), p[1] = Math.max(S[1], B[1]), p;
      }
      function dc(p, S) {
        return p[0] = Math.round(S[0]), p[1] = Math.round(S[1]), p;
      }
      function fc(p, S, B) {
        return p[0] = S[0] * B, p[1] = S[1] * B, p;
      }
      function hc(p, S, B, re) {
        return p[0] = S[0] + B[0] * re, p[1] = S[1] + B[1] * re, p;
      }
      function pa(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1];
        return Math.hypot(B, re);
      }
      function ga(p, S) {
        var B = S[0] - p[0], re = S[1] - p[1];
        return B * B + re * re;
      }
      function ma(p) {
        var S = p[0], B = p[1];
        return Math.hypot(S, B);
      }
      function _a(p) {
        var S = p[0], B = p[1];
        return S * S + B * B;
      }
      function pc(p, S) {
        return p[0] = -S[0], p[1] = -S[1], p;
      }
      function gc(p, S) {
        return p[0] = 1 / S[0], p[1] = 1 / S[1], p;
      }
      function mc(p, S) {
        var B = S[0], re = S[1], le = B * B + re * re;
        return le > 0 && (le = 1 / Math.sqrt(le)), p[0] = S[0] * le, p[1] = S[1] * le, p;
      }
      function _c(p, S) {
        return p[0] * S[0] + p[1] * S[1];
      }
      function vc(p, S, B) {
        var re = S[0] * B[1] - S[1] * B[0];
        return p[0] = p[1] = 0, p[2] = re, p;
      }
      function xc(p, S, B, re) {
        var le = S[0], me = S[1];
        return p[0] = le + re * (B[0] - le), p[1] = me + re * (B[1] - me), p;
      }
      function yc(p, S) {
        S = S || 1;
        var B = 2 * C() * Math.PI;
        return p[0] = Math.cos(B) * S, p[1] = Math.sin(B) * S, p;
      }
      function bc(p, S, B) {
        var re = S[0], le = S[1];
        return p[0] = B[0] * re + B[2] * le, p[1] = B[1] * re + B[3] * le, p;
      }
      function Ec(p, S, B) {
        var re = S[0], le = S[1];
        return p[0] = B[0] * re + B[2] * le + B[4], p[1] = B[1] * re + B[3] * le + B[5], p;
      }
      function Ac(p, S, B) {
        var re = S[0], le = S[1];
        return p[0] = B[0] * re + B[3] * le + B[6], p[1] = B[1] * re + B[4] * le + B[7], p;
      }
      function Tc(p, S, B) {
        var re = S[0], le = S[1];
        return p[0] = B[0] * re + B[4] * le + B[12], p[1] = B[1] * re + B[5] * le + B[13], p;
      }
      function Sc(p, S, B, re) {
        var le = S[0] - B[0], me = S[1] - B[1], xe = Math.sin(re), Te = Math.cos(re);
        return p[0] = le * Te - me * xe + B[0], p[1] = le * xe + me * Te + B[1], p;
      }
      function Cc(p, S) {
        var B = p[0], re = p[1], le = S[0], me = S[1], xe = Math.sqrt(B * B + re * re) * Math.sqrt(le * le + me * me), Te = xe && (B * le + re * me) / xe;
        return Math.acos(Math.min(Math.max(Te, -1), 1));
      }
      function wc(p) {
        return p[0] = 0, p[1] = 0, p;
      }
      function Dc(p) {
        return "vec2(" + p[0] + ", " + p[1] + ")";
      }
      function Rc(p, S) {
        return p[0] === S[0] && p[1] === S[1];
      }
      function Mc(p, S) {
        var B = p[0], re = p[1], le = S[0], me = S[1];
        return Math.abs(B - le) <= A * Math.max(1, Math.abs(B), Math.abs(le)) && Math.abs(re - me) <= A * Math.max(1, Math.abs(re), Math.abs(me));
      }
      var Fc = ma, Ic = da, Pc = fa, Lc = ha, Uc = pa, Oc = ga, Nc = _a, kc = function() {
        var p = ua();
        return function(S, B, re, le, me, xe) {
          var Te, Re;
          for (B || (B = 2), re || (re = 0), Re = le ? Math.min(le * B + re, S.length) : S.length, Te = re; Te < Re; Te += B)
            p[0] = S[Te], p[1] = S[Te + 1], me(p, p, xe), S[Te] = p[0], S[Te + 1] = p[1];
          return S;
        };
      }();
    }, 831: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(f, h, g, x) {
        x === void 0 && (x = g);
        var E = Object.getOwnPropertyDescriptor(h, g);
        E && !("get" in E ? !h.__esModule : E.writable || E.configurable) || (E = { enumerable: !0, get: function() {
          return h[g];
        } }), Object.defineProperty(f, x, E);
      } : function(f, h, g, x) {
        x === void 0 && (x = g), f[x] = h[g];
      }), d = this && this.__exportStar || function(f, h) {
        for (var g in f)
          g === "default" || Object.prototype.hasOwnProperty.call(h, g) || u(h, f, g);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), d(c(6086), l), d(c(1712), l), d(c(6952), l);
    }, 126: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Bitmap = void 0, l.Bitmap = function() {
      };
    }, 5056: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ClippingPlane = void 0, l.ClippingPlane = function() {
      };
    }, 1447: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Coloring = void 0, l.Coloring = function() {
      };
    }, 9368: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Component = void 0, l.Component = function(c) {
        this.ifc_guid = c, this.originating_system = "xBIM", this.authoring_tool_id = "WebUI";
      };
    }, 2680: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Components = void 0, l.Components = function() {
      };
    }, 7085: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Guid = void 0;
      var c = function() {
        function u() {
        }
        return u.new = function() {
          return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(d) {
            var f = parseInt(d, 10);
            return (f ^ 16 * Math.random() >> f / 4).toString(16);
          });
        }, u;
      }();
      l.Guid = c;
    }, 6952: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(f, h, g, x) {
        x === void 0 && (x = g);
        var E = Object.getOwnPropertyDescriptor(h, g);
        E && !("get" in E ? !h.__esModule : E.writable || E.configurable) || (E = { enumerable: !0, get: function() {
          return h[g];
        } }), Object.defineProperty(f, x, E);
      } : function(f, h, g, x) {
        x === void 0 && (x = g), f[x] = h[g];
      }), d = this && this.__exportStar || function(f, h) {
        for (var g in f)
          g === "default" || Object.prototype.hasOwnProperty.call(h, g) || u(h, f, g);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), d(c(126), l), d(c(5056), l), d(c(1447), l), d(c(9368), l), d(c(2680), l), d(c(1970), l), d(c(9891), l), d(c(1963), l), d(c(1304), l), d(c(7745), l), d(c(779), l), d(c(4134), l);
    }, 1970: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Line = void 0, l.Line = function() {
      };
    }, 9891: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.OrthogonalCamera = void 0, l.OrthogonalCamera = function() {
      };
    }, 1963: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PerspectiveCamera = void 0, l.PerspectiveCamera = function() {
      };
    }, 1304: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Snapshot = void 0, l.Snapshot = function() {
      };
    }, 7745: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ViewSetupHints = void 0, l.ViewSetupHints = function() {
      };
    }, 779: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Viewpoint = void 0;
      var u = c(7085), d = c(5056), f = c(2680), h = c(8378), g = c(887), x = c(6413), E = c(8194), m = c(4134), v = c(9368), y = function() {
        function A() {
          this.index = ++A._currentIndex, this.guid = u.Guid.new();
        }
        return A.GetViewpoint = function(b, C, T) {
          T === void 0 && (T = b.width / 2);
          var w = new A(), R = b.width / b.height, O = T / R, D = function(Y) {
            return Array.prototype.slice.call(Y);
          };
          if (b.camera === x.CameraType.PERSPECTIVE)
            w.perspective_camera = { camera_direction: D(b.getCameraDirection()), camera_up_vector: D(b.getCameraHeading()), camera_view_point: D(b.getCameraPositionWcs()), field_of_view: b.cameraProperties.fov, height: b.cameraProperties.height, width: b.cameraProperties.height * R };
          else {
            var k = b.cameraProperties.height / b.unitsInMeter, W = b.height / A.resolution;
            w.orthogonal_camera = { camera_direction: D(b.getCameraDirection()), camera_up_vector: D(b.getCameraHeading()), camera_view_point: D(b.getCameraPositionWcs()), view_to_world_scale: W / k, height: b.cameraProperties.height, width: b.cameraProperties.height * R };
          }
          var L = b.getCurrentImageDataUrl(T, O, "png").substring(22);
          w.snapshot = { snapshot_type: "png", snapshot_data: L };
          var z = b.getClip();
          z != null && (A.AddClippingPlane(w, z.PlaneA), A.AddClippingPlane(w, z.PlaneB));
          var P = b.getProductsWithState(E.State.HIGHLIGHTED);
          if (P != null && P.length > 0) {
            C == null && (console.warn("ID mapping function should be used to persist global identity of selected elements"), C = function(Y, ie) {
              return "".concat(ie, "_").concat(Y);
            }), w.components == null && (w.components = new f.Components(), w.components.coloring = [], w.components.selection = [], w.components.visibility = new m.Visibility());
            var Q = w.components.selection;
            P.forEach(function(Y) {
              var ie = C(Y.id, Y.model);
              Q.push(new v.Component(ie));
            });
          }
          return w;
        }, A.AddClippingPlane = function(b, C) {
          if (C != null && C.length === 4) {
            b.clipping_planes == null && (b.clipping_planes = []);
            var T = new d.ClippingPlane();
            T.direction = C.slice(0, 3);
            var w = C, R = -w[0] * w[3] / (w[0] * w[0] + w[1] * w[1] + w[2] * w[2]), O = -w[1] * w[3] / (w[0] * w[0] + w[1] * w[1] + w[2] * w[2]), D = -w[2] * w[3] / (w[0] * w[0] + w[1] * w[1] + w[2] * w[2]);
            T.location = [R, O, D], b.clipping_planes.push(T);
          }
        }, A.SetViewpoint = function(b, C, T, w) {
          w === void 0 && (w = 0);
          var R = function(ye) {
            return ye == null || ye.length < 3 ? null : g.vec3.fromValues(ye[0], ye[1], ye[2]);
          }, O = b.getCurrentWcs(), D = b.width / b.height;
          A.SetClipping(b, C);
          var k = C.perspective_camera || C.orthogonal_camera;
          if (k != null) {
            var W = k.camera_view_point, L = k.camera_direction, z = k.camera_up_vector, P = R(W), Q = g.vec3.subtract(g.vec3.create(), P, O), Y = g.vec3.normalize(g.vec3.create(), R(L)), ie = g.vec3.normalize(g.vec3.create(), R(z) || g.vec3.fromValues(0, 0, 1)), te = g.vec3.angle(Y, ie);
            (Math.abs(te) < 1e-6 || Math.abs(te - Math.PI) < 1e-6) && (console.warn("Collinear target and heading vectors for the view. Singularity will be fixed by guess."), te = g.vec3.angle(Y, g.vec3.fromValues(0, 0, 1)), (Math.abs(te) < 1e-6 || Math.abs(te - Math.PI) < 1e-6) && (ie = g.vec3.fromValues(0, 1, 0)));
            var Z = function(ye) {
              return ye != null && typeof ye == "number" && ye > 0;
            }, ae = b.cameraProperties.height || 100, G = b.getMergedRegion(), U = G && G.bbox && G.population > 0 ? b.getDistanceAndHeight(G.bbox, Y, ie) : null;
            if (U != null && g.vec3.dist(R(G.centre), Q) > 4 * U.distance) {
              var F = g.vec3.negate(g.vec3.create(), Y), M = g.vec3.scale(g.vec3.create(), F, U.distance);
              Q = g.vec3.add(g.vec3.create(), R(G.centre), M), ae = U.height;
            }
            if (C.perspective_camera) {
              b.camera = x.CameraType.PERSPECTIVE;
              var I = 60;
              if (Z(C.perspective_camera.field_of_view) && (I = C.perspective_camera.field_of_view), Z(k.width) && Z(k.height) && (q = k.width / k.height) > D) {
                var N = I * Math.PI / 180;
                I = 2 * Math.atan(Math.tan(N / 2) * q / D) * 180 / Math.PI;
              }
              b.cameraProperties.fov = I;
            } else if (C.orthogonal_camera) {
              if (b.camera = x.CameraType.ORTHOGONAL, b.cameraProperties.fov = 60, Z(C.orthogonal_camera.view_to_world_scale)) {
                var V = C.orthogonal_camera.view_to_world_scale;
                ae = b.height / A.resolution / V * b.unitsInMeter;
              }
              if (Z(k.width) && Z(k.height)) {
                var q, H = k.height;
                (q = k.width / H) > D && (H = H * q / D), U != null && H > 4 * U.height && (H = U.height), ae = H;
              }
            }
            var ne = g.vec3.add(g.vec3.create(), Q, Y), he = g.mat4.lookAt(g.mat4.create(), Q, ne, ie);
            b.animations.viewTo({ mv: he, height: ae }, w).then(function() {
              if (C.orthogonal_camera) {
                if (g.vec3.angle(R(k.camera_direction), g.vec3.fromValues(0, 0, -1)) > Math.PI / 180)
                  return;
                b.adjustments.adjust(10);
              }
            });
          }
          if (b.clearHighlighting(), C.components != null && C.components.selection != null && C.components.selection.length > 0) {
            var j = C.components.selection;
            T == null && (console.warn("No function defined to map between global IDs and local product and model IDs"), T = function(ye) {
              var Ae = ye.split("_"), fe = parseInt(Ae[0], 10);
              return { productId: parseInt(Ae[1], 10), modelId: fe };
            });
            var Fe = {}, X = [];
            j.map(function(ye) {
              return T(ye.ifc_guid);
            }).forEach(function(ye) {
              (Fe[ye.modelId] || (Fe[ye.modelId] = [])).push(ye.productId), X.push({ id: ye.productId, model: ye.modelId });
            }), Object.getOwnPropertyNames(Fe).forEach(function(ye) {
              b.addState(E.State.HIGHLIGHTED, Fe[ye], parseInt(ye, 10));
            }), k == null && (b.renderingMode = h.RenderingMode.XRAY_ULTRA, b.show(h.ViewType.DEFAULT, void 0, void 0, w > 0).then(function() {
              b.zoomTo(X, void 0, w > 0, !1);
            }));
          }
        }, A.SetClipping = function(b, C) {
          if (b.unclip(), b.sectionBox.setToInfinity(), C.clipping_planes != null && C.clipping_planes.length !== 0)
            if (C.clipping_planes.length !== 6) {
              var T = A.getClippingEquation(C.clipping_planes[0]), w = A.getClippingEquation(C.clipping_planes[1]);
              T != null && b.setClippingPlaneA(T), w != null && b.setClippingPlaneB(w);
            } else
              b.sectionBox.setToPlanes(C.clipping_planes);
        }, A.getClippingEquation = function(b) {
          if (b == null || b.direction == null || b.location == null)
            return null;
          var C = b.direction, T = b.location, w = 0 - C[0] * T[0] - C[1] * T[1] - C[2] * T[2];
          return [C[0], C[1], C[2], w];
        }, Object.defineProperty(A, "resolution", { get: function() {
          if (A._resolution != null)
            return A._resolution;
          var b = document.createElement("div");
          b.style.position = "absolute", b.style.width = "100mm", document.body.appendChild(b);
          var C = b.getBoundingClientRect();
          return document.body.removeChild(b), A._resolution = C.width / 0.1, A._resolution;
        }, enumerable: !1, configurable: !0 }), A._currentIndex = 0, A._resolution = null, A;
      }();
      l.Viewpoint = y;
    }, 4134: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Visibility = void 0, l.Visibility = function() {
        this.default_visibility = !1;
      };
    }, 6413: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CameraType = l.CameraProperties = void 0;
      var u, d = c(887), f = function() {
        function h(g) {
          this._fov = 45, this._type = u.PERSPECTIVE, this.onChange = function() {
          }, this.onChange = g || function() {
          };
        }
        return Object.defineProperty(h.prototype, "fov", { get: function() {
          return this._fov;
        }, set: function(g) {
          if (g == null || g <= 0 || g > 180)
            throw new Error("Perspective field of view has to be a positive number between 0 and 180 degrees");
          this._fov = g, this.onChange && this.type === u.PERSPECTIVE && this.onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "near", { get: function() {
          return this._near;
        }, set: function(g) {
          this._near = g, this.onChange && this.onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "far", { get: function() {
          return this._far;
        }, set: function(g) {
          this._far = g, this.onChange && this.onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "height", { get: function() {
          return this._height;
        }, set: function(g) {
          if (g == null || g <= 0)
            throw new Error("Orthographic view height has to be a positive number");
          this._height = g, this.onChange && this.type === u.ORTHOGONAL && this.onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "type", { get: function() {
          return this._type;
        }, set: function(g) {
          this._type = g, this.onChange && this.onChange();
        }, enumerable: !1, configurable: !0 }), h.prototype.getProjectionMatrix = function(g, x) {
          var E = g / x;
          switch (this.type) {
            case u.PERSPECTIVE:
              return d.mat4.perspective(d.mat4.create(), this.fov * Math.PI / 180, E, this.near, this.far);
            case u.ORTHOGONAL:
              var m = this.height, v = m * E;
              return d.mat4.ortho(d.mat4.create(), v / -2, v / 2, m / -2, m / 2, this.near, this.far);
            default:
              throw new Error("Undefined camera type");
          }
        }, h;
      }();
      l.CameraProperties = f, function(h) {
        h[h.PERSPECTIVE = 0] = "PERSPECTIVE", h[h.ORTHOGONAL = 1] = "ORTHOGONAL";
      }(u = l.CameraType || (l.CameraType = {}));
    }, 3810: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Abilities = void 0;
      var u = c(7997), d = c(1275), f = function() {
        function h() {
        }
        return h.check = function() {
          var g = new d.CheckResult(), x = document.createElement("canvas");
          if (x) {
            var E = null, m = 0;
            if (u.WebGLUtils.setupWebGL(x, function(y, A) {
              E = y, m = A;
            }, null, function(y) {
              g.errors.push(y);
            }), E == null)
              g.errors.push("Browser doesn't support WebGL. This is critical.");
            else {
              !(m < 2) || E.getExtension("OES_texture_float") || E.getExtension("MOZ_OES_texture_float") || E.getExtension("WEBKIT_OES_texture_float") || g.errors.push("Floating point texture extension is not supported."), !(m < 2) || E.getExtension("WEBGL_depth_texture") || E.getExtension("WEBKIT_WEBGL_depth_texture") || E.getExtension("MOZ_WEBGL_depth_texture") || g.warnings.push("Depth texture extension is not available. It will not be possible to get 3D coordinates of user interactions.");
              var v = E.getParameter(E.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
              v < 4 && g.errors.push("Browser supports only " + v + " vertex texture image units but minimal requirement for the viewer is 4.");
            }
          } else
            g.errors.push("Browser doesn't have support for HTMLCanvasElement. This is critical.");
          return window.File && window.FileReader && window.Blob || g.errors.push("Browser doesn't support 'File', 'FileReader' or 'Blob' objects."), window.Int32Array && window.Float32Array || g.errors.push("Browser doesn't support TypedArrays. These are crucial for binary parsing and for comunication with GPU."), g.errors.length == 0 && (g.noErrors = !0), g.warnings.length == 0 && (g.noWarnings = !0), g;
        }, h;
      }();
      l.Abilities = f;
    }, 5460: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.BBox = void 0;
      var u = c(887), d = function() {
        function f() {
        }
        return f.centre = function(h) {
          return [h[0] + h[3] / 2, h[1] + h[4] / 2, h[2] + h[5] / 2];
        }, f.union = function(h, g) {
          if (g == null && h == null)
            return null;
          if (g == null && h != null)
            return h;
          if (g != null && h == null)
            return g;
          var x = [h[0], h[1], h[2]], E = [g[0], g[1], g[2]], m = [h[0] + h[3], h[1] + h[4], h[2] + h[5]], v = [g[0] + g[3], g[1] + g[4], g[2] + g[5]], y = [Math.min(x[0], E[0]), Math.min(x[1], E[1]), Math.min(x[2], E[2])], A = [Math.max(m[0], v[0]), Math.max(m[1], v[1]), Math.max(m[2], v[2])];
          return [y[0], y[1], y[2], A[0] - y[0], A[1] - y[1], A[2] - y[2]];
        }, f.intersection = function(h, g) {
          if (h == null || g == null || f.areDisjoint(h, g))
            return null;
          var x = [h[0], h[1], h[2]], E = [g[0], g[1], g[2]], m = [h[0] + h[3], h[1] + h[4], h[2] + h[5]], v = [g[0] + g[3], g[1] + g[4], g[2] + g[5]], y = [Math.max(x[0], E[0]), Math.max(x[1], E[1]), Math.max(x[2], E[2])], A = [Math.min(m[0], v[0]), Math.min(m[1], v[1]), Math.min(m[2], v[2])];
          return [y[0], y[1], y[2], A[0] - y[0], A[1] - y[1], A[2] - y[2]];
        }, f.areDisjoint = function(h, g) {
          if (h == null || g == null)
            throw new Error("Bounding box is not defined");
          var x = [h[0], h[1], h[2]], E = [g[0], g[1], g[2]], m = [h[0] + h[3], h[1] + h[4], h[2] + h[5]], v = [g[0] + g[3], g[1] + g[4], g[2] + g[5]];
          return x[0] > v[0] || x[1] > v[1] || x[2] > v[2] || E[0] > m[0] || E[1] > m[1] || E[2] > m[2];
        }, f.getDiagonalSize = function(h) {
          return Math.sqrt(h[3] * h[3] + h[4] * h[4] + h[5] * h[5]);
        }, f.getSizeInView = function(h, g, x) {
          g = u.vec3.normalize(u.vec3.create(), g), x = u.vec3.normalize(u.vec3.create(), x);
          var E = u.vec3.negate(u.vec3.create(), g), m = Math.max(h[3], h[4], h[5]), v = u.vec3.fromValues(h[0] + h[3] / 2, h[1] + h[4] / 2, h[2] + h[5] / 2), y = u.vec3.scale(u.vec3.create(), E, m), A = u.vec3.add(u.vec3.create(), v, y), b = u.mat4.lookAt(u.mat4.create(), A, v, x), C = Array.prototype.slice.call(b.slice(0, 3)), T = Array.prototype.slice.call(b.slice(4, 7)), w = Array.prototype.slice.call(b.slice(8, 11)), R = u.vec3.scale(u.vec3.create(), C, h[0]), O = u.vec3.scale(u.vec3.create(), C, h[0] + h[3]), D = u.vec3.scale(u.vec3.create(), T, h[1]), k = u.vec3.scale(u.vec3.create(), T, h[1] + h[4]), W = u.vec3.scale(u.vec3.create(), w, h[2]), L = u.vec3.scale(u.vec3.create(), w, h[2] + h[5]), z = u.vec3.min(u.vec3.create(), R, O), P = u.vec3.min(u.vec3.create(), D, k), Q = u.vec3.min(u.vec3.create(), W, L), Y = u.vec3.max(u.vec3.create(), R, O), ie = u.vec3.max(u.vec3.create(), D, k), te = u.vec3.max(u.vec3.create(), W, L), Z = u.vec3.fromValues(z[0] + P[0] + Q[0], z[1] + P[1] + Q[1], z[2] + P[2] + Q[2]), ae = u.vec3.fromValues(Y[0] + ie[0] + te[0], Y[1] + ie[1] + te[1], Y[2] + ie[2] + te[2]), G = u.vec3.sub(u.vec3.create(), ae, Z);
          return { width: 1 * G[0], height: 1 * G[1], depth: G[2] };
        }, f;
      }();
      l.BBox = d;
    }, 1275: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CheckResult = void 0, l.CheckResult = function() {
        this.warnings = [], this.errors = [], this.noErrors = !1, this.noWarnings = !1;
      };
    }, 269: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.FpsWatch = void 0;
      var c = function() {
        function d(f) {
          var h = this;
          this.buffer = new u(20);
          var g = function(x) {
            h.buffer.next(x), f(g);
          };
          f(g);
        }
        return Object.defineProperty(d.prototype, "fps", { get: function() {
          var f = this.buffer.first, h = this.buffer.last;
          return f == null || h == null ? 60 : this.buffer.size / (h - f) * 1e3;
        }, enumerable: !1, configurable: !0 }), d;
      }();
      l.FpsWatch = c;
      var u = function() {
        function d(f) {
          this.size = f, this.inner = [], this.idx = 0;
        }
        return d.prototype.next = function(f) {
          this.inner[this.idx] = f, this.idx = (this.idx + 1) % this.size;
        }, Object.defineProperty(d.prototype, "first", { get: function() {
          return this.inner[this.idx];
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(d.prototype, "last", { get: function() {
          var f = (this.idx + this.size - 1) % this.size;
          return this.inner[f];
        }, enumerable: !1, configurable: !0 }), d;
      }();
    }, 7300: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(f, h, g, x) {
        x === void 0 && (x = g);
        var E = Object.getOwnPropertyDescriptor(h, g);
        E && !("get" in E ? !h.__esModule : E.writable || E.configurable) || (E = { enumerable: !0, get: function() {
          return h[g];
        } }), Object.defineProperty(f, x, E);
      } : function(f, h, g, x) {
        x === void 0 && (x = g), f[x] = h[g];
      }), d = this && this.__exportStar || function(f, h) {
        for (var g in f)
          g === "default" || Object.prototype.hasOwnProperty.call(h, g) || u(h, f, g);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), d(c(8194), l), d(c(6920), l), d(c(3753), l), d(c(1850), l), d(c(1275), l), d(c(4469), l), d(c(3157), l);
    }, 6920: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.LoadingPhase = l.MessageType = l.MessageProgress = l.Message = void 0;
      var c, u;
      l.Message = function() {
      }, l.MessageProgress = function(d) {
        var f = 33.333333333333336;
        return f * d.phase + f * d.percent / 100;
      }, (u = l.MessageType || (l.MessageType = {}))[u.PROGRESS = 0] = "PROGRESS", u[u.COMPLETED = 1] = "COMPLETED", u[u.FAILED = 2] = "FAILED", (c = l.LoadingPhase || (l.LoadingPhase = {}))[c.DOWNLOADING = 0] = "DOWNLOADING", c[c.READING = 1] = "READING", c[c.LOADING = 2] = "LOADING";
    }, 3157: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ProductAnalyticalResult = void 0, l.ProductAnalyticalResult = function() {
      };
    }, 1850: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ProductIdentity = void 0, l.ProductIdentity = function() {
      };
    }, 3753: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ProductMap = void 0;
      var u = c(8194), d = function() {
        function f() {
          this.states = [];
        }
        return f.clone = function(h) {
          var g = new f();
          return g.productID = h.productID, g.renderId = h.renderId, g.type = h.type, g.bBox = new Float32Array(h.bBox), g.spans = h.spans, g.states = h.states.slice(0), g;
        }, f.addState = function(h, g) {
          h.states.find(function(x) {
            return x === g;
          }) == null && h.states.push(g);
        }, f.removeState = function(h, g) {
          var x = h.states.indexOf(g);
          x < 0 || h.states.splice(x, 1);
        }, f.getState = function(h) {
          return h.states == null || h.states.length === 0 ? u.State.UNDEFINED : u.StatePriorities.getHighestPriority(h.states);
        }, f;
      }();
      l.ProductMap = d;
    }, 8194: (o, l) => {
      var c;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.StatePriorities = l.State = void 0, function(d) {
        d[d.UNDEFINED = 255] = "UNDEFINED", d[d.HIDDEN = 254] = "HIDDEN", d[d.HIGHLIGHTED = 253] = "HIGHLIGHTED", d[d.XRAYVISIBLE = 252] = "XRAYVISIBLE", d[d.PICKING_ONLY = 251] = "PICKING_ONLY", d[d.HOVEROVER = 250] = "HOVEROVER", d[d.UNSTYLED = 225] = "UNSTYLED";
      }(c = l.State || (l.State = {}));
      var u = function() {
        function d() {
        }
        return d.getPriority = function(f) {
          switch (f) {
            case c.HIGHLIGHTED:
              return 1;
            case c.PICKING_ONLY:
              return 2;
            case c.HIDDEN:
              return 3;
            case c.XRAYVISIBLE:
              return 4;
            default:
              return 100;
          }
        }, d.getHighestPriority = function(f) {
          var h = this;
          if (f == null || f.length === 0)
            return null;
          if (f.length === 1)
            return f[0];
          var g = f.map(function(E) {
            return { state: E, priority: h.getPriority(E) };
          });
          g.sort(function(E, m) {
            return E.priority - m.priority;
          });
          var x = g[0];
          return x.priority > 50 ? c.UNDEFINED : x.state;
        }, d;
      }();
      l.StatePriorities = u;
    }, 1150: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.VectorUtils = void 0;
      var u = c(887), d = function() {
        function f() {
        }
        return f.getVec3 = function(h) {
          if (h.length >= 3)
            return u.vec3.fromValues(h[0], h[1], h[2]);
        }, f;
      }();
      l.VectorUtils = d;
    }, 4469: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 });
    }, 7997: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.WebGLUtils = void 0;
      var c = function() {
        function u() {
        }
        return u.makeFailHTML = function(d) {
          return '<table style="background-color: #8CE; width: 100%; height: 100%;"><tr><td align="center"><div style="display: table-cell; vertical-align: middle;"><div style="">' + d + "</div></div></td></tr></table>";
        }, u.setupWebGL = function(d, f, h, g) {
          g = g || function(x) {
            var E = d.parentNode;
            if (E) {
              var m = typeof WebGLRenderingContext < "u" ? u.OTHER_PROBLEM : u.GET_A_WEBGL_BROWSER;
              x && (m += "<br/><br/>Status: " + x), E.innerHTML = u.makeFailHTML(m);
            }
          }, d.addEventListener && d.addEventListener("webglcontextcreationerror", function(x) {
            g(x.statusMessage);
          }, !1), u.create3DContext(d, f, h);
        }, u.create3DContext = function(d, f, h) {
          var g = null;
          try {
            if ((g = d.getContext("webgl2", h)) != null)
              return void f(g, 2);
          } catch {
          }
          ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"].forEach(function(x) {
            if (g == null)
              try {
                g = d.getContext(x, h);
              } catch {
              }
          }), f(g, 1);
        }, u.GET_A_WEBGL_BROWSER = 'This page requires a browser that supports WebGL.<br/><a href="http://get.webgl.org">Click here to upgrade your browser.</a>', u.OTHER_PROBLEM = `It doesn't appear your computer can support WebGL.<br/><a href="http://get.webgl.org/troubleshooting/">Click here for more information.</a>`, u;
      }();
      l.WebGLUtils = c;
    }, 9499: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Framebuffer = void 0;
      var u = c(1205), d = c(887), f = function() {
        function h(g, x, E, m, v) {
          if (this.gl = g, this.width = x, this.height = E, this.withDepth = m, this.glVersion = v, this.isReady = !0, this._disposed = !1, this._glVersion = 1, this.width = x = Math.floor(x), this.height = E = Math.floor(E), x !== 0 && E !== 0) {
            if (this._glVersion = v, this.framebuffer = g.createFramebuffer(), g.bindFramebuffer(g.FRAMEBUFFER, this.framebuffer), this.renderbuffer = g.createRenderbuffer(), g.bindRenderbuffer(g.RENDERBUFFER, this.renderbuffer), g.renderbufferStorage(g.RENDERBUFFER, g.DEPTH_COMPONENT16, x, E), this.texture = g.createTexture(), g.activeTexture(g.TEXTURE0), g.bindTexture(g.TEXTURE_2D, this.texture), g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, x, E, 0, g.RGBA, g.UNSIGNED_BYTE, null), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.NEAREST), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.NEAREST), g.pixelStorei(g.UNPACK_FLIP_Y_WEBGL, 1), m && (this.depthTexture = g.createTexture(), g.bindTexture(g.TEXTURE_2D, this.depthTexture), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.NEAREST), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.NEAREST), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE), g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE), this._glVersion === 1 ? g.texImage2D(g.TEXTURE_2D, 0, g.DEPTH_COMPONENT, x, E, 0, g.DEPTH_COMPONENT, g.UNSIGNED_SHORT, null) : g.texImage2D(g.TEXTURE_2D, 0, g.DEPTH_COMPONENT16, x, E, 0, g.DEPTH_COMPONENT, g.UNSIGNED_SHORT, null)), g.framebufferTexture2D(g.FRAMEBUFFER, g.COLOR_ATTACHMENT0, g.TEXTURE_2D, this.texture, 0), m ? g.framebufferTexture2D(g.FRAMEBUFFER, g.DEPTH_ATTACHMENT, g.TEXTURE_2D, this.depthTexture, 0) : g.framebufferRenderbuffer(g.FRAMEBUFFER, g.DEPTH_ATTACHMENT, g.RENDERBUFFER, this.renderbuffer), g.checkFramebufferStatus(g.FRAMEBUFFER) !== g.FRAMEBUFFER_COMPLETE)
              throw new Error("this combination of attachments does not work");
          } else
            this.isReady = !1;
        }
        return Object.defineProperty(h.prototype, "depthReader", { get: function() {
          return this._depthReader != null || (this._depthReader = new u.DepthReader(this.gl, this.glVersion)), this._depthReader;
        }, enumerable: !1, configurable: !0 }), h.prototype.bind = function() {
          if (this.isReady) {
            var g = this.gl;
            g.bindFramebuffer(g.FRAMEBUFFER, this.framebuffer), g.bindRenderbuffer(g.RENDERBUFFER, this.renderbuffer);
          }
        }, h.prototype.getPixel = function(g, x) {
          if (!this.isReady)
            return null;
          var E = new Uint8Array(4);
          return this.gl.readPixels(g, x, 1, 1, this.gl.RGBA, this.gl.UNSIGNED_BYTE, E), E;
        }, h.prototype.getDepth = function(g, x) {
          return this.isReady ? this.withDepth ? this.depthReader.getDepth(g, x, this.depthTexture, this.width, this.height) : -1 : null;
        }, h.prototype.getDepths = function(g) {
          return this.withDepth && this.isReady ? this.depthReader.getDepths(g, this.depthTexture, this.width, this.height) : null;
        }, h.prototype.getXYZArray = function(g) {
          var x = this;
          return this.withDepth && this.isReady ? this.getDepths(g).map(function(E, m) {
            if (E === 255)
              return null;
            var v = g[m], y = v.x / x.width * 2 - 1, A = v.y / x.height * 2 - 1, b = 2 * (E / 255 - 0.5);
            return d.vec3.fromValues(y, A, b);
          }) : null;
        }, h.prototype.getXYZ = function(g, x) {
          return this.withDepth && this.isReady ? this.getXYZArray([{ x: g, y: x }])[0] : null;
        }, h.prototype.getXYZRange = function(g, x) {
          if (!this.withDepth || !this.isReady)
            return null;
          var E = this.getDepth(g, x);
          if (E === 255)
            return null;
          var m = g / this.width * 2 - 1, v = x / this.height * 2 - 1, y = 2 * (E / 255 - 0.5), A = 2 * (Math.max(E - 1, 0) / 255 - 0.5), b = 2 * (Math.min(E + 1, 255) / 255 - 0.5);
          return { far: d.vec3.fromValues(m, v, b), near: d.vec3.fromValues(m, v, A), middle: d.vec3.fromValues(m, v, y) };
        }, h.prototype.getId = function(g, x) {
          if (!this.isReady)
            return null;
          var E = this.getPixel(g, x);
          return E[3] !== 0 ? E[0] + 256 * E[1] + 256 * E[2] * 256 : null;
        }, h.prototype.getIds = function(g) {
          var x = this;
          return this.isReady ? g.map(function(E) {
            var m = x.getPixel(E.x, E.y);
            return m[3] !== 0 ? m[0] + 256 * m[1] + 256 * m[2] * 256 : null;
          }) : null;
        }, h.prototype.getImageDataArray = function() {
          if (!this.isReady)
            return null;
          var g = this.gl;
          g.bindFramebuffer(g.FRAMEBUFFER, this.framebuffer), g.bindRenderbuffer(g.RENDERBUFFER, this.renderbuffer);
          var x = new Uint8Array(this.width * this.height * 4);
          g.readPixels(0, 0, this.width, this.height, g.RGBA, g.UNSIGNED_BYTE, x);
          for (var E = new Uint8ClampedArray(this.width * this.height * 4), m = 0; m < this.height; m++) {
            var v = x.subarray(m * this.width * 4, (m + 1) * this.width * 4), y = this.height - m - 1;
            E.set(new Uint8ClampedArray(v), y * this.width * 4);
          }
          return E;
        }, h.prototype.get2DCanvas = function() {
          if (!this.isReady)
            return document.createElement("canvas");
          var g = this.getImageDataArray(), x = document.createElement("canvas");
          x.width = this.width, x.height = this.height;
          var E = x.getContext("2d"), m = E.createImageData(this.width, this.height);
          return m.data.set(new Uint8ClampedArray(g)), E.putImageData(m, 0, 0), x;
        }, h.prototype.getImageDataUrl = function(g) {
          return g === void 0 && (g = "png"), this.isReady ? this.get2DCanvas().toDataURL("image/".concat(g)) : null;
        }, h.prototype.getImageDataBlob = function(g, x) {
          x === void 0 && (x = "png"), this.isReady && this.get2DCanvas().toBlob(g, "image/".concat(x));
        }, h.prototype.delete = function() {
          if (!this._disposed && this.isReady) {
            var g = this.gl;
            typeof WebGL2RenderingContext < "u" && g instanceof WebGL2RenderingContext && g.invalidateFramebuffer(g.FRAMEBUFFER, [g.COLOR_ATTACHMENT0, g.DEPTH_ATTACHMENT]), g.deleteFramebuffer(this.framebuffer), g.deleteRenderbuffer(this.renderbuffer), g.deleteTexture(this.texture), g.deleteTexture(this.depthTexture), this._depthReader != null && this._depthReader.delete(), this._disposed = !0;
          }
        }, h;
      }();
      l.Framebuffer = f;
    }, 6086: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(f, h, g, x) {
        x === void 0 && (x = g);
        var E = Object.getOwnPropertyDescriptor(h, g);
        E && !("get" in E ? !h.__esModule : E.writable || E.configurable) || (E = { enumerable: !0, get: function() {
          return h[g];
        } }), Object.defineProperty(f, x, E);
      } : function(f, h, g, x) {
        x === void 0 && (x = g), f[x] = h[g];
      }), d = this && this.__exportStar || function(f, h) {
        for (var g in f)
          g === "default" || Object.prototype.hasOwnProperty.call(h, g) || u(h, f, g);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), d(c(9438), l), d(c(3425), l), d(c(7300), l), d(c(8378), l), d(c(6413), l), d(c(2607), l), d(c(9499), l), d(c(4932), l), d(c(2067), l), d(c(1675), l), d(c(3948), l), d(c(1271), l);
    }, 4932: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DrawMode = l.ModelHandle = void 0;
      var u, d = c(3948), f = c(8194), h = c(9438), g = c(6920), x = c(887), E = c(3753), m = c(5460), v = c(1150), y = function() {
        function A(b, C, T) {
          if (this._gl = b, this._model = C, this.tag = null, this.wcs = x.vec3.create(), this._stopped = !1, this.pickable = !0, this.clippable = !0, this.pinned = !1, this._changed = !1, this._empty = !1, this._drawProductIds = null, this._clippingPlaneA = null, this._clippingPlaneB = null, this._clippingA = !1, this._clippingB = !1, this._glVersion = 1, b === void 0 || C === void 0)
            throw new Error("WebGL context and geometry model must be specified");
          if (typeof WebGL2RenderingContext < "u" && b instanceof WebGL2RenderingContext && (this._glVersion = 2), T = T || function(w) {
          }, this.id = A._instancesNum++, this.meter = C.meter, this.wcs = v.VectorUtils.getVec3(C.wcs), C.indices.length === 0)
            return this._empty = !0, void (this._changed = !1);
          this.InitGlBuffersAndTextures(b), this.InitRegions(C.regions), this.InitGPU(b, C, T), this._changed = !0;
        }
        return Object.defineProperty(A.prototype, "stopped", { get: function() {
          return this._stopped;
        }, set: function(b) {
          this._stopped = b, this._changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "isolatedProducts", { get: function() {
          return this._drawProductIds;
        }, set: function(b) {
          this._drawProductIds = b, this._changed = !0;
        }, enumerable: !1, configurable: !0 }), A.prototype.getRegion = function(b) {
          var C = this, T = null;
          if (this.isolatedProducts != null) {
            var w = [];
            if (this.isolatedProducts.forEach(function(k) {
              var W = C.getProductMap(k, b);
              W && w.push(W);
            }), w.length === 0)
              return null;
            var R = w.reduce(function(k, W) {
              return k == null ? W.bBox : m.BBox.union(k, W.bBox);
            }, null);
            return (T = new d.Region()).population = w.length, T.bbox = new Float32Array(R), T.centre = new Float32Array([R[0] + R[3] / 2, R[1] + R[4] / 2, R[2] + R[5] / 2]), T;
          }
          T = d.Region.clone(this._region);
          var O = x.vec3.subtract(x.vec3.create(), this.wcs, b);
          T.centre = x.vec3.add(x.vec3.create(), O, v.VectorUtils.getVec3(T.centre));
          var D = x.vec3.add(x.vec3.create(), O, v.VectorUtils.getVec3(T.bbox.subarray(0, 3)));
          return T.bbox.set(new Float32Array(D), 0), T;
        }, Object.defineProperty(A.prototype, "changed", { get: function() {
          return this._changed;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "empty", { get: function() {
          return this._empty;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "gl1", { get: function() {
          return this._glVersion === 1 ? this._gl : null;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "gl2", { get: function() {
          return this._glVersion === 2 ? this._gl : null;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "clippingPlaneA", { get: function() {
          return this._clippingPlaneA;
        }, set: function(b) {
          this._clippingPlaneA = b, this._clippingA = b != null, this._changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(A.prototype, "clippingPlaneB", { get: function() {
          return this._clippingPlaneB;
        }, set: function(b) {
          this._clippingPlaneB = b, this._clippingB = b != null, this._changed = !0;
        }, enumerable: !1, configurable: !0 }), A.prototype.InitRegions = function(b) {
          var C = this;
          this.empty || (this._region = b[0], b.forEach(function(T) {
            T.population > C._region.population && (C._region = T);
          }), this._region.bbox.indexOf(Number.NaN) === -1 && this._region.bbox.indexOf(1 / 0) === -1 && this._region.bbox.indexOf(-1 / 0) === -1 || (console.warn("Invalid region detected. Attempting to recompute the region based on all the products."), this._region = this.recomputeCompleteRegion()), this._region == null && (this._region = new d.Region(), this._region.population = 0, this._region.centre = new Float32Array([0, 0, 0]), this._region.bbox = new Float32Array([0, 0, 0, 0, 0, 0])));
        }, A.prototype.recomputeCompleteRegion = function() {
          var b = this, C = Object.getOwnPropertyNames(this._model.productMaps).map(function(R) {
            return b._model.productMaps[R];
          }), T = C.reduce(function(R, O) {
            return O.bBox.indexOf(Number.NaN) !== -1 || O.bBox.indexOf(1 / 0) !== -1 || O.bBox.indexOf(-1 / 0) !== -1 ? R : R == null ? O.bBox : m.BBox.union(R, O.bBox);
          }, null), w = new d.Region();
          return T == null ? (console.error("Failed to recompute the region. No valid product bounding boxes found."), w) : (w.population = C.length, w.bbox = new Float32Array(T), w.centre = new Float32Array([T[0] + T[3] / 2, T[1] + T[4] / 2, T[2] + T[5] / 2]), w);
        }, A.prototype.InitGlBuffersAndTextures = function(b) {
          this.empty || (this._vertexTexture = b.createTexture(), this._matrixTexture = b.createTexture(), this._styleTexture = b.createTexture(), this._vertexTextureSize = 0, this._matrixTextureSize = 0, this._styleTextureSize = 0, this._normalBuffer = b.createBuffer(), this._indexBuffer = b.createBuffer(), this._productBuffer = b.createBuffer(), this._styleBuffer = b.createBuffer(), this._stateBuffer = b.createBuffer(), this._transformationBuffer = b.createBuffer());
        }, A.prototype.setActive = function(b, C) {
          if (!this.stopped && !this.empty) {
            var T = this._glVersion === 1 ? this.gl1 : this.gl2;
            this._vertexTextureSize > 0 && (T.activeTexture(T.TEXTURE1), T.bindTexture(T.TEXTURE_2D, this._vertexTexture), T.uniform1i(b.VertexSamplerUniform, 1)), this._matrixTextureSize > 0 && (T.activeTexture(T.TEXTURE2), T.bindTexture(T.TEXTURE_2D, this._matrixTexture), T.uniform1i(b.MatrixSamplerUniform, 2)), this._styleTextureSize > 0 && (T.activeTexture(T.TEXTURE3), T.bindTexture(T.TEXTURE_2D, this._styleTexture), T.uniform1i(b.StyleSamplerUniform, 3)), T.bindBuffer(T.ARRAY_BUFFER, this._normalBuffer), T.vertexAttribPointer(b.NormalAttrPointer, 2, T.UNSIGNED_BYTE, !1, 0, 0), T.bindBuffer(T.ARRAY_BUFFER, this._indexBuffer), T.vertexAttribPointer(b.IndexlAttrPointer, 1, T.FLOAT, !1, 0, 0), T.bindBuffer(T.ARRAY_BUFFER, this._productBuffer), T.vertexAttribPointer(b.ProductAttrPointer, 1, T.FLOAT, !1, 0, 0), T.bindBuffer(T.ARRAY_BUFFER, this._stateBuffer), T.vertexAttribPointer(b.StateAttrPointer, 2, T.UNSIGNED_BYTE, !1, 0, 0), T.bindBuffer(T.ARRAY_BUFFER, this._styleBuffer), T.vertexAttribPointer(b.StyleAttrPointer, 1, T.UNSIGNED_SHORT, !1, 0, 0), T.bindBuffer(T.ARRAY_BUFFER, this._transformationBuffer), T.vertexAttribPointer(b.TransformationAttrPointer, 1, T.FLOAT, !1, 0, 0), T.uniform1f(b.VertexTextureSizeUniform, this._vertexTextureSize), T.uniform1f(b.MatrixTextureSizeUniform, this._matrixTextureSize), T.uniform1f(b.StyleTextureSizeUniform, this._styleTextureSize), T.uniform1f(b.MeterUniform, this.meter);
            var w = x.vec3.subtract(x.vec3.create(), this.wcs, C);
            if (T.uniform3fv(b.WcsUniform, w), T.uniform1i(b.ClippingAUniform, this._clippingA ? 1 : 0), T.uniform1i(b.ClippingBUniform, this._clippingB ? 1 : 0), this._clippingA) {
              var R = this.transformPlane(this._clippingPlaneA, C);
              T.uniform4fv(b.ClippingPlaneAUniform, R);
            }
            this._clippingB && (R = this.transformPlane(this._clippingPlaneB, C), T.uniform4fv(b.ClippingPlaneBUniform, R));
          }
        }, A.prototype.transformPlane = function(b, C) {
          var T = x.vec3.len(v.VectorUtils.getVec3(b)), w = b[0], R = b[1], O = b[2], D = b[3], k = w * -D / T, W = R * -D / T, L = O * -D / T;
          return D = 0 - w * (k -= C[0]) - R * (W -= C[1]) - O * (L -= C[2]), new Float32Array([w, R, O, D]);
        }, A.prototype.draw = function(b, C) {
          var T = this;
          if (this._changed = !1, !this.stopped && !this.empty) {
            var w = this._gl, R = this.isolatedProducts && this.isolatedProducts.length > 0 ? this.isolatedProducts.reduce(function(D, k) {
              var W = T.getProductMap(k);
              return W && D.push(W), D;
            }, new Array()) : null;
            if (R == null || R.length !== 0)
              if (b != null)
                if (b === u.SOLID && this._model.transparentIndex > 0)
                  if (R == null)
                    if (C == null || C === 100 || this._model.breaks[C] == null)
                      w.drawArrays(w.TRIANGLES, 0, this._model.transparentIndex);
                    else {
                      var O = this._model.breaks[C];
                      w.drawArrays(w.TRIANGLES, 0, O[0] + 1);
                    }
                  else
                    R.forEach(function(D) {
                      D.spans.filter(function(k) {
                        return k[1] <= T._model.transparentIndex;
                      }).forEach(function(k) {
                        w.drawArrays(w.TRIANGLES, k[0], k[1] - k[0]);
                      });
                    });
                else
                  b === u.TRANSPARENT && this._model.transparentIndex < this._numberOfIndices && (w.depthMask(!1), R == null ? C == null || C === 100 || this._model.breaks[C] == null ? w.drawArrays(w.TRIANGLES, this._model.transparentIndex, this._numberOfIndices - this._model.transparentIndex) : (O = this._model.breaks[C], w.drawArrays(w.TRIANGLES, O[1], this._numberOfIndices - O[1])) : R.forEach(function(D) {
                    D.spans.filter(function(k) {
                      return k[0] >= T._model.transparentIndex;
                    }).forEach(function(k) {
                      w.drawArrays(w.TRIANGLES, k[0], k[1] - k[0]);
                    });
                  }), w.depthMask(!0));
              else
                R == null ? w.drawArrays(w.TRIANGLES, 0, this._numberOfIndices) : R.forEach(function(D) {
                  D.spans.forEach(function(k) {
                    w.drawArrays(w.TRIANGLES, k[0], k[1] - k[0]);
                  });
                });
          }
        }, A.prototype.getProductId = function(b) {
          return this.empty ? null : this._model.productIdLookup[b];
        }, A.prototype.getProductMap = function(b, C) {
          if (this.empty)
            return null;
          var T = this._model.productMaps[b];
          if (T != null) {
            if (C != null) {
              T = E.ProductMap.clone(T);
              var w = v.VectorUtils.getVec3(T.bBox.subarray(0, 3)), R = x.vec3.subtract(x.vec3.create(), this.wcs, C), O = x.vec3.add(x.vec3.create(), w, R);
              T.bBox.set(O, 0);
            }
            return T;
          }
          return null;
        }, A.prototype.getProductMaps = function(b) {
          var C = this, T = new Array();
          return this.empty || b.forEach(function(w) {
            var R = C._model.productMaps[w];
            R != null && T.push(R);
          }), T;
        }, A.prototype.getProductsOfType = function(b) {
          var C = this, T = [];
          if (this.empty)
            return T;
          var w = h.Product.getAllSubTypes(b);
          return Object.getOwnPropertyNames(this._model.productMaps).forEach(function(R) {
            var O = C._model.productMaps[R];
            w[O.type] && T.push(O);
          }), T;
        }, A.prototype.unload = function() {
          if (this.empty)
            return null;
          var b = this._gl;
          b.deleteTexture(this._vertexTexture), b.deleteTexture(this._matrixTexture), b.deleteTexture(this._styleTexture), b.deleteBuffer(this._normalBuffer), b.deleteBuffer(this._indexBuffer), b.deleteBuffer(this._productBuffer), b.deleteBuffer(this._styleBuffer), b.deleteBuffer(this._stateBuffer), b.deleteBuffer(this._transformationBuffer);
        }, A.prototype.InitGPU = function(b, C, T) {
          if (this.empty)
            return null;
          var w = function(O) {
            var D = { message: "Loading data into GPU", percent: O, type: g.MessageType.PROGRESS, phase: g.LoadingPhase.LOADING };
            T(D);
          };
          this._numberOfIndices = C.indices.length, this.bufferData(this._normalBuffer, C.normals), w(10), this.bufferData(this._indexBuffer, C.indices), w(30), this.bufferData(this._productBuffer, C.products), w(40), this.bufferData(this._stateBuffer, C.states), w(50), this.bufferData(this._transformationBuffer, C.transformations), w(60), this.bufferData(this._styleBuffer, C.styleIndices), this._vertexTextureSize = A.bufferTexture(b, this._vertexTexture, C.vertices, 3), w(80), this._matrixTextureSize = A.bufferTexture(b, this._matrixTexture, C.matrices, 4), w(90), this._styleTextureSize = A.bufferTexture(b, this._styleTexture, C.styles), w(100), C.normals = null, C.indices = null, C.products = null, C.transformations = null, C.styleIndices = null, C.vertices = null, C.matrices = null;
          var R = { message: "Model loaded", percent: 100, type: g.MessageType.COMPLETED, phase: g.LoadingPhase.LOADING };
          T(R);
        }, A.prototype.bufferData = function(b, C) {
          var T;
          this._glVersion === 1 && ((T = this.gl1).bindBuffer(T.ARRAY_BUFFER, b), T.bufferData(T.ARRAY_BUFFER, C, T.STATIC_DRAW)), this._glVersion === 2 && ((T = this.gl2).bindBuffer(T.ARRAY_BUFFER, b), T.bufferData(T.ARRAY_BUFFER, C, T.STATIC_DRAW));
        }, A.bufferTexture = function(b, C, T, w) {
          if (T.length === 0) {
            b.bindTexture(b.TEXTURE_2D, C);
            var R = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
            return b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, 2, 2, 0, b.RGBA, b.UNSIGNED_BYTE, R), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.NEAREST), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.NEAREST), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE), 2;
          }
          var O = T instanceof Float32Array, D = 0, k = b.getParameter(b.MAX_TEXTURE_SIZE);
          if (O)
            D = Math.ceil(Math.sqrt(Math.ceil(T.length / w))) + 1;
          else {
            var W = Math.sqrt(T.byteLength / 4);
            D = Math.ceil(W);
          }
          if (D === 0)
            return 0;
          if (D > k)
            throw new Error("Too much data! It cannot fit into the texture.");
          if (b.bindTexture(b.TEXTURE_2D, C), b.pixelStorei(b.UNPACK_FLIP_Y_WEBGL, 0), b.pixelStorei(b.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), T instanceof Float32Array) {
            if (R = null, D * D * w !== T.length ? (R = new Float32Array(D * D * w)).set(T) : R = T, b instanceof WebGLRenderingContext) {
              var L = null;
              switch (w) {
                case 1:
                  L = b.ALPHA;
                  break;
                case 3:
                  L = b.RGB;
                  break;
                case 4:
                  L = b.RGBA;
              }
              b.texImage2D(b.TEXTURE_2D, 0, L, D, D, 0, L, b.FLOAT, R);
            }
            if (typeof WebGL2RenderingContext < "u" && b instanceof WebGL2RenderingContext) {
              var z = b, P = null, Q = null;
              switch (w) {
                case 1:
                  Q = z.RED, P = z.R32F;
                  break;
                case 3:
                  Q = z.RGB, P = z.RGB32F;
                  break;
                case 4:
                  Q = z.RGBA, P = z.RGBA32F;
              }
              z.texImage2D(z.TEXTURE_2D, 0, P, D, D, 0, Q, z.FLOAT, R);
            }
          } else
            b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, D, D, 0, b.RGBA, b.UNSIGNED_BYTE, new Uint8Array(T.buffer));
          return b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.NEAREST), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.NEAREST), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE), D;
        }, A.prototype.getState = function(b) {
          var C = this.getFirstSpan(b);
          return C == null ? null : this._model.states[2 * C[0]];
        }, A.prototype.getStates = function() {
          var b = this, C = [];
          return Object.getOwnPropertyNames(this._model.productMaps).forEach(function(T) {
            var w = b._model.productMaps[+T];
            w.states != null && w.states.length !== 0 && (w.states.length === 1 && w.states[0] === f.State.UNDEFINED || C.push({ id: w.productID, states: w.states.slice(0) }));
          }), C;
        }, A.prototype.getStyle = function(b) {
          var C = this.getFirstSpan(b);
          return C == null ? null : this._model.states[2 * C[0] + 1];
        }, A.prototype.getFirstSpan = function(b) {
          if (this.empty)
            return null;
          if (b === void 0)
            throw new Error("id must be defined");
          var C = this.getProductMap(b);
          if (C === null)
            return null;
          var T = C.spans[0];
          return T === void 0 ? null : T;
        }, A.prototype.addState = function(b, C) {
          var T = this;
          this.empty || (this.checkStateArgs(b, C), this.getMaps(C).forEach(function(w) {
            E.ProductMap.addState(w, b);
            var R = E.ProductMap.getState(w);
            w.spans.forEach(function(O) {
              for (var D = O[0]; D < O[1]; D++)
                T._model.states[2 * D] = R;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0);
        }, A.prototype.setState = function(b, C) {
          var T = this;
          this.empty || (this.checkStateArgs(b, C), this.getMaps(C).forEach(function(w) {
            w.states = [b], w.spans.forEach(function(R) {
              for (var O = R[0]; O < R[1]; O++)
                T._model.states[2 * O] = b;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0);
        }, A.prototype.clearHighlighting = function() {
          var b = this;
          Object.getOwnPropertyNames(this._model.productMaps).forEach(function(C) {
            var T = b._model.productMaps[+C];
            E.ProductMap.removeState(T, f.State.HIGHLIGHTED);
            var w = E.ProductMap.getState(T);
            T.spans.forEach(function(R) {
              for (var O = R[0]; O < R[1]; O++)
                b._model.states[2 * O] = w;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0;
        }, A.prototype.removeState = function(b, C) {
          var T = this;
          this.empty || (this.checkStateArgs(b, C), this.getMaps(C).forEach(function(w) {
            E.ProductMap.removeState(w, b);
            var R = E.ProductMap.getState(w);
            w.spans.forEach(function(O) {
              for (var D = O[0]; D < O[1]; D++)
                T._model.states[2 * D] = R;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0);
        }, A.prototype.checkStateArgs = function(b, C) {
          if (typeof b != "number" || b < 0 || b > 255)
            throw new Error("You have to specify state as an ID of state or index in style pallete.");
          if (C === void 0)
            throw new Error("You have to specify products as an array of product IDs or as a product type ID");
        }, A.prototype.resetState = function(b) {
          var C = this;
          if (this.empty)
            return null;
          if (b == null) {
            Object.getOwnPropertyNames(this._model.productMaps).forEach(function(w) {
              C._model.productMaps[+w].states = [];
            });
            for (var T = 0; T < this._model.states.length; T += 2)
              this._model.states[T] = f.State.UNDEFINED;
          } else
            this.getMaps(b).forEach(function(w) {
              w.states = [], w.spans.forEach(function(R) {
                for (var O = R[0]; O < R[1]; O++)
                  C._model.states[2 * O] = f.State.UNDEFINED;
              });
            });
          this.bufferData(this._stateBuffer, this._model.states), this._changed = !0;
        }, A.prototype.getProductsWithState = function(b) {
          var C = this, T = [], w = {}, R = this.isolatedProducts != null && this.isolatedProducts.length > 0;
          return R && this.isolatedProducts.forEach(function(O) {
            return w[O] = !0;
          }), Object.getOwnPropertyNames(this._model.productMaps).forEach(function(O) {
            var D = C._model.productMaps[O];
            D.states.indexOf(b) !== -1 && (R && !w[D.productID] || T.push({ id: D.productID, model: C.id }));
          }), T;
        }, A.prototype.setStyle = function(b, C) {
          var T = this;
          if (this.empty)
            return null;
          if (typeof b != "number" && b < 0 && b > 255)
            throw new Error("You have to specify state as an ID of state or index in style pallete.");
          if (C === void 0)
            throw new Error("You have to specify products as an array of product IDs or as a product type ID");
          this.getMaps(C).forEach(function(w) {
            w.spans.forEach(function(R) {
              for (var O = R[0]; O < R[1]; O++)
                T._model.states[2 * O + 1] = b;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0;
        }, A.prototype.getMaps = function(b) {
          var C = this, T = [];
          if (typeof b == "number") {
            var w = h.Product.getAllSubTypes(b);
            Object.getOwnPropertyNames(this._model.productMaps).forEach(function(R) {
              var O = C._model.productMaps[R];
              w[O.type] && T.push(O);
            });
          } else
            b.forEach(function(R) {
              var O = C.getProductMap(R);
              O != null && T.push(O);
            });
          return T;
        }, A.prototype.resetStyles = function() {
          if (this.empty)
            return null;
          for (var b = 0; b < this._model.states.length; b += 2)
            this._model.states[b + 1] = f.State.UNSTYLED;
          this.bufferData(this._stateBuffer, this._model.states), this._changed = !0;
        }, A.prototype.getModelState = function() {
          var b = [];
          if (this.empty)
            return b;
          var C = this._model.productMaps;
          for (var T in C)
            if (C.hasOwnProperty(T)) {
              var w = C[T], R = w.spans[0];
              if (R !== void 0) {
                var O = this._model.states[2 * R[0]], D = this._model.states[2 * R[0] + 1];
                b.push([w.productID, O + (D << 8)]);
              }
            }
          return b;
        }, A.prototype.restoreModelState = function(b) {
          var C = this;
          if (this.empty)
            return null;
          b.forEach(function(T) {
            var w = T[0], R = T[1] >> 8, O = T[1] - (R << 8), D = C.getProductMap(w);
            D != null && D.spans.forEach(function(k) {
              for (var W = k[0]; W < k[1]; W++)
                C._model.states[2 * W] = O, C._model.states[2 * W + 1] = R;
            });
          }), this.bufferData(this._stateBuffer, this._model.states), this._changed = !0;
        }, A.prototype.getProductAnalysis = function(b) {
          var C = this;
          return b == null && (b = []), Object.getOwnPropertyNames(this._model.productMaps).forEach(function(T) {
            var w = C._model.productMaps[T], R = w.spans.reduce(function(k, W) {
              return k + W[1] - W[0];
            }, 0), O = Math.max(w.bBox[3], w.bBox[4], w.bBox[5]), D = Math.sqrt(w.bBox[3] * w.bBox[3] + w.bBox[4] * w.bBox[4] + w.bBox[5] * w.bBox[5]);
            b.push({ modelId: C.id, numberOfTriangles: R / 3, productId: w.productID, size: O, volume: D, density: R / 3 / D });
          }), b;
        }, A._instancesNum = 1, A;
      }();
      l.ModelHandle = y, function(A) {
        A[A.SOLID = 0] = "SOLID", A[A.TRANSPARENT = 1] = "TRANSPARENT";
      }(u = l.DrawMode || (l.DrawMode = {}));
    }, 2067: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ModelPointers = void 0, l.ModelPointers = function(c, u) {
        this.NormalAttrPointer = c.getAttribLocation(u, "aNormal"), this.IndexlAttrPointer = c.getAttribLocation(u, "aVertexIndex"), this.ProductAttrPointer = c.getAttribLocation(u, "aProduct"), this.StateAttrPointer = c.getAttribLocation(u, "aState"), this.StyleAttrPointer = c.getAttribLocation(u, "aStyleIndex"), this.TransformationAttrPointer = c.getAttribLocation(u, "aTransformationIndex"), this.VertexSamplerUniform = c.getUniformLocation(u, "uVertexSampler"), this.MatrixSamplerUniform = c.getUniformLocation(u, "uMatrixSampler"), this.StyleSamplerUniform = c.getUniformLocation(u, "uStyleSampler"), this.VertexTextureSizeUniform = c.getUniformLocation(u, "uVertexTextureSize"), this.MatrixTextureSizeUniform = c.getUniformLocation(u, "uMatrixTextureSize"), this.StyleTextureSizeUniform = c.getUniformLocation(u, "uStyleTextureSize"), this.ClippingPlaneAUniform = c.getUniformLocation(u, "uClippingPlaneA"), this.ClippingAUniform = c.getUniformLocation(u, "uClippingA"), this.ClippingPlaneBUniform = c.getUniformLocation(u, "uClippingPlaneB"), this.ClippingBUniform = c.getUniformLocation(u, "uClippingB"), this.MeterUniform = c.getUniformLocation(u, "uMeter"), this.WcsUniform = c.getUniformLocation(u, "uWcs"), c.enableVertexAttribArray(this.NormalAttrPointer), c.enableVertexAttribArray(this.IndexlAttrPointer), c.enableVertexAttribArray(this.ProductAttrPointer), c.enableVertexAttribArray(this.StateAttrPointer), c.enableVertexAttribArray(this.StyleAttrPointer), c.enableVertexAttribArray(this.TransformationAttrPointer);
      };
    }, 9549: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Animations = l.EasingType = void 0;
      var u, d = c(887);
      (function(h) {
        h[h.LINEAR = 0] = "LINEAR", h[h.SINUS = 1] = "SINUS", h[h.SINUS2 = 2] = "SINUS2", h[h.CIRCLE = 3] = "CIRCLE";
      })(u = l.EasingType || (l.EasingType = {}));
      var f = function() {
        function h(g) {
          var x = this;
          this.viewer = g, this._rotationOn = !1, this.setTimeout = window.setTimeout.bind(window), this.requestAnimationFrame = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(E) {
            window.setTimeout(E, 1e3 / 60);
          }).bind(window), g.canvas.addEventListener("mousedown", function() {
            return x.clear();
          }), g.canvas.addEventListener("touchstart", function() {
            return x.clear();
          });
        }
        return h.prototype.clear = function() {
          h.viewQueue = [], h.zoomQueue = [], this._rotationOn = !1;
        }, h.prototype.startRotation = function() {
          var g = this;
          return this._rotationOn ? new Promise(function(x, E) {
            x();
          }) : (this._rotationOn = !0, new Promise(function(x, E) {
            var m = function() {
              g._rotationOn ? (g.viewer.mvMatrix = d.mat4.rotateZ(d.mat4.create(), g.viewer.mvMatrix, 0.2 * Math.PI / 180), g.requestAnimationFrame(m)) : x();
            };
            m();
          }));
        }, h.prototype.stopRotation = function() {
          this._rotationOn = !1;
        }, h.prototype.viewTo = function(g, x, E) {
          var m = this;
          return E === void 0 && (E = u.SINUS2), new Promise(function(v, y) {
            if (x <= 0)
              return m.viewer.mvMatrix = g.mv, m.viewer.cameraProperties.height = g.height, void v();
            var A;
            if (A = h.viewQueue.length > 0 ? h.viewQueue[h.viewQueue.length - 1] : { mv: d.mat4.copy(d.mat4.create(), m.viewer.mvMatrix), height: m.viewer.cameraProperties.height }, d.mat4.equals(A.mv, g.mv) && Math.abs(A.height - g.height) < 1e-6)
              v();
            else {
              var b = d.mat4.getRotation(d.quat.create(), A.mv), C = d.mat4.getScaling(d.vec3.create(), A.mv), T = d.mat4.getTranslation(d.vec3.create(), A.mv), w = null, R = d.mat4.getRotation(d.quat.create(), g.mv), O = d.mat4.getScaling(d.vec3.create(), g.mv), D = d.mat4.getTranslation(d.vec3.create(), g.mv);
              h.viewQueue.push(g);
              var k = function() {
                if (h.viewQueue[0] !== g)
                  return h.viewQueue.filter(function(te) {
                    return te === g;
                  }).pop() != null ? void m.requestAnimationFrame(k) : void v();
                w == null && (w = Date.now());
                var W = Date.now();
                if (!(W < w + x))
                  return m.viewer.mvMatrix = g.mv, m.viewer.cameraProperties.height = g.height, h.viewQueue.shift(), void v();
                var L = (W - w) / x;
                switch (E) {
                  case u.LINEAR:
                    break;
                  case u.CIRCLE:
                    L = m.getCircleEasing(L);
                    break;
                  case u.SINUS:
                    L = m.getSinEasing(L);
                    break;
                  case u.SINUS2:
                    L = m.getSinEasing(L), L = m.getSinEasing(L);
                }
                var z = d.quat.slerp(d.quat.create(), b, R, L), P = d.vec3.lerp(d.vec3.create(), C, O, L), Q = d.vec3.lerp(d.vec3.create(), T, D, L), Y = (g.height - A.height) * L, ie = d.mat4.fromRotationTranslationScaleOrigin(d.mat4.create(), z, Q, P, d.vec3.create());
                m.viewer.mvMatrix = ie, m.viewer.cameraProperties.height = A.height + Y, m.requestAnimationFrame(k);
              };
              k();
            }
          });
        }, h.prototype.addZoom = function(g, x, E) {
          var m = this, v = d.mat4.copy(d.mat4.create(), this.viewer.mvMatrix), y = this.viewer.cameraProperties.height;
          if (h.zoomQueue.length > 0) {
            var A = h.zoomQueue[h.zoomQueue.length - 1];
            v = A.mv, y = A.height;
          }
          var b = d.vec3.create();
          if (E)
            E = d.vec3.normalize(d.vec3.create(), E), d.vec3.negate(b, E);
          else {
            var C = d.mat4.invert(d.mat4.create(), v), T = d.mat4.getRotation(d.quat.create(), C), w = d.vec3.transformQuat(d.vec3.create(), d.vec3.fromValues(0, 0, -1), T);
            d.vec3.negate(b, w);
          }
          var R = d.vec3.scale(d.vec3.create(), b, g), O = this.viewer.cameraProperties.fov * Math.PI / 180, D = 2 * g * Math.tan(O / 2), k = 2 * this.viewer.cameraProperties.near * Math.tan(O / 2);
          y - D < k && (D = 0);
          var W = { mv: d.mat4.translate(d.mat4.create(), v, R), height: y - D };
          return new Promise(function(L, z) {
            if (x <= 0)
              return h.zoomQueue = [], m.viewer.mvMatrix = W.mv, m.viewer.cameraProperties.height = W.height, void L();
            var P = null, Q = R;
            h.zoomQueue.push(W);
            var Y = function() {
              if (h.zoomQueue[0] !== W)
                return h.zoomQueue.filter(function(G) {
                  return G === W;
                }).pop() != null ? void m.requestAnimationFrame(Y) : void L();
              P == null && (P = Date.now());
              var ie = Date.now();
              if (!(ie < P + x))
                return m.viewer.mvMatrix = W.mv, m.viewer.cameraProperties.height = W.height, h.zoomQueue.shift(), void L();
              var te = (ie - P) / x, Z = d.vec3.lerp(d.vec3.create(), d.vec3.create(), Q, te), ae = D * te;
              m.viewer.mvMatrix = d.mat4.translate(d.mat4.create(), v, Z), m.viewer.cameraProperties.height = y - ae, m.requestAnimationFrame(Y);
            };
            Y();
          });
        }, h.prototype.getCircleEasing = function(g) {
          if (g <= 0.5) {
            var x = 2 * g;
            return (1 - Math.sqrt(1 - x * x)) / 2;
          }
          return x = 2 * g - 2, (1 + Math.sqrt(1 - x * x)) / 2;
        }, h.prototype.getSinEasing = function(g) {
          var x = g * Math.PI - Math.PI / 2;
          return 0.5 * Math.sin(x) + 0.5;
        }, h.viewQueue = [], h.zoomQueue = [], h;
      }();
      l.Animations = f;
    }, 6235: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CameraAdjustment = void 0;
      var u = c(9499), d = c(887), f = c(6413), h = function() {
        function g(x, E, m) {
          this.viewer = x, this.request = E, this.density = m, this.lastMvChange = 0, this.dirty = !0, this.stopped = !0;
        }
        return g.prototype.stop = function() {
          this.stopped = !0;
        }, g.prototype.watch = function(x) {
          var E = this;
          if (x === void 0 && (x = 500), this.viewer.hasDepthSupport) {
            var m = this.request, v = this.viewer;
            this.stopped = !1;
            var y = function() {
              if (!E.stopped) {
                if (!(Date.now() - E.lastMvChange < x + 20))
                  return v.mvMatrixAge < x ? (E.dirty = !0, void m(y)) : (v.mvMatrixAge > x && !E.dirty || v.height && (E.adjust(), E.dirty = !1), void m(y));
                m(y);
              }
            };
            m(y);
          }
        }, g.prototype.adjust = function(x) {
          x === void 0 && (x = null);
          var E = this.viewer;
          if (x = x || this.density, E.hasDepthSupport && E.isRunning && E.activeHandles.length !== 0) {
            var m = E.width / 4, v = E.height / 4;
            if (m !== 0 && v !== 0) {
              var y = new u.Framebuffer(E.gl, m, v, !0, this.viewer.glVersion);
              E.draw(y, !0);
              for (var A = [], b = m / (x + 1), C = v / (x + 1), T = 1; T < x + 1; T++)
                for (var w = T * b, R = 1; R < x + 1; R++) {
                  var O = R * C;
                  A.push({ x: w, y: O });
                }
              var D = A.map(function(U) {
                return 1;
              }), k = y.getXYZArray(A).map(function(U, F) {
                return U == null ? null : { point: U, weight: D[F] };
              }).filter(function(U) {
                return U != null;
              });
              if (k.length !== 0) {
                var W = E.cameraProperties.getProjectionMatrix(m, v), L = d.mat4.invert(d.mat4.create(), W), z = k.map(function(U) {
                  return { point: d.vec3.transformMat4(d.vec3.create(), U.point, L), weight: U.weight };
                }).map(function(U) {
                  return { distance: -U.point[2], weight: U.weight };
                }), P = this.trimmedMean(z), Q = E.cameraProperties.fov * Math.PI / 180;
                if (E.camera === f.CameraType.PERSPECTIVE) {
                  var Y = 2 * P * Math.tan(Q / 2);
                  E.cameraProperties.height = Y;
                }
                if (E.camera === f.CameraType.ORTHOGONAL) {
                  var ie = d.vec3.normalize(d.vec3.create(), E.getCameraDirection()), te = E.cameraProperties.height / (2 * Math.tan(Q / 2)), Z = te / P;
                  if (Z > 1.1 || Z < 0.9) {
                    var ae = te - P, G = d.vec3.scale(d.vec3.create(), ie, ae);
                    E.mvMatrix = d.mat4.translate(d.mat4.create(), E.mvMatrix, G), this.lastMvChange = Date.now();
                  }
                }
              }
            }
          }
        }, g.prototype.trimmedMean = function(x) {
          if (x.length > 100) {
            x.sort(function(m, v) {
              return m.distance - v.distance;
            });
            var E = Math.floor(x.length / 10);
            x = x.slice(E, x.length - E);
          }
          return x.reduce(function(m, v) {
            return m + v.distance * v.weight;
          }, 0) / x.reduce(function(m, v) {
            return m + v.weight;
          }, 0);
        }, g;
      }();
      l.CameraAdjustment = h;
    }, 1271: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(h, g, x, E) {
        E === void 0 && (E = x);
        var m = Object.getOwnPropertyDescriptor(g, x);
        m && !("get" in m ? !g.__esModule : m.writable || m.configurable) || (m = { enumerable: !0, get: function() {
          return g[x];
        } }), Object.defineProperty(h, E, m);
      } : function(h, g, x, E) {
        E === void 0 && (E = x), h[E] = g[x];
      }), d = this && this.__exportStar || function(h, g) {
        for (var x in h)
          x === "default" || Object.prototype.hasOwnProperty.call(g, x) || u(g, h, x);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Animations = l.EasingType = void 0, d(c(6235), l);
      var f = c(9549);
      Object.defineProperty(l, "EasingType", { enumerable: !0, get: function() {
        return f.EasingType;
      } }), Object.defineProperty(l, "Animations", { enumerable: !0, get: function() {
        return f.Animations;
      } });
    }, 810: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.KeyboardNavigation = void 0;
      var u = c(887), d = function() {
        function f() {
        }
        return f.initKeyboardEvents = function(h) {
          document.addEventListener("keydown", function(g) {
            if (h.navigationMode === "walk") {
              var x = function() {
                var m = h.getCameraDirection(), v = h.getCameraPosition(), y = 10 * h.unitsInMeter;
                return u.vec3.add(u.vec3.create(), v, u.vec3.scale(u.vec3.create(), m, y));
              }, E = g.shiftKey === !0 ? 3 : 1;
              switch (g.code) {
                case "KeyW":
                  h.navigate("walk", 0, 2 * E, u.vec3.create());
                  break;
                case "KeyS":
                  h.navigate("walk", 0, -2 * E, u.vec3.create());
                  break;
                case "KeyA":
                  h.navigate("pan", 4 * E, 0, x());
                  break;
                case "KeyD":
                  h.navigate("pan", -4 * E, 0, x());
                  break;
                case "KeyR":
                case "ArrowUp":
                  h.navigate("pan", 0, 4 * E, x());
                  break;
                case "KeyF":
                case "ArrowDown":
                  h.navigate("pan", 0, -4 * E, x());
                  break;
                case "KeyQ":
                case "ArrowLeft":
                  h.navigate("look-around", 2, 0, h.getCameraPosition());
                  break;
                case "KeyE":
                case "ArrowRight":
                  h.navigate("look-around", -2, 0, h.getCameraPosition());
              }
            }
          }, !1);
        }, f;
      }();
      l.KeyboardNavigation = d;
    }, 4802: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.MouseNavigation = void 0;
      var u = c(887), d = function() {
        function f() {
        }
        return f.initMouseEvents = function(h) {
          var g = !1, x = null, E = null, m = null, v = null, y = "L", A = -1, b = -1, C = null, T = !1, w = u.vec3.create(), R = function(z) {
            h.navigationMode === "walk" && h.navigate("look-at", 0.5 * z.movementX, 0.5 * z.movementY, w);
          }, O = null, D = null, k = 0, W = h.canvas.requestPointerLock;
          W != null && (W = W.bind(h.canvas), h.canvas.onclick = function() {
            h.navigationMode !== "walk" || T || W();
          }), document.addEventListener("pointerlockchange", function(z) {
            document.pointerLockElement === h.canvas ? T || (T = !0, h.canvas.addEventListener("mousemove", R, !1)) : (T = !1, h.canvas.removeEventListener("mousemove", R, !1));
          }, !1);
          var L = 0;
          h.canvas.addEventListener("mousedown", function(z) {
            return function(P) {
              g = !0, x = P.clientX, E = P.clientY, m = P.clientX, v = P.clientY;
              var Q = h.canvas.getBoundingClientRect(), Y = m - Q.left, ie = h.height - (v - Q.top), te = h.getEventData(Y, ie);
              if (te != null) {
                if (A = te.id, b = te.model, C = te.xyz, h.navigationMode === "locked-orbit")
                  w = h.lockedOrbitOrigin;
                else if (te == null || te.id == null || te.model == null) {
                  var Z = h.getMergedRegion();
                  if (Z == null || Z.centre == null)
                    return void (g = !1);
                  w = u.vec3.fromValues(Z.centre[0], Z.centre[1], Z.centre[2]);
                } else if (te.xyz == null) {
                  var ae = h.getTargetBoundingBox(te.id, te.model);
                  w = u.vec3.fromValues(ae[0] + ae[3] / 2, ae[1] + ae[4] / 2, ae[2] + ae[5] / 2);
                } else
                  w = te.xyz;
                switch (P.button) {
                  case 0:
                  default:
                    y = "left";
                    break;
                  case 1:
                    y = "middle";
                    break;
                  case 2:
                    y = "right";
                }
                h.disableTextSelection();
              } else
                g = !1;
            }(z);
          }, !0), h.canvas.addEventListener("wheel", function(z) {
            return function(P) {
              try {
                if (h.navigationMode === "none")
                  return;
                P.stopPropagation && P.stopPropagation(), P.preventDefault && P.preventDefault(), k++;
                var Q = u.vec2.fromValues(P.clientX, P.clientY);
                if (D == null || u.vec2.dist(D, Q) > 5 || k > 10) {
                  if ((O = h.getInteractionOrigin(P)) == null) {
                    var Y = h.getMergedRegion();
                    if (Y && Y.centre) {
                      var ie = u.vec3.fromValues(Y.centre[0], Y.centre[1], Y.centre[2]), te = h.getCameraPosition(), Z = u.vec3.distance(ie, te), ae = u.mat4.invert(u.mat4.create(), h.mvMatrix), G = u.mat4.getRotation(u.quat.create(), ae), U = u.vec3.normalize(u.vec3.create(), u.vec3.transformQuat(u.vec3.create(), [0, 0, -1], G)), F = u.vec3.scale(u.vec3.create(), U, Z);
                      O = u.vec3.add(u.vec3.create(), F, te);
                    }
                  }
                  D = Q, k = 0;
                }
                var M = function(I) {
                  return (I = +I) == 0 || isNaN(I) ? I : I > 0 ? 1 : -1;
                };
                h.navigate("zoom", -1 * M(P.deltaX), -1 * M(P.deltaY), O);
              } catch (I) {
                console.error(I);
              }
            }(z);
          }, !0), window.addEventListener("mouseup", function(z) {
            return function(P) {
              if (g) {
                g = !1;
                var Q = P.clientX, Y = P.clientY, ie = Math.abs(Q - m), te = Math.abs(Y - v);
                if (ie < 3 && te < 3 && y === "left") {
                  h.fire("pick", { id: A, model: b, event: P, xyz: C });
                  var Z = (/* @__PURE__ */ new Date()).getTime();
                  Z - L < 250 && h.fire("dblclick", { id: A, model: b, event: P, xyz: C }), L = Z;
                }
                h.enableTextSelection();
              }
            }(z);
          }, !0), window.addEventListener("mousemove", function(z) {
            return function(P) {
              if (h.hoverPickEnabled && !g && h.navigationMode !== "walk") {
                var Q = h.canvas.getBoundingClientRect(), Y = P.clientX - Q.left, ie = h.height - (P.clientY - Q.top), te = h.getEventData(Y, ie);
                h.setHoverPick(te.id, te.model), h.fire("hoverpick", { id: te.id, model: te.model, event: P, xyz: te.xyz });
              }
              if (g && h.navigationMode !== "none") {
                var Z = P.clientX, ae = P.clientY, G = Z - x, U = ae - E;
                if (x = Z, E = ae, y === "left")
                  if (P.shiftKey)
                    h.navigate("pan", G, U, w);
                  else
                    switch (h.navigationMode) {
                      case "free-orbit":
                        h.navigate("free-orbit", G, U, w);
                        break;
                      case "locked-orbit":
                        h.navigate("locked-orbit", G, U, w);
                      case "fixed-orbit":
                      case "orbit":
                        h.navigate("orbit", G, U, w);
                        break;
                      case "pan":
                        h.navigate("pan", G, U, w);
                        break;
                      case "zoom":
                        h.navigate("zoom", G, U, w);
                        break;
                      case "look-around":
                        h.navigate("look-around", G, U, w);
                    }
                y !== "middle" && y !== "right" || h.navigate("pan", G, U, w);
              }
            }(z);
          }, !0);
        }, f;
      }();
      l.MouseNavigation = d;
    }, 8948: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PreflightCheck = void 0;
      var u = c(887), d = c(1150), f = function() {
        function h() {
        }
        return h.findView = function(g, x, E) {
          if (x == null || x.length === 0)
            return null;
          var m = g.getTargetsBoundingBox(x);
          if (m == null)
            return null;
          var v = [{ dir: [1, 0, 0], up: [0, 0, 1] }, { dir: [0, 1, 0], up: [0, 0, 1] }, { dir: [-1, 0, 0], up: [0, 0, 1] }, { dir: [0, -1, 0], up: [0, 0, 1] }, { dir: [1, 1, 0], up: [0, 0, 1] }, { dir: [-1, -1, 0], up: [0, 0, 1] }, { dir: [-1, 1, 0], up: [0, 0, 1] }, { dir: [1, -1, 0], up: [0, 0, 1] }].map(function(ae) {
            return { dir: u.vec3.normalize(u.vec3.create(), d.VectorUtils.getVec3(ae.dir)), up: u.vec3.normalize(u.vec3.create(), d.VectorUtils.getVec3(ae.up)) };
          }), y = m[3] * m[4], A = m[3] * m[5], b = m[4] * m[5];
          y > A && y > b && (v.push({ dir: u.vec3.fromValues(0, 0, -1), up: u.vec3.fromValues(0, 1, 0) }), v.push({ dir: u.vec3.fromValues(0, 0, -1), up: u.vec3.fromValues(1, 0, 0) }));
          for (var C = g.width / E, T = g.height / E, w = [], R = 1; R < E; R++)
            for (var O = 1; O < 10; O++)
              w.push({ x: R * C, y: O * T });
          var D = x.reduce(function(ae, G) {
            return ae["".concat(G.model, ".").concat(G.id)] = !0, ae;
          }, {}), k = g.isRunning;
          g.stop();
          var W = g.mvMatrix, L = g.cameraProperties.height, z = g.adaptivePerformanceOn;
          try {
            g.adaptivePerformanceOn = !1;
            var P = u.vec3.fromValues(m[0] + m[3] / 2, m[1] + m[4] / 2, m[2] + m[5] / 2), Q = v.map(function(ae) {
              return g.getDistanceAndHeight(m, ae.dir, ae.up);
            }), Y = Q.map(function(ae, G) {
              var U = u.vec3.negate(u.vec3.create(), v[G].dir), F = u.vec3.scale(u.vec3.create(), U, ae.distance), M = u.vec3.add(u.vec3.create(), F, P);
              return u.mat4.lookAt(u.mat4.create(), M, P, v[G].up);
            }), ie = Y.map(function(ae, G) {
              return g.mvMatrix = ae, g.cameraProperties.height = Q[G].height, g.getData(w).map(function(U) {
                return U != null ? "".concat(U.model, ".").concat(U.id) : null;
              });
            }).map(function(ae) {
              return ae.reduce(function(G, U) {
                return U == null || D[U] === !0 && (G.count++, G.types[U] == null ? G.types[U] = 1 : G.types[U] = G.types[U] + 1), G;
              }, { count: 0, types: {} });
            }).map(function(ae) {
              return ae.count * Math.pow(Object.getOwnPropertyNames(ae.types).length, 2);
            }), te = 0, Z = 0;
            return ie.forEach(function(ae, G) {
              ae > Z && (Z = ae, te = G);
            }), Z > 0 ? { mv: Y[te], height: Q[te].height } : null;
          } catch (ae) {
            console.error(ae);
          } finally {
            g.mvMatrix = W, L != null && L > 0 && (g.cameraProperties.height = L), g.adaptivePerformanceOn = z, k && g.start();
          }
        }, h;
      }();
      l.PreflightCheck = f;
    }, 5771: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.TouchNavigation = void 0;
      var u = c(887), d = function() {
        function f() {
        }
        return f.initTouchNavigationEvents = function(h) {
          var g, x, E, m, v = u.vec3.create();
          h.canvas.addEventListener("touchstart", function(y) {
            return function(A) {
              A.cancelable && A.preventDefault(), A.touches.length >= 1 && (g = A.touches[0].clientX, x = A.touches[0].clientY), A.touches.length >= 2 && (E = A.touches[1].clientX, m = A.touches[1].clientY);
              var b = h.getEventDataFromEvent(A.touches[0]);
              if (b == null || b.id == null || b.model == null) {
                var C = h.getMergedRegion();
                v = u.vec3.fromValues(C.centre[0], C.centre[1], C.centre[2]);
              } else if (b.xyz == null) {
                var T = h.getTargetBoundingBox(b.id, b.model);
                v = u.vec3.fromValues(T[0] + T[3] / 2, T[1] + T[4] / 2, T[2] + T[5] / 2);
              } else
                v = b.xyz;
            }(y);
          }, !0), h.canvas.addEventListener("touchmove", function(y) {
            return function(A) {
              if (A.cancelable && A.preventDefault(), h.navigationMode !== "none" && A.touches) {
                if (A.touches.length === 1) {
                  var b = A.touches[0].clientX - g, C = A.touches[0].clientY - x;
                  g = A.touches[0].clientX, x = A.touches[0].clientY, h.navigationMode === "locked-orbit" ? h.navigate("locked-orbit", b / 1.5, C / 1.5, h.lockedOrbitOrigin) : h.navigate("orbit", b / 1.5, C / 1.5, v);
                } else if (A.touches.length >= 2) {
                  var T = Math.sqrt((g - E) * (g - E) + (x - m) * (x - m)), w = [(g + E) / 2, (x + m) / 2];
                  g = A.touches[0].clientX, x = A.touches[0].clientY, E = A.touches[1].clientX, m = A.touches[1].clientY;
                  var R = Math.sqrt((g - E) * (g - E) + (x - m) * (x - m)), O = [(g + E) / 2, (x + m) / 2];
                  if (A.touches.length === 2) {
                    var D = T - R;
                    D > 10 ? h.navigate("zoom", -1.5, -1.5, v) : D < -10 && h.navigate("zoom", 1.5, 1.5, v);
                  }
                  var k = O[0] - w[0], W = O[1] - w[1];
                  h.navigate("pan", k, W, v);
                }
              }
            }(y);
          }, !0);
        }, f.initTouchTapEvents = function(h) {
          var g, x, E = !1, m = /* @__PURE__ */ new Date(), v = { id: null, model: null, xyz: null };
          h.canvas.addEventListener("touchstart", function(y) {
            return function(A) {
              if (A.touches.length === 1) {
                E = !0, g = A.touches[0].clientX, x = A.touches[0].clientY;
                var b = h.canvas.getBoundingClientRect(), C = g - b.left, T = h.height - (x - b.top);
                v = h.getEventData(C, T);
                var w = /* @__PURE__ */ new Date();
                w.getTime() - m.getTime() < 200 && h.fire("dblclick", { id: v.id, model: v.model, event: A, xyz: v.xyz }), m = w, h.fire("mousedown", { id: v.id, model: v.model, event: A, xyz: v.xyz }), h.disableTextSelection();
              }
            }(y);
          }, !0), h.canvas.addEventListener("touchend", function(y) {
            return function(A) {
              if (E) {
                E = !1;
                var b = A.changedTouches[0].clientX, C = A.changedTouches[0].clientY, T = Math.abs(b - g), w = Math.abs(C - x);
                T < 3 && w < 3 && h.fire("pick", { id: v.id, model: v.model, event: A, xyz: v.xyz }), h.enableTextSelection();
              }
            }(y);
          }, !0);
        }, f;
      }();
      l.TouchNavigation = d;
    }, 1675: (o, l) => {
      var c;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.PerformanceRating = void 0, (c = l.PerformanceRating || (l.PerformanceRating = {}))[c.VERY_LOW = 0] = "VERY_LOW", c[c.LOW = 1] = "LOW", c[c.MEDIUM = 2] = "MEDIUM", c[c.HIGH = 3] = "HIGH";
    }, 8198: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.fshader = void 0, l.fshader = `precision mediump float;

varying vec4 vColor;


void main(void) {
 gl_FragColor = vColor;
}`;
    }, 382: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.InteractiveClippingPlane = void 0;
      var u = c(887), d = c(8198), f = c(8515), h = c(6413), g = c(887), x = function() {
        function E() {
          this.ARROW = 1, this.HORIZONTAL = 2, this.VERTICAL = 3, this.PLANE = 4, this.arrowColour = [1, 0, 0, 1], this.horizontalColour = [0, 1, 0, 1], this.verticalColour = [0, 0, 1, 1], this.planeColour = [0.5, 0.5, 0.5, 0.3], this.currentInteraction = -1, this.initialized = !1, this.transformation = u.mat4.create(), this.mvMatrix = u.mat4.create(), this._hoverPickColour = [10, 150, 112, 255], this._stopped = !0;
        }
        return Object.defineProperty(E.prototype, "stopped", { get: function() {
          return this._stopped;
        }, set: function(m) {
          if (this._stopped = m, m === !1) {
            var v = this.viewer.getMergedRegion(), y = Math.sqrt(v.bbox[3] * v.bbox[3] + v.bbox[4] * v.bbox[4] + v.bbox[5] * v.bbox[5]);
            this.setActive();
            var A = Math.max(0.5 * this.viewer.unitsInMeter, 0.05 * y);
            this.bufferGeometry(A, y), this.updateTransformationFromPlane(), this.applyCurrentPlane();
          }
          this.viewer && this.viewer.draw();
        }, enumerable: !1, configurable: !0 }), E.prototype.init = function(m) {
          this.viewer = m;
          var v = m.gl;
          this.initShader(), v.useProgram(this.program), this.index_buffer = v.createBuffer(), this.vertex_buffer = v.createBuffer(), this.colours_buffer = v.createBuffer(), this.id_buffer = v.createBuffer(), this.coordinatesAttributePointer = v.getAttribLocation(this.program, "aVertex"), this.coloursAttributePointer = v.getAttribLocation(this.program, "aColour"), this.idsAttributePointer = v.getAttribLocation(this.program, "aId"), v.bindBuffer(v.ARRAY_BUFFER, this.vertex_buffer), v.vertexAttribPointer(this.coordinatesAttributePointer, 3, v.FLOAT, !1, 0, 0), v.bindBuffer(v.ARRAY_BUFFER, this.colours_buffer), v.vertexAttribPointer(this.coloursAttributePointer, 4, v.FLOAT, !1, 0, 0), v.bindBuffer(v.ARRAY_BUFFER, this.id_buffer), v.vertexAttribPointer(this.idsAttributePointer, 1, v.FLOAT, !1, 0, 0), v.bindBuffer(v.ELEMENT_ARRAY_BUFFER, this.index_buffer), v.bufferData(v.ELEMENT_ARRAY_BUFFER, this.indices, v.STATIC_DRAW), v.enableVertexAttribArray(this.coordinatesAttributePointer), v.enableVertexAttribArray(this.coloursAttributePointer), v.enableVertexAttribArray(this.idsAttributePointer), this.pUniformPointer = v.getUniformLocation(this.program, "uPMatrix"), this.mvUniformPointer = v.getUniformLocation(this.program, "uMvMatrix"), this.idCodingUniformPointer = v.getUniformLocation(this.program, "uColorCoding"), this.idSelectedIdUniformPointer = v.getUniformLocation(this.program, "uSelectedId"), this.hoverPickColourUniformPointer = v.getUniformLocation(this.program, "uHoverPickColour"), this.bufferGeometry(1, 1), this.initEvents(), this.initialized = !0, this.updateTransformationFromPlane(), this.applyCurrentPlane();
        }, E.prototype.onBeforeDraw = function(m, v) {
        }, E.prototype.onAfterDraw = function(m, v) {
          if (!this.stopped) {
            var y = this.setActive();
            y.blendFunc(y.SRC_ALPHA, y.ONE_MINUS_SRC_ALPHA), y.enable(y.BLEND), y.uniform1f(this.idCodingUniformPointer, 0), this.draw(y);
          }
        }, E.prototype.onBeforeDrawId = function() {
        }, E.prototype.onAfterDrawId = function() {
          if (!this.stopped) {
            var m = this.setActive();
            m.uniform1f(this.idCodingUniformPointer, 1), this.draw(m);
          }
        }, E.prototype.onAfterDrawModelId = function() {
          if (!this.stopped) {
            var m = this.setActive();
            m.uniform1f(this.idCodingUniformPointer, -1), this.draw(m);
          }
        }, E.prototype.draw = function(m) {
          this.stopped || this.initialized && (u.mat4.multiply(this.mvMatrix, this.viewer.mvMatrix, this.transformation), m.uniformMatrix4fv(this.pUniformPointer, !1, this.viewer.pMatrix), m.uniformMatrix4fv(this.mvUniformPointer, !1, this.mvMatrix), m.uniform4fv(this.hoverPickColourUniformPointer, new Float32Array([this._hoverPickColour[0] / 255, this._hoverPickColour[1] / 255, this._hoverPickColour[2] / 255, this._hoverPickColour[3] / 255])), this.viewer.gl.uniform1f(this.idSelectedIdUniformPointer, this.currentInteraction), m.bindBuffer(m.ARRAY_BUFFER, this.vertex_buffer), m.vertexAttribPointer(this.coordinatesAttributePointer, 3, m.FLOAT, !1, 0, 0), m.bindBuffer(m.ARRAY_BUFFER, this.id_buffer), m.vertexAttribPointer(this.idsAttributePointer, 1, m.FLOAT, !1, 0, 0), m.bindBuffer(m.ARRAY_BUFFER, this.colours_buffer), m.vertexAttribPointer(this.coloursAttributePointer, 4, m.FLOAT, !1, 0, 0), m.disable(m.CULL_FACE), m.enable(m.DEPTH_TEST), m.bindBuffer(m.ELEMENT_ARRAY_BUFFER, this.index_buffer), m.drawElements(m.TRIANGLES, this.indices.length, m.UNSIGNED_SHORT, 0));
        }, E.prototype.bufferGeometry = function(m, v) {
          var y = this, A = this.computePlaneVertices(v), b = this.computeArrowVertices(m / 3, m, m / 1e3), C = this.computeArrowVertices(m / 3, m, m / -1e3), T = this.computeArrowIndices(), w = this.computePlaneIndices(), R = this.computeRingVertices(0.9 * m, 0.5 * m, 50, function(Q, Y) {
            return [Q, Y, 0];
          }), O = this.computeRingVertices(0.9 * m, 0.5 * m, 50, function(Q, Y) {
            return [Q, 0, Y];
          }), D = this.computeRingIndices(50), k = [];
          k.push.apply(k, b), k.push.apply(k, C), k.push.apply(k, R), k.push.apply(k, O), k.push.apply(k, A), this.vertices = new Float32Array(k);
          var W = [];
          W.push.apply(W, T), W.push.apply(W, T.map(function(Q) {
            return Q + b.length / 3;
          })), W.push.apply(W, D.map(function(Q) {
            return Q + b.length / 3 * 2;
          })), W.push.apply(W, D.map(function(Q) {
            return Q + b.length / 3 * 2 + R.length / 3 - 2;
          })), W.push.apply(W, w.map(function(Q) {
            return Q + b.length / 3 * 2 + R.length / 3 * 2;
          })), this.indices = new Uint16Array(W);
          var L = [];
          L.push.apply(L, b.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).map(function() {
            return y.ARROW;
          })), L.push.apply(L, b.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).map(function() {
            return y.ARROW;
          })), L.push.apply(L, R.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).map(function() {
            return y.HORIZONTAL;
          })), L.push.apply(L, O.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).map(function() {
            return y.VERTICAL;
          })), L.push.apply(L, A.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).map(function() {
            return y.PLANE;
          })), this.ids = new Float32Array(L);
          var z = [];
          z.push.apply(z, b.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).flatMap(function() {
            return y.arrowColour;
          })), z.push.apply(z, b.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).flatMap(function() {
            return y.arrowColour;
          })), z.push.apply(z, R.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).flatMap(function() {
            return y.horizontalColour;
          })), z.push.apply(z, O.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).flatMap(function() {
            return y.verticalColour;
          })), z.push.apply(z, A.filter(function(Q, Y) {
            return Y % 3 == 0;
          }).flatMap(function() {
            return y.planeColour;
          })), this.colours = new Float32Array(z);
          var P = this.viewer.gl;
          P.bindBuffer(P.ARRAY_BUFFER, this.vertex_buffer), P.bufferData(P.ARRAY_BUFFER, this.vertices, P.STATIC_DRAW), P.bindBuffer(P.ARRAY_BUFFER, this.colours_buffer), P.bufferData(P.ARRAY_BUFFER, this.colours, P.STATIC_DRAW), P.bindBuffer(P.ARRAY_BUFFER, this.id_buffer), P.bufferData(P.ARRAY_BUFFER, this.ids, P.STATIC_DRAW), P.bindBuffer(P.ELEMENT_ARRAY_BUFFER, this.index_buffer), P.bufferData(P.ELEMENT_ARRAY_BUFFER, this.indices, P.STATIC_DRAW);
        }, E.prototype.initEvents = function() {
          var m, v, y, A = this, b = null, C = null;
          this.viewer.canvas.addEventListener("pointerdown", function(T) {
            if (!(A.stopped || A.viewer.plugins.indexOf(A) < 0)) {
              var w = A.viewer.getEventDataFromEvent(T, !0);
              w.model === 1000010 && w.id != A.PLANE && (A.currentInteraction = w.id, b = T.clientX, C = T.clientY, m = A.viewer.navigationMode, v = w.xyz, A.viewer.navigationMode = "none", y = u.vec3.transformMat4(u.vec3.create(), v, u.mat4.invert(u.mat4.create(), A.transformation)));
            }
          }), window.addEventListener("pointerup", function(T) {
            A.currentInteraction !== -1 && (A.snapToMainAxes(), A.applyCurrentPlane(), A.currentInteraction = -1, A.viewer.navigationMode = m);
          }), window.addEventListener("pointermove", function(T) {
            if (A.currentInteraction !== -1) {
              var w = T.clientX, R = T.clientY, O = w - b, D = R - C;
              b = w, C = R;
              var k = A.viewer.getCameraPosition(), W = u.vec3.distance(k, v);
              switch (A.currentInteraction) {
                case A.ARROW:
                  var L = 0;
                  if (A.viewer.camera === h.CameraType.ORTHOGONAL)
                    L = A.viewer.cameraProperties.height / A.viewer.height;
                  else {
                    var z = A.viewer.cameraProperties.fov * Math.PI / 180;
                    L = 2 * W * Math.tan(z / 2) / A.viewer.height;
                  }
                  var P = A.getDragOffset(L, O, D);
                  u.mat4.translate(A.transformation, A.transformation, P);
                  break;
                case A.HORIZONTAL:
                  var Q = A.getRotatingAngle(O, D, y);
                  u.mat4.rotateZ(A.transformation, A.transformation, Q);
                  break;
                case A.VERTICAL:
                  Q = A.getRotatingAngle(O, D, y, !0), u.mat4.rotateY(A.transformation, A.transformation, Q);
              }
              A.applyCurrentPlane();
            }
          });
        }, E.prototype.getRotatingAngle = function(m, v, y, A) {
          A === void 0 && (A = !1);
          var b = u.mat4.getRotation(g.quat.create(), this.mvMatrix), C = u.vec3.transformQuat(u.vec3.create(), y, b), T = this.viewer.getCameraPosition(), w = A ? this.getTangentPlaneEquation() : this.getPrependicularPlaneEquation(), R = w[0] * T[0] + w[1] * T[1] + w[2] * T[2] + w[3], O = u.vec3.fromValues(m, -v, 0), D = u.vec3.add(u.vec3.create(), C, O), k = u.vec3.angle(C, D), W = this.viewer.getMergedRegion(), L = Math.sqrt(W.bbox[3] * W.bbox[3] + W.bbox[4] * W.bbox[4] + W.bbox[5] * W.bbox[5]), z = u.vec3.cross(u.vec3.create(), D, C);
          u.vec3.normalize(z, z);
          var P = Math.cbrt(L * this.viewer.unitsInMeter * Math.sqrt(m * m + v * v)) / 100;
          return (A ? -1 : 1) * (R > 0 ? -1 : 1) * z[2] * P * k;
        }, E.prototype.getDragOffset = function(m, v, y) {
          var A = u.vec3.fromValues(1, 0, 0), b = u.mat4.getRotation(g.quat.create(), this.mvMatrix), C = u.vec3.transformQuat(u.vec3.create(), A, b);
          u.vec3.normalize(C, C);
          var T = v * C[0] - y * C[1];
          return u.vec3.scale(A, A, T * m), A;
        }, E.prototype.updateTransformationFromPlane = function() {
          var m;
          if (this.viewer != null && !this.stopped && this.viewer.plugins.indexOf(this) !== -1 && this.viewer.activeHandles.length !== 0) {
            var v = (m = this.viewer.getClip()) === null || m === void 0 ? void 0 : m.PlaneA;
            if (v != null) {
              var y = u.vec3.normalize(u.vec3.create(), u.vec3.fromValues(v[0], v[1], v[2])), A = this.getTangent(y), b = u.vec3.cross(u.vec3.create(), y, A);
              u.vec3.normalize(b, b);
              var C = this.getPlanePoint(v), T = u.mat4.fromValues(y[0], y[1], y[2], 0, A[0], A[1], A[2], 0, b[0], b[1], b[2], 0, C[0], C[1], C[2], 1);
              this.transformation && this.isTransformationsHasSameOrientation(this.transformation, T, v) || (this.transformation = T);
            } else {
              var w = this.viewer.getMergedRegion();
              this.transformation = u.mat4.translate(u.mat4.create(), u.mat4.create(), w.centre);
            }
          }
        }, E.prototype.isTransformationsHasSameOrientation = function(m, v, y) {
          var A = 1e-3;
          if (Math.abs(m[0] - v[0]) < A && Math.abs(m[1] - v[1]) < A && Math.abs(m[2] - v[2]) < A && Math.abs(m[3] - v[3]) < A)
            return Math.abs(y[0] * v[12] + y[1] * v[13] + y[2] * v[14] + y[3]) < A;
        }, E.prototype.getPlanePoint = function(m) {
          var v, y, A = (y = (v = this.viewer.getMergedRegion()) === null || v === void 0 ? void 0 : v.centre) !== null && y !== void 0 ? y : u.vec3.create(), b = this.viewer.getCurrentWcs(), C = this.transformPlane(m, b), T = u.vec3.fromValues(C[0], C[1], C[2]), w = null;
          if (T[2] != 0) {
            var R = T[0] * A[0] + T[1] * A[1] + C[3];
            w = u.vec3.fromValues(A[0], A[1], R / T[2] * -1);
          } else
            T[1] != 0 ? (R = T[0] * A[0] + T[2] * A[2] + C[3], w = u.vec3.fromValues(A[0], R / T[1] * -1, A[2])) : T[0] != 0 && (R = T[1] * A[1] + T[2] * A[2] + C[3], w = u.vec3.fromValues(R / T[0] * -1, A[1], A[2]));
          return w;
        }, E.prototype.transformPlane = function(m, v) {
          var y = m[0], A = m[1], b = m[2], C = m[3], T = u.vec3.len(u.vec3.fromValues(y, A, b)), w = y * -C / T, R = A * -C / T, O = b * -C / T;
          return C = 0 - y * (w -= v[0]) - A * (R -= v[1]) - b * (O -= v[2]), new Float32Array([y, A, b, C]);
        }, E.prototype.getTangent = function(m) {
          var v = function(T, w, R) {
            return T > w && T < R;
          }, y = u.vec3.fromValues(1, 0, 0), A = u.vec3.fromValues(0, 1, 0), b = u.vec3.fromValues(0, 0, 1), C = null;
          return v(u.vec3.angle(m, b), 0, Math.PI) ? C = u.vec3.cross(u.vec3.create(), m, b) : v(u.vec3.angle(m, y), 0, Math.PI) ? C = u.vec3.cross(u.vec3.create(), m, y) : v(u.vec3.angle(m, A), 0, Math.PI) && (C = u.vec3.cross(u.vec3.create(), m, A)), u.vec3.normalize(C, C), C;
        }, E.prototype.applyCurrentPlane = function() {
          if (this.viewer != null && !this.stopped && this.viewer.plugins.indexOf(this) !== -1 && this.viewer.activeHandles.length !== 0) {
            var m = this.getPlaneEquation();
            this.viewer.setClippingPlaneA(m);
          }
        }, E.prototype.snapToMainAxes = function() {
          var m = u.mat4.getRotation(g.quat.create(), this.transformation), v = u.vec3.transformQuat(u.vec3.create(), u.vec3.fromValues(1, 0, 0), m), y = Math.PI / 180 * 5;
          if (u.vec3.angle(v, u.vec3.fromValues(0, 0, 1)) < y) {
            var A = u.mat4.getTranslation(u.vec3.create(), this.transformation), b = g.quat.rotateY(g.quat.create(), g.quat.create(), -Math.PI / 2);
            u.mat4.fromRotationTranslation(this.transformation, b, A);
          }
          u.vec3.angle(v, u.vec3.fromValues(0, 0, -1)) < y && (A = u.mat4.getTranslation(u.vec3.create(), this.transformation), b = g.quat.rotateY(g.quat.create(), g.quat.create(), Math.PI / 2), u.mat4.fromRotationTranslation(this.transformation, b, A));
        }, E.prototype.getPlaneEquation = function() {
          var m = this.viewer.getCurrentWcs(), v = u.vec3.transformMat4(u.vec3.create(), u.vec3.create(), this.transformation), y = this.getPlaneNormal(), A = u.vec3.len(y), b = -y[0] * (v[0] + m[0]) - y[1] * (v[1] + m[1]) - y[2] * (v[2] + m[2]);
          return [y[0], y[1], y[2], b / A];
        }, E.prototype.getPrependicularPlaneEquation = function() {
          var m = u.vec3.transformMat4(u.vec3.create(), u.vec3.create(), this.transformation), v = this.getPlaneBinormal(), y = 0 - v[0] * m[0] - v[1] * m[1] - v[2] * m[2];
          return [v[0], v[1], v[2], y];
        }, E.prototype.getTangentPlaneEquation = function() {
          var m = u.vec3.transformMat4(u.vec3.create(), u.vec3.create(), this.transformation), v = this.getPlaneTangent(), y = 0 - v[0] * m[0] - v[1] * m[1] - v[2] * m[2];
          return [v[0], v[1], v[2], y];
        }, E.prototype.getPlaneNormal = function() {
          var m = u.mat4.getRotation(g.quat.create(), this.transformation);
          return u.vec3.transformQuat(u.vec3.create(), u.vec3.fromValues(1, 0, 0), m);
        }, E.prototype.getPlaneBinormal = function() {
          var m = u.mat4.getRotation(g.quat.create(), this.transformation);
          return u.vec3.transformQuat(u.vec3.create(), u.vec3.fromValues(0, 0, 1), m);
        }, E.prototype.getPlaneTangent = function() {
          var m = u.mat4.getRotation(g.quat.create(), this.transformation);
          return u.vec3.transformQuat(u.vec3.create(), u.vec3.fromValues(0, -1, 0), m);
        }, E.prototype.initShader = function() {
          var m = this.viewer.gl, v = this.viewer, y = function(C, T) {
            if (m.shaderSource(C, T), m.compileShader(C), !m.getShaderParameter(C, m.COMPILE_STATUS)) {
              var w = m.getShaderInfoLog(C);
              return v.error(w), null;
            }
          }, A = m.createShader(m.FRAGMENT_SHADER);
          y(A, d.fshader);
          var b = m.createShader(m.VERTEX_SHADER);
          y(b, f.vshader), this.program = m.createProgram(), m.attachShader(this.program, b), m.attachShader(this.program, A), m.linkProgram(this.program), m.getProgramParameter(this.program, m.LINK_STATUS) || v.error("Could not initialise shaders for a navigation cube plugin");
        }, E.prototype.setActive = function() {
          var m = this.viewer.gl;
          return m.useProgram(this.program), m;
        }, E.prototype.computeArrowVertices = function(m, v, y) {
          var A = [0, y, -m / 2, v, y, -m / 2, v, y, m / 2, 0, y, m / 2, v, y, -m, v + m, y, 0, v, y, m], b = A.map(function(C, T) {
            return T % 3 == 0 ? -1 * C : C;
          });
          return A.concat(b);
        }, E.prototype.computeArrowIndices = function() {
          return [0, 1, 2, 0, 2, 3, 4, 5, 6, 9, 8, 7, 9, 7, 10, 13, 12, 11];
        }, E.prototype.computeRingVertices = function(m, v, y, A) {
          for (var b = [], C = 0; C <= y; C++) {
            var T = 2 * Math.PI / y * C, w = Math.cos(T) * v, R = Math.sin(T) * v, O = Math.cos(T) * m, D = Math.sin(T) * m, k = A(w, R), W = A(O, D);
            b.push.apply(b, k), b.push.apply(b, W);
          }
          return b;
        }, E.prototype.computeRingIndices = function(m) {
          for (var v = [], y = 0; y <= m; y++) {
            var A = 2 * y;
            v.push(0 + A, 1 + A, 2 + A, 1 + A, 3 + A, 2 + A);
          }
          return v;
        }, E.prototype.computePlaneVertices = function(m) {
          return [0, -m / 2, -m / 2, 0, m / 2, -m / 2, 0, m / 2, m / 2, 0, -m / 2, m / 2];
        }, E.prototype.computePlaneIndices = function() {
          return [0, 1, 2, 0, 2, 3];
        }, E;
      }();
      l.InteractiveClippingPlane = x;
    }, 8515: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.vshader = void 0, l.vshader = `attribute highp vec3 aVertex;
attribute highp vec4 aColour;
attribute highp float aId;


uniform mat4 uMvMatrix;
uniform mat4 uPMatrix;


uniform mediump float uColorCoding; 
uniform mediump float uSelectedId;


uniform vec4 uHoverPickColour;


varying vec4 vColor;

vec4 getIdColor(float id){
 float product = floor(id + 0.5);
 float B = floor(product / (256.0*256.0));
 float G = floor((product - B * 256.0*256.0) / 256.0);
 float R = mod(product, 256.0);
 return vec4(R / 255.0, G / 255.0, B / 255.0, 1.0);
}

vec4 getTransparentColor(vec4 color, float transparency){
 mat4 aMat4 = mat4(1.0, 0.0, 0.0, 0.0,
 0.0, 1.0, 0.0, 0.0,
 0.0, 0.0, 1.0, 0.0,
 0.0, 0.0, 0.0, transparency);
 return aMat4 * color;
}


void main(void) {

 bool ignoreVec = false;
 if (uColorCoding > 0.5 && uColorCoding <= 1.0)
 {
 vColor = getIdColor(aId);
 }
 else if (uColorCoding < -0.5)
 {
 vColor = getIdColor(1000010.0);
 }
 else
 { 
 if(uSelectedId == aId)
 { 
 vColor = uHoverPickColour; 
 }
 else
 {
 if(uSelectedId > 0.0) 
 {
 if(aId != 4.0){ 
 ignoreVec = true;
 }
 else
 vColor = getTransparentColor(aColour, 1.5);
 }
 else 
 vColor = aColour;
 }
 }

 if(!ignoreVec)
 {
 gl_Position = uPMatrix * uMvMatrix * vec4(aVertex, 1.0);
 }

}`;
    }, 5637: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Grid = void 0;
      var u = c(5585), d = function() {
        function f() {
          this.initialized = !1, this.factor = 1.5, this.zFactor = 5, this.numberOfLines = 10, this.colour = [0, 0, 0, 0.6], this._stopped = !1;
        }
        return Object.defineProperty(f.prototype, "stopped", { get: function() {
          return this._stopped;
        }, set: function(h) {
          this._stopped = h, this.viewer && this.viewer.draw();
        }, enumerable: !1, configurable: !0 }), f.prototype.init = function(h) {
          this.viewer = h;
          var g = h.gl;
          this._initShader(), g.useProgram(this.program), this.vertex_buffer = g.createBuffer(), g.bindBuffer(g.ARRAY_BUFFER, this.vertex_buffer), this.coordinatesAttributePointer = g.getAttribLocation(this.program, "coordinates"), g.vertexAttribPointer(this.coordinatesAttributePointer, 3, g.FLOAT, !1, 0, 0), g.enableVertexAttribArray(this.coordinatesAttributePointer), this.colourUniformPointer = g.getUniformLocation(this.program, "uColour"), this.pUniformPointer = g.getUniformLocation(this.program, "uPMatrix"), this.mvUniformPointer = g.getUniformLocation(this.program, "uMvMatrix"), this.initialized = !0;
        }, f.prototype._initShader = function() {
          var h = this.viewer.gl, g = this.viewer, x = function(v, y) {
            if (h.shaderSource(v, y), h.compileShader(v), !h.getShaderParameter(v, h.COMPILE_STATUS)) {
              var A = h.getShaderInfoLog(v);
              return g.error(A), null;
            }
          }, E = h.createShader(h.FRAGMENT_SHADER);
          x(E, "precision mediump float; uniform vec4 uColour;void main(void) {gl_FragColor = uColour;}");
          var m = h.createShader(h.VERTEX_SHADER);
          x(m, u.vshader), this.program = h.createProgram(), h.attachShader(this.program, m), h.attachShader(this.program, E), h.linkProgram(this.program), h.getProgramParameter(this.program, h.LINK_STATUS) || g.error("Could not initialise shaders for a navigation cube plugin");
        }, f.prototype.onAfterDraw = function(h, g) {
          if (this.initialized && !this.stopped) {
            var x = this.viewer.getMergedRegion();
            if (x && !(x.population < 1)) {
              var E = Math.max(x.bbox[3], x.bbox[4]) * this.factor;
              if (!(E < 0.1)) {
                for (var m = E / (this.numberOfLines + 1), v = x.bbox[0] + x.bbox[3] / 2 - E / 2, y = x.bbox[1] + x.bbox[4] / 2 - E / 2, A = x.bbox[2] - x.bbox[5] / this.zFactor, b = [], C = 1; C < this.numberOfLines + 1; C++)
                  b.push(v), b.push(y + C * m), b.push(A), b.push(v + E), b.push(y + C * m), b.push(A);
                for (C = 1; C < this.numberOfLines + 1; C++)
                  b.push(v + C * m), b.push(y), b.push(A), b.push(v + C * m), b.push(y + E), b.push(A);
                var T = this.viewer.gl;
                T.useProgram(this.program), T.uniformMatrix4fv(this.pUniformPointer, !1, this.viewer.pMatrix), T.uniformMatrix4fv(this.mvUniformPointer, !1, this.viewer.mvMatrix), T.uniform4fv(this.colourUniformPointer, this.colour), T.bindBuffer(T.ARRAY_BUFFER, this.vertex_buffer), T.bufferData(T.ARRAY_BUFFER, new Float32Array(b), T.STATIC_DRAW), T.bindBuffer(T.ARRAY_BUFFER, this.vertex_buffer), T.vertexAttribPointer(this.coordinatesAttributePointer, 3, T.FLOAT, !1, 0, 0), T.enable(T.BLEND), T.enable(T.DEPTH_TEST), T.blendFunc(T.ONE_MINUS_DST_ALPHA, T.ONE_MINUS_SRC_ALPHA), T.drawArrays(T.LINES, 0, b.length / 3);
              }
            }
          }
        }, f.prototype.onBeforeDraw = function(h, g) {
        }, f.prototype.onBeforeDrawId = function() {
        }, f.prototype.onAfterDrawId = function() {
        }, f.prototype.onAfterDrawModelId = function() {
        }, f;
      }();
      l.Grid = d;
    }, 5585: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.vshader = void 0, l.vshader = `attribute vec3 coordinates;


uniform mat4 uMvMatrix;
uniform mat4 uPMatrix;

void main(void) {
 gl_Position = uPMatrix * uMvMatrix * vec4(coordinates, 1.0);
}`;
    }, 1906: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.LoaderOverlay = void 0;
      var c = function() {
        function u() {
          var d = document.createElement("style");
          d.innerText = `
        .xbim-viewer-loader {
            border: 32px solid #eee; /* Light grey */
            border-top: 32px solid #aaa; /* Dark gray */
            border-radius: 50%;
            width: 120px;
            height: 120px;
            animation: xbim-viewer-loader-spin 2s linear infinite;
          }
          
          @keyframes xbim-viewer-loader-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }`, document.body.appendChild(d);
        }
        return u.prototype.init = function(d) {
          this.viewer = d;
        }, u.prototype.onBeforeDraw = function(d, f) {
        }, u.prototype.onAfterDraw = function(d, f) {
        }, u.prototype.onBeforeDrawId = function() {
        }, u.prototype.onAfterDrawId = function() {
        }, u.prototype.onAfterDrawModelId = function() {
        }, u.prototype.show = function(d) {
          if (!this.overlay) {
            var f = document.createElement("div");
            f.style.width = "100%", f.style.height = "100%", f.style.zIndex = "1000", f.style.overflow = "hidden", f.style.position = "absolute", f.style.top = "0", f.style.left = "0";
            var h = document.createElement("div");
            if (h.style.height = "100%", h.style.width = "100%", h.style.backgroundColor = "rgb(200,200,200)", h.style.opacity = "0.5", f.appendChild(h), d != null) {
              var g = document.createElement("div");
              g.style.position = "absolute", g.style.top = "0", g.style.left = "0", g.style.height = "100%", g.style.width = "100%", g.style.display = "flex", g.style.alignItems = "center", g.style.justifyContent = "center", f.appendChild(g), d.style.height = "100%", d.style.filter = "blur(15px)", g.appendChild(d);
            }
            var x = document.createElement("div");
            x.style.position = "absolute", x.style.top = "0", x.style.left = "0", x.style.height = "100%", x.style.width = "100%", x.style.display = "flex", x.style.alignItems = "center", x.style.justifyContent = "center";
            var E = document.createElement("div");
            E.className = "xbim-viewer-loader", x.appendChild(E), f.appendChild(x), this.overlay = f;
            var m = this.viewer.canvas.parentElement;
            m.style.position !== "relative" && m.style.position !== "absolute" && (m.style.position = "relative");
            var v = this.viewer.canvas.nextElementSibling;
            v != null ? m.insertBefore(f, v) : m.appendChild(f);
          }
        }, u.prototype.hide = function() {
          this.overlay != null && (this.overlay.parentElement != null && this.overlay.parentElement.removeChild(this.overlay), this.overlay = null);
        }, u;
      }();
      l.LoaderOverlay = c;
    }, 9706: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.cube_fshader = void 0, l.cube_fshader = `precision mediump float;

uniform float uAlpha;
uniform sampler2D uTexture;
uniform mediump float uColorCoding;
uniform float uHighlighting;

varying vec2 vTexCoord;
varying vec4 vIdColor;


void main(void) {
 if (uColorCoding > 0.0)
 {
 gl_FragColor = vIdColor;
 }
 else
 {
 vec4 pixel = texture2D(uTexture, vTexCoord);
 if (vIdColor.x < 0.0)
 {
 
 gl_FragColor = vec4(pixel.rgb * uHighlighting, uAlpha);
 }
 else
 {
 
 gl_FragColor = vec4(pixel.rgb, uAlpha);
 }
 }
}`;
    }, 1524: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.cube_vshader = void 0, l.cube_vshader = `attribute highp vec3 aVertex;
attribute highp vec2 aTexCoord;
attribute highp float aId;


uniform mat3 uRotation;
uniform mat4 uPMatrix;



uniform mediump float uColorCoding; 
uniform float uSelection;


varying vec2 vTexCoord;
varying vec4 vIdColor;

vec4 getIdColor(float id){
 float product = floor(id + 0.5);
 float B = floor(product / (256.0*256.0));
 float G = floor((product - B * 256.0*256.0) / 256.0);
 float R = mod(product, 256.0);
 return vec4(R / 255.0, G / 255.0, B / 255.0, 1.0);
}

void main(void) {
 vec4 point = vec4(uRotation * aVertex, 1.0);
 gl_Position = uPMatrix * point;
 vTexCoord = aTexCoord;

 if (uColorCoding == 1.0)
 {
 vIdColor = getIdColor(aId);
 return;
 }

 if (uColorCoding > 1.0)
 {
 vIdColor = getIdColor(float(uColorCoding));
 return;
 }
 
 bool isSelected = abs(uSelection - aId) < 0.1;
 if (isSelected){
 vIdColor = vec4(-1.0, -1.0, -1.0, -1.0);
 }
 else{
 vIdColor = vec4(1.0, 1.0, 1.0, 1.0);
 }
}`;
    }, 5715: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.CubeTextures = void 0, l.CubeTextures = { en: "data:image/png;base64,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" };
    }, 5819: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.NavigationCube = void 0;
      var u = c(9706), d = c(1524), f = c(5715), h = c(887), g = c(9499), x = function() {
        function E(m) {
          this.TOP = 1, this.BOTTOM = 2, this.LEFT = 3, this.RIGHT = 4, this.FRONT = 5, this.BACK = 6, this.TOP_LEFT_FRONT = 7, this.TOP_RIGHT_FRONT = 8, this.TOP_LEFT_BACK = 9, this.TOP_RIGHT_BACK = 10, this.BOTTOM_LEFT_FRONT = 11, this.BOTTOM_RIGHT_FRONT = 12, this.BOTTOM_LEFT_BACK = 13, this.BOTTOM_RIGHT_BACK = 14, this.TOP_LEFT = 15, this.TOP_RIGHT = 16, this.TOP_FRONT = 17, this.TOP_BACK = 18, this.BOTTOM_LEFT = 19, this.BOTTOM_RIGHT = 20, this.BOTTOM_FRONT = 21, this.BOTTOM_BACK = 22, this.FRONT_RIGHT = 23, this.FRONT_LEFT = 24, this.BACK_RIGHT = 25, this.BACK_LEFT = 26, this._initialized = !1, this._modelId = 1000001, this.ratio = 0.15, this.minSize = 50, this.maxSize = 200, this.highlighting = 1.2, this.activeAlpha = 1, this.passiveAlpha = 0.7, this.position = this.BOTTOM_RIGHT, this.trueNorth = 0, this._stopped = !1, this.vertices = new Float32Array([-0.3, -0.5, -0.3, 0.3, -0.5, -0.3, 0.3, -0.5, 0.3, -0.3, -0.5, 0.3, -0.3, 0.5, -0.3, -0.3, 0.5, 0.3, 0.3, 0.5, 0.3, 0.3, 0.5, -0.3, -0.3, -0.3, 0.5, 0.3, -0.3, 0.5, 0.3, 0.3, 0.5, -0.3, 0.3, 0.5, -0.3, -0.3, -0.5, -0.3, 0.3, -0.5, 0.3, 0.3, -0.5, 0.3, -0.3, -0.5, 0.5, -0.3, -0.3, 0.5, 0.3, -0.3, 0.5, 0.3, 0.3, 0.5, -0.3, 0.3, -0.5, -0.3, -0.3, -0.5, -0.3, 0.3, -0.5, 0.3, 0.3, -0.5, 0.3, -0.3, -0.5, -0.5, 0.5, -0.3, -0.5, 0.5, -0.3, -0.3, 0.5, -0.5, -0.3, 0.5, -0.5, -0.5, 0.3, -0.5, -0.5, 0.5, -0.5, -0.3, 0.5, -0.5, -0.3, 0.3, -0.5, -0.5, 0.3, -0.3, -0.5, 0.3, -0.3, -0.5, 0.5, -0.5, -0.5, 0.5, 0.3, -0.5, 0.5, 0.5, -0.5, 0.5, 0.5, -0.3, 0.5, 0.3, -0.3, 0.5, 0.5, -0.5, 0.3, 0.5, -0.3, 0.3, 0.5, -0.3, 0.5, 0.5, -0.5, 0.5, 0.3, -0.5, 0.3, 0.5, -0.5, 0.3, 0.5, -0.5, 0.5, 0.3, -0.5, 0.5, -0.5, 0.3, 0.5, -0.3, 0.3, 0.5, -0.3, 0.5, 0.5, -0.5, 0.5, 0.5, -0.5, 0.3, 0.3, -0.5, 0.3, 0.5, -0.5, 0.5, 0.5, -0.5, 0.5, 0.3, -0.5, 0.5, 0.3, -0.5, 0.5, 0.5, -0.3, 0.5, 0.5, -0.3, 0.5, 0.3, 0.3, 0.3, 0.5, 0.5, 0.3, 0.5, 0.5, 0.5, 0.5, 0.3, 0.5, 0.5, 0.5, 0.3, 0.3, 0.5, 0.5, 0.3, 0.5, 0.5, 0.5, 0.5, 0.3, 0.5, 0.3, 0.5, 0.3, 0.3, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.3, -0.5, -0.5, -0.5, -0.3, -0.5, -0.5, -0.3, -0.3, -0.5, -0.5, -0.3, -0.5, -0.5, -0.5, -0.5, -0.5, -0.5, -0.3, -0.5, -0.3, -0.3, -0.5, -0.3, -0.5, -0.5, -0.5, -0.5, -0.3, -0.5, -0.5, -0.3, -0.5, -0.3, -0.5, -0.5, -0.3, 0.3, -0.5, -0.5, 0.5, -0.5, -0.5, 0.5, -0.3, -0.5, 0.3, -0.3, -0.5, 0.5, -0.5, -0.5, 0.5, -0.3, -0.5, 0.5, -0.3, -0.3, 0.5, -0.5, -0.3, 0.3, -0.5, -0.5, 0.5, -0.5, -0.5, 0.5, -0.5, -0.3, 0.3, -0.5, -0.3, -0.5, 0.3, -0.5, -0.3, 0.3, -0.5, -0.3, 0.5, -0.5, -0.5, 0.5, -0.5, -0.5, 0.3, -0.5, -0.5, 0.3, -0.3, -0.5, 0.5, -0.3, -0.5, 0.5, -0.5, -0.5, 0.5, -0.5, -0.5, 0.5, -0.3, -0.3, 0.5, -0.3, -0.3, 0.5, -0.5, 0.3, 0.3, -0.5, 0.5, 0.3, -0.5, 0.5, 0.5, -0.5, 0.3, 0.5, -0.5, 0.5, 0.3, -0.5, 0.5, 0.5, -0.5, 0.5, 0.5, -0.3, 0.5, 0.3, -0.3, 0.3, 0.5, -0.5, 0.3, 0.5, -0.3, 0.5, 0.5, -0.3, 0.5, 0.5, -0.5, 0.3, -0.3, 0.5, 0.5, -0.3, 0.5, 0.5, 0.3, 0.5, 0.3, 0.3, 0.5, 0.5, -0.3, 0.3, 0.5, 0.3, 0.3, 0.5, 0.3, 0.5, 0.5, -0.3, 0.5, -0.5, -0.3, 0.5, -0.3, -0.3, 0.5, -0.3, 0.3, 0.5, -0.5, 0.3, 0.5, -0.5, -0.3, 0.3, -0.5, -0.3, 0.5, -0.5, 0.3, 0.5, -0.5, 0.3, 0.3, -0.3, -0.5, 0.5, 0.3, -0.5, 0.5, 0.3, -0.3, 0.5, -0.3, -0.3, 0.5, -0.3, -0.5, 0.3, 0.3, -0.5, 0.3, 0.3, -0.5, 0.5, -0.3, -0.5, 0.5, -0.3, 0.3, 0.5, 0.3, 0.3, 0.5, 0.3, 0.5, 0.5, -0.3, 0.5, 0.5, -0.3, 0.5, 0.3, -0.3, 0.5, 0.5, 0.3, 0.5, 0.5, 0.3, 0.5, 0.3, 0.3, -0.3, -0.5, 0.5, -0.3, -0.5, 0.5, 0.3, -0.5, 0.3, 0.3, -0.5, 0.5, -0.3, -0.5, 0.5, 0.3, -0.5, 0.5, 0.3, -0.3, 0.5, -0.3, -0.3, -0.5, -0.3, -0.5, -0.5, 0.3, -0.5, -0.3, 0.3, -0.5, -0.3, -0.3, -0.5, -0.5, -0.3, -0.5, -0.5, -0.3, -0.3, -0.5, 0.3, -0.3, -0.5, 0.3, -0.5, -0.3, -0.5, -0.5, 0.3, -0.5, -0.5, 0.3, -0.3, -0.5, -0.3, -0.3, -0.5, -0.3, -0.5, -0.5, 0.3, -0.5, -0.5, 0.3, -0.5, -0.3, -0.3, -0.5, -0.3, -0.3, 0.3, -0.5, 0.3, 0.3, -0.5, 0.3, 0.5, -0.5, -0.3, 0.5, -0.5, -0.3, 0.5, -0.5, -0.3, 0.5, -0.3, 0.3, 0.5, -0.3, 0.3, 0.5, -0.5, 0.3, -0.5, -0.3, 0.5, -0.5, -0.3, 0.5, -0.5, 0.3, 0.3, -0.5, 0.3, 0.5, -0.5, -0.3, 0.5, -0.3, -0.3, 0.5, -0.3, 0.3, 0.5, -0.5, 0.3, -0.5, -0.5, -0.3, -0.3, -0.5, -0.3, -0.3, -0.5, 0.3, -0.5, -0.5, 0.3, -0.5, -0.5, -0.3, -0.5, -0.5, 0.3, -0.5, -0.3, 0.3, -0.5, -0.3, -0.3, 0.3, 0.5, -0.3, 0.3, 0.5, 0.3, 0.5, 0.5, 0.3, 0.5, 0.5, -0.3, 0.5, 0.3, -0.3, 0.5, 0.5, -0.3, 0.5, 0.5, 0.3, 0.5, 0.3, 0.3, -0.5, 0.5, -0.3, -0.5, 0.5, 0.3, -0.3, 0.5, 0.3, -0.3, 0.5, -0.3, -0.5, 0.3, -0.3, -0.5, 0.3, 0.3, -0.5, 0.5, 0.3, -0.5, 0.5, -0.3]), this.indices = new Uint16Array([0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23, 24, 25, 26, 24, 26, 27, 28, 29, 30, 28, 30, 31, 32, 33, 34, 32, 34, 35, 36, 37, 38, 36, 38, 39, 40, 41, 42, 40, 42, 43, 44, 45, 46, 44, 46, 47, 48, 49, 50, 48, 50, 51, 52, 53, 54, 52, 54, 55, 56, 57, 58, 56, 58, 59, 60, 61, 62, 60, 62, 63, 64, 65, 66, 64, 66, 67, 68, 69, 70, 68, 70, 71, 72, 74, 73, 72, 75, 74, 76, 77, 78, 76, 78, 79, 80, 81, 82, 80, 82, 83, 84, 86, 85, 84, 87, 86, 88, 89, 90, 88, 90, 91, 92, 93, 94, 92, 94, 95, 96, 98, 97, 96, 99, 98, 100, 101, 102, 100, 102, 103, 104, 105, 106, 104, 106, 107, 108, 110, 109, 108, 111, 110, 112, 113, 114, 112, 114, 115, 116, 117, 118, 116, 118, 119, 120, 121, 122, 120, 122, 123, 124, 125, 126, 124, 126, 127, 128, 129, 130, 128, 130, 131, 132, 133, 134, 132, 134, 135, 136, 137, 138, 136, 138, 139, 140, 141, 142, 140, 142, 143, 144, 145, 146, 144, 146, 147, 148, 149, 150, 148, 150, 151, 152, 154, 153, 152, 155, 154, 156, 157, 158, 156, 158, 159, 160, 161, 162, 160, 162, 163, 164, 165, 166, 164, 166, 167, 168, 170, 169, 168, 171, 170, 172, 173, 174, 172, 174, 175, 176, 178, 177, 176, 179, 178, 180, 181, 182, 180, 182, 183, 184, 185, 186, 184, 186, 187, 188, 189, 190, 188, 190, 191, 192, 193, 194, 192, 194, 195, 196, 197, 198, 196, 198, 199, 200, 201, 202, 200, 202, 203, 204, 205, 206, 204, 206, 207, 208, 209, 210, 208, 210, 211, 212, 213, 214, 212, 214, 215]), this.txtCoords = new Float32Array([1 / 3 + 1 / 15, 0 + 1 / 15, 0.6, 0 + 1 / 15, 0.6, 1 / 3 - 1 / 15, 1 / 3 + 1 / 15, 1 / 3 - 1 / 15, 1 - 1 / 15, 0 + 1 / 15, 1 - 1 / 15, 1 / 3 - 1 / 15, 2 / 3 + 1 / 15, 1 / 3 - 1 / 15, 2 / 3 + 1 / 15, 0 + 1 / 15, 2 / 3 + 1 / 15, 1 / 3 + 1 / 15, 1 - 1 / 15, 1 / 3 + 1 / 15, 1 - 1 / 15, 0.6, 2 / 3 + 1 / 15, 0.6, 0 + 1 / 15, 1 / 3 - 1 / 15, 0 + 1 / 15, 0 + 1 / 15, 1 / 3 - 1 / 15, 0 + 1 / 15, 1 / 3 - 1 / 15, 1 / 3 - 1 / 15, 0 + 1 / 15, 1 / 3 + 1 / 15, 1 / 3 - 1 / 15, 1 / 3 + 1 / 15, 1 / 3 - 1 / 15, 0.6, 0 + 1 / 15, 0.6, 0.6, 1 / 3 + 1 / 15, 0.6, 0.6, 1 / 3 + 1 / 15, 0.6, 1 / 3 + 1 / 15, 1 / 3 + 1 / 15, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 0.7, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 1 / 3 + 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 1 / 30, 1 / 3 + 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 0.7, 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 30, 1 / 3 + 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 2 / 3 + 2 / 30, 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30, 1 / 3 + 2 / 30, 1 / 3 + 1 / 30]), this.ids = new Float32Array([this.FRONT, this.FRONT, this.FRONT, this.FRONT, this.BACK, this.BACK, this.BACK, this.BACK, this.TOP, this.TOP, this.TOP, this.TOP, this.BOTTOM, this.BOTTOM, this.BOTTOM, this.BOTTOM, this.RIGHT, this.RIGHT, this.RIGHT, this.RIGHT, this.LEFT, this.LEFT, this.LEFT, this.LEFT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_LEFT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_RIGHT_FRONT, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_LEFT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.TOP_RIGHT_BACK, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_LEFT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_RIGHT_FRONT, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_LEFT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.BOTTOM_RIGHT_BACK, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_RIGHT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_LEFT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_FRONT, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.TOP_BACK, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_RIGHT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_LEFT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_FRONT, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.BOTTOM_BACK, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_RIGHT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.FRONT_LEFT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_RIGHT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT, this.BACK_LEFT]), this._image = m;
        }
        return Object.defineProperty(E.prototype, "stopped", { get: function() {
          return this._stopped;
        }, set: function(m) {
          this._stopped = m, this.viewer && this.viewer.draw();
        }, enumerable: !1, configurable: !0 }), E.prototype.init = function(m) {
          var v = this;
          this.viewer = m;
          var y = this.viewer.gl;
          this._shader = null, this._initShader(), this._alpha = this.passiveAlpha, this._selection = 0, y.useProgram(this._shader), this._pMatrixUniformPointer = y.getUniformLocation(this._shader, "uPMatrix"), this._rotationUniformPointer = y.getUniformLocation(this._shader, "uRotation"), this._colourCodingUniformPointer = y.getUniformLocation(this._shader, "uColorCoding"), this._alphaUniformPointer = y.getUniformLocation(this._shader, "uAlpha"), this._selectionUniformPointer = y.getUniformLocation(this._shader, "uSelection"), this._textureUniformPointer = y.getUniformLocation(this._shader, "uTexture"), this._highlightingUniformPointer = y.getUniformLocation(this._shader, "uHighlighting"), this._vertexAttrPointer = y.getAttribLocation(this._shader, "aVertex"), this._texCoordAttrPointer = y.getAttribLocation(this._shader, "aTexCoord"), this._idAttrPointer = y.getAttribLocation(this._shader, "aId"), y.enableVertexAttribArray(this._vertexAttrPointer), y.enableVertexAttribArray(this._texCoordAttrPointer), y.enableVertexAttribArray(this._idAttrPointer), this._indexBuffer = y.createBuffer(), this._vertexBuffer = y.createBuffer(), this._texCoordBuffer = y.createBuffer(), this._idBuffer = y.createBuffer(), y.bindBuffer(y.ELEMENT_ARRAY_BUFFER, this._indexBuffer), y.bufferData(y.ELEMENT_ARRAY_BUFFER, this.indices, y.STATIC_DRAW), y.bindBuffer(y.ARRAY_BUFFER, this._vertexBuffer), y.bufferData(y.ARRAY_BUFFER, this.vertices, y.STATIC_DRAW), y.bindBuffer(y.ARRAY_BUFFER, this._texCoordBuffer), y.bufferData(y.ARRAY_BUFFER, this.txtCoords, y.STATIC_DRAW), y.bindBuffer(y.ARRAY_BUFFER, this._idBuffer), y.bufferData(y.ARRAY_BUFFER, this.ids, y.STATIC_DRAW);
          var A = this;
          if (this._texture = y.createTexture(), this._image === void 0) {
            var b = f.CubeTextures.en, C = new Image();
            A._image = C, C.addEventListener("load", function() {
              y.bindTexture(y.TEXTURE_2D, A._texture), y.pixelStorei(y.UNPACK_FLIP_Y_WEBGL, 1), y.texImage2D(y.TEXTURE_2D, 0, y.RGBA, y.RGBA, y.UNSIGNED_BYTE, A._image), y.texParameteri(y.TEXTURE_2D, y.TEXTURE_MAG_FILTER, y.LINEAR), y.texParameteri(y.TEXTURE_2D, y.TEXTURE_MIN_FILTER, y.LINEAR_MIPMAP_NEAREST), y.generateMipmap(y.TEXTURE_2D);
            }), C.src = b;
          } else
            y.bindTexture(y.TEXTURE_2D, A._texture), y.pixelStorei(y.UNPACK_FLIP_Y_WEBGL, 1), y.texImage2D(y.TEXTURE_2D, 0, y.RGBA, y.RGBA, y.UNSIGNED_BYTE, A._image), y.texParameteri(y.TEXTURE_2D, y.TEXTURE_MAG_FILTER, y.LINEAR), y.texParameteri(y.TEXTURE_2D, y.TEXTURE_MIN_FILTER, y.LINEAR_MIPMAP_NEAREST), y.generateMipmap(y.TEXTURE_2D);
          m.canvas.addEventListener("mousemove", function(T) {
            if (!(v.stopped || m.plugins.indexOf(v) < 0)) {
              var w = T.clientX, R = T.clientY, O = m.canvas.getBoundingClientRect(), D = w - O.left, k = m.height - (R - O.top);
              if (A._region) {
                if (!A.isInRegion(D, k))
                  return A._alpha = A.passiveAlpha, void (A._selection = 0);
                var W = v.getId(T);
                W == null ? (A._alpha = A.passiveAlpha, A._selection = 0) : W >= A.TOP && W <= A.BACK_LEFT && (A._alpha = A.activeAlpha, A._selection = W), v.onAfterDraw(m.width, m.height);
              }
            }
          }, !0), A._drag = !1, m.canvas.addEventListener("mousedown", function(T) {
            if (!(v.stopped || m.plugins.indexOf(v) < 0)) {
              var w = T.clientX, R = T.clientY, O = m.canvas.getBoundingClientRect(), D = w - O.left, k = m.height - (R - O.top);
              if (v._region && A.isInRegion(D, k)) {
                var W = v.getId(T);
                W != null && W >= A.TOP && W <= A.BACK_LEFT && (A._drag = !0, A._originalNavigation = m.navigationMode, m.navigationMode = "orbit");
              }
            }
          }, !0), window.addEventListener("mouseup", function(T) {
            v.stopped || m.plugins.indexOf(v) < 0 || A._drag === !0 && (m.navigationMode = A._originalNavigation), A._drag = !1;
          }, !0), m.on("pick", function(T) {
            if (T.model == null) {
              var w = T.event;
              if (w instanceof MouseEvent || w instanceof TouchEvent) {
                var R = null;
                R = w instanceof MouseEvent ? w : w.changedTouches[0];
                var O = v.getId(R), D = h.vec3.create(), k = h.vec3.fromValues(0, 0, 1);
                switch (O) {
                  case v.TOP:
                    D = h.vec3.fromValues(0, 0, 1), k = h.vec3.fromValues(0, 1, 0);
                    break;
                  case v.BOTTOM:
                    D = h.vec3.fromValues(0, 0, -1), k = h.vec3.fromValues(0, -1, 0);
                    break;
                  case v.FRONT:
                    D = h.vec3.fromValues(0, -1, 0);
                    break;
                  case v.BACK:
                    D = h.vec3.fromValues(0, 1, 0);
                    break;
                  case v.LEFT:
                    D = h.vec3.fromValues(-1, 0, 0);
                    break;
                  case v.RIGHT:
                    D = h.vec3.fromValues(1, 0, 0);
                    break;
                  case v.TOP_LEFT_FRONT:
                    D = h.vec3.fromValues(-1, -1, 1);
                    break;
                  case v.TOP_RIGHT_FRONT:
                    D = h.vec3.fromValues(1, -1, 1);
                    break;
                  case v.TOP_LEFT_BACK:
                    D = h.vec3.fromValues(-1, 1, 1);
                    break;
                  case v.TOP_RIGHT_BACK:
                    D = h.vec3.fromValues(1, 1, 1);
                    break;
                  case v.BOTTOM_LEFT_FRONT:
                    D = h.vec3.fromValues(-1, -1, -1);
                    break;
                  case v.BOTTOM_RIGHT_FRONT:
                    D = h.vec3.fromValues(1, -1, -1);
                    break;
                  case v.BOTTOM_LEFT_BACK:
                    D = h.vec3.fromValues(-1, 1, -1);
                    break;
                  case v.BOTTOM_RIGHT_BACK:
                    D = h.vec3.fromValues(1, 1, -1);
                    break;
                  case v.TOP_LEFT:
                    D = h.vec3.fromValues(-1, 0, 1);
                    break;
                  case v.TOP_RIGHT:
                    D = h.vec3.fromValues(1, 0, 1);
                    break;
                  case v.TOP_FRONT:
                    D = h.vec3.fromValues(0, -1, 1);
                    break;
                  case v.TOP_BACK:
                    D = h.vec3.fromValues(0, 1, 1);
                    break;
                  case v.BOTTOM_LEFT:
                    D = h.vec3.fromValues(-1, 0, -1);
                    break;
                  case v.BOTTOM_RIGHT:
                    D = h.vec3.fromValues(1, 0, -1);
                    break;
                  case v.BOTTOM_FRONT:
                    D = h.vec3.fromValues(0, -1, -1);
                    break;
                  case v.BOTTOM_BACK:
                    D = h.vec3.fromValues(0, 1, -1);
                    break;
                  case v.FRONT_RIGHT:
                    D = h.vec3.fromValues(1, -1, 0);
                    break;
                  case v.FRONT_LEFT:
                    D = h.vec3.fromValues(-1, -1, 0);
                    break;
                  case v.BACK_RIGHT:
                    D = h.vec3.fromValues(1, 1, 0);
                    break;
                  case v.BACK_LEFT:
                    D = h.vec3.fromValues(-1, 1, 0);
                    break;
                  default:
                    return !1;
                }
                var W = m.getTargetBoundingBox(), L = h.vec3.fromValues(W[0] + W[3] / 2, W[1] + W[4] / 2, W[2] + W[5] / 2);
                if (D = h.vec3.normalize(h.vec3.create(), D), v.trueNorth !== 0) {
                  var z = -v.trueNorth * Math.PI / 180, P = h.quat.rotateZ(h.quat.create(), h.quat.create(), z);
                  D = h.vec3.transformQuat(h.vec3.create(), D, P), k = h.vec3.transformQuat(h.vec3.create(), k, P);
                }
                var Q = m.getDistanceAndHeight(W, D, k), Y = h.vec3.scale(h.vec3.create(), D, Q.distance), ie = h.vec3.add(h.vec3.create(), L, Y), te = h.mat4.lookAt(h.mat4.create(), ie, L, k);
                v.viewer.animations.viewTo({ mv: te, height: Q.height }, v.viewer.zoomDuration);
              }
            }
          }), this._initialized = !0;
        }, E.prototype.onBeforeDraw = function(m, v) {
        }, E.prototype.onBeforePick = function(m) {
          return m.model === this._modelId && m.id != null;
        }, E.prototype.onAfterDraw = function(m, v) {
          if (!this.stopped) {
            var y = this.setActive();
            y.disable(y.BLEND), y.disable(y.DEPTH_TEST), y.uniform1f(this._colourCodingUniformPointer, 0), this.draw(m, v);
          }
        }, E.prototype.onBeforeDrawId = function() {
        }, E.prototype.onAfterDrawId = function() {
          this.stopped || (this.setActive().uniform1f(this._colourCodingUniformPointer, 1), this.draw(this.viewer.width, this.viewer.height));
        }, E.prototype.onAfterDrawModelId = function() {
          this.stopped || (this.setActive().uniform1f(this._colourCodingUniformPointer, this._modelId), this.draw(this.viewer.width, this.viewer.height));
        }, E.prototype.getId = function(m) {
          var v = m.clientX, y = m.clientY, A = this.viewer.canvas.getBoundingClientRect(), b = v - A.left, C = this.viewer.height - (y - A.top), T = this.viewer.gl, w = new g.Framebuffer(T, this.viewer.width, this.viewer.height, this.viewer.hasDepthSupport, this.viewer.glVersion);
          T.viewport(0, 0, this.viewer.width, this.viewer.height), T.enable(T.DEPTH_TEST), T.disable(T.BLEND), T.clearColor(0, 0, 0, 0), T.clear(T.COLOR_BUFFER_BIT | T.DEPTH_BUFFER_BIT), this.onAfterDrawId();
          var R = w.getId(b, C);
          return w.delete(), R;
        }, E.prototype.setActive = function() {
          var m = this.viewer.gl;
          return m.useProgram(this._shader), m;
        }, E.prototype.isInRegion = function(m, v) {
          var y = this._region[0] * this.viewer.width, A = this._region[2] * this.viewer.width, b = this._region[1] * this.viewer.height, C = this._region[3] * this.viewer.height;
          return !(m < y || m > A || v < b || v > C);
        }, E.prototype.draw = function(m, v) {
          if (!this.stopped && this._initialized) {
            var y = this.viewer.gl, A = Math.min(m, v), b = this.minSize / A, C = this.maxSize / A, T = this.ratio;
            T < b ? T = b : T > C && (T = C);
            var w = h.mat4.create(), R = 1 / T, O = R / v * m;
            v > m && (R = (O = 1 / T) / m * v);
            var D = T * v / m * 2, k = 2 * T;
            switch (this.position) {
              case this.BOTTOM_RIGHT:
                h.mat4.ortho(w, 1 - O, 1, -1, R - 1, -1, 1), this._region = [1 - D, 0, 1, k];
                break;
              case this.BOTTOM_LEFT:
                h.mat4.ortho(w, -1, O - 1, -1, R - 1, -1, 1), this._region = [0, 0, D, k];
                break;
              case this.TOP_LEFT:
                h.mat4.ortho(w, -1, O - 1, 1 - R, 1, -1, 1), this._region = [0, 1 - k, D, 1];
                break;
              case this.TOP_RIGHT:
                h.mat4.ortho(w, 1 - O, 1, 1 - R, 1, -1, 1), this._region = [1 - D, 1 - k, 1, 1];
            }
            var W = h.mat3.fromMat4(h.mat3.create(), this.viewer.mvMatrix);
            if (this.trueNorth !== 0) {
              var L = -this.trueNorth * Math.PI / 180, z = h.mat3.fromRotation(h.mat3.create(), L);
              W = h.mat3.multiply(h.mat3.create(), W, z);
            }
            y.uniformMatrix4fv(this._pMatrixUniformPointer, !1, w), y.uniformMatrix3fv(this._rotationUniformPointer, !1, W), y.uniform1f(this._alphaUniformPointer, this._alpha), y.uniform1f(this._highlightingUniformPointer, this.highlighting), y.uniform1f(this._selectionUniformPointer, this._selection), y.bindBuffer(y.ARRAY_BUFFER, this._vertexBuffer), y.vertexAttribPointer(this._vertexAttrPointer, 3, y.FLOAT, !1, 0, 0), y.bindBuffer(y.ARRAY_BUFFER, this._idBuffer), y.vertexAttribPointer(this._idAttrPointer, 1, y.FLOAT, !1, 0, 0), y.bindBuffer(y.ARRAY_BUFFER, this._texCoordBuffer), y.vertexAttribPointer(this._texCoordAttrPointer, 2, y.FLOAT, !1, 0, 0), y.activeTexture(y.TEXTURE1), y.bindTexture(y.TEXTURE_2D, this._texture), y.uniform1i(this._textureUniformPointer, 1);
            var P = y.getParameter(y.CULL_FACE);
            P || y.enable(y.CULL_FACE), y.disable(y.BLEND), y.bindBuffer(y.ELEMENT_ARRAY_BUFFER, this._indexBuffer), y.drawElements(y.TRIANGLES, this.indices.length, y.UNSIGNED_SHORT, 0), P || y.disable(y.CULL_FACE);
          }
        }, E.prototype._initShader = function() {
          var m = this.viewer.gl, v = this.viewer, y = function(C, T) {
            if (m.shaderSource(C, T), m.compileShader(C), !m.getShaderParameter(C, m.COMPILE_STATUS)) {
              var w = m.getShaderInfoLog(C);
              return v.error(w), null;
            }
          }, A = m.createShader(m.FRAGMENT_SHADER);
          y(A, u.cube_fshader);
          var b = m.createShader(m.VERTEX_SHADER);
          y(b, d.cube_vshader), this._shader = m.createProgram(), m.attachShader(this._shader, b), m.attachShader(this._shader, A), m.linkProgram(this._shader), m.getProgramParameter(this._shader, m.LINK_STATUS) || v.error("Could not initialise shaders for a navigation cube plugin");
        }, E;
      }();
      l.NavigationCube = x;
    }, 1712: function(o, l, c) {
      var u = this && this.__createBinding || (Object.create ? function(f, h, g, x) {
        x === void 0 && (x = g);
        var E = Object.getOwnPropertyDescriptor(h, g);
        E && !("get" in E ? !h.__esModule : E.writable || E.configurable) || (E = { enumerable: !0, get: function() {
          return h[g];
        } }), Object.defineProperty(f, x, E);
      } : function(f, h, g, x) {
        x === void 0 && (x = g), f[x] = h[g];
      }), d = this && this.__exportStar || function(f, h) {
        for (var g in f)
          g === "default" || Object.prototype.hasOwnProperty.call(h, g) || u(h, f, g);
      };
      Object.defineProperty(l, "__esModule", { value: !0 }), d(c(1410), l), d(c(5819), l), d(c(5637), l), d(c(1906), l), d(c(382), l);
    }, 1410: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 });
    }, 9438: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Product = void 0;
      var c = function() {
        function d() {
        }
        return d.getByName = function(f) {
          f = f.toUpperCase();
          for (var h = [u]; h.length !== 0; ) {
            var g = h.shift();
            if (g.name.toUpperCase() === f)
              return g;
            g.children && g.children.forEach(function(x) {
              h.push(x);
            });
          }
          return null;
        }, d.getAllSubTypes = function(f) {
          for (var h = [], g = [u]; g.length !== 0; )
            (E = g.shift()).id === f && h.push(E), E.children && E.children.forEach(function(m) {
              g.push(m);
            });
          g = h.slice();
          for (var x = {}; g.length !== 0; ) {
            var E;
            (E = g.shift()).abs === !1 && (x[E.id] = !0), E.children && E.children.forEach(function(m) {
              g.push(m);
            });
          }
          return x;
        }, d;
      }();
      l.Product = c;
      var u = { name: "IfcProduct", id: 20, abs: !0, children: [{ name: "IfcElement", id: 19, abs: !0, children: [{ name: "IfcDistributionElement", id: 44, abs: !1, children: [{ name: "IfcDistributionFlowElement", id: 45, abs: !1, children: [{ name: "IfcDistributionChamberElement", id: 180, abs: !1 }, { name: "IfcEnergyConversionDevice", id: 175, abs: !1, children: [{ name: "IfcAirToAirHeatRecovery", id: 1097, abs: !1 }, { name: "IfcBoiler", id: 1105, abs: !1 }, { name: "IfcBurner", id: 1109, abs: !1 }, { name: "IfcChiller", id: 1119, abs: !1 }, { name: "IfcCoil", id: 1124, abs: !1 }, { name: "IfcCondenser", id: 1132, abs: !1 }, { name: "IfcCooledBeam", id: 1141, abs: !1 }, { name: "IfcCoolingTower", id: 1142, abs: !1 }, { name: "IfcEngine", id: 1164, abs: !1 }, { name: "IfcEvaporativeCooler", id: 1166, abs: !1 }, { name: "IfcEvaporator", id: 1167, abs: !1 }, { name: "IfcHeatExchanger", id: 1187, abs: !1 }, { name: "IfcHumidifier", id: 1188, abs: !1 }, { name: "IfcTubeBundle", id: 1305, abs: !1 }, { name: "IfcUnitaryEquipment", id: 1310, abs: !1 }, { name: "IfcElectricGenerator", id: 1160, abs: !1 }, { name: "IfcElectricMotor", id: 1161, abs: !1 }, { name: "IfcMotorConnection", id: 1216, abs: !1 }, { name: "IfcSolarDevice", id: 1270, abs: !1 }, { name: "IfcTransformer", id: 1303, abs: !1 }] }, { name: "IfcFlowController", id: 121, abs: !1, children: [{ name: "IfcElectricDistributionPoint", id: 242, abs: !1 }, { name: "IfcAirTerminalBox", id: 1096, abs: !1 }, { name: "IfcDamper", id: 1148, abs: !1 }, { name: "IfcFlowMeter", id: 1182, abs: !1 }, { name: "IfcValve", id: 1311, abs: !1 }, { name: "IfcElectricDistributionBoard", id: 1157, abs: !1 }, { name: "IfcElectricTimeControl", id: 1162, abs: !1 }, { name: "IfcProtectiveDevice", id: 1235, abs: !1 }, { name: "IfcSwitchingDevice", id: 1290, abs: !1 }] }, { name: "IfcFlowFitting", id: 467, abs: !1, children: [{ name: "IfcDuctFitting", id: 1153, abs: !1 }, { name: "IfcPipeFitting", id: 1222, abs: !1 }, { name: "IfcCableCarrierFitting", id: 1111, abs: !1 }, { name: "IfcCableFitting", id: 1113, abs: !1 }, { name: "IfcJunctionBox", id: 1195, abs: !1 }] }, { name: "IfcFlowMovingDevice", id: 502, abs: !1, children: [{ name: "IfcCompressor", id: 1131, abs: !1 }, { name: "IfcFan", id: 1177, abs: !1 }, { name: "IfcPump", id: 1238, abs: !1 }] }, { name: "IfcFlowSegment", id: 574, abs: !1, children: [{ name: "IfcDuctSegment", id: 1154, abs: !1 }, { name: "IfcPipeSegment", id: 1223, abs: !1 }, { name: "IfcCableCarrierSegment", id: 1112, abs: !1 }, { name: "IfcCableSegment", id: 1115, abs: !1 }] }, { name: "IfcFlowStorageDevice", id: 371, abs: !1, children: [{ name: "IfcTank", id: 1293, abs: !1 }, { name: "IfcElectricFlowStorageDevice", id: 1159, abs: !1 }] }, { name: "IfcFlowTerminal", id: 46, abs: !1, children: [{ name: "IfcFireSuppressionTerminal", id: 1179, abs: !1 }, { name: "IfcSanitaryTerminal", id: 1262, abs: !1 }, { name: "IfcStackTerminal", id: 1277, abs: !1 }, { name: "IfcWasteTerminal", id: 1315, abs: !1 }, { name: "IfcAirTerminal", id: 1095, abs: !1 }, { name: "IfcMedicalDevice", id: 1212, abs: !1 }, { name: "IfcSpaceHeater", id: 1272, abs: !1 }, { name: "IfcAudioVisualAppliance", id: 1099, abs: !1 }, { name: "IfcCommunicationsAppliance", id: 1127, abs: !1 }, { name: "IfcElectricAppliance", id: 1156, abs: !1 }, { name: "IfcLamp", id: 1198, abs: !1 }, { name: "IfcLightFixture", id: 1199, abs: !1 }, { name: "IfcOutlet", id: 1219, abs: !1 }] }, { name: "IfcFlowTreatmentDevice", id: 425, abs: !1, children: [{ name: "IfcInterceptor", id: 1193, abs: !1 }, { name: "IfcDuctSilencer", id: 1155, abs: !1 }, { name: "IfcFilter", id: 1178, abs: !1 }] }] }, { name: "IfcDistributionControlElement", id: 468, abs: !1, children: [{ name: "IfcProtectiveDeviceTrippingUnit", id: 1236, abs: !1 }, { name: "IfcActuator", id: 1091, abs: !1 }, { name: "IfcAlarm", id: 1098, abs: !1 }, { name: "IfcController", id: 1139, abs: !1 }, { name: "IfcFlowInstrument", id: 1181, abs: !1 }, { name: "IfcSensor", id: 1264, abs: !1 }, { name: "IfcUnitaryControlElement", id: 1308, abs: !1 }] }] }, { name: "IfcElementComponent", id: 424, abs: !0, children: [{ name: "IfcDiscreteAccessory", id: 423, abs: !1 }, { name: "IfcFastener", id: 535, abs: !1, children: [{ name: "IfcMechanicalFastener", id: 536, abs: !1 }] }, { name: "IfcReinforcingElement", id: 262, abs: !0, children: [{ name: "IfcReinforcingBar", id: 571, abs: !1 }, { name: "IfcReinforcingMesh", id: 531, abs: !1 }, { name: "IfcTendon", id: 261, abs: !1 }, { name: "IfcTendonAnchor", id: 675, abs: !1 }] }, { name: "IfcBuildingElementPart", id: 220, abs: !1 }, { name: "IfcMechanicalFastener", id: 536, abs: !1 }, { name: "IfcVibrationIsolator", id: 1312, abs: !1 }] }, { name: "IfcFeatureElement", id: 386, abs: !0, children: [{ name: "IfcFeatureElementSubtraction", id: 499, abs: !0, children: [{ name: "IfcEdgeFeature", id: 764, abs: !0, children: [{ name: "IfcChamferEdgeFeature", id: 765, abs: !1 }, { name: "IfcRoundedEdgeFeature", id: 766, abs: !1 }] }, { name: "IfcOpeningElement", id: 498, abs: !1, children: [{ name: "IfcOpeningStandardCase", id: 1217, abs: !1 }] }, { name: "IfcVoidingFeature", id: 1313, abs: !1 }] }, { name: "IfcFeatureElementAddition", id: 385, abs: !0, children: [{ name: "IfcProjectionElement", id: 384, abs: !1 }] }, { name: "IfcSurfaceFeature", id: 1287, abs: !1 }] }, { name: "IfcBuildingElement", id: 26, abs: !0, children: [{ name: "IfcBuildingElementComponent", id: 221, abs: !0, children: [{ name: "IfcBuildingElementPart", id: 220, abs: !1 }, { name: "IfcReinforcingElement", id: 262, abs: !0, children: [{ name: "IfcReinforcingBar", id: 571, abs: !1 }, { name: "IfcReinforcingMesh", id: 531, abs: !1 }, { name: "IfcTendon", id: 261, abs: !1 }, { name: "IfcTendonAnchor", id: 675, abs: !1 }] }] }, { name: "IfcFooting", id: 120, abs: !1 }, { name: "IfcPile", id: 572, abs: !1 }, { name: "IfcBeam", id: 171, abs: !1, children: [{ name: "IfcBeamStandardCase", id: 1104, abs: !1 }] }, { name: "IfcColumn", id: 383, abs: !1, children: [{ name: "IfcColumnStandardCase", id: 1126, abs: !1 }] }, { name: "IfcCurtainWall", id: 456, abs: !1 }, { name: "IfcDoor", id: 213, abs: !1, children: [{ name: "IfcDoorStandardCase", id: 1151, abs: !1 }] }, { name: "IfcMember", id: 310, abs: !1, children: [{ name: "IfcMemberStandardCase", id: 1214, abs: !1 }] }, { name: "IfcPlate", id: 351, abs: !1, children: [{ name: "IfcPlateStandardCase", id: 1224, abs: !1 }] }, { name: "IfcRailing", id: 350, abs: !1 }, { name: "IfcRamp", id: 414, abs: !1 }, { name: "IfcRampFlight", id: 348, abs: !1 }, { name: "IfcRoof", id: 347, abs: !1 }, { name: "IfcSlab", id: 99, abs: !1, children: [{ name: "IfcSlabElementedCase", id: 1268, abs: !1 }, { name: "IfcSlabStandardCase", id: 1269, abs: !1 }] }, { name: "IfcStair", id: 346, abs: !1 }, { name: "IfcStairFlight", id: 25, abs: !1 }, { name: "IfcWall", id: 452, abs: !1, children: [{ name: "IfcWallStandardCase", id: 453, abs: !1 }, { name: "IfcWallElementedCase", id: 1314, abs: !1 }] }, { name: "IfcWindow", id: 667, abs: !1, children: [{ name: "IfcWindowStandardCase", id: 1316, abs: !1 }] }, { name: "IfcBuildingElementProxy", id: 560, abs: !1 }, { name: "IfcCovering", id: 382, abs: !1 }, { name: "IfcChimney", id: 1120, abs: !1 }, { name: "IfcShadingDevice", id: 1265, abs: !1 }] }, { name: "IfcElementAssembly", id: 18, abs: !1 }, { name: "IfcFurnishingElement", id: 253, abs: !1, children: [{ name: "IfcFurniture", id: 1184, abs: !1 }, { name: "IfcSystemFurnitureElement", id: 1291, abs: !1 }] }, { name: "IfcTransportElement", id: 416, abs: !1 }, { name: "IfcVirtualElement", id: 168, abs: !1 }, { name: "IfcElectricalElement", id: 23, abs: !1 }, { name: "IfcEquipmentElement", id: 212, abs: !1 }, { name: "IfcCivilElement", id: 1122, abs: !1 }, { name: "IfcGeographicElement", id: 1185, abs: !1 }] }, { name: "IfcPort", id: 179, abs: !0, children: [{ name: "IfcDistributionPort", id: 178, abs: !1 }] }, { name: "IfcProxy", id: 447, abs: !1 }, { name: "IfcStructuralActivity", id: 41, abs: !0, children: [{ name: "IfcStructuralAction", id: 40, abs: !0, children: [{ name: "IfcStructuralLinearAction", id: 463, abs: !1, children: [{ name: "IfcStructuralLinearActionVarying", id: 464, abs: !1 }] }, { name: "IfcStructuralPlanarAction", id: 39, abs: !1, children: [{ name: "IfcStructuralPlanarActionVarying", id: 357, abs: !1 }] }, { name: "IfcStructuralPointAction", id: 356, abs: !1 }, { name: "IfcStructuralCurveAction", id: 1279, abs: !1, children: [{ name: "IfcStructuralLinearAction", id: 463, abs: !1 }] }, { name: "IfcStructuralSurfaceAction", id: 1284, abs: !1, children: [{ name: "IfcStructuralPlanarAction", id: 39, abs: !1 }] }] }, { name: "IfcStructuralReaction", id: 355, abs: !0, children: [{ name: "IfcStructuralPointReaction", id: 354, abs: !1 }, { name: "IfcStructuralCurveReaction", id: 1280, abs: !1 }, { name: "IfcStructuralSurfaceReaction", id: 1285, abs: !1 }] }] }, { name: "IfcStructuralItem", id: 226, abs: !0, children: [{ name: "IfcStructuralConnection", id: 265, abs: !0, children: [{ name: "IfcStructuralCurveConnection", id: 534, abs: !1 }, { name: "IfcStructuralPointConnection", id: 533, abs: !1 }, { name: "IfcStructuralSurfaceConnection", id: 264, abs: !1 }] }, { name: "IfcStructuralMember", id: 225, abs: !0, children: [{ name: "IfcStructuralCurveMember", id: 224, abs: !1, children: [{ name: "IfcStructuralCurveMemberVarying", id: 227, abs: !1 }] }, { name: "IfcStructuralSurfaceMember", id: 420, abs: !1, children: [{ name: "IfcStructuralSurfaceMemberVarying", id: 421, abs: !1 }] }] }] }, { name: "IfcAnnotation", id: 634, abs: !1 }, { name: "IfcSpatialStructureElement", id: 170, abs: !0, children: [{ name: "IfcBuilding", id: 169, abs: !1 }, { name: "IfcBuildingStorey", id: 459, abs: !1 }, { name: "IfcSite", id: 349, abs: !1 }, { name: "IfcSpace", id: 454, abs: !1 }] }, { name: "IfcGrid", id: 564, abs: !1 }, { name: "IfcSpatialElement", id: 1273, abs: !0, children: [{ name: "IfcSpatialStructureElement", id: 170, abs: !0, children: [{ name: "IfcBuilding", id: 169, abs: !1 }, { name: "IfcBuildingStorey", id: 459, abs: !1 }, { name: "IfcSite", id: 349, abs: !1 }, { name: "IfcSpace", id: 454, abs: !1 }] }, { name: "IfcExternalSpatialStructureElement", id: 1175, abs: !0, children: [{ name: "IfcExternalSpatialElement", id: 1174, abs: !1 }] }, { name: "IfcSpatialZone", id: 1275, abs: !1 }] }] };
    }, 3425: (o, l) => {
      var c;
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ProductType = void 0, (c = l.ProductType || (l.ProductType = {}))[c.IFCPRODUCT = 20] = "IFCPRODUCT", c[c.IFCELEMENT = 19] = "IFCELEMENT", c[c.IFCBUILDINGELEMENT = 26] = "IFCBUILDINGELEMENT", c[c.IFCFOOTING = 120] = "IFCFOOTING", c[c.IFCPILE = 572] = "IFCPILE", c[c.IFCBEAM = 171] = "IFCBEAM", c[c.IFCBEAMSTANDARDCASE = 1104] = "IFCBEAMSTANDARDCASE", c[c.IFCBUILDINGELEMENTPROXY = 560] = "IFCBUILDINGELEMENTPROXY", c[c.IFCCHIMNEY = 1120] = "IFCCHIMNEY", c[c.IFCCOLUMN = 383] = "IFCCOLUMN", c[c.IFCCOLUMNSTANDARDCASE = 1126] = "IFCCOLUMNSTANDARDCASE", c[c.IFCCOVERING = 382] = "IFCCOVERING", c[c.IFCCURTAINWALL = 456] = "IFCCURTAINWALL", c[c.IFCDOOR = 213] = "IFCDOOR", c[c.IFCDOORSTANDARDCASE = 1151] = "IFCDOORSTANDARDCASE", c[c.IFCMEMBER = 310] = "IFCMEMBER", c[c.IFCMEMBERSTANDARDCASE = 1214] = "IFCMEMBERSTANDARDCASE", c[c.IFCPLATE = 351] = "IFCPLATE", c[c.IFCPLATESTANDARDCASE = 1224] = "IFCPLATESTANDARDCASE", c[c.IFCRAILING = 350] = "IFCRAILING", c[c.IFCRAMP = 414] = "IFCRAMP", c[c.IFCRAMPFLIGHT = 348] = "IFCRAMPFLIGHT", c[c.IFCROOF = 347] = "IFCROOF", c[c.IFCSHADINGDEVICE = 1265] = "IFCSHADINGDEVICE", c[c.IFCSLAB = 99] = "IFCSLAB", c[c.IFCSLABELEMENTEDCASE = 1268] = "IFCSLABELEMENTEDCASE", c[c.IFCSLABSTANDARDCASE = 1269] = "IFCSLABSTANDARDCASE", c[c.IFCSTAIR = 346] = "IFCSTAIR", c[c.IFCSTAIRFLIGHT = 25] = "IFCSTAIRFLIGHT", c[c.IFCWALL = 452] = "IFCWALL", c[c.IFCWALLELEMENTEDCASE = 1314] = "IFCWALLELEMENTEDCASE", c[c.IFCWALLSTANDARDCASE = 453] = "IFCWALLSTANDARDCASE", c[c.IFCWINDOW = 667] = "IFCWINDOW", c[c.IFCWINDOWSTANDARDCASE = 1316] = "IFCWINDOWSTANDARDCASE", c[c.IFCELEMENTCOMPONENT = 424] = "IFCELEMENTCOMPONENT", c[c.IFCREINFORCINGELEMENT = 262] = "IFCREINFORCINGELEMENT", c[c.IFCREINFORCINGBAR = 571] = "IFCREINFORCINGBAR", c[c.IFCREINFORCINGMESH = 531] = "IFCREINFORCINGMESH", c[c.IFCTENDON = 261] = "IFCTENDON", c[c.IFCTENDONANCHOR = 675] = "IFCTENDONANCHOR", c[c.IFCBUILDINGELEMENTPART = 220] = "IFCBUILDINGELEMENTPART", c[c.IFCDISCRETEACCESSORY = 423] = "IFCDISCRETEACCESSORY", c[c.IFCFASTENER = 535] = "IFCFASTENER", c[c.IFCMECHANICALFASTENER = 536] = "IFCMECHANICALFASTENER", c[c.IFCVIBRATIONISOLATOR = 1312] = "IFCVIBRATIONISOLATOR", c[c.IFCFEATUREELEMENT = 386] = "IFCFEATUREELEMENT", c[c.IFCSURFACEFEATURE = 1287] = "IFCSURFACEFEATURE", c[c.IFCFEATUREELEMENTSUBTRACTION = 499] = "IFCFEATUREELEMENTSUBTRACTION", c[c.IFCVOIDINGFEATURE = 1313] = "IFCVOIDINGFEATURE", c[c.IFCOPENINGELEMENT = 498] = "IFCOPENINGELEMENT", c[c.IFCOPENINGSTANDARDCASE = 1217] = "IFCOPENINGSTANDARDCASE", c[c.IFCFEATUREELEMENTADDITION = 385] = "IFCFEATUREELEMENTADDITION", c[c.IFCPROJECTIONELEMENT = 384] = "IFCPROJECTIONELEMENT", c[c.IFCFURNISHINGELEMENT = 253] = "IFCFURNISHINGELEMENT", c[c.IFCFURNITURE = 1184] = "IFCFURNITURE", c[c.IFCSYSTEMFURNITUREELEMENT = 1291] = "IFCSYSTEMFURNITUREELEMENT", c[c.IFCDISTRIBUTIONELEMENT = 44] = "IFCDISTRIBUTIONELEMENT", c[c.IFCDISTRIBUTIONFLOWELEMENT = 45] = "IFCDISTRIBUTIONFLOWELEMENT", c[c.IFCDISTRIBUTIONCHAMBERELEMENT = 180] = "IFCDISTRIBUTIONCHAMBERELEMENT", c[c.IFCENERGYCONVERSIONDEVICE = 175] = "IFCENERGYCONVERSIONDEVICE", c[c.IFCAIRTOAIRHEATRECOVERY = 1097] = "IFCAIRTOAIRHEATRECOVERY", c[c.IFCBOILER = 1105] = "IFCBOILER", c[c.IFCBURNER = 1109] = "IFCBURNER", c[c.IFCCHILLER = 1119] = "IFCCHILLER", c[c.IFCCOIL = 1124] = "IFCCOIL", c[c.IFCCONDENSER = 1132] = "IFCCONDENSER", c[c.IFCCOOLEDBEAM = 1141] = "IFCCOOLEDBEAM", c[c.IFCCOOLINGTOWER = 1142] = "IFCCOOLINGTOWER", c[c.IFCENGINE = 1164] = "IFCENGINE", c[c.IFCEVAPORATIVECOOLER = 1166] = "IFCEVAPORATIVECOOLER", c[c.IFCEVAPORATOR = 1167] = "IFCEVAPORATOR", c[c.IFCHEATEXCHANGER = 1187] = "IFCHEATEXCHANGER", c[c.IFCHUMIDIFIER = 1188] = "IFCHUMIDIFIER", c[c.IFCTUBEBUNDLE = 1305] = "IFCTUBEBUNDLE", c[c.IFCUNITARYEQUIPMENT = 1310] = "IFCUNITARYEQUIPMENT", c[c.IFCELECTRICGENERATOR = 1160] = "IFCELECTRICGENERATOR", c[c.IFCELECTRICMOTOR = 1161] = "IFCELECTRICMOTOR", c[c.IFCMOTORCONNECTION = 1216] = "IFCMOTORCONNECTION", c[c.IFCSOLARDEVICE = 1270] = "IFCSOLARDEVICE", c[c.IFCTRANSFORMER = 1303] = "IFCTRANSFORMER", c[c.IFCFLOWCONTROLLER = 121] = "IFCFLOWCONTROLLER", c[c.IFCAIRTERMINALBOX = 1096] = "IFCAIRTERMINALBOX", c[c.IFCDAMPER = 1148] = "IFCDAMPER", c[c.IFCFLOWMETER = 1182] = "IFCFLOWMETER", c[c.IFCVALVE = 1311] = "IFCVALVE", c[c.IFCELECTRICDISTRIBUTIONBOARD = 1157] = "IFCELECTRICDISTRIBUTIONBOARD", c[c.IFCELECTRICTIMECONTROL = 1162] = "IFCELECTRICTIMECONTROL", c[c.IFCPROTECTIVEDEVICE = 1235] = "IFCPROTECTIVEDEVICE", c[c.IFCSWITCHINGDEVICE = 1290] = "IFCSWITCHINGDEVICE", c[c.IFCFLOWFITTING = 467] = "IFCFLOWFITTING", c[c.IFCDUCTFITTING = 1153] = "IFCDUCTFITTING", c[c.IFCPIPEFITTING = 1222] = "IFCPIPEFITTING", c[c.IFCCABLECARRIERFITTING = 1111] = "IFCCABLECARRIERFITTING", c[c.IFCCABLEFITTING = 1113] = "IFCCABLEFITTING", c[c.IFCJUNCTIONBOX = 1195] = "IFCJUNCTIONBOX", c[c.IFCFLOWMOVINGDEVICE = 502] = "IFCFLOWMOVINGDEVICE", c[c.IFCCOMPRESSOR = 1131] = "IFCCOMPRESSOR", c[c.IFCFAN = 1177] = "IFCFAN", c[c.IFCPUMP = 1238] = "IFCPUMP", c[c.IFCFLOWSEGMENT = 574] = "IFCFLOWSEGMENT", c[c.IFCDUCTSEGMENT = 1154] = "IFCDUCTSEGMENT", c[c.IFCPIPESEGMENT = 1223] = "IFCPIPESEGMENT", c[c.IFCCABLECARRIERSEGMENT = 1112] = "IFCCABLECARRIERSEGMENT", c[c.IFCCABLESEGMENT = 1115] = "IFCCABLESEGMENT", c[c.IFCFLOWSTORAGEDEVICE = 371] = "IFCFLOWSTORAGEDEVICE", c[c.IFCTANK = 1293] = "IFCTANK", c[c.IFCELECTRICFLOWSTORAGEDEVICE = 1159] = "IFCELECTRICFLOWSTORAGEDEVICE", c[c.IFCFLOWTERMINAL = 46] = "IFCFLOWTERMINAL", c[c.IFCFIRESUPPRESSIONTERMINAL = 1179] = "IFCFIRESUPPRESSIONTERMINAL", c[c.IFCSANITARYTERMINAL = 1262] = "IFCSANITARYTERMINAL", c[c.IFCSTACKTERMINAL = 1277] = "IFCSTACKTERMINAL", c[c.IFCWASTETERMINAL = 1315] = "IFCWASTETERMINAL", c[c.IFCAIRTERMINAL = 1095] = "IFCAIRTERMINAL", c[c.IFCMEDICALDEVICE = 1212] = "IFCMEDICALDEVICE", c[c.IFCSPACEHEATER = 1272] = "IFCSPACEHEATER", c[c.IFCAUDIOVISUALAPPLIANCE = 1099] = "IFCAUDIOVISUALAPPLIANCE", c[c.IFCCOMMUNICATIONSAPPLIANCE = 1127] = "IFCCOMMUNICATIONSAPPLIANCE", c[c.IFCELECTRICAPPLIANCE = 1156] = "IFCELECTRICAPPLIANCE", c[c.IFCLAMP = 1198] = "IFCLAMP", c[c.IFCLIGHTFIXTURE = 1199] = "IFCLIGHTFIXTURE", c[c.IFCOUTLET = 1219] = "IFCOUTLET", c[c.IFCFLOWTREATMENTDEVICE = 425] = "IFCFLOWTREATMENTDEVICE", c[c.IFCINTERCEPTOR = 1193] = "IFCINTERCEPTOR", c[c.IFCDUCTSILENCER = 1155] = "IFCDUCTSILENCER", c[c.IFCFILTER = 1178] = "IFCFILTER", c[c.IFCDISTRIBUTIONCONTROLELEMENT = 468] = "IFCDISTRIBUTIONCONTROLELEMENT", c[c.IFCPROTECTIVEDEVICETRIPPINGUNIT = 1236] = "IFCPROTECTIVEDEVICETRIPPINGUNIT", c[c.IFCACTUATOR = 1091] = "IFCACTUATOR", c[c.IFCALARM = 1098] = "IFCALARM", c[c.IFCCONTROLLER = 1139] = "IFCCONTROLLER", c[c.IFCFLOWINSTRUMENT = 1181] = "IFCFLOWINSTRUMENT", c[c.IFCSENSOR = 1264] = "IFCSENSOR", c[c.IFCUNITARYCONTROLELEMENT = 1308] = "IFCUNITARYCONTROLELEMENT", c[c.IFCCIVILELEMENT = 1122] = "IFCCIVILELEMENT", c[c.IFCELEMENTASSEMBLY = 18] = "IFCELEMENTASSEMBLY", c[c.IFCGEOGRAPHICELEMENT = 1185] = "IFCGEOGRAPHICELEMENT", c[c.IFCTRANSPORTELEMENT = 416] = "IFCTRANSPORTELEMENT", c[c.IFCVIRTUALELEMENT = 168] = "IFCVIRTUALELEMENT", c[c.IFCSTRUCTURALACTIVITY = 41] = "IFCSTRUCTURALACTIVITY", c[c.IFCSTRUCTURALACTION = 40] = "IFCSTRUCTURALACTION", c[c.IFCSTRUCTURALCURVEACTION = 1279] = "IFCSTRUCTURALCURVEACTION", c[c.IFCSTRUCTURALLINEARACTION = 463] = "IFCSTRUCTURALLINEARACTION", c[c.IFCSTRUCTURALSURFACEACTION = 1284] = "IFCSTRUCTURALSURFACEACTION", c[c.IFCSTRUCTURALPLANARACTION = 39] = "IFCSTRUCTURALPLANARACTION", c[c.IFCSTRUCTURALPOINTACTION = 356] = "IFCSTRUCTURALPOINTACTION", c[c.IFCSTRUCTURALREACTION = 355] = "IFCSTRUCTURALREACTION", c[c.IFCSTRUCTURALCURVEREACTION = 1280] = "IFCSTRUCTURALCURVEREACTION", c[c.IFCSTRUCTURALPOINTREACTION = 354] = "IFCSTRUCTURALPOINTREACTION", c[c.IFCSTRUCTURALSURFACEREACTION = 1285] = "IFCSTRUCTURALSURFACEREACTION", c[c.IFCSTRUCTURALITEM = 226] = "IFCSTRUCTURALITEM", c[c.IFCSTRUCTURALCONNECTION = 265] = "IFCSTRUCTURALCONNECTION", c[c.IFCSTRUCTURALCURVECONNECTION = 534] = "IFCSTRUCTURALCURVECONNECTION", c[c.IFCSTRUCTURALPOINTCONNECTION = 533] = "IFCSTRUCTURALPOINTCONNECTION", c[c.IFCSTRUCTURALSURFACECONNECTION = 264] = "IFCSTRUCTURALSURFACECONNECTION", c[c.IFCSTRUCTURALMEMBER = 225] = "IFCSTRUCTURALMEMBER", c[c.IFCSTRUCTURALCURVEMEMBER = 224] = "IFCSTRUCTURALCURVEMEMBER", c[c.IFCSTRUCTURALCURVEMEMBERVARYING = 227] = "IFCSTRUCTURALCURVEMEMBERVARYING", c[c.IFCSTRUCTURALSURFACEMEMBER = 420] = "IFCSTRUCTURALSURFACEMEMBER", c[c.IFCSTRUCTURALSURFACEMEMBERVARYING = 421] = "IFCSTRUCTURALSURFACEMEMBERVARYING", c[c.IFCPORT = 179] = "IFCPORT", c[c.IFCDISTRIBUTIONPORT = 178] = "IFCDISTRIBUTIONPORT", c[c.IFCANNOTATION = 634] = "IFCANNOTATION", c[c.IFCSPATIALELEMENT = 1273] = "IFCSPATIALELEMENT", c[c.IFCSPATIALSTRUCTUREELEMENT = 170] = "IFCSPATIALSTRUCTUREELEMENT", c[c.IFCBUILDING = 169] = "IFCBUILDING", c[c.IFCBUILDINGSTOREY = 459] = "IFCBUILDINGSTOREY", c[c.IFCSITE = 349] = "IFCSITE", c[c.IFCSPACE = 454] = "IFCSPACE", c[c.IFCEXTERNALSPATIALSTRUCTUREELEMENT = 1175] = "IFCEXTERNALSPATIALSTRUCTUREELEMENT", c[c.IFCEXTERNALSPATIALELEMENT = 1174] = "IFCEXTERNALSPATIALELEMENT", c[c.IFCSPATIALZONE = 1275] = "IFCSPATIALZONE", c[c.IFCGRID = 564] = "IFCGRID", c[c.IFCPROXY = 447] = "IFCPROXY";
    }, 6105: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.BinaryReader = void 0;
      var u = c(6920), d = function() {
        function f() {
          this._buffer = null, this._view = null, this._position = 0, this._progress = function(h) {
          }, this._lastProgress = 0;
        }
        return Object.defineProperty(f.prototype, "Position", { get: function() {
          return this._position;
        }, enumerable: !1, configurable: !0 }), f.prototype.getSubReader = function(h) {
          var g = new f(), x = this._buffer.slice(this._position, this._position + h);
          return g.load(x, null, null), this._position += h, g;
        }, f.prototype.load = function(h, g, x) {
          this._position = 0;
          var E = this;
          if (x = x || function(y) {
          }, this._progress = x, h === void 0 || h == null)
            throw "Source must be defined";
          if (typeof h == "string") {
            var m = new XMLHttpRequest();
            m.open("GET", h, !0), m.onreadystatechange = function() {
              if (m.readyState == 4 && m.status == 200) {
                var y = new FileReader();
                y.onloadend = function() {
                  y.result && typeof y.result != "string" && (E._buffer = y.result, E._view = new DataView(E._buffer), E.onloaded && E.onloaded(E));
                }, y.onprogress = function(b) {
                  x({ message: "Downloading geometry", percent: Math.floor(b.loaded / b.total * 100), type: u.MessageType.PROGRESS, phase: u.LoadingPhase.DOWNLOADING });
                }, y.readAsArrayBuffer(m.response);
              }
              if (m.readyState == 4 && m.status != 200) {
                var A = "Failed to fetch binary data from server. Server code: " + m.status + ". This might be due to CORS policy of your browser if you run this as a local file.";
                throw x({ message: "Downloading geometry", percent: 0, type: u.MessageType.FAILED, phase: u.LoadingPhase.DOWNLOADING }), E.onerror && E.onerror(A), A;
              }
            }, m.responseType = "blob", g != null && Object.keys(g).forEach(function(y) {
              var A = g[y];
              m.setRequestHeader(y, A);
            }), m.send();
          } else if (h instanceof Blob || typeof File < "u" && h instanceof File) {
            var v = new FileReader();
            v.onloadend = function() {
              v.result && typeof v.result != "string" && (E._buffer = v.result, E._view = new DataView(E._buffer), E.onloaded && E.onloaded(E));
            }, v.onprogress = function(y) {
              x({ message: "Loading binary data", percent: Math.floor(y.loaded / y.total * 100), type: u.MessageType.PROGRESS, phase: u.LoadingPhase.DOWNLOADING });
            }, v.readAsArrayBuffer(h);
          } else
            h instanceof ArrayBuffer && (this._buffer = h, this._view = new DataView(E._buffer), E.onloaded && E.onloaded(E));
        }, f.prototype.seek = function(h) {
          if (h < 0 || h > this._buffer.byteLength)
            throw "Position out of range.";
          this._position = h;
        }, f.prototype.isEOF = function() {
          if (this._position == null)
            throw "Position is not defined";
          return this._position == this._buffer.byteLength;
        }, f.prototype.readArray = function(h, g, x) {
          g == null && (g = 1);
          var E = h * g, m = this._position;
          return this._position += E, this.reportProgress(), g === 1 ? new x(this._buffer.slice(m, m + E))[0] : new x(this._buffer.slice(m, m + E));
        }, f.prototype.move = function(h) {
          var g = this._position;
          return this._position += h, this.reportProgress(), g;
        }, f.prototype.reportProgress = function() {
          this._progress != null && this._position - this._lastProgress > 5e5 && (this._lastProgress = this._position, this._progress({ type: u.MessageType.PROGRESS, message: "Reading data", percent: Math.floor(100 * this._position / this._buffer.byteLength), phase: u.LoadingPhase.READING }));
        }, f.prototype.readByte = function() {
          return this.readUint8();
        }, f.prototype.readByteArray = function(h) {
          return this.readUint8Array(h);
        }, f.prototype.readUint8 = function() {
          var h = this.move(1);
          return this._view.getUint8(h);
        }, f.prototype.readUint8Array = function(h) {
          return this.readArray(1, h, Uint8Array);
        }, f.prototype.readInt16 = function() {
          var h = this.move(2);
          return this._view.getInt16(h, !0);
        }, f.prototype.readInt16Array = function(h) {
          return this.readArray(2, h, Int16Array);
        }, f.prototype.readUInt16 = function() {
          var h = this.move(2);
          return this._view.getUint16(h, !0);
        }, f.prototype.readUint16Array = function(h) {
          return this.readArray(2, h, Uint16Array);
        }, f.prototype.readInt32 = function() {
          var h = this.move(4);
          return this._view.getInt32(h, !0);
        }, f.prototype.readInt32Array = function(h) {
          return this.readArray(4, h, Int32Array);
        }, f.prototype.readUint32 = function() {
          var h = this.move(4);
          return this._view.getUint32(h, !0);
        }, f.prototype.readUint32Array = function(h) {
          return this.readArray(4, h, Uint32Array);
        }, f.prototype.readFloat32 = function() {
          var h = this.move(4);
          return this._view.getFloat32(h, !0);
        }, f.prototype.readFloat32Array = function(h) {
          return this.readArray(4, h, Float32Array);
        }, f.prototype.readFloat64 = function() {
          var h = this.move(8);
          return this._view.getFloat64(h, !0);
        }, f.prototype.readFloat64Array = function(h) {
          return this.readArray(8, h, Float64Array);
        }, f.prototype.readChar = function(h) {
          h == null && (h = 1);
          var g = this.readByteArray(h), x = new Array(h);
          for (var E in g)
            x[E] = String.fromCharCode(g[E]);
          return h === 1 ? x[0] : x;
        }, f.prototype.readPoint = function(h) {
          h == null && (h = 1);
          for (var g = this.readFloat32Array(3 * h), x = new Array(h), E = 0; E < h; E++) {
            var m = 3 * E * 4, v = new Float32Array(g.buffer, m, 3);
            x[E] = v;
          }
          return h === 1 ? x[0] : x;
        }, f.prototype.readRgba = function(h) {
          h == null && (h = 1);
          for (var g = this.readByteArray(4 * h), x = new Array(h), E = 0; E < h; E++) {
            var m = 4 * E, v = new Uint8Array(g.buffer, m, 4);
            x[E] = v;
          }
          return h === 1 ? x[0] : x;
        }, f.prototype.readPackedNormal = function(h) {
          h == null && (h = 1);
          for (var g = this.readUint8Array(2 * h), x = new Array(h), E = 0; E < h; E++) {
            var m = new Uint8Array(g.buffer, 2 * E, 2);
            x[E] = m;
          }
          return h === 1 ? x[0] : x;
        }, f.prototype.readMatrix4x4 = function(h) {
          h == null && (h = 1);
          for (var g = this.readFloat32Array(16 * h), x = new Array(h), E = 0; E < h; E++) {
            var m = 16 * E * 4, v = new Float32Array(g.buffer, m, 16);
            x[E] = v;
          }
          return h === 1 ? x[0] : x;
        }, f.prototype.readMatrix4x4_64 = function(h) {
          h == null && (h = 1);
          for (var g = this.readFloat64Array(16 * h), x = new Array(h), E = 0; E < h; E++) {
            var m = 16 * E * 8, v = new Float64Array(g.buffer, m, 16);
            x[E] = v;
          }
          return h === 1 ? x[0] : x;
        }, f.prototype.readData = function(h) {
          var g = this.move(h);
          return this._buffer.slice(g, g + h);
        }, f;
      }();
      l.BinaryReader = d;
    }, 3948: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.Region = l.ModelGeometry = void 0;
      var u = c(6105), d = c(3918), f = c(8194), h = c(3425), g = c(6920), x = c(3753), E = function() {
        function y() {
          this.normals = new Uint8Array(0), this.indices = new Float32Array(0), this.products = new Float32Array(0), this.transformations = new Float32Array(0), this.styleIndices = new Uint16Array(0), this.states = new Uint8Array(0), this.vertices = new Float32Array(0), this.matrices = new Float32Array(0), this.styles = new Uint8Array(0), this.meter = 1e3, this.wcs = [0, 0, 0], this._iVertex = 0, this._iIndexForward = 0, this._iIndexBackward = 0, this._iTransform = 0, this._iMatrix = 0, this._maxVersionSupported = 4, this.productMaps = {}, this.productIdLookup = [], this.breaks = { 10: [], 20: [], 40: [], 30: [], 50: [], 60: [], 70: [], 80: [], 90: [], 100: [] }, this._styleMap = new v();
        }
        return y.prototype.parse = function(A, b) {
          var C = this;
          if (A && !A.isEOF()) {
            this._reader = A;
            var T = A;
            if (T.readInt32() !== 94132117)
              throw new Error("Magic number mismatch. This is not a wexBIM file.");
            var w = T.readByte();
            if (w > this._maxVersionSupported)
              throw new Error("Viewer doesn't support version ".concat(w, " of the wexBIM stream"));
            var R = T.readInt32(), O = T.readInt32(), D = T.readInt32(), k = T.readInt32(), W = T.readInt32(), L = T.readInt32();
            this.meter = T.readFloat32(), w > 3 && (this.wcs = [T.readFloat64(), T.readFloat64(), T.readFloat64()]);
            var z = T.readInt16();
            this.vertices = new Float32Array(this.square(4, 3 * O)), this.normals = new Uint8Array(6 * D), this.indices = new Float32Array(3 * D), this.styleIndices = new Uint16Array(3 * D), this.styles = new Uint8Array(this.square(1, 4 * (L + 2))), this.products = new Float32Array(3 * D), this.states = new Uint8Array(3 * D * 2), this.transformations = new Float32Array(3 * D), this.matrices = new Float32Array(this.square(4, 16 * k)), this.productMaps = {}, this.regions = new Array(z), this._iVertex = 0, this._iIndexForward = 0, this._iIndexBackward = 3 * D, this._iTransform = 0, this._iMatrix = 0;
            for (var P = 0; P < z; P++)
              (N = new m()).population = T.readInt32(), N.centre = T.readFloat32Array(3), N.bbox = T.readFloat32Array(6), this.regions[P] = N;
            for (var Q = 0; Q < L; Q++) {
              var Y = T.readInt32(), ie = 255 * T.readFloat32(), te = 255 * T.readFloat32(), Z = 255 * T.readFloat32(), ae = 255 * T.readFloat32();
              this.styles.set([ie, te, Z, ae], 4 * Q), this._styleMap.Add({ id: Y, index: Q, transparent: ae < 254 });
            }
            for (this.styles.set([255, 255, 255, 255], 4 * Q), this._styleMap.Add({ id: -1, index: Q, transparent: !1 }), Q++, this.styles.set([0, 255, 255, 100], 4 * Q), this._styleMap.Add({ id: -2, index: Q, transparent: !1 }), P = 0; P < W; P++) {
              var G = T.readInt32(), U = T.readInt16(), F = T.readFloat32Array(6), M = new x.ProductMap();
              M.productID = G, M.renderId = P + 1, M.type = U, M.bBox = F, M.spans = [], this.productMaps[G] = M, this.productIdLookup[P + 1] = G, U !== h.ProductType.IFCSPACE && U !== h.ProductType.IFCOPENINGELEMENT || M.states.push(f.State.HIDDEN);
            }
            if (w >= 3)
              for (var I = 0; I < z; I++) {
                for (var N = this.regions[I], V = T.readInt32(), q = new Array(V), H = 0; H < V; H++) {
                  var ne = this.readShape(w), he = T.readInt32();
                  if (he !== 0) {
                    var j = T.getSubReader(he);
                    if ((ye = new d.TriangulatedShape()).parse(j), !j.isEOF())
                      throw new Error("Incomplete reading of geometry for shape instance ".concat(ne[0].iLabel));
                    q[H] = { shapes: ne, geometry: ye };
                  }
                }
                for (b.orderGeometryBySize && q.sort(function(Ae, fe) {
                  var _e, Ie, Be = (_e = Ae.shapes[0]) === null || _e === void 0 ? void 0 : _e.pLabel, $e = (Ie = fe.shapes[0]) === null || Ie === void 0 ? void 0 : Ie.pLabel;
                  if (Be == null || $e == null)
                    return 0;
                  var Me = C.productMaps[Be], J = C.productMaps[$e];
                  if (Me == null)
                    return 1;
                  if (J == null)
                    return -1;
                  var K = Me.bBox[3] * Me.bBox[4] * Me.bBox[5];
                  return J.bBox[3] * Me.bBox[4] * Me.bBox[5] - K;
                }), H = 0; H < V; H++) {
                  var Fe = q[H];
                  this.feedDataArrays(Fe.shapes, Fe.geometry);
                }
              }
            else
              for (var X = 0; X < R; X++) {
                var ye;
                ne = this.readShape(w), (ye = new d.TriangulatedShape()).parse(T), this.feedDataArrays(ne, ye);
              }
            if (!T.isEOF())
              throw this.progress({ type: g.MessageType.FAILED, message: "Processed data", percent: 0, phase: g.LoadingPhase.READING }), new Error("Binary reader is not at the end of the file.");
            this.progress({ type: g.MessageType.PROGRESS, message: "Processed data", percent: 100, phase: g.LoadingPhase.READING }), this.transparentIndex = this._iIndexForward, this.breaks[100] = [this.transparentIndex - 1, this.transparentIndex];
          }
        }, y.prototype.square = function(A, b) {
          if (A == null || b == null)
            throw new Error('Wrong arguments for "square" function.');
          if (b === 0)
            return 0;
          for (var C = b * A, T = Math.ceil(Math.sqrt(C / 4)); 4 * T % A != 0; )
            T++;
          return T * T * 4 / A;
        }, y.prototype.feedDataArrays = function(A, b) {
          var C = this;
          A.forEach(function(T) {
            var w = 0, R = w = T.transparent ? C._iIndexBackward - b.indices.length : C._iIndexForward, O = C.productMaps[T.pLabel];
            O === void 0 && ((O = new x.ProductMap()).productID = 0, O.renderId = 0, O.type = h.ProductType.IFCOPENINGELEMENT, O.bBox = new Float32Array(6), O.spans = [], O.states.push(f.State.HIDDEN), C.productMaps[T.pLabel] = O), C.normals.set(b.normals, 2 * w);
            var D = O.type === h.ProductType.IFCSPACE || O.type === h.ProductType.IFCOPENINGELEMENT ? f.State.HIDDEN : 255;
            b.indices.forEach(function(L) {
              C.indices[w] = L + C._iVertex / 3, C.products[w] = O.renderId, C.styleIndices[w] = T.style, C.transformations[w] = T.transform, C.states[2 * w] = D, C.states[2 * w + 1] = 255, w++;
            });
            var k = w;
            O.spans.push(new Int32Array([R, k])), T.transparent ? C._iIndexBackward -= b.indices.length : C._iIndexForward += b.indices.length;
            var W = (C._iIndexForward + C.indices.length - C._iIndexBackward) / C.indices.length * 100;
            Object.getOwnPropertyNames(C.breaks).forEach(function(L) {
              var z = +L;
              C.breaks[z].length === 0 && W > z && (C.breaks[z] = [C._iIndexForward, C._iIndexBackward]);
            });
          }, this), this.vertices.set(b.vertices, this._iVertex), this._iVertex += b.vertices.length;
        }, y.prototype.readShape = function(A) {
          for (var b = this._reader, C = b.readInt32(), T = new Array(), w = 0; w < C; w++) {
            var R = b.readInt32(), O = (b.readInt16(), b.readInt32()), D = b.readInt32(), k = null;
            C > 1 && (k = A === 1 ? b.readFloat32Array(16) : b.readFloat64Array(16), this.matrices.set(k, this._iMatrix), this._iMatrix += 16);
            var W = this._styleMap.GetStyle(D);
            W === null && (W = this._styleMap.GetStyle(-1));
            var L = this.productMaps[R] ? this.productMaps[R].type : h.ProductType.IFCPRODUCT;
            L !== h.ProductType.IFCSPACE && L !== h.ProductType.IFCOPENINGELEMENT || (W = this._styleMap.GetStyle(-2)), T.push({ pLabel: R, iLabel: O, style: W.index, transparent: W.transparent, transform: k != null ? this._iTransform++ : -1 });
          }
          return T;
        }, y.prototype.load = function(A, b, C, T) {
          var w = this;
          T === void 0 && (T = {}), this.progress = C || function(D) {
          };
          var R = new u.BinaryReader(), O = this;
          R.onloaded = function() {
            O.parse(R, T), O.onloaded && O.onloaded(w);
          }, R.onerror = function(D) {
            O.onerror && O.onerror(D);
          }, R.load(A, b, C);
        }, y;
      }();
      l.ModelGeometry = E;
      var m = function() {
        function y(A) {
          this.population = -1, this.centre = null, this.bbox = null, A && (this.population = A.population, A.centre && (this.centre = new Float32Array(A.centre)), A.bbox && (this.bbox = new Float32Array(A.bbox)));
        }
        return y.clone = function(A) {
          var b = new y();
          return b.population = A.population, A.centre && (b.centre = new Float32Array(A.centre)), A.bbox && (b.bbox = new Float32Array(A.bbox)), b;
        }, y.prototype.merge = function(A) {
          if (this.population === -1 && this.centre === null && this.bbox === null)
            return new y(A);
          var b = new y();
          if (b.population = this.population + A.population, this.bbox && A.bbox) {
            var C = Math.min(this.bbox[0], A.bbox[0]), T = Math.min(this.bbox[1], A.bbox[1]), w = Math.min(this.bbox[2], A.bbox[2]), R = Math.max(this.bbox[0] + this.bbox[3], A.bbox[0] + A.bbox[3]), O = Math.max(this.bbox[1] + this.bbox[4], A.bbox[1] + A.bbox[4]), D = Math.max(this.bbox[2] + this.bbox[5], A.bbox[2] + A.bbox[5]), k = R - C, W = O - T, L = D - w, z = (C + R) / 2, P = (T + O) / 2, Q = (w + D) / 2;
            b.bbox = new Float32Array([C, T, w, k, W, L]), b.centre = new Float32Array([z, P, Q]);
          } else
            this.bbox ? (b.bbox = new Float32Array(this.bbox), b.centre = new Float32Array(this.centre)) : (b.bbox = new Float32Array(A.bbox), b.centre = new Float32Array(A.centre));
          return b;
        }, y;
      }();
      l.Region = m;
      var v = function() {
        function y() {
          this._internal = {};
        }
        return y.prototype.Add = function(A) {
          this._internal[A.id] = A;
        }, y.prototype.GetStyle = function(A) {
          return this._internal[A] || null;
        }, y;
      }();
    }, 3918: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.TriangulatedShape = void 0;
      var u = c(6105), d = function() {
        function f() {
          var h = this;
          this.load = function(g) {
            var x = new u.BinaryReader(), E = h;
            x.onloaded = function() {
              E.parse(x), E.onloaded && E.onloaded(h);
            }, x.load(g, null, null);
          };
        }
        return f.prototype.parse = function(h) {
          var g = this, x = (h.readByte(), h.readInt32()), E = h.readInt32();
          g.vertices = h.readFloat32Array(3 * x), g.indices = new Uint32Array(3 * E), g.normals = new Uint8Array(6 * E);
          var m, v = 0;
          m = x <= 255 ? function(O) {
            return h.readByteArray(O);
          } : x <= 65535 ? function(O) {
            return h.readUint16Array(O);
          } : function(O) {
            return h.readInt32Array(O);
          };
          var y = h.readInt32();
          if (x !== 0 && E !== 0)
            for (var A = 0; A < y; A++) {
              var b = h.readInt32();
              if (b != 0) {
                var C = b > 0;
                if (b = Math.abs(b), C) {
                  var T = h.readByteArray(2), w = m(3 * b);
                  g.indices.set(w, v);
                  for (var R = 0; R < 3 * b; R++)
                    g.normals[2 * v] = T[0], g.normals[2 * v + 1] = T[1], v++;
                } else
                  for (R = 0; R < b; R++)
                    g.indices[v] = m(), g.normals.set(h.readByteArray(2), 2 * v), v++, g.indices[v] = m(), g.normals.set(h.readByteArray(2), 2 * v), v++, g.indices[v] = m(), g.normals.set(h.readByteArray(2), 2 * v), v++;
              }
            }
        }, f;
      }();
      l.TriangulatedShape = d;
    }, 2607: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.SectionBox = void 0;
      var u = c(887), d = c(1150), f = function() {
        function h(g) {
          var x = this;
          this.setToInfinity(), this._onChange = function() {
            x._lastWcs = null, x._lastBBox = null, g && g();
          };
        }
        return Object.defineProperty(h.prototype, "location", { get: function() {
          return this._location;
        }, set: function(g) {
          this._location = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "rotationX", { get: function() {
          return this._rotationX;
        }, set: function(g) {
          this._rotationX = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "rotationY", { get: function() {
          return this._rotationY;
        }, set: function(g) {
          this._rotationY = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "rotationZ", { get: function() {
          return this._rotationZ;
        }, set: function(g) {
          this._rotationZ = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "lengthX", { get: function() {
          return this._lengthX;
        }, set: function(g) {
          this._lengthX = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "lengthY", { get: function() {
          return this._lengthY;
        }, set: function(g) {
          this._lengthY = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(h.prototype, "lengthZ", { get: function() {
          return this._lengthZ;
        }, set: function(g) {
          this._lengthZ = g, this._onChange();
        }, enumerable: !1, configurable: !0 }), h.prototype.getMatrix = function(g) {
          var x = u.mat4.create();
          x = u.mat4.rotateX(u.mat4.create(), x, -this.rotationX / 180 * Math.PI), x = u.mat4.rotateY(u.mat4.create(), x, -this.rotationY / 180 * Math.PI), x = u.mat4.rotateZ(u.mat4.create(), x, -this.rotationZ / 180 * Math.PI);
          var E = u.vec3.subtract(u.vec3.create(), this.location, g), m = u.vec3.scale(u.vec3.create(), E, -1);
          x = u.mat4.translate(u.mat4.create(), x, m);
          var v = u.mat4.ortho(u.mat4.create(), -this.lengthX / 2, this.lengthX / 2, -this.lengthY / 2, this.lengthY / 2, -this.lengthZ / 2, this.lengthZ / 2);
          return u.mat4.multiply(u.mat4.create(), v, x);
        }, Object.defineProperty(h.prototype, "isSet", { get: function() {
          return Number.isFinite(this._lengthX);
        }, enumerable: !1, configurable: !0 }), h.prototype.clear = function() {
          this.setToInfinity();
        }, h.prototype.setToInfinity = function() {
          this._location = u.vec3.fromValues(0, 0, 0), this._rotationX = this._rotationY = this._rotationZ = 0, this._lengthX = this._lengthY = this._lengthZ = Number.MAX_SAFE_INTEGER, this._onChange && this._onChange();
        }, h.prototype.setToBox = function(g) {
          this._location = u.vec3.clone(g.location), this._lengthX = g._lengthX, this._lengthY = g._lengthY, this._lengthZ = g._lengthZ, this._rotationX = g._rotationX, this._rotationY = g._rotationY, this._rotationZ = g._rotationZ, this._onChange && this._onChange();
        }, h.prototype.setToBoundingBox = function(g) {
          this._location = u.vec3.fromValues(g[0] + g[3] / 2, g[1] + g[4] / 2, g[2] + g[5] / 2), this._lengthX = g[3], this._lengthY = g[4], this._lengthZ = g[5], this._rotationX = 0, this._rotationY = 0, this._rotationZ = 0, this._onChange && this._onChange();
        }, h.prototype.setToPlanes = function(g) {
          if (g == null || g.length !== 6)
            throw new Error("Invalid input: box has to be defined by 3 clipping planes");
          for (var x = [], E = [], m = 0; m < 6; m++)
            for (var v = g[m], y = m + 1; y < 6; y++) {
              var A = g[y];
              if (this.areOrthogonal(v, A))
                for (var b = y + 1; b < 6; b++) {
                  var C = g[b];
                  if (this.areOrthogonal(v, C) && this.areOrthogonal(A, C)) {
                    var T = v.direction, w = A.direction, R = C.direction, O = v.location, D = A.location, k = C.location, W = this.getDparam(T, O), L = this.getDparam(w, D), z = this.getDparam(R, k), P = u.vec3.fromValues(-W, -L, -z), Q = u.mat3.fromValues(T[0], w[0], R[0], T[1], w[1], R[1], T[2], w[2], R[2]), Y = u.mat3.determinant(Q);
                    if (Math.abs(Y) < 1e-6)
                      console.warn("Singular system of linear equations. Intersection point for section box can't be computed");
                    else {
                      var ie = u.mat3.invert(u.mat3.create(), Q), te = u.vec3.transformMat3(u.vec3.create(), P, ie);
                      E.push(te), this.addPointToResults(x, v, te), this.addPointToResults(x, A, te), this.addPointToResults(x, C, te);
                    }
                  }
                }
            }
          if (E.length !== 8)
            return console.warn("Section box based on clipping planes should have exactly 8 intersection points"), !1;
          var Z = this.getCentroid(E), ae = this.getSize(x[0].plane, g), G = this.getSize(x[1].plane, g), U = this.getSize(x[2].plane, g);
          if (ae == null || G == null || U == null)
            return console.warn("Section box based on clipping planes should have always two planes pointing to opposite direction"), !1;
          var F = u.vec3.normalize(u.vec3.create(), d.VectorUtils.getVec3(x[0].plane.direction)), M = u.vec3.normalize(u.vec3.create(), d.VectorUtils.getVec3(x[1].plane.direction)), I = u.vec3.normalize(u.vec3.create(), d.VectorUtils.getVec3(x[2].plane.direction)), N = u.quat.setAxes(u.quat.create(), u.vec3.negate(u.vec3.create(), I), F, M), V = this.toEulerAngles(N);
          return this._location = Z, this._lengthX = ae, this._lengthY = G, this._lengthZ = U, this._rotationX = 180 * V.roll / Math.PI, this._rotationY = 180 * V.pitch / Math.PI, this._rotationZ = 180 * -V.yaw / Math.PI, this._onChange && this._onChange(), !0;
        }, h.prototype.getSize = function(g, x) {
          var E = this, m = x.filter(function(R) {
            return E.isOpposite(d.VectorUtils.getVec3(g.direction), d.VectorUtils.getVec3(R.direction));
          }).pop();
          if (m == null)
            return null;
          var v = m.direction[0], y = m.direction[1], A = m.direction[2], b = this.getDparam(m.direction, m.location), C = g.location[0], T = g.location[1], w = g.location[2];
          return Math.abs(v * C + y * T + A * w + b) / u.vec3.length(d.VectorUtils.getVec3(m.direction));
        }, h.prototype.toEulerAngles = function(g) {
          var x = g[0], E = g[1], m = g[2], v = g[3], y = 2 * (v * x + E * m), A = 1 - 2 * (x * x + E * E), b = 2 * (v * E - m * x), C = 2 * (v * m + x * E), T = 1 - 2 * (E * E + m * m);
          return { roll: Math.atan2(y, A), pitch: Math.abs(b) >= 1 ? Math.PI / 2 * Math.sign(b) : Math.asin(b), yaw: Math.atan2(C, T) };
        }, h.prototype.isOpposite = function(g, x) {
          var E = u.vec3.angle(g, x);
          return Math.abs(E - Math.PI) < 0.01;
        }, h.prototype.getCentroid = function(g) {
          var x = g.reduce(function(E, m) {
            return u.vec3.add(u.vec3.create(), E, m);
          });
          return u.vec3.scale(u.vec3.create(), x, 1 / g.length);
        }, h.prototype.addPointToResults = function(g, x, E) {
          var m = g.filter(function(v) {
            return v.plane === x;
          }).pop();
          m == null && (m = { plane: x, points: [] }, g.push(m)), m.points.push(E);
        }, h.prototype.getDparam = function(g, x) {
          return -g[0] * x[0] - g[1] * x[1] - g[2] * x[2];
        }, h.prototype.areOrthogonal = function(g, x) {
          var E = u.vec3.angle(d.VectorUtils.getVec3(g.direction), d.VectorUtils.getVec3(x.direction));
          return Math.abs(E - Math.PI / 2) < 0.01;
        }, h.prototype.getBoundingBox = function(g) {
          if (this._lastBBox && this._lastWcs && u.vec3.distance(this._lastWcs, g) < 1e-6)
            return this._lastBBox;
          var x = this.lengthX / 2, E = this.lengthY / 2, m = this.lengthZ / 2, v = [[-x, -E, -m], [-x, -E, +m], [-x, +E, -m], [-x, +E, +m], [+x, -E, -m], [+x, -E, +m], [+x, +E, -m], [+x, +E, +m]], y = u.vec3.subtract(u.vec3.create(), this.location, g), A = u.mat4.create();
          A = u.mat4.rotateX(u.mat4.create(), A, this.rotationX * Math.PI / 180), A = u.mat4.rotateY(u.mat4.create(), A, this.rotationY * Math.PI / 180), A = u.mat4.rotateZ(u.mat4.create(), A, this.rotationZ * Math.PI / 180), A = u.mat4.translate(u.mat4.create(), A, y);
          var b = v.map(function(w) {
            return u.vec3.transformMat4(u.vec3.create(), d.VectorUtils.getVec3(w), A);
          }), C = b.reduce(function(w, R) {
            return u.vec3.fromValues(Math.min(w[0], R[0]), Math.min(w[1], R[1]), Math.min(w[2], R[2]));
          }), T = b.reduce(function(w, R) {
            return u.vec3.fromValues(Math.max(w[0], R[0]), Math.max(w[1], R[1]), Math.max(w[2], R[2]));
          });
          return this._lastWcs = g, this._lastBBox = new Float32Array([C[0], C[1], C[2], T[0] - C[0], T[1] - C[1], T[2] - C[2]]), this._lastBBox;
        }, h;
      }();
      l.SectionBox = f;
    }, 1205: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.DepthReader = void 0;
      var u = c(2411), d = c(1615), f = c(9499), h = function() {
        function g(x, E) {
          this.gl = x, this.glVersion = E, this.vertices = new Float32Array([0, 0, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1]);
          var m = function(v, y) {
            if (x.shaderSource(v, y), x.compileShader(v), !x.getShaderParameter(v, x.COMPILE_STATUS)) {
              var A = x.getShaderInfoLog(v);
              return console.error(A), !1;
            }
            return !0;
          };
          if (this.fragmentShader = x.createShader(x.FRAGMENT_SHADER), !m(this.fragmentShader, u.depth_fragment_shader))
            throw new Error("Failed to compile depth reading fragment shader");
          if (this.vertexShader = x.createShader(x.VERTEX_SHADER), !m(this.vertexShader, d.depth_vertex_shader))
            throw new Error("Failed to compile depth reading vertex shader");
          this.program = x.createProgram(), x.attachShader(this.program, this.vertexShader), x.attachShader(this.program, this.fragmentShader), x.linkProgram(this.program), x.getProgramParameter(this.program, x.LINK_STATUS) ? (x.useProgram(this.program), this.texUniform = x.getUniformLocation(this.program, "texture"), this.vertAttrs = x.getAttribLocation(this.program, "point"), this.vertBuffer = x.createBuffer(), x.bindBuffer(x.ARRAY_BUFFER, this.vertBuffer), x.bufferData(x.ARRAY_BUFFER, this.vertices, x.STATIC_DRAW)) : console.error("Could not initialise shaders ");
        }
        return g.prototype.draw = function(x) {
          var E = this.gl;
          E.useProgram(this.program), E.activeTexture(E.TEXTURE0), E.bindTexture(E.TEXTURE_2D, x), E.uniform1i(this.texUniform, 0), E.bindBuffer(E.ARRAY_BUFFER, this.vertBuffer), E.enableVertexAttribArray(this.vertAttrs), E.vertexAttribPointer(this.vertAttrs, 2, E.FLOAT, !1, 0, 0), E.clearColor(0, 0, 0, 0), E.clear(E.COLOR_BUFFER_BIT | E.DEPTH_BUFFER_BIT), E.drawArrays(E.TRIANGLES, 0, 6);
        }, g.prototype.getDepths = function(x, E, m, v) {
          var y = this.gl;
          y.useProgram(this.program);
          var A = new f.Framebuffer(y, m, v, !1, this.glVersion);
          y.viewport(0, 0, m, v), this.draw(E);
          var b = x.map(function(C) {
            return A.getPixel(C.x, C.y)[0];
          });
          return A.delete(), b;
        }, g.prototype.getDepth = function(x, E, m, v, y) {
          return this.getDepths([{ x, y: E }], m, v, y)[0];
        }, g.prototype.delete = function() {
          var x = this.gl;
          x.deleteBuffer(this.vertBuffer), x.deleteShader(this.fragmentShader), x.deleteShader(this.vertexShader), x.deleteProgram(this.program);
        }, g;
      }();
      l.DepthReader = h;
    }, 2411: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.depth_fragment_shader = void 0, l.depth_fragment_shader = ` precision mediump float;
 
 varying vec2 position;
 
 uniform sampler2D texture;
 
 void main() {
 
 float depth = texture2D(texture, position).x; 

 
 gl_FragColor = vec4(depth, depth, depth, 1.0);
 }`;
    }, 1615: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.depth_vertex_shader = void 0, l.depth_vertex_shader = `attribute highp vec2 point;

varying vec2 position;

void main(void) {
 float x = (point.x * 2.0) - 1.0;
 float y = (point.y * 2.0) - 1.0;
 gl_Position = vec4(x, y, 0.0, 1.0);
 position = point;
}`;
    }, 380: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.fragment_shader = void 0, l.fragment_shader = `precision highp float;

uniform vec4 uClippingPlaneA;
uniform vec4 uClippingPlaneB;
uniform bool uClippingA;
uniform bool uClippingB;


uniform vec3 uGBC;


uniform vec3 uLight;


uniform mat4 uSectionBox;

varying vec4 vColor;

varying vec3 vPosition;

varying vec3 vNormal;


varying float vDiscard;

void main(void) {
 
 if ( vDiscard > 0.5) discard;
 
 
 vec4 fp = uSectionBox * vec4(vPosition, 1);
 if (
 fp.x > 1.0 || fp.x < -1.0 || 
 fp.y > 1.0 || fp.y < -1.0 || 
 fp.z > 1.0 || fp.z < -1.0) 
 discard;

 
 if (uClippingA)
 {
 
 vec4 p = uClippingPlaneA;
 vec3 x = vPosition;
 float distance = (dot(p.xyz, x) + p.w) / length(p.xyz);
 if (distance < 0.0){
 discard;
 return;
 }
 }

 
 if (uClippingB)
 {
 
 vec4 p = uClippingPlaneB;
 vec3 x = vPosition;
 float distance = (dot(p.xyz, x) + p.w) / length(p.xyz);
 if (distance < 0.0) {
 discard;
 return;
 }
 }
 
 
 if (length(vNormal) < 0.1) {
 gl_FragColor = vColor;
 return;
 }

 
 vec3 normalInterp = gl_FrontFacing ? vNormal : -vNormal;

 
 float Ka = 1.0; 
 float Kd = 1.0; 
 float Ks = 0.2; 
 float shininessVal = 30.0; 

 vec3 ambientColor = vColor.rgb * 0.2; 
 vec3 diffuseColor = vColor.rgb;
 vec3 specularColor = vec3(1.0, 1.0, 1.0);

 vec3 N = normalize(normalInterp);
 vec3 L = normalize(uLight - vPosition);

 
 float lambertian = max(dot(N, L), 0.0);

 float specular = 0.0;

 if(lambertian > 0.0) {
 vec3 R = reflect(-L, N); 
 
 vec3 V = L; 

 
 float specAngle = max(dot(R, V), 0.0);
 specular = pow(specAngle, shininessVal);
 }

 vec4 fragColor = vec4(
 Ka * ambientColor +
 Kd * lambertian * diffuseColor +
 Ks * specular * specularColor
 , vColor.a
 );

 
 
 fragColor.r = (pow(fragColor.r,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;
 fragColor.g = (pow(fragColor.g,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;
 fragColor.b = (pow(fragColor.b,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;

 gl_FragColor = fragColor;
}`;
    }, 6907: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.fragment_shader_300 = void 0, l.fragment_shader_300 = `#version 300 es


precision highp float;

uniform vec4 uClippingPlaneA;
uniform vec4 uClippingPlaneB;
uniform bool uClippingA;
uniform bool uClippingB;

uniform vec3 uGBC;


uniform vec3 uLight;


uniform mat4 uSectionBox;

in vec4 vColor;

in vec3 vPosition;

in vec3 vNormal;


in float vDiscard;


out vec4 vFragColor;

void main(void) {
 
 if ( vDiscard > 0.5) discard;
 
 
 vec4 fp = uSectionBox * vec4(vPosition, 1);
 if (
 fp.x > 1.0 || fp.x < -1.0 || 
 fp.y > 1.0 || fp.y < -1.0 || 
 fp.z > 1.0 || fp.z < -1.0) 
 discard;

 
 if (uClippingA)
 {
 
 vec4 p = uClippingPlaneA;
 vec3 x = vPosition;
 float distance = (dot(p.xyz, x) + p.w) / length(p.xyz);
 if (distance < 0.0){
 discard;
 return;
 }
 }

 
 if (uClippingB)
 {
 
 vec4 p = uClippingPlaneB;
 vec3 x = vPosition;
 float distance = (dot(p.xyz, x) + p.w) / length(p.xyz);
 if (distance < 0.0) {
 discard;
 return;
 }

 }

 
 if (length(vNormal) < 0.1) {
 vFragColor = vColor;
 return;
 }

 
 vec3 normalInterp = gl_FrontFacing ? vNormal : -vNormal;

 
 float Ka = 0.8; 
 float Kd = 1.0; 
 float Ks = 0.15; 
 float shininessVal = 30.0; 

 vec3 ambientColor = vColor.rgb * 0.5; 
 vec3 diffuseColor = vColor.rgb;
 vec3 specularColor = vec3(1.0, 1.0, 1.0);

 vec3 N = normalize(normalInterp);
 vec3 L = normalize(uLight - vPosition);

 
 
 float lambertian = max(dot(N, L), 0.0);

 
 float specular = 0.0;

 
 if (lambertian > 0.0) {
 vec3 R = reflect(-L, N); 
 vec3 V = L; 

 
 float specAngle = max(dot(R, V), 0.0);
 specular = pow(specAngle, shininessVal);
 }

vec4 fragColor = vec4(
 Ka * ambientColor +
 Kd * lambertian * diffuseColor +
 Ks * specular * specularColor
 , vColor.a
 );

 
 
 fragColor.r = (pow(fragColor.r,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;
 fragColor.g = (pow(fragColor.g,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;
 fragColor.b = (pow(fragColor.b,uGBC[0]) - 0.5)*uGBC[1] + uGBC[2] + 0.5;

 vFragColor = fragColor;
}`;
    }, 2241: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.vertex_shader = void 0, l.vertex_shader = `attribute highp float aVertexIndex;
attribute highp float aTransformationIndex;
attribute highp float aStyleIndex;
attribute highp float aProduct;
attribute highp vec2 aState;
attribute highp vec2 aNormal;


uniform mat4 uMVMatrix;
uniform mat4 uPMatrix;


uniform vec4 uHighlightColour;


uniform vec4 uHoverPickColour;


uniform vec4 uXRayColour;


uniform float uMeter;


uniform vec3 uWcs;



uniform int uColorCoding;






uniform int uRenderingMode;


uniform highp sampler2D uVertexSampler;
uniform highp float uVertexTextureSize;


uniform highp sampler2D uMatrixSampler;
uniform highp float uMatrixTextureSize;


uniform highp sampler2D uStyleSampler;
uniform highp float uStyleTextureSize;


uniform highp sampler2D uStateStyleSampler;


varying vec4 vColor;

varying vec3 vPosition;

varying vec3 vNormal;

varying mediump float vDiscard;

const float PI = 3.1415926535897932384626433832795;

vec3 getNormal(mat4 transform) {
 float U = aNormal[0];
 float V = aNormal[1];
 float lon = U / 252.0 * 2.0 * PI;
 float lat = V / 252.0 * PI;

 float x = sin(lon) * sin(lat);
 float z = cos(lon) * sin(lat);
 float y = cos(lat);

 vec3 normal = vec3(x, y, z);
 if (aTransformationIndex < -0.5) {
 return normalize(normal);
 }

 
 
 
 
 mat3 normTrans = mat3(transform);

 return normalize(vec3(normTrans * normal));
}

vec4 getIdColor(float id) {
 float B = floor(id / (256.0*256.0));
 float G = floor((id - B * 256.0*256.0) / 256.0);
 float R = mod(id, 256.0);
 
 

 return vec4(R / 255.0, G / 255.0, B / 255.0, 1.0);
}

vec2 getTextureCoordinates(float index, float size)
{
 float x = floor(mod(index + 0.5, size)); 
 float y = floor((index + 0.5)/ size); 
 
 return vec2((x + 0.5) / size, (y + 0.5) / size);
}


vec4 getColor() { 
 
 float restyle = aState[1];
 if (restyle > 224.5) {
 vec2 coords = getTextureCoordinates(aStyleIndex, uStyleTextureSize);
 vec4 col = texture2D(uStyleSampler, coords);
 
 
 if (uRenderingMode == 1) {
 float intensity = (col.r + col.g + col.b) / 3.0;
 return vec4(intensity, intensity, intensity, col.a);
 }

 
 return col;
 }

 
 
 vec2 coords = getTextureCoordinates(restyle, 15.0);
 vec4 col2 = texture2D(uStateStyleSampler, coords);

 
 if (uRenderingMode == 1) {
 float intensity = (col2.r + col2.g + col2.b) / 3.0;
 return vec4(intensity, intensity, intensity, col2.a);
 }

 return col2;
}

vec4 getVertexPosition(mat4 transform) {
 vec2 coords = getTextureCoordinates(aVertexIndex, uVertexTextureSize);
 vec3 point = vec3(texture2D(uVertexSampler, coords));

 if (aTransformationIndex < -0.5) {
 return vec4(point, 1.0);
 }

 return transform * vec4(point, 1.0);
}

mat4 getTransform() {
 if (aTransformationIndex < -0.5) {
 return mat4(1.0);
 }

 float tIndex = aTransformationIndex * 4.0;

 
 vec2 c1 = getTextureCoordinates(tIndex, uMatrixTextureSize);
 vec2 c2 = getTextureCoordinates(tIndex + 1.0, uMatrixTextureSize);
 vec2 c3 = getTextureCoordinates(tIndex + 2.0, uMatrixTextureSize);
 vec2 c4 = getTextureCoordinates(tIndex + 3.0, uMatrixTextureSize);

 
 vec4 v1 = texture2D(uMatrixSampler, c1);
 vec4 v2 = texture2D(uMatrixSampler, c2);
 vec4 v3 = texture2D(uMatrixSampler, c3);
 vec4 v4 = texture2D(uMatrixSampler, c4);

 
 return mat4(v1, v2, v3, v4);
}

void main(void) {
 int state = int(floor(aState[0] + 0.5));
 vDiscard = 0.0;

 if (state == 254 || 
 (uColorCoding == -1 && state == 251) || 
 (uColorCoding == -1 && (
 (uRenderingMode == 2 && state != 253 && state != 252 && state != 250) || 
 (uRenderingMode == 3 && (state == 253 || state == 252 || state == 250))) 
 ))
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0);
 vPosition = vec3(0.0, 0.0, 0.0);
 gl_Position = vec4(0.0, 0.0, 0.0, 1.0);
 return;
 }

 
 mat4 transform = getTransform();
 
 vPosition = vec3(getVertexPosition(transform)) + uWcs;
 vNormal = getNormal(transform);

 
 vec4 baseColor = getColor();

 
 if (baseColor.a < 0.98)
 {
 float correction = -0.002;
 if (uColorCoding == -2 || uColorCoding >= 0) {
 correction = -0.02;
 }
 vec3 trans = correction * uMeter * normalize(vNormal);
 vPosition = vPosition + trans;
 }

 
 if (uColorCoding == -2) {
 
 if ((uRenderingMode == 2 || uRenderingMode == 4) && state != 252 && state != 253)
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0); 
 } 
 else
 {
 float id = floor(aProduct + 0.5);
 vColor = getIdColor(id);
 vNormal = vec3(0.0, 0.0, 0.0);
 }
 }
 
 else if (uColorCoding >= 0) {
 
 if ((uRenderingMode == 2 || uRenderingMode == 4) && state != 252 && state != 253)
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0); 
 } 
 else
 {
 float id = float(uColorCoding);
 vColor = getIdColor(id);
 vNormal = vec3(0.0, 0.0, 0.0);
 }
 }
 
 else {
 
 
 
 if (state == 250) {
 baseColor = uHoverPickColour;
 }
 else if (state == 253) {
 baseColor = uHighlightColour;
 }
 
 else if (uRenderingMode == 2 || uRenderingMode == 3) {
 
 if (state == 252) { 
 baseColor = getColor();
 }
 
 else {
 baseColor = vec4(0.0, 0.0, 0.3, 0.5); 
 }
 }

 
 vColor = baseColor;
 }

 
 gl_Position = uPMatrix * uMVMatrix * vec4(vPosition, 1.0);
}`;
    }, 5761: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.vertex_shader_300 = void 0, l.vertex_shader_300 = `#version 300 es
in highp float aVertexIndex;
in highp float aTransformationIndex;
in highp float aStyleIndex;
in highp float aProduct;
in highp vec2 aState;
in highp vec2 aNormal;


uniform mat4 uMVMatrix;
uniform mat4 uPMatrix;


uniform vec4 uHighlightColour;


uniform vec4 uHoverPickColour;


uniform vec4 uXRayColour;


uniform float uMeter;


uniform vec3 uWcs;



uniform int uColorCoding;






uniform int uRenderingMode;


uniform highp sampler2D uVertexSampler;
uniform highp float uVertexTextureSize;


uniform highp sampler2D uMatrixSampler;
uniform highp float uMatrixTextureSize;


uniform highp sampler2D uStyleSampler;
uniform highp float uStyleTextureSize;


uniform highp sampler2D uStateStyleSampler;


out vec4 vColor;

out vec3 vPosition;

out vec3 vNormal;

out mediump float vDiscard;

const float PI = 3.1415926535897932384626433832795;

vec3 getNormal(mat4 transform) {
 float U = aNormal[0];
 float V = aNormal[1];
 float lon = U / 252.0 * 2.0 * PI;
 float lat = V / 252.0 * PI;

 float x = sin(lon) * sin(lat);
 float z = cos(lon) * sin(lat);
 float y = cos(lat);

 vec3 normal = vec3(x, y, z);
 if (aTransformationIndex < -0.5) {
 return normalize(normal);
 }

 
 
 
 
 mat3 normTrans = mat3(transform);

 return normalize(vec3(normTrans * normal));
}

vec4 getIdColor(float id) {
 float B = floor(id / (256.0*256.0));
 float G = floor((id - B * 256.0*256.0) / 256.0);
 float R = mod(id, 256.0);
 
 

 return vec4(R / 255.0, G / 255.0, B / 255.0, 1.0);
}

vec2 getTextureCoordinates(float index, float size)
{
 float x = floor(mod(index + 0.5, size)); 
 float y = floor((index + 0.5)/ size); 
 
 return vec2((x + 0.5) / size, (y + 0.5) / size);
}


vec4 getColor() { 
 
 float restyle = aState[1];
 if (restyle > 224.5) {
 vec2 coords = getTextureCoordinates(aStyleIndex, uStyleTextureSize);
 vec4 col = texture(uStyleSampler, coords);
 
 
 if (uRenderingMode == 1) {
 float intensity = (col.r + col.g + col.b) / 3.0;
 return vec4(intensity, intensity, intensity, col.a);
 }

 
 return col;
 }

 
 
 vec2 coords = getTextureCoordinates(restyle, 15.0);
 vec4 col2 = texture(uStateStyleSampler, coords);

 
 if (uRenderingMode == 1) {
 float intensity = (col2.r + col2.g + col2.b) / 3.0;
 return vec4(intensity, intensity, intensity, col2.a);
 }

 return col2;
}

vec4 getVertexPosition(mat4 transform) {
 vec2 coords = getTextureCoordinates(aVertexIndex, uVertexTextureSize);
 vec3 point = vec3(texture(uVertexSampler, coords));

 if (aTransformationIndex < -0.5) {
 return vec4 (point, 1.0);
 }

 return transform * vec4(point, 1.0);
}

mat4 getTransform() {
 if (aTransformationIndex < -0.5) {
 return mat4(1.0);
 }

 float tIndex = aTransformationIndex * 4.0;

 
 vec2 c1 = getTextureCoordinates(tIndex, uMatrixTextureSize);
 vec2 c2 = getTextureCoordinates(tIndex + 1.0, uMatrixTextureSize);
 vec2 c3 = getTextureCoordinates(tIndex + 2.0, uMatrixTextureSize);
 vec2 c4 = getTextureCoordinates(tIndex + 3.0, uMatrixTextureSize);

 
 vec4 v1 = texture(uMatrixSampler, c1);
 vec4 v2 = texture(uMatrixSampler, c2);
 vec4 v3 = texture(uMatrixSampler, c3);
 vec4 v4 = texture(uMatrixSampler, c4);

 
 return mat4(v1, v2, v3, v4);
}

void main(void) {
 int state = int(floor(aState[0] + 0.5));
 vDiscard = 0.0;

 if (state == 254 || 
 (uColorCoding == -1 && state == 251) || 
 (uColorCoding == -1 && (
 (uRenderingMode == 2 && state != 253 && state != 252 && state != 250) || 
 (uRenderingMode == 3 && (state == 253 || state == 252 || state == 250))) 
 ))
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0);
 vPosition = vec3(0.0, 0.0, 0.0);
 gl_Position = vec4(0.0, 0.0, 0.0, 1.0);
 return;
 }

 
 mat4 transform = getTransform();
 
 vPosition = vec3(getVertexPosition(transform)) + uWcs;
 vNormal = getNormal(transform);

 
 vec4 baseColor = getColor();

 
 if (baseColor.a < 0.98)
 {
 float correction = -0.002;
 if (uColorCoding == -2 || uColorCoding >= 0) {
 correction = -0.02;
 }
 vec3 trans = correction * uMeter * normalize(vNormal);
 vPosition = vPosition + trans;
 }
 
 
 if (uColorCoding == -2) {
 
 if ((uRenderingMode == 2 || uRenderingMode == 4) && state != 252 && state != 253)
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0); 
 } 
 else
 {
 float id = floor(aProduct + 0.5);
 vColor = getIdColor(id);
 vNormal = vec3(0.0, 0.0, 0.0);
 }
 }
 
 else if (uColorCoding >= 0) {
 
 if ((uRenderingMode == 2 || uRenderingMode == 4) && state != 252 && state != 253)
 {
 vDiscard = 1.0;
 vColor = vec4(0.0, 0.0, 0.0, 0.0);
 vNormal = vec3(0.0, 0.0, 0.0); 
 } 
 else
 {
 float id = float(uColorCoding);
 vColor = getIdColor(id);
 vNormal = vec3(0.0, 0.0, 0.0);
 }
 }
 
 else {
 
 
 
 if (state == 250) {
 baseColor = uHoverPickColour;
 }
 else if (state == 253) {
 baseColor = uHighlightColour;
 }
 
 else if (uRenderingMode == 2 || uRenderingMode == 3) {
 
 if (state == 252) { 
 baseColor = getColor();
 }
 
 else {
 baseColor = uXRayColour; 
 }
 }
 
 vColor = baseColor;
 }

 
 gl_Position = uPMatrix * uMVMatrix * vec4(vPosition, 1.0);
}`;
    }, 8378: (o, l, c) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.ViewType = l.RenderingMode = l.Viewer = void 0;
      var u, d, f, h = c(8194), g = c(3948), x = c(4932), E = c(9499), m = c(2067), v = c(7751), y = c(380), A = c(2241), b = c(6907), C = c(5761), T = c(7997), w = c(6920), R = c(4802), O = c(810), D = c(5771), k = c(3810), W = c(9549), L = c(887), z = c(1675), P = c(6413), Q = c(2607), Y = c(5460), ie = c(6235), te = c(8948), Z = c(3425), ae = c(269), G = function() {
        function U(F, M) {
          var I = this;
          if (this.changed = !0, this._navigationMode = "orbit", this.zoomDuration = 1e3, this._camera = new P.CameraProperties(function() {
            I.changed = !0;
          }), this._sectionBox = new Q.SectionBox(function() {
            var ne = I.getCurrentWcs(), he = I.getMergedRegion().bbox, j = I._sectionBox.getBoundingBox(ne);
            he != null && j != null && Y.BBox.areDisjoint(he, j) && console.warn("Section box is disjoint with the current content"), I.changed = !0;
          }), this._background = [230, 230, 230, 255], this._highlightingColour = [255, 173, 33, 255], this._hoverPickColour = [0, 255, 0, 255], this._xrayColour = [80, 80, 80, 150], this._mvMatrix = L.mat4.create(), this._pMatrix = L.mat4.create(), this._renderingMode = d.NORMAL, this._mvMatrixTimestamp = Date.now(), this._isRunning = !1, this._plugins = [], this._handles = [], this._shaderProgram = null, this._gamma = 1, this._contrast = 1, this._brightness = 0, this._currentFps = 60, this._performance = z.PerformanceRating.HIGH, this._adaptivePerformanceOn = !0, this._hoverPickEnabled = !1, this._events = {}, this._canvasListeners = {}, this._readerOptions = { orderGeometryBySize: !1 }, F == null)
            throw new Error("Canvas has to be defined");
          if (F.nodeName !== void 0 && F.nodeName === "CANVAS" && (this.canvas = F), typeof F == "string" && (this.canvas = document.getElementById(F)), this.canvas == null)
            throw new Error("You have to specify canvas either as an ID of HTML element or the element itself");
          if (M != null && this.on("error", M), this.cameraProperties.fov = 60, this.cameraProperties.near = 1, this.cameraProperties.far = 100, T.WebGLUtils.setupWebGL(this.canvas, function(ne, he) {
            I.gl = ne, I.glVersion = he;
          }, { preserveDrawingBuffer: !0 }, function(ne) {
            I.error(ne);
          }), this.gl) {
            this._requestAnimationFrame = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(ne) {
              window.setTimeout(ne, 1e3 / 60);
            }).bind(window);
            var N = this.gl;
            if (this.glVersion < 2) {
              if (this._fptExtension = N.getExtension("OES_texture_float") || N.getExtension("MOZ_OES_texture_float") || N.getExtension("WEBKIT_OES_texture_float"), !this._fptExtension)
                throw new Error("Floating point texture support required.");
              this._depthTextureExtension = N.getExtension("WEBGL_depth_texture") || N.getExtension("WEBKIT_WEBGL_depth_texture") || N.getExtension("MOZ_WEBGL_depth_texture"), this._depthTextureExtension || console.warn("WebGL 1.0 Depth texture extension not available. Interaction might be constrained as 3D of the event won't be calculated.");
            }
            N.enable(N.DEPTH_TEST), N.blendFunc(N.SRC_ALPHA, N.ONE_MINUS_SRC_ALPHA), N.enable(N.BLEND), this.width = this.canvas.width = this.canvas.offsetWidth, this.height = this.canvas.height = this.canvas.offsetHeight, this._initShaders(), this._initAttributesAndUniforms(), R.MouseNavigation.initMouseEvents(this), O.KeyboardNavigation.initKeyboardEvents(this), D.TouchNavigation.initTouchNavigationEvents(this), D.TouchNavigation.initTouchTapEvents(this), this._disableContextMenu(), this._stateStyles = new Uint8Array(900), this._stateStyleTexture = N.createTexture(), N.activeTexture(N.TEXTURE4), N.bindTexture(N.TEXTURE_2D, this._stateStyleTexture), N.uniform1i(this._stateStyleSamplerUniform, 4), x.ModelHandle.bufferTexture(N, this._stateStyleTexture, this._stateStyles);
            var V = this.height, q = this.width, H = function() {
              I.canvas.offsetHeight === V && I.canvas.offsetWidth === q || (V = I.height = I.canvas.height = I.canvas.offsetHeight, q = I.width = I.canvas.width = I.canvas.offsetWidth), I._requestAnimationFrame(H);
            };
            H(), this._cameraAdjustment = new ie.CameraAdjustment(this, this._requestAnimationFrame, 20), this.animations = new W.Animations(this), this._fpsWatch = new ae.FpsWatch(this._requestAnimationFrame), this.setupFpsReporting(), this._watchPerformance();
          } else
            this.error("Unable to set up WebGL");
        }
        return Object.defineProperty(U.prototype, "navigationMode", { get: function() {
          return this._navigationMode;
        }, set: function(F) {
          this._navigationMode = F, this.adaptivePerformanceOn = F !== "walk" && F !== "look-around" && F !== "look-at";
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "cameraProperties", { get: function() {
          return this._camera;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "sectionBox", { get: function() {
          return this._sectionBox;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "width", { get: function() {
          return this._width;
        }, set: function(F) {
          this._width = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "height", { get: function() {
          return this._height;
        }, set: function(F) {
          this._height = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "camera", { get: function() {
          return this.cameraProperties.type;
        }, set: function(F) {
          this.cameraProperties.type = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "background", { get: function() {
          return this._background;
        }, set: function(F) {
          this._background = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "highlightingColour", { get: function() {
          return this._highlightingColour;
        }, set: function(F) {
          this._highlightingColour = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "hoverPickColour", { get: function() {
          return this._hoverPickColour;
        }, set: function(F) {
          this._hoverPickColour = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "xrayColour", { get: function() {
          return this._xrayColour;
        }, set: function(F) {
          this._xrayColour = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "mvMatrix", { get: function() {
          return this._mvMatrix;
        }, set: function(F) {
          this._mvMatrix = F, this.changed = !0, this._mvMatrixTimestamp = Date.now();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "pMatrix", { get: function() {
          return this._pMatrix;
        }, set: function(F) {
          this._pMatrix = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "renderingMode", { get: function() {
          return this._renderingMode;
        }, set: function(F) {
          this._renderingMode = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "gamma", { get: function() {
          return this._gamma;
        }, set: function(F) {
          this._gamma = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "contrast", { get: function() {
          return this._contrast;
        }, set: function(F) {
          this._contrast = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "brightness", { get: function() {
          return this._brightness;
        }, set: function(F) {
          this._brightness = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "mvMatrixAge", { get: function() {
          return Date.now() - this._mvMatrixTimestamp;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "performance", { get: function() {
          return this._performance;
        }, set: function(F) {
          this._performance = F, this.changed = !0;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "adaptivePerformanceOn", { get: function() {
          return this._adaptivePerformanceOn;
        }, set: function(F) {
          this._adaptivePerformanceOn = F;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "hoverPickEnabled", { get: function() {
          return this._hoverPickEnabled;
        }, set: function(F) {
          this._hoverPickEnabled = F;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "plugins", { get: function() {
          return this._plugins.slice();
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "unitsInMeter", { get: function() {
          var F = this.activeHandles.map(function(M) {
            return M.meter;
          });
          return F.length === 0 ? null : F[0];
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "adjustments", { get: function() {
          return this._cameraAdjustment;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "activeHandles", { get: function() {
          return this._handles.filter(function(F) {
            return F != null && !F.stopped && !F.empty;
          });
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "readerOptions", { get: function() {
          return this._readerOptions;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "hasDepthSupport", { get: function() {
          return this.glVersion > 1 || this._depthTextureExtension != null;
        }, enumerable: !1, configurable: !0 }), Object.defineProperty(U.prototype, "isRunning", { get: function() {
          return this._isRunning;
        }, enumerable: !1, configurable: !0 }), U.check = function() {
          return k.Abilities.check();
        }, U.prototype.addPlugin = function(F) {
          F.init && (F.init(this), this._plugins.push(F), this.changed = !0);
        }, U.prototype.removePlugin = function(F) {
          var M = this._plugins.indexOf(F, 0);
          M < 0 || (this._plugins.splice(M, 1), this.changed = !0);
        }, U.prototype.defineStyle = function(F, M) {
          if (F === void 0 || F < 0 && F > 224)
            throw new Error("Style index has to be defined as a number 0-224");
          if (M === void 0 || !M.length || M.length !== 4)
            throw new Error("Colour must be defined as an array of 4 bytes");
          var I = new Uint8Array(M);
          this._stateStyles.set(I, 4 * F);
          var N = this.setActive();
          N.activeTexture(N.TEXTURE4), N.bindTexture(N.TEXTURE_2D, this._stateStyleTexture), x.ModelHandle.bufferTexture(N, this._stateStyleTexture, this._stateStyles), this.changed = !0;
        }, U.prototype.addState = function(F, M, I) {
          if (F === void 0 || !(F >= 225 && F <= 255))
            throw new Error("State has to be defined as 225 - 255. Use State enum.");
          if (M == null)
            throw new Error("Target must be defined either as type ID or as a list of product IDs");
          this.forHandleOrAll(function(N) {
            N.addState(F, M);
          }, I), this.changed = !0;
        }, U.prototype.setState = function(F, M, I) {
          if (F === void 0 || !(F >= 225 && F <= 255))
            throw new Error("State has to be defined as 225 - 255. Use State enum.");
          if (M == null)
            throw new Error("Target must be defined either as type ID or as a list of product IDs");
          this.forHandleOrAll(function(N) {
            N.setState(F, M);
          }, I), this.changed = !0;
        }, U.prototype.removeState = function(F, M, I) {
          if (F === void 0 || !(F >= 225 && F <= 255))
            throw new Error("State has to be defined as 225 - 255. Use State enum.");
          if (M == null)
            throw new Error("Target must be defined either as type ID or as a list of product IDs");
          this.forHandleOrAll(function(N) {
            N.removeState(F, M);
          }, I), this.changed = !0;
        }, U.prototype.setHoverPick = function(F, M) {
          var I = this, N = this.getProductsWithState(h.State.HOVEROVER);
          if (F) {
            if (N.some(function(V) {
              return V.id === F && V.model === M;
            }))
              return;
            this.getProductType(F, M) !== Z.ProductType.IFCSITE && this.addState(h.State.HOVEROVER, [F], M);
          }
          N.forEach(function(V) {
            F == V.id && M == V.model || I.removeState(h.State.HOVEROVER, [V.id], V.model);
          });
        }, U.prototype.getProductsWithState = function(F) {
          var M = [];
          return this._handles.filter(function(I) {
            return !I.stopped && !I.empty;
          }).forEach(function(I) {
            var N = I.getProductsWithState(F);
            N != null && N.length > 0 && (M = M.concat(N));
          }), M;
        }, U.prototype.getState = function(F, M) {
          return this.forHandleOrAll(function(I) {
            return I.getState(F);
          }, M);
        }, U.prototype.resetState = function(F, M) {
          this.forHandleOrAll(function(I) {
            I.resetState(F);
          }, M), this.changed = !0;
        }, U.prototype.clearHighlighting = function() {
          this._handles.filter(function(F) {
            return !F.stopped && !F.empty;
          }).forEach(function(F) {
            return F.clearHighlighting();
          });
        }, U.prototype.forHandleOrAll = function(F, M) {
          if (M != null) {
            var I = this.getHandle(M);
            if (!I)
              throw new Error("Model with id '".concat(M, "' doesn't exist."));
            return F(I);
          }
          var N = null;
          return this._handles.forEach(function(V) {
            if (V) {
              var q = F(V);
              q != null && (N = q);
            }
          }), N;
        }, U.prototype.getHandle = function(F) {
          return this._handles.filter(function(M) {
            return M != null && M.id === F;
          }).pop();
        }, U.prototype.getCurrentImageHtml = function(F, M) {
          F === void 0 && (F = this.width), M === void 0 && (M = this.height);
          var I = document.createElement("img");
          return I.src = this.getCurrentImageDataUrl(F, M), I;
        }, U.prototype.getCurrentImageDataUrl = function(F, M, I) {
          if (F === void 0 && (F = this.width), M === void 0 && (M = this.height), I === void 0 && (I = "png"), F === 0 || M === 0)
            return null;
          var N = new E.Framebuffer(this.gl, F, M, !1, this.glVersion);
          this.draw(N);
          var V = N.getImageDataUrl(I);
          return N.delete(), V;
        }, U.prototype.getCurrentImageDataArray = function(F, M) {
          if (F === void 0 && (F = this.width), M === void 0 && (M = this.height), F === 0 || M === 0)
            return null;
          var I = new E.Framebuffer(this.gl, F, M, !1, this.glVersion);
          this.draw(I);
          var N = I.getImageDataArray();
          return I.delete(), N;
        }, U.prototype.getCurrentImageBlob = function(F) {
          return this.canvas.toBlob(F, "image/png");
        }, U.prototype.getProductsStates = function(F) {
          var M = this.getHandle(F);
          if (M == null)
            throw new Error("Model '".concat(F, "' doesn't exist"));
          return M.getStates();
        }, U.prototype.restoreProductsStates = function(F, M) {
          var I = this.getHandle(F);
          if (I == null)
            throw new Error("Model '".concat(F, "' doesn't exist"));
          I.resetState(), M.forEach(function(N) {
            N.states.forEach(function(V) {
              I.addState(V, [N.id]);
            });
          });
        }, U.prototype.getModelState = function(F) {
          var M = this.getHandle(F);
          if (M == null)
            throw new Error("Model '".concat(F, "' doesn't exist"));
          return M.getModelState();
        }, U.prototype.restoreModelState = function(F, M) {
          var I = this.getHandle(F);
          if (I == null)
            throw new Error("Model '".concat(F, "' doesn't exist"));
          I.restoreModelState(M), this.changed = !0;
        }, U.prototype.setStyle = function(F, M, I) {
          if (F === void 0 || !(F >= 0 && F <= 225))
            throw new Error("Style has to be defined as 0 - 225 where 225 is for default style.");
          var N = [this._stateStyles[4 * F], this._stateStyles[4 * F + 1], this._stateStyles[4 * F + 2], this._stateStyles[4 * F + 3]];
          N[0] === 0 && N[1] === 0 && N[2] === 0 && N[3] === 0 && console.warn("You have used undefined colour for restyling. Elements with this style will have transparent black colour and hence will be invisible."), this.forHandleOrAll(function(V) {
            V.setStyle(F, M);
          }, I), this.changed = !0;
        }, U.prototype.getStyle = function(F, M) {
          var I = null;
          return this.forHandleOrAll(function(N) {
            I = N.getStyle(F);
          }, M), I;
        }, U.prototype.resetStyles = function(F) {
          this.forHandleOrAll(function(M) {
            M.resetStyles();
          }, F), this.changed = !0;
        }, U.prototype.getProductType = function(F, M) {
          return this.forHandleOrAll(function(I) {
            var N = I.getProductMap(F);
            if (N)
              return N.type;
          }, M);
        }, U.prototype.getProductBoundingBox = function(F, M) {
          var I = this;
          return this.forHandleOrAll(function(N) {
            var V = I.getCurrentWcs(), q = N.getProductMap(F, V);
            if (q) {
              var H = q.bBox;
              return new Float32Array([H[0] + V[0], H[1] + V[1], H[2] + V[2], H[3], H[4], H[5]]);
            }
          }, M);
        }, U.prototype.getDistanceAndHeight = function(F, M, I) {
          var N = Y.BBox.getSizeInView(F, M, I), V = N.width / N.height, q = this.width > 0 && this.height > 0 ? this.width / this.height : 1, H = N.width, ne = N.height;
          V > q ? ne = H / q : V < q && (H = ne * q);
          var he = this.cameraProperties.near + N.depth / 2, j = ne / (2 * Math.tan(this.cameraProperties.fov * Math.PI / 180 / 2)) + N.depth / 2;
          return { distance: 1.2 * Math.max(j, he), height: 1.2 * ne };
        }, U.prototype.getTargetBoundingBox = function(F, M) {
          var I = this.getCurrentWcs();
          if (F != null)
            return this.forHandleOrAll(function(V) {
              var q = V.getProductMap(F, I);
              if (q)
                return q.bBox;
            }, M) || null;
          var N = this.getMergedRegion();
          return N && N.population > 0 ? N.bbox : null;
        }, U.prototype.getTargetsBoundingBox = function(F) {
          var M = this, I = this.getCurrentWcs();
          return F.reduce(function(N, V) {
            var q = M.forHandleOrAll(function(H) {
              var ne = H.getProductMap(V.id, I);
              if (ne)
                return ne.bBox;
            }, V.model);
            return Y.BBox.union(q, N);
          }, null);
        }, U.prototype.getMergedRegion = function() {
          var F = new g.Region(), M = this.getCurrentWcs();
          this.activeHandles.forEach(function(N) {
            var V = N.getRegion(M);
            V != null && (F = F.merge(V));
          });
          var I = F.bbox;
          return this.sectionBox.isSet && ((I = Y.BBox.intersection(F.bbox, this.sectionBox.getBoundingBox(M))) == null ? console.debug("View will be empty because section box and actual content region are disjoint") : (F.bbox = new Float32Array(I), F.centre = new Float32Array(Y.BBox.centre(I)))), F;
        }, U.prototype.getMergedRegionWcs = function() {
          var F = new g.Region(), M = L.vec3.create();
          return this.activeHandles.forEach(function(I) {
            var N = I.getRegion(M);
            N != null && (F = F.merge(N));
          }), F;
        }, U.prototype.set = function(F) {
          var M = this;
          Object.getOwnPropertyNames(F).forEach(function(I) {
            M[I] = F[I];
          });
        }, U.prototype.loadAsync = function(F, M, I, N) {
          if (F === void 0)
            throw new Error("You have to specify model to load.");
          if (typeof F != "string" && !(F instanceof Blob))
            throw new Error("Model has to be specified either as a URL to wexBIM file or Blob object representing the wexBIM file.");
          var V = this, q = N ? function(j) {
            j.type === w.MessageType.COMPLETED && (j.type = w.MessageType.PROGRESS), N(j);
          } : function(j) {
          };
          if (typeof Worker > "u")
            return this.load(F, M, I, N), void console.warn("Asynchronous model loading requires Web Worker support in the browser. Falling back to synchronous loading.");
          var H = new Blob([v.worker], { type: "application/javascript" }), ne = new Worker(URL.createObjectURL(H));
          if (ne.onmessage = function(j) {
            var Fe = j.data;
            if (Fe.type === w.MessageType.COMPLETED) {
              var X = Fe.result;
              Fe.result = null, q(Fe);
              var ye = V.addHandle(X, M, q);
              N && N({ message: "Model load complete", type: w.MessageType.COMPLETED, percent: 100, wexbimId: ye, phase: w.LoadingPhase.LOADING });
            } else
              q(Fe);
          }, ne.onerror = function(j) {
            V.error(j.message);
          }, typeof F == "string" && F.indexOf("http") !== 0) {
            var he = document.createElement("a");
            he.href = F, F = he.href;
          }
          ne.postMessage({ model: F, headers: I, options: this.readerOptions });
        }, U.prototype.load = function(F, M, I, N) {
          if (F == null)
            throw new Error("You have to specify model to load.");
          if (typeof F != "string" && !(F instanceof Blob))
            throw new Error("Model has to be specified either as a URL to wexBIM file or Blob object representing the wexBIM file.");
          var V = this, q = new g.ModelGeometry();
          q.onloaded = function() {
            V.addHandle(q, M, N);
          }, q.onerror = function(H) {
            V.error(H);
          };
          try {
            q.load(F, I, N, this.readerOptions);
          } catch (H) {
            V.error(H);
          }
        }, U.prototype.addHandle = function(F, M, I) {
          var N = this.setActive(), V = new x.ModelHandle(N, F, I);
          return V.tag = M, this._handles.push(V), this.setNearAndFarFromCurrentModels(), this.changed = !0, this.fire("loaded", { model: V.id, tag: M }), V.id;
        }, U.prototype.setNearAndFarFromCurrentModels = function() {
          if (this.activeHandles.length !== 0) {
            var F = this.getMergedRegion();
            if (F && F.bbox && F.bbox.length !== 0) {
              var M = this.activeHandles[0].meter, I = Y.BBox.getDiagonalSize(F.bbox);
              this.cameraProperties.far = 10 * I, this.cameraProperties.near = M / 4;
            }
          }
        }, U.prototype.unload = function(F) {
          var M = this.getHandle(F);
          if (M == null)
            throw new Error("Model with id: " + F + " doesn't exist or was unloaded already.");
          M.stopped = !0;
          var I = this._handles.indexOf(M);
          this._handles.splice(I, 1), this.changed = !0, M.unload(), this.fire("unloaded", { tag: M.tag, model: M.id });
        }, U.prototype._initShaders = function() {
          var F = this, M = this.gl, I = function(q, H) {
            if (M.shaderSource(q, H), M.compileShader(q), !M.getShaderParameter(q, M.COMPILE_STATUS)) {
              var ne = M.getShaderInfoLog(q);
              return F.error(ne), console.error(ne), !1;
            }
            return !0;
          }, N = M.createShader(M.FRAGMENT_SHADER);
          if (!(this.glVersion === 1 ? I(N, y.fragment_shader) : I(N, b.fragment_shader_300)))
            return !1;
          var V = M.createShader(M.VERTEX_SHADER);
          if (!(this.glVersion === 1 ? I(V, A.vertex_shader) : I(V, C.vertex_shader_300)))
            return !1;
          this._shaderProgram = M.createProgram(), M.attachShader(this._shaderProgram, V), M.attachShader(this._shaderProgram, N), M.linkProgram(this._shaderProgram), M.getProgramParameter(this._shaderProgram, M.LINK_STATUS) ? M.useProgram(this._shaderProgram) : (this.error("Could not initialise shaders "), console.error("Could not initialise shaders "));
        }, U.prototype.setActive = function() {
          var F = this.gl;
          return F.useProgram(this._shaderProgram), F;
        }, U.prototype._initAttributesAndUniforms = function() {
          var F = this.setActive();
          this._pMatrixUniformPointer = F.getUniformLocation(this._shaderProgram, "uPMatrix"), this._mvMatrixUniformPointer = F.getUniformLocation(this._shaderProgram, "uMVMatrix"), this._lightUniformPointer = F.getUniformLocation(this._shaderProgram, "uLight"), this._colorCodingUniformPointer = F.getUniformLocation(this._shaderProgram, "uColorCoding"), this._renderingModeUniformPointer = F.getUniformLocation(this._shaderProgram, "uRenderingMode"), this._highlightingColourUniformPointer = F.getUniformLocation(this._shaderProgram, "uHighlightColour"), this._hoverPickColourUniformPointer = F.getUniformLocation(this._shaderProgram, "uHoverPickColour"), this._xrayColourUniformPointer = F.getUniformLocation(this._shaderProgram, "uXRayColour"), this._stateStyleSamplerUniform = F.getUniformLocation(this._shaderProgram, "uStateStyleSampler"), this._gammaContrastBrightnessUniform = F.getUniformLocation(this._shaderProgram, "uGBC"), this._sectionBoxUniform = F.getUniformLocation(this._shaderProgram, "uSectionBox"), this._pointers = new m.ModelPointers(F, this._shaderProgram);
        }, U.prototype._disableContextMenu = function() {
          this.canvas.addEventListener("contextmenu", function(F) {
            return F.preventDefault(), F.type !== "contextmenu";
          });
        }, Object.defineProperty(U.prototype, "meter", { get: function() {
          var F = this._handles.find(function(M) {
            return !M.stopped && !M.empty;
          });
          return F ? F.meter : 1;
        }, enumerable: !1, configurable: !0 }), U.prototype.navigate = function(F, M, I, N) {
          if (this.activeHandles.length !== 0) {
            F === "locked-orbit" && (N = this.lockedOrbitOrigin || N);
            var V = this.getCameraPosition(), q = L.vec3.distance(V, N);
            F === "look-around" && (N = V, M = -M, I = -I), F === "look-at" && (N = V);
            var H = L.vec3.transformMat4(L.vec3.create(), N, this.mvMatrix), ne = L.mat4.translate(L.mat4.create(), L.mat4.create(), H), he = function(Ie) {
              return Ie * Math.PI / 180;
            };
            switch (F) {
              case "free-orbit":
                ne = L.mat4.rotate(L.mat4.create(), ne, he(I / 4), [1, 0, 0]), ne = L.mat4.rotate(L.mat4.create(), ne, he(M / 4), [0, 1, 0]);
                break;
              case "locked-orbit":
              case "fixed-orbit":
              case "look-around":
              case "look-at":
              case "orbit":
                L.mat4.rotate(ne, ne, he(I / 4), [1, 0, 0]);
                var j = L.vec3.transformMat3(L.vec3.create(), [0, 0, 1], L.mat3.fromMat4(L.mat3.create(), this.mvMatrix));
                j = L.vec3.normalize(L.vec3.create(), j), ne = L.mat4.rotate(L.mat4.create(), ne, he(M / 4), j);
                break;
              case "pan":
                var Fe = 0;
                if (this.camera === P.CameraType.ORTHOGONAL)
                  Fe = this.cameraProperties.height / this.height;
                else {
                  var X = this.cameraProperties.fov * Math.PI / 180;
                  Fe = 2 * q * Math.tan(X / 2) / this.height;
                }
                ne = L.mat4.translate(L.mat4.create(), ne, [Fe * M, -Fe * I, 0]);
                break;
              case "walk":
                var ye = I * this.meter * 0.5 / 20;
                return void this.animations.addZoom(ye, 0);
              case "zoom":
                var Ae = L.vec3.subtract(L.vec3.create(), N, V), fe = I * Math.max(q, 2 * this.meter) / 20;
                return void this.animations.addZoom(fe, 0, Ae);
            }
            var _e = L.vec3.negate(L.vec3.create(), H);
            ne = L.mat4.translate(L.mat4.create(), ne, _e), this.mvMatrix = L.mat4.multiply(L.mat4.create(), ne, this.mvMatrix);
          }
        }, U.prototype.getCurrentWcs = function() {
          var F = function(I) {
            return !I.empty && !I.stopped;
          };
          if (this._lastWcs != null && F(this._lastWcs) === !0)
            return this._lastWcs.wcs;
          var M = this._handles.filter(F)[0];
          return M != null ? (this._lastWcs = M, this._lastWcs.wcs) : L.vec3.create();
        }, U.prototype.draw = function(F, M) {
          var I = this;
          M === void 0 && (M = !1);
          var N = this.getCurrentWcs(), V = this.gl;
          V.clearColor(this.background[0] / 255, this.background[1] / 255, this.background[2] / 255, this.background[3] / 255), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
          var q = F ? F.width : this.width, H = F ? F.height : this.height;
          V.viewport(0, 0, q, H), this.updatePMatrix(q, H), V.enable(V.BLEND), V.blendFunc(V.SRC_ALPHA, V.ONE_MINUS_SRC_ALPHA), M || this._plugins.forEach(function(j) {
            j.onBeforeDraw && j.onBeforeDraw(q, H);
          }), (V = this.setActive()).activeTexture(V.TEXTURE4), V.bindTexture(V.TEXTURE_2D, this._stateStyleTexture), V.uniform1i(this._stateStyleSamplerUniform, 4), V.uniformMatrix4fv(this._pMatrixUniformPointer, !1, this.pMatrix), V.uniformMatrix4fv(this._mvMatrixUniformPointer, !1, this.mvMatrix);
          var ne = this.getLightPosition(1 * this.meter, 1 * this.meter);
          if (V.uniform3fv(this._lightUniformPointer, ne), V.uniform3fv(this._gammaContrastBrightnessUniform, new Float32Array([this.gamma, this.contrast, this.brightness])), V.uniformMatrix4fv(this._sectionBoxUniform, !1, this.sectionBox.getMatrix(N)), V.uniform1i(this._colorCodingUniformPointer, u.NONE), V.uniform4fv(this._highlightingColourUniformPointer, new Float32Array([this.highlightingColour[0] / 255, this.highlightingColour[1] / 255, this.highlightingColour[2] / 255, this.highlightingColour[3] / 255])), V.uniform4fv(this._hoverPickColourUniformPointer, new Float32Array([this.hoverPickColour[0] / 255, this.hoverPickColour[1] / 255, this.hoverPickColour[2] / 255, this.hoverPickColour[3] / 255])), V.uniform4fv(this._xrayColourUniformPointer, new Float32Array([this.xrayColour[0] / 255, this.xrayColour[1] / 255, this.xrayColour[2] / 255, this.xrayColour[3] / 255])), F ? V.bindFramebuffer(V.FRAMEBUFFER, F.framebuffer) : V.bindFramebuffer(V.FRAMEBUFFER, null), V.uniform1i(this._renderingModeUniformPointer, this.renderingMode), this.renderingMode === d.XRAY || this.renderingMode === d.XRAY_ULTRA)
            this.drawXRAY(V);
          else {
            V.disable(V.CULL_FACE), V.enable(V.DEPTH_TEST);
            var he = 100;
            switch (this.performance) {
              case z.PerformanceRating.VERY_LOW:
                he = 10;
                break;
              case z.PerformanceRating.LOW:
                he = 30;
                break;
              case z.PerformanceRating.MEDIUM:
                he = 50;
                break;
              case z.PerformanceRating.HIGH:
              default:
                he = 100;
            }
            this._handles.forEach(function(j) {
              j.stopped || (j.setActive(I._pointers, N), j.draw(x.DrawMode.SOLID, j.pinned ? 100 : he));
            }), this.performance > z.PerformanceRating.LOW && this._handles.forEach(function(j) {
              j.stopped || (j.setActive(I._pointers, N), j.draw(x.DrawMode.TRANSPARENT, j.pinned ? 100 : he));
            });
          }
          M || this._plugins.forEach(function(j) {
            j.onAfterDraw && j.onAfterDraw(q, H);
          });
        }, U.prototype.getLightPosition = function(F, M) {
          var I = L.mat4.getRotation(L.quat.create(), this.mvMatrix), N = L.quat.invert(L.quat.create(), I), V = L.vec3.transformQuat(L.vec3.create(), [0, 1, 0], N), q = L.vec3.transformQuat(L.vec3.create(), [1, 0, 0], N), H = L.vec3.scale(L.vec3.create(), V, F), ne = L.vec3.scale(L.vec3.create(), q, M), he = L.vec3.add(L.vec3.create(), H, ne), j = this.getCameraPosition();
          return L.vec3.add(L.vec3.create(), j, he);
        }, U.prototype.drawXRAY = function(F) {
          var M = this, I = this.renderingMode, N = this.getCurrentWcs(), V = function() {
            F.enable(F.CULL_FACE), F.uniform1i(M._renderingModeUniformPointer, 3), F.depthMask(!1), M._handles.forEach(function(H) {
              H.stopped || (H.setActive(M._pointers, N), H.draw());
            }), F.depthMask(!0);
          }, q = function() {
            F.disable(F.CULL_FACE), F.uniform1i(M._renderingModeUniformPointer, d.XRAY), F.enable(F.DEPTH_TEST), M._handles.forEach(function(H) {
              H.stopped || (H.setActive(M._pointers, N), H.draw());
            });
          };
          I === d.XRAY && (q(), V()), I === d.XRAY_ULTRA && (V(), q());
        }, U.prototype.updatePMatrix = function(F, M) {
          this.pMatrix = this.cameraProperties.getProjectionMatrix(F, M);
        }, U.prototype.getCameraDistanceFromRegion = function() {
          var F = this.getMergedRegion();
          if (!F.bbox || F.bbox.length === 0)
            return { near: 0, far: 0, size: 0 };
          var M = this.getCameraPosition(), I = L.vec3.normalize(L.vec3.create(), this.getCameraDirection()), N = Y.BBox.getDiagonalSize(F.bbox), V = L.vec3.subtract(L.vec3.create(), F.centre, M), q = L.vec3.normalize(L.vec3.create(), V), H = L.vec3.length(V), ne = L.vec3.scale(L.vec3.create(), q, H - N), he = L.vec3.scale(L.vec3.create(), q, H + N);
          return { near: L.vec3.dot(I, ne), far: L.vec3.dot(I, he), size: N };
        }, U.prototype.getCameraPosition = function() {
          var F = L.mat4.invert(L.mat4.create(), this.mvMatrix);
          return F == null ? L.vec3.create() : L.vec3.transformMat4(L.vec3.create(), L.vec3.create(), F);
        }, U.prototype.getCameraPositionWcs = function() {
          var F = this.getCameraPosition(), M = this.getCurrentWcs();
          return L.vec3.add(L.vec3.create(), F, M);
        }, U.prototype.getCameraDirection = function() {
          var F = L.mat4.invert(L.mat4.create(), this.mvMatrix), M = L.mat4.getRotation(L.quat.create(), F);
          return L.vec3.transformQuat(L.vec3.create(), L.vec3.fromValues(0, 0, -1), M);
        }, U.prototype.getCameraHeading = function() {
          var F = L.mat4.invert(L.mat4.create(), this.mvMatrix), M = L.mat4.getRotation(L.quat.create(), F);
          return L.vec3.transformQuat(L.vec3.create(), L.vec3.fromValues(0, 1, 0), M);
        }, U.prototype.zoomTo = function(F, M, I, N) {
          I === void 0 && (I = !0), N === void 0 && (N = !0);
          var V = I ? this.zoomDuration : 0, q = null;
          if (F == null || typeof F == "number") {
            if (q = this.getTargetBoundingBox(F, M), N === !0 && typeof F == "number" && (H = te.PreflightCheck.findView(this, [{ id: F, model: M || 1 }], 10)) != null)
              return this.animations.viewTo(H, V);
          } else {
            var H;
            if (N === !0 && F.length > 0 && (H = te.PreflightCheck.findView(this, F, 10)) != null)
              return this.animations.viewTo(H, V);
            q = F.length > 0 ? this.getTargetsBoundingBox(F) : this.getTargetBoundingBox();
          }
          if (q == null)
            return new Promise(function(_e, Ie) {
              return _e();
            });
          var ne = L.vec3.fromValues(q[0] + q[3] / 2, q[1] + q[4] / 2, q[2] + q[5] / 2), he = this.getCameraPosition(), j = L.vec3.subtract(L.vec3.create(), he, ne);
          j = L.vec3.normalize(L.vec3.create(), j);
          var Fe = L.vec3.angle(j, [0, 0, 1]), X = L.vec3.fromValues(0, 0, 1);
          (Math.abs(Fe) < 1e-6 || Math.abs(Fe - Math.PI) < 1e-6) && (X = this.getCameraHeading());
          var ye = this.getDistanceAndHeight(q, j, X), Ae = L.vec3.create();
          L.vec3.scale(Ae, j, ye.distance), L.vec3.add(he, Ae, ne);
          var fe = L.mat4.lookAt(L.mat4.create(), he, ne, X);
          return this.animations.viewTo({ mv: fe, height: ye.height }, V);
        }, U.prototype.show = function(F, M, I, N) {
          N === void 0 && (N = !0);
          var V = this.getTargetBoundingBox(M, I);
          if (V == null)
            return new Promise(function(fe, _e) {
              return _e();
            });
          var q = N ? this.zoomDuration : 0, H = L.vec3.fromValues(V[0] + V[3] / 2, V[1] + V[4] / 2, V[2] + V[5] / 2), ne = null, he = L.vec3.fromValues(0, 0, 1);
          switch (F) {
            case f.TOP:
              ne = L.vec3.fromValues(0, 0, -1), he = L.vec3.fromValues(0, 1, 0);
              break;
            case f.BOTTOM:
              ne = L.vec3.fromValues(0, 0, 1), he = L.vec3.fromValues(0, -1, 0);
              break;
            case f.FRONT:
              ne = L.vec3.fromValues(0, 1, 0);
              break;
            case f.BACK:
              ne = L.vec3.fromValues(0, -1, 0);
              break;
            case f.LEFT:
              ne = L.vec3.fromValues(1, 0, 0);
              break;
            case f.RIGHT:
              ne = L.vec3.fromValues(-1, 0, 0);
              break;
            case f.DEFAULT:
              ne = L.vec3.normalize(L.vec3.create(), [1, 1, -1]);
          }
          var j = this.getDistanceAndHeight(V, ne, he), Fe = L.vec3.negate(L.vec3.create(), ne), X = L.vec3.scale(L.vec3.create(), Fe, j.distance), ye = L.vec3.add(L.vec3.create(), H, X), Ae = L.mat4.lookAt(L.mat4.create(), ye, H, he);
          return this.animations.viewTo({ mv: Ae, height: j.height }, q);
        }, U.prototype.startRotation = function() {
          this.animations.startRotation();
        }, U.prototype.stopRotation = function() {
          this.animations.stopRotation();
        }, U.prototype.error = function(F) {
          this.fire("error", { message: F }), typeof console < "u" && console.error != null && console.error(F);
        }, U.prototype.getInteractionOrigin = function(F) {
          var M = this.getEventDataFromEvent(F);
          if (M == null || M.id == null || M.model == null)
            return null;
          if (M.xyz != null)
            return M.xyz;
          var I = this.getTargetBoundingBox(M.id, M.model);
          return L.vec3.fromValues(I[0] + I[3] / 2, I[1] + I[4] / 2, I[2] + I[5] / 2);
        }, U.prototype.getEventDataFromEvent = function(F, M) {
          M === void 0 && (M = !1);
          var I = F.clientX, N = F.clientY, V = this.canvas.getBoundingClientRect(), q = I - V.left, H = this.height - (N - V.top);
          if (!M)
            return this.getEventData(q, H);
          var ne = this.getEventDataRaw(q, H);
          return ne == null ? { id: null, model: null, xyz: null } : { id: ne.renderId, model: ne.modelId, xyz: ne.location };
        }, U.prototype.getEventData = function(F, M) {
          var I = this.getEventDataRaw(F, M);
          if (I == null)
            return U.noData;
          var N = I.renderId, V = I.modelId, q = this.getHandle(V);
          return q != null ? { id: q.getProductId(N), model: V, xyz: I.location } : U.noData;
        }, U.prototype.getEventDataRaw = function(F, M) {
          var I = this;
          if (this.width === 0 || this.height === 0 || this.activeHandles.length === 0)
            return null;
          var N = this.setActive(), V = Math.floor(this.width / 4), q = Math.floor(this.height / 4), H = this.getCurrentWcs(), ne = this.cameraProperties.near, he = this.cameraProperties.far, j = this._isRunning;
          F = Math.floor(F / 4), M = Math.floor(M / 4), this._isRunning = !1, this._eventFB == null && (this._eventFB = new E.Framebuffer(N, V, q, this.hasDepthSupport, this.glVersion)), (Math.abs(V - this._eventFB.width) > 1 || Math.abs(q - this._eventFB.height) > 1) && (this._eventFB.delete(), this._eventFB = new E.Framebuffer(N, V, q, this.hasDepthSupport, this.glVersion));
          var Fe = this._eventFB;
          Fe.bind();
          try {
            this.setActive(), N.viewport(0, 0, V, q), N.enable(N.DEPTH_TEST), N.disable(N.BLEND), N.enable(N.SCISSOR_TEST), N.scissor(F, M, 1, 1), N.clearColor(0, 0, 0, 0), N.clear(N.COLOR_BUFFER_BIT | N.DEPTH_BUFFER_BIT), this._plugins.forEach(function(Ce) {
              Ce.onBeforeDrawId && Ce.onBeforeDrawId();
            }), this.setActive(), N.uniform1i(this._colorCodingUniformPointer, u.PRODUCTS), N.uniform1i(this._renderingModeUniformPointer, this.renderingMode), this._handles.forEach(function(Ce) {
              !Ce.stopped && Ce.pickable && (Ce.setActive(I._pointers, H), Ce.draw());
            }), this._plugins.forEach(function(Ce) {
              Ce.onAfterDrawId && Ce.onAfterDrawId();
            });
            var X = Fe.getId(F, M);
            if (X == null)
              return null;
            var ye = Fe.getXYZRange(F, M);
            if (ye != null) {
              var Ae = L.mat4.invert(L.mat4.create(), this.pMatrix), fe = L.vec3.transformMat4(L.vec3.create(), ye.near, Ae), _e = L.vec3.transformMat4(L.vec3.create(), ye.far, Ae), Ie = -1 * fe[2], Be = -1 * _e[2];
              this.cameraProperties.near = Ie, this.cameraProperties.far = Be;
            }
            this.setActive(), N.bindFramebuffer(N.FRAMEBUFFER, Fe.framebuffer), this.updatePMatrix(V, q), N.uniformMatrix4fv(this._pMatrixUniformPointer, !1, this.pMatrix), N.clearColor(0, 0, 0, 0), N.clear(N.COLOR_BUFFER_BIT | N.DEPTH_BUFFER_BIT), this._handles.forEach(function(Ce) {
              !Ce.stopped && Ce.pickable && (N.uniform1i(I._colorCodingUniformPointer, Ce.id), Ce.setActive(I._pointers, H), Ce.draw());
            }), this._plugins.forEach(function(Ce) {
              Ce.onAfterDrawModelId && Ce.onAfterDrawModelId();
            });
            var $e = Fe.getId(F, M), Me = Fe.getXYZ(F, M), J = null;
            if (Me != null) {
              var K = L.mat4.multiply(L.mat4.create(), this.pMatrix, this.mvMatrix), ge = L.mat4.invert(L.mat4.create(), K);
              J = L.vec3.transformMat4(L.vec3.create(), Me, ge);
            }
            return { location: J, modelId: $e, renderId: X };
          } catch (Ce) {
            this.error(Ce);
          } finally {
            this.setActive(), N.bindFramebuffer(N.FRAMEBUFFER, null), N.blendFunc(N.SRC_ALPHA, N.ONE_MINUS_SRC_ALPHA), N.enable(N.BLEND), N.disable(N.SCISSOR_TEST), this.cameraProperties.near = ne, this.cameraProperties.far = he, this.updatePMatrix(V, q), N.uniformMatrix4fv(this._pMatrixUniformPointer, !1, this.pMatrix), this._isRunning = j;
          }
        }, U.prototype.getData = function(F) {
          var M = this;
          if (this.width === 0 || this.height === 0 || this.activeHandles.length === 0)
            return null;
          var I = this.setActive(), N = Math.floor(this.width / 4), V = Math.floor(this.height / 4), q = this.getCurrentWcs(), H = this._isRunning;
          F = F.map(function(Fe) {
            return { x: Math.floor(Fe.x / 4), y: Math.floor(Fe.y / 4) };
          }), this._isRunning = !1;
          var ne = new E.Framebuffer(I, N, V, !1, this.glVersion);
          ne.bind();
          try {
            this.setActive(), I.viewport(0, 0, N, V), I.enable(I.DEPTH_TEST), I.disable(I.BLEND), I.clearColor(0, 0, 0, 0), I.clear(I.COLOR_BUFFER_BIT | I.DEPTH_BUFFER_BIT), this.setActive(), I.uniform1i(this._colorCodingUniformPointer, u.PRODUCTS), this.updatePMatrix(N, V), I.uniformMatrix4fv(this._pMatrixUniformPointer, !1, this.pMatrix), I.uniformMatrix4fv(this._mvMatrixUniformPointer, !1, this.mvMatrix), this._handles.forEach(function(Fe) {
              Fe.stopped || (Fe.setActive(M._pointers, q), Fe.draw());
            });
            var he = ne.getIds(F);
            this.setActive(), I.bindFramebuffer(I.FRAMEBUFFER, ne.framebuffer), I.clearColor(0, 0, 0, 0), I.clear(I.COLOR_BUFFER_BIT | I.DEPTH_BUFFER_BIT), this._handles.forEach(function(Fe) {
              Fe.stopped || (I.uniform1i(M._colorCodingUniformPointer, Fe.id), Fe.setActive(M._pointers, q), Fe.draw());
            });
            var j = ne.getIds(F);
            return he.map(function(Fe, X) {
              if (Fe == null)
                return null;
              var ye = j[X];
              if (ye == null)
                return null;
              var Ae = M.getHandle(ye);
              return Ae == null ? null : { id: Ae.getProductId(Fe), model: ye };
            });
          } catch (Fe) {
            this.error(Fe);
          } finally {
            this.setActive(), I.bindFramebuffer(I.FRAMEBUFFER, null), I.blendFunc(I.SRC_ALPHA, I.ONE_MINUS_SRC_ALPHA), I.enable(I.BLEND), this._isRunning = H;
          }
        }, U.prototype.isolate = function(F, M) {
          if (M == null)
            this._handles.forEach(function(N) {
              N.isolatedProducts = F;
            });
          else {
            var I = this.getHandle(M);
            if (!I)
              throw new Error("Model with id ".concat(M, " doesn't exist."));
            I.isolatedProducts = F;
          }
        }, U.prototype.getIsolated = function(F) {
          var M = this.getHandle(F);
          if (!M)
            throw new Error("Model with id ".concat(F, " doesn't exist."));
          return M.isolatedProducts;
        }, U.prototype.setupFpsReporting = function() {
          var F = this, M = function() {
            var I = F._fpsWatch.fps;
            Math.abs(F._currentFps - I) >= 1 && (F._currentFps = I, F.fire("fps", Math.floor(I))), F._requestAnimationFrame(M);
          };
          M();
        }, U.prototype._watchPerformance = function() {
          var F = this, M = !1, I = function() {
            if (!F._adaptivePerformanceOn)
              return F.performance = z.PerformanceRating.HIGH, void F._requestAnimationFrame(I);
            var N = F.mvMatrixAge, V = F._fpsWatch.fps;
            if (N > 2e3 && !M)
              F._requestAnimationFrame(I);
            else if (N > 2e3) {
              if (M = !1, F.performance = z.PerformanceRating.HIGH, F.fire("navigationEnd", !0), F.activeHandles.length > 0) {
                var q = F.getCameraDistanceFromRegion(), H = q.near, ne = q.far, he = q.size;
                H > 0 && ne > 0 && (F.cameraProperties.near = H, F.cameraProperties.far = ne), F.draw();
              }
              F._requestAnimationFrame(I);
            } else {
              if (M === !1) {
                M = !0;
                var j = F.getCameraDistanceFromRegion();
                H = j.near, ne = j.far, he = j.size, F.cameraProperties.near = 0.2 * F.meter, F.cameraProperties.far = 5 * he, F.fire("navigationStart", !0);
              }
              V < 10 && F.performance > z.PerformanceRating.VERY_LOW ? F.performance = z.PerformanceRating.VERY_LOW : V < 20 && F.performance > z.PerformanceRating.LOW ? F.performance = z.PerformanceRating.LOW : V < 30 && F.performance > z.PerformanceRating.MEDIUM ? F.performance = z.PerformanceRating.MEDIUM : V >= 30 && F.performance <= z.PerformanceRating.MEDIUM && (F.performance = z.PerformanceRating.HIGH), F._requestAnimationFrame(I);
            }
          };
          I();
        }, U.prototype.start = function(F) {
          var M = this;
          if (F != null) {
            var I = this.getHandle(F);
            if (I === void 0)
              throw new Error("Model doesn't exist.");
            if (I.stopped = !1, I.empty || this.setNearAndFarFromCurrentModels(), this._isRunning)
              return;
          }
          if (this.changed = !0, this.setNearAndFarFromCurrentModels(), !this._isRunning) {
            this._isRunning = !0;
            var N = function() {
              M._isRunning && (M._handles.length === 0 || !M.changed && M.activeHandles.filter(function(V) {
                return V.changed;
              }).length === 0 || (M.draw(), M.changed = !1), M._requestAnimationFrame(N));
            };
            N();
          }
        }, U.prototype.stop = function(F) {
          if (F != null) {
            var M = this.getHandle(F);
            if (M == null)
              throw new Error("Model doesn't exist.");
            M.stopped = !0, this.changed = !0, this.setNearAndFarFromCurrentModels();
          } else
            this._isRunning = !1;
        }, U.prototype.stopAll = function() {
          var F = this;
          this._handles.forEach(function(M) {
            M.stopped = !0, F.changed = !0;
          }), this._isRunning = !1;
        }, U.prototype.isModelOn = function(F) {
          var M = this.getHandle(F);
          return !!M && !M.stopped;
        }, U.prototype.isProductInModel = function(F, M) {
          var I = this.getHandle(M);
          return !!I && I.getState(F) != null;
        }, U.prototype.isModelLoaded = function(F) {
          return !!this.getHandle(F);
        }, U.prototype.startAll = function() {
          var F = this;
          this._handles.forEach(function(M) {
            M.stopped = !1, F.changed = !0;
          }), this._isRunning = !0;
        }, U.prototype.stopPicking = function(F) {
          var M = this.getHandle(F);
          if (M == null)
            throw new Error("Model doesn't exist.");
          M.pickable = !1;
        }, U.prototype.startPicking = function(F) {
          var M = this.getHandle(F);
          if (M === void 0)
            throw new Error("Model doesn't exist.");
          M.pickable = !0;
        }, U.prototype.isPickable = function(F) {
          return this.getHandle(F).pickable;
        }, U.prototype.on = function(F, M) {
          var I = this, N = this._events;
          N[F] || (N[F] = []), N[F].push(M);
          var V = "on".concat(F);
          if ((this.canvas[V] !== void 0 || document[V] !== void 0) && this._canvasListeners[F] == null) {
            var q = function(H) {
              if (H.type !== "pointerlockchange") {
                var ne, he = F;
                H instanceof MouseEvent ? (ne = I.getEventDataFromEvent(H)) != null && I.fire(he, { event: H, id: ne.id, model: ne.model, xyz: ne.xyz }) : H instanceof TouchEvent && (ne = I.getEventDataFromEvent(H.touches[H.touches.length - 1])) != null && I.fire(he, { event: H, id: ne.id, model: ne.model, xyz: ne.xyz });
              } else
                I.fire("pointerlockchange", { target: document.pointerLockElement });
            };
            F === "pointerlockchange" || F === "pointerlockerror" ? document.addEventListener(F, q, !1) : this.canvas.addEventListener(F, q), this._canvasListeners[F] = q;
          }
        }, U.prototype.off = function(F, M) {
          var I = this._events[F];
          if (I) {
            var N = I.indexOf(M);
            if (N >= 0) {
              I.splice(N, 1);
              var V = this._canvasListeners[F];
              I.length === 0 && V !== null && (F === "pointerlockchange" || F === "pointerlockerror" ? document.removeEventListener(F, V) : this.canvas.removeEventListener(F, V), this._canvasListeners[F] = null);
            }
          }
        }, U.prototype.fire = function(F, M) {
          var I = this._events[F];
          I && I.slice().forEach(function(N) {
            try {
              N(M);
            } catch (V) {
              console.error(V);
            }
          });
        }, U.prototype.disableTextSelection = function() {
          document.documentElement.style["-webkit-touch-callout"] = "none", document.documentElement.style["-webkit-user-select"] = "none", document.documentElement.style["-khtml-user-select"] = "none", document.documentElement.style["-moz-user-select"] = "none", document.documentElement.style["-ms-user-select"] = "none", document.documentElement.style["user-select"] = "none";
        }, U.prototype.enableTextSelection = function() {
          document.documentElement.style["-webkit-touch-callout"] = "text", document.documentElement.style["-webkit-user-select"] = "text", document.documentElement.style["-khtml-user-select"] = "text", document.documentElement.style["-moz-user-select"] = "text", document.documentElement.style["-ms-user-select"] = "text", document.documentElement.style["user-select"] = "text";
        }, U.prototype.clip = function(F, M) {
          if (F == null || M == null)
            throw new Error("Cutting plane not well defined");
          var I = 0 - M[0] * F[0] - M[1] * F[1] - M[2] * F[2];
          this._handles.forEach(function(N) {
            N.clippingPlaneA = [M[0], M[1], M[2], I], N.clippingPlaneB = null;
          });
        }, U.prototype.setClippingPlaneA = function(F, M) {
          if (M != null) {
            var I = this.getHandle(M);
            I && (I.clippingPlaneA = F);
          } else
            this._handles.forEach(function(N) {
              N.clippingPlaneA = F;
            });
        }, U.prototype.setClippingPlaneB = function(F, M) {
          if (M != null) {
            var I = this.getHandle(M);
            I && (I.clippingPlaneB = F);
          } else
            this._handles.forEach(function(N) {
              N.clippingPlaneB = F;
            });
        }, U.prototype.unclip = function(F) {
          if (F != null) {
            var M = this.getHandle(F);
            M && (M.clippingPlaneA = null, M.clippingPlaneB = null);
          } else
            this._handles.forEach(function(I) {
              I.clippingPlaneA = null, I.clippingPlaneB = null;
            });
        }, U.prototype.getClip = function(F) {
          var M;
          return (M = F == null ? this._handles.filter(function(I) {
            return I.clippable && !I.stopped && (I.clippingPlaneA != null || I.clippingPlaneB != null);
          }).pop() : this.getHandle(F)) ? { PlaneA: M.clippingPlaneA, PlaneB: M.clippingPlaneB } : null;
        }, U.prototype.getProductAnalysis = function(F) {
          F === void 0 && (F = "triangles");
          var M = F === "triangles" ? function(I) {
            return I.numberOfTriangles;
          } : function(I) {
            return I.density;
          };
          return this.activeHandles.reduce(function(I, N) {
            return N.getProductAnalysis(I);
          }, []).sort(function(I, N) {
            return M(N) - M(I);
          });
        }, U.prototype.isolateHeavyProducts = function(F, M) {
          var I = this;
          F === void 0 && (F = "triangles"), M === void 0 && (M = 0.2);
          for (var N = F === "triangles" ? function(X) {
            return X.numberOfTriangles;
          } : function(X) {
            return X.density;
          }, V = this.getProductAnalysis(F), q = V.reduce(function(X, ye) {
            return X + N(ye);
          }, 0) * M, H = 0, ne = [], he = 0; H < q; he++) {
            var j = V[he];
            H += N(j), ne.push(j);
          }
          var Fe = {};
          return ne.reduce(function(X, ye) {
            var Ae = X[ye.modelId];
            return Ae == null && (Ae = [], X[ye.modelId] = Ae), Ae.push(ye.productId), X;
          }, Fe), this.activeHandles.forEach(function(X) {
            I.isolate([0], X.id);
          }), Object.getOwnPropertyNames(Fe).forEach(function(X) {
            var ye = Fe[X], Ae = +X;
            I.isolate(ye, Ae);
          }), ne;
        }, U.prototype.getHTMLPositionOfProductCentroid = function(F, M) {
          var I = this.getHandle(M).getProductMap(F, this.getCurrentWcs()).bBox, N = L.vec3.fromValues(I[0] + I[3] / 2, I[1] + I[4] / 2, I[2] + I[5] / 2);
          return this.getHtmlCoordinatesOfVector(N);
        }, U.prototype.getHtmlCoordinatesOfVector = function(F) {
          if (!F)
            return [];
          var M = L.mat4.multiply(L.mat4.create(), this.pMatrix, this.mvMatrix), I = L.vec3.transformMat4(L.vec3.create(), F, M), N = I[0], V = I[1];
          return [(N + 1) / 2 * this.width, this.height - (V + 1) / 2 * this.height];
        }, U.prototype.setLockedOrbitOrigin = function(F, M) {
          var I = this.getHandle(M);
          if (I == null)
            throw new Error("Invalid model ID");
          var N = I.getProductMap(F, this.getCurrentWcs()).bBox;
          this.lockedOrbitOrigin = L.vec3.fromValues(N[0] + N[3] / 2, N[1] + N[4] / 2, N[2] + N[5] / 2);
        }, U.noData = { id: null, model: null, xyz: null }, U;
      }();
      l.Viewer = G, function(U) {
        U[U.NONE = -1] = "NONE", U[U.PRODUCTS = -2] = "PRODUCTS";
      }(u || (u = {})), function(U) {
        U[U.NORMAL = 0] = "NORMAL", U[U.GRAYSCALE = 1] = "GRAYSCALE", U[U.XRAY = 2] = "XRAY", U[U.XRAY_ULTRA = 4] = "XRAY_ULTRA";
      }(d = l.RenderingMode || (l.RenderingMode = {})), function(U) {
        U[U.TOP = 0] = "TOP", U[U.BOTTOM = 1] = "BOTTOM", U[U.FRONT = 2] = "FRONT", U[U.BACK = 3] = "BACK", U[U.LEFT = 4] = "LEFT", U[U.RIGHT = 5] = "RIGHT", U[U.DEFAULT = 6] = "DEFAULT";
      }(f = l.ViewType || (l.ViewType = {}));
    }, 7751: (o, l) => {
      Object.defineProperty(l, "__esModule", { value: !0 }), l.worker = void 0, l.worker = `(()=>{"use strict";var e={747:(e,r)=>{Object.defineProperty(r,"__esModule",{value:!0}),r.LoadingPhase=r.MessageType=r.MessageProgress=r.Message=void 0;var t,I;r.Message=function(){},r.MessageProgress=function(e){var r=100/3;return r*e.phase+r*e.percent/100},(I=r.MessageType||(r.MessageType={}))[I.PROGRESS=0]="PROGRESS",I[I.COMPLETED=1]="COMPLETED",I[I.FAILED=2]="FAILED",(t=r.LoadingPhase||(r.LoadingPhase={}))[t.DOWNLOADING=0]="DOWNLOADING",t[t.READING=1]="READING",t[t.LOADING=2]="LOADING"},18:(e,r,t)=>{Object.defineProperty(r,"__esModule",{value:!0}),r.ProductMap=void 0;var I=t(486),a=function(){function e(){this.states=[]}return e.clone=function(r){var t=new e;return t.productID=r.productID,t.renderId=r.renderId,t.type=r.type,t.bBox=new Float32Array(r.bBox),t.spans=r.spans,t.states=r.states.slice(0),t},e.addState=function(e,r){null==e.states.find((function(e){return e===r}))&&e.states.push(r)},e.removeState=function(e,r){var t=e.states.indexOf(r);t<0||e.states.splice(t,1)},e.getState=function(e){return null==e.states||0===e.states.length?I.State.UNDEFINED:I.StatePriorities.getHighestPriority(e.states)},e}();r.ProductMap=a},486:(e,r)=>{var t;Object.defineProperty(r,"__esModule",{value:!0}),r.StatePriorities=r.State=void 0,function(e){e[e.UNDEFINED=255]="UNDEFINED",e[e.HIDDEN=254]="HIDDEN",e[e.HIGHLIGHTED=253]="HIGHLIGHTED",e[e.XRAYVISIBLE=252]="XRAYVISIBLE",e[e.PICKING_ONLY=251]="PICKING_ONLY",e[e.HOVEROVER=250]="HOVEROVER",e[e.UNSTYLED=225]="UNSTYLED"}(t=r.State||(r.State={}));var I=function(){function e(){}return e.getPriority=function(e){switch(e){case t.HIGHLIGHTED:return 1;case t.PICKING_ONLY:return 2;case t.HIDDEN:return 3;case t.XRAYVISIBLE:return 4;default:return 100}},e.getHighestPriority=function(e){var r=this;if(null==e||0===e.length)return null;if(1===e.length)return e[0];var I=e.map((function(e){return{state:e,priority:r.getPriority(e)}}));I.sort((function(e,r){return e.priority-r.priority}));var a=I[0];return a.priority>50?t.UNDEFINED:a.state},e}();r.StatePriorities=I},66:(e,r)=>{var t;Object.defineProperty(r,"__esModule",{value:!0}),r.ProductType=void 0,(t=r.ProductType||(r.ProductType={}))[t.IFCPRODUCT=20]="IFCPRODUCT",t[t.IFCELEMENT=19]="IFCELEMENT",t[t.IFCBUILDINGELEMENT=26]="IFCBUILDINGELEMENT",t[t.IFCFOOTING=120]="IFCFOOTING",t[t.IFCPILE=572]="IFCPILE",t[t.IFCBEAM=171]="IFCBEAM",t[t.IFCBEAMSTANDARDCASE=1104]="IFCBEAMSTANDARDCASE",t[t.IFCBUILDINGELEMENTPROXY=560]="IFCBUILDINGELEMENTPROXY",t[t.IFCCHIMNEY=1120]="IFCCHIMNEY",t[t.IFCCOLUMN=383]="IFCCOLUMN",t[t.IFCCOLUMNSTANDARDCASE=1126]="IFCCOLUMNSTANDARDCASE",t[t.IFCCOVERING=382]="IFCCOVERING",t[t.IFCCURTAINWALL=456]="IFCCURTAINWALL",t[t.IFCDOOR=213]="IFCDOOR",t[t.IFCDOORSTANDARDCASE=1151]="IFCDOORSTANDARDCASE",t[t.IFCMEMBER=310]="IFCMEMBER",t[t.IFCMEMBERSTANDARDCASE=1214]="IFCMEMBERSTANDARDCASE",t[t.IFCPLATE=351]="IFCPLATE",t[t.IFCPLATESTANDARDCASE=1224]="IFCPLATESTANDARDCASE",t[t.IFCRAILING=350]="IFCRAILING",t[t.IFCRAMP=414]="IFCRAMP",t[t.IFCRAMPFLIGHT=348]="IFCRAMPFLIGHT",t[t.IFCROOF=347]="IFCROOF",t[t.IFCSHADINGDEVICE=1265]="IFCSHADINGDEVICE",t[t.IFCSLAB=99]="IFCSLAB",t[t.IFCSLABELEMENTEDCASE=1268]="IFCSLABELEMENTEDCASE",t[t.IFCSLABSTANDARDCASE=1269]="IFCSLABSTANDARDCASE",t[t.IFCSTAIR=346]="IFCSTAIR",t[t.IFCSTAIRFLIGHT=25]="IFCSTAIRFLIGHT",t[t.IFCWALL=452]="IFCWALL",t[t.IFCWALLELEMENTEDCASE=1314]="IFCWALLELEMENTEDCASE",t[t.IFCWALLSTANDARDCASE=453]="IFCWALLSTANDARDCASE",t[t.IFCWINDOW=667]="IFCWINDOW",t[t.IFCWINDOWSTANDARDCASE=1316]="IFCWINDOWSTANDARDCASE",t[t.IFCELEMENTCOMPONENT=424]="IFCELEMENTCOMPONENT",t[t.IFCREINFORCINGELEMENT=262]="IFCREINFORCINGELEMENT",t[t.IFCREINFORCINGBAR=571]="IFCREINFORCINGBAR",t[t.IFCREINFORCINGMESH=531]="IFCREINFORCINGMESH",t[t.IFCTENDON=261]="IFCTENDON",t[t.IFCTENDONANCHOR=675]="IFCTENDONANCHOR",t[t.IFCBUILDINGELEMENTPART=220]="IFCBUILDINGELEMENTPART",t[t.IFCDISCRETEACCESSORY=423]="IFCDISCRETEACCESSORY",t[t.IFCFASTENER=535]="IFCFASTENER",t[t.IFCMECHANICALFASTENER=536]="IFCMECHANICALFASTENER",t[t.IFCVIBRATIONISOLATOR=1312]="IFCVIBRATIONISOLATOR",t[t.IFCFEATUREELEMENT=386]="IFCFEATUREELEMENT",t[t.IFCSURFACEFEATURE=1287]="IFCSURFACEFEATURE",t[t.IFCFEATUREELEMENTSUBTRACTION=499]="IFCFEATUREELEMENTSUBTRACTION",t[t.IFCVOIDINGFEATURE=1313]="IFCVOIDINGFEATURE",t[t.IFCOPENINGELEMENT=498]="IFCOPENINGELEMENT",t[t.IFCOPENINGSTANDARDCASE=1217]="IFCOPENINGSTANDARDCASE",t[t.IFCFEATUREELEMENTADDITION=385]="IFCFEATUREELEMENTADDITION",t[t.IFCPROJECTIONELEMENT=384]="IFCPROJECTIONELEMENT",t[t.IFCFURNISHINGELEMENT=253]="IFCFURNISHINGELEMENT",t[t.IFCFURNITURE=1184]="IFCFURNITURE",t[t.IFCSYSTEMFURNITUREELEMENT=1291]="IFCSYSTEMFURNITUREELEMENT",t[t.IFCDISTRIBUTIONELEMENT=44]="IFCDISTRIBUTIONELEMENT",t[t.IFCDISTRIBUTIONFLOWELEMENT=45]="IFCDISTRIBUTIONFLOWELEMENT",t[t.IFCDISTRIBUTIONCHAMBERELEMENT=180]="IFCDISTRIBUTIONCHAMBERELEMENT",t[t.IFCENERGYCONVERSIONDEVICE=175]="IFCENERGYCONVERSIONDEVICE",t[t.IFCAIRTOAIRHEATRECOVERY=1097]="IFCAIRTOAIRHEATRECOVERY",t[t.IFCBOILER=1105]="IFCBOILER",t[t.IFCBURNER=1109]="IFCBURNER",t[t.IFCCHILLER=1119]="IFCCHILLER",t[t.IFCCOIL=1124]="IFCCOIL",t[t.IFCCONDENSER=1132]="IFCCONDENSER",t[t.IFCCOOLEDBEAM=1141]="IFCCOOLEDBEAM",t[t.IFCCOOLINGTOWER=1142]="IFCCOOLINGTOWER",t[t.IFCENGINE=1164]="IFCENGINE",t[t.IFCEVAPORATIVECOOLER=1166]="IFCEVAPORATIVECOOLER",t[t.IFCEVAPORATOR=1167]="IFCEVAPORATOR",t[t.IFCHEATEXCHANGER=1187]="IFCHEATEXCHANGER",t[t.IFCHUMIDIFIER=1188]="IFCHUMIDIFIER",t[t.IFCTUBEBUNDLE=1305]="IFCTUBEBUNDLE",t[t.IFCUNITARYEQUIPMENT=1310]="IFCUNITARYEQUIPMENT",t[t.IFCELECTRICGENERATOR=1160]="IFCELECTRICGENERATOR",t[t.IFCELECTRICMOTOR=1161]="IFCELECTRICMOTOR",t[t.IFCMOTORCONNECTION=1216]="IFCMOTORCONNECTION",t[t.IFCSOLARDEVICE=1270]="IFCSOLARDEVICE",t[t.IFCTRANSFORMER=1303]="IFCTRANSFORMER",t[t.IFCFLOWCONTROLLER=121]="IFCFLOWCONTROLLER",t[t.IFCAIRTERMINALBOX=1096]="IFCAIRTERMINALBOX",t[t.IFCDAMPER=1148]="IFCDAMPER",t[t.IFCFLOWMETER=1182]="IFCFLOWMETER",t[t.IFCVALVE=1311]="IFCVALVE",t[t.IFCELECTRICDISTRIBUTIONBOARD=1157]="IFCELECTRICDISTRIBUTIONBOARD",t[t.IFCELECTRICTIMECONTROL=1162]="IFCELECTRICTIMECONTROL",t[t.IFCPROTECTIVEDEVICE=1235]="IFCPROTECTIVEDEVICE",t[t.IFCSWITCHINGDEVICE=1290]="IFCSWITCHINGDEVICE",t[t.IFCFLOWFITTING=467]="IFCFLOWFITTING",t[t.IFCDUCTFITTING=1153]="IFCDUCTFITTING",t[t.IFCPIPEFITTING=1222]="IFCPIPEFITTING",t[t.IFCCABLECARRIERFITTING=1111]="IFCCABLECARRIERFITTING",t[t.IFCCABLEFITTING=1113]="IFCCABLEFITTING",t[t.IFCJUNCTIONBOX=1195]="IFCJUNCTIONBOX",t[t.IFCFLOWMOVINGDEVICE=502]="IFCFLOWMOVINGDEVICE",t[t.IFCCOMPRESSOR=1131]="IFCCOMPRESSOR",t[t.IFCFAN=1177]="IFCFAN",t[t.IFCPUMP=1238]="IFCPUMP",t[t.IFCFLOWSEGMENT=574]="IFCFLOWSEGMENT",t[t.IFCDUCTSEGMENT=1154]="IFCDUCTSEGMENT",t[t.IFCPIPESEGMENT=1223]="IFCPIPESEGMENT",t[t.IFCCABLECARRIERSEGMENT=1112]="IFCCABLECARRIERSEGMENT",t[t.IFCCABLESEGMENT=1115]="IFCCABLESEGMENT",t[t.IFCFLOWSTORAGEDEVICE=371]="IFCFLOWSTORAGEDEVICE",t[t.IFCTANK=1293]="IFCTANK",t[t.IFCELECTRICFLOWSTORAGEDEVICE=1159]="IFCELECTRICFLOWSTORAGEDEVICE",t[t.IFCFLOWTERMINAL=46]="IFCFLOWTERMINAL",t[t.IFCFIRESUPPRESSIONTERMINAL=1179]="IFCFIRESUPPRESSIONTERMINAL",t[t.IFCSANITARYTERMINAL=1262]="IFCSANITARYTERMINAL",t[t.IFCSTACKTERMINAL=1277]="IFCSTACKTERMINAL",t[t.IFCWASTETERMINAL=1315]="IFCWASTETERMINAL",t[t.IFCAIRTERMINAL=1095]="IFCAIRTERMINAL",t[t.IFCMEDICALDEVICE=1212]="IFCMEDICALDEVICE",t[t.IFCSPACEHEATER=1272]="IFCSPACEHEATER",t[t.IFCAUDIOVISUALAPPLIANCE=1099]="IFCAUDIOVISUALAPPLIANCE",t[t.IFCCOMMUNICATIONSAPPLIANCE=1127]="IFCCOMMUNICATIONSAPPLIANCE",t[t.IFCELECTRICAPPLIANCE=1156]="IFCELECTRICAPPLIANCE",t[t.IFCLAMP=1198]="IFCLAMP",t[t.IFCLIGHTFIXTURE=1199]="IFCLIGHTFIXTURE",t[t.IFCOUTLET=1219]="IFCOUTLET",t[t.IFCFLOWTREATMENTDEVICE=425]="IFCFLOWTREATMENTDEVICE",t[t.IFCINTERCEPTOR=1193]="IFCINTERCEPTOR",t[t.IFCDUCTSILENCER=1155]="IFCDUCTSILENCER",t[t.IFCFILTER=1178]="IFCFILTER",t[t.IFCDISTRIBUTIONCONTROLELEMENT=468]="IFCDISTRIBUTIONCONTROLELEMENT",t[t.IFCPROTECTIVEDEVICETRIPPINGUNIT=1236]="IFCPROTECTIVEDEVICETRIPPINGUNIT",t[t.IFCACTUATOR=1091]="IFCACTUATOR",t[t.IFCALARM=1098]="IFCALARM",t[t.IFCCONTROLLER=1139]="IFCCONTROLLER",t[t.IFCFLOWINSTRUMENT=1181]="IFCFLOWINSTRUMENT",t[t.IFCSENSOR=1264]="IFCSENSOR",t[t.IFCUNITARYCONTROLELEMENT=1308]="IFCUNITARYCONTROLELEMENT",t[t.IFCCIVILELEMENT=1122]="IFCCIVILELEMENT",t[t.IFCELEMENTASSEMBLY=18]="IFCELEMENTASSEMBLY",t[t.IFCGEOGRAPHICELEMENT=1185]="IFCGEOGRAPHICELEMENT",t[t.IFCTRANSPORTELEMENT=416]="IFCTRANSPORTELEMENT",t[t.IFCVIRTUALELEMENT=168]="IFCVIRTUALELEMENT",t[t.IFCSTRUCTURALACTIVITY=41]="IFCSTRUCTURALACTIVITY",t[t.IFCSTRUCTURALACTION=40]="IFCSTRUCTURALACTION",t[t.IFCSTRUCTURALCURVEACTION=1279]="IFCSTRUCTURALCURVEACTION",t[t.IFCSTRUCTURALLINEARACTION=463]="IFCSTRUCTURALLINEARACTION",t[t.IFCSTRUCTURALSURFACEACTION=1284]="IFCSTRUCTURALSURFACEACTION",t[t.IFCSTRUCTURALPLANARACTION=39]="IFCSTRUCTURALPLANARACTION",t[t.IFCSTRUCTURALPOINTACTION=356]="IFCSTRUCTURALPOINTACTION",t[t.IFCSTRUCTURALREACTION=355]="IFCSTRUCTURALREACTION",t[t.IFCSTRUCTURALCURVEREACTION=1280]="IFCSTRUCTURALCURVEREACTION",t[t.IFCSTRUCTURALPOINTREACTION=354]="IFCSTRUCTURALPOINTREACTION",t[t.IFCSTRUCTURALSURFACEREACTION=1285]="IFCSTRUCTURALSURFACEREACTION",t[t.IFCSTRUCTURALITEM=226]="IFCSTRUCTURALITEM",t[t.IFCSTRUCTURALCONNECTION=265]="IFCSTRUCTURALCONNECTION",t[t.IFCSTRUCTURALCURVECONNECTION=534]="IFCSTRUCTURALCURVECONNECTION",t[t.IFCSTRUCTURALPOINTCONNECTION=533]="IFCSTRUCTURALPOINTCONNECTION",t[t.IFCSTRUCTURALSURFACECONNECTION=264]="IFCSTRUCTURALSURFACECONNECTION",t[t.IFCSTRUCTURALMEMBER=225]="IFCSTRUCTURALMEMBER",t[t.IFCSTRUCTURALCURVEMEMBER=224]="IFCSTRUCTURALCURVEMEMBER",t[t.IFCSTRUCTURALCURVEMEMBERVARYING=227]="IFCSTRUCTURALCURVEMEMBERVARYING",t[t.IFCSTRUCTURALSURFACEMEMBER=420]="IFCSTRUCTURALSURFACEMEMBER",t[t.IFCSTRUCTURALSURFACEMEMBERVARYING=421]="IFCSTRUCTURALSURFACEMEMBERVARYING",t[t.IFCPORT=179]="IFCPORT",t[t.IFCDISTRIBUTIONPORT=178]="IFCDISTRIBUTIONPORT",t[t.IFCANNOTATION=634]="IFCANNOTATION",t[t.IFCSPATIALELEMENT=1273]="IFCSPATIALELEMENT",t[t.IFCSPATIALSTRUCTUREELEMENT=170]="IFCSPATIALSTRUCTUREELEMENT",t[t.IFCBUILDING=169]="IFCBUILDING",t[t.IFCBUILDINGSTOREY=459]="IFCBUILDINGSTOREY",t[t.IFCSITE=349]="IFCSITE",t[t.IFCSPACE=454]="IFCSPACE",t[t.IFCEXTERNALSPATIALSTRUCTUREELEMENT=1175]="IFCEXTERNALSPATIALSTRUCTUREELEMENT",t[t.IFCEXTERNALSPATIALELEMENT=1174]="IFCEXTERNALSPATIALELEMENT",t[t.IFCSPATIALZONE=1275]="IFCSPATIALZONE",t[t.IFCGRID=564]="IFCGRID",t[t.IFCPROXY=447]="IFCPROXY"},241:(e,r,t)=>{Object.defineProperty(r,"__esModule",{value:!0}),r.BinaryReader=void 0;var I=t(747),a=function(){function e(){this._buffer=null,this._view=null,this._position=0,this._progress=function(e){},this._lastProgress=0}return Object.defineProperty(e.prototype,"Position",{get:function(){return this._position},enumerable:!1,configurable:!0}),e.prototype.getSubReader=function(r){var t=new e,I=this._buffer.slice(this._position,this._position+r);return t.load(I,null,null),this._position+=r,t},e.prototype.load=function(e,r,t){this._position=0;var a=this;if(t=t||function(e){},this._progress=t,void 0===e||null==e)throw"Source must be defined";if("string"==typeof e){var n=new XMLHttpRequest;n.open("GET",e,!0),n.onreadystatechange=function(){if(4==n.readyState&&200==n.status){var e=new FileReader;e.onloadend=function(){e.result&&"string"!=typeof e.result&&(a._buffer=e.result,a._view=new DataView(a._buffer),a.onloaded&&a.onloaded(a))},e.onprogress=function(e){t({message:"Downloading geometry",percent:Math.floor(e.loaded/e.total*100),type:I.MessageType.PROGRESS,phase:I.LoadingPhase.DOWNLOADING})},e.readAsArrayBuffer(n.response)}if(4==n.readyState&&200!=n.status){var r="Failed to fetch binary data from server. Server code: "+n.status+". This might be due to CORS policy of your browser if you run this as a local file.";throw t({message:"Downloading geometry",percent:0,type:I.MessageType.FAILED,phase:I.LoadingPhase.DOWNLOADING}),a.onerror&&a.onerror(r),r}},n.responseType="blob",null!=r&&Object.keys(r).forEach((function(e){var t=r[e];n.setRequestHeader(e,t)})),n.send()}else if(e instanceof Blob||"undefined"!=typeof File&&e instanceof File){var E=new FileReader;E.onloadend=function(){E.result&&"string"!=typeof E.result&&(a._buffer=E.result,a._view=new DataView(a._buffer),a.onloaded&&a.onloaded(a))},E.onprogress=function(e){t({message:"Loading binary data",percent:Math.floor(e.loaded/e.total*100),type:I.MessageType.PROGRESS,phase:I.LoadingPhase.DOWNLOADING})},E.readAsArrayBuffer(e)}else e instanceof ArrayBuffer&&(this._buffer=e,this._view=new DataView(a._buffer),a.onloaded&&a.onloaded(a))},e.prototype.seek=function(e){if(e<0||e>this._buffer.byteLength)throw"Position out of range.";this._position=e},e.prototype.isEOF=function(){if(null==this._position)throw"Position is not defined";return this._position==this._buffer.byteLength},e.prototype.readArray=function(e,r,t){null==r&&(r=1);var I=e*r,a=this._position;return this._position+=I,this.reportProgress(),1===r?new t(this._buffer.slice(a,a+I))[0]:new t(this._buffer.slice(a,a+I))},e.prototype.move=function(e){var r=this._position;return this._position+=e,this.reportProgress(),r},e.prototype.reportProgress=function(){null!=this._progress&&this._position-this._lastProgress>5e5&&(this._lastProgress=this._position,this._progress({type:I.MessageType.PROGRESS,message:"Reading data",percent:Math.floor(100*this._position/this._buffer.byteLength),phase:I.LoadingPhase.READING}))},e.prototype.readByte=function(){return this.readUint8()},e.prototype.readByteArray=function(e){return this.readUint8Array(e)},e.prototype.readUint8=function(){var e=this.move(1);return this._view.getUint8(e)},e.prototype.readUint8Array=function(e){return this.readArray(1,e,Uint8Array)},e.prototype.readInt16=function(){var e=this.move(2);return this._view.getInt16(e,!0)},e.prototype.readInt16Array=function(e){return this.readArray(2,e,Int16Array)},e.prototype.readUInt16=function(){var e=this.move(2);return this._view.getUint16(e,!0)},e.prototype.readUint16Array=function(e){return this.readArray(2,e,Uint16Array)},e.prototype.readInt32=function(){var e=this.move(4);return this._view.getInt32(e,!0)},e.prototype.readInt32Array=function(e){return this.readArray(4,e,Int32Array)},e.prototype.readUint32=function(){var e=this.move(4);return this._view.getUint32(e,!0)},e.prototype.readUint32Array=function(e){return this.readArray(4,e,Uint32Array)},e.prototype.readFloat32=function(){var e=this.move(4);return this._view.getFloat32(e,!0)},e.prototype.readFloat32Array=function(e){return this.readArray(4,e,Float32Array)},e.prototype.readFloat64=function(){var e=this.move(8);return this._view.getFloat64(e,!0)},e.prototype.readFloat64Array=function(e){return this.readArray(8,e,Float64Array)},e.prototype.readChar=function(e){null==e&&(e=1);var r=this.readByteArray(e),t=new Array(e);for(var I in r)t[I]=String.fromCharCode(r[I]);return 1===e?t[0]:t},e.prototype.readPoint=function(e){null==e&&(e=1);for(var r=this.readFloat32Array(3*e),t=new Array(e),I=0;I<e;I++){var a=3*I*4,n=new Float32Array(r.buffer,a,3);t[I]=n}return 1===e?t[0]:t},e.prototype.readRgba=function(e){null==e&&(e=1);for(var r=this.readByteArray(4*e),t=new Array(e),I=0;I<e;I++){var a=4*I,n=new Uint8Array(r.buffer,a,4);t[I]=n}return 1===e?t[0]:t},e.prototype.readPackedNormal=function(e){null==e&&(e=1);for(var r=this.readUint8Array(2*e),t=new Array(e),I=0;I<e;I++){var a=new Uint8Array(r.buffer,2*I,2);t[I]=a}return 1===e?t[0]:t},e.prototype.readMatrix4x4=function(e){null==e&&(e=1);for(var r=this.readFloat32Array(16*e),t=new Array(e),I=0;I<e;I++){var a=16*I*4,n=new Float32Array(r.buffer,a,16);t[I]=n}return 1===e?t[0]:t},e.prototype.readMatrix4x4_64=function(e){null==e&&(e=1);for(var r=this.readFloat64Array(16*e),t=new Array(e),I=0;I<e;I++){var a=16*I*8,n=new Float64Array(r.buffer,a,16);t[I]=n}return 1===e?t[0]:t},e.prototype.readData=function(e){var r=this.move(e);return this._buffer.slice(r,r+e)},e}();r.BinaryReader=a},360:(e,r,t)=>{Object.defineProperty(r,"__esModule",{value:!0}),r.Region=r.ModelGeometry=void 0;var I=t(241),a=t(623),n=t(486),E=t(66),o=t(747),C=t(18),i=function(){function e(){this.normals=new Uint8Array(0),this.indices=new Float32Array(0),this.products=new Float32Array(0),this.transformations=new Float32Array(0),this.styleIndices=new Uint16Array(0),this.states=new Uint8Array(0),this.vertices=new Float32Array(0),this.matrices=new Float32Array(0),this.styles=new Uint8Array(0),this.meter=1e3,this.wcs=[0,0,0],this._iVertex=0,this._iIndexForward=0,this._iIndexBackward=0,this._iTransform=0,this._iMatrix=0,this._maxVersionSupported=4,this.productMaps={},this.productIdLookup=[],this.breaks={10:[],20:[],40:[],30:[],50:[],60:[],70:[],80:[],90:[],100:[]},this._styleMap=new T}return e.prototype.parse=function(e,r){var t=this;if(e&&!e.isEOF()){this._reader=e;var I=e;if(94132117!==I.readInt32())throw new Error("Magic number mismatch. This is not a wexBIM file.");var i=I.readByte();if(i>this._maxVersionSupported)throw new Error("Viewer doesn't support version ".concat(i," of the wexBIM stream"));var T=I.readInt32(),F=I.readInt32(),A=I.readInt32(),R=I.readInt32(),N=I.readInt32(),d=I.readInt32();this.meter=I.readFloat32(),i>3&&(this.wcs=[I.readFloat64(),I.readFloat64(),I.readFloat64()]);var L=I.readInt16();this.vertices=new Float32Array(this.square(4,3*F)),this.normals=new Uint8Array(6*A),this.indices=new Float32Array(3*A),this.styleIndices=new Uint16Array(3*A),this.styles=new Uint8Array(this.square(1,4*(d+2))),this.products=new Float32Array(3*A),this.states=new Uint8Array(3*A*2),this.transformations=new Float32Array(3*A),this.matrices=new Float32Array(this.square(4,16*R)),this.productMaps={},this.regions=new Array(L),this._iVertex=0,this._iIndexForward=0,this._iIndexBackward=3*A,this._iTransform=0,this._iMatrix=0;for(var u=0;u<L;u++)(P=new s).population=I.readInt32(),P.centre=I.readFloat32Array(3),P.bbox=I.readFloat32Array(6),this.regions[u]=P;for(var O=0;O<d;O++){var p=I.readInt32(),l=255*I.readFloat32(),h=255*I.readFloat32(),S=255*I.readFloat32(),y=255*I.readFloat32();this.styles.set([l,h,S,y],4*O),this._styleMap.Add({id:p,index:O,transparent:y<254})}for(this.styles.set([255,255,255,255],4*O),this._styleMap.Add({id:-1,index:O,transparent:!1}),O++,this.styles.set([0,255,255,100],4*O),this._styleMap.Add({id:-2,index:O,transparent:!1}),u=0;u<N;u++){var M=I.readInt32(),f=I.readInt16(),c=I.readFloat32Array(6),U=new C.ProductMap;U.productID=M,U.renderId=u+1,U.type=f,U.bBox=c,U.spans=[],this.productMaps[M]=U,this.productIdLookup[u+1]=M,f!==E.ProductType.IFCSPACE&&f!==E.ProductType.IFCOPENINGELEMENT||U.states.push(n.State.HIDDEN)}if(i>=3)for(var D=0;D<L;D++){for(var P=this.regions[D],v=I.readInt32(),b=new Array(v),G=0;G<v;G++){var g=this.readShape(i),w=I.readInt32();if(0!==w){var B=I.getSubReader(w);if((V=new a.TriangulatedShape).parse(B),!B.isEOF())throw new Error("Incomplete reading of geometry for shape instance ".concat(g[0].iLabel));b[G]={shapes:g,geometry:V}}}for(r.orderGeometryBySize&&b.sort((function(e,r){var I,a,n=null===(I=e.shapes[0])||void 0===I?void 0:I.pLabel,E=null===(a=r.shapes[0])||void 0===a?void 0:a.pLabel;if(null==n||null==E)return 0;var o=t.productMaps[n],C=t.productMaps[E];if(null==o)return 1;if(null==C)return-1;var i=o.bBox[3]*o.bBox[4]*o.bBox[5];return C.bBox[3]*o.bBox[4]*o.bBox[5]-i})),G=0;G<v;G++){var _=b[G];this.feedDataArrays(_.shapes,_.geometry)}}else for(var x=0;x<T;x++){var V;g=this.readShape(i),(V=new a.TriangulatedShape).parse(I),this.feedDataArrays(g,V)}if(!I.isEOF())throw this.progress({type:o.MessageType.FAILED,message:"Processed data",percent:0,phase:o.LoadingPhase.READING}),new Error("Binary reader is not at the end of the file.");this.progress({type:o.MessageType.PROGRESS,message:"Processed data",percent:100,phase:o.LoadingPhase.READING}),this.transparentIndex=this._iIndexForward,this.breaks[100]=[this.transparentIndex-1,this.transparentIndex]}},e.prototype.square=function(e,r){if(null==e||null==r)throw new Error('Wrong arguments for "square" function.');if(0===r)return 0;for(var t=r*e,I=Math.ceil(Math.sqrt(t/4));4*I%e!=0;)I++;return I*I*4/e},e.prototype.feedDataArrays=function(e,r){var t=this;e.forEach((function(e){var I=0,a=I=e.transparent?t._iIndexBackward-r.indices.length:t._iIndexForward,o=t.productMaps[e.pLabel];void 0===o&&((o=new C.ProductMap).productID=0,o.renderId=0,o.type=E.ProductType.IFCOPENINGELEMENT,o.bBox=new Float32Array(6),o.spans=[],o.states.push(n.State.HIDDEN),t.productMaps[e.pLabel]=o),t.normals.set(r.normals,2*I);var i=o.type===E.ProductType.IFCSPACE||o.type===E.ProductType.IFCOPENINGELEMENT?n.State.HIDDEN:255;r.indices.forEach((function(r){t.indices[I]=r+t._iVertex/3,t.products[I]=o.renderId,t.styleIndices[I]=e.style,t.transformations[I]=e.transform,t.states[2*I]=i,t.states[2*I+1]=255,I++}));var s=I;o.spans.push(new Int32Array([a,s])),e.transparent?t._iIndexBackward-=r.indices.length:t._iIndexForward+=r.indices.length;var T=(t._iIndexForward+t.indices.length-t._iIndexBackward)/t.indices.length*100;Object.getOwnPropertyNames(t.breaks).forEach((function(e){var r=+e;0===t.breaks[r].length&&T>r&&(t.breaks[r]=[t._iIndexForward,t._iIndexBackward])}))}),this),this.vertices.set(r.vertices,this._iVertex),this._iVertex+=r.vertices.length},e.prototype.readShape=function(e){for(var r=this._reader,t=r.readInt32(),I=new Array,a=0;a<t;a++){var n=r.readInt32(),o=(r.readInt16(),r.readInt32()),C=r.readInt32(),i=null;t>1&&(i=1===e?r.readFloat32Array(16):r.readFloat64Array(16),this.matrices.set(i,this._iMatrix),this._iMatrix+=16);var s=this._styleMap.GetStyle(C);null===s&&(s=this._styleMap.GetStyle(-1));var T=this.productMaps[n]?this.productMaps[n].type:E.ProductType.IFCPRODUCT;T!==E.ProductType.IFCSPACE&&T!==E.ProductType.IFCOPENINGELEMENT||(s=this._styleMap.GetStyle(-2)),I.push({pLabel:n,iLabel:o,style:s.index,transparent:s.transparent,transform:null!=i?this._iTransform++:-1})}return I},e.prototype.load=function(e,r,t,a){var n=this;void 0===a&&(a={}),this.progress=t||function(e){};var E=new I.BinaryReader,o=this;E.onloaded=function(){o.parse(E,a),o.onloaded&&o.onloaded(n)},E.onerror=function(e){o.onerror&&o.onerror(e)},E.load(e,r,t)},e}();r.ModelGeometry=i;var s=function(){function e(e){this.population=-1,this.centre=null,this.bbox=null,e&&(this.population=e.population,e.centre&&(this.centre=new Float32Array(e.centre)),e.bbox&&(this.bbox=new Float32Array(e.bbox)))}return e.clone=function(r){var t=new e;return t.population=r.population,r.centre&&(t.centre=new Float32Array(r.centre)),r.bbox&&(t.bbox=new Float32Array(r.bbox)),t},e.prototype.merge=function(r){if(-1===this.population&&null===this.centre&&null===this.bbox)return new e(r);var t=new e;if(t.population=this.population+r.population,this.bbox&&r.bbox){var I=Math.min(this.bbox[0],r.bbox[0]),a=Math.min(this.bbox[1],r.bbox[1]),n=Math.min(this.bbox[2],r.bbox[2]),E=Math.max(this.bbox[0]+this.bbox[3],r.bbox[0]+r.bbox[3]),o=Math.max(this.bbox[1]+this.bbox[4],r.bbox[1]+r.bbox[4]),C=Math.max(this.bbox[2]+this.bbox[5],r.bbox[2]+r.bbox[5]),i=E-I,s=o-a,T=C-n,F=(I+E)/2,A=(a+o)/2,R=(n+C)/2;t.bbox=new Float32Array([I,a,n,i,s,T]),t.centre=new Float32Array([F,A,R])}else this.bbox?(t.bbox=new Float32Array(this.bbox),t.centre=new Float32Array(this.centre)):(t.bbox=new Float32Array(r.bbox),t.centre=new Float32Array(r.centre));return t},e}();r.Region=s;var T=function(){function e(){this._internal={}}return e.prototype.Add=function(e){this._internal[e.id]=e},e.prototype.GetStyle=function(e){return this._internal[e]||null},e}()},623:(e,r,t)=>{Object.defineProperty(r,"__esModule",{value:!0}),r.TriangulatedShape=void 0;var I=t(241),a=function(){function e(){var e=this;this.load=function(r){var t=new I.BinaryReader,a=e;t.onloaded=function(){a.parse(t),a.onloaded&&a.onloaded(e)},t.load(r,null,null)}}return e.prototype.parse=function(e){var r=this,t=(e.readByte(),e.readInt32()),I=e.readInt32();r.vertices=e.readFloat32Array(3*t),r.indices=new Uint32Array(3*I),r.normals=new Uint8Array(6*I);var a,n=0;a=t<=255?function(r){return e.readByteArray(r)}:t<=65535?function(r){return e.readUint16Array(r)}:function(r){return e.readInt32Array(r)};var E=e.readInt32();if(0!==t&&0!==I)for(var o=0;o<E;o++){var C=e.readInt32();if(0!=C){var i=C>0;if(C=Math.abs(C),i){var s=e.readByteArray(2),T=a(3*C);r.indices.set(T,n);for(var F=0;F<3*C;F++)r.normals[2*n]=s[0],r.normals[2*n+1]=s[1],n++}else for(F=0;F<C;F++)r.indices[n]=a(),r.normals.set(e.readByteArray(2),2*n),n++,r.indices[n]=a(),r.normals.set(e.readByteArray(2),2*n),n++,r.indices[n]=a(),r.normals.set(e.readByteArray(2),2*n),n++}}},e}();r.TriangulatedShape=a}},r={};function t(I){var a=r[I];if(void 0!==a)return a.exports;var n=r[I]={exports:{}};return e[I](n,n.exports,t),n.exports}var I={};for(var a in(()=>{var e=I;Object.defineProperty(e,"__esModule",{value:!0});var r=t(747),a=t(360);if(self&&self instanceof DedicatedWorkerGlobalScope){var n=self;n.onmessage=function(e){var t=e.data.model,I=e.data.headers,E=e.data.options,o=new a.ModelGeometry;o.onerror=function(e){var t={type:r.MessageType.FAILED,message:e,percent:0,phase:r.LoadingPhase.DOWNLOADING};n.postMessage(t),console.error(e),n.close()},o.onloaded=function(){try{var e={},t=[];for(var I in o)if(o.hasOwnProperty(I)){var a=o[I];"function"==typeof a||I.startsWith("_")||(e[I]=a,ArrayBuffer.isView(a)?t.push(a.buffer):null!=(C=a).width&&null!=C.height&&null!=C.close&&t.push(a))}var E={type:r.MessageType.COMPLETED,message:"Read Completed",percent:100,result:e,phase:r.LoadingPhase.READING};n.postMessage(E,t),n.close()}catch(e){E={type:r.MessageType.FAILED,message:e,percent:0,phase:r.LoadingPhase.READING},n.postMessage(E),console.error(e),n.close()}var C},o.load(t,I,(function(e){n.postMessage(e)}),E)}}})(),I)this[a]=I[a];I.__esModule&&Object.defineProperty(this,"__esModule",{value:!0})})();`;
    } }, a = {};
    function s(o) {
      var l = a[o];
      if (l !== void 0)
        return l.exports;
      var c = a[o] = { exports: {} };
      return n[o].call(c.exports, c, c.exports, s), c.exports;
    }
    return s.d = (o, l) => {
      for (var c in l)
        s.o(l, c) && !s.o(o, c) && Object.defineProperty(o, c, { enumerable: !0, get: l[c] });
    }, s.o = (o, l) => Object.prototype.hasOwnProperty.call(o, l), s.r = (o) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
    }, s(831);
  })());
})(viewer);
var viewerExports = viewer.exports, js_cookie = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(t, e) {
  (function(n) {
    var a;
    if (t.exports = n(), a = !0, !a) {
      var s = window.Cookies, o = window.Cookies = n();
      o.noConflict = function() {
        return window.Cookies = s, o;
      };
    }
  })(function() {
    function n() {
      for (var o = 0, l = {}; o < arguments.length; o++) {
        var c = arguments[o];
        for (var u in c)
          l[u] = c[u];
      }
      return l;
    }
    function a(o) {
      return o.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function s(o) {
      function l() {
      }
      function c(d, f, h) {
        if (!(typeof document > "u")) {
          h = n({
            path: "/"
          }, l.defaults, h), typeof h.expires == "number" && (h.expires = new Date(/* @__PURE__ */ new Date() * 1 + h.expires * 864e5)), h.expires = h.expires ? h.expires.toUTCString() : "";
          try {
            var g = JSON.stringify(f);
            /^[\{\[]/.test(g) && (f = g);
          } catch {
          }
          f = o.write ? o.write(f, d) : encodeURIComponent(String(f)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), d = encodeURIComponent(String(d)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var x = "";
          for (var E in h)
            h[E] && (x += "; " + E, h[E] !== !0 && (x += "=" + h[E].split(";")[0]));
          return document.cookie = d + "=" + f + x;
        }
      }
      function u(d, f) {
        if (!(typeof document > "u")) {
          for (var h = {}, g = document.cookie ? document.cookie.split("; ") : [], x = 0; x < g.length; x++) {
            var E = g[x].split("="), m = E.slice(1).join("=");
            !f && m.charAt(0) === '"' && (m = m.slice(1, -1));
            try {
              var v = a(E[0]);
              if (m = (o.read || o)(m, v) || a(m), f)
                try {
                  m = JSON.parse(m);
                } catch {
                }
              if (h[v] = m, d === v)
                break;
            } catch {
            }
          }
          return d ? h[d] : h;
        }
      }
      return l.set = c, l.get = function(d) {
        return u(
          d,
          !1
          /* read as raw */
        );
      }, l.getJSON = function(d) {
        return u(
          d,
          !0
          /* read as json */
        );
      }, l.remove = function(d, f) {
        c(d, "", n(f, {
          expires: -1
        }));
      }, l.defaults = {}, l.withConverter = s, l;
    }
    return s(function() {
    });
  });
})(js_cookie);
var js_cookieExports = js_cookie.exports;
const XBimViewer = (t) => {
  const e = useRef(!1), [n, a] = useState(null);
  return useEffect(() => {
    const s = async () => {
      try {
        const o = new viewerExports.Viewer("viewer");
        o.load(t.filePath), o.on("loaded", () => {
          o.show(viewerExports.ViewType.DEFAULT);
        }), o.start(), js_cookieExports.set;
      } catch (o) {
        t.onError && t.onError(o), a(o);
      }
    };
    !e.current && t.filePath && (e.current = !0, s());
  }, [t.filePath]), n ? /* @__PURE__ */ jsxRuntimeExports.jsx(Error$2, { error: n.message }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-driver-view", children: /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { id: "viewer", width: "500", height: "300" }) });
}, UnsupportedViewer = (t) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-driver-view", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "unsupported-message", children: t.unsupportedComponent ? t.unsupportedComponent : /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "alert", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: `.${t.fileType}` }),
  " is not supported."
] }) }) }), PhotoViewer = ({
  filePath: t,
  texture: e,
  imageHeight: n,
  imageWidth: a
}) => {
  const s = useRef(null), o = useRef(!1);
  useEffect(() => {
    const c = () => {
      const u = s.current;
      if (u) {
        u.childNodes.length > 0 && u.removeChild(u.childNodes[0]);
        const { width: d, height: f } = u.getBoundingClientRect();
        u.appendChild(e.image);
        const h = l(d, f);
        e.image.style.width = `${h.width}px`, e.image.style.height = `${h.height}px`, e.image.setAttribute("class", "photo");
      }
    };
    o.current || (o.current = !0, c());
  }, [t]);
  const l = (c, u) => {
    let d, f;
    if (n <= u && a <= c)
      f = a, d = n;
    else {
      const h = u / n, g = c / a;
      h < g ? (d = n * h, f = a * h) : (d = n * g, f = a * g);
    }
    return { height: d, width: f };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: s, className: "photo-viewer-container" });
}, PhotoViewerWrapper = (t) => {
  const [e, n] = useState(0), [a, s] = useState(0), [o, l] = useState(!1), [c, u] = useState(), [d, f] = useState("");
  useEffect(() => {
    const g = new TextureLoader();
    g.crossOrigin = "", g.load(
      t.filePath,
      (x) => {
        n(x.image.width), s(x.image.height), l(!0), u(x);
      },
      (x) => {
        console.log(`${x.loaded / x.total * 100}% loaded`);
      },
      (x) => {
        console.log("An error happened", x), f("An error happened");
      }
    );
  }, [t.filePath]);
  const h = t.fileType === "jpg" && window.Math.abs(e / a - 2) <= 0.01;
  return d ? t.errorComponent ?? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: d }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: o ? h ? c ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Photo360Viewer,
    {
      ...t,
      texture: c,
      originalHeight: a,
      originalWidth: e
    }
  ) : null : c ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    PhotoViewer,
    {
      ...t,
      texture: c,
      imageHeight: c.image.height,
      imageWidth: c.image.width
    }
  ) : null : /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) });
}, AudioViewer = (t) => {
  const [e, n] = useState(!0), [a, s] = useState(null);
  return a ? t.errorComponent : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-driver-view", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "video-container", children: [
    e ? /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "audio",
      {
        style: { visibility: e ? "hidden" : "visible" },
        controls: !0,
        onCanPlay: () => n(!1),
        onError: (o) => s(o),
        src: t.filePath,
        children: "Audio playback is not supported by your browser."
      }
    )
  ] }) });
}, FetchWrapper = (t) => {
  const { childComponent: e, filePath: n } = t, [a, s] = useState(), [o, l] = useState(), [c, u] = useState(""), [d, f] = useState();
  useEffect(() => ((() => {
    s(void 0), l(void 0);
    const m = h(n);
    m && (f(m), g(m));
  })(), () => {
    x();
  }), [n, e, t.childComponent]);
  const h = (E) => {
    const m = new XMLHttpRequest();
    if ("withCredentials" in m)
      m.open("GET", E, !0);
    else
      return null;
    return t.responseType !== void 0 && (m.responseType = t.responseType), m.onload = () => {
      if (m.status >= 400) {
        u(`fetch error with status ${m.status}`);
        return;
      }
      t.responseType === "arraybuffer" ? l(m.response) : s(m.responseText);
    }, m.onerror = () => {
      u("fetch error");
    }, m;
  }, g = (E) => {
    E && E.send();
  }, x = () => {
    d && d.abort();
  };
  return c ? t.errorComponent ?? /* @__PURE__ */ jsxRuntimeExports.jsx(Error$2, { error: c }) : d ? e === "csv" ? a ? /* @__PURE__ */ jsxRuntimeExports.jsx(CsvViewer, { data: a, errorComponent: t.errorComponent }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) : o ? /* @__PURE__ */ jsxRuntimeExports.jsx(XlsxViewer, { data: o, errorComponent: t.errorComponent }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "CORS not supported" });
}, FileViewer = (t) => {
  const e = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-viewer-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "pg-viewer", id: "pg-viewer", ref: e, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Driver, { ...t }) }) });
}, Driver = (t) => {
  const { fileType: e } = t;
  switch (e) {
    case "csv":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FetchWrapper, { ...t, childComponent: "csv" });
    case "xlsx":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FetchWrapper,
        {
          ...t,
          responseType: "arraybuffer",
          childComponent: "xls"
        }
      );
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "png":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PhotoViewerWrapper, { ...t });
    case "pdf":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PDFViewer, { ...t });
    case "docx":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DocxViewer, { ...t });
    case "mp3":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AudioViewer, { ...t });
    case "webm":
    case "mov":
    case "mp4":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(VideoViewer, { ...t });
    case "wexbim":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(XBimViewer, { ...t });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(UnsupportedViewer, { fileType: t.fileType });
  }
};
export {
  FileViewer as default
};
